(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 42693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ systemActions; }
/* harmony export */ });
/* unused harmony export systemActionsConstants */
/* harmony import */ var _shared_store_system_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93893);


const systemActionsConstants = {
  ..._shared_store_system_actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsSystem */ .v,
  SET_SCREEN_TYPE: "system/ACTION_SET_SCREEN_TYPE",
};
const systemActions = {
  ..._shared_store_system_actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsSystem */ .g,
  setScreenType: (screenType) => ({
    type: systemActionsConstants.SET_SCREEN_TYPE,
    data: screenType,
  }),
};


/***/ }),

/***/ 39403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B6": function() { return /* binding */ advSearchAutocompleteTypes; },
/* harmony export */   "FI": function() { return /* binding */ parseFolders; },
/* harmony export */   "Fu": function() { return /* binding */ resultsLimit; },
/* harmony export */   "O6": function() { return /* binding */ periodOptionCustom; },
/* harmony export */   "TR": function() { return /* binding */ advSearchInfoLangTypes; },
/* harmony export */   "pg": function() { return /* binding */ virtualPeriodValues; },
/* harmony export */   "t4": function() { return /* binding */ emptyOption; }
/* harmony export */ });
/* unused harmony exports typesCompatibleWithBookCode, periodOptions, getBookIdByLocation, getFolderList, getActiveLangs */
/* harmony import */ var _shared_utils_content_content__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69051);
/* harmony import */ var _shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5626);
/* harmony import */ var _shared_utils_search_search_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80226);




const resultsLimit = 100;

const advSearchAutocompleteTypes = ["topical", "dictionary", "ltms"];
const advSearchInfoLangTypes = ["book", "bible"];
const typesCompatibleWithBookCode = (/* unused pure expression or super */ null && ([
  "basic",
  "book",
  "periodicals",
  "apl",
  "reference",
  "bible",
  "commentary",
]));

const emptyOption = [{ id: "", label: "any_option" }];

const periodOptionCustom = { key: _shared_utils_search_search_constants__WEBPACK_IMPORTED_MODULE_2__/* .PeriodWithCustom.custom */ .TR.custom, label: "custom" };
const periodOptions = [..._shared_utils_search_search_constants__WEBPACK_IMPORTED_MODULE_2__/* .periodOptions */ .ly, periodOptionCustom];

const virtualPeriodValues = [_shared_utils_search_search_constants__WEBPACK_IMPORTED_MODULE_2__/* .PeriodWithCustom.myBible */ .TR.myBible, _shared_utils_search_search_constants__WEBPACK_IMPORTED_MODULE_2__/* .PeriodWithCustom.apl */ .TR.apl, _shared_utils_search_search_constants__WEBPACK_IMPORTED_MODULE_2__/* .PeriodWithCustom.custom */ .TR.custom, _shared_utils_search_search_constants__WEBPACK_IMPORTED_MODULE_2__/* .PeriodWithCustom.dictionary */ .TR.dictionary];

const BookUrlRegex = /^\/book\/(b\d+)$/i;

const getBookIdByLocation = (pathname, activeId) => {
  if (activeId) {
    return getBookIdWithPrefix(activeId);
  } else if (pathname && BookUrlRegex.test(pathname)) {
    const [_, bookId] = pathname.match(BookUrlRegex);
    return bookId;
  }
  return undefined;
};

const getFolderList = (mainTree, checked) => {
  if (!mainTree) {
    // if mainTree is not loaded yet then no actual folders
    return [];
  }
  // we need to send langauges in PARTIAL state to search
  // we need to send other folders in ALL state
  // we need not to send children of parent in ALL state

  const checkedSet = new Set(checked);
  // list of partial/all folders

  const { lang, folder, pubnr } = parseFolders(checked);
  const books = pubnr.map((value) => getBookIdWithPrefix(value));

  const parents = [];
  // we need parent folders list to drop parents if

  const res = [];
  // ALL-checked parent folders will be stored here

  // each item from <list> will be excluded from <valueSet>
  const dropList = (valueSet, list) => {
    if (!list.length) {
      return;
    }
    list.forEach((item) => {
      valueSet.delete(item);
    });
  };

  // recursive func to exclude from fullChecked all PARTIAL-checked folders
  // if checked folder has non-checked child, it is PARTIAL-checked. not ALL-checked
  const _drop = (item) => {
    const id = item.id;
    if (!checkedSet.has(id)) {
      dropList(fullChecked, parents);
      return;
    }
    // else
    // included case
    // now book children can't be checked/unchecked separately ! =)
    // so a book is the lowest level to test
    if (item.children && !item.book_id) {
      parents.push(id);
      item.children.forEach((item) => {
        _drop(item);
      });
      parents.pop();
    }
  };

  // recursive func to copy to results only parent ALL-checked folders, not any of their children
  const _copy = (item) => {
    const id = item.id;
    if (fullChecked.has(id)) {
      res.push(id);
      // folder is ALL-checked, no need to process its children
      return;
    }
    // else
    // not ALL-checked case
    // so need to process its children
    // now book children can't be checked/unchecked separately ! =)
    // so a book is the lowest level to test
    if (item.children && !item.book_id) {
      item.children.forEach((item) => {
        _copy(item);
      });
    }
  };

  const fullChecked = new Set(folder.concat(books));
  // we need to exclude non-ALL folders and books, but not langauges
  // so languages will be stored (in <lang>)and added to results at the process end

  // exclude form fullChecked PARTIAL-checked folders
  mainTree.forEach((item) => {
    _drop(item);
  });

  // copy to res only parent ALL-checked folders
  mainTree.forEach((item) => {
    _copy(item);
  });
  const result = lang.concat(res);
  return result;
};

const parseFolders = (folders) => {
  const lang = [];
  const folder = [];
  const pubnr = [];
  (folders || []).forEach((value) => {
    if (_shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_1__/* .langRegex.test */ .ZF.test(value)) {
      // lang case
      lang.push(value);
    } else if (_shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_1__/* .folderIdRegex.test */ .Ft.test(value)) {
      // folder value
      folder.push(value);
    } else if (_shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_1__/* .bookIdRegex.test */ .QO.test(value)) {
      // book case
      pubnr.push(value.slice(1));
    }
  });
  return { lang, folder, pubnr };
};

// TODO refactor
const getActiveLangs = (checked = [], mainTree, bookLangMap = {}) => {
  // get book langs
  const checkedLangs = [];
  const bookLangs = [];
  const checkedFolders = [];
  const folderLangs = [];

  checked.forEach((item) => {
    if (bookIdRegex.test(item) && bookLangMap[item]) {
      bookLangs.push(bookLangMap[item]);
    }
    if (langRegex.test(item)) {
      checkedLangs.push(item);
    }
    if (Number.isInteger(item)) {
      checkedFolders.push(item);
    }
  });
  const unloadedCheckedLangs = mainTree
    .filter((item) => checkedLangs.includes(item.code) && item.children === undefined)
    .map((item) => item.code);

  const _process = (items) => {
    if (items === undefined) {
      return;
    }
    const limit = items.length;
    for (let i = 0; i < limit; i++) {
      const item = items[i];
      if (item.className === "language") {
        // language case
        _process(item.children);
        continue;
      }
      // else
      // folder case
      if (checkedFolders.includes(item.id)) {
        // lang is uses
        folderLangs.push(item.lang);
        continue;
      }
      // else
      // lang status in unknown
      if (item.nbooks !== 0) {
        // no subfolders
        continue;
      }
      // there are subfolders
      _process(item.children);
    }
  };
  if (mainTree) {
    _process(mainTree);
  }

  return [...new Set([...unloadedCheckedLangs, ...bookLangs, ...folderLangs])]; // result.unique()
};


/***/ }),

/***/ 47599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JB": function() { return /* binding */ detectIfLastRead; },
/* harmony export */   "Sw": function() { return /* binding */ removeDuplicatesFromPrimitives; },
/* harmony export */   "Z3": function() { return /* binding */ HistoryType; },
/* harmony export */   "jR": function() { return /* binding */ trimBr; }
/* harmony export */ });
/* unused harmony exports COOKIE_KEY_APP_OPEN_NUMBER, DelayOpenML, SearchQueryLimit, MOUSE_BUTTON_CODE, scOptions, getNodeIds, getNodePathIds, insertParasToBook, generateParasHtml, getIdFromElement, fixDuplicateRefCodes, collectAllNodes, getCoordinateX, getChildrenIds, getSortDate, makeTreeFromList, orderLanguages, orderLanguagesDetect, getWindowSizes, checkWordsNumber, getBoundingClientRect, buttonPressedCode, findItemById, getSelectionAnchorClosest, dispatchMouseEvent, osList, detectOS, getExtendedClass, changeElementTag, SCREEN_ORIENTATION, getScreenOrientation, swapObjectsProperty, findBible, getObjectKeysNotNullable, isFunction */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27693);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56253);
/* harmony import */ var _shared_utils_content_content__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69051);
/* harmony import */ var _shared_utils_array__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21707);
/* harmony import */ var _shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5626);
/* harmony import */ var _shared_utils_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62330);









const COOKIE_KEY_APP_OPEN_NUMBER = "openNumber";

// Delay between open last read book of ML
const DelayOpenML = (/* unused pure expression or super */ null && (1000 * 60 * 60));

const SearchQueryLimit = 500;

const MOUSE_BUTTON_CODE = {
  main: 0, // Main button, usually the left button.
  middle: 1, //  Auxiliary button, usually the wheel button or the middle button (if present).
  secondary: 2, // Secondary button, usually the right button.
};

/**
 * @readonly
 * @enum {number}
 */
const scOptions = {
  SELECTION: "selection",
  CHAPTER: "CHAPTER",
  RANGE: "RANGE",
};

/**
 * @readonly
 * @enum {string}
 */
const HistoryType = {
  READING: "read",
  LISTEN: "audio",

  LIBRARY: "download_history",

  ML_HISTORY: "library",

  SEARCH: "search_history",
};

const getNodeIds = (node, array, ids = []) => {
  if (node?.length) {
    for (let i = 0; i < node.length; i++) {
      ids.push(node[i].id);
      getNodeIds(node[i].children, array, ids);
    }
  }

  return ids;
};

const getNodePathIds = (node, id) => {
  const path = [];
  findNode(id, node, "id", path);
  return path.map((child) => child.id);
};

const insertParasToBook = (book, paras) => {
  if (!paras.length || !book?.children?.length) {
    return;
  }

  const bookChildren = book.children;
  const firstChildPuborder = bookChildren[0].puborder;

  let para;
  for (let i = 0; i < paras.length; i++) {
    para = paras[i];

    // Lower {puborder} than {firstChildPuborder} means there is no holder for {para}.
    // (e.g. paragraph of the book title, title chapters are cut off from the "children",
    // because the title chapter would be the same as the book title in the "Tree").
    if (para.puborder < firstChildPuborder) {
      continue;
    }

    insertParaToNodeByPuborder(book, para);
  }
};

const insertParaToNodeByPuborder = (node, para) => {
  if (node.className === CONTENT_CLASSES.PARAGRAPH) {
    // eslint-disable-next-line no-console
    console.log(
      "%c Paragraph is not allowed as the node! Use book or chapter!",
      "background: black; color: white;",
    );
  }

  const paraPuborder = para.puborder;
  const paraParentChildrenSpread = [...node.children];
  const paraParentChildrenSpreadLength = paraParentChildrenSpread.length;

  if (paraParentChildrenSpreadLength) {
    if (paraParentChildrenSpread[0].className === CONTENT_CLASSES.PARAGRAPH) {
      insertParaToChapterByPuborder(node, para);
    } else {
      let childCurr, childNext, childCurrPuborder, childNextPuborder;
      for (let i = 0; i < paraParentChildrenSpreadLength; i++) {
        childCurr = paraParentChildrenSpread[i];
        childNext = paraParentChildrenSpread[i + 1];
        childCurrPuborder = childCurr.puborder;
        childNextPuborder = childNext?.puborder;

        // Skip push if {para} is already in the book as either a paragraph or a chapter.
        // The priority has a chapter as it has the same {content} as a para.
        if (paraPuborder === childCurrPuborder || paraPuborder === childNextPuborder) {
          return;
        }

        if (
          childCurrPuborder < paraPuborder &&
          (!childNextPuborder || childNextPuborder > paraPuborder)
        ) {
          insertParaToNodeByPuborder(childCurr, para);
        }
      }
    }
  } else {
    node.children = [para];
  }
};

const insertParaToChapterByPuborder = (chapter, para) => {
  const paraPuborder = para.puborder;
  const childrenSpread = [...chapter.children];
  const childrenSpreadLength = childrenSpread.length;

  if (childrenSpreadLength) {
    let childNextPuborder;

    for (let i = 0; i < childrenSpreadLength; i++) {
      const puborderDelta = paraPuborder - childrenSpread[i].puborder;
      childNextPuborder = childrenSpread[i + 1]?.puborder;

      // Skip push if {para} is already in the book as either a paragraph or a chapter.
      // The priority has a chapter as it has the same {content} as a para.
      if (puborderDelta === 0 || (childNextPuborder && childNextPuborder === paraPuborder)) {
        return;
      }

      if (puborderDelta === -1) {
        // push before the item
        chapter.children = [];
        if (i > 0) {
          chapter.children.push(...childrenSpread.slice(0, i));
        }
        chapter.children.push(para);
        chapter.children.push(...childrenSpread.slice(i));
        break;
      }

      if (puborderDelta === 1) {
        // push after the item
        chapter.children = [];
        chapter.children.push(...childrenSpread.slice(0, i + 1));
        chapter.children.push(para);
        if (i < childrenSpreadLength) {
          chapter.children.push(...childrenSpread.slice(i + 1));
        }
        break;
      }
    }
  } else {
    chapter.children = [para];
  }
};

const trimBr = (html) => html.replace(/^( |<br\s*[/]?>)*(.*?)( |<br\s*[/]?>)*$/, "$2");

const generateParasHtml = (readerItems, { refs, headers, pageBreaks } = {}) => {
  let container = document.createElement("div");
  let firstPara, lastPara;
  let lastPageNumber;

  readerItems.forEach((item, index) => {
    const type = item.element_type;
    const isParagraphItem = type === "p";

    const wrap = document.createElement("div");
    wrap.className = CONTENT_CLASSES.PARAGRAPH;
    wrap.dataset.id = item.id;
    const element = document.createElement(type);

    let formedContent = item.content;
    if (isParagraphItem && refs) {
      formedContent += `<span class="${CONTENT_CLASSES.REF_CODE}">${item.refcode_short}</span>`;
    }

    element.innerHTML = `${formedContent} `;

    if (index === 0) {
      firstPara = wrap;
    }
    if (index === readerItems.length - 1) {
      lastPara = wrap;
    }

    if (headers && isParagraphItem) {
      container.insertAdjacentHTML(
        "beforeend",
        `<div class="${CONTENT_CLASSES.READER_HEADER_TEXT}">${item.refcode_long}</div>`,
      );
    }

    wrap.appendChild(element);
    container.appendChild(wrap);

    if (pageBreaks && isParagraphItem) {
      if (lastPageNumber !== item.refcode_2) {
        lastPageNumber = item.refcode_2;
        container.insertAdjacentHTML(
          "beforeend",
          `<div class="${CONTENT_CLASSES.PAGE_NUMBER}">${item.refcode_2}</div>`,
        );
      }
    }
  });

  return { container, firstPara, lastPara };
};

const getIdFromElement = (element) => {
  const { parentElement, id } = element;
  if (id) {
    return id;
  }
  return parentElement ? getIdFromElement(parentElement) : null;
};

const fixDuplicateRefCodes = (options) => {
  let noDupOptions = options.filter((item) => item.refcode_short !== "");
  let duplicates = {};

  noDupOptions.forEach((item) => {
    const refcode = item.refcode_short;
    if (!duplicates[refcode]) {
      duplicates[refcode] = [];
    }
    duplicates[refcode].push(item);
  });

  Object.keys(duplicates).forEach((item) => {
    const indicies = duplicates[item];
    if (indicies.length >= 2) {
      indicies.forEach((option, index) => {
        option.refCodePostFix = index;
      });
    }
  });
  return noDupOptions;
};

const collectAllNodes = (node, holder, classes = []) => {
  if (node.children) {
    node.children.forEach((item) => {
      if (classes.indexOf(item.className) === -1 || classes.length === 0) {
        holder.push(item);
      }
      collectAllNodes(item, holder, classes);
    });
  }
};

/**
 * @description Returns x coordinate of the received event
 * or the last x coordinate of the touches of the received event.
 * @param {MouseEvent|TouchEvent} e
 * @returns {number|undefined}
 */
const getCoordinateX = (e) => {
  let x = e.x ?? e.clientX;

  if (x === undefined) {
    const touches = getTouches(e);
    if (touches?.length) {
      const lastTouch = touches[touches.length - 1];
      if (lastTouch) {
        x = lastTouch.clientX;
      }
    }
  }

  return x;
};

const getChildrenIds = (id, mainTree) => {
  let ids = [id];
  let allNodes = [];
  const getId = (item) => item.id;
  const node = findNode(id, mainTree, "id", allNodes);
  const parent = allNodes[1];
  let siblings = [];
  let parentId;
  if (parent && parent.children) {
    parentId = parent.id;
    siblings = parent.children.map(getId);
  }
  const parents = allNodes.map(getId);
  if (node && node.children) {
    let holder = [];
    collectAllNodes(node, holder, ["para", "chapter"]);
    ids = [id, ...holder.map(getId)];
  }
  return { ids, siblings, parents, parentId };
};

const detectIfLastRead = (luRead, luListen) => {
  if (luRead && luListen) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(luRead).isAfter(luListen);
  } else if (luRead && !luListen) {
    return true;
  } else if (!luRead && luListen) {
    return false;
  }
  return true;
};

const getSortDate = (luRead, luListen, showReadingHistory, showListenHistory) => {
  if (showReadingHistory && showListenHistory) {
    let readDate = luRead ? dayjs(luRead) : undefined;
    let listenDate = luListen ? dayjs(luListen) : undefined;
    if (readDate && listenDate) {
      return readDate.isAfter(listenDate) ? readDate : listenDate;
    } else if (readDate) {
      return readDate;
    } else if (listenDate) {
      return listenDate;
    }
  } else if (showReadingHistory && !showListenHistory && luRead) {
    return dayjs(luRead);
  } else if (!showReadingHistory && showListenHistory && luListen) {
    return dayjs(luListen);
  }
  return undefined;
};


const makeTreeFromList = (data, options = {}) => {
  var ID_KEY = options.id || "id";
  var PARENT_KEY = options.parent || "topic";
  var CHILDREN_KEY = "children";

  var tree = [],
    childrenOf = {};
  var item, id, parentId;

  for (var i = 0, length = data.length; i < length; i++) {
    item = data[i];
    id = item[ID_KEY];
    parentId = item[PARENT_KEY] || 0;
    // every item may have children
    childrenOf[id] = childrenOf[id] || [];
    // init its children
    item[CHILDREN_KEY] = childrenOf[id];
    if (parentId != 0) {
      // init its parent's children object
      childrenOf[parentId] = childrenOf[parentId] || [];
      // push it into its parent's children object
      childrenOf[parentId].push(item);
    } else {
      tree.push(item);
    }
  }

  return tree;
};

/**
 * development
 * staging
 * production
 */

const orderLanguages = (languages = [], addedLanguages = []) => {
  let resultItems = languages
    .filter((item) => addedLanguages.includes(item.id))
    .sort((prev, next) => {
      if (prev.id < next.id) {
        return -1;
      }
      if (prev.id > next.id) {
        return 1;
      }
      return 0;
    });

  resultItems = sortByArray(resultItems, addedLanguages, "id");
  return resultItems;
};

const orderLanguagesDetect = (languages, addedLanguages) => {
  let resultItems = (languages || []).filter((item) => addedLanguages.includes(item.id));
  const defLang = addedLanguages[0];
  const defLangIndex = resultItems.findIndex((item) => item.id === defLang);
  if (defLangIndex !== -1) {
    arraymove(resultItems, defLangIndex, 0);
  }
  return resultItems;
};

/**
 * @description Returns window or document sizes (width and height). Specific
 * window object can be passed.
 * @returns {{width: number, height: number}}
 */
const getWindowSizes = (windowObject = window) => {
  let width, height;

  // Fix for devices, that don't have innerWidth/Height properties. (e.g. old IOS)
  if (windowObject?.innerWidth === undefined) {
    width = windowObject.document.documentElement.clientWidth;
    height = windowObject.document.documentElement.clientHeight;
  } else {
    width = windowObject.innerWidth;
    height = windowObject.innerHeight;
  }

  return { width, height };
};

const checkWordsNumber = (str) => !str || str.trim().split(" ").length > 1;

const getBoundingClientRect = (target, returnOriginalRect = false) => {
  if (!target) {
    return { height: 0, width: 0, x: 0, y: 0, top: 0, left: 0, right: 0, bottom: 0 };
  }

  if (returnOriginalRect) {
    return target.getBoundingClientRect();
  }

  const { height, width, x, y, top, left, right, bottom } = target.getBoundingClientRect();

  return {
    height,
    width,
    left: left || x,
    top: top || y,
    x: left || x,
    y: top || y,
    right,
    bottom,
  };
};

/**
 * Check what button is clicked
 * @param {*} event
 */
const buttonPressedCode = (event) =>
  event.buttons !== undefined ? event.buttons : event.nativeEvent.which;

const findItemById = (list, id) => list.find((item) => item.id === id);

const getSelectionAnchorClosest = (selection, selector) => {
  return selection?.anchorNode?.parentElement?.closest(selector) || null;
};

/**
 * @description Dispatches "name" mouse event on "target" in "touch" position.
 * @param {string} name
 * @param {Object} touch
 * @param {HTMLElement} target
 */
const dispatchMouseEvent = (name, touch, target) => {
  const e = document.createEvent("MouseEvent");
  e.initMouseEvent(
    name,
    true,
    true,
    touch.view,
    1,
    touch.screenX,
    touch.screenY,
    touch.clientX,
    touch.clientY,
    false,
    false,
    false,
    false,
    0,
    null,
  );
  target.dispatchEvent(e);
};

const osList = {
  MAC_OS: "MacOS",
  IOS: "iOS",
  ANDROID: "Android",
  WINDOWS: "Win",
  LINUX: "Linux",
};

const detectOS = () => {
  if (typeof navigator !== "undefined") {
    const platform = navigator.platform.toLowerCase();

    if (getIsIos()) {
      return osList.IOS;
    }
    if (platform.includes("mac")) {
      return osList.MAC_OS;
    }
    if (/android/.test(navigator.userAgent.toLowerCase())) {
      return osList.ANDROID;
    }
    if (platform.includes("win")) {
      return osList.WINDOWS;
    }
    if (/linux/.test(platform)) {
      return osList.LINUX;
    }
  }

  return "unknown";
};

const getExtendedClass = (index, isExpand, selected) => {
  let addClass = "";

  if (!isExpand) {
    addClass = "sideMenuItemCollapsed";
    if (selected !== -1 && index === selected) {
      addClass += " miSel";
    }
  } else if (selected !== -1 && index === selected) {
    addClass = "sideMenuSelected";
  } else if (selected !== -1 && Math.abs(selected - index) === 1 && isExpand) {
    addClass = "sideMenuBigger";
  } else {
    addClass = "sideMenuItemDefault";
  }

  return addClass;
};

/**
 * Returns new DOM element with "tag" name and copied "element" attributes.
 * @param {HTMLElement} element
 * @param {string} tag
 * @returns {HTMLElement}
 */
const changeElementTag = (element, tag) => {
  const newElement = document.createElement(tag);
  const { attributes } = element;

  for (let i = 0, length = attributes.length; i < length; i++) {
    const { nodeName, nodeValue } = attributes.item(i);
    newElement.setAttribute(nodeName, nodeValue);
  }

  newElement.innerHTML = element.innerHTML;

  return newElement;
};

const SCREEN_ORIENTATION = {
  PORTRAIT: "PORTRAIT",
  LANDSCAPE: "LANDSCAPE",
};

/**
 * Returns current screen orientation.
 * @param windowObject - for the test.
 * @param isTabletFlag - for the test.
 * @param isMobileFlag - for the test.
 * @returns {string}
 */
const getScreenOrientation = (
  windowObject = window,
  isTabletFlag = isTablet,
  isMobileFlag = isMobile,
) => {
  let isLandscape = false;

  if (isMobileFlag || isTabletFlag) {
    if (windowObject.matchMedia("(min-aspect-ratio: 13/9)").matches) {
      isLandscape = true;
    }
  } else if (windowObject.innerWidth > windowObject.innerHeight) {
    isLandscape = true;
  }

  if (isLandscape) {
    return SCREEN_ORIENTATION.LANDSCAPE;
  }

  return SCREEN_ORIENTATION.PORTRAIT;
};

const swapObjectsProperty = (obj1, obj2, keys) => {
  if (typeof keys === "string") {
    const temp = obj1[keys];
    obj1[keys] = obj2[keys];
    obj2[keys] = temp;
  } else if (keys instanceof Array) {
    for (let key of keys) {
      swapObjectsProperty(obj1, obj2, key);
    }
  }
};

const findBible = (bibles, id) => bibles.length > 1 && bibles.find((b) => b.id === id);

const getObjectKeysNotNullable = (obj) => Object.keys(obj).filter((key) => !!obj[key]);

const removeDuplicatesFromPrimitives = (options) => [...new Set(options)];

const isFunction = (func) => typeof func === "function";


/***/ }),

/***/ 26923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Tb": function() { return /* reexport */ captureException; },
  "yl": function() { return /* reexport */ flush; },
  "S1": function() { return /* reexport */ client_init; }
});

// UNUSED EXPORTS: Breadcrumbs, BrowserClient, BrowserTracing, Dedupe, ErrorBoundary, FunctionToString, GlobalHandlers, HttpContext, Hub, InboundFilters, Integrations, LinkedErrors, Profiler, Replay, SDK_VERSION, Scope, TryCatch, WINDOW, addBreadcrumb, addGlobalEventProcessor, captureEvent, captureMessage, captureUnderscoreErrorException, chromeStackLineParser, close, configureScope, createReduxEnhancer, createTransport, defaultIntegrations, defaultStackLineParsers, defaultStackParser, eventFromException, eventFromMessage, forceLoad, geckoStackLineParser, getCurrentHub, getHubFromCarrier, lastEventId, makeBrowserOfflineTransport, makeFetchTransport, makeMain, makeXHRTransport, nextRouterInstrumentation, onLoad, opera10StackLineParser, opera11StackLineParser, reactRouterV3Instrumentation, reactRouterV4Instrumentation, reactRouterV5Instrumentation, reactRouterV6Instrumentation, setContext, setExtra, setExtras, setTag, setTags, setUser, showReportDialog, startTransaction, useProfiler, winjsStackLineParser, withErrorBoundary, withProfiler, withScope, withSentryGetServerSideProps, withSentryGetStaticProps, withSentryReactRouterV6Routing, withSentryRouting, withSentryServerSideAppGetInitialProps, withSentryServerSideDocumentGetInitialProps, withSentryServerSideErrorGetInitialProps, withSentryServerSideGetInitialProps, wrap, wrapAppGetInitialPropsWithSentry, wrapCreateBrowserRouter, wrapDocumentGetInitialPropsWithSentry, wrapErrorGetInitialPropsWithSentry, wrapGetInitialPropsWithSentry, wrapGetServerSidePropsWithSentry, wrapGetStaticPropsWithSentry, wrapUseRoutes

// NAMESPACE OBJECT: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/integrations/index.js
var integrations_namespaceObject = {};
__webpack_require__.r(integrations_namespaceObject);
__webpack_require__.d(integrations_namespaceObject, {
  "FunctionToString": function() { return FunctionToString; },
  "InboundFilters": function() { return InboundFilters; }
});

// NAMESPACE OBJECT: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/integrations/index.js
var esm_integrations_namespaceObject = {};
__webpack_require__.r(esm_integrations_namespaceObject);
__webpack_require__.d(esm_integrations_namespaceObject, {
  "Breadcrumbs": function() { return Breadcrumbs; },
  "Dedupe": function() { return Dedupe; },
  "GlobalHandlers": function() { return GlobalHandlers; },
  "HttpContext": function() { return HttpContext; },
  "LinkedErrors": function() { return LinkedErrors; },
  "TryCatch": function() { return TryCatch; }
});

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i] ;
    const fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(81272);
;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/misc.js




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = worldwide/* GLOBAL_OBJ */.n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  const getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    addNonEnumerableProperty(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(37712);
;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/logger.js


/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in worldwide/* GLOBAL_OBJ */.n2)) {
    return callback();
  }

  const originalConsole = worldwide/* GLOBAL_OBJ.console */.n2.console ;
  const wrappedLevels = {};

  // Restore all wrapped console methods
  CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    const originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in originalConsole && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            worldwide/* GLOBAL_OBJ.console */.n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let logger_logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  logger_logger = (0,worldwide/* getGlobalSingleton */.YO)('logger', makeLogger);
} else {
  logger_logger = makeLogger();
}


//# sourceMappingURL=logger.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(16230);
;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/is.js
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return is_isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isEvent(wat) {
  return typeof Event !== 'undefined' && is_isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isElement(wat) {
  return typeof Element !== 'undefined' && is_isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function is_isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}


//# sourceMappingURL=is.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/syncpromise.js


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function syncpromise_resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
   __init() {this._state = States.PENDING;}
   __init2() {this._handlers = [];}

   constructor(
    executor,
  ) {SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);SyncPromise.prototype.__init5.call(this);SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if (isThenable(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/object.js




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    try {
      markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
      // This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function object_addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: value,
    writable: true,
    configurable: true,
  });
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  const proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  object_addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(value)

 {
  if (isError(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if (isEvent(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && isInstanceOf(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return isElement(target) ? htmlTreeAsString(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return truncate(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return truncate(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if (isPlainObject(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/core/esm/session.js


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,time/* timestampInSeconds */.ph)();

  const session = {
    sid: uuid4(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,time/* timestampInSeconds */.ph)();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : uuid4();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return dropUndefinedKeys({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/core/esm/scope.js



/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
      newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      updateSession(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
    } else if (isPlainObject(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,time/* dateTimestampInSeconds */.yW)(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transactionName = this._span.transaction && this._span.transaction.name;
      if (transactionName) {
        event.tags = { transaction: transactionName, ...event.tags };
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = { ...event.sdkProcessingMetadata, ...this._sdkProcessingMetadata };

    return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new SyncPromise((resolve, reject) => {
      const processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        const result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          logger_logger.log(`Event processor "${processor.id}" dropped event`);

        if (isThenable(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? arrayify(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,worldwide/* getGlobalSingleton */.YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}


//# sourceMappingURL=scope.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/core/esm/hub.js




/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * A layer in the process stack.
 * @hidden
 */

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */
    __init() {this._stack = [{}];}

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new Scope(),   _version = API_VERSION) {this._version = _version;Hub.prototype.__init.call(this);
    this.getStackTop().scope = scope;
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = Scope.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4());
    const syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4());
    const syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : uuid4();
    if (!event.type) {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!scope || !client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,time/* dateTimestampInSeconds */.yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? (consoleSandbox(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    const scope = this.getScope();
    if (scope) scope.setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    const scope = this.getScope();
    if (scope) scope.setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    const scope = this.getScope();
    if (scope) scope.setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    const scope = this.getScope();
    if (scope) scope.setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    const scope = this.getScope();
    if (scope) scope.setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    const scope = this.getScope();
    if (scope) scope.setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (scope && client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    return this._callExtensionMethod('startTransaction', context, customSamplingContext);
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer && layer.scope;
    const session = scope && scope.getSession();
    if (session) {
      closeSession(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    if (scope) {
      scope.setSession();
    }
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = worldwide/* GLOBAL_OBJ.navigator */.n2.navigator || {};

    const session = makeSession({
      release,
      environment,
      ...(scope && { user: scope.getUser() }),
      ...(userAgent && { userAgent }),
      ...context,
    });

    if (scope) {
      // End existing session if there's one
      const currentSession = scope.getSession && scope.getSession();
      if (currentSession && currentSession.status === 'ok') {
        updateSession(currentSession, { status: 'exited' });
      }
      this.endSession();

      // Afterwards we set the new session on the scope
      scope.setSession(session);
    }

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();
    if (!scope) return;

    const session = scope.getSession();
    if (session) {
      if (client && client.captureSession) {
        client.captureSession(session);
      }
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  worldwide/* GLOBAL_OBJ.__SENTRY__ */.n2.__SENTRY__ = worldwide/* GLOBAL_OBJ.__SENTRY__ */.n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return worldwide/* GLOBAL_OBJ */.n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function hub_getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Prefer domains over global if they are there (applicable only to Node environment)
  if ((0,node/* isNodeEnv */.KV)()) {
    return getHubFromActiveDomain(registry);
  }
  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
  try {
    const sentry = getMainCarrier().__SENTRY__;
    const activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;

    // If there's no active domain, just return global hub
    if (!activeDomain) {
      return getHubFromCarrier(registry);
    }

    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
      const registryHubTopStack = getHubFromCarrier(registry).getStackTop();
      setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, Scope.clone(registryHubTopStack.scope)));
    }

    // Return hub that lives on a domain
    return getHubFromCarrier(activeDomain);
  } catch (_Oo) {
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
  }
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,worldwide/* getGlobalSingleton */.YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/core/esm/utils/hasTracingEnabled.js


// Treeshakable guard to remove all code related to tracing

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) {
    return false;
  }

  const client = hub_getCurrentHub().getClient();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


//# sourceMappingURL=hasTracingEnabled.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/integrations/node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js

/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  let up = 0;
  for (let i = parts.length - 1; i >= 0; i--) {
    const last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */
function splitPath(filename) {
  const parts = splitPathRe.exec(filename);
  return parts ? parts.slice(1) : [];
}

// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve(...args) {
  let resolvedPath = '';
  let resolvedAbsolute = false;

  for (let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    const path = i >= 0 ? args[i] : '/';

    // Skip empty entries
    if (!path) {
      continue;
    }

    resolvedPath = `${path}/${resolvedPath}`;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(
    resolvedPath.split('/').filter(p => !!p),
    !resolvedAbsolute,
  ).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}

/** JSDoc */
function trim(arr) {
  let start = 0;
  for (; start < arr.length; start++) {
    if (arr[start] !== '') {
      break;
    }
  }

  let end = arr.length - 1;
  for (; end >= 0; end--) {
    if (arr[end] !== '') {
      break;
    }
  }

  if (start > end) {
    return [];
  }
  return arr.slice(start, end - start + 1);
}

// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
  /* eslint-disable no-param-reassign */
  from = resolve(from).slice(1);
  to = resolve(to).slice(1);
  /* eslint-enable no-param-reassign */

  const fromParts = trim(from.split('/'));
  const toParts = trim(to.split('/'));

  const length = Math.min(fromParts.length, toParts.length);
  let samePartsLength = length;
  for (let i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  let outputParts = [];
  for (let i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
}

// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
  const isPathAbsolute = isAbsolute(path);
  const trailingSlash = path.slice(-1) === '/';

  // Normalize the path
  let normalizedPath = normalizeArray(
    path.split('/').filter(p => !!p),
    !isPathAbsolute,
  ).join('/');

  if (!normalizedPath && !isPathAbsolute) {
    normalizedPath = '.';
  }
  if (normalizedPath && trailingSlash) {
    normalizedPath += '/';
  }

  return (isPathAbsolute ? '/' : '') + normalizedPath;
}

// posix version
/** JSDoc */
function isAbsolute(path) {
  return path.charAt(0) === '/';
}

// posix version
/** JSDoc */
function join(...args) {
  return normalizePath(args.join('/'));
}

/** JSDoc */
function dirname(path) {
  const result = splitPath(path);
  const root = result[0];
  let dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
  }

  return root + dir;
}

/** JSDoc */
function basename(path, ext) {
  let f = splitPath(path)[2];
  if (ext && f.slice(ext.length * -1) === ext) {
    f = f.slice(0, f.length - ext.length);
  }
  return f;
}


//# sourceMappingURL=path.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/integrations/esm/rewriteframes.js


/** Rewrite event frames paths */
class RewriteFrames  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'RewriteFrames';}

  /**
   * @inheritDoc
   */
   __init() {this.name = RewriteFrames.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
    __init2() {this._prefix = 'app:///';}

  /**
   * @inheritDoc
   */
   constructor(options = {}) {RewriteFrames.prototype.__init.call(this);RewriteFrames.prototype.__init2.call(this);RewriteFrames.prototype.__init3.call(this);
    if (options.root) {
      this._root = options.root;
    }
    if (options.prefix) {
      this._prefix = options.prefix;
    }
    if (options.iteratee) {
      this._iteratee = options.iteratee;
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    addGlobalEventProcessor(event => {
      const self = getCurrentHub().getIntegration(RewriteFrames);
      if (self) {
        return self.process(event);
      }
      return event;
    });
  }

  /** JSDoc */
   process(originalEvent) {
    let processedEvent = originalEvent;

    if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
      processedEvent = this._processExceptionsEvent(processedEvent);
    }

    return processedEvent;
  }

  /**
   * @inheritDoc
   */
    __init3() {this._iteratee = (frame) => {
    if (!frame.filename) {
      return frame;
    }
    // Check if the frame filename begins with `/` or a Windows-style prefix such as `C:\`
    const isWindowsFrame = /^[A-Z]:\\/.test(frame.filename);
    const startsWithSlash = /^\//.test(frame.filename);
    if (isWindowsFrame || startsWithSlash) {
      const filename = isWindowsFrame
        ? frame.filename
            .replace(/^[A-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
        : frame.filename;
      const base = this._root ? relative(this._root, filename) : basename(filename);
      frame.filename = `${this._prefix}${base}`;
    }
    return frame;
  };}

  /** JSDoc */
   _processExceptionsEvent(event) {
    try {
      return {
        ...event,
        exception: {
          ...event.exception,
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(value => ({
            ...value,
            ...(value.stacktrace && { stacktrace: this._processStacktrace(value.stacktrace) }),
          })),
        },
      };
    } catch (_oO) {
      return event;
    }
  }

  /** JSDoc */
   _processStacktrace(stacktrace) {
    return {
      ...stacktrace,
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(f => this._iteratee(f)),
    };
  }
} RewriteFrames.__initStatic();


//# sourceMappingURL=rewriteframes.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/version.js
const SDK_VERSION = '7.40.0';


//# sourceMappingURL=version.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/worldwide.js
var esm_worldwide = __webpack_require__(55574);
;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/logger.js


/** Prefix for logging strings */
const logger_PREFIX = 'Sentry Logger ';

const logger_CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function logger_consoleSandbox(callback) {
  if (!("console" in esm_worldwide/* GLOBAL_OBJ */.n2)) {
    return callback();
  }

  const originalConsole = esm_worldwide/* GLOBAL_OBJ.console */.n2.console ;
  const wrappedLevels = {};

  // Restore all wrapped console methods
  logger_CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    const originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in originalConsole && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function logger_makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    logger_CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          logger_consoleSandbox(() => {
            esm_worldwide/* GLOBAL_OBJ.console */.n2.console[name](`${logger_PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    logger_CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let esm_logger_logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  esm_logger_logger = (0,esm_worldwide/* getGlobalSingleton */.YO)('logger', logger_makeLogger);
} else {
  esm_logger_logger = logger_makeLogger();
}


//# sourceMappingURL=logger.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/is.js
// eslint-disable-next-line @typescript-eslint/unbound-method
const is_objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function esm_is_isError(wat) {
  switch (is_objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return esm_is_isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function is_isBuiltin(wat, className) {
  return is_objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isErrorEvent(wat) {
  return is_isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isDOMError(wat) {
  return is_isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isDOMException(wat) {
  return is_isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isString(wat) {
  return is_isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function esm_is_isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isPlainObject(wat) {
  return is_isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function esm_is_isEvent(wat) {
  return typeof Event !== 'undefined' && esm_is_isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function esm_is_isElement(wat) {
  return typeof Element !== 'undefined' && esm_is_isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isRegExp(wat) {
  return is_isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function is_isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isSyntheticEvent(wat) {
  return is_isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function esm_is_isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function esm_is_isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}


//# sourceMappingURL=is.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/browser.js



// eslint-disable-next-line deprecation/deprecation
const browser_WINDOW = (0,esm_worldwide/* getGlobalObject */.Rf)();

const DEFAULT_MAX_STRING_LENGTH = 80;

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function browser_htmlTreeAsString(
  elem,
  options = {},
) {

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = (!Array.isArray(options) && options.maxStringLength) || DEFAULT_MAX_STRING_LENGTH;

    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds maxStringLength
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && is_isString(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['aria-label', 'type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return browser_WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (browser_WINDOW.document && browser_WINDOW.document.querySelector) {
    return browser_WINDOW.document.querySelector(selector) ;
  }
  return null;
}


//# sourceMappingURL=browser.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/string.js


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function string_truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function string_snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      output.push(String(value));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function isMatchingPattern(
  value,
  pattern,
  requireExactStringMatch = false,
) {
  if (!is_isString(value)) {
    return false;
  }

  if (is_isRegExp(pattern)) {
    return pattern.test(value);
  }
  if (is_isString(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }

  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function stringMatchesSomePattern(
  testString,
  patterns = [],
  requireExactStringMatch = false,
) {
  return patterns.some(pattern => isMatchingPattern(testString, pattern, requireExactStringMatch));
}

/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
  // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
  // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
  return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}


//# sourceMappingURL=string.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/object.js




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function object_fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    try {
      object_markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
      // This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function esm_object_addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: value,
    writable: true,
    configurable: true,
  });
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function object_markFunctionWrapped(wrapped, original) {
  const proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  esm_object_addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function object_getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function object_urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function object_convertToPlainObject(value)

 {
  if (esm_is_isError(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...object_getOwnProperties(value),
    };
  } else if (esm_is_isEvent(value)) {
    const newObj

 = {
      type: value.type,
      target: object_serializeEventTarget(value.target),
      currentTarget: object_serializeEventTarget(value.currentTarget),
      ...object_getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && esm_is_isInstanceOf(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function object_serializeEventTarget(target) {
  try {
    return esm_is_isElement(target) ? browser_htmlTreeAsString(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function object_getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function object_extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(object_convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return string_truncate(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return string_truncate(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function object_dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return esm_object_dropUndefinedKeys(inputValue, memoizationMap);
}

function esm_object_dropUndefinedKeys(inputValue, memoizationMap) {
  if (is_isPlainObject(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = esm_object_dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(esm_object_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function object_objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/misc.js




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function misc_uuid4() {
  const gbl = esm_worldwide/* GLOBAL_OBJ */.n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  const getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function misc_getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function misc_getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = misc_getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function misc_addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function misc_addExceptionMechanism(event, newMechanism) {
  const firstException = misc_getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const misc_SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function misc_parseSemver(input) {
  const match = input.match(misc_SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function misc_addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function misc_checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    esm_object_addNonEnumerableProperty(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function misc_arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/integrations/inboundfilters.js


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];

/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */
class InboundFilters  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'InboundFilters';}

  /**
   * @inheritDoc
   */
   __init() {this.name = InboundFilters.id;}

   constructor(  _options = {}) {this._options = _options;InboundFilters.prototype.__init.call(this);}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcess = (event) => {
      const hub = getCurrentHub();
      if (hub) {
        const self = hub.getIntegration(InboundFilters);
        if (self) {
          const client = hub.getClient();
          const clientOptions = client ? client.getOptions() : {};
          const options = _mergeOptions(self._options, clientOptions);
          return _shouldDropEvent(event, options) ? null : event;
        }
      }
      return event;
    };

    eventProcess.id = this.name;
    addGlobalEventProcessor(eventProcess);
  }
} InboundFilters.__initStatic();

/** JSDoc */
function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...DEFAULT_IGNORE_ERRORS,
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

/** JSDoc */
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger_logger.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${misc_getEventDescription(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger_logger.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${misc_getEventDescription(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger_logger.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${misc_getEventDescription(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger_logger.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${misc_getEventDescription(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  if (!ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message => stringMatchesSomePattern(message, ignoreErrors));
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : stringMatchesSomePattern(url, denyUrls);
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : stringMatchesSomePattern(url, allowUrls);
}

function _getPossibleEventMessages(event) {
  if (event.message) {
    return [event.message];
  }
  if (event.exception) {
    try {
      const { type = '', value = '' } = (event.exception.values && event.exception.values[0]) || {};
      return [`${value}`, `${type}: ${value}`];
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.error(`Cannot extract message for event ${misc_getEventDescription(event)}`);
      return [];
    }
  }
  return [];
}

function _isSentryError(event) {
  try {
    // @ts-ignore can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-ignore we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.error(`Cannot extract url for event ${misc_getEventDescription(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/integrations/functiontostring.js


let originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
class FunctionToString  {constructor() { FunctionToString.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'FunctionToString';}

  /**
   * @inheritDoc
   */
   __init() {this.name = FunctionToString.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    originalFunctionToString = Function.prototype.toString;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Function.prototype.toString = function ( ...args) {
      const context = object_getOriginalFunction(this) || this;
      return originalFunctionToString.apply(context, args);
    };
  }
} FunctionToString.__initStatic();


//# sourceMappingURL=functiontostring.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/time.js
var esm_time = __webpack_require__(1088);
// EXTERNAL MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/node.js
var esm_node = __webpack_require__(94440);
;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/syncpromise.js


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var syncpromise_States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(syncpromise_States || (syncpromise_States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function esm_syncpromise_resolvedSyncPromise(value) {
  return new syncpromise_SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function syncpromise_rejectedSyncPromise(reason) {
  return new syncpromise_SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class syncpromise_SyncPromise {
   __init() {this._state = syncpromise_States.PENDING;}
   __init2() {this._handlers = [];}

   constructor(
    executor,
  ) {syncpromise_SyncPromise.prototype.__init.call(this);syncpromise_SyncPromise.prototype.__init2.call(this);syncpromise_SyncPromise.prototype.__init3.call(this);syncpromise_SyncPromise.prototype.__init4.call(this);syncpromise_SyncPromise.prototype.__init5.call(this);syncpromise_SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new syncpromise_SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new syncpromise_SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(syncpromise_States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(syncpromise_States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== syncpromise_States.PENDING) {
      return;
    }

    if (is_isThenable(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === syncpromise_States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === syncpromise_States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === syncpromise_States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/session.js


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function session_makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,esm_time/* timestampInSeconds */.ph)();

  const session = {
    sid: misc_uuid4(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => session_sessionToJSON(session),
  };

  if (context) {
    session_updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function session_updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,esm_time/* timestampInSeconds */.ph)();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : misc_uuid4();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function session_closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  session_updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function session_sessionToJSON(session) {
  return object_dropUndefinedKeys({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/scope.js



/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const scope_DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class scope_Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new scope_Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
      newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      session_updateSession(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof scope_Scope ? updatedScope : this;
    }

    if (captureContext instanceof scope_Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
    } else if (is_isPlainObject(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : scope_DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,esm_time/* dateTimestampInSeconds */.yW)(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transactionName = this._span.transaction && this._span.transaction.name;
      if (transactionName) {
        event.tags = { transaction: transactionName, ...event.tags };
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = { ...event.sdkProcessingMetadata, ...this._sdkProcessingMetadata };

    return this._notifyEventProcessors([...scope_getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new syncpromise_SyncPromise((resolve, reject) => {
      const processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        const result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          esm_logger_logger.log(`Event processor "${processor.id}" dropped event`);

        if (is_isThenable(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? misc_arrayify(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

/**
 * Returns the global event processors.
 */
function scope_getGlobalEventProcessors() {
  return (0,esm_worldwide/* getGlobalSingleton */.YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function scope_addGlobalEventProcessor(callback) {
  scope_getGlobalEventProcessors().push(callback);
}


//# sourceMappingURL=scope.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/hub.js




/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const hub_API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const hub_DEFAULT_BREADCRUMBS = 100;

/**
 * A layer in the process stack.
 * @hidden
 */

/**
 * @inheritDoc
 */
class hub_Hub  {
  /** Is a {@link Layer}[] containing the client and scope */
    __init() {this._stack = [{}];}

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new scope_Scope(),   _version = hub_API_VERSION) {this._version = _version;hub_Hub.prototype.__init.call(this);
    this.getStackTop().scope = scope;
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = scope_Scope.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : misc_uuid4());
    const syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : misc_uuid4());
    const syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : misc_uuid4();
    if (!event.type) {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!scope || !client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = hub_DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,esm_time/* dateTimestampInSeconds */.yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? (logger_consoleSandbox(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    const scope = this.getScope();
    if (scope) scope.setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    const scope = this.getScope();
    if (scope) scope.setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    const scope = this.getScope();
    if (scope) scope.setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    const scope = this.getScope();
    if (scope) scope.setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    const scope = this.getScope();
    if (scope) scope.setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    const scope = this.getScope();
    if (scope) scope.setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (scope && client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = hub_makeMain(this);
    try {
      callback(this);
    } finally {
      hub_makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    return this._callExtensionMethod('startTransaction', context, customSamplingContext);
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer && layer.scope;
    const session = scope && scope.getSession();
    if (session) {
      session_closeSession(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    if (scope) {
      scope.setSession();
    }
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = esm_worldwide/* GLOBAL_OBJ.navigator */.n2.navigator || {};

    const session = session_makeSession({
      release,
      environment,
      ...(scope && { user: scope.getUser() }),
      ...(userAgent && { userAgent }),
      ...context,
    });

    if (scope) {
      // End existing session if there's one
      const currentSession = scope.getSession && scope.getSession();
      if (currentSession && currentSession.status === 'ok') {
        session_updateSession(currentSession, { status: 'exited' });
      }
      this.endSession();

      // Afterwards we set the new session on the scope
      scope.setSession(session);
    }

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();
    if (!scope) return;

    const session = scope.getSession();
    if (session) {
      if (client && client.captureSession) {
        client.captureSession(session);
      }
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = hub_getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function hub_getMainCarrier() {
  esm_worldwide/* GLOBAL_OBJ.__SENTRY__ */.n2.__SENTRY__ = esm_worldwide/* GLOBAL_OBJ.__SENTRY__ */.n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return esm_worldwide/* GLOBAL_OBJ */.n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function hub_makeMain(hub) {
  const registry = hub_getMainCarrier();
  const oldHub = hub_getHubFromCarrier(registry);
  hub_setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function esm_hub_getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = hub_getMainCarrier();

  // If there's no hub, or its an old API, assign a new one
  if (!hub_hasHubOnCarrier(registry) || hub_getHubFromCarrier(registry).isOlderThan(hub_API_VERSION)) {
    hub_setHubOnCarrier(registry, new hub_Hub());
  }

  // Prefer domains over global if they are there (applicable only to Node environment)
  if ((0,esm_node/* isNodeEnv */.KV)()) {
    return hub_getHubFromActiveDomain(registry);
  }
  // Return hub that lives on a global object
  return hub_getHubFromCarrier(registry);
}

/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function hub_getHubFromActiveDomain(registry) {
  try {
    const sentry = hub_getMainCarrier().__SENTRY__;
    const activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;

    // If there's no active domain, just return global hub
    if (!activeDomain) {
      return hub_getHubFromCarrier(registry);
    }

    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hub_hasHubOnCarrier(activeDomain) || hub_getHubFromCarrier(activeDomain).isOlderThan(hub_API_VERSION)) {
      const registryHubTopStack = hub_getHubFromCarrier(registry).getStackTop();
      hub_setHubOnCarrier(activeDomain, new hub_Hub(registryHubTopStack.client, scope_Scope.clone(registryHubTopStack.scope)));
    }

    // Return hub that lives on a domain
    return hub_getHubFromCarrier(activeDomain);
  } catch (_Oo) {
    // Return hub that lives on a global object
    return hub_getHubFromCarrier(registry);
  }
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hub_hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function hub_getHubFromCarrier(carrier) {
  return (0,esm_worldwide/* getGlobalSingleton */.YO)('hub', () => new hub_Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function hub_setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/integration.js




const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};

  integrations.forEach(currentInstance => {
    const { name } = currentInstance;

    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });

  return Object.values(integrationsByName);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });

  let integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    integrations = misc_arrayify(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = finalIntegrations.findIndex(integration => integration.name === 'Debug');
  if (debugIndex !== -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(integrations) {
  const integrationIndex = {};

  integrations.forEach(integration => {
    // guard against empty provided integrations
    if (integration) {
      setupIntegration(integration, integrationIndex);
    }
  });

  return integrationIndex;
}

/** Setup a single integration.  */
function setupIntegration(integration, integrationIndex) {
  integrationIndex[integration.name] = integration;

  if (installedIntegrations.indexOf(integration.name) === -1) {
    integration.setupOnce(scope_addGlobalEventProcessor, esm_hub_getCurrentHub);
    installedIntegrations.push(integration.name);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.log(`Integration installed: ${integration.name}`);
  }
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/sdk.js



/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      esm_logger_logger.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      // eslint-disable-next-line no-console
      console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
  }
  const hub = esm_hub_getCurrentHub();
  const scope = hub.getScope();
  if (scope) {
    scope.update(options.initialScope);
  }

  const client = new clientClass(options);
  hub.bindClient(client);
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/stacktrace.js
const STACKTRACE_LIMIT = 50;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];
    for (const line of stack.split('\n').slice(skipFirst)) {
      // Ignore lines over 1kb as they are unlikely to be stack frames.
      // Many of the regular expressions use backtracking which results in run time that increases exponentially with
      // input size. Huge strings can result in hangs/Denial of Service:
      // https://github.com/getsentry/sentry-javascript/issues/2286
      if (line.length > 1024) {
        continue;
      }

      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = line.replace(/\(error: (.*)\)/, '$1');

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  let localStack = stack;

  const firstFrameFunction = localStack[0].function || '';
  const lastFrameFunction = localStack[localStack.length - 1].function || '';

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
    localStack = localStack.slice(1);
  }

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
    localStack = localStack.slice(0, -1);
  }

  // The frame where the crash happened, should be the last entry in the array
  return localStack
    .slice(0, STACKTRACE_LIMIT)
    .map(frame => ({
      ...frame,
      filename: frame.filename || localStack[0].filename,
      function: frame.function || '?',
    }))
    .reverse();
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

// eslint-disable-next-line complexity
function stacktrace_node(getModule) {
  const FILENAME_MATCH = /^\s*[-]{4,}$/;
  const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;

  // eslint-disable-next-line complexity
  return (line) => {
    if (line.match(FILENAME_MATCH)) {
      return {
        filename: line,
      };
    }

    const lineMatch = line.match(FULL_MATCH);
    if (!lineMatch) {
      return undefined;
    }

    let object;
    let method;
    let functionName;
    let typeName;
    let methodName;

    if (lineMatch[1]) {
      functionName = lineMatch[1];

      let methodStart = functionName.lastIndexOf('.');
      if (functionName[methodStart - 1] === '.') {
        methodStart--;
      }

      if (methodStart > 0) {
        object = functionName.slice(0, methodStart);
        method = functionName.slice(methodStart + 1);
        const objectEnd = object.indexOf('.Module');
        if (objectEnd > 0) {
          functionName = functionName.slice(objectEnd + 1);
          object = object.slice(0, objectEnd);
        }
      }
      typeName = undefined;
    }

    if (method) {
      typeName = object;
      methodName = method;
    }

    if (method === '<anonymous>') {
      methodName = undefined;
      functionName = undefined;
    }

    if (functionName === undefined) {
      methodName = methodName || '<anonymous>';
      functionName = typeName ? `${typeName}.${methodName}` : methodName;
    }

    const filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
    const isNative = lineMatch[5] === 'native';
    const isInternal =
      isNative || (filename && !filename.startsWith('/') && !filename.startsWith('.') && filename.indexOf(':\\') !== 1);

    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    const in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');

    return {
      filename,
      module: getModule ? getModule(filename) : undefined,
      function: functionName,
      lineno: parseInt(lineMatch[3], 10) || undefined,
      colno: parseInt(lineMatch[4], 10) || undefined,
      in_app,
    };
  };
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, stacktrace_node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/supports.js



// eslint-disable-next-line deprecation/deprecation
const supports_WINDOW = (0,esm_worldwide/* getGlobalObject */.Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-ignore It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in supports_WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(supports_WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = supports_WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger_logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in supports_WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chrome = (supports_WINDOW ).chrome;
  const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in supports_WINDOW && !!supports_WINDOW.history.pushState && !!supports_WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supports.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/instrument.js







// eslint-disable-next-line deprecation/deprecation
const instrument_WINDOW = (0,esm_worldwide/* getGlobalObject */.Rf)();

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

const handlers = {};
const instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (const handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger_logger.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${getFunctionName(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!('console' in instrument_WINDOW)) {
    return;
  }

  logger_CONSOLE_LEVELS.forEach(function (level) {
    if (!(level in instrument_WINDOW.console)) {
      return;
    }

    object_fill(instrument_WINDOW.console, level, function (originalConsoleMethod) {
      return function (...args) {
        triggerHandlers('console', { args, level });

        // this fails for some browsers. :(
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(instrument_WINDOW.console, args);
        }
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!supportsNativeFetch()) {
    return;
  }

  object_fill(instrument_WINDOW, 'fetch', function (originalFetch) {
    return function (...args) {
      const handlerData = {
        args,
        fetchData: {
          method: getFetchMethod(args),
          url: getFetchUrl(args),
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(instrument_WINDOW, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs = []) {
  if ('Request' in instrument_WINDOW && esm_is_isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
    return String(fetchArgs[0].method).toUpperCase();
  }
  if (fetchArgs[1] && fetchArgs[1].method) {
    return String(fetchArgs[1].method).toUpperCase();
  }
  return 'GET';
}

/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs = []) {
  if (typeof fetchArgs[0] === 'string') {
    return fetchArgs[0];
  }
  if ('Request' in instrument_WINDOW && esm_is_isInstanceOf(fetchArgs[0], Request)) {
    return fetchArgs[0].url;
  }
  return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */

/** JSDoc */
function instrumentXHR() {
  if (!('XMLHttpRequest' in instrument_WINDOW)) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  object_fill(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const xhr = this;
      const url = args[1];
      const xhrInfo = (xhr.__sentry_xhr__ = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: is_isString(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
      });

      // if Sentry key appears in URL, don't capture it as a request
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (is_isString(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        xhr.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = function () {
        if (xhr.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = xhr.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr,
          });
        }
      };

      if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
        object_fill(xhr, 'onreadystatechange', function (original) {
          return function (...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(xhr, readyStateArgs);
          };
        });
      } else {
        xhr.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      return originalOpen.apply(xhr, args);
    };
  });

  object_fill(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      if (this.__sentry_xhr__ && args[0] !== undefined) {
        this.__sentry_xhr__.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!supportsHistory()) {
    return;
  }

  const oldOnPopState = instrument_WINDOW.onpopstate;
  instrument_WINDOW.onpopstate = function ( ...args) {
    const to = instrument_WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  object_fill(instrument_WINDOW.history, 'pushState', historyReplacementFunction);
  object_fill(instrument_WINDOW.history, 'replaceState', historyReplacementFunction);
}

const debounceDuration = 1000;
let debounceTimerID;
let lastCapturedEvent;

/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
  // If there was no previous event, it should always be swapped for the new one.
  if (!previous) {
    return true;
  }

  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (previous.type !== current.type) {
    return true;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (previous.target !== current.target) {
      return true;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return false;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
  // We are only interested in filtering `keypress` events for now.
  if (event.type !== 'keypress') {
    return false;
  }

  try {
    const target = event.target ;

    if (!target || !target.tagName) {
      return true;
    }

    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || lastCapturedEvent === event) {
      return;
    }

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event)) {
      return;
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
    if (debounceTimerID === undefined) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }
    // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = instrument_WINDOW.setTimeout(() => {
      debounceTimerID = undefined;
    }, debounceDuration);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!('document' in instrument_WINDOW)) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  instrument_WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  instrument_WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (instrument_WINDOW )[target] && (instrument_WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    object_fill(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount++;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    object_fill(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount--;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = instrument_WINDOW.onerror;

  instrument_WINDOW.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = instrument_WINDOW.onunhandledrejection;

  instrument_WINDOW.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };
}


//# sourceMappingURL=instrument.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class error_SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;
    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/dsn.js


/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsn_dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    throw new error_SentryError(`Invalid Sentry Dsn: ${str}`);
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  requiredComponents.forEach(component => {
    if (!dsn[component]) {
      throw new error_SentryError(`Invalid Sentry Dsn: ${component} missing`);
    }
  });

  if (!projectId.match(/^\d+$/)) {
    throw new error_SentryError(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
  }

  if (!isValidProtocol(protocol)) {
    throw new error_SentryError(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
  }

  if (port && isNaN(parseInt(port, 10))) {
    throw new error_SentryError(`Invalid Sentry Dsn: Invalid port ${port}`);
  }

  return true;
}

/** The Sentry Dsn, identifying a Sentry instance and project. */
function dsn_makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  validateDsn(components);
  return components;
}


//# sourceMappingURL=dsn.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = +Infinity, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  const normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !esm_is_isNaN(value))) {
    return value ;
  }

  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We're also done if we've reached the max depth
  if (depth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, depth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = object_convertToPlainObject(value );

  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);

    numAdded++;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    // React's SyntheticEvent thingy
    if (is_isSyntheticEvent(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
    if (value === void 0) {
      return '[undefined]';
    }

    if (typeof value === 'function') {
      return `[Function: ${getFunctionName(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    return `[object ${getConstructorName(value)}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}

function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);

  return prototype ? prototype.constructor.name : 'null prototype';
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}


//# sourceMappingURL=normalize.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/envelope.js




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  const envelopeItems = envelope[1];

  for (const envelopeItem of envelopeItems) {
    const envelopeItemType = envelopeItem[0].type;
    const result = callback(envelopeItem, envelopeItemType);

    if (result) {
      return true;
    }
  }

  return false;
}

/**
 * Returns true if the envelope contains any of the given envelope item types
 */
function envelopeContainsItemType(envelope, types) {
  return forEachEnvelopeItem(envelope, (_, type) => types.includes(type));
}

/**
 * Encode a string to UTF8.
 */
function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (const item of items) {
    const [itemHeaders, payload] = item;

    append(`\n${JSON.stringify(itemHeaders)}\n`);

    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify(normalize(payload));
      }
      append(stringifiedPayload);
    }
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Parses an envelope
 */
function parseEnvelope(
  env,
  textEncoder,
  textDecoder,
) {
  let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;

  function readBinary(length) {
    const bin = buffer.subarray(0, length);
    // Replace the buffer with the remaining data excluding trailing newline
    buffer = buffer.subarray(length + 1);
    return bin;
  }

  function readJson() {
    let i = buffer.indexOf(0xa);
    // If we couldn't find a newline, we must have found the end of the buffer
    if (i < 0) {
      i = buffer.length;
    }

    return JSON.parse(textDecoder.decode(readBinary(i))) ;
  }

  const envelopeHeader = readJson();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const items = [];

  while (buffer.length) {
    const itemHeader = readJson();
    const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;

    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
  }

  return [envelopeHeader, items];
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    object_dropUndefinedKeys({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
  profile: 'profile',
  replay_event: 'replay',
  replay_recording: 'replay',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}

/** Extracts the minimal SDK info from from the metadata or an events */
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent || !metadataOrEvent.sdk) {
    return;
  }
  const { name, version } = metadataOrEvent.sdk;
  return { name, version };
}

/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */
function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;

  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
    ...(event.type === 'transaction' &&
      dynamicSamplingContext && {
        trace: object_dropUndefinedKeys({ ...dynamicSamplingContext }),
      }),
  };
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/api.js


const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return object_urlEncode({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function api_getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  const dsn = makeDsn(dsnLike);
  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/envelope.js


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
  };

  const envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session];

  return createEnvelope(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);

  /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */
  const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  const envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  const eventItem = [{ type: eventType }, event];
  return createEnvelope(envelopeHeaders, [eventItem]);
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/utils/prepareEvent.js



/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */
function prepareEvent(
  options,
  event,
  hint,
  scope,
) {
  const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || misc_uuid4(),
    timestamp: event.timestamp || (0,esm_time/* dateTimestampInSeconds */.yW)(),
  };
  const integrations = hint.integrations || options.integrations.map(i => i.name);

  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(prepared, integrations);
  applyDebugMetadata(prepared, options.stackParser);

  // If we have scope given to us, use it as the base for further modifications.
  // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
  let finalScope = scope;
  if (hint.captureContext) {
    finalScope = scope_Scope.clone(finalScope).update(hint.captureContext);
  }

  // We prepare the result here with a resolved Event.
  let result = esm_syncpromise_resolvedSyncPromise(prepared);

  // This should be the last thing called, since we want that
  // {@link Hub.addEventProcessor} gets the finished prepared event.
  //
  // We need to check for the existence of `finalScope.getAttachments`
  // because `getAttachments` can be undefined if users are using an older version
  // of `@sentry/core` that does not have the `getAttachments` method.
  // See: https://github.com/getsentry/sentry-javascript/issues/5229
  if (finalScope) {
    // Collect attachments from the hint and scope
    if (finalScope.getAttachments) {
      const attachments = [...(hint.attachments || []), ...finalScope.getAttachments()];

      if (attachments.length) {
        hint.attachments = attachments;
      }
    }

    // In case we have a hub we reassign it.
    result = finalScope.applyToEvent(prepared, hint);
  }

  return result.then(evt => {
    if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}

/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */
function applyClientOptions(event, options) {
  const { environment, release, dist, maxValueLength = 250 } = options;

  if (!('environment' in event)) {
    event.environment = 'environment' in options ? environment : 'production';
  }

  if (event.release === undefined && release !== undefined) {
    event.release = release;
  }

  if (event.dist === undefined && dist !== undefined) {
    event.dist = dist;
  }

  if (event.message) {
    event.message = string_truncate(event.message, maxValueLength);
  }

  const exception = event.exception && event.exception.values && event.exception.values[0];
  if (exception && exception.value) {
    exception.value = string_truncate(exception.value, maxValueLength);
  }

  const request = event.request;
  if (request && request.url) {
    request.url = string_truncate(request.url, maxValueLength);
  }
}

/**
 * Applies debug metadata images to the event in order to apply source maps by looking up their debug ID.
 */
function applyDebugMetadata(event, stackParser) {
  const debugIdMap = esm_worldwide/* GLOBAL_OBJ._sentryDebugIds */.n2._sentryDebugIds;

  if (!debugIdMap) {
    return;
  }

  // Build a map of abs_path -> debug_id
  const absPathDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace) => {
    const parsedStack = stackParser(debugIdStackTrace);
    for (const stackFrame of parsedStack) {
      if (stackFrame.abs_path) {
        acc[stackFrame.abs_path] = debugIdMap[debugIdStackTrace];
        break;
      }
    }
    return acc;
  }, {});

  // Get a Set of abs_paths in the stack trace
  const errorAbsPaths = new Set();
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.abs_path) {
          errorAbsPaths.add(frame.abs_path);
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }

  // Fill debug_meta information
  event.debug_meta = event.debug_meta || {};
  event.debug_meta.images = event.debug_meta.images || [];
  const images = event.debug_meta.images;
  errorAbsPaths.forEach(absPath => {
    if (absPathDebugIdMap[absPath]) {
      images.push({
        type: 'sourcemap',
        code_file: absPath,
        debug_id: absPathDebugIdMap[absPath],
      });
    }
  });
}

/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationNames];
  }
}

/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */
function normalizeEvent(event, depth, maxBreadth) {
  if (!event) {
    return null;
  }

  const normalized = {
    ...event,
    ...(event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map(b => ({
        ...b,
        ...(b.data && {
          data: normalize(b.data, depth, maxBreadth),
        }),
      })),
    }),
    ...(event.user && {
      user: normalize(event.user, depth, maxBreadth),
    }),
    ...(event.contexts && {
      contexts: normalize(event.contexts, depth, maxBreadth),
    }),
    ...(event.extra && {
      extra: normalize(event.extra, depth, maxBreadth),
    }),
  };

  // event.contexts.trace stores information about a Transaction. Similarly,
  // event.spans[] stores information about child Spans. Given that a
  // Transaction is conceptually a Span, normalization should apply to both
  // Transactions and Spans consistently.
  // For now the decision is to skip normalization of Transactions and Spans,
  // so this block overwrites the normalized event to add back the original
  // Transaction information prior to normalization.
  if (event.contexts && event.contexts.trace && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;

    // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = normalize(event.contexts.trace.data, depth, maxBreadth);
    }
  }

  // event.spans[].data may contain circular/dangerous data so we need to normalize it
  if (event.spans) {
    normalized.spans = event.spans.map(span => {
      // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
      if (span.data) {
        span.data = normalize(span.data, depth, maxBreadth);
      }
      return span;
    });
  }

  return normalized;
}


//# sourceMappingURL=prepareEvent.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/baseclient.js







const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */
   __init() {this._integrations = {};}

  /** Indicates whether this client's integrations have been set up. */
   __init2() {this._integrationsInitialized = false;}

  /** Number of calls being processed */
   __init3() {this._numProcessing = 0;}

  /** Holds flushable  */
   __init4() {this._outcomes = {};}

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {BaseClient.prototype.__init.call(this);BaseClient.prototype.__init2.call(this);BaseClient.prototype.__init3.call(this);BaseClient.prototype.__init4.call(this);
    this._options = options;
    if (options.dsn) {
      this._dsn = dsn_makeDsn(options.dsn);
      const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.warn('No DSN provided, client will not do anything.');
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if (misc_checkOrSetAlreadyCaught(exception)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    const promisedEvent = esm_is_isPrimitive(message)
      ? this.eventFromMessage(String(message), level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && misc_checkOrSetAlreadyCaught(hint.originalException)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this._captureEvent(event, hint, scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.warn('SDK not enabled, will not capture session.');
      return;
    }

    if (!(typeof session.release === 'string')) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      session_updateSession(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
   getSdkMetadata() {
    return this._options._metadata;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    const transport = this._transport;
    if (transport) {
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return esm_syncpromise_resolvedSyncPromise(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      return result;
    });
  }

  /**
   * Sets up the integrations
   */
   setupIntegrations() {
    if (this._isEnabled() && !this._integrationsInitialized) {
      this._integrations = setupIntegrations(this._options.integrations);
      this._integrationsInitialized = true;
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
   getIntegrationById(integrationId) {
    return this._integrations[integrationId];
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   addIntegration(integration) {
    setupIntegration(integration, this._integrations);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    if (this._dsn) {
      let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

      for (const attachment of hint.attachments || []) {
        env = addItemToEnvelope(
          env,
          createAttachmentEnvelopeItem(
            attachment,
            this._options.transportOptions && this._options.transportOptions.textEncoder,
          ),
        );
      }

      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    if (this._dsn) {
      const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category, _event) {
    // Note: we use `event` in replay, where we overwrite this hook.

    if (this._options.sendClientReports) {
      // We want to track each category (error, transaction, session, replay_event) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.log(`Adding outcome: "${key}"`);

      // The following works because undefined + 1 === NaN and NaN is falsy
      this._outcomes[key] = this._outcomes[key] + 1 || 1;
    }
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    const exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      session_updateSession(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise_SyncPromise(resolve => {
      let ticked = 0;
      const tick = 1;

      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a valid Dsn is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._dsn !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(event, hint, scope) {
    const options = this.getOptions();
    const integrations = Object.keys(this._integrations);
    if (!hint.integrations && integrations.length > 0) {
      hint.integrations = integrations;
    }
    return prepareEvent(options, event, hint, scope);
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          const sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            esm_logger_logger.log(sentryError.message);
          } else {
            esm_logger_logger.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const options = this.getOptions();
    const { sampleRate } = options;

    if (!this._isEnabled()) {
      return syncpromise_rejectedSyncPromise(new error_SentryError('SDK not enabled, will not capture event.', 'log'));
    }

    const isTransaction = isTransactionEvent(event);
    const isError = baseclient_isErrorEvent(event);
    const eventType = event.type || 'error';
    const beforeSendLabel = `before send for type \`${eventType}\``;

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error', event);
      return syncpromise_rejectedSyncPromise(
        new error_SentryError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;

    return this._prepareEvent(event, hint, scope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', dataCategory, event);
          throw new error_SentryError('An event processor returned `null`, will not send event.', 'log');
        }

        const isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException) {
          return prepared;
        }

        const result = processBeforeSend(options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', dataCategory, event);
          throw new error_SentryError(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
        }

        const session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        const transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          const source = 'custom';
          processedEvent.transaction_info = {
            ...transactionInfo,
            source,
          };
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof error_SentryError) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason ,
        });
        throw new error_SentryError(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing++;
    void promise.then(
      value => {
        this._numProcessing--;
        return value;
      },
      reason => {
        this._numProcessing--;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    if (this._transport && this._dsn) {
      this._transport.send(envelope).then(null, reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.error('Error while sending event:', reason);
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(
  beforeSendResult,
  beforeSendLabel,
) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if (is_isThenable(beforeSendResult)) {
    return beforeSendResult.then(
      event => {
        if (!is_isPlainObject(event) && event !== null) {
          throw new error_SentryError(invalidValueError);
        }
        return event;
      },
      e => {
        throw new error_SentryError(`${beforeSendLabel} rejected with ${e}`);
      },
    );
  } else if (!is_isPlainObject(beforeSendResult) && beforeSendResult !== null) {
    throw new error_SentryError(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(
  options,
  event,
  hint,
) {
  const { beforeSend, beforeSendTransaction } = options;

  if (baseclient_isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }

  if (isTransactionEvent(event) && beforeSendTransaction) {
    return beforeSendTransaction(event, hint);
  }

  return event;
}

function baseclient_isErrorEvent(event) {
  return event.type === undefined;
}

function isTransactionEvent(event) {
  return event.type === 'transaction';
}


//# sourceMappingURL=baseclient.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/env.js
var env = __webpack_require__(9127);
;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  const clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,esm_time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/eventbuilder.js



/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = parseStackFrames(stackParser, ex);

  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  const hub = esm_hub_getCurrentHub();
  const client = hub.getClient();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  const event = {
    exception: {
      values: [
        {
          type: esm_is_isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: `Non-Error ${
            isUnhandledRejection ? 'promise rejection' : 'exception'
          } captured with keys: ${object_extractExceptionKeysForMessage(exception)}`,
        },
      ],
    },
    extra: {
      __serialized__: normalizeToSize(exception, normalizeDepth),
    },
  };

  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';

  const popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  misc_addExceptionMechanism(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return esm_syncpromise_resolvedSyncPromise(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return esm_syncpromise_resolvedSyncPromise(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if (is_isErrorEvent(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if (is_isDOMError(exception ) || is_isDOMException(exception )) {
    const domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      const name = domException.name || (is_isDOMError(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      misc_addExceptionTypeValue(event, message);
    }
    if ('code' in domException) {
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if (esm_is_isError(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if (is_isPlainObject(exception) || esm_is_isEvent(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    misc_addExceptionMechanism(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  misc_addExceptionTypeValue(event, `${exception}`, undefined);
  misc_addExceptionMechanism(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  input,
  syntheticException,
  attachStacktrace,
) {
  const event = {
    message: input,
  };

  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }],
      };
    }
  }

  return event;
}


//# sourceMappingURL=eventbuilder.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/exports.js


// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
  return esm_hub_getCurrentHub().captureException(exception, { captureContext });
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(
  message,
  // eslint-disable-next-line deprecation/deprecation
  captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  return getCurrentHub().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event, hint) {
  return getCurrentHub().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
  esm_hub_getCurrentHub().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
  getCurrentHub().addBreadcrumb(breadcrumb);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
  getCurrentHub().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  getCurrentHub().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  getCurrentHub().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  getCurrentHub().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  getCurrentHub().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  getCurrentHub().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
  esm_hub_getCurrentHub().withScope(callback);
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(
  context,
  customSamplingContext,
) {
  return getCurrentHub().startTransaction({ ...context }, customSamplingContext);
}


//# sourceMappingURL=exports.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/helpers.js



const helpers_WINDOW = esm_worldwide/* GLOBAL_OBJ */.n2 ;

let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      return wrapper;
    }

    // We don't wanna wrap it twice
    if (object_getOriginalFunction(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  /* eslint-disable prefer-rest-params */
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function () {
    const args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      const wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      withScope((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            misc_addExceptionTypeValue(event, undefined, undefined);
            misc_addExceptionMechanism(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        captureException(ex);
      });

      throw ex;
    }
  };
  /* eslint-enable prefer-rest-params */

  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} // eslint-disable-line no-empty

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  object_markFunctionWrapped(sentryWrapped, fn);

  esm_object_addNonEnumerableProperty(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
    // eslint-disable-next-line no-empty
  } catch (_oO) {}

  return sentryWrapped;
}

/**
 * All properties the report dialog supports
 */


//# sourceMappingURL=helpers.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

const validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/url.js
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url)

 {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}


//# sourceMappingURL=url.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/integrations/breadcrumbs.js




/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** JSDoc */

/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */
const MAX_ALLOWED_STRING_LENGTH = 1024;

const BREADCRUMB_INTEGRATION_ID = 'Breadcrumbs';

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
class Breadcrumbs  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = BREADCRUMB_INTEGRATION_ID;}

  /**
   * @inheritDoc
   */
   __init() {this.name = Breadcrumbs.id;}

  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.

  /**
   * @inheritDoc
   */
   constructor(options) {Breadcrumbs.prototype.__init.call(this);
    this.options = {
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      ...options,
    };
  }

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
   setupOnce() {
    if (this.options.console) {
      addInstrumentationHandler('console', _consoleBreadcrumb);
    }
    if (this.options.dom) {
      addInstrumentationHandler('dom', _domBreadcrumb(this.options.dom));
    }
    if (this.options.xhr) {
      addInstrumentationHandler('xhr', _xhrBreadcrumb);
    }
    if (this.options.fetch) {
      addInstrumentationHandler('fetch', _fetchBreadcrumb);
    }
    if (this.options.history) {
      addInstrumentationHandler('history', _historyBreadcrumb);
    }
  }

  /**
   * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
   */
   addSentryBreadcrumb(event) {
    if (this.options.sentry) {
      esm_hub_getCurrentHub().addBreadcrumb(
        {
          category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
          event_id: event.event_id,
          level: event.level,
          message: misc_getEventDescription(event),
        },
        {
          event,
        },
      );
    }
  }
} Breadcrumbs.__initStatic();

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _domBreadcrumb(dom) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    let maxStringLength =
      typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger_logger.warn(
          `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`,
        );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      target = handlerData.event.target
        ? browser_htmlTreeAsString(handlerData.event.target , { keyAttrs, maxStringLength })
        : browser_htmlTreeAsString(handlerData.event , { keyAttrs, maxStringLength });
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    esm_hub_getCurrentHub().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target,
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global,
      },
    );
  }

  return _innerDomBreadcrumb;
}

/**
 * Creates breadcrumbs from console API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _consoleBreadcrumb(handlerData) {
  // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
  // console warnings. This happens when a Vue template is rendered with
  // an undeclared variable, which we try to stringify, ultimately causing
  // Vue to issue another warning which repeats indefinitely.
  // see: https://github.com/getsentry/sentry-javascript/pull/6010
  // see: https://github.com/getsentry/sentry-javascript/issues/5916
  for (let i = 0; i < handlerData.args.length; i++) {
    if (handlerData.args[i] === 'ref=Ref<') {
      handlerData.args[i + 1] = 'viewRef';
      break;
    }
  }
  const breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console',
    },
    level: severityLevelFromString(handlerData.level),
    message: safeJoin(handlerData.args, ' '),
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${safeJoin(handlerData.args.slice(1), ' ') || 'console.assert'}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  esm_hub_getCurrentHub().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level,
  });
}

/**
 * Creates breadcrumbs from XHR API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _xhrBreadcrumb(handlerData) {
  if (handlerData.endTimestamp) {
    // We only capture complete, non-sentry requests
    if (handlerData.xhr.__sentry_own_request__) {
      return;
    }

    const { method, url, status_code, body } = handlerData.xhr.__sentry_xhr__ || {};

    esm_hub_getCurrentHub().addBreadcrumb(
      {
        category: 'xhr',
        data: {
          method,
          url,
          status_code,
        },
        type: 'http',
      },
      {
        xhr: handlerData.xhr,
        input: body,
      },
    );

    return;
  }
}

/**
 * Creates breadcrumbs from fetch API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _fetchBreadcrumb(handlerData) {
  // We only capture complete fetch requests
  if (!handlerData.endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    esm_hub_getCurrentHub().addBreadcrumb(
      {
        category: 'fetch',
        data: handlerData.fetchData,
        level: 'error',
        type: 'http',
      },
      {
        data: handlerData.error,
        input: handlerData.args,
      },
    );
  } else {
    esm_hub_getCurrentHub().addBreadcrumb(
      {
        category: 'fetch',
        data: {
          ...handlerData.fetchData,
          status_code: handlerData.response.status,
        },
        type: 'http',
      },
      {
        input: handlerData.args,
        response: handlerData.response,
      },
    );
  }
}

/**
 * Creates breadcrumbs from history API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _historyBreadcrumb(handlerData) {
  let from = handlerData.from;
  let to = handlerData.to;
  const parsedLoc = parseUrl(helpers_WINDOW.location.href);
  let parsedFrom = parseUrl(from);
  const parsedTo = parseUrl(to);

  // Initial pushState doesn't provide `from` information
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }

  // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  esm_hub_getCurrentHub().addBreadcrumb({
    category: 'navigation',
    data: {
      from,
      to,
    },
  });
}


//# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/client.js






/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    const sdkSource = helpers_WINDOW.SENTRY_SDK_SOURCE || (0,env/* getSDKSource */.S)();

    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [
        {
          name: `${sdkSource}:@sentry/browser`,
          version: SDK_VERSION,
        },
      ],
      version: SDK_VERSION,
    };

    super(options);

    if (options.sendClientReports && helpers_WINDOW.document) {
      helpers_WINDOW.document.addEventListener('visibilitychange', () => {
        if (helpers_WINDOW.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level = 'info',
    hint,
  ) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint) {
    // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
    // activated its `sentry` option.
    // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
    // bundles, if it is not used by the SDK.
    // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
    // way for now.
    const breadcrumbIntegration = this.getIntegrationById(BREADCRUMB_INTEGRATION_ID) ;
    // We check for definedness of `addSentryBreadcrumb` in case users provided their own integration with id
    // "Breadcrumbs" that does not have this function.
    if (breadcrumbIntegration && breadcrumbIntegration.addSentryBreadcrumb) {
      breadcrumbIntegration.addSentryBreadcrumb(event);
    }

    super.sendEvent(event, hint);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    const outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.log('No outcomes to send');
      return;
    }

    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.log('No dsn provided, will not send outcomes');
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.log('Sending outcomes:', outcomes);

    const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, this._options);
    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsn_dsnToString(this._dsn));

    try {
      const isRealNavigator = Object.prototype.toString.call(helpers_WINDOW && helpers_WINDOW.navigator) === '[object Navigator]';
      const hasSendBeacon = isRealNavigator && typeof helpers_WINDOW.navigator.sendBeacon === 'function';
      // Make sure beacon is not used if user configures custom transport options
      if (hasSendBeacon && !this._options.transportOptions) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        const sendBeacon = helpers_WINDOW.navigator.sendBeacon.bind(helpers_WINDOW.navigator);
        sendBeacon(url, serializeEnvelope(envelope));
      } else {
        // If beacon is not supported or if they are using the tunnel option
        // use our regular transport to send client reports to Sentry.
        this._sendEnvelope(envelope);
      }
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.error(e);
    }
  }
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/integrations/globalhandlers.js





/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** Global handlers */
class GlobalHandlers  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GlobalHandlers';}

  /**
   * @inheritDoc
   */
   __init() {this.name = GlobalHandlers.id;}

  /** JSDoc */

  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
   __init2() {this._installFunc = {
    onerror: _installGlobalOnErrorHandler,
    onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
  };}

  /** JSDoc */
   constructor(options) {GlobalHandlers.prototype.__init.call(this);GlobalHandlers.prototype.__init2.call(this);
    this._options = {
      onerror: true,
      onunhandledrejection: true,
      ...options,
    };
  }
  /**
   * @inheritDoc
   */
   setupOnce() {
    Error.stackTraceLimit = 50;
    const options = this._options;

    // We can disable guard-for-in as we construct the options object above + do checks against
    // `this._installFunc` for the property.
    // eslint-disable-next-line guard-for-in
    for (const key in options) {
      const installFunc = this._installFunc[key ];
      if (installFunc && options[key ]) {
        globalHandlerLog(key);
        installFunc();
        this._installFunc[key ] = undefined;
      }
    }
  }
} GlobalHandlers.__initStatic();

/** JSDoc */
function _installGlobalOnErrorHandler() {
  addInstrumentationHandler(
    'error',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      const { msg, url, line, column, error } = data;
      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return;
      }

      const event =
        error === undefined && is_isString(msg)
          ? _eventFromIncompleteOnError(msg, url, line, column)
          : _enhanceEventWithInitialFrame(
              eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false),
              url,
              line,
              column,
            );

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onerror');
    },
  );
}

/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
  addInstrumentationHandler(
    'unhandledrejection',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      let error = e;

      // dig the object of the rejection out of known event types
      try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) {
          error = e.reason;
        }
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        else if ('detail' in e && 'reason' in e.detail) {
          error = e.detail.reason;
        }
      } catch (_oO) {
        // no-empty
      }

      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return true;
      }

      const event = esm_is_isPrimitive(error)
        ? _eventFromRejectionWithPrimitive(error)
        : eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
      return;
    },
  );
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
  const ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = is_isErrorEvent(msg) ? msg.message : msg;
  let name = 'Error';

  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  const event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = (event.exception = event.exception || {});
  // event.exception.values
  const ev = (e.values = e.values || []);
  // event.exception.values[0]
  const ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  const ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  const ev0sf = (ev0s.frames = ev0s.frames || []);

  const colno = isNaN(parseInt(column, 10)) ? undefined : column;
  const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  const filename = is_isString(url) && url.length > 0 ? url : getLocationHref();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.log(`Global Handler attached: ${type}`);
}

function addMechanismAndCapture(hub, error, event, type) {
  misc_addExceptionMechanism(event, {
    handled: false,
    type,
  });
  hub.captureEvent(event, {
    originalException: error,
  });
}

function getHubAndOptions() {
  const hub = esm_hub_getCurrentHub();
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return [hub, options.stackParser, options.attachStacktrace];
}


//# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/integrations/trycatch.js



const DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

/** Wrap timer functions and event targets to catch errors and provide better meta data */
class TryCatch  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'TryCatch';}

  /**
   * @inheritDoc
   */
   __init() {this.name = TryCatch.id;}

  /** JSDoc */

  /**
   * @inheritDoc
   */
   constructor(options) {TryCatch.prototype.__init.call(this);
    this._options = {
      XMLHttpRequest: true,
      eventTarget: true,
      requestAnimationFrame: true,
      setInterval: true,
      setTimeout: true,
      ...options,
    };
  }

  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
   setupOnce() {
    if (this._options.setTimeout) {
      object_fill(helpers_WINDOW, 'setTimeout', _wrapTimeFunction);
    }

    if (this._options.setInterval) {
      object_fill(helpers_WINDOW, 'setInterval', _wrapTimeFunction);
    }

    if (this._options.requestAnimationFrame) {
      object_fill(helpers_WINDOW, 'requestAnimationFrame', _wrapRAF);
    }

    if (this._options.XMLHttpRequest && "XMLHttpRequest" in helpers_WINDOW) {
      object_fill(XMLHttpRequest.prototype, 'send', _wrapXHR);
    }

    const eventTargetOption = this._options.eventTarget;
    if (eventTargetOption) {
      const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
      eventTarget.forEach(_wrapEventTarget);
    }
  }
} TryCatch.__initStatic();

/** JSDoc */
function _wrapTimeFunction(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    const originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        data: { function: getFunctionName(original) },
        handled: true,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( callback) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: getFunctionName(original),
          },
          handled: true,
          type: 'instrument',
        },
      }),
    ]);
  };
}

/** JSDoc */
function _wrapXHR(originalSend) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        object_fill(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: getFunctionName(original),
              },
              handled: true,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          const originalFunction = object_getOriginalFunction(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = getFunctionName(originalFunction);
          }

          // Otherwise wrap directly
          return wrap(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

/** JSDoc */
function _wrapEventTarget(target) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalObject = helpers_WINDOW ;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const proto = globalObject[target] && globalObject[target].prototype;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  object_fill(proto, 'addEventListener', function (original)

 {
    return function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: getFunctionName(fn),
                target,
              },
              handled: true,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        wrap(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: getFunctionName(fn),
              target,
            },
            handled: true,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  object_fill(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        const wrappedEventHandler = fn ;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/integrations/linkederrors.js




const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
class LinkedErrors  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'LinkedErrors';}

  /**
   * @inheritDoc
   */
    __init() {this.name = LinkedErrors.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {LinkedErrors.prototype.__init.call(this);
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    const client = esm_hub_getCurrentHub().getClient();
    if (!client) {
      return;
    }
    scope_addGlobalEventProcessor((event, hint) => {
      const self = esm_hub_getCurrentHub().getIntegration(LinkedErrors);
      return self ? _handler(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
    });
  }
} LinkedErrors.__initStatic();

/**
 * @inheritDoc
 */
function _handler(
  parser,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !esm_is_isInstanceOf(hint.originalException, Error)) {
    return event;
  }
  const linkedErrors = _walkErrorTree(parser, limit, hint.originalException , key);
  event.exception.values = [...linkedErrors, ...event.exception.values];
  return event;
}

/**
 * JSDOC
 */
function _walkErrorTree(
  parser,
  limit,
  error,
  key,
  stack = [],
) {
  if (!esm_is_isInstanceOf(error[key], Error) || stack.length + 1 >= limit) {
    return stack;
  }
  const exception = exceptionFromError(parser, error[key]);
  return _walkErrorTree(parser, limit, error[key], key, [exception, ...stack]);
}


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/integrations/httpcontext.js



/** HttpContext integration collects information about HTTP request headers */
class HttpContext  {constructor() { HttpContext.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'HttpContext';}

  /**
   * @inheritDoc
   */
   __init() {this.name = HttpContext.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    scope_addGlobalEventProcessor((event) => {
      if (esm_hub_getCurrentHub().getIntegration(HttpContext)) {
        // if none of the information we want exists, don't bother
        if (!helpers_WINDOW.navigator && !helpers_WINDOW.location && !helpers_WINDOW.document) {
          return event;
        }

        // grab as much info as exists and add it to the event
        const url = (event.request && event.request.url) || (helpers_WINDOW.location && helpers_WINDOW.location.href);
        const { referrer } = helpers_WINDOW.document || {};
        const { userAgent } = helpers_WINDOW.navigator || {};

        const headers = {
          ...(event.request && event.request.headers),
          ...(referrer && { Referer: referrer }),
          ...(userAgent && { 'User-Agent': userAgent }),
        };
        const request = { ...event.request, ...(url && { url }), headers };

        return { ...event, request };
      }
      return event;
    });
  }
} HttpContext.__initStatic();


//# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/integrations/dedupe.js


/** Deduplication filter */
class Dedupe  {constructor() { Dedupe.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Dedupe';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Dedupe.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcessor = currentEvent => {
      // We want to ignore any non-error type events, e.g. transactions or replays
      // These should never be deduped, and also not be compared against as _previousEvent.
      if (currentEvent.type) {
        return currentEvent;
      }

      const self = getCurrentHub().getIntegration(Dedupe);
      if (self) {
        // Juuust in case something goes wrong
        try {
          if (dedupe_shouldDropEvent(currentEvent, self._previousEvent)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.warn('Event dropped due to being a duplicate of previously captured event.');
            return null;
          }
        } catch (_oO) {
          return (self._previousEvent = currentEvent);
        }

        return (self._previousEvent = currentEvent);
      }
      return currentEvent;
    };

    eventProcessor.id = this.name;
    addGlobalEventProcessor(eventProcessor);
  }
} Dedupe.__initStatic();

/** JSDoc */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

/** JSDoc */
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

/** JSDoc */
function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-ignore Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/stack-parsers.js


// global reference to slice
const UNKNOWN_FUNCTION = '?';

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    abs_path: filename, // As opposed to filename, abs_path is immutable (I can't control your actions but don't touch it!)
    function: func,
    in_app: true, // All browser frames are considered in_app
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex =
  /^\s*at (?:(.*\).*?|.*?) ?\((?:address at )?)?(?:async )?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

const chrome = line => {
  const parts = chromeRegex.exec(line);

  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

const chromeStackLineParser = [CHROME_PRIORITY, chrome];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|safari-extension|safari-web-extension|capacitor)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

const gecko = line => {
  const parts = geckoREgex.exec(line);

  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

const geckoStackLineParser = [GECKO_PRIORITY, gecko];

const winjsRegex =
  /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

const winjs = line => {
  const parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

const winjsStackLineParser = [WINJS_PRIORITY, winjs];

const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

const opera10StackLineParser = [OPERA10_PRIORITY, opera10];

const opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

const opera11StackLineParser = [OPERA11_PRIORITY, opera11];

const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

const defaultStackParser = createStackParser(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return syncpromise_rejectedSyncPromise(new error_SentryError('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise_SyncPromise((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void esm_syncpromise_resolvedSyncPromise(item).then(() => {
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}

/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  const updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories] = limit.split(':', 2);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/transports/base.js


const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(
    options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE,
  ),
) {
  let rateLimits = {};

  const flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    forEachEnvelopeItem(envelope, (item, type) => {
      const envelopeItemDataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, envelopeItemDataCategory)) {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return esm_syncpromise_resolvedSyncPromise();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (item, type) => {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type), event);
      });
    };

    const requestTask = () =>
      makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = updateRateLimits(rateLimits, response);
          return response;
        },
        error => {
          recordEnvelopeLoss('network_error');
          throw error;
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof error_SentryError) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.error('Skipped sending event because buffer is full.');
          recordEnvelopeLoss('queue_overflow');
          return esm_syncpromise_resolvedSyncPromise();
        } else {
          throw error;
        }
      },
    );
  }

  return {
    send,
    flush,
  };
}

function getEventForEnvelopeItem(item, type) {
  if (type !== 'event' && type !== 'transaction') {
    return undefined;
  }

  return Array.isArray(item) ? (item )[1] : undefined;
}


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/transports/utils.js



let cachedFetchImpl = undefined;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  /* eslint-disable @typescript-eslint/unbound-method */

  // Fast path to avoid DOM I/O
  if (isNativeFetch(helpers_WINDOW.fetch)) {
    return (cachedFetchImpl = helpers_WINDOW.fetch.bind(helpers_WINDOW));
  }

  const document = helpers_WINDOW.document;
  let fetchImpl = helpers_WINDOW.fetch;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger_logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(helpers_WINDOW));
  /* eslint-enable @typescript-eslint/unbound-method */
}

/** Clears cached fetch impl */
function clearCachedFetchImplementation() {
  cachedFetchImpl = undefined;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  function makeRequest(request) {
    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch), a request with `keepalive: true`
      //   and a content length of > 64 kibibytes returns a network error. We will therefore only activate the flag when
      //   we're below that limit.
      keepalive: request.body.length <= 65536,
      ...options.fetchOptions,
    };

    try {
      return nativeFetch(options.url, requestOptions).then(response => ({
        statusCode: response.status,
        headers: {
          'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
          'retry-after': response.headers.get('Retry-After'),
        },
      }));
    } catch (e) {
      clearCachedFetchImplementation();
      return syncpromise_rejectedSyncPromise(e);
    }
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/transports/xhr.js



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
const XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new syncpromise_SyncPromise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (const header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/sdk.js














const defaultIntegrations = [
  new InboundFilters(),
  new FunctionToString(),
  new TryCatch(),
  new Breadcrumbs(),
  new GlobalHandlers(),
  new LinkedErrors(),
  new Dedupe(),
  new HttpContext(),
];

/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }
  if (options.release === undefined) {
    // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
    if (typeof __SENTRY_RELEASE__ === 'string') {
      options.release = __SENTRY_RELEASE__;
    }

    // This supports the variable that sentry-webpack-plugin injects
    if (helpers_WINDOW.SENTRY_RELEASE && helpers_WINDOW.SENTRY_RELEASE.id) {
      options.release = helpers_WINDOW.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  const clientOptions = {
    ...options,
    stackParser: stackParserFromStackParserOptions(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup(options),
    transport: options.transport || (supportsFetch() ? makeFetchTransport : makeXHRTransport),
  };

  initAndBind(BrowserClient, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}, hub = getCurrentHub()) {
  // doesn't work without a document (React Native)
  if (!WINDOW.document) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Global document not defined in showReportDialog call');
    return;
  }

  const { client, scope } = hub.getStackTop();
  const dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }

  const script = WINDOW.document.createElement('script');
  script.async = true;
  script.src = getReportDialogEndpoint(dsn, options);

  if (options.onLoad) {
    script.onload = options.onLoad;
  }

  const injectionPoint = WINDOW.document.head || WINDOW.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  return getCurrentHub().lastEventId();
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
  const client = esm_hub_getCurrentHub().getClient();
  if (client) {
    return client.flush(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger_logger.warn('Cannot flush events. No client defined.');
  return esm_syncpromise_resolvedSyncPromise(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.close(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
  return wrap$1(fn)();
}

function startSessionOnHub(hub) {
  hub.startSession({ ignoreDuration: true });
  hub.captureSession();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  if (typeof helpers_WINDOW.document === 'undefined') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger_logger.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  const hub = esm_hub_getCurrentHub();

  // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
  // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
  // pinned at the same version in package.json, but there are edge cases where it's possible. See
  // https://github.com/getsentry/sentry-javascript/issues/3207 and
  // https://github.com/getsentry/sentry-javascript/issues/3234 and
  // https://github.com/getsentry/sentry-javascript/issues/3278.
  if (!hub.captureSession) {
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  startSessionOnHub(hub);

  // We want to create a session for every navigation as well
  addInstrumentationHandler('history', ({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (!(from === undefined || from === to)) {
      startSessionOnHub(esm_hub_getCurrentHub());
    }
  });
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function sdk_init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: SDK_VERSION,
      },
    ],
    version: SDK_VERSION,
  };
  init(options);
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/core/esm/integrations/index.js


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/integrations/index.js






//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/node_modules/@sentry/browser/esm/index.js




















let windowIntegrations = {};

// This block is needed to add compatibility with the integrations packages when used with a CDN
if (helpers_WINDOW.Sentry && helpers_WINDOW.Sentry.Integrations) {
  windowIntegrations = helpers_WINDOW.Sentry.Integrations;
}

const INTEGRATIONS = {
  ...windowIntegrations,
  ...integrations_namespaceObject,
  ...esm_integrations_namespaceObject,
};
// __ROLLUP_EXCLUDE_OFFLINE_FROM_BUNDLES_END__


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/react/esm/index.js








//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/tracing/esm/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(94681);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(75394);
;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/tracing.js
const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  const matches = traceparent.match(TRACEPARENT_REGEXP);

  if (!traceparent || !matches) {
    // empty string or no matches is invalid traceparent data
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}


//# sourceMappingURL=tracing.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(29856);
;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/baggage.js



const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!(0,is/* isString */.HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      return {
        ...acc,
        ...currBaggageObject,
      };
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/worldwide.js
var utils_esm_worldwide = __webpack_require__(68356);
;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/browser.js



// eslint-disable-next-line deprecation/deprecation
const esm_browser_WINDOW = (0,utils_esm_worldwide/* getGlobalObject */.Rf)();

const browser_DEFAULT_MAX_STRING_LENGTH = 80;

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function esm_browser_htmlTreeAsString(
  elem,
  options = {},
) {

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = (!Array.isArray(options) && options.maxStringLength) || browser_DEFAULT_MAX_STRING_LENGTH;

    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = browser_htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds maxStringLength
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function browser_htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0,is/* isString */.HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['aria-label', 'type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function browser_getLocationHref() {
  try {
    return esm_browser_WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function browser_getDomElement(selector) {
  if (esm_browser_WINDOW.document && esm_browser_WINDOW.document.querySelector) {
    return esm_browser_WINDOW.document.querySelector(selector) ;
  }
  return null;
}


//# sourceMappingURL=browser.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(94061);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(65498);
;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/types.js


const types_WINDOW = utils_esm_worldwide/* GLOBAL_OBJ */.n2 ;


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/backgroundtab.js




/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (types_WINDOW && types_WINDOW.document) {
    types_WINDOW.document.addEventListener('visibilitychange', () => {
      const activeTransaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (types_WINDOW.document.hidden && activeTransaction) {
        const statusType = 'cancelled';

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          esm_logger/* logger.log */.kg.log(
            `[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`,
          );
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!activeTransaction.status) {
          activeTransaction.setStatus(statusType);
        }
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.finish();
      }
    });
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/time.js
var utils_esm_time = __webpack_require__(28965);
;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/bindReporter.js
const bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getNavigationEntryFromPerformanceTiming = () => {
  // eslint-disable-next-line deprecation/deprecation
  const timing = types_WINDOW.performance.timing;
  // eslint-disable-next-line deprecation/deprecation
  const type = types_WINDOW.performance.navigation.type;

  const navigationEntry = {
    entryType: 'navigation',
    startTime: 0,
    type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
  };

  for (const key in timing) {
    if (key !== 'navigationStart' && key !== 'toJSON') {
      navigationEntry[key] = Math.max((timing[key ] ) - timing.navigationStart, 0);
    }
  }
  return navigationEntry ;
};

const getNavigationEntry = () => {
  if (types_WINDOW.__WEB_VITALS_POLYFILL__) {
    return (
      types_WINDOW.performance &&
      ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) ||
        getNavigationEntryFromPerformanceTiming())
    );
  } else {
    return types_WINDOW.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  }
};


//# sourceMappingURL=getNavigationEntry.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = getNavigationEntry();
  return (navEntry && navEntry.activationStart) || 0;
};


//# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = getNavigationEntry();
  let navigationType = 'navigate';

  if (navEntry) {
    if (types_WINDOW.document.prerendering || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-') ;
    }
  }

  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good', // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: generateUniqueID(),
    navigationType,
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (
  type,
  callback,
  opts,
) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        callback(list.getEntries() );
      });
      po.observe(
        Object.assign(
          {
            type,
            buffered: true,
          },
          opts || {},
        ) ,
      );
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const onHidden = (cb, once) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || types_WINDOW.document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };
  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  // Some browsers have buggy implementations of visibilitychange,
  // so we use pagehide in addition, just to be safe.
  addEventListener('pagehide', onHiddenOrPageHide, true);
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (onReport) => {
  const metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  // const handleEntries = (entries: Metric['entries']) => {
  const handleEntries = (entries) => {
    entries.forEach(entry => {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        const firstSessionEntry = sessionEntries[0];
        const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

        // If the entry occurred less than 1 second after the previous entry and
        // less than 5 seconds after the first entry in the session, include the
        // entry in the current session. Otherwise, start a new session.
        if (
          sessionValue &&
          sessionEntries.length !== 0 &&
          entry.startTime - lastSessionEntry.startTime < 1000 &&
          entry.startTime - firstSessionEntry.startTime < 5000
        ) {
          sessionValue += entry.value;
          sessionEntries.push(entry);
        } else {
          sessionValue = entry.value;
          sessionEntries = [entry];
        }

        // If the current session value is larger than the current CLS value,
        // update CLS and the entries contributing to it.
        if (sessionValue > metric.value) {
          metric.value = sessionValue;
          metric.entries = sessionEntries;
          if (report) {
            report();
          }
        }
      }
    });
  };

  const po = observe('layout-shift', handleEntries);
  if (po) {
    report = bindReporter(onReport, metric);

    onHidden(() => {
      handleEntries(po.takeRecords() );
      report(true);
    });
  }
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

const initHiddenTime = () => {
  // If the document is hidden and not prerendering, assume it was always
  // hidden and the page was loaded in the background.
  return types_WINDOW.document.visibilityState === 'hidden' && !types_WINDOW.document.prerendering ? 0 : Infinity;
};

const trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

const getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('FID');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntry = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  const handleEntries = (entries) => {
    (entries ).forEach(handleEntry);
  };

  const po = observe('first-input', handleEntries);
  report = bindReporter(onReport, metric);

  if (po) {
    onHidden(() => {
      handleEntries(po.takeRecords() );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/web-vitals/getLCP.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */
const onLCP = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('LCP');
  let report;

  const handleEntries = (entries) => {
    const lastEntry = entries[entries.length - 1] ;
    if (lastEntry) {
      // The startTime attribute returns the value of the renderTime if it is
      // not 0, and the value of the loadTime otherwise. The activationStart
      // reference is used because LCP should be relative to page activation
      // rather than navigation start if the page was prerendered.
      const value = Math.max(lastEntry.startTime - getActivationStart(), 0);

      // Only report if the page wasn't hidden prior to LCP.
      if (value < visibilityWatcher.firstHiddenTime) {
        metric.value = value;
        metric.entries = [lastEntry];
        report();
      }
    }
  };

  const po = observe('largest-contentful-paint', handleEntries);

  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        handleEntries(po.takeRecords() );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      addEventListener(type, stopListening, { once: true, capture: true });
    });

    onHidden(stopListening, true);
  }
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    transaction.startTimestamp = startTimestamp;
  }

  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/metrics/index.js










function getBrowserPerformanceAPI() {
  return types_WINDOW && types_WINDOW.addEventListener && types_WINDOW.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals
 */
function startTrackingWebVitals() {
  const performance = getBrowserPerformanceAPI();
  if (performance && utils_esm_time/* browserPerformanceTimeOrigin */.Z1) {
    if (performance.mark) {
      types_WINDOW.performance.mark('sentry-tracing-init');
    }
    _trackCLS();
    _trackLCP();
    _trackFID();
  }
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  const entryHandler = (entries) => {
    for (const entry of entries) {
      const transaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (!transaction) {
        return;
      }
      const startTime = (0,utils/* msToSec */.XL)((utils_esm_time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
      const duration = (0,utils/* msToSec */.XL)(entry.duration);

      transaction.startChild({
        description: 'Main UI thread blocked',
        op: 'ui.long-task',
        startTimestamp: startTime,
        endTimestamp: startTime + duration,
      });
    }
  };

  observe('longtask', entryHandler);
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  // See:
  // https://web.dev/evolving-cls/
  // https://web.dev/cls-web-tooling/
  onCLS(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  });
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP() {
  onLCP(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _lcpEntry = entry ;
  });
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  onFID(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    const timeOrigin = (0,utils/* msToSec */.XL)(utils_esm_time/* browserPerformanceTimeOrigin */.Z1 );
    const startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !types_WINDOW.performance.getEntries || !utils_esm_time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  const timeOrigin = (0,utils/* msToSec */.XL)(utils_esm_time/* browserPerformanceTimeOrigin */.Z1);

  const performanceEntries = performance.getEntries();

  let responseStartTimestamp;
  let requestStartTimestamp;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    const duration = (0,utils/* msToSec */.XL)(entry.duration);

    if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        responseStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart);
        requestStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        const firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        break;
      }
      case 'resource': {
        const resourceName = (entry.name ).replace(types_WINDOW.location.origin, '');
        _addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
        break;
      }
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (transaction.op === 'pageload') {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === 'number') {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
      _measurements['ttfb'] = {
        value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
        unit: 'millisecond',
      };

      if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
        // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements['ttfb.requestTime'] = {
          value: (responseStartTimestamp - requestStartTimestamp) * 1000,
          unit: 'millisecond',
        };
      }
    }

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || timeOrigin >= transaction.startTimestamp) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      const oldValue = _measurements[name].value;
      const measurementTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(oldValue);

      // normalizedValue should be in milliseconds
      const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
      const delta = normalizedValue - oldValue;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: fidMark.value + (0,utils/* msToSec */.XL)(_measurements['fid'].value),
        op: 'ui.action',
        startTimestamp: fidMark.value,
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      transaction.setMeasurement(
        measurementName,
        _measurements[measurementName].value,
        _measurements[measurementName].unit,
      );
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  startTime,
  duration,
  timeOrigin,
) {
  const measureStartTimestamp = timeOrigin + startTime;
  const measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  const end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  const start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    description: description || event,
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(start),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(end),
  });
}

/** Create request and response related spans */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
  _startChild(transaction, {
    op: 'browser',
    description: 'request',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });

  _startChild(transaction, {
    op: 'browser',
    description: 'response',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceName,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = {};
  if ('transferSize' in entry) {
    data['Transfer Size'] = entry.transferSize;
  }
  if ('encodedBodySize' in entry) {
    data['Encoded Body Size'] = entry.encodedBodySize;
  }
  if ('decodedBodySize' in entry) {
    data['Decoded Body Size'] = entry.decodedBodySize;
  }
  if ('renderBlockingStatus' in entry) {
    data['resource.render_blocking_status'] = entry.renderBlockingStatus;
  }

  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceName,
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  const navigator = types_WINDOW.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      transaction.setTag('lcp.element', esm_browser_htmlTreeAsString(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      transaction.setTag(`cls.source.${index + 1}`, esm_browser_htmlTreeAsString(source.node)),
    );
  }
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/core/esm/utils/hasTracingEnabled.js
var utils_hasTracingEnabled = __webpack_require__(55006);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/core/esm/hub.js + 3 modules
var hub = __webpack_require__(45532);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/instrument.js + 2 modules
var esm_instrument = __webpack_require__(44624);
;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/string.js


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function esm_string_truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function esm_string_snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function string_safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      output.push(String(value));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function string_isMatchingPattern(
  value,
  pattern,
  requireExactStringMatch = false,
) {
  if (!(0,is/* isString */.HD)(value)) {
    return false;
  }

  if ((0,is/* isRegExp */.Kj)(pattern)) {
    return pattern.test(value);
  }
  if ((0,is/* isString */.HD)(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }

  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function string_stringMatchesSomePattern(
  testString,
  patterns = [],
  requireExactStringMatch = false,
) {
  return patterns.some(pattern => string_isMatchingPattern(testString, pattern, requireExactStringMatch));
}

/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function string_escapeStringForRegex(regexString) {
  // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
  // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
  return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}


//# sourceMappingURL=string.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/request.js



/* eslint-disable max-lines */

const DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\//];

/** Options for Request Instrumentation */

const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  // TODO (v8): Remove this property
  tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
  // eslint-disable-next-line deprecation/deprecation
  const { traceFetch, traceXHR, tracePropagationTargets, tracingOrigins, shouldCreateSpanForRequest } = {
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR,
    ..._options,
  };

  const shouldCreateSpan =
    typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_) => true;

  // TODO(v8) Remove tracingOrigins here
  // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
  // and we don't want to break the API. We can remove it in v8.
  const shouldAttachHeadersWithTargets = (url) =>
    shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);

  const spans = {};

  if (traceFetch) {
    (0,esm_instrument/* addInstrumentationHandler */.o)('fetch', (handlerData) => {
      fetchCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
  }

  if (traceXHR) {
    (0,esm_instrument/* addInstrumentationHandler */.o)('xhr', (handlerData) => {
      xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
  }
}

/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */
function shouldAttachHeaders(url, tracePropagationTargets) {
  return string_stringMatchesSomePattern(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}

/**
 * Create and track fetch request spans
 */
function fetchCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (!(0,utils_hasTracingEnabled/* hasTracingEnabled */.z)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
    return;
  }

  if (handlerData.endTimestamp) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        span.setHttpStatus(handlerData.response.status);
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  const currentScope = (0,hub/* getCurrentHub */.Gd)().getScope();
  const currentSpan = currentScope && currentScope.getSpan();
  const activeTransaction = currentSpan && currentSpan.transaction;

  if (currentSpan && activeTransaction) {
    const span = currentSpan.startChild({
      data: {
        ...handlerData.fetchData,
        type: 'fetch',
      },
      description: `${handlerData.fetchData.method} ${handlerData.fetchData.url}`,
      op: 'http.client',
    });

    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;

    const request = handlerData.args[0];

    // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
    handlerData.args[1] = handlerData.args[1] || {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = handlerData.args[1];

    if (shouldAttachHeaders(handlerData.fetchData.url)) {
      options.headers = addTracingHeadersToFetchRequest(
        request,
        activeTransaction.getDynamicSamplingContext(),
        span,
        options,
      );
    }
  }
}

function addTracingHeadersToFetchRequest(
  request,
  dynamicSamplingContext,
  span,
  options

,
) {
  const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);
  const sentryTraceHeader = span.toTraceparent();

  const headers =
    typeof Request !== 'undefined' && (0,is/* isInstanceOf */.V9)(request, Request) ? (request ).headers : options.headers;

  if (!headers) {
    return { 'sentry-trace': sentryTraceHeader, baggage: sentryBaggageHeader };
  } else if (typeof Headers !== 'undefined' && (0,is/* isInstanceOf */.V9)(headers, Headers)) {
    const newHeaders = new Headers(headers );

    newHeaders.append('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // If the same header is appended miultiple times the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.append(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
    }

    return newHeaders ;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers, ['sentry-trace', sentryTraceHeader]];

    if (sentryBaggageHeader) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push([BAGGAGE_HEADER_NAME, sentryBaggageHeader]);
    }

    return newHeaders;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    const newBaggageHeaders = [];

    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders.push(...existingBaggageHeader);
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(existingBaggageHeader);
    }

    if (sentryBaggageHeader) {
      newBaggageHeaders.push(sentryBaggageHeader);
    }

    return {
      ...(headers ),
      'sentry-trace': sentryTraceHeader,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined,
    };
  }
}

/**
 * Create and track xhr request spans
 */
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (
    !(0,utils_hasTracingEnabled/* hasTracingEnabled */.z)() ||
    (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
    !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))
  ) {
    return;
  }

  const xhr = handlerData.xhr.__sentry_xhr__;

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp) {
    const spanId = handlerData.xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      span.setHttpStatus(xhr.status_code);
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  const currentScope = (0,hub/* getCurrentHub */.Gd)().getScope();
  const currentSpan = currentScope && currentScope.getSpan();
  const activeTransaction = currentSpan && currentSpan.transaction;

  if (currentSpan && activeTransaction) {
    const span = currentSpan.startChild({
      data: {
        ...xhr.data,
        type: 'xhr',
        method: xhr.method,
        url: xhr.url,
      },
      description: `${xhr.method} ${xhr.url}`,
      op: 'http.client',
    });

    handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[handlerData.xhr.__sentry_xhr_span_id__] = span;

    if (handlerData.xhr.setRequestHeader && shouldAttachHeaders(handlerData.xhr.__sentry_xhr__.url)) {
      try {
        handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());

        const dynamicSamplingContext = activeTransaction.getDynamicSamplingContext();
        const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);

        if (sentryBaggageHeader) {
          // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
          // We can therefore simply set a baggage header without checking what was there before
          // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
          handlerData.xhr.setRequestHeader(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
        }
      } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
      }
    }
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/router.js



/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!types_WINDOW || !types_WINDOW.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = types_WINDOW.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: types_WINDOW.location.pathname,
      op: 'pageload',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    (0,esm_instrument/* addInstrumentationHandler */.o)('history', ({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.finish();
        }
        activeTransaction = customStartTransaction({
          name: types_WINDOW.location.pathname,
          op: 'navigation',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/browser/browsertracing.js










const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  idleTimeout: idletransaction/* DEFAULT_IDLE_TIMEOUT */.nT,
  finalTimeout: idletransaction/* DEFAULT_FINAL_TIMEOUT */.mg,
  heartbeatInterval: idletransaction/* DEFAULT_HEARTBEAT_INTERVAL */.hd,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  enableLongTask: true,
  _experiments: {},
  ...defaultRequestInstrumentationOptions,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */
   __init() {this.name = BROWSER_TRACING_INTEGRATION_ID;}

   constructor(_options) {BrowserTracing.prototype.__init.call(this);
    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
    };

    // Special case: enableLongTask can be set in _experiments
    // TODO (v8): Remove this in v8
    if (this.options._experiments.enableLongTask !== undefined) {
      this.options.enableLongTask = this.options._experiments.enableLongTask;
    }

    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
      // eslint-disable-next-line deprecation/deprecation
      this.options.tracePropagationTargets = _options.tracingOrigins;
    }

    startTrackingWebVitals();
    if (this.options.enableLongTask) {
      startTrackingLongTasks();
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;

    const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
      _experiments,
    } = this.options;

    instrumentRouting(
      (context) => this._createRouteTransaction(context),
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    if (_experiments.enableInteractions) {
      this._registerInteractionListener();
    }

    instrumentOutgoingRequests({
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
    });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

    const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;

    const isPageloadTransaction = context.op === 'pageload';

    const sentryTraceMetaTagValue = isPageloadTransaction ? getMetaContent('sentry-trace') : null;
    const baggageMetaTagValue = isPageloadTransaction ? getMetaContent('baggage') : null;

    const traceParentData = sentryTraceMetaTagValue ? extractTraceparentData(sentryTraceMetaTagValue) : undefined;
    const dynamicSamplingContext = baggageMetaTagValue
      ? baggageHeaderToDynamicSamplingContext(baggageMetaTagValue)
      : undefined;

    const expandedContext = {
      ...context,
      ...traceParentData,
      metadata: {
        ...context.metadata,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
      trimEnd: true,
    };

    const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    const finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? { ...finalContext.metadata, source: 'custom' }
        : finalContext.metadata;

    this._latestRouteName = finalContext.name;
    this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;

    if (finalContext.sampled === false) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const hub = this._getCurrentHub();
    const { location } = types_WINDOW;

    const idleTransaction = (0,hubextensions/* startIdleTransaction */.lb)(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
    );
    idleTransaction.registerBeforeFinishCallback(transaction => {
      addPerformanceEntries(transaction);
    });

    return idleTransaction ;
  }

  /** Start listener for interaction transactions */
   _registerInteractionListener() {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = () => {
      const { idleTimeout, finalTimeout, heartbeatInterval } = this.options;

      const op = 'ui.action.click';
      if (inflightInteractionTransaction) {
        inflightInteractionTransaction.finish();
        inflightInteractionTransaction = undefined;
      }

      if (!this._getCurrentHub) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
        return undefined;
      }

      if (!this._latestRouteName) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
        return undefined;
      }

      const hub = this._getCurrentHub();
      const { location } = types_WINDOW;

      const context = {
        name: this._latestRouteName,
        op,
        trimEnd: true,
        metadata: {
          source: this._latestRouteSource || 'url',
        },
      };

      inflightInteractionTransaction = (0,hubextensions/* startIdleTransaction */.lb)(
        hub,
        context,
        idleTimeout,
        finalTimeout,
        true,
        { location }, // for use in the tracesSampler
        heartbeatInterval,
      );
    };

    ['click'].forEach(type => {
      addEventListener(type, registerInteractionTransaction, { once: false, capture: true });
    });
  }
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = browser_getDomElement(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : null;
}


//# sourceMappingURL=browsertracing.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/index.js













// Treeshakable guard to remove all code related to tracing

// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
  // We are patching the global object with our hub extension methods
  (0,hubextensions/* addExtensionMethods */.ro)();
}
//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/common/getVercelEnv.js
/* provided dependency */ var process = __webpack_require__(27061);
/**
 * Returns an environment setting value determined by Vercel's `VERCEL_ENV` environment variable.
 *
 * @param isClient Flag to indicate whether to use the `NEXT_PUBLIC_` prefixed version of the environment variable.
 */
function getVercelEnv(isClient) {
  const vercelEnvVar = isClient ? process.env.NEXT_PUBLIC_VERCEL_ENV : process.env.VERCEL_ENV;
  return vercelEnvVar ? `vercel-${vercelEnvVar}` : undefined;
}


//# sourceMappingURL=getVercelEnv.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/core/esm/version.js
const version_SDK_VERSION = '7.40.0';


//# sourceMappingURL=version.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/common/metadata.js


const PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: version_SDK_VERSION,
      })),
      version: version_SDK_VERSION,
    } );
}


//# sourceMappingURL=metadata.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/common/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  const match = keyPath.match(/([a-z_]+)\.(.*)/i);
  // The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
  if (match === null) {
    obj[keyPath] = value;
  } else {
    // `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
    const innerObj = obj[match[1]];
    setNestedKey(innerObj, match[2], value);
  }
}

/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 */
function addOrUpdateIntegration(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions = {},
) {
  return (
    Array.isArray(userIntegrations)
      ? addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions)
      : addOrUpdateIntegrationInFunction(
          defaultIntegrationInstance,
          // Somehow TS can't figure out that not being an array makes this necessarily a function
          userIntegrations ,
          forcedOptions,
        )
  ) ;
}

function addOrUpdateIntegrationInArray(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions,
) {
  const userInstance = userIntegrations.find(integration => integration.name === defaultIntegrationInstance.name);

  if (userInstance) {
    for (const [keyPath, value] of Object.entries(forcedOptions)) {
      setNestedKey(userInstance, keyPath, value);
    }

    return userIntegrations;
  }

  return [...userIntegrations, defaultIntegrationInstance];
}

function addOrUpdateIntegrationInFunction(
  defaultIntegrationInstance,
  userIntegrationsFunc,
  forcedOptions,
) {
  const wrapper = defaultIntegrations => {
    const userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);

    // There are instances where we want the user to be able to prevent an integration from appearing at all, which they
    // would do by providing a function which filters out the integration in question. If that's happened in one of
    // those cases, don't add our default back in.
    if (defaultIntegrationInstance.allowExclusionByUser) {
      const userFinalInstance = userFinalIntegrations.find(
        integration => integration.name === defaultIntegrationInstance.name,
      );
      if (!userFinalInstance) {
        return userFinalIntegrations;
      }
    }

    return addOrUpdateIntegrationInArray(defaultIntegrationInstance, userFinalIntegrations, forcedOptions);
  };

  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/tracing.js
const tracing_TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function tracing_extractTraceparentData(traceparent) {
  const matches = traceparent.match(tracing_TRACEPARENT_REGEXP);

  if (!traceparent || !matches) {
    // empty string or no matches is invalid traceparent data
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}


//# sourceMappingURL=tracing.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/baggage.js



const baggage_BAGGAGE_HEADER_NAME = 'baggage';

const baggage_SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const baggage_SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const baggage_MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggage_baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!isString(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggage_baggageHeaderToObject(curr);
      return {
        ...acc,
        ...currBaggageObject,
      };
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggage_baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(baggage_SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(baggage_SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function baggage_dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${baggage_SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return baggage_objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggage_baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function baggage_objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > baggage_MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/url.js
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function url_parseUrl(url)

 {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function url_stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function url_getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}


//# sourceMappingURL=url.js.map

// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(86677);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/client/performance.js





const globalObject = helpers_WINDOW

;

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  const nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props && props.pageProps) {
    if (props.pageProps._sentryBaggage) {
      nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
    }

    if (props.pageProps._sentryTraceData) {
      nextDataTagInfo.traceParentData = tracing_extractTraceparentData(props.pageProps._sentryTraceData);
    }
  }

  return nextDataTagInfo;
}

const DEFAULT_TAGS = {
  'routing.instrumentation': 'next-router',
} ;

// We keep track of the active transaction so we can finish it when we start a navigation transaction.
let activeTransaction = undefined;

// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
let prevLocationName = undefined;

const client = hub_getCurrentHub().getClient();

/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  const { route, traceParentData, baggage, params } = extractNextDataTagInformation();
  prevLocationName = route || globalObject.location.pathname;

  if (startTransactionOnPageLoad) {
    const source = route ? 'route' : 'url';
    const dynamicSamplingContext = baggage_baggageHeaderToDynamicSamplingContext(baggage);

    activeTransaction = startTransactionCb({
      name: prevLocationName,
      op: 'pageload',
      tags: DEFAULT_TAGS,
      ...(params && client && client.getOptions().sendDefaultPii && { data: params }),
      ...traceParentData,
      metadata: {
        source,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
    });
  }

  if (startTransactionOnLocationChange) {
    router_default().events.on('routeChangeStart', (navigationTarget) => {
      const matchedRoute = getNextRouteFromPathname(url_stripUrlQueryAndFragment(navigationTarget));

      let transactionName;
      let transactionSource;

      if (matchedRoute) {
        transactionName = matchedRoute;
        transactionSource = 'route';
      } else {
        transactionName = navigationTarget;
        transactionSource = 'url';
      }

      const tags = {
        ...DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.finish();
      }

      const navigationTransaction = startTransactionCb({
        name: transactionName,
        op: 'navigation',
        tags,
        metadata: { source: transactionSource },
      });

      if (navigationTransaction) {
        // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
        // and `routeChangeComplete` events.
        // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
        // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
        // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
        const nextRouteChangeSpan = navigationTransaction.startChild({
          op: 'ui.nextjs.route-change',
          description: 'Next.js Route Change',
        });

        const finishRouteChangeSpan = () => {
          nextRouteChangeSpan.finish();
          router_default().events.off('routeChangeComplete', finishRouteChangeSpan);
        };

        router_default().events.on('routeChangeComplete', finishRouteChangeSpan);
      }
    });
  }
}

function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }

  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');

  let optionalCatchallWildcardRegex = '';
  if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }

  const rejoinedRouteParts = routeParts
    .map(
      routePart =>
        routePart
          .replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
          .replace(/^\[.*\]$/, '([^/]+?)'), // Replace route wildcards with lazy regex wildcards
    )
    .join('/');

  return new RegExp(
    `^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`, // optional slash at the end
  );
}


//# sourceMappingURL=performance.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class esm_error_SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;
    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/dsn.js


/** Regular expression used to parse a Dsn. */
const dsn_DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function dsn_isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function esm_dsn_dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents
 */
function dsn_dsnFromString(str) {
  const match = dsn_DSN_REGEX.exec(str);

  if (!match) {
    throw new esm_error_SentryError(`Invalid Sentry Dsn: ${str}`);
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsn_dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsn_dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function dsn_validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  requiredComponents.forEach(component => {
    if (!dsn[component]) {
      throw new SentryError(`Invalid Sentry Dsn: ${component} missing`);
    }
  });

  if (!projectId.match(/^\d+$/)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
  }

  if (!dsn_isValidProtocol(protocol)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
  }

  if (port && isNaN(parseInt(port, 10))) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid port ${port}`);
  }

  return true;
}

/** The Sentry Dsn, identifying a Sentry instance and project. */
function esm_dsn_makeDsn(from) {
  const components = typeof from === 'string' ? dsn_dsnFromString(from) : dsn_dsnFromComponents(from);
  dsn_validateDsn(components);
  return components;
}


//# sourceMappingURL=dsn.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/client/tunnelRoute.js


const globalWithInjectedValues = __webpack_require__.g

;

/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */
function applyTunnelRouteOption(options) {
  const tunnelRouteOption = globalWithInjectedValues.__sentryRewritesTunnelPath__;
  if (tunnelRouteOption && options.dsn) {
    const dsnComponents = dsn_dsnFromString(options.dsn);
    const sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest\.sentry\.io$/);
    if (sentrySaasDsnMatch) {
      const orgId = sentrySaasDsnMatch[1];
      const tunnelPath = `${tunnelRouteOption}?o=${orgId}&p=${dsnComponents.projectId}`;
      options.tunnel = tunnelPath;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.info(`Tunneling events to "${tunnelPath}"`);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger_logger.warn('Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.');
    }
  }
}


//# sourceMappingURL=tunnelRoute.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/client/index.js























// Treeshakable guard to remove all code related to tracing

const client_globalWithInjectedValues = __webpack_require__.g

;

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function client_init(options) {
  applyTunnelRouteOption(options);
  buildMetadata(options, ['nextjs', 'react']);

  options.environment = options.environment || getVercelEnv(true) || "production";

  addClientIntegrations(options);

  sdk_init(options);

  configureScope(scope => {
    scope.setTag('runtime', 'browser');
    const filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);

    if (false) {}
  });
}

function addClientIntegrations(options) {
  let integrations = options.integrations || [];

  // This value is injected at build time, based on the output directory specified in the build config. Though a default
  // is set there, we set it here as well, just in case something has gone wrong with the injection.
  const assetPrefixPath = client_globalWithInjectedValues.__rewriteFramesAssetPrefixPath__ || '';

  const defaultRewriteFramesIntegration = new RewriteFrames({
    // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
    iteratee: frame => {
      try {
        const { origin } = new URL(frame.filename );
        frame.filename = _optionalChain([frame, 'access', _ => _.filename, 'optionalAccess', _2 => _2.replace, 'call', _3 => _3(origin, 'app://'), 'access', _4 => _4.replace, 'call', _5 => _5(assetPrefixPath, '')]);
      } catch (err) {
        // Filename wasn't a properly formed URL, so there's nothing we can do
      }

      if (frame.filename && frame.filename.startsWith('app:///_next')) {
        // We need to URI-decode the filename because Next.js has wildcard routes like "/users/[id].js" which show up as "/users/%5id%5.js" in Error stacktraces.
        // The corresponding sources that Next.js generates have proper brackets so we also need proper brackets in the frame so that source map resolving works.
        frame.filename = decodeURI(frame.filename);
      }

      if (
        frame.filename &&
        frame.filename.match(
          /^app:\/\/\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/,
        )
      ) {
        // We don't care about these frames. It's Next.js internal code.
        frame.in_app = false;
      }

      return frame;
    },
  });
  integrations = addOrUpdateIntegration(defaultRewriteFramesIntegration, integrations);

  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false", in which case everything inside
  // will get treeshaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    if (hasTracingEnabled(options)) {
      const defaultBrowserTracingIntegration = new BrowserTracing({
        // eslint-disable-next-line deprecation/deprecation
        tracingOrigins: [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
        routingInstrumentation: nextRouterInstrumentation,
      });

      integrations = addOrUpdateIntegration(defaultBrowserTracingIntegration, integrations, {
        'options.routingInstrumentation': nextRouterInstrumentation,
      });
    }
  }

  options.integrations = integrations;
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/esm/index.client.js


/***/ }),

/***/ 16230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; }
});

// UNUSED EXPORTS: loadModule

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * Get source of SDK.
 */
function getSDKSource() {
  // @ts-ignore "npm" is injected by rollup during build process
  return "npm";
}


//# sourceMappingURL=env.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(27061);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !isBrowserBundle() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 37712:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, browserPerformanceTimeOrigin, timestampWithMs, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16230);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81272);
/* module decorator */ module = __webpack_require__.hmd(module);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

// Re-exported with an old name for backwards-compatibility.
const timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
const usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 81272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 9127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getSDKSource; },
/* harmony export */   "n": function() { return /* binding */ isBrowserBundle; }
/* harmony export */ });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * Get source of SDK.
 */
function getSDKSource() {
  // @ts-ignore "npm" is injected by rollup during build process
  return "npm";
}


//# sourceMappingURL=env.js.map


/***/ }),

/***/ 94440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ isNodeEnv; },
/* harmony export */   "l$": function() { return /* binding */ dynamicRequire; }
/* harmony export */ });
/* unused harmony export loadModule */
/* harmony import */ var _env_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9127);
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(27061);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !(0,_env_js__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserBundle */ .n)() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 1088:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, browserPerformanceTimeOrigin, timestampWithMs, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94440);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55574);
/* module decorator */ module = __webpack_require__.hmd(module);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

// Re-exported with an old name for backwards-compatibility.
const timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
const usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 55574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 94681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ro": function() { return /* binding */ addExtensionMethods; },
  "lb": function() { return /* binding */ startIdleTransaction; }
});

// UNUSED EXPORTS: _addTracingExtensions

// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/core/esm/utils/hasTracingEnabled.js
var hasTracingEnabled = __webpack_require__(55006);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/core/esm/hub.js + 3 modules
var hub = __webpack_require__(45532);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(75394);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(29856);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(90525);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/instrument.js + 2 modules
var instrument = __webpack_require__(44624);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(65498);
;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/errors.js



/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  (0,instrument/* addInstrumentationHandler */.o)('error', errorCallback);
  (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    const status = 'internal_error';
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}


//# sourceMappingURL=errors.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(94061);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/esm/transaction.js
var esm_transaction = __webpack_require__(56590);
;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/esm/hubextensions.js
/* module decorator */ module = __webpack_require__.hmd(module);






/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
  const scope = this.getScope();
  if (scope) {
    const span = scope.getSpan();
    if (span) {
      return {
        'sentry-trace': span.toTraceparent(),
      };
    }
  }
  return {};
}

/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)(options)) {
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  if (transaction.sampled !== undefined) {
    transaction.setMetadata({
      sampleRate: Number(transaction.sampled),
    });
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else {
    // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    transaction.setMetadata({
      sampleRate,
    });
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  if (!transaction.sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(

  transactionContext,
  customSamplingContext,
) {
  const client = this.getClient();
  const options = (client && client.getOptions()) || {};

  const configInstrumenter = options.instrumenter || 'sentry';
  const transactionInstrumenter = transactionContext.instrumenter || 'sentry';

  if (configInstrumenter !== transactionInstrumenter) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.error */.kg.error(
        `A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`,
      );

    transactionContext.sampled = false;
  }

  let transaction = new esm_transaction/* Transaction */.Y(transactionContext, this);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
  heartbeatInterval,
) {
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {};

  let transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * @private
 */
function _addTracingExtensions() {
  const carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }
}

/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
  const carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }

  const packageToIntegrationMapping = {
    mongodb() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo')

;
      return new integration.Mongo();
    },
    mongoose() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo')

;
      return new integration.Mongo({ mongoose: true });
    },
    mysql() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mysql')

;
      return new integration.Mysql();
    },
    pg() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/postgres')

;
      return new integration.Postgres();
    },
  };

  const mappedPackages = Object.keys(packageToIntegrationMapping)
    .filter(moduleName => !!(0,node/* loadModule */.$y)(moduleName))
    .map(pkg => {
      try {
        return packageToIntegrationMapping[pkg]();
      } catch (e) {
        return undefined;
      }
    })
    .filter(p => p) ;

  if (mappedPackages.length > 0) {
    carrier.__SENTRY__.integrations = [...(carrier.__SENTRY__.integrations || []), ...mappedPackages];
  }
}

/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
  _addTracingExtensions();

  // Detect and automatically load specified integrations.
  if ((0,node/* isNodeEnv */.KV)()) {
    _autoloadDatabaseIntegrations();
  }

  // If an error happens globally, we should make sure transaction status is set to error.
  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map


/***/ }),

/***/ 94061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hd": function() { return /* binding */ DEFAULT_HEARTBEAT_INTERVAL; },
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; },
/* harmony export */   "mg": function() { return /* binding */ DEFAULT_FINAL_TIMEOUT; },
/* harmony export */   "nT": function() { return /* binding */ DEFAULT_IDLE_TIMEOUT; }
/* harmony export */ });
/* unused harmony export IdleTransactionSpanRecorder */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28965);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75394);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10092);
/* harmony import */ var _transaction_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56590);




const DEFAULT_IDLE_TIMEOUT = 1000;
const DEFAULT_FINAL_TIMEOUT = 30000;
const DEFAULT_HEARTBEAT_INTERVAL = 5000;

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanId !== this.transactionSpanId) {
      // We patch span.finish() to pop an activity after setting an endTimestamp.
      span.finish = (endTimestamp) => {
        span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
        this._popActivity(span.spanId);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if (span.endTimestamp === undefined) {
        this._pushActivity(span.spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends _transaction_js__WEBPACK_IMPORTED_MODULE_2__/* .Transaction */ .Y {
  // Activities store a list of active spans
   __init() {this.activities = {};}

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
   __init2() {this._heartbeatCounter = 0;}

  // We should not use heartbeat if we finished a transaction
   __init3() {this._finished = false;}

    __init4() {this._beforeFinishCallbacks = [];}

  /**
   * Timer that tracks Transaction idleTimeout
   */

   constructor(
    transactionContext,
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = DEFAULT_IDLE_TIMEOUT,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = DEFAULT_FINAL_TIMEOUT,
      _heartbeatInterval = DEFAULT_HEARTBEAT_INTERVAL,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._heartbeatInterval = _heartbeatInterval;this._onScope = _onScope;IdleTransaction.prototype.__init.call(this);IdleTransaction.prototype.__init2.call(this);IdleTransaction.prototype.__init3.call(this);IdleTransaction.prototype.__init4.call(this);
    if (_onScope) {
      // There should only be one active transaction on the scope
      clearActiveTransaction(_idleHub);

      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
      _idleHub.configureScope(scope => scope.setSpan(this));
    }

    this._startIdleTimeout();
    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this.finish();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   finish(endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)()) {
    this._finished = true;
    this.activities = {};

    if (this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

      for (const callback of this._beforeFinishCallbacks) {
        callback(this, endTimestamp);
      }

      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanId === this.spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!span.endTimestamp) {
          span.endTimestamp = endTimestamp;
          span.setStatus('cancelled');
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        const keepSpan = span.startTimestamp < endTimestamp;
        if (!keepSpan) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
              '[Tracing] discarding Span since it happened after Transaction was finished',
              JSON.stringify(span, undefined, 2),
            );
        }
        return keepSpan;
      });

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] flushing IdleTransaction');
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      clearActiveTransaction(this._idleHub);
    }

    return super.finish(endTimestamp);
  }

  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    if (!this.spanRecorder) {
      const pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      const popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idletimeout, if there is one
   */
   _cancelIdleTimeout() {
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;
    }
  }

  /**
   * Creates an idletimeout
   */
   _startIdleTimeout(endTimestamp) {
    this._cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this.finish(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this._cancelIdleTimeout();
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] popActivity ${spanId}`);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.activities[spanId];
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      // We need to add the timeout here to have the real endtimestamp of the transaction
      // Remember timestampWithMs is in seconds, timeout is in ms
      const endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)() + this._idleTimeout / 1000;
      this._startIdleTimeout(endTimestamp);
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    const heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter++;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
      this.setStatus('deadline_exceeded');
      this.finish();
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}

/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
  const scope = hub.getScope();
  if (scope) {
    const transaction = scope.getTransaction();
    if (transaction) {
      scope.setSpan(undefined);
    }
  }
}


//# sourceMappingURL=idletransaction.js.map


/***/ }),

/***/ 10092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dr": function() { return /* binding */ Span; },
/* harmony export */   "gB": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* unused harmony export spanStatusfromHttpCode */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23595);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28965);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75394);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79734);


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {
   __init() {this.spans = [];}

   constructor(maxlen = 1000) {SpanRecorder.prototype.__init.call(this);
    this._maxlen = maxlen;
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * @inheritDoc
   */
   __init2() {this.traceId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();}

  /**
   * @inheritDoc
   */
   __init3() {this.spanId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);}

  /**
   * @inheritDoc
   */

  /**
   * Internal keeper of the status
   */

  /**
   * @inheritDoc
   */

  /**
   * Timestamp in seconds when the span was created.
   */
   __init4() {this.startTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();}

  /**
   * Timestamp in seconds when the span ended.
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   __init5() {this.tags = {};}

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   __init6() {this.data = {};}

  /**
   * List of spans that were finalized
   */

  /**
   * @inheritDoc
   */

  /**
   * The instrumenter that created this span.
   */
   __init7() {this.instrumenter = 'sentry';}

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext) {Span.prototype.__init2.call(this);Span.prototype.__init3.call(this);Span.prototype.__init4.call(this);Span.prototype.__init5.call(this);Span.prototype.__init6.call(this);Span.prototype.__init7.call(this);
    if (!spanContext) {
      return this;
    }
    if (spanContext.traceId) {
      this.traceId = spanContext.traceId;
    }
    if (spanContext.spanId) {
      this.spanId = spanContext.spanId;
    }
    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }
    if (spanContext.op) {
      this.op = spanContext.op;
    }
    if (spanContext.description) {
      this.description = spanContext.description;
    }
    if (spanContext.data) {
      this.data = spanContext.data;
    }
    if (spanContext.tags) {
      this.tags = spanContext.tags;
    }
    if (spanContext.status) {
      this.status = spanContext.status;
    }
    if (spanContext.startTimestamp) {
      this.startTimestamp = spanContext.startTimestamp;
    }
    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
    if (spanContext.instrumenter) {
      this.instrumenter = spanContext.instrumenter;
    }
  }

  /**
   * @inheritDoc
   */
   startChild(
    spanContext,
  ) {
    const childSpan = new Span({
      ...spanContext,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId,
    });

    childSpan.spanRecorder = this.spanRecorder;
    if (childSpan.spanRecorder) {
      childSpan.spanRecorder.add(childSpan);
    }

    childSpan.transaction = this.transaction;

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
      const opStr = (spanContext && spanContext.op) || '< unknown op >';
      const nameStr = childSpan.transaction.name || '< unknown name >';
      const idStr = childSpan.transaction.spanId;

      const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = { logMessage };
      _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(logMessage);
    }

    return childSpan;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   setData(key, value) {
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this.status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
   setHttpStatus(httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    const spanStatus = spanStatusfromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') {
      this.setStatus(spanStatus);
    }
    return this;
  }

  /**
   * @inheritDoc
   */
   isSuccess() {
    return this.status === 'ok';
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    if (
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      // Don't call this for transactions
      this.transaction &&
      this.transaction.spanId !== this.spanId
    ) {
      const { logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
      if (logMessage) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
  }

  /**
   * @inheritDoc
   */
   toTraceparent() {
    let sampledString = '';
    if (this.sampled !== undefined) {
      sampledString = this.sampled ? '-1' : '-0';
    }
    return `${this.traceId}-${this.spanId}${sampledString}`;
  }

  /**
   * @inheritDoc
   */
   toContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(spanContext) {
    this.data = spanContext.data || {};
    this.description = spanContext.description;
    this.endTimestamp = spanContext.endTimestamp;
    this.op = spanContext.op;
    this.parentSpanId = spanContext.parentSpanId;
    this.sampled = spanContext.sampled;
    this.spanId = spanContext.spanId || this.spanId;
    this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
    this.status = spanContext.status;
    this.tags = spanContext.tags || {};
    this.traceId = spanContext.traceId || this.traceId;

    return this;
  }

  /**
   * @inheritDoc
   */
   getTraceContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   toJSON()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId,
    });
  }
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}


//# sourceMappingURL=span.js.map


/***/ }),

/***/ 56590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45532);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75394);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79734);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10092);




/** JSDoc */
class Transaction extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .Span */ .Dr  {

  /**
   * The reference to the current hub.
   */

   __init() {this._measurements = {};}

   __init2() {this._contexts = {};}

   __init3() {this._frozenDynamicSamplingContext = undefined;}

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(transactionContext, hub) {
    super(transactionContext);Transaction.prototype.__init.call(this);Transaction.prototype.__init2.call(this);Transaction.prototype.__init3.call(this);
    this._hub = hub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();

    this._name = transactionContext.name || '';

    this.metadata = {
      source: 'custom',
      ...transactionContext.metadata,
      spanMetadata: {},
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    this.transaction = this;

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      this._frozenDynamicSamplingContext = { ...incomingDynamicSamplingContext };
    }
  }

  /** Getter for `name` property */
   get name() {
    return this._name;
  }

  /** Setter for `name` property, which also sets `source` as custom */
   set name(newName) {
    this.setName(newName);
  }

  /**
   * JSDoc
   */
   setName(name, source = 'custom') {
    this._name = name;
    this.metadata.source = source;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    if (!this.spanRecorder) {
      this.spanRecorder = new _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB(maxlen);
    }
    this.spanRecorder.add(this);
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
  }

  /**
   * @inheritDoc
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * @inheritDoc
   */
   setMetadata(newMetadata) {
    this.metadata = { ...this.metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.finish(endTimestamp);

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      const client = this._hub.getClient();
      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(s => s !== this && s.endTimestamp) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce((prev, current) => {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }
        return prev;
      }).endTimestamp;
    }

    const metadata = this.metadata;

    const transaction = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: this.getTraceContext(),
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        dynamicSamplingContext: this.getDynamicSamplingContext(),
      },
      ...(metadata.source && {
        transaction_info: {
          source: metadata.source,
        },
      }),
    };

    const hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);

    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    const spanContext = super.toContext();

    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      ...spanContext,
      name: this.name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    super.updateWithContext(transactionContext);

    this.name = transactionContext.name || '';

    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   */
   getDynamicSamplingContext() {
    if (this._frozenDynamicSamplingContext) {
      return this._frozenDynamicSamplingContext;
    }

    const hub = this._hub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();
    const client = hub && hub.getClient();

    if (!client) return {};

    const { environment, release } = client.getOptions() || {};
    const { publicKey: public_key } = client.getDsn() || {};

    const maybeSampleRate = this.metadata.sampleRate;
    const sample_rate = maybeSampleRate !== undefined ? maybeSampleRate.toString() : undefined;

    const scope = hub.getScope();
    const { segment: user_segment } = (scope && scope.getUser()) || {};

    const source = this.metadata.source;

    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const transaction = source && source !== 'url' ? this.name : undefined;

    const dsc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      environment,
      release,
      transaction,
      user_segment,
      public_key,
      trace_id: this.traceId,
      sample_rate,
    });

    // Uncomment if we want to make DSC immutable
    // this._frozenDynamicSamplingContext = dsc;

    return dsc;
  }
}


//# sourceMappingURL=transaction.js.map


/***/ }),

/***/ 65498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XL": function() { return /* binding */ msToSec; },
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; }
/* harmony export */ });
/* unused harmony export hasTracingEnabled */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45532);



/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 * @deprecated This export has moved to `@sentry/core`. This export will be removed from `@sentry/tracing` in v8.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  return hasTracingEnabled$1(maybeOptions);
}

/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
  const hub = maybeHub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  const scope = hub.getScope();
  return scope && (scope.getTransaction() );
}

/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 45532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Gd": function() { return /* binding */ getCurrentHub; },
  "cu": function() { return /* binding */ getMainCarrier; }
});

// UNUSED EXPORTS: API_VERSION, Hub, getHubFromCarrier, makeMain, setHubOnCarrier

// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(23595);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(28965);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(75394);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(68356);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(90525);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(29856);
;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/syncpromise.js


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
   __init() {this._state = States.PENDING;}
   __init2() {this._handlers = [];}

   constructor(
    executor,
  ) {SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);SyncPromise.prototype.__init5.call(this);SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,is/* isThenable */.J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(79734);
;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/core/esm/session.js


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,time/* timestampInSeconds */.ph)();

  const session = {
    sid: (0,misc/* uuid4 */.DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,time/* timestampInSeconds */.ph)();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,misc/* uuid4 */.DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,object/* dropUndefinedKeys */.Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/core/esm/scope.js



/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
      newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      updateSession(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
    } else if ((0,is/* isPlainObject */.PO)(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,time/* dateTimestampInSeconds */.yW)(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transactionName = this._span.transaction && this._span.transaction.name;
      if (transactionName) {
        event.tags = { transaction: transactionName, ...event.tags };
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = { ...event.sdkProcessingMetadata, ...this._sdkProcessingMetadata };

    return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new SyncPromise((resolve, reject) => {
      const processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        const result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          logger/* logger.log */.kg.log(`Event processor "${processor.id}" dropped event`);

        if ((0,is/* isThenable */.J8)(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0,misc/* arrayify */.lE)(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,worldwide/* getGlobalSingleton */.YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}


//# sourceMappingURL=scope.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/core/esm/hub.js




/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * A layer in the process stack.
 * @hidden
 */

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */
    __init() {this._stack = [{}];}

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new Scope(),   _version = API_VERSION) {this._version = _version;Hub.prototype.__init.call(this);
    this.getStackTop().scope = scope;
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = Scope.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)());
    const syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)());
    const syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)();
    if (!event.type) {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!scope || !client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,time/* dateTimestampInSeconds */.yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? ((0,logger/* consoleSandbox */.Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    const scope = this.getScope();
    if (scope) scope.setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    const scope = this.getScope();
    if (scope) scope.setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    const scope = this.getScope();
    if (scope) scope.setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    const scope = this.getScope();
    if (scope) scope.setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    const scope = this.getScope();
    if (scope) scope.setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    const scope = this.getScope();
    if (scope) scope.setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (scope && client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    return this._callExtensionMethod('startTransaction', context, customSamplingContext);
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer && layer.scope;
    const session = scope && scope.getSession();
    if (session) {
      closeSession(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    if (scope) {
      scope.setSession();
    }
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = worldwide/* GLOBAL_OBJ.navigator */.n2.navigator || {};

    const session = makeSession({
      release,
      environment,
      ...(scope && { user: scope.getUser() }),
      ...(userAgent && { userAgent }),
      ...context,
    });

    if (scope) {
      // End existing session if there's one
      const currentSession = scope.getSession && scope.getSession();
      if (currentSession && currentSession.status === 'ok') {
        updateSession(currentSession, { status: 'exited' });
      }
      this.endSession();

      // Afterwards we set the new session on the scope
      scope.setSession(session);
    }

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();
    if (!scope) return;

    const session = scope.getSession();
    if (session) {
      if (client && client.captureSession) {
        client.captureSession(session);
      }
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  worldwide/* GLOBAL_OBJ.__SENTRY__ */.n2.__SENTRY__ = worldwide/* GLOBAL_OBJ.__SENTRY__ */.n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return worldwide/* GLOBAL_OBJ */.n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Prefer domains over global if they are there (applicable only to Node environment)
  if ((0,node/* isNodeEnv */.KV)()) {
    return getHubFromActiveDomain(registry);
  }
  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
  try {
    const sentry = getMainCarrier().__SENTRY__;
    const activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;

    // If there's no active domain, just return global hub
    if (!activeDomain) {
      return getHubFromCarrier(registry);
    }

    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
      const registryHubTopStack = getHubFromCarrier(registry).getStackTop();
      setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, Scope.clone(registryHubTopStack.scope)));
    }

    // Return hub that lives on a domain
    return getHubFromCarrier(activeDomain);
  } catch (_Oo) {
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
  }
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,worldwide/* getGlobalSingleton */.YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 55006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45532);


// Treeshakable guard to remove all code related to tracing

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) {
    return false;
  }

  const client = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


//# sourceMappingURL=hasTracingEnabled.js.map


/***/ }),

/***/ 44624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ addInstrumentationHandler; }
});

// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(29856);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(75394);
// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(79734);
;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/stacktrace.js
const STACKTRACE_LIMIT = 50;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];
    for (const line of stack.split('\n').slice(skipFirst)) {
      // Ignore lines over 1kb as they are unlikely to be stack frames.
      // Many of the regular expressions use backtracking which results in run time that increases exponentially with
      // input size. Huge strings can result in hangs/Denial of Service:
      // https://github.com/getsentry/sentry-javascript/issues/2286
      if (line.length > 1024) {
        continue;
      }

      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = line.replace(/\(error: (.*)\)/, '$1');

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  let localStack = stack;

  const firstFrameFunction = localStack[0].function || '';
  const lastFrameFunction = localStack[localStack.length - 1].function || '';

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
    localStack = localStack.slice(1);
  }

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
    localStack = localStack.slice(0, -1);
  }

  // The frame where the crash happened, should be the last entry in the array
  return localStack
    .slice(0, STACKTRACE_LIMIT)
    .map(frame => ({
      ...frame,
      filename: frame.filename || localStack[0].filename,
      function: frame.function || '?',
    }))
    .reverse();
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

// eslint-disable-next-line complexity
function node(getModule) {
  const FILENAME_MATCH = /^\s*[-]{4,}$/;
  const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;

  // eslint-disable-next-line complexity
  return (line) => {
    if (line.match(FILENAME_MATCH)) {
      return {
        filename: line,
      };
    }

    const lineMatch = line.match(FULL_MATCH);
    if (!lineMatch) {
      return undefined;
    }

    let object;
    let method;
    let functionName;
    let typeName;
    let methodName;

    if (lineMatch[1]) {
      functionName = lineMatch[1];

      let methodStart = functionName.lastIndexOf('.');
      if (functionName[methodStart - 1] === '.') {
        methodStart--;
      }

      if (methodStart > 0) {
        object = functionName.slice(0, methodStart);
        method = functionName.slice(methodStart + 1);
        const objectEnd = object.indexOf('.Module');
        if (objectEnd > 0) {
          functionName = functionName.slice(objectEnd + 1);
          object = object.slice(0, objectEnd);
        }
      }
      typeName = undefined;
    }

    if (method) {
      typeName = object;
      methodName = method;
    }

    if (method === '<anonymous>') {
      methodName = undefined;
      functionName = undefined;
    }

    if (functionName === undefined) {
      methodName = methodName || '<anonymous>';
      functionName = typeName ? `${typeName}.${methodName}` : methodName;
    }

    const filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
    const isNative = lineMatch[5] === 'native';
    const isInternal =
      isNative || (filename && !filename.startsWith('/') && !filename.startsWith('.') && filename.indexOf(':\\') !== 1);

    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    const in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');

    return {
      filename,
      module: getModule ? getModule(filename) : undefined,
      function: functionName,
      lineno: parseInt(lineMatch[3], 10) || undefined,
      colno: parseInt(lineMatch[4], 10) || undefined,
      in_app,
    };
  };
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map

// EXTERNAL MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(68356);
;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/supports.js



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-ignore It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chrome = (WINDOW ).chrome;
  const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in WINDOW && !!WINDOW.history.pushState && !!WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supports.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/instrument.js







// eslint-disable-next-line deprecation/deprecation
const instrument_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

const handlers = {};
const instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (const handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.error */.kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${getFunctionName(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!('console' in instrument_WINDOW)) {
    return;
  }

  logger/* CONSOLE_LEVELS.forEach */.RU.forEach(function (level) {
    if (!(level in instrument_WINDOW.console)) {
      return;
    }

    (0,object/* fill */.hl)(instrument_WINDOW.console, level, function (originalConsoleMethod) {
      return function (...args) {
        triggerHandlers('console', { args, level });

        // this fails for some browsers. :(
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(instrument_WINDOW.console, args);
        }
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!supportsNativeFetch()) {
    return;
  }

  (0,object/* fill */.hl)(instrument_WINDOW, 'fetch', function (originalFetch) {
    return function (...args) {
      const handlerData = {
        args,
        fetchData: {
          method: getFetchMethod(args),
          url: getFetchUrl(args),
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(instrument_WINDOW, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs = []) {
  if ('Request' in instrument_WINDOW && (0,is/* isInstanceOf */.V9)(fetchArgs[0], Request) && fetchArgs[0].method) {
    return String(fetchArgs[0].method).toUpperCase();
  }
  if (fetchArgs[1] && fetchArgs[1].method) {
    return String(fetchArgs[1].method).toUpperCase();
  }
  return 'GET';
}

/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs = []) {
  if (typeof fetchArgs[0] === 'string') {
    return fetchArgs[0];
  }
  if ('Request' in instrument_WINDOW && (0,is/* isInstanceOf */.V9)(fetchArgs[0], Request)) {
    return fetchArgs[0].url;
  }
  return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */

/** JSDoc */
function instrumentXHR() {
  if (!('XMLHttpRequest' in instrument_WINDOW)) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  (0,object/* fill */.hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const xhr = this;
      const url = args[1];
      const xhrInfo = (xhr.__sentry_xhr__ = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: (0,is/* isString */.HD)(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
      });

      // if Sentry key appears in URL, don't capture it as a request
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if ((0,is/* isString */.HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        xhr.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = function () {
        if (xhr.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = xhr.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr,
          });
        }
      };

      if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
        (0,object/* fill */.hl)(xhr, 'onreadystatechange', function (original) {
          return function (...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(xhr, readyStateArgs);
          };
        });
      } else {
        xhr.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      return originalOpen.apply(xhr, args);
    };
  });

  (0,object/* fill */.hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      if (this.__sentry_xhr__ && args[0] !== undefined) {
        this.__sentry_xhr__.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!supportsHistory()) {
    return;
  }

  const oldOnPopState = instrument_WINDOW.onpopstate;
  instrument_WINDOW.onpopstate = function ( ...args) {
    const to = instrument_WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,object/* fill */.hl)(instrument_WINDOW.history, 'pushState', historyReplacementFunction);
  (0,object/* fill */.hl)(instrument_WINDOW.history, 'replaceState', historyReplacementFunction);
}

const debounceDuration = 1000;
let debounceTimerID;
let lastCapturedEvent;

/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
  // If there was no previous event, it should always be swapped for the new one.
  if (!previous) {
    return true;
  }

  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (previous.type !== current.type) {
    return true;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (previous.target !== current.target) {
      return true;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return false;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
  // We are only interested in filtering `keypress` events for now.
  if (event.type !== 'keypress') {
    return false;
  }

  try {
    const target = event.target ;

    if (!target || !target.tagName) {
      return true;
    }

    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || lastCapturedEvent === event) {
      return;
    }

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event)) {
      return;
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
    if (debounceTimerID === undefined) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }
    // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = instrument_WINDOW.setTimeout(() => {
      debounceTimerID = undefined;
    }, debounceDuration);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!('document' in instrument_WINDOW)) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  instrument_WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  instrument_WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (instrument_WINDOW )[target] && (instrument_WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,object/* fill */.hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount++;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,object/* fill */.hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount--;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = instrument_WINDOW.onerror;

  instrument_WINDOW.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = instrument_WINDOW.onunhandledrejection;

  instrument_WINDOW.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };
}


//# sourceMappingURL=instrument.js.map


/***/ }),

/***/ 29856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; }
/* harmony export */ });
/* unused harmony exports isDOMError, isDOMException, isElement, isError, isErrorEvent, isEvent, isPrimitive, isSyntheticEvent */
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 75394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68356);


/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
    return callback();
  }

  const originalConsole = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console ;
  const wrappedLevels = {};

  // Restore all wrapped console methods
  CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    const originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in originalConsole && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  logger = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)('logger', makeLogger);
} else {
  logger = makeLogger();
}


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 23595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, addExceptionMechanism, addExceptionTypeValue, checkOrSetAlreadyCaught, getEventDescription, parseSemver */
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68356);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  const getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    addNonEnumerableProperty(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 90525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; },
  "$y": function() { return /* binding */ loadModule; }
});

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * Get source of SDK.
 */
function getSDKSource() {
  // @ts-ignore "npm" is injected by rollup during build process
  return "npm";
}


//# sourceMappingURL=env.js.map

;// CONCATENATED MODULE: ../node_modules/@sentry/tracing/node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(27061);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !isBrowserBundle() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 79734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "hl": function() { return /* binding */ fill; }
/* harmony export */ });
/* unused harmony exports addNonEnumerableProperty, convertToPlainObject, extractExceptionKeysForMessage, getOriginalFunction, markFunctionWrapped, objectify, urlEncode */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29856);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    try {
      markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
      // This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: value,
    writable: true,
    configurable: true,
  });
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  const proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(value)

 {
  if (isError(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if (isEvent(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && isInstanceOf(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return isElement(target) ? htmlTreeAsString(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return truncate(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return truncate(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 28965:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "_I": function() { return /* binding */ timestampWithMs; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90525);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68356);
/* module decorator */ module = __webpack_require__.hmd(module);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

// Re-exported with an old name for backwards-compatibility.
const timestampWithMs = timestampInSeconds;

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
const usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 68356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 30473:
/***/ (function(module) {

"use strict";
/*globals self, window */


/*eslint-disable @mysticatea/prettier */
const { AbortController, AbortSignal } =
    typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    /* otherwise */ undefined
/*eslint-enable @mysticatea/prettier */

module.exports = AbortController
module.exports.AbortSignal = AbortSignal
module.exports["default"] = AbortController


/***/ }),

/***/ 21498:
/***/ (function(module) {

/* The following list is defined in React's core */
var IS_UNITLESS = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

module.exports = function(name, value) {
  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
    return value + 'px';
  } else {
    return value;
  }
};

/***/ }),

/***/ 39619:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(27061);
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(51404),
    _require$codes = _require.codes,
    ERR_AMBIGUOUS_ARGUMENT = _require$codes.ERR_AMBIGUOUS_ARGUMENT,
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_INVALID_ARG_VALUE = _require$codes.ERR_INVALID_ARG_VALUE,
    ERR_INVALID_RETURN_VALUE = _require$codes.ERR_INVALID_RETURN_VALUE,
    ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS;

var AssertionError = __webpack_require__(87366);

var _require2 = __webpack_require__(71323),
    inspect = _require2.inspect;

var _require$types = (__webpack_require__(71323).types),
    isPromise = _require$types.isPromise,
    isRegExp = _require$types.isRegExp;

var objectAssign = Object.assign ? Object.assign : (__webpack_require__(42098).assign);
var objectIs = Object.is ? Object.is : __webpack_require__(83822);
var errorCache = new Map();
var isDeepEqual;
var isDeepStrictEqual;
var parseExpressionAt;
var findNodeAround;
var decoder;

function lazyLoadComparison() {
  var comparison = __webpack_require__(40118);

  isDeepEqual = comparison.isDeepEqual;
  isDeepStrictEqual = comparison.isDeepStrictEqual;
} // Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex


var escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var meta = (/* unused pure expression or super */ null && (["\\u0000", "\\u0001", "\\u0002", "\\u0003", "\\u0004", "\\u0005", "\\u0006", "\\u0007", '\\b', '', '', "\\u000b", '\\f', '', "\\u000e", "\\u000f", "\\u0010", "\\u0011", "\\u0012", "\\u0013", "\\u0014", "\\u0015", "\\u0016", "\\u0017", "\\u0018", "\\u0019", "\\u001a", "\\u001b", "\\u001c", "\\u001d", "\\u001e", "\\u001f"]));

var escapeFn = function escapeFn(str) {
  return meta[str.charCodeAt(0)];
};

var warned = false; // The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;
var NO_EXCEPTION_SENTINEL = {}; // All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function innerFail(obj) {
  if (obj.message instanceof Error) throw obj.message;
  throw new AssertionError(obj);
}

function fail(actual, expected, message, operator, stackStartFn) {
  var argsLen = arguments.length;
  var internalMessage;

  if (argsLen === 0) {
    internalMessage = 'Failed';
  } else if (argsLen === 1) {
    message = actual;
    actual = undefined;
  } else {
    if (warned === false) {
      warned = true;
      var warn = process.emitWarning ? process.emitWarning : console.warn.bind(console);
      warn('assert.fail() with more than one argument is deprecated. ' + 'Please use assert.strictEqual() instead or only pass a message.', 'DeprecationWarning', 'DEP0094');
    }

    if (argsLen === 2) operator = '!=';
  }

  if (message instanceof Error) throw message;
  var errArgs = {
    actual: actual,
    expected: expected,
    operator: operator === undefined ? 'fail' : operator,
    stackStartFn: stackStartFn || fail
  };

  if (message !== undefined) {
    errArgs.message = message;
  }

  var err = new AssertionError(errArgs);

  if (internalMessage) {
    err.message = internalMessage;
    err.generatedMessage = true;
  }

  throw err;
}

assert.fail = fail; // The AssertionError is defined in internal/error.

assert.AssertionError = AssertionError;

function innerOk(fn, argLen, value, message) {
  if (!value) {
    var generatedMessage = false;

    if (argLen === 0) {
      generatedMessage = true;
      message = 'No value argument passed to `assert.ok()`';
    } else if (message instanceof Error) {
      throw message;
    }

    var err = new AssertionError({
      actual: value,
      expected: true,
      message: message,
      operator: '==',
      stackStartFn: fn
    });
    err.generatedMessage = generatedMessage;
    throw err;
  }
} // Pure assertion tests whether a value is truthy, as determined
// by !!value.


function ok() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  innerOk.apply(void 0, [ok, args.length].concat(args));
}

assert.ok = ok; // The equality assertion tests shallow, coercive equality with ==.

/* eslint-disable no-restricted-properties */

assert.equal = function equal(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  } // eslint-disable-next-line eqeqeq


  if (actual != expected) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: '==',
      stackStartFn: equal
    });
  }
}; // The non-equality assertion tests for whether two objects are not
// equal with !=.


assert.notEqual = function notEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  } // eslint-disable-next-line eqeqeq


  if (actual == expected) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: '!=',
      stackStartFn: notEqual
    });
  }
}; // The equivalence assertion tests a deep equality relation.


assert.deepEqual = function deepEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }

  if (isDeepEqual === undefined) lazyLoadComparison();

  if (!isDeepEqual(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'deepEqual',
      stackStartFn: deepEqual
    });
  }
}; // The non-equivalence assertion tests for any deep inequality.


assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }

  if (isDeepEqual === undefined) lazyLoadComparison();

  if (isDeepEqual(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'notDeepEqual',
      stackStartFn: notDeepEqual
    });
  }
};
/* eslint-enable */


assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }

  if (isDeepEqual === undefined) lazyLoadComparison();

  if (!isDeepStrictEqual(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'deepStrictEqual',
      stackStartFn: deepStrictEqual
    });
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;

function notDeepStrictEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }

  if (isDeepEqual === undefined) lazyLoadComparison();

  if (isDeepStrictEqual(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'notDeepStrictEqual',
      stackStartFn: notDeepStrictEqual
    });
  }
}

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }

  if (!objectIs(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'strictEqual',
      stackStartFn: strictEqual
    });
  }
};

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }

  if (objectIs(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'notStrictEqual',
      stackStartFn: notStrictEqual
    });
  }
};

var Comparison = function Comparison(obj, keys, actual) {
  var _this = this;

  _classCallCheck(this, Comparison);

  keys.forEach(function (key) {
    if (key in obj) {
      if (actual !== undefined && typeof actual[key] === 'string' && isRegExp(obj[key]) && obj[key].test(actual[key])) {
        _this[key] = actual[key];
      } else {
        _this[key] = obj[key];
      }
    }
  });
};

function compareExceptionKey(actual, expected, key, message, keys, fn) {
  if (!(key in actual) || !isDeepStrictEqual(actual[key], expected[key])) {
    if (!message) {
      // Create placeholder objects to create a nice output.
      var a = new Comparison(actual, keys);
      var b = new Comparison(expected, keys, actual);
      var err = new AssertionError({
        actual: a,
        expected: b,
        operator: 'deepStrictEqual',
        stackStartFn: fn
      });
      err.actual = actual;
      err.expected = expected;
      err.operator = fn.name;
      throw err;
    }

    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: fn.name,
      stackStartFn: fn
    });
  }
}

function expectedException(actual, expected, msg, fn) {
  if (typeof expected !== 'function') {
    if (isRegExp(expected)) return expected.test(actual); // assert.doesNotThrow does not accept objects.

    if (arguments.length === 2) {
      throw new ERR_INVALID_ARG_TYPE('expected', ['Function', 'RegExp'], expected);
    } // Handle primitives properly.


    if (_typeof(actual) !== 'object' || actual === null) {
      var err = new AssertionError({
        actual: actual,
        expected: expected,
        message: msg,
        operator: 'deepStrictEqual',
        stackStartFn: fn
      });
      err.operator = fn.name;
      throw err;
    }

    var keys = Object.keys(expected); // Special handle errors to make sure the name and the message are compared
    // as well.

    if (expected instanceof Error) {
      keys.push('name', 'message');
    } else if (keys.length === 0) {
      throw new ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
    }

    if (isDeepEqual === undefined) lazyLoadComparison();
    keys.forEach(function (key) {
      if (typeof actual[key] === 'string' && isRegExp(expected[key]) && expected[key].test(actual[key])) {
        return;
      }

      compareExceptionKey(actual, expected, key, msg, keys, fn);
    });
    return true;
  } // Guard instanceof against arrow functions as they don't have a prototype.


  if (expected.prototype !== undefined && actual instanceof expected) {
    return true;
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function getActual(fn) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
  }

  try {
    fn();
  } catch (e) {
    return e;
  }

  return NO_EXCEPTION_SENTINEL;
}

function checkIsPromise(obj) {
  // Accept native ES6 promises and promises that are implemented in a similar
  // way. Do not accept thenables that use a function as `obj` and that have no
  // `catch` handler.
  // TODO: thenables are checked up until they have the correct methods,
  // but according to documentation, the `then` method should receive
  // the `fulfill` and `reject` arguments as well or it may be never resolved.
  return isPromise(obj) || obj !== null && _typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}

function waitForActual(promiseFn) {
  return Promise.resolve().then(function () {
    var resultPromise;

    if (typeof promiseFn === 'function') {
      // Return a rejected promise if `promiseFn` throws synchronously.
      resultPromise = promiseFn(); // Fail in case no promise is returned.

      if (!checkIsPromise(resultPromise)) {
        throw new ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
      }
    } else if (checkIsPromise(promiseFn)) {
      resultPromise = promiseFn;
    } else {
      throw new ERR_INVALID_ARG_TYPE('promiseFn', ['Function', 'Promise'], promiseFn);
    }

    return Promise.resolve().then(function () {
      return resultPromise;
    }).then(function () {
      return NO_EXCEPTION_SENTINEL;
    }).catch(function (e) {
      return e;
    });
  });
}

function expectsError(stackStartFn, actual, error, message) {
  if (typeof error === 'string') {
    if (arguments.length === 4) {
      throw new ERR_INVALID_ARG_TYPE('error', ['Object', 'Error', 'Function', 'RegExp'], error);
    }

    if (_typeof(actual) === 'object' && actual !== null) {
      if (actual.message === error) {
        throw new ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
      }
    } else if (actual === error) {
      throw new ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
    }

    message = error;
    error = undefined;
  } else if (error != null && _typeof(error) !== 'object' && typeof error !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('error', ['Object', 'Error', 'Function', 'RegExp'], error);
  }

  if (actual === NO_EXCEPTION_SENTINEL) {
    var details = '';

    if (error && error.name) {
      details += " (".concat(error.name, ")");
    }

    details += message ? ": ".concat(message) : '.';
    var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
    innerFail({
      actual: undefined,
      expected: error,
      operator: stackStartFn.name,
      message: "Missing expected ".concat(fnType).concat(details),
      stackStartFn: stackStartFn
    });
  }

  if (error && !expectedException(actual, error, message, stackStartFn)) {
    throw actual;
  }
}

function expectsNoError(stackStartFn, actual, error, message) {
  if (actual === NO_EXCEPTION_SENTINEL) return;

  if (typeof error === 'string') {
    message = error;
    error = undefined;
  }

  if (!error || expectedException(actual, error)) {
    var details = message ? ": ".concat(message) : '.';
    var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
    innerFail({
      actual: actual,
      expected: error,
      operator: stackStartFn.name,
      message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
      stackStartFn: stackStartFn
    });
  }

  throw actual;
}

assert.throws = function throws(promiseFn) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  expectsError.apply(void 0, [throws, getActual(promiseFn)].concat(args));
};

assert.rejects = function rejects(promiseFn) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return waitForActual(promiseFn).then(function (result) {
    return expectsError.apply(void 0, [rejects, result].concat(args));
  });
};

assert.doesNotThrow = function doesNotThrow(fn) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  expectsNoError.apply(void 0, [doesNotThrow, getActual(fn)].concat(args));
};

assert.doesNotReject = function doesNotReject(fn) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  return waitForActual(fn).then(function (result) {
    return expectsNoError.apply(void 0, [doesNotReject, result].concat(args));
  });
};

assert.ifError = function ifError(err) {
  if (err !== null && err !== undefined) {
    var message = 'ifError got unwanted exception: ';

    if (_typeof(err) === 'object' && typeof err.message === 'string') {
      if (err.message.length === 0 && err.constructor) {
        message += err.constructor.name;
      } else {
        message += err.message;
      }
    } else {
      message += inspect(err);
    }

    var newErr = new AssertionError({
      actual: err,
      expected: null,
      operator: 'ifError',
      message: message,
      stackStartFn: ifError
    }); // Make sure we actually have a stack trace!

    var origStack = err.stack;

    if (typeof origStack === 'string') {
      // This will remove any duplicated frames from the error frames taken
      // from within `ifError` and add the original error frames to the newly
      // created ones.
      var tmp2 = origStack.split('\n');
      tmp2.shift(); // Filter all frames existing in err.stack.

      var tmp1 = newErr.stack.split('\n');

      for (var i = 0; i < tmp2.length; i++) {
        // Find the first occurrence of the frame.
        var pos = tmp1.indexOf(tmp2[i]);

        if (pos !== -1) {
          // Only keep new frames.
          tmp1 = tmp1.slice(0, pos);
          break;
        }
      }

      newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
    }

    throw newErr;
  }
}; // Expose a strict only variant of assert


function strict() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  innerOk.apply(void 0, [strict, args.length].concat(args));
}

assert.strict = objectAssign(strict, assert, {
  equal: assert.strictEqual,
  deepEqual: assert.deepStrictEqual,
  notEqual: assert.notStrictEqual,
  notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

/***/ }),

/***/ 87366:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(27061);
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _require = __webpack_require__(71323),
    inspect = _require.inspect;

var _require2 = __webpack_require__(51404),
    ERR_INVALID_ARG_TYPE = _require2.codes.ERR_INVALID_ARG_TYPE; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat


function repeat(str, count) {
  count = Math.floor(count);
  if (str.length == 0 || count == 0) return '';
  var maxCount = str.length * count;
  count = Math.floor(Math.log(count) / Math.log(2));

  while (count) {
    str += str;
    count--;
  }

  str += str.substring(0, maxCount - str.length);
  return str;
}

var blue = '';
var green = '';
var red = '';
var white = '';
var kReadableOperator = {
  deepStrictEqual: 'Expected values to be strictly deep-equal:',
  strictEqual: 'Expected values to be strictly equal:',
  strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
  deepEqual: 'Expected values to be loosely deep-equal:',
  equal: 'Expected values to be loosely equal:',
  notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
  notStrictEqual: 'Expected "actual" to be strictly unequal to:',
  notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
  notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
  notEqual: 'Expected "actual" to be loosely unequal to:',
  notIdentical: 'Values identical but not reference-equal:'
}; // Comparing short primitives should just show === / !== instead of using the
// diff.

var kMaxShortLength = 10;

function copyError(source) {
  var keys = Object.keys(source);
  var target = Object.create(Object.getPrototypeOf(source));
  keys.forEach(function (key) {
    target[key] = source[key];
  });
  Object.defineProperty(target, 'message', {
    value: source.message
  });
  return target;
}

function inspectValue(val) {
  // The util.inspect default values could be changed. This makes sure the
  // error messages contain the necessary information nevertheless.
  return inspect(val, {
    compact: false,
    customInspect: false,
    depth: 1000,
    maxArrayLength: Infinity,
    // Assert compares only enumerable properties (with a few exceptions).
    showHidden: false,
    // Having a long line as error is better than wrapping the line for
    // comparison for now.
    // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
    // have meta information about the inspected properties (i.e., know where
    // in what line the property starts and ends).
    breakLength: Infinity,
    // Assert does not detect proxies currently.
    showProxy: false,
    sorted: true,
    // Inspect getters as we also check them when comparing entries.
    getters: true
  });
}

function createErrDiff(actual, expected, operator) {
  var other = '';
  var res = '';
  var lastPos = 0;
  var end = '';
  var skipped = false;
  var actualInspected = inspectValue(actual);
  var actualLines = actualInspected.split('\n');
  var expectedLines = inspectValue(expected).split('\n');
  var i = 0;
  var indicator = ''; // In case both values are objects explicitly mark them as not reference equal
  // for the `strictEqual` operator.

  if (operator === 'strictEqual' && _typeof(actual) === 'object' && _typeof(expected) === 'object' && actual !== null && expected !== null) {
    operator = 'strictEqualObject';
  } // If "actual" and "expected" fit on a single line and they are not strictly
  // equal, check further special handling.


  if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
    var inputLength = actualLines[0].length + expectedLines[0].length; // If the character length of "actual" and "expected" together is less than
    // kMaxShortLength and if neither is an object and at least one of them is
    // not `zero`, use the strict equal comparison to visualize the output.

    if (inputLength <= kMaxShortLength) {
      if ((_typeof(actual) !== 'object' || actual === null) && (_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) {
        // -0 === +0
        return "".concat(kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
      }
    } else if (operator !== 'strictEqualObject') {
      // If the stderr is a tty and the input length is lower than the current
      // columns per line, add a mismatch indicator below the output. If it is
      // not a tty, use a default value of 80 characters.
      var maxLength = process.stderr && process.stderr.isTTY ? process.stderr.columns : 80;

      if (inputLength < maxLength) {
        while (actualLines[0][i] === expectedLines[0][i]) {
          i++;
        } // Ignore the first characters.


        if (i > 2) {
          // Add position indicator for the first mismatch in case it is a
          // single line and the input length is less than the column length.
          indicator = "\n  ".concat(repeat(' ', i), "^");
          i = 0;
        }
      }
    }
  } // Remove all ending lines that match (this optimizes the output for
  // readability by reducing the number of total changed lines).


  var a = actualLines[actualLines.length - 1];
  var b = expectedLines[expectedLines.length - 1];

  while (a === b) {
    if (i++ < 2) {
      end = "\n  ".concat(a).concat(end);
    } else {
      other = a;
    }

    actualLines.pop();
    expectedLines.pop();
    if (actualLines.length === 0 || expectedLines.length === 0) break;
    a = actualLines[actualLines.length - 1];
    b = expectedLines[expectedLines.length - 1];
  }

  var maxLines = Math.max(actualLines.length, expectedLines.length); // Strict equal with identical objects that are not identical by reference.
  // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })

  if (maxLines === 0) {
    // We have to get the result again. The lines were all removed before.
    var _actualLines = actualInspected.split('\n'); // Only remove lines in case it makes sense to collapse those.
    // TODO: Accept env to always show the full error.


    if (_actualLines.length > 30) {
      _actualLines[26] = "".concat(blue, "...").concat(white);

      while (_actualLines.length > 27) {
        _actualLines.pop();
      }
    }

    return "".concat(kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
  }

  if (i > 3) {
    end = "\n".concat(blue, "...").concat(white).concat(end);
    skipped = true;
  }

  if (other !== '') {
    end = "\n  ".concat(other).concat(end);
    other = '';
  }

  var printedLines = 0;
  var msg = kReadableOperator[operator] + "\n".concat(green, "+ actual").concat(white, " ").concat(red, "- expected").concat(white);
  var skippedMsg = " ".concat(blue, "...").concat(white, " Lines skipped");

  for (i = 0; i < maxLines; i++) {
    // Only extra expected lines exist
    var cur = i - lastPos;

    if (actualLines.length < i + 1) {
      // If the last diverging line is more than one line above and the
      // current line is at least line three, add some of the former lines and
      // also add dots to indicate skipped entries.
      if (cur > 1 && i > 2) {
        if (cur > 4) {
          res += "\n".concat(blue, "...").concat(white);
          skipped = true;
        } else if (cur > 3) {
          res += "\n  ".concat(expectedLines[i - 2]);
          printedLines++;
        }

        res += "\n  ".concat(expectedLines[i - 1]);
        printedLines++;
      } // Mark the current line as the last diverging one.


      lastPos = i; // Add the expected line to the cache.

      other += "\n".concat(red, "-").concat(white, " ").concat(expectedLines[i]);
      printedLines++; // Only extra actual lines exist
    } else if (expectedLines.length < i + 1) {
      // If the last diverging line is more than one line above and the
      // current line is at least line three, add some of the former lines and
      // also add dots to indicate skipped entries.
      if (cur > 1 && i > 2) {
        if (cur > 4) {
          res += "\n".concat(blue, "...").concat(white);
          skipped = true;
        } else if (cur > 3) {
          res += "\n  ".concat(actualLines[i - 2]);
          printedLines++;
        }

        res += "\n  ".concat(actualLines[i - 1]);
        printedLines++;
      } // Mark the current line as the last diverging one.


      lastPos = i; // Add the actual line to the result.

      res += "\n".concat(green, "+").concat(white, " ").concat(actualLines[i]);
      printedLines++; // Lines diverge
    } else {
      var expectedLine = expectedLines[i];
      var actualLine = actualLines[i]; // If the lines diverge, specifically check for lines that only diverge by
      // a trailing comma. In that case it is actually identical and we should
      // mark it as such.

      var divergingLines = actualLine !== expectedLine && (!endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine); // If the expected line has a trailing comma but is otherwise identical,
      // add a comma at the end of the actual line. Otherwise the output could
      // look weird as in:
      //
      //   [
      //     1         // No comma at the end!
      // +   2
      //   ]
      //

      if (divergingLines && endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
        divergingLines = false;
        actualLine += ',';
      }

      if (divergingLines) {
        // If the last diverging line is more than one line above and the
        // current line is at least line three, add some of the former lines and
        // also add dots to indicate skipped entries.
        if (cur > 1 && i > 2) {
          if (cur > 4) {
            res += "\n".concat(blue, "...").concat(white);
            skipped = true;
          } else if (cur > 3) {
            res += "\n  ".concat(actualLines[i - 2]);
            printedLines++;
          }

          res += "\n  ".concat(actualLines[i - 1]);
          printedLines++;
        } // Mark the current line as the last diverging one.


        lastPos = i; // Add the actual line to the result and cache the expected diverging
        // line so consecutive diverging lines show up as +++--- and not +-+-+-.

        res += "\n".concat(green, "+").concat(white, " ").concat(actualLine);
        other += "\n".concat(red, "-").concat(white, " ").concat(expectedLine);
        printedLines += 2; // Lines are identical
      } else {
        // Add all cached information to the result before adding other things
        // and reset the cache.
        res += other;
        other = ''; // If the last diverging line is exactly one line above or if it is the
        // very first line, add the line to the result.

        if (cur === 1 || i === 0) {
          res += "\n  ".concat(actualLine);
          printedLines++;
        }
      }
    } // Inspected object to big (Show ~20 rows max)


    if (printedLines > 20 && i < maxLines - 2) {
      return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat(blue, "...").concat(white).concat(other, "\n") + "".concat(blue, "...").concat(white);
    }
  }

  return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}

var AssertionError =
/*#__PURE__*/
function (_Error) {
  _inherits(AssertionError, _Error);

  function AssertionError(options) {
    var _this;

    _classCallCheck(this, AssertionError);

    if (_typeof(options) !== 'object' || options === null) {
      throw new ERR_INVALID_ARG_TYPE('options', 'Object', options);
    }

    var message = options.message,
        operator = options.operator,
        stackStartFn = options.stackStartFn;
    var actual = options.actual,
        expected = options.expected;
    var limit = Error.stackTraceLimit;
    Error.stackTraceLimit = 0;

    if (message != null) {
      _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, String(message)));
    } else {
      if (process.stderr && process.stderr.isTTY) {
        // Reset on each call to make sure we handle dynamically set environment
        // variables correct.
        if (process.stderr && process.stderr.getColorDepth && process.stderr.getColorDepth() !== 1) {
          blue = "\x1B[34m";
          green = "\x1B[32m";
          white = "\x1B[39m";
          red = "\x1B[31m";
        } else {
          blue = '';
          green = '';
          white = '';
          red = '';
        }
      } // Prevent the error stack from being visible by duplicating the error
      // in a very close way to the original in case both sides are actually
      // instances of Error.


      if (_typeof(actual) === 'object' && actual !== null && _typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
        actual = copyError(actual);
        expected = copyError(expected);
      }

      if (operator === 'deepStrictEqual' || operator === 'strictEqual') {
        _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, createErrDiff(actual, expected, operator)));
      } else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
        // In case the objects are equal but the operator requires unequal, show
        // the first object and say A equals B
        var base = kReadableOperator[operator];
        var res = inspectValue(actual).split('\n'); // In case "actual" is an object, it should not be reference equal.

        if (operator === 'notStrictEqual' && _typeof(actual) === 'object' && actual !== null) {
          base = kReadableOperator.notStrictEqualObject;
        } // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.


        if (res.length > 30) {
          res[26] = "".concat(blue, "...").concat(white);

          while (res.length > 27) {
            res.pop();
          }
        } // Only print a single input.


        if (res.length === 1) {
          _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, "".concat(base, " ").concat(res[0])));
        } else {
          _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n")));
        }
      } else {
        var _res = inspectValue(actual);

        var other = '';
        var knownOperators = kReadableOperator[operator];

        if (operator === 'notDeepEqual' || operator === 'notEqual') {
          _res = "".concat(kReadableOperator[operator], "\n\n").concat(_res);

          if (_res.length > 1024) {
            _res = "".concat(_res.slice(0, 1021), "...");
          }
        } else {
          other = "".concat(inspectValue(expected));

          if (_res.length > 512) {
            _res = "".concat(_res.slice(0, 509), "...");
          }

          if (other.length > 512) {
            other = "".concat(other.slice(0, 509), "...");
          }

          if (operator === 'deepEqual' || operator === 'equal') {
            _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
          } else {
            other = " ".concat(operator, " ").concat(other);
          }
        }

        _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, "".concat(_res).concat(other)));
      }
    }

    Error.stackTraceLimit = limit;
    _this.generatedMessage = !message;
    Object.defineProperty(_assertThisInitialized(_this), 'name', {
      value: 'AssertionError [ERR_ASSERTION]',
      enumerable: false,
      writable: true,
      configurable: true
    });
    _this.code = 'ERR_ASSERTION';
    _this.actual = actual;
    _this.expected = expected;
    _this.operator = operator;

    if (Error.captureStackTrace) {
      // eslint-disable-next-line no-restricted-syntax
      Error.captureStackTrace(_assertThisInitialized(_this), stackStartFn);
    } // Create error message including the error code in the name.


    _this.stack; // Reset the name.

    _this.name = 'AssertionError';
    return _possibleConstructorReturn(_this);
  }

  _createClass(AssertionError, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
    }
  }, {
    key: inspect.custom,
    value: function value(recurseTimes, ctx) {
      // This limits the `actual` and `expected` property default inspection to
      // the minimum depth. Otherwise those values would be too verbose compared
      // to the actual error message which contains a combined view of these two
      // input values.
      return inspect(this, _objectSpread({}, ctx, {
        customInspect: false,
        depth: 0
      }));
    }
  }]);

  return AssertionError;
}(_wrapNativeSuper(Error));

module.exports = AssertionError;

/***/ }),

/***/ 51404:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f

/* eslint node-core/documented-errors: "error" */

/* eslint node-core/alphabetize-errors: "error" */

/* eslint node-core/prefer-util-format-errors: "error" */
 // The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var codes = {}; // Lazy loaded

var assert;
var util;

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inherits(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      var _this;

      _classCallCheck(this, NodeError);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(NodeError).call(this, getMessage(arg1, arg2, arg3)));
      _this.code = code;
      return _this;
    }

    return NodeError;
  }(Base);

  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  if (assert === undefined) assert = __webpack_require__(39619);
  assert(typeof name === 'string', "'name' must be a string"); // determiner: 'must be' or 'must not be'

  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } // TODO(BridgeAR): Improve the output by showing `null` and similar.


  msg += ". Received type ".concat(_typeof(actual));
  return msg;
}, TypeError);
createErrorType('ERR_INVALID_ARG_VALUE', function (name, value) {
  var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
  if (util === undefined) util = __webpack_require__(71323);
  var inspected = util.inspect(value);

  if (inspected.length > 128) {
    inspected = "".concat(inspected.slice(0, 128), "...");
  }

  return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
createErrorType('ERR_INVALID_RETURN_VALUE', function (input, name, value) {
  var type;

  if (value && value.constructor && value.constructor.name) {
    type = "instance of ".concat(value.constructor.name);
  } else {
    type = "type ".concat(_typeof(value));
  }

  return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);
createErrorType('ERR_MISSING_ARGS', function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (assert === undefined) assert = __webpack_require__(39619);
  assert(args.length > 0, 'At least one arg needs to be specified');
  var msg = 'The ';
  var len = args.length;
  args = args.map(function (a) {
    return "\"".concat(a, "\"");
  });

  switch (len) {
    case 1:
      msg += "".concat(args[0], " argument");
      break;

    case 2:
      msg += "".concat(args[0], " and ").concat(args[1], " arguments");
      break;

    default:
      msg += args.slice(0, len - 1).join(', ');
      msg += ", and ".concat(args[len - 1], " arguments");
      break;
  }

  return "".concat(msg, " must be specified");
}, TypeError);
module.exports.codes = codes;

/***/ }),

/***/ 40118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9


function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var regexFlagsSupported = /a/g.flags !== undefined;

var arrayFromSet = function arrayFromSet(set) {
  var array = [];
  set.forEach(function (value) {
    return array.push(value);
  });
  return array;
};

var arrayFromMap = function arrayFromMap(map) {
  var array = [];
  map.forEach(function (value, key) {
    return array.push([key, value]);
  });
  return array;
};

var objectIs = Object.is ? Object.is : __webpack_require__(83822);
var objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function () {
  return [];
};
var numberIsNaN = Number.isNaN ? Number.isNaN : __webpack_require__(74866);

function uncurryThis(f) {
  return f.call.bind(f);
}

var hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
var propertyIsEnumerable = uncurryThis(Object.prototype.propertyIsEnumerable);
var objectToString = uncurryThis(Object.prototype.toString);

var _require$types = (__webpack_require__(71323).types),
    isAnyArrayBuffer = _require$types.isAnyArrayBuffer,
    isArrayBufferView = _require$types.isArrayBufferView,
    isDate = _require$types.isDate,
    isMap = _require$types.isMap,
    isRegExp = _require$types.isRegExp,
    isSet = _require$types.isSet,
    isNativeError = _require$types.isNativeError,
    isBoxedPrimitive = _require$types.isBoxedPrimitive,
    isNumberObject = _require$types.isNumberObject,
    isStringObject = _require$types.isStringObject,
    isBooleanObject = _require$types.isBooleanObject,
    isBigIntObject = _require$types.isBigIntObject,
    isSymbolObject = _require$types.isSymbolObject,
    isFloat32Array = _require$types.isFloat32Array,
    isFloat64Array = _require$types.isFloat64Array;

function isNonIndex(key) {
  if (key.length === 0 || key.length > 10) return true;

  for (var i = 0; i < key.length; i++) {
    var code = key.charCodeAt(i);
    if (code < 48 || code > 57) return true;
  } // The maximum size for an array is 2 ** 32 -1.


  return key.length === 10 && key >= Math.pow(2, 32);
}

function getOwnNonIndexProperties(value) {
  return Object.keys(value).filter(isNonIndex).concat(objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
} // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */


function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }

  if (y < x) {
    return 1;
  }

  return 0;
}

var ONLY_ENUMERABLE = undefined;
var kStrict = true;
var kLoose = false;
var kNoIterator = 0;
var kIsArray = 1;
var kIsSet = 2;
var kIsMap = 3; // Check if they have the same source and flags

function areSimilarRegExps(a, b) {
  return regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}

function areSimilarFloatArrays(a, b) {
  if (a.byteLength !== b.byteLength) {
    return false;
  }

  for (var offset = 0; offset < a.byteLength; offset++) {
    if (a[offset] !== b[offset]) {
      return false;
    }
  }

  return true;
}

function areSimilarTypedArrays(a, b) {
  if (a.byteLength !== b.byteLength) {
    return false;
  }

  return compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}

function areEqualArrayBuffers(buf1, buf2) {
  return buf1.byteLength === buf2.byteLength && compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}

function isEqualBoxedPrimitive(val1, val2) {
  if (isNumberObject(val1)) {
    return isNumberObject(val2) && objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
  }

  if (isStringObject(val1)) {
    return isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
  }

  if (isBooleanObject(val1)) {
    return isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
  }

  if (isBigIntObject(val1)) {
    return isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
  }

  return isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
} // Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.


function innerDeepEqual(val1, val2, strict, memos) {
  // All identical values are equivalent, as determined by ===.
  if (val1 === val2) {
    if (val1 !== 0) return true;
    return strict ? objectIs(val1, val2) : true;
  } // Check more closely if val1 and val2 are equal.


  if (strict) {
    if (_typeof(val1) !== 'object') {
      return typeof val1 === 'number' && numberIsNaN(val1) && numberIsNaN(val2);
    }

    if (_typeof(val2) !== 'object' || val1 === null || val2 === null) {
      return false;
    }

    if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) {
      return false;
    }
  } else {
    if (val1 === null || _typeof(val1) !== 'object') {
      if (val2 === null || _typeof(val2) !== 'object') {
        // eslint-disable-next-line eqeqeq
        return val1 == val2;
      }

      return false;
    }

    if (val2 === null || _typeof(val2) !== 'object') {
      return false;
    }
  }

  var val1Tag = objectToString(val1);
  var val2Tag = objectToString(val2);

  if (val1Tag !== val2Tag) {
    return false;
  }

  if (Array.isArray(val1)) {
    // Check for sparse arrays and general fast path
    if (val1.length !== val2.length) {
      return false;
    }

    var keys1 = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
    var keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);

    if (keys1.length !== keys2.length) {
      return false;
    }

    return keyCheck(val1, val2, strict, memos, kIsArray, keys1);
  } // [browserify] This triggers on certain types in IE (Map/Set) so we don't
  // wan't to early return out of the rest of the checks. However we can check
  // if the second value is one of these values and the first isn't.


  if (val1Tag === '[object Object]') {
    // return keyCheck(val1, val2, strict, memos, kNoIterator);
    if (!isMap(val1) && isMap(val2) || !isSet(val1) && isSet(val2)) {
      return false;
    }
  }

  if (isDate(val1)) {
    if (!isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) {
      return false;
    }
  } else if (isRegExp(val1)) {
    if (!isRegExp(val2) || !areSimilarRegExps(val1, val2)) {
      return false;
    }
  } else if (isNativeError(val1) || val1 instanceof Error) {
    // Do not compare the stack as it might differ even though the error itself
    // is otherwise identical.
    if (val1.message !== val2.message || val1.name !== val2.name) {
      return false;
    }
  } else if (isArrayBufferView(val1)) {
    if (!strict && (isFloat32Array(val1) || isFloat64Array(val1))) {
      if (!areSimilarFloatArrays(val1, val2)) {
        return false;
      }
    } else if (!areSimilarTypedArrays(val1, val2)) {
      return false;
    } // Buffer.compare returns true, so val1.length === val2.length. If they both
    // only contain numeric keys, we don't need to exam further than checking
    // the symbols.


    var _keys = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);

    var _keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);

    if (_keys.length !== _keys2.length) {
      return false;
    }

    return keyCheck(val1, val2, strict, memos, kNoIterator, _keys);
  } else if (isSet(val1)) {
    if (!isSet(val2) || val1.size !== val2.size) {
      return false;
    }

    return keyCheck(val1, val2, strict, memos, kIsSet);
  } else if (isMap(val1)) {
    if (!isMap(val2) || val1.size !== val2.size) {
      return false;
    }

    return keyCheck(val1, val2, strict, memos, kIsMap);
  } else if (isAnyArrayBuffer(val1)) {
    if (!areEqualArrayBuffers(val1, val2)) {
      return false;
    }
  } else if (isBoxedPrimitive(val1) && !isEqualBoxedPrimitive(val1, val2)) {
    return false;
  }

  return keyCheck(val1, val2, strict, memos, kNoIterator);
}

function getEnumerables(val, keys) {
  return keys.filter(function (k) {
    return propertyIsEnumerable(val, k);
  });
}

function keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
  // For all remaining Object pairs, including Array, objects and Maps,
  // equivalence is determined by having:
  // a) The same number of owned enumerable properties
  // b) The same set of keys/indexes (although not necessarily the same order)
  // c) Equivalent values for every corresponding key/index
  // d) For Sets and Maps, equal contents
  // Note: this accounts for both named and indexed properties on Arrays.
  if (arguments.length === 5) {
    aKeys = Object.keys(val1);
    var bKeys = Object.keys(val2); // The pair must have the same number of owned properties.

    if (aKeys.length !== bKeys.length) {
      return false;
    }
  } // Cheap key test


  var i = 0;

  for (; i < aKeys.length; i++) {
    if (!hasOwnProperty(val2, aKeys[i])) {
      return false;
    }
  }

  if (strict && arguments.length === 5) {
    var symbolKeysA = objectGetOwnPropertySymbols(val1);

    if (symbolKeysA.length !== 0) {
      var count = 0;

      for (i = 0; i < symbolKeysA.length; i++) {
        var key = symbolKeysA[i];

        if (propertyIsEnumerable(val1, key)) {
          if (!propertyIsEnumerable(val2, key)) {
            return false;
          }

          aKeys.push(key);
          count++;
        } else if (propertyIsEnumerable(val2, key)) {
          return false;
        }
      }

      var symbolKeysB = objectGetOwnPropertySymbols(val2);

      if (symbolKeysA.length !== symbolKeysB.length && getEnumerables(val2, symbolKeysB).length !== count) {
        return false;
      }
    } else {
      var _symbolKeysB = objectGetOwnPropertySymbols(val2);

      if (_symbolKeysB.length !== 0 && getEnumerables(val2, _symbolKeysB).length !== 0) {
        return false;
      }
    }
  }

  if (aKeys.length === 0 && (iterationType === kNoIterator || iterationType === kIsArray && val1.length === 0 || val1.size === 0)) {
    return true;
  } // Use memos to handle cycles.


  if (memos === undefined) {
    memos = {
      val1: new Map(),
      val2: new Map(),
      position: 0
    };
  } else {
    // We prevent up to two map.has(x) calls by directly retrieving the value
    // and checking for undefined. The map can only contain numbers, so it is
    // safe to check for undefined only.
    var val2MemoA = memos.val1.get(val1);

    if (val2MemoA !== undefined) {
      var val2MemoB = memos.val2.get(val2);

      if (val2MemoB !== undefined) {
        return val2MemoA === val2MemoB;
      }
    }

    memos.position++;
  }

  memos.val1.set(val1, memos.position);
  memos.val2.set(val2, memos.position);
  var areEq = objEquiv(val1, val2, strict, aKeys, memos, iterationType);
  memos.val1.delete(val1);
  memos.val2.delete(val2);
  return areEq;
}

function setHasEqualElement(set, val1, strict, memo) {
  // Go looking.
  var setValues = arrayFromSet(set);

  for (var i = 0; i < setValues.length; i++) {
    var val2 = setValues[i];

    if (innerDeepEqual(val1, val2, strict, memo)) {
      // Remove the matching element to make sure we do not check that again.
      set.delete(val2);
      return true;
    }
  }

  return false;
} // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').


function findLooseMatchingPrimitives(prim) {
  switch (_typeof(prim)) {
    case 'undefined':
      return null;

    case 'object':
      // Only pass in null as object!
      return undefined;

    case 'symbol':
      return false;

    case 'string':
      prim = +prim;
    // Loose equal entries exist only if the string is possible to convert to
    // a regular number and not NaN.
    // Fall through

    case 'number':
      if (numberIsNaN(prim)) {
        return false;
      }

  }

  return true;
}

function setMightHaveLoosePrim(a, b, prim) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) return altValue;
  return b.has(altValue) && !a.has(altValue);
}

function mapMightHaveLoosePrim(a, b, prim, item, memo) {
  var altValue = findLooseMatchingPrimitives(prim);

  if (altValue != null) {
    return altValue;
  }

  var curB = b.get(altValue);

  if (curB === undefined && !b.has(altValue) || !innerDeepEqual(item, curB, false, memo)) {
    return false;
  }

  return !a.has(altValue) && innerDeepEqual(item, curB, false, memo);
}

function setEquiv(a, b, strict, memo) {
  // This is a lazily initiated Set of entries which have to be compared
  // pairwise.
  var set = null;
  var aValues = arrayFromSet(a);

  for (var i = 0; i < aValues.length; i++) {
    var val = aValues[i]; // Note: Checking for the objects first improves the performance for object
    // heavy sets but it is a minor slow down for primitives. As they are fast
    // to check this improves the worst case scenario instead.

    if (_typeof(val) === 'object' && val !== null) {
      if (set === null) {
        set = new Set();
      } // If the specified value doesn't exist in the second set its an not null
      // object (or non strict only: a not matching primitive) we'll need to go
      // hunting for something thats deep-(strict-)equal to it. To make this
      // O(n log n) complexity we have to copy these values in a new set first.


      set.add(val);
    } else if (!b.has(val)) {
      if (strict) return false; // Fast path to detect missing string, symbol, undefined and null values.

      if (!setMightHaveLoosePrim(a, b, val)) {
        return false;
      }

      if (set === null) {
        set = new Set();
      }

      set.add(val);
    }
  }

  if (set !== null) {
    var bValues = arrayFromSet(b);

    for (var _i = 0; _i < bValues.length; _i++) {
      var _val = bValues[_i]; // We have to check if a primitive value is already
      // matching and only if it's not, go hunting for it.

      if (_typeof(_val) === 'object' && _val !== null) {
        if (!setHasEqualElement(set, _val, strict, memo)) return false;
      } else if (!strict && !a.has(_val) && !setHasEqualElement(set, _val, strict, memo)) {
        return false;
      }
    }

    return set.size === 0;
  }

  return true;
}

function mapHasEqualEntry(set, map, key1, item1, strict, memo) {
  // To be able to handle cases like:
  //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
  // ... we need to consider *all* matching keys, not just the first we find.
  var setValues = arrayFromSet(set);

  for (var i = 0; i < setValues.length; i++) {
    var key2 = setValues[i];

    if (innerDeepEqual(key1, key2, strict, memo) && innerDeepEqual(item1, map.get(key2), strict, memo)) {
      set.delete(key2);
      return true;
    }
  }

  return false;
}

function mapEquiv(a, b, strict, memo) {
  var set = null;
  var aEntries = arrayFromMap(a);

  for (var i = 0; i < aEntries.length; i++) {
    var _aEntries$i = _slicedToArray(aEntries[i], 2),
        key = _aEntries$i[0],
        item1 = _aEntries$i[1];

    if (_typeof(key) === 'object' && key !== null) {
      if (set === null) {
        set = new Set();
      }

      set.add(key);
    } else {
      // By directly retrieving the value we prevent another b.has(key) check in
      // almost all possible cases.
      var item2 = b.get(key);

      if (item2 === undefined && !b.has(key) || !innerDeepEqual(item1, item2, strict, memo)) {
        if (strict) return false; // Fast path to detect missing string, symbol, undefined and null
        // keys.

        if (!mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;

        if (set === null) {
          set = new Set();
        }

        set.add(key);
      }
    }
  }

  if (set !== null) {
    var bEntries = arrayFromMap(b);

    for (var _i2 = 0; _i2 < bEntries.length; _i2++) {
      var _bEntries$_i = _slicedToArray(bEntries[_i2], 2),
          key = _bEntries$_i[0],
          item = _bEntries$_i[1];

      if (_typeof(key) === 'object' && key !== null) {
        if (!mapHasEqualEntry(set, a, key, item, strict, memo)) return false;
      } else if (!strict && (!a.has(key) || !innerDeepEqual(a.get(key), item, false, memo)) && !mapHasEqualEntry(set, a, key, item, false, memo)) {
        return false;
      }
    }

    return set.size === 0;
  }

  return true;
}

function objEquiv(a, b, strict, keys, memos, iterationType) {
  // Sets and maps don't have their entries accessible via normal object
  // properties.
  var i = 0;

  if (iterationType === kIsSet) {
    if (!setEquiv(a, b, strict, memos)) {
      return false;
    }
  } else if (iterationType === kIsMap) {
    if (!mapEquiv(a, b, strict, memos)) {
      return false;
    }
  } else if (iterationType === kIsArray) {
    for (; i < a.length; i++) {
      if (hasOwnProperty(a, i)) {
        if (!hasOwnProperty(b, i) || !innerDeepEqual(a[i], b[i], strict, memos)) {
          return false;
        }
      } else if (hasOwnProperty(b, i)) {
        return false;
      } else {
        // Array is sparse.
        var keysA = Object.keys(a);

        for (; i < keysA.length; i++) {
          var key = keysA[i];

          if (!hasOwnProperty(b, key) || !innerDeepEqual(a[key], b[key], strict, memos)) {
            return false;
          }
        }

        if (keysA.length !== Object.keys(b).length) {
          return false;
        }

        return true;
      }
    }
  } // The pair must have equivalent values for every corresponding key.
  // Possibly expensive deep test:


  for (i = 0; i < keys.length; i++) {
    var _key = keys[i];

    if (!innerDeepEqual(a[_key], b[_key], strict, memos)) {
      return false;
    }
  }

  return true;
}

function isDeepEqual(val1, val2) {
  return innerDeepEqual(val1, val2, kLoose);
}

function isDeepStrictEqual(val1, val2) {
  return innerDeepEqual(val1, val2, kStrict);
}

module.exports = {
  isDeepEqual: isDeepEqual,
  isDeepStrictEqual: isDeepStrictEqual
};

/***/ }),

/***/ 14206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8057);

/***/ }),

/***/ 14387:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67485);
var settle = __webpack_require__(94570);
var cookies = __webpack_require__(12940);
var buildURL = __webpack_require__(60581);
var buildFullPath = __webpack_require__(30574);
var parseHeaders = __webpack_require__(53845);
var isURLSameOrigin = __webpack_require__(38338);
var createError = __webpack_require__(68524);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 8057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67485);
var bind = __webpack_require__(875);
var Axios = __webpack_require__(25029);
var mergeConfig = __webpack_require__(44941);
var defaults = __webpack_require__(73141);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(37132);
axios.CancelToken = __webpack_require__(34603);
axios.isCancel = __webpack_require__(21475);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(35739);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(35835);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 37132:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 34603:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(37132);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 21475:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 25029:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67485);
var buildURL = __webpack_require__(60581);
var InterceptorManager = __webpack_require__(68096);
var dispatchRequest = __webpack_require__(55009);
var mergeConfig = __webpack_require__(44941);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 68096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67485);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 30574:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(32642);
var combineURLs = __webpack_require__(72288);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 68524:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(69953);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 55009:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67485);
var transformData = __webpack_require__(9212);
var isCancel = __webpack_require__(21475);
var defaults = __webpack_require__(73141);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 69953:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ 44941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67485);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),

/***/ 94570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(68524);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 9212:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67485);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ 73141:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(27061);


var utils = __webpack_require__(67485);
var normalizeHeaderName = __webpack_require__(51446);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(14387);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(14387);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 875:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 60581:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67485);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 72288:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 12940:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67485);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 32642:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 35835:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ 38338:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67485);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 51446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67485);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 53845:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67485);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 35739:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 67485:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(875);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 24782:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 88590:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(24782)
var ieee754 = __webpack_require__(78898)
var isArray = __webpack_require__(21631)

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = __webpack_require__.g.TYPED_ARRAY_SUPPORT !== undefined
  ? __webpack_require__.g.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
__webpack_unused_export__ = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.h2
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}


/***/ }),

/***/ 21631:
/***/ (function(module) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 8558:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(88590)["lW"];

var ReadStream = __webpack_require__(29869)

module.exports = BlobSlicer

function BlobSlicer (blob) {
  if (!(this instanceof BlobSlicer)) return new BlobSlicer(blob)

  if (!(
    blob instanceof Blob ||
    ['[object Blob]', '[object File]'].indexOf(Object.prototype.toString.call(blob)) !== -1
  )) throw new TypeError('"blob" argument must be an instance of Blob or File')

  this._blob = blob
}

BlobSlicer.prototype.read = function (start, end, cb) {
  if (typeof start === 'function') cb = start
  else if (typeof end === 'function') {
    cb = end
    end = this._blob.size
  }
  if (typeof cb !== 'function') throw new TypeError('"callback" argument must be a function')

  start = ~~start
  end = end === undefined ? this._blob.size : ~~end

  var reader = new FileReader()
  reader.addEventListener('loadend', function onLoadend () {
    this.removeEventListener('loadend', onLoadend)
    cb(this.error, this.result ? Buffer.from(this.result) : null)
  })
  reader.readAsArrayBuffer(this._blob.slice(start, end))
}

BlobSlicer.prototype.createReadStream = function (options) {
  return new ReadStream(this._blob, options)
}


/***/ }),

/***/ 29869:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(88590)["lW"];

var Readable = (__webpack_require__(18359).Readable)

module.exports = ReadStream

function ReadStream (blob, options) {
  if (!options) options = {}
  if (options.highWaterMark === undefined) options.highWaterMark = 64 * 1024
  Readable.call(this, options)

  var start = ~~options.start
  var end = options.end === undefined ? blob.size : ~~options.end

  this._blob = blob.slice(start, end)
  this._end = this._blob.size
  this._pos = 0
  this._reader = new FileReader()

  var self = this
  this._loadendListener = function () {
    if (this.error) {
      self.destroy(this.error)
      return
    }

    self._pos += this.result.byteLength
    self.push(Buffer.from(this.result))
  }
  this._reader.addEventListener('loadend', this._loadendListener)

  this.on('end', function () { this.destroy() })
}
ReadStream.prototype = Object.create(Readable.prototype)
ReadStream.prototype.constructor = ReadStream

Object.defineProperties(ReadStream.prototype, {
  readableLength: {
    get: function () { return this._readableState.length }
  },
  ended: {
    get: function () { return this._pos >= this._end }
  }
})

ReadStream.prototype._read = function (n) {
  if (this.destroyed) return

  if (this.ended) {
    this.push(null)
    return
  }

  this._reader.readAsArrayBuffer(this._blob.slice(this._pos, this._pos + n))
}

ReadStream.prototype._destroy = function (err, cb) {
  cb(err)
  if (this._reader.readyState === FileReader.LOADING) this._reader.abort()
  this._reader.removeEventListener('loadend', this._loadendListener)
  this._reader = null
}


/***/ }),

/***/ 47857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Buffer = (__webpack_require__(30816).Buffer);

var CRC_TABLE = [
  0x00000000, 0x77073096, 0xee0e612c, 0x990951ba, 0x076dc419,
  0x706af48f, 0xe963a535, 0x9e6495a3, 0x0edb8832, 0x79dcb8a4,
  0xe0d5e91e, 0x97d2d988, 0x09b64c2b, 0x7eb17cbd, 0xe7b82d07,
  0x90bf1d91, 0x1db71064, 0x6ab020f2, 0xf3b97148, 0x84be41de,
  0x1adad47d, 0x6ddde4eb, 0xf4d4b551, 0x83d385c7, 0x136c9856,
  0x646ba8c0, 0xfd62f97a, 0x8a65c9ec, 0x14015c4f, 0x63066cd9,
  0xfa0f3d63, 0x8d080df5, 0x3b6e20c8, 0x4c69105e, 0xd56041e4,
  0xa2677172, 0x3c03e4d1, 0x4b04d447, 0xd20d85fd, 0xa50ab56b,
  0x35b5a8fa, 0x42b2986c, 0xdbbbc9d6, 0xacbcf940, 0x32d86ce3,
  0x45df5c75, 0xdcd60dcf, 0xabd13d59, 0x26d930ac, 0x51de003a,
  0xc8d75180, 0xbfd06116, 0x21b4f4b5, 0x56b3c423, 0xcfba9599,
  0xb8bda50f, 0x2802b89e, 0x5f058808, 0xc60cd9b2, 0xb10be924,
  0x2f6f7c87, 0x58684c11, 0xc1611dab, 0xb6662d3d, 0x76dc4190,
  0x01db7106, 0x98d220bc, 0xefd5102a, 0x71b18589, 0x06b6b51f,
  0x9fbfe4a5, 0xe8b8d433, 0x7807c9a2, 0x0f00f934, 0x9609a88e,
  0xe10e9818, 0x7f6a0dbb, 0x086d3d2d, 0x91646c97, 0xe6635c01,
  0x6b6b51f4, 0x1c6c6162, 0x856530d8, 0xf262004e, 0x6c0695ed,
  0x1b01a57b, 0x8208f4c1, 0xf50fc457, 0x65b0d9c6, 0x12b7e950,
  0x8bbeb8ea, 0xfcb9887c, 0x62dd1ddf, 0x15da2d49, 0x8cd37cf3,
  0xfbd44c65, 0x4db26158, 0x3ab551ce, 0xa3bc0074, 0xd4bb30e2,
  0x4adfa541, 0x3dd895d7, 0xa4d1c46d, 0xd3d6f4fb, 0x4369e96a,
  0x346ed9fc, 0xad678846, 0xda60b8d0, 0x44042d73, 0x33031de5,
  0xaa0a4c5f, 0xdd0d7cc9, 0x5005713c, 0x270241aa, 0xbe0b1010,
  0xc90c2086, 0x5768b525, 0x206f85b3, 0xb966d409, 0xce61e49f,
  0x5edef90e, 0x29d9c998, 0xb0d09822, 0xc7d7a8b4, 0x59b33d17,
  0x2eb40d81, 0xb7bd5c3b, 0xc0ba6cad, 0xedb88320, 0x9abfb3b6,
  0x03b6e20c, 0x74b1d29a, 0xead54739, 0x9dd277af, 0x04db2615,
  0x73dc1683, 0xe3630b12, 0x94643b84, 0x0d6d6a3e, 0x7a6a5aa8,
  0xe40ecf0b, 0x9309ff9d, 0x0a00ae27, 0x7d079eb1, 0xf00f9344,
  0x8708a3d2, 0x1e01f268, 0x6906c2fe, 0xf762575d, 0x806567cb,
  0x196c3671, 0x6e6b06e7, 0xfed41b76, 0x89d32be0, 0x10da7a5a,
  0x67dd4acc, 0xf9b9df6f, 0x8ebeeff9, 0x17b7be43, 0x60b08ed5,
  0xd6d6a3e8, 0xa1d1937e, 0x38d8c2c4, 0x4fdff252, 0xd1bb67f1,
  0xa6bc5767, 0x3fb506dd, 0x48b2364b, 0xd80d2bda, 0xaf0a1b4c,
  0x36034af6, 0x41047a60, 0xdf60efc3, 0xa867df55, 0x316e8eef,
  0x4669be79, 0xcb61b38c, 0xbc66831a, 0x256fd2a0, 0x5268e236,
  0xcc0c7795, 0xbb0b4703, 0x220216b9, 0x5505262f, 0xc5ba3bbe,
  0xb2bd0b28, 0x2bb45a92, 0x5cb36a04, 0xc2d7ffa7, 0xb5d0cf31,
  0x2cd99e8b, 0x5bdeae1d, 0x9b64c2b0, 0xec63f226, 0x756aa39c,
  0x026d930a, 0x9c0906a9, 0xeb0e363f, 0x72076785, 0x05005713,
  0x95bf4a82, 0xe2b87a14, 0x7bb12bae, 0x0cb61b38, 0x92d28e9b,
  0xe5d5be0d, 0x7cdcefb7, 0x0bdbdf21, 0x86d3d2d4, 0xf1d4e242,
  0x68ddb3f8, 0x1fda836e, 0x81be16cd, 0xf6b9265b, 0x6fb077e1,
  0x18b74777, 0x88085ae6, 0xff0f6a70, 0x66063bca, 0x11010b5c,
  0x8f659eff, 0xf862ae69, 0x616bffd3, 0x166ccf45, 0xa00ae278,
  0xd70dd2ee, 0x4e048354, 0x3903b3c2, 0xa7672661, 0xd06016f7,
  0x4969474d, 0x3e6e77db, 0xaed16a4a, 0xd9d65adc, 0x40df0b66,
  0x37d83bf0, 0xa9bcae53, 0xdebb9ec5, 0x47b2cf7f, 0x30b5ffe9,
  0xbdbdf21c, 0xcabac28a, 0x53b39330, 0x24b4a3a6, 0xbad03605,
  0xcdd70693, 0x54de5729, 0x23d967bf, 0xb3667a2e, 0xc4614ab8,
  0x5d681b02, 0x2a6f2b94, 0xb40bbe37, 0xc30c8ea1, 0x5a05df1b,
  0x2d02ef8d
];

if (typeof Int32Array !== 'undefined') {
  CRC_TABLE = new Int32Array(CRC_TABLE);
}

function ensureBuffer(input) {
  if (Buffer.isBuffer(input)) {
    return input;
  }

  var hasNewBufferAPI =
      typeof Buffer.alloc === "function" &&
      typeof Buffer.from === "function";

  if (typeof input === "number") {
    return hasNewBufferAPI ? Buffer.alloc(input) : new Buffer(input);
  }
  else if (typeof input === "string") {
    return hasNewBufferAPI ? Buffer.from(input) : new Buffer(input);
  }
  else {
    throw new Error("input must be buffer, number, or string, received " +
                    typeof input);
  }
}

function bufferizeInt(num) {
  var tmp = ensureBuffer(4);
  tmp.writeInt32BE(num, 0);
  return tmp;
}

function _crc32(buf, previous) {
  buf = ensureBuffer(buf);
  if (Buffer.isBuffer(previous)) {
    previous = previous.readUInt32BE(0);
  }
  var crc = ~~previous ^ -1;
  for (var n = 0; n < buf.length; n++) {
    crc = CRC_TABLE[(crc ^ buf[n]) & 0xff] ^ (crc >>> 8);
  }
  return (crc ^ -1);
}

function crc32() {
  return bufferizeInt(_crc32.apply(null, arguments));
}
crc32.signed = function () {
  return _crc32.apply(null, arguments);
};
crc32.unsigned = function () {
  return _crc32.apply(null, arguments) >>> 0;
};

module.exports = crc32;


/***/ }),

/***/ 30816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__(24782)
const ieee754 = __webpack_require__(78898)
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

const K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ 12737:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(68750);

var callBind = __webpack_require__(34573);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 34573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(20132);
var GetIntrinsic = __webpack_require__(68750);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 70943:
/***/ (function(module) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),

/***/ 60042:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 34882:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
exports.q = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 29677:
/***/ (function(module) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),

/***/ 27693:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 87815:
/***/ (function(module) {

!function(r,e){ true?module.exports=e():0}(this,(function(){"use strict";return function(r,e,t){r=r||{};var n=e.prototype,o={future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"};function i(r,e,t,o){return n.fromToBase(r,e,t,o)}t.en.relativeTime=o,n.fromToBase=function(e,n,i,d,u){for(var f,a,s,l=i.$locale().relativeTime||o,h=r.thresholds||[{l:"s",r:44,d:"second"},{l:"m",r:89},{l:"mm",r:44,d:"minute"},{l:"h",r:89},{l:"hh",r:21,d:"hour"},{l:"d",r:35},{l:"dd",r:25,d:"day"},{l:"M",r:45},{l:"MM",r:10,d:"month"},{l:"y",r:17},{l:"yy",d:"year"}],m=h.length,c=0;c<m;c+=1){var y=h[c];y.d&&(f=d?t(e).diff(i,y.d,!0):i.diff(e,y.d,!0));var p=(r.rounding||Math.round)(Math.abs(f));if(s=f>0,p<=y.r||!y.r){p<=1&&c>0&&(y=h[c-1]);var v=l[y.l];u&&(p=u(""+p)),a="string"==typeof v?v.replace("%d",p):v(p,n,y.l,s);break}}if(n)return a;var M=s?l.future:l.past;return"function"==typeof M?M(a):M.replace("%s",a)},n.to=function(r,e){return i(r,e,this,!0)},n.from=function(r,e){return i(r,e,this)};var d=function(r){return r.$u?t.utc():t()};n.toNow=function(r){return this.to(d(this),r)},n.fromNow=function(r){return this.from(d(this),r)}}}));

/***/ }),

/***/ 22741:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var objectKeys = __webpack_require__(44733);
var isArguments = __webpack_require__(47740);
var is = __webpack_require__(83822);
var isRegex = __webpack_require__(82483);
var flags = __webpack_require__(62473);
var isArray = __webpack_require__(55182);
var isDate = __webpack_require__(17355);
var whichBoxedPrimitive = __webpack_require__(38574);
var GetIntrinsic = __webpack_require__(68750);
var callBound = __webpack_require__(12737);
var whichCollection = __webpack_require__(13062);
var getIterator = __webpack_require__(22395);
var getSideChannel = __webpack_require__(95337);
var whichTypedArray = __webpack_require__(52505);
var assign = __webpack_require__(86606);

var $getTime = callBound('Date.prototype.getTime');
var gPO = Object.getPrototypeOf;
var $objToString = callBound('Object.prototype.toString');

var $Set = GetIntrinsic('%Set%', true);
var $mapHas = callBound('Map.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSize = callBound('Map.prototype.size', true);
var $setAdd = callBound('Set.prototype.add', true);
var $setDelete = callBound('Set.prototype.delete', true);
var $setHas = callBound('Set.prototype.has', true);
var $setSize = callBound('Set.prototype.size', true);

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414
function setHasEqualElement(set, val1, opts, channel) {
  var i = getIterator(set);
  var result;
  while ((result = i.next()) && !result.done) {
    if (internalDeepEqual(val1, result.value, opts, channel)) { // eslint-disable-line no-use-before-define
      // Remove the matching element to make sure we do not check that again.
      $setDelete(set, result.value);
      return true;
    }
  }

  return false;
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439
function findLooseMatchingPrimitives(prim) {
  if (typeof prim === 'undefined') {
    return null;
  }
  if (typeof prim === 'object') { // Only pass in null as object!
    return void 0;
  }
  if (typeof prim === 'symbol') {
    return false;
  }
  if (typeof prim === 'string' || typeof prim === 'number') {
    // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
    return +prim === +prim; // eslint-disable-line no-implicit-coercion
  }
  return true;
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460
function mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }
  var curB = $mapGet(b, altValue);
  var looseOpts = assign({}, opts, { strict: false });
  if (
    (typeof curB === 'undefined' && !$mapHas(b, altValue))
    // eslint-disable-next-line no-use-before-define
    || !internalDeepEqual(item, curB, looseOpts, channel)
  ) {
    return false;
  }
  // eslint-disable-next-line no-use-before-define
  return !$mapHas(a, altValue) && internalDeepEqual(item, curB, looseOpts, channel);
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447
function setMightHaveLoosePrim(a, b, prim) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }

  return $setHas(b, altValue) && !$setHas(a, altValue);
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533
function mapHasEqualEntry(set, map, key1, item1, opts, channel) {
  var i = getIterator(set);
  var result;
  var key2;
  while ((result = i.next()) && !result.done) {
    key2 = result.value;
    if (
      // eslint-disable-next-line no-use-before-define
      internalDeepEqual(key1, key2, opts, channel)
      // eslint-disable-next-line no-use-before-define
      && internalDeepEqual(item1, $mapGet(map, key2), opts, channel)
    ) {
      $setDelete(set, key2);
      return true;
    }
  }

  return false;
}

function internalDeepEqual(actual, expected, options, channel) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  var actualBoxed = whichBoxedPrimitive(actual);
  var expectedBoxed = whichBoxedPrimitive(expected);
  if (actualBoxed !== expectedBoxed) {
    return false;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration

  var hasActual = channel.has(actual);
  var hasExpected = channel.has(expected);
  var sentinel;
  if (hasActual && hasExpected) {
    if (channel.get(actual) === channel.get(expected)) {
      return true;
    }
  } else {
    sentinel = {};
  }
  if (!hasActual) { channel.set(actual, sentinel); }
  if (!hasExpected) { channel.set(expected, sentinel); }

  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts, channel);
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }

  return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
}

function setEquiv(a, b, opts, channel) {
  if ($setSize(a) !== $setSize(b)) {
    return false;
  }
  var iA = getIterator(a);
  var iB = getIterator(b);
  var resultA;
  var resultB;
  var set;
  while ((resultA = iA.next()) && !resultA.done) {
    if (resultA.value && typeof resultA.value === 'object') {
      if (!set) { set = new $Set(); }
      $setAdd(set, resultA.value);
    } else if (!$setHas(b, resultA.value)) {
      if (opts.strict) { return false; }
      if (!setMightHaveLoosePrim(a, b, resultA.value)) {
        return false;
      }
      if (!set) { set = new $Set(); }
      $setAdd(set, resultA.value);
    }
  }
  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
      if (resultB.value && typeof resultB.value === 'object') {
        if (!setHasEqualElement(set, resultB.value, opts.strict, channel)) {
          return false;
        }
      } else if (
        !opts.strict
        && !$setHas(a, resultB.value)
        && !setHasEqualElement(set, resultB.value, opts.strict, channel)
      ) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}

function mapEquiv(a, b, opts, channel) {
  if ($mapSize(a) !== $mapSize(b)) {
    return false;
  }
  var iA = getIterator(a);
  var iB = getIterator(b);
  var resultA;
  var resultB;
  var set;
  var key;
  var item1;
  var item2;
  while ((resultA = iA.next()) && !resultA.done) {
    key = resultA.value[0];
    item1 = resultA.value[1];
    if (key && typeof key === 'object') {
      if (!set) { set = new $Set(); }
      $setAdd(set, key);
    } else {
      item2 = $mapGet(b, key);
      if ((typeof item2 === 'undefined' && !$mapHas(b, key)) || !internalDeepEqual(item1, item2, opts, channel)) {
        if (opts.strict) {
          return false;
        }
        if (!mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) {
          return false;
        }
        if (!set) { set = new $Set(); }
        $setAdd(set, key);
      }
    }
  }

  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      key = resultB.value[0];
      item2 = resultB.value[1];
      if (key && typeof key === 'object') {
        if (!mapHasEqualEntry(set, a, key, item2, opts, channel)) {
          return false;
        }
      } else if (
        !opts.strict
        && (!a.has(key) || !internalDeepEqual($mapGet(a, key), item2, opts, channel))
        && !mapHasEqualEntry(set, a, key, item2, assign({}, opts, { strict: false }), channel)
      ) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}

function objEquiv(a, b, opts, channel) {
  /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5] */
  var i, key;

  if (typeof a !== typeof b) { return false; }
  if (a == null || b == null) { return false; }

  if ($objToString(a) !== $objToString(b)) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsArray = isArray(a);
  var bIsArray = isArray(b);
  if (aIsArray !== bIsArray) { return false; }

  // TODO: replace when a cross-realm brand check is available
  var aIsError = a instanceof Error;
  var bIsError = b instanceof Error;
  if (aIsError !== bIsError) { return false; }
  if (aIsError || bIsError) {
    if (a.name !== b.name || a.message !== b.message) { return false; }
  }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if ((aIsRegex || bIsRegex) && (a.source !== b.source || flags(a) !== flags(b))) {
    return false;
  }

  var aIsDate = isDate(a);
  var bIsDate = isDate(b);
  if (aIsDate !== bIsDate) { return false; }
  if (aIsDate || bIsDate) { // && would work too, because both are true or both false here
    if ($getTime(a) !== $getTime(b)) { return false; }
  }
  if (opts.strict && gPO && gPO(a) !== gPO(b)) { return false; }

  if (whichTypedArray(a) !== whichTypedArray(b)) {
    return false;
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  var ka = objectKeys(a);
  var kb = objectKeys(b);
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; } // eslint-disable-line eqeqeq
  }

  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!internalDeepEqual(a[key], b[key], opts, channel)) { return false; }
  }

  var aCollection = whichCollection(a);
  var bCollection = whichCollection(b);
  if (aCollection !== bCollection) {
    return false;
  }
  if (aCollection === 'Set' || bCollection === 'Set') { // aCollection === bCollection
    return setEquiv(a, b, opts, channel);
  }
  if (aCollection === 'Map') { // aCollection === bCollection
    return mapEquiv(a, b, opts, channel);
  }

  return true;
}

module.exports = function deepEqual(a, b, opts) {
  return internalDeepEqual(a, b, opts, getSideChannel());
};


/***/ }),

/***/ 67392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(44733);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = __webpack_require__(21365)();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;

var defineProperty = function (object, name, value, predicate) {
	if (name in object) {
		if (predicate === true) {
			if (object[name] === value) {
				return;
			}
		} else if (!isFunction(predicate) || !predicate()) {
			return;
		}
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),

/***/ 18575:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var prefix = __webpack_require__(82780)
var toCamelCase = __webpack_require__(87602)
var cache = { 'float': 'cssFloat' }
var addPxToStyle = __webpack_require__(21498)

function style (element, property, value) {
  var camel = cache[property]
  if (typeof camel === 'undefined') {
    camel = detect(property)
  }

  // may be false if CSS prop is unsupported
  if (camel) {
    if (value === undefined) {
      return element.style[camel]
    }

    element.style[camel] = addPxToStyle(camel, value)
  }
}

function each (element, properties) {
  for (var k in properties) {
    if (properties.hasOwnProperty(k)) {
      style(element, k, properties[k])
    }
  }
}

function detect (cssProp) {
  var camel = toCamelCase(cssProp)
  var result = prefix(camel)
  cache[camel] = cache[cssProp] = cache[result] = result
  return result
}

function set () {
  if (arguments.length === 2) {
    if (typeof arguments[1] === 'string') {
      arguments[0].style.cssText = arguments[1]
    } else {
      each(arguments[0], arguments[1])
    }
  } else {
    style(arguments[0], arguments[1], arguments[2])
  }
}

module.exports = set
module.exports.set = set

module.exports.get = function (element, properties) {
  if (Array.isArray(properties)) {
    return properties.reduce(function (obj, prop) {
      obj[prop] = style(element, prop || '')
      return obj
    }, {})
  } else {
    return style(element, properties || '')
  }
}


/***/ }),

/***/ 42098:
/***/ (function(module) {

"use strict";
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */



function assign(target, firstSource) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }

  var to = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }
  return to;
}

function polyfill() {
  if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: assign
    });
  }
}

module.exports = {
  assign: assign,
  polyfill: polyfill
};


/***/ }),

/***/ 50343:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ 55278:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(72922);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;


/***/ }),

/***/ 68458:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 20132:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(68458);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 80222:
/***/ (function(module) {

"use strict";


var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) {
	try {
		gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	if (!functionsHaveNames() || !gOPD) {
		return false;
	}
	var desc = gOPD(function () {}, 'name');
	return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

module.exports = functionsHaveNames;


/***/ }),

/***/ 68750:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(40679)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

try {
	null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
	// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
	var errorProto = getProto(getProto(e));
	INTRINSICS['%Error.prototype%'] = errorProto;
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(20132);
var hasOwn = __webpack_require__(77492);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 77502:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(68750);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 32608:
/***/ (function(module) {

"use strict";


var $BigInt = typeof BigInt !== 'undefined' && BigInt;

module.exports = function hasNativeBigInts() {
	return typeof $BigInt === 'function'
		&& typeof BigInt === 'function'
		&& typeof $BigInt(42) === 'bigint' // eslint-disable-line no-magic-numbers
		&& typeof BigInt(42) === 'bigint'; // eslint-disable-line no-magic-numbers
};


/***/ }),

/***/ 21365:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(68750);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),

/***/ 40679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(8186);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 8186:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 10698:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(8186);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),

/***/ 77492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(20132);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 55839:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(12097);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 14173:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 12097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(14173);
} else {}


/***/ }),

/***/ 78898:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 70087:
/***/ (function(module) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ 22524:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(68750);
var has = __webpack_require__(77492);
var channel = __webpack_require__(95337)();

var $TypeError = GetIntrinsic('%TypeError%');

var SLOT = {
	assert: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		channel.assert(O);
		if (!SLOT.has(O, slot)) {
			throw new $TypeError('`' + slot + '` is not present on `O`');
		}
	},
	get: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		return slots && slots['$' + slot];
	},
	has: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		return !!slots && has(slots, '$' + slot);
	},
	set: function (O, slot, V) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		if (!slots) {
			slots = {};
			channel.set(O, slots);
		}
		slots['$' + slot] = V;
	}
};

if (Object.freeze) {
	Object.freeze(SLOT);
}

module.exports = SLOT;


/***/ }),

/***/ 47740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(10698)();
var callBound = __webpack_require__(12737);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),

/***/ 17810:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasBigInts = __webpack_require__(32608)();

if (hasBigInts) {
	var bigIntValueOf = BigInt.prototype.valueOf;
	var tryBigInt = function tryBigIntObject(value) {
		try {
			bigIntValueOf.call(value);
			return true;
		} catch (e) {
		}
		return false;
	};

	module.exports = function isBigInt(value) {
		if (
			value === null
			|| typeof value === 'undefined'
			|| typeof value === 'boolean'
			|| typeof value === 'string'
			|| typeof value === 'number'
			|| typeof value === 'symbol'
			|| typeof value === 'function'
		) {
			return false;
		}
		if (typeof value === 'bigint') {
			return true;
		}

		return tryBigInt(value);
	};
} else {
	module.exports = function isBigInt(value) {
		return  false && 0;
	};
}


/***/ }),

/***/ 80240:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(12737);
var $boolToStr = callBound('Boolean.prototype.toString');
var $toString = callBound('Object.prototype.toString');

var tryBooleanObject = function booleanBrandCheck(value) {
	try {
		$boolToStr(value);
		return true;
	} catch (e) {
		return false;
	}
};
var boolClass = '[object Boolean]';
var hasToStringTag = __webpack_require__(10698)();

module.exports = function isBoolean(value) {
	if (typeof value === 'boolean') {
		return true;
	}
	if (value === null || typeof value !== 'object') {
		return false;
	}
	return hasToStringTag && Symbol.toStringTag in value ? tryBooleanObject(value) : $toString(value) === boolClass;
};


/***/ }),

/***/ 48809:
/***/ (function(module) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ 72922:
/***/ (function(module) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() { return false; };
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr.call(all) === toStr.call(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr.call(value);
					return (
						str === ddaClass
						|| str === ddaClass2
						|| str === ddaClass3 // opera 12.16
						|| str === objectClass // IE 6-8
					) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

module.exports = reflectApply
	? function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value) && tryFunctionObject(value);
	}
	: function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
		return tryFunctionObject(value);
	};


/***/ }),

/***/ 17355:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(10698)();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),

/***/ 18265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var fnToStr = Function.prototype.toString;
var isFnRegex = /^\s*(?:function)?\*/;
var hasToStringTag = __webpack_require__(10698)();
var getProto = Object.getPrototypeOf;
var getGeneratorFunc = function () { // eslint-disable-line consistent-return
	if (!hasToStringTag) {
		return false;
	}
	try {
		return Function('return function*() {}')();
	} catch (e) {
	}
};
var GeneratorFunction;

module.exports = function isGeneratorFunction(fn) {
	if (typeof fn !== 'function') {
		return false;
	}
	if (isFnRegex.test(fnToStr.call(fn))) {
		return true;
	}
	if (!hasToStringTag) {
		var str = toStr.call(fn);
		return str === '[object GeneratorFunction]';
	}
	if (!getProto) {
		return false;
	}
	if (typeof GeneratorFunction === 'undefined') {
		var generatorFunc = getGeneratorFunc();
		GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
	}
	return getProto(fn) === GeneratorFunction;
};


/***/ }),

/***/ 6966:
/***/ (function(module) {

"use strict";


var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;

var exported;

if (!$Map) {
	// eslint-disable-next-line no-unused-vars
	exported = function isMap(x) {
		// `Map` is not present in this environment.
		return false;
	};
}

var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$mapHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isMap(x) {
		// `Map` does not have a `has` method
		return false;
	};
}

module.exports = exported || function isMap(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$mapHas.call(x);
		if ($setHas) {
			try {
				$setHas.call(x);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $Map; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};


/***/ }),

/***/ 44127:
/***/ (function(module) {

"use strict";


/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

module.exports = function isNaN(value) {
	return value !== value;
};


/***/ }),

/***/ 74866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(34573);
var define = __webpack_require__(67392);

var implementation = __webpack_require__(44127);
var getPolyfill = __webpack_require__(40850);
var shim = __webpack_require__(88045);

var polyfill = callBind(getPolyfill(), Number);

/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),

/***/ 40850:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(44127);

module.exports = function getPolyfill() {
	if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) {
		return Number.isNaN;
	}
	return implementation;
};


/***/ }),

/***/ 88045:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(67392);
var getPolyfill = __webpack_require__(40850);

/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

module.exports = function shimNumberIsNaN() {
	var polyfill = getPolyfill();
	define(Number, { isNaN: polyfill }, {
		isNaN: function testIsNaN() {
			return Number.isNaN !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),

/***/ 37691:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var numToStr = Number.prototype.toString;
var tryNumberObject = function tryNumberObject(value) {
	try {
		numToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var numClass = '[object Number]';
var hasToStringTag = __webpack_require__(10698)();

module.exports = function isNumberObject(value) {
	if (typeof value === 'number') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag ? tryNumberObject(value) : toStr.call(value) === numClass;
};


/***/ }),

/***/ 82483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(12737);
var hasToStringTag = __webpack_require__(10698)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),

/***/ 4255:
/***/ (function(module) {

"use strict";


var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;

var exported;

if (!$Set) {
	// eslint-disable-next-line no-unused-vars
	exported = function isSet(x) {
		// `Set` is not present in this environment.
		return false;
	};
}

var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$setHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isSet(x) {
		// `Set` does not have a `has` method
		return false;
	};
}

module.exports = exported || function isSet(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$setHas.call(x);
		if ($mapHas) {
			try {
				$mapHas.call(x);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $Set; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};


/***/ }),

/***/ 38559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject(value) {
	try {
		strValue.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var strClass = '[object String]';
var hasToStringTag = __webpack_require__(10698)();

module.exports = function isString(value) {
	if (typeof value === 'string') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
};


/***/ }),

/***/ 83448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = __webpack_require__(40679)();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return  false && 0;
	};
}


/***/ }),

/***/ 50387:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var forEach = __webpack_require__(55278);
var availableTypedArrays = __webpack_require__(40973);
var callBound = __webpack_require__(12737);

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__(10698)();
var gOPD = __webpack_require__(77502);

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};
var $slice = callBound('String.prototype.slice');
var toStrTags = {};
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr) {
			var proto = getPrototypeOf(arr);
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor) {
				var superProto = getPrototypeOf(proto);
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			toStrTags[typedArray] = descriptor.get;
		}
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var anyTrue = false;
	forEach(toStrTags, function (getter, typedArray) {
		if (!anyTrue) {
			try {
				anyTrue = getter.call(value) === typedArray;
			} catch (e) { /**/ }
		}
	});
	return anyTrue;
};

module.exports = function isTypedArray(value) {
	if (!value || typeof value !== 'object') { return false; }
	if (!hasToStringTag || !(Symbol.toStringTag in value)) {
		var tag = $slice($toString(value), 8, -1);
		return $indexOf(typedArrays, tag) > -1;
	}
	if (!gOPD) { return false; }
	return tryTypedArrays(value);
};


/***/ }),

/***/ 80349:
/***/ (function(module) {

"use strict";


var $WeakMap = typeof WeakMap === 'function' && WeakMap.prototype ? WeakMap : null;
var $WeakSet = typeof WeakSet === 'function' && WeakSet.prototype ? WeakSet : null;

var exported;

if (!$WeakMap) {
	// eslint-disable-next-line no-unused-vars
	exported = function isWeakMap(x) {
		// `WeakMap` is not present in this environment.
		return false;
	};
}

var $mapHas = $WeakMap ? $WeakMap.prototype.has : null;
var $setHas = $WeakSet ? $WeakSet.prototype.has : null;
if (!exported && !$mapHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isWeakMap(x) {
		// `WeakMap` does not have a `has` method
		return false;
	};
}

module.exports = exported || function isWeakMap(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$mapHas.call(x, $mapHas);
		if ($setHas) {
			try {
				$setHas.call(x, $setHas);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $WeakMap; // core-js workaround, pre-v3
	} catch (e) {}
	return false;
};


/***/ }),

/***/ 7812:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(68750);
var callBound = __webpack_require__(12737);

var $WeakSet = GetIntrinsic('%WeakSet%', true);

var $setHas = callBound('WeakSet.prototype.has', true);

if ($setHas) {
	var $mapHas = callBound('WeakMap.prototype.has', true);

	module.exports = function isWeakSet(x) {
		if (!x || typeof x !== 'object') {
			return false;
		}
		try {
			$setHas(x, $setHas);
			if ($mapHas) {
				try {
					$mapHas(x, $mapHas);
				} catch (e) {
					return true;
				}
			}
			return x instanceof $WeakSet; // core-js workaround, pre-v3
		} catch (e) {}
		return false;
	};
} else {
	// eslint-disable-next-line no-unused-vars
	module.exports = function isWeakSet(x) {
		// `WeakSet` does not exist, or does not have a `has` method
		return false;
	};
}


/***/ }),

/***/ 55182:
/***/ (function(module) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 67921:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 96539:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(77400);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 99736:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(96539),
    getRawTag = __webpack_require__(34840),
    objectToString = __webpack_require__(21258);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 74833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(56127);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 39120:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 34840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(96539);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 21258:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 77400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(39120);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 56127:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 66726:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(11611),
    now = __webpack_require__(82846),
    toNumber = __webpack_require__(91936);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 11611:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 92360:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 55193:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(99736),
    isObjectLike = __webpack_require__(92360);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 82846:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(77400);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 19783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(66726),
    isObject = __webpack_require__(11611);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 91936:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(74833),
    isObject = __webpack_require__(11611),
    isSymbol = __webpack_require__(55193);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 61586:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__(29677),
      utf8 = (__webpack_require__(70943).utf8),
      isBuffer = __webpack_require__(48809),
      bin = (__webpack_require__(70943).bin),

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ }),

/***/ 60098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jc": function() { return /* reexport */ appWithTranslation; },
  "$G": function() { return /* reexport */ useTranslation; }
});

// UNUSED EXPORTS: I18nContext, Trans, Translation, i18n, withTranslation

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(8136);
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(64649);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(22951);
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(91976);
;// CONCATENATED MODULE: ../node_modules/next-i18next/node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape_unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
;// CONCATENATED MODULE: ../node_modules/next-i18next/node_modules/react-i18next/dist/es/context.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
var i18nInstance;
var I18nContext = (0,react.createContext)();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    (0,classCallCheck/* default */.Z)(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  (0,createClass/* default */.Z)(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ../node_modules/next-i18next/node_modules/react-i18next/dist/es/utils.js
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ../node_modules/next-i18next/node_modules/react-i18next/dist/es/useTranslation.js



function useTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useTranslation_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = useTranslation_objectSpread(useTranslation_objectSpread(useTranslation_objectSpread({}, getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(25773);
// EXTERNAL MODULE: ../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(55839);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../node_modules/next-i18next/node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = (0,react.useMemo)(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return (0,react.createElement)(I18nContext.Provider, {
    value: value
  }, children);
}
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(1793);
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(64013);
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function toConsumableArray_toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(33940);
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(30808);
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = (0,objectWithoutPropertiesLoose/* default */.Z)(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/config/defaultConfig.js
var DEFAULT_LOCALE = 'en';
var LOCALES = ['en'];
var DEFAULT_NAMESPACE = 'common';
var LOCALE_PATH = './public/locales';
var LOCALE_STRUCTURE = '{{lng}}/{{ns}}';
var LOCALE_EXTENSION = 'json';
var defaultConfig = {
  defaultNS: DEFAULT_NAMESPACE,
  errorStackTraceLimit: 0,
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: LOCALES
  },

  get initImmediate() {
    return  true && typeof window !== 'undefined';
  },

  interpolation: {
    escapeValue: false
  },
  load: 'currentOnly',
  localeExtension: LOCALE_EXTENSION,
  localePath: LOCALE_PATH,
  localeStructure: LOCALE_STRUCTURE,
  react: {
    useSuspense: false
  },
  reloadOnPrerender: false,
  serializeConfig: true,
  use: []
};
;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/utils.js


var getFallbackForLng = function getFallbackForLng(lng, fallbackLng) {
  if (typeof fallbackLng === 'string') {
    return [fallbackLng];
  }

  if (Array.isArray(fallbackLng)) {
    return fallbackLng;
  }

  if (_typeof(fallbackLng) === 'object') {
    var fallbackList = fallbackLng[lng];
    var fallbackDefault = fallbackLng["default"];
    return [].concat(_toConsumableArray(fallbackList !== null && fallbackList !== void 0 ? fallbackList : []), _toConsumableArray(fallbackDefault !== null && fallbackDefault !== void 0 ? fallbackDefault : []));
  }

  if (typeof fallbackLng === 'function') {
    return getFallbackForLng(lng, fallbackLng(lng));
  }

  return [];
};
var unique = function unique(list) {
  return Array.from(new Set(list));
};
;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/config/createConfig.js





var _excluded = ["i18n"],
    _excluded2 = ["i18n"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function createConfig_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function createConfig_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? createConfig_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createConfig_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var deepMergeObjects = ['backend', 'detection'];
var createConfig = function createConfig(userConfig) {
  var _userConfig$use;

  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.lng) !== 'string') {
    throw new Error('config.lng was not passed into createConfig');
  } //
  // Initial merge of default and user-provided config
  //


  var userI18n = userConfig.i18n,
      userConfigStripped = _objectWithoutProperties(userConfig, _excluded);

  var defaultI18n = defaultConfig.i18n,
      defaultConfigStripped = _objectWithoutProperties(defaultConfig, _excluded2);

  var combinedConfig = createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread({}, defaultConfigStripped), userConfigStripped), defaultI18n), userI18n);

  var defaultNS = combinedConfig.defaultNS,
      lng = combinedConfig.lng,
      localeExtension = combinedConfig.localeExtension,
      localePath = combinedConfig.localePath,
      localeStructure = combinedConfig.localeStructure,
      nonExplicitSupportedLngs = combinedConfig.nonExplicitSupportedLngs;
  var locales = combinedConfig.locales.filter(function (l) {
    return l !== 'default';
  });
  /**
   * Skips translation file resolution while in cimode
   * https://github.com/i18next/next-i18next/pull/851#discussion_r503113620
  */

  if (lng === 'cimode') {
    return combinedConfig;
  }

  if (typeof combinedConfig.fallbackLng === 'undefined') {
    combinedConfig.fallbackLng = combinedConfig.defaultLocale;

    if (combinedConfig.fallbackLng === 'default') {
      var _locales = (0,slicedToArray/* default */.Z)(locales, 1);

      combinedConfig.fallbackLng = _locales[0];
    }
  }

  var fallbackLng = combinedConfig.fallbackLng;

  if (nonExplicitSupportedLngs) {
    var createFallbackObject = function createFallbackObject(acc, l) {
      var _l$split = l.split('-'),
          _l$split2 = (0,slicedToArray/* default */.Z)(_l$split, 1),
          locale = _l$split2[0];

      acc[l] = [locale];
      return acc;
    };

    if (typeof fallbackLng === 'string') {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": [fallbackLng]
      });
    } else if (Array.isArray(fallbackLng)) {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": fallbackLng
      });
    } else if ((0,esm_typeof/* default */.Z)(fallbackLng) === 'object') {
      combinedConfig.fallbackLng = Object.entries(combinedConfig.fallbackLng).reduce(function (acc, _ref) {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
            l = _ref2[0],
            f = _ref2[1];

        acc[l] = l.includes('-') ? unique([l.split('-')[0]].concat(toConsumableArray_toConsumableArray(f))) : f;
        return acc;
      }, fallbackLng);
    } else if (typeof fallbackLng === 'function') {
      throw new Error('If nonExplicitSupportedLngs is true, no functions are allowed for fallbackLng');
    }
  }

  var hasCustomBackend = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$use = userConfig.use) === null || _userConfig$use === void 0 ? void 0 : _userConfig$use.some(function (b) {
    return b.type === 'backend';
  });

  if (false) { var getNamespaces, _defaultFallbackNSExists, _fallback, _defaultNSExists, _defaultNSPath, defaultFallbackNSExists, fallback, defaultNSExists, defaultNSPath, defaultFile, defaultLocaleStructure, suffix, prefix, _userConfig$interpola, _userConfig$interpola2, _userConfig$interpola3, _userConfig$interpola4, path, fs; } else {
    //
    // Set client side backend, if there is no custom backend
    //
    if (!hasCustomBackend) {
      if (typeof localePath === 'string') {
        combinedConfig.backend = {
          addPath: "".concat(localePath, "/").concat(localeStructure, ".missing.").concat(localeExtension),
          loadPath: "".concat(localePath, "/").concat(localeStructure, ".").concat(localeExtension)
        };
      } else if (typeof localePath === 'function') {
        combinedConfig.backend = {
          addPath: function addPath(locale, namespace) {
            return localePath(locale, namespace, true);
          },
          loadPath: function loadPath(locale, namespace) {
            return localePath(locale, namespace, false);
          }
        };
      }
    }

    if (typeof combinedConfig.ns !== 'string' && !Array.isArray(combinedConfig.ns)) {
      combinedConfig.ns = [defaultNS];
    }
  } //
  // Deep merge with overwrite - goes last
  //


  deepMergeObjects.forEach(function (obj) {
    if (userConfig[obj]) {
      combinedConfig[obj] = createConfig_objectSpread(createConfig_objectSpread({}, combinedConfig[obj]), userConfig[obj]);
    }
  });
  return combinedConfig;
};
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && ((0,esm_typeof/* default */.Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(66470);
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(53764);
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/toArray.js




function _toArray(arr) {
  return (0,arrayWithHoles/* default */.Z)(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || (0,nonIterableRest/* default */.Z)();
}
;// CONCATENATED MODULE: ../node_modules/next-i18next/node_modules/i18next/dist/esm/i18next.js










function i18next_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function i18next_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { i18next_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { i18next_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Logger);

    this.init(concreteLogger, options);
  }

  (0,createClass/* default */.Z)(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, i18next_objectSpread(i18next_objectSpread({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    (0,classCallCheck/* default */.Z)(this, EventEmitter);

    this.observers = {};
  }

  (0,createClass/* default */.Z)(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);

  if (!matched) {
    var ki = key.indexOf(keySeparator);

    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }

  return matched;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;

    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;
      if (mix === null) return null;

      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }

      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  var _super = _createSuper(ResourceStore);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    (0,classCallCheck/* default */.Z)(this, ResourceStore);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  (0,createClass/* default */.Z)(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1(_objectSpread$1({}, pack), resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1(_objectSpread$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  var _super = _createSuper$1(Translator);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Translator);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  (0,createClass/* default */.Z)(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };

      if (key === undefined || key === null) {
        return false;
      }

      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);

      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if ((0,esm_typeof/* default */.Z)(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;

          if (returnDetails) {
            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
            return resolved;
          }

          return "".concat(namespace).concat(nsSeparator).concat(key);
        }

        if (returnDetails) {
          resolved.res = key;
          return resolved;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");

          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }

          return r;
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;

            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);

        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }

      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
          interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();

        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");

              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);

                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }

              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);

                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);

                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    (0,classCallCheck/* default */.Z)(this, LanguageUtil);

    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  (0,createClass/* default */.Z)(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');

    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }

    this.rules = createRules();
  }

  (0,createClass/* default */.Z)(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }

      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }

      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (!rule) {
        return [];
      }

      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);

      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }

        return this.getSuffixRetroCompatible(rule, count);
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }

      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);

  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,classCallCheck/* default */.Z)(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  (0,createClass/* default */.Z)(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$3({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);

        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};

  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);

    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;

        var _opt$split = opt.split(':'),
            _opt$split2 = _toArray(_opt$split),
            key = _opt$split2[0],
            rest = _opt$split2.slice(1);

        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }

  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}

function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter = cache[key];

    if (!formatter) {
      formatter = fn(lng, options);
      cache[key] = formatter;
    }

    return formatter(val);
  };
}

var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,classCallCheck/* default */.Z)(this, Formatter);

    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, options);
        return function (val) {
          return formatter.format(val);
        };
      }),
      currency: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
          style: 'currency'
        }));
        return function (val) {
          return formatter.format(val);
        };
      }),
      datetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      }),
      relativetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val, options.range || 'day');
        };
      }),
      list: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.ListFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      })
    };
    this.init(options);
  }

  (0,createClass/* default */.Z)(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;

      var formats = _format.split(this.formatSeparator);

      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
            formatName = _parseFormatStr.formatName,
            formatOptions = _parseFormatStr.formatOptions;

        if (_this.formats[formatName]) {
          var formatted = mem;

          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }

          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }

        return mem;
      }, value);
      return result;
    }
  }]);

  return Formatter;
}();

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  var _super = _createSuper$2(Connector);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    (0,classCallCheck/* default */.Z)(this, Connector);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });

      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);

        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];

            if (loadedKeys.length) {
              loadedKeys.forEach(function (ns) {
                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});

      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }

      this.readingCalls++;
      return this.backend[fcName](lng, ns, function (err, data) {
        _this3.readingCalls--;

        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();

          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }

        if (err && data && tried < _this3.maxRetries) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if ((0,esm_typeof/* default */.Z)(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if ((0,esm_typeof/* default */.Z)(args[2]) === 'object' || (0,esm_typeof/* default */.Z)(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function noop() {}

function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  var _super = _createSuper$3(I18n);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    (0,classCallCheck/* default */.Z)(this, I18n);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions(_assertThisInitialized(_this));

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }

      var defOpts = get();
      this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));

      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
      }

      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }

      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var formatter;

        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });

        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }

        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;

      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;

        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;

        _this4.setResolvedLanguage(l);
      };

      var done = function done(err, l) {
        if (l) {
          setLngProps(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if ((0,esm_typeof/* default */.Z)(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
        isClone: true
      });

      var clone = new I18n(mergedOptions);

      if (options.debug !== undefined || options.prefix !== undefined) {
        clone.logger = clone.logger.clone(options);
      }

      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$6({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);

  return I18n;
}(EventEmitter);

(0,defineProperty/* default */.Z)(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});

var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

var createInstance = instance.createInstance;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var i18next_hasLoadedNamespace = instance.hasLoadedNamespace;
var i18next_loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

/* harmony default export */ var i18next = (instance);


;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/createClient/browser.js

/* harmony default export */ var browser = (function (config) {
  if (config.ns === undefined) config.ns = [];
  var instance = i18next.createInstance(config);
  var initPromise;

  if (!instance.isInitialized) {
    var _config$use;

    config === null || config === void 0 ? void 0 : (_config$use = config.use) === null || _config$use === void 0 ? void 0 : _config$use.forEach(function (x) {
      return instance.use(x);
    });

    if (typeof config.onPreInitI18next === 'function') {
      config.onPreInitI18next(instance);
    }

    initPromise = instance.init(config);
  } else {
    initPromise = Promise.resolve(i18next.t);
  }

  return {
    i18n: instance,
    initPromise: initPromise
  };
});
;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/appWithTranslation.js


var __jsx = react.createElement;

function appWithTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function appWithTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? appWithTranslation_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : appWithTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var globalI18n = null;
var appWithTranslation = function appWithTranslation(WrappedComponent) {
  var configOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var AppWithTranslation = function AppWithTranslation(props) {
    var _nextI18Next$initialL, _props$router;

    var _ref = props.pageProps,
        _nextI18Next = _ref._nextI18Next;
    var locale = (_nextI18Next$initialL = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.initialLocale) !== null && _nextI18Next$initialL !== void 0 ? _nextI18Next$initialL : props === null || props === void 0 ? void 0 : (_props$router = props.router) === null || _props$router === void 0 ? void 0 : _props$router.locale;
    var ns = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.ns; // Memoize the instance and only re-initialize when either:
    // 1. The route changes (non-shallowly)
    // 2. Router locale changes
    // 3. UserConfig override changes

    var i18n = (0,react.useMemo)(function () {
      var _userConfig, _userConfig2, _userConfig2$i18n;

      if (!_nextI18Next && !configOverride) return null;
      var userConfig = configOverride !== null && configOverride !== void 0 ? configOverride : _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.userConfig;

      if (!userConfig && configOverride === null) {
        throw new Error('appWithTranslation was called without a next-i18next config');
      }

      if (configOverride !== null) {
        userConfig = configOverride;
      }

      if (!((_userConfig = userConfig) !== null && _userConfig !== void 0 && _userConfig.i18n)) {
        throw new Error('appWithTranslation was called without config.i18n');
      }

      if (!((_userConfig2 = userConfig) !== null && _userConfig2 !== void 0 && (_userConfig2$i18n = _userConfig2.i18n) !== null && _userConfig2$i18n !== void 0 && _userConfig2$i18n.defaultLocale)) {
        throw new Error('config.i18n does not include a defaultLocale property');
      }

      var _ref2 = _nextI18Next || {},
          initialI18nStore = _ref2.initialI18nStore;

      var resources = configOverride !== null && configOverride !== void 0 && configOverride.resources ? configOverride.resources : initialI18nStore;
      if (!locale) locale = userConfig.i18n.defaultLocale;
      var instance = browser(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, createConfig(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, userConfig), {}, {
        lng: locale
      }))), {}, {
        lng: locale,
        ns: ns,
        resources: resources
      })).i18n;
      globalI18n = instance;
      return instance;
    }, [_nextI18Next, locale, configOverride, ns]);
    return i18n !== null ? __jsx(I18nextProvider, {
      i18n: i18n
    }, __jsx(WrappedComponent, props)) : __jsx(WrappedComponent, (0,esm_extends/* default */.Z)({
      key: locale
    }, props));
  };

  return hoist_non_react_statics_cjs_default()(AppWithTranslation, WrappedComponent);
};
;// CONCATENATED MODULE: ../node_modules/next-i18next/dist/esm/index.js



/***/ }),

/***/ 67084:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

var uiLanguages = __webpack_require__(72044);

var _require = __webpack_require__(10808),
    LANG_CODE_EN = _require.LANG_CODE_EN;

var packageJson = __webpack_require__(4147); // TODO: Add new langs


var nonUiLangs = ["ab", "ake", "alt", "as", "av", "ba", "btk", "cze", "bum", "car", "ce", "nya", "lu", "ch", "da", "prs", "eo", "cfm", "fo", "fj", "grt", "kl", "chn", "ha", "he", "hl", "hmr", "is", "ig", "il", "id", "ja", "kbd", "kk", "kh", "km", "nnb", "rw", "gil", "rn", "koo", "kpy", "ku", "ky", "lo", "lv", "lt", "loz", "lg", "luo", "lua", "mas", "mk", "mg", "ms", "mni", "mi", "mrh", "mfe", "lus", "mon", "cnr", "ne", "nb", "nyo", "om", "kj", "pam", "pag", "pa", "rar", "rue", "sm", "sat", "sh", "kar", "sn", "si", "sk", "som", "st", "sv", "tl", "ty", "zht", "tg", "te", "th", "tpi", "to", "tn", "tum", "tr", "tk", "ak", "ur", "uz", "ve", "vi", "cy", "xh", "yo", "zom", "zu"];
module.exports = {
  i18n: {
    defaultLocale: LANG_CODE_EN,
    fallbackLng: LANG_CODE_EN,
    locales: [].concat(_toConsumableArray(uiLanguages.map(function (l) {
      return l.id;
    })), nonUiLangs),
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json?v=" + packageJson.version
    }
  }
};

/***/ }),

/***/ 37462:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
  "ABC": 61697,
  "add-subscription": 61698,
  "adventist-beliefs": 61699,
  "adventist-library": 61700,
  "all-collections": 61701,
  "anchor": 61702,
  "arrow-diagonal": 61703,
  "arrow-right": 61704,
  "audio-books": 61705,
  "AZ": 61706,
  "backups": 61707,
  "bible": 61708,
  "bibliography": 61709,
  "bold-text": 61710,
  "book-circle": 61711,
  "book-close": 61712,
  "book-open": 61713,
  "book-stack": 61714,
  "bookmark-outline": 61715,
  "bookmark": 61716,
  "books": 61717,
  "bookshelf": 61718,
  "bracers": 61719,
  "burger-menu": 61720,
  "calendar": 61721,
  "cart": 61722,
  "chevron-double-left": 61723,
  "chevron-double-right": 61724,
  "chevron-down": 61725,
  "chevron-left": 61726,
  "chevron-right": 61727,
  "chevron-up-circle": 61728,
  "chevron-up": 61729,
  "childrens-stories": 61730,
  "christ-s-life-and-ministry": 61731,
  "christian-lifestyle": 61732,
  "church-history": 61733,
  "church-life-and-ministry": 61734,
  "clip": 61735,
  "close": 61736,
  "commentaries": 61737,
  "concordances": 61738,
  "conflict-of-the-ages-series": 61739,
  "contact-us": 61740,
  "content": 61741,
  "copy-link": 61742,
  "copy": 61743,
  "delete": 61744,
  "devotional-readings": 61745,
  "devotionals": 61746,
  "dictionaries": 61747,
  "dictionary": 61748,
  "donate": 61749,
  "dots-vertical": 61750,
  "download": 61751,
  "edit": 61752,
  "education": 61753,
  "egw-biography": 61754,
  "ellen-dark": 61755,
  "ellen-light": 61756,
  "email-circle": 61757,
  "epub-file": 61758,
  "epub": 61759,
  "evangelism-and-witnessing": 61760,
  "extend": 61761,
  "facebook-circle": 61762,
  "facebook": 61763,
  "faq": 61764,
  "file": 61765,
  "filter": 61766,
  "folder-add": 61767,
  "folder-close": 61768,
  "folder-copy-to": 61769,
  "folder-import": 61770,
  "folder-move-to": 61771,
  "folder-open": 61772,
  "folder-shared": 61773,
  "folder-up": 61774,
  "font": 61775,
  "fullscreen-exit": 61776,
  "fullscreen": 61777,
  "go-to-full-app": 61778,
  "go-to-reader": 61779,
  "google-translate": 61780,
  "grid-2": 61781,
  "grid": 61782,
  "health-and-wellness": 61783,
  "heart-outline": 61784,
  "helping-guides": 61785,
  "highlight": 61786,
  "history-of-redemption": 61787,
  "history": 61788,
  "home": 61789,
  "info-circle": 61790,
  "info": 61791,
  "information": 61792,
  "insta": 61793,
  "install": 61794,
  "italic-text": 61795,
  "L2h": 61796,
  "L2v": 61797,
  "L3h": 61798,
  "L3s12": 61799,
  "L3s12v": 61800,
  "L3s21": 61801,
  "L3s21v": 61802,
  "L3v": 61803,
  "L4h": 61804,
  "L4s112": 61805,
  "L4s112v": 61806,
  "L4s121": 61807,
  "L4s121v": 61808,
  "L4s211": 61809,
  "L4s211v": 61810,
  "L4s22": 61811,
  "L4v": 61812,
  "L5s122": 61813,
  "L5s122v": 61814,
  "L5s2111": 61815,
  "L5s2111v": 61816,
  "L5s212": 61817,
  "L5s212v": 61818,
  "L5s221": 61819,
  "L5s221v": 61820,
  "L6h": 61821,
  "L6v": 61822,
  "L7s1222": 61823,
  "L7s1222v": 61824,
  "L7s2122": 61825,
  "L7s2122v": 61826,
  "L7s2212": 61827,
  "L7s2212v": 61828,
  "L7s2221": 61829,
  "L7s2221v": 61830,
  "L8h": 61831,
  "L8v": 61832,
  "languages": 61833,
  "last-day-events": 61834,
  "layouts": 61835,
  "leadership": 61836,
  "left-arrow": 61837,
  "lessons-from-the-bible": 61838,
  "lessons": 61839,
  "letters-manuscripts": 61840,
  "list": 61841,
  "logo-review-and-herald": 61842,
  "logo": 61843,
  "manuscript": 61844,
  "menu": 61845,
  "microphone": 61846,
  "minus": 61847,
  "misc-collections": 61848,
  "misc-titles": 61849,
  "mobi-file": 61850,
  "modern-english": 61851,
  "move": 61852,
  "mp3-file": 61853,
  "my-library": 61854,
  "new-tab": 61855,
  "note": 61856,
  "old": 61857,
  "page-breaks": 61858,
  "page-numbers": 61859,
  "pamphlets": 61860,
  "paper-study-center": 61861,
  "parenting": 61862,
  "pause-circle": 61863,
  "pause": 61864,
  "pdf-file": 61865,
  "pdf": 61866,
  "periodicals": 61867,
  "pin": 61868,
  "pinterest": 61869,
  "planet-search": 61870,
  "planet": 61871,
  "play-circle": 61872,
  "play-header": 61873,
  "play": 61874,
  "playback-rate": 61875,
  "plus": 61876,
  "preview": 61877,
  "print-circle": 61878,
  "print": 61879,
  "profile": 61880,
  "publishing": 61881,
  "qr-code-header": 61882,
  "qr-code-mobile-menu": 61883,
  "qr-code": 61884,
  "question": 61885,
  "read": 61886,
  "reader-arrow": 61887,
  "reading-history": 61888,
  "recent-authors": 61889,
  "reference-works": 61890,
  "reference": 61891,
  "relationships-and-marriage": 61892,
  "research-documents": 61893,
  "restart": 61894,
  "result-size": 61895,
  "save": 61896,
  "sda-scripture-Index": 61897,
  "search-book": 61898,
  "search-clear": 61899,
  "search-corrections": 61900,
  "search-featured": 61901,
  "search-header": 61902,
  "search-history": 61903,
  "search-phrase": 61904,
  "search-relation": 61905,
  "search-shortcut": 61906,
  "search-suggestions": 61907,
  "search-text": 61908,
  "search": 61909,
  "settings": 61910,
  "share": 61911,
  "show-headers": 61912,
  "sign-in": 61913,
  "skip-back": 61914,
  "skip-forward": 61915,
  "sort-by-recent": 61916,
  "sort": 61917,
  "star": 61918,
  "stop": 61919,
  "study-center-cap": 61920,
  "study-center-plus": 61921,
  "study-center": 61922,
  "study-guides": 61923,
  "subscription-outline": 61924,
  "subscription": 61925,
  "sync-with-feature-search": 61926,
  "sync-with-player": 61927,
  "sync": 61928,
  "telegram-circle": 61929,
  "testimonies-for-the-church": 61930,
  "text-center": 61931,
  "text-decrease": 61932,
  "text-increase": 61933,
  "text-justify": 61934,
  "text-left": 61935,
  "text-right": 61936,
  "the-light-and-life-collection": 61937,
  "theme-select": 61938,
  "timer-disabled": 61939,
  "timer": 61940,
  "titles": 61941,
  "topical-index": 61942,
  "translation": 61943,
  "tree": 61944,
  "twitter-circle": 61945,
  "twitter": 61946,
  "typo": 61947,
  "underline-text": 61948,
  "unshare": 61949,
  "view": 61950,
  "volume-muted": 61951,
  "volume": 61952,
  "whatsapp-circle": 61953,
  "youth-and-modern-english": 61954,
  "youtube-circle": 61955,
  "youtube": 61956
});

/***/ }),

/***/ 78430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BG": function() { return /* binding */ makeBreadcrumbsChildrenLanding; },
/* harmony export */   "Fd": function() { return /* binding */ ReaderQueryParam; },
/* harmony export */   "Jc": function() { return /* binding */ CN_EL_SWIPE_ARROWS; },
/* harmony export */   "SK": function() { return /* binding */ PanelIdOffline; },
/* harmony export */   "_X": function() { return /* binding */ getParamByActivePanel; },
/* harmony export */   "cI": function() { return /* binding */ panelLoading; },
/* harmony export */   "dR": function() { return /* binding */ handlePanelBecameLoading; },
/* harmony export */   "g2": function() { return /* binding */ panelOffline; },
/* harmony export */   "gw": function() { return /* binding */ handlePanelBecameNotLoading; },
/* harmony export */   "i": function() { return /* binding */ CN_EL_READER_MODE; },
/* harmony export */   "m5": function() { return /* binding */ isSearchHighlightOK; },
/* harmony export */   "rb": function() { return /* binding */ makeBreadcrumbsPropsWithOldBreadcrumbs; },
/* harmony export */   "rn": function() { return /* binding */ CN_EL_ARROW_PLAYER; },
/* harmony export */   "sF": function() { return /* binding */ getChapterParasFromChaptersParasByParaId; },
/* harmony export */   "sO": function() { return /* binding */ layoutIds; },
/* harmony export */   "uI": function() { return /* binding */ layoutIcons; }
/* harmony export */ });
/* harmony import */ var _utils_MenuItems_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84257);
/* harmony import */ var _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37462);
/* harmony import */ var _shared_utils_breadcrumbs_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23658);
/* harmony import */ var _shared_utils_breadcrumbs_breadcrumbs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45973);
/* harmony import */ var _utils_landing_landing_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56938);
var _layoutIcons;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var ReaderQueryParam = {
  panelSecond: "linkPanel",
  panelFirst: "id",
  indexPanelActive: "index"
};
var CN_EL_READER_MODE = "note_reader-mode";
var CN_EL_ARROW_PLAYER = "arrow-player";
var CN_EL_SWIPE_ARROWS = "swipe-arrows";
var getParamByActivePanel = function getParamByActivePanel(indexPanelActive) {
  return indexPanelActive === 0 ? ReaderQueryParam.panelFirst : ReaderQueryParam.panelSecond;
};
var layoutIds = {
  l1: "l1",
  l2v: "l2v",
  l2h: "l2h"
};
var layoutIcons = (_layoutIcons = {}, _defineProperty(_layoutIcons, layoutIds.l1, _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_1__/* ["default"].stop */ .Z.stop), _defineProperty(_layoutIcons, layoutIds.l2v, _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_1__/* ["default"].L2v */ .Z.L2v), _defineProperty(_layoutIcons, layoutIds.l2h, _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_1__/* ["default"].L2h */ .Z.L2h), _layoutIcons);
var panelLoading = {
  isAvailable: true,
  breadcrumbsProps: {
    title: "loading",
    breadcrumbs: [_objectSpread(_objectSpread({}, _utils_MenuItems_constants__WEBPACK_IMPORTED_MODULE_0__/* .MainMenuItem */ .kl), {}, {
      children: null
    })]
  }
};
var panelOffline = {
  isAvailable: true,
  breadcrumbsProps: {
    title: "offline",
    breadcrumbs: [_objectSpread(_objectSpread({}, _utils_MenuItems_constants__WEBPACK_IMPORTED_MODULE_0__/* .MainMenuItem */ .kl), {}, {
      children: null
    })]
  }
};
var makeBreadcrumbsChildrenLanding = function makeBreadcrumbsChildrenLanding(book, landingConfigBooksSet, bookTitles, bookSites, bookCategory, isSetLanding, isLanding) {
  if (isSetLanding) {
    var isBookFromSet = bookTitles === null || bookTitles === void 0 ? void 0 : bookTitles.some(function (b) {
      return b.id === book.id;
    });

    if (isBookFromSet) {
      var bookSet = (0,_utils_landing_landing_utils__WEBPACK_IMPORTED_MODULE_4__/* .filterByLangAndSortBookTitles */ .Py)(bookTitles, landingConfigBooksSet, book.lang);
      var bookSetChapters = bookSet.map(function (book) {
        return _objectSpread(_objectSpread({}, book), {}, {
          id: book.first_para
        });
      }); // Add kjv book to asi(RPRAC)

      if (landingConfigBooksSet.titleShort === "RPRAC") {
        bookSetChapters.push({
          id: "1965.1",
          title: "King James Version"
        });
      }

      return bookSetChapters.map(_shared_utils_breadcrumbs_breadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* .makeBreadcrumbChapter */ .KC);
    }

    return null;
  }

  if (isLanding) {
    var _bookCategory$books;

    var _isBookFromSet = bookCategory === null || bookCategory === void 0 ? void 0 : (_bookCategory$books = bookCategory.books) === null || _bookCategory$books === void 0 ? void 0 : _bookCategory$books.some(function (b) {
      return b.id === book.id;
    });

    if (_isBookFromSet) {
      var _bookSet = (0,_utils_landing_landing_utils__WEBPACK_IMPORTED_MODULE_4__/* .filterByLangAndSortBookTitles */ .Py)(bookCategory.books, landingConfigBooksSet, book.lang);

      var _bookSetChapters = _bookSet.map(function (book) {
        var urlLandingSuitable = "";
        var bookEn = Object.values(bookSites.allBooks).find(function (bookSite) {
          return bookSite.id === book.idEn;
        });

        if (bookEn !== null && bookEn !== void 0 && bookEn.urlLanding) {
          urlLandingSuitable = bookEn.urlLanding.substring(0, bookEn.urlLanding.lastIndexOf("/"));
          urlLandingSuitable = "".concat(urlLandingSuitable, "/").concat(book.lang);
        }

        return _objectSpread(_objectSpread({}, book), {}, {
          urlLanding: urlLandingSuitable
        });
      });

      return _bookSetChapters.map(_shared_utils_breadcrumbs_breadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* .makeBreadcrumbLandingBook */ .$y);
    }
  }

  return null;
}; // Temporary fix. Need to fetch book folders to know the full breadcrumbs in runtime.

var makeBreadcrumbsPropsWithOldBreadcrumbs = function makeBreadcrumbsPropsWithOldBreadcrumbs(breadcrumbsOld, langs, book, toc, chapter, chapterId, isLanding, bookTitles, childrenCustomSuitableLang) {
  var indexBook = breadcrumbsOld.breadcrumbs.findIndex(function (i) {
    return i.type === _shared_utils_breadcrumbs_constants__WEBPACK_IMPORTED_MODULE_2__/* .BreadcrumbType.book */ .k.book;
  });

  if (indexBook === -1) {
    return (0,_shared_utils_breadcrumbs_breadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* .makeBreadcrumbsReader */ .gH)(isLanding, langs, null, book, toc, chapterId, _utils_MenuItems_constants__WEBPACK_IMPORTED_MODULE_0__/* .MainMenuItem */ .kl, bookTitles, childrenCustomSuitableLang);
  }

  var breadcrumbs = breadcrumbsOld.breadcrumbs.slice(0, indexBook + 1);

  if (toc && toc.length && chapterId) {
    breadcrumbs.push.apply(breadcrumbs, _toConsumableArray((0,_shared_utils_breadcrumbs_breadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* .makeBreadcrumbsChapter */ .ri)(toc, chapterId)));
  }

  return _objectSpread(_objectSpread({}, breadcrumbsOld), (0,_shared_utils_breadcrumbs_breadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* .makeBreadcrumbsObject */ .A3)(breadcrumbs, breadcrumbsOld.realType));
};
var handlePanelBecameLoading = function handlePanelBecameLoading(panelData, panelId, panelDataPrev) {
  var panelDataNew = _objectSpread(_objectSpread({}, panelData), {}, {
    isLoading: true,
    currentPara: panelId
  });

  if (panelData.paraListLoading || panelDataPrev !== null && panelDataPrev !== void 0 && panelDataPrev.paraList) {
    panelDataNew.paraListLoading = panelData.paraListLoading || panelDataPrev.paraList;
    panelDataNew.paraList = undefined;
  }

  return panelDataNew;
};
var handlePanelBecameNotLoading = function handlePanelBecameNotLoading(panelCurr, panelId) {
  var panelDataNew = _objectSpread(_objectSpread({}, panelCurr), {}, {
    isLoading: false,
    currentPara: panelId
  });

  if (panelDataNew.paraListLoading) {
    panelDataNew.paraListLoading = undefined;
  }

  return panelDataNew;
};
var getChapterParasFromChaptersParasByParaId = function getChapterParasFromChaptersParasByParaId(bookChaptersParas, paraId) {
  var chapter = null;

  for (var chapterNumber in bookChaptersParas) {
    var _bookChaptersParas$ch, _bookChaptersParas$ch2;

    if ((_bookChaptersParas$ch = bookChaptersParas[chapterNumber]) !== null && _bookChaptersParas$ch !== void 0 && (_bookChaptersParas$ch2 = _bookChaptersParas$ch.paras) !== null && _bookChaptersParas$ch2 !== void 0 && _bookChaptersParas$ch2.some(function (p) {
      return p.para_id === paraId;
    })) {
      chapter = bookChaptersParas[chapterNumber].paras;
    }
  }

  return chapter;
};
var isSearchHighlightOK = function isSearchHighlightOK(searchParamsQuery, searchTotal, paraData) {
  if (!paraData) {
    return false;
  }

  return !searchParamsQuery && !paraData.highlight || !searchTotal && !paraData.highlight || paraData.highlight === searchParamsQuery;
};
var PanelIdOffline = "offline";

/***/ }),

/***/ 51945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ SEARCH_FONT_SIZE_DEFAULT; }
/* harmony export */ });
var SEARCH_FONT_SIZE_DEFAULT = 18;

/***/ }),

/***/ 7578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ao": function() { return /* binding */ makeSearchUrlObject; },
/* harmony export */   "VL": function() { return /* binding */ formatSearchParams; },
/* harmony export */   "eJ": function() { return /* binding */ basicSearchDefault; }
/* harmony export */ });
/* harmony import */ var _shared_utils_search_search_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80226);
var _excluded = ["query", "queryFull", "books", "chapters", "context", "folders", "start", "limit", "extras", "lang", "bookCode"],
    _excluded2 = ["extras"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var formatSearchParams = function formatSearchParams(searchParams) {
  var query = searchParams.query,
      queryFull = searchParams.queryFull,
      books = searchParams.books,
      chapters = searchParams.chapters,
      context = searchParams.context,
      folders = searchParams.folders,
      start = searchParams.start,
      _searchParams$limit = searchParams.limit,
      limit = _searchParams$limit === void 0 ? 10 : _searchParams$limit,
      _searchParams$extras = searchParams.extras,
      extras = _searchParams$extras === void 0 ? {} : _searchParams$extras,
      lang = searchParams.lang,
      bookCode = searchParams.bookCode,
      rest = _objectWithoutProperties(searchParams, _excluded);

  return {
    query: query,
    queryFull: queryFull ? queryFull : query,
    books: makeArray(books),
    chapters: chapters ? makeArray(chapters) : undefined,
    context: context,
    folders: folders,
    start: start,
    limit: limit,
    lang: lang,
    bookCode: bookCode,
    extras: _objectSpread(_objectSpread(_objectSpread({}, rest), extras), {}, {
      lang: lang ? makeArray(lang) : "",
      queryType: rest.queryType || extras.queryType || _shared_utils_search_search_constants__WEBPACK_IMPORTED_MODULE_0__/* .QueryTypeDefault */ .J0
    })
  };
};

var makeArray = function makeArray(param) {
  if (Array.isArray(param)) {
    return param;
  }

  return [param];
};

var makeSearchUrlObject = function makeSearchUrlObject(searchParams) {
  var searchUrlObject = {};

  var extras = searchParams.extras,
      basic = _objectWithoutProperties(searchParams, _excluded2);

  var flatSearchParams = _objectSpread(_objectSpread({}, extras), basic);

  for (var _i = 0, _Object$entries = Object.entries(flatSearchParams); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i2 = _slicedToArray(_Object$entries[_i], 2),
        name = _Object$entries$_i2[0],
        value = _Object$entries$_i2[1];

    if (value && value !== "") {
      searchUrlObject[name] = value;
    }
  }

  return searchUrlObject;
};
var basicSearchDefault = {
  start: 0,
  limit: 10,
  extras: {
    type: _shared_utils_search_search_constants__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypeDefault */ .bz,
    period: _shared_utils_search_search_constants__WEBPACK_IMPORTED_MODULE_0__/* .PeriodDefault */ .p2,
    snippet: _shared_utils_search_search_constants__WEBPACK_IMPORTED_MODULE_0__/* .SEARCH_SNIPPET_DEFAULT */ .fU,
    order: _shared_utils_search_search_constants__WEBPACK_IMPORTED_MODULE_0__/* .OrderDefault */ .u7
  }
};

/***/ }),

/***/ 89284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useAuthContext; },
/* harmony export */   "H": function() { return /* binding */ AuthProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34412);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_api_cPanel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42304);
/* harmony import */ var _shared_utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52707);
/* harmony import */ var _shared_api_not_sorted__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58890);
/* harmony import */ var _store_actions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62013);
/* harmony import */ var _shared_hooks_useCookiesWithOptions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65482);
/* harmony import */ var _shared_utils_storage_storage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12202);
/* harmony import */ var _shared_store_settings_selectors__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4787);
/* harmony import */ var _shared_utils_console__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65795);
/* harmony import */ var _shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76439);
/* harmony import */ var _shared_utils_settings_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20467);
/* harmony import */ var _shared_utils_settings_settings__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19819);
/* harmony import */ var _utils_settings_settings__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(91241);
/* harmony import */ var _shared_hooks_useLogin__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(60370);
/* harmony import */ var _shared_store_system_selectors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(91809);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


















var AuthContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var AuthProvider = function AuthProvider(_ref) {
  var children = _ref.children;
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var _useCookiesWithOption = (0,_shared_hooks_useCookiesWithOptions__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)([_shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_10__/* .COOKIE_KEY_I_18_NEXT */ .po]),
      _useCookiesWithOption2 = _slicedToArray(_useCookiesWithOption, 2),
      cookie = _useCookiesWithOption2[0],
      setCookie = _useCookiesWithOption2[1];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isInit = _useState2[0],
      setIsInit = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      afterLoginCb = _useState6[0],
      setAfterLoginCb = _useState6[1];

  var user = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_shared_store_system_selectors__WEBPACK_IMPORTED_MODULE_15__/* .selectorUserInfo */ .If);
  var languageUI = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((0,_shared_store_settings_selectors__WEBPACK_IMPORTED_MODULE_16__/* .selectorSetting */ .K)(_shared_utils_settings_constants__WEBPACK_IMPORTED_MODULE_11__/* .SETTING.languageUI.id */ .Fy.languageUI.id));

  var _useLogin = (0,_shared_hooks_useLogin__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(),
      openLoginWindow = _useLogin.openLoginWindow; // Fetches user info using cookies tokens.


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    (0,_shared_api_cPanel__WEBPACK_IMPORTED_MODULE_3__/* .fetchLegacyUserInfo */ ._)().then(function (userInfo) {
      if (userInfo) {
        dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_6__/* .systemActions.setUserInfo */ .nm.setUserInfo(userInfo));
      }
    }).catch(function (e) {
      (0,_shared_utils_console__WEBPACK_IMPORTED_MODULE_9__/* .consoleLogError */ .aw)("Auth", "Failed to fetch user info", e);
    }).finally(function () {
      setIsInit(true);
    });
  }, []); // Handles auth tokens when login.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var handleAuthToken = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(message) {
        var _message$data, _message$data2;

        var _message$data4, accessToken, refreshToken, expires_in, userInfo;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(message !== null && message !== void 0 && (_message$data = message.data) !== null && _message$data !== void 0 && _message$data.error)) {
                _context.next = 4;
                break;
              }

              dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_6__/* .systemActions.toast */ .nm.toast(message.error));
              _context.next = 13;
              break;

            case 4:
              if (!(message !== null && message !== void 0 && (_message$data2 = message.data) !== null && _message$data2 !== void 0 && _message$data2.access_token)) {
                _context.next = 13;
                break;
              }

              _message$data4 = message.data, accessToken = _message$data4.access_token, refreshToken = _message$data4.refresh_token, expires_in = _message$data4.expires_in;

              if (!accessToken) {
                _context.next = 13;
                break;
              }

              (0,_shared_utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_4__/* .setTokens */ .d0)(accessToken, refreshToken, expires_in);

              if (!refreshToken) {
                _context.next = 13;
                break;
              }

              _context.next = 11;
              return (0,_shared_api_cPanel__WEBPACK_IMPORTED_MODULE_3__/* .fetchLegacyUserInfo */ ._)();

            case 11:
              userInfo = _context.sent;

              if (userInfo) {
                dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_6__/* .systemActions.setUserInfo */ .nm.setUserInfo(userInfo));

                if (afterLoginCb) {
                  afterLoginCb(userInfo);
                }
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));

      return function handleAuthToken(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    window.addEventListener("message", handleAuthToken);
    return function () {
      window.removeEventListener("message", handleAuthToken);
    };
  }, []); // Handles auth state.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (user) {
      dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_6__/* .systemActions.setIsLogin */ .nm.setIsLogin(true));
      handleAuthSuccess();
    } else {
      dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_6__/* .systemActions.setIsLogin */ .nm.setIsLogin(false));
      setLoading(false);
    }
  }, [user]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (languageUI !== cookie[_shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_10__/* .COOKIE_KEY_I_18_NEXT */ .po]) {
      setCookie(_shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_10__/* .COOKIE_KEY_I_18_NEXT */ .po, languageUI);
    }
  }, [languageUI]);

  var login = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(cb) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!user) {
              setLoading(true);

              try {
                openLoginWindow(function () {
                  setLoading(false);
                });
                setAfterLoginCb(cb);
              } catch (e) {
                setLoading(false);
                setAfterLoginCb(null);
                dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_6__/* .systemActions.toast */ .nm.toast(e.toString()));
              }
            }

          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));

    return function login(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var logout = function logout() {
    router.push("/");
    (0,_shared_utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_4__/* .deleteAllCookies */ .Bt)();
    dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_6__/* .libraryActions.updateAllHistory */ .jK.updateAllHistory([]));
    (0,_shared_utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_4__/* .setTokens */ .d0)();

    if (_shared_utils_storage_storage__WEBPACK_IMPORTED_MODULE_8__/* .localStorageSafe */ .NE) {
      (0,_shared_utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_4__/* .clearLocalStorage */ .ZL)();
    }

    dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_6__/* .systemActions.setUserInfo */ .nm.setUserInfo(null));
  };

  var handleAuthSuccess = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var storedSettings, serverSettings, libLangs, settingsLocalInvalidFixed, key, settingsLocalFinal, settingsServerInvalidFixed, serverSettingsFinal, _key2;

      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            storedSettings = (0,_utils_settings_settings__WEBPACK_IMPORTED_MODULE_13__/* .getStoredSettingsNextApp */ .qp)();
            _context3.next = 3;
            return (0,_shared_api_not_sorted__WEBPACK_IMPORTED_MODULE_5__/* .getSettingsRequest */ .Dt)();

          case 3:
            serverSettings = _context3.sent;
            _context3.next = 6;
            return (0,_shared_api_not_sorted__WEBPACK_IMPORTED_MODULE_5__/* .fetchLibraryLanguagesRequest */ .Bb)();

          case 6:
            libLangs = _context3.sent;
            // Validate local settings
            settingsLocalInvalidFixed = {};
            (0,_utils_settings_settings__WEBPACK_IMPORTED_MODULE_13__/* .validateSettingsNextApp */ .sC)(storedSettings, settingsLocalInvalidFixed); // Update invalid local settings in storage

            for (key in settingsLocalInvalidFixed) {
              (0,_shared_utils_settings_settings__WEBPACK_IMPORTED_MODULE_12__/* .storeSetting */ .Jp)(key, settingsLocalInvalidFixed[key]);
            }

            settingsLocalFinal = _objectSpread(_objectSpread({}, storedSettings), settingsLocalInvalidFixed); // =======================
            // Validate server settings

            settingsServerInvalidFixed = {};
            (0,_utils_settings_settings__WEBPACK_IMPORTED_MODULE_13__/* .validateSettingsNextApp */ .sC)(storedSettings, settingsServerInvalidFixed); // Store all server settings in storage

            serverSettingsFinal = _objectSpread(_objectSpread({}, serverSettings), settingsServerInvalidFixed);

            for (_key2 in serverSettingsFinal) {
              (0,_shared_utils_settings_settings__WEBPACK_IMPORTED_MODULE_12__/* .storeSetting */ .Jp)(_key2, serverSettingsFinal[_key2]);
            } // =======================


            dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_6__/* .settingsActions.updateSettingSuccess */ .ff.updateSettingSuccess(_objectSpread(_objectSpread(_objectSpread({}, settingsLocalFinal), serverSettingsFinal), {}, _defineProperty({}, _shared_utils_settings_constants__WEBPACK_IMPORTED_MODULE_11__/* .SETTING.libraryLanguages.id */ .Fy.libraryLanguages.id, libLangs))));
            dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_6__/* .libraryActions.fetchAllBooksData */ .jK.fetchAllBooksData(undefined, undefined, function () {
              setLoading(false);
            }));

          case 17:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));

    return function handleAuthSuccess() {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(AuthContext.Provider, {
    value: {
      isLogin: !!user,
      isInit: isInit,
      user: user,
      loading: loading,
      login: login,
      logout: logout
    }
  }, children);
};
var useAuthContext = function useAuthContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AuthContext);
};

/***/ }),

/***/ 84847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ HistoryProvider; },
/* harmony export */   "z": function() { return /* binding */ useCustomHistory; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



var HistoryContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var HistoryProvider = function HistoryProvider(_ref) {
  var children = _ref.children;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      history = _useState2[0],
      setHistory = _useState2[1];

  var back = function back(fallbackRoute) {
    for (var i = history.length - 2; i >= 0; i--) {
      var route = history[i];

      if (!route.includes("#") && route !== router.pathname) {
        router.push(route);
        var newHistory = history.slice(0, i);
        setHistory(newHistory);
        return;
      }
    }

    if (fallbackRoute) {
      router.push(fallbackRoute);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setHistory(function (previous) {
      return [].concat(_toConsumableArray(previous), [router.asPath]);
    });
  }, [router.asPath]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(HistoryContext.Provider, {
    value: {
      back: back,
      history: history,
      setHistory: setHistory
    }
  }, children);
};
var useCustomHistory = function useCustomHistory() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HistoryContext);
};

/***/ }),

/***/ 2978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ PagePropsProvider; },
/* harmony export */   "b": function() { return /* binding */ usePagePropsContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);

var PagePropsContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var PagePropsProvider = function PagePropsProvider(_ref) {
  var localeLanding = _ref.localeLanding,
      book = _ref.book,
      booksSet = _ref.booksSet,
      isLanding = _ref.isLanding,
      isSetLanding = _ref.isSetLanding,
      isSetRPRAC = _ref.isSetRPRAC,
      isSetCONFLICT = _ref.isSetCONFLICT,
      isSetTESTIMONIES = _ref.isSetTESTIMONIES,
      isBigLanding = _ref.isBigLanding,
      landingConfigBooksSet = _ref.landingConfigBooksSet,
      landingIdBooksSet = _ref.landingIdBooksSet,
      bookTitles = _ref.bookTitles,
      bookSites = _ref.bookSites,
      bookCategory = _ref.bookCategory,
      landingBookId = _ref.landingBookId,
      landingBookViewConfig = _ref.landingBookViewConfig,
      pageUrl = _ref.pageUrl,
      urlOrigin = _ref.urlOrigin,
      children = _ref.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(PagePropsContext.Provider, {
    value: {
      // Landing
      localeLanding: localeLanding,
      isLanding: isLanding,
      isSetLanding: isSetLanding,
      isSetRPRAC: isSetRPRAC,
      isSetCONFLICT: isSetCONFLICT,
      isSetTESTIMONIES: isSetTESTIMONIES,
      isBigLanding: isBigLanding,
      bookTitles: bookTitles,
      bookSites: bookSites,
      bookCategory: bookCategory,
      landingBookId: landingBookId,
      book: book,
      landingBookViewConfig: landingBookViewConfig,
      booksSet: booksSet,
      landingConfigBooksSet: landingConfigBooksSet,
      landingIdBooksSet: landingIdBooksSet,
      // ===================
      // Rest
      pageUrl: pageUrl,
      urlOrigin: urlOrigin
    }
  }, children);
};
/**
 * @returns {{
 *    localeLanding: string,
 * 
 *    isLanding: boolean,
 *    isSetLanding: boolean,
 *    isSetRPRAC: boolean,
 *    isBigLanding: boolean,
 *
 *    bookTitles: []|null,
 *    bookSites: []|null,
 *
 *    landingBookId: string,
 *    book: {}|null,
 *    landingBookViewConfig: {},
 *
 *    booksSet: {}|null,
 *    landingConfigBooksSet: {}|null,
 *
 *    pageUrl: string,
 *    urlOrigin: string,
 * }}
 */

var usePagePropsContext = function usePagePropsContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(PagePropsContext);
};

/***/ }),

/***/ 91318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ContextMenuProvider; },
/* harmony export */   "v": function() { return /* binding */ useCustomMenuContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shared_hooks_usePopup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98754);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var CustomContextMenuPopup = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(218), __webpack_require__.e(239), __webpack_require__.e(113)]).then(__webpack_require__.bind(__webpack_require__, 66113));
}, {
  ssr: false
});
var RightClickMenuContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var ContextMenuProvider = function ContextMenuProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      fnGetUrl = _useState2[0],
      setFnGetUrl = _useState2[1];

  var _usePopup = (0,_shared_hooks_usePopup__WEBPACK_IMPORTED_MODULE_2__/* .usePopup */ .B)(),
      isShown = _usePopup.isShown,
      anchorEl = _usePopup.anchorEl,
      openPopup = _usePopup.openPopup,
      closePopup = _usePopup.closePopup;

  var handleContextListener = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    openPopup(e);
    var linkRelated = e.detail.target.tagName === "A" ? e.detail.target : e.detail.target.querySelector("a");

    if (typeof e.detail.getUrl === "function") {
      setFnGetUrl(e.detail.getUrl);
    } else if (linkRelated) {
      setFnGetUrl(function () {
        return linkRelated.href;
      });
    } else {
      setFnGetUrl(null);
    }
  }, [openPopup]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    document.addEventListener("contextMenuCustom", handleContextListener);
    return function () {
      document.addEventListener("contextMenuCustom", handleContextListener);
    };
  }, [handleContextListener, isShown]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!isShown) {
      setFnGetUrl(null);
    }
  }, [isShown]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(RightClickMenuContext.Provider, {
    value: {
      fnGetUrl: fnGetUrl,
      anchorEl: anchorEl,
      isShown: isShown,
      closePopup: closePopup
    }
  }, children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(CustomContextMenuPopup, null));
};
var useCustomMenuContext = function useCustomMenuContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(RightClickMenuContext);
};

/***/ }),

/***/ 38768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useSearchContext; },
/* harmony export */   "X": function() { return /* binding */ SearchProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _store_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62013);
/* harmony import */ var _shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76439);
/* harmony import */ var _shared_api_search_suggestions_requests__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33967);
/* harmony import */ var _shared_utils_search_search__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15347);
/* harmony import */ var _shared_utils_content_content__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69051);
/* harmony import */ var _shared_api_shopApi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48367);
/* harmony import */ var _utils_routes_routes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69994);
/* harmony import */ var _utils_routes_routes_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46072);
/* harmony import */ var _components_SearchWidget_SearchWidget_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7578);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60098);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34412);
/* harmony import */ var _shared_store_settings_selectors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4787);
/* harmony import */ var _shared_utils_settings_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20467);
/* harmony import */ var _shared_utils_search_advanced_advanced__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(55082);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

















var SearchContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var SearchProvider = function SearchProvider(_ref) {
  var children = _ref.children;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$G)(),
      i18n = _useTranslation.i18n;

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_12__/* .useDispatch */ .I0)();
  var baseBible = (0,react_redux__WEBPACK_IMPORTED_MODULE_12__/* .useSelector */ .v9)((0,_shared_store_settings_selectors__WEBPACK_IMPORTED_MODULE_15__/* .selectorSetting */ .K)(_shared_utils_settings_constants__WEBPACK_IMPORTED_MODULE_13__/* .SETTING.baseBible.id */ .Fy.baseBible.id));

  var resetSearch = function resetSearch() {
    dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_2__/* .searchActions.reset */ .RR.reset());
  };

  var searchByShortcut = function searchByShortcut(shortcut, searchParams) {
    (0,_shared_utils_search_search__WEBPACK_IMPORTED_MODULE_5__/* .handleSearchShortcut */ .Xm)(shortcut, {
      onShortcutBook: function onShortcutBook() {
        resetSearch();
        openBookOrPara(shortcut.bookId);
      },
      onShortcutPara: function onShortcutPara() {
        resetSearch();
        openBookOrPara(shortcut.paraId);
      },
      onSearchInBookOrChapter: function onSearchInBookOrChapter() {
        (0,_shared_utils_search_search__WEBPACK_IMPORTED_MODULE_5__/* .setShortcutDataParamsToSearchParams */ .Gb)(searchParams, shortcut, baseBible, true, false);

        if (searchParams.extras.period) {
          searchParams.period = searchParams.extras.period;
          delete searchParams.extras.period;
        }

        if (shortcut.book_code) {
          // if search in book, not in chapter
          // should be removed, is used inside book code input
          searchParams.bookCode = shortcut.book_code;
        }

        openSearchPage(searchParams);
      },
      onTextSearch: function onTextSearch() {
        openSearchPage(searchParams);
      }
    });
  };

  var openBookOrPara = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(paraId) {
      var bookId, shopBooks, shopBook;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            bookId = (0,_shared_utils_content_content__WEBPACK_IMPORTED_MODULE_6__/* .getBookIdNumber */ .o8)(paraId);
            _context.next = 3;
            return (0,_shared_api_shopApi__WEBPACK_IMPORTED_MODULE_7__/* .getShopBooksRequest */ .xh)([bookId]);

          case 3:
            shopBooks = _context.sent;
            shopBook = shopBooks.books[0];

            if (!(shopBook && !shopBook.is_purchased)) {
              _context.next = 8;
              break;
            }

            router.push({
              pathname: (0,_utils_routes_routes__WEBPACK_IMPORTED_MODULE_8__/* .makeBookUrl */ .Q_)(bookId)
            });
            return _context.abrupt("return");

          case 8:
            router.push({
              pathname: (0,_utils_routes_routes__WEBPACK_IMPORTED_MODULE_8__/* .makeChapterUrl */ .ME)(paraId)
            });

          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));

    return function openBookOrPara(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var openSearchPage = function openSearchPage(searchParams) {
    router.push({
      pathname: _utils_routes_routes_constants__WEBPACK_IMPORTED_MODULE_9__/* .NEXT_URLS.search */ .h.search,
      query: (0,_components_SearchWidget_SearchWidget_utils__WEBPACK_IMPORTED_MODULE_10__/* .makeSearchUrlObject */ .Ao)(_objectSpread(_objectSpread({}, _components_SearchWidget_SearchWidget_utils__WEBPACK_IMPORTED_MODULE_10__/* .basicSearchDefault */ .eJ), searchParams))
    });
  };

  var search = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(query, lang) {
      var langFinal, shortcutResponse, newSearchParams;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            langFinal = lang || router.query.lang || i18n.language || _shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_LANGUAGE */ .k$;
            _context2.next = 3;
            return (0,_shared_api_search_suggestions_requests__WEBPACK_IMPORTED_MODULE_4__/* .getSearchSuggestionsShortcutRequest */ .g9)(query, (0,_shared_utils_search_advanced_advanced__WEBPACK_IMPORTED_MODULE_14__/* .getBiblePubnr */ .n4)(baseBible));

          case 3:
            shortcutResponse = _context2.sent;
            newSearchParams = {
              query: query,
              queryFull: query,
              lang: langFinal
            };

            if (!(0,_shared_utils_search_search__WEBPACK_IMPORTED_MODULE_5__/* .isQueryOnlyText */ .ML)(query)) {
              searchByShortcut(shortcutResponse, newSearchParams);
            } else {
              openSearchPage(newSearchParams);
            }

          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));

    return function search(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchContext.Provider, {
    value: {
      search: search,
      searchByShortcut: searchByShortcut
    }
  }, children);
};
var useSearchContext = function useSearchContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SearchContext);
};

/***/ }),

/***/ 36895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ SubscriptionsProvider; },
  "T": function() { return /* binding */ useSubscriptionsContext; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27693);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/next/contexts/auth.js
var auth = __webpack_require__(89284);
// EXTERNAL MODULE: ../shared/utils/subscriptions.js
var utils_subscriptions = __webpack_require__(8816);
// EXTERNAL MODULE: ../shared/api/baseApi.js
var baseApi = __webpack_require__(97649);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
// EXTERNAL MODULE: ../shared/api/not-sorted.utils.js
var not_sorted_utils = __webpack_require__(1511);
;// CONCATENATED MODULE: ../shared/api/subscriptionsApi.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




var getCalendarForMonth = function getCalendarForMonth(year, month) {
  return (0,baseApi/* makeRequest */.$f)({
    url: "subscriptions/content/month/".concat(year, "/").concat(month),
    type: "GET",
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  });
};
var getSubscriptions = function getSubscriptions() {
  return (0,baseApi/* makeRequest */.$f)({
    url: "subscriptions/subscriptions",
    type: "get",
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  });
};
var deleteSubscription = function deleteSubscription(id) {
  return (0,baseApi/* makeRequest */.$f)({
    url: "subscriptions/subscriptions/".concat(id),
    type: "delete",
    parseResponse: function parseResponse(response) {
      return response.status;
    }
  });
};
var getSubsContentForDate = function getSubsContentForDate(date) {
  var request = {
    url: "subscriptions/content/".concat(date),
    type: "GET",
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  };
  return (0,baseApi/* makeRequest */.$f)(request);
};
var fetchContentByDateRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(date) {
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return getSubsContentForDate(date);

        case 3:
          response = _context.sent;
          return _context.abrupt("return", _defineProperty({}, date, (0,content/* cutOutHeaders */.H7)((0,content/* normalizeSubsContent */.Eq)(response.subscriptions))));

        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", null);

        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function fetchContentByDateRequest(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getThoughtsByDate = function getThoughtsByDate(date) {
  return (0,baseApi/* makeRequest */.$f)({
    url: "subscriptions/thought?date=".concat(date),
    type: "GET",
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  });
};
var fetchThoughtsByDateRequest = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(date) {
    var response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return getThoughtsByDate(date);

        case 3:
          response = _context2.sent;
          return _context2.abrupt("return", _defineProperty({}, date, response));

        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](0);
          return _context2.abrupt("return", null);

        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function fetchThoughtsByDateRequest(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./src/next/contexts/subscriptions.js
function subscriptions_typeof(obj) { "@babel/helpers - typeof"; return subscriptions_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, subscriptions_typeof(obj); }

function subscriptions_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ subscriptions_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == subscriptions_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function subscriptions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function subscriptions_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { subscriptions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { subscriptions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { subscriptions_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function subscriptions_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }







var SubscriptionsContext = /*#__PURE__*/(0,react.createContext)({});
var SubscriptionsProvider = function SubscriptionsProvider(_ref) {
  var children = _ref.children;
  var router = (0,next_router.useRouter)();

  var _useAuthContext = (0,auth/* useAuthContext */.E)(),
      isLogin = _useAuthContext.isLogin;

  var date = (0,react.useMemo)(function () {
    var _router$query$subscri;

    var date;
    var initialDate = (_router$query$subscri = router.query.subscription) === null || _router$query$subscri === void 0 ? void 0 : _router$query$subscri[1];

    if (initialDate && dayjs_min_default()(initialDate).isValid()) {
      date = (0,utils_subscriptions/* validateDate */.qS)(new Date(initialDate));
    } else {
      date = (0,utils_subscriptions/* validateDate */.qS)(new Date());
    }

    return date;
  }, [router.query.subscription]);

  var _useState = (0,react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      content = _useState2[0],
      setContent = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      subscriptions = _useState4[0],
      setSubscriptions = _useState4[1];

  var _useState5 = (0,react.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      thoughts = _useState6[0],
      setThoughts = _useState6[1];

  var _useState7 = (0,react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      calendar = _useState8[0],
      setCalendar = _useState8[1];

  var fetchMonthData = (0,react.useCallback)(function (date) {
    var dateObject = dayjs_min_default()(date);
    var year = dateObject.year();
    var month = dateObject.month() + 1;

    if (!(year in calendar) || !(month in calendar[year])) {
      getCalendarForMonth(year, month).then(function (dates) {
        var updatedCalendar = _objectSpread({}, calendar);

        if (!(year in updatedCalendar)) {
          updatedCalendar[year] = {};
        }

        updatedCalendar[year][month] = dates;
        setCalendar(updatedCalendar);
      });
    }
  }, [calendar]);
  var fetchThoughts = (0,react.useCallback)(function () {
    if (isLogin && date && !(date in thoughts)) {
      fetchThoughtsByDateRequest(date).then(function (response) {
        setThoughts(response);
      });
    }
  }, [thoughts, date, isLogin]);
  var fetchContent = (0,react.useCallback)(function () {
    if (isLogin && date && !(date in content)) {
      fetchContentByDateRequest(date).then(function (response) {
        setContent(response || {});
      }).catch(function () {
        setContent({});
      });
    }
  }, [content, date, isLogin]);
  var fetchSubscriptions = (0,react.useCallback)(function () {
    if (isLogin) {
      getSubscriptions().then(function (response) {
        setSubscriptions(response);
      }).catch(function () {
        setSubscriptions([]);
      });
    }
  }, [isLogin]);
  var unsubscribe = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = subscriptions_asyncToGenerator( /*#__PURE__*/subscriptions_regeneratorRuntime().mark(function _callee(id) {
      var status;
      return subscriptions_regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return deleteSubscription(id);

          case 2:
            status = _context.sent;

            if (status === 204) {
              setContent(subscriptions_defineProperty({}, date, content[date].filter(function (item) {
                return item.subscription !== id;
              })));
            }

          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [content, date]);
  var isSubscribedBook = (0,react.useCallback)(function (book) {
    return !!(subscriptions !== null && subscriptions !== void 0 && subscriptions.find(function (sub) {
      return sub.book.book_id === book.book_id;
    }));
  }, [subscriptions]);
  (0,react.useEffect)(function () {
    fetchSubscriptions();
  }, [fetchSubscriptions]);
  return /*#__PURE__*/react.createElement(SubscriptionsContext.Provider, {
    value: {
      date: date,
      content: content,
      thoughts: thoughts,
      calendar: calendar,
      subscriptions: subscriptions,
      // methods
      isSubscribedBook: isSubscribedBook,
      fetchThoughts: fetchThoughts,
      fetchContent: fetchContent,
      fetchSubscriptions: fetchSubscriptions,
      fetchMonthData: fetchMonthData,
      unsubscribe: unsubscribe
    }
  }, children);
};
var useSubscriptionsContext = function useSubscriptionsContext() {
  return (0,react.useContext)(SubscriptionsContext);
};

/***/ }),

/***/ 88130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UG": function() { return /* binding */ useRegulateTheme; },
  "Fg": function() { return /* binding */ useTheme; }
});

// UNUSED EXPORTS: ZoomCoefficientAcc

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(34412);
// EXTERNAL MODULE: ../shared/utils/theme/theme.js + 1 modules
var theme = __webpack_require__(93752);
// EXTERNAL MODULE: ../shared/utils/viewmode.js
var viewmode = __webpack_require__(24064);
// EXTERNAL MODULE: ./src/next/components/SearchResults/Search.constants.js
var Search_constants = __webpack_require__(51945);
// EXTERNAL MODULE: ./src/next/store/actions/index.js + 6 modules
var actions = __webpack_require__(62013);
// EXTERNAL MODULE: ../shared/hooks/useCookiesWithOptions.js + 9 modules
var useCookiesWithOptions = __webpack_require__(65482);
// EXTERNAL MODULE: ../shared/store/settings/selectors.js
var selectors = __webpack_require__(4787);
// EXTERNAL MODULE: ../shared/utils/settings/constants.js + 1 modules
var constants = __webpack_require__(20467);
// EXTERNAL MODULE: ./src/next/utils/theme.js
var utils_theme = __webpack_require__(12621);
// EXTERNAL MODULE: ./src/next/utils/settings/settings.js + 1 modules
var settings = __webpack_require__(91241);
// EXTERNAL MODULE: ../shared/utils/storage/storage.js
var storage = __webpack_require__(12202);
;// CONCATENATED MODULE: ./src/next/utils/reader/constants.js
var READER_FONT_SIZE_DEFAULT = 18;
;// CONCATENATED MODULE: ./src/next/hooks/useTheme.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }














var ZoomCoefficientAcc = 1.1;

var isViewModeAccessibilityNow = function isViewModeAccessibilityNow() {
  return document.body.classList.contains(viewmode/* VIEW_MODE.BLIND */.WF.BLIND);
};

var regulateBlindModeProperties = function regulateBlindModeProperties(themeId) {
  var rootElement = document.querySelector(":root");
  var classList = document.body.classList;

  if ((0,theme/* getIsAccessibilityTheme */.xI)(themeId)) {
    classList.add(viewmode/* VIEW_MODE.BLIND */.WF.BLIND);
    rootElement.style.fontSize = theme/* DefaultFontSize */.OS * ZoomCoefficientAcc + "px";
  } else {
    classList.remove(viewmode/* VIEW_MODE.BLIND */.WF.BLIND);
    rootElement.style.fontSize = theme/* DefaultFontSize */.OS + "px";
  }
};

var useRegulateTheme = function useRegulateTheme(_ref) {
  var isLanding = _ref.isLanding,
      landingBookViewConfig = _ref.landingBookViewConfig;
  var dispatch = (0,es/* useDispatch */.I0)();
  var themeMode = (0,es/* useSelector */.v9)((0,selectors/* selectorSetting */.K)(constants/* SETTING.themeMode.id */.Fy.themeMode.id));

  var _useCookiesWithOption = (0,useCookiesWithOptions/* default */.Z)([theme/* COOKIE_KEY_THEME */.kh]),
      _useCookiesWithOption2 = _slicedToArray(_useCookiesWithOption, 2),
      setCookie = _useCookiesWithOption2[1];

  var isAppHasSingleTheme = isLanding && !(landingBookViewConfig !== null && landingBookViewConfig !== void 0 && landingBookViewConfig.hasDarkMode);
  var updateTheme = (0,react.useCallback)(function (themeId) {
    if (!isAppHasSingleTheme) {
      var isAccessibilityTheme = (0,theme/* getIsAccessibilityTheme */.xI)(themeId);
      setCookie(theme/* COOKIE_KEY_THEME */.kh, themeId);

      if (isAccessibilityTheme !== isViewModeAccessibilityNow()) {
        var coefficientSearchFontSizeAccToNormal = 22 / Search_constants/* SEARCH_FONT_SIZE_DEFAULT */.F;
        var coefficientReaderFontSizeAccToNormal = theme/* ReaderFontSizes.blindDefault */.Rb.blindDefault / READER_FONT_SIZE_DEFAULT;
        var searchFontSizeCurr = (0,storage/* getCookie */.ej)(theme/* COOKIE_KEY_SEARCH_FONT_SIZE */.wV, document.cookie);
        var readerFontSizeCurr = (0,storage/* getCookie */.ej)(theme/* COOKIE_KEY_READER_FONT_SIZE */.Es, document.cookie);
        setCookie(theme/* COOKIE_KEY_SEARCH_FONT_SIZE */.wV, isAccessibilityTheme ? searchFontSizeCurr * coefficientSearchFontSizeAccToNormal : searchFontSizeCurr / coefficientSearchFontSizeAccToNormal);
        setCookie(theme/* COOKIE_KEY_READER_FONT_SIZE */.Es, isAccessibilityTheme ? readerFontSizeCurr * coefficientReaderFontSizeAccToNormal : readerFontSizeCurr / coefficientReaderFontSizeAccToNormal);
      }
    }

    (0,theme/* activateTheme */.VK)(themeId);
    regulateBlindModeProperties(themeId);
    dispatch(actions/* settingsActions.updateSettings */.ff.updateSettings(constants/* SETTING.themeMode.id */.Fy.themeMode.id, themeId, !isLanding));
  }, [isAppHasSingleTheme, isLanding, setCookie]);
  (0,react.useEffect)(function () {
    if (isAppHasSingleTheme) {
      updateTheme(landingBookViewConfig === null || landingBookViewConfig === void 0 ? void 0 : landingBookViewConfig.defaultTheme);
    } else {
      // Fast-fix:
      // Exception for {Theme.ls}, to prevent "ls" theme for landing site,
      // but though be able to use "ls" theme for specific landing apps.
      var isValidTheme = themeMode !== theme/* Theme.ls.id */.Q2.ls.id && (0,settings/* validateSettingNextApp */.fT)(constants/* SETTING.themeMode.id */.Fy.themeMode.id, themeMode);

      if (isValidTheme) {
        updateTheme(themeMode);
      } else {
        updateTheme(isLanding ? landingBookViewConfig === null || landingBookViewConfig === void 0 ? void 0 : landingBookViewConfig.defaultTheme : utils_theme/* DefaultThemeIdEasyModeApp */.Pt);
      }
    }
  }, [isAppHasSingleTheme, isLanding, themeMode, updateTheme]);
};
var useTheme = function useTheme() {
  var dispatch = (0,es/* useDispatch */.I0)();
  var themeMode = (0,es/* useSelector */.v9)((0,selectors/* selectorSetting */.K)(constants/* SETTING.themeMode.id */.Fy.themeMode.id));

  var updateTheme = function updateTheme(themeId) {
    if (themeId) {
      document.body.className = document.body.className.replace(themeMode, themeId);
      dispatch(actions/* settingsActions.updateSettings */.ff.updateSettings(constants/* SETTING.themeMode.id */.Fy.themeMode.id, themeId));
    }
  };

  return {
    activeTheme: themeMode,
    updateTheme: updateTheme,
    isDarkTheme: (0,theme/* isDarkTheme */.$o)(themeMode)
  };
};

/***/ }),

/***/ 72777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ actionsFeaturedSearch; }
/* harmony export */ });
/* unused harmony export actionsConstantsFeaturedSearch */
/* harmony import */ var _shared_store_featuredSearch_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67775);

var actionsConstantsFeaturedSearch = (/* unused pure expression or super */ null && (_sharedActionsConstantsFeaturedSearch));
var actionsFeaturedSearch = _shared_store_featuredSearch_actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsFeaturedSearch */ .G;

/***/ }),

/***/ 62013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jK": function() { return /* reexport */ libraryActions; },
  "hb": function() { return /* reexport */ libraryActionsConstants; },
  "nf": function() { return /* reexport */ mainTree_actions/* mainTreeActionConstants */.n; },
  "Ze": function() { return /* reexport */ mainTree_actions/* mainTreeActions */.Z; },
  "Kd": function() { return /* reexport */ paragraphsReducerActions; },
  "Db": function() { return /* reexport */ paragraphsReducerConstants; },
  "L4": function() { return /* reexport */ playerActionConstants; },
  "UT": function() { return /* reexport */ relevantSearch_actions/* relevantSearchActionConstants */.U; },
  "fg": function() { return /* reexport */ relevantSearch_actions/* relevantSearchActions */.f; },
  "cT": function() { return /* reexport */ searchActionConstants; },
  "RR": function() { return /* reexport */ searchActions; },
  "ff": function() { return /* reexport */ settings_actions/* settingsActions */.f; },
  "Se": function() { return /* reexport */ settings_actions/* settingsActionsConstants */.S; },
  "CT": function() { return /* reexport */ supportActionConstants; },
  "_F": function() { return /* reexport */ swActionConstants; },
  "s1": function() { return /* reexport */ swActions; },
  "nm": function() { return /* reexport */ system_actions/* systemActions */.n; },
  "My": function() { return /* reexport */ system_actions/* systemActionsConstants */.M; }
});

// UNUSED EXPORTS: playerActions, supportActions

// EXTERNAL MODULE: ../shared/store/search/actions.js
var actions = __webpack_require__(37314);
;// CONCATENATED MODULE: ./src/next/store/actions/search.actions.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var prefix = "search/";
var searchActionConstants = _objectSpread({
  SEARCH_SUCCESS: "SEARCH_SUCCESS",
  ACTION_SEARCH: "ACTION_SEARCH",
  SEARCH_CLEAR: "SEARCH_CLEAR",
  RESET: prefix + "RESET",
  ACTION_SEARCH_PARAMS_UPDATE: "ACTION_SEARCH_PARAMS_UPDATE",
  ACTION_SEARCH_CURRENT_ITEM_UPDATE: "ACTION_SEARCH_CURRENT_ITEM_UPDATE",
  SEARCH_TOGGLE_MARKS: "SEARCH_TOGGLE_MARKS",
  FETCH_SEARCH_DICTIONARY: "FETCH_SEARCH_DICTIONARY",
  FETCH_SEARCH_DICTIONARY_SUCCESS: "FETCH_SEARCH_DICTIONARY_SUCCESS"
}, actions/* _sharedActionsConstantsSearch */.k);
var searchActions = _objectSpread({
  search: function search(data, onSuccess) {
    return {
      type: searchActionConstants.ACTION_SEARCH,
      data: {
        actionSearchParams: data,
        onSuccess: onSuccess
      }
    };
  },
  searchCurrentItemUpdate: function searchCurrentItemUpdate(data) {
    return {
      type: searchActionConstants.ACTION_SEARCH_CURRENT_ITEM_UPDATE,
      data: data
    };
  },
  searchSuccess: function searchSuccess(data) {
    return {
      type: searchActionConstants.SEARCH_SUCCESS,
      data: data
    };
  },
  searchClear: function searchClear() {
    return {
      type: searchActionConstants.SEARCH_CLEAR
    };
  },
  reset: function reset() {
    return {
      type: searchActionConstants.RESET
    };
  },
  searchToggleMarks: function searchToggleMarks() {
    return {
      type: searchActionConstants.SEARCH_TOGGLE_MARKS
    };
  },
  searchDictionary: function searchDictionary(query, dictionary) {
    return {
      type: searchActionConstants.FETCH_SEARCH_DICTIONARY,
      data: {
        query: query,
        dictionary: dictionary
      }
    };
  },
  searchDictionarySuccess: function searchDictionarySuccess(params, results) {
    return {
      type: searchActionConstants.FETCH_SEARCH_DICTIONARY_SUCCESS,
      data: {
        params: params,
        results: results
      }
    };
  }
}, actions/* _sharedActionsSearch */.F);
// EXTERNAL MODULE: ../shared/store/player/actions.js
var player_actions = __webpack_require__(16360);
;// CONCATENATED MODULE: ./src/next/store/actions/player.actions.js

var playerActionConstants = player_actions/* _sharedActionsConstantsPlayer */.c;
var playerActions = (/* unused pure expression or super */ null && (_sharedActionsPlayer));
// EXTERNAL MODULE: ./src/next/store/actions/system.actions.js
var system_actions = __webpack_require__(63436);
// EXTERNAL MODULE: ./src/next/store/actions/relevantSearch.actions.js
var relevantSearch_actions = __webpack_require__(17652);
// EXTERNAL MODULE: ./src/next/store/actions/settings.actions.js
var settings_actions = __webpack_require__(90487);
// EXTERNAL MODULE: ./src/next/store/actions/mainTree.actions.js
var mainTree_actions = __webpack_require__(97541);
// EXTERNAL MODULE: ../shared/store/support/actions.js
var support_actions = __webpack_require__(97580);
;// CONCATENATED MODULE: ./src/next/store/actions/support.actions.js
function support_actions_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function support_actions_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? support_actions_ownKeys(Object(source), !0).forEach(function (key) { support_actions_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : support_actions_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function support_actions_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var supportActionConstants = support_actions_objectSpread({}, support_actions/* _sharedActionsConstantsSupport */.Z);
var supportActions = support_actions_objectSpread({}, support_actions/* _sharedActionsSupport */._);
// EXTERNAL MODULE: ../shared/store/paragraphs/actions.js
var paragraphs_actions = __webpack_require__(9206);
;// CONCATENATED MODULE: ./src/next/store/actions/paragraphsReducer.actions.js
function paragraphsReducer_actions_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function paragraphsReducer_actions_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? paragraphsReducer_actions_ownKeys(Object(source), !0).forEach(function (key) { paragraphsReducer_actions_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : paragraphsReducer_actions_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function paragraphsReducer_actions_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var paragraphsReducerConstants = paragraphsReducer_actions_objectSpread(paragraphsReducer_actions_objectSpread({}, paragraphs_actions/* _sharedActionsConstantsParagraphs */.X), {}, {
  FETCH_CHAPTER_PARAS: "paras/FETCH_CHAPTER_PARAS"
});
var paragraphsReducerActions = paragraphsReducer_actions_objectSpread(paragraphsReducer_actions_objectSpread({}, paragraphs_actions/* _sharedActionsParagraphs */.e), {}, {
  fetchParas: function fetchParas(chapterId, highlight, onResponseNotIncludesRequestedChapterId) {
    return {
      type: paragraphsReducerConstants.FETCH_CHAPTER_PARAS,
      data: {
        chapterId: chapterId,
        highlight: highlight,
        onResponseNotIncludesRequestedChapterId: onResponseNotIncludesRequestedChapterId
      }
    };
  }
});
// EXTERNAL MODULE: ../shared/store/sw/actions.js
var sw_actions = __webpack_require__(38857);
;// CONCATENATED MODULE: ./src/next/store/actions/sw.actions.js

var swActionConstants = sw_actions/* _sharedActionsConstantsSW */.d;
var swActions = sw_actions/* _sharedActionsSW */.m;
// EXTERNAL MODULE: ../shared/store/library/actions.js
var library_actions = __webpack_require__(82900);
;// CONCATENATED MODULE: ./src/next/store/actions/library.actions.js
function library_actions_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function library_actions_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? library_actions_ownKeys(Object(source), !0).forEach(function (key) { library_actions_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : library_actions_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function library_actions_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var libraryActionsConstants = library_actions_objectSpread(library_actions_objectSpread({}, library_actions/* _sharedActionsConstantsLibrary */.G), {}, {
  GET_ID_AND_POSITION_TO_OPEN_BOOK: "GET_ID_AND_POSITION_TO_OPEN_BOOK",
  CANCEL_GET_ID_AND_POSITION_TO_OPEN_BOOK: "CANCEL_GET_ID_AND_POSITION_TO_OPEN_BOOK"
});
var libraryActions = library_actions_objectSpread(library_actions_objectSpread({}, library_actions/* _sharedActionsLibrary */.C), {}, {
  getIdAndPositionToOpenBook: function getIdAndPositionToOpenBook(bookId, isGonnaListen, isUseMLHistory, isUseDefaultHistory, isUseLocalHistory, isFetchNewestHistory, onSuccess) {
    return {
      type: libraryActionsConstants.GET_ID_AND_POSITION_TO_OPEN_BOOK,
      data: {
        bookId: bookId,
        isGonnaListen: isGonnaListen,
        isUseMLHistory: isUseMLHistory,
        isUseDefaultHistory: isUseDefaultHistory,
        isUseLocalHistory: isUseLocalHistory,
        isFetchNewestHistory: isFetchNewestHistory,
        onSuccess: onSuccess
      }
    };
  },
  cancelGetIdAndPositionToOpenBook: function cancelGetIdAndPositionToOpenBook() {
    return {
      type: libraryActionsConstants.CANCEL_GET_ID_AND_POSITION_TO_OPEN_BOOK
    };
  }
});
;// CONCATENATED MODULE: ./src/next/store/actions/index.js











/***/ }),

/***/ 97541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ mainTreeActions; },
/* harmony export */   "n": function() { return /* binding */ mainTreeActionConstants; }
/* harmony export */ });
/* harmony import */ var _shared_store_mainTree_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53882);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var mainTreeActionConstants = _objectSpread(_objectSpread({}, _shared_store_mainTree_actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsMainTree */ .t), {}, {
  FETCH_MAIN_TREE_ALL_DATA: "FETCH_MAIN_TREE_ALL_DATA"
});
var mainTreeActions = _objectSpread(_objectSpread({}, _shared_store_mainTree_actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsMainTree */ .H), {}, {
  fetchMainTreeAllData: function fetchMainTreeAllData(data) {
    return {
      type: mainTreeActionConstants.FETCH_MAIN_TREE_ALL_DATA,
      data: data
    };
  }
});

/***/ }),

/***/ 17652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ relevantSearchActionConstants; },
/* harmony export */   "f": function() { return /* binding */ relevantSearchActions; }
/* harmony export */ });
var relevantSearchActionConstants = {
  FETCH_RELEVANT_SEARCH_SCHEME: "FETCH_RELEVANT_SEARCH_SCHEME",
  FETCH_RELEVANT_SEARCH_SCHEME_SUCCESS: "FETCH_RELEVANT_SEARCH_SCHEME_SUCCESS",
  FETCH_RELEVANT_SEARCH_FACET: "FETCH_RELEVANT_SEARCH_FACET",
  ACTION_CHANGE_RELATED_LANG: "ACTION_CHANGE_RELATED_LANG",
  FETCH_RELEVANT_SEARCH_FACET_AGGREGATE: "FETCH_RELEVANT_SEARCH_FACET_AGGREGATE",
  FETCH_RELEVANT_SEARCH_FACET_AGGREGATE_SUCCESS: "FETCH_RELEVANT_SEARCH_FACET_AGGREGATE_SUCCESS",
  FETCH_RELEVANT_SEARCH_FACET_SUCCESS: "FETCH_RELEVANT_SEARCH_FACET_SUCCESS",
  ACTION_RELATED_TYPE: "ACTION_RELATED_TYPE"
};
var relevantSearchActions = {
  fetchRelevantSearchScheme: function fetchRelevantSearchScheme() {
    return {
      type: relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_SCHEME
    };
  },
  actionChangeRelatedLang: function actionChangeRelatedLang(lang) {
    return {
      type: relevantSearchActionConstants.ACTION_CHANGE_RELATED_LANG,
      data: {
        lang: lang
      }
    };
  },
  fetchRelevantSearchSchemeSuccess: function fetchRelevantSearchSchemeSuccess(sections, relatedLangs) {
    return {
      type: relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_SCHEME_SUCCESS,
      data: {
        sections: sections,
        relatedLangs: relatedLangs
      }
    };
  },
  fetchRelevantSearchFacetAggregate: function fetchRelevantSearchFacetAggregate(lang, query) {
    return {
      type: relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_FACET_AGGREGATE,
      data: {
        lang: lang,
        query: query
      }
    };
  },
  fetchRelevantSearchFacetAggregateSuccess: function fetchRelevantSearchFacetAggregateSuccess(results, lang) {
    return {
      type: relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_FACET_AGGREGATE_SUCCESS,
      data: {
        results: results,
        lang: lang
      }
    };
  }
};

/***/ }),

/***/ 90487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ settingsActionsConstants; },
/* harmony export */   "f": function() { return /* binding */ settingsActions; }
/* harmony export */ });
/* harmony import */ var _shared_store_settings_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58538);

var settingsActionsConstants = _shared_store_settings_actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsSettings */ .u;
var settingsActions = _shared_store_settings_actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsSettings */ .a;

/***/ }),

/***/ 63436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ systemActionsConstants; },
/* harmony export */   "n": function() { return /* binding */ systemActions; }
/* harmony export */ });
/* harmony import */ var _shared_store_system_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93893);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var systemActionsConstants = _objectSpread(_objectSpread({}, _shared_store_system_actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsSystem */ .v), {}, {
  SET_SHOW_SIDE_MENU: "SET_SHOW_SIDE_MENU",
  SET_SHOW_SEARCH_PANEL: "SET_SHOW_SEARCH_PANEL",
  SET_SHOW_ADV_SEARCH_PANEL: "SET_SHOW_ADV_SEARCH_PANEL",
  SET_SHOW_PANEL_BOOK_TRANSLATIONS: "SET_SHOW_PANEL_BOOK_TRANSLATIONS",
  SET_SHOW_PANEL_BOOK_CONTENTS: "SET_SHOW_PANEL_BOOK_CONTENTS",
  ACTION_HIDE_ALL: "ACTION_HIDE_ALL",
  ACTION_COPY: "ACTION_COPY"
});
var systemActions = _objectSpread(_objectSpread({}, _shared_store_system_actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsSystem */ .g), {}, {
  setShowSearchPanel: function setShowSearchPanel(data) {
    return {
      type: systemActionsConstants.SET_SHOW_SEARCH_PANEL,
      data: data
    };
  },
  setShowPanelBookTranslations: function setShowPanelBookTranslations(data) {
    return {
      type: systemActionsConstants.SET_SHOW_PANEL_BOOK_TRANSLATIONS,
      data: data
    };
  },
  setShowPanelBookContents: function setShowPanelBookContents(data) {
    return {
      type: systemActionsConstants.SET_SHOW_PANEL_BOOK_CONTENTS,
      data: data
    };
  },
  setShowAdvSearchPanel: function setShowAdvSearchPanel(data) {
    return {
      type: systemActionsConstants.SET_SHOW_ADV_SEARCH_PANEL,
      data: data
    };
  },
  setShowSideMenu: function setShowSideMenu(data) {
    return {
      type: systemActionsConstants.SET_SHOW_SIDE_MENU,
      data: data
    };
  },
  actionHideAll: function actionHideAll() {
    return {
      type: systemActionsConstants.ACTION_HIDE_ALL
    };
  },

  /**
   * @param text
   * @param {{
   *   noToast?: boolean,
   *   successMessage?: string,
   *   errorMessage?: string,
   * }} options
   */
  actionCopy: function actionCopy(text) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return {
      type: systemActionsConstants.ACTION_COPY,
      data: {
        text: text,
        options: options
      }
    };
  }
});

/***/ }),

/***/ 4164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ tocActionsConstants; },
/* harmony export */   "b": function() { return /* binding */ tocActions; }
/* harmony export */ });
/* harmony import */ var _shared_store_toc_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85939);

var tocActionsConstants = _shared_store_toc_actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsToc */ .g;
var tocActions = _shared_store_toc_actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsToc */ .v;

/***/ }),

/***/ 84257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zs": function() { return /* binding */ MenuItemsList; },
/* harmony export */   "kl": function() { return /* binding */ MainMenuItem; },
/* harmony export */   "rV": function() { return /* binding */ goToFullAppLabel; },
/* harmony export */   "sd": function() { return /* binding */ MenuItems; }
/* harmony export */ });
/* harmony import */ var src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37462);
/* harmony import */ var _shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35567);
/* harmony import */ var _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59916);
/* harmony import */ var _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46072);




var goToFullAppLabel = "goToFullApp";
var MenuItems = {
  allCollection: {
    add_class: "all-collections",
    url: "/",
    id: "/",
    label: "allCollection",
    locations: [_shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.BREADCRUMBS */ .u.BREADCRUMBS, _shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.MENU */ .u.MENU],
    onlyAuth: false
  },
  subscription: {
    add_class: "subscription",
    url: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.subscription */ .h.subscription,
    id: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.subscription */ .h.subscription,
    label: "subscriptions",
    locations: [_shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.BREADCRUMBS */ .u.BREADCRUMBS, _shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.MENU */ .u.MENU],
    onlyAuth: true
  },
  moreAboutUs: {
    add_class: "info",
    url: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.about */ .h.about,
    id: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.about */ .h.about,
    label: "whatIsEGW",
    locations: [_shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.HOME */ .u.HOME, _shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.BREADCRUMBS */ .u.BREADCRUMBS, _shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.MENU */ .u.MENU],
    onlyAuth: false
  },
  about: {
    add_class: "biography",
    url: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .EXTERNAL_URLS.about */ .wk.about,
    id: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .EXTERNAL_URLS.about */ .wk.about,
    newTab: true,
    label: "aboutEW",
    locations: [_shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.BREADCRUMBS */ .u.BREADCRUMBS, _shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.MENU */ .u.MENU],
    onlyAuth: false
  },
  donate: {
    add_class: "donate",
    url: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .EXTERNAL_URLS.donate */ .wk.donate,
    id: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .EXTERNAL_URLS.donate */ .wk.donate,
    newTab: true,
    label: "supportOur",
    locations: [_shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.HOME */ .u.HOME, _shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.BREADCRUMBS */ .u.BREADCRUMBS, _shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.MENU */ .u.MENU],
    onlyAuth: false
  },
  faq: {
    add_class: "faq",
    url: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .EXTERNAL_URLS.faq */ .wk.faq,
    id: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .EXTERNAL_URLS.faq */ .wk.faq,
    newTab: true,
    label: "shortFaq",
    shortLabel: "shortFaq",
    locations: [_shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.BREADCRUMBS */ .u.BREADCRUMBS, _shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.MENU */ .u.MENU],
    onlyAuth: false
  },
  bibliography: {
    icon: src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ABC */ .Z.ABC,
    label: "bibliography",
    url: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .URLS.bibliography */ .ns.bibliography,
    id: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .URLS.bibliography */ .ns.bibliography,
    locations: [_shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.MENU */ .u.MENU]
  },
  contactUs: {
    add_class: "contact-us",
    url: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.contactUs */ .h.contactUs,
    id: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.contactUs */ .h.contactUs,
    label: "contactUs",
    locations: [_shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.BREADCRUMBS */ .u.BREADCRUMBS, _shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.MENU */ .u.MENU],
    onlyAuth: false
  },
  goToFullApp: {
    id: "fullVersionLink",
    url: "fullVersionLink",
    newTab: false,
    icon: src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["go-to-full-app"] */ .Z["go-to-full-app"],
    label: goToFullAppLabel,
    locations: [_shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.MENU */ .u.MENU],
    add_class: "goToFullApp"
  },
  settings: {
    add_class: "settings",
    label: "settings",
    id: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.settings */ .h.settings,
    url: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.settings */ .h.settings,
    onlyAuth: true,
    locations: [_shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.BREADCRUMBS */ .u.BREADCRUMBS, _shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.MENU */ .u.MENU]
  },
  login: {
    icon: src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_0__/* ["default"].profile */ .Z.profile,
    label: "login",
    id: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .URLS.login */ .ns.login,
    onlyNoAuth: true,
    locations: [_shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.MENU */ .u.MENU]
  },
  logout: {
    icon: src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_0__/* ["default"].profile */ .Z.profile,
    label: "logout",
    id: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .URLS.logout */ .ns.logout,
    onlyAuth: true,
    locations: [_shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.MENU */ .u.MENU]
  },
  bibliographyEgw: {
    url: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.bibliographyEgw */ .h.bibliographyEgw,
    id: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.bibliographyEgw */ .h.bibliographyEgw,
    label: "egwBibliography",
    locations: [_shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.BREADCRUMBS */ .u.BREADCRUMBS],
    onlyAuth: false
  },
  bibliographyBible: {
    url: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.bibliographyBible */ .h.bibliographyBible,
    id: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.bibliographyBible */ .h.bibliographyBible,
    label: "bibleBibliography",
    locations: [_shared_utils_menu__WEBPACK_IMPORTED_MODULE_1__/* .MENU_ITEM_LOCATION.BREADCRUMBS */ .u.BREADCRUMBS],
    onlyAuth: false
  },
  search: {
    url: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.search */ .h.search,
    id: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.search */ .h.search,
    label: "searchResults",
    locations: [],
    onlyAuth: false
  },
  searchLocal: {
    url: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.searchLocal */ .h.searchLocal,
    id: _routes_routes_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_URLS.searchLocal */ .h.searchLocal,
    label: "search",
    locations: [],
    onlyAuth: false
  },
  privacyPolicy: {
    label: "privacyPolicy",
    id: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .URLS.privacyPolicy */ .ns.privacyPolicy,
    locations: []
  },
  copirightNotice: {
    label: "copirightNotice",
    id: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .URLS.copirightNotice */ .ns.copirightNotice,
    locations: []
  },
  userAgreement: {
    label: "userAgreement",
    id: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .URLS.userAgreement */ .ns.userAgreement,
    locations: []
  },
  offline: {
    label: "books",
    id: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .URLS.offline */ .ns.offline,
    locations: []
  }
};
var MenuItemsList = Object.values(MenuItems);
var MainMenuItem = {
  url: "/",
  id: "/",
  label: "main",
  children: MenuItemsList
};

/***/ }),

/***/ 59055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ isLandingApp; }
/* harmony export */ });
/* unused harmony export getLandingMapOriginToBookId */
/* harmony import */ var _shared_utils_assembly__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76732);
/* provided dependency */ var process = __webpack_require__(27061);
 // use flag, bcz it's often case when Book.site accidentally becomes Next application.

var IS_BOOK_SITE = true;
var isLandingApp = function isLandingApp() {
  return (0,_shared_utils_assembly__WEBPACK_IMPORTED_MODULE_0__/* .isDevelopment */ .yG)() ? IS_BOOK_SITE : (0,_shared_utils_assembly__WEBPACK_IMPORTED_MODULE_0__/* .getEvnVariable */ .AK)("REACT_APP_IS_LANDING", process.env.REACT_APP_IS_LANDING) === "true";
};
var getLandingMapOriginToBookId = function getLandingMapOriginToBookId() {
  var value = getEvnVariable("REACT_APP_LANDING_MAP_HOST_TO_BOOK_ID", process.env.REACT_APP_LANDING_MAP_HOST_TO_BOOK_ID, "{}");

  try {
    return JSON.parse(value);
  } catch (e) {
    console.log("[LANDING] Error parse REACT_APP_LANDING_MAP_HOST_TO_BOOK_ID", {
      value: value
    });
    return {};
  }
};

/***/ }),

/***/ 13257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$F": function() { return /* binding */ idCategoryCOA; },
/* harmony export */   "QR": function() { return /* binding */ LANDING_SELECTORS; },
/* harmony export */   "SP": function() { return /* binding */ MAP_BOOKS_SET_ID_TO_ICON_ID; },
/* harmony export */   "c2": function() { return /* binding */ MAP_LANDING_BOOKS_SET_ID_TO_CONFIG; },
/* harmony export */   "pH": function() { return /* binding */ _old_idCategoryLOF; },
/* harmony export */   "ts": function() { return /* binding */ idCategoryCONFLICT; },
/* harmony export */   "v_": function() { return /* binding */ idCategoryRPRAC; }
/* harmony export */ });
/* unused harmony exports BODY_CN_LANDING, idCategoryTESTIMONIES, LANDING_VIEW, TYPE_BOOKS_SET, TYPES_BOOKS_SET, LANDING_SEPARATOR_TYPE_BOOKS_SET, LANDING_SEPARATOR_VIEW, LandingViewDefault, MAP_LANDING_VIEW_ID_TO_CONFIG, SINGLE_BOOKS, normalizeLandingBook */
/* harmony import */ var _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93752);
/* harmony import */ var _shared_components_Button_Button_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29718);
/* harmony import */ var src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37462);
/* harmony import */ var _shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76439);
var _MAP_LANDING_VIEW_ID_, _MAP_LANDING_BOOKS_SE, _MAP_BOOKS_SET_ID_TO_;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var BODY_CN_LANDING = "is-landing";
var idCategoryTESTIMONIES = "testimonies_for_the_church";
var idCategoryRPRAC = "real_peace_real_answers_collection";
var idCategoryCONFLICT = "1469";
var idCategoryCOA = "conflict_of_the_ages_series";
var _old_idCategoryLOF = "the_life_of_faith_collection";
var idCategoryLOF = "the_light_and_life_collection";
var LANDING_VIEW = {
  primary: "primary",
  sda: "sda",
  big: "big"
};
var TYPE_BOOKS_SET = {
  categories: "c",
  folders: "f",
  titles: "t"
};
var TYPES_BOOKS_SET = Object.values(TYPE_BOOKS_SET);
var LANDING_SEPARATOR_TYPE_BOOKS_SET = "/";
var LANDING_SEPARATOR_VIEW = "-";
var LandingViewDefault = LANDING_VIEW.primary;
var MAP_LANDING_VIEW_ID_TO_CONFIG = (_MAP_LANDING_VIEW_ID_ = {}, _defineProperty(_MAP_LANDING_VIEW_ID_, LANDING_VIEW.primary, {
  defaultTheme: _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_0__/* .Theme.dg.id */ .Q2.dg.id,
  hasDarkMode: true,
  splashAsImage: false,
  buttonVariant: _shared_components_Button_Button_constants__WEBPACK_IMPORTED_MODULE_1__/* .BUTTON_VARIANT.outline */ .RN.outline,
  buttonColor: _shared_components_Button_Button_constants__WEBPACK_IMPORTED_MODULE_1__/* .BUTTON_COLOR.light */ .tY.light,
  withLinkInAuthorSection: false,
  withAdventistContainerInFooter: false
}), _defineProperty(_MAP_LANDING_VIEW_ID_, LANDING_VIEW.sda, {
  defaultTheme: _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_0__/* .Theme.ls.id */ .Q2.ls.id,
  imagesSubFolder: "sda",
  splashAsImage: true,
  isArrowVariantNotSecondary: true,
  buttonVariant: _shared_components_Button_Button_constants__WEBPACK_IMPORTED_MODULE_1__/* .BUTTON_VARIANT.outline */ .RN.outline,
  buttonColor: _shared_components_Button_Button_constants__WEBPACK_IMPORTED_MODULE_1__/* .BUTTON_COLOR.quaternary */ .tY.quaternary,
  withLinkInAuthorSection: true,
  withAdventistContainerInFooter: true
}), _MAP_LANDING_VIEW_ID_);
var ConfigLOF = {
  title: "The Life of Faith Collection",
  titleMoreBooks: "<i>The Life of Faith</i> Series",
  titleShort: "LOF",
  backgroundColor: "#442A56",
  order: _defineProperty({}, _shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_3__/* .LANG_CODE_EN */ .vh, [108, 150, 15, 135, 29])
};
var SINGLE_BOOKS = (/* unused pure expression or super */ null && (["12280"]));
var MAP_LANDING_BOOKS_SET_ID_TO_CONFIG = (_MAP_LANDING_BOOKS_SE = {}, _defineProperty(_MAP_LANDING_BOOKS_SE, idCategoryTESTIMONIES, {
  title: "Testimonies for the Church",
  titleMoreBooks: "<i>The Testimonies for the Church</i> Series",
  titleShort: "TFC",
  backgroundColor: "#013044",
  order: _defineProperty({}, _shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_3__/* .LANG_CODE_EN */ .vh, [116, 120, 119, 114, 113, 118, 117, 112, 115])
}), _defineProperty(_MAP_LANDING_BOOKS_SE, idCategoryCOA, {
  title: "The Conflict of the Ages Series",
  titleMoreBooks: "<i>The Conflict of the Ages</i> Series",
  titleShort: "COA",
  backgroundColor: "#013044",
  order: _defineProperty({}, _shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_3__/* .LANG_CODE_EN */ .vh, [84, 88, 130, 127, 132])
}), _defineProperty(_MAP_LANDING_BOOKS_SE, idCategoryRPRAC, {
  onlyOneLang: true,
  hideLanguagesSection: true,
  withAdventistContainerInFooter: true,
  title: "Real Peace<br>Real Answers<br>Collection",
  titleMoreBooks: "<i>Real Peace Real Answers</i> Collection",
  titleShort: "RPRAC",
  backgroundColor: "#013044",
  order: _defineProperty({}, _shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_3__/* .LANG_CODE_EN */ .vh, [14669, 14661, 14668, 14665, 14664, 14663, 14662, 14667, 14670])
}), _defineProperty(_MAP_LANDING_BOOKS_SE, idCategoryCONFLICT, {
  onlyOneLang: true,
  hideLanguagesSection: true,
  forceShowBuyBook: true,
  withAdventistContainerInFooter: true,
  title: "The Conflict",
  titleMoreBooks: "<i>The Conflict</i> Collection",
  titleShort: "CONFLICT",
  backgroundColor: "#013044",
  order: _defineProperty({}, _shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_3__/* .LANG_CODE_EN */ .vh, [14748, 14749, 14752, 14750, 14753])
}), _defineProperty(_MAP_LANDING_BOOKS_SE, _old_idCategoryLOF, ConfigLOF), _defineProperty(_MAP_LANDING_BOOKS_SE, idCategoryLOF, ConfigLOF), _MAP_LANDING_BOOKS_SE);
var IconIdLOF = src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["the-light-and-life-collection"] */ .Z["the-light-and-life-collection"];
var MAP_BOOKS_SET_ID_TO_ICON_ID = (_MAP_BOOKS_SET_ID_TO_ = {}, _defineProperty(_MAP_BOOKS_SET_ID_TO_, idCategoryCOA, src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["conflict-of-the-ages-series"] */ .Z["conflict-of-the-ages-series"]), _defineProperty(_MAP_BOOKS_SET_ID_TO_, _old_idCategoryLOF, IconIdLOF), _defineProperty(_MAP_BOOKS_SET_ID_TO_, idCategoryLOF, IconIdLOF), _defineProperty(_MAP_BOOKS_SET_ID_TO_, idCategoryRPRAC, IconIdLOF), _defineProperty(_MAP_BOOKS_SET_ID_TO_, idCategoryCONFLICT, IconIdLOF), _defineProperty(_MAP_BOOKS_SET_ID_TO_, idCategoryTESTIMONIES, IconIdLOF), _MAP_BOOKS_SET_ID_TO_);
var LANDING_SELECTORS = {
  btnOpen: "#btnOpen",
  btnQR: ".btnQR",
  btnQRSmall: ".btnQRSmall",
  readBookBtn: ".readBookBtn",
  listenBookBtn: "#listenBookBtn",
  pdfBookBtn: "#pdfBookBtn",
  ePubBookBtn: "#ePubBookBtn",
  bookCoverClass: ".bookCoverClass",
  buttonArrowClass: ".buttonArrowClass",
  typographyCroppedClass: ".typographyCroppedClass",
  typoCropParaGhostClass: ".typoCropParaGhostClass",
  typoCropParaClass: ".typoCropParaClass",
  bookListWithLangID: "#bookListWithLangID",
  bookListWithArrowsClass: ".bookListWithArrowsClass",
  availableLanguagesBtnClass: ".availableLanguagesBtnClass",
  langDialogRootClass: ".langDialogRootClass",
  langDialogBackdrop: "#langDialogBackdrop",
  langDialogWrapperClass: ".langDialogWrapperClass",
  langDialogItemClass: ".langDialogItemClass",
  bookInfoClass: ".bookInfoClass",
  bookCarouselWrapperId: "#bookCarouselWrapperId",
  bookCarouselItemClass: ".bookCarouselItemClass",
  bookCarouselPrevId: "#bookCarouselPrevId",
  bookCarouselNextId: "#bookCarouselNextId",
  bookCarouselCurrentId: "#bookCarouselCurrentId",
  buttonInstallPWA: ".buttonInstallPWA",
  buttonShare: ".buttonShare",
  mobileMenuBlock: "#mobileMenuBlock"
};

var normalizeLandingBookTitle = function normalizeLandingBookTitle(title) {
  return title.replace(/ *\(ADAPTED\) */gi, "");
};

var normalizeLandingBook = function normalizeLandingBook(book) {
  return _objectSpread(_objectSpread({}, book), {}, {
    translated_into: [],
    chapters: [],
    title: normalizeLandingBookTitle(book.title)
  });
};

/***/ }),

/***/ 56938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Py": function() { return /* binding */ filterByLangAndSortBookTitles; }
/* harmony export */ });
/* unused harmony exports isLandingIdTypeBooksSet, getBookSetConfigByBookIdOriginal, getBookSetIdByBookIdOriginal */
/* harmony import */ var _utils_landing_landing_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13257);
/* harmony import */ var _shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76439);


var isLandingIdTypeBooksSet = function isLandingIdTypeBooksSet(landingId) {
  if (!landingId) {
    return false;
  }

  return TYPES_BOOKS_SET.some(function (type) {
    return landingId.startsWith(type + LANDING_SEPARATOR_TYPE_BOOKS_SET);
  });
};
var getBookSetConfigByBookIdOriginal = function getBookSetConfigByBookIdOriginal(bookIdOriginal) {
  var nBookIdOriginal = parseInt(bookIdOriginal);
  return Object.values(MAP_LANDING_BOOKS_SET_ID_TO_CONFIG).find(function (config) {
    return config.order[LANG_CODE_EN].includes(nBookIdOriginal);
  });
};
var getBookSetIdByBookIdOriginal = function getBookSetIdByBookIdOriginal(bookIdOriginal) {
  var nBookIdOriginal = parseInt(bookIdOriginal);
  return Object.keys(MAP_LANDING_BOOKS_SET_ID_TO_CONFIG).find(function (id) {
    return MAP_LANDING_BOOKS_SET_ID_TO_CONFIG[id].order[LANG_CODE_EN].includes(nBookIdOriginal);
  });
};

var filterBookTitlesByLang = function filterBookTitlesByLang(bookTitles, lang) {
  if (!bookTitles) {
    return null;
  }

  if (!lang) {
    return bookTitles;
  }

  var suitableBookTitles = bookTitles.filter(function (b) {
    return b.lang === lang;
  });
  return suitableBookTitles.length ? suitableBookTitles : bookTitles.filter(function (b) {
    return b.lang === _shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_LANGUAGE */ .k$;
  });
};

var getBookENIdNormalized = function getBookENIdNormalized(book) {
  return book !== null && book !== void 0 && book.idEn ? +book.idEn.substring(1) : book.book_id;
};

var sortBookTitlesByBookSetConfig = function sortBookTitlesByBookSetConfig(bookTitles, bookSetConfig, orderLangPreferred) {
  if (bookTitles && bookSetConfig) {
    var order = bookSetConfig.order[orderLangPreferred] || bookSetConfig.order[_shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_LANGUAGE */ .k$];

    if (order) {
      return bookTitles.filter(function (b) {
        return order.includes(getBookENIdNormalized(b));
      }).sort(function (a, b) {
        return order.indexOf(getBookENIdNormalized(a)) > order.indexOf(getBookENIdNormalized(b)) ? 1 : -1;
      });
    }
  }

  return bookTitles;
};

var filterByLangAndSortBookTitles = function filterByLangAndSortBookTitles(bookTitles, config, lang) {
  var listFiltered = config !== null && config !== void 0 && config.onlyOneLang ? bookTitles : filterBookTitlesByLang(bookTitles, lang);
  return sortBookTitlesByBookSetConfig(listFiltered, config, lang);
};

/***/ }),

/***/ 46072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ NEXT_URLS; }
/* harmony export */ });
/* harmony import */ var _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59916);

var bibliography = "/bibliography";
var NEXT_URLS = {
  home: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.home */ .ns.home,
  allCollection: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.allCollection */ .ns.allCollection,
  studyCenter: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.studyCenter */ .ns.studyCenter,
  subscription: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.subscription */ .ns.subscription,
  read: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.read */ .ns.read,
  bookInfo: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.book */ .ns.book,
  search: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.textSearchResults */ .ns.textSearchResults,
  searchLocal: "/search-local",
  contactUs: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.contactus */ .ns.contactus,
  settings: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.settings */ .ns.settings,
  about: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.about */ .ns.about,
  searchFilters: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.searchFilters */ .ns.searchFilters,
  bibliography: bibliography,
  bibliographyEgw: bibliography + "?type=egw",
  bibliographyBible: bibliography + "?type=bible",
  copirightNotice: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.copirightNotice */ .ns.copirightNotice,
  privacyPolicy: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.privacyPolicy */ .ns.privacyPolicy,
  userAgreement: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.userAgreement */ .ns.userAgreement,
  offline: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.offline */ .ns.offline,
  apiAuthCallback: "/api/authCallback",
  apiGetNextPWAConfig: "/api/getPWAConfig",
  apiGetToken: "/api/getToken",
  apiRobots: "/api/robots",
  apiStatus: "/api/status"
};

/***/ }),

/***/ 69994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dw": function() { return /* binding */ makeShareChapterUrl; },
/* harmony export */   "ME": function() { return /* binding */ makeChapterUrl; },
/* harmony export */   "Q_": function() { return /* binding */ makeBookUrl; }
/* harmony export */ });
/* harmony import */ var _shared_utils_content_content__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69051);
/* harmony import */ var _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59916);
/* harmony import */ var _routes_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46072);
/* harmony import */ var _components_Reader_Panel_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78430);




var makeChapterUrl = function makeChapterUrl(idOrIds) {
  var activeIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var isObject = arguments.length > 2 ? arguments[2] : undefined;
  var pathname = _routes_constants__WEBPACK_IMPORTED_MODULE_2__/* .NEXT_URLS.read */ .h.read + "/" + (Array.isArray(idOrIds) ? idOrIds[0] : idOrIds);
  var query = "";

  if (Array.isArray(idOrIds) && idOrIds[1]) {
    query = _components_Reader_Panel_constants__WEBPACK_IMPORTED_MODULE_3__/* .ReaderQueryParam.panelSecond */ .Fd.panelSecond + "=" + idOrIds[1] + "&" + _components_Reader_Panel_constants__WEBPACK_IMPORTED_MODULE_3__/* .ReaderQueryParam.indexPanelActive */ .Fd.indexPanelActive + "=" + activeIndex;
  }

  if (isObject) {
    return {
      pathname: pathname,
      query: query
    };
  }

  return pathname + (query ? "?" + query : "");
};
var makeBookUrl = function makeBookUrl(id) {
  return _routes_constants__WEBPACK_IMPORTED_MODULE_2__/* .NEXT_URLS.bookInfo */ .h.bookInfo + "/" + (0,_shared_utils_content_content__WEBPACK_IMPORTED_MODULE_0__/* .getBookIdWithPrefix */ .NR)(id);
};
var makeShareChapterUrl = function makeShareChapterUrl(basePath, id) {
  return (0,_shared_utils_url_url__WEBPACK_IMPORTED_MODULE_1__/* .getBaseHost */ .UO)() + basePath + _routes_constants__WEBPACK_IMPORTED_MODULE_2__/* .NEXT_URLS.read */ .h.read + "/" + id;
};

/***/ }),

/***/ 95655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ SEARCH_PARAM_QUERY_NAME; }
/* harmony export */ });
var SEARCH_PARAM_QUERY_NAME = "query";

/***/ }),

/***/ 91241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zv": function() { return /* binding */ getDefaultSettingsNextApp; },
  "qp": function() { return /* binding */ getStoredSettingsNextApp; },
  "fT": function() { return /* binding */ validateSettingNextApp; },
  "sC": function() { return /* binding */ validateSettingsNextApp; }
});

// EXTERNAL MODULE: ../shared/utils/settings/constants.js + 1 modules
var constants = __webpack_require__(20467);
// EXTERNAL MODULE: ../shared/utils/settings/settings.js
var settings_settings = __webpack_require__(19819);
// EXTERNAL MODULE: ../shared/utils/theme/theme.js + 1 modules
var theme = __webpack_require__(93752);
// EXTERNAL MODULE: ./src/next/utils/theme.js
var utils_theme = __webpack_require__(12621);
// EXTERNAL MODULE: ../shared/utils/settings/validators.js
var validators = __webpack_require__(38175);
;// CONCATENATED MODULE: ./src/next/utils/settings/constants.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var LITE_APP_SETTINGS_VALIDATORS = _objectSpread(_objectSpread({}, validators/* SETTINGS_VALIDATORS */.ik), {}, _defineProperty({}, constants/* SETTING.themeMode.id */.Fy.themeMode.id, function (v) {
  return v in theme/* Theme */.Q2 && utils_theme/* ThemesEasyModeApp.includes */.Yd.includes(theme/* Theme */.Q2[v]);
}));
var LANDING_APP_SETTINGS_VALIDATORS = _objectSpread(_objectSpread({}, validators/* SETTINGS_VALIDATORS */.ik), {}, _defineProperty({}, constants/* SETTING.themeMode.id */.Fy.themeMode.id, function (v) {
  return v in theme/* Theme */.Q2 && utils_theme/* ThemesLandingApp.includes */.D8.includes(theme/* Theme */.Q2[v]);
}));
var LITE_APP_DEFAULT_SETTINGS_OVERRIDE_MAP = _defineProperty({}, constants/* SETTING.themeMode.id */.Fy.themeMode.id, utils_theme/* DefaultThemeIdEasyModeApp */.Pt);
var LANDING_APP_DEFAULT_SETTINGS_OVERRIDE_MAP = _defineProperty({}, constants/* SETTING.themeMode.id */.Fy.themeMode.id, utils_theme/* DefaultThemeIdLandingApp */.zG);
// EXTERNAL MODULE: ./src/next/utils/assembly.js
var assembly = __webpack_require__(59055);
;// CONCATENATED MODULE: ./src/next/utils/settings/settings.js





var _validateSettingsEasyModeApp = function _validateSettingsEasyModeApp(settings, holderFixedSettings) {
  return (0,settings_settings/* _validateSettings */.t4)(settings, LITE_APP_SETTINGS_VALIDATORS, LITE_APP_DEFAULT_SETTINGS_OVERRIDE_MAP, holderFixedSettings);
};

var _validateSettingsLandingApp = function _validateSettingsLandingApp(settings, holderFixedSettings) {
  return (0,settings_settings/* _validateSettings */.t4)(settings, LANDING_APP_SETTINGS_VALIDATORS, LANDING_APP_DEFAULT_SETTINGS_OVERRIDE_MAP, holderFixedSettings);
};

var validateSettingsNextApp = function validateSettingsNextApp(settings, holderFixedSettings) {
  return (0,assembly/* isLandingApp */.c)() ? _validateSettingsLandingApp(settings, holderFixedSettings) : _validateSettingsEasyModeApp(settings, holderFixedSettings);
};

var _validateSettingEasyModeApp = function _validateSettingEasyModeApp(id, value, holderFixedSettings) {
  return (0,settings_settings/* _validateSetting */.ty)(id, value, LITE_APP_SETTINGS_VALIDATORS, LITE_APP_DEFAULT_SETTINGS_OVERRIDE_MAP, holderFixedSettings);
};

var _validateSettingLandingApp = function _validateSettingLandingApp(id, value, holderFixedSettings) {
  return (0,settings_settings/* _validateSetting */.ty)(id, value, LANDING_APP_SETTINGS_VALIDATORS, LANDING_APP_DEFAULT_SETTINGS_OVERRIDE_MAP, holderFixedSettings);
};

var validateSettingNextApp = function validateSettingNextApp(id, value, holderFixedSettings) {
  return (0,assembly/* isLandingApp */.c)() ? _validateSettingLandingApp(id, value, holderFixedSettings) : _validateSettingEasyModeApp(id, value, holderFixedSettings);
};

var _getStoredSettingsEasyModeApp = function _getStoredSettingsEasyModeApp() {
  return (0,settings_settings/* _getStoredSettings */.b9)(constants/* SETTING_LOCATION.NEXT_APP */.MU.NEXT_APP, LITE_APP_DEFAULT_SETTINGS_OVERRIDE_MAP);
};

var _getStoredSettingsLandingApp = function _getStoredSettingsLandingApp() {
  return (0,settings_settings/* _getStoredSettings */.b9)(constants/* SETTING_LOCATION.NEXT_APP */.MU.NEXT_APP, LANDING_APP_DEFAULT_SETTINGS_OVERRIDE_MAP);
};

var getStoredSettingsNextApp = function getStoredSettingsNextApp() {
  return (0,assembly/* isLandingApp */.c)() ? _getStoredSettingsLandingApp() : _getStoredSettingsEasyModeApp();
};

var _getDefaultSettingsEasyModeApp = function _getDefaultSettingsEasyModeApp() {
  return (0,settings_settings/* _getDefaultSettings */.xB)(constants/* SETTING_LOCATION.NEXT_APP */.MU.NEXT_APP, LITE_APP_DEFAULT_SETTINGS_OVERRIDE_MAP);
};

var _getDefaultSettingsLandingApp = function _getDefaultSettingsLandingApp() {
  return (0,settings_settings/* _getDefaultSettings */.xB)(constants/* SETTING_LOCATION.NEXT_APP */.MU.NEXT_APP, LANDING_APP_DEFAULT_SETTINGS_OVERRIDE_MAP);
};

var getDefaultSettingsNextApp = function getDefaultSettingsNextApp() {
  return (0,assembly/* isLandingApp */.c)() ? _getDefaultSettingsLandingApp() : _getDefaultSettingsEasyModeApp();
};

/***/ }),

/***/ 12621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D8": function() { return /* binding */ ThemesLandingApp; },
/* harmony export */   "Pt": function() { return /* binding */ DefaultThemeIdEasyModeApp; },
/* harmony export */   "Yd": function() { return /* binding */ ThemesEasyModeApp; },
/* harmony export */   "zG": function() { return /* binding */ DefaultThemeIdLandingApp; }
/* harmony export */ });
/* harmony import */ var _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93752);

var ThemesEasyModeApp = _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_0__/* .Themes.filter */ .b3.filter(function (theme) {
  return theme.location.includes(_shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_0__/* .ThemeLocations.NEXT_APP */ .Op.NEXT_APP);
});
var ThemesLandingApp = _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_0__/* .Themes.filter */ .b3.filter(function (theme) {
  return theme.location.includes(_shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_0__/* .ThemeLocations.LANDING_APP */ .Op.LANDING_APP);
});
var DefaultThemeIdLandingApp = _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_0__/* .Theme.dg.id */ .Q2.dg.id;
var DefaultThemeIdEasyModeApp = _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_0__/* .Theme.dm.id */ .Q2.dm.id;

/***/ }),

/***/ 5772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(34412);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(60098);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(86677);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(86248);
// EXTERNAL MODULE: ./next-i18next.config.js
var next_i18next_config = __webpack_require__(67084);
var next_i18next_config_default = /*#__PURE__*/__webpack_require__.n(next_i18next_config);
// EXTERNAL MODULE: ./src/next/contexts/auth.js
var auth = __webpack_require__(89284);
// EXTERNAL MODULE: ./src/next/contexts/subscriptions.js + 1 modules
var subscriptions = __webpack_require__(36895);
// EXTERNAL MODULE: ../shared/contexts/modal.js
var modal = __webpack_require__(26933);
// EXTERNAL MODULE: ./src/next/contexts/history.js
var contexts_history = __webpack_require__(84847);
// EXTERNAL MODULE: ./src/next/contexts/pageProps.js
var contexts_pageProps = __webpack_require__(2978);
;// CONCATENATED MODULE: ./src/next/contexts/index.js





// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(64649);
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
;// CONCATENATED MODULE: ../node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {}



;// CONCATENATED MODULE: ../node_modules/next-redux-wrapper/es6/index.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


/**
 * Quick note on Next.js return types:
 *
 * Page.getInitialProps https://nextjs.org/docs/api-reference/data-fetching/getInitialProps
 * as-is
 *
 * App.getInitialProps: AppInitialProps https://nextjs.org/docs/advanced-features/custom-app
 * {pageProps: any}
 *
 * getStaticProps https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 * {props: any}
 *
 * getServerSideProps https://nextjs.org/docs/basic-features/data-fetching#getserversideprops-server-side-rendering
 * {props: any}
 */
var HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';
var getIsServer = function () { return typeof window === 'undefined'; };
var getDeserializedState = function (initialState, _a) {
    var _b = _a === void 0 ? {} : _a, deserializeState = _b.deserializeState;
    return deserializeState ? deserializeState(initialState) : initialState;
};
var getSerializedState = function (state, _a) {
    var _b = _a === void 0 ? {} : _a, serializeState = _b.serializeState;
    return serializeState ? serializeState(state) : state;
};
var sharedClientStore;
var initStore = function (_a) {
    var _b, _c, _d;
    var makeStore = _a.makeStore, _e = _a.context, context = _e === void 0 ? {} : _e;
    var createStore = function () { return makeStore(context); };
    if (getIsServer()) {
        var req = ((_b = context) === null || _b === void 0 ? void 0 : _b.req) || ((_d = (_c = context) === null || _c === void 0 ? void 0 : _c.ctx) === null || _d === void 0 ? void 0 : _d.req);
        if (req) {
            // ATTENTION! THIS IS INTERNAL, DO NOT ACCESS DIRECTLY ANYWHERE ELSE
            // @see https://github.com/kirill-konshin/next-redux-wrapper/pull/196#issuecomment-611673546
            if (!req.__nextReduxWrapperStore) {
                req.__nextReduxWrapperStore = createStore();
            }
            return req.__nextReduxWrapperStore;
        }
        return createStore();
    }
    // Memoize store if client
    if (!sharedClientStore) {
        sharedClientStore = createStore();
    }
    return sharedClientStore;
};
var createWrapper = function (makeStore, config) {
    if (config === void 0) { config = {}; }
    var makeProps = function (_a) {
        var callback = _a.callback, context = _a.context, _b = _a.addStoreToContext, addStoreToContext = _b === void 0 ? false : _b;
        return __awaiter(void 0, void 0, void 0, function () {
            var store, nextCallback, initialProps, _c, state;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        store = initStore({ context: context, makeStore: makeStore });
                        if (config.debug) {
                            console.log("1. getProps created store with state", store.getState());
                        }
                        // Legacy stuff - put store in context
                        if (addStoreToContext) {
                            if (context.ctx) {
                                context.ctx.store = store;
                            }
                            else {
                                context.store = store;
                            }
                        }
                        nextCallback = callback && callback(store);
                        _c = nextCallback;
                        if (!_c) return [3 /*break*/, 2];
                        return [4 /*yield*/, nextCallback(context)];
                    case 1:
                        _c = (_d.sent());
                        _d.label = 2;
                    case 2:
                        initialProps = (_c) || {};
                        if (config.debug) {
                            console.log("3. getProps after dispatches has store state", store.getState());
                        }
                        state = store.getState();
                        return [2 /*return*/, {
                                initialProps: initialProps,
                                initialState: getIsServer() ? getSerializedState(state, config) : state,
                            }];
                }
            });
        });
    };
    var getInitialPageProps = function (callback) {
        return function (context) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // context is store — avoid double-wrapping
                if ('getState' in context) {
                    return [2 /*return*/, callback && callback(context)];
                }
                return [2 /*return*/, makeProps({ callback: callback, context: context, addStoreToContext: true })];
            });
        }); };
    };
    var getInitialAppProps = function (callback) {
        return function (context) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, initialProps, initialState;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context, addStoreToContext: true })];
                    case 1:
                        _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                        return [2 /*return*/, __assign(__assign({}, initialProps), { initialState: initialState })];
                }
            });
        }); };
    };
    var getStaticProps = function (callback) {
        return function (context) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, initialProps, initialState;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                    case 1:
                        _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                        return [2 /*return*/, __assign(__assign({}, initialProps), { props: __assign(__assign({}, initialProps.props), { initialState: initialState }) })];
                }
            });
        }); };
    };
    var getServerSideProps = function (callback) {
        return function (context) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getStaticProps(callback)(context)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); };
    }; // just not to repeat myself
    var hydrate = function (store, state) {
        if (!state) {
            return;
        }
        store.dispatch({
            type: HYDRATE,
            payload: getDeserializedState(state, config),
        });
    };
    var useHybridHydrate = function (store, state) {
        var firstRender = (0,react.useRef)(true);
        (0,react.useEffect)(function () {
            firstRender.current = false;
        }, []);
        (0,react.useMemo)(function () {
            // synchronous for server or first time render
            if (getIsServer() || firstRender.current) {
                hydrate(store, state);
            }
        }, [store, state]);
        (0,react.useEffect)(function () {
            // asynchronous for client subsequent navigation
            if (!getIsServer()) {
                hydrate(store, state);
            }
        }, [store, state]);
    };
    var useWrappedStore = function (_a, displayName) {
        var _b, _c;
        if (displayName === void 0) { displayName = 'useWrappedStore'; }
        var initialState = _a.initialState, initialProps = _a.initialProps, props = __rest(_a, ["initialState", "initialProps"]);
        // this happens when App has page with getServerSideProps/getStaticProps, initialState will be dumped twice:
        // one incomplete and one complete
        var initialStateFromGSPorGSSR = (_b = props === null || props === void 0 ? void 0 : props.pageProps) === null || _b === void 0 ? void 0 : _b.initialState;
        if (config.debug) {
            console.log('4.', displayName, 'created new store with', {
                initialState: initialState,
                initialStateFromGSPorGSSR: initialStateFromGSPorGSSR,
            });
        }
        var store = (0,react.useMemo)(function () { return initStore({ makeStore: makeStore }); }, []);
        useHybridHydrate(store, initialState);
        useHybridHydrate(store, initialStateFromGSPorGSSR);
        var resultProps = props;
        // order is important! Next.js overwrites props from pages/_app with getStaticProps from page
        // @see https://github.com/zeit/next.js/issues/11648
        if (initialProps && initialProps.pageProps) {
            resultProps.pageProps = __assign(__assign({}, initialProps.pageProps), props.pageProps);
        }
        // just some cleanup to prevent passing it as props, we need to clone props to safely delete initialState
        if (initialStateFromGSPorGSSR) {
            resultProps = __assign(__assign({}, props), { pageProps: __assign({}, props.pageProps) });
            delete resultProps.pageProps.initialState;
        }
        // unwrap getInitialPageProps
        if ((_c = resultProps === null || resultProps === void 0 ? void 0 : resultProps.pageProps) === null || _c === void 0 ? void 0 : _c.initialProps) {
            resultProps.pageProps = __assign(__assign({}, resultProps.pageProps), resultProps.pageProps.initialProps);
            delete resultProps.pageProps.initialProps;
        }
        return { store: store, props: __assign(__assign({}, initialProps), resultProps) };
    };
    var withRedux = function (Component) {
        console.warn('/!\\ You are using legacy implementaion. Please update your code: use createWrapper() and wrapper.useWrappedStore().');
        //TODO Check if pages/_app was wrapped so there's no need to wrap a page itself
        var WrappedComponent = function (props) {
            var _a = useWrappedStore(props, WrappedComponent.displayName), store = _a.store, combinedProps = _a.props;
            return (react.createElement(es/* Provider */.zt, { store: store },
                react.createElement(Component, __assign({}, combinedProps))));
        };
        WrappedComponent.displayName = "withRedux(".concat(Component.displayName || Component.name || 'Component', ")");
        if ('getInitialProps' in Component) {
            WrappedComponent.getInitialProps = Component.getInitialProps;
        }
        return WrappedComponent;
    };
    return {
        getServerSideProps: getServerSideProps,
        getStaticProps: getStaticProps,
        getInitialAppProps: getInitialAppProps,
        getInitialPageProps: getInitialPageProps,
        withRedux: withRedux,
        useWrappedStore: useWrappedStore,
    };
};
// Legacy
/* harmony default export */ var es6 = (function (makeStore, config) {
    if (config === void 0) { config = {}; }
    console.warn('/!\\ You are using legacy implementaion. Please update your code: use createWrapper() and wrapper.withRedux().');
    return createWrapper(makeStore, config).withRedux;
});
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@redux-saga/symbols/dist/redux-saga-symbols.esm.js
var createSymbol = function createSymbol(name) {
  return "@@redux-saga/" + name;
};

var CANCEL =
/*#__PURE__*/
createSymbol('CANCEL_PROMISE');
var CHANNEL_END_TYPE =
/*#__PURE__*/
createSymbol('CHANNEL_END');
var redux_saga_symbols_esm_IO =
/*#__PURE__*/
createSymbol('IO');
var MATCH =
/*#__PURE__*/
createSymbol('MATCH');
var MULTICAST =
/*#__PURE__*/
createSymbol('MULTICAST');
var redux_saga_symbols_esm_SAGA_ACTION =
/*#__PURE__*/
createSymbol('SAGA_ACTION');
var SELF_CANCELLATION =
/*#__PURE__*/
createSymbol('SELF_CANCELLATION');
var redux_saga_symbols_esm_TASK =
/*#__PURE__*/
createSymbol('TASK');
var TASK_CANCEL =
/*#__PURE__*/
createSymbol('TASK_CANCEL');
var TERMINATE =
/*#__PURE__*/
createSymbol('TERMINATE');
var SAGA_LOCATION =
/*#__PURE__*/
createSymbol('LOCATION');



// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(25773);
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(30808);
;// CONCATENATED MODULE: ../node_modules/@redux-saga/is/dist/redux-saga-is.esm.js


var undef = function undef(v) {
  return v === null || v === undefined;
};
var redux_saga_is_esm_notUndef = function notUndef(v) {
  return v !== null && v !== undefined;
};
var redux_saga_is_esm_func = function func(f) {
  return typeof f === 'function';
};
var number = function number(n) {
  return typeof n === 'number';
};
var redux_saga_is_esm_string = function string(s) {
  return typeof s === 'string';
};
var redux_saga_is_esm_array = Array.isArray;
var redux_saga_is_esm_object = function object(obj) {
  return obj && !redux_saga_is_esm_array(obj) && typeof obj === 'object';
};
var promise = function promise(p) {
  return p && redux_saga_is_esm_func(p.then);
};
var iterator = function iterator(it) {
  return it && redux_saga_is_esm_func(it.next) && redux_saga_is_esm_func(it.throw);
};
var iterable = function iterable(it) {
  return it && redux_saga_is_esm_func(Symbol) ? redux_saga_is_esm_func(it[Symbol.iterator]) : redux_saga_is_esm_array(it);
};
var task = function task(t) {
  return t && t[TASK];
};
var sagaAction = function sagaAction(a) {
  return Boolean(a && a[SAGA_ACTION]);
};
var observable = function observable(ob) {
  return ob && redux_saga_is_esm_func(ob.subscribe);
};
var buffer = function buffer(buf) {
  return buf && redux_saga_is_esm_func(buf.isEmpty) && redux_saga_is_esm_func(buf.take) && redux_saga_is_esm_func(buf.put);
};
var pattern = function pattern(pat) {
  return pat && (redux_saga_is_esm_string(pat) || symbol(pat) || redux_saga_is_esm_func(pat) || redux_saga_is_esm_array(pat) && pat.every(pattern));
};
var redux_saga_is_esm_channel = function channel(ch) {
  return ch && redux_saga_is_esm_func(ch.take) && redux_saga_is_esm_func(ch.close);
};
var stringableFunc = function stringableFunc(f) {
  return redux_saga_is_esm_func(f) && f.hasOwnProperty('toString');
};
var symbol = function symbol(sym) {
  return Boolean(sym) && typeof Symbol === 'function' && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var multicast = function multicast(ch) {
  return redux_saga_is_esm_channel(ch) && ch[MULTICAST];
};
var redux_saga_is_esm_effect = function effect(eff) {
  return eff && eff[IO];
};



;// CONCATENATED MODULE: ../node_modules/@redux-saga/delay-p/dist/redux-saga-delay-p.esm.js


var MAX_SIGNED_INT = 2147483647;
function delayP(ms, val) {
  if (val === void 0) {
    val = true;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/setTimeout#maximum_delay_value
  if (false) {}

  var timeoutId;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(resolve, Math.min(MAX_SIGNED_INT, ms), val);
  });

  promise[CANCEL] = function () {
    clearTimeout(timeoutId);
  };

  return promise;
}

/* harmony default export */ var redux_saga_delay_p_esm = (delayP);

;// CONCATENATED MODULE: ../node_modules/@redux-saga/core/dist/io-c3792963.js





var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue =
/*#__PURE__*/
konst(true);

var noop = function noop() {};

if (false) {}
var identity = function identity(v) {
  return v;
};
var hasSymbol = typeof Symbol === 'function';
var asyncIteratorSymbol = hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : '@@asyncIterator';
function io_c3792963_check(value, predicate, error) {
  if (!predicate(value)) {
    throw new Error(error);
  }
}
var assignWithSymbols = function assignWithSymbols(target, source) {
  (0,esm_extends/* default */.Z)(target, source);

  if (Object.getOwnPropertySymbols) {
    Object.getOwnPropertySymbols(source).forEach(function (s) {
      target[s] = source[s];
    });
  }
};
var flatMap = function flatMap(mapper, arr) {
  var _ref;

  return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function remove(array, item) {
  var index = array.indexOf(item);

  if (index >= 0) {
    array.splice(index, 1);
  }
}
function io_c3792963_once(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }

    called = true;
    fn();
  };
}

var kThrow = function kThrow(err) {
  throw err;
};

var kReturn = function kReturn(value) {
  return {
    value: value,
    done: true
  };
};

function makeIterator(next, thro, name) {
  if (thro === void 0) {
    thro = kThrow;
  }

  if (name === void 0) {
    name = 'iterator';
  }

  var iterator = {
    meta: {
      name: name
    },
    next: next,
    throw: thro,
    return: kReturn,
    isSagaIterator: true
  };

  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }

  return iterator;
}
function logError(error, _ref2) {
  var sagaStack = _ref2.sagaStack;

  /*eslint-disable no-console*/
  console.error(error);
  console.error(sagaStack);
}
var internalErr = function internalErr(err) {
  return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + "setContext(props): argument " + props + " is not a plain object";
};
var FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array

var createEmptyArray = function createEmptyArray(n) {
  return Array.apply(null, new Array(n));
};
var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    if (false) {}

    return dispatch(Object.defineProperty(action, redux_saga_symbols_esm_SAGA_ACTION, {
      value: true
    }));
  };
};
var shouldTerminate = function shouldTerminate(res) {
  return res === TERMINATE;
};
var shouldCancel = function shouldCancel(res) {
  return res === TASK_CANCEL;
};
var shouldComplete = function shouldComplete(res) {
  return shouldTerminate(res) || shouldCancel(res);
};
function createAllStyleChildCallbacks(shape, parentCallback) {
  var keys = Object.keys(shape);
  var totalCount = keys.length;

  if (false) {}

  var completedCount = 0;
  var completed;
  var results = redux_saga_is_esm_array(shape) ? createEmptyArray(totalCount) : {};
  var childCallbacks = {};

  function checkEnd() {
    if (completedCount === totalCount) {
      completed = true;
      parentCallback(results);
    }
  }

  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || shouldComplete(res)) {
        parentCallback.cancel();
        parentCallback(res, isErr);
      } else {
        results[key] = res;
        completedCount++;
        checkEnd();
      }
    };

    chCbAtKey.cancel = noop;
    childCallbacks[key] = chCbAtKey;
  });

  parentCallback.cancel = function () {
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCallbacks[key].cancel();
      });
    }
  };

  return childCallbacks;
}
function getMetaInfo(fn) {
  return {
    name: fn.name || 'anonymous',
    location: getLocation(fn)
  };
}
function getLocation(instrumented) {
  return instrumented[SAGA_LOCATION];
}

var BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;
var zeroBuffer = {
  isEmpty: kTrue,
  put: noop,
  take: noop
};

function ringBuffer(limit, overflowAction) {
  if (limit === void 0) {
    limit = 10;
  }

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];

    while (length) {
      items.push(take());
    }

    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit;

        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);

          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;

          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;
            arr = flush();
            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;
            arr.length = doubledLimit;
            limit = doubledLimit;
            push(it);
            break;

          default: // DROP

        }
      }
    },
    take: take,
    flush: flush
  };
}

var io_c3792963_none = function none() {
  return zeroBuffer;
};
var fixed = function fixed(limit) {
  return ringBuffer(limit, ON_OVERFLOW_THROW);
};
var dropping = function dropping(limit) {
  return ringBuffer(limit, ON_OVERFLOW_DROP);
};
var io_c3792963_sliding = function sliding(limit) {
  return ringBuffer(limit, ON_OVERFLOW_SLIDE);
};
var expanding = function expanding(initialSize) {
  return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
};

var buffers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  none: io_c3792963_none,
  fixed: fixed,
  dropping: dropping,
  sliding: io_c3792963_sliding,
  expanding: expanding
});

var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var io_c3792963_CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var effectTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TAKE: TAKE,
  PUT: PUT,
  ALL: ALL,
  RACE: RACE,
  CALL: CALL,
  CPS: CPS,
  FORK: FORK,
  JOIN: JOIN,
  CANCEL: io_c3792963_CANCEL,
  SELECT: SELECT,
  ACTION_CHANNEL: ACTION_CHANNEL,
  CANCELLED: CANCELLED,
  FLUSH: FLUSH,
  GET_CONTEXT: GET_CONTEXT,
  SET_CONTEXT: SET_CONTEXT
});

var TEST_HINT = '\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)';

var makeEffect = function makeEffect(type, payload) {
  var _ref;

  return _ref = {}, _ref[redux_saga_symbols_esm_IO] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};

var isForkEffect = function isForkEffect(eff) {
  return effect(eff) && eff.type === FORK;
};

var detach = function detach(eff) {
  if (false) {}

  return makeEffect(FORK, _extends({}, eff.payload, {
    detached: true
  }));
};
function io_c3792963_take(patternOrChannel, multicastPattern) {
  if (patternOrChannel === void 0) {
    patternOrChannel = '*';
  }

  if (false) {}

  if (pattern(patternOrChannel)) {
    if (redux_saga_is_esm_notUndef(multicastPattern)) {
      /* eslint-disable no-console */
      console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
    }

    return makeEffect(TAKE, {
      pattern: patternOrChannel
    });
  }

  if (multicast(patternOrChannel) && redux_saga_is_esm_notUndef(multicastPattern) && pattern(multicastPattern)) {
    return makeEffect(TAKE, {
      channel: patternOrChannel,
      pattern: multicastPattern
    });
  }

  if (redux_saga_is_esm_channel(patternOrChannel)) {
    if (redux_saga_is_esm_notUndef(multicastPattern)) {
      /* eslint-disable no-console */
      console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
    }

    return makeEffect(TAKE, {
      channel: patternOrChannel
    });
  }

  if (false) {}
}
var takeMaybe = function takeMaybe() {
  var eff = io_c3792963_take.apply(void 0, arguments);
  eff.payload.maybe = true;
  return eff;
};
function put(channel$1, action) {
  if (false) {}

  if (undef(action)) {
    action = channel$1; // `undefined` instead of `null` to make default parameter work

    channel$1 = undefined;
  }

  return makeEffect(PUT, {
    channel: channel$1,
    action: action
  });
}
var putResolve = function putResolve() {
  var eff = put.apply(void 0, arguments);
  eff.payload.resolve = true;
  return eff;
};
function io_c3792963_all(effects) {
  var eff = makeEffect(ALL, effects);
  eff.combinator = true;
  return eff;
}
function io_c3792963_race(effects) {
  var eff = makeEffect(RACE, effects);
  eff.combinator = true;
  return eff;
} // this match getFnCallDescriptor logic

var validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
  io_c3792963_check(fnDescriptor, notUndef, effectName + ": argument fn is undefined or null");

  if (func(fnDescriptor)) {
    return;
  }

  var context = null;
  var fn;

  if (array(fnDescriptor)) {
    context = fnDescriptor[0];
    fn = fnDescriptor[1];
    io_c3792963_check(fn, notUndef, effectName + ": argument of type [context, fn] has undefined or null `fn`");
  } else if (object(fnDescriptor)) {
    context = fnDescriptor.context;
    fn = fnDescriptor.fn;
    io_c3792963_check(fn, notUndef, effectName + ": argument of type {context, fn} has undefined or null `fn`");
  } else {
    io_c3792963_check(fnDescriptor, func, effectName + ": argument fn is not function");
    return;
  }

  if (context && string(fn)) {
    io_c3792963_check(context[fn], func, effectName + ": context arguments has no such method - \"" + fn + "\"");
    return;
  }

  io_c3792963_check(fn, func, effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};

function getFnCallDescriptor(fnDescriptor, args) {
  var context = null;
  var fn;

  if (redux_saga_is_esm_func(fnDescriptor)) {
    fn = fnDescriptor;
  } else {
    if (redux_saga_is_esm_array(fnDescriptor)) {
      context = fnDescriptor[0];
      fn = fnDescriptor[1];
    } else {
      context = fnDescriptor.context;
      fn = fnDescriptor.fn;
    }

    if (context && redux_saga_is_esm_string(fn) && redux_saga_is_esm_func(context[fn])) {
      fn = context[fn];
    }
  }

  return {
    context: context,
    fn: fn,
    args: args
  };
}

var isNotDelayEffect = function isNotDelayEffect(fn) {
  return fn !== io_c3792963_delay;
};

function io_c3792963_call(fnDescriptor) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (false) { var arg0; }

  return makeEffect(CALL, getFnCallDescriptor(fnDescriptor, args));
}
function apply(context, fn, args) {
  if (args === void 0) {
    args = [];
  }

  var fnDescriptor = [context, fn];

  if (false) {}

  return makeEffect(CALL, getFnCallDescriptor([context, fn], args));
}
function cps(fnDescriptor) {
  if (false) {}

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return makeEffect(CPS, getFnCallDescriptor(fnDescriptor, args));
}
function io_c3792963_fork(fnDescriptor) {
  if (false) {}

  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return makeEffect(FORK, getFnCallDescriptor(fnDescriptor, args));
}
function spawn(fnDescriptor) {
  if (false) {}

  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(io_c3792963_fork.apply(void 0, [fnDescriptor].concat(args)));
}
function join(taskOrTasks) {
  if (false) {}

  return makeEffect(JOIN, taskOrTasks);
}
function cancel(taskOrTasks) {
  if (taskOrTasks === void 0) {
    taskOrTasks = SELF_CANCELLATION;
  }

  if (false) {}

  return makeEffect(io_c3792963_CANCEL, taskOrTasks);
}
function io_c3792963_select(selector) {
  if (selector === void 0) {
    selector = identity;
  }

  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  if (false) {}

  return makeEffect(SELECT, {
    selector: selector,
    args: args
  });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/

function io_c3792963_actionChannel(pattern$1, buffer$1) {
  if (false) {}

  return makeEffect(ACTION_CHANNEL, {
    pattern: pattern$1,
    buffer: buffer$1
  });
}
function cancelled() {
  return makeEffect(CANCELLED, {});
}
function flush(channel$1) {
  if (false) {}

  return makeEffect(FLUSH, channel$1);
}
function getContext(prop) {
  if (false) {}

  return makeEffect(GET_CONTEXT, prop);
}
function setContext(props) {
  if (false) {}

  return makeEffect(SET_CONTEXT, props);
}
var io_c3792963_delay =
/*#__PURE__*/
io_c3792963_call.bind(null, redux_saga_delay_p_esm);



;// CONCATENATED MODULE: ../node_modules/@redux-saga/deferred/dist/redux-saga-deferred.esm.js
function deferred() {
  var def = {};
  def.promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  return def;
}
function arrayOfDeferred(length) {
  var arr = [];

  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }

  return arr;
}

/* harmony default export */ var redux_saga_deferred_esm = (deferred);


;// CONCATENATED MODULE: ../node_modules/@redux-saga/core/dist/redux-saga-core.esm.js











var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/

var semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/

function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/


function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    redux_saga_core_esm_flush();
  }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */

function immediately(task) {
  try {
    suspend();
    return task();
  } finally {
    redux_saga_core_esm_flush();
  }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/

function suspend() {
  semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/


function release() {
  semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/


function redux_saga_core_esm_flush() {
  release();
  var task;

  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

var redux_saga_core_esm_array = function array(patterns) {
  return function (input) {
    return patterns.some(function (p) {
      return matcher(p)(input);
    });
  };
};
var predicate = function predicate(_predicate) {
  return function (input) {
    return _predicate(input);
  };
};
var redux_saga_core_esm_string = function string(pattern) {
  return function (input) {
    return input.type === String(pattern);
  };
};
var redux_saga_core_esm_symbol = function symbol(pattern) {
  return function (input) {
    return input.type === pattern;
  };
};
var wildcard = function wildcard() {
  return kTrue;
};
function matcher(pattern) {
  // prettier-ignore
  var matcherCreator = pattern === '*' ? wildcard : redux_saga_is_esm_string(pattern) ? redux_saga_core_esm_string : redux_saga_is_esm_array(pattern) ? redux_saga_core_esm_array : stringableFunc(pattern) ? redux_saga_core_esm_string : redux_saga_is_esm_func(pattern) ? predicate : symbol(pattern) ? redux_saga_core_esm_symbol : null;

  if (matcherCreator === null) {
    throw new Error("invalid pattern: " + pattern);
  }

  return matcherCreator(pattern);
}

var END = {
  type: CHANNEL_END_TYPE
};
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};
var CLOSED_CHANNEL_WITH_TAKERS = 'Cannot have a closed channel with pending takers';
var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function redux_saga_core_esm_channel(buffer$1) {
  if (buffer$1 === void 0) {
    buffer$1 = expanding();
  }

  var closed = false;
  var takers = [];

  if (false) {}

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw internalErr(CLOSED_CHANNEL_WITH_TAKERS);
    }

    if (takers.length && !buffer$1.isEmpty()) {
      throw internalErr('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    if (false) {}

    if (closed) {
      return;
    }

    if (takers.length === 0) {
      return buffer$1.put(input);
    }

    var cb = takers.shift();
    cb(input);
  }

  function take(cb) {
    if (false) {}

    if (closed && buffer$1.isEmpty()) {
      cb(END);
    } else if (!buffer$1.isEmpty()) {
      cb(buffer$1.take());
    } else {
      takers.push(cb);

      cb.cancel = function () {
        remove(takers, cb);
      };
    }
  }

  function flush(cb) {
    if (false) {}

    if (closed && buffer$1.isEmpty()) {
      cb(END);
      return;
    }

    cb(buffer$1.flush());
  }

  function close() {
    if (false) {}

    if (closed) {
      return;
    }

    closed = true;
    var arr = takers;
    takers = [];

    for (var i = 0, len = arr.length; i < len; i++) {
      var taker = arr[i];
      taker(END);
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close
  };
}
function eventChannel(subscribe, buffer) {
  if (buffer === void 0) {
    buffer = none();
  }

  var closed = false;
  var unsubscribe;
  var chan = redux_saga_core_esm_channel(buffer);

  var close = function close() {
    if (closed) {
      return;
    }

    closed = true;

    if (func(unsubscribe)) {
      unsubscribe();
    }

    chan.close();
  };

  unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }

    chan.put(input);
  });

  if (false) {}

  unsubscribe = once(unsubscribe);

  if (closed) {
    unsubscribe();
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}
function multicastChannel() {
  var _ref;

  var closed = false;
  var currentTakers = [];
  var nextTakers = currentTakers;

  function checkForbiddenStates() {
    if (closed && nextTakers.length) {
      throw internalErr(CLOSED_CHANNEL_WITH_TAKERS);
    }
  }

  var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
    if (nextTakers !== currentTakers) {
      return;
    }

    nextTakers = currentTakers.slice();
  };

  var close = function close() {
    if (false) {}

    closed = true;
    var takers = currentTakers = nextTakers;
    nextTakers = [];
    takers.forEach(function (taker) {
      taker(END);
    });
  };

  return _ref = {}, _ref[MULTICAST] = true, _ref.put = function put(input) {
    if (false) {}

    if (closed) {
      return;
    }

    if (isEnd(input)) {
      close();
      return;
    }

    var takers = currentTakers = nextTakers;

    for (var i = 0, len = takers.length; i < len; i++) {
      var taker = takers[i];

      if (taker[MATCH](input)) {
        taker.cancel();
        taker(input);
      }
    }
  }, _ref.take = function take(cb, matcher) {
    if (matcher === void 0) {
      matcher = wildcard;
    }

    if (false) {}

    if (closed) {
      cb(END);
      return;
    }

    cb[MATCH] = matcher;
    ensureCanMutateNextTakers();
    nextTakers.push(cb);
    cb.cancel = io_c3792963_once(function () {
      ensureCanMutateNextTakers();
      remove(nextTakers, cb);
    });
  }, _ref.close = close, _ref;
}
function stdChannel() {
  var chan = multicastChannel();
  var put = chan.put;

  chan.put = function (input) {
    if (input[redux_saga_symbols_esm_SAGA_ACTION]) {
      put(input);
      return;
    }

    asap(function () {
      put(input);
    });
  };

  return chan;
}

var RUNNING = 0;
var redux_saga_core_esm_CANCELLED = 1;
var ABORTED = 2;
var DONE = 3;

function resolvePromise(promise, cb) {
  var cancelPromise = promise[CANCEL];

  if (redux_saga_is_esm_func(cancelPromise)) {
    cb.cancel = cancelPromise;
  }

  promise.then(cb, function (error) {
    cb(error, true);
  });
}

var current = 0;
var nextSagaId = (function () {
  return ++current;
});

var _effectRunnerMap;

function getIteratorMetaInfo(iterator, fn) {
  if (iterator.isSagaIterator) {
    return {
      name: iterator.meta.name
    };
  }

  return getMetaInfo(fn);
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  // catch synchronous failures; see #152 and #441
  try {
    var result = fn.apply(context, args); // i.e. a generator function returns an iterator

    if (iterator(result)) {
      return result;
    }

    var resolved = false;

    var next = function next(arg) {
      if (!resolved) {
        resolved = true; // Only promises returned from fork will be interpreted. See #1573

        return {
          value: result,
          done: !promise(result)
        };
      } else {
        return {
          value: arg,
          done: true
        };
      }
    };

    return makeIterator(next);
  } catch (err) {
    // do not bubble up synchronous failures for detached forks
    // instead create a failed task. See #152 and #441
    return makeIterator(function () {
      throw err;
    });
  }
}

function runPutEffect(env, _ref2, cb) {
  var channel = _ref2.channel,
      action = _ref2.action,
      resolve = _ref2.resolve;

  /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/
  asap(function () {
    var result;

    try {
      result = (channel ? channel.put : env.dispatch)(action);
    } catch (error) {
      cb(error, true);
      return;
    }

    if (resolve && promise(result)) {
      resolvePromise(result, cb);
    } else {
      cb(result);
    }
  }); // Put effects are non cancellables
}

function runTakeEffect(env, _ref3, cb) {
  var _ref3$channel = _ref3.channel,
      channel = _ref3$channel === void 0 ? env.channel : _ref3$channel,
      pattern = _ref3.pattern,
      maybe = _ref3.maybe;

  var takeCb = function takeCb(input) {
    if (input instanceof Error) {
      cb(input, true);
      return;
    }

    if (isEnd(input) && !maybe) {
      cb(TERMINATE);
      return;
    }

    cb(input);
  };

  try {
    channel.take(takeCb, redux_saga_is_esm_notUndef(pattern) ? matcher(pattern) : null);
  } catch (err) {
    cb(err, true);
    return;
  }

  cb.cancel = takeCb.cancel;
}

function runCallEffect(env, _ref4, cb, _ref5) {
  var context = _ref4.context,
      fn = _ref4.fn,
      args = _ref4.args;
  var task = _ref5.task;

  // catch synchronous failures; see #152
  try {
    var result = fn.apply(context, args);

    if (promise(result)) {
      resolvePromise(result, cb);
      return;
    }

    if (iterator(result)) {
      // resolve iterator
      proc(env, result, task.context, current, getMetaInfo(fn),
      /* isRoot */
      false, cb);
      return;
    }

    cb(result);
  } catch (error) {
    cb(error, true);
  }
}

function runCPSEffect(env, _ref6, cb) {
  var context = _ref6.context,
      fn = _ref6.fn,
      args = _ref6.args;

  // CPS (ie node style functions) can define their own cancellation logic
  // by setting cancel field on the cb
  // catch synchronous failures; see #152
  try {
    var cpsCb = function cpsCb(err, res) {
      if (undef(err)) {
        cb(res);
      } else {
        cb(err, true);
      }
    };

    fn.apply(context, args.concat(cpsCb));

    if (cpsCb.cancel) {
      cb.cancel = cpsCb.cancel;
    }
  } catch (error) {
    cb(error, true);
  }
}

function runForkEffect(env, _ref7, cb, _ref8) {
  var context = _ref7.context,
      fn = _ref7.fn,
      args = _ref7.args,
      detached = _ref7.detached;
  var parent = _ref8.task;
  var taskIterator = createTaskIterator({
    context: context,
    fn: fn,
    args: args
  });
  var meta = getIteratorMetaInfo(taskIterator, fn);
  immediately(function () {
    var child = proc(env, taskIterator, parent.context, current, meta, detached, undefined);

    if (detached) {
      cb(child);
    } else {
      if (child.isRunning()) {
        parent.queue.addTask(child);
        cb(child);
      } else if (child.isAborted()) {
        parent.queue.abort(child.error());
      } else {
        cb(child);
      }
    }
  }); // Fork effects are non cancellables
}

function runJoinEffect(env, taskOrTasks, cb, _ref9) {
  var task = _ref9.task;

  var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
    if (taskToJoin.isRunning()) {
      var joiner = {
        task: task,
        cb: cb
      };

      cb.cancel = function () {
        if (taskToJoin.isRunning()) remove(taskToJoin.joiners, joiner);
      };

      taskToJoin.joiners.push(joiner);
    } else {
      if (taskToJoin.isAborted()) {
        cb(taskToJoin.error(), true);
      } else {
        cb(taskToJoin.result());
      }
    }
  };

  if (redux_saga_is_esm_array(taskOrTasks)) {
    if (taskOrTasks.length === 0) {
      cb([]);
      return;
    }

    var childCallbacks = createAllStyleChildCallbacks(taskOrTasks, cb);
    taskOrTasks.forEach(function (t, i) {
      joinSingleTask(t, childCallbacks[i]);
    });
  } else {
    joinSingleTask(taskOrTasks, cb);
  }
}

function cancelSingleTask(taskToCancel) {
  if (taskToCancel.isRunning()) {
    taskToCancel.cancel();
  }
}

function runCancelEffect(env, taskOrTasks, cb, _ref10) {
  var task = _ref10.task;

  if (taskOrTasks === SELF_CANCELLATION) {
    cancelSingleTask(task);
  } else if (redux_saga_is_esm_array(taskOrTasks)) {
    taskOrTasks.forEach(cancelSingleTask);
  } else {
    cancelSingleTask(taskOrTasks);
  }

  cb(); // cancel effects are non cancellables
}

function runAllEffect(env, effects, cb, _ref11) {
  var digestEffect = _ref11.digestEffect;
  var effectId = current;
  var keys = Object.keys(effects);

  if (keys.length === 0) {
    cb(redux_saga_is_esm_array(effects) ? [] : {});
    return;
  }

  var childCallbacks = createAllStyleChildCallbacks(effects, cb);
  keys.forEach(function (key) {
    digestEffect(effects[key], effectId, childCallbacks[key], key);
  });
}

function runRaceEffect(env, effects, cb, _ref12) {
  var digestEffect = _ref12.digestEffect;
  var effectId = current;
  var keys = Object.keys(effects);
  var response = redux_saga_is_esm_array(effects) ? createEmptyArray(keys.length) : {};
  var childCbs = {};
  var completed = false;
  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || shouldComplete(res)) {
        // Race Auto cancellation
        cb.cancel();
        cb(res, isErr);
      } else {
        cb.cancel();
        completed = true;
        response[key] = res;
        cb(response);
      }
    };

    chCbAtKey.cancel = noop;
    childCbs[key] = chCbAtKey;
  });

  cb.cancel = function () {
    // prevents unnecessary cancellation
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCbs[key].cancel();
      });
    }
  };

  keys.forEach(function (key) {
    if (completed) {
      return;
    }

    digestEffect(effects[key], effectId, childCbs[key], key);
  });
}

function runSelectEffect(env, _ref13, cb) {
  var selector = _ref13.selector,
      args = _ref13.args;

  try {
    var state = selector.apply(void 0, [env.getState()].concat(args));
    cb(state);
  } catch (error) {
    cb(error, true);
  }
}

function runChannelEffect(env, _ref14, cb) {
  var pattern = _ref14.pattern,
      buffer = _ref14.buffer;
  var chan = redux_saga_core_esm_channel(buffer);
  var match = matcher(pattern);

  var taker = function taker(action) {
    if (!isEnd(action)) {
      env.channel.take(taker, match);
    }

    chan.put(action);
  };

  var close = chan.close;

  chan.close = function () {
    taker.cancel();
    close();
  };

  env.channel.take(taker, match);
  cb(chan);
}

function runCancelledEffect(env, data, cb, _ref15) {
  var task = _ref15.task;
  cb(task.isCancelled());
}

function runFlushEffect(env, channel, cb) {
  channel.flush(cb);
}

function runGetContextEffect(env, prop, cb, _ref16) {
  var task = _ref16.task;
  cb(task.context[prop]);
}

function runSetContextEffect(env, props, cb, _ref17) {
  var task = _ref17.task;
  assignWithSymbols(task.context, props);
  cb();
}

var effectRunnerMap = (_effectRunnerMap = {}, _effectRunnerMap[TAKE] = runTakeEffect, _effectRunnerMap[PUT] = runPutEffect, _effectRunnerMap[ALL] = runAllEffect, _effectRunnerMap[RACE] = runRaceEffect, _effectRunnerMap[CALL] = runCallEffect, _effectRunnerMap[CPS] = runCPSEffect, _effectRunnerMap[FORK] = runForkEffect, _effectRunnerMap[JOIN] = runJoinEffect, _effectRunnerMap[io_c3792963_CANCEL] = runCancelEffect, _effectRunnerMap[SELECT] = runSelectEffect, _effectRunnerMap[ACTION_CHANNEL] = runChannelEffect, _effectRunnerMap[CANCELLED] = runCancelledEffect, _effectRunnerMap[FLUSH] = runFlushEffect, _effectRunnerMap[GET_CONTEXT] = runGetContextEffect, _effectRunnerMap[SET_CONTEXT] = runSetContextEffect, _effectRunnerMap);

/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/

function forkQueue(mainTask, onAbort, cont) {
  var tasks = [];
  var result;
  var completed = false;
  addTask(mainTask);

  var getTasks = function getTasks() {
    return tasks;
  };

  function abort(err) {
    onAbort();
    cancelAll();
    cont(err, true);
  }

  function addTask(task) {
    tasks.push(task);

    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      remove(tasks, task);
      task.cont = noop;

      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }

        if (!tasks.length) {
          completed = true;
          cont(result);
        }
      }
    };
  }

  function cancelAll() {
    if (completed) {
      return;
    }

    completed = true;
    tasks.forEach(function (t) {
      t.cont = noop;
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: getTasks
  };
}

// there can be only a single saga error created at any given moment

function formatLocation(fileName, lineNumber) {
  return fileName + "?" + lineNumber;
}

function effectLocationAsString(effect) {
  var location = getLocation(effect);

  if (location) {
    var code = location.code,
        fileName = location.fileName,
        lineNumber = location.lineNumber;
    var source = code + "  " + formatLocation(fileName, lineNumber);
    return source;
  }

  return '';
}

function sagaLocationAsString(sagaMeta) {
  var name = sagaMeta.name,
      location = sagaMeta.location;

  if (location) {
    return name + "  " + formatLocation(location.fileName, location.lineNumber);
  }

  return name;
}

function cancelledTasksAsString(sagaStack) {
  var cancelledTasks = flatMap(function (i) {
    return i.cancelledTasks;
  }, sagaStack);

  if (!cancelledTasks.length) {
    return '';
  }

  return ['Tasks cancelled due to error:'].concat(cancelledTasks).join('\n');
}

var crashedEffect = null;
var sagaStack = [];
var addSagaFrame = function addSagaFrame(frame) {
  frame.crashedEffect = crashedEffect;
  sagaStack.push(frame);
};
var clear = function clear() {
  crashedEffect = null;
  sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now

var setCrashedEffect = function setCrashedEffect(effect) {
  crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/

var redux_saga_core_esm_toString = function toString() {
  var firstSaga = sagaStack[0],
      otherSagas = sagaStack.slice(1);
  var crashedEffectLocation = firstSaga.crashedEffect ? effectLocationAsString(firstSaga.crashedEffect) : null;
  var errorMessage = "The above error occurred in task " + sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : '');
  return [errorMessage].concat(otherSagas.map(function (s) {
    return "    created by " + sagaLocationAsString(s.meta);
  }), [cancelledTasksAsString(sagaStack)]).join('\n');
};

function newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
  var _task;

  if (cont === void 0) {
    cont = noop;
  }

  var status = RUNNING;
  var taskResult;
  var taskError;
  var deferredEnd = null;
  var cancelledDueToErrorTasks = [];
  var context = Object.create(parentContext);
  var queue = forkQueue(mainTask, function onAbort() {
    cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function (t) {
      return t.meta.name;
    }));
  }, end);
  /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/

  function cancel() {
    if (status === RUNNING) {
      // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
      // effects in the iterator's finally block will still be executed
      status = redux_saga_core_esm_CANCELLED;
      queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners

      end(TASK_CANCEL, false);
    }
  }

  function end(result, isErr) {
    if (!isErr) {
      // The status here may be RUNNING or CANCELLED
      // If the status is CANCELLED, then we do not need to change it here
      if (result === TASK_CANCEL) {
        status = redux_saga_core_esm_CANCELLED;
      } else if (status !== redux_saga_core_esm_CANCELLED) {
        status = DONE;
      }

      taskResult = result;
      deferredEnd && deferredEnd.resolve(result);
    } else {
      status = ABORTED;
      addSagaFrame({
        meta: meta,
        cancelledTasks: cancelledDueToErrorTasks
      });

      if (task.isRoot) {
        var sagaStack = redux_saga_core_esm_toString(); // we've dumped the saga stack to string and are passing it to user's code
        // we know that it won't be needed anymore and we need to clear it

        clear();
        env.onError(result, {
          sagaStack: sagaStack
        });
      }

      taskError = result;
      deferredEnd && deferredEnd.reject(result);
    }

    task.cont(result, isErr);
    task.joiners.forEach(function (joiner) {
      joiner.cb(result, isErr);
    });
    task.joiners = null;
  }

  function setContext(props) {
    if (false) {}

    assignWithSymbols(context, props);
  }

  function toPromise() {
    if (deferredEnd) {
      return deferredEnd.promise;
    }

    deferredEnd = redux_saga_deferred_esm();

    if (status === ABORTED) {
      deferredEnd.reject(taskError);
    } else if (status !== RUNNING) {
      deferredEnd.resolve(taskResult);
    }

    return deferredEnd.promise;
  }

  var task = (_task = {}, _task[redux_saga_symbols_esm_TASK] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
    return status === RUNNING;
  }, _task.isCancelled = function isCancelled() {
    return status === redux_saga_core_esm_CANCELLED || status === RUNNING && mainTask.status === redux_saga_core_esm_CANCELLED;
  }, _task.isAborted = function isAborted() {
    return status === ABORTED;
  }, _task.result = function result() {
    return taskResult;
  }, _task.error = function error() {
    return taskError;
  }, _task);
  return task;
}

function proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
  if (false) {}

  var finalRunEffect = env.finalizeRunEffect(runEffect);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/

  next.cancel = noop;
  /** Creates a main task to track the main flow */

  var mainTask = {
    meta: meta,
    cancel: cancelMain,
    status: RUNNING
  };
  /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/

  var task = newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
  var executingContext = {
    task: task,
    digestEffect: digestEffect
  };
  /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/

  function cancelMain() {
    if (mainTask.status === RUNNING) {
      mainTask.status = redux_saga_core_esm_CANCELLED;
      next(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/


  if (cont) {
    cont.cancel = task.cancel;
  } // kicks up the generator


  next(); // then return the task descriptor to the caller

  return task;
  /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */

  function next(arg, isErr) {
    try {
      var result;

      if (isErr) {
        result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values

        clear();
      } else if (shouldCancel(arg)) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.status = redux_saga_core_esm_CANCELLED;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/

        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/

        result = redux_saga_is_esm_func(iterator$1.return) ? iterator$1.return(TASK_CANCEL) : {
          done: true,
          value: TASK_CANCEL
        };
      } else if (shouldTerminate(arg)) {
        // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = redux_saga_is_esm_func(iterator$1.return) ? iterator$1.return() : {
          done: true
        };
      } else {
        result = iterator$1.next(arg);
      }

      if (!result.done) {
        digestEffect(result.value, parentEffectId, next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        if (mainTask.status !== redux_saga_core_esm_CANCELLED) {
          mainTask.status = DONE;
        }

        mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.status === redux_saga_core_esm_CANCELLED) {
        throw error;
      }

      mainTask.status = ABORTED;
      mainTask.cont(error, true);
    }
  }

  function runEffect(effect, effectId, currCb) {
    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    if (promise(effect)) {
      resolvePromise(effect, currCb);
    } else if (iterator(effect)) {
      // resolve iterator
      proc(env, effect, task.context, effectId, meta,
      /* isRoot */
      false, currCb);
    } else if (effect && effect[redux_saga_symbols_esm_IO]) {
      var effectRunner = effectRunnerMap[effect.type];
      effectRunner(env, effect.payload, currCb, executingContext);
    } else {
      // anything else returned as is
      currCb(effect);
    }
  }

  function digestEffect(effect, parentEffectId, cb, label) {
    if (label === void 0) {
      label = '';
    }

    var effectId = nextSagaId();
    env.sagaMonitor && env.sagaMonitor.effectTriggered({
      effectId: effectId,
      parentEffectId: parentEffectId,
      label: label,
      effect: effect
    });
    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/

    var effectSettled; // Completion callback passed to the appropriate effect runner

    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = noop; // defensive measure

      if (env.sagaMonitor) {
        if (isErr) {
          env.sagaMonitor.effectRejected(effectId, res);
        } else {
          env.sagaMonitor.effectResolved(effectId, res);
        }
      }

      if (isErr) {
        setCrashedEffect(effect);
      }

      cb(res, isErr);
    } // tracks down the current cancel


    currCb.cancel = noop; // setup cancellation logic on the parent cb

    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      currCb.cancel(); // propagates cancel downward

      currCb.cancel = noop; // defensive measure

      env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
    };

    finalRunEffect(effect, effectId, currCb);
  }
}

var RUN_SAGA_SIGNATURE = 'runSaga(options, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function runSaga(_ref, saga) {
  var _ref$channel = _ref.channel,
      channel = _ref$channel === void 0 ? stdChannel() : _ref$channel,
      dispatch = _ref.dispatch,
      getState = _ref.getState,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context,
      sagaMonitor = _ref.sagaMonitor,
      effectMiddlewares = _ref.effectMiddlewares,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? logError : _ref$onError;

  if (false) {}

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator$1 = saga.apply(void 0, args);

  if (false) {}

  var effectId = nextSagaId();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || noop;
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || noop;
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || noop;
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || noop;
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || noop;
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || noop;
    sagaMonitor.rootSagaStarted({
      effectId: effectId,
      saga: saga,
      args: args
    });
  }

  if (false) { var MIDDLEWARE_TYPE_ERROR; }

  var finalizeRunEffect;

  if (effectMiddlewares) {
    var middleware = compose.apply(void 0, effectMiddlewares);

    finalizeRunEffect = function finalizeRunEffect(runEffect) {
      return function (effect, effectId, currCb) {
        var plainRunEffect = function plainRunEffect(eff) {
          return runEffect(eff, effectId, currCb);
        };

        return middleware(plainRunEffect)(effect);
      };
    };
  } else {
    finalizeRunEffect = identity;
  }

  var env = {
    channel: channel,
    dispatch: wrapSagaDispatch(dispatch),
    getState: getState,
    sagaMonitor: sagaMonitor,
    onError: onError,
    finalizeRunEffect: finalizeRunEffect
  };
  return immediately(function () {
    var task = proc(env, iterator$1, context, effectId, getMetaInfo(saga),
    /* isRoot */
    true, undefined);

    if (sagaMonitor) {
      sagaMonitor.effectResolved(effectId, task);
    }

    return task;
  });
}

function sagaMiddlewareFactory(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context,
      _ref$channel = _ref.channel,
      channel = _ref$channel === void 0 ? stdChannel() : _ref$channel,
      sagaMonitor = _ref.sagaMonitor,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["context", "channel", "sagaMonitor"]);

  var boundRunSaga;

  if (false) {}

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;
    boundRunSaga = runSaga.bind(null, (0,esm_extends/* default */.Z)({}, options, {
      context: context,
      channel: channel,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor
    }));
    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }

        var result = next(action); // hit reducers

        channel.put(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    if (false) {}

    return boundRunSaga.apply(void 0, arguments);
  };

  sagaMiddleware.setContext = function (props) {
    if (false) {}

    assignWithSymbols(context, props);
  };

  return sagaMiddleware;
}

/* harmony default export */ var redux_saga_core_esm = (sagaMiddlewareFactory);


;// CONCATENATED MODULE: ../node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js





/* harmony default export */ var redux_saga_core_npm_proxy_esm = (redux_saga_core_esm);

;// CONCATENATED MODULE: ../node_modules/@redux-saga/core/dist/redux-saga-effects.esm.js







var done = function done(value) {
  return {
    done: true,
    value: value
  };
};

var qEnd = {};
function safeName(patternOrChannel) {
  if (redux_saga_is_esm_channel(patternOrChannel)) {
    return 'channel';
  }

  if (stringableFunc(patternOrChannel)) {
    return String(patternOrChannel);
  }

  if (redux_saga_is_esm_func(patternOrChannel)) {
    return patternOrChannel.name;
  }

  return String(patternOrChannel);
}
function fsmIterator(fsm, startState, name) {
  var stateUpdater,
      errorState,
      effect,
      nextState = startState;

  function next(arg, error) {
    if (nextState === qEnd) {
      return done(arg);
    }

    if (error && !errorState) {
      nextState = qEnd;
      throw error;
    } else {
      stateUpdater && stateUpdater(arg);
      var currentState = error ? fsm[errorState](error) : fsm[nextState]();
      nextState = currentState.nextState;
      effect = currentState.effect;
      stateUpdater = currentState.stateUpdater;
      errorState = currentState.errorState;
      return nextState === qEnd ? done(arg) : effect;
    }
  }

  return makeIterator(next, function (error) {
    return next(null, error);
  }, name);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: io_c3792963_take(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: io_c3792963_fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var action,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q1',
        effect: yFork(action)
      };
    }
  }, 'q1', "takeEvery(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: io_c3792963_take(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: io_c3792963_fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yCancel = function yCancel(task) {
    return {
      done: false,
      value: cancel(task)
    };
  };

  var task, action;

  var setTask = function setTask(t) {
    return task = t;
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return task ? {
        nextState: 'q3',
        effect: yCancel(task)
      } : {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    },
    q3: function q3() {
      return {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    }
  }, 'q1', "takeLatest(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function takeLeading(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: io_c3792963_take(patternOrChannel)
  };

  var yCall = function yCall(ac) {
    return {
      done: false,
      value: io_c3792963_call.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var action;

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q1',
        effect: yCall(action)
      };
    }
  }, 'q1', "takeLeading(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function throttle(delayLength, patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action, channel$1;

  var yTake = function yTake() {
    return {
      done: false,
      value: take(channel$1)
    };
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yDelay = {
    done: false,
    value: delay(delayLength)
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  var setChannel = function setChannel(ch) {
    return channel$1 = ch;
  };

  var needsChannel = !channel(patternOrChannel);

  if (!needsChannel) {
    setChannel(patternOrChannel);
  }

  return fsmIterator({
    q1: function q1() {
      var yActionChannel = {
        done: false,
        value: actionChannel(patternOrChannel, sliding(1))
      };
      return {
        nextState: 'q2',
        effect: yActionChannel,
        stateUpdater: setChannel
      };
    },
    q2: function q2() {
      return {
        nextState: 'q3',
        effect: yTake(),
        stateUpdater: setAction
      };
    },
    q3: function q3() {
      return {
        nextState: 'q4',
        effect: yFork(action)
      };
    },
    q4: function q4() {
      return {
        nextState: 'q2',
        effect: yDelay
      };
    }
  }, needsChannel ? 'q1' : 'q2', "throttle(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function retry(maxTries, delayLength, fn) {
  var counter = maxTries;

  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var yCall = {
    done: false,
    value: call.apply(void 0, [fn].concat(args))
  };
  var yDelay = {
    done: false,
    value: delay(delayLength)
  };
  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yCall,
        errorState: 'q10'
      };
    },
    q2: function q2() {
      return {
        nextState: qEnd
      };
    },
    q10: function q10(error) {
      counter -= 1;

      if (counter <= 0) {
        throw error;
      }

      return {
        nextState: 'q1',
        effect: yDelay
      };
    }
  }, 'q1', "retry(" + fn.name + ")");
}

function debounceHelper(delayLength, patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action, raceOutput;
  var yTake = {
    done: false,
    value: take(patternOrChannel)
  };
  var yRace = {
    done: false,
    value: race({
      action: take(patternOrChannel),
      debounce: delay(delayLength)
    })
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yNoop = function yNoop(value) {
    return {
      done: false,
      value: value
    };
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  var setRaceOutput = function setRaceOutput(ro) {
    return raceOutput = ro;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q3',
        effect: yRace,
        stateUpdater: setRaceOutput
      };
    },
    q3: function q3() {
      return raceOutput.debounce ? {
        nextState: 'q1',
        effect: yFork(action)
      } : {
        nextState: 'q2',
        effect: yNoop(raceOutput.action),
        stateUpdater: setAction
      };
    }
  }, 'q1', "debounce(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

var validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
  check(patternOrChannel, notUndef, fn.name + " requires a pattern or channel");
  check(worker, notUndef, fn.name + " requires a saga parameter");
};

function takeEvery$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return io_c3792963_fork.apply(void 0, [takeEvery, patternOrChannel, worker].concat(args));
}
function takeLatest$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return io_c3792963_fork.apply(void 0, [takeLatest, patternOrChannel, worker].concat(args));
}
function takeLeading$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    args[_key3 - 2] = arguments[_key3];
  }

  return io_c3792963_fork.apply(void 0, [takeLeading, patternOrChannel, worker].concat(args));
}
function throttle$1(ms, patternOrChannel, worker) {
  if (false) {}

  for (var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
    args[_key4 - 3] = arguments[_key4];
  }

  return fork.apply(void 0, [throttle, ms, patternOrChannel, worker].concat(args));
}
function retry$1(maxTries, delayLength, worker) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
    args[_key5 - 3] = arguments[_key5];
  }

  return call.apply(void 0, [retry, maxTries, delayLength, worker].concat(args));
}
function debounce(delayLength, pattern, worker) {
  for (var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
    args[_key6 - 3] = arguments[_key6];
  }

  return fork.apply(void 0, [debounceHelper, delayLength, pattern, worker].concat(args));
}



;// CONCATENATED MODULE: ../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js


// EXTERNAL MODULE: ../node_modules/deep-equal/index.js
var deep_equal = __webpack_require__(22741);
var deep_equal_default = /*#__PURE__*/__webpack_require__.n(deep_equal);
// EXTERNAL MODULE: ../main/src/utils/AdvSearchTypes.js
var AdvSearchTypes = __webpack_require__(39403);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content_content = __webpack_require__(69051);
// EXTERNAL MODULE: ../shared/utils/search/search.js
var search_search = __webpack_require__(15347);
// EXTERNAL MODULE: ../shared/api/not-sorted.utils.js
var not_sorted_utils = __webpack_require__(1511);
// EXTERNAL MODULE: ../shared/api/baseApi.js
var baseApi = __webpack_require__(97649);
// EXTERNAL MODULE: ../shared/api/analitics.js
var analitics = __webpack_require__(82287);
// EXTERNAL MODULE: ../shared/utils/content/content.constants.js
var content_constants = __webpack_require__(5626);
;// CONCATENATED MODULE: ../shared/api/search/utils.js
function utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? utils_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var normalizeSearchBasicResponse = function normalizeSearchBasicResponse(query, response) {
  var _response$data = response.data,
      total = _response$data.total,
      _response$data$langua = _response$data.language_facets,
      languageFacets = _response$data$langua === void 0 ? {} : _response$data$langua,
      suggested_query = _response$data.suggested_query;
  var results = response.data.results.map(function (item) {
    return _objectSpread(_objectSpread({
      query: query
    }, item), {}, {
      isForSale: item.action_required === content_constants/* BOOK_PERMISSION.purchased */.k$.purchased,
      id: (0,content_content/* getBookIdWithPrefix */.NR)(item.para_id),
      className: content_constants/* CONTENT_CLASSES.BOOK */.J8.BOOK
    });
  });
  return {
    total: total,
    languageFacets: languageFacets,
    results: results,
    suggested_query: suggested_query
  };
};
// EXTERNAL MODULE: ../shared/api/search/advanced/requests.js + 1 modules
var requests = __webpack_require__(23157);
;// CONCATENATED MODULE: ../shared/api/search/related/requests.js
function requests_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function requests_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? requests_ownKeys(Object(source), !0).forEach(function (key) { requests_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : requests_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function requests_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var relevantSearchRequest = function relevantSearchRequest(query, context, extras, limit, offset) {
  var lang = extras["lang"] || "en";
  var section = extras["section"];
  var order = extras.order ? "&order=" + extras.order : "";
  var url = "related/search/" + lang + "/" + section + "/" + context + "?query=" + encodeURIComponent(query) + order + "&limit=" + limit + "&offset=" + offset; // console.groupCollapsed(`🔍 RS ${query} [${limit}] (${lang || "no lang"})`);
  // console.table({
  //   queryEncoded: encodeURIComponent(query),
  //   lang,
  //   section,
  //   context,
  //   order,
  //   limit,
  //   offset,
  // });
  // console.groupEnd();

  var request = {
    url: url,
    type: "get",
    parseResponse: function parseResponse(response) {
      var total = response.data.total;
      console.log("relevantSearch:response", response);
      var results = response.data.results.map(function (item, k) {
        if (item.index) {
          return requests_objectSpread(requests_objectSpread({
            query: query
          }, item), {}, {
            isForSale: item.action_required === content_constants/* BOOK_PERMISSION.purchased */.k$.purchased,
            id: (0,content_content/* getBookIdWithPrefix */.NR)(item.para_id),
            className: "book"
          });
        }

        return requests_objectSpread(requests_objectSpread({
          query: query,
          index: offset + k
        }, item), {}, {
          isForSale: item.action_required === content_constants/* BOOK_PERMISSION.purchased */.k$.purchased,
          id: (0,content_content/* getBookIdWithPrefix */.NR)(item.para_id)
        });
      });
      return {
        total: total,
        results: results,
        languageFacets: {}
      };
    }
  };
  return (0,baseApi/* makeRequest */.$f)(request);
};
var searchTopicsRequest = function searchTopicsRequest(searchValue) {
  return makeRequest({
    url: "search/related/topics?query=".concat(encodeURIComponent(searchValue), "&lang=en"),
    type: "get",
    memoryCache: true,
    parseResponse: parseResponseDefault
  });
};
// EXTERNAL MODULE: ../shared/utils/search/search.constants.js
var search_constants = __webpack_require__(80226);
// EXTERNAL MODULE: ../shared/utils/multilang/constants.js
var constants = __webpack_require__(76439);
// EXTERNAL MODULE: ../shared/api/utils.js
var utils = __webpack_require__(65851);
// EXTERNAL MODULE: ../shared/utils/search/advanced/advanced.js
var advanced = __webpack_require__(55082);
;// CONCATENATED MODULE: ../shared/api/search/SearchAPI.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function SearchAPI_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SearchAPI_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SearchAPI_ownKeys(Object(source), !0).forEach(function (key) { SearchAPI_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SearchAPI_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function SearchAPI_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-console */













function basicSearchRequest(_ref) {
  var query = _ref.query,
      offset = _ref.offset,
      folders = _ref.folders,
      books = _ref.books,
      chapters = _ref.chapters,
      extras = _ref.extras,
      limit = _ref.limit,
      langs = _ref.langs;
  var postData = {
    query: query,
    limit: limit !== null && limit !== void 0 ? limit : AdvSearchTypes/* resultsLimit */.Fu,
    offset: offset,
    facets: true,
    include_language_facets: true
  };
  var apiExtras = extras ? SearchAPI_objectSpread({}, extras) : {};

  if (apiExtras.queryType) {
    apiExtras.query_type = apiExtras.queryType;
    delete apiExtras.queryType;
  }

  if (extras !== null && extras !== void 0 && extras.period) {
    apiExtras.period = AdvSearchTypes/* virtualPeriodValues.includes */.pg.includes(extras.period) ? search_constants/* PeriodWithCustom.all */.TR.all : extras.period;
  }

  delete apiExtras["type"];
  delete apiExtras["treePeriod"];

  if ((extras === null || extras === void 0 ? void 0 : extras.period) === search_constants/* PeriodWithCustom.myBible */.TR.myBible && !(chapters !== null && chapters !== void 0 && chapters.length)) {
    postData.pubnr = [(0,advanced/* getBiblePubnr */.n4)(apiExtras["pubnr"] || (books === null || books === void 0 ? void 0 : books[0]))];
  } else if ((extras === null || extras === void 0 ? void 0 : extras.period) === search_constants/* PeriodWithCustom.apl */.TR.apl) {
    postData.folder = search_constants/* FOLDERS_IDS_APL */.sX;
  } else {
    if (folders && folders.length === 1 && folders[0] === "all") {
      var defLang = (extras === null || extras === void 0 ? void 0 : extras.defLang) || constants/* DEFAULT_LANGUAGE */.k$;
      delete apiExtras["defLang"];
      postData.lang = [defLang, "all"];
    } else if (folders && folders.length) {
      var _parseFolders2 = (0,AdvSearchTypes/* parseFolders */.FI)(folders),
          lang = _parseFolders2.lang,
          folder = _parseFolders2.folder,
          pubnr = _parseFolders2.pubnr;

      postData.folder = folder;
      postData.pubnr = pubnr;
      postData.lang = lang;
      delete apiExtras["lang"];
    }

    if (langs) {
      postData.lang = langs;
    }

    if (books && books.length) {
      var _parseFolders4 = (0,AdvSearchTypes/* parseFolders */.FI)(books.map(content_content/* getBookIdWithPrefix */.NR)),
          _pubnr = _parseFolders4.pubnr;

      postData.pubnr = _pubnr;
      postData.period = search_constants/* PeriodWithCustom.all */.TR.all;
    }

    if (chapters !== null && chapters !== void 0 && chapters.length) {
      postData.chapter = chapters;
    }
  }

  if (apiExtras) {
    postData = SearchAPI_objectSpread(SearchAPI_objectSpread({}, apiExtras), postData);
  }

  if (postData.lang) {
    if (typeof postData.lang === "string") {
      postData.lang = [postData.lang];
    }
  } else {
    delete postData.lang;
  }

  if (!postData.snippet) {
    postData.snippet = "short";
  }

  (0,analitics/* logSearchEvent */.l_)(analitics/* SearchLogEvents.SEARCH */.vZ.SEARCH, postData); // console.groupCollapsed(
  //   `🔎 SH ${query} (${postData.lang?.length ? postData.lang : "no lang"})`
  //   + ` [${postData.limit}]`
  //   + ` ${postData.query_type ? (postData.query_type + " ") : ""}`
  // );
  // console.table(Object.keys(postData).reduce((acc, key) => {
  //   if (postData[key]) {
  //     acc[key] = Array.isArray(postData[key]) ? postData[key].toString() : postData[key];
  //   }
  //   return acc;
  // }, {}));
  // console.groupEnd();

  var url = "search";
  var cacheName = url + JSON.stringify(postData);
  return (0,baseApi/* makeRequest */.$f)({
    url: url,
    type: "post",
    memoryCache: true,
    memoryCacheName: cacheName,
    data: postData,
    parseResponse: function parseResponse(response) {
      return normalizeSearchBasicResponse(query, response);
    }
  });
}

function splitSearchMatchRequest(_x) {
  return _splitSearchMatchRequest.apply(this, arguments);
}

function _splitSearchMatchRequest() {
  _splitSearchMatchRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", (0,search_search/* fixSearchPreferExact */.IA)(function (queryType, offset, limit) {
            return basicSearchRequest(SearchAPI_objectSpread(SearchAPI_objectSpread({}, params), {}, {
              extras: SearchAPI_objectSpread(SearchAPI_objectSpread({}, params.extras), {}, {
                queryType: queryType
              }),
              offset: offset,
              limit: limit
            }));
          }, params.offset, params.limit));

        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _splitSearchMatchRequest.apply(this, arguments);
}

var splitSearchRequest = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
    var query, offset, limit, folders, books, extras, langs, nIdBookFirst, fetchFn, check1, total, results, response1, req2Offset, req2Limit, needMoreResults, hasMoreResultsFromFirstPart, response2, response2ResultsIndexUpdated, check2;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          query = _ref2.query, offset = _ref2.offset, limit = _ref2.limit, folders = _ref2.folders, books = _ref2.books, extras = _ref2.extras, langs = _ref2.langs;
          nIdBookFirst = (0,content_content/* getBookIdNumber */.o8)(extras === null || extras === void 0 ? void 0 : extras.bookfirst);
          fetchFn = extras.queryType === search_constants/* QUERY_TYPE.PREFER_EXACT */.OS.PREFER_EXACT ? splitSearchMatchRequest : basicSearchRequest;
          _context.next = 5;
          return fetchFn({
            query: query,
            langs: langs,
            folders: folders,
            books: [nIdBookFirst],
            extras: SearchAPI_objectSpread(SearchAPI_objectSpread({}, extras), {}, {
              period: search_constants/* Period.all */.pH.all
            }),
            offset: 0,
            limit: 1
          });

        case 5:
          check1 = _context.sent;
          total = check1.total;
          results = [];

          if (!(total > offset)) {
            _context.next = 13;
            break;
          }

          _context.next = 11;
          return fetchFn({
            query: query,
            langs: langs,
            folders: folders,
            books: [nIdBookFirst],
            extras: SearchAPI_objectSpread(SearchAPI_objectSpread({}, extras), {}, {
              period: search_constants/* Period.all */.pH.all
            }),
            offset: offset,
            limit: limit
          });

        case 11:
          response1 = _context.sent;
          results.push.apply(results, _toConsumableArray(response1.results));

        case 13:
          req2Offset = offset + results.length - total;
          req2Limit = limit - results.length;
          needMoreResults = req2Limit > 0;
          hasMoreResultsFromFirstPart = req2Offset < search_constants/* SEARCH_TOTAL_MAX */.QL && req2Offset > -1;

          if (!(needMoreResults && hasMoreResultsFromFirstPart)) {
            _context.next = 26;
            break;
          }

          _context.next = 20;
          return fetchFn({
            query: query,
            folders: folders,
            books: books,
            langs: langs,
            extras: SearchAPI_objectSpread(SearchAPI_objectSpread({}, extras), {}, {
              excluded_pubnr: [nIdBookFirst]
            }),
            offset: req2Offset,
            limit: req2Limit
          });

        case 20:
          response2 = _context.sent;
          response2ResultsIndexUpdated = response2.results.map(function (item) {
            return SearchAPI_objectSpread(SearchAPI_objectSpread({}, item), {}, {
              index: item.index + total
            });
          });
          total += response2.total;
          results.push.apply(results, _toConsumableArray(response2ResultsIndexUpdated));
          _context.next = 30;
          break;

        case 26:
          _context.next = 28;
          return fetchFn({
            query: query,
            folders: folders,
            books: books,
            langs: langs,
            extras: SearchAPI_objectSpread(SearchAPI_objectSpread({}, extras), {}, {
              excluded_pubnr: [nIdBookFirst]
            }),
            offset: 0,
            limit: 1
          });

        case 28:
          check2 = _context.sent;
          total += check2.total;

        case 30:
          return _context.abrupt("return", {
            total: total,
            results: results
          });

        case 31:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function splitSearchRequest(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var searchRequest = function searchRequest(_ref4) {
  var _extras$lang;

  var query = _ref4.query,
      start = _ref4.start,
      folders = _ref4.folders,
      books = _ref4.books,
      context = _ref4.context,
      extras = _ref4.extras,
      _ref4$limit = _ref4.limit,
      limit = _ref4$limit === void 0 ? AdvSearchTypes/* resultsLimit */.Fu : _ref4$limit,
      chapters = _ref4.chapters,
      langs = _ref4.langs;
  var offset = parseInt(start, 10);

  if (search_constants/* advSearchTypes.includes */.Bo.includes(extras === null || extras === void 0 ? void 0 : extras.type)) {
    return (0,requests/* advSearch */.ic)(query, extras, limit, offset, folders);
  }

  if ((extras === null || extras === void 0 ? void 0 : extras.type) === search_constants/* SearchType.related */.Sc.related && (extras === null || extras === void 0 ? void 0 : (_extras$lang = extras.lang) === null || _extras$lang === void 0 ? void 0 : _extras$lang.length) > 0) {
    return relevantSearchRequest(query, context, extras, limit, offset);
  } else if ((extras === null || extras === void 0 ? void 0 : extras.type) === search_constants/* SearchType.related */.Sc.related) {
    return false;
  }

  if (extras !== null && extras !== void 0 && extras.bookfirst) {
    var extrasFinal = SearchAPI_objectSpread({}, extras);

    delete extras.bookfirst;
    return splitSearchRequest({
      query: query,
      offset: offset,
      folders: folders,
      books: books,
      extras: extrasFinal,
      limit: limit
    });
  }

  if ((extras === null || extras === void 0 ? void 0 : extras.queryType) === search_constants/* QUERY_TYPE.PREFER_EXACT */.OS.PREFER_EXACT) {
    return splitSearchMatchRequest({
      query: query,
      offset: offset,
      folders: folders,
      books: books,
      context: context,
      extras: extras,
      limit: limit || AdvSearchTypes/* resultsLimit */.Fu,
      chapters: chapters,
      langs: langs
    });
  }

  return basicSearchRequest({
    query: query,
    offset: offset,
    folders: folders,
    context: context,
    books: books,
    chapters: chapters,
    extras: extras,
    langs: langs,
    limit: limit
  });
};
var searchBookByNameRequest = function searchBookByNameRequest(query, langs) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  var params = ["query=".concat(encodeURIComponent(query))];

  if (langs) {
    params.push(makeParamsString({
      lang: langs
    }, true));
  }

  if (limit) {
    params.push("limit=".concat(limit));
  }

  return makeRequest({
    url: "search/book/name?".concat(params.join("&")),
    memoryCache: true,
    parseResponse: function parseResponse(response) {
      var _response$data = response.data,
          total = _response$data.total,
          results = _response$data.results;
      return {
        total: total,
        results: results.map(function (item) {
          return SearchAPI_objectSpread(SearchAPI_objectSpread({}, item), {}, {
            id: getBookIdWithPrefix(item.book_id),
            coverSmall: item.cover,
            folder_color_group: item.folder_type
          });
        })
      };
    }
  });
};
var getPosibleTranslateLangRequest = function getPosibleTranslateLangRequest(lang) {
  return makeRequest({
    url: "/translations/languages/" + lang,
    memoryCache: true,
    parseResponse: parseResponseDefault
  });
};
var getTranslateRequest = function getTranslateRequest(langs, query) {
  var fromLang = langs.fromLang,
      toLang = langs.toLang;
  return makeRequest({
    url: "/translations/translate?from=".concat(fromLang, "&to=").concat(toLang, "&text=").concat(query),
    memoryCache: true,
    parseResponse: parseResponseDefault
  });
};
// EXTERNAL MODULE: ./src/next/store/actions/index.js + 6 modules
var actions = __webpack_require__(62013);
// EXTERNAL MODULE: ./src/next/components/SearchWidget/SearchWidget.utils.js
var SearchWidget_utils = __webpack_require__(7578);
// EXTERNAL MODULE: ../shared/store/search/constants.js
var store_search_constants = __webpack_require__(76713);
// EXTERNAL MODULE: ../shared/store/search/selectors.js
var selectors = __webpack_require__(24803);
// EXTERNAL MODULE: ../shared/utils/console.js
var utils_console = __webpack_require__(65795);
;// CONCATENATED MODULE: ../shared/api/suggestions/utils.js
var parseResponseFakeRelatedSearchSuggestions = function parseResponseFakeRelatedSearchSuggestions(response) {
  if (response && response.suggestions) {
    return response.suggestions.map(function (data, key) {
      return {
        group: "external",
        index: key,
        result: data
      };
    });
  }

  return null;
};
;// CONCATENATED MODULE: ../shared/api/suggestions/suggestions.js
function suggestions_typeof(obj) { "@babel/helpers - typeof"; return suggestions_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, suggestions_typeof(obj); }

function suggestions_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ suggestions_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == suggestions_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function suggestions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function suggestions_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { suggestions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { suggestions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }






var getTextDetectedLanguagesRequest = function getTextDetectedLanguagesRequest(text, languagesToDetectIn) {
  return (0,baseApi/* makeRequest */.$f)({
    url: "/suggestions/detect?" + (0,utils/* makeParamsString */.HR)({
      text: text,
      language: languagesToDetectIn
    }, true),
    memoryCache: true,
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  });
}; // make default count 100 for avoid multiple call

var getSuggestionsPopupRequest = /*#__PURE__*/function () {
  var _ref = suggestions_asyncToGenerator( /*#__PURE__*/suggestions_regeneratorRuntime().mark(function _callee(searchValue, lang) {
    var count,
        result,
        _args = arguments;
    return suggestions_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          count = _args.length > 2 && _args[2] !== undefined ? _args[2] : 100;
          _context.next = 3;
          return (0,baseApi/* makeRequest */.$f)({
            url: "/suggestions/popup/".concat(lang, "?query=").concat(encodeURIComponent(searchValue), "&count=").concat(count),
            type: "get",
            memoryCache: true,
            memoryCacheName: "SG-" + lang + "-" + searchValue + "-" + count,
            parseResponse: not_sorted_utils/* parseResponseDefault */.t3
          });

        case 3:
          result = _context.sent;
          return _context.abrupt("return", result);

        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function getSuggestionsPopupRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchFakeRelatedSearchSuggestions = /*#__PURE__*/function () {
  var _ref2 = suggestions_asyncToGenerator( /*#__PURE__*/suggestions_regeneratorRuntime().mark(function _callee2(searchValue, lang) {
    var count,
        result,
        _args2 = arguments;
    return suggestions_regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          count = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 100;
          _context2.next = 3;
          return getSuggestionsPopupRequest(searchValue, lang, count);

        case 3:
          result = _context2.sent;
          return _context2.abrupt("return", parseResponseFakeRelatedSearchSuggestions(result));

        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function fetchFakeRelatedSearchSuggestions(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ../shared/store/settings/selectors.js
var settings_selectors = __webpack_require__(4787);
// EXTERNAL MODULE: ../shared/utils/settings/constants.js + 1 modules
var settings_constants = __webpack_require__(20467);
// EXTERNAL MODULE: ../shared/utils/array.js
var utils_array = __webpack_require__(21707);
// EXTERNAL MODULE: ../shared/api/search/suggestions/requests.js + 1 modules
var suggestions_requests = __webpack_require__(33967);
// EXTERNAL MODULE: ../shared/utils/user-agent.js
var user_agent = __webpack_require__(74741);
// EXTERNAL MODULE: ../shared/store/system/actions.js
var system_actions = __webpack_require__(93893);
// EXTERNAL MODULE: ../shared/store/mainTree/selectors.js
var mainTree_selectors = __webpack_require__(47725);
// EXTERNAL MODULE: ../shared/store/search/actions.js
var search_actions = __webpack_require__(37314);
;// CONCATENATED MODULE: ../shared/store/search/saga.js
function saga_typeof(obj) { "@babel/helpers - typeof"; return saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, saga_typeof(obj); }

function saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var _marked = /*#__PURE__*/saga_regeneratorRuntime().mark(_sharedWorkerFetchShortcuts),
    _marked2 = /*#__PURE__*/saga_regeneratorRuntime().mark(fetchTextDetectedLanguagesWorker),
    _marked3 = /*#__PURE__*/saga_regeneratorRuntime().mark(_sharedWorkerFetchSuggestionsPopup);

function saga_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function saga_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? saga_ownKeys(Object(source), !0).forEach(function (key) { saga_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : saga_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function saga_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function saga_toConsumableArray(arr) { return saga_arrayWithoutHoles(arr) || saga_iterableToArray(arr) || saga_unsupportedIterableToArray(arr) || saga_nonIterableSpread(); }

function saga_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function saga_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return saga_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return saga_arrayLikeToArray(o, minLen); }

function saga_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function saga_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return saga_arrayLikeToArray(arr); }

function saga_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
















var scope = "Saga Search";
function _sharedWorkerFetchShortcuts(query) {
  var _responseSorted, _responseSorted$;

  var shortcutsAll, queryTrimmed, responseSorted, response, baseBible, indexBaseBible, _responseSorted2, _responseSorted2$, trimQuery, detectResponce, detectMap;

  return saga_regeneratorRuntime().wrap(function _sharedWorkerFetchShortcuts$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        if (query) {
          _context.next = 2;
          break;
        }

        return _context.abrupt("return", null);

      case 2:
        _context.next = 4;
        return io_c3792963_select(selectors/* selectorSearchShortcuts */.e0);

      case 4:
        shortcutsAll = _context.sent;
        queryTrimmed = query.trim();
        responseSorted = shortcutsAll[queryTrimmed];

        if (!(queryTrimmed && !responseSorted)) {
          _context.next = 26;
          break;
        }

        _context.prev = 8;
        _context.next = 11;
        return io_c3792963_call(suggestions_requests/* getSearchSuggestionsRequest */.Ib, queryTrimmed, true);

      case 11:
        response = _context.sent;

        if (!response) {
          _context.next = 21;
          break;
        }

        // Make base bible first in the list
        responseSorted = saga_toConsumableArray(response);
        _context.next = 16;
        return io_c3792963_select((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.baseBible.id */.Fy.baseBible.id));

      case 16:
        baseBible = _context.sent;
        indexBaseBible = responseSorted.findIndex(function (item) {
          return item.bookId === baseBible;
        });

        if (indexBaseBible !== -1 && indexBaseBible !== 0) {
          (0,utils_array/* arraymove */.yf)(responseSorted, indexBaseBible, 0);
        } // =====================================


        _context.next = 21;
        return put(search_actions/* _sharedActionsSearch.fetchShortcutSuccess */.F.fetchShortcutSuccess(saga_objectSpread(saga_objectSpread({}, shortcutsAll), {}, saga_defineProperty({}, queryTrimmed, responseSorted))));

      case 21:
        _context.next = 26;
        break;

      case 23:
        _context.prev = 23;
        _context.t0 = _context["catch"](8);
        (0,utils_console/* consoleLogError */.aw)("search.saga", "_sharedWorkerFetchShortcuts error: ", {
          error: _context.t0,
          query: query,
          shortcutsAll: shortcutsAll,
          trimQuery: queryTrimmed,
          responseSorted: responseSorted
        });

      case 26:
        if (!((_responseSorted = responseSorted) !== null && _responseSorted !== void 0 && (_responseSorted$ = _responseSorted[0]) !== null && _responseSorted$ !== void 0 && _responseSorted$.cutQuery)) {
          _context.next = 33;
          break;
        }

        trimQuery = (_responseSorted2 = responseSorted) === null || _responseSorted2 === void 0 ? void 0 : (_responseSorted2$ = _responseSorted2[0]) === null || _responseSorted2$ === void 0 ? void 0 : _responseSorted2$.cutQuery.trim();
        _context.next = 30;
        return io_c3792963_call(getTextDetectedLanguagesRequest, trimQuery);

      case 30:
        detectResponce = _context.sent;
        detectMap = (0,utils_array/* arrayToObjMap */.G2)(detectResponce, "language", "score");
        return _context.abrupt("return", responseSorted.filter(function (item) {
          return detectMap[item.lang] !== undefined && item.hits !== 0;
        }));

      case 33:
        return _context.abrupt("return", responseSorted);

      case 34:
      case "end":
        return _context.stop();
    }
  }, _marked, null, [[8, 23]]);
}

function fetchTextDetectedLanguagesWorker(action) {
  var query, trimQuery, detectResponce, detectLangs, langScore, mainTreeLangs, libraryLanguages, languageUI, detectedLangs;
  return saga_regeneratorRuntime().wrap(function fetchTextDetectedLanguagesWorker$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        query = action.data.query;
        _context2.prev = 1;
        trimQuery = query.trim();
        _context2.next = 5;
        return io_c3792963_call(getTextDetectedLanguagesRequest, trimQuery);

      case 5:
        detectResponce = _context2.sent;
        detectLangs = detectResponce.map(function (item) {
          return item.language;
        });
        langScore = (0,utils_array/* arrayToObjMap */.G2)(detectResponce, "language", "score");
        _context2.next = 10;
        return io_c3792963_select(mainTree_selectors/* selectorMainTree */.h6);

      case 10:
        mainTreeLangs = _context2.sent;
        _context2.next = 13;
        return io_c3792963_select((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.libraryLanguages.id */.Fy.libraryLanguages.id));

      case 13:
        libraryLanguages = _context2.sent;
        _context2.next = 16;
        return io_c3792963_select((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.languageUI.id */.Fy.languageUI.id));

      case 16:
        languageUI = _context2.sent;
        _context2.next = 19;
        return (0,search_search/* _makeLangSort */.Kc)(mainTreeLangs, libraryLanguages, languageUI, detectLangs, langScore);

      case 19:
        detectedLangs = _context2.sent;
        _context2.next = 22;
        return put(search_actions/* _sharedActionsSearch.fetchDetectSuccess */.F.fetchDetectSuccess(detectedLangs));

      case 22:
        _context2.next = 27;
        break;

      case 24:
        _context2.prev = 24;
        _context2.t0 = _context2["catch"](1);
        (0,utils_console/* consoleLogError */.aw)(scope, "fetchTextDetectedLanguagesWorker ERROR: ", _context2.t0);

      case 27:
      case "end":
        return _context2.stop();
    }
  }, _marked2, null, [[1, 24]]);
}

function _sharedWorkerFetchSuggestionsPopup(action) {
  var _action$data2, query, currentLang, queryTrimmed, _shortcuts$, shortcuts, queryFinal, correctionsFinal, _yield$select2, searchQueryLangsCache, queryCorrectionsCache, searchQueryLangs, correction, result, libraryLanguages, defLang, responseSuggestions, suggestionResult, _responseSuggestions$, _responseSuggestions$2, autocomplete;

  return saga_regeneratorRuntime().wrap(function _sharedWorkerFetchSuggestionsPopup$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.prev = 0;
        _action$data2 = action.data, query = _action$data2.query, currentLang = _action$data2.currentLang;

        if (query) {
          _context3.next = 4;
          break;
        }

        return _context3.abrupt("return");

      case 4:
        queryTrimmed = query.trim();

        if (!queryTrimmed) {
          _context3.next = 47;
          break;
        }

        _context3.next = 8;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(store_search_constants/* LOADER_ID_SUGGESTIONS */.y6));

      case 8:
        _context3.next = 10;
        return io_c3792963_call(fetchTextDetectedLanguagesWorker, {
          data: {
            query: queryTrimmed
          }
        });

      case 10:
        _context3.next = 12;
        return io_c3792963_call(_sharedWorkerFetchShortcuts, queryTrimmed);

      case 12:
        shortcuts = _context3.sent;
        queryFinal = (shortcuts === null || shortcuts === void 0 ? void 0 : (_shortcuts$ = shortcuts[0]) === null || _shortcuts$ === void 0 ? void 0 : _shortcuts$.cutQuery) || queryTrimmed;
        correctionsFinal = []; // Fetches amount of results in different languages for {queryFinal}
        // Fetches a correction query for {queryFinal}

        _context3.prev = 15;
        _context3.next = 18;
        return io_c3792963_select(function (state) {
          return state.search;
        });

      case 18:
        _yield$select2 = _context3.sent;
        searchQueryLangsCache = _yield$select2.searchQueryLangsCache;
        queryCorrectionsCache = _yield$select2.queryCorrectionsCache;
        searchQueryLangs = searchQueryLangsCache[queryFinal];
        correction = queryCorrectionsCache[queryFinal]; // Doesn't check for a {correction}, because it's optional return parameter in the API.

        if (searchQueryLangs) {
          _context3.next = 29;
          break;
        }

        _context3.next = 26;
        return io_c3792963_call(searchRequest, {
          query: queryFinal,
          start: 0,
          limit: 1
        });

      case 26:
        result = _context3.sent;
        searchQueryLangs = result === null || result === void 0 ? void 0 : result.languageFacets;
        correction = result === null || result === void 0 ? void 0 : result.suggested_query;

      case 29:
        if (correction) {
          correctionsFinal.push(correction);
        }

        _context3.next = 32;
        return put(search_actions/* _sharedActionsSearch.fetchLangsForWordSuccess */.F.fetchLangsForWordSuccess(searchQueryLangs, queryFinal, correction));

      case 32:
        _context3.next = 37;
        break;

      case 34:
        _context3.prev = 34;
        _context3.t0 = _context3["catch"](15);
        (0,utils_console/* consoleLogError */.aw)(scope, "Try/Catch with a searchRequest ERROR: ", _context3.t0);

      case 37:
        _context3.next = 39;
        return io_c3792963_select((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.libraryLanguages.id */.Fy.libraryLanguages.id));

      case 39:
        libraryLanguages = _context3.sent;
        defLang = (0,user_agent/* getLanguageDefault */.hW)(libraryLanguages);
        _context3.next = 43;
        return io_c3792963_call(getSuggestionsPopupRequest, queryFinal, currentLang || defLang);

      case 43:
        responseSuggestions = _context3.sent;

        if (responseSuggestions) {
          if (typeof responseSuggestions.did_you_mean === "string") {
            if (responseSuggestions.did_you_mean !== queryTrimmed) {
              correctionsFinal.push(responseSuggestions.did_you_mean);
            }
          } else if (Array.isArray(responseSuggestions.did_you_mean) && responseSuggestions.did_you_mean.length) {
            correctionsFinal.push.apply(correctionsFinal, saga_toConsumableArray(responseSuggestions.did_you_mean.filter(function (s) {
              return s !== queryTrimmed;
            })));
          }

          autocomplete = (_responseSuggestions$ = responseSuggestions === null || responseSuggestions === void 0 ? void 0 : (_responseSuggestions$2 = responseSuggestions.autocomplete) === null || _responseSuggestions$2 === void 0 ? void 0 : _responseSuggestions$2.filter(function (autocompleteItem) {
            return autocompleteItem.trim() !== queryTrimmed;
          })) !== null && _responseSuggestions$ !== void 0 ? _responseSuggestions$ : [];
          correctionsFinal.sort(function (a, b) {
            return b.type > a.type ? 1 : -1;
          });
          suggestionResult = {
            searchedQuery: queryTrimmed,
            corrections: correctionsFinal,
            shortcuts: shortcuts,
            suggestions: responseSuggestions.suggestions,
            synonyms: responseSuggestions.synonyms,
            autocomplete: autocomplete
          };
        }

        _context3.next = 47;
        return put(search_actions/* _sharedActionsSearch.fetchSuggestionSuccess */.F.fetchSuggestionSuccess(suggestionResult));

      case 47:
        _context3.next = 52;
        break;

      case 49:
        _context3.prev = 49;
        _context3.t1 = _context3["catch"](0);
        (0,utils_console/* consoleLogError */.aw)(scope, "_sharedWorkerFetchSuggestionsPopup ERROR: ", _context3.t1);

      case 52:
        _context3.prev = 52;
        _context3.next = 55;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(store_search_constants/* LOADER_ID_SUGGESTIONS */.y6, true));

      case 55:
        return _context3.finish(52);

      case 56:
      case "end":
        return _context3.stop();
    }
  }, _marked3, null, [[0, 49, 52, 56], [15, 34]]);
}
// EXTERNAL MODULE: ./src/next/store/actions/featuredSearch.actions.js
var featuredSearch_actions = __webpack_require__(72777);
;// CONCATENATED MODULE: ./src/next/store/saga/search.saga.js
function search_saga_typeof(obj) { "@babel/helpers - typeof"; return search_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, search_saga_typeof(obj); }

function search_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ search_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == search_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var search_saga_marked = /*#__PURE__*/search_saga_regeneratorRuntime().mark(fetchSearchMethod),
    search_saga_marked2 = /*#__PURE__*/search_saga_regeneratorRuntime().mark(fetchSearchDictionaryWorker),
    search_saga_marked3 = /*#__PURE__*/search_saga_regeneratorRuntime().mark(searchSaga);















var TAG = "searchSaga_";

function fetchSearchMethod(action) {
  var _action$data, actionSearchParams, onSuccess, searchParams, actionSearchParamsFormatted, extras, query, lang, context, start, limit, type, resultsSuggestions, notFound, search, result;

  return search_saga_regeneratorRuntime().wrap(function fetchSearchMethod$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _action$data = action.data, actionSearchParams = _action$data.actionSearchParams, onSuccess = _action$data.onSuccess;
        _context.next = 3;
        return io_c3792963_select(selectors/* selectorSearchParams */.im);

      case 3:
        searchParams = _context.sent;
        actionSearchParamsFormatted = (0,SearchWidget_utils/* formatSearchParams */.VL)(actionSearchParams);
        actionSearchParamsFormatted.timestamp = Date.now();
        extras = actionSearchParamsFormatted.extras, query = actionSearchParamsFormatted.query, lang = actionSearchParamsFormatted.lang, context = actionSearchParamsFormatted.context, start = actionSearchParamsFormatted.start, limit = actionSearchParamsFormatted.limit;
        type = extras.type;

        if (!(type === search_constants/* SearchType.related */.Sc.related && context === "suggestions" && lang)) {
          _context.next = 15;
          break;
        }

        _context.next = 11;
        return io_c3792963_call(fetchFakeRelatedSearchSuggestions, query, lang);

      case 11:
        resultsSuggestions = _context.sent;
        _context.next = 14;
        return put(actions/* searchActions.searchSuccess */.RR.searchSuccess({
          searchParams: actionSearchParamsFormatted,
          search: {
            total: resultsSuggestions.length,
            results: resultsSuggestions.splice(start, limit)
          }
        }));

      case 14:
        return _context.abrupt("return");

      case 15:
        if (deep_equal_default()(actionSearchParamsFormatted, searchParams)) {
          _context.next = 32;
          break;
        }

        if ((0,search_search/* validateSearchQuery */.Kq)(actionSearchParamsFormatted.query)) {
          _context.next = 18;
          break;
        }

        return _context.abrupt("return");

      case 18:
        notFound = {
          total: 0,
          results: []
        };
        _context.next = 21;
        return put(actions/* systemActions.loading */.nm.loading(store_search_constants/* LOADER_ID_LOAD_SEARCH */.El));

      case 21:
        _context.next = 23;
        return io_c3792963_call(searchRequest, actionSearchParamsFormatted);

      case 23:
        search = _context.sent;
        result = search || notFound;

        if (onSuccess) {
          onSuccess(result);
        }

        _context.next = 28;
        return put(actions/* searchActions.searchSuccess */.RR.searchSuccess({
          search: result,
          searchParams: actionSearchParamsFormatted
        }));

      case 28:
        _context.next = 30;
        return put(actions/* systemActions.loading */.nm.loading(store_search_constants/* LOADER_ID_LOAD_SEARCH */.El, true));

      case 30:
        _context.next = 32;
        return put(featuredSearch_actions/* actionsFeaturedSearch.fetchByQuery */.x.fetchByQuery(actionSearchParamsFormatted.query, searchParams.folders));

      case 32:
      case "end":
        return _context.stop();
    }
  }, search_saga_marked);
}

function fetchSearchDictionaryWorker(action) {
  var result, _action$data3, query, dictionary;

  return search_saga_regeneratorRuntime().wrap(function fetchSearchDictionaryWorker$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.prev = 0;
        _action$data3 = action.data, query = _action$data3.query, dictionary = _action$data3.dictionary;
        _context2.next = 4;
        return put(actions/* systemActions.loading */.nm.loading(store_search_constants/* LOADER_ID_DICTIONARY_LOAD */.RR));

      case 4:
        if (!(dictionary === search_constants/* dictionaryAllFilterKey */.uB)) {
          _context2.next = 10;
          break;
        }

        _context2.next = 7;
        return io_c3792963_call(requests/* searchDictionaryContent */.Z, query, null);

      case 7:
        result = _context2.sent;
        _context2.next = 13;
        break;

      case 10:
        _context2.next = 12;
        return io_c3792963_call(requests/* searchDictionaryContent */.Z, query, dictionary);

      case 12:
        result = _context2.sent;

      case 13:
        if (!Array.isArray(result)) {
          _context2.next = 18;
          break;
        }

        _context2.next = 16;
        return put(actions/* searchActions.searchDictionarySuccess */.RR.searchDictionarySuccess({
          query: query,
          dictionary: dictionary
        }, result));

      case 16:
        _context2.next = 20;
        break;

      case 18:
        _context2.next = 20;
        return put(actions/* searchActions.searchDictionarySuccess */.RR.searchDictionarySuccess({
          query: query,
          dictionary: dictionary
        }, []));

      case 20:
        _context2.next = 25;
        break;

      case 22:
        _context2.prev = 22;
        _context2.t0 = _context2["catch"](0);
        (0,utils_console/* consoleLogError */.aw)(TAG, "fetchSearchDictionaryWorker ERROR: ", {
          error: _context2.t0,
          action: action
        });

      case 25:
        _context2.prev = 25;
        _context2.next = 28;
        return put(actions/* systemActions.loading */.nm.loading(store_search_constants/* LOADER_ID_DICTIONARY_LOAD */.RR, true));

      case 28:
        return _context2.finish(25);

      case 29:
      case "end":
        return _context2.stop();
    }
  }, search_saga_marked2, null, [[0, 22, 25, 29]]);
}

function searchSaga() {
  return search_saga_regeneratorRuntime().wrap(function searchSaga$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return io_c3792963_all([takeLatest$1(actions/* searchActionConstants.ACTION_SEARCH */.cT.ACTION_SEARCH, fetchSearchMethod), takeLatest$1(actions/* searchActionConstants.FETCH_SUGGESTION */.cT.FETCH_SUGGESTION, _sharedWorkerFetchSuggestionsPopup), takeLatest$1(actions/* searchActionConstants.FETCH_SEARCH_DICTIONARY */.cT.FETCH_SEARCH_DICTIONARY, fetchSearchDictionaryWorker)]);

      case 2:
      case "end":
        return _context3.stop();
    }
  }, search_saga_marked3);
}
// EXTERNAL MODULE: ../shared/api/CacheHolder.js
var CacheHolder = __webpack_require__(33775);
// EXTERNAL MODULE: ../shared/utils/langs.js
var langs = __webpack_require__(76221);
;// CONCATENATED MODULE: ../shared/api/relevantSearch/utils.js

var normalizeFeaturedSearchSections = function normalizeFeaturedSearchSections(sections) {
  return (0,utils_array/* sortByArray */.lI)(sections, ["bibleCommentaries", "concordances", "dictionary", "bibleVersions", "similarParagraphs", "egwIndex", "aplIndex"], "code");
};
;// CONCATENATED MODULE: ../shared/api/relevantSearch/RelevantSearchAPI.js






var relevantSearchSchemeRequest = function relevantSearchSchemeRequest(lang) {
  var url = "/related/form/";
  var storageCacheName = CacheHolder/* CACHE_RELEVANT_FORMS */.yu;

  if (lang) {
    url += "?lang=" + langs/* langListShort */.Q;
    storageCacheName += "_" + lang;
  }

  return (0,baseApi/* makeRequest */.$f)({
    url: url,
    storageCacheName: storageCacheName,
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  });
};
var relevantSearchFacetAggregateRequest = function relevantSearchFacetAggregateRequest(data) {
  var lang = data.lang,
      query = data.query;
  var queryLowerCase = query.toLowerCase();
  return (0,baseApi/* makeRequest */.$f)({
    url: "/related/aggregate/?lang=".concat(lang, "&query=").concat(encodeURIComponent(queryLowerCase)),
    type: "get",
    memoryCache: true,
    memoryCacheName: "FC-" + lang + "-" + queryLowerCase,
    parseResponse: function parseResponse(response) {
      // consoleLogGroup(`🪞 RS ${queryLowerCase} (${lang || "no lang"})`, response.data);
      return response.data;
    }
  });
};
var fetchFeaturedSearchRequest = function fetchFeaturedSearchRequest(query) {
  var langs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var cacheKey = query + (langs || []).toString();
  return (0,baseApi/* makeRequest */.$f)({
    url: "/search/featured/search?query=".concat(encodeURIComponent(query), "&lang=").concat(langs),
    type: "get",
    memoryCache: true,
    parseResponse: function parseResponse(response) {
      if (response.data.sections) {
        return normalizeFeaturedSearchSections(response.data.sections);
      }

      return [];
    }
  });
};
var fetchFeaturedForParagraph = function fetchFeaturedForParagraph(paraId
/* e.g. "127.5" - id without a char prefix */
) {
  return (0,baseApi/* makeRequest */.$f)({
    url: "/search/featured/".concat(paraId),
    type: "get",
    memoryCache: true,
    parseResponse: function parseResponse(response) {
      if (response.data.sections) {
        return normalizeFeaturedSearchSections(response.data.sections);
      }

      return [];
    }
  });
};
;// CONCATENATED MODULE: ./src/next/store/saga/relevantSearch.saga.js
function relevantSearch_saga_typeof(obj) { "@babel/helpers - typeof"; return relevantSearch_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, relevantSearch_saga_typeof(obj); }

function relevantSearch_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ relevantSearch_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == relevantSearch_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var relevantSearch_saga_marked = /*#__PURE__*/relevantSearch_saga_regeneratorRuntime().mark(fetchRelevantSearchSchemeAsync),
    relevantSearch_saga_marked2 = /*#__PURE__*/relevantSearch_saga_regeneratorRuntime().mark(fetchRelevantSearchFacetAggregateAsync),
    relevantSearch_saga_marked3 = /*#__PURE__*/relevantSearch_saga_regeneratorRuntime().mark(relevantSearch);

function relevantSearch_saga_toConsumableArray(arr) { return relevantSearch_saga_arrayWithoutHoles(arr) || relevantSearch_saga_iterableToArray(arr) || relevantSearch_saga_unsupportedIterableToArray(arr) || relevantSearch_saga_nonIterableSpread(); }

function relevantSearch_saga_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function relevantSearch_saga_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return relevantSearch_saga_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return relevantSearch_saga_arrayLikeToArray(o, minLen); }

function relevantSearch_saga_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function relevantSearch_saga_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return relevantSearch_saga_arrayLikeToArray(arr); }

function relevantSearch_saga_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

/* eslint-disable no-console */




var relevantSearch_saga_TAG = "RelevantSearchSaga_";

function fetchRelevantSearchSchemeAsync() {
  var _yield$select2, scheme, data, languages, unicLanguages;

  return relevantSearch_saga_regeneratorRuntime().wrap(function fetchRelevantSearchSchemeAsync$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.prev = 0;
        _context.next = 3;
        return io_c3792963_select(function (state) {
          return state.relevantSearch;
        });

      case 3:
        _yield$select2 = _context.sent;
        scheme = _yield$select2.scheme;

        if (!(scheme.length === 0)) {
          _context.next = 14;
          break;
        }

        _context.next = 8;
        return io_c3792963_call(relevantSearchSchemeRequest);

      case 8:
        data = _context.sent;

        if (!data) {
          _context.next = 14;
          break;
        }

        languages = data.sections.map(function (v) {
          return v.language_code;
        });
        unicLanguages = relevantSearch_saga_toConsumableArray(new Set(languages));
        _context.next = 14;
        return put(actions/* relevantSearchActions.fetchRelevantSearchSchemeSuccess */.fg.fetchRelevantSearchSchemeSuccess(data.sections, unicLanguages));

      case 14:
        _context.next = 19;
        break;

      case 16:
        _context.prev = 16;
        _context.t0 = _context["catch"](0);
        console.log(relevantSearch_saga_TAG + "fetchRelevantSearchSchemeAsync", _context.t0);

      case 19:
      case "end":
        return _context.stop();
    }
  }, relevantSearch_saga_marked, null, [[0, 16]]);
}

function fetchRelevantSearchFacetAggregateAsync(action) {
  var _resultsSuggestions$s, results, resultsSuggestions;

  return relevantSearch_saga_regeneratorRuntime().wrap(function fetchRelevantSearchFacetAggregateAsync$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return io_c3792963_delay(1000);

      case 2:
        _context2.prev = 2;

        if (!action.data.lang) {
          _context2.next = 15;
          break;
        }

        _context2.next = 6;
        return io_c3792963_call(relevantSearchFacetAggregateRequest, action.data);

      case 6:
        results = _context2.sent;

        if (!results) {
          results = {};
        }

        _context2.next = 10;
        return io_c3792963_call(getSuggestionsPopupRequest, action.data.query, action.data.lang);

      case 10:
        resultsSuggestions = _context2.sent;

        if ((resultsSuggestions === null || resultsSuggestions === void 0 ? void 0 : (_resultsSuggestions$s = resultsSuggestions.suggestions) === null || _resultsSuggestions$s === void 0 ? void 0 : _resultsSuggestions$s.length) > 0) {
          results["egw_search:009"] = {
            facets: {
              suggestions: resultsSuggestions.suggestions
            }
          };
        } else {
          results["egw_search:009"] = {
            facets: {
              suggestions: []
            }
          };
        }

        if (!results) {
          _context2.next = 15;
          break;
        }

        _context2.next = 15;
        return put(actions/* relevantSearchActions.fetchRelevantSearchFacetAggregateSuccess */.fg.fetchRelevantSearchFacetAggregateSuccess(results, action.data.lang));

      case 15:
        _context2.next = 20;
        break;

      case 17:
        _context2.prev = 17;
        _context2.t0 = _context2["catch"](2);
        console.log(relevantSearch_saga_TAG + "fetchRelevantSearchFacetAggregateAsync", _context2.t0);

      case 20:
      case "end":
        return _context2.stop();
    }
  }, relevantSearch_saga_marked2, null, [[2, 17]]);
}

function relevantSearch() {
  return relevantSearch_saga_regeneratorRuntime().wrap(function relevantSearch$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return takeLeading$1(actions/* relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_SCHEME */.UT.FETCH_RELEVANT_SEARCH_SCHEME, fetchRelevantSearchSchemeAsync);

      case 2:
        _context3.next = 4;
        return takeEvery$1(actions/* relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_FACET_AGGREGATE */.UT.FETCH_RELEVANT_SEARCH_FACET_AGGREGATE, fetchRelevantSearchFacetAggregateAsync);

      case 4:
      case "end":
        return _context3.stop();
    }
  }, relevantSearch_saga_marked3);
}
// EXTERNAL MODULE: ../shared/api/avatar/requests.js + 1 modules
var avatar_requests = __webpack_require__(89616);
// EXTERNAL MODULE: ../shared/store/system/selectors.js
var system_selectors = __webpack_require__(91809);
;// CONCATENATED MODULE: ../shared/store/system/saga.js
function system_saga_typeof(obj) { "@babel/helpers - typeof"; return system_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, system_saga_typeof(obj); }

function system_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ system_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == system_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var saga_marked = /*#__PURE__*/system_saga_regeneratorRuntime().mark(_renewUserAvatarLastUpdateTimestamp),
    saga_marked2 = /*#__PURE__*/system_saga_regeneratorRuntime().mark(_sharedWorkerUploadAvatar),
    saga_marked3 = /*#__PURE__*/system_saga_regeneratorRuntime().mark(_sharedWorkerDeleteAvatar);







var saga_scope = "Shared System";

function _renewUserAvatarLastUpdateTimestamp() {
  return system_saga_regeneratorRuntime().wrap(function _renewUserAvatarLastUpdateTimestamp$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return put(system_actions/* _sharedActionsSystem.setAvatarLastUpdateTimestamp */.g.setAvatarLastUpdateTimestamp(Date.now()));

      case 2:
      case "end":
        return _context.stop();
    }
  }, saga_marked);
}

function _sharedWorkerUploadAvatar(action) {
  var isLogin, avatarFile;
  return system_saga_regeneratorRuntime().wrap(function _sharedWorkerUploadAvatar$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.prev = 0;
        _context2.next = 3;
        return io_c3792963_select(system_selectors/* selectorSystemIsLogin */.wN);

      case 3:
        isLogin = _context2.sent;

        if (!isLogin) {
          _context2.next = 10;
          break;
        }

        avatarFile = action.data;
        _context2.next = 8;
        return io_c3792963_call(avatar_requests/* uploadUserAvatar */.x9, avatarFile);

      case 8:
        _context2.next = 10;
        return io_c3792963_call(_renewUserAvatarLastUpdateTimestamp);

      case 10:
        _context2.next = 15;
        break;

      case 12:
        _context2.prev = 12;
        _context2.t0 = _context2["catch"](0);
        (0,utils_console/* consoleLogError */.aw)(saga_scope, "Error: ", _context2.t0);

      case 15:
      case "end":
        return _context2.stop();
    }
  }, saga_marked2, null, [[0, 12]]);
}
function _sharedWorkerDeleteAvatar() {
  var isLogin;
  return system_saga_regeneratorRuntime().wrap(function _sharedWorkerDeleteAvatar$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.prev = 0;
        _context3.next = 3;
        return io_c3792963_select(system_selectors/* selectorSystemIsLogin */.wN);

      case 3:
        isLogin = _context3.sent;

        if (!isLogin) {
          _context3.next = 9;
          break;
        }

        _context3.next = 7;
        return io_c3792963_call(avatar_requests/* deleteUserAvatar */.VB);

      case 7:
        _context3.next = 9;
        return io_c3792963_call(_renewUserAvatarLastUpdateTimestamp);

      case 9:
        _context3.next = 14;
        break;

      case 11:
        _context3.prev = 11;
        _context3.t0 = _context3["catch"](0);
        (0,utils_console/* consoleLogError */.aw)(saga_scope, "Error: ", _context3.t0);

      case 14:
      case "end":
        return _context3.stop();
    }
  }, saga_marked3, null, [[0, 11]]);
}
// EXTERNAL MODULE: ../shared/constants.js
var shared_constants = __webpack_require__(75573);
// EXTERNAL MODULE: ../shared/utils/copy.js
var copy = __webpack_require__(73981);
;// CONCATENATED MODULE: ./src/next/store/saga/system.saga.js
function saga_system_saga_typeof(obj) { "@babel/helpers - typeof"; return saga_system_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, saga_system_saga_typeof(obj); }

function saga_system_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ saga_system_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == saga_system_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var system_saga_marked = /*#__PURE__*/saga_system_saga_regeneratorRuntime().mark(system_saga_copy),
    system_saga_marked2 = /*#__PURE__*/saga_system_saga_regeneratorRuntime().mark(systemSaga);







function system_saga_copy(action) {
  var _action$data, text, options, result;

  return saga_system_saga_regeneratorRuntime().wrap(function copy$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _action$data = action.data, text = _action$data.text, options = _action$data.options;
        _context.next = 3;
        return io_c3792963_call(copy/* copyText */.zp, text);

      case 3:
        result = _context.sent;

        if (!(options !== null && options !== void 0 && options.noToast)) {
          _context.next = 6;
          break;
        }

        return _context.abrupt("return");

      case 6:
        if (!result) {
          _context.next = 11;
          break;
        }

        _context.next = 9;
        return put(actions/* systemActions.toast */.nm.toast((options === null || options === void 0 ? void 0 : options.successMessage) || "@textCopied", shared_constants/* TOAST_TYPE.success */["do"].success));

      case 9:
        _context.next = 13;
        break;

      case 11:
        _context.next = 13;
        return put(actions/* systemActions.toast */.nm.toast((options === null || options === void 0 ? void 0 : options.errorMessage) || "@textNotCopied", shared_constants/* TOAST_TYPE.error */["do"].error));

      case 13:
      case "end":
        return _context.stop();
    }
  }, system_saga_marked);
}

function systemSaga() {
  return saga_system_saga_regeneratorRuntime().wrap(function systemSaga$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return io_c3792963_all([takeEvery$1(actions/* systemActionsConstants.ACTION_COPY */.My.ACTION_COPY, system_saga_copy), takeLatest$1(actions/* systemActionsConstants.UPLOAD_USER_AVATAR */.My.UPLOAD_USER_AVATAR, _sharedWorkerUploadAvatar), takeLatest$1(actions/* systemActionsConstants.DELETE_USER_AVATAR */.My.DELETE_USER_AVATAR, _sharedWorkerDeleteAvatar)]);

      case 2:
      case "end":
        return _context2.stop();
    }
  }, system_saga_marked2);
}
// EXTERNAL MODULE: ../shared/store/mainTree/actions.js
var mainTree_actions = __webpack_require__(53882);
// EXTERNAL MODULE: ../shared/api/not-sorted.js + 1 modules
var not_sorted = __webpack_require__(58890);
;// CONCATENATED MODULE: ../shared/utils/saga.js
function utils_saga_typeof(obj) { "@babel/helpers - typeof"; return utils_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, utils_saga_typeof(obj); }

function utils_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ utils_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == utils_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var utils_saga_marked = /*#__PURE__*/utils_saga_regeneratorRuntime().mark(withTakePreviousCallIfSameParams);



var ACTION_TYPE_COMPLETE_COMMON_PROCESS = "common-process/";

var getActionTypeCommonProcess = function getActionTypeCommonProcess(process) {
  return ACTION_TYPE_COMPLETE_COMMON_PROCESS + process;
};

var actionCompleteCommonProcess = function actionCompleteCommonProcess(process, data) {
  return {
    type: getActionTypeCommonProcess(process),
    data: data
  };
}; // Use this function to enhance a generator function to return its existing call if the same args.


var activeProcesses = new Set();
function withTakePreviousCallIfSameParams(fnGenerator) {
  var _len,
      args,
      _key,
      process,
      action,
      result,
      _args = arguments;

  return utils_saga_regeneratorRuntime().wrap(function withTakePreviousCallIfSameParams$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        for (_len = _args.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = _args[_key];
        }

        process = fnGenerator.name + args.join("");

        if (!activeProcesses.has(process)) {
          _context.next = 7;
          break;
        }

        _context.next = 5;
        return io_c3792963_take(getActionTypeCommonProcess(process));

      case 5:
        action = _context.sent;
        return _context.abrupt("return", action.data);

      case 7:
        activeProcesses.add(process);
        _context.prev = 8;
        _context.next = 11;
        return fnGenerator.apply(void 0, args);

      case 11:
        result = _context.sent;
        _context.next = 17;
        break;

      case 14:
        _context.prev = 14;
        _context.t0 = _context["catch"](8);
        (0,utils_console/* consoleLogError */.aw)("[withTakePreviousCallIfSameParams]", "Error", _context.t0);

      case 17:
        _context.next = 19;
        return put(actionCompleteCommonProcess(process, result));

      case 19:
        activeProcesses.delete(process);
        return _context.abrupt("return", result);

      case 21:
      case "end":
        return _context.stop();
    }
  }, utils_saga_marked, null, [[8, 14]]);
}
// EXTERNAL MODULE: ../shared/store/player/actions.js
var player_actions = __webpack_require__(16360);
// EXTERNAL MODULE: ../shared/store/toc/selectors.js
var toc_selectors = __webpack_require__(8962);
// EXTERNAL MODULE: ../shared/store/paragraphs/selectors.js
var paragraphs_selectors = __webpack_require__(83934);
// EXTERNAL MODULE: ../shared/store/player/selectors.js
var player_selectors = __webpack_require__(46996);
// EXTERNAL MODULE: ../shared/api/content/common.js + 1 modules
var common = __webpack_require__(11034);
// EXTERNAL MODULE: ../shared/api/content/constants.js
var api_content_constants = __webpack_require__(84520);
// EXTERNAL MODULE: ../shared/store/saga-functions.utils.js
var saga_functions_utils = __webpack_require__(22343);
// EXTERNAL MODULE: ../shared/api/content/books/requests.js
var books_requests = __webpack_require__(92834);
// EXTERNAL MODULE: ../shared/store/mainTree/utils.js
var mainTree_utils = __webpack_require__(79622);
;// CONCATENATED MODULE: ../shared/store/saga-functions.js
function saga_functions_typeof(obj) { "@babel/helpers - typeof"; return saga_functions_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, saga_functions_typeof(obj); }

function saga_functions_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function saga_functions_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? saga_functions_ownKeys(Object(source), !0).forEach(function (key) { saga_functions_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : saga_functions_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function saga_functions_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function saga_functions_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ saga_functions_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == saga_functions_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var saga_functions_marked = /*#__PURE__*/saga_functions_regeneratorRuntime().mark(_fetchAndStoreWaveformsDictionary),
    saga_functions_marked2 = /*#__PURE__*/saga_functions_regeneratorRuntime().mark(_getBookToc),
    saga_functions_marked3 = /*#__PURE__*/saga_functions_regeneratorRuntime().mark(getDefaultLanguage);






















function _fetchAndStoreWaveformsDictionary(url, chapterId) {
  var loader, waveformsDictionary, nBookId, response, _ref2, waveform, paragraphsAudioPositions;

  return saga_functions_regeneratorRuntime().wrap(function _fetchAndStoreWaveformsDictionary$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        if (!(url && chapterId)) {
          _context.next = 28;
          break;
        }

        loader = (0,saga_functions_utils/* getBookWaveformLoaderId */.J)(chapterId);
        _context.prev = 2;
        _context.next = 5;
        return io_c3792963_select(player_selectors/* selectorPlayerWaveformsDictionary */.cc);

      case 5:
        waveformsDictionary = _context.sent;

        if (!waveformsDictionary[chapterId]) {
          _context.next = 8;
          break;
        }

        return _context.abrupt("return", waveformsDictionary[chapterId]);

      case 8:
        _context.next = 10;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(loader));

      case 10:
        nBookId = (0,content_content/* getBookIdNumber */.o8)(chapterId);
        _context.next = 13;
        return io_c3792963_call(not_sorted/* getWaveformRequest */.O1, url, nBookId);

      case 13:
        response = _context.sent;
        _ref2 = response || {}, waveform = _ref2.waveform, paragraphsAudioPositions = _ref2.paragraphsAudioPositions;
        _context.next = 17;
        return put(player_actions/* _sharedActionsPlayer.putAudioWaveformsData */.m.putAudioWaveformsData({
          waveform: waveform,
          paragraphsAudioPositions: paragraphsAudioPositions,
          chapterId: chapterId
        }));

      case 17:
        return _context.abrupt("return", {
          waveform: waveform,
          paragraphsAudioPositions: paragraphsAudioPositions
        });

      case 20:
        _context.prev = 20;
        _context.t0 = _context["catch"](2);
        // eslint-disable-next-line no-console
        (0,utils_console/* consoleLogError */.aw)("Shared Saga", "Error load waveform " + chapterId + " url: " + url, _context.t0);
        return _context.abrupt("return", undefined);

      case 24:
        _context.prev = 24;
        _context.next = 27;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(loader, true));

      case 27:
        return _context.finish(24);

      case 28:
        return _context.abrupt("return", undefined);

      case 29:
      case "end":
        return _context.stop();
    }
  }, saga_functions_marked, null, [[2, 20, 24, 28]]);
}

var fetchAndStoreWaveformsDictionary = function fetchAndStoreWaveformsDictionary(url, chapterId) {
  return withTakePreviousCallIfSameParams(_fetchAndStoreWaveformsDictionary, url, chapterId);
};
function _getBookById(_bookId) {
  var attachChildrenToBook = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return /*#__PURE__*/saga_functions_regeneratorRuntime().mark(function _callee() {
    var bookIdOrigin, _book$chapters, idsBooksFetchFailed, bookId, mainTree, books, book, treeBook, loaderId, _loaderId, chapterData;

    return saga_functions_regeneratorRuntime().wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (_bookId) {
            _context2.next = 2;
            break;
          }

          return _context2.abrupt("return", undefined);

        case 2:
          bookIdOrigin = (0,content_content/* getBookIdNumber */.o8)(_bookId);
          _context2.prev = 3;
          _context2.next = 6;
          return io_c3792963_select(mainTree_selectors/* selectorMainTreeIdsBooksFetchFailed */.Zn);

        case 6:
          idsBooksFetchFailed = _context2.sent;

          if (!idsBooksFetchFailed.includes(bookIdOrigin)) {
            _context2.next = 9;
            break;
          }

          return _context2.abrupt("return", null);

        case 9:
          bookId = (0,content_content/* getBookIdWithPrefix */.NR)(_bookId);
          _context2.next = 12;
          return io_c3792963_select(mainTree_selectors/* selectorMainTree */.h6);

        case 12:
          mainTree = _context2.sent;
          _context2.next = 15;
          return io_c3792963_select(mainTree_selectors/* selectorMainTreeBooks */.yS);

        case 15:
          books = _context2.sent;
          book = books.find(function (b) {
            return b.book_id === bookIdOrigin;
          });

          if (!book) {
            treeBook = (0,content_content/* findNode */.DY)(bookId, mainTree);

            if (treeBook) {
              book = saga_functions_objectSpread({}, treeBook);
            }
          }

          if (book) {
            _context2.next = 27;
            break;
          }

          loaderId = (0,mainTree_utils/* makeLoaderIdBook */.X)(bookId);
          _context2.next = 22;
          return put(system_actions/* _sharedActionsSystem.loading */.g.loading(loaderId));

        case 22:
          _context2.next = 24;
          return io_c3792963_call(books_requests/* getBookByIdRequest */.LM, bookId);

        case 24:
          book = _context2.sent;
          _context2.next = 27;
          return put(system_actions/* _sharedActionsSystem.loading */.g.loading(loaderId, true));

        case 27:
          if (!(book && attachChildrenToBook && !((_book$chapters = book.chapters) !== null && _book$chapters !== void 0 && _book$chapters.length))) {
            _context2.next = 37;
            break;
          }

          _loaderId = (0,mainTree_utils/* makeLoaderIdBookTOC */.s)(bookId);
          _context2.next = 31;
          return put(system_actions/* _sharedActionsSystem.loading */.g.loading(_loaderId));

        case 31:
          _context2.next = 33;
          return io_c3792963_call(books_requests/* getBookTocById */.tu, bookIdOrigin);

        case 33:
          chapterData = _context2.sent;

          if (chapterData) {
            book.children = chapterData.children;
            book.chapters = chapterData.chapters;
          } // may be need to save a book firstly, then remove the loader?


          _context2.next = 37;
          return put(system_actions/* _sharedActionsSystem.loading */.g.loading(_loaderId, true));

        case 37:
          if (book) {
            _context2.next = 40;
            break;
          }

          _context2.next = 40;
          return put(mainTree_actions/* _sharedActionsMainTree.addIdBrokenBook */.H.addIdBrokenBook(bookIdOrigin));

        case 40:
          return _context2.abrupt("return", book);

        case 43:
          _context2.prev = 43;
          _context2.t0 = _context2["catch"](3);
          _context2.next = 47;
          return put(mainTree_actions/* _sharedActionsMainTree.addIdBrokenBook */.H.addIdBrokenBook(bookIdOrigin));

        case 47:
          return _context2.abrupt("return", undefined);

        case 48:
        case "end":
          return _context2.stop();
      }
    }, _callee, null, [[3, 43]]);
  })();
} // {attachChildrenToBook} - is for REACT app old logic of a book having chapters and children,
// but it's changed - book chapters is a TOC and is stored in a store reducer {state.toc}.

var getBookById = function getBookById(bookIdOrigin, attachChildrenToBook) {
  return withTakePreviousCallIfSameParams(_getBookById, bookIdOrigin, attachChildrenToBook);
};
function _getBookToc(_bookId) {
  var bookIdOrigin, tocItems, toc, loaderId, data;
  return saga_functions_regeneratorRuntime().wrap(function _getBookToc$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        bookIdOrigin = (0,content_content/* getBookIdNumber */.o8)(_bookId);

        if (bookIdOrigin) {
          _context3.next = 3;
          break;
        }

        return _context3.abrupt("return", undefined);

      case 3:
        _context3.prev = 3;
        _context3.next = 6;
        return io_c3792963_select(toc_selectors/* selectorTocItems */.L);

      case 6:
        tocItems = _context3.sent;
        toc = tocItems[bookIdOrigin];

        if (toc) {
          _context3.next = 18;
          break;
        }

        loaderId = (0,mainTree_utils/* makeLoaderIdBookTOC */.s)(bookIdOrigin);
        _context3.next = 12;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(loaderId));

      case 12:
        _context3.next = 14;
        return io_c3792963_call(books_requests/* getBookTocById */.tu, bookIdOrigin);

      case 14:
        data = _context3.sent;
        toc = data.chapters;
        _context3.next = 18;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(loaderId, true));

      case 18:
        return _context3.abrupt("return", toc);

      case 21:
        _context3.prev = 21;
        _context3.t0 = _context3["catch"](3);
        return _context3.abrupt("return", undefined);

      case 24:
      case "end":
        return _context3.stop();
    }
  }, saga_functions_marked2, null, [[3, 21]]);
}
var getBookToc = function getBookToc(bookIdOrigin) {
  return withTakePreviousCallIfSameParams(_getBookToc, bookIdOrigin);
};
function _getChapterParas(chapterId, highlight) {
  var isFetchAllPara = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return /*#__PURE__*/saga_functions_regeneratorRuntime().mark(function _callee2() {
    var chaptersParas, bookIdOrigin, chapterNumber, bookChaptersParas, content, response;
    return saga_functions_regeneratorRuntime().wrap(function _callee2$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (chapterId) {
            _context4.next = 2;
            break;
          }

          return _context4.abrupt("return", undefined);

        case 2:
          _context4.prev = 2;
          _context4.next = 5;
          return io_c3792963_select(paragraphs_selectors/* selectorChaptersParas */.$m);

        case 5:
          chaptersParas = _context4.sent;
          bookIdOrigin = (0,content_content/* getBookIdNumber */.o8)(chapterId);
          chapterNumber = chapterId.split(".")[1];
          bookChaptersParas = chaptersParas[bookIdOrigin];
          content = bookChaptersParas === null || bookChaptersParas === void 0 ? void 0 : bookChaptersParas[chapterNumber];

          if (!(!content || content.highlight !== highlight)) {
            _context4.next = 22;
            break;
          }

          response = null;

          if (!isFetchAllPara) {
            _context4.next = 18;
            break;
          }

          _context4.next = 15;
          return io_c3792963_call(common/* getParagraphsRequest */.Wf, chapterId, 100, api_content_constants/* LoadDirection.both */.b.both, highlight);

        case 15:
          response = _context4.sent;
          _context4.next = 21;
          break;

        case 18:
          _context4.next = 20;
          return io_c3792963_call(not_sorted/* getChapterContentRequest */.Ym, chapterId, undefined, undefined, highlight);

        case 20:
          response = _context4.sent;

        case 21:
          if (response) {
            content = {
              paras: response,
              highlight: highlight
            };
          }

        case 22:
          return _context4.abrupt("return", content);

        case 25:
          _context4.prev = 25;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", undefined);

        case 28:
        case "end":
          return _context4.stop();
      }
    }, _callee2, null, [[2, 25]]);
  })();
}
var getChapterParas = function getChapterParas(chapterId, highlight) {
  var isFetchAllPara = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return withTakePreviousCallIfSameParams(_getChapterParas, chapterId, highlight, isFetchAllPara);
};
function getDefaultLanguage() {
  var libraryLanguages;
  return saga_functions_regeneratorRuntime().wrap(function getDefaultLanguage$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.next = 2;
        return io_c3792963_select((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.libraryLanguages.id */.Fy.libraryLanguages.id));

      case 2:
        libraryLanguages = _context5.sent;
        return _context5.abrupt("return", (0,user_agent/* getLanguageDefault */.hW)(libraryLanguages));

      case 4:
      case "end":
        return _context5.stop();
    }
  }, saga_functions_marked3);
}
// EXTERNAL MODULE: ../shared/api/content/languages/utils.js
var languages_utils = __webpack_require__(20394);
;// CONCATENATED MODULE: ../shared/api/content/languages/requests.js


var getFoldersRequest = function getFoldersRequest(lang) {
  return (0,baseApi/* makeRequest */.$f)({
    url: "/content/languages/".concat(lang, "/folders"),
    storageCacheName: (0,languages_utils/* makeFolderCacheName */.K)(lang),
    parseResponse: function parseResponse(response) {
      return (0,languages_utils/* normalizeLanguageFolders */.u)(response.data, lang).outList;
    }
  });
};
;// CONCATENATED MODULE: ../shared/store/mainTree/saga.js
function mainTree_saga_typeof(obj) { "@babel/helpers - typeof"; return mainTree_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, mainTree_saga_typeof(obj); }

function mainTree_saga_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function mainTree_saga_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? mainTree_saga_ownKeys(Object(source), !0).forEach(function (key) { mainTree_saga_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : mainTree_saga_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function mainTree_saga_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = mainTree_saga_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function mainTree_saga_toConsumableArray(arr) { return mainTree_saga_arrayWithoutHoles(arr) || mainTree_saga_iterableToArray(arr) || mainTree_saga_unsupportedIterableToArray(arr) || mainTree_saga_nonIterableSpread(); }

function mainTree_saga_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function mainTree_saga_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return mainTree_saga_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mainTree_saga_arrayLikeToArray(o, minLen); }

function mainTree_saga_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function mainTree_saga_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return mainTree_saga_arrayLikeToArray(arr); }

function mainTree_saga_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function mainTree_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ mainTree_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == mainTree_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var mainTree_saga_marked = /*#__PURE__*/mainTree_saga_regeneratorRuntime().mark(_sharedWorkerFetchBook),
    mainTree_saga_marked2 = /*#__PURE__*/mainTree_saga_regeneratorRuntime().mark(_sharedWorkerFetchBooksByIds),
    mainTree_saga_marked3 = /*#__PURE__*/mainTree_saga_regeneratorRuntime().mark(_sharedWatcherFetchBooksByIds),
    _marked4 = /*#__PURE__*/mainTree_saga_regeneratorRuntime().mark(_sharedWorkerFetchSGBooks),
    _marked5 = /*#__PURE__*/mainTree_saga_regeneratorRuntime().mark(_sharedWorkerFetchBibles),
    _marked6 = /*#__PURE__*/mainTree_saga_regeneratorRuntime().mark(_sharedWorkerFetchDictionaries),
    _marked7 = /*#__PURE__*/mainTree_saga_regeneratorRuntime().mark(_sharedWorkerFetchLanguages),
    _marked8 = /*#__PURE__*/mainTree_saga_regeneratorRuntime().mark(_sharedWorkerFetchLanguageFolders),
    _marked9 = /*#__PURE__*/mainTree_saga_regeneratorRuntime().mark(_sharedWorkerFetchMainTreeAllData),
    _marked10 = /*#__PURE__*/mainTree_saga_regeneratorRuntime().mark(_sharedFetchFolderForBookWorker);
















var mainTree_saga_scope = "Shared Saga Main Tree";
function _sharedWorkerFetchBook(action) {
  var nBookId, loaderId, book, bookWithRealTypeProperty;
  return mainTree_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchBook$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        nBookId = action.data;
        loaderId = (0,mainTree_utils/* makeLoaderIdBook */.X)(nBookId);
        _context.prev = 2;
        _context.next = 5;
        return getBookById(nBookId);

      case 5:
        book = _context.sent;
        _context.next = 8;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(loaderId, false, true));

      case 8:
        if (!book) {
          _context.next = 15;
          break;
        }

        _context.next = 11;
        return io_c3792963_call(_sharedFetchFolderForBookWorker, {
          data: {
            book: book
          }
        });

      case 11:
        bookWithRealTypeProperty = _context.sent;
        _context.next = 14;
        return put(mainTree_actions/* _sharedActionsMainTree.addBooks */.H.addBooks(bookWithRealTypeProperty));

      case 14:
        return _context.abrupt("return", bookWithRealTypeProperty);

      case 15:
        return _context.abrupt("return", book);

      case 18:
        _context.prev = 18;
        _context.t0 = _context["catch"](2);
        (0,utils_console/* consoleLogError */.aw)(mainTree_saga_scope, "Error: ", _context.t0);
        return _context.abrupt("return", false);

      case 22:
        _context.prev = 22;
        _context.next = 25;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(loaderId, true));

      case 25:
        return _context.finish(22);

      case 26:
      case "end":
        return _context.stop();
    }
  }, mainTree_saga_marked, null, [[2, 18, 22, 26]]);
}
function _sharedWorkerFetchBooksByIds(booksIds) {
  var books, booksOut, booksToFetch, fetchedBooks;
  return mainTree_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchBooksByIds$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        if (booksIds) {
          _context2.next = 2;
          break;
        }

        return _context2.abrupt("return", null);

      case 2:
        _context2.next = 4;
        return io_c3792963_select(mainTree_selectors/* selectorMainTreeBooks */.yS);

      case 4:
        books = _context2.sent;
        booksOut = [];
        booksToFetch = [];
        booksIds.forEach(function (bookId) {
          var book = books.find(function (item) {
            return item.id === bookId;
          });

          if (book) {
            booksOut.push(book);
          } else {
            booksToFetch.push((0,content_content/* getBookIdNumber */.o8)(bookId));
          }
        });

        if (!(booksToFetch.length > 0)) {
          _context2.next = 21;
          break;
        }

        _context2.prev = 9;
        _context2.next = 12;
        return io_c3792963_call(books_requests/* getBooksRequest */.Uf, booksToFetch);

      case 12:
        fetchedBooks = _context2.sent;
        booksOut.push.apply(booksOut, mainTree_saga_toConsumableArray(fetchedBooks));
        _context2.next = 16;
        return put(mainTree_actions/* _sharedActionsMainTree.addBooks */.H.addBooks(booksOut));

      case 16:
        _context2.next = 21;
        break;

      case 18:
        _context2.prev = 18;
        _context2.t0 = _context2["catch"](9);
        (0,utils_console/* consoleLogError */.aw)(mainTree_saga_scope, "loadBooksDataWorker_error", _context2.t0);

      case 21:
        return _context2.abrupt("return", booksOut);

      case 22:
      case "end":
        return _context2.stop();
    }
  }, mainTree_saga_marked2, null, [[9, 18]]);
}
function _sharedWatcherFetchBooksByIds() {
  var requestChan, action, _action$data2, booksIds, loaderId;

  return mainTree_saga_regeneratorRuntime().wrap(function _sharedWatcherFetchBooksByIds$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return io_c3792963_actionChannel(mainTree_actions/* _sharedActionsConstantsMainTree.FETCH_BOOKS_BY_IDS */.t.FETCH_BOOKS_BY_IDS);

      case 2:
        requestChan = _context3.sent;

      case 3:
        if (false) {}

        _context3.next = 6;
        return io_c3792963_take(requestChan);

      case 6:
        action = _context3.sent;
        _action$data2 = action.data, booksIds = _action$data2.booksIds, loaderId = _action$data2.loaderId;

        if (!loaderId) {
          _context3.next = 11;
          break;
        }

        _context3.next = 11;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(loaderId));

      case 11:
        _context3.next = 13;
        return io_c3792963_call(_sharedWorkerFetchBooksByIds, booksIds);

      case 13:
        if (!loaderId) {
          _context3.next = 16;
          break;
        }

        _context3.next = 16;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(loaderId, true));

      case 16:
        _context3.next = 3;
        break;

      case 18:
      case "end":
        return _context3.stop();
    }
  }, mainTree_saga_marked3);
}
function _sharedWorkerFetchSGBooks() {
  var sgBooksMap, sgBooks;
  return mainTree_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchSGBooks$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        _context4.prev = 0;
        _context4.next = 3;
        return io_c3792963_select(mainTree_selectors/* selectorMainTreeSgBooksMap */.Kw);

      case 3:
        sgBooksMap = _context4.sent;

        if (!(Object.keys(sgBooksMap).length === 0)) {
          _context4.next = 11;
          break;
        }

        _context4.next = 7;
        return io_c3792963_call(books_requests/* getSGBooksRequest */.i6);

      case 7:
        sgBooks = _context4.sent;

        if (!(sgBooks !== null && sgBooks !== void 0 && sgBooks.length)) {
          _context4.next = 11;
          break;
        }

        _context4.next = 11;
        return put(mainTree_actions/* _sharedActionsMainTree.fetchSGBooksSuccess */.H.fetchSGBooksSuccess(sgBooks));

      case 11:
        _context4.next = 16;
        break;

      case 13:
        _context4.prev = 13;
        _context4.t0 = _context4["catch"](0);
        console.log("ERROR _sharedWorkerFetchSGBooks", _context4.t0);

      case 16:
      case "end":
        return _context4.stop();
    }
  }, _marked4, null, [[0, 13]]);
}
function _sharedWorkerFetchBibles() {
  var bibles, biblesNew;
  return mainTree_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchBibles$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.prev = 0;
        _context5.next = 3;
        return io_c3792963_select(mainTree_selectors/* selectorMainTreeBibleVersions */.Q5);

      case 3:
        bibles = _context5.sent;

        if (!(bibles.length === 0)) {
          _context5.next = 10;
          break;
        }

        _context5.next = 7;
        return io_c3792963_call(books_requests/* getBiblesAllLangsRequest */.HC);

      case 7:
        biblesNew = _context5.sent;
        _context5.next = 10;
        return put(mainTree_actions/* _sharedActionsMainTree.fetchBiblesSuccess */.H.fetchBiblesSuccess(biblesNew));

      case 10:
        _context5.next = 15;
        break;

      case 12:
        _context5.prev = 12;
        _context5.t0 = _context5["catch"](0);
        console.log("ERROR _sharedWorkerFetchBibles", _context5.t0);

      case 15:
      case "end":
        return _context5.stop();
    }
  }, _marked5, null, [[0, 12]]);
}
function _sharedWorkerFetchDictionaries() {
  var dictionaries, payload;
  return mainTree_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchDictionaries$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        _context6.prev = 0;
        _context6.next = 3;
        return io_c3792963_select(mainTree_selectors/* selectorMainTreeDictionaries */.CL);

      case 3:
        dictionaries = _context6.sent;

        if (!(dictionaries.length === 0)) {
          _context6.next = 10;
          break;
        }

        _context6.next = 7;
        return io_c3792963_call(common/* fetchDictionariesRequest */.di);

      case 7:
        payload = _context6.sent;
        _context6.next = 10;
        return put(mainTree_actions/* _sharedActionsMainTree.fetchDictionariesSuccess */.H.fetchDictionariesSuccess(payload));

      case 10:
        _context6.next = 15;
        break;

      case 12:
        _context6.prev = 12;
        _context6.t0 = _context6["catch"](0);
        console.log("ERROR _sharedWorkerFetchDictionaries", _context6.t0);

      case 15:
      case "end":
        return _context6.stop();
    }
  }, _marked6, null, [[0, 12]]);
}
function _sharedWorkerFetchLanguages() {
  var mainTree, defLang, payload;
  return mainTree_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchLanguages$(_context7) {
    while (1) switch (_context7.prev = _context7.next) {
      case 0:
        _context7.prev = 0;
        _context7.next = 3;
        return io_c3792963_select(mainTree_selectors/* selectorMainTree */.h6);

      case 3:
        mainTree = _context7.sent;

        if (!(mainTree.length === 0)) {
          _context7.next = 14;
          break;
        }

        _context7.next = 7;
        return io_c3792963_call(getDefaultLanguage);

      case 7:
        defLang = _context7.sent;
        _context7.next = 10;
        return io_c3792963_call(not_sorted/* getLanguagesRequest */.iJ, defLang);

      case 10:
        payload = _context7.sent;
        _context7.next = 13;
        return put(mainTree_actions/* _sharedActionsMainTree.fetchMainTreeSuccess */.H.fetchMainTreeSuccess(payload));

      case 13:
        return _context7.abrupt("return", payload);

      case 14:
        return _context7.abrupt("return", mainTree);

      case 17:
        _context7.prev = 17;
        _context7.t0 = _context7["catch"](0);
        console.log("ERROR _sharedWorkerFetchLanguageFolders", _context7.t0);

      case 20:
      case "end":
        return _context7.stop();
    }
  }, _marked7, null, [[0, 17]]);
}
function _sharedWorkerFetchLanguageFolders(action) {
  var lang, languages, langSuitable;
  return mainTree_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchLanguageFolders$(_context8) {
    while (1) switch (_context8.prev = _context8.next) {
      case 0:
        _context8.prev = 0;
        lang = action.data;

        if (lang) {
          _context8.next = 6;
          break;
        }

        _context8.next = 5;
        return io_c3792963_call(getDefaultLanguage);

      case 5:
        lang = _context8.sent;

      case 6:
        _context8.next = 8;
        return io_c3792963_call(_sharedWorkerFetchLanguages);

      case 8:
        languages = _context8.sent;
        langSuitable = (0,content_content/* findNode */.DY)(lang, languages);

        if (!(langSuitable && (!langSuitable.children || !langSuitable.children.length))) {
          _context8.next = 16;
          break;
        }

        _context8.next = 13;
        return io_c3792963_call(getFoldersRequest, lang);

      case 13:
        langSuitable.children = _context8.sent;
        _context8.next = 16;
        return put(mainTree_actions/* _sharedActionsMainTree.fetchMainTreeSuccess */.H.fetchMainTreeSuccess(mainTree_saga_toConsumableArray(languages)));

      case 16:
        return _context8.abrupt("return", {
          languageWithFoldersAttached: langSuitable
        });

      case 19:
        _context8.prev = 19;
        _context8.t0 = _context8["catch"](0);
        console.log("ERROR _sharedWorkerFetchLanguageFolders", _context8.t0);

      case 22:
      case "end":
        return _context8.stop();
    }
  }, _marked8, null, [[0, 19]]);
}
function _sharedWorkerFetchMainTreeAllData(lang) {
  var _yield$call2, languageWithFoldersAttached;

  return mainTree_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchMainTreeAllData$(_context9) {
    while (1) switch (_context9.prev = _context9.next) {
      case 0:
        _context9.prev = 0;
        _context9.next = 3;
        return io_c3792963_call(_sharedWorkerFetchBibles);

      case 3:
        _context9.next = 5;
        return io_c3792963_call(_sharedWorkerFetchDictionaries);

      case 5:
        _context9.next = 7;
        return io_c3792963_call(_sharedWorkerFetchSGBooks);

      case 7:
        _context9.next = 9;
        return io_c3792963_call(_sharedWorkerFetchLanguageFolders, {
          data: lang
        });

      case 9:
        _yield$call2 = _context9.sent;
        languageWithFoldersAttached = _yield$call2.languageWithFoldersAttached;
        return _context9.abrupt("return", {
          languageWithFoldersAttached: languageWithFoldersAttached
        });

      case 14:
        _context9.prev = 14;
        _context9.t0 = _context9["catch"](0);
        console.log("ERROR _sharedWorkerFetchMainTreeAllData", _context9.t0);

      case 17:
      case "end":
        return _context9.stop();
    }
  }, _marked9, null, [[0, 14]]);
}
function _sharedFetchFolderForBookWorker(action) {
  var book, mainTree, bookLangMap, langs, folder, bookFinal, libraryLanguages, defLang, folders, books, parentHolder, bookFind, _iterator, _step, _book, bookIndex;

  return mainTree_saga_regeneratorRuntime().wrap(function _sharedFetchFolderForBookWorker$(_context10) {
    while (1) switch (_context10.prev = _context10.next) {
      case 0:
        book = action.data.book;
        _context10.next = 3;
        return io_c3792963_select(mainTree_selectors/* selectorMainTree */.h6);

      case 3:
        mainTree = _context10.sent;
        _context10.next = 6;
        return io_c3792963_select(mainTree_selectors/* selectorMainTreeBookLangMap */.Km);

      case 6:
        bookLangMap = _context10.sent;
        langs = mainTree_saga_toConsumableArray(mainTree);
        folder = (0,content_content/* findNode */.DY)(book.folder_id, mainTree);
        bookFinal = book;

        if (folder) {
          _context10.next = 25;
          break;
        }

        if (!(mainTree.length === 0)) {
          _context10.next = 21;
          break;
        }

        _context10.next = 14;
        return io_c3792963_select((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.libraryLanguages.id */.Fy.libraryLanguages.id));

      case 14:
        libraryLanguages = _context10.sent;
        defLang = (0,user_agent/* getLanguageDefault */.hW)(libraryLanguages);
        _context10.next = 18;
        return io_c3792963_call(not_sorted/* getLanguagesRequest */.iJ, defLang);

      case 18:
        langs = _context10.sent;
        _context10.next = 21;
        return put(mainTree_actions/* _sharedActionsMainTree.fetchFoldersToRootSuccess */.H.fetchFoldersToRootSuccess(langs));

      case 21:
        _context10.next = 23;
        return io_c3792963_call(getFoldersRequest, book.lang);

      case 23:
        folders = _context10.sent;

        if (folders) {
          langs.find(function (item) {
            return item.id === book.lang;
          }).children = folders;
          folder = (0,content_content/* findNode */.DY)(book.folder_id, langs);
        }

      case 25:
        if (!folder) {
          _context10.next = 39;
          break;
        }

        parentHolder = [];
        bookFind = (0,content_content/* findNode */.DY)(book.id, folder, "id", parentHolder);

        if (bookFind) {
          _context10.next = 33;
          break;
        }

        _context10.next = 31;
        return io_c3792963_call(books_requests/* getFolderBooksRequest */.gI, book.folder_id);

      case 31:
        books = _context10.sent;

        if (books) {
          folder.children = books;
          _iterator = _createForOfIteratorHelper(books);

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              _book = _step.value;
              bookLangMap[_book.id] = _book.lang;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          bookFind = (0,content_content/* findNode */.DY)(book.id, folder, "id", parentHolder);
        }

      case 33:
        bookFind.realType = folder.className;
        bookFind.children = book.children;
        bookFind.chapters = book.chapters;
        /* ---- Spread the new book item to invoke Redux updates. ---- */

        bookIndex = folder.children.findIndex(function (item) {
          return item === bookFind;
        });

        if (bookIndex !== -1) {
          folder.children[bookIndex] = mainTree_saga_objectSpread({}, bookFind);
        }

        bookFinal = bookFind;

      case 39:
        _context10.next = 41;
        return put(mainTree_actions/* _sharedActionsMainTree.fetchFoldersToRootSuccess */.H.fetchFoldersToRootSuccess(langs, {
          bookLangMap: bookLangMap,
          books: books
        }));

      case 41:
        return _context10.abrupt("return", bookFinal);

      case 42:
      case "end":
        return _context10.stop();
    }
  }, _marked10);
}
;// CONCATENATED MODULE: ./src/next/store/saga/mainTree.saga.js
function saga_mainTree_saga_typeof(obj) { "@babel/helpers - typeof"; return saga_mainTree_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, saga_mainTree_saga_typeof(obj); }

function saga_mainTree_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ saga_mainTree_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == saga_mainTree_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var saga_mainTree_saga_marked = /*#__PURE__*/saga_mainTree_saga_regeneratorRuntime().mark(mainTree_saga_systemSaga);




function mainTree_saga_systemSaga() {
  return saga_mainTree_saga_regeneratorRuntime().wrap(function systemSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return io_c3792963_all([takeEvery$1(actions/* mainTreeActionConstants.FETCH_MAIN_TREE_ALL_DATA */.nf.FETCH_MAIN_TREE_ALL_DATA, _sharedWorkerFetchMainTreeAllData), takeEvery$1(actions/* mainTreeActionConstants.FETCH_LANGUAGE_FOLDERS */.nf.FETCH_LANGUAGE_FOLDERS, _sharedWorkerFetchLanguageFolders), takeEvery$1(actions/* mainTreeActionConstants.FETCH_BOOK */.nf.FETCH_BOOK, _sharedWorkerFetchBook)]);

      case 2:
      case "end":
        return _context.stop();
    }
  }, saga_mainTree_saga_marked);
}
// EXTERNAL MODULE: ../shared/store/settings/actions.js
var settings_actions = __webpack_require__(58538);
// EXTERNAL MODULE: ../shared/utils/settings/settings.js
var settings = __webpack_require__(19819);
;// CONCATENATED MODULE: ../shared/store/settings/saga.js
function settings_saga_typeof(obj) { "@babel/helpers - typeof"; return settings_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, settings_saga_typeof(obj); }

function settings_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ settings_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == settings_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var settings_saga_marked = /*#__PURE__*/settings_saga_regeneratorRuntime().mark(_sharedWorkerUpdateSettingsMethod),
    settings_saga_marked2 = /*#__PURE__*/settings_saga_regeneratorRuntime().mark(_sharedWorkerFetchGeoIpData);

function settings_saga_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function settings_saga_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? settings_saga_ownKeys(Object(source), !0).forEach(function (key) { settings_saga_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : settings_saga_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function settings_saga_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var settings_saga_scope = "Saga Settings";
function _sharedWorkerUpdateSettingsMethod(action) {
  var data, _action$saveOnServer2, saveOnServer, isLogin, settingsList, serverSettingsList, key, value, setting;

  return settings_saga_regeneratorRuntime().wrap(function _sharedWorkerUpdateSettingsMethod$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.prev = 0;
        data = action.data, _action$saveOnServer2 = action.saveOnServer, saveOnServer = _action$saveOnServer2 === void 0 ? true : _action$saveOnServer2;
        _context.next = 4;
        return io_c3792963_select(system_selectors/* selectorSystemIsLogin */.wN);

      case 4:
        isLogin = _context.sent;
        settingsList = {};
        serverSettingsList = {};

        for (key in data) {
          value = data[key];
          setting = (0,settings/* storeSetting */.Jp)(key, value);

          if (setting) {
            if (!settingsList[key]) {
              settingsList[key] = value;
            }

            if (isLogin && setting.server) {
              serverSettingsList[key] = value;
            }
          }
        }

        if (!(saveOnServer && isLogin && Object.keys(serverSettingsList).length)) {
          _context.next = 11;
          break;
        }

        _context.next = 11;
        return io_c3792963_call(not_sorted/* saveSettingsRequest */.UR, serverSettingsList);

      case 11:
        _context.next = 13;
        return put(settings_actions/* _sharedActionsSettings.updateSettingSuccess */.a.updateSettingSuccess(settings_saga_objectSpread({}, settingsList)));

      case 13:
        _context.next = 18;
        break;

      case 15:
        _context.prev = 15;
        _context.t0 = _context["catch"](0);
        (0,utils_console/* consoleLogError */.aw)(settings_saga_scope, "Error store settings: ", _context.t0);

      case 18:
      case "end":
        return _context.stop();
    }
  }, settings_saga_marked, null, [[0, 15]]);
}
function _sharedWorkerFetchGeoIpData() {
  var _yield$select2, geoIpData, data;

  return settings_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchGeoIpData$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.prev = 0;
        _context2.next = 3;
        return io_c3792963_select(function (state) {
          return state.settings;
        });

      case 3:
        _yield$select2 = _context2.sent;
        geoIpData = _yield$select2.geoIpData;

        if (!(Object.keys(geoIpData).length === 0)) {
          _context2.next = 12;
          break;
        }

        _context2.next = 8;
        return io_c3792963_call(not_sorted/* getGeoIpData */.Gn);

      case 8:
        data = _context2.sent;

        if (!data) {
          _context2.next = 12;
          break;
        }

        _context2.next = 12;
        return put(settings_actions/* _sharedActionsSettings.fetchGeoIpDataSuccess */.a.fetchGeoIpDataSuccess(data));

      case 12:
        _context2.next = 17;
        break;

      case 14:
        _context2.prev = 14;
        _context2.t0 = _context2["catch"](0);
        (0,utils_console/* consoleLogError */.aw)(settings_saga_scope, "Error getting GEO data: ", _context2.t0);

      case 17:
      case "end":
        return _context2.stop();
    }
  }, settings_saga_marked2, null, [[0, 14]]);
}
;// CONCATENATED MODULE: ./src/next/store/saga/settings.saga.js
function saga_settings_saga_typeof(obj) { "@babel/helpers - typeof"; return saga_settings_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, saga_settings_saga_typeof(obj); }

function saga_settings_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ saga_settings_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == saga_settings_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var saga_settings_saga_marked = /*#__PURE__*/saga_settings_saga_regeneratorRuntime().mark(settingsSaga);




function settingsSaga() {
  return saga_settings_saga_regeneratorRuntime().wrap(function settingsSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return io_c3792963_all([takeEvery$1(actions/* settingsActionsConstants.UPDATE_SETTINGS */.Se.UPDATE_SETTINGS, _sharedWorkerUpdateSettingsMethod), takeLatest$1(actions/* settingsActionsConstants.FETCH_GEO_IP_DATA */.Se.FETCH_GEO_IP_DATA, _sharedWorkerFetchGeoIpData)]);

      case 2:
      case "end":
        return _context.stop();
    }
  }, saga_settings_saga_marked);
}
// EXTERNAL MODULE: ../shared/store/shop/actions.js
var shop_actions = __webpack_require__(37623);
;// CONCATENATED MODULE: ./src/next/store/actions/shop.actions.js

// EXTERNAL MODULE: ../shared/store/shop/constants.js
var shop_constants = __webpack_require__(34144);
// EXTERNAL MODULE: ../shared/api/shopApi.js
var shopApi = __webpack_require__(48367);
// EXTERNAL MODULE: ../shared/store/shop/selectors.js
var shop_selectors = __webpack_require__(47108);
;// CONCATENATED MODULE: ../shared/store/shop/saga.js
function shop_saga_typeof(obj) { "@babel/helpers - typeof"; return shop_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, shop_saga_typeof(obj); }

function shop_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ shop_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == shop_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var shop_saga_marked = /*#__PURE__*/shop_saga_regeneratorRuntime().mark(_sharedWorkerFetchShopBooks);

function shop_saga_toConsumableArray(arr) { return shop_saga_arrayWithoutHoles(arr) || shop_saga_iterableToArray(arr) || shop_saga_unsupportedIterableToArray(arr) || shop_saga_nonIterableSpread(); }

function shop_saga_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function shop_saga_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return shop_saga_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return shop_saga_arrayLikeToArray(o, minLen); }

function shop_saga_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function shop_saga_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return shop_saga_arrayLikeToArray(arr); }

function shop_saga_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }








function _sharedWorkerFetchShopBooks(action) {
  var isPackagesFetched, isLoading, booksToFetch, packagesData, packages, booksToFetchArray, shopData;
  return shop_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchShopBooks$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return io_c3792963_select(shop_selectors/* selectorShopIsPackagesFetched */.rG);

      case 2:
        isPackagesFetched = _context.sent;

        if (!isPackagesFetched) {
          _context.next = 5;
          break;
        }

        return _context.abrupt("return");

      case 5:
        _context.next = 7;
        return io_c3792963_select(function (s) {
          return (0,system_selectors/* selectorLoaderById */.Uw)(s, shop_constants/* LOADER_ID_SHOP */.y);
        });

      case 7:
        isLoading = _context.sent;

        if (!isLoading) {
          _context.next = 10;
          break;
        }

        return _context.abrupt("return");

      case 10:
        booksToFetch = new Set(action.data);
        _context.next = 13;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(shop_constants/* LOADER_ID_SHOP */.y));

      case 13:
        _context.next = 15;
        return put(shop_actions/* _sharedActionsShop.fetchPackagesPending */.h.fetchPackagesPending());

      case 15:
        _context.next = 17;
        return io_c3792963_call(shopApi/* getPackagesRequest */.bb);

      case 17:
        packagesData = _context.sent;
        packages = (packagesData === null || packagesData === void 0 ? void 0 : packagesData.packages) || [];
        _context.next = 21;
        return put(shop_actions/* _sharedActionsShop.fetchPackagesSuccess */.h.fetchPackagesSuccess(packages));

      case 21:
        packages.forEach(function (shopPackage) {
          shopPackage.items.forEach(function (shopBook) {
            booksToFetch.add(shopBook.book_id);
          });
        });

        if (!booksToFetch.size) {
          _context.next = 31;
          break;
        }

        booksToFetchArray = shop_saga_toConsumableArray(booksToFetch);
        _context.next = 26;
        return put(shop_actions/* _sharedActionsShop.fetchShopBooksPending */.h.fetchShopBooksPending(booksToFetchArray));

      case 26:
        _context.next = 28;
        return io_c3792963_call(shopApi/* getShopBooksRequest */.xh, booksToFetchArray);

      case 28:
        shopData = _context.sent;
        _context.next = 31;
        return put(shop_actions/* _sharedActionsShop.fetchShopBooksSuccess */.h.fetchShopBooksSuccess(shopData === null || shopData === void 0 ? void 0 : shopData.books, booksToFetchArray));

      case 31:
        _context.next = 33;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(shop_constants/* LOADER_ID_SHOP */.y, true));

      case 33:
      case "end":
        return _context.stop();
    }
  }, shop_saga_marked);
}
;// CONCATENATED MODULE: ./src/next/store/saga/shop.saga.js
function saga_shop_saga_typeof(obj) { "@babel/helpers - typeof"; return saga_shop_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, saga_shop_saga_typeof(obj); }

function saga_shop_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ saga_shop_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == saga_shop_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var saga_shop_saga_marked = /*#__PURE__*/saga_shop_saga_regeneratorRuntime().mark(shopSaga);




function shopSaga() {
  return saga_shop_saga_regeneratorRuntime().wrap(function shopSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return io_c3792963_all([takeLeading$1(shop_actions/* _sharedActionsConstantsShop.FETCH_SHOP_BOOKS */.H.FETCH_SHOP_BOOKS, _sharedWorkerFetchShopBooks)]);

      case 2:
      case "end":
        return _context.stop();
    }
  }, saga_shop_saga_marked);
}
;
// EXTERNAL MODULE: ../shared/store/support/actions.js
var support_actions = __webpack_require__(97580);
;// CONCATENATED MODULE: ../shared/store/support/saga.js
function support_saga_typeof(obj) { "@babel/helpers - typeof"; return support_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, support_saga_typeof(obj); }

function support_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ support_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == support_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var support_saga_marked = /*#__PURE__*/support_saga_regeneratorRuntime().mark(_sharedWorkerFetchCF),
    support_saga_marked2 = /*#__PURE__*/support_saga_regeneratorRuntime().mark(_sharedWorkerSendCF);

function support_saga_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function support_saga_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? support_saga_ownKeys(Object(source), !0).forEach(function (key) { support_saga_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : support_saga_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function support_saga_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var support_saga_scope = "Shared Saga Support";
function _sharedWorkerFetchCF() {
  var response, contactTypes;
  return support_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchCF$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.prev = 0;
        _context.next = 3;
        return io_c3792963_call(not_sorted/* getContactUsRequest */.NL);

      case 3:
        response = _context.sent;
        contactTypes = response.data[0].contacts.map(function (item) {
          return support_saga_objectSpread(support_saga_objectSpread({}, item), {}, {
            id: item.tag
          });
        });
        _context.next = 7;
        return put(support_actions/* _sharedActionsSupport.actionFetchCFSuccess */._.actionFetchCFSuccess(contactTypes));

      case 7:
        _context.next = 12;
        break;

      case 9:
        _context.prev = 9;
        _context.t0 = _context["catch"](0);
        (0,utils_console/* consoleLogError */.aw)(support_saga_scope, "Error: ", _context.t0);

      case 12:
      case "end":
        return _context.stop();
    }
  }, support_saga_marked, null, [[0, 9]]);
}
function _sharedWorkerSendCF(action) {
  var response;
  return support_saga_regeneratorRuntime().wrap(function _sharedWorkerSendCF$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.prev = 0;
        _context2.next = 3;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(shared_constants/* ComponentsId.CF_SEND_ID */.uB.CF_SEND_ID));

      case 3:
        _context2.next = 5;
        return io_c3792963_call(not_sorted/* sendContact */.b8, action.data);

      case 5:
        response = _context2.sent;

        if (!(response.status === 202)) {
          _context2.next = 11;
          break;
        }

        _context2.next = 9;
        return put(support_actions/* _sharedActionsSupport.actionSendCFStatus */._.actionSendCFStatus(shared_constants/* CFStatus.SUCCESS */.ZX.SUCCESS));

      case 9:
        _context2.next = 13;
        break;

      case 11:
        _context2.next = 13;
        return put(support_actions/* _sharedActionsSupport.actionSendCFStatus */._.actionSendCFStatus(shared_constants/* CFStatus.ERROR */.ZX.ERROR));

      case 13:
        _context2.next = 20;
        break;

      case 15:
        _context2.prev = 15;
        _context2.t0 = _context2["catch"](0);
        (0,utils_console/* consoleLogError */.aw)(support_saga_scope, "Error: ", _context2.t0);
        _context2.next = 20;
        return put(system_actions/* _sharedActionsSystem.toast */.g.toast("Can't send contact data", shared_constants/* TOAST_TYPE.error */["do"].error));

      case 20:
        _context2.prev = 20;
        _context2.next = 23;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(shared_constants/* ComponentsId.CF_SEND_ID */.uB.CF_SEND_ID, true));

      case 23:
        return _context2.finish(20);

      case 24:
      case "end":
        return _context2.stop();
    }
  }, support_saga_marked2, null, [[0, 15, 20, 24]]);
}
;// CONCATENATED MODULE: ./src/next/store/saga/support.saga.js
function saga_support_saga_typeof(obj) { "@babel/helpers - typeof"; return saga_support_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, saga_support_saga_typeof(obj); }

function saga_support_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ saga_support_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == saga_support_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var saga_support_saga_marked = /*#__PURE__*/saga_support_saga_regeneratorRuntime().mark(contentSaga);

/* eslint-disable no-console */



var support_saga_TAG = "SUPPORT_SAGA";
function contentSaga() {
  return saga_support_saga_regeneratorRuntime().wrap(function contentSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return io_c3792963_all([takeLatest$1(actions/* supportActionConstants.FETCH_CF */.CT.FETCH_CF, _sharedWorkerFetchCF), takeLatest$1(actions/* supportActionConstants.SEND_CF */.CT.SEND_CF, _sharedWorkerSendCF)]);

      case 2:
      case "end":
        return _context.stop();
    }
  }, saga_support_saga_marked);
}
// EXTERNAL MODULE: ../shared/utils/sw/sw.js + 1 modules
var sw = __webpack_require__(3359);
// EXTERNAL MODULE: ../shared/utils/string/string.js
var string_string = __webpack_require__(56332);
// EXTERNAL MODULE: ../shared/utils/sw/sw.constants.js
var sw_constants = __webpack_require__(34855);
// EXTERNAL MODULE: ../shared/utils/url/url.js
var url_url = __webpack_require__(59916);
;// CONCATENATED MODULE: ../shared/api/content/audio/utils.js
function utils_typeof(obj) { "@babel/helpers - typeof"; return utils_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, utils_typeof(obj); }

function utils_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ utils_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == utils_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function utils_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function utils_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { utils_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { utils_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


var parseAudio = /*#__PURE__*/function () {
  var _ref = utils_asyncToGenerator( /*#__PURE__*/utils_regeneratorRuntime().mark(function _callee(response) {
    var base64;
    return utils_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          base64 = (0,utils_array/* bufferToBase64 */.h$)(response.data);
          return _context.abrupt("return", base64);

        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function parseAudio(_x) {
    return _ref.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ../shared/api/content/books/constants.js
var books_constants = __webpack_require__(67504);
;// CONCATENATED MODULE: ../shared/api/content/audio/requests.js




var fetchAudioFileAsBase64 = function fetchAudioFileAsBase64(chapterId, src, onDownloadProgress, onCancel) {
  return (0,baseApi/* makeRequest */.$f)({
    url: (0,url_url/* makeResourceUrl */.c7)(src),
    responseType: "arraybuffer",
    parseResponse: parseAudio,
    onDownloadProgress: onDownloadProgress,
    onCancel: onCancel,
    cancelTokenKey: (0,books_constants/* makeAudioDownloadCancelTokenKey */.l7)(chapterId)
  });
};
// EXTERNAL MODULE: ../shared/utils/storage/storage.js
var storage = __webpack_require__(12202);
// EXTERNAL MODULE: ../shared/utils/dom.js
var dom = __webpack_require__(62330);
// EXTERNAL MODULE: ../shared/store/toc/actions.js
var toc_actions = __webpack_require__(85939);
// EXTERNAL MODULE: ../shared/store/paragraphs/actions.js
var paragraphs_actions = __webpack_require__(9206);
// EXTERNAL MODULE: ../shared/store/sw/constants.js
var store_sw_constants = __webpack_require__(59079);
// EXTERNAL MODULE: ../shared/store/sw/selectorWebsiteUrlsForOfflineUse.js
var selectorWebsiteUrlsForOfflineUse = __webpack_require__(53201);
// EXTERNAL MODULE: ../shared/store/sw/selectorIsDownloadingWebsite.js
var selectorIsDownloadingWebsite = __webpack_require__(4061);
// EXTERNAL MODULE: ../shared/store/sw/selectorDownloadAudiosProgresses.js
var selectorDownloadAudiosProgresses = __webpack_require__(65268);
// EXTERNAL MODULE: ../shared/store/sw/selectorAudiosDownloadedIds.js
var selectorAudiosDownloadedIds = __webpack_require__(8073);
// EXTERNAL MODULE: ../shared/store/sw/selectorDownloadBooksProgresses.js
var selectorDownloadBooksProgresses = __webpack_require__(55445);
// EXTERNAL MODULE: ../shared/store/sw/selectorDownloadedBooksIds.js
var selectorDownloadedBooksIds = __webpack_require__(4586);
;// CONCATENATED MODULE: ./src/next/store/saga/sw.saga.js
function sw_saga_typeof(obj) { "@babel/helpers - typeof"; return sw_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, sw_saga_typeof(obj); }

function sw_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ sw_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == sw_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var sw_saga_marked = /*#__PURE__*/sw_saga_regeneratorRuntime().mark(downloadWebsite),
    sw_saga_marked2 = /*#__PURE__*/sw_saga_regeneratorRuntime().mark(cancelDownloadWebsite),
    sw_saga_marked3 = /*#__PURE__*/sw_saga_regeneratorRuntime().mark(_downloadDataWorker),
    sw_saga_marked4 = /*#__PURE__*/sw_saga_regeneratorRuntime().mark(_downloadBook),
    sw_saga_marked5 = /*#__PURE__*/sw_saga_regeneratorRuntime().mark(downloadBooks),
    sw_saga_marked6 = /*#__PURE__*/sw_saga_regeneratorRuntime().mark(_downloadAudio),
    sw_saga_marked7 = /*#__PURE__*/sw_saga_regeneratorRuntime().mark(downloadAudioChapters),
    sw_saga_marked8 = /*#__PURE__*/sw_saga_regeneratorRuntime().mark(downloadData),
    sw_saga_marked9 = /*#__PURE__*/sw_saga_regeneratorRuntime().mark(cancelDownloadData),
    sw_saga_marked10 = /*#__PURE__*/sw_saga_regeneratorRuntime().mark(pull),
    _marked11 = /*#__PURE__*/sw_saga_regeneratorRuntime().mark(pullSuccess),
    _marked12 = /*#__PURE__*/sw_saga_regeneratorRuntime().mark(getInitStatus),
    _marked13 = /*#__PURE__*/sw_saga_regeneratorRuntime().mark(swSaga);


























var sw_saga_TAG = "SW";
/* ===== WEBSITE ===== */

function downloadWebsite() {
  var urlsForOfflineUse, isDownloadingWebsite;
  return sw_saga_regeneratorRuntime().wrap(function downloadWebsite$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return io_c3792963_select(selectorWebsiteUrlsForOfflineUse/* selectorWebsiteUrlsForOfflineUse */.q);

      case 2:
        urlsForOfflineUse = _context.sent;
        _context.next = 5;
        return io_c3792963_select(selectorIsDownloadingWebsite/* selectorIsDownloadingWebsite */.H);

      case 5:
        isDownloadingWebsite = _context.sent;

        if (isDownloadingWebsite) {
          (0,sw/* postSWMessageCancelProcess */.s5)(sw_constants/* ID_PROCESS_CACHE_URLS */.jQ);
        }

        _context.next = 9;
        return io_c3792963_call(sw/* postSWMessageCacheUrls */.cx, urlsForOfflineUse);

      case 9:
      case "end":
        return _context.stop();
    }
  }, sw_saga_marked);
}

function cancelDownloadWebsite() {
  var isUrlsDownloading;
  return sw_saga_regeneratorRuntime().wrap(function cancelDownloadWebsite$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return io_c3792963_select(selectorIsDownloadingWebsite/* selectorIsDownloadingWebsite */.H);

      case 2:
        isUrlsDownloading = _context2.sent;

        if (isUrlsDownloading) {
          (0,sw/* postSWMessageCancelProcess */.s5)(sw_constants/* ID_PROCESS_CACHE_URLS */.jQ);
          (0,storage/* setLocalStorageItem */.D$)(sw_constants/* STORAGE_KEY_IS_USER_CANCELED_AUTO_DOWNLOADING */.Dr, "1");
        }

      case 4:
      case "end":
        return _context2.stop();
    }
  }, sw_saga_marked2);
}
/* ==================== */

/* ======= NAMED CACHE ======= */


function _downloadDataWorker(fetch, actionUpdateProgress, textSuccess, textCancel, textNoData, postMessage) {
  var canceled, data;
  return sw_saga_regeneratorRuntime().wrap(function _downloadDataWorker$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        canceled = false;
        _context3.next = 3;
        return io_c3792963_call(fetch, function (progress) {
          // FIXME: possibly lame approach
          if (__webpack_require__.g.window) {
            __webpack_require__.g.window.store.dispatch(actionUpdateProgress(progress.loaded / progress.total));
          }
        }, function () {
          canceled = true;
        });

      case 3:
        data = _context3.sent;
        _context3.next = 6;
        return put(actionUpdateProgress(store_sw_constants/* PROGRESS_VALUE_REMOVE */.m));

      case 6:
        if (!canceled) {
          _context3.next = 10;
          break;
        }

        _context3.next = 9;
        return put(actions/* systemActions.toast */.nm.toast(textCancel));

      case 9:
        return _context3.abrupt("return", false);

      case 10:
        if (data) {
          _context3.next = 14;
          break;
        }

        _context3.next = 13;
        return put(actions/* systemActions.toast */.nm.toast(textNoData));

      case 13:
        return _context3.abrupt("return", false);

      case 14:
        postMessage(data);
        _context3.next = 17;
        return put(actions/* systemActions.toast */.nm.toast(textSuccess));

      case 17:
        return _context3.abrupt("return", true);

      case 18:
      case "end":
        return _context3.stop();
    }
  }, sw_saga_marked3);
}
/* ==== BOOK ==== */


var makeToastMessageCancelBook = function makeToastMessageCancelBook(book) {
  return ["@sw:downloadCancelled", " " + (0,string_string/* addQuotes */.XK)(book.title)];
};

function _downloadBook(book) {
  var nBookId, isSuccess;
  return sw_saga_regeneratorRuntime().wrap(function _downloadBook$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        nBookId = book.book_id;
        _context4.next = 3;
        return io_c3792963_call(_downloadDataWorker, function (onProgress, onCancel) {
          return (0,books_requests/* fetchDownloadBook */.Nz)(book, onProgress, onCancel);
        }, function (progress) {
          return actions/* swActions.updateDownloadProgressBookData */.s1.updateDownloadProgressBookData(nBookId, progress);
        }, [(0,string_string/* addQuotes */.XK)(book.title) + " ", "@sw:successfullyDownloaded", "!"], makeToastMessageCancelBook(book), "@sw:bookNotAvailableOffline", function (data) {
          return (0,sw/* postSWMessageCacheBook */.lW)(nBookId, data);
        });

      case 3:
        isSuccess = _context4.sent;
        return _context4.abrupt("return", isSuccess);

      case 5:
      case "end":
        return _context4.stop();
    }
  }, sw_saga_marked4);
}

function downloadBooks(action) {
  var _action$data, books, onSuccess, downloadSuccessCount, downloadedBooksIds, downloadingBooksProgresses, booksNotDownloaded, book, bookId, i, downloadingBooksProgressesReselected, _i2;

  return sw_saga_regeneratorRuntime().wrap(function downloadBooks$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _action$data = action.data, books = _action$data.data, onSuccess = _action$data.onSuccess;
        downloadSuccessCount = 0;
        _context5.prev = 2;
        _context5.next = 5;
        return io_c3792963_select(selectorDownloadedBooksIds/* selectorDownloadedBooksIds */.F);

      case 5:
        downloadedBooksIds = _context5.sent;
        _context5.next = 8;
        return io_c3792963_select(selectorDownloadBooksProgresses/* selectorDownloadBooksProgresses */.a);

      case 8:
        downloadingBooksProgresses = _context5.sent;
        booksNotDownloaded = []; // Filter. Leaves only not downloaded/downloading books.

        i = 0;

      case 11:
        if (!(i < books.length)) {
          _context5.next = 21;
          break;
        }

        book = books[i];
        bookId = book.book_id.toString();

        if (!(!downloadedBooksIds.includes(bookId) && downloadingBooksProgresses[bookId] === undefined)) {
          _context5.next = 18;
          break;
        }

        booksNotDownloaded.push(book); // Initiate progresses, so user will see how many books are in the downloading queue

        _context5.next = 18;
        return put(actions/* swActions.updateDownloadProgressBookData */.s1.updateDownloadProgressBookData(bookId, 0));

      case 18:
        i++;
        _context5.next = 11;
        break;

      case 21:
        _i2 = 0;

      case 22:
        if (!(_i2 < booksNotDownloaded.length)) {
          _context5.next = 36;
          break;
        }

        _context5.next = 25;
        return io_c3792963_select(selectorDownloadBooksProgresses/* selectorDownloadBooksProgresses */.a);

      case 25:
        downloadingBooksProgressesReselected = _context5.sent;
        _context5.t0 = downloadingBooksProgressesReselected[booksNotDownloaded[_i2].book_id] !== undefined;

        if (!_context5.t0) {
          _context5.next = 31;
          break;
        }

        _context5.next = 30;
        return io_c3792963_call(_downloadBook, booksNotDownloaded[_i2]);

      case 30:
        _context5.t0 = _context5.sent;

      case 31:
        if (!_context5.t0) {
          _context5.next = 33;
          break;
        }

        downloadSuccessCount++;

      case 33:
        _i2++;
        _context5.next = 22;
        break;

      case 36:
        _context5.next = 41;
        break;

      case 38:
        _context5.prev = 38;
        _context5.t1 = _context5["catch"](2);
        (0,utils_console/* consoleLogError */.aw)(sw_saga_TAG, "Cache book for offline use", _context5.t1);

      case 41:
        _context5.prev = 41;

        if (downloadSuccessCount) {
          if (onSuccess) {
            onSuccess();
          }
        }

        return _context5.finish(41);

      case 44:
      case "end":
        return _context5.stop();
    }
  }, sw_saga_marked5, null, [[2, 38, 41, 44]]);
}
/* ==== AUDIO ==== */


var makeToastMessageCancelAudio = function makeToastMessageCancelAudio(audioChapter) {
  return ["@sw:downloadCancelled", " " + (0,string_string/* addQuotes */.XK)(audioChapter.title)];
};

function _downloadAudio(audioChapter) {
  var id, isSuccess, waveform;
  return sw_saga_regeneratorRuntime().wrap(function _downloadAudio$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        id = audioChapter.para_id;
        _context6.next = 3;
        return io_c3792963_call(_downloadDataWorker, function (onProgress, onCancel) {
          return fetchAudioFileAsBase64(id, audioChapter.mp3, onProgress, onCancel);
        }, function (progress) {
          return actions/* swActions.updateDownloadProgressAudio */.s1.updateDownloadProgressAudio(id, progress);
        }, [(0,string_string/* addQuotes */.XK)(audioChapter.title) + " ", "@sw:successfullyDownloaded", "!"], makeToastMessageCancelAudio(audioChapter), ["@sw:noInternetConnection", ". ", "@sw:featureNotAvailable", "."], function (data) {
          return (0,sw/* postSWMessageCacheAudioFile */.Hm)(id, "data:audio/mpeg;base64," + data);
        });

      case 3:
        isSuccess = _context6.sent;

        if (!(isSuccess && audioChapter.mp3)) {
          _context6.next = 9;
          break;
        }

        _context6.next = 7;
        return fetchAndStoreWaveformsDictionary((0,url_url/* makeWaveformsJsonUrl */.Je)(audioChapter.mp3), id);

      case 7:
        waveform = _context6.sent;
        (0,sw/* postSWMessageCacheWaveform */.ez)(id, waveform);

      case 9:
        return _context6.abrupt("return", isSuccess);

      case 10:
      case "end":
        return _context6.stop();
    }
  }, sw_saga_marked6);
}

function downloadAudioChapters(action) {
  var items, downloadedIds, downloadingProgresses, itemsNotDownloaded, item, itemId, i, downloadingProgressesReselected, _i4;

  return sw_saga_regeneratorRuntime().wrap(function downloadAudioChapters$(_context7) {
    while (1) switch (_context7.prev = _context7.next) {
      case 0:
        items = action.data.data;
        _context7.prev = 1;
        _context7.next = 4;
        return io_c3792963_select(selectorAudiosDownloadedIds/* selectorAudiosDownloadedIds */.P);

      case 4:
        downloadedIds = _context7.sent;
        _context7.next = 7;
        return io_c3792963_select(selectorDownloadAudiosProgresses/* selectorDownloadAudiosProgresses */._);

      case 7:
        downloadingProgresses = _context7.sent;
        itemsNotDownloaded = []; // Filter. Leaves only not downloaded/downloading books.

        i = 0;

      case 10:
        if (!(i < items.length)) {
          _context7.next = 20;
          break;
        }

        item = items[i];
        itemId = item.para_id;

        if (!(!downloadedIds.includes(itemId) && downloadingProgresses[itemId] === undefined)) {
          _context7.next = 17;
          break;
        }

        itemsNotDownloaded.push(item); // Initiate progresses, so user will see how many books are in the downloading queue

        _context7.next = 17;
        return put(actions/* swActions.updateDownloadProgressAudio */.s1.updateDownloadProgressAudio(itemId, 0));

      case 17:
        i++;
        _context7.next = 10;
        break;

      case 20:
        _i4 = 0;

      case 21:
        if (!(_i4 < itemsNotDownloaded.length)) {
          _context7.next = 31;
          break;
        }

        _context7.next = 24;
        return io_c3792963_select(selectorDownloadAudiosProgresses/* selectorDownloadAudiosProgresses */._);

      case 24:
        downloadingProgressesReselected = _context7.sent;

        if (!( // If an item has no value of progress, then consider its downloading had been canceled.
        // It's because the progress, but not the request is init beforehand,
        // so, on click cancel btn, there is no request to cancel.
        downloadingProgressesReselected[itemsNotDownloaded[_i4].para_id] !== undefined)) {
          _context7.next = 28;
          break;
        }

        _context7.next = 28;
        return io_c3792963_call(_downloadAudio, itemsNotDownloaded[_i4]);

      case 28:
        _i4++;
        _context7.next = 21;
        break;

      case 31:
        _context7.next = 36;
        break;

      case 33:
        _context7.prev = 33;
        _context7.t0 = _context7["catch"](1);
        (0,utils_console/* consoleLogError */.aw)(sw_saga_TAG, "Cache AUDIO File for offline use", _context7.t0);

      case 36:
      case "end":
        return _context7.stop();
    }
  }, sw_saga_marked7, null, [[1, 33]]);
}
/* ==== COMMON ==== */


function downloadData(action) {
  var cacheName;
  return sw_saga_regeneratorRuntime().wrap(function downloadData$(_context8) {
    while (1) switch (_context8.prev = _context8.next) {
      case 0:
        cacheName = action.data.cacheName;

        if (!(cacheName === sw_constants/* NAMED_CACHE_NAME.BOOK_DATA */.jy.BOOK_DATA)) {
          _context8.next = 6;
          break;
        }

        _context8.next = 4;
        return downloadBooks(action);

      case 4:
        _context8.next = 12;
        break;

      case 6:
        if (!(cacheName === sw_constants/* NAMED_CACHE_NAME.AUDIO_FILE */.jy.AUDIO_FILE)) {
          _context8.next = 11;
          break;
        }

        _context8.next = 9;
        return downloadAudioChapters(action);

      case 9:
        _context8.next = 12;
        break;

      case 11:
        if (cacheName === sw_constants/* NAMED_CACHE_NAME.WAVEFORM */.jy.WAVEFORM) {// for now, is downloaded with {AUDIO_FILE}.
        }

      case 12:
      case "end":
        return _context8.stop();
    }
  }, sw_saga_marked8);
}

function cancelDownloadData(action) {
  var _action$data2, cacheName, item, isSuchRequestWasInit, _isSuchRequestWasInit;

  return sw_saga_regeneratorRuntime().wrap(function cancelDownloadData$(_context9) {
    while (1) switch (_context9.prev = _context9.next) {
      case 0:
        _action$data2 = action.data, cacheName = _action$data2.cacheName, item = _action$data2.item;

        if (!(cacheName === sw_constants/* NAMED_CACHE_NAME.BOOK_DATA */.jy.BOOK_DATA)) {
          _context9.next = 10;
          break;
        }

        isSuchRequestWasInit = (0,utils/* cancelRequest */.wq)((0,books_constants/* makeBooksDownloadCancelTokenKey */.$0)(item.book_id));

        if (isSuchRequestWasInit) {
          _context9.next = 8;
          break;
        }

        _context9.next = 6;
        return put(actions/* systemActions.toast */.nm.toast(makeToastMessageCancelBook(item)));

      case 6:
        _context9.next = 8;
        return put(actions/* swActions.updateDownloadProgressBookData */.s1.updateDownloadProgressBookData(item.book_id, store_sw_constants/* PROGRESS_VALUE_REMOVE */.m));

      case 8:
        _context9.next = 20;
        break;

      case 10:
        if (!(cacheName === sw_constants/* NAMED_CACHE_NAME.AUDIO_FILE */.jy.AUDIO_FILE)) {
          _context9.next = 19;
          break;
        }

        _isSuchRequestWasInit = (0,utils/* cancelRequest */.wq)((0,books_constants/* makeAudioDownloadCancelTokenKey */.l7)(item.para_id));

        if (_isSuchRequestWasInit) {
          _context9.next = 17;
          break;
        }

        _context9.next = 15;
        return put(actions/* systemActions.toast */.nm.toast(makeToastMessageCancelAudio(item)));

      case 15:
        _context9.next = 17;
        return put(actions/* swActions.updateDownloadProgressAudio */.s1.updateDownloadProgressAudio(item.para_id, store_sw_constants/* PROGRESS_VALUE_REMOVE */.m));

      case 17:
        _context9.next = 20;
        break;

      case 19:
        if (cacheName === sw_constants/* NAMED_CACHE_NAME.WAVEFORM */.jy.WAVEFORM) {// for now, is canceled with {AUDIO_FILE}.
        }

      case 20:
      case "end":
        return _context9.stop();
    }
  }, sw_saga_marked9);
}

function pull(action) {
  var _action$data3, cacheName, key;

  return sw_saga_regeneratorRuntime().wrap(function pull$(_context10) {
    while (1) switch (_context10.prev = _context10.next) {
      case 0:
        _action$data3 = action.data, cacheName = _action$data3.cacheName, key = _action$data3.key;

        if (!(cacheName === sw_constants/* NAMED_CACHE_NAME.BOOK_DATA */.jy.BOOK_DATA)) {
          _context10.next = 6;
          break;
        }

        _context10.next = 4;
        return io_c3792963_call(sw/* postSWMessageGetBook */.jD, key);

      case 4:
        _context10.next = 14;
        break;

      case 6:
        if (!(cacheName === sw_constants/* NAMED_CACHE_NAME.AUDIO_FILE */.jy.AUDIO_FILE)) {
          _context10.next = 11;
          break;
        }

        _context10.next = 9;
        return io_c3792963_call(sw/* postSWMessageGetAudioFile */.aB, key);

      case 9:
        _context10.next = 14;
        break;

      case 11:
        if (!(cacheName === sw_constants/* NAMED_CACHE_NAME.WAVEFORM */.jy.WAVEFORM)) {
          _context10.next = 14;
          break;
        }

        _context10.next = 14;
        return io_c3792963_call(sw/* postSWMessageGetWaveform */.g, key);

      case 14:
      case "end":
        return _context10.stop();
    }
  }, sw_saga_marked10);
}

function pullSuccess(action) {
  var _action$data4, cacheName, key, value, mapChapterNumberToParas, waveform, paragraphsAudioPositions, chapterId, position, saveML, timestamp, _chapterId, paraId, _saveML, _timestamp;

  return sw_saga_regeneratorRuntime().wrap(function pullSuccess$(_context11) {
    while (1) switch (_context11.prev = _context11.next) {
      case 0:
        _action$data4 = action.data, cacheName = _action$data4.cacheName, key = _action$data4.key, value = _action$data4.value;

        if (!(cacheName === sw_constants/* NAMED_CACHE_NAME.BOOK_DATA */.jy.BOOK_DATA)) {
          _context11.next = 12;
          break;
        }

        _context11.next = 4;
        return put(mainTree_actions/* _sharedActionsMainTree.addBooks */.H.addBooks(value.book));

      case 4:
        _context11.next = 6;
        return put(toc_actions/* _sharedActionsToc.setItem */.v.setItem(value.book.book_id, value.toc));

      case 6:
        mapChapterNumberToParas = {};
        Object.keys(value.chaptersParas).forEach(function (chapterNumber) {
          mapChapterNumberToParas[chapterNumber] = {
            paras: value.chaptersParas[chapterNumber],
            highlight: ""
          };
        });
        _context11.next = 10;
        return put(paragraphs_actions/* _sharedActionsParagraphs.fetchChaptersParasSuccess */.e.fetchChaptersParasSuccess(value.book.book_id, mapChapterNumberToParas));

      case 10:
        _context11.next = 32;
        break;

      case 12:
        if (!(cacheName === sw_constants/* NAMED_CACHE_NAME.AUDIO_FILE */.jy.AUDIO_FILE)) {
          _context11.next = 16;
          break;
        }

        // FIXME: It's a crutch, because base64 strings are too large (e.g. 16 megabytes)!
        //  Actually, need to access the audio file directly, by using a custom endpoint
        //  in SW e.g. "/sw/named-cache/audioFile/[chapter_id]".
        //  But it's not working with mp3 file for some reason. Need to investigate!
        if (__webpack_require__.g.window) {
          (0,dom/* dispatchCustomEvent */.hb)(sw_constants/* CUSTOM_EVENT_TYPE_NEW_PULLED_AUDIO_FILE_SRC */.x, {
            key: key,
            value: value
          });
        }

        _context11.next = 32;
        break;

      case 16:
        if (!(cacheName === sw_constants/* NAMED_CACHE_NAME.WAVEFORM */.jy.WAVEFORM)) {
          _context11.next = 22;
          break;
        }

        waveform = value.waveform, paragraphsAudioPositions = value.paragraphsAudioPositions;
        _context11.next = 20;
        return put(player_actions/* _sharedActionsPlayer.putAudioWaveformsData */.m.putAudioWaveformsData({
          waveform: waveform,
          paragraphsAudioPositions: paragraphsAudioPositions,
          chapterId: key
        }));

      case 20:
        _context11.next = 32;
        break;

      case 22:
        if (!(cacheName === sw_constants/* NAMED_CACHE_NAME.OFFLINE_HISTORY_LISTEN */.jy.OFFLINE_HISTORY_LISTEN)) {
          _context11.next = 28;
          break;
        }

        chapterId = value.chapterId, position = value.position, saveML = value.saveML, timestamp = value.timestamp; // Don't save on the server to prevent not obvious, for user, history updates.

        _context11.next = 26;
        return put(actions/* libraryActions.saveListen */.jK.saveListen(chapterId, position, saveML, 0, timestamp, true));

      case 26:
        _context11.next = 32;
        break;

      case 28:
        if (!(cacheName === sw_constants/* NAMED_CACHE_NAME.OFFLINE_HISTORY_READ */.jy.OFFLINE_HISTORY_READ)) {
          _context11.next = 32;
          break;
        }

        _chapterId = value.chapterId, paraId = value.paraId, _saveML = value.saveML, _timestamp = value.timestamp; // Don't save on the server to prevent not obvious, for user, history updates.

        _context11.next = 32;
        return put(actions/* libraryActions.saveRead */.jK.saveRead(_chapterId, paraId, _saveML, 0, _timestamp, true));

      case 32:
      case "end":
        return _context11.stop();
    }
  }, _marked11);
}
/*  ====================  */


function getInitStatus() {
  var urlsForOfflineUse;
  return sw_saga_regeneratorRuntime().wrap(function getInitStatus$(_context12) {
    while (1) switch (_context12.prev = _context12.next) {
      case 0:
        _context12.prev = 0;
        _context12.next = 3;
        return io_c3792963_select(selectorWebsiteUrlsForOfflineUse/* selectorWebsiteUrlsForOfflineUse */.q);

      case 3:
        urlsForOfflineUse = _context12.sent;
        (0,sw/* postSWMessageGetInitData */.z3)(urlsForOfflineUse);
        _context12.next = 10;
        break;

      case 7:
        _context12.prev = 7;
        _context12.t0 = _context12["catch"](0);
        (0,utils_console/* consoleLogError */.aw)(sw_saga_TAG, "Get init status ERROR", _context12.t0);

      case 10:
      case "end":
        return _context12.stop();
    }
  }, _marked12, null, [[0, 7]]);
}

function swSaga() {
  return sw_saga_regeneratorRuntime().wrap(function swSaga$(_context13) {
    while (1) switch (_context13.prev = _context13.next) {
      case 0:
        _context13.next = 2;
        return io_c3792963_all([takeLatest$1(actions/* swActionConstants.DOWNLOAD_WEBSITE */._F.DOWNLOAD_WEBSITE, downloadWebsite), takeLatest$1(actions/* swActionConstants.CANCEL_DOWNLOAD_WEBSITE */._F.CANCEL_DOWNLOAD_WEBSITE, cancelDownloadWebsite), takeEvery$1(actions/* swActionConstants.DOWNLOAD_DATA */._F.DOWNLOAD_DATA, downloadData), takeEvery$1(actions/* swActionConstants.CANCEL_DOWNLOAD_DATA */._F.CANCEL_DOWNLOAD_DATA, cancelDownloadData), takeEvery$1(actions/* swActionConstants.PULL_SUCCESS */._F.PULL_SUCCESS, pullSuccess), takeEvery$1(actions/* swActionConstants.PULL */._F.PULL, pull), takeLatest$1(actions/* swActionConstants.GET_INIT_STATUS */._F.GET_INIT_STATUS, getInitStatus)]);

      case 2:
      case "end":
        return _context13.stop();
    }
  }, _marked13);
}
// EXTERNAL MODULE: ../shared/store/paragraphs/constants.js
var paragraphs_constants = __webpack_require__(3195);
// EXTERNAL MODULE: ../shared/utils/reader/constants.js
var reader_constants = __webpack_require__(16484);
;// CONCATENATED MODULE: ./src/next/store/saga/paragraphsReducer.saga.js
function paragraphsReducer_saga_typeof(obj) { "@babel/helpers - typeof"; return paragraphsReducer_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, paragraphsReducer_saga_typeof(obj); }

function paragraphsReducer_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ paragraphsReducer_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == paragraphsReducer_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var paragraphsReducer_saga_marked = /*#__PURE__*/paragraphsReducer_saga_regeneratorRuntime().mark(fetchChapterParasWorker),
    paragraphsReducer_saga_marked2 = /*#__PURE__*/paragraphsReducer_saga_regeneratorRuntime().mark(paragraphsReducer_saga_systemSaga);










function fetchChapterParasWorker(action) {
  var _action$data, chapterId, highlight, onResponseNotIncludesRequestedChapterId, loaderId, isLoading, content, indexChapterIdInResponse, chapterIdActual;

  return paragraphsReducer_saga_regeneratorRuntime().wrap(function fetchChapterParasWorker$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _action$data = action.data, chapterId = _action$data.chapterId, highlight = _action$data.highlight, onResponseNotIncludesRequestedChapterId = _action$data.onResponseNotIncludesRequestedChapterId;
        loaderId = (0,paragraphs_constants/* makeLoaderIdChapterParasLoading */.Ti)(chapterId);
        _context.next = 4;
        return io_c3792963_select(function (s) {
          return (0,system_selectors/* selectorLoaderById */.Uw)(s, loaderId);
        });

      case 4:
        isLoading = _context.sent;

        if (!isLoading) {
          _context.next = 7;
          break;
        }

        return _context.abrupt("return");

      case 7:
        _context.prev = 7;
        _context.next = 10;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(loaderId, false, true));

      case 10:
        _context.next = 12;
        return getChapterParas(chapterId, highlight, reader_constants/* BooksIdsJTL.includes */.t4.includes((0,content_content/* getBookIdWithPrefix */.NR)(chapterId)));

      case 12:
        content = _context.sent;

        if (!content) {
          _context.next = 21;
          break;
        }

        indexChapterIdInResponse = content.paras.findIndex(function (p) {
          return p.para_id === chapterId;
        });
        chapterIdActual = indexChapterIdInResponse === 0 // If to make a request with an id of a random chapter's para,
        // actual {chapterId} will be the first para's id.
        ? chapterId : content.paras[0].para_id;

        if (!(indexChapterIdInResponse === -1 && onResponseNotIncludesRequestedChapterId)) {
          _context.next = 19;
          break;
        }

        _context.next = 19;
        return io_c3792963_call(onResponseNotIncludesRequestedChapterId, {
          chapterIdActual: chapterIdActual
        });

      case 19:
        _context.next = 21;
        return put(actions/* paragraphsReducerActions.fetchChapterParasSuccess */.Kd.fetchChapterParasSuccess(chapterIdActual, content.paras, content.highlight));

      case 21:
        _context.prev = 21;
        _context.next = 24;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(loaderId, true));

      case 24:
        return _context.finish(21);

      case 25:
      case "end":
        return _context.stop();
    }
  }, paragraphsReducer_saga_marked, null, [[7,, 21, 25]]);
}

function paragraphsReducer_saga_systemSaga() {
  return paragraphsReducer_saga_regeneratorRuntime().wrap(function systemSaga$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return io_c3792963_all([takeEvery$1(actions/* paragraphsReducerConstants.FETCH_CHAPTER_PARAS */.Db.FETCH_CHAPTER_PARAS, fetchChapterParasWorker)]);

      case 2:
      case "end":
        return _context2.stop();
    }
  }, paragraphsReducer_saga_marked2);
}
;// CONCATENATED MODULE: ../shared/store/toc/saga.js
function toc_saga_typeof(obj) { "@babel/helpers - typeof"; return toc_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, toc_saga_typeof(obj); }

function toc_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ toc_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == toc_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var toc_saga_marked = /*#__PURE__*/toc_saga_regeneratorRuntime().mark(_sharedWorkerFetchToc);





var toc_saga_scope = "Shared Saga TOC";
function _sharedWorkerFetchToc(action) {
  var bookIdOrigin, toc;
  return toc_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchToc$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.prev = 0;
        bookIdOrigin = action.data;
        _context.next = 4;
        return getBookToc(bookIdOrigin);

      case 4:
        toc = _context.sent;

        if (!toc) {
          _context.next = 8;
          break;
        }

        _context.next = 8;
        return put(toc_actions/* _sharedActionsToc.setItem */.v.setItem(bookIdOrigin, toc));

      case 8:
        return _context.abrupt("return", toc);

      case 11:
        _context.prev = 11;
        _context.t0 = _context["catch"](0);
        (0,utils_console/* consoleLogError */.aw)(toc_saga_scope, "Error: ", _context.t0);
        return _context.abrupt("return", undefined);

      case 15:
      case "end":
        return _context.stop();
    }
  }, toc_saga_marked, null, [[0, 11]]);
}
// EXTERNAL MODULE: ../shared/utils/reader/reader.js
var reader = __webpack_require__(18664);
// EXTERNAL MODULE: ../shared/utils/player.js
var player = __webpack_require__(87794);
// EXTERNAL MODULE: ../shared/store/library/selectors.js
var library_selectors = __webpack_require__(35589);
// EXTERNAL MODULE: ../main/src/utils/Utils.js
var Utils = __webpack_require__(47599);
// EXTERNAL MODULE: ../shared/utils/assembly.js
var assembly = __webpack_require__(76732);
// EXTERNAL MODULE: ../shared/store/library/actions.js
var library_actions = __webpack_require__(82900);
// EXTERNAL MODULE: ../shared/store/library/constants.js
var library_constants = __webpack_require__(70929);
// EXTERNAL MODULE: ../shared/utils/date/index.js
var date = __webpack_require__(96112);
;// CONCATENATED MODULE: ../shared/store/library/saga.js
function library_saga_typeof(obj) { "@babel/helpers - typeof"; return library_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, library_saga_typeof(obj); }

function saga_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = library_saga_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function library_saga_toConsumableArray(arr) { return library_saga_arrayWithoutHoles(arr) || library_saga_iterableToArray(arr) || library_saga_unsupportedIterableToArray(arr) || library_saga_nonIterableSpread(); }

function library_saga_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function library_saga_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return library_saga_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return library_saga_arrayLikeToArray(o, minLen); }

function library_saga_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function library_saga_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return library_saga_arrayLikeToArray(arr); }

function library_saga_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function library_saga_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function library_saga_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? library_saga_ownKeys(Object(source), !0).forEach(function (key) { library_saga_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : library_saga_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function library_saga_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function library_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ library_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == library_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var library_saga_marked = /*#__PURE__*/library_saga_regeneratorRuntime().mark(_getWaveformsDictionary),
    library_saga_marked2 = /*#__PURE__*/library_saga_regeneratorRuntime().mark(_getParaIdByChapterIdAndPosition),
    library_saga_marked3 = /*#__PURE__*/library_saga_regeneratorRuntime().mark(_getAudioParamsByChapterAndParaId),
    saga_marked4 = /*#__PURE__*/library_saga_regeneratorRuntime().mark(_sharedWorkerGetIdAndPositionForBookOpen),
    saga_marked5 = /*#__PURE__*/library_saga_regeneratorRuntime().mark(_saveHistoryMethod),
    saga_marked6 = /*#__PURE__*/library_saga_regeneratorRuntime().mark(_sharedWorkerSaveAllHistory),
    saga_marked7 = /*#__PURE__*/library_saga_regeneratorRuntime().mark(_sharedWorkerSaveReadHistory),
    saga_marked8 = /*#__PURE__*/library_saga_regeneratorRuntime().mark(_sharedWorkerSaveListenHistory),
    saga_marked9 = /*#__PURE__*/library_saga_regeneratorRuntime().mark(_sharedHandleNewAllHistoryItems),
    saga_marked10 = /*#__PURE__*/library_saga_regeneratorRuntime().mark(_sharedWorkerFetchAllHistory),
    saga_marked11 = /*#__PURE__*/library_saga_regeneratorRuntime().mark(_sharedWorkerToggleBookInMLById),
    saga_marked12 = /*#__PURE__*/library_saga_regeneratorRuntime().mark(_sharedWorkerSetLibraryLanguages);



























function _getWaveformsDictionary(audioChapter) {
  var audioChapterId, waveformsDictionary;
  return library_saga_regeneratorRuntime().wrap(function _getWaveformsDictionary$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        audioChapterId = audioChapter.id;
        _context.next = 3;
        return io_c3792963_select(player_selectors/* selectorPlayerWaveformsDictionary */.cc);

      case 3:
        waveformsDictionary = _context.sent;

        if (waveformsDictionary[audioChapterId]) {
          _context.next = 10;
          break;
        }

        _context.next = 7;
        return fetchAndStoreWaveformsDictionary((0,url_url/* makeWaveformsJsonUrl */.Je)(audioChapter.mp3), audioChapterId);

      case 7:
        _context.next = 9;
        return io_c3792963_select(player_selectors/* selectorPlayerWaveformsDictionary */.cc);

      case 9:
        return _context.abrupt("return", _context.sent);

      case 10:
        return _context.abrupt("return", waveformsDictionary);

      case 11:
      case "end":
        return _context.stop();
    }
  }, library_saga_marked);
} // Detect exactly {paraId} based on listen {chapterId} and {position}.
// We can't store {paraId} for LISTEN history. (we can do it for ML though)


function _getParaIdByChapterIdAndPosition(chapterId, position) {
  var toc, audioChapter, _findWaveformsDiction, audioChapterId, waveformsDictionary, foundParaId;

  return library_saga_regeneratorRuntime().wrap(function _getParaIdByChapterIdAndPosition$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return _sharedWorkerFetchToc({
          data: (0,content_content/* getBookIdNumber */.o8)(chapterId)
        });

      case 2:
        toc = _context2.sent;

        if (!(toc !== null && toc !== void 0 && toc.length)) {
          _context2.next = 13;
          break;
        }

        audioChapter = (0,reader/* getReaderAudioChapter */.mT)(toc, chapterId);

        if (!audioChapter) {
          _context2.next = 13;
          break;
        }

        audioChapterId = audioChapter.id;
        _context2.next = 9;
        return _getWaveformsDictionary(audioChapter);

      case 9:
        waveformsDictionary = _context2.sent;
        foundParaId = (_findWaveformsDiction = (0,player/* findWaveformsDictionaryParaByPosition */.h$)(waveformsDictionary, audioChapterId, position)) === null || _findWaveformsDiction === void 0 ? void 0 : _findWaveformsDiction.id;

        if (!foundParaId) {
          _context2.next = 13;
          break;
        }

        return _context2.abrupt("return", foundParaId);

      case 13:
        return _context2.abrupt("return", chapterId);

      case 14:
      case "end":
        return _context2.stop();
    }
  }, library_saga_marked2);
} // Detect {audioChapterId} and {position} based on {chapterId} and {paraId}.


function _getAudioParamsByChapterAndParaId(chapterId, paraId) {
  var toc, audioChapterId, position, audioChapter, _findWaveformsDiction2, waveformsDictionary, foundPosition;

  return library_saga_regeneratorRuntime().wrap(function _getAudioParamsByChapterAndParaId$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return _sharedWorkerFetchToc({
          data: (0,content_content/* getBookIdNumber */.o8)(chapterId)
        });

      case 2:
        toc = _context3.sent;
        audioChapterId = chapterId, position = 0;

        if (!(toc !== null && toc !== void 0 && toc.length)) {
          _context3.next = 13;
          break;
        }

        audioChapter = (0,reader/* getReaderAudioChapter */.mT)(toc, chapterId);

        if (!audioChapter) {
          _context3.next = 13;
          break;
        }

        audioChapterId = audioChapter.id;
        _context3.next = 10;
        return _getWaveformsDictionary(audioChapter);

      case 10:
        waveformsDictionary = _context3.sent;
        foundPosition = (_findWaveformsDiction2 = (0,player/* findWaveformsDictionaryParaById */.Mp)(waveformsDictionary, audioChapterId, paraId)) === null || _findWaveformsDiction2 === void 0 ? void 0 : _findWaveformsDiction2.start;

        if (foundPosition !== undefined) {
          position = parseInt(foundPosition);
        }

      case 13:
        return _context3.abrupt("return", {
          id: audioChapterId,
          position: position
        });

      case 14:
      case "end":
        return _context3.stop();
    }
  }, library_saga_marked3);
}

function _sharedWorkerGetIdAndPositionForBookOpen(bookId, isGonnaListen, isUseMLHistory, isUseDefaultHistory, isUseLocalHistory, isFetchNewestHistory) {
  var id, chapterId, paraId, position, inLibrary, isNeedToDetectParaId, isNeedToDetectAudioChapterParams, isUseHistory, allHistory, bookHistory, isHistoryMyLibraryNewerThanLocal, isHistoryMyLibraryNewerThanDefault, isHistoryDefaultNewerThanLocal, isNewestHistoryML, isNewestHistoryDefault, isMLHistorySuitable, isDefaultHistorySuitable, isLocalHistorySuitable, timestampRead, timestampListen, isLastRead, audioData, book, value;
  return library_saga_regeneratorRuntime().wrap(function _sharedWorkerGetIdAndPositionForBookOpen$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        isUseHistory = isUseMLHistory || isUseDefaultHistory || isUseLocalHistory;

        if (!isUseHistory) {
          _context4.next = 10;
          break;
        }

        if (!isFetchNewestHistory) {
          _context4.next = 5;
          break;
        }

        _context4.next = 5;
        return io_c3792963_call(_sharedWorkerFetchAllHistory);

      case 5:
        _context4.next = 7;
        return io_c3792963_select(library_selectors/* selectorHistoryAllHistory */.uV);

      case 7:
        allHistory = _context4.sent;
        bookHistory = allHistory.find(function (item) {
          return item.id === bookId;
        });

        if (bookHistory) {
          isHistoryMyLibraryNewerThanLocal = isGonnaListen ? (0,date/* isBeforeDateISO */.Ut)(bookHistory.luListenLocal, bookHistory.mlLu) : (0,date/* isBeforeDateISO */.Ut)(bookHistory.luReadLocal, bookHistory.mlLu);
          isHistoryMyLibraryNewerThanDefault = isGonnaListen ? (0,date/* isBeforeDateISO */.Ut)(bookHistory.luListen, bookHistory.mlLu) : (0,date/* isBeforeDateISO */.Ut)(bookHistory.luRead, bookHistory.mlLu);
          isHistoryDefaultNewerThanLocal = isGonnaListen ? (0,date/* isBeforeDateISO */.Ut)(bookHistory.luListenLocal, bookHistory.luListen) : (0,date/* isBeforeDateISO */.Ut)(bookHistory.luReadLocal, bookHistory.luRead);
          isNewestHistoryML = isHistoryMyLibraryNewerThanDefault && isHistoryMyLibraryNewerThanLocal;
          isNewestHistoryDefault = !isHistoryMyLibraryNewerThanLocal && isHistoryDefaultNewerThanLocal;
          inLibrary = !!bookHistory.inLibrary;
          isMLHistorySuitable = isNewestHistoryML && isUseMLHistory && inLibrary;
          isDefaultHistorySuitable = (isNewestHistoryDefault || !isUseLocalHistory) && isUseDefaultHistory;
          isLocalHistorySuitable = isUseLocalHistory;
          timestampRead = isMLHistorySuitable ? bookHistory.luRead // use default history timestamp, because ML has only one {mlLu}
          : isDefaultHistorySuitable ? bookHistory.luRead : isLocalHistorySuitable ? bookHistory.luReadLocal : undefined;
          timestampListen = isMLHistorySuitable ? bookHistory.luListen // use default history timestamp, because ML has only one {mlLu}
          : isDefaultHistorySuitable ? bookHistory.luListen : isLocalHistorySuitable ? bookHistory.luListenLocal : undefined; // Default history is saved every time.

          isLastRead = (0,Utils/* detectIfLastRead */.JB)(timestampRead, timestampListen);

          if (isLastRead && isGonnaListen) {
            isNeedToDetectAudioChapterParams = true;
          }

          if (!isLastRead && !isGonnaListen) {
            isNeedToDetectParaId = true;
          }

          if (isMLHistorySuitable) {
            position = bookHistory.mlPosition;
            chapterId = bookHistory.mlChapterId;
            paraId = bookHistory.mlParaId;
            id = isGonnaListen ? bookHistory.mlChapterId : bookHistory.mlParaId;
          } else if (isDefaultHistorySuitable) {
            position = isLastRead ? bookHistory.readPosition : bookHistory.listenPosition;
            chapterId = isLastRead ? bookHistory.readChapterId : bookHistory.listenChapterId;
            paraId = bookHistory.readParaId;

            if (isLastRead) {
              id = isGonnaListen ? bookHistory.readChapterId : bookHistory.readParaId;
            } else {
              id = bookHistory.listenChapterId;
            }
          } else if (isLocalHistorySuitable) {
            chapterId = isLastRead ? bookHistory.readChapterIdLocal : bookHistory.listenChapterIdLocal;
            position = isLastRead ? bookHistory.readPositionLocal : bookHistory.listenPositionLocal;
            paraId = bookHistory.readParaIdLocal;

            if (isLastRead) {
              id = isGonnaListen ? bookHistory.readChapterIdLocal : bookHistory.readParaIdLocal;
            } else {
              id = bookHistory.listenChapterIdLocal;
            }
          }
        }

      case 10:
        if (!(isNeedToDetectParaId && chapterId)) {
          _context4.next = 14;
          break;
        }

        _context4.next = 13;
        return _getParaIdByChapterIdAndPosition(chapterId, position);

      case 13:
        id = _context4.sent;

      case 14:
        if (!(isNeedToDetectAudioChapterParams && chapterId)) {
          _context4.next = 20;
          break;
        }

        _context4.next = 17;
        return _getAudioParamsByChapterAndParaId(chapterId, paraId);

      case 17:
        audioData = _context4.sent;
        id = audioData.id;
        position = audioData.position;

      case 20:
        if (id) {
          _context4.next = 26;
          break;
        }

        _context4.next = 23;
        return getBookById(bookId, false);

      case 23:
        book = _context4.sent;

        if (book) {
          id = book.first_para;
        } else {
          value = (0,content_content/* getBookIdNumber */.o8)(bookId);
          id = value + ".1";
        }

        position = 0;

      case 26:
        return _context4.abrupt("return", {
          id: id,
          position: position,
          inLibrary: inLibrary
        });

      case 27:
      case "end":
        return _context4.stop();
    }
  }, saga_marked4);
}
var SYNC_HISTORY_TYPE_DEBOUNCE_MS = 3000;
var IS_CONSOLE_LOGS = true;
var saga_TAG = "Saga Library";

function _saveHistoryMethod(historyType, chapterId, paraId, position, saveML, localItemDateISO, skipSaveOnServer) {
  var bookId, isReadHistory, isListenHistory, userInfo, allHistory, _yield$select, isLogin, onLine, shouldSaveOnServer, item, isInLibrary, isSyncMLAlso, date, currentDateISO, historyItem, itemIndexInAllHistory, _item, itemToSave, dateToFetchNewItems;

  return library_saga_regeneratorRuntime().wrap(function _saveHistoryMethod$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        bookId = (0,content_content/* getBookIdWithPrefix */.NR)(paraId);
        isReadHistory = historyType === Utils/* HistoryType.READING */.Z3.READING;
        isListenHistory = historyType === Utils/* HistoryType.LISTEN */.Z3.LISTEN;
        _context5.next = 5;
        return io_c3792963_select(system_selectors/* selectorUserInfo */.If);

      case 5:
        userInfo = _context5.sent;
        _context5.next = 8;
        return io_c3792963_select(library_selectors/* selectorHistoryAllHistory */.uV);

      case 8:
        allHistory = _context5.sent;
        _context5.next = 11;
        return io_c3792963_select(function (s) {
          return {
            isLogin: (0,system_selectors/* selectorSystemIsLogin */.wN)(s),
            onLine: (0,system_selectors/* selectorSystemOnLine */.JU)(s)
          };
        });

      case 11:
        _yield$select = _context5.sent;
        isLogin = _yield$select.isLogin;
        onLine = _yield$select.onLine;
        shouldSaveOnServer = isLogin && onLine && !skipSaveOnServer;
        item = allHistory.find(function (item) {
          return item.id === bookId;
        }); // for next app it's enough just to have a book in the library.

        isInLibrary = item === null || item === void 0 ? void 0 : item.inLibrary;
        isSyncMLAlso = isInLibrary;
        date = new Date();
        currentDateISO = date.toISOString();
        historyItem = {
          id: bookId
        };

        if (isReadHistory) {
          historyItem.readChapterIdLocal = chapterId;
          historyItem.readParaIdLocal = paraId;
          historyItem.readPositionLocal = position;
          historyItem.luReadLocal = localItemDateISO || currentDateISO;

          if (IS_CONSOLE_LOGS) {
            console.log("%c[History] SAVE Read", "background: red; color: white;", {
              shouldSaveOnServer: shouldSaveOnServer,
              chapterId: chapterId,
              paraId: paraId,
              position: historyItem.readPosition
            });
          }
        } else {
          historyItem.listenChapterIdLocal = chapterId;
          historyItem.listenPositionLocal = position;
          historyItem.luListenLocal = localItemDateISO || currentDateISO;

          if (IS_CONSOLE_LOGS) {
            console.log("%c[History] SAVE Listen", "background: blue; color: white;", {
              shouldSaveOnServer: shouldSaveOnServer,
              chapterId: chapterId,
              paraId: paraId,
              position: position
            });
          }
        }

        if (shouldSaveOnServer) {
          if (isReadHistory) {
            historyItem.luRead = currentDateISO;
            historyItem.readChapterId = chapterId;
            historyItem.readParaId = paraId;
            historyItem.readPosition = position;
          } else if (isListenHistory) {
            historyItem.luListen = currentDateISO;
            historyItem.listenChapterId = chapterId;
            historyItem.listenPosition = position;
          }

          if (isSyncMLAlso) {
            historyItem.mlLu = currentDateISO;
            historyItem.mlChapterId = chapterId;
            historyItem.mlParaId = paraId;
            historyItem.mlPosition = position;

            if (IS_CONSOLE_LOGS) {
              console.log("%c[ML] SAVE", "background: green; color: white;", {
                chapterId: historyItem.mlChapterId,
                paraId: historyItem.mlParaId,
                position: historyItem.mlPosition
              });
            }
          }
        }

        itemIndexInAllHistory = allHistory.findIndex(function (item) {
          return item.id === bookId;
        });

        if (itemIndexInAllHistory !== -1) {
          _item = allHistory[itemIndexInAllHistory];
          allHistory[itemIndexInAllHistory] = library_saga_objectSpread(library_saga_objectSpread({}, _item || {}), historyItem);
        } else {
          allHistory.push(historyItem);
        }

        _context5.next = 27;
        return put(library_actions/* _sharedActionsLibrary.updateAllHistory */.C.updateAllHistory(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id, allHistory));

      case 27:
        if (!shouldSaveOnServer) {
          _context5.next = 47;
          break;
        }

        itemToSave = {};

        if (isReadHistory) {
          itemToSave = (0,not_sorted_utils/* mapReadingHistoryForServer */.MI)(historyItem.readParaId, historyItem.readPosition, historyItem.luRead);
        } else if (isListenHistory) {
          itemToSave = (0,not_sorted_utils/* mapListenHistoryForServer */.u8)(historyItem.listenChapterId, historyItem.listenPosition, historyItem.luListen);
        }

        _context5.prev = 30;
        _context5.next = 33;
        return io_c3792963_call(not_sorted/* putHistoryRequest */.Z5, historyType, {
          items: [itemToSave]
        });

      case 33:
        _context5.next = 38;
        break;

      case 35:
        _context5.prev = 35;
        _context5.t0 = _context5["catch"](30);
        (0,utils_console/* consoleLogError */.aw)(saga_TAG, "Error put history", {
          e: _context5.t0,
          historyType: historyType,
          args: {
            items: [itemToSave]
          },
          fn: not_sorted/* putHistoryRequest */.Z5
        });

      case 38:
        if (!isSyncMLAlso) {
          _context5.next = 47;
          break;
        }

        _context5.prev = 39;
        _context5.next = 42;
        return io_c3792963_call(not_sorted/* putHistoryRequest */.Z5, Utils/* HistoryType.ML_HISTORY */.Z3.ML_HISTORY, {
          items: [{
            lu: historyItem.mlLu,
            chapter_id: historyItem.mlChapterId,
            para_id: historyItem.mlParaId,
            position: historyItem.mlPosition
          }]
        });

      case 42:
        _context5.next = 47;
        break;

      case 44:
        _context5.prev = 44;
        _context5.t1 = _context5["catch"](39);
        (0,utils_console/* consoleLogError */.aw)(saga_TAG, "Error put ML history", {
          e: _context5.t1,
          historyType: Utils/* HistoryType.ML_HISTORY */.Z3.ML_HISTORY,
          args: {
            items: [{
              lu: historyItem.mlLu,
              chapter_id: historyItem.mlChapterId,
              para_id: historyItem.mlParaId,
              position: historyItem.mlPosition
            }]
          },
          fn: not_sorted/* putHistoryRequest */.Z5
        });

      case 47:
        if (item && localItemDateISO !== (isReadHistory ? item.luReadLocal : item.luListenLocal)) {
          if (isReadHistory) {
            (0,sw/* postSWMessageCacheOfflineHistoryRead */.GW)(chapterId, paraId, saveML, historyItem.luReadLocal);
          } else {
            (0,sw/* postSWMessageCacheOfflineHistoryListen */.vw)(chapterId, position, saveML, historyItem.luListenLocal);
          }
        } // fetch newly added or updated items as server computes some data on its side,
        // (e.g. chapter id for para id and ref codes)


        dateToFetchNewItems = new Date(date.getTime() - 1000);
        _context5.next = 51;
        return put(library_actions/* _sharedActionsLibrary.fetchAllBooksData */.C.fetchAllBooksData(dateToFetchNewItems.toISOString()));

      case 51:
      case "end":
        return _context5.stop();
    }
  }, saga_marked5, null, [[30, 35], [39, 44]]);
}

function _sharedWorkerSaveAllHistory(action) {
  var _action$data, chapterId, paraId, positionNotParsed, saveML, delayMS, localItemDateISO, skipSaveOnServer, position;

  return library_saga_regeneratorRuntime().wrap(function _sharedWorkerSaveAllHistory$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        _action$data = action.data, chapterId = _action$data.chapterId, paraId = _action$data.paraId, positionNotParsed = _action$data.position, saveML = _action$data.saveML, delayMS = _action$data.delay, localItemDateISO = _action$data.localItemDateISO, skipSaveOnServer = _action$data.skipSaveOnServer;
        _context6.next = 3;
        return io_c3792963_delay(delayMS !== null && delayMS !== void 0 ? delayMS : SYNC_HISTORY_TYPE_DEBOUNCE_MS);

      case 3:
        position = positionNotParsed ? Number.parseInt(positionNotParsed, 10) : 0;
        _context6.next = 6;
        return _saveHistoryMethod(Utils/* HistoryType.LISTEN */.Z3.LISTEN, chapterId, paraId || chapterId, position, false, localItemDateISO, skipSaveOnServer);

      case 6:
        _context6.next = 8;
        return _saveHistoryMethod(Utils/* HistoryType.READING */.Z3.READING, chapterId, paraId, position, saveML, localItemDateISO, skipSaveOnServer);

      case 8:
      case "end":
        return _context6.stop();
    }
  }, saga_marked6);
}
function _sharedWorkerSaveReadHistory(action) {
  var _action$data2, chapterId, paraId, saveML, delayMS, localItemDateISO, skipSaveOnServer;

  return library_saga_regeneratorRuntime().wrap(function _sharedWorkerSaveReadHistory$(_context7) {
    while (1) switch (_context7.prev = _context7.next) {
      case 0:
        _action$data2 = action.data, chapterId = _action$data2.chapterId, paraId = _action$data2.paraId, saveML = _action$data2.saveML, delayMS = _action$data2.delay, localItemDateISO = _action$data2.localItemDateISO, skipSaveOnServer = _action$data2.skipSaveOnServer;
        _context7.next = 3;
        return io_c3792963_delay(delayMS !== null && delayMS !== void 0 ? delayMS : SYNC_HISTORY_TYPE_DEBOUNCE_MS);

      case 3:
        _context7.next = 5;
        return _saveHistoryMethod(Utils/* HistoryType.READING */.Z3.READING, chapterId, paraId, undefined, saveML, localItemDateISO, skipSaveOnServer);

      case 5:
      case "end":
        return _context7.stop();
    }
  }, saga_marked7);
}
function _sharedWorkerSaveListenHistory(action) {
  var _action$data3, chapterId, positionNotParsed, saveML, delayMS, localItemDateISO, skipSaveOnServer, position;

  return library_saga_regeneratorRuntime().wrap(function _sharedWorkerSaveListenHistory$(_context8) {
    while (1) switch (_context8.prev = _context8.next) {
      case 0:
        _action$data3 = action.data, chapterId = _action$data3.chapterId, positionNotParsed = _action$data3.position, saveML = _action$data3.saveML, delayMS = _action$data3.delay, localItemDateISO = _action$data3.localItemDateISO, skipSaveOnServer = _action$data3.skipSaveOnServer;
        position = positionNotParsed ? Number.parseInt(positionNotParsed, 10) : 0;
        _context8.next = 4;
        return io_c3792963_delay(delayMS !== null && delayMS !== void 0 ? delayMS : SYNC_HISTORY_TYPE_DEBOUNCE_MS);

      case 4:
        _context8.next = 6;
        return _saveHistoryMethod(Utils/* HistoryType.LISTEN */.Z3.LISTEN, chapterId, chapterId, position, saveML, localItemDateISO, skipSaveOnServer);

      case 6:
      case "end":
        return _context8.stop();
    }
  }, saga_marked8);
}
function _sharedHandleNewAllHistoryItems(allHistoryItems) {
  var userInfo, langLessItemsIndexes, allHistoryItem, i, langLessItemsIds, books, index, book, _loop, _i2;

  return library_saga_regeneratorRuntime().wrap(function _sharedHandleNewAllHistoryItems$(_context10) {
    while (1) switch (_context10.prev = _context10.next) {
      case 0:
        _context10.next = 2;
        return io_c3792963_select(system_selectors/* selectorUserInfo */.If);

      case 2:
        userInfo = _context10.sent;
        langLessItemsIndexes = [];

        for (i = 0; i < allHistoryItems.length; i++) {
          allHistoryItem = allHistoryItems[i];

          if (!allHistoryItem.lang) {
            langLessItemsIndexes.push(i);
          }
        }

        langLessItemsIds = langLessItemsIndexes.map(function (i) {
          return allHistoryItems[i].id;
        });

        if (!langLessItemsIds.length) {
          _context10.next = 18;
          break;
        }

        _context10.next = 9;
        return io_c3792963_call(_sharedWorkerFetchBooksByIds, langLessItemsIds);

      case 9:
        books = _context10.sent;

        if (!books) {
          _context10.next = 18;
          break;
        }

        _loop = /*#__PURE__*/library_saga_regeneratorRuntime().mark(function _loop(_i) {
          return library_saga_regeneratorRuntime().wrap(function _loop$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                index = langLessItemsIndexes[_i];
                book = books.find(function (b) {
                  return b.id === langLessItemsIds[_i];
                });

                if (book) {
                  allHistoryItems[index] = library_saga_objectSpread(library_saga_objectSpread({}, allHistoryItems[index]), {}, {
                    lang: book.lang
                  });
                }

              case 3:
              case "end":
                return _context9.stop();
            }
          }, _loop);
        });
        _i2 = 0;

      case 13:
        if (!(_i2 < langLessItemsIndexes.length)) {
          _context10.next = 18;
          break;
        }

        return _context10.delegateYield(_loop(_i2), "t0", 15);

      case 15:
        _i2++;
        _context10.next = 13;
        break;

      case 18:
        _context10.next = 20;
        return put(library_actions/* _sharedActionsLibrary.updateAllHistory */.C.updateAllHistory(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id, allHistoryItems));

      case 20:
      case "end":
        return _context10.stop();
    }
  }, saga_marked9);
}
function _sharedWorkerFetchAllHistory(action) {
  var isLogin, start, onFinally, _yield$call2, reading, listen, ml, library, allHistory, allHistoryItems;

  return library_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchAllHistory$(_context11) {
    while (1) switch (_context11.prev = _context11.next) {
      case 0:
        _context11.next = 2;
        return io_c3792963_select(system_selectors/* selectorSystemIsLogin */.wN);

      case 2:
        isLogin = _context11.sent;

        if (isLogin) {
          _context11.next = 5;
          break;
        }

        return _context11.abrupt("return");

      case 5:
        if (action !== null && action !== void 0 && action.data) {
          start = action.data.start;
          onFinally = action.data.onFinally;
        }

        _context11.prev = 6;
        _context11.next = 9;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(library_constants/* LOADER_ID_FETCH_ALL_HISTORY */.r));

      case 9:
        _context11.next = 11;
        return io_c3792963_call(not_sorted/* getAllHistoryRequest */.XH, start);

      case 11:
        _yield$call2 = _context11.sent;
        reading = _yield$call2.reading;
        listen = _yield$call2.listen;
        ml = _yield$call2.ml;
        library = _yield$call2.library;
        _context11.next = 18;
        return io_c3792963_select(library_selectors/* selectorHistoryAllHistory */.uV);

      case 18:
        allHistory = _context11.sent;
        allHistoryItems = (0,not_sorted_utils/* joinHistoryData */.dA)(reading, listen, ml, library, allHistory, !!start);
        _context11.next = 22;
        return _sharedHandleNewAllHistoryItems(allHistoryItems);

      case 22:
        _context11.next = 27;
        break;

      case 24:
        _context11.prev = 24;
        _context11.t0 = _context11["catch"](6);
        console.log("fetchAllBooksDataWorker Error", _context11.t0);

      case 27:
        _context11.prev = 27;
        _context11.next = 30;
        return put(system_actions/* _sharedActionsSystem.loading */.g.loading(library_constants/* LOADER_ID_FETCH_ALL_HISTORY */.r, true));

      case 30:
        if (onFinally) {
          onFinally();
        }

        return _context11.finish(27);

      case 32:
      case "end":
        return _context11.stop();
    }
  }, saga_marked10, null, [[6, 24, 27, 32]]);
}
function _sharedWorkerToggleBookInMLById(action) {
  var ids, userInfo, allHistory, books, libraryLanguages, allHistorySpread, suitableBooks, _iterator, _step, id, book, idsAdded, idsRemoved, _iterator2, _step2, _loop2;

  return library_saga_regeneratorRuntime().wrap(function _sharedWorkerToggleBookInMLById$(_context13) {
    while (1) switch (_context13.prev = _context13.next) {
      case 0:
        ids = Array.isArray(action.data) ? action.data.map(content_content/* getBookIdNumber */.o8) : [(0,content_content/* getBookIdNumber */.o8)(action.data)];
        _context13.next = 3;
        return io_c3792963_select(system_selectors/* selectorUserInfo */.If);

      case 3:
        userInfo = _context13.sent;
        _context13.next = 6;
        return io_c3792963_select(library_selectors/* selectorHistoryAllHistory */.uV);

      case 6:
        allHistory = _context13.sent;
        _context13.next = 9;
        return io_c3792963_select(mainTree_selectors/* selectorMainTreeBooks */.yS);

      case 9:
        books = _context13.sent;
        _context13.next = 12;
        return io_c3792963_select((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.libraryLanguages.id */.Fy.libraryLanguages.id));

      case 12:
        libraryLanguages = _context13.sent;
        allHistorySpread = library_saga_toConsumableArray(allHistory);
        suitableBooks = books.filter(function (book) {
          return ids.includes((0,content_content/* getBookIdNumber */.o8)(book.id));
        });

        if (suitableBooks.length) {
          _context13.next = 36;
          break;
        }

        suitableBooks = [];
        _iterator = saga_createForOfIteratorHelper(ids);
        _context13.prev = 18;

        _iterator.s();

      case 20:
        if ((_step = _iterator.n()).done) {
          _context13.next = 28;
          break;
        }

        id = _step.value;
        _context13.next = 24;
        return getBookById(id, false);

      case 24:
        book = _context13.sent;
        suitableBooks.push(book);

      case 26:
        _context13.next = 20;
        break;

      case 28:
        _context13.next = 33;
        break;

      case 30:
        _context13.prev = 30;
        _context13.t0 = _context13["catch"](18);

        _iterator.e(_context13.t0);

      case 33:
        _context13.prev = 33;

        _iterator.f();

        return _context13.finish(33);

      case 36:
        if (suitableBooks) {
          _context13.next = 39;
          break;
        }

        (0,utils_console/* consoleLogError */.aw)("ML", "Couldn't load a book, so won't toggled in the ML!", {
          ids: ids
        });
        return _context13.abrupt("return");

      case 39:
        idsAdded = [];
        idsRemoved = [];
        _iterator2 = saga_createForOfIteratorHelper(suitableBooks);
        _context13.prev = 42;
        _loop2 = /*#__PURE__*/library_saga_regeneratorRuntime().mark(function _loop2() {
          var book, id, bookLang, bookIndex, isAdded, inLibraryNew, newLangs;
          return library_saga_regeneratorRuntime().wrap(function _loop2$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                book = _step2.value;
                id = (0,content_content/* getBookIdNumber */.o8)(book.id);
                bookLang = book.lang;
                bookIndex = allHistorySpread.findIndex(function (item) {
                  return (0,content_content/* getBookIdNumber */.o8)(item.id) === id;
                });

                if (bookIndex === -1) {
                  allHistorySpread.push({
                    id: (0,content_content/* getBookIdWithPrefix */.NR)(id),
                    lang: bookLang,
                    inLibrary: true,
                    luLibrary: new Date().toISOString()
                  });
                  isAdded = true;
                } else {
                  inLibraryNew = !allHistorySpread[bookIndex].inLibrary;
                  allHistorySpread[bookIndex].inLibrary = inLibraryNew;
                  allHistorySpread[bookIndex].luLibrary = new Date().toISOString();
                  isAdded = inLibraryNew;
                }

                if (!isAdded) {
                  _context12.next = 13;
                  break;
                }

                idsAdded.push(id);

                if (!(bookLang && !libraryLanguages.includes(bookLang))) {
                  _context12.next = 11;
                  break;
                }

                newLangs = [].concat(library_saga_toConsumableArray(libraryLanguages), [bookLang]);
                _context12.next = 11;
                return put(library_actions/* _sharedActionsLibrary.setLibraryLanguages */.C.setLibraryLanguages(newLangs));

              case 11:
                _context12.next = 14;
                break;

              case 13:
                idsRemoved.push(id);

              case 14:
              case "end":
                return _context12.stop();
            }
          }, _loop2);
        });

        _iterator2.s();

      case 45:
        if ((_step2 = _iterator2.n()).done) {
          _context13.next = 49;
          break;
        }

        return _context13.delegateYield(_loop2(), "t1", 47);

      case 47:
        _context13.next = 45;
        break;

      case 49:
        _context13.next = 54;
        break;

      case 51:
        _context13.prev = 51;
        _context13.t2 = _context13["catch"](42);

        _iterator2.e(_context13.t2);

      case 54:
        _context13.prev = 54;

        _iterator2.f();

        return _context13.finish(54);

      case 57:
        _context13.next = 59;
        return put(library_actions/* _sharedActionsLibrary.updateAllHistory */.C.updateAllHistory(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id, allHistorySpread));

      case 59:
        if (!idsAdded.length) {
          _context13.next = 64;
          break;
        }

        _context13.next = 62;
        return io_c3792963_call(not_sorted/* addBooksToLibraryRequest */.Ak, idsAdded);

      case 62:
        _context13.next = 64;
        return put(system_actions/* _sharedActionsSystem.toast */.g.toast("@toastAddToLibrary"));

      case 64:
        if (!idsRemoved.length) {
          _context13.next = 69;
          break;
        }

        _context13.next = 67;
        return io_c3792963_call(not_sorted/* deleteBooksFromLibraryRequest */.oP, idsRemoved);

      case 67:
        _context13.next = 69;
        return put(system_actions/* _sharedActionsSystem.toast */.g.toast("@toastRemoveFromLibrary"));

      case 69:
      case "end":
        return _context13.stop();
    }
  }, saga_marked11, null, [[18, 30, 33, 36], [42, 51, 54, 57]]);
}
function _sharedWorkerSetLibraryLanguages(action) {
  var langs, isLogin, _sharedActionsSetting;

  return library_saga_regeneratorRuntime().wrap(function _sharedWorkerSetLibraryLanguages$(_context14) {
    while (1) switch (_context14.prev = _context14.next) {
      case 0:
        langs = action.data;
        _context14.next = 3;
        return io_c3792963_select(system_selectors/* selectorSystemIsLogin */.wN);

      case 3:
        isLogin = _context14.sent;
        _context14.prev = 4;

        if (!isLogin) {
          _context14.next = 8;
          break;
        }

        _context14.next = 8;
        return io_c3792963_call(not_sorted/* setLibraryLanguagesRequest */.au, langs);

      case 8:
        _context14.next = 10;
        return put(settings_actions/* _sharedActionsSettings.updateSettings */.a.updateSettings((_sharedActionsSetting = {}, library_saga_defineProperty(_sharedActionsSetting, settings_constants/* SETTING.libraryLanguages.id */.Fy.libraryLanguages.id, langs), library_saga_defineProperty(_sharedActionsSetting, settings_constants/* SETTING.filterLibraryLanguages.id */.Fy.filterLibraryLanguages.id, langs), _sharedActionsSetting)));

      case 10:
        _context14.next = 15;
        break;

      case 12:
        _context14.prev = 12;
        _context14.t0 = _context14["catch"](4);
        console.log("setLibraryLanguagesWorker Error", _context14.t0);

      case 15:
      case "end":
        return _context14.stop();
    }
  }, saga_marked12, null, [[4, 12]]);
}
;// CONCATENATED MODULE: ./src/next/store/saga/library.saga.js
function saga_library_saga_typeof(obj) { "@babel/helpers - typeof"; return saga_library_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, saga_library_saga_typeof(obj); }

function saga_library_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ saga_library_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == saga_library_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var saga_library_saga_marked = /*#__PURE__*/saga_library_saga_regeneratorRuntime().mark(getIdAndPositionToBookOpen),
    saga_library_saga_marked2 = /*#__PURE__*/saga_library_saga_regeneratorRuntime().mark(watchRaceGetIdAndPositionToOpenBook),
    saga_library_saga_marked3 = /*#__PURE__*/saga_library_saga_regeneratorRuntime().mark(library_saga_settingsSaga);

/* eslint-disable no-console */




function getIdAndPositionToBookOpen(action) {
  var _action$data, bookId, isGonnaListen, isUseMLHistory, isUseDefaultHistory, isUseLocalHistory, isFetchNewestHistory, isPreferNewestHistory, onSuccess, result;

  return saga_library_saga_regeneratorRuntime().wrap(function getIdAndPositionToBookOpen$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _action$data = action.data, bookId = _action$data.bookId, isGonnaListen = _action$data.isGonnaListen, isUseMLHistory = _action$data.isUseMLHistory, isUseDefaultHistory = _action$data.isUseDefaultHistory, isUseLocalHistory = _action$data.isUseLocalHistory, isFetchNewestHistory = _action$data.isFetchNewestHistory, isPreferNewestHistory = _action$data.isPreferNewestHistory, onSuccess = _action$data.onSuccess;
        _context.next = 3;
        return _sharedWorkerGetIdAndPositionForBookOpen(bookId, isGonnaListen, isUseMLHistory, isUseDefaultHistory, isUseLocalHistory, isFetchNewestHistory, isPreferNewestHistory);

      case 3:
        result = _context.sent;

        if (onSuccess) {
          onSuccess(result);
        }

      case 5:
      case "end":
        return _context.stop();
    }
  }, saga_library_saga_marked);
}

function watchRaceGetIdAndPositionToOpenBook() {
  var action;
  return saga_library_saga_regeneratorRuntime().wrap(function watchRaceGetIdAndPositionToOpenBook$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        if (false) {}

        _context2.next = 3;
        return io_c3792963_take(actions/* libraryActionsConstants.GET_ID_AND_POSITION_TO_OPEN_BOOK */.hb.GET_ID_AND_POSITION_TO_OPEN_BOOK);

      case 3:
        action = _context2.sent;
        _context2.next = 6;
        return io_c3792963_race({
          task: io_c3792963_call(getIdAndPositionToBookOpen, action),
          cancel: io_c3792963_take(actions/* libraryActionsConstants.CANCEL_GET_ID_AND_POSITION_TO_OPEN_BOOK */.hb.CANCEL_GET_ID_AND_POSITION_TO_OPEN_BOOK)
        });

      case 6:
        _context2.next = 0;
        break;

      case 8:
      case "end":
        return _context2.stop();
    }
  }, saga_library_saga_marked2);
}

function library_saga_settingsSaga() {
  return saga_library_saga_regeneratorRuntime().wrap(function settingsSaga$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return io_c3792963_all([takeLatest$1(actions/* libraryActionsConstants.ACTION_SAVE_READ */.hb.ACTION_SAVE_READ, _sharedWorkerSaveReadHistory), takeLatest$1(actions/* libraryActionsConstants.ACTION_SAVE_ALL */.hb.ACTION_SAVE_ALL, _sharedWorkerSaveAllHistory), takeLeading$1(actions/* libraryActionsConstants.ACTION_SAVE_LISTEN */.hb.ACTION_SAVE_LISTEN, _sharedWorkerSaveListenHistory), takeEvery$1(actions/* libraryActionsConstants.FETCH_ALL_BOOKS_DATA */.hb.FETCH_ALL_BOOKS_DATA, _sharedWorkerFetchAllHistory), takeEvery$1(actions/* libraryActionsConstants.TOGGLE_BOOK_IN_ML_BY_ID */.hb.TOGGLE_BOOK_IN_ML_BY_ID, _sharedWorkerToggleBookInMLById), takeEvery$1(actions/* libraryActionsConstants.SET_LIBRARY_LANGUAGES */.hb.SET_LIBRARY_LANGUAGES, _sharedWorkerSetLibraryLanguages), io_c3792963_fork(watchRaceGetIdAndPositionToOpenBook)]);

      case 2:
      case "end":
        return _context3.stop();
    }
  }, saga_library_saga_marked3);
}
;// CONCATENATED MODULE: ./src/next/store/saga/player.saga.js
function player_saga_typeof(obj) { "@babel/helpers - typeof"; return player_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, player_saga_typeof(obj); }

function player_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ player_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == player_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var player_saga_marked = /*#__PURE__*/player_saga_regeneratorRuntime().mark(fetchWaveformsDictionary),
    player_saga_marked2 = /*#__PURE__*/player_saga_regeneratorRuntime().mark(playerSaga);





function fetchWaveformsDictionary(action) {
  var _action$data, url, chapterId;

  return player_saga_regeneratorRuntime().wrap(function fetchWaveformsDictionary$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _action$data = action.data, url = _action$data.url, chapterId = _action$data.chapterId;
        _context.next = 3;
        return fetchAndStoreWaveformsDictionary(url, chapterId);

      case 3:
      case "end":
        return _context.stop();
    }
  }, player_saga_marked);
}

function playerSaga() {
  return player_saga_regeneratorRuntime().wrap(function playerSaga$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return io_c3792963_all([takeEvery$1(actions/* playerActionConstants.FETCH_WAVE_FORMS_DICTIONARY */.L4.FETCH_WAVE_FORMS_DICTIONARY, fetchWaveformsDictionary)]);

      case 2:
      case "end":
        return _context2.stop();
    }
  }, player_saga_marked2);
}
// EXTERNAL MODULE: ./src/next/store/actions/toc.actions.js
var actions_toc_actions = __webpack_require__(4164);
;// CONCATENATED MODULE: ./src/next/store/saga/toc.js
function toc_typeof(obj) { "@babel/helpers - typeof"; return toc_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, toc_typeof(obj); }

function toc_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ toc_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == toc_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var toc_marked = /*#__PURE__*/toc_regeneratorRuntime().mark(tocSaga);




function tocSaga() {
  return toc_regeneratorRuntime().wrap(function tocSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return io_c3792963_all([takeEvery$1(actions_toc_actions/* tocActionsConstants.FETCH */.J.FETCH, _sharedWorkerFetchToc)]);

      case 2:
      case "end":
        return _context.stop();
    }
  }, toc_marked);
}
// EXTERNAL MODULE: ../main/src/redux/system/system.actions.js
var system_system_actions = __webpack_require__(42693);
// EXTERNAL MODULE: ../shared/store/featuredSearch/actions.js
var store_featuredSearch_actions = __webpack_require__(67775);
// EXTERNAL MODULE: ../shared/store/featuredSearch/constants.js
var featuredSearch_constants = __webpack_require__(85533);
;// CONCATENATED MODULE: ../shared/store/featuredSearch/saga.js
function featuredSearch_saga_typeof(obj) { "@babel/helpers - typeof"; return featuredSearch_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, featuredSearch_saga_typeof(obj); }

function featuredSearch_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ featuredSearch_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == featuredSearch_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var featuredSearch_saga_marked = /*#__PURE__*/featuredSearch_saga_regeneratorRuntime().mark(_handlerFetchFeaturedSearch),
    featuredSearch_saga_marked2 = /*#__PURE__*/featuredSearch_saga_regeneratorRuntime().mark(_sharedWorkerFetchFeaturedByQuery),
    featuredSearch_saga_marked3 = /*#__PURE__*/featuredSearch_saga_regeneratorRuntime().mark(_sharedWorkerFetchFeaturedByParaId),
    featuredSearch_saga_marked4 = /*#__PURE__*/featuredSearch_saga_regeneratorRuntime().mark(_sharedSagaFeaturedSearch);








function _handlerFetchFeaturedSearch(fetchFn, params, onSuccess) {
  var isLoaderWasEnabled, data;
  return featuredSearch_saga_regeneratorRuntime().wrap(function _handlerFetchFeaturedSearch$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        isLoaderWasEnabled = false;
        _context.prev = 1;
        _context.next = 4;
        return put(system_system_actions/* systemActions.loading */.n.loading(featuredSearch_constants/* LOADER_ID_FEATURED_SEARCH_SECTIONS */.v));

      case 4:
        isLoaderWasEnabled = true;
        _context.next = 7;
        return io_c3792963_call(fetchFn);

      case 7:
        data = _context.sent;
        _context.next = 10;
        return put(store_featuredSearch_actions/* _sharedActionsFeaturedSearch.fetchSuccess */.G.fetchSuccess(data, params));

      case 10:
        if (onSuccess) {
          onSuccess(data);
        }

        _context.next = 16;
        break;

      case 13:
        _context.prev = 13;
        _context.t0 = _context["catch"](1);
        // eslint-disable-next-line no-console
        console.log("%c[Featured Search] Error: ", "background: red; color: white;", _context.t0);

      case 16:
        _context.prev = 16;

        if (!isLoaderWasEnabled) {
          _context.next = 20;
          break;
        }

        _context.next = 20;
        return put(system_system_actions/* systemActions.loading */.n.loading(featuredSearch_constants/* LOADER_ID_FEATURED_SEARCH_SECTIONS */.v, true));

      case 20:
        return _context.finish(16);

      case 21:
      case "end":
        return _context.stop();
    }
  }, featuredSearch_saga_marked, null, [[1, 13, 16, 21]]);
}

function _sharedWorkerFetchFeaturedByQuery(action) {
  var _action$data, query, langs, fetchFn;

  return featuredSearch_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchFeaturedByQuery$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _action$data = action.data, query = _action$data.query, langs = _action$data.langs;

        if (query) {
          _context2.next = 3;
          break;
        }

        return _context2.abrupt("return");

      case 3:
        fetchFn = function fetchFn() {
          return fetchFeaturedSearchRequest(query, langs);
        };

        _context2.next = 6;
        return io_c3792963_call(_handlerFetchFeaturedSearch, fetchFn, {
          query: query,
          langs: langs
        });

      case 6:
      case "end":
        return _context2.stop();
    }
  }, featuredSearch_saga_marked2);
}

function _sharedWorkerFetchFeaturedByParaId(action) {
  var _action$data2, paraId, onSuccess, fetchFn;

  return featuredSearch_saga_regeneratorRuntime().wrap(function _sharedWorkerFetchFeaturedByParaId$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _action$data2 = action.data, paraId = _action$data2.paraId, onSuccess = _action$data2.onSuccess;

        fetchFn = function fetchFn() {
          return fetchFeaturedForParagraph(paraId);
        };

        _context3.next = 4;
        return io_c3792963_call(_handlerFetchFeaturedSearch, fetchFn, {
          paraId: paraId
        }, onSuccess);

      case 4:
      case "end":
        return _context3.stop();
    }
  }, featuredSearch_saga_marked3);
}

function _sharedSagaFeaturedSearch() {
  return featuredSearch_saga_regeneratorRuntime().wrap(function _sharedSagaFeaturedSearch$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        _context4.next = 2;
        return io_c3792963_all([takeLatest$1(store_featuredSearch_actions/* _sharedActionsConstantsFeaturedSearch.FETCH_BY_QUERY */.c.FETCH_BY_QUERY, _sharedWorkerFetchFeaturedByQuery), takeLatest$1(store_featuredSearch_actions/* _sharedActionsConstantsFeaturedSearch.FETCH_FOR_PARAGRAPH */.c.FETCH_FOR_PARAGRAPH, _sharedWorkerFetchFeaturedByParaId)]);

      case 2:
      case "end":
        return _context4.stop();
    }
  }, featuredSearch_saga_marked4);
}
;
;// CONCATENATED MODULE: ./src/next/store/saga/index.js
function store_saga_typeof(obj) { "@babel/helpers - typeof"; return store_saga_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, store_saga_typeof(obj); }

function store_saga_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ store_saga_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == store_saga_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var store_saga_marked = /*#__PURE__*/store_saga_regeneratorRuntime().mark(rootSaga);















function rootSaga() {
  return store_saga_regeneratorRuntime().wrap(function rootSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return io_c3792963_all([io_c3792963_fork(searchSaga), io_c3792963_fork(relevantSearch), io_c3792963_fork(systemSaga), io_c3792963_fork(mainTree_saga_systemSaga), io_c3792963_fork(settingsSaga), io_c3792963_fork(shopSaga), io_c3792963_fork(contentSaga), io_c3792963_fork(paragraphsReducer_saga_systemSaga), io_c3792963_fork(_sharedSagaFeaturedSearch), io_c3792963_fork(swSaga), io_c3792963_fork(library_saga_settingsSaga), io_c3792963_fork(playerSaga), io_c3792963_fork(tocSaga)]);

      case 2:
      case "end":
        return _context.stop();
    }
  }, store_saga_marked);
}
;// CONCATENATED MODULE: ../shared/store/settings/reducer.js
function reducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function reducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? reducer_ownKeys(Object(source), !0).forEach(function (key) { reducer_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : reducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function reducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var _sharedStateSettings = {
  geoIpData: {}
};
var _sharedReducerSettings = function _sharedReducerSettings(state, action) {
  switch (action.type) {
    case settings_actions/* _sharedActionsConstantsSettings.UPDATE_SETTING_SUCCESS */.u.UPDATE_SETTING_SUCCESS:
      {
        return reducer_objectSpread(reducer_objectSpread({}, state), action.data);
      }

    case settings_actions/* _sharedActionsConstantsSettings.FETCH_GEO_IP_DATA_SUCCESS */.u.FETCH_GEO_IP_DATA_SUCCESS:
      {
        return reducer_objectSpread(reducer_objectSpread({}, state), {}, {
          geoIpData: action.data
        });
      }

    default:
      return state;
  }
};
// EXTERNAL MODULE: ./src/next/utils/settings/settings.js + 1 modules
var settings_settings = __webpack_require__(91241);
;// CONCATENATED MODULE: ./src/next/store/reducers/settings.js
function settings_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function settings_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? settings_ownKeys(Object(source), !0).forEach(function (key) { settings_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : settings_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function settings_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var methodGetSettingsInitial = "window" in __webpack_require__.g ? settings_settings/* getStoredSettingsNextApp */.qp : settings_settings/* getDefaultSettingsNextApp */.zv;
var initialState = settings_objectSpread(settings_objectSpread({}, _sharedStateSettings), methodGetSettingsInitial());

var settingsReducer = function settingsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actions/* systemActionsConstants.SET_IS_LOGIN */.My.SET_IS_LOGIN:
      {
        if (action.data || action.isFetchInitLoad) {
          return state;
        }

        var storedSettings = (0,settings_settings/* getStoredSettingsNextApp */.qp)();

        var newInitState = settings_objectSpread(settings_objectSpread({}, initialState), storedSettings);

        var settingsKeys = Object.keys(settings_constants/* SETTING */.Fy);
        settingsKeys.forEach(function (settingName) {
          var saveOnLogout = settings_constants/* SETTING */.Fy[settingName].saveOnLogout;

          if (Object.hasOwnProperty.call(initialState, settingName) && saveOnLogout) {
            newInitState[settingName] = state[settingName];
          }
        });
        return newInitState;
      }

    default:
      return _sharedReducerSettings(state, action);
  }
};

/* harmony default export */ var reducers_settings = (settingsReducer);
;// CONCATENATED MODULE: ../shared/store/search/reducer.js
function search_reducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function search_reducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? search_reducer_ownKeys(Object(source), !0).forEach(function (key) { search_reducer_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : search_reducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function search_reducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var initSearchFilter = {
  searchedQuery: undefined,
  translate: [],
  detect: [],
  autocomplete: [],
  suggestions: [],
  corrections: [],
  shortcuts: [],
  synonyms: []
};
var _sharedStateSearch = {
  shortcuts: {},
  searchFilter: initSearchFilter,
  searchQueryLangs: {},
  searchQueryLangsCache: {},
  queryCorrectionsCache: {}
};
var _sharedReducerSearch = function _sharedReducerSearch(state, action) {
  switch (action.type) {
    case search_actions/* _sharedActionsConstantsSearch.FETCH_SHORTCUT_SUCCESS */.k.FETCH_SHORTCUT_SUCCESS:
      return search_reducer_objectSpread(search_reducer_objectSpread({}, state), {}, {
        shortcuts: action.data
      });

    case search_actions/* _sharedActionsConstantsSearch.FETCH_DETECT_SUCCESS */.k.FETCH_DETECT_SUCCESS:
      {
        var detect = action.data.detect;

        var newSearchFilter = search_reducer_objectSpread({}, state.searchFilter);

        newSearchFilter.detect = detect || [];
        return search_reducer_objectSpread(search_reducer_objectSpread({}, state), {}, {
          searchFilter: newSearchFilter
        });
      }

    case search_actions/* _sharedActionsConstantsSearch.FETCH_LANGS_FOR_WORD_SUCCESS */.k.FETCH_LANGS_FOR_WORD_SUCCESS:
      {
        var _action$data2 = action.data,
            langs = _action$data2.langs,
            query = _action$data2.query,
            correction = _action$data2.correction;

        var searchQueryLangsCache = search_reducer_objectSpread({}, state.searchQueryLangsCache);

        searchQueryLangsCache[query] = langs;

        var newQueryCorrections = search_reducer_objectSpread({}, state.queryCorrectionsCache);

        if (correction) {
          newQueryCorrections[query] = correction;
        }

        return search_reducer_objectSpread(search_reducer_objectSpread({}, state), {}, {
          searchQueryLangs: langs,
          searchQueryLangsCache: searchQueryLangsCache,
          queryCorrectionsCache: newQueryCorrections
        });
      }

    case search_actions/* _sharedActionsConstantsSearch.FETCH_SUGGESTION_SUCCESS */.k.FETCH_SUGGESTION_SUCCESS:
      {
        var searchedQuery, suggestions, corrections, shortcuts, synonyms, autocomplete;

        if (action.data) {
          searchedQuery = action.data.searchedQuery;
          suggestions = action.data.suggestions;
          corrections = action.data.corrections;
          shortcuts = action.data.shortcuts;
          synonyms = action.data.synonyms;
          autocomplete = action.data.autocomplete;
        }

        var searchFilterNew = search_reducer_objectSpread({}, state.searchFilter);

        if (!searchedQuery) {
          searchFilterNew.detect = initSearchFilter.detect;
          searchFilterNew.translate = initSearchFilter.translate;
        }

        searchFilterNew.searchedQuery = searchedQuery || "";
        searchFilterNew.suggestions = suggestions || initSearchFilter.suggestions;
        searchFilterNew.corrections = corrections || initSearchFilter.corrections;
        searchFilterNew.shortcuts = shortcuts || initSearchFilter.shortcuts;
        searchFilterNew.synonyms = synonyms || initSearchFilter.synonyms;
        searchFilterNew.autocomplete = autocomplete || initSearchFilter.autocomplete;
        return search_reducer_objectSpread(search_reducer_objectSpread({}, state), {}, {
          searchFilter: searchFilterNew
        });
      }

    default:
      return state;
  }
};
// EXTERNAL MODULE: ./src/next/utils/search.js
var search = __webpack_require__(95655);
;// CONCATENATED MODULE: ./src/next/store/reducers/search.js
var _searchParams;

function search_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function search_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? search_ownKeys(Object(source), !0).forEach(function (key) { search_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : search_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function search_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var search_initialState = search_objectSpread({
  isShownMarks: true,
  currentItemIndex: -1,
  search: {
    total: 0,
    results: [],
    languageFacets: {}
  },
  searchParams: (_searchParams = {}, search_defineProperty(_searchParams, search/* SEARCH_PARAM_QUERY_NAME */.t, ""), search_defineProperty(_searchParams, "folders", []), search_defineProperty(_searchParams, "context", ""), search_defineProperty(_searchParams, "extras", {
    type: "basic",
    snippet: "long",
    period: search_constants/* Period.both */.pH.both
  }), _searchParams),
  searchDictionary: []
}, _sharedStateSearch);

var searchReducer = function searchReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : search_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actions/* searchActionConstants.SEARCH_SUCCESS */.cT.SEARCH_SUCCESS:
      return search_objectSpread(search_objectSpread({}, state), action.data);

    case actions/* searchActionConstants.SEARCH_CLEAR */.cT.SEARCH_CLEAR:
      return search_objectSpread(search_objectSpread({}, state), {}, {
        searchParams: search_objectSpread(search_objectSpread({}, state.searchParams), {}, search_defineProperty({}, search/* SEARCH_PARAM_QUERY_NAME */.t, "")),
        search: {
          total: 0,
          results: [],
          languageFacets: {}
        }
      });

    case actions/* searchActionConstants.RESET */.cT.RESET:
      return search_objectSpread(search_objectSpread({}, state), {}, {
        searchParams: search_initialState.searchParams,
        search: search_initialState.search
      });

    case actions/* searchActionConstants.ACTION_SEARCH_PARAMS_UPDATE */.cT.ACTION_SEARCH_PARAMS_UPDATE:
      return search_objectSpread(search_objectSpread({}, state), {}, {
        searchParams: search_objectSpread({}, (0,SearchWidget_utils/* formatSearchParams */.VL)(action.data))
      });

    case actions/* searchActionConstants.ACTION_SEARCH_CURRENT_ITEM_UPDATE */.cT.ACTION_SEARCH_CURRENT_ITEM_UPDATE:
      return search_objectSpread(search_objectSpread({}, state), {}, {
        currentItemIndex: action.data
      });

    case actions/* searchActionConstants.SEARCH_TOGGLE_MARKS */.cT.SEARCH_TOGGLE_MARKS:
      return search_objectSpread(search_objectSpread({}, state), {}, {
        isShownMarks: !state.isShownMarks
      });

    case actions/* searchActionConstants.FETCH_SEARCH_DICTIONARY_SUCCESS */.cT.FETCH_SEARCH_DICTIONARY_SUCCESS:
      {
        return search_objectSpread(search_objectSpread({}, state), {}, {
          searchParamsDictionary: action.data.params,
          searchDictionary: action.data.results
        });
      }

    default:
      return _sharedReducerSearch(state, action);
  }
};

/* harmony default export */ var reducers_search = (searchReducer);
;// CONCATENATED MODULE: ../shared/store/player/reducer.js
function player_reducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function player_reducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? player_reducer_ownKeys(Object(source), !0).forEach(function (key) { player_reducer_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : player_reducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function player_reducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var _sharedStatePlayer = {
  waveformsDictionary: {},
  isSmallPlayerVisible: false,
  brokenAudios: []
};
var _sharedReducerPlayer = function _sharedReducerPlayer(state, action) {
  switch (action.type) {
    case player_actions/* _sharedActionsConstantsPlayer.PUT_AUDIO_WAVE */.c.PUT_AUDIO_WAVE:
      {
        var _action$data2 = action.data,
            waveform = _action$data2.waveform,
            paragraphsAudioPositions = _action$data2.paragraphsAudioPositions,
            chapterId = _action$data2.chapterId;

        if (!waveform && !paragraphsAudioPositions) {
          return state;
        }

        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          waveformsDictionary: player_reducer_objectSpread(player_reducer_objectSpread({}, state.waveformsDictionary), {}, player_reducer_defineProperty({}, chapterId, {
            waveform: waveform,
            paragraphsAudioPositions: paragraphsAudioPositions
          }))
        });
      }

    case player_actions/* _sharedActionsConstantsPlayer.SET_BROKEN_AUDIOS */.c.SET_BROKEN_AUDIOS:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          brokenAudios: action.data
        });
      }

    case player_actions/* _sharedActionsConstantsPlayer.SET_IS_SMALL_PLAYER_VISIBLE */.c.SET_IS_SMALL_PLAYER_VISIBLE:
      {
        return player_reducer_objectSpread(player_reducer_objectSpread({}, state), {}, {
          isSmallPlayerVisible: action.data
        });
      }

    default:
      return state;
  }
};
;// CONCATENATED MODULE: ./src/next/store/reducers/player.js

var player_initialState = _sharedStatePlayer;

var playerReducer = function playerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : player_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    default:
      return _sharedReducerPlayer(state, action);
  }
};

/* harmony default export */ var reducers_player = (playerReducer);
;// CONCATENATED MODULE: ../shared/store/system/reducer.js
var _isOnLine;

function reducer_toConsumableArray(arr) { return reducer_arrayWithoutHoles(arr) || reducer_iterableToArray(arr) || reducer_unsupportedIterableToArray(arr) || reducer_nonIterableSpread(); }

function reducer_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function reducer_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return reducer_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return reducer_arrayLikeToArray(o, minLen); }

function reducer_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function reducer_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return reducer_arrayLikeToArray(arr); }

function reducer_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function system_reducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function system_reducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? system_reducer_ownKeys(Object(source), !0).forEach(function (key) { system_reducer_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : system_reducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function system_reducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var _sharedStateSystem = {
  isLogin: false,
  isTopPanelVisible: true,
  loaders: [],
  messages: [],
  onLine: (_isOnLine = (0,user_agent/* isOnLine */.Mc)()) !== null && _isOnLine !== void 0 ? _isOnLine : false,
  dataAcquisitionStatus: undefined,
  userInfo: null,
  avatarLastUpdateTimestamp: Date.now()
};
var _sharedReducerSystem = function _sharedReducerSystem(state, action) {
  switch (action.type) {
    case system_actions/* _sharedActionsConstantsSystem.UPDATE_DATA_ACQUISITION_STATUS */.v.UPDATE_DATA_ACQUISITION_STATUS:
      {
        return system_reducer_objectSpread(system_reducer_objectSpread({}, state), {}, {
          dataAcquisitionStatus: action.data
        });
      }

    case system_actions/* _sharedActionsConstantsSystem.LOADING */.v.LOADING:
      {
        var _action$data2 = action.data,
            loadingId = _action$data2.loadingId,
            forceRemove = _action$data2.forceRemove,
            forceAdd = _action$data2.forceAdd;

        var loaders = reducer_toConsumableArray(state.loaders);

        var index = loaders.findIndex(function (item) {
          return item === loadingId;
        });

        if (forceAdd) {
          if (index === -1) {
            loaders.push(loadingId);
          }
        } else if (forceRemove) {
          if (index !== -1) {
            loaders.splice(index, 1);
          }
        } else if (index === -1) {
          loaders.push(loadingId);
        } else {
          loaders.splice(index, 1);
        }

        return system_reducer_objectSpread(system_reducer_objectSpread({}, state), {}, {
          loaders: loaders
        });
      }

    case system_actions/* _sharedActionsConstantsSystem.TOAST */.v.TOAST:
      return system_reducer_objectSpread(system_reducer_objectSpread({}, state), {}, {
        messages: [action.data].concat(reducer_toConsumableArray(state.messages))
      });

    case system_actions/* _sharedActionsConstantsSystem.TOAST_SUCCESS */.v.TOAST_SUCCESS:
      return system_reducer_objectSpread(system_reducer_objectSpread({}, state), {}, {
        messages: state.messages.filter(function (m) {
          return m !== action.data;
        })
      });

    case system_actions/* _sharedActionsConstantsSystem.SET_IS_ONLINE */.v.SET_IS_ONLINE:
      return system_reducer_objectSpread(system_reducer_objectSpread({}, state), {}, {
        onLine: action.data
      });

    case system_actions/* _sharedActionsConstantsSystem.SET_IS_LOGIN */.v.SET_IS_LOGIN:
      {
        return system_reducer_objectSpread(system_reducer_objectSpread({}, state), {}, {
          isLogin: action.data
        });
      }

    case system_actions/* _sharedActionsConstantsSystem.SET_USER_INFO */.v.SET_USER_INFO:
      {
        return system_reducer_objectSpread(system_reducer_objectSpread({}, state), {}, {
          userInfo: action.data
        });
      }

    case system_actions/* _sharedActionsConstantsSystem.SET_AVATAR_LAST_UPDATE_TIMESTAMP */.v.SET_AVATAR_LAST_UPDATE_TIMESTAMP:
      {
        return system_reducer_objectSpread(system_reducer_objectSpread({}, state), {}, {
          avatarLastUpdateTimestamp: action.data
        });
      }

    case system_actions/* _sharedActionsConstantsSystem.SET_TOP_PANEL_VISIBILITY */.v.SET_TOP_PANEL_VISIBILITY:
      {
        return system_reducer_objectSpread(system_reducer_objectSpread({}, state), {}, {
          isTopPanelVisible: action.data
        });
      }

    default:
      return state;
  }
};
;// CONCATENATED MODULE: ./src/next/store/reducers/system.js
function system_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function system_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? system_ownKeys(Object(source), !0).forEach(function (key) { system_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : system_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function system_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var system_initialState = system_objectSpread(system_objectSpread({}, _sharedStateSystem), {}, {
  showSearchPanel: false,
  showAvailableLangPanel: false,
  isShowPanelBookContents: false,
  showAdvSearchPanel: false,
  showSideMenu: false
});

var systemReducer = function systemReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : system_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      data = action.data;

  switch (type) {
    case actions/* systemActionsConstants.SET_SHOW_SEARCH_PANEL */.My.SET_SHOW_SEARCH_PANEL:
      return system_objectSpread(system_objectSpread({}, state), {}, {
        showSearchPanel: action.data
      });

    case actions/* systemActionsConstants.SET_SHOW_PANEL_BOOK_TRANSLATIONS */.My.SET_SHOW_PANEL_BOOK_TRANSLATIONS:
      return system_objectSpread(system_objectSpread({}, state), {}, {
        showAvailableLangPanel: action.data
      });

    case actions/* systemActionsConstants.SET_SHOW_PANEL_BOOK_CONTENTS */.My.SET_SHOW_PANEL_BOOK_CONTENTS:
      return system_objectSpread(system_objectSpread({}, state), {}, {
        showAvailableLangPanel: false,
        isShowPanelBookContents: action.data
      });

    case actions/* systemActionsConstants.SET_SHOW_ADV_SEARCH_PANEL */.My.SET_SHOW_ADV_SEARCH_PANEL:
      return system_objectSpread(system_objectSpread({}, state), {}, {
        showAdvSearchPanel: action.data,
        showSearchPanel: false,
        showSideMenu: false
      });

    case actions/* systemActionsConstants.SET_SHOW_SIDE_MENU */.My.SET_SHOW_SIDE_MENU:
      return system_objectSpread(system_objectSpread({}, state), {}, {
        showSideMenu: data
      });

    case actions/* systemActionsConstants.ACTION_HIDE_ALL */.My.ACTION_HIDE_ALL:
      return system_objectSpread(system_objectSpread({}, state), {}, {
        showAdvSearchPanel: false,
        showSearchPanel: false,
        showAvailableLangPanel: false,
        showSideMenu: false
      });

    default:
      return _sharedReducerSystem(state, action);
  }
};

/* harmony default export */ var system = (systemReducer);
// EXTERNAL MODULE: ./src/next/store/actions/relevantSearch.actions.js
var relevantSearch_actions = __webpack_require__(17652);
;// CONCATENATED MODULE: ./src/next/store/reducers/relevantSearch.js
function relevantSearch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function relevantSearch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? relevantSearch_ownKeys(Object(source), !0).forEach(function (key) { relevantSearch_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : relevantSearch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function relevantSearch_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var relevantSearch_initialState = {
  scheme: [],
  relatedLangs: [],
  facets: [],
  currentLang: "",
  isBible: false
};

var relevantSearchReducer = function relevantSearchReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : relevantSearch_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case relevantSearch_actions/* relevantSearchActionConstants.ACTION_RELATED_TYPE */.U.ACTION_RELATED_TYPE:
      {
        var isBible = action.data.isBible;

        var newState = relevantSearch_objectSpread({}, state);

        newState.isBible = isBible;
        return newState;
      }

    case relevantSearch_actions/* relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_SCHEME_SUCCESS */.U.FETCH_RELEVANT_SEARCH_SCHEME_SUCCESS:
      {
        var _action$data2 = action.data,
            sections = _action$data2.sections,
            relatedLangs = _action$data2.relatedLangs;

        var _newState = relevantSearch_objectSpread({}, state);

        if (sections) {
          _newState.scheme = sections;
        }

        if (relatedLangs) {
          _newState.relatedLangs = relatedLangs;
        }

        return _newState;
      }

    case relevantSearch_actions/* relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_FACET_SUCCESS */.U.FETCH_RELEVANT_SEARCH_FACET_SUCCESS:
      {
        var _action$data4 = action.data,
            code = _action$data4.code,
            results = _action$data4.results;

        var _newState2 = relevantSearch_objectSpread({}, state);

        _newState2.facets[code] = results.facets; // newState.facets['time'] = Date.now() ;

        return _newState2;
      }

    case relevantSearch_actions/* relevantSearchActionConstants.FETCH_RELEVANT_SEARCH_FACET_AGGREGATE_SUCCESS */.U.FETCH_RELEVANT_SEARCH_FACET_AGGREGATE_SUCCESS:
      {
        var _action$data6 = action.data,
            _results = _action$data6.results,
            lang = _action$data6.lang;

        var _newState3 = relevantSearch_objectSpread({}, state);

        var newFacets = relevantSearch_objectSpread({}, state.facets);

        Object.keys(_results).forEach(function (code) {
          var result = _results[code];
          newFacets[code] = (result === null || result === void 0 ? void 0 : result.facets) || [];
        });
        _newState3.facets = newFacets;
        _newState3.currentLang = lang ? lang : "";
        return _newState3;
      }

    case relevantSearch_actions/* relevantSearchActionConstants.ACTION_CHANGE_RELATED_LANG */.U.ACTION_CHANGE_RELATED_LANG:
      {
        var _lang = action.data.lang;

        var _newState4 = relevantSearch_objectSpread({}, state);

        _newState4.currentLang = _lang ? _lang : "";
        return _newState4;
      }

    default:
      return state;
  }
};

/* harmony default export */ var reducers_relevantSearch = (relevantSearchReducer);
;// CONCATENATED MODULE: ../shared/store/mainTree/reducer.js
function mainTree_reducer_toConsumableArray(arr) { return mainTree_reducer_arrayWithoutHoles(arr) || mainTree_reducer_iterableToArray(arr) || mainTree_reducer_unsupportedIterableToArray(arr) || mainTree_reducer_nonIterableSpread(); }

function mainTree_reducer_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function mainTree_reducer_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return mainTree_reducer_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mainTree_reducer_arrayLikeToArray(o, minLen); }

function mainTree_reducer_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function mainTree_reducer_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return mainTree_reducer_arrayLikeToArray(arr); }

function mainTree_reducer_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function mainTree_reducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function mainTree_reducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? mainTree_reducer_ownKeys(Object(source), !0).forEach(function (key) { mainTree_reducer_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : mainTree_reducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function mainTree_reducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var _sharedStateMainTree = {
  books: [],
  idsBooksFetchFailed: [],
  mainTree: [],
  langMap: {},
  bibles: [],
  sgBooksMap: {},
  bookLangMap: {},
  dictionaries: [],
  periodicals: []
};
var _sharedReducerMainTree = function _sharedReducerMainTree(state, action) {
  switch (action.type) {
    case mainTree_actions/* _sharedActionsConstantsMainTree.SET_BOOKS */.t.SET_BOOKS:
      {
        return mainTree_reducer_objectSpread(mainTree_reducer_objectSpread({}, state), {}, {
          books: action.data
        });
      }

    case mainTree_actions/* _sharedActionsConstantsMainTree.ADD_ID_BOOK_FETCH_FAILED */.t.ADD_ID_BOOK_FETCH_FAILED:
      {
        var idsBooksFetchFailedNew = mainTree_reducer_toConsumableArray(state.idsBooksFetchFailed);

        idsBooksFetchFailedNew.push(action.data);
        return mainTree_reducer_objectSpread(mainTree_reducer_objectSpread({}, state), {}, {
          idsBooksFetchFailed: idsBooksFetchFailedNew
        });
      }

    case mainTree_actions/* _sharedActionsConstantsMainTree.PUSH_BOOKS */.t.PUSH_BOOKS:
      {
        if (!action.data) {
          console.log("%c\u26D4 Book is missing in action data", "background: black; color: white;");
          return;
        }

        var existingBookIds = state.books.map(content_content/* getBookIdWithPrefix */.NR);
        var payloadBooks = Array.isArray(action.data) ? action.data : [action.data];
        var newBooks = payloadBooks.filter(function (b) {
          return !existingBookIds.includes(b.id);
        });

        if (newBooks.length) {
          var booksNew = (0,CacheHolder/* storeBooks */.F6)(newBooks);

          if (booksNew) {
            return mainTree_reducer_objectSpread(mainTree_reducer_objectSpread({}, state), {}, {
              books: booksNew
            });
          }
        }

        return state;
      }

    case mainTree_actions/* _sharedActionsConstantsMainTree.FETCH_MAIN_TREE_SUCCESS */.t.FETCH_MAIN_TREE_SUCCESS:
      {
        var newState = mainTree_reducer_objectSpread({}, state);

        var mainTree = action.data;

        if (mainTree !== null && mainTree !== void 0 && mainTree.length) {
          var langMap = {};
          mainTree.forEach(function (item) {
            langMap[item.id] = item.label;
          });
          newState.langMap = langMap;
          newState.mainTree = mainTree;
        }

        return newState;
      }

    case mainTree_actions/* _sharedActionsConstantsMainTree.FETCH_FOLDERS_TO_ROOT_SUCCESS */.t.FETCH_FOLDERS_TO_ROOT_SUCCESS:
      {
        var _newState = mainTree_reducer_objectSpread({}, state);

        var _action$data2 = action.data,
            _mainTree = _action$data2.mainTree,
            options = _action$data2.options;

        if (_mainTree !== null && _mainTree !== void 0 && _mainTree.length) {
          var _langMap = {};

          _mainTree.forEach(function (item) {
            _langMap[item.id] = item.label;
          });

          _newState.langMap = _langMap;
          _newState.mainTree = _mainTree;
        }

        var bookLangMap = options.bookLangMap,
            bibles = options.bibles,
            dictionaries = options.dictionaries,
            books = options.books;

        if (bibles) {
          _newState.bibles = bibles;
        }

        if (dictionaries) {
          _newState.dictionaries = dictionaries;
        }

        if (books) {
          _newState.books = (0,CacheHolder/* storeBooks */.F6)(books) || [];
        }

        if (bookLangMap) {
          _newState.bookLangMap = mainTree_reducer_objectSpread(mainTree_reducer_objectSpread({}, _newState.bookLangMap), bookLangMap);
        }

        return _newState;
      }

    case mainTree_actions/* _sharedActionsConstantsMainTree.FETCH_BIBLES_SUCCESS */.t.FETCH_BIBLES_SUCCESS:
      return mainTree_reducer_objectSpread(mainTree_reducer_objectSpread({}, state), {}, {
        bibles: action.data
      });

    case mainTree_actions/* _sharedActionsConstantsMainTree.FETCH_DICTIONARIES_SUCCESS */.t.FETCH_DICTIONARIES_SUCCESS:
      return mainTree_reducer_objectSpread(mainTree_reducer_objectSpread({}, state), {}, {
        dictionaries: action.data
      });

    case mainTree_actions/* _sharedActionsConstantsMainTree.FETCH_SG_BOOKS_SUCCESS */.t.FETCH_SG_BOOKS_SUCCESS:
      {
        var sgBooks = action.data;
        var sgBooksMap = {};
        sgBooks.forEach(function (item) {
          var originalBookCode = item.code.replace(content_constants/* POSTFIX_BOOK_CODE_SG */.nM, "");
          sgBooksMap[originalBookCode] = item;
        });
        return mainTree_reducer_objectSpread(mainTree_reducer_objectSpread({}, state), {}, {
          sgBooksMap: sgBooksMap
        });
      }

    default:
      return state;
  }
};
;// CONCATENATED MODULE: ./src/next/store/reducers/mainTree.js

var mainTree_initialState = _sharedStateMainTree;

var mainTreeReducer = function mainTreeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mainTree_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    default:
      return _sharedReducerMainTree(state, action);
  }
};

/* harmony default export */ var mainTree = (mainTreeReducer);
;// CONCATENATED MODULE: ../shared/store/shop/reducer.js
function shop_reducer_toConsumableArray(arr) { return shop_reducer_arrayWithoutHoles(arr) || shop_reducer_iterableToArray(arr) || shop_reducer_unsupportedIterableToArray(arr) || shop_reducer_nonIterableSpread(); }

function shop_reducer_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function shop_reducer_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return shop_reducer_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return shop_reducer_arrayLikeToArray(o, minLen); }

function shop_reducer_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function shop_reducer_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return shop_reducer_arrayLikeToArray(arr); }

function shop_reducer_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function shop_reducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function shop_reducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? shop_reducer_ownKeys(Object(source), !0).forEach(function (key) { shop_reducer_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : shop_reducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function shop_reducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var _sharedStateShop = {
  pendingIds: new Set(),
  loadingPackages: false,
  isPackagesFetched: false,
  shopIds: [],
  shopBooks: {},
  packageIds: [],
  shopPackages: {},
  allShopBooks: []
};
var _sharedReducerShop = function _sharedReducerShop(state, action, initialState) {
  switch (action.type) {
    case shop_actions/* _sharedActionsConstantsShop.FETCH_ALL_SHOP_BOOKS_SUCCESS */.H.FETCH_ALL_SHOP_BOOKS_SUCCESS:
      {
        return shop_reducer_objectSpread(shop_reducer_objectSpread({}, state), {}, {
          allShopBooks: action.data
        });
      }

    case shop_actions/* _sharedActionsConstantsShop.FETCH_SHOP_BOOKS_SUCCESS */.H.FETCH_SHOP_BOOKS_SUCCESS:
      {
        var _action$data$books;

        var updatedPendingIds = new Set(state.pendingIds);

        var updatedShopIds = shop_reducer_toConsumableArray(state.shopIds);

        var updatedShopBooks = shop_reducer_objectSpread({}, state.shopBooks);

        action.data.bookIds.forEach(function (bookId) {
          updatedPendingIds.delete(bookId);
        });
        (_action$data$books = action.data.books) === null || _action$data$books === void 0 ? void 0 : _action$data$books.forEach(function (shopBook) {
          updatedShopIds.push(shopBook.book_id);
          updatedShopBooks[shopBook.book_id] = shopBook;
        });
        return shop_reducer_objectSpread(shop_reducer_objectSpread({}, state), {}, {
          pendingIds: updatedPendingIds,
          shopIds: shop_reducer_toConsumableArray(new Set(updatedShopIds)),
          shopBooks: updatedShopBooks
        });
      }

    case shop_actions/* _sharedActionsConstantsShop.FETCH_SHOP_BOOKS_PENDING */.H.FETCH_SHOP_BOOKS_PENDING:
      {
        var _updatedPendingIds = new Set(state.pendingIds);

        action.data.forEach(function (bookId) {
          return _updatedPendingIds.add(bookId);
        });
        return shop_reducer_objectSpread(shop_reducer_objectSpread({}, state), {}, {
          pendingIds: _updatedPendingIds
        });
      }

    case shop_actions/* _sharedActionsConstantsShop.FETCH_PACKAGES_PENDING */.H.FETCH_PACKAGES_PENDING:
      {
        return shop_reducer_objectSpread(shop_reducer_objectSpread({}, state), {}, {
          loadingPackages: true
        });
      }

    case shop_actions/* _sharedActionsConstantsShop.FETCH_PACKAGES_SUCCESS */.H.FETCH_PACKAGES_SUCCESS:
      {
        var updatedPackageIds = shop_reducer_toConsumableArray(state.packageIds);

        var updatedShopPackages = shop_reducer_objectSpread({}, state.shopPackages);

        action.data.forEach(function (shopPackage) {
          updatedPackageIds.push(shopPackage.id);
          updatedShopPackages[shopPackage.id] = shopPackage;
        });
        return shop_reducer_objectSpread(shop_reducer_objectSpread({}, state), {}, {
          shopPackages: updatedShopPackages,
          packageIds: updatedPackageIds,
          loadingPackages: false,
          isPackagesFetched: true
        });
      }

    case shop_actions/* _sharedActionsConstantsShop.SET_IS_PACKAGE_FETCHED */.H.SET_IS_PACKAGE_FETCHED:
      {
        return shop_reducer_objectSpread(shop_reducer_objectSpread({}, state), {}, {
          isPackagesFetched: action.data
        });
      }

    case shop_actions/* _sharedActionsConstantsShop.RESTORE_SHOP */.H.RESTORE_SHOP:
      {
        var _action$data2 = action.data,
            shopPackages = _action$data2.shopPackages,
            shopBooks = _action$data2.shopBooks;

        var _updatedPackageIds = shop_reducer_toConsumableArray(state.packageIds);

        var _updatedShopIds = shop_reducer_toConsumableArray(state.shopIds);

        var _updatedShopBooks = shop_reducer_objectSpread({}, state.shopBooks);

        var _updatedShopPackages = shop_reducer_objectSpread({}, state.shopPackages);

        shopPackages.forEach(function (shopPackage) {
          _updatedPackageIds.push(shopPackage.id);

          _updatedShopPackages[shopPackage.id] = shopPackage;
        });
        shopBooks.forEach(function (shopBook) {
          _updatedShopIds.push(shopBook.book_id);

          _updatedShopBooks[shopBook.book_id] = shopBook;
        });
        return shop_reducer_objectSpread(shop_reducer_objectSpread({}, state), {}, {
          shopIds: shop_reducer_toConsumableArray(new Set(_updatedShopIds)),
          shopBooks: _updatedShopBooks,
          shopPackages: _updatedShopPackages,
          packageIds: shop_reducer_toConsumableArray(new Set(_updatedPackageIds))
        });
      }

    case system_actions/* _sharedActionsConstantsSystem.SET_IS_LOGIN */.v.SET_IS_LOGIN:
    case shop_actions/* _sharedActionsConstantsShop.RESET_SHOP */.H.RESET_SHOP:
      {
        if (action.type === system_actions/* _sharedActionsConstantsSystem.SET_IS_LOGIN */.v.SET_IS_LOGIN && action.data === true) {
          return state;
        }

        return initialState;
      }

    default:
      return state;
  }
};
;// CONCATENATED MODULE: ./src/next/store/reducers/shop.js

var shop_initialState = _sharedStateShop;

var shopReducer = function shopReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shop_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    // Define App special cases here
    default:
      return _sharedReducerShop(state, action, shop_initialState);
  }
};

/* harmony default export */ var shop = (shopReducer);
;// CONCATENATED MODULE: ../shared/store/support/reducer.js
function support_reducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function support_reducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? support_reducer_ownKeys(Object(source), !0).forEach(function (key) { support_reducer_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : support_reducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function support_reducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var _sharedStateSupport = {
  mainGeneralQuestions: [],
  formSentStatus: shared_constants/* CFStatus.PENDING */.ZX.PENDING
};
var _sharedReducerSupport = function _sharedReducerSupport(state, action) {
  switch (action.type) {
    case support_actions/* _sharedActionsConstantsSupport.FETCH_CF_SUCCESS */.Z.FETCH_CF_SUCCESS:
      {
        return support_reducer_objectSpread(support_reducer_objectSpread({}, state), {}, {
          mainGeneralQuestions: action.data
        });
      }

    case support_actions/* _sharedActionsConstantsSupport.SEND_CF_STATUS */.Z.SEND_CF_STATUS:
      {
        return support_reducer_objectSpread(support_reducer_objectSpread({}, state), {}, {
          formSentStatus: action.data
        });
      }

    default:
      return state;
  }
};
/* harmony default export */ var reducer = (_sharedReducerSupport);
;// CONCATENATED MODULE: ./src/next/store/reducers/support.js
function support_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function support_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? support_ownKeys(Object(source), !0).forEach(function (key) { support_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : support_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function support_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var support_initialState = support_objectSpread({}, _sharedStateSupport);
/* harmony default export */ var support = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : support_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    default:
      return reducer(state, action);
  }
});
;// CONCATENATED MODULE: ../shared/store/paragraphs/reducer.js
function paragraphs_reducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function paragraphs_reducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? paragraphs_reducer_ownKeys(Object(source), !0).forEach(function (key) { paragraphs_reducer_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : paragraphs_reducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function paragraphs_reducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var _sharedStateParagraphs = {
  paragraphs: {},
  chaptersParas: {}
};
var _sharedReducerParagraphs = function _sharedReducerParagraphs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _sharedStateParagraphs;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case paragraphs_actions/* _sharedActionsConstantsParagraphs.FETCH_PARAGRAPHS_SUCCESS */.X.FETCH_PARAGRAPHS_SUCCESS:
      return paragraphs_reducer_objectSpread(paragraphs_reducer_objectSpread({}, state), {}, {
        paragraphs: paragraphs_reducer_objectSpread(paragraphs_reducer_objectSpread({}, state.paragraphs), {}, paragraphs_reducer_defineProperty({}, action.data.nBookId, action.data.parasObj))
      });

    case paragraphs_actions/* _sharedActionsConstantsParagraphs.FETCH_CHAPTER_PARAS_SUCCESS */.X.FETCH_CHAPTER_PARAS_SUCCESS:
      {
        var _state$chaptersParas$;

        var _action$data2 = action.data,
            chapterId = _action$data2.chapterId,
            paras = _action$data2.paras,
            highlight = _action$data2.highlight;
        var bookIdOrigin = (0,content_content/* getBookIdNumber */.o8)(chapterId);
        var chapterNumber = chapterId.split(".")[1];
        var chapterParasCurrent = (_state$chaptersParas$ = state.chaptersParas[bookIdOrigin]) === null || _state$chaptersParas$ === void 0 ? void 0 : _state$chaptersParas$[chapterNumber];

        if (chapterParasCurrent && chapterParasCurrent.highlight === highlight) {
          return state;
        }

        var bookChaptersParasNew = state.chaptersParas[bookIdOrigin] ? paragraphs_reducer_objectSpread(paragraphs_reducer_objectSpread({}, state.chaptersParas[bookIdOrigin]), {}, paragraphs_reducer_defineProperty({}, chapterNumber, {
          paras: paras,
          highlight: highlight
        })) : paragraphs_reducer_defineProperty({}, chapterNumber, {
          paras: paras,
          highlight: highlight
        });
        return paragraphs_reducer_objectSpread(paragraphs_reducer_objectSpread({}, state), {}, {
          chaptersParas: paragraphs_reducer_objectSpread(paragraphs_reducer_objectSpread({}, state.chaptersParas), {}, paragraphs_reducer_defineProperty({}, bookIdOrigin, bookChaptersParasNew))
        });
      }

    case paragraphs_actions/* _sharedActionsConstantsParagraphs.FETCH_CHAPTERS_PARAS_SUCCESS */.X.FETCH_CHAPTERS_PARAS_SUCCESS:
      {
        var _action$data4 = action.data,
            _bookIdOrigin = _action$data4.bookIdOrigin,
            mapChapterNumberToParas = _action$data4.mapChapterNumberToParas;
        var bookChaptersParasCurrent = state.chaptersParas[_bookIdOrigin];

        if (!bookChaptersParasCurrent) {
          return paragraphs_reducer_objectSpread(paragraphs_reducer_objectSpread({}, state), {}, {
            chaptersParas: paragraphs_reducer_objectSpread(paragraphs_reducer_objectSpread({}, state.chaptersParas), {}, paragraphs_reducer_defineProperty({}, _bookIdOrigin, mapChapterNumberToParas))
          });
        }

        var bookChaptersParasNumbersCurrent = Object.keys(bookChaptersParasCurrent);
        var chaptersParasNumbers = Object.keys(mapChapterNumberToParas);

        if (chaptersParasNumbers.some(function (i) {
          return !bookChaptersParasNumbersCurrent.includes(i);
        })) {
          return paragraphs_reducer_objectSpread(paragraphs_reducer_objectSpread({}, state), {}, {
            chaptersParas: paragraphs_reducer_objectSpread(paragraphs_reducer_objectSpread({}, state.chaptersParas), {}, paragraphs_reducer_defineProperty({}, _bookIdOrigin, mapChapterNumberToParas))
          });
        }

        return state;
      }

    case paragraphs_actions/* _sharedActionsConstantsParagraphs.CLEAR_BOOK_PARAS */.X.CLEAR_BOOK_PARAS:
      {
        var paragraphsNew;

        if (action.data) {
          paragraphsNew = paragraphs_reducer_objectSpread({}, state.paragraphs);
          delete paragraphsNew[action.data];
        } else {
          paragraphsNew = {};
        }

        return paragraphs_reducer_objectSpread(paragraphs_reducer_objectSpread({}, state), {}, {
          paragraphs: paragraphsNew
        });
      }

    default:
      return state;
  }
};
// EXTERNAL MODULE: ./src/next/store/actions/system.actions.js
var actions_system_actions = __webpack_require__(63436);
;// CONCATENATED MODULE: ./src/next/store/reducers/paragraphsReducer.js


var paragraphsReducer_initialState = _sharedStateParagraphs;

var paragraphsReducer = function paragraphsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : paragraphsReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actions_system_actions/* systemActionsConstants.SET_IS_LOGIN */.M.SET_IS_LOGIN:
      {
        if (action.data === true) {
          return state;
        }

        return paragraphsReducer_initialState;
      }

    default:
      return _sharedReducerParagraphs(state, action);
  }
};

/* harmony default export */ var reducers_paragraphsReducer = (paragraphsReducer);
// EXTERNAL MODULE: ../shared/store/sw/reducer.js
var sw_reducer = __webpack_require__(69884);
;// CONCATENATED MODULE: ./src/next/store/reducers/sw.reducer.js

var sw_reducer_initialState = sw_reducer/* _sharedStateSW */.Q;

var sw_reducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sw_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return (0,sw_reducer/* _sharedReducerSW */.d)(state, action);
};

/* harmony default export */ var reducers_sw_reducer = (sw_reducer_reducer);
;// CONCATENATED MODULE: ../shared/store/toc/reducer.js
function toc_reducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function toc_reducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? toc_reducer_ownKeys(Object(source), !0).forEach(function (key) { toc_reducer_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : toc_reducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function toc_reducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var _sharedStateToc = {
  items: {}
};
var _sharedReducerToc = function _sharedReducerToc(state, action) {
  switch (action.type) {
    case toc_actions/* _sharedActionsConstantsToc.SET_ITEM */.g.SET_ITEM:
      if (state.items[action.data.bookIdOrigin]) {
        return state;
      }

      return toc_reducer_objectSpread(toc_reducer_objectSpread({}, state), {}, {
        items: toc_reducer_objectSpread(toc_reducer_objectSpread({}, state.items), {}, toc_reducer_defineProperty({}, action.data.bookIdOrigin, action.data.toc))
      });

    default:
      return state;
  }
};
;// CONCATENATED MODULE: ./src/next/store/reducers/toc.js

var toc_initialState = _sharedStateToc;

var tocReducer = function tocReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : toc_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    default:
      return _sharedReducerToc(state, action);
  }
};

/* harmony default export */ var toc = (tocReducer);
;// CONCATENATED MODULE: ../shared/store/library/reducer.js
function library_reducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function library_reducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? library_reducer_ownKeys(Object(source), !0).forEach(function (key) { library_reducer_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : library_reducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function library_reducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var _sharedStateLibrary = {
  allHistory: [],
  allHistoryUserId: null
};
var _sharedReducerLibrary = function _sharedReducerLibrary(state, action) {
  switch (action.type) {
    case system_actions/* _sharedActionsConstantsSystem.SET_IS_LOGIN */.v.SET_IS_LOGIN:
      {
        // doubtful, probably need to remove history items on login to another account,
        // but before
        // need to split all history object to [ML | Basic | Local] separated history objects.
        if (action.data === true) {
          return state;
        }

        return library_reducer_objectSpread(library_reducer_objectSpread({}, state), _sharedStateLibrary);
      }

    case library_actions/* _sharedActionsConstantsLibrary.UPDATE_ALL_HISTORY */.G.UPDATE_ALL_HISTORY:
      return library_reducer_objectSpread(library_reducer_objectSpread({}, state), {}, {
        allHistoryUserId: action.data.userId,
        allHistory: action.data.payload || []
      });

    default:
      return state;
  }
};
;// CONCATENATED MODULE: ./src/next/store/reducers/library.js
function library_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function library_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? library_ownKeys(Object(source), !0).forEach(function (key) { library_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : library_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function library_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var library_initialState = library_objectSpread(library_objectSpread({}, _sharedStateLibrary), {}, {
  a: "fd"
});

var libraryReducer = function libraryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : library_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type;

  switch (type) {
    default:
      return _sharedReducerLibrary(state, action);
  }
};

/* harmony default export */ var library = (libraryReducer);
;// CONCATENATED MODULE: ../shared/store/featuredSearch/reducer.js
function featuredSearch_reducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function featuredSearch_reducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? featuredSearch_reducer_ownKeys(Object(source), !0).forEach(function (key) { featuredSearch_reducer_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : featuredSearch_reducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function featuredSearch_reducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var reducer_initialState = {
  results: [],
  params: {
    query: "",
    langs: null,
    paraId: ""
  },
  section: ""
};

var reducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case store_featuredSearch_actions/* _sharedActionsConstantsFeaturedSearch.FETCH_SUCCESS */.c.FETCH_SUCCESS:
      {
        var stateNew = featuredSearch_reducer_objectSpread({}, state);

        stateNew.results = action.data.data;
        stateNew.params = action.data.params;
        return stateNew;
      }

    case store_featuredSearch_actions/* _sharedActionsConstantsFeaturedSearch.SET_SECTION */.c.SET_SECTION:
      {
        return featuredSearch_reducer_objectSpread(featuredSearch_reducer_objectSpread({}, state), {}, {
          section: action.data
        });
      }

    default:
      {
        return state;
      }
  }
};

/* harmony default export */ var featuredSearch_reducer = (reducer_reducer);
// EXTERNAL MODULE: ../shared/store/share/actions.js
var share_actions = __webpack_require__(88882);
;// CONCATENATED MODULE: ../shared/store/share/reducer.js
function share_reducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function share_reducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? share_reducer_ownKeys(Object(source), !0).forEach(function (key) { share_reducer_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : share_reducer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function share_reducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var _sharedStateShare = {
  shareData: null
};
var _sharedReducerShare = function _sharedReducerShare(state, action) {
  switch (action.type) {
    case share_actions/* _sharedActionsConstantsShare.SET_SHARE_DATA */.O.SET_SHARE_DATA:
      {
        return share_reducer_objectSpread(share_reducer_objectSpread({}, state), {}, {
          shareData: action.data
        });
      }

    default:
      return state;
  }
};
;// CONCATENATED MODULE: ./src/next/store/reducers/share.js

var share_initialState = _sharedStateShare;

var shareReducer = function shareReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : share_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type;

  switch (type) {
    default:
      return _sharedReducerShare(state, action);
  }
};

/* harmony default export */ var share = (shareReducer);
// EXTERNAL MODULE: ../shared/store/player/constants.js
var player_constants = __webpack_require__(94238);
// EXTERNAL MODULE: ../shared/store/toc/constants.js
var toc_constants = __webpack_require__(53087);
// EXTERNAL MODULE: ../shared/store/system/constants.js
var system_constants = __webpack_require__(59465);
// EXTERNAL MODULE: ../shared/store/mainTree/constants.js
var mainTree_constants = __webpack_require__(41330);
// EXTERNAL MODULE: ../shared/store/settings/constants.js
var store_settings_constants = __webpack_require__(94889);
// EXTERNAL MODULE: ../shared/store/share/constants.js
var share_constants = __webpack_require__(59825);
;// CONCATENATED MODULE: ./src/next/store/reducers/index.js
var _combineReducers;

function reducers_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




























/* harmony default export */ var reducers = (combineReducers((_combineReducers = {
  relevantSearch: reducers_relevantSearch,
  support: support
}, reducers_defineProperty(_combineReducers, share_constants/* KEY_REDUCER_SHARE */.B, share), reducers_defineProperty(_combineReducers, shop_constants/* KEY_REDUCER_SHOP */._, shop), reducers_defineProperty(_combineReducers, store_settings_constants/* KEY_REDUCER_SETTINGS */.P, reducers_settings), reducers_defineProperty(_combineReducers, mainTree_constants/* KEY_REDUCER_MAIN_TREE */.$, mainTree), reducers_defineProperty(_combineReducers, store_search_constants/* KEY_REDUCER_SEARCH */.gK, reducers_search), reducers_defineProperty(_combineReducers, featuredSearch_constants/* KEY_REDUCER_FEATURED_SEARCH */.d, featuredSearch_reducer), reducers_defineProperty(_combineReducers, player_constants/* KEY_REDUCER_PLAYER */.e, reducers_player), reducers_defineProperty(_combineReducers, system_constants/* KEY_REDUCER_SYSTEM */.G, system), reducers_defineProperty(_combineReducers, paragraphs_constants/* KEY_REDUCER_PARAGRAPHS */.fv, reducers_paragraphsReducer), reducers_defineProperty(_combineReducers, store_sw_constants/* KEY_REDUCER_SW */.U, reducers_sw_reducer), reducers_defineProperty(_combineReducers, library_constants/* KEY_REDUCER_LIBRARY */.O, library), reducers_defineProperty(_combineReducers, toc_constants/* KEY_REDUCER_TOC */.q, toc), _combineReducers)));
;// CONCATENATED MODULE: ./src/next/store/index.js
function store_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function store_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? store_ownKeys(Object(source), !0).forEach(function (key) { store_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : store_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function store_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function store_toConsumableArray(arr) { return store_arrayWithoutHoles(arr) || store_iterableToArray(arr) || store_unsupportedIterableToArray(arr) || store_nonIterableSpread(); }

function store_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function store_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return store_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return store_arrayLikeToArray(o, minLen); }

function store_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function store_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return store_arrayLikeToArray(arr); }

function store_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }







var bindMiddleware = function bindMiddleware(middleware) {
  if (false) { var composeEnhancers, _require2, composeWithDevTools; }

  return applyMiddleware.apply(void 0, store_toConsumableArray(middleware));
};

var rootReducer = function rootReducer(state, action) {
  if (action.type === HYDRATE) {
    var _state$count;

    var nextState = store_objectSpread(store_objectSpread({}, state), action.payload);

    if (state !== null && state !== void 0 && (_state$count = state.count) !== null && _state$count !== void 0 && _state$count.count) {
      nextState.count.count = state.count.count; // preserve count value on client side navigation
    }

    return nextState;
  }

  return reducers(state, action);
};

var makeStore = function makeStore() {
  var sagaMiddleware = redux_saga_core_npm_proxy_esm();
  var store = createStore(rootReducer, bindMiddleware([sagaMiddleware]));

  if (__webpack_require__.g.window) {
    __webpack_require__.g.window.store = store;
  }

  store.sagaTask = sagaMiddleware.run(rootSaga);
  return store;
};

var wrapper = createWrapper(makeStore, {
  debug: true
});
// EXTERNAL MODULE: ./src/next/store/actions/mainTree.actions.js
var actions_mainTree_actions = __webpack_require__(97541);
// EXTERNAL MODULE: ./src/next/store/actions/settings.actions.js
var actions_settings_actions = __webpack_require__(90487);
// EXTERNAL MODULE: ./src/next/hooks/useTheme.js + 1 modules
var useTheme = __webpack_require__(88130);
// EXTERNAL MODULE: ./src/next/contexts/righthClickMenuContext.js
var righthClickMenuContext = __webpack_require__(91318);
// EXTERNAL MODULE: ./package.json
var package_0 = __webpack_require__(4147);
// EXTERNAL MODULE: ../shared/utils/theme/theme.js + 1 modules
var theme = __webpack_require__(93752);
// EXTERNAL MODULE: ./src/next/utils/routes/routes.constants.js
var routes_constants = __webpack_require__(46072);
;// CONCATENATED MODULE: ./src/next/hooks/sw/constants.js
var LS_KEY_PWA_CONFIG = "pwa-config";
// EXTERNAL MODULE: ./src/next/utils/theme.js
var utils_theme = __webpack_require__(12621);
;// CONCATENATED MODULE: ./src/next/hooks/sw/useSW.js
function useSW_typeof(obj) { "@babel/helpers - typeof"; return useSW_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, useSW_typeof(obj); }

function useSW_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ useSW_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == useSW_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function useSW_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function useSW_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { useSW_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { useSW_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function useSW_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = useSW_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function useSW_toConsumableArray(arr) { return useSW_arrayWithoutHoles(arr) || useSW_iterableToArray(arr) || useSW_unsupportedIterableToArray(arr) || useSW_nonIterableSpread(); }

function useSW_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function useSW_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function useSW_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return useSW_arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || useSW_unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function useSW_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useSW_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useSW_arrayLikeToArray(o, minLen); }

function useSW_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

















var makeUrlsImagesBook = function makeUrlsImagesBook(book, imagesSubFolder) {
  return [(0,url_url/* makeUrlImgBookPaper */.jL)(book, imagesSubFolder), (0,url_url/* makeUrlImgBookCover */.uO)(book, imagesSubFolder), (0,url_url/* makeUrlImgBookReflection */.t6)(book, imagesSubFolder), (0,url_url/* getUrlImagesBooks */.T8)() + "/book-shadow.png"];
};

var addPrefixBuildFolder = function addPrefixBuildFolder(arr) {
  return arr.map(function (u) {
    return "/_next/" + u;
  });
};

var URLS_OFFLINE_COMMON = [routes_constants/* NEXT_URLS.offline */.h.offline, routes_constants/* NEXT_URLS.read */.h.read + "/[id]", routes_constants/* NEXT_URLS.privacyPolicy */.h.privacyPolicy, routes_constants/* NEXT_URLS.copirightNotice */.h.copirightNotice, routes_constants/* NEXT_URLS.userAgreement */.h.userAgreement];
var URLS_OFFLINE = URLS_OFFLINE_COMMON;
var URLS_OFFLINE_LANDING = [].concat(URLS_OFFLINE_COMMON, [routes_constants/* NEXT_URLS.home */.h.home]);
var useDefineWebsiteUrlsForOfflineUse = function useDefineWebsiteUrlsForOfflineUse(isLanding, pageProps, book) {
  var _Object$keys;

  var dispatch = (0,es/* useDispatch */.I0)();
  var onLine = (0,es/* useSelector */.v9)(system_selectors/* selectorSystemOnLine */.JU);
  var langMap = (0,es/* useSelector */.v9)(mainTree_selectors/* selectorMainTreeLangMap */.Qu);

  var _useState = (0,react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      pwaConfig = _useState2[0],
      setPwaConfig = _useState2[1];

  var reactLoadableManifest = pwaConfig.reactLoadableManifest,
      buildManifest = pwaConfig.buildManifest;
  var isPWAConfigFetched = !!(reactLoadableManifest && buildManifest);
  var langCurrent = pageProps._nextI18Next ? ((_Object$keys = Object.keys(pageProps._nextI18Next.initialI18nStore)) === null || _Object$keys === void 0 ? void 0 : _Object$keys[0]) || pageProps._nextI18Next.userConfig.defaultNS : constants/* DEFAULT_LANGUAGE */.k$;
  var bookAuthor = book === null || book === void 0 ? void 0 : book.author;
  var bookIdOrigin = book === null || book === void 0 ? void 0 : book.book_id;
  var urlsForOfflineUseLocal = (0,react.useMemo)(function () {
    if (!("window" in __webpack_require__.g) || !isPWAConfigFetched) {
      return [];
    }

    var urls = new Set([].concat(useSW_toConsumableArray(addPrefixBuildFolder(buildManifest.lowPriorityFiles)), useSW_toConsumableArray(addPrefixBuildFolder(buildManifest.polyfillFiles)), useSW_toConsumableArray((0,sw/* makeUrlsStaticForUsingAppOffline */.Sl)(langCurrent, isLanding ? utils_theme/* ThemesLandingApp */.D8 : theme/* Themes */.b3, constants/* I18N_NAMESPACES_LANDING */.og, langMap)))); // Landing page images.

    if (isLanding && bookAuthor && bookIdOrigin) {
      var _pageProps$landingBoo, _pageProps$booksSet, _pageProps$landingBoo2;

      var imagesSubFolder = (_pageProps$landingBoo = pageProps.landingBookViewConfig) === null || _pageProps$landingBoo === void 0 ? void 0 : _pageProps$landingBoo.imagesSubFolder;
      urls.add((0,url_url/* makeUrlImgAuthorSignature */.j5)(bookAuthor));
      urls.add((0,url_url/* makeUrlImgAuthor */.IW)(bookAuthor));
      urls.add((0,url_url/* makePublicUrl */.xo)("/scripts/qrious.min.js"));
      urls.add((0,url_url/* makePublicUrl */.xo)("/scripts/what-input.min.js"));
      urls.add((0,url_url/* makePublicUrl */.xo)("/scripts/landing.auth.js"));

      if (pageProps.isSetLanding && (_pageProps$booksSet = pageProps.booksSet) !== null && _pageProps$booksSet !== void 0 && _pageProps$booksSet.length) {
        pageProps.booksSet.forEach(function (book) {
          return urls.add((0,url_url/* getBookCover */.Ow)(book, true));
        });
        pageProps.booksSet.forEach(function (book) {
          return urls.add((0,url_url/* getBookCover */.Ow)(book, false));
        });
      } else {
        makeUrlsImagesBook(book, imagesSubFolder).forEach(function (i) {
          return urls.add(i);
        });
      }

      if ((_pageProps$landingBoo2 = pageProps.landingBookViewConfig) !== null && _pageProps$landingBoo2 !== void 0 && _pageProps$landingBoo2.splashAsImage) {
        urls.add((0,url_url/* makeUrlImgBookSplash */.cP)(imagesSubFolder));
      }
    } // Dynamic import modules (e.g. modules that are imported with "dynamic()").


    if (reactLoadableManifest) {
      Object.values(reactLoadableManifest).forEach(function (_ref) {
        var files = _ref.files;
        addPrefixBuildFolder(files).forEach(function (i) {
          return urls.add(i);
        });
      });
    } // Dev scripts.


    if ((0,assembly/* isDevelopment */.yG)()) {
      urls.add("/_next/static/development/_devPagesManifest.json");
      addPrefixBuildFolder(buildManifest.devFiles).forEach(function (i) {
        return urls.add(i);
      });
    } // Necessary files.


    if (buildManifest.pages["/_app"]) {
      addPrefixBuildFolder(buildManifest.pages["/_app"]).forEach(function (i) {
        return urls.add(i);
      });
    } // Pages scripts.


    var urlsOfflineFinal = isLanding ? URLS_OFFLINE_LANDING : URLS_OFFLINE;

    var _iterator = useSW_createForOfIteratorHelper(urlsOfflineFinal),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var url = _step.value;

        if (buildManifest.pages[url]) {
          addPrefixBuildFolder(buildManifest.pages[url]).forEach(function (i) {
            return urls.add(i);
          });
        }
      } // Pages HTMLs.

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var prefixPathnameLocale = "/" + langCurrent;
    urlsOfflineFinal.forEach(function (u) {
      urls.add(u === "/" ? prefixPathnameLocale : prefixPathnameLocale + u.replace("[id]", "offline"));
    }); // Pages data.

    var prefixData = "/_next/data/";
    var buildID = buildManifest.lowPriorityFiles[0].split("/")[1];
    urls.add(prefixData + buildID + prefixPathnameLocale + ".json");
    return useSW_toConsumableArray(urls.values());
  }, [// Ignore missing dependency {book} so far,
  // it will be triggered anyway by {bookAuthor} or {bookIdOrigin}
  isLanding, buildManifest, reactLoadableManifest, bookAuthor, bookIdOrigin, langCurrent, isPWAConfigFetched, langMap]); // Sets urls for offline use to redux.

  (0,react.useEffect)(function () {
    dispatch(actions/* swActions.updateWebsiteUrls */.s1.updateWebsiteUrls(urlsForOfflineUseLocal));
  }, [urlsForOfflineUseLocal]); // Fetches PWA Config.

  (0,react.useEffect)(function () {
    var loadStorageConfig = function loadStorageConfig() {
      var storageItem = (0,storage/* getLocalStorageItem */.le)(LS_KEY_PWA_CONFIG, undefined, true);

      if (storageItem) {
        setPwaConfig(storageItem);
      }
    };

    if (onLine) {
      fetch(routes_constants/* NEXT_URLS.apiGetNextPWAConfig */.h.apiGetNextPWAConfig + "?v=" + package_0.version).then( /*#__PURE__*/function () {
        var _ref2 = useSW_asyncToGenerator( /*#__PURE__*/useSW_regeneratorRuntime().mark(function _callee(response) {
          var data, pwaConfigNew;
          return useSW_regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return response.json();

              case 2:
                data = _context.sent;

                if (data !== null && data !== void 0 && data.buildManifest) {
                  pwaConfigNew = {
                    buildManifest: data.buildManifest,
                    reactLoadableManifest: data.reactLoadableManifest
                  };
                  setPwaConfig(pwaConfigNew);
                  (0,storage/* setLocalStorageItem */.D$)(LS_KEY_PWA_CONFIG, pwaConfigNew, true);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(loadStorageConfig);
    } else {
      loadStorageConfig();
    }
  }, [onLine]);
};
// EXTERNAL MODULE: ../node_modules/axios/index.js
var node_modules_axios = __webpack_require__(14206);
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);
// EXTERNAL MODULE: ../shared/utils/appServer/appServer.js
var appServer = __webpack_require__(12537);
;// CONCATENATED MODULE: ../shared/api/BaseHostAPI.js
function BaseHostAPI_typeof(obj) { "@babel/helpers - typeof"; return BaseHostAPI_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, BaseHostAPI_typeof(obj); }

function BaseHostAPI_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ BaseHostAPI_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == BaseHostAPI_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function BaseHostAPI_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function BaseHostAPI_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { BaseHostAPI_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { BaseHostAPI_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





var getVersionRequest = /*#__PURE__*/function () {
  var _ref = BaseHostAPI_asyncToGenerator( /*#__PURE__*/BaseHostAPI_regeneratorRuntime().mark(function _callee() {
    var url, _res$data, res;

    return BaseHostAPI_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = (0,url_url/* getBaseHost */.UO)() + appServer/* APIUrls.status */.Go.status + "?t=" + Date.now();
          _context.prev = 1;
          _context.next = 4;
          return axios_default().get(url);

        case 4:
          res = _context.sent;
          return _context.abrupt("return", res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.version);

        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", undefined);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function getVersionRequest() {
    return _ref.apply(this, arguments);
  };
}(); // - if refresh token is available, then the user refreshed token will be returned for this request.
// - if no refresh token, then an anonymous token will be returned for this request.

var refreshTokenRequest = function refreshTokenRequest() {
  var refreshToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var tokenLink = getBaseHost() + APIUrls.getToken;

  if (refreshToken) {
    tokenLink += "?token=" + refreshToken;
  }

  return axios.get(tokenLink).then(function (response) {
    var _response$data = response.data,
        access_token = _response$data.access_token,
        refresh_token = _response$data.refresh_token,
        expires_in = _response$data.expires_in;
    var refreshTokenNew = refresh_token || refreshToken;
    return {
      accessToken: access_token,
      refreshToken: refreshTokenNew,
      expiresIn: expires_in
    };
  }).catch(function (error) {
    consoleLogError("Refresh Token", "Error refreshing token: ", {
      refreshToken: refreshToken,
      error: error
    });
    return null;
  });
};
// EXTERNAL MODULE: ../shared/utils/time.js
var time = __webpack_require__(82344);
// EXTERNAL MODULE: ../shared/utils/systemUtils/systemUtils.js + 1 modules
var systemUtils = __webpack_require__(52707);
// EXTERNAL MODULE: ../shared/utils/storage/storage.constants.js
var storage_constants = __webpack_require__(79384);
;// CONCATENATED MODULE: ../shared/hooks/useCheckVersion.constants.js
var LS_KEY_LAST_CHECK = "version_last_check";
var LS_KEY_VERSION = "version";
;// CONCATENATED MODULE: ../shared/hooks/useCheckVersion.js
function useCheckVersion_typeof(obj) { "@babel/helpers - typeof"; return useCheckVersion_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, useCheckVersion_typeof(obj); }

function useCheckVersion_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ useCheckVersion_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == useCheckVersion_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function useCheckVersion_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function useCheckVersion_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { useCheckVersion_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { useCheckVersion_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }















var useCheckVersion_scope = "Version";
var MS_FREQUENCY = shared_constants/* TIMEOUT_HOUR */.Yt;
var useCheckVersion_IS_CONSOLE_LOGS = (0,assembly/* isProduction */.yv)() || false;

var checkVersion = function checkVersion(versionServer, onAppVersionDiffers) {
  var versionClient = storage/* localStorageSafe.getItem */.NE.getItem(LS_KEY_VERSION);

  try {
    if (versionClient && versionServer && versionClient !== versionServer) {
      (0,systemUtils/* clearLocalStorage */.ZL)(true);
      (0,systemUtils/* clearSessionStorage */.Xp)(true);

      var _getTokens2 = (0,systemUtils/* getTokens */.lz)(),
          refreshToken = _getTokens2.refreshToken; // EGWW-1226 save login and donateNotify on change versionServer


      (0,systemUtils/* deleteAllCookies */.Bt)();
      (0,sw/* unregisterServiceWorker */.Dm)();
      (0,systemUtils/* setTokens */.d0)(undefined, refreshToken);
      (0,dom/* dispatchCustomEvent */.hb)(storage_constants/* CUSTOM_EVENT_APP_VERSION_DIFFERS */.t0);
      (0,storage/* setLocalStorageItem */.D$)(LS_KEY_VERSION, versionServer);
      var refreshCounts = parseInt(storage/* sessionStorageSafe.getItem */.kh.getItem(storage_constants/* STORAGE_KEY_REFRESH_COUNT */.Sj));

      if (isNaN(refreshCounts)) {
        refreshCounts = 0;
      }

      if (refreshCounts) {
        (0,utils_console/* consoleLogError */.aw)("Version", "Error! App reloaded once, but versions differ anyway.", {
          versionClient: versionClient,
          versionServer: versionServer,
          refreshCounts: refreshCounts
        });
      } else {
        storage/* sessionStorageSafe.setItem */.kh.setItem(storage_constants/* STORAGE_KEY_REFRESH_COUNT */.Sj, refreshCounts + 1);
        (0,utils_console/* consoleLogWarning */.b9)("Version", "Differs! App will be reloaded in 3s!");
        (0,utils_console/* consoleLogGroup */.B9)("More info about content versions", {
          server: versionServer,
          client: versionClient
        });
        onAppVersionDiffers();
        setTimeout(function () {
          window.location.reload();
        }, 3000);
      }
    } else {
      (0,storage/* setLocalStorageItem */.D$)(LS_KEY_VERSION, versionServer || versionClient);
      storage/* sessionStorageSafe.setItem */.kh.setItem(storage_constants/* STORAGE_KEY_REFRESH_COUNT */.Sj, 0);

      if (useCheckVersion_IS_CONSOLE_LOGS) {
        (0,utils_console/* consoleLogSuccess */.UA)("Version", "Version is OK!");
        (0,utils_console/* consoleLogGroup */.B9)("More info about versions", {
          client: versionClient,
          server: versionServer
        });
      }
    }
  } catch (e) {
    console.log(e);
  }
};

var useCheckVersion = function useCheckVersion() {
  var isEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var dispatch = (0,es/* useDispatch */.I0)();
  (0,react.useEffect)(function () {
    if (!isEnabled) {
      return undefined;
    }

    if ((0,assembly/* isDevelopment */.yG)()) {
      return undefined;
    }

    var timerId;

    var checkAfter = function checkAfter(ms) {
      if (useCheckVersion_IS_CONSOLE_LOGS) {
        (0,utils_console/* consoleLogInfo */.jn)(useCheckVersion_scope, "Check in ".concat((0,time/* msToTimeLabel */.AJ)(ms)));
      }

      timerId = setTimeout( /*#__PURE__*/useCheckVersion_asyncToGenerator( /*#__PURE__*/useCheckVersion_regeneratorRuntime().mark(function _callee() {
        return useCheckVersion_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (useCheckVersion_IS_CONSOLE_LOGS) {
                (0,utils_console/* consoleLogInfo */.jn)(useCheckVersion_scope, "Checking...");
              }

              (0,storage/* setLocalStorageItem */.D$)(LS_KEY_LAST_CHECK, Date.now());
              _context.next = 4;
              return getVersionRequest().then(function (serverVersion) {
                if (serverVersion) {
                  checkVersion(serverVersion, function () {
                    dispatch(system_actions/* _sharedActionsSystem.toast */.g.toast("This webpage needs updating,</br>" + "and will reload in 3 seconds."));
                  });
                }
              });

            case 4:
              checkAfter(MS_FREQUENCY);

            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })), ms);
    };

    checkAfter(0);
    return function () {
      clearTimeout(timerId);
    };
  }, [isEnabled]);
};

/* harmony default export */ var hooks_useCheckVersion = (useCheckVersion);
;// CONCATENATED MODULE: ../shared/hooks/useDetectOnLine.js





var useDetectOnLine = function useDetectOnLine() {
  var dispatch = (0,es/* useDispatch */.I0)();
  var setOnline = (0,react.useCallback)(function (flag) {
    dispatch(system_actions/* _sharedActionsSystem.setIsOnline */.g.setIsOnline(flag));
  }, []);
  (0,react.useEffect)(function () {
    var _global$window;

    var handleOnLineChange = function handleOnLineChange(onLine) {
      setOnline(onLine);

      if (!onLine) {
        dispatch(system_actions/* _sharedActionsSystem.toast */.g.toast("@sw:noInternetConnection"));
      }
    };

    var listenerOnline = function listenerOnline() {
      return handleOnLineChange(true);
    };

    var listenerOffline = function listenerOffline() {
      return handleOnLineChange(false);
    };

    window.addEventListener("online", listenerOnline);
    window.addEventListener("offline", listenerOffline);

    if ((_global$window = __webpack_require__.g.window) !== null && _global$window !== void 0 && _global$window.navigator) {
      handleOnLineChange((0,user_agent/* isOnLine */.Mc)());
    }

    return function () {
      window.removeEventListener("online", listenerOnline);
      window.removeEventListener("offline", listenerOffline);
    };
  }, [setOnline]);
};

/* harmony default export */ var hooks_useDetectOnLine = (useDetectOnLine);
;// CONCATENATED MODULE: ../shared/hooks/useAppHeight.js

var CSS_VAR_APP_HEIGHT = "--app__height";
var CSS_VAR_APP_HEIGHT_START = "--app__height-start";

var setAppProperty = function setAppProperty(property) {
  document.documentElement.style.setProperty(property, "".concat(window.innerHeight, "px"));
};

var setAppHeight = function setAppHeight() {
  return setAppProperty(CSS_VAR_APP_HEIGHT);
};

var setAppHeightStart = function setAppHeightStart() {
  return setAppProperty(CSS_VAR_APP_HEIGHT_START);
};

var useAppHeight = function useAppHeight() {
  (0,react.useEffect)(function () {
    setAppHeight();
    setAppHeightStart();
    window.addEventListener("resize", setAppHeight);
    return function () {
      window.removeEventListener("resize", setAppHeight);
    };
  }, []);
};

/* harmony default export */ var hooks_useAppHeight = (useAppHeight);
;// CONCATENATED MODULE: ../shared/hooks/useCheckContentVersion.js
function useCheckContentVersion_typeof(obj) { "@babel/helpers - typeof"; return useCheckContentVersion_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, useCheckContentVersion_typeof(obj); }

function useCheckContentVersion_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ useCheckContentVersion_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == useCheckContentVersion_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function useCheckContentVersion_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function useCheckContentVersion_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { useCheckContentVersion_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { useCheckContentVersion_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }










var useCheckContentVersion_scope = "Content version";
var useCheckContentVersion_MS_FREQUENCY = shared_constants/* TIMEOUT_DAY */.pY;
var useCheckContentVersion_IS_CONSOLE_LOGS = (0,assembly/* isProduction */.yv)() || false;

var useCheckContentVersion = function useCheckContentVersion() {
  var isEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  (0,react.useEffect)(function () {
    if (!isEnabled) {
      return undefined;
    }

    var timerId;

    var checkAfter = function checkAfter(ms) {
      if (useCheckContentVersion_IS_CONSOLE_LOGS) {
        (0,utils_console/* consoleLogInfo */.jn)(useCheckContentVersion_scope, "Check in ".concat((0,time/* msToTimeLabel */.AJ)(ms)));
      }

      timerId = setTimeout( /*#__PURE__*/useCheckContentVersion_asyncToGenerator( /*#__PURE__*/useCheckContentVersion_regeneratorRuntime().mark(function _callee() {
        var contentVersionServer;
        return useCheckContentVersion_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (useCheckContentVersion_IS_CONSOLE_LOGS) {
                (0,utils_console/* consoleLogInfo */.jn)(useCheckContentVersion_scope, "Checking...");
              }

              (0,storage/* setLocalStorageItem */.D$)(storage_constants/* STORAGE_KEY_CONTENT_CACHE_LAST_CHECK */.ns, Date.now());
              _context.next = 4;
              return (0,common/* checkContentVersionRequest */.tV)();

            case 4:
              contentVersionServer = _context.sent;
              (0,CacheHolder/* checkNetworkCache */.ve)(contentVersionServer, true, useCheckContentVersion_IS_CONSOLE_LOGS);
              checkAfter(useCheckContentVersion_MS_FREQUENCY);

            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })), ms);
    };

    checkAfter(0);
    return function () {
      clearTimeout(timerId);
    };
  }, [isEnabled]);
};

/* harmony default export */ var hooks_useCheckContentVersion = (useCheckContentVersion);
// EXTERNAL MODULE: ../shared/contexts/AudioContext.js
var AudioContext = __webpack_require__(77926);
// EXTERNAL MODULE: ../shared/hooks/pwa/sw.js + 2 modules
var pwa_sw = __webpack_require__(69867);
;// CONCATENATED MODULE: ../shared/hooks/useIsFontsLoaded.js
function useIsFontsLoaded_extends() { useIsFontsLoaded_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return useIsFontsLoaded_extends.apply(this, arguments); }

function useIsFontsLoaded_slicedToArray(arr, i) { return useIsFontsLoaded_arrayWithHoles(arr) || useIsFontsLoaded_iterableToArrayLimit(arr, i) || useIsFontsLoaded_unsupportedIterableToArray(arr, i) || useIsFontsLoaded_nonIterableRest(); }

function useIsFontsLoaded_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function useIsFontsLoaded_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useIsFontsLoaded_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useIsFontsLoaded_arrayLikeToArray(o, minLen); }

function useIsFontsLoaded_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function useIsFontsLoaded_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function useIsFontsLoaded_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var useIsFontsLoaded = function useIsFontsLoaded() {
  var onLine = (0,es/* useSelector */.v9)(system_selectors/* selectorSystemOnLine */.JU);

  var _useState = (0,react.useState)(!onLine),
      _useState2 = useIsFontsLoaded_slicedToArray(_useState, 2),
      isFontsLoaded = _useState2[0],
      setIsFontsLoaded = _useState2[1];

  (0,react.useEffect)(function () {
    var _global$window2, _global$window2$docum, _global$window2$docum2;

    var timerId;

    var onLoadingDone = function onLoadingDone() {
      var _global$window, _global$window$docume, _global$window$docume2;

      clearTimeout(timerId);
      setIsFontsLoaded(true);
      (_global$window = __webpack_require__.g.window) === null || _global$window === void 0 ? void 0 : (_global$window$docume = _global$window.document) === null || _global$window$docume === void 0 ? void 0 : (_global$window$docume2 = _global$window$docume.fonts) === null || _global$window$docume2 === void 0 ? void 0 : _global$window$docume2.removeEventListener("loadingdone", onLoadingDone);
    };

    if (!((_global$window2 = __webpack_require__.g.window) !== null && _global$window2 !== void 0 && (_global$window2$docum = _global$window2.document) !== null && _global$window2$docum !== void 0 && (_global$window2$docum2 = _global$window2$docum.fonts) !== null && _global$window2$docum2 !== void 0 && _global$window2$docum2.status) || !onLine) {
      onLoadingDone(true);
    } else {
      if (__webpack_require__.g.window.document.fonts.status === "loaded") {
        onLoadingDone();
      } else {
        __webpack_require__.g.window.document.fonts.addEventListener("loadingdone", onLoadingDone); // Show UI after 2 seconds anyway.

        timerId = setTimeout(function () {
          onLoadingDone(true);
        }, 2000);
      }
    }

    return function () {
      clearTimeout(timerId);
      __webpack_require__.g.window.document.fonts.removeEventListener("loadingdone", onLoadingDone);
    };
  }, [onLine]);
  return isFontsLoaded;
};
var withIsFontsLoaded = function withIsFontsLoaded(Component) {
  return function (props) {
    var isFontsLoaded = useIsFontsLoaded();
    return /*#__PURE__*/React.createElement(Component, useIsFontsLoaded_extends({
      isFontsLoaded: isFontsLoaded
    }, props));
  };
};
;// CONCATENATED MODULE: ./src/next/utils/constants.js
var CLASSNAME_IS_APP_INIT = "is-app-init";
// EXTERNAL MODULE: ../shared/what-input/useWhatInput.js
var useWhatInput = __webpack_require__(83951);
;// CONCATENATED MODULE: ../shared/hooks/useRegulateWhatInputClassNames.js


var className = "is-last-input-mouse";

var useRegulateWhatInputClassNames = function useRegulateWhatInputClassNames() {
  var isLastInputMouse = (0,useWhatInput/* useWhatInputIsLastPointerMouse */.a)();
  (0,react.useEffect)(function () {
    var bodyClassList = document.documentElement.classList;

    if (isLastInputMouse) {
      bodyClassList.add(className);
    } else {
      bodyClassList.remove(className);
    }
  }, [isLastInputMouse]);
};

/* harmony default export */ var hooks_useRegulateWhatInputClassNames = (useRegulateWhatInputClassNames);
// EXTERNAL MODULE: ../shared/components/Toaster/Toaster.js
var Toaster = __webpack_require__(88770);
// EXTERNAL MODULE: ../shared/components/Tooltip/TooltipContext.js
var TooltipContext = __webpack_require__(23853);
// EXTERNAL MODULE: ./src/next/contexts/search.js
var contexts_search = __webpack_require__(38768);
// EXTERNAL MODULE: ../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(56253);
// EXTERNAL MODULE: ../shared/utils/device-detect.js
var device_detect = __webpack_require__(83684);
;// CONCATENATED MODULE: ../shared/hooks/useAddHTMLClassNameIsIOSDevice.js




var useAddHTMLClassNameIsIOSDevice = function useAddHTMLClassNameIsIOSDevice() {
  (0,react.useEffect)(function () {
    if ((0,device_detect/* getIsIOSDevice */.Y$)()) {
      document.documentElement.classList.add("is-ios-device");
    }
  }, []);
};

var useAddHTMLClassNameIsAndroidDevice = function useAddHTMLClassNameIsAndroidDevice() {
  (0,react.useEffect)(function () {
    if (lib/* isAndroid */.Dt) {
      document.documentElement.classList.add("is-android");
    }
  }, []);
};

var useGlobalClassNameDeviceOS = function useGlobalClassNameDeviceOS() {
  useAddHTMLClassNameIsIOSDevice();
  useAddHTMLClassNameIsAndroidDevice();
};

/* harmony default export */ var hooks_useAddHTMLClassNameIsIOSDevice = (useGlobalClassNameDeviceOS);
// EXTERNAL MODULE: ../shared/components/Loader/Loader.constants.js
var Loader_constants = __webpack_require__(69517);
// EXTERNAL MODULE: ../shared/contexts/TranslateContext.js
var TranslateContext = __webpack_require__(48081);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../shared/components/Scroll/Scroll.js
var Scroll = __webpack_require__(95793);
// EXTERNAL MODULE: ../shared/components/Button/CloseButton/CloseButton.js
var CloseButton = __webpack_require__(72064);
// EXTERNAL MODULE: ../shared/components/Button/Button.js
var Button = __webpack_require__(18170);
// EXTERNAL MODULE: ../shared/components/Logotype/Logotype.js
var Logotype = __webpack_require__(48011);
;// CONCATENATED MODULE: ../shared/components/Loader/ImageWithLoader.js
function ImageWithLoader_slicedToArray(arr, i) { return ImageWithLoader_arrayWithHoles(arr) || ImageWithLoader_iterableToArrayLimit(arr, i) || ImageWithLoader_unsupportedIterableToArray(arr, i) || ImageWithLoader_nonIterableRest(); }

function ImageWithLoader_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function ImageWithLoader_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ImageWithLoader_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ImageWithLoader_arrayLikeToArray(o, minLen); }

function ImageWithLoader_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function ImageWithLoader_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function ImageWithLoader_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



function ImageWithLoader(_ref) {
  var src = _ref.src,
      children = _ref.children;

  var _useState = (0,react.useState)(false),
      _useState2 = ImageWithLoader_slicedToArray(_useState, 2),
      isLoaded = _useState2[0],
      setIsLoaded = _useState2[1];

  (0,react.useEffect)(function () {
    var image = new Image();

    image.onload = function () {
      return setIsLoaded(true);
    };

    image.src = src;
  }, []);
  return isLoaded ? /*#__PURE__*/react.createElement("img", {
    src: src
  }) : /*#__PURE__*/react.createElement(react.Fragment, null, children);
}

/* harmony default export */ var Loader_ImageWithLoader = (ImageWithLoader);
// EXTERNAL MODULE: ../shared/hooks/useLockBodyScroll.js
var useLockBodyScroll = __webpack_require__(77706);
// EXTERNAL MODULE: ../shared/pages/TextModePage.module.scss
var TextModePage_module = __webpack_require__(29431);
var TextModePage_module_default = /*#__PURE__*/__webpack_require__.n(TextModePage_module);
;// CONCATENATED MODULE: ../shared/pages/TextModePage.js
function TextModePage_slicedToArray(arr, i) { return TextModePage_arrayWithHoles(arr) || TextModePage_iterableToArrayLimit(arr, i) || TextModePage_unsupportedIterableToArray(arr, i) || TextModePage_nonIterableRest(); }

function TextModePage_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function TextModePage_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return TextModePage_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TextModePage_arrayLikeToArray(o, minLen); }

function TextModePage_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function TextModePage_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function TextModePage_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

















var googlePlaySrc = (0,url_url/* getUrlImgStore */.VP)("android");
var appStoreSrc = (0,url_url/* getUrlImgStore */.VP)("ios");

var TextModePage = function TextModePage() {
  var _useSharedTranslation = (0,TranslateContext/* useSharedTranslation */.G)(),
      t = _useSharedTranslation.t;

  var textMode = (0,es/* useSelector */.v9)((0,settings_selectors/* selectorSetting */.K)(settings_constants/* SETTING.textMode.id */.Fy.textMode.id));
  var dataAcquisitionStatus = (0,es/* useSelector */.v9)(system_selectors/* selectorSystemDataAcquisitionStatus */.ci);

  var _useState = (0,react.useState)(false),
      _useState2 = TextModePage_slicedToArray(_useState, 2),
      isTextModePopupVisible = _useState2[0],
      setIsTextModePopupVisible = _useState2[1];

  (0,useLockBodyScroll/* default */.Z)(isTextModePopupVisible); // Show "Slow internet connection" notification

  (0,react.useEffect)(function () {
    if (dataAcquisitionStatus === Loader_constants/* DATA_ACQUISITION_STATUS.LOW */.JF.LOW && !textMode) {
      setIsTextModePopupVisible(true);
    }
  }, [dataAcquisitionStatus, textMode]);

  if (!isTextModePopupVisible) {
    return null;
  }

  return /*#__PURE__*/react.createElement("div", {
    className: (TextModePage_module_default())["text-mode-page"]
  }, /*#__PURE__*/react.createElement("div", {
    className: (TextModePage_module_default())["header-page"]
  }, /*#__PURE__*/react.createElement(CloseButton/* default */.Z, {
    onClick: function onClick() {
      setIsTextModePopupVisible(false);
    }
  })), /*#__PURE__*/react.createElement("div", {
    className: (TextModePage_module_default()).container
  }, /*#__PURE__*/react.createElement("div", {
    className: (TextModePage_module_default())["logo-container"]
  }, /*#__PURE__*/react.createElement(Logotype/* default */.Z, {
    className: (TextModePage_module_default()).logo,
    isShowRegistered: true,
    isShowLogoLinks: true,
    isShowLogoWritingsLabel: true
  })), /*#__PURE__*/react.createElement(Scroll/* default */.Z, {
    autoHeight: true,
    autoHeightMax: "65vh"
  }, /*#__PURE__*/react.createElement("div", {
    className: (TextModePage_module_default())["content-container"]
  }, /*#__PURE__*/react.createElement("div", {
    className: (TextModePage_module_default()).title
  }, t("textModePageTitle")), /*#__PURE__*/react.createElement("p", null, t("try_switching_to_text_mode")), /*#__PURE__*/react.createElement(Button/* default */.Z, {
    rootTagName: "a",
    href: (0,url_url/* getTextAppHost */.nb)(),
    className: (TextModePage_module_default())["text-mode-button"]
  }, t("switch_to_text_mode")), /*#__PURE__*/react.createElement("div", {
    className: (TextModePage_module_default())["footer-container"]
  }, /*#__PURE__*/react.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: t("or_download_our_apps")
    }
  }), /*#__PURE__*/react.createElement("div", {
    className: (TextModePage_module_default())["btn-group"]
  }, /*#__PURE__*/react.createElement("a", {
    className: (TextModePage_module_default())["app-sore-button"],
    href: url_url/* EXTERNAL_URLS.iosAPP */.wk.iosAPP,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/react.createElement(Loader_ImageWithLoader, {
    src: appStoreSrc
  }, t("appleStoreButton"))), /*#__PURE__*/react.createElement("a", {
    className: (TextModePage_module_default())["google-play-button"],
    href: url_url/* EXTERNAL_URLS.androidApp */.wk.androidApp,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/react.createElement(Loader_ImageWithLoader, {
    src: googlePlaySrc
  }, t("googlePlayButton")))))))));
};

TextModePage.propTypes = {
  Link: (prop_types_default()).any,
  LinkButton: (prop_types_default()).any
};
/* harmony default export */ var pages_TextModePage = (TextModePage);
;// CONCATENATED MODULE: ../shared/hooks/useRegulateBrowserZoom.js


var applyZoomProperties = function applyZoomProperties() {
  var zoomLevel = Math.ceil((window.outerWidth - 6) / window.innerWidth * 100);

  if (zoomLevel >= 150) {
    document.body.classList.add("zoom-150");
  } else {
    document.body.classList.remove("zoom-150");
  }
};

var useRegulateBrowserZoom = function useRegulateBrowserZoom() {
  (0,react.useEffect)(function () {
    applyZoomProperties();
  }, []);
  (0,react.useEffect)(function () {
    window.addEventListener("resize", applyZoomProperties);
    return function () {
      window.addEventListener("resize", applyZoomProperties);
    };
  }, []);
};

/* harmony default export */ var hooks_useRegulateBrowserZoom = (useRegulateBrowserZoom);
;// CONCATENATED MODULE: ../shared/pages/TextModePageScript.js
var WINDOW_PROP_KEY_TIMESTAMP_APP_HTML_PARSED = "__timestamp_app_html_parsed";
var TextModePageScript = "\n  window[\"".concat(WINDOW_PROP_KEY_TIMESTAMP_APP_HTML_PARSED, "\"] = Date.now();\n");
;// CONCATENATED MODULE: ../shared/hooks/useIOSGlobalClassNames.js


var prefix = "ios-until-";

var useIOSGlobalClassNames = function useIOSGlobalClassNames() {
  (0,react.useEffect)(function () {
    var bodyClassList = document.documentElement.classList;

    if ((0,device_detect/* isIOSVersionUntil11 */.G2)()) {
      bodyClassList.add(prefix + "11");
    } else {
      bodyClassList.remove(prefix + "11");
    }
  }, []);
};

/* harmony default export */ var hooks_useIOSGlobalClassNames = (useIOSGlobalClassNames);
// EXTERNAL MODULE: ../shared/store/index.js + 2 modules
var store = __webpack_require__(27736);
// EXTERNAL MODULE: ../shared/what-input/source.js
var source = __webpack_require__(53769);
var source_default = /*#__PURE__*/__webpack_require__.n(source);
// EXTERNAL MODULE: ../shared/what-input/what-input.utils.js
var what_input_utils = __webpack_require__(95504);
;// CONCATENATED MODULE: ../shared/what-input/what-input.js




if (__webpack_require__.g.window) {
  __webpack_require__.g.window[what_input_utils/* WINDOW_KEY_IS_LAST_POINTER_MOUSE */.cc] = (0,dom/* getIsMatchesCssMediaHover */.oM)();
}

var handleWhatInputChange = function handleWhatInputChange(type) {
  var valueNew;

  if (type === "mouse" || type === "pointer") {
    valueNew = true;
  } else if (type === "touch") {
    valueNew = false;
  }

  if (valueNew !== undefined) {
    window[what_input_utils/* WINDOW_KEY_IS_LAST_POINTER_MOUSE */.cc] = valueNew;
    (0,what_input_utils/* dispatchCustomEventLastInputWasMouseChange */.w)(valueNew);
  }
};

source_default().registerOnChange(handleWhatInputChange, "intent");
source_default().registerOnChange(handleWhatInputChange, "input");
// EXTERNAL MODULE: ./src/next/styles/global.scss
var global = __webpack_require__(88734);
;// CONCATENATED MODULE: ./src/pages/_app.js
var _excluded = ["Component"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _app_extends() { _app_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _app_extends.apply(this, arguments); }

function _app_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _app_slicedToArray(arr, i) { return _app_arrayWithHoles(arr) || _app_iterableToArrayLimit(arr, i) || _app_unsupportedIterableToArray(arr, i) || _app_nonIterableRest(); }

function _app_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _app_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _app_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _app_arrayLikeToArray(o, minLen); }

function _app_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _app_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _app_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }









































 // dynamic, to prevent console errors - server content mismatch the client's.

var BadgeOffline = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 70184));
}, {
  ssr: false
});
var InstallPWANotification = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(218), __webpack_require__.e(239), __webpack_require__.e(731)]).then(__webpack_require__.bind(__webpack_require__, 76731));
}, {
  ssr: false
});



var Content = function Content(_ref) {
  var _pageProps$mainPanel;

  var pageProps = _ref.pageProps,
      Component = _ref.Component;
  var isLanding = pageProps.isLanding;
  var isSetCONFLICT = pageProps === null || pageProps === void 0 ? void 0 : pageProps.isSetCONFLICT;
  var book = pageProps.book || ((_pageProps$mainPanel = pageProps.mainPanel) === null || _pageProps$mainPanel === void 0 ? void 0 : _pageProps$mainPanel.book);
  var dispatch = (0,es/* useDispatch */.I0)();
  var onLine = (0,es/* useSelector */.v9)(system_selectors/* selectorSystemOnLine */.JU);
  var isSWInit = (0,es/* useSelector */.v9)(store/* selectorIsSWInit */.uV);
  var isSWRegistered = (0,es/* useSelector */.v9)(store/* selectorIsSWRegistered */.ZB);
  var isSWInitStatusRetrieved = (0,es/* useSelector */.v9)(store/* selectorIsSWInitStatusRetrieved */._H);

  var _useState = (0,react.useState)(false),
      _useState2 = _app_slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  (0,useTheme/* useRegulateTheme */.UG)(pageProps);
  hooks_useRegulateBrowserZoom();
  hooks_useRegulateWhatInputClassNames();
  hooks_useAddHTMLClassNameIsIOSDevice();
  hooks_useIOSGlobalClassNames();
  (0,pwa_sw/* useRegisterServiceWorker */.MN)("/sw.js");
  useDefineWebsiteUrlsForOfflineUse(isLanding, pageProps, book);
  (0,pwa_sw/* useAutoDownloadWebsite */.Db)(isLanding);
  (0,pwa_sw/* useHandleSWMessages */.OH)();
  (0,pwa_sw/* useClearSWDataWhenVersionsDiffers */.Go)(); // Check versions only after the SW is available.
  // So, if the app version differs, the event could be sent to clean the cache.

  var isSWInitAndRegistered = isSWInit && isSWRegistered;
  hooks_useCheckContentVersion(isSWInitAndRegistered);
  hooks_useCheckVersion(isSWInitAndRegistered);
  hooks_useDetectOnLine();
  hooks_useAppHeight(); // Update default bible for Conflict landing page

  (0,react.useEffect)(function () {
    if (isSetCONFLICT) {
      var _settingsActions$upda;

      dispatch(actions_settings_actions/* settingsActions.updateSettings */.f.updateSettings((_settingsActions$upda = {}, _app_defineProperty(_settingsActions$upda, settings_constants/* SETTING.baseBible.id */.Fy.baseBible.id, content_constants/* NKJV_BIBLE */.tA), _app_defineProperty(_settingsActions$upda, settings_constants/* SETTING.jtlBaseBible.id */.Fy.jtlBaseBible.id, content_constants/* NKJV_BIBLE */.tA), _settingsActions$upda)));
    }
  }, [isSetCONFLICT]); // Regulates loading flag.

  (0,react.useEffect)(function () {
    dispatch(actions_mainTree_actions/* mainTreeActions.fetchMainTreeAllData */.Z.fetchMainTreeAllData());
    dispatch(actions_settings_actions/* settingsActions.fetchGeoIpData */.f.fetchGeoIpData());
    var routePrev, localePrev;

    var start = function start() {
      var _Router$router = (router_default()).router,
          locale = _Router$router.locale,
          route = _Router$router.route;
      var routeFinal = (router_default()).router.route === "/" ? "/" : "/" + route.split("/")[1] + "/";
      routePrev = routeFinal;
      localePrev = locale;
      setLoading(true);
    };

    var end = function end(pathnameNew) {
      setLoading(false);

      if (typeof pathnameNew === "string") {
        var isTheSameRoute = routePrev === "/" ? pathnameNew === "/" || "/" + localePrev + "/" : pathnameNew.startsWith(routePrev) || pathnameNew.startsWith("/" + localePrev + routePrev);

        if (!isTheSameRoute) {
          dispatch(actions_system_actions/* systemActions.actionHideAll */.n.actionHideAll());
        }
      }
    };

    router_default().events.on("routeChangeStart", start);
    router_default().events.on("routeChangeComplete", end);
    router_default().events.on("routeChangeError", end);
    return function () {
      router_default().events.off("routeChangeStart", start);
      router_default().events.off("routeChangeComplete", end);
      router_default().events.off("routeChangeError", end);
    };
  }, []);
  return /*#__PURE__*/react.createElement(contexts_pageProps/* PagePropsProvider */.O, pageProps, /*#__PURE__*/react.createElement(contexts_history/* HistoryProvider */.f, null, /*#__PURE__*/react.createElement(subscriptions/* SubscriptionsProvider */.I, null, /*#__PURE__*/react.createElement(contexts_search/* SearchProvider */.X, null, /*#__PURE__*/react.createElement(AudioContext/* AudioProvider */.nY, {
    analytics: false
  }, /*#__PURE__*/react.createElement(righthClickMenuContext/* ContextMenuProvider */.d, null, !onLine && /*#__PURE__*/react.createElement(BadgeOffline, null), /*#__PURE__*/react.createElement(Component, _app_extends({
    isLoading: loading
  }, pageProps)), !!(isLanding && pageProps.isReader && book && isSWRegistered && isSWInitStatusRetrieved) && /*#__PURE__*/react.createElement(InstallPWANotification, {
    isLanding: isLanding,
    book: book,
    booksSet: pageProps.booksSet
  }), !isLanding && /*#__PURE__*/react.createElement(pages_TextModePage, null)))))), /*#__PURE__*/react.createElement(Toaster/* default */.Z, null));
};

var InitPage = function InitPage(_ref2) {
  var Component = _ref2.Component,
      pageProps = _ref2.pageProps;

  var _useAuthContext = (0,auth/* useAuthContext */.E)(),
      isInit = _useAuthContext.isInit;

  var dispatch = (0,es/* useDispatch */.I0)();
  var isFontsLoaded = useIsFontsLoaded();
  var isAppInit = isFontsLoaded && isInit;
  (0,pwa_sw/* useStashInstallPWAPrompt */.px)(); // Regulates loader overlay based on is fonts loading.

  (0,react.useEffect)(function () {
    if (isAppInit) {
      var delta = Date.now() - window[WINDOW_PROP_KEY_TIMESTAMP_APP_HTML_PARSED];

      if (delta > Loader_constants/* minLoadingTimeInMillisecondsDefault */.CY) {
        dispatch(system_actions/* _sharedActionsSystem.updateDataAcquisitionStatus */.g.updateDataAcquisitionStatus(Loader_constants/* DATA_ACQUISITION_STATUS.LOW */.JF.LOW));
      }

      __webpack_require__.g.window.document.documentElement.classList.add(CLASSNAME_IS_APP_INIT);
    }
  }, [isAppInit]);
  return /*#__PURE__*/react.createElement(Content, {
    Component: Component,
    pageProps: pageProps
  });
};

var App = function App(_ref3) {
  var Component = _ref3.Component,
      restProps = _objectWithoutProperties(_ref3, _excluded);

  var _wrapper$useWrappedSt = wrapper.useWrappedStore(restProps),
      store = _wrapper$useWrappedSt.store,
      props = _wrapper$useWrappedSt.props;

  var pageProps = props.pageProps;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement((head_default()), null, /*#__PURE__*/react.createElement("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1.0"
  })), /*#__PURE__*/react.createElement(es/* Provider */.zt, {
    store: store
  }, /*#__PURE__*/react.createElement(TranslateContext/* SharedTranslationProvider */.u, {
    useTranslation: esm/* useTranslation */.$G
  }, /*#__PURE__*/react.createElement(TooltipContext/* TooltipProvider */.pn, null, /*#__PURE__*/react.createElement(modal/* default */.Z, null, /*#__PURE__*/react.createElement(auth/* AuthProvider */.H, null, /*#__PURE__*/react.createElement(InitPage, {
    Component: Component,
    pageProps: pageProps
  })))))));
};

/* harmony default export */ var _app = ((0,esm/* appWithTranslation */.Jc)(App, (next_i18next_config_default())));

/***/ }),

/***/ 33164:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26923);
/* provided dependency */ var process = __webpack_require__(27061);
var _sentryCollisionFreeGlobalObject =  false ? 0 : window;

_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
  "id": "0.33664028464766926"
};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

var SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || "https://b10629fc49f440f1a209994d69f3fe04@sentry.egwwritings.org/11";
_sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .init */ .S1({
  dsn: SENTRY_DSN,
  autoSessionTracking: false
});

/***/ }),

/***/ 25836:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _interop_require_default = (__webpack_require__(42619)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(27378));

var AmpStateContext = _react.default.createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 10878:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

/***/ }),

/***/ 90568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;

var _extends = (__webpack_require__(76516)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(42619)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(27378));

var _loadable = _interop_require_default(__webpack_require__(34142));

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable.default;
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (_typeof(dynamicOptions) === 'object') {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _extends({}, loadableOptions, options);

  if (loadableOptions.suspense) {
    if (false) {}

    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly


  if (typeof loadableOptions.ssr === 'boolean' && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react.default.createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

if ((typeof exports.default === 'function' || _typeof(exports.default) === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 31508:
/***/ (function(module, exports, __webpack_require__) {

"use client";
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _extends = (__webpack_require__(76516)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(42619)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(96808)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(27378));

var _sideEffect = _interop_require_default(__webpack_require__(36775));

var _ampContext = __webpack_require__(25836);

var _headManagerContext = __webpack_require__(3759);

var _ampMode = __webpack_require__(10878);

var _warnOnce = __webpack_require__(4301);

'use client';

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react.default.createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react.default.createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react.default.Fragment) {
    return list.concat(_react.default.Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */


function reduceComponents(headChildrenElements, props) {
  var inAmpMode = props.inAmpMode;
  return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _extends({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react.default.cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react.default.cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react.default.createElement(_sideEffect.default, {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _ampMode).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if ((typeof exports.default === 'function' || _typeof(exports.default) === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 62461:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _interop_require_default = (__webpack_require__(42619)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(27378));

var LoadableContext = _react.default.createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 34142:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _extends = (__webpack_require__(76516)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(96808)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(27378));

var _loadableContext = __webpack_require__(62461);

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react.default.lazy(opts.loader);
  }
  /** @type LoadableSubscription */


  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true) {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;

    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {
        var _iterator = _createForOfIteratorHelper(moduleIds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var moduleId = _step.value;

            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }

  function useLoadableModule() {
    init();

    var context = _react.default.useContext(_loadableContext.LoadableContext);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  }

  function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);

    _react.default.useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    return _react.default.useMemo(function () {
      if (state.loading || state.error) {
        return _react.default.createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react.default.createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    useLoadableModule();
    return _react.default.createElement(opts.lazy, _extends({}, props, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react.default.forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      }).catch(function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _extends({}, this._state, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks.delete(callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 36775:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SideEffect;

var _interop_require_wildcard = (__webpack_require__(96808)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(27378));

function SideEffect(props) {
  var headManager = props.headManager,
      reduceComponentsToState = props.reduceComponentsToState;

  function emitChange() {
    if (headManager && headManager.mountedInstances) {
      var headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));

      headManager.updateHead(reduceComponentsToState(headElements, props));
    }
  }

  if (isServer) {
    var ref;
    headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.add(props.children);
    emitChange();
  }

  useClientOnlyLayoutEffect(function () {
    var ref1;
    headManager == null ? void 0 : (ref1 = headManager.mountedInstances) == null ? void 0 : ref1.add(props.children);
    return function () {
      var ref;
      headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.delete(props.children);
    };
  }); // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
  // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
  // being rendered, we only trigger the method from the last one.
  // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
  // singleton in the layout effect pass, and actually trigger it in the effect pass.

  useClientOnlyLayoutEffect(function () {
    if (headManager) {
      headManager._pendingUpdate = emitChange;
    }

    return function () {
      if (headManager) {
        headManager._pendingUpdate = emitChange;
      }
    };
  });
  useClientOnlyEffect(function () {
    if (headManager && headManager._pendingUpdate) {
      headManager._pendingUpdate();

      headManager._pendingUpdate = null;
    }

    return function () {
      if (headManager && headManager._pendingUpdate) {
        headManager._pendingUpdate();

        headManager._pendingUpdate = null;
      }
    };
  });
  return null;
}

var isServer = false;
var useClientOnlyLayoutEffect = isServer ? function () {} : _react.useLayoutEffect;
var useClientOnlyEffect = isServer ? function () {} : _react.useEffect;

/***/ }),

/***/ 4301:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.warnOnce = void 0;

var warnOnce = function warnOnce(_) {};

if (false) { var warnings; }

exports.warnOnce = warnOnce;

/***/ }),

/***/ 33775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F6": function() { return /* binding */ storeBooks; },
/* harmony export */   "p": function() { return /* binding */ CACHE_LANG; },
/* harmony export */   "ve": function() { return /* binding */ checkNetworkCache; },
/* harmony export */   "yu": function() { return /* binding */ CACHE_RELEVANT_FORMS; }
/* harmony export */ });
/* unused harmony exports CACHE_SEARCH_HISTORY, CACHE_SUBSCRIPTION_BOOKS, makeDumpCacheName */
/* harmony import */ var _utils_assembly__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76732);
/* harmony import */ var _utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12202);
/* harmony import */ var _baseApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97649);
/* harmony import */ var _utils_console__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65795);
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62330);
/* harmony import */ var _utils_storage_storage_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79384);
/* harmony import */ var _utils_array__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21707);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-console */







var CACHE_LANG = "langCache";
var CACHE_SEARCH_HISTORY = "searchHistory";
var CACHE_SUBSCRIPTION_BOOKS = "subscriptionBooks";
var CACHE_RELEVANT_FORMS = "relevantSearchForms";
var CACHE_BOOKS = "books_cache";
var scope = "💵 Network cache";
var makeDumpCacheName = function makeDumpCacheName(lang) {
  return "dump_" + lang;
};
var IS_DEBUG = false;

var isDebugCache = function isDebugCache() {
  return (0,_utils_assembly__WEBPACK_IMPORTED_MODULE_0__/* .isDevelopment */ .yG)() && IS_DEBUG;
};

var storeBooks = function storeBooks(books) {
  if (!books) {
    return null;
  }

  var isDebugCacheValue = isDebugCache();
  var bookList = null;
  var t1 = Date.now();
  var cacheValue = _utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .localStorageSafe.getItem */ .NE.getItem(CACHE_BOOKS);

  if (cacheValue) {
    try {
      bookList = JSON.parse(cacheValue);
    } catch (error) {
      (0,_utils_console__WEBPACK_IMPORTED_MODULE_3__/* .consoleLogError */ .aw)("Store books", "Parse cache value ERROR: ", {
        cacheValue: cacheValue,
        key: CACHE_BOOKS
      });
    }
  }

  try {
    var booksWithoutChildren = books.map(function (book) {
      var bookWithoutChildren = _objectSpread({}, book);

      delete bookWithoutChildren.children;
      delete bookWithoutChildren.chapters;
      return bookWithoutChildren;
    });
    bookList = bookList ? (0,_utils_array__WEBPACK_IMPORTED_MODULE_6__/* .joinObjArrays */ .dl)([booksWithoutChildren, bookList]) : booksWithoutChildren;
    (0,_utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .setLocalStorageItem */ .D$)(CACHE_BOOKS, JSON.stringify(bookList), false);
  } catch (e) {
    (0,_utils_console__WEBPACK_IMPORTED_MODULE_3__/* .consoleLogError */ .aw)("Store books", "Save to storage ERROR: ", {
      key: CACHE_BOOKS,
      bookList: bookList
    });
  }

  if (isDebugCacheValue) {
    (0,_utils_console__WEBPACK_IMPORTED_MODULE_3__/* .consoleLogInfo */ .jn)("Store books", "Stored. Time=" + Date.now() - t1, {
      count: bookList.length,
      bookList: bookList,
      books: books
    });
  }

  return bookList;
};

var cleanNetworkCache = function cleanNetworkCache() {
  (0,_utils_console__WEBPACK_IMPORTED_MODULE_3__/* .consoleLogInfo */ .jn)(scope, "Clearing cache...");
  console.groupCollapsed("Network cleared items");
  Object.keys(_utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .localStorageSafe */ .NE).forEach(function (item) {
    if (item.indexOf(_baseApi__WEBPACK_IMPORTED_MODULE_2__/* .CACHE_PREFIX */ .qg) === 0) {
      _utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .localStorageSafe.removeItem */ .NE.removeItem(item);
      console.log(item);
    }
  });
  _utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .localStorageSafe.removeItem */ .NE.removeItem(CACHE_BOOKS);
  console.log(CACHE_BOOKS);
  console.groupEnd();
};

function checkNetworkCache(version) {
  var withReloadIfDiffers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isConsoleLogsSuccessOrInfo = arguments.length > 2 ? arguments[2] : undefined;

  if (window && _utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .localStorageSafe */ .NE && version) {
    var currentVersion = _utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .localStorageSafe.getItem */ .NE.getItem(_utils_storage_storage_constants__WEBPACK_IMPORTED_MODULE_5__/* .STORAGE_KEY_CONTENT_VERSION */ .vj);
    var isVersionDiffers = !!currentVersion && new Date(currentVersion).getTime() !== new Date(version).getTime();

    if (isVersionDiffers) {
      (0,_utils_console__WEBPACK_IMPORTED_MODULE_3__/* .consoleLogWarning */ .b9)("Content version", "Differs! Cache will will be cleaned!");
      (0,_utils_console__WEBPACK_IMPORTED_MODULE_3__/* .consoleLogGroup */ .B9)("More info about content versions", {
        currentVersion: currentVersion,
        version: version
      });
      cleanNetworkCache();
      (0,_utils_dom__WEBPACK_IMPORTED_MODULE_4__/* .dispatchCustomEvent */ .hb)(_utils_storage_storage_constants__WEBPACK_IMPORTED_MODULE_5__/* .CUSTOM_EVENT_CONTENT_VERSION_DIFFERS */ .w_);
      (0,_utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .setLocalStorageItem */ .D$)(_utils_storage_storage_constants__WEBPACK_IMPORTED_MODULE_5__/* .STORAGE_KEY_CONTENT_VERSION */ .vj, version);

      if (withReloadIfDiffers) {
        if (__webpack_require__.g.window) {
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        }
      }
    } else {
      (0,_utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .setLocalStorageItem */ .D$)(_utils_storage_storage_constants__WEBPACK_IMPORTED_MODULE_5__/* .STORAGE_KEY_CONTENT_VERSION */ .vj, version);

      if (isConsoleLogsSuccessOrInfo) {
        (0,_utils_console__WEBPACK_IMPORTED_MODULE_3__/* .consoleLogSuccess */ .UA)("Content version", "OK!");
      }
    }
  }
}

/***/ }),

/***/ 82287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b$": function() { return /* binding */ OtherLogEvents; },
/* harmony export */   "iW": function() { return /* binding */ logOtherEvent; },
/* harmony export */   "l_": function() { return /* binding */ logSearchEvent; },
/* harmony export */   "on": function() { return /* binding */ logNetworkEvent; },
/* harmony export */   "vZ": function() { return /* binding */ SearchLogEvents; }
/* harmony export */ });
/* unused harmony exports logTypes, isCanLogAnythingToAWS, isCanLogAnythingToTech, isCanLogToTechByLogType, makeTechLogsEndpoint, getStoredLogs, flushStoredLogsByData */
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56253);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14206);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13596);
/* harmony import */ var _utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52707);
/* harmony import */ var _utils_url_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59916);
/* harmony import */ var _utils_user_agent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74741);
/* harmony import */ var _utils_assembly__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76732);
/* harmony import */ var _utils_storage_storage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12202);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//* eslint-disable no-console */








var userAgentString = react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .osName */ .BF + " " + react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .osVersion */ .MM + " " + react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .browserName */ .KC + " " + react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .browserVersion */ .x_;
var isDevelopModule = false; // Runtime stores

var mapLogTypeToTimeoutId = {};
var currentlySendingLogTypes = new Set(); // Log types

var LOG_TYPE_SEARCH = "logSearch";
var LOG_TYPE_NETWORK = "logNetwork";
var LOG_TYPE_OTHER = "logOther";
var logTypes = [LOG_TYPE_SEARCH, LOG_TYPE_NETWORK, LOG_TYPE_OTHER]; // AWS logger flags

var isLogNetworkAWS = function isLogNetworkAWS() {
  return false;
};

var isLogOtherAWS = function isLogOtherAWS() {
  return false;
};

var isLogSearchAWS = function isLogSearchAWS() {
  return isDevelopModule || (0,_utils_assembly__WEBPACK_IMPORTED_MODULE_5__/* .isProduction */ .yv)();
};

var isCanLogAnythingToAWS = function isCanLogAnythingToAWS() {
  return isLogNetworkAWS() || isLogOtherAWS() || isLogSearchAWS();
}; // Tech logger flags

var isLogNetworkTech = function isLogNetworkTech() {
  return (0,_utils_assembly__WEBPACK_IMPORTED_MODULE_5__/* .isDevelopment */ .yG)() ? isDevelopModule : false;
};

var isLogOtherTech = function isLogOtherTech() {
  return (0,_utils_assembly__WEBPACK_IMPORTED_MODULE_5__/* .isDevelopment */ .yG)() ? isDevelopModule : false;
};

var isLogSearchTech = function isLogSearchTech() {
  return (0,_utils_assembly__WEBPACK_IMPORTED_MODULE_5__/* .isDevelopment */ .yG)() ? isDevelopModule : false;
};

var isCanLogAnythingToTech = function isCanLogAnythingToTech() {
  return isLogNetworkTech() || isLogOtherTech() || isLogSearchTech();
}; // Common flags

var isLogNetworkNeeded = function isLogNetworkNeeded() {
  return isLogNetworkAWS() || isLogNetworkTech();
};

var isLogSearchNeeded = function isLogSearchNeeded() {
  return isLogSearchAWS() || isLogSearchTech();
};

var isLogOtherNeeded = function isLogOtherNeeded() {
  return isLogOtherAWS() || isLogOtherTech();
};

var isCanLogToAWSByLogType = function isCanLogToAWSByLogType(logType) {
  if (logType === LOG_TYPE_SEARCH) {
    return isLogSearchAWS();
  }

  return false;
};

var isCanLogToTechByLogType = function isCanLogToTechByLogType(logType) {
  if (logType === LOG_TYPE_SEARCH) {
    return isLogSearchTech();
  }

  if (logType === LOG_TYPE_OTHER) {
    return isLogOtherTech();
  }

  if (logType === LOG_TYPE_NETWORK) {
    return isLogNetworkTech();
  }

  return false;
}; // Getters

var getSendTimeoutByLogType = function getSendTimeoutByLogType(logType) {
  return 600000; // 10 minutes
};

var getLogItemsCountMaxByLogType = function getLogItemsCountMaxByLogType(logType) {
  if (logType === LOG_TYPE_OTHER) {
    return 45;
  }

  if (logType === LOG_TYPE_SEARCH) {
    return 30;
  }

  return 60;
};

var techLogsEndpointOrigin = isDevelopModule ? "http://localhost:8080" : "https://yo.pages.egwhite.net";
var makeTechLogsEndpoint = function makeTechLogsEndpoint(logType) {
  var endPoint;

  if (logType === LOG_TYPE_NETWORK) {
    endPoint = "network";
  } else if (logType === LOG_TYPE_OTHER) {
    endPoint = "other";
  } else if (logType === LOG_TYPE_SEARCH) {
    endPoint = "search";
  }

  return techLogsEndpointOrigin + "/api/v1/log/" + endPoint;
}; // Other

var OtherLogEvents = {
  READ_CHAPTER: "read_chapter",
  LISTEN_CHAPTER: "listen_chapter",
  CLICK_SIDE_MENU: "click_side_menu",
  TREE_ITEM_CLICK: "tree_item_click",
  BREADCRUMBS_ITEM_CLICK: "breadcrumbs_item_click",
  READER_ACTION: "reader_action",
  BOOK_TOC_ACTION: "book_toc_action",
  BUY_PRINTED: "buy_printed",
  DOWNLOAD: "download",
  SHARE: "share",
  COPY: "copy",
  PRINT: "print",
  BUY_PACKAGE: "buy_package",
  BUY_BOOK: "buy_book",
  LOGIN: "login",
  BOOK_INTERACTION: "book_interaction"
};
var logOtherEvent = function logOtherEvent(eventType, eventData) {
  if (!isLogOtherNeeded()) {
    return;
  } // TODO add some data


  var webpage_url = window.location.origin + window.location.pathname;
  var fullEventData = {
    event_id: (0,uuid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(),
    event_type: eventType,
    params: eventData,
    user_id: window.userId || "",
    user_lang: window.userLang || (0,_utils_user_agent__WEBPACK_IMPORTED_MODULE_4__/* .getSystemLang */ .aQ)(),
    date: new Date().toISOString(),
    cookie_id: (0,_utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_2__/* .getStableToken */ .vp)(),
    session_id: (0,_utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_2__/* .getSessionToken */ .YW)(),
    webpage_url: webpage_url,
    device_type: react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .deviceType */ .vO
  };
  logEvent(LOG_TYPE_OTHER, fullEventData);
}; // Search

var SearchLogEvents = {
  SEARCH: "search",
  SEARCH_SHORTCUT: "search_shortcut",
  SEARCH_CHANGE_LANG: "search_change_lang",
  SEARCH_LOAD_MORE: "search_load_more",
  SEARCH_CHANGE_POSITION: "search_change_position",
  SEARCH_CLICK: "search_click",
  SEARCH_CLICK_CORRECTION: "search_click_correction",
  SEARCH_CLICK_SUGGESTION: "search_click_suggestion",
  SEARCH_CLICK_HISTORY: "search_click_history",
  PAGE_VIEW: "pageview",
  LOGIN: "login"
};
var SearchLogEventsUnnecessaryForTech = [SearchLogEvents.PAGE_VIEW, SearchLogEvents.LOGIN];
var logSearchEvent = function logSearchEvent(eventType, eventData) {
  if (!isLogSearchNeeded()) {
    return;
  } // TODO add some data


  var webpage_url = window.location.origin + window.location.pathname;
  var fullEventData = {
    event_id: (0,uuid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(),
    event_type: eventType,
    params: eventData,
    user_id: window.userId || "",
    user_lang: window.userLang || (0,_utils_user_agent__WEBPACK_IMPORTED_MODULE_4__/* .getSystemLang */ .aQ)(),
    date: new Date().toISOString(),
    cookie_id: (0,_utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_2__/* .getStableToken */ .vp)(),
    session_id: (0,_utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_2__/* .getSessionToken */ .YW)(),
    webpage_url: webpage_url,
    device_type: react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .deviceType */ .vO
  };
  logEvent(LOG_TYPE_SEARCH, fullEventData);
}; // Network

var logNetworkEvent = function logNetworkEvent(eventData) {
  if (!isLogNetworkNeeded()) {
    return;
  } // TODO add some data


  var fullEventData = _objectSpread(_objectSpread({}, eventData), {}, {
    userId: window.userId || "",
    ua: userAgentString,
    appUrl: (0,_utils_url_url__WEBPACK_IMPORTED_MODULE_3__/* .getBaseHost */ .UO)(),
    date: new Date().toISOString()
  });

  logEvent(LOG_TYPE_NETWORK, fullEventData);
}; // Common

var getStoredLogs = function getStoredLogs(logType) {
  var defaultValue = [];
  var analiticDataString = _utils_storage_storage__WEBPACK_IMPORTED_MODULE_6__/* .localStorageSafe.getItem */ .NE.getItem(logType);
  var analiticDataJson;

  if (analiticDataString) {
    try {
      analiticDataJson = JSON.parse(analiticDataString);

      if (!Array.isArray(analiticDataJson)) {
        analiticDataJson = defaultValue;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log("background: black; color: white;[getStoredLogs] Error: ", analiticDataString);
    }
  } else {
    analiticDataJson = defaultValue;
  }

  return analiticDataJson;
};

var logEvent = function logEvent(logType, eventData) {
  clearTimeout(mapLogTypeToTimeoutId[logType]);
  var analiticDataJson = getStoredLogs(logType);
  analiticDataJson.push(eventData);
  (0,_utils_storage_storage__WEBPACK_IMPORTED_MODULE_6__/* .setLocalStorageItem */ .D$)(logType, JSON.stringify(analiticDataJson));

  if (isDevelopModule) {
    console.log("%c".concat(analiticDataJson.length), "background: ".concat(logType === LOG_TYPE_NETWORK ? "red" : logType === LOG_TYPE_SEARCH ? "blue" : "green", "; color: white;"));
  }

  var isSendImmediately = analiticDataJson.length > getLogItemsCountMaxByLogType(logType) && !currentlySendingLogTypes.has(logType);

  if (isSendImmediately) {
    if (isDevelopModule) {
      console.log("%cSend immediately ".concat(logType), "background: gold; color: white;");
    }

    sendLogsByType(logType);
  } else {
    mapLogTypeToTimeoutId[logType] = setTimeout(function () {
      sendLogsByType(logType);
    }, getSendTimeoutByLogType(logType));
  }
};

var flushStoredLogsByData = function flushStoredLogsByData(logType, logData) {
  var allData = getStoredLogs(logType);
  var simpleList = logData.map(function (item) {
    return item.date;
  });
  var clearList = allData.filter(function (item) {
    return !simpleList.includes(item.date);
  });

  if (isDevelopModule) {
    console.log("flushLogData, new list: ", logType, clearList);
  }

  (0,_utils_storage_storage__WEBPACK_IMPORTED_MODULE_6__/* .setLocalStorageItem */ .D$)(logType, JSON.stringify(clearList));
};

var prepareLogDataForTech = function prepareLogDataForTech(logType, data) {
  if (logType === LOG_TYPE_SEARCH) {
    return data.filter(function (item) {
      return !SearchLogEventsUnnecessaryForTech.includes(item.event_type);
    });
  }

  return data;
};

var prepareLogDataForAWS = function prepareLogDataForAWS(logType, data) {
  var records = [];

  if (logType === LOG_TYPE_SEARCH) {
    records = data.map(function (item) {
      var out = _objectSpread({}, item);

      out.language = item.user_lang;
      out.timestamp = item.date;
      out["event_data"] = item.params;
      delete out.user_lang;
      delete out.date;
      delete out.params;
      return out;
    });
  }

  return {
    records: records
  };
};

var sendLogsByType = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(logType) {
    var logData, egwTechReqResponse, awsReqResponse, isEgwTechError, isAWSError, isCanSendToEgwTechLogger, isCanSendToAWSLogger, isCanFLush;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          logData = getStoredLogs(logType);

          if (isDevelopModule) {
            console.groupCollapsed("Send logs group");
            console.log({
              logType: logType,
              logData: logData
            });
          }

          if (!logData.length) {
            _context.next = 30;
            break;
          }

          isCanSendToEgwTechLogger = isCanLogToTechByLogType(logType);
          isCanSendToAWSLogger = isCanLogToAWSByLogType(logType);
          currentlySendingLogTypes.add(logType); // EGW Tech logger

          if (!isCanSendToEgwTechLogger) {
            _context.next = 16;
            break;
          }

          _context.prev = 7;
          _context.next = 10;
          return axios__WEBPACK_IMPORTED_MODULE_1___default()({
            method: "post",
            url: makeTechLogsEndpoint(logType),
            data: prepareLogDataForTech(logType, logData)
          });

        case 10:
          egwTechReqResponse = _context.sent;
          _context.next = 16;
          break;

        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](7);
          isEgwTechError = true;

        case 16:
          if (!isCanSendToAWSLogger) {
            _context.next = 26;
            break;
          }

          _context.prev = 17;
          _context.next = 20;
          return axios__WEBPACK_IMPORTED_MODULE_1___default()({
            method: "post",
            headers: {
              "x-api-key": (0,_utils_url_url__WEBPACK_IMPORTED_MODULE_3__/* .getSearchLogsToken */ .$F)()
            },
            url: (0,_utils_url_url__WEBPACK_IMPORTED_MODULE_3__/* .getSearchLogsUrl */ .hV)(),
            data: prepareLogDataForAWS(logType, logData)
          });

        case 20:
          awsReqResponse = _context.sent;
          _context.next = 26;
          break;

        case 23:
          _context.prev = 23;
          _context.t1 = _context["catch"](17);
          isAWSError = true;

        case 26:
          // for now, ignore if some api failed to not overfill the storage or send the same data twice.
          isCanFLush = isCanSendToAWSLogger && !isAWSError || isCanSendToEgwTechLogger && !isEgwTechError;

          if (isCanFLush) {
            flushStoredLogsByData(logType, logData);
          }

          currentlySendingLogTypes.delete(logType);

          if (isDevelopModule) {
            console.log("Flush " + (isCanFLush ? "✅" : "❌"));
            console.table({
              isCanSendToAWSLogger: isCanSendToAWSLogger,
              isCanSendToEgwTechLogger: isCanSendToEgwTechLogger,
              isAWSError: isAWSError,
              isEgwTechError: isEgwTechError
            });
            console.log("Logs requests: ", {
              egwTechReqResponse: egwTechReqResponse,
              awsReqResponse: awsReqResponse
            });
          }

        case 30:
          if (isDevelopModule) {
            console.groupEnd("Send logs method");
          }

        case 31:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[7, 13], [17, 23]]);
  }));

  return function sendLogsByType(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 89616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VB": function() { return /* binding */ deleteUserAvatar; },
  "Dm": function() { return /* binding */ getUserAvatar; },
  "x9": function() { return /* binding */ uploadUserAvatar; }
});

// EXTERNAL MODULE: ../shared/utils/url/url.js
var url_url = __webpack_require__(59916);
// EXTERNAL MODULE: ../shared/api/baseApi.js
var baseApi = __webpack_require__(97649);
// EXTERNAL MODULE: ../node_modules/md5/md5.js
var md5_md5 = __webpack_require__(61586);
;// CONCATENATED MODULE: ../shared/api/gravatar.js

var getGravatarImage = function getGravatarImage(email) {
  return "https://www.gravatar.com/avatar/" + md5(email) + "?d=404";
};
;// CONCATENATED MODULE: ../shared/api/avatar/requests.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




var AVATAR_DEFAULT_WIDTH = 80;
var getUserAvatar = function getUserAvatar(userId, email, timestampLastUpdate) {
  var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : AVATAR_DEFAULT_WIDTH;
  var url = (0,url_url/* getAPIUrl */.jE)() + "/avatar/".concat(userId, "?w=").concat(width);

  if (timestampLastUpdate) {
    url = "".concat(url, "&v=").concat(timestampLastUpdate);
  }
  /*if (email) {
    return `${url}&d=${encodeURIComponent(getGravatarImage(email))}`;
  }*/


  return url;
};
var uploadUserAvatar = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0,baseApi/* makeRequest */.$f)({
            url: "/avatar",
            type: "post",
            data: data,
            "Content-type": "multipart/form-data"
          });

        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function uploadUserAvatar(_x) {
    return _ref.apply(this, arguments);
  };
}();
var deleteUserAvatar = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0,baseApi/* makeRequest */.$f)({
            url: "/avatar",
            type: "delete"
          });

        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function deleteUserAvatar() {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 97649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$f": function() { return /* binding */ makeRequest; },
/* harmony export */   "qg": function() { return /* binding */ CACHE_PREFIX; }
/* harmony export */ });
/* unused harmony exports NetworkError, fetchToken */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14206);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_url_url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59916);
/* harmony import */ var _utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52707);
/* harmony import */ var _utils_appServer_appServer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12537);
/* harmony import */ var _analitics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82287);
/* harmony import */ var _utils_assembly__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76732);
/* harmony import */ var _utils_storage_storage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12202);
/* harmony import */ var _utils_console__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65795);
/* harmony import */ var _utils_storage_storage_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79384);
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62330);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65851);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }












var MEMORY_CACHE_TIME = 1000 * 60 * 10; // 10 minutes

var STORAGE_CACHE_TIME = 1000 * 60 * 60 * 24 * 7; //cache for one week

var TAG_NETWORK = "NetworkLog_";
var CACHE_PREFIX = "net_cache.";
var NetworkError = /*#__PURE__*/function (_Error) {
  _inherits(NetworkError, _Error);

  var _super = _createSuper(NetworkError);

  function NetworkError(code, message) {
    var _this;

    _classCallCheck(this, NetworkError);

    _this = _super.call(this, message);
    _this.code = code;
    return _this;
  }

  return _createClass(NetworkError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

function storeCache(name, data) {
  if (window && _utils_storage_storage__WEBPACK_IMPORTED_MODULE_6__/* .localStorageSafe */ .NE) {
    var json = {
      timestamp: Date.now(),
      data: data
    };
    (0,_utils_storage_storage__WEBPACK_IMPORTED_MODULE_6__/* .setLocalStorageItem */ .D$)(name, JSON.stringify(json));
  }
}

function fetchToken(refresh) {
  var _getTokens = (0,_utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_2__/* .getTokens */ .lz)(),
      accessToken = _getTokens.accessToken,
      refreshToken = _getTokens.refreshToken,
      serverToken = _getTokens.serverToken,
      expiresTimestamp = _getTokens.expiresTimestamp;

  if (!refresh) {
    if (accessToken && Date.now() < expiresTimestamp) {
      return Promise.resolve(accessToken);
    }

    if (!refreshToken && serverToken) {
      return serverToken;
    }
  }

  var tokenLink = (0,_utils_url_url__WEBPACK_IMPORTED_MODULE_1__/* .getBaseHost */ .UO)() + _utils_appServer_appServer__WEBPACK_IMPORTED_MODULE_3__/* .APIUrls.getToken */ .Go.getToken;

  if (refreshToken) {
    tokenLink += "?token=" + refreshToken;
  }

  var timeStart = Date.now();
  return axios__WEBPACK_IMPORTED_MODULE_0___default().get(tokenLink).then(function (response) {
    var requestTime = Date.now() - timeStart;

    if (requestTime > 3000) {
      (0,_analitics__WEBPACK_IMPORTED_MODULE_4__/* .logNetworkEvent */ .on)({
        url: "?token=refreshToken",
        method: "get",
        status: "success",
        time: Date.now() - timeStart,
        code: response.status
      });
      (0,_utils_console__WEBPACK_IMPORTED_MODULE_7__/* .consoleLogWarning */ .b9)("Base API", "Long request ".concat((requestTime / 1000).toFixed(1), "s"), {
        requestTime: requestTime,
        tokenLink: tokenLink
      });
    }

    var _response$data = response.data,
        access_token = _response$data.access_token,
        refresh_token = _response$data.refresh_token,
        expires_in = _response$data.expires_in;
    var refToken = refresh_token === undefined ? refreshToken : refresh_token;
    (0,_utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_2__/* .setTokens */ .d0)(access_token, refToken, expires_in);
    return access_token;
  }).catch(function (response) {
    var _response$response;

    if ((response === null || response === void 0 ? void 0 : response.message) === "Request failed with status code 400") {
      (0,_utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_2__/* .setTokens */ .d0)();
    }

    (0,_analitics__WEBPACK_IMPORTED_MODULE_4__/* .logNetworkEvent */ .on)({
      url: "?token=refreshToken",
      time: Date.now() - timeStart,
      status: "error",
      code: ((_response$response = response.response) === null || _response$response === void 0 ? void 0 : _response$response.status) || "unknown"
    });
    return undefined;
  });
}
/**
 * @type {{
 *   [string]: {
 *     timestamp: number,
 *     data: any,
 *   }
 * }}
 */

var MemoryCacheHolder = {};

if (true) {
  window.MemoryCacheHolder = MemoryCacheHolder;
}
/**
 * @typedef {Object} NetworkParams
 * @property {boolean} external
 * @property {!string} url - url, if start without http - adds base API server
 * @property {?string} type=get - get, post, delete, put.
 * @property {?object} data - data for post request
 * @property {?object} headers - additional headers
 * @property {?boolean} skipToken - skip use api token if request for external request
 * @property {?function} parseError - parse error of request
 * @property {?function} parseResponse - parse result of request
 * @property {?boolean} memoryCache - cache get request in memory by url
 * @property {?string} memoryCacheName - cache get request in memory by special name
 * @property {number} memoryCacheTime={@link MEMORY_CACHE_TIME} - set time for cache
 * @property {?string} storageCacheName - Store data in localStorage by name
 * @property {?number} storageCacheTime={@link STORAGE_CACHE_TIME} - set time for cache
 * @property {?string} responseType - e.g. "blob" for zip files
 * @property {?function} onDownloadProgress
 * @property {?Object} cancelTokenKey - key for set request's {axios.CancelToken.source()}
 */

/**
 * base network request for client side
 * @param {NetworkParams} request
 * @param {number} refreshCount
 * @returns
 */


function makeRequest(_x) {
  return _makeRequest.apply(this, arguments);
}

function _makeRequest() {
  _makeRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(request) {
    var refreshCount,
        headers,
        token,
        requestMethod,
        url,
        storageNameWithPrefix,
        cache,
        storageTime,
        jsonCache,
        memoryCacheName,
        time,
        cachedData,
        timeStart,
        cancelTokenSource,
        requestBodyFinal,
        _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          refreshCount = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 0;

          if (request.url) {
            _context2.next = 3;
            break;
          }

          return _context2.abrupt("return", undefined);

        case 3:
          headers = request.headers || {};

          if (request.external) {
            _context2.next = 11;
            break;
          }

          _context2.next = 7;
          return fetchToken(refreshCount !== 0);

        case 7:
          token = _context2.sent;

          if (token) {
            _context2.next = 10;
            break;
          }

          return _context2.abrupt("return", undefined);

        case 10:
          headers.Authorization = "Bearer ".concat(token);

        case 11:
          requestMethod = request.type || "get";

          if (request.url.indexOf("http") === 0) {
            url = request.url;
          } else if (request.url.indexOf("/") === 0) {
            url = (0,_utils_url_url__WEBPACK_IMPORTED_MODULE_1__/* .getAPIUrl */ .jE)() + request.url;
          } else {
            url = (0,_utils_url_url__WEBPACK_IMPORTED_MODULE_1__/* .getAPIUrl */ .jE)() + "/" + request.url;
          }

          storageNameWithPrefix = request.storageCacheName ? CACHE_PREFIX + request.storageCacheName : undefined;

          if (!(window && _utils_storage_storage__WEBPACK_IMPORTED_MODULE_6__/* .localStorageSafe */ .NE && storageNameWithPrefix)) {
            _context2.next = 27;
            break;
          }

          cache = _utils_storage_storage__WEBPACK_IMPORTED_MODULE_6__/* .localStorageSafe.getItem */ .NE.getItem(storageNameWithPrefix);

          if (!cache) {
            _context2.next = 27;
            break;
          }

          _context2.prev = 17;
          storageTime = request.storageCacheTime || STORAGE_CACHE_TIME;
          jsonCache = JSON.parse(cache);

          if (!(jsonCache.data && Date.now() - jsonCache.timestamp < storageTime)) {
            _context2.next = 22;
            break;
          }

          return _context2.abrupt("return", jsonCache.data);

        case 22:
          _context2.next = 27;
          break;

        case 24:
          _context2.prev = 24;
          _context2.t0 = _context2["catch"](17);
          console.log("Error accessing local storage network cache: ", _context2.t0);

        case 27:
          if (!request.memoryCache) {
            _context2.next = 33;
            break;
          }

          if (request.memoryCacheName) {
            memoryCacheName = request.memoryCacheName;
          } else if (requestMethod === "get") {
            memoryCacheName = url;
          }

          time = request.memoryCacheTime || MEMORY_CACHE_TIME;
          cachedData = MemoryCacheHolder[memoryCacheName];

          if (!(cachedData && cachedData.data && Date.now() - cachedData.timestamp < time)) {
            _context2.next = 33;
            break;
          }

          return _context2.abrupt("return", cachedData.data);

        case 33:
          timeStart = Date.now();

          if (request.cancelTokenKey) {
            cancelTokenSource = axios__WEBPACK_IMPORTED_MODULE_0___default().CancelToken.source();
            (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .setRequestCancelTokenSource */ .jj)(request.cancelTokenKey, cancelTokenSource);
          }

          requestBodyFinal = {
            method: requestMethod,
            url: url,
            headers: headers,
            data: request.data,
            responseType: request.responseType,
            onDownloadProgress: request.onDownloadProgress,
            cancelToken: cancelTokenSource ? cancelTokenSource.token : undefined
          };
          return _context2.abrupt("return", axios__WEBPACK_IMPORTED_MODULE_0___default()(requestBodyFinal).then( /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(response) {
              var requestTime, finalResponse;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    requestTime = Date.now() - timeStart;

                    if (requestTime < 1000000) {
                      if ((0,_utils_assembly__WEBPACK_IMPORTED_MODULE_5__/* .isProduction */ .yv)()) {
                        if (requestTime > 3000) {
                          (0,_analitics__WEBPACK_IMPORTED_MODULE_4__/* .logNetworkEvent */ .on)({
                            url: url,
                            method: requestMethod,
                            status: "success",
                            time: Date.now() - timeStart,
                            code: response.status,
                            post_data: request.data
                          });
                          (0,_utils_console__WEBPACK_IMPORTED_MODULE_7__/* .consoleLogWarning */ .b9)("Base API", "Long request ".concat((requestTime / 1000).toFixed(1), "s"), {
                            requestTime: requestTime,
                            requestBodyFinal: requestBodyFinal
                          });
                        }
                      } else {
                        (0,_analitics__WEBPACK_IMPORTED_MODULE_4__/* .logNetworkEvent */ .on)({
                          url: url,
                          method: requestMethod,
                          status: "success",
                          time: Date.now() - timeStart,
                          code: response.status,
                          post_data: request.data
                        });
                      }
                    }

                    finalResponse = response;

                    if (!(typeof request.parseResponse === "function")) {
                      _context.next = 7;
                      break;
                    }

                    _context.next = 6;
                    return request.parseResponse(response);

                  case 6:
                    finalResponse = _context.sent;

                  case 7:
                    if (storageNameWithPrefix) {
                      storeCache(storageNameWithPrefix, finalResponse);
                    }

                    if (memoryCacheName) {
                      MemoryCacheHolder[memoryCacheName] = {
                        timestamp: Date.now(),
                        data: finalResponse
                      };
                    }

                    return _context.abrupt("return", finalResponse);

                  case 10:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));

            return function (_x2) {
              return _ref.apply(this, arguments);
            };
          }()).catch(function (response) {
            if (response.__CANCEL__) {
              if (request.onCancel) {
                request.onCancel();
              }
            } else {
              if (response.response) {
                if (response.response.status !== 304) {
                  console.log("".concat(TAG_NETWORK, "makeRequest error"), url, response);
                }

                (0,_analitics__WEBPACK_IMPORTED_MODULE_4__/* .logNetworkEvent */ .on)({
                  url: url,
                  time: Date.now() - timeStart,
                  status: "error",
                  code: response.response.status
                });

                if (response.response.status === 401) {
                  if (request.external) {
                    throw new NetworkError(response.response.status);
                  } else {
                    var callNumber = refreshCount ? refreshCount + 1 : 1;
                    console.log("%cRefreshing token ", "background: black; color: white;", {
                      callNumber: callNumber
                    });

                    if (callNumber > 5) {
                      (0,_utils_dom__WEBPACK_IMPORTED_MODULE_9__/* .dispatchCustomEvent */ .hb)(_utils_storage_storage_constants__WEBPACK_IMPORTED_MODULE_8__/* .CUSTOM_EVENT_CONTENT_LOGOUT */ .Cn);
                      return undefined;
                    }

                    return makeRequest(request, callNumber);
                  }
                }

                if (request.parseError) {
                  return request.parseError(response.response);
                }
              }
            }

            return undefined;
          }));

        case 37:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[17, 24]]);
  }));
  return _makeRequest.apply(this, arguments);
}

/***/ }),

/***/ 42304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ fetchLegacyUserInfo; },
/* harmony export */   "d": function() { return /* binding */ makeOAuthRequest; }
/* harmony export */ });
/* harmony import */ var _baseApi__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97649);
/* harmony import */ var _shared_utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52707);
/* harmony import */ var _utils_url_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59916);
/* harmony import */ var _not_sorted_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1511);
/* harmony import */ var _utils_appServer_appServer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12537);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }






var fetchLegacyUserInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _getTokens, refreshToken, userinfo;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _getTokens = (0,_shared_utils_systemUtils_systemUtils__WEBPACK_IMPORTED_MODULE_1__/* .getTokens */ .lz)(), refreshToken = _getTokens.refreshToken;

          if (!refreshToken) {
            _context.next = 6;
            break;
          }

          _context.next = 4;
          return (0,_baseApi__WEBPACK_IMPORTED_MODULE_0__/* .makeRequest */ .$f)({
            // url: "user/info/",
            // impl more stable API call when cors will be resolved
            url: (0,_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .getCPanelUrl */ .gU)() + "/connect/legacy-userinfo",
            type: "get",
            parseResponse: _not_sorted_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseResponseDefault */ .t3
          });

        case 4:
          userinfo = _context.sent;
          return _context.abrupt("return", userinfo);

        case 6:
          return _context.abrupt("return", undefined);

        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fetchLegacyUserInfo() {
    return _ref.apply(this, arguments);
  };
}();
function makeOAuthRequest() {
  var authParams = encodeURIComponent("/connect/authorize?response_type=code" + "&client_id=" + (0,_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .getClientId */ .i2)() + "&redirect_uri=" + encodeURIComponent((0,_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .getMainAppHost */ .oq)() + _utils_appServer_appServer__WEBPACK_IMPORTED_MODULE_4__/* .APIUrls.authCallback */ .Go.authCallback) + "&scope=" + encodeURIComponent("user_info writings search " + "studycenter subscriptions offline_access") + "&grant_type=authorization_code" + "&state=test");
  var loginURL = "".concat((0,_utils_url_url__WEBPACK_IMPORTED_MODULE_2__/* .getCPanelUrl */ .gU)(), "/accounts/login/?next=").concat(authParams);
  return window.open(loginURL);
}

/***/ }),

/***/ 60196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ WINDOW_KEY_APP_CANCEL_TOKENS_SOURCES; },
/* harmony export */   "Y": function() { return /* binding */ CONTENT_MEMORY_CACHE_TIME; }
/* harmony export */ });
var WINDOW_KEY_APP_CANCEL_TOKENS_SOURCES = "__APP_CANCEL_TOKENS_SOURCES";
var CONTENT_MEMORY_CACHE_TIME = 1000 * 60 * 60;

/***/ }),

/***/ 67504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ makeBooksDownloadCancelTokenKey; },
/* harmony export */   "l7": function() { return /* binding */ makeAudioDownloadCancelTokenKey; },
/* harmony export */   "ux": function() { return /* binding */ FILES_DOWNLOAD_BOOK; }
/* harmony export */ });
var FILES_DOWNLOAD_BOOK = {
  BOOK: "info.json",
  TOC: "toc.json",
  TRACKS: "tracks.json",
  // isn't used
  PARAS: "para.json" // isn't used

};
var makeBooksDownloadCancelTokenKey = function makeBooksDownloadCancelTokenKey(bookIdOrigin) {
  return "books/download/" + bookIdOrigin;
};
var makeAudioDownloadCancelTokenKey = function makeAudioDownloadCancelTokenKey(bookId) {
  return "audio/download/" + bookId;
};

/***/ }),

/***/ 92834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HC": function() { return /* binding */ getBiblesAllLangsRequest; },
/* harmony export */   "LM": function() { return /* binding */ getBookByIdRequest; },
/* harmony export */   "Nz": function() { return /* binding */ fetchDownloadBook; },
/* harmony export */   "Uf": function() { return /* binding */ getBooksRequest; },
/* harmony export */   "gI": function() { return /* binding */ getFolderBooksRequest; },
/* harmony export */   "i6": function() { return /* binding */ getSGBooksRequest; },
/* harmony export */   "tu": function() { return /* binding */ getBookTocById; },
/* harmony export */   "zm": function() { return /* binding */ getAbbreviationsRequest; }
/* harmony export */ });
/* harmony import */ var _baseApi__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97649);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26343);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67504);
/* harmony import */ var _not_sorted_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1511);
/* harmony import */ var _shared_api_content_languages_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20394);
/* harmony import */ var _shared_utils_content_content__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69051);
/* harmony import */ var _shared_api_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60196);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }








var fetchDownloadBook = function fetchDownloadBook(book, onDownloadProgress, onCancel) {
  return (0,_baseApi__WEBPACK_IMPORTED_MODULE_0__/* .makeRequest */ .$f)({
    url: book.download,
    type: "get",
    responseType: "blob",
    parseResponse: _not_sorted_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseResponseDefault */ .t3,
    onDownloadProgress: onDownloadProgress,
    onCancel: onCancel,
    cancelTokenKey: (0,_constants__WEBPACK_IMPORTED_MODULE_2__/* .makeBooksDownloadCancelTokenKey */ .$0)(book.book_id)
  });
};
var getAbbreviationsRequest = function getAbbreviationsRequest() {
  var request = {
    url: "/content/books/abbreviations",
    type: "GET",
    parseResponse: function parseResponse(response) {
      return (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .convertAbbreviations */ .cE)(response.data);
    }
  };
  return (0,_baseApi__WEBPACK_IMPORTED_MODULE_0__/* .makeRequest */ .$f)(request);
};
var getBiblesAllLangsRequest = function getBiblesAllLangsRequest() {
  return (0,_baseApi__WEBPACK_IMPORTED_MODULE_0__/* .makeRequest */ .$f)({
    url: "/content/books?type=bible",
    storageCacheName: (0,_shared_api_content_languages_utils__WEBPACK_IMPORTED_MODULE_5__/* .makeFolderCacheName */ .K)("bibles"),
    parseResponse: function parseResponse(response) {
      return (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .convertBooks */ .hI)(response.data.results);
    }
  });
};
var getSGBooksRequest = function getSGBooksRequest() {
  return (0,_baseApi__WEBPACK_IMPORTED_MODULE_0__/* .makeRequest */ .$f)({
    url: "/content/books?search=" + encodeURIComponent("Study Guide"),
    storageCacheName: (0,_shared_api_content_languages_utils__WEBPACK_IMPORTED_MODULE_5__/* .makeFolderCacheName */ .K)("studyGuide"),
    parseResponse: function parseResponse(response) {
      return (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .convertBooks */ .hI)(response.data.results);
    }
  });
};
var getFolderBooksRequest = function getFolderBooksRequest(id) {
  return (0,_baseApi__WEBPACK_IMPORTED_MODULE_0__/* .makeRequest */ .$f)({
    url: "/content/books/by_folder/".concat(id),
    storageCacheName: (0,_shared_api_content_languages_utils__WEBPACK_IMPORTED_MODULE_5__/* .makeFolderCacheName */ .K)(id),
    parseResponse: function parseResponse(response) {
      return (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .convertBooks */ .hI)(response.data);
    }
  });
};
var getBookByIdRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
    var realId, bookData;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          realId = (0,_shared_utils_content_content__WEBPACK_IMPORTED_MODULE_4__/* .getBookIdNumber */ .o8)(id);
          _context.next = 3;
          return (0,_baseApi__WEBPACK_IMPORTED_MODULE_0__/* .makeRequest */ .$f)({
            url: "content/books/".concat(realId),
            memoryCache: true,
            memoryCacheTime: _shared_api_constants__WEBPACK_IMPORTED_MODULE_6__/* .CONTENT_MEMORY_CACHE_TIME */ .Y,
            parseResponse: function parseResponse(response) {
              return (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .convertBook */ .RC)(response.data);
            }
          });

        case 3:
          bookData = _context.sent;

          if (!((bookData === null || bookData === void 0 ? void 0 : bookData.id) !== id)) {
            _context.next = 6;
            break;
          }

          return _context.abrupt("return", undefined);

        case 6:
          return _context.abrupt("return", bookData);

        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function getBookByIdRequest(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getBookTocById = function getBookTocById(bookIdOrigin) {
  return (0,_baseApi__WEBPACK_IMPORTED_MODULE_0__/* .makeRequest */ .$f)({
    url: "content/books/".concat(bookIdOrigin, "/toc"),
    memoryCache: true,
    memoryCacheTime: _shared_api_constants__WEBPACK_IMPORTED_MODULE_6__/* .CONTENT_MEMORY_CACHE_TIME */ .Y,
    parseResponse: function parseResponse(response) {
      return (0,_shared_utils_content_content__WEBPACK_IMPORTED_MODULE_4__/* .makeChapterTree */ .o)(response.data);
    }
  });
};

var _getBooksRequest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(ids) {
    var args;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          args = ids.map(function (item) {
            return "pubnr=" + item;
          }).join("&");
          return _context2.abrupt("return", (0,_baseApi__WEBPACK_IMPORTED_MODULE_0__/* .makeRequest */ .$f)({
            url: "content/books?".concat(args),
            type: "get",
            memoryCache: true,
            memoryCacheTime: _shared_api_constants__WEBPACK_IMPORTED_MODULE_6__/* .CONTENT_MEMORY_CACHE_TIME */ .Y,
            parseResponse: function parseResponse(response) {
              return (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .convertBooks */ .hI)(response.data.results);
            }
          }));

        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function _getBooksRequest(_x2) {
    return _ref2.apply(this, arguments);
  };
}(); // Workaround for loading big amount of books.


var getBooksRequest = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(bookIds) {
    var allList, ids, partIds, books;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          allList = [];
          ids = _toConsumableArray(bookIds);

        case 2:
          if (!(ids.length !== 0)) {
            _context3.next = 10;
            break;
          }

          partIds = ids.splice(0, 100);
          _context3.next = 6;
          return _getBooksRequest(partIds);

        case 6:
          books = _context3.sent;

          if (books) {
            allList.push.apply(allList, _toConsumableArray(books));
          }

          _context3.next = 2;
          break;

        case 10:
          return _context3.abrupt("return", allList);

        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));

  return function getBooksRequest(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ 26343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RC": function() { return /* binding */ convertBook; },
/* harmony export */   "cE": function() { return /* binding */ convertAbbreviations; },
/* harmony export */   "hI": function() { return /* binding */ convertBooks; }
/* harmony export */ });
/* unused harmony export convertAbbreviation */
/* harmony import */ var _shared_utils_content_content__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69051);
/* harmony import */ var _shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5626);
var _excluded = ["cover"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var convertAbbreviation = function convertAbbreviation(abbr) {
  var chars = [];
  abbr.abbreviations.forEach(function (string) {
    chars.push(string.trim().substr(0, 1));
  });
  return _objectSpread(_objectSpread({}, abbr), {}, {
    firstChars: chars
  });
};
var convertAbbreviations = function convertAbbreviations(abbreviations) {
  return {
    egw: abbreviations.egw.map(function (abbr) {
      return convertAbbreviation(abbr);
    }),
    bible: abbreviations.bible.map(function (abbr) {
      return convertAbbreviation(abbr);
    })
  };
};
var convertBooks = function convertBooks(books) {
  return books.map(convertBook);
};
var convertBook = function convertBook(item) {
  var firstChar = (0,_shared_utils_content_content__WEBPACK_IMPORTED_MODULE_0__/* .getFirstTitleChar */ .HS)(item.title);
  var realType = item.folder_color_group || item.subtype || item.type;

  if (_shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_1__/* .BOOK_TYPES.indexOf */ .yj.indexOf(item.type) !== -1) {
    realType = item.type;
  }

  var isForSale = item.permission_required === _shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_1__/* .BOOK_PERMISSION.purchased */ .k$.purchased;

  var cover = item.cover,
      otherBookProps = _objectWithoutProperties(item, _excluded);

  var bookData = _objectSpread(_objectSpread({}, otherBookProps), {}, {
    realType: realType,
    label: item.title,
    className: "book",
    id: (0,_shared_utils_content_content__WEBPACK_IMPORTED_MODULE_0__/* .getBookIdWithPrefix */ .NR)(item.book_id),
    pubYear: parseInt(otherBookProps.pub_year) || 0,
    firstChar: firstChar,
    isForSale: isForSale
  });

  if (cover) {
    if (cover.small) {
      bookData.coverSmall = cover.small;
    }

    if (cover.large) {
      bookData.coverLarge = cover.large;
    }
  }

  return bookData;
};

/***/ }),

/***/ 11034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tV": function() { return /* binding */ checkContentVersionRequest; },
  "di": function() { return /* binding */ fetchDictionariesRequest; },
  "Yn": function() { return /* binding */ getBibleLanguagesRequest; },
  "DP": function() { return /* binding */ getBibliographyRequest; },
  "FV": function() { return /* binding */ getContentPreviewBible; },
  "Wf": function() { return /* binding */ getParagraphsRequest; }
});

// UNUSED EXPORTS: getContentPreviewRequest, getParaByPeriodRefCode, getParaByRefCode, getParaByRefCodeRequest, resolveParaByRefCode

// EXTERNAL MODULE: ../shared/api/baseApi.js
var baseApi = __webpack_require__(97649);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
;// CONCATENATED MODULE: ../shared/api/content/utils.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var parseResponseBibleContents = function parseResponseBibleContents(response) {
  if (response.data.paragraphs) {
    return response.data.paragraphs.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        bookId: (0,content/* getBookIdWithPrefix */.NR)(item.para_id),
        paraId: item.para_id
      });
    });
  }

  return [];
};
var utils_parseResponseContentPreview = function parseResponseContentPreview(response) {
  var outData = [];

  if (response.data.original) {
    outData.push(response.data.original);
  }

  if (response.data.translations) {
    outData.push.apply(outData, _toConsumableArray(response.data.translations));
  }

  return outData.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      bookId: getBookIdWithPrefix(item.para_id),
      paraId: item.para_id
    });
  });
};
var parseResponseCheckContentVersion = function parseResponseCheckContentVersion(response) {
  var _response$data;

  return (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.version;
};
// EXTERNAL MODULE: ../shared/api/not-sorted.utils.js
var not_sorted_utils = __webpack_require__(1511);
// EXTERNAL MODULE: ../shared/api/content/constants.js
var constants = __webpack_require__(84520);
// EXTERNAL MODULE: ../shared/api/search/advanced/requests.js + 1 modules
var requests = __webpack_require__(23157);
// EXTERNAL MODULE: ../shared/api/search/suggestions/requests.js + 1 modules
var suggestions_requests = __webpack_require__(33967);
// EXTERNAL MODULE: ../shared/utils/content/content.constants.js
var content_constants = __webpack_require__(5626);
// EXTERNAL MODULE: ../shared/utils/search/search.constants.js
var search_constants = __webpack_require__(80226);
// EXTERNAL MODULE: ../shared/api/utils.js
var utils = __webpack_require__(65851);
// EXTERNAL MODULE: ../shared/utils/search/advanced/advanced.js
var advanced = __webpack_require__(55082);
;// CONCATENATED MODULE: ../shared/api/content/common.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function common_toConsumableArray(arr) { return common_arrayWithoutHoles(arr) || common_iterableToArray(arr) || common_unsupportedIterableToArray(arr) || common_nonIterableSpread(); }

function common_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function common_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function common_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return common_arrayLikeToArray(arr); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function common_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function common_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? common_ownKeys(Object(source), !0).forEach(function (key) { common_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : common_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function common_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || common_unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function common_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return common_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return common_arrayLikeToArray(o, minLen); }

function common_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }












var getContentPreviewBible = function getContentPreviewBible(bibleId, targetBibles, targetParagraphs) {
  var url = "content/preview/bible/".concat((0,content/* getBookIdNumber */.o8)(bibleId), "?");
  var pubnrs = targetBibles.map(function (item) {
    return "pubnr=" + (0,content/* getBookIdNumber */.o8)(item);
  });

  if (pubnrs.length) {
    url += pubnrs.join("&");
  }

  var paras = targetParagraphs.map(function (item) {
    var para = item.indexOf(".") !== -1 ? item.split(".")[1] : item;
    return "para=" + para;
  });

  if (paras.length) {
    url += "&" + paras.join("&");
  }

  return (0,baseApi/* makeRequest */.$f)({
    url: url,
    memoryCache: true,
    parseResponse: parseResponseBibleContents
  });
};
var getContentPreviewRequest = function getContentPreviewRequest(paraId, langs) {
  var url = "content/preview/".concat(paraId);

  if (langs) {
    var langParams = langs.map(function (item) {
      return "lang=" + item;
    });
    url += "?" + langParams.join("&");
  }

  return makeRequest({
    url: url,
    memoryCache: true,
    parseResponse: parseResponseContentPreview
  });
};
var getParaByPeriodRefCode = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(refs, periodicals, book) {
    var _refs, pubnr, year, month, day, paragraph, defaultExtras, extras, bookId, data;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _refs = _slicedToArray(refs, 5), pubnr = _refs[0], year = _refs[1], month = _refs[2], day = _refs[3], paragraph = _refs[4];
          defaultExtras = {
            type: "periodicals",
            daterange: "all"
          };
          extras = common_objectSpread({}, defaultExtras);
          bookId = getBookIdByCode(periodicals, pubnr, book.book_id);

          if (year) {
            _context.next = 11;
            break;
          }

          if (bookId) {
            _context.next = 7;
            break;
          }

          return _context.abrupt("return", {
            status: "error",
            message: "codeNotFound"
          });

        case 7:
          extras.pubnr = bookId;
          _context.next = 10;
          return AdvSearchNavigationRequest(extras);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
          extras.date = "".concat(year, "-").concat(getOrderNumberOfMonth(month), "-").concat(day || "1");

          if (bookId) {
            extras.pubnr = bookId;
          }

          extras.paragraph = paragraph || "1";
          _context.next = 16;
          return AdvSearchNavigationRequest(extras);

        case 16:
          data = _context.sent;

          if (data) {
            _context.next = 19;
            break;
          }

          return _context.abrupt("return", {
            status: "error",
            message: "dateNotFound"
          });

        case 19:
          return _context.abrupt("return", data);

        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function getParaByPeriodRefCode(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}()));
var resolveParaByRefCode = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(refs, periodicals, book, langs, baseBible) {
    var isBible, isPeriodical, _refs2, ref1, ref2, ref3, params, delimiter, postfix;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          isBible = book.realType === "bible";
          isPeriodical = book.realType === "periodicals";

          if (!isPeriodical) {
            _context2.next = 4;
            break;
          }

          return _context2.abrupt("return", getParaByPeriodRefCode(refs, periodicals, book));

        case 4:
          _refs2 = _slicedToArray(refs, 3), ref1 = _refs2[0], ref2 = _refs2[1], ref3 = _refs2[2];
          params = {
            query: "",
            langs: langs,
            bibleId: isBible ? getBiblePubnr(baseBible) : book.book_id
          };
          delimiter = isBible ? ":" : ".";
          postfix = _createPostfix(ref2, ref3, delimiter);
          params.query = postfix ? "".concat(ref1, " ").concat(postfix) : ref1; // if chapter is empty - change chapter and paragraph to "1"

          if (!ref2) {
            refs[1] = "1";
            refs[2] = "1";
          }

          return _context2.abrupt("return", getParaByRefCodeRequest(refs, params, book.book_id, book.lang, isBible));

        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function resolveParaByRefCode(_x4, _x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}()));

var _createPostfix = function _createPostfix(ref2, ref3, delimiter) {
  return [ref2 || 1, ref3 || 1].join(delimiter);
};

var getParaByRefCodeRequest = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(refs, params, bookId, bookLang) {
    var _res, _res2, _res3;

    var isBible,
        _refs3,
        ref1,
        ref2,
        ref3,
        res,
        _args3 = arguments;

    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          isBible = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : false;
          _refs3 = _slicedToArray(refs, 3), ref1 = _refs3[0], ref2 = _refs3[1], ref3 = _refs3[2];
          _context3.next = 4;
          return getSearchSuggestionsShortcutRequest(params.query, params.bibleId, params.langs);

        case 4:
          res = _context3.sent;

          if (!((_res = res) !== null && _res !== void 0 && _res.para_id)) {
            _context3.next = 7;
            break;
          }

          return _context3.abrupt("return", res);

        case 7:
          _context3.next = 9;
          return getParaByRefCode({
            ref1: ref1,
            ref2: ref2,
            ref3: ref3,
            bookId: bookId,
            isBible: isBible,
            lang: bookLang
          });

        case 9:
          res = _context3.sent;

          if (!((_res2 = res) !== null && _res2 !== void 0 && _res2.para_id)) {
            _context3.next = 12;
            break;
          }

          return _context3.abrupt("return", res);

        case 12:
          _context3.next = 14;
          return getParaByRefCode({
            ref1: ref1,
            ref3: "1",
            bookId: bookId,
            isBible: isBible,
            lang: bookLang
          });

        case 14:
          res = _context3.sent;

          if (!((_res3 = res) !== null && _res3 !== void 0 && _res3.para_id)) {
            _context3.next = 17;
            break;
          }

          return _context3.abrupt("return", res);

        case 17:
          _context3.next = 19;
          return getParaByRefCode({
            ref1: ref1,
            ref3: "1",
            bookId: bookId,
            isBible: false
          });

        case 19:
          res = _context3.sent;
          return _context3.abrupt("return", res);

        case 21:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));

  return function getParaByRefCodeRequest(_x9, _x10, _x11, _x12) {
    return _ref3.apply(this, arguments);
  };
}()));
var getParaByRefCode = function getParaByRefCode(_ref4) {
  var ref1 = _ref4.ref1,
      ref2 = _ref4.ref2,
      ref3 = _ref4.ref3,
      bookId = _ref4.bookId,
      isBible = _ref4.isBible,
      lang = _ref4.lang,
      code = _ref4.code;
  var params = [];
  var type = isBible ? "bible" : "book";
  params.push("type=".concat(type));

  if (ref1) {
    params.push(isBible ? "bible_code=".concat(ref1) : "code=".concat(ref1));
  }

  if (ref2) {
    params.push(isBible ? "chapter=".concat(ref2) : "page=".concat(ref2));
  }

  if (ref3) {
    params.push(isBible ? "verse=".concat(ref3) : "paragraph=".concat(ref3));
  }

  if (lang) {
    params.push("lang=".concat(lang));
  }

  if (code && isBible) {
    params.push("code=".concat(code));
  }

  if (bookId && isBible) {
    params.push("book_id=".concat(bookId));
  }

  return makeRequest({
    url: "content/utilities/paraid?".concat(params.join("&")),
    memoryCache: true,
    parseResponse: parseResponseDefault
  });
};
var fetchDictionariesRequest = function fetchDictionariesRequest() {
  var request = {
    // There was no dictionaries for non-english languages.
    url: "content/books?type=dictionary&lang=en",
    type: "get",
    parseResponse: function parseResponse(response) {
      var options = response.data.results.map(function (item) {
        return {
          key: item.book_id,
          label: "".concat(item.title, " (").concat(item.code, ")"),
          isForSale: item.action_required === content_constants/* BOOK_PERMISSION.purchased */.k$.purchased,
          id: (0,content/* getBookIdWithPrefix */.NR)(item.para_id),
          className: "book"
        };
      });
      return [search_constants/* dictionaryDefaultFilter */.kV].concat(common_toConsumableArray(options));
    }
  };
  return (0,baseApi/* makeRequest */.$f)(request);
};
var bibleExpireTime = 60 * 60 * 1000; // 1 hour

var getBibleLanguagesRequest = function getBibleLanguagesRequest() {
  var url = "content/books/biblelang";
  return (0,baseApi/* makeRequest */.$f)({
    url: url,
    storageCacheName: url,
    storageCacheTime: bibleExpireTime,
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  });
};
var getBibliographyRequest = function getBibliographyRequest(lang, page, order, extras) {
  //const [bookId, chapterId] = paraId.split(".");
  if (extras["type"]) {
    delete extras["type"];
  }

  var paramsString = (0,utils/* makeParamsString */.HR)(extras, true);
  var searchExtras = paramsString ? "?".concat(paramsString, "&") : "?";
  var args = Object.entries(order).length !== 0 ? "sort=" + order.sort + "&order=" + order.order + "&page=" + page : "sort=default&order=asc&page=" + page;
  var request = {
    url: "content/languages/".concat(lang, "/bibliography/").concat(searchExtras).concat(args),
    type: "get",
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  };
  return (0,baseApi/* makeRequest */.$f)(request);
};
var getParagraphsRequest = function getParagraphsRequest(paraId, limit) {
  var loadDirection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : constants/* LoadDirection.both */.b.both;
  var highlight = arguments.length > 3 ? arguments[3] : undefined;

  var _paraId$split = paraId.split("."),
      _paraId$split2 = _slicedToArray(_paraId$split, 2),
      bookId = _paraId$split2[0],
      chapterId = _paraId$split2[1];

  var queries = ["trans=all"];

  if (limit) {
    queries.push("limit=" + limit);
  }

  if (loadDirection) {
    queries.push("direction=" + loadDirection);
  }

  if (highlight) {
    var _highlight$match;

    // Single quote replacing is a fix of:
    // `Darryl says that if we search phrase and in has a quote only
    // in the beginning or only in the end, then results are not highlighted in reader`
    var highlightFinal = ((_highlight$match = highlight.match(/"/g)) === null || _highlight$match === void 0 ? void 0 : _highlight$match.length) === 1 ? highlight.replace("\"", "") : highlight;
    queries.push("highlight=" + highlightFinal);
  }

  return (0,baseApi/* makeRequest */.$f)({
    url: "content/books/".concat(bookId, "/content/").concat(chapterId, "?") + queries.join("&"),
    memoryCache: true,
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  });
};
var checkContentVersionRequest = function checkContentVersionRequest() {
  return (0,baseApi/* makeRequest */.$f)({
    url: "/content/version",
    parseResponse: parseResponseCheckContentVersion
  });
};

/***/ }),

/***/ 84520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ LoadDirection; }
/* harmony export */ });
var LoadDirection = {
  up: "up",
  down: "down",
  both: "both"
};

/***/ }),

/***/ 20394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ makeFolderCacheName; },
/* harmony export */   "u": function() { return /* binding */ normalizeLanguageFolders; }
/* harmony export */ });
var makeFolderCacheName = function makeFolderCacheName(folderId) {
  return "folder_" + folderId;
};
/**
 * @typedef Folder
 * @property waveformsDictionary: {},
 * @property nbooks: number,
 * @property nAudioBooks: number,
 * @property value: number,
 * @property id: number,
 * @property label: string,
 * @property className: string,
 * @property totalCount: number,
 * @property totalAudioCount: number,
 * @property children: Folder[],
 * @property lang: string,
 */

/**
 * @param {{}[]} folders – API folders
 * @param {string} lang – language
 * @returns {{totalAudioCount: number, totalCount: number, outList: Folder[]}}
 */

var normalizeLanguageFolders = function normalizeLanguageFolders(folders, lang) {
  if (!folders) {
    return {
      totalCount: 0,
      totalAudioCount: 0,
      outList: []
    };
  }

  var totalCount = 0;
  var totalAudioCount = 0;
  var outList = [];
  folders.forEach(function (item) {
    var outChildren = normalizeLanguageFolders(item.children, lang);
    totalCount += item.nbooks;
    totalCount += outChildren.totalCount;
    totalAudioCount += item.naudiobooks;
    totalAudioCount += outChildren.totalAudioCount;
    outList.push({
      nbooks: item.nbooks,
      nAudioBooks: item.naudiobooks,
      value: item.folder_id,
      id: item.folder_id,
      label: item.name,
      className: item.add_class,
      totalCount: outChildren.totalCount,
      totalAudioCount: outChildren.totalAudioCount,
      children: outChildren.outList,
      lang: lang
    });
  });
  return {
    totalCount: totalCount,
    totalAudioCount: totalAudioCount,
    outList: outList
  };
};

/***/ }),

/***/ 58890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ak": function() { return /* binding */ addBooksToLibraryRequest; },
  "oP": function() { return /* binding */ deleteBooksFromLibraryRequest; },
  "Bb": function() { return /* binding */ fetchLibraryLanguagesRequest; },
  "XH": function() { return /* binding */ getAllHistoryRequest; },
  "Ym": function() { return /* binding */ getChapterContentRequest; },
  "NL": function() { return /* binding */ getContactUsRequest; },
  "Gn": function() { return /* binding */ getGeoIpData; },
  "iJ": function() { return /* binding */ getLanguagesRequest; },
  "Dt": function() { return /* binding */ getSettingsRequest; },
  "O1": function() { return /* binding */ getWaveformRequest; },
  "Z5": function() { return /* binding */ putHistoryRequest; },
  "UR": function() { return /* binding */ saveSettingsRequest; },
  "b8": function() { return /* binding */ sendContact; },
  "au": function() { return /* binding */ setLibraryLanguagesRequest; }
});

// UNUSED EXPORTS: deleteMlItem, deleteSearchHistory, fetchBaseDataRequest, fetchBaseUserDataRequest, getAbbreviationsRequest, getAggregateRequest, getBookAudioHistory, getBookReadHistory, getChapterContentRequestLite, getHistoryRequest, getSubscriptionBooksRequest, sendCFTypo

// EXTERNAL MODULE: ../main/src/utils/Utils.js
var Utils = __webpack_require__(47599);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
// EXTERNAL MODULE: ../shared/utils/content/content.constants.js
var content_constants = __webpack_require__(5626);
// EXTERNAL MODULE: ../shared/utils/reader/reader-notes.js
var reader_notes = __webpack_require__(41674);
;// CONCATENATED MODULE: ../main/src/utils/ContentUtils.js





const makeChapterTree = (/* unused pure expression or super */ null && (makeChapterTreeShared));

const externalRefRE = /href\s*=\s*['"]https?:\/\/[^\s]+['"]/gis;

const addBlankTarget = (string) => {
  const matches = string.match(externalRefRE);

  if (matches) {
    return string.replace(externalRefRE, `target="_blank" ${matches[0]}'`);
  }

  return string;
};

const DataLinkRegex = /data-link="(.*?)"/gm;

const getAllDataLink = (paragraphs) => {
  let links = [];
  let resItem;
  paragraphs.forEach((item) => {
    const result = item.content.match(DataLinkRegex);
    result.forEach((matchResult) => {
      resItem = matchResult.split("\"")[1];
      if (!links.includes(resItem)) {
        links.push(resItem);
      }
    });
  });
  return links;
};

/**
 *
 * @param {Object[]} paras
 * @param {String} bookRealType
 * @param {*} bookType
 * @returns
 */
const makeChapterContent = (paras, bookRealType, bookType) => {
  const isRealTypeBible = (0,content/* isBookRealTypeBible */.$s)(bookRealType);
  const isRealTypeBibleCommentaries = (0,content/* isBookRealTypeBibleCommentaries */.$9)(bookRealType);

  let htmlElement;
  const paragraphsParsed = paras.map((item, index) => {
    htmlElement = (!htmlElement || htmlElement.tagName !== item.element_type)
      ? document.createElement(item.element_type || "div")
      : htmlElement;
    const outPara = {
      ...item,
      id: item.para_id || item.id,
      bookType: bookRealType,
      className: content_constants/* CONTENT_CLASSES.PARAGRAPH */.J8.PARAGRAPH,
    };
    outPara.content = addBlankTarget(outPara.content);

    const firstLinkIndex = outPara.content.indexOf(content_constants/* CONTENT_CLASSES.EGW_LINK */.J8.EGW_LINK);
    const isNeedParseLinks = firstLinkIndex > -1 && !outPara.links;

    // not needed parse again if make data from cache
    if (isNeedParseLinks || isRealTypeBible) {
      htmlElement.innerHTML = outPara.content;
      (0,reader_notes/* highlightContainingMarkNoteElements */.V)(htmlElement);

      if (isNeedParseLinks) {
        const allLinks = htmlElement.getElementsByClassName(content_constants/* CONTENT_CLASSES.EGW_LINK */.J8.EGW_LINK);
        let links = [];
        let icon;
        const linkClassName = content_constants/* CONTENT_CLASSES.ICON_BIBLE */.J8.ICON_BIBLE + " icon-bible";
        Array.from(allLinks).forEach((link) => {
          if (link.classList.contains(content_constants/* CONTENT_CLASSES.EGW_LINK_BIBLE */.J8.EGW_LINK_BIBLE)) {
            icon = `<i class="${linkClassName}" data-link="${link.dataset.link}"></i>`;
            if (!link.innerText) {
              link.classList.add("icon-link-empty");
              link.innerHTML = "<i class=\"icon-arrow-right \"></i>";
            }
            link.insertAdjacentHTML("afterend", icon);
            link.removeAttribute("title");
            links.push({ type: content_constants/* CONTENT_CLASSES.EGW_LINK_BIBLE */.J8.EGW_LINK_BIBLE, link: link.dataset.link });
          } else {
            links.push({ type: content_constants/* CONTENT_CLASSES.EGW_LINK */.J8.EGW_LINK, link: link.dataset.link });
          }
        });
        outPara.links = links;
      }

      // Removes bible verse number (bold text before paragraph),
      // It is needed for Bible Versions, because that bold text is generated manually there,
      // don't know about other types of bible.
      // – Skip removing for Bible Commentaries, because there is important content.
      if (isRealTypeBible && !isRealTypeBibleCommentaries) {
        htmlElement.querySelector("strong")?.remove();
      }
      // ============================

      outPara.content = htmlElement.innerHTML;
    }

    const paraDataFinal = (0,content/* makeParaDataFinal */.bp)(bookType, bookRealType, outPara, index);

    outPara.label = paraDataFinal.labelFinal;
    outPara.treeLabel = paraDataFinal.labelTreeFinal;

    if (outPara.treeLabel === content_constants/* TREE_LABEL_HIDE_IN_TREE */.Vz) {
      outPara.content = "";
    } else {
      outPara.content = (0,Utils/* trimBr */.jR)(outPara.content);
    }

    return outPara;
  });

  if (htmlElement?.remove) {
    htmlElement.remove();
  }

  return paragraphsParsed;
};

const cutOutHeaders = (dateContent) => {
  dateContent.forEach((item) => {
    item.content = item.content.filter((tag) => !tag.includes("</h1>"));
  });
  return dateContent;
};

const normalizeSubsContent = (content) => {
  return content.map((item) => ({
    ...item,
    baseId: item.id,
    id: "sub" + item.id, //make special if for avoid endless tree rerender
    className: "subscription",
    label: item.book_title,
  }));
};

// EXTERNAL MODULE: ../shared/api/CacheHolder.js
var CacheHolder = __webpack_require__(33775);
// EXTERNAL MODULE: ../shared/api/not-sorted.utils.js
var not_sorted_utils = __webpack_require__(1511);
// EXTERNAL MODULE: ../shared/api/baseApi.js
var baseApi = __webpack_require__(97649);
// EXTERNAL MODULE: ../shared/api/content/books/utils.js
var utils = __webpack_require__(26343);
// EXTERNAL MODULE: ../shared/utils/search/search.constants.js
var search_constants = __webpack_require__(80226);
// EXTERNAL MODULE: ../shared/api/constants.js
var constants = __webpack_require__(60196);
;// CONCATENATED MODULE: ../shared/api/not-sorted.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }











var fetchBaseDataRequest = function fetchBaseDataRequest(lang) {
  return makeRequest({
    url: "/aggregate/anonymous/" + lang,
    storageCacheName: makeDumpCacheName(lang),
    parseResponse: function parseResponse(response) {
      var _allData$bibleBooks;

      var outData = {};
      var allData = response.data;

      if (allData["dictionary-books"]) {
        var dictionaries = allData["dictionary-books"].results;

        if (dictionaries) {
          dictionaries = dictionaries.map(function (item) {
            return {
              key: item.book_id,
              label: "".concat(item.title, " (").concat(item.code, ")")
            };
          });
          dictionaries.unshift(dictionaryDefaultFilter);
          outData.dictionaries = dictionaries;
        }
      }

      if ((_allData$bibleBooks = allData["bible-books"]) !== null && _allData$bibleBooks !== void 0 && _allData$bibleBooks.results) {
        outData.bibles = convertBooks(allData["bible-books"].results);
      }

      if (allData["subscription-books"]) {
        outData.subscriptions = allData["subscription-books"].map(function (item) {
          return getBookIdWithPrefix(item.book_id);
        });
      }

      if (allData["search-periods"]) {
        var presets = allData["search-periods"];

        if (allData["search-apl"]) {
          var _allData$searchApl$b, _allData$searchApl$p, _allData$searchApl$b2;

          presets.apl = {
            books: [].concat(_toConsumableArray(((_allData$searchApl$b = allData["search-apl"].books) === null || _allData$searchApl$b === void 0 ? void 0 : _allData$searchApl$b.books) || []), _toConsumableArray(((_allData$searchApl$p = allData["search-apl"].periodicals) === null || _allData$searchApl$p === void 0 ? void 0 : _allData$searchApl$p.books) || []), _toConsumableArray(((_allData$searchApl$b2 = allData["search-apl"].both) === null || _allData$searchApl$b2 === void 0 ? void 0 : _allData$searchApl$b2.books) || []))
          };
        }

        outData.presets = presets;
      }

      if (allData["languages"]) {
        outData.langs = parseResponseContentLanguages(allData["languages"], lang);
      }

      if (allData["folders"]) {
        var folders = normalizeLanguageFolders(allData["folders"], lang).outList;
        outData.folders = folders;
      }

      if (allData.geoip) {
        outData.geoIpData = allData.geoip;
      }

      return outData;
    }
  });
};
var fetchBaseUserDataRequest = function fetchBaseUserDataRequest() {
  return makeRequest({
    url: "/aggregate/authenticated",
    parseResponse: function parseResponse(response) {
      var _allData$settingsLib, _allData$subscription;

      var outData = {};
      var allData = response.data;

      if (allData["subscription-time"]) {
        outData.timeData = allData["subscription-time"];
      }

      if ((_allData$settingsLib = allData["settings-library"]) !== null && _allData$settingsLib !== void 0 && _allData$settingsLib.languages) {
        outData.languages = allData["settings-library"].languages;
      }

      if (allData["settings-custom"]) {
        outData.settings = allData["settings-custom"];
      }

      if ((_allData$subscription = allData["subscription-unread"]) !== null && _allData$subscription !== void 0 && _allData$subscription.unread) {
        outData.subsUnreadCount = allData["subscription-unread"].unread;
      }

      if (allData["history-search"]) {
        outData.searchHistory = allData["history-search"].items;
      }

      if (allData["history-read"]) {
        outData.reading = {};
        outData.reading.items = normalizeHistoryData(allData["history-read"].items);
        outData.reading.deleted = normalizeHistoryData(allData["history-read"].deleted);
      }

      if (allData["history-audio"]) {
        outData.listen = {};
        outData.listen.items = normalizeHistoryData(allData["history-audio"].items);
        outData.listen.deleted = normalizeHistoryData(allData["history-audio"].deleted);
      }

      if (allData["history-download"]) {
        outData.library = {};
        outData.library.items = normalizeHistoryData(allData["history-download"].items);
        outData.library.deleted = normalizeHistoryData(allData["history-download"].deleted);
      }

      if (allData["history-library"]) {
        outData.ml = {};
        outData.ml.items = normalizeHistoryData(allData["history-library"].items);
        outData.ml.deleted = normalizeHistoryData(allData["history-library"].deleted);
      }

      return outData;
    }
  });
};
/**
 *
 * @param {Object} oUrls  object with keyname and url e.g { book1: "/books/11", book2: "/books/2" }
 * @returns {Object} with multiple data from urls
 */

var getAggregateRequest = function getAggregateRequest(oUrls) {
  return (0,baseApi/* makeRequest */.$f)({
    url: (0,not_sorted_utils/* makeAggregateUrl */.um)(oUrls),
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  });
};
var getSubscriptionBooksRequest = function getSubscriptionBooksRequest() {
  return makeRequest({
    url: "/subscriptions/books/short",
    storageCacheName: CACHE_SUBSCRIPTION_BOOKS,
    parseResponse: function parseResponse(response) {
      return response.data.map(function (item) {
        return getBookIdWithPrefix(item.book_id);
      });
    }
  });
};
var getLanguagesRequest = function getLanguagesRequest(idLangBeFirst) {
  return (0,baseApi/* makeRequest */.$f)({
    url: "/content/languages/",
    type: "get",
    storageCacheName: CacheHolder/* CACHE_LANG */.p,
    parseResponse: function parseResponse(response) {
      return (0,not_sorted_utils/* parseResponseContentLanguages */.qY)(response.data, idLangBeFirst);
    }
  });
};
var getChapterContentRequest = function getChapterContentRequest(chapterId, bookRealType, bookType, highlight) {
  var _chapterId$split = chapterId.split("."),
      _chapterId$split2 = _slicedToArray(_chapterId$split, 2),
      bookId = _chapterId$split2[0],
      chapterNumber = _chapterId$split2[1];

  var url = "/content/books/".concat(bookId, "/chapter/").concat(chapterNumber, "?trans=all");

  if (highlight) {
    url += "&highlight=" + highlight;
  }

  return (0,baseApi/* makeRequest */.$f)({
    url: url,
    memoryCache: true,
    memoryCacheTime: constants/* CONTENT_MEMORY_CACHE_TIME */.Y,
    parseResponse: function parseResponse(response) {
      return makeChapterContent(response.data, bookRealType, bookType);
    }
  });
};
var getChapterContentRequestLite = function getChapterContentRequestLite(paraId) {
  var _paraId$split = paraId.split("."),
      _paraId$split2 = _slicedToArray(_paraId$split, 2),
      bookId = _paraId$split2[0],
      chapterNumber = _paraId$split2[1];

  var url = "/content/books/".concat(bookId, "/chapter/").concat(chapterNumber);
  return makeRequest({
    url: url,
    memoryCache: true,
    memoryCacheTime: CONTENT_MEMORY_CACHE_TIME,
    parseResponse: parseResponseDefault
  });
};

var normalizeHistoryData = function normalizeHistoryData(list) {
  return list.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      id: (0,content/* getBookIdWithPrefix */.NR)(item.book)
    });
  });
};

var getHistoryRequest = function getHistoryRequest(historyType, withDelete, start, end) {
  return makeRequest({
    url: makeHistoryUrl(historyType, withDelete, start, end),
    type: "get",
    parseResponse: function parseResponse(response) {
      return normalizeHistoryData(response.data.items);
    }
  });
};
var getAllHistoryRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(start) {
    var requests, results, allHistory;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          requests = {
            reading: (0,not_sorted_utils/* makeHistoryUrl */.E3)(Utils/* HistoryType.READING */.Z3.READING, true, start),
            listen: (0,not_sorted_utils/* makeHistoryUrl */.E3)(Utils/* HistoryType.LISTEN */.Z3.LISTEN, true, start),
            ml: (0,not_sorted_utils/* makeHistoryUrl */.E3)(Utils/* HistoryType.ML_HISTORY */.Z3.ML_HISTORY, true, start),
            library: (0,not_sorted_utils/* makeHistoryUrl */.E3)(Utils/* HistoryType.LIBRARY */.Z3.LIBRARY, false, start)
          };
          _context.next = 3;
          return getAggregateRequest(requests);

        case 3:
          results = _context.sent;
          allHistory = {};
          Object.keys(requests).forEach(function (type) {
            var _results$type, _results$type$data, _results$type3, _results$type3$data;

            allHistory[type] = {};

            if ((_results$type = results[type]) !== null && _results$type !== void 0 && (_results$type$data = _results$type.data) !== null && _results$type$data !== void 0 && _results$type$data.items) {
              var _results$type2, _results$type2$data;

              allHistory[type].items = normalizeHistoryData((_results$type2 = results[type]) === null || _results$type2 === void 0 ? void 0 : (_results$type2$data = _results$type2.data) === null || _results$type2$data === void 0 ? void 0 : _results$type2$data.items);
            }

            if ((_results$type3 = results[type]) !== null && _results$type3 !== void 0 && (_results$type3$data = _results$type3.data) !== null && _results$type3$data !== void 0 && _results$type3$data.deleted) {
              var _results$type4, _results$type4$data;

              allHistory[type].deleted = normalizeHistoryData((_results$type4 = results[type]) === null || _results$type4 === void 0 ? void 0 : (_results$type4$data = _results$type4.data) === null || _results$type4$data === void 0 ? void 0 : _results$type4$data.deleted);
            }
          });
          return _context.abrupt("return", allHistory);

        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function getAllHistoryRequest(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 *
 * @param {*} historyType
 * @param {Object} params { items: [],  date: Date, deleted: [] }
 * @returns
 */

var putHistoryRequest = function putHistoryRequest(historyType, params) {
  return (0,baseApi/* makeRequest */.$f)({
    url: "/settings/".concat(historyType, "/sync"),
    type: "put",
    headers: {
      "Content-Type": "application/json-patch+json",
      accept: "text/plain"
    },
    data: params,
    parseResponse: function parseResponse(response) {
      return response.data.date;
    }
  });
};
var deleteSearchHistory = function deleteSearchHistory() {
  return makeRequest({
    url: "/settings/search_history/",
    type: "delete",
    parseResponse: function parseResponse(response) {
      return response.data.date;
    }
  });
};
var fetchLibraryLanguagesRequest = function fetchLibraryLanguagesRequest() {
  return (0,baseApi/* makeRequest */.$f)({
    url: "settings/library/settings",
    type: "get",
    parseResponse: function parseResponse(response) {
      return response.data.languages;
    }
  });
};
var setLibraryLanguagesRequest = function setLibraryLanguagesRequest(languages) {
  var request = {
    headers: {
      "Content-Type": "application/json"
    },
    url: "settings/library/settings",
    type: "put",
    data: {
      languages: languages,
      lu: new Date().toISOString()
    },
    parseResponse: function parseResponse(response) {
      return response.status;
    }
  };
  return (0,baseApi/* makeRequest */.$f)(request);
};
var getWaveformRequest = function getWaveformRequest(url, bookId) {
  return fetch(url).then(function (response) {
    return response.json();
  }).then(function (_ref2) {
    var data = _ref2.data,
        chapters = _ref2.chapters;
    return {
      waveform: data,
      paragraphsAudioPositions: chapters.map(function (chapter) {
        chapter.id = "".concat(bookId, ".").concat(chapter.paraId);

        if (chapter.start === 4294967.5) {
          // server bug
          chapter.start = 0;
        }

        if (chapter.end === 4294967.5) {
          // server bug
          chapter.end = 0;
        }

        delete chapter.paraId;
        return chapter;
      })
    };
  });
};
var getGeoIpData = function getGeoIpData() {
  return (0,baseApi/* makeRequest */.$f)({
    url: "geoip",
    type: "get",
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  });
};
var deleteMlItem = function deleteMlItem(id) {
  return (0,baseApi/* makeRequest */.$f)({
    url: "settings/library",
    type: "delete",
    data: {
      id: id
    },
    parseResponse: function parseResponse(response) {
      return response.status;
    }
  });
};
var addBooksToLibraryRequest = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(books) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0,baseApi/* makeRequest */.$f)({
            url: "/settings/".concat(Utils/* HistoryType.LIBRARY */.Z3.LIBRARY),
            type: "post",
            data: {
              books: books
            },
            parseResponse: function parseResponse(response) {
              return response.status;
            }
          });

        case 2:
          return _context2.abrupt("return", _context2.sent);

        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function addBooksToLibraryRequest(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
var deleteBooksFromLibraryRequest = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(books) {
    var result;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0,baseApi/* makeRequest */.$f)({
            url: "settings/".concat(Utils/* HistoryType.LIBRARY */.Z3.LIBRARY),
            type: "delete",
            data: {
              books: books
            },
            parseResponse: function parseResponse(response) {
              return response.status;
            }
          });

        case 2:
          result = _context3.sent;
          _context3.next = 5;
          return deleteMlItem(books);

        case 5:
          return _context3.abrupt("return", result);

        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));

  return function deleteBooksFromLibraryRequest(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
var getBookAudioHistory = function getBookAudioHistory(bookId) {
  return makeRequest({
    url: "settings/audio/".concat(bookId),
    parseResponse: parseResponseDefault
  });
};
var getBookReadHistory = function getBookReadHistory(bookId) {
  return makeRequest({
    url: "settings/read/".concat(bookId),
    parseResponse: parseResponseDefault
  });
};
var sendCFTypo = function sendCFTypo(data) {
  return makeRequest({
    url: "cf/typo",
    type: "post",
    data: data,
    headers: {
      "Content-type": "multipart/form-data"
    },
    parseError: parseErrorDefault
  });
};
var getContactUsRequest = function getContactUsRequest() {
  return (0,baseApi/* makeRequest */.$f)({
    url: "cf"
  });
};
var sendContact = function sendContact(data) {
  return (0,baseApi/* makeRequest */.$f)({
    url: "cf",
    type: "post",
    data: data,
    "Content-type": "multipart/form-data"
  });
};
var getSettingsRequest = function getSettingsRequest() {
  return (0,baseApi/* makeRequest */.$f)({
    url: "settings/custom",
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  });
};
var saveSettingsRequest = function saveSettingsRequest(data) {
  return (0,baseApi/* makeRequest */.$f)({
    url: "settings/custom",
    type: "PATCH",
    data: data
  });
};
var getAbbreviationsRequest = function getAbbreviationsRequest() {
  return makeRequest({
    url: "/content/books/abbreviations",
    parseResponse: function parseResponse(response) {
      return convertAbbreviations(response.data);
    }
  });
};

/***/ }),

/***/ 1511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E3": function() { return /* binding */ makeHistoryUrl; },
/* harmony export */   "Ex": function() { return /* binding */ parseErrorDefault; },
/* harmony export */   "MI": function() { return /* binding */ mapReadingHistoryForServer; },
/* harmony export */   "dA": function() { return /* binding */ joinHistoryData; },
/* harmony export */   "gT": function() { return /* binding */ removeLangFromFolders; },
/* harmony export */   "qY": function() { return /* binding */ parseResponseContentLanguages; },
/* harmony export */   "t3": function() { return /* binding */ parseResponseDefault; },
/* harmony export */   "u8": function() { return /* binding */ mapListenHistoryForServer; },
/* harmony export */   "um": function() { return /* binding */ makeAggregateUrl; }
/* harmony export */ });
/* unused harmony exports withEtagSaving, getOrderNumberOfMonth, getBookIdByCode */
/* harmony import */ var _utils_content_content__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69051);
/* harmony import */ var _utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12202);
/* harmony import */ var _utils_array__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21707);
/* harmony import */ var _utils_content_content_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5626);
/* harmony import */ var _utils_search_search_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80226);
/* harmony import */ var _shared_utils_date__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96112);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }







var withEtagSaving = function withEtagSaving(callback, eTagCacheName) {
  return function (response) {
    var responseETag = response.headers.etag;
    var storedETag = localStorageSafe.getItem(eTagCacheName);

    if (responseETag && responseETag !== storedETag) {
      setLocalStorageItem(eTagCacheName, responseETag);
    }

    var value = null;

    if (response.data) {
      value = response.data;

      if (callback) {
        value = callback(response);
      }
    }

    return {
      status: response.status,
      value: value
    };
  };
};
var getOrderNumberOfMonth = function getOrderNumberOfMonth(month) {
  var matched = monthNamesInitial.findIndex(function (item) {
    return item.includes(month.toLowerCase());
  });
  return matched !== -1 ? matched + 1 : "1";
};
var getBookIdByCode = function getBookIdByCode() {
  var periodicals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var code = arguments.length > 1 ? arguments[1] : undefined;
  var bookId = arguments.length > 2 ? arguments[2] : undefined;
  var cloned = _toConsumableArray(periodicals) || [];
  var lowerCode = code.toLowerCase(); // first of all we are looking up in the same book

  var filteredByBookId = cloned.filter(function (item) {
    return item.book_id === bookId && item.code.toLowerCase() === lowerCode;
  });

  if (filteredByBookId.length) {
    return filteredByBookId[0].book_id;
  }

  var filteredByCode = cloned.filter(function (item) {
    return item.code.toLowerCase() === lowerCode;
  });

  if (filteredByCode.length) {
    return filteredByCode[0].book_id;
  }

  return null;
};
var removeLangFromFolders = function removeLangFromFolders() {
  var folders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return folders.filter(function (item) {
    return !_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_3__/* .langRegex.test */ .ZF.test(item) && item !== "all";
  });
};
var joinHistoryData = function joinHistoryData() {
  var readData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var listenData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var mlData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var libraryData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var allHistory = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var isUpdate = arguments.length > 5 ? arguments[5] : undefined;
  var allHistoryNew = {};
  var allHistoryOldMap = {};

  var getAllHistoryOldItem = function getAllHistoryOldItem(id) {
    var item = allHistoryOldMap[id];

    if (!item && item !== null) {
      item = (allHistory === null || allHistory === void 0 ? void 0 : allHistory.find(function (i) {
        return i.id === id;
      })) || null;
      allHistoryOldMap[id] = item;
    }

    return item;
  };

  var itemHolder;

  if (readData !== null && readData !== void 0 && readData.items) {
    readData.items.forEach(function (item) {
      if (item.id) {
        if (!allHistoryNew[item.id]) {
          allHistoryNew[item.id] = getAllHistoryOldItem(item.id) || {};
        }

        itemHolder = allHistoryNew[item.id];

        if ((0,_shared_utils_date__WEBPACK_IMPORTED_MODULE_5__/* .isBeforeDateISO */ .Ut)(itemHolder.luRead, item.lu)) {
          itemHolder.luRead = item.lu;
          itemHolder.readParaId = item.para_id;
          itemHolder.readRefCodeShort = item.refcode_short;
          itemHolder.readRefCodeLong = item.refcode_long;
          itemHolder.readChapterId = item.chapter_id;
          itemHolder.readPosition = item.position;
          itemHolder.lang = item.lang;
          itemHolder.id = (0,_utils_content_content__WEBPACK_IMPORTED_MODULE_0__/* .getBookIdWithPrefix */ .NR)(item.id);
        }
      }
    });
  }

  if (listenData !== null && listenData !== void 0 && listenData.items) {
    listenData.items.forEach(function (item) {
      if (item.id) {
        if (!allHistoryNew[item.id]) {
          allHistoryNew[item.id] = getAllHistoryOldItem(item.id) || {};
        }

        itemHolder = allHistoryNew[item.id];

        if ((0,_shared_utils_date__WEBPACK_IMPORTED_MODULE_5__/* .isBeforeDateISO */ .Ut)(itemHolder.luListen, item.lu)) {
          itemHolder.luListen = item.lu;
          itemHolder.listenPosition = item.position;
          itemHolder.listenChapterId = item.book + "." + item.chapter;
          itemHolder.lang = item.lang;
          itemHolder.id = (0,_utils_content_content__WEBPACK_IMPORTED_MODULE_0__/* .getBookIdWithPrefix */ .NR)(item.book);
        }
      }
    });
  }

  if (mlData !== null && mlData !== void 0 && mlData.items) {
    mlData.items.forEach(function (item) {
      if (item.id) {
        if (!allHistoryNew[item.id]) {
          allHistoryNew[item.id] = getAllHistoryOldItem(item.id) || {};
        }

        itemHolder = allHistoryNew[item.id];

        if ((0,_shared_utils_date__WEBPACK_IMPORTED_MODULE_5__/* .isBeforeDateISO */ .Ut)(itemHolder.mlLu, item.lu)) {
          itemHolder.mlParaId = item.para_id;
          itemHolder.mlChapterId = item.chapter_id;
          itemHolder.mlPosition = item.position;
          itemHolder.mlLu = item.lu;
          itemHolder.mlRefCodeShort = item.refcode_short;
          itemHolder.mlRefCodeLong = item.refcode_long;
          itemHolder.id = (0,_utils_content_content__WEBPACK_IMPORTED_MODULE_0__/* .getBookIdWithPrefix */ .NR)(item.book);
        }
      }
    });
  }

  if (libraryData !== null && libraryData !== void 0 && libraryData.items) {
    libraryData.items.forEach(function (item) {
      if (item.id) {
        if (!allHistoryNew[item.id]) {
          allHistoryNew[item.id] = getAllHistoryOldItem(item.id) || {};
        }

        itemHolder = allHistoryNew[item.id];

        if ((0,_shared_utils_date__WEBPACK_IMPORTED_MODULE_5__/* .isBeforeDateISO */ .Ut)(itemHolder.luLibrary, item.lu)) {
          itemHolder.luLibrary = item.lu;
          itemHolder.id = (0,_utils_content_content__WEBPACK_IMPORTED_MODULE_0__/* .getBookIdWithPrefix */ .NR)(item.book);
        }

        itemHolder.inLibrary = true;
      }
    });
  }

  if (mlData !== null && mlData !== void 0 && mlData.deleted) {
    mlData.deleted.forEach(function (item) {
      if (item.id) {
        if (allHistoryNew[item.id]) {
          allHistoryNew[item.id].inLibrary = false;
        }
      }
    });
  }

  var allHistoryNewArr = Object.values(allHistoryNew);

  if (isUpdate) {
    // if is update, join old and new items.
    var allHistoryUpdated = _toConsumableArray(allHistory);

    var allHistoryNewItem;

    for (var i = 0; i < allHistoryNewArr.length; i++) {
      allHistoryNewItem = allHistoryNewArr[i];
      var index = allHistory.findIndex(function (item) {
        return item.id === allHistoryNewItem.id;
      });

      if (index === -1) {
        allHistoryUpdated.unshift(allHistoryNewItem);
      } else {
        allHistoryUpdated[index] = allHistoryNewItem;
      }
    }

    return allHistoryUpdated;
  }

  return allHistoryNewArr;
};
var makeHistoryUrl = function makeHistoryUrl(historyType, withDelete, start, end) {
  var params = ["deleted=".concat(withDelete)];

  if (start) {
    params.push("start=".concat(start));
  }

  if (end) {
    params.push("end=".concat(end));
  }

  return "settings/".concat(historyType, "/sync?").concat(params.join("&"));
};
var makeAggregateUrl = function makeAggregateUrl(oUrls) {
  var elements = Object.entries(oUrls).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    var urlValue = value;

    if (urlValue.indexOf("/") !== 0) {
      urlValue = "/" + urlValue;
    }

    return key + "=" + encodeURIComponent(urlValue);
  });
  return "/aggregate/?" + elements.join("&");
};
var mapReadingHistoryForServer = function mapReadingHistoryForServer(paraId, position, dateISO) {
  return {
    para_id: paraId,
    position: position,
    lu: dateISO
  };
};
var mapListenHistoryForServer = function mapListenHistoryForServer(paraId, position, dateISO) {
  var _paraId$split = paraId.split("."),
      _paraId$split2 = _slicedToArray(_paraId$split, 2),
      bookId = _paraId$split2[0],
      chapter = _paraId$split2[1];

  return {
    book: bookId,
    chapter: chapter,
    lu: dateISO,
    position: position
  };
};
var parseResponseContentLanguages = function parseResponseContentLanguages(langList, lang) {
  var languages = langList.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      label: item.name,
      id: item.code,
      className: _utils_content_content_constants__WEBPACK_IMPORTED_MODULE_3__/* .CONTENT_CLASSES.LANGUAGE */ .J8.LANGUAGE
    });
  });

  if (lang) {
    var index = languages.findIndex(function (item) {
      return item.id === lang;
    });

    if (index > -1 && index !== 0) {
      (0,_utils_array__WEBPACK_IMPORTED_MODULE_2__/* .arraymove */ .yf)(languages, index, 0);
    }
  }

  return languages;
};
var parseErrorDefault = function parseErrorDefault(error) {
  return error.data;
};
var parseResponseDefault = function parseResponseDefault(response) {
  return response.data;
};

/***/ }),

/***/ 23157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Aq": function() { return /* binding */ AdvSearchNavigation; },
  "ic": function() { return /* binding */ advSearch; },
  "VY": function() { return /* binding */ advSearchAplInfoByPubnr; },
  "fC": function() { return /* binding */ advSearchAutocomplete; },
  "pG": function() { return /* binding */ advSearchInfo; },
  "tx": function() { return /* binding */ advSearchPeriodicalsInfoByPubnr; },
  "Nd": function() { return /* binding */ getScripturePubnrsRequest; },
  "Z": function() { return /* binding */ searchDictionaryContent; }
});

// UNUSED EXPORTS: AdvSearchNavigationRequest, advSearchInfoExpireTime, searchDictionaryAutocompleteRequest, searchDictionaryRequest

// EXTERNAL MODULE: ../shared/api/baseApi.js
var baseApi = __webpack_require__(97649);
// EXTERNAL MODULE: ../shared/api/not-sorted.utils.js
var not_sorted_utils = __webpack_require__(1511);
// EXTERNAL MODULE: ../main/src/utils/AdvSearchTypes.js
var AdvSearchTypes = __webpack_require__(39403);
// EXTERNAL MODULE: ../shared/utils/appServer/appServer.js
var appServer = __webpack_require__(12537);
// EXTERNAL MODULE: ../shared/utils/content/content.constants.js
var content_constants = __webpack_require__(5626);
;// CONCATENATED MODULE: ../shared/api/search/advanced/utils.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var parseResponseSearchDictionaryContent = function parseResponseSearchDictionaryContent(response) {
  return response.data.map(function (item) {
    return _objectSpread(_objectSpread({
      id: item.para_id
    }, item), {}, {
      isForSale: item.action_required === content_constants/* BOOK_PERMISSION.purchased */.k$.purchased,
      className: content_constants/* CONTENT_CLASSES.BOOK */.J8.BOOK
    });
  });
};
// EXTERNAL MODULE: ../shared/utils/search/search.constants.js
var search_constants = __webpack_require__(80226);
// EXTERNAL MODULE: ../shared/api/utils.js
var utils = __webpack_require__(65851);
;// CONCATENATED MODULE: ../shared/api/search/advanced/requests.js
function requests_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function requests_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? requests_ownKeys(Object(source), !0).forEach(function (key) { requests_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : requests_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function requests_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var advSearchInfoExpireTime = 60 * 60 * 1000; // 1 hour

var advSearchPeriodicalsInfoByPubnr = function advSearchPeriodicalsInfoByPubnr(pubnr) {
  var url = "/search/advanced/periodicals/".concat(pubnr, "/info/");
  return (0,baseApi/* makeRequest */.$f)({
    url: url,
    storageCacheName: url,
    storageCacheTime: advSearchInfoExpireTime,
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  });
};
var advSearchAplInfoByPubnr = function advSearchAplInfoByPubnr(pubnr) {
  var url = "/search/advanced/apl/".concat(pubnr, "/info/");
  return (0,baseApi/* makeRequest */.$f)({
    url: url,
    storageCacheName: url,
    storageCacheTime: advSearchInfoExpireTime,
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  });
};
var advSearchAutocomplete = function advSearchAutocomplete(extras) {
  var type = extras["type"];

  if (!AdvSearchTypes/* advSearchAutocompleteTypes.includes */.B6.includes(type)) {
    return null;
  }

  if (extras["type"]) {
    delete extras["type"];
  }

  if (extras["subtype"]) {
    if (extras["subtype"] !== "all") {
      extras["type"] = extras["subtype"];
    }

    delete extras["subtype"];
  }

  var path = "/search/advanced/".concat(type, "/autocomplete");
  var paramsString = (0,utils/* makeParamsString */.HR)(extras, true);
  var url = path + (paramsString ? "?".concat(paramsString) : "");
  return (0,baseApi/* makeRequest */.$f)({
    url: url,
    memoryCache: true,
    parseResponse: function parseResponse(response) {
      return response.data;
    }
  });
};
var advSearchInfo = function advSearchInfo(extras) {
  var type = extras["type"];

  if (!search_constants/* advSearchTypes.includes */.Bo.includes(type)) {
    return null;
  }

  if (extras["type"]) {
    delete extras["type"];
  }

  var path = "";

  if (!AdvSearchTypes/* advSearchInfoLangTypes.includes */.TR.includes(type)) {
    // common case
    path = "/search/advanced/".concat(type, "/info");
  } else {
    // info(lang) case
    if (!extras["lang"]) {
      return null;
    }

    var lang = extras["lang"];

    if (lang.length < 2) {
      return null;
    }

    path = "/search/advanced/".concat(type, "/").concat(lang, "/info");
    delete extras["lang"];
  }

  var paramsString = (0,utils/* makeParamsString */.HR)(extras, true);
  var url = path + (paramsString ? "?".concat(paramsString) : "");
  return (0,baseApi/* makeRequest */.$f)({
    url: url,
    storageCacheName: url,
    storageCacheTime: advSearchInfoExpireTime,
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  });
};
var AdvSearchNavigationRequest = function AdvSearchNavigationRequest(extras) {
  var type = extras["type"];

  if (!search_constants/* advSearchTypes.includes */.Bo.includes(type)) {
    return null;
  }

  if (extras["type"]) {
    delete extras["type"];
  }

  if (extras["bookpage"]) {
    extras["page"] = extras["bookpage"];
    delete extras["bookpage"];
  }

  var path = "/search/advanced/".concat(type, "/navigate");
  var paramsString = (0,utils/* makeParamsString */.HR)(extras, true);
  var url = path + (paramsString ? "?".concat(paramsString) : "");
  return (0,baseApi/* makeRequest */.$f)({
    url: url,
    memoryCache: true,
    parseResponse: function parseResponse(response) {
      return response.data;
    }
  });
};
var advSearch = function advSearch(query, extrasOriginal, limit, offset) {
  var folders = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  var extras = requests_objectSpread({}, extrasOriginal);

  var type = extras["type"];
  var path = search_constants/* advSearchTypes.includes */.Bo.includes(type) ? "/search/advanced/".concat(type) : "/search";

  if (extras["type"]) {
    delete extras["type"];
  }

  if (extras["subtype"]) {
    extras["type"] = extras["subtype"];
    delete extras["subtype"];
  }

  if (extras["bookpage"]) {
    extras["page"] = extras["bookpage"];
    delete extras["bookpage"];
  }

  if (extras["queryType"]) {
    extras["query_type"] = extras["queryType"];
    delete extras["queryType"];
  }

  delete extras["period"]; // datarange process

  switch (type) {
    case "bible":
      if (folders.length && !extras.lang) {
        extras["lang"] = folders[0];
      }

      break;

    case "apl":
      if (extras["start_year"]) {
        extras["start_date"] = "".concat(extras["start_year"], "-01-01");
        delete extras["start_year"];
      }

      if (extras["end_year"]) {
        extras["end_date"] = "".concat(extras["end_year"], "-12-31");
        delete extras["end_year"];
      }

      break;

    case "book":
      if (extras.daterange) {
        switch (extras.daterange) {
          case "all":
            break;

          case "lifetime":
            extras["end_date"] = "1917-12-31";
            break;

          case "compilations":
            extras["start_date"] = "1918-01-01";
            break;
        }

        delete extras["daterange"];
      }

      break;

    case "ltms":
      if (extras["number"]) {
        if (isNaN(parseInt(extras["number"]))) {
          delete extras["number"];
        }
      }

      if (extras["start_year"]) {
        extras["start_date"] = "".concat(extras["start_year"], "-01-01");
        delete extras["start_year"];
      }

      if (extras["end_year"]) {
        extras["end_date"] = "".concat(extras["end_year"], "-12-31");
        delete extras["end_year"];
      }

      if (extras["year"]) {
        var year = extras["year"];
        extras["start_date"] = "".concat(year, "-01-01");
        extras["end_date"] = "".concat(year, "-12-31");
        delete extras["year"];
      }

      break;

    case "periodicals":
      delete extras["bookCode"]; // is used to set the book code input value

      if (extras["year"] && extras["month"] && extras["day"]) {
        var _year = extras["year"];
        var month = extras["month"];
        var day = extras["day"];
        extras["start_date"] = "".concat(_year, "-").concat(month, "-").concat(day);
        extras["end_date"] = "".concat(_year, "-").concat(month, "-").concat(day);
        delete extras["year"];
        delete extras["month"];
        delete extras["day"];
      } else if (extras["year"] && extras["month"]) {
        var _year2 = extras["year"];
        var _month = extras["month"];
        extras["start_date"] = "".concat(_year2, "-").concat(_month, "-01");
        extras["end_date"] = "".concat(_year2, "-").concat(_month, "-31");
        delete extras["year"];
        delete extras["month"];
      } else if (extras["year"]) {
        var _year3 = extras["year"];
        extras["start_date"] = "".concat(_year3, "-01-01");
        extras["end_date"] = "".concat(_year3, "-12-31");
        delete extras["year"];
      } else {
        // combine start_date-end_date with daterange('lifetime', 'compilations', 'all')
        if (extras["start_year"]) {
          extras["start_date"] = "".concat(extras["start_year"], "-01-01");
          delete extras["start_year"];
        }

        if (extras["end_year"]) {
          extras["end_date"] = "".concat(extras["end_year"], "-12-31");
          delete extras["end_year"];
        }

        if (extras["daterange"]) {
          var daterange = extras["daterange"];

          switch (daterange) {
            case "lifetime":
              if (!extras["end_date"] || "1917-12-31" < extras["end_date"]) {
                extras["end_date"] = "1917-12-31";
              }

              break;

            case "compilations":
              if (!extras["start_date"] || "1918-01-01" > extras["start_date"]) {
                extras["start_date"] = "1918-01-01";
              }

              break;
          }

          delete extras["daterange"];
        }
      }

      break;

    case "dictionary":
      {
        if (extras["dictionarySearchType"]) {
          extras["headings_only"] = extras["dictionarySearchType"];
        }

        var foldersWithoutLang = (0,not_sorted_utils/* removeLangFromFolders */.gT)(folders);

        if (foldersWithoutLang.length !== 0) {
          extras["pubnr"] = [foldersWithoutLang];
        }

        delete extras["dictionarySearchType"];
        break;
      }
  }

  if (extras["collections"]) {
    var seq;

    if (typeof extras["collections"] === "string") {
      seq = decodeURIComponent(extras["collections"]).split(",");
    } else {
      seq = extras["collections"];
    }

    if (seq.length) {
      extras["folder"] = seq;
    }

    delete extras["collections"];
  }

  var paramsStr = (0,utils/* makeParamsString */.HR)(extras, true);
  var searchParams = ["query=".concat(encodeURIComponent(query)), paramsStr];

  if (limit) {
    searchParams.push("limit=".concat(limit));
  }

  if (offset) {
    searchParams.push("offset=".concat(offset));
  }

  var searchStr = "?" + searchParams.join("&");
  var fullUrl = path + searchStr;
  console.groupCollapsed("\uD83D\uDD75\uFE0F AS ".concat(query, " [").concat(limit, "] (").concat(extras.lang || "no lang", ")"));

  try {
    console.table((0,appServer/* searchStrToReqParams */.ap)(searchStr));
  } catch (e) {
    console.log(searchStr);
  }

  console.groupEnd();
  var request = {
    url: fullUrl,
    type: "get",
    parseResponse: function parseResponse(response) {
      var total = response.data.total;
      var results = response.data.results.map(function (item) {
        // isForSale = isAvailable for search items,
        // because search items do not have "action_required" property if available
        var isForSale = item.action_required === content_constants/* BOOK_PERMISSION.purchased */.k$.purchased;
        return requests_objectSpread(requests_objectSpread({
          query: query
        }, item), {}, {
          isForSale: isForSale
        });
      });
      return {
        total: total,
        results: results
      };
    }
  };
  return (0,baseApi/* makeRequest */.$f)(request);
};
var searchDictionaryAutocompleteRequest = function searchDictionaryAutocompleteRequest(query) {
  return makeRequest({
    url: "/search/advanced/dictionary/autocomplete?q=".concat(query),
    memoryCache: true,
    parseResponse: function parseResponse(response) {
      console.log("dictionaryAutocompete", response.data);
      return response.data.options;
    }
  });
};
var AdvSearchNavigation = function AdvSearchNavigation(extras) {
  return AdvSearchNavigationRequest(extras).then(function (data) {
    if (data && data.pubnr && data.para) {
      var paraId = "".concat(data.pubnr, ".").concat(data.para);
      return {
        paraId: paraId,
        lang: data.lang
      };
    }

    return {};
  });
};
var searchDictionaryContent = function searchDictionaryContent(query, dictionary) {
  var pubnr = dictionary ? "&pubnr=".concat(dictionary) : "";
  return (0,baseApi/* makeRequest */.$f)({
    url: "/search/advanced/dictionary/content?chapter=".concat(query).concat(pubnr),
    memoryCache: true,
    parseResponse: parseResponseSearchDictionaryContent,
    parseError: not_sorted_utils/* parseErrorDefault */.Ex
  });
};
var getScripturePubnrsRequest = function getScripturePubnrsRequest() {
  var url = "/search/advanced/scripture/books";
  return (0,baseApi/* makeRequest */.$f)({
    url: url,
    storageCacheName: url,
    storageCacheTime: advSearchInfoExpireTime,
    parseResponse: not_sorted_utils/* parseResponseDefault */.t3
  });
};
var searchDictionaryRequest = function searchDictionaryRequest(query, dictionary, headingsOnly) {
  var pubnr = dictionary && dictionary !== "all" ? "&pubnr=".concat(dictionary) : "";
  return makeRequest({
    url: "/search/advanced/dictionary?headings_only=".concat(headingsOnly, "&query=").concat(encodeURIComponent(query)).concat(pubnr),
    memoryCache: true,
    parseResponse: function parseResponse(response) {
      return response.data.results.map(function (item) {
        return requests_objectSpread(requests_objectSpread({
          id: item.para_id,
          type: "dictionary"
        }, item), {}, {
          isForSale: item.action_required === BOOK_PERMISSION.purchased,
          className: "book"
        });
      });
    },
    parseError: parseErrorDefault
  });
};

/***/ }),

/***/ 33967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ib": function() { return /* binding */ getSearchSuggestionsRequest; },
  "g9": function() { return /* binding */ getSearchSuggestionsShortcutRequest; }
});

// UNUSED EXPORTS: searchNavProcess, searchSuggestionsRequest

// EXTERNAL MODULE: ../shared/api/baseApi.js
var baseApi = __webpack_require__(97649);
// EXTERNAL MODULE: ../shared/api/not-sorted.utils.js
var not_sorted_utils = __webpack_require__(1511);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
;// CONCATENATED MODULE: ../shared/api/search/suggestions/utils.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/**
 *
 * @param {*} data
 * @param {*} query
 * @returns {ShortcutParams[]}
 */

var normilizeShortcut = function normilizeShortcut(data, query) {
  var outData = _objectSpread(_objectSpread({}, data), {}, {
    query: query
  });

  outData.shortCutType = data.type;

  if (data.type === "search") {
    outData.cutQuery = data.params.query;
  } else {
    outData.cutQuery = "";
  }

  if (data.params && data.params.pubnr) {
    outData.bookId = (0,content/* getBookIdWithPrefix */.NR)(data.params.pubnr);
  }

  if (data.para_id) {
    outData.bookId = (0,content/* getBookIdWithPrefix */.NR)(data.para_id);
    outData.paraId = data.para_id;
  }

  if (data.params && data.params.chapter) {
    outData.bookId = (0,content/* getBookIdWithPrefix */.NR)(data.params.chapter);
    outData.paraId = data.params.chapter;
  }

  return outData;
};
var utils_processCode = function processCode(query) {
  var trimmed = query.trim();
  var rx = /^([0-9]*[a-z]+)([0-9]+[0-9.:]*)$/i;

  if (!rx.test(trimmed)) {
    return [query];
  } // else
  // extended code


  var res = trimmed.match(rx);
  return ["".concat(res[1], " ").concat(res[2]), "".concat(res[1]).concat(res[2])];
};
// EXTERNAL MODULE: ../shared/api/utils.js
var utils = __webpack_require__(65851);
// EXTERNAL MODULE: ../shared/utils/search/advanced/advanced.js
var advanced = __webpack_require__(55082);
;// CONCATENATED MODULE: ../shared/api/search/suggestions/requests.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }






/**
 * Note from the old code: OMSK search is used  via redirect from /related/search/en/egw_phrase:000
 */

var searchSuggestionsRequest = function searchSuggestionsRequest(searchValue) {
  var query = searchValue.query,
      langs = searchValue.langs;
  var langsString = langs && langs.length ? "&" + makeParamsString({
    lang: langs
  }, true) : "";
  return makeRequest({
    url: "search/suggestions?query=".concat(encodeURIComponent(query)).concat(langsString),
    type: "get",
    memoryCache: true,
    parseResponse: parseResponseDefault
  });
};
/**
 *
 * @typedef {Object} ShortcutParams
 * @property {string} query
 * @property {string} cutQuery
 * @property {string} bookId
 * @property {?string} paraId
 * @property {string} shortCutType
 * @property {number} hits
 * @property {string} title
 */

var getSearchSuggestionsShortcutRequest = function getSearchSuggestionsShortcutRequest(query, bibleId, langs) {
  var params = ["query=".concat(encodeURIComponent(query)), "bible_id=".concat(bibleId)];

  if (langs && langs.length) {
    params.push((0,utils/* makeParamsString */.HR)({
      lang: langs
    }, true));
  }

  return (0,baseApi/* makeRequest */.$f)({
    url: "search/suggestions/shortcut?".concat(params.join("&")),
    type: "get",
    memoryCache: true,
    parseResponse: function parseResponse(response) {
      var data = response.data;

      if (!data) {
        return null;
      }

      return normilizeShortcut(data, query);
    }
  });
};
var getSearchSuggestionsRequest = function getSearchSuggestionsRequest(query, empty) {
  return (0,baseApi/* makeRequest */.$f)({
    url: "search/suggestions?query=".concat(encodeURIComponent(query), "&empty=").concat(empty),
    type: "get",
    memoryCache: true,
    parseResponse: function parseResponse(response) {
      var data = response.data;
      return data.map(function (item) {
        return normilizeShortcut(item, query);
      });
    }
  });
};
var searchNavProcess = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(query, baseBible, langs) {
    var _processCode, _processCode2, query1, bibleId;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _processCode = processCode(query), _processCode2 = _slicedToArray(_processCode, 1), query1 = _processCode2[0];
          bibleId = getBiblePubnr(baseBible);
          _context.next = 4;
          return getSearchSuggestionsShortcutRequest(query1, bibleId, langs);

        case 4:
          return _context.abrupt("return", _context.sent);

        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function searchNavProcess(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}()));

/***/ }),

/***/ 48367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bb": function() { return /* binding */ getPackagesRequest; },
/* harmony export */   "xh": function() { return /* binding */ getShopBooksRequest; }
/* harmony export */ });
/* unused harmony export createPayPalCheckoutRequest */
/* harmony import */ var _utils_content_content__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69051);
/* harmony import */ var _baseApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97649);
/* harmony import */ var _not_sorted_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1511);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var getShopBooksRequest = function getShopBooksRequest() {
  var bookIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var url = "shop/books?limit=50";

  if (bookIds.length > 0) {
    url += "&" + bookIds.map(function (item) {
      return "book_id=" + item;
    }).join("&");
  }

  return (0,_baseApi__WEBPACK_IMPORTED_MODULE_1__/* .makeRequest */ .$f)({
    url: url,
    type: "get",
    parseResponse: function parseResponse(response) {
      if (response.data) {
        var _response$data2 = response.data,
            books = _response$data2.books,
            total = _response$data2.total;
        return {
          total: total,
          books: books.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              id: (0,_utils_content_content__WEBPACK_IMPORTED_MODULE_0__/* .getBookIdWithPrefix */ .NR)(item.book_id)
            });
          })
        };
      }

      return undefined;
    }
  });
};
var getPackagesRequest = function getPackagesRequest(options) {
  var limit, offset, packageIds;

  if (options) {
    limit = options.limit;
    offset = options.offset;
    packageIds = options.packageIds;
  }

  var params = [];
  var url = "shop/packages";

  if (packageIds) {
    params.push("package_id=" + packageIds.join("&package_id="));
  }

  if (limit && offset) {
    params.push("limit=" + limit);
    params.push("offset=" + offset);
  }

  if (params.length) {
    url += "?" + params.join("&");
  }

  return (0,_baseApi__WEBPACK_IMPORTED_MODULE_1__/* .makeRequest */ .$f)({
    url: url,
    type: "get",
    parseResponse: _not_sorted_utils__WEBPACK_IMPORTED_MODULE_2__/* .parseResponseDefault */ .t3
  });
};
var createPayPalCheckoutRequest = function createPayPalCheckoutRequest(data) {
  var request = {
    url: "paypal/checkout/create",
    type: "post",
    data: data,
    parseResponse: parseResponseDefault
  };
  return makeRequest(request);
};

/***/ }),

/***/ 65851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HR": function() { return /* binding */ makeParamsString; },
/* harmony export */   "jj": function() { return /* binding */ setRequestCancelTokenSource; },
/* harmony export */   "wq": function() { return /* binding */ cancelRequest; }
/* harmony export */ });
/* unused harmony export withEtagCachingRequest */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60196);
/* harmony import */ var _utils_storage_storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12202);
/* harmony import */ var _not_sorted_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1511);
/* harmony import */ var _baseApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97649);
/* harmony import */ var _utils_search_advanced_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27962);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var setRequestCancelTokenSource = function setRequestCancelTokenSource(cancelTokenKey, cancelTokenSource) {
  if (__webpack_require__.g.window) {
    __webpack_require__.g.window[_constants__WEBPACK_IMPORTED_MODULE_4__/* .WINDOW_KEY_APP_CANCEL_TOKENS_SOURCES */ .J] = _objectSpread(_objectSpread({}, __webpack_require__.g.window[_constants__WEBPACK_IMPORTED_MODULE_4__/* .WINDOW_KEY_APP_CANCEL_TOKENS_SOURCES */ .J]), {}, _defineProperty({}, cancelTokenKey, cancelTokenSource));
  }
};
/**
 * Cancels a request, made by {makeRequest} fn with {cancelTokenKey} param.
 * @returns {boolean} indicating whether {cancelTokenKey} exists.
 */

var cancelRequest = function cancelRequest(cancelTokenKey) {
  if (__webpack_require__.g.window) {
    if (__webpack_require__.g.window[_constants__WEBPACK_IMPORTED_MODULE_4__/* .WINDOW_KEY_APP_CANCEL_TOKENS_SOURCES */ .J][cancelTokenKey]) {
      __webpack_require__.g.window[_constants__WEBPACK_IMPORTED_MODULE_4__/* .WINDOW_KEY_APP_CANCEL_TOKENS_SOURCES */ .J][cancelTokenKey].cancel();
      __webpack_require__.g.window[_constants__WEBPACK_IMPORTED_MODULE_4__/* .WINDOW_KEY_APP_CANCEL_TOKENS_SOURCES */ .J][cancelTokenKey] = undefined;
      return true;
    }
  }

  return false;
};
var withEtagCachingRequest = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(requestOptions) {
    var TAG, eTagCacheName, dataCacheName, storedETag, parseResponseAndError, request, data, dataFromCache;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          TAG = "/etag";
          eTagCacheName = requestOptions.url + TAG;
          dataCacheName = requestOptions.url;
          storedETag = localStorageSafe.getItem(eTagCacheName);
          parseResponseAndError = withEtagSaving(requestOptions.parseResponse, eTagCacheName);
          request = _objectSpread(_objectSpread({}, requestOptions), {}, {
            headers: _objectSpread(_objectSpread({}, requestOptions.headers), {}, {
              "if-none-match": storedETag
            }),
            parseResponse: parseResponseAndError,
            parseError: parseResponseAndError
          });
          _context.next = 8;
          return makeRequest(request);

        case 8:
          data = _context.sent;

          if (!(data.status === 304)) {
            _context.next = 13;
            break;
          }

          dataFromCache = localStorageSafe.getItem(dataCacheName);

          if (!dataFromCache) {
            _context.next = 13;
            break;
          }

          return _context.abrupt("return", JSON.parse(dataFromCache));

        case 13:
          setLocalStorageItem(dataCacheName, JSON.stringify(data.value));
          return _context.abrupt("return", data.value);

        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function withEtagCachingRequest(_x) {
    return _ref.apply(this, arguments);
  };
}()));
var makeParamsString = function makeParamsString(params) {
  var isApi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Object.keys(params).length) {
    return "";
  }

  var aParams = [];

  for (var key in params) {
    if (!params[key]) {
      continue;
    }

    var item = params[key];

    if (Array.isArray(item)) {
      // array case
      if (isApi) {
        // array api format
        var _iterator = _createForOfIteratorHelper(item),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var value = _step.value;
            aParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        // array app format
        var _value = item.join(",");

        aParams.push("".concat(key, "=").concat(_value));
      }
    } else {
      // string case
      if (_utils_search_advanced_constants__WEBPACK_IMPORTED_MODULE_3__/* .extrasArrayFields.includes */ ._q.includes(key)) {
        // array serialization case
        aParams.push("".concat(key, "=").concat(item));
      } else {
        aParams.push("".concat(key, "=").concat(encodeURIComponent(item)));
      }
    }
  }

  return aParams.join("&");
};

/***/ }),

/***/ 59034:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
  "ABC": 61697,
  "add-subscription": 61698,
  "adventist-beliefs": 61699,
  "adventist-library": 61700,
  "all-collections": 61701,
  "anchor": 61702,
  "arrow-diagonal": 61703,
  "arrow-right": 61704,
  "audio-books": 61705,
  "AZ": 61706,
  "backups": 61707,
  "bible": 61708,
  "bibliography": 61709,
  "bold-text": 61710,
  "book-circle": 61711,
  "book-close": 61712,
  "book-open": 61713,
  "book-stack": 61714,
  "bookmark-outline": 61715,
  "bookmark": 61716,
  "books": 61717,
  "bookshelf": 61718,
  "bracers": 61719,
  "burger-menu": 61720,
  "calendar": 61721,
  "cart": 61722,
  "chevron-double-left": 61723,
  "chevron-double-right": 61724,
  "chevron-down": 61725,
  "chevron-left": 61726,
  "chevron-right": 61727,
  "chevron-up-circle": 61728,
  "chevron-up": 61729,
  "childrens-stories": 61730,
  "christ-s-life-and-ministry": 61731,
  "christian-lifestyle": 61732,
  "church-history": 61733,
  "church-life-and-ministry": 61734,
  "clip": 61735,
  "close": 61736,
  "commentaries": 61737,
  "concordances": 61738,
  "conflict-of-the-ages-series": 61739,
  "contact-us": 61740,
  "content": 61741,
  "copy-link": 61742,
  "copy": 61743,
  "delete": 61744,
  "devotional-readings": 61745,
  "devotionals": 61746,
  "dictionaries": 61747,
  "dictionary": 61748,
  "donate": 61749,
  "dots-vertical": 61750,
  "download": 61751,
  "edit": 61752,
  "education": 61753,
  "egw-biography": 61754,
  "ellen-dark": 61755,
  "ellen-light": 61756,
  "email-circle": 61757,
  "epub-file": 61758,
  "epub": 61759,
  "evangelism-and-witnessing": 61760,
  "extend": 61761,
  "facebook-circle": 61762,
  "facebook": 61763,
  "faq": 61764,
  "file": 61765,
  "filter": 61766,
  "folder-add": 61767,
  "folder-close": 61768,
  "folder-copy-to": 61769,
  "folder-import": 61770,
  "folder-move-to": 61771,
  "folder-open": 61772,
  "folder-shared": 61773,
  "folder-up": 61774,
  "font": 61775,
  "fullscreen-exit": 61776,
  "fullscreen": 61777,
  "go-to-full-app": 61778,
  "go-to-reader": 61779,
  "google-translate": 61780,
  "grid-2": 61781,
  "grid": 61782,
  "health-and-wellness": 61783,
  "heart-outline": 61784,
  "helping-guides": 61785,
  "highlight": 61786,
  "history-of-redemption": 61787,
  "history": 61788,
  "home": 61789,
  "info-circle": 61790,
  "info": 61791,
  "information": 61792,
  "insta": 61793,
  "install": 61794,
  "italic-text": 61795,
  "L2h": 61796,
  "L2v": 61797,
  "L3h": 61798,
  "L3s12": 61799,
  "L3s12v": 61800,
  "L3s21": 61801,
  "L3s21v": 61802,
  "L3v": 61803,
  "L4h": 61804,
  "L4s112": 61805,
  "L4s112v": 61806,
  "L4s121": 61807,
  "L4s121v": 61808,
  "L4s211": 61809,
  "L4s211v": 61810,
  "L4s22": 61811,
  "L4v": 61812,
  "L5s122": 61813,
  "L5s122v": 61814,
  "L5s2111": 61815,
  "L5s2111v": 61816,
  "L5s212": 61817,
  "L5s212v": 61818,
  "L5s221": 61819,
  "L5s221v": 61820,
  "L6h": 61821,
  "L6v": 61822,
  "L7s1222": 61823,
  "L7s1222v": 61824,
  "L7s2122": 61825,
  "L7s2122v": 61826,
  "L7s2212": 61827,
  "L7s2212v": 61828,
  "L7s2221": 61829,
  "L7s2221v": 61830,
  "L8h": 61831,
  "L8v": 61832,
  "languages": 61833,
  "last-day-events": 61834,
  "layouts": 61835,
  "leadership": 61836,
  "left-arrow": 61837,
  "lessons-from-the-bible": 61838,
  "lessons": 61839,
  "letters-manuscripts": 61840,
  "list": 61841,
  "logo-review-and-herald": 61842,
  "logo": 61843,
  "manuscript": 61844,
  "menu": 61845,
  "microphone": 61846,
  "minus": 61847,
  "misc-collections": 61848,
  "misc-titles": 61849,
  "mobi-file": 61850,
  "modern-english": 61851,
  "move": 61852,
  "mp3-file": 61853,
  "my-library": 61854,
  "new-tab": 61855,
  "note": 61856,
  "old": 61857,
  "page-breaks": 61858,
  "page-numbers": 61859,
  "pamphlets": 61860,
  "paper-study-center": 61861,
  "parenting": 61862,
  "pause-circle": 61863,
  "pause": 61864,
  "pdf-file": 61865,
  "pdf": 61866,
  "periodicals": 61867,
  "pin": 61868,
  "pinterest": 61869,
  "planet-search": 61870,
  "planet": 61871,
  "play-circle": 61872,
  "play-header": 61873,
  "play": 61874,
  "playback-rate": 61875,
  "plus": 61876,
  "preview": 61877,
  "print-circle": 61878,
  "print": 61879,
  "profile": 61880,
  "publishing": 61881,
  "qr-code-header": 61882,
  "qr-code-mobile-menu": 61883,
  "qr-code": 61884,
  "question": 61885,
  "read": 61886,
  "reader-arrow": 61887,
  "reading-history": 61888,
  "recent-authors": 61889,
  "reference-works": 61890,
  "reference": 61891,
  "relationships-and-marriage": 61892,
  "research-documents": 61893,
  "restart": 61894,
  "result-size": 61895,
  "save": 61896,
  "sda-scripture-Index": 61897,
  "search-book": 61898,
  "search-clear": 61899,
  "search-corrections": 61900,
  "search-featured": 61901,
  "search-header": 61902,
  "search-history": 61903,
  "search-phrase": 61904,
  "search-relation": 61905,
  "search-shortcut": 61906,
  "search-suggestions": 61907,
  "search-text": 61908,
  "search": 61909,
  "settings": 61910,
  "share": 61911,
  "show-headers": 61912,
  "sign-in": 61913,
  "skip-back": 61914,
  "skip-forward": 61915,
  "sort-by-recent": 61916,
  "sort": 61917,
  "star": 61918,
  "stop": 61919,
  "study-center-cap": 61920,
  "study-center-plus": 61921,
  "study-center": 61922,
  "study-guides": 61923,
  "subscription-outline": 61924,
  "subscription": 61925,
  "sync-with-feature-search": 61926,
  "sync-with-player": 61927,
  "sync": 61928,
  "telegram-circle": 61929,
  "testimonies-for-the-church": 61930,
  "text-center": 61931,
  "text-decrease": 61932,
  "text-increase": 61933,
  "text-justify": 61934,
  "text-left": 61935,
  "text-right": 61936,
  "the-light-and-life-collection": 61937,
  "theme-select": 61938,
  "timer-disabled": 61939,
  "timer": 61940,
  "titles": 61941,
  "topical-index": 61942,
  "translation": 61943,
  "tree": 61944,
  "twitter-circle": 61945,
  "twitter": 61946,
  "typo": 61947,
  "underline-text": 61948,
  "unshare": 61949,
  "view": 61950,
  "volume-muted": 61951,
  "volume": 61952,
  "whatsapp-circle": 61953,
  "youth-and-modern-english": 61954,
  "youtube-circle": 61955,
  "youtube": 61956
});

/***/ }),

/***/ 76149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_hooks_useFocus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47630);
/* harmony import */ var _shared_utils_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62330);
/* harmony import */ var _utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78889);
/* harmony import */ var _Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33906);
/* harmony import */ var _Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }









var Accordion = function Accordion(_ref) {
  var isCanBeToggled = _ref.isCanBeToggled,
      children = _ref.children,
      title = _ref.title,
      className = _ref.className,
      disabled = _ref.disabled,
      headClassName = _ref.headClassName,
      isChevronSecondary = _ref.isChevronSecondary,
      bodyClassName = _ref.bodyClassName,
      isOpenByDefault = _ref.isOpenByDefault,
      isOpenExternal = _ref.isOpen,
      setIsOpenExternal = _ref.setIsOpen;
  var refRoot = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var refContent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isOpenExternal !== null && isOpenExternal !== void 0 ? isOpenExternal : false),
      _useState2 = _slicedToArray(_useState, 2),
      _isOpen = _useState2[0],
      _setIsOpen = _useState2[1];

  var isCanBeToggledFinal = isCanBeToggled && !!children;
  var isOpen = !isCanBeToggledFinal || (isOpenExternal !== null && isOpenExternal !== void 0 ? isOpenExternal : _isOpen);
  var setIsOpen = setIsOpenExternal !== null && setIsOpenExternal !== void 0 ? setIsOpenExternal : _setIsOpen;

  var toggleIsOpen = function toggleIsOpen() {
    setIsOpen(!isOpen);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isOpenByDefault !== undefined) {
      setIsOpen(isOpenByDefault);
    }
  }, [isOpenByDefault, setIsOpen]);
  (0,_shared_hooks_useFocus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(isOpen, refContent, {
    isFocusOnFirstIteration: false,
    isScrollFocusedElementIntoView: false,
    onAfterFocus: function onAfterFocus() {
      (0,_shared_utils_dom__WEBPACK_IMPORTED_MODULE_4__/* .scrollIntoViewIfVisibleLessThan */ .p2)(refContent.current, 0.3);
    }
  });
  var elementChevron = isChevronSecondary ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()({
      "expandItem": isCanBeToggledFinal,
      "expandChevronRotate": isOpen && children
    })
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()({
      "with-chevron": isCanBeToggledFinal,
      "open": isOpen && children
    })
  });

  var handleKeyDown = function handleKeyDown(e) {
    (0,_utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_5__/* .handleKeyDownSelectItem */ .nq)(e, toggleIsOpen) || (0,_utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_5__/* .handleKeyDownNavigation */ .OB)(refRoot.current, e);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: refRoot,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6___default().root), "accordion", className, _defineProperty({
      "open": isOpen
    }, (_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["toggling-disabled"]), !isCanBeToggledFinal)),
    onKeyDown: handleKeyDown,
    tabIndex: disabled ? -1 : 0
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6___default().head), "accordion_head", headClassName),
    onClick: isCanBeToggledFinal ? toggleIsOpen : undefined
  }, typeof title === "function" ? title(elementChevron) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, title, elementChevron)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: refContent,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6___default().body), "accordion_body", bodyClassName)
  }, isOpen && children));
};

Accordion.defaultProps = {
  isCanBeToggled: true
};
Accordion.propTypes = {
  children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node),
  title: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().node), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func)]),
  isOpen: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  isOpenByDefault: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  setIsOpen: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  isCanBeToggled: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  isChevronSecondary: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  headClassName: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  bodyClassName: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion);

/***/ }),

/***/ 95804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _AdventistIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25752);
/* harmony import */ var _AdventistContainer_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39244);
/* harmony import */ var _AdventistContainer_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_AdventistContainer_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var AdventistContainer = function AdventistContainer(_ref) {
  var _ref$textMode = _ref.textMode,
      textMode = _ref$textMode === void 0 ? false : _ref$textMode,
      className = _ref.className,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? "adventist.org" : _ref$link,
      iconSrc = _ref.iconSrc,
      hideLinkLabel = _ref.hideLinkLabel;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_AdventistContainer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().adventistContainer), className)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    className: (_AdventistContainer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().adventistIconContainer),
    href: "https://www.".concat(link, "/"),
    target: "_blank",
    rel: "noopener noreferrer"
  }, !textMode && !iconSrc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_AdventistIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: (_AdventistContainer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footerADVIcon)
  }), !textMode && iconSrc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: iconSrc,
    className: (_AdventistContainer_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footerADVIcon)
  }), !hideLinkLabel && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, link)));
};

AdventistContainer.propTypes = {
  textMode: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (AdventistContainer);

/***/ }),

/***/ 25752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);



var AdventistIcon = function AdventistIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    width: "63",
    height: "63",
    viewBox: "0 0 63 63",
    className: className
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    fill: "var(--footer-logo-circle)",
    cx: "31.5",
    cy: "31.5",
    r: "31.5"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "var(--footer-logo-color)",
    d: "M34.5976 32.1387C33.07 33.9311 32.3211 34.7922 31.9317 36.9887C31.9018 37.1469 31.752 37.1469 31.752 36.9887V34.3001C31.752 32.578 33.055 31.0141 34.6126 29.2041L35.8557 27.7456C37.608 25.6896 38.0274 23.3173 36.6345 21.9115C36.5147 21.7884 36.5746 21.6479 36.7244 21.7357C38.4617 22.6671 39.8247 26.0234 36.8592 29.5204L34.5976 32.1387ZM31.737 39.0096V41.6982C31.737 41.8563 31.9018 41.8563 31.9167 41.6982C32.3061 39.5192 33.04 38.6406 34.5827 36.8306L37.009 33.9838C39.9744 30.5044 40.4986 27.1305 38.9859 24.9515C38.8811 24.8109 38.7763 24.8988 38.8362 25.0745C39.8396 27.728 37.4433 30.5396 36.305 31.8751L34.5976 33.896C33.04 35.7235 31.737 37.305 31.737 39.0096ZM25.1471 30.3463C22.1816 33.8257 23.5445 37.1996 25.2819 38.1309C25.4317 38.2188 25.4916 38.0607 25.3717 37.9552C23.9789 36.5494 24.3982 34.1595 26.1506 32.1211L31.093 26.3222C32.6506 24.4946 33.9536 22.9307 33.9536 21.2261V18.5199C33.9536 18.3618 33.7889 18.3618 33.7739 18.5199C33.3845 20.6989 32.6506 21.56 31.108 23.37L25.1471 30.3463ZM33.9536 16.4991V13.7929C33.9536 13.6348 33.7889 13.6348 33.7739 13.7929C33.3845 15.9719 32.6506 16.8506 31.108 18.6605L24.9823 25.8301C22.0169 29.3095 21.4927 32.6834 23.0054 34.8624C23.1102 35.003 23.215 34.9152 23.1551 34.7394C22.1517 32.086 24.548 29.2744 25.6863 27.9389L31.093 21.5951C32.6506 19.7852 33.9387 18.2212 33.9536 16.4991ZM24.3233 21.9115C21.7623 24.8988 21.4028 28.0794 21.957 30.153C22.0019 30.3287 22.1367 30.3463 22.1367 30.153C22.1217 28.4133 22.556 26.9196 25.2519 23.7566L31.093 16.9033C32.6506 15.0757 33.9536 13.5118 33.9536 11.8072V9.11861C33.9536 8.96046 33.7889 8.96046 33.7739 9.11861C33.3845 11.2976 32.6506 12.1587 31.108 13.9686L24.3233 21.9115ZM27.9029 43.6136C27.8579 43.6136 27.813 43.5609 27.813 43.5082V41.9442C27.813 41.8915 27.8579 41.8388 27.9029 41.8388H30.1494C30.1944 41.8388 30.2393 41.786 30.2393 41.7333C30.2393 40.3451 29.3407 39.3962 25.7462 40.1167L17.988 41.6806C17.988 41.6806 12.087 48.6042 12.0421 48.6745C11.9972 48.7272 11.9822 48.8151 12.0271 48.8678C12.0571 48.9029 12.102 48.9205 12.1469 48.9029C12.2518 48.8854 25.0422 46.3022 25.0422 46.3022C27.9778 45.7223 29.5803 47.3566 30.0596 48.9029C30.1045 49.0435 30.2393 49.0259 30.2393 48.8854V43.7015C30.2393 43.6487 30.1944 43.596 30.1494 43.596L27.9029 43.6136ZM37.1587 40.3099L34.5976 43.3149C33.04 45.1424 31.752 46.7064 31.752 48.4109V48.8854C31.752 49.0084 31.8868 49.0435 31.9317 48.9029C32.411 47.3741 34.0135 45.7223 36.9491 46.3022C36.9491 46.3022 49.7395 48.9029 49.8444 48.9029C49.9043 48.9205 49.9791 48.8678 49.9941 48.7975C50.0091 48.7448 49.9941 48.6921 49.9642 48.6569C49.9192 48.5866 44.0033 41.663 44.0033 41.663L37.1587 40.3099ZM40.0194 29.6961C39.9744 29.5204 39.8396 29.5028 39.8396 29.6961C39.8546 31.4358 39.4203 32.9295 36.7244 36.0925L34.5827 38.5878C33.6092 39.7301 32.7405 40.7668 32.2163 41.8212H34.3281L34.5827 41.5225L37.653 37.9201C40.2141 34.9503 40.5735 31.7697 40.0194 29.6961ZM31.737 46.3901C31.737 46.5482 31.9018 46.5482 31.9167 46.3901C32.0665 45.3709 32.426 44.4219 32.9502 43.6136H31.8269C31.7819 43.6136 31.737 43.6663 31.737 43.719V46.3901Z"
  }));
};

AdventistIcon.propTypes = {
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (AdventistIcon);

/***/ }),

/***/ 93588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ArrowIcon_ArrowIcon; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../shared/components/IconView/IconView.js
var IconView = __webpack_require__(20844);
// EXTERNAL MODULE: ../shared/assets/EgwWebFont.js
var EgwWebFont = __webpack_require__(59034);
;// CONCATENATED MODULE: ../shared/components/ArrowIcon/constants.js
var ARROW_ICON_DIRECTION = {
  UP: "up",
  DOWN: "down",
  LEFT: "left",
  RIGHT: "right"
};
// EXTERNAL MODULE: ../shared/components/ArrowIcon/arrow-icon.module.scss
var arrow_icon_module = __webpack_require__(7862);
var arrow_icon_module_default = /*#__PURE__*/__webpack_require__.n(arrow_icon_module);
;// CONCATENATED MODULE: ../shared/components/ArrowIcon/ArrowIcon.js








var ArrowIcon = function ArrowIcon(_ref) {
  var onClick = _ref.onClick,
      direction = _ref.direction,
      variant = _ref.variant,
      className = _ref.className,
      size = _ref.size;
  return /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    onClick: onClick,
    className: classnames_default()((arrow_icon_module_default())["arrow-icon"], className, (arrow_icon_module_default())[variant], (arrow_icon_module_default())[direction]),
    style: {
      "fontSize": size
    },
    icon: variant === "chevron" ? EgwWebFont/* default.chevron-right */.Z["chevron-right"] : EgwWebFont/* default.arrow-right */.Z["arrow-right"]
  });
};

ArrowIcon.defaultProps = {
  direction: ARROW_ICON_DIRECTION.RIGHT,
  size: "0.8rem",
  variant: "chevron"
};
ArrowIcon.direction = ARROW_ICON_DIRECTION;
ArrowIcon.propTypes = {
  active: (prop_types_default()).bool,
  direction: (prop_types_default()).string,
  variant: (prop_types_default()).string,
  className: (prop_types_default()).string,
  onClick: (prop_types_default()).func,
  size: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number])
};
/* harmony default export */ var ArrowIcon_ArrowIcon = (ArrowIcon);

/***/ }),

/***/ 95524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _backdrop_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95778);
/* harmony import */ var _backdrop_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_backdrop_module_scss__WEBPACK_IMPORTED_MODULE_3__);
var _excluded = ["id", "className", "clickable"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var Backdrop = function Backdrop(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? "" : _ref$id,
      className = _ref.className,
      _ref$clickable = _ref.clickable,
      clickable = _ref$clickable === void 0 ? true : _ref$clickable,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({
    id: id,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_backdrop_module_scss__WEBPACK_IMPORTED_MODULE_3___default().backdrop), "_js-test_backdrop", className, _defineProperty({}, (_backdrop_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["not-clickable"]), !clickable))
  }, restProps));
};

Backdrop.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_1__.string,
  clickable: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool
};
/* harmony default export */ __webpack_exports__["Z"] = (Backdrop);

/***/ }),

/***/ 806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21766);
/* harmony import */ var _Badge_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53131);
/* harmony import */ var _Badge_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Badge_module_scss__WEBPACK_IMPORTED_MODULE_4__);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }







var Badge = function Badge(_ref) {
  var number = _ref.number,
      className = _ref.className,
      classNameText = _ref.classNameText,
      children = _ref.children;
  var realNumber = number; // TODO: WORKAROUND need valid fix of api EGWW-2627

  if (number && _typeof(number) === "object" && (number === null || number === void 0 ? void 0 : number.count) > -1) {
    realNumber = number.count;
  }

  if (typeof number !== "string" && isNaN(number)) {
    realNumber = 0;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Badge_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["badge-wrap"]), className),
    tag: "div",
    variant: _shared_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"].variant.h6 */ .Z.variant.h6,
    letterSpacing: _shared_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"].letterSpacing.sm */ .Z.letterSpacing.sm,
    color: _shared_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"].color.searchSectionPrimary */ .Z.color.searchSectionPrimary
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Badge_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["badge-text"]), classNameText)
  }, children !== null && children !== void 0 ? children : realNumber));
};

Badge.propTypes = {
  number: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().any),
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().any),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  classNameText: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Badge);

/***/ }),

/***/ 70184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48081);
/* harmony import */ var _Typography_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21766);
/* harmony import */ var _BadgeOffline_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88484);
/* harmony import */ var _BadgeOffline_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_BadgeOffline_module_scss__WEBPACK_IMPORTED_MODULE_3__);





var BadgeOffline = function BadgeOffline() {
  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_1__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    "data-draggable": true,
    className: (_BadgeOffline_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["badge-offline"]),
    variant: "body3"
  }, t("sw:offline"));
};

/* harmony default export */ __webpack_exports__["default"] = (BadgeOffline);

/***/ }),

/***/ 365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumbs_BreadCrumbs; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../shared/contexts/TranslateContext.js
var TranslateContext = __webpack_require__(48081);
// EXTERNAL MODULE: ../node_modules/react-dom/index.js
var react_dom = __webpack_require__(31542);
// EXTERNAL MODULE: ../node_modules/lodash/debounce.js
var debounce = __webpack_require__(66726);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ../node_modules/lodash/throttle.js
var throttle = __webpack_require__(19783);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ../node_modules/react-resize-detector/build/index.esm.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}var patchResizeHandler = function (resizeCallback, refreshMode, refreshRate, refreshOptions) {
    switch (refreshMode) {
        case 'debounce':
            return debounce_default()(resizeCallback, refreshRate, refreshOptions);
        case 'throttle':
            return throttle_default()(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
var isFunction = function (fn) { return typeof fn === 'function'; };
var isSSR = function () { return typeof window === 'undefined'; };
var isDOMElement = function (element) {
    return element instanceof Element || element instanceof HTMLDocument;
};
var createNotifier = function (onResize, setSize, handleWidth, handleHeight) {
    return function (_a) {
        var width = _a.width, height = _a.height;
        setSize(function (prev) {
            if (prev.width === width && prev.height === height) {
                // skip if dimensions haven't changed
                return prev;
            }
            if ((prev.width === width && !handleHeight) || (prev.height === height && !handleWidth)) {
                // process `handleHeight/handleWidth` props
                return prev;
            }
            onResize === null || onResize === void 0 ? void 0 : onResize(width, height);
            return { width: width, height: height };
        });
    };
};var ResizeDetector = /** @class */ (function (_super) {
    __extends(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.cancelHandler = function () {
            if (_this.resizeHandler && _this.resizeHandler.cancel) {
                // cancel debounced handler
                _this.resizeHandler.cancel();
                _this.resizeHandler = null;
            }
        };
        _this.attachObserver = function () {
            var _a = _this.props, targetRef = _a.targetRef, observerOptions = _a.observerOptions;
            if (isSSR()) {
                return;
            }
            if (targetRef && targetRef.current) {
                _this.targetRef.current = targetRef.current;
            }
            var element = _this.getElement();
            if (!element) {
                // can't find element to observe
                return;
            }
            if (_this.observableElement && _this.observableElement === element) {
                // element is already observed
                return;
            }
            _this.observableElement = element;
            _this.resizeObserver.observe(element, observerOptions);
        };
        _this.getElement = function () {
            var _a = _this.props, querySelector = _a.querySelector, targetDomEl = _a.targetDomEl;
            if (isSSR())
                return null;
            // in case we pass a querySelector
            if (querySelector)
                return document.querySelector(querySelector);
            // in case we pass a DOM element
            if (targetDomEl && isDOMElement(targetDomEl))
                return targetDomEl;
            // in case we pass a React ref using React.createRef()
            if (_this.targetRef && isDOMElement(_this.targetRef.current))
                return _this.targetRef.current;
            // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
            // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
            var currentElement = (0,react_dom.findDOMNode)(_this);
            if (!currentElement)
                return null;
            var renderType = _this.getRenderType();
            switch (renderType) {
                case 'renderProp':
                    return currentElement;
                case 'childFunction':
                    return currentElement;
                case 'child':
                    return currentElement;
                case 'childArray':
                    return currentElement;
                default:
                    return currentElement.parentElement;
            }
        };
        _this.createResizeHandler = function (entries) {
            var _a = _this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c, onResize = _a.onResize;
            if (!handleWidth && !handleHeight)
                return;
            var notifyResize = createNotifier(onResize, _this.setState.bind(_this), handleWidth, handleHeight);
            entries.forEach(function (entry) {
                var _a = (entry && entry.contentRect) || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !_this.skipOnMount && !isSSR();
                if (shouldSetSize) {
                    notifyResize({ width: width, height: height });
                }
                _this.skipOnMount = false;
            });
        };
        _this.getRenderType = function () {
            var _a = _this.props, render = _a.render, children = _a.children;
            if (isFunction(render)) {
                // DEPRECATED. Use `Child Function Pattern` instead
                return 'renderProp';
            }
            if (isFunction(children)) {
                return 'childFunction';
            }
            if ((0,react.isValidElement)(children)) {
                return 'child';
            }
            if (Array.isArray(children)) {
                // DEPRECATED. Wrap children with a single parent
                return 'childArray';
            }
            // DEPRECATED. Use `Child Function Pattern` instead
            return 'parent';
        };
        var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === void 0 ? 1000 : _a, refreshOptions = props.refreshOptions;
        _this.state = {
            width: undefined,
            height: undefined
        };
        _this.skipOnMount = skipOnMount;
        _this.targetRef = (0,react.createRef)();
        _this.observableElement = null;
        if (isSSR()) {
            return _this;
        }
        _this.resizeHandler = patchResizeHandler(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
        _this.resizeObserver = new window.ResizeObserver(_this.resizeHandler);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function () {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentDidUpdate = function () {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentWillUnmount = function () {
        if (isSSR()) {
            return;
        }
        this.observableElement = null;
        this.resizeObserver.disconnect();
        this.cancelHandler();
    };
    ResizeDetector.prototype.render = function () {
        var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === void 0 ? 'div' : _b;
        var _c = this.state, width = _c.width, height = _c.height;
        var childProps = { width: width, height: height, targetRef: this.targetRef };
        var renderType = this.getRenderType();
        switch (renderType) {
            case 'renderProp':
                return render === null || render === void 0 ? void 0 : render(childProps);
            case 'childFunction': {
                var childFunction = children;
                return childFunction === null || childFunction === void 0 ? void 0 : childFunction(childProps);
            }
            case 'child': {
                // @TODO bug prone logic
                var child = children;
                if (child.type && typeof child.type === 'string') {
                    // child is a native DOM elements such as div, span etc
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    childProps.targetRef; var nativeProps = __rest(childProps, ["targetRef"]);
                    return (0,react.cloneElement)(child, nativeProps);
                }
                // class or functional component otherwise
                return (0,react.cloneElement)(child, childProps);
            }
            case 'childArray': {
                var childArray = children;
                return childArray.map(function (el) { return !!el && (0,react.cloneElement)(el, childProps); });
            }
            default:
                return react.createElement(WrapperTag, null);
        }
    };
    return ResizeDetector;
}(react.PureComponent));function withResizeDetector(ComponentInner, options) {
    if (options === void 0) { options = {}; }
    var ResizeDetectorHOC = /** @class */ (function (_super) {
        __extends(ResizeDetectorHOC, _super);
        function ResizeDetectorHOC() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ref = (0,react.createRef)();
            return _this;
        }
        ResizeDetectorHOC.prototype.render = function () {
            var _a = this.props, forwardedRef = _a.forwardedRef, rest = __rest(_a, ["forwardedRef"]);
            var targetRef = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : this.ref;
            return (react.createElement(ResizeDetector, __assign({}, options, { targetRef: targetRef }),
                react.createElement(ComponentInner, __assign({ targetRef: targetRef }, rest))));
        };
        return ResizeDetectorHOC;
    }(react.Component));
    function forwardRefWrapper(props, ref) {
        return react.createElement(ResizeDetectorHOC, __assign({}, props, { forwardedRef: ref }));
    }
    var name = ComponentInner.displayName || ComponentInner.name;
    forwardRefWrapper.displayName = "withResizeDetector(".concat(name, ")");
    return (0,react.forwardRef)(forwardRefWrapper);
}var useEnhancedEffect = isSSR() ? react.useEffect : react.useLayoutEffect;
function useResizeDetector(props) {
    if (props === void 0) { props = {}; }
    var _a = props.skipOnMount, skipOnMount = _a === void 0 ? false : _a, refreshMode = props.refreshMode, _b = props.refreshRate, refreshRate = _b === void 0 ? 1000 : _b, refreshOptions = props.refreshOptions, _c = props.handleWidth, handleWidth = _c === void 0 ? true : _c, _d = props.handleHeight, handleHeight = _d === void 0 ? true : _d, targetRef = props.targetRef, observerOptions = props.observerOptions, onResize = props.onResize;
    var skipResize = useRef(skipOnMount);
    var localRef = useRef(null);
    var resizeHandler = useRef();
    var ref = targetRef !== null && targetRef !== void 0 ? targetRef : localRef;
    var _e = useState({
        width: undefined,
        height: undefined
    }), size = _e[0], setSize = _e[1];
    useEnhancedEffect(function () {
        if (!handleWidth && !handleHeight)
            return;
        var notifyResize = createNotifier(onResize, setSize, handleWidth, handleHeight);
        var resizeCallback = function (entries) {
            if (!handleWidth && !handleHeight)
                return;
            entries.forEach(function (entry) {
                var _a = (entry && entry.contentRect) || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !skipResize.current;
                if (shouldSetSize) {
                    notifyResize({ width: width, height: height });
                }
                skipResize.current = false;
            });
        };
        resizeHandler.current = patchResizeHandler(resizeCallback, refreshMode, refreshRate, refreshOptions);
        var resizeObserver = new window.ResizeObserver(resizeHandler.current);
        if (ref.current) {
            resizeObserver.observe(ref.current, observerOptions);
        }
        return function () {
            var _a, _b;
            resizeObserver.disconnect();
            (_b = (_a = resizeHandler.current).cancel) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
    }, [refreshMode, refreshRate, refreshOptions, handleWidth, handleHeight, onResize, observerOptions, ref.current]);
    return __assign({ ref: ref }, size);
}//# sourceMappingURL=index.esm.js.map

// EXTERNAL MODULE: ../shared/what-input/source.js
var source = __webpack_require__(53769);
var source_default = /*#__PURE__*/__webpack_require__.n(source);
// EXTERNAL MODULE: ../shared/components/Select/SelectVariantButton.js
var SelectVariantButton = __webpack_require__(80800);
// EXTERNAL MODULE: ../shared/components/ArrowIcon/ArrowIcon.js + 1 modules
var ArrowIcon = __webpack_require__(93588);
// EXTERNAL MODULE: ../shared/components/DropDown/DropDownVariantButton.js
var DropDownVariantButton = __webpack_require__(12346);
// EXTERNAL MODULE: ../shared/components/Button/Button.js
var Button = __webpack_require__(18170);
// EXTERNAL MODULE: ../shared/utils/dom.js
var dom = __webpack_require__(62330);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
// EXTERNAL MODULE: ../shared/utils/content/content.constants.js
var content_constants = __webpack_require__(5626);
// EXTERNAL MODULE: ../shared/utils/select.js
var utils_select = __webpack_require__(48018);
// EXTERNAL MODULE: ../shared/components/Popup/popup.constants.js
var popup_constants = __webpack_require__(29467);
// EXTERNAL MODULE: ../shared/utils/theme/theme.js + 1 modules
var theme = __webpack_require__(93752);
;// CONCATENATED MODULE: ../shared/utils/theme/index.js


// EXTERNAL MODULE: ../shared/utils/studyCenter/constants.js
var constants = __webpack_require__(37332);
// EXTERNAL MODULE: ../shared/utils/systemUtils/systemUtils.js + 1 modules
var systemUtils = __webpack_require__(52707);
;// CONCATENATED MODULE: ../shared/utils/user/user.js

var user_getUserRole = function getUserRole() {
  var _getTokens = getTokens(),
      accessToken = _getTokens.accessToken;

  if (accessToken) {
    var tokenPayload = atob(accessToken.split(".")[1]);
    var tokenDetails = JSON.parse(tokenPayload);
    return Array.isArray(tokenDetails.role) ? tokenDetails.role : [tokenDetails.role];
  }

  return undefined;
};
;// CONCATENATED MODULE: ../shared/utils/studyCenter/study-center.js


var isSystemFolder = function isSystemFolder(id) {
  return constants/* SystemFolderIds.includes */.YF.includes(id);
};
var isUserEditor = function isUserEditor(roles) {
  var userRoles = roles ? roles : getUserRole();

  if (!userRoles) {
    return false;
  }

  return userRoles.includes(UserRoles.studyCenterEditor) || userRoles.includes(UserRoles.StudyCenterEditorAdmin);
};
;// CONCATENATED MODULE: ../shared/utils/studyCenter/index.js


// EXTERNAL MODULE: ../shared/utils/time.js
var time = __webpack_require__(82344);
;// CONCATENATED MODULE: ../shared/utils/index.js





// EXTERNAL MODULE: ../shared/utils/keyboard-navigation/keyboard-navigation.js
var keyboard_navigation = __webpack_require__(78889);
// EXTERNAL MODULE: ../shared/components/Breadcrumbs/BreadCrumbs.module.scss
var BreadCrumbs_module = __webpack_require__(96468);
var BreadCrumbs_module_default = /*#__PURE__*/__webpack_require__.n(BreadCrumbs_module);
;// CONCATENATED MODULE: ../shared/components/Breadcrumbs/BreadCrumbs.js
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


















var BreadCrumbs = function BreadCrumbs(_ref) {
  var currentLeft = _ref.currentLeft,
      width = _ref.width,
      maxWidth = _ref.maxWidth,
      onClickItem = _ref.onClickItem,
      items = _ref.items,
      folderType = _ref.folderType;

  var _useSharedTranslation = (0,TranslateContext/* useSharedTranslation */.G)(),
      t = _useSharedTranslation.t;

  var _useState = (0,react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      elRoot = _useState2[0],
      setElRoot = _useState2[1];

  var refContentHidden = (0,react.useRef)();
  var currentLeftFinal = currentLeft !== null && currentLeft !== void 0 ? currentLeft : elRoot === null || elRoot === void 0 ? void 0 : elRoot.getBoundingClientRect().left;
  var bottom = "window" in __webpack_require__.g ? window.innerHeight : 0;
  var boundaryRect = {
    x: currentLeftFinal,
    y: 0,
    top: 0,
    width: width,
    height: bottom,
    left: currentLeftFinal,
    right: currentLeftFinal + width,
    bottom: bottom
  };

  var _useMemo = (0,react.useMemo)(function () {
    var itemsShown = [];
    var itemsHidden = [];
    var accWidth = 0;
    var itemSize, item;

    for (var i = items.length - 1; i >= 0; i--) {
      var _items$i$isTranslateL;

      itemSize = (0,dom/* calculateTextDimension */.Sb)(items[i].label + " > ", ["expandItem"]);
      accWidth += itemSize.width;
      item = _objectSpread(_objectSpread({
        index: i,
        icon: undefined
      }, items[i]), {}, {
        isTranslateLabel: (_items$i$isTranslateL = items[i].isTranslateLabel) !== null && _items$i$isTranslateL !== void 0 ? _items$i$isTranslateL : true
      });

      if (items.length - 1 === i || accWidth < width) {
        itemsShown.push(item);
      } else {
        itemsHidden.push(item);
      }
    }

    itemsShown.reverse();
    itemsHidden.reverse();
    return [itemsShown, itemsHidden];
  }, [items, width]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      itemsShown = _useMemo2[0],
      itemsHidden = _useMemo2[1];

  var renderBcItem = function renderBcItem(item, isLast, children, isInsideThreeDots) {
    var id = item.id,
        label = item.label,
        title = item.title,
        _item$isTranslateLabe = item.isTranslateLabel,
        isTranslateLabel = _item$isTranslateLabe === void 0 ? true : _item$isTranslateLabe,
        _item$nsSeparator = item.nsSeparator,
        nsSeparator = _item$nsSeparator === void 0 ? false : _item$nsSeparator;
    var labelFinal;

    if (isSystemFolder(id)) {
      labelFinal = t(title, {
        defaultValue: title
      });
    } else if (isTranslateLabel) {
      labelFinal = (0,content/* removeBR */.H8)(t(label, {
        // prevent labels with a colon (":")
        // being considered as the {[namespace]:[key]}
        nsSeparator: nsSeparator ? undefined : false
      }));
    } else {
      labelFinal = label;
    }

    var isLastItem = item.index === items.length - 1;
    var isHasChildren = !!(children !== null && children !== void 0 && children.length);
    var buttonColor;

    if (isLastItem) {
      if (folderType === content_constants/* FOLDER_TYPE.bible */.S.bible) {
        buttonColor = Button/* default.color.bible */.Z.color.bible;
      } else if (folderType === content_constants/* FOLDER_TYPE.apl */.S.apl) {
        buttonColor = Button/* default.color.apl */.Z.color.apl;
      } else if (folderType === content_constants/* FOLDER_TYPE.reference */.S.reference) {
        buttonColor = Button/* default.color.references */.Z.color.references;
      } else if (folderType === content_constants/* FOLDER_TYPE.egwwritings */.S.egwwritings) {
        buttonColor = Button/* default.color.egw */.Z.color.egw;
      } else {
        buttonColor = Button/* default.color.icon */.Z.color.icon;
      }
    } else {
      buttonColor = Button/* default.color.icon */.Z.color.icon;
    }

    var buttonProps = {
      tabIndex: -1,
      paddingLess: !isInsideThreeDots,
      fontFamily: isInsideThreeDots ? Button/* default.fontFamily.roboto */.Z.fontFamily.roboto : undefined,
      variant: Button/* default.variant.clear */.Z.variant.clear,
      color: buttonColor,
      style: {
        fontWeight: 400,
        width: isInsideThreeDots ? "100%" : undefined,
        justifyContent: isInsideThreeDots ? "space-between" : undefined
      }
    };

    buttonProps.onClick = function (e, preventDropDownDefault) {
      if (isHasChildren) {
        if (source_default().ask() === "mouse" && !isInsideThreeDots) {
          onClickItem(item, item.index);

          if (preventDropDownDefault) {
            preventDropDownDefault();
          }
        }
      } else {
        onClickItem(item, item.index);
      }
    };

    if (!isHasChildren) {
      return /*#__PURE__*/react.createElement(Button/* default */.Z, _extends({
        key: item.index,
        className: folderType
      }, buttonProps), labelFinal, "\xA0", !isLastItem && /*#__PURE__*/react.createElement(ArrowIcon/* default */.Z, {
        direction: ArrowIcon/* default.direction.RIGHT */.Z.direction.RIGHT
      }));
    } // EGWW-1851 prevent show titles of bible in content


    var childrenFinal = children.filter(function (subItem) {
      return !(subItem.className === content_constants/* CONTENT_CLASSES.PARAGRAPH */.J8.PARAGRAPH && (subItem.element_type === "h1" || subItem.element_type === "h2"));
    }).map(function (c) {
      return _objectSpread(_objectSpread({}, c), {}, {
        label: (0,content/* removeBR */.H8)(t(c.label, {
          // prevent labels with a colon (":")
          // being considered as the {[namespace]:[key]}
          nsSeparator: false
        }))
      });
    });
    return /*#__PURE__*/react.createElement(SelectVariantButton/* default */.Z, {
      key: item.index,
      toggleOnMouseOverLeave: true,
      label: labelFinal,
      value: id,
      buttonProps: buttonProps,
      boundaryRect: boundaryRect,
      popupProps: {
        maxHeight: "window" in __webpack_require__.g ? window.innerHeight * 0.4 : 0,
        positionPattern: isInsideThreeDots ? popup_constants/* PopupPositionPattern.AT_RIGHT_ANCHOR_SIDE */.a.AT_RIGHT_ANCHOR_SIDE : undefined
      },
      className: "js-test_item",
      options: childrenFinal,
      style: {
        minWidth: 0
      },
      onChange: function onChange(key) {
        var item = childrenFinal.find(function (o) {
          return (0,utils_select/* getOptionKey */._)(o) === key;
        });
        onClickItem(item, item.index);
      }
    });
  };

  var handleKeyDown = function handleKeyDown(e) {
    return (0,keyboard_navigation/* handleKeyDownNavigation */.OB)(elRoot, e);
  };

  var jsxChildren = [];

  if (itemsHidden !== null && itemsHidden !== void 0 && itemsHidden.length) {
    jsxChildren.push(renderBcItem(itemsHidden[0]));

    var _handleKeyDown = function _handleKeyDown(e) {
      return (0,keyboard_navigation/* handleKeyDownNavigation */.OB)(refContentHidden.current, e, true);
    };

    if (itemsHidden.length > 1) {
      jsxChildren.push( /*#__PURE__*/react.createElement(DropDownVariantButton/* default */.Z, {
        toggleOnMouseOverLeave: true,
        key: "threeDots",
        boundaryRect: boundaryRect,
        label: "...",
        buttonProps: {
          tabIndex: -1
        },
        body: /*#__PURE__*/react.createElement("div", {
          ref: refContentHidden,
          onKeyDown: _handleKeyDown
        }, itemsHidden.map(function (item, index, arr) {
          var _arr2;

          if (index === 0) {
            return null;
          }

          return renderBcItem(item, index === itemsShown.length - 1, (_arr2 = arr[index - 1]) === null || _arr2 === void 0 ? void 0 : _arr2.children, true);
        }))
      }));
    }
  }

  itemsShown.forEach(function (item, index, arr) {
    var children;

    if (index === 0) {
      if (itemsHidden !== null && itemsHidden !== void 0 && itemsHidden.length) {
        children = itemsHidden[itemsHidden.length - 1].children;
      }
    } else {
      var _arr3;

      children = (_arr3 = arr[index - 1]) === null || _arr3 === void 0 ? void 0 : _arr3.children;
    }

    jsxChildren.push(renderBcItem(item, index === itemsShown.length - 1, children));
  });
  return /*#__PURE__*/react.createElement("div", {
    ref: setElRoot,
    tabIndex: jsxChildren.length ? 0 : -1,
    className: (BreadCrumbs_module_default()).root,
    onKeyDown: handleKeyDown,
    style: maxWidth ? {
      maxWidth: maxWidth
    } : undefined
  }, jsxChildren);
};

/* harmony default export */ var Breadcrumbs_BreadCrumbs = (withResizeDetector(BreadCrumbs));

/***/ }),

/***/ 29718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gt": function() { return /* binding */ BUTTON_SIZES; },
/* harmony export */   "Il": function() { return /* binding */ BUTTON_FONT_FAMILY; },
/* harmony export */   "QO": function() { return /* binding */ MapButtonFontFamilyToCN; },
/* harmony export */   "RN": function() { return /* binding */ BUTTON_VARIANT; },
/* harmony export */   "lY": function() { return /* binding */ BUTTON_MIN_WIDTH; },
/* harmony export */   "tY": function() { return /* binding */ BUTTON_COLOR; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75573);
var _MapButtonFontFamilyT;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var BUTTON_VARIANT = {
  clear: "clear",
  default: "default",
  link: "link",
  outline: "outline"
};
var BUTTON_COLOR = {
  grayDark: "gray-dark",
  icon: "icon",
  light: "light",
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
  quaternary: "quaternary",
  egw: "egw",
  references: "references",
  apl: "apl",
  bible: "bible",
  searchSectionPrimary: "search-section-primary",
  headerItem: "header-item"
};
var BUTTON_FONT_FAMILY = _constants__WEBPACK_IMPORTED_MODULE_0__/* .FontFamily */ .bt;
var BUTTON_SIZES = {
  default: "size-default",
  small: "small",
  medium: "medium",
  big: "big"
};
var BUTTON_MIN_WIDTH = {
  md: "min-width_md",
  lg: "min-width_lg"
};
var MapButtonFontFamilyToCN = (_MapButtonFontFamilyT = {}, _defineProperty(_MapButtonFontFamilyT, _constants__WEBPACK_IMPORTED_MODULE_0__/* .FontFamily.bebas */ .bt.bebas, "bebas"), _defineProperty(_MapButtonFontFamilyT, _constants__WEBPACK_IMPORTED_MODULE_0__/* .FontFamily.roboto */ .bt.roboto, "roboto"), _MapButtonFontFamilyT);

/***/ }),

/***/ 18170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _LongPressWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40654);
/* harmony import */ var _shared_components_Button_Ripple__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22168);
/* harmony import */ var _hooks_useOnlineOnlyHandler__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12651);
/* harmony import */ var _Button_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29718);
/* harmony import */ var _utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78889);
/* harmony import */ var _Button_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48804);
/* harmony import */ var _Button_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Button_module_scss__WEBPACK_IMPORTED_MODULE_8__);
var _excluded = ["idRipple", "classNameRipple", "rootTagName", "className", "activeClassName", "variant", "color", "size", "paddingLess", "active", "isContextMenuCustom", "onContextMenu", "isOnLineOnly", "onClick", "onKeyDown", "timeout", "minWidth", "children", "title", "fontFamily", "tabIndex"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }











var isIconByChildren = function isIconByChildren(children) {
  var _children$type$name, _children$props;

  return children && (children.type === "i" || typeof children.type === "function" && ((_children$type$name = children.type.name) === null || _children$type$name === void 0 ? void 0 : _children$type$name.toLowerCase().includes("icon")) || ((_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.icon));
};

var getVariantFallbackBasedOnChildren = function getVariantFallbackBasedOnChildren(children) {
  if (isIconByChildren(children)) {
    return _Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_VARIANT.clear */ .RN.clear;
  }

  return _Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_VARIANT["default"] */ .RN["default"];
};

var getColorFallbackBasedOnChildren = function getColorFallbackBasedOnChildren(children) {
  if (isIconByChildren(children)) {
    return _Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_COLOR.icon */ .tY.icon;
  }

  return _Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_COLOR.primary */ .tY.primary;
};

var getSizeFallbackBasedOnChildren = function getSizeFallbackBasedOnChildren(children) {
  if (isIconByChildren(children)) {
    return _Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_SIZES["default"] */ .Gt["default"];
  }

  return _Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_SIZES.big */ .Gt.big;
};

var preventEvent = function preventEvent(e) {
  e.preventDefault();
};

var Button = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var _classnames, _objectSpread2;

  var idRipple = _ref.idRipple,
      classNameRipple = _ref.classNameRipple,
      _ref$rootTagName = _ref.rootTagName,
      RootTag = _ref$rootTagName === void 0 ? "button" : _ref$rootTagName,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "" : _ref$activeClassName,
      variant = _ref.variant,
      color = _ref.color,
      size = _ref.size,
      paddingLess = _ref.paddingLess,
      active = _ref.active,
      isContextMenuCustom = _ref.isContextMenuCustom,
      onContextMenu = _ref.onContextMenu,
      isOnLineOnly = _ref.isOnLineOnly,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      timeout = _ref.timeout,
      minWidth = _ref.minWidth,
      children = _ref.children,
      title = _ref.title,
      fontFamily = _ref.fontFamily,
      tabIndex = _ref.tabIndex,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var isDisabled = restProps.disabled;
  var handler = (0,_hooks_useOnlineOnlyHandler__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
  var handleClick = isOnLineOnly ? handler(onClick, preventEvent) : onClick;

  var handleKeyDown = function handleKeyDown(e) {
    if (onKeyDown) {
      onKeyDown(e);
    }

    if (!e.defaultPrevented && onClick) {
      (0,_utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_7__/* .handleKeyDownSelectItem */ .nq)(e, onClick);
    }
  };

  var handleLongPress = function handleLongPress(e) {
    e.preventDefault();
    document.dispatchEvent(new CustomEvent("contextMenuCustom", {
      detail: {
        target: e.target,
        getUrl: onContextMenu ? onContextMenu : ""
      }
    }));
  };

  var variantFinal = variant || getVariantFallbackBasedOnChildren(children);
  var colorFinal = color || getColorFallbackBasedOnChildren(children);
  var sizeFinal = size || getSizeFallbackBasedOnChildren(children);

  var rootProps = _objectSpread(_objectSpread({}, restProps), {}, (_objectSpread2 = {
    onClick: handleClick
  }, _defineProperty(_objectSpread2, "data-only-online", isOnLineOnly ? 1 : 0), _defineProperty(_objectSpread2, "onKeyDown", handleKeyDown), _defineProperty(_objectSpread2, "aria-label", restProps["aria-label"] || restProps.title), _defineProperty(_objectSpread2, "className", classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, fontFamily ? (_Button_module_scss__WEBPACK_IMPORTED_MODULE_8___default())[_Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .MapButtonFontFamilyToCN */ .QO[fontFamily]] : undefined, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btn), "btn", variantFinal, colorFinal, sizeFinal, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_8___default())[variantFinal], (_Button_module_scss__WEBPACK_IMPORTED_MODULE_8___default())[colorFinal], (_Button_module_scss__WEBPACK_IMPORTED_MODULE_8___default())[sizeFinal], (_Button_module_scss__WEBPACK_IMPORTED_MODULE_8___default())[minWidth], (_Button_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["with-custom-ctx-menu"]), isContextMenuCustom, (_classnames = {
    "active": active
  }, _defineProperty(_classnames, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active), active), _defineProperty(_classnames, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_8___default().disabled), isDisabled), _defineProperty(_classnames, activeClassName, active), _defineProperty(_classnames, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["padding-less"]), paddingLess), _classnames))), _defineProperty(_objectSpread2, "tabIndex", tabIndex !== null && tabIndex !== void 0 ? tabIndex : isDisabled ? -1 : 0), _defineProperty(_objectSpread2, "ref", ref), _objectSpread2));

  if (isContextMenuCustom) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_LongPressWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _extends({}, rootProps, {
      tag: RootTag,
      timeout: timeout,
      onLongPress: handleLongPress,
      onContextMenu: handleLongPress
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Button_Ripple__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      idRipple: idRipple
    }), children);
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(RootTag, rootProps, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Button_Ripple__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    idRipple: idRipple,
    className: classNameRipple
  }), children);
});
Button.variant = _Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_VARIANT */ .RN;
Button.color = _Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_COLOR */ .tY;
Button.size = _Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_SIZES */ .Gt;
Button.minWidth = _Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_MIN_WIDTH */ .lY;
Button.fontFamily = _Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_FONT_FAMILY */ .Il;
Button.propTypes = {
  idRipple: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  classNameRipple: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  activeClassName: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  rootTagName: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().any),
  variant: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(Object.values(_Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_VARIANT */ .RN)),
  color: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(Object.values(_Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_COLOR */ .tY)),
  size: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(Object.values(_Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_SIZES */ .Gt)),
  minWidth: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(Object.values(_Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_MIN_WIDTH */ .lY)),
  fontFamily: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(Object.values(_Button_constants__WEBPACK_IMPORTED_MODULE_6__/* .BUTTON_FONT_FAMILY */ .Il)),
  type: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  active: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  disabled: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  paddingLess: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  onContextMenu: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  onClick: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  isContextMenuCustom: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  isOnLineOnly: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 14435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48081);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18170);
/* harmony import */ var _IconView_IconView__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20844);
/* harmony import */ var _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59034);
/* harmony import */ var _ButtonMore_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31089);
/* harmony import */ var _ButtonMore_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_ButtonMore_module_scss__WEBPACK_IMPORTED_MODULE_6__);
var _excluded = ["isMoreActive", "onClick", "paddingLess"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }









var ButtonMore = function ButtonMore(_ref) {
  var isMoreActive = _ref.isMoreActive,
      onClick = _ref.onClick,
      paddingLess = _ref.paddingLess,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_1__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _extends({
    tabIndex: -1,
    paddingLess: paddingLess,
    variant: _Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"].variant.link */ .Z.variant.link,
    size: _Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"].size.small */ .Z.size.small,
    color: _Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"].color.searchSectionPrimary */ .Z.color.searchSectionPrimary,
    fontFamily: _Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fontFamily.roboto */ .Z.fontFamily.roboto,
    onClick: onClick
  }, restProps, {
    "data-less": t("less"),
    "data-more": t("more")
  }), t(isMoreActive ? "less" : "more"), "\xA0", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconView_IconView__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_ButtonMore_module_scss__WEBPACK_IMPORTED_MODULE_6___default().icon), _defineProperty({}, (_ButtonMore_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["is-less"]), isMoreActive)),
    icon: _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_5__/* ["default"]["chevron-right"] */ .Z["chevron-right"]
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (ButtonMore);

/***/ }),

/***/ 72064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48081);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18170);
/* harmony import */ var _IconView_IconView__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20844);
/* harmony import */ var _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59034);
/* harmony import */ var _shared_components_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75448);
/* harmony import */ var _close_button_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28903);
/* harmony import */ var _close_button_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_close_button_module_scss__WEBPACK_IMPORTED_MODULE_8__);
var _excluded = ["className", "showLabel"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }











var CloseButton = function CloseButton(_ref) {
  var className = _ref.className,
      _ref$showLabel = _ref.showLabel,
      showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_3__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  if (showLabel) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _extends({
      variant: _Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"].variant.clear */ .Z.variant.clear,
      color: _Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"].color.icon */ .Z.color.icon,
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_close_button_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["btn-close"]), className)
    }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconView_IconView__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      icon: _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_6__/* ["default"].close */ .Z.close
    }), showLabel && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: (_close_button_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["btn-close__text"])
    }, t("hideBtn")));
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, _extends({
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_close_button_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["root-icon-btn"]), className),
    icon: _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_6__/* ["default"].close */ .Z.close,
    title: t("hideBtn")
  }, props));
};

CloseButton.size = _Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"].size */ .Z.size;
CloseButton.propTypes = {
  showLabel: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseButton);

/***/ }),

/***/ 7360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ LinkLearnHowToUseApps; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48081);
/* harmony import */ var _shared_components_IconView_IconView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20844);
/* harmony import */ var _shared_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59034);
/* harmony import */ var _shared_utils_external_youtube_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10620);
/* harmony import */ var _shared_utils_string_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56332);






var LinkLearnHowToUseApps = function LinkLearnHowToUseApps(_ref) {
  var _ref$link = _ref.link,
      link = _ref$link === void 0 ? _shared_utils_external_youtube_constants__WEBPACK_IMPORTED_MODULE_4__/* .YOUTUBE_CHANNEL_URL */ .OV : _ref$link,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "egwWritingsApps" : _ref$title,
      style = _ref.style;

  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_1__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconView_IconView__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    style: {
      color: "red"
    },
    icon: _shared_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_3__/* ["default"].youtube */ .Z.youtube
  }), "\xA0", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: link,
    style: {
      fontFamily: "Roboto",
      letterSpacing: "0.01em"
    }
  }, t("learnHowToUse") + " " + (0,_shared_utils_string_string__WEBPACK_IMPORTED_MODULE_5__/* .addQuotes */ .XK)(t(title))));
};

/***/ }),

/***/ 22168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34412);
/* harmony import */ var _shared_utils_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62330);
/* harmony import */ var _shared_store_settings_selectors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4787);
/* harmony import */ var _shared_utils_settings_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20467);
/* harmony import */ var _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93752);
/* harmony import */ var _Ripple_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63758);
/* harmony import */ var _Ripple_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Ripple_module_scss__WEBPACK_IMPORTED_MODULE_7__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }










var Ripple = function Ripple(_ref) {
  var _classNames2;

  var activateOnMove = _ref.activateOnMove,
      idRipple = _ref.idRipple,
      className = _ref.className;
  var themeMode = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((0,_shared_store_settings_selectors__WEBPACK_IMPORTED_MODULE_6__/* .selectorSetting */ .K)(_shared_utils_settings_constants__WEBPACK_IMPORTED_MODULE_4__/* .SETTING.themeMode.id */ .Fy.themeMode.id));

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      darkTheme = _useState2[0],
      setDarkTheme = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      released = _useState4[0],
      setReleased = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      pressedTimeStamp = _useState6[0],
      setPressedTimestamp = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      rippleStyle = _useState8[0],
      setRippleStyle = _useState8[1];

  var updateRippleStyleByEvent = function updateRippleStyleByEvent(e) {
    var currentTargetRect = e.currentTarget.getBoundingClientRect();
    var coords = (0,_shared_utils_dom__WEBPACK_IMPORTED_MODULE_3__/* .getEventCoordinates */ .DC)(e);
    setRippleStyle({
      left: coords.x - currentTargetRect.x,
      top: coords.y - currentTargetRect.y
    });
  };

  var handleStart = function handleStart(e) {
    if (!pressedTimeStamp) {
      setPressedTimestamp(e.timeStamp);
    }

    updateRippleStyleByEvent(e);
  };

  var handleMove = activateOnMove || pressedTimeStamp ? activateOnMove ? handleStart : updateRippleStyleByEvent : undefined;
  var handleLeave = activateOnMove ? function () {
    setPressedTimestamp(null);
  } : undefined; // Listen for end interaction event.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var animationPressedMS = 200;
    var animationReleasedMS = 200;
    var timerIdAnimationPressed, timerIdAnimationRelease;

    var onTimerReleasedFire = function onTimerReleasedFire() {
      setReleased(null);
    };

    var onTimerPressedFire = function onTimerPressedFire() {
      setPressedTimestamp(null);
      setReleased(true);
      timerIdAnimationRelease = setTimeout(onTimerReleasedFire, animationReleasedMS);
    };

    var listener = function listener(e) {
      var delta = e.timeStamp - pressedTimeStamp;

      if (delta > animationPressedMS) {
        onTimerPressedFire();
      } else {
        timerIdAnimationPressed = setTimeout(onTimerPressedFire, animationPressedMS - delta);
      }
    };

    if (pressedTimeStamp) {
      // uses capture, because an event may be propagation stopped.
      document.addEventListener("mouseup", listener, true);
      document.addEventListener("touchend", listener, true);
    }

    return function () {
      if (timerIdAnimationRelease) {
        clearTimeout(timerIdAnimationRelease);
        onTimerReleasedFire();
      }

      if (timerIdAnimationPressed) {
        clearTimeout(timerIdAnimationPressed);
        onTimerPressedFire();
      }

      if (pressedTimeStamp) {
        document.removeEventListener("mouseup", listener, true);
        document.removeEventListener("touchend", listener, true);
      }
    };
  }, [pressedTimeStamp]); // Fixes hydration error: Prop `className` did not match.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setDarkTheme((0,_shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_5__/* .isDarkTheme */ .$o)(themeMode));
  }, [themeMode]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    id: idRipple !== null && idRipple !== void 0 ? idRipple : "",
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Ripple_module_scss__WEBPACK_IMPORTED_MODULE_7___default().root), className, _defineProperty({}, (_Ripple_module_scss__WEBPACK_IMPORTED_MODULE_7___default().dark), !darkTheme)),
    onTouchStart: handleStart,
    onMouseDown: handleStart,
    onMouseMove: handleMove,
    onTouchMove: handleMove,
    onMouseLeave: handleLeave,
    onBlur: handleLeave
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Ripple_module_scss__WEBPACK_IMPORTED_MODULE_7___default().ripple), (_classNames2 = {}, _defineProperty(_classNames2, (_Ripple_module_scss__WEBPACK_IMPORTED_MODULE_7___default().pressed), pressedTimeStamp), _defineProperty(_classNames2, (_Ripple_module_scss__WEBPACK_IMPORTED_MODULE_7___default().released), released), _classNames2)),
    style: rippleStyle
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Ripple);

/***/ }),

/***/ 33499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48081);
/* harmony import */ var _shared_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59034);
/* harmony import */ var _shared_components_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75448);
/* harmony import */ var _ThemeButton_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59954);
/* harmony import */ var _ThemeButton_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ThemeButton_module_scss__WEBPACK_IMPORTED_MODULE_5__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var ThemeButton = function ThemeButton(_ref) {
  var isLightDarkModesOnly = _ref.isLightDarkModesOnly,
      active = _ref.active,
      color = _ref.color,
      className = _ref.className,
      isDarkTheme = _ref.isDarkTheme,
      onClick = _ref.onClick;

  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_2__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  var title = isLightDarkModesOnly ? t("theme") + " " + (isDarkTheme ? t("dayMode") : t("darkMode")) : t("theme");
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    bordered: true,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, (_ThemeButton_module_scss__WEBPACK_IMPORTED_MODULE_5___default().btn)),
    active: active,
    color: color,
    icon: _shared_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_3__/* ["default"]["theme-select"] */ .Z["theme-select"],
    title: title,
    onClick: onClick
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ThemeButton_module_scss__WEBPACK_IMPORTED_MODULE_5___default().icon), _defineProperty({}, (_ThemeButton_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["is-dark-theme"]), isDarkTheme))
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (ThemeButton);

/***/ }),

/***/ 66636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48081);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Typography_Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21766);
/* harmony import */ var _Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64235);
/* harmony import */ var _Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78889);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








var Checkbox = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var _classNames;

  var className = _ref.className,
      _ref$iconClassName = _ref.iconClassName,
      iconClassName = _ref$iconClassName === void 0 ? "" : _ref$iconClassName,
      style = _ref.style,
      isInline = _ref.isInline,
      isTranslateLabel = _ref.isTranslateLabel,
      checked = _ref.checked,
      partCheck = _ref.partCheck,
      disabled = _ref.disabled,
      title = _ref.title,
      onChange = _ref.onChange,
      typographyProps = _ref.typographyProps,
      slotBefore = _ref.slotBefore,
      groupName = _ref.groupName,
      _ref$isFocusable = _ref.isFocusable,
      isFocusable = _ref$isFocusable === void 0 ? true : _ref$isFocusable;

  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_1__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  var name = (groupName !== null && groupName !== void 0 ? groupName : "checkbox") + "" + title;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var isCheckboxChecked = partCheck || checked;

  var handleKeyDown = function handleKeyDown(event) {
    if (onChange) {
      (0,_utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_5__/* .handleKeyDownSelectItem */ .nq)(event, function (e) {
        return onChange(!isCheckboxChecked, e);
      });
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: ref,
    style: style,
    onClick: function onClick(e) {
      return onChange && onChange(!isCheckboxChecked, e);
    },
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["checkbox-item"]), "checkbox-item", className, (_classNames = {}, _defineProperty(_classNames, (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_6___default().focused), focus), _defineProperty(_classNames, (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_6___default().checked), checked && !partCheck), _defineProperty(_classNames, (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["part-checked"]), partCheck), _defineProperty(_classNames, (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["is-inline"]), isInline), _defineProperty(_classNames, (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_6___default().disabled), disabled), _classNames))
  }, slotBefore, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", {
    tabIndex: isFocusable ? 0 : -1,
    "data-focus": isFocusable ? undefined : "false",
    type: "checkbox",
    name: name,
    className: (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_6___default().input),
    checked: isCheckboxChecked,
    onChange: function onChange() {},
    onFocus: function onFocus() {
      return setFocus(true);
    },
    onBlur: function onBlur() {
      return setFocus(false);
    },
    onKeyDown: handleKeyDown
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["wrap-checkmark"]), "global_wrap-checkmark", iconClassName)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_6___default().checkmark)
  })), title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _extends({
    tag: "label",
    htmlFor: name // threeDots
    ,
    variant: "body3",
    className: (_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
    color: "inherit"
  }, typographyProps), isTranslateLabel ? t(title) : title));
});
Checkbox.propTypes = {
  title: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  checked: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  isInline: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  disabled: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  partCheck: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  onChange: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  iconClassName: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  typographyProps: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)
};
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);

/***/ }),

/***/ 68551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DropDown_DropDown; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../shared/components/Popup/Popup.js
var Popup = __webpack_require__(4701);
// EXTERNAL MODULE: ../shared/utils/dom.js
var dom = __webpack_require__(62330);
// EXTERNAL MODULE: ../shared/utils/react.js
var utils_react = __webpack_require__(97993);
// EXTERNAL MODULE: ../shared/components/Portal/PortalMainAfter/constants.js
var constants = __webpack_require__(265);
// EXTERNAL MODULE: ../shared/what-input/useWhatInput.js
var useWhatInput = __webpack_require__(83951);
;// CONCATENATED MODULE: ../shared/hooks/useOutsideEvent.js


var useOutsideEvent = function useOutsideEvent(refOrRefs) {
  var eventType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "click";
  var callback = arguments.length > 2 ? arguments[2] : undefined;
  var specialCondition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var enabled = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var refElementsRefs = (0,react.useRef)();
  refElementsRefs.current = Array.isArray(refOrRefs) ? refOrRefs : [refOrRefs];
  (0,react.useEffect)(function () {
    var handleEvent = function handleEvent(event) {
      if (!callback) {
        return;
      }

      var isSpecialConditionOK = specialCondition && (typeof specialCondition === "function" ? specialCondition(event) : specialCondition);

      if (isSpecialConditionOK && refElementsRefs.current.some(function (elRef) {
        return (elRef === null || elRef === void 0 ? void 0 : elRef.current) && !elRef.current.contains(event.target);
      })) {
        callback(event);
      }
    };

    if (enabled) {
      document.addEventListener(eventType, handleEvent);
    }

    return function () {
      if (enabled) {
        document.removeEventListener(eventType, handleEvent);
      }
    };
  }, [callback, eventType, specialCondition, enabled]);
};

/* harmony default export */ var hooks_useOutsideEvent = (useOutsideEvent);
// EXTERNAL MODULE: ../shared/hooks/usePopup.js
var usePopup = __webpack_require__(98754);
// EXTERNAL MODULE: ../shared/components/DropDown/dropDown.module.scss
var dropDown_module = __webpack_require__(15644);
var dropDown_module_default = /*#__PURE__*/__webpack_require__.n(dropDown_module);
;// CONCATENATED MODULE: ../shared/components/DropDown/DropDown.js
var _excluded = ["isRenderBodyWhenSSR", "hasConstantSizes", "isUseLockBodyScroll", "disabled", "className", "button", "onClickButton", "body", "boundaryRect", "hasBackdrop", "toggleOnMouseOverLeave", "closeOnPathnameChange", "isPopupCoversButtonByDefault", "isMaxWidthBasedOnButton", "toggleOnClickButton", "focusOnBecameVisible", "onShow", "onHide", "popupProps", "isMinWidthBasedOnButton", "style", "noPortal"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }












var DropDown = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _popupProps$contentPr;

  var isRenderBodyWhenSSR = _ref.isRenderBodyWhenSSR,
      hasConstantSizes = _ref.hasConstantSizes,
      isUseLockBodyScroll = _ref.isUseLockBodyScroll,
      disabled = _ref.disabled,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      button = _ref.button,
      onClickButton = _ref.onClickButton,
      body = _ref.body,
      boundaryRect = _ref.boundaryRect,
      _ref$hasBackdrop = _ref.hasBackdrop,
      hasBackdrop = _ref$hasBackdrop === void 0 ? false : _ref$hasBackdrop,
      _ref$toggleOnMouseOve = _ref.toggleOnMouseOverLeave,
      toggleOnMouseOverLeave = _ref$toggleOnMouseOve === void 0 ? false : _ref$toggleOnMouseOve,
      closeOnPathnameChange = _ref.closeOnPathnameChange,
      isPopupCoversButtonByDefault = _ref.isPopupCoversButtonByDefault,
      isMaxWidthBasedOnButton = _ref.isMaxWidthBasedOnButton,
      toggleOnClickButton = _ref.toggleOnClickButton,
      focusOnBecameVisible = _ref.focusOnBecameVisible,
      onShow = _ref.onShow,
      onHide = _ref.onHide,
      popupProps = _ref.popupProps,
      isMinWidthBasedOnButton = _ref.isMinWidthBasedOnButton,
      style = _ref.style,
      noPortal = _ref.noPortal,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0,react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      elRoot = _useState2[0],
      setElRoot = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      elPopup = _useState4[0],
      setElPopup = _useState4[1];

  var _usePopup = (0,usePopup/* usePopup */.B)(closeOnPathnameChange),
      isShown = _usePopup.isShown,
      closePopup = _usePopup.closePopup,
      openPopup = _usePopup.openPopup,
      anchorEl = _usePopup.anchorEl;

  var isLastInputMouse = (0,useWhatInput/* useWhatInputIsLastPointerMouse */.a)();

  var handleClickButton = function handleClickButton(e) {
    e.stopPropagation();

    if (toggleOnClickButton && isShown) {
      hide();
    } else {
      show(e);

      if (onClickButton) {
        onClickButton(e);
      }
    }
  };

  var show = (0,react.useCallback)(function (e) {
    openPopup(e);

    if (onShow) {
      onShow();
    }
  }, [openPopup, onShow]);
  var hide = (0,react.useCallback)(function () {
    closePopup();

    if (onHide) {
      onHide();
    }
  }, [closePopup, onHide]);
  var checkIfEventRelatedToThisFloatWindow = (0,react.useCallback)(function (e) {
    var eventPath = (0,dom/* getEventPath */.AZ)(e);
    var elPortalMainAfter = document.getElementById(constants/* EL_ID_PORTAL_MAIN_AFTER */.t);

    if (!eventPath || !eventPath.includes(elPortalMainAfter)) {
      return true;
    }

    var elsChildrenPortalAfter = _toConsumableArray(elPortalMainAfter.children);

    var indexThisRootInPortal = elsChildrenPortalAfter.findIndex(function (c) {
      return c === elPopup;
    });

    if (indexThisRootInPortal === -1) {
      return true;
    }

    var indexInPortalEvent = elsChildrenPortalAfter.findIndex(function (c) {
      return eventPath.includes(c);
    });

    if (indexInPortalEvent === -1) {
      return true;
    }

    return indexInPortalEvent < indexThisRootInPortal;
  }, [elPopup]); // FAST-FIX (need to investigate issue more, if troubles with the current fix):
  // Use "mouseup" for input mouse instead of "click".
  // There is a bug with click, on desktop:
  // 1) open small player TOC
  // 2) long press on item so the custom context menu appears
  // 3) release the mouse button
  // AR: TOC popup closes
  // ER: TOC popup is not closed

  var eventTypeOutsideEvent = isLastInputMouse ? "mouseup" : "touchstart";
  hooks_useOutsideEvent([{
    current: elRoot
  }, elPopup], eventTypeOutsideEvent, hide, checkIfEventRelatedToThisFloatWindow, isShown);

  var handleKeyDownRoot = function handleKeyDownRoot(e) {
    if (checkIfEventRelatedToThisFloatWindow(e)) {
      if ((0,dom/* isEventKey */.WV)(e, dom/* KeyCode.enter */.VD.enter)) {
        if (!isShown) {
          show(e);
        }
      }
    }
  };

  var onHideFromProps = popupProps === null || popupProps === void 0 ? void 0 : popupProps.onHide;
  var handleHidePopup = (0,react.useCallback)(function () {
    hide();

    if (onHideFromProps) {
      onHideFromProps.apply(void 0, arguments);
    }
  }, [hide, onHideFromProps]);
  var handleRef = (0,react.useCallback)(function (el) {
    if (ref) {
      var refData = {
        view: el,
        hide: hide,
        show: show
      };
      (0,utils_react/* handleReactRef */.q)(ref, refData);
    }

    setElRoot(el);
  }, [ref, hide, show]);
  var anchorRectFinal;

  if (anchorEl && isPopupCoversButtonByDefault) {
    var rect = anchorEl.getBoundingClientRect();
    anchorRectFinal = {
      top: rect.top,
      left: rect.left,
      bottom: rect.top,
      right: rect.left,
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: 0
    };
  }

  var contentPropsFinal = popupProps !== null && popupProps !== void 0 && popupProps.contentProps ? _objectSpread({}, popupProps.contentProps) : {};
  var contentPropsStyleDefault = {};

  if (isMinWidthBasedOnButton) {
    contentPropsStyleDefault.minWidth = elRoot === null || elRoot === void 0 ? void 0 : elRoot.offsetWidth;
  }

  if (isMaxWidthBasedOnButton) {
    contentPropsStyleDefault.maxWidth = elRoot === null || elRoot === void 0 ? void 0 : elRoot.offsetWidth;
  }

  contentPropsFinal.style = popupProps !== null && popupProps !== void 0 && (_popupProps$contentPr = popupProps.contentProps) !== null && _popupProps$contentPr !== void 0 && _popupProps$contentPr.style ? _objectSpread(_objectSpread({}, popupProps.contentProps.style), contentPropsStyleDefault) : contentPropsStyleDefault;
  var isCanToggleByMouseEnterLeave = toggleOnMouseOverLeave && isLastInputMouse;
  return /*#__PURE__*/react.createElement("div", _extends({
    ref: handleRef,
    className: classnames_default()((dropDown_module_default())["base-drop-down"], className),
    onMouseEnter: isCanToggleByMouseEnterLeave ? show : undefined,
    onMouseLeave: isCanToggleByMouseEnterLeave ? hide : undefined,
    onKeyDown: handleKeyDownRoot,
    style: style
  }, restProps), typeof button === "function" ? button({
    show: isShown,
    hide: hide,
    onClick: handleClickButton
  }) : button, /*#__PURE__*/react.createElement(Popup["default"], _extends({
    ref: setElPopup,
    noPortal: noPortal,
    focusOnBecameVisible: focusOnBecameVisible,
    isUseLockBodyScroll: isUseLockBodyScroll,
    isShown: isShown,
    anchorEl: anchorEl,
    anchorRect: anchorRectFinal,
    boundaryRect: boundaryRect,
    hasBackdrop: hasBackdrop !== null && hasBackdrop !== void 0 ? hasBackdrop : !isCanToggleByMouseEnterLeave
  }, popupProps, {
    onHide: handleHidePopup,
    contentProps: contentPropsFinal,
    className: classnames_default()(popupProps === null || popupProps === void 0 ? void 0 : popupProps.className, (dropDown_module_default())["dd-popup"])
  }), (isShown || isRenderBodyWhenSSR && !("window" in __webpack_require__.g)) && (typeof body === "function" ? body({
    hide: hide
  }) : body)));
});
DropDown.propTypes = {
  isRenderBodyWhenSSR: (prop_types_default()).bool,
  isUseLockBodyScroll: (prop_types_default()).bool,
  toggleOnMouseOverLeave: (prop_types_default()).bool,
  className: (prop_types_default()).string,
  boundaryRect: (prop_types_default()).object,
  button: prop_types_default().oneOfType([(prop_types_default()).node, (prop_types_default()).func]),
  onClick: (prop_types_default()).func,
  body: prop_types_default().oneOfType([(prop_types_default()).node, (prop_types_default()).func]),
  onShow: (prop_types_default()).func,
  popupProps: (prop_types_default()).object
};
/* harmony default export */ var DropDown_DropDown = (DropDown);

/***/ }),

/***/ 12346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _DropDown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68551);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18170);
/* harmony import */ var _ArrowIcon_ArrowIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93588);
/* harmony import */ var _shared_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58114);
var _excluded = ["className", "showArrow", "label", "buttonProps", "parentNode", "boundaryRect", "children", "toggleOnMouseOverLeave", "closeOnPathnameChange", "clamp", "btnRef", "popupProps", "onShow"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var DropDownVariantButton = function DropDownVariantButton(_ref) {
  var className = _ref.className,
      _ref$showArrow = _ref.showArrow,
      showArrow = _ref$showArrow === void 0 ? true : _ref$showArrow,
      label = _ref.label,
      buttonProps = _ref.buttonProps,
      parentNode = _ref.parentNode,
      boundaryRect = _ref.boundaryRect,
      children = _ref.children,
      toggleOnMouseOverLeave = _ref.toggleOnMouseOverLeave,
      closeOnPathnameChange = _ref.closeOnPathnameChange,
      clamp = _ref.clamp,
      btnRef = _ref.btnRef,
      popupProps = _ref.popupProps,
      onShow = _ref.onShow,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_DropDown__WEBPACK_IMPORTED_MODULE_1__["default"], _extends({
    className: className,
    closeOnPathnameChange: closeOnPathnameChange,
    toggleOnMouseOverLeave: toggleOnMouseOverLeave,
    boundaryRect: boundaryRect !== null && boundaryRect !== void 0 ? boundaryRect : parentNode === null || parentNode === void 0 ? void 0 : parentNode.getBoundingClientRect(),
    toggleOnClickButton: true,
    onShow: onShow,
    button: function button(_ref2) {
      var show = _ref2.show,
          onClick = _ref2.onClick;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _extends({
        ref: btnRef,
        type: "button",
        variant: _Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].variant.clear */ .Z.variant.clear,
        color: _Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.icon */ .Z.color.icon,
        fontFamily: _Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fontFamily.roboto */ .Z.fontFamily.roboto,
        active: show,
        "aria-label": label
      }, buttonProps, {
        onClick: buttonProps !== null && buttonProps !== void 0 && buttonProps.onClick ? function (e) {
          var prevented = false;
          buttonProps.onClick(e, function () {
            prevented = true;
          });

          if (!prevented) {
            onClick(e);
          }
        } : onClick
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
        threeDots: !clamp,
        clamp: clamp
      }, label), "\xA0", showArrow ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ArrowIcon_ArrowIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        direction: show ? _ArrowIcon_ArrowIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"].direction.DOWN */ .Z.direction.DOWN : _ArrowIcon_ArrowIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"].direction.RIGHT */ .Z.direction.RIGHT
      }) : "");
    },
    body: children,
    popupProps: popupProps
  }, restProps));
};

/* harmony default export */ __webpack_exports__["Z"] = (DropDownVariantButton);

/***/ }),

/***/ 26976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _DropDown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68551);
/* harmony import */ var _IconButton_IconButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75448);
/* harmony import */ var _what_input_useWhatInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83951);
/* harmony import */ var _Select_SelectVariantIcon_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35005);
/* harmony import */ var _Select_SelectVariantIcon_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Select_SelectVariantIcon_module_scss__WEBPACK_IMPORTED_MODULE_6__);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }









var DropDownVariantIconButton = function DropDownVariantIconButton(_ref) {
  var icon = _ref.icon,
      disabled = _ref.disabled,
      active = _ref.active,
      iconTitle = _ref.iconTitle,
      iconBordered = _ref.iconBordered,
      iconColor = _ref.iconColor,
      showIcon = _ref.showIcon,
      className = _ref.className,
      buttonClassName = _ref.buttonClassName,
      isPopupCoversButtonByDefault = _ref.isPopupCoversButtonByDefault,
      toggleOnMouseOverLeave = _ref.toggleOnMouseOverLeave,
      id = _ref.id,
      style = _ref.style,
      buttonProps = _ref.buttonProps,
      popupProps = _ref.popupProps,
      children = _ref.children;
  var isLastInputMouse = (0,_what_input_useWhatInput__WEBPACK_IMPORTED_MODULE_5__/* .useWhatInputIsLastPointerMouse */ .a)(); // [EGWW-2043]

  var refIdTimerPreventOpenOnClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var refIsPreventOpenOnClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false); // ============

  var handleMouseOverButton = function handleMouseOverButton() {
    if (toggleOnMouseOverLeave && isLastInputMouse) {
      refIsPreventOpenOnClick.current = true;
      clearTimeout(refIdTimerPreventOpenOnClick.current);
      refIdTimerPreventOpenOnClick.current = setTimeout(function () {
        refIdTimerPreventOpenOnClick.current = undefined;
        refIsPreventOpenOnClick.current = false;
      }, 750);
    } else {
      refIsPreventOpenOnClick.current = false;
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_DropDown__WEBPACK_IMPORTED_MODULE_3__["default"], {
    toggleOnClickButton: true,
    isPopupCoversButtonByDefault: isPopupCoversButtonByDefault,
    toggleOnMouseOverLeave: toggleOnMouseOverLeave,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, (_Select_SelectVariantIcon_module_scss__WEBPACK_IMPORTED_MODULE_6___default().root)),
    style: style,
    popupProps: popupProps,
    button: function button(_ref2) {
      var show = _ref2.show,
          _onClick = _ref2.onClick;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _extends({
        bordered: iconBordered,
        showIcon: showIcon,
        id: id,
        active: active || show,
        title: iconTitle,
        icon: icon,
        color: iconColor,
        className: buttonClassName,
        onClick: function onClick() {
          return refIsPreventOpenOnClick.current ? undefined : _onClick.apply(void 0, arguments);
        },
        disabled: disabled,
        onMouseOver: handleMouseOverButton
      }, buttonProps));
    },
    body: children
  });
};

DropDownVariantIconButton.defaultProps = {
  withToggleDelayRestriction: true
};
DropDownVariantIconButton.propTypes = {
  icon: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().func), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)]),
  iconTitle: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  onChange: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  active: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  disabled: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  maxHeight: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number),
  withRadio: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  toggleOnMouseOverLeave: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  id: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (DropDownVariantIconButton);

/***/ }),

/***/ 9237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21766);
/* harmony import */ var _Button_ButtonMore_ButtonMore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14435);
/* harmony import */ var _FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71984);
/* harmony import */ var _FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5__);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








var getFullWidth = function getFullWidth(element) {
  var style = element.currentStyle || window.getComputedStyle(element),
      width = element.offsetWidth,
      // or use style.width
  margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight),
      padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight),
      border = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
  return parseInt(width + margin + padding + border, 10);
};

var MIN_SHOW_COUNT = 2;
var MAX_SHOW_COUNT = 5;

var FeaturedSectionContent = function FeaturedSectionContent(_ref) {
  var book = _ref.book,
      onItemClick = _ref.onItemClick,
      onContextMenu = _ref.onContextMenu,
      BookCoverView = _ref.BookCoverView,
      Badge = _ref.Badge,
      withoutMore = _ref.withoutMore;
  var contentRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var hiddenContentRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      elementCount = _useState2[0],
      setElementCount = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isShowMore = _useState4[0],
      setElementWidth = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(MIN_SHOW_COUNT),
      _useState6 = _slicedToArray(_useState5, 2),
      isMore = _useState6[0],
      setIsMore = _useState6[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (contentRef.current && hiddenContentRef.current) {
      var containerWidth = contentRef.current.offsetWidth;
      var items = hiddenContentRef.current.querySelectorAll(".featured-section__link");
      var threeLinesWidth = containerWidth * isMore + containerWidth / 2;
      var elementsWidth = 0;
      var elementsCount = 0;
      var _isShowMore = false;

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var width = getFullWidth(item);

        if (elementsWidth < threeLinesWidth) {
          elementsWidth += width;
          elementsCount += 1;
        } else {
          _isShowMore = true;
        }
      }

      setElementWidth(_isShowMore);
      setElementCount(elementsCount);
    }
  }, [book.links, isMore]);
  var links = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    if (elementCount === 0) {
      return book.links;
    }

    return book.links.slice(0, elementCount);
  }, [book.links, elementCount]);

  var toggleShow = function toggleShow() {
    if (isMore === MIN_SHOW_COUNT) {
      setIsMore(MAX_SHOW_COUNT);
    } else {
      setIsMore(MIN_SHOW_COUNT);
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    key: book.book_id,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["featured-section__item"]), "featured-section__item")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["featured-section__image"])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(BookCoverView, {
    book: book
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["featured-section__title"]), "featured-section__title")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    threeDots: true,
    color: "default",
    variant: "body2",
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["featured-section__title-text"]))
  }, book.title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Badge, {
    number: book.links.length
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", {
    ref: hiddenContentRef,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["featured-section__links"]), (_FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hidden), "hidden")
  }, book.links.map(function (link) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
      key: link.para_id,
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["featured-section__link"]), "featured-section__link")
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["featured-section__link-text"]), "featured-section__link-text")
    }, link.ref));
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", {
    ref: contentRef,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["featured-section__links"]), "featured-section__links")
  }, links.map(function (link) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
      key: link.para_id,
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["featured-section__link"]), "featured-section__link"),
      tabIndex: -1,
      onContextMenu: onContextMenu ? function (e) {
        return onContextMenu(e, link);
      } : null
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["featured-section__link-text"]), "featured-section__link-text"),
      onClick: function onClick() {
        return onItemClick(link.para_id);
      },
      dangerouslySetInnerHTML: {
        __html: link.ref
      }
    }));
  }), isShowMore && !withoutMore && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_ButtonMore_ButtonMore__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    key: "btn-more",
    className: (_FeaturedSectionContent_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["btn-more"]),
    paddingLess: true,
    isMoreActive: isMore === MAX_SHOW_COUNT,
    onClick: toggleShow
  }))));
};

FeaturedSectionContent.propTypes = {
  book: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object),
  onItemClick: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  onContextMenu: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  BookCoverView: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  Badge: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  withoutMore: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  i18nTranslate: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (FeaturedSectionContent);

/***/ }),

/***/ 56123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Portal_Portal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64976);
/* harmony import */ var _Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(265);
/* harmony import */ var _utils_number_number__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50150);
/* harmony import */ var _shared_utils_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62330);
/* harmony import */ var _shared_utils_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97993);
/* harmony import */ var _FloatWindow_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21571);
/* harmony import */ var _FloatWindow_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_FloatWindow_module_scss__WEBPACK_IMPORTED_MODULE_7__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }










var isEventContainsDraggableElement = function isEventContainsDraggableElement(e) {
  return "draggable" in e.target.dataset && e.target.dataset.draggable !== "false" || e.target.closest("[data-draggable]:not([data-draggable='false'])");
};

var TIME_CLICK_ALLOWED = 250;
var FloatWindow = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      positionInitial = _ref.positionInitial,
      children = _ref.children,
      position = _ref.position,
      onChangePosition = _ref.onChangePosition,
      onDrag = _ref.onDrag;

  // FIXES:
  // In Lite App "init drag use effect" is not re-called on page change
  // if dependency is an empty array.
  // Listeners of {elRoot} are not saved on page change either.
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      elRoot = _useState2[0],
      setElRoot = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      timeStampStart = _useState4[0],
      setTimeStampStart = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      positionStart = _useState6[0],
      setPositionStart = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(positionInitial !== null && positionInitial !== void 0 ? positionInitial : position),
      _useState8 = _slicedToArray(_useState7, 2),
      positionLocal = _useState8[0],
      setPositionLocal = _useState8[1];

  var positionFinal = position !== null && position !== void 0 ? position : positionLocal;
  var setPositionFinal = onChangePosition !== null && onChangePosition !== void 0 ? onChangePosition : setPositionLocal;
  var scrollBarInfo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return (0,_shared_utils_dom__WEBPACK_IMPORTED_MODULE_3__/* .getBrowserScrollbarInfo */ .Ke)();
  }, []);
  var refPositionFinal = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  refPositionFinal.current = positionFinal;
  var refIsLastInteractionDragged = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var refFnOnDrag = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  refFnOnDrag.current = onDrag;

  var getRectParent = function getRectParent() {
    return {
      x: 0,
      y: 0,
      left: 0,
      top: 0,
      right: window.innerWidth,
      bottom: window.innerHeight,
      width: window.innerWidth - scrollBarInfo.width,
      height: window.innerHeight
    };
  };

  var handleTouchEnd = function handleTouchEnd() {
    setPositionStart(undefined);
    setTimeStampStart(undefined);
  };

  var handleMouseUp = function handleMouseUp() {
    setPositionStart(undefined);
    setTimeStampStart(undefined);
  };

  var onChildResized = function onChildResized(deltaX, deltaY) {
    var _refPositionFinal$cur, _refPositionFinal$cur2;

    var rectParent = getRectParent();
    var rectRoot = elRoot.getBoundingClientRect();
    var topCurrent = (_refPositionFinal$cur = refPositionFinal.current) === null || _refPositionFinal$cur === void 0 ? void 0 : _refPositionFinal$cur.top;
    var leftCurrent = (_refPositionFinal$cur2 = refPositionFinal.current) === null || _refPositionFinal$cur2 === void 0 ? void 0 : _refPositionFinal$cur2.left;
    setPositionFinal({
      top: (0,_utils_number_number__WEBPACK_IMPORTED_MODULE_4__/* .clutch */ .Cz)(topCurrent + deltaY, rectParent.top, rectParent.top + rectParent.height - rectRoot.height),
      left: (0,_utils_number_number__WEBPACK_IMPORTED_MODULE_4__/* .clutch */ .Cz)(leftCurrent + deltaX, rectParent.left, rectParent.left + rectParent.width - rectRoot.width)
    });
  };

  var refValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
  refValue.current.onChildResized = onChildResized;
  (0,_shared_utils_react__WEBPACK_IMPORTED_MODULE_5__/* .handleReactRef */ .q)(ref, refValue.current); // Listen to "drag init".

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var initDragAndDrop = function initDragAndDrop(e) {
      if (!isEventContainsDraggableElement(e)) {
        return;
      }

      setPositionStart((0,_shared_utils_dom__WEBPACK_IMPORTED_MODULE_3__/* .getEventCoordinates */ .DC)(e));
      setTimeStampStart(e.timeStamp);
    };

    var handleClick = function handleClick(e) {
      if (!isEventContainsDraggableElement(e)) {
        return;
      }

      if (refIsLastInteractionDragged.current) {
        e.preventDefault();
        e.stopPropagation();
        refIsLastInteractionDragged.current = undefined;
      }
    };

    if (elRoot) {
      elRoot.addEventListener("touchstart", initDragAndDrop);
      elRoot.addEventListener("mousedown", initDragAndDrop);
      elRoot.addEventListener("click", handleClick);
    }

    return function () {
      if (elRoot) {
        elRoot.removeEventListener("touchstart", initDragAndDrop);
        elRoot.removeEventListener("mousedown", initDragAndDrop);
        elRoot.removeEventListener("click", handleClick);
      }
    };
  }, [elRoot]); // Listen to "drag move".

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var offsetX;
    var offsetY;

    var handleNewPosition = function handleNewPosition(position) {
      var rectParent = getRectParent();
      var rectRoot = elRoot.getBoundingClientRect();
      setPositionFinal({
        top: (0,_utils_number_number__WEBPACK_IMPORTED_MODULE_4__/* .clutch */ .Cz)(position.y + offsetY, 0, rectParent.top + rectParent.height - rectRoot.height),
        left: (0,_utils_number_number__WEBPACK_IMPORTED_MODULE_4__/* .clutch */ .Cz)(position.x + offsetX, 0, rectParent.left + rectParent.width - rectRoot.width)
      });
    };

    var handleDrag = function handleDrag(e) {
      if (e.timeStamp - timeStampStart > TIME_CLICK_ALLOWED) {
        refIsLastInteractionDragged.current = true;
      }

      handleNewPosition((0,_shared_utils_dom__WEBPACK_IMPORTED_MODULE_3__/* .getEventCoordinates */ .DC)(e));

      if (refFnOnDrag.current) {
        refFnOnDrag.current(e);
      }
    };

    if (positionStart && elRoot) {
      var rootBoundingClientRect = elRoot.getBoundingClientRect();
      offsetX = rootBoundingClientRect.left - positionStart.x;
      offsetY = rootBoundingClientRect.top - positionStart.y;
      window.addEventListener("mousemove", handleDrag);
      window.addEventListener("touchmove", handleDrag);
    }

    return function () {
      if (positionStart) {
        window.removeEventListener("mousemove", handleDrag);
        window.removeEventListener("touchmove", handleDrag);
      }
    };
  }, [positionStart, timeStampStart]); // Validate {position} on "resize".

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var windowWidthPrev = window.innerWidth;
    var windowHeightPrev = window.innerHeight;

    var validatePosition = function validatePosition() {
      if (elRoot) {
        var _refPositionFinal$cur3, _refPositionFinal$cur4;

        var rectParent = getRectParent();
        var rectRoot = elRoot.getBoundingClientRect();
        var topCurrent = (_refPositionFinal$cur3 = refPositionFinal.current) === null || _refPositionFinal$cur3 === void 0 ? void 0 : _refPositionFinal$cur3.top;
        var leftCurrent = (_refPositionFinal$cur4 = refPositionFinal.current) === null || _refPositionFinal$cur4 === void 0 ? void 0 : _refPositionFinal$cur4.left;
        setPositionFinal({
          top: (0,_utils_number_number__WEBPACK_IMPORTED_MODULE_4__/* .clutch */ .Cz)(topCurrent > windowHeightPrev / 2 ? topCurrent + (window.innerHeight - windowHeightPrev) : topCurrent, rectParent.top, rectParent.top + rectParent.height - rectRoot.height),
          left: (0,_utils_number_number__WEBPACK_IMPORTED_MODULE_4__/* .clutch */ .Cz)(leftCurrent > windowWidthPrev / 2 ? leftCurrent + (window.innerWidth - windowWidthPrev) : leftCurrent, rectParent.left, rectParent.left + rectParent.width - rectRoot.width)
        });
      }

      windowWidthPrev = window.innerWidth;
      windowHeightPrev = window.innerHeight;
    };

    window.addEventListener("resize", validatePosition);
    validatePosition();
    return function () {
      window.removeEventListener("resize", validatePosition);
    };
  }, [elRoot]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Portal_Portal__WEBPACK_IMPORTED_MODULE_2__["default"], {
    id: _Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_6__/* .EL_ID_PORTAL_MAIN_AFTER */ .t
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: setElRoot,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_FloatWindow_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["float-window"]), className, _defineProperty({}, (_FloatWindow_module_scss__WEBPACK_IMPORTED_MODULE_7___default().dragging), !!positionFinal)),
    style: positionFinal,
    onMouseUp: handleMouseUp,
    onTouchEnd: handleTouchEnd,
    onTouchCancel: handleTouchEnd,
    tabIndex: 0
  }, children));
});
/* harmony default export */ __webpack_exports__["Z"] = (FloatWindow);

/***/ }),

/***/ 75448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ IconButton_IconButton; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(34412);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../shared/components/IconView/IconView.js
var IconView = __webpack_require__(20844);
// EXTERNAL MODULE: ../shared/components/index.js + 5 modules
var components = __webpack_require__(58114);
// EXTERNAL MODULE: ../shared/what-input/useWhatInput.js
var useWhatInput = __webpack_require__(83951);
// EXTERNAL MODULE: ../shared/utils/optimization.js
var optimization = __webpack_require__(18747);
// EXTERNAL MODULE: ../shared/store/settings/selectors.js
var selectors = __webpack_require__(4787);
// EXTERNAL MODULE: ../shared/hooks/useOnlineOnlyHandler.js
var useOnlineOnlyHandler = __webpack_require__(12651);
// EXTERNAL MODULE: ../shared/utils/settings/constants.js + 1 modules
var constants = __webpack_require__(20467);
// EXTERNAL MODULE: ../shared/utils/keyboard-navigation/keyboard-navigation.js
var keyboard_navigation = __webpack_require__(78889);
;// CONCATENATED MODULE: ../shared/components/IconButton/IconButton.constants.js
var ICON_BUTTON_COLOR = {
  headerItem: "header-item"
};
// EXTERNAL MODULE: ../shared/components/Button/Ripple.js
var Ripple = __webpack_require__(22168);
// EXTERNAL MODULE: ../shared/components/IconButton/IconButton.module.scss
var IconButton_module = __webpack_require__(64501);
var IconButton_module_default = /*#__PURE__*/__webpack_require__.n(IconButton_module);
;// CONCATENATED MODULE: ../shared/components/IconButton/IconButton.js
var _excluded = ["color", "icon", "showIcon", "active", "disabled", "isOnLineOnly", "onClick", "onKeyDown", "onDisableClick", "className", "classNameActive", "title", "ariaLabel", "role", "ariaPressed", "bordered", "noHoverBackground", "noFocusable", "trottle", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
















var preventEvent = function preventEvent(e) {
  e.preventDefault();
};

var IconButton = function IconButton(_ref) {
  var color = _ref.color,
      icon = _ref.icon,
      showIcon = _ref.showIcon,
      active = _ref.active,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      isOnLineOnly = _ref.isOnLineOnly,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      onDisableClick = _ref.onDisableClick,
      className = _ref.className,
      classNameActive = _ref.classNameActive,
      title = _ref.title,
      ariaLabel = _ref.ariaLabel,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? "button" : _ref$role,
      _ref$ariaPressed = _ref.ariaPressed,
      ariaPressed = _ref$ariaPressed === void 0 ? undefined : _ref$ariaPressed,
      bordered = _ref.bordered,
      noHoverBackground = _ref.noHoverBackground,
      noFocusable = _ref.noFocusable,
      _ref$trottle = _ref.trottle,
      trottle = _ref$trottle === void 0 ? 0 : _ref$trottle,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var classes = ["icon-button-base", (IconButton_module_default()).root];
  var trottleRef = (0,react.useRef)(Date.now());
  var handler = (0,useOnlineOnlyHandler/* default */.Z)();
  var handleClick = isOnLineOnly ? handler(onClick, preventEvent) : onClick;
  var isLastPointerMouse = (0,useWhatInput/* useWhatInputValueIsLastPointerMouse */.s)();
  var textMode = (0,es/* useSelector */.v9)((0,selectors/* selectorSetting */.K)(constants/* SETTING.textMode.id */.Fy.textMode.id));
  var showTextInsteadOfIcon = textMode && title && !showIcon;

  if (color) {
    classes.push((IconButton_module_default())[color]);
  }

  if (active) {
    classes.push("icon-button-active", (IconButton_module_default()).active, "active");

    if (classNameActive) {
      classes.push(classNameActive);
    }
  } else if (disabled) {
    classes.push("icon-button-disabled", (IconButton_module_default()).disabled);
  }

  if (bordered) {
    classes.push("bordered", (IconButton_module_default()).bordered);
  }

  if (noHoverBackground) {
    classes.push("noHoverBackground", (IconButton_module_default()).noHoverBackground);
  }

  if (className) {
    classes.push(className);
  }

  if (showTextInsteadOfIcon) {
    classes.push("text-only", (IconButton_module_default())["text-only"]);
  }

  var _useTooltipContext = (0,components/* useTooltipContext */.nr)(),
      hideTooltip = _useTooltipContext.hideTooltip,
      showTooltip = _useTooltipContext.showTooltip; // Hide a tooltip on unmount.
  // FIXME: Need to specify a unique id, otherwise an unrelated tooltip may be closed.


  (0,react.useEffect)(function () {
    return function () {
      hideTooltip();
    };
  }, [hideTooltip]);
  var label = ariaLabel || title;
  var onClickFinal = undefined;

  if (onClick && !disabled) {
    onClickFinal = function onClickFinal(e) {
      if ((0,optimization/* trottleCheck */.qo)(trottle, trottleRef.current)) {
        hideTooltip();
        trottleRef.current = Date.now();
        handleClick(e);
      }
    };
  } else if (onDisableClick && disabled) {
    onClickFinal = function onClickFinal(e) {
      if ((0,optimization/* trottleCheck */.qo)(trottle, trottleRef.current)) {
        hideTooltip();
        onDisableClick(e);
      }
    };
  }

  var handleKeyDown = function handleKeyDown(e) {
    if (onKeyDown) {
      onKeyDown(e);
    }

    if (!e.defaultPrevented && onClickFinal) {
      (0,keyboard_navigation/* handleKeyDownSelectItem */.nq)(e, onClickFinal);
    }
  };

  var allProps = _objectSpread({
    className: classes.join(" "),
    icon: icon,
    tabIndex: noFocusable ? -1 : disabled ? undefined : 0,
    "aria-label": label,
    "aria-pressed": active !== null && active !== void 0 ? active : ariaPressed,
    role: role,
    onKeyDown: handleKeyDown,
    onClick: onClickFinal
  }, otherProps);

  if (showTextInsteadOfIcon) {
    return /*#__PURE__*/react.createElement("span", allProps, label, children);
  }

  allProps.icon = icon;
  allProps.onMouseEnter = isLastPointerMouse ? function (e) {
    if (title) {
      showTooltip(title, e, null);
    }
  } : undefined;
  allProps.children = children ? /*#__PURE__*/react.createElement(react.Fragment, null, children, /*#__PURE__*/react.createElement(Ripple/* default */.Z, null)) : /*#__PURE__*/react.createElement(Ripple/* default */.Z, null);
  return /*#__PURE__*/react.createElement(IconView/* default */.Z, allProps);
};

IconButton.color = ICON_BUTTON_COLOR;
IconButton.propTypes = {
  icon: prop_types_default().oneOfType([(prop_types_default()).func, (prop_types_default()).number]).isRequired,
  active: (prop_types_default()).bool,
  bordered: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  className: (prop_types_default()).string,
  title: (prop_types_default()).string,
  onClick: (prop_types_default()).func,
  showIcon: (prop_types_default()).bool,
  ariaPressed: (prop_types_default()).bool,
  noFocusable: (prop_types_default()).bool,
  ariaLabel: (prop_types_default()).string,
  role: (prop_types_default()).string,
  onDisableClick: (prop_types_default()).func,
  trottle: (prop_types_default()).number,
  isOnLineOnly: (prop_types_default()).bool
};
/* harmony default export */ var IconButton_IconButton = (IconButton);

/***/ }),

/***/ 4128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CN_ICON_VIEW; }
/* harmony export */ });
var CN_ICON_VIEW = "egw-font-icon";

/***/ }),

/***/ 20844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _IconView_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4128);
var _excluded = ["icon", "className", "children"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var IconView = function IconView(props) {
  var icon = props.icon,
      className = props.className,
      children = props.children,
      restProps = _objectWithoutProperties(props, _excluded);

  if (!icon) {
    return null;
  }

  if (typeof icon === "number") {
    if (restProps.fill) {
      restProps.style = {
        color: restProps.fill
      };
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("i", _extends({}, restProps, {
      className: (className || "") + " " + _IconView_constants__WEBPACK_IMPORTED_MODULE_2__/* .CN_ICON_VIEW */ .B
    }), String.fromCodePoint(icon), children);
  }

  var Icon = icon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Icon, _extends({}, restProps, {
    className: "icon-base " + (className || "")
  }));
};

IconView.propTypes = {
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  icon: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().number), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)])
};
/* harmony default export */ __webpack_exports__["Z"] = (IconView);

/***/ }),

/***/ 38081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Input_Input; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../shared/components/Input/Input.constants.js
var InputVariant = {
  default: "default",
  search: "search",
  oneWord: "oneWord"
};
var InputSize = {
  small: "sm"
};
// EXTERNAL MODULE: ../shared/utils/react.js
var utils_react = __webpack_require__(97993);
// EXTERNAL MODULE: ../shared/components/Input/Input.module.scss
var Input_module = __webpack_require__(49616);
var Input_module_default = /*#__PURE__*/__webpack_require__.n(Input_module);
;// CONCATENATED MODULE: ../shared/components/Input/Input.js
var _excluded = ["isPreventKeyDownForNumberTypeStrict", "inputClassName", "className", "active", "hasPlaceholderColorActive", "variant", "rounded", "size", "isRootDirectionColumn", "slotBefore", "slotAfter", "isTextarea", "tagRoot", "rootProps", "tagInput"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








var preventKeyDownForNumberTypeStrict = function preventKeyDownForNumberTypeStrict(e) {
  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
};

var Input = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _classnames;

  var isPreventKeyDownForNumberTypeStrict = _ref.isPreventKeyDownForNumberTypeStrict,
      inputClassName = _ref.inputClassName,
      className = _ref.className,
      active = _ref.active,
      hasPlaceholderColorActive = _ref.hasPlaceholderColorActive,
      variant = _ref.variant,
      rounded = _ref.rounded,
      size = _ref.size,
      isRootDirectionColumn = _ref.isRootDirectionColumn,
      slotBefore = _ref.slotBefore,
      slotAfter = _ref.slotAfter,
      isTextarea = _ref.isTextarea,
      _ref$tagRoot = _ref.tagRoot,
      TagRoot = _ref$tagRoot === void 0 ? "div" : _ref$tagRoot,
      rootProps = _ref.rootProps,
      _ref$tagInput = _ref.tagInput,
      TagInput = _ref$tagInput === void 0 ? "input" : _ref$tagInput,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/react.createElement(TagRoot, _extends({}, rootProps, {
    className: classnames_default()((Input_module_default()).root, className, (Input_module_default())[variant], (Input_module_default())[size], (_classnames = {}, _defineProperty(_classnames, (Input_module_default()).rounded, rounded), _defineProperty(_classnames, (Input_module_default()).active, active), _defineProperty(_classnames, (Input_module_default())["has-placeholder-color-active"], hasPlaceholderColorActive), _defineProperty(_classnames, (Input_module_default())["read-only"], restProps.readOnly), _defineProperty(_classnames, (Input_module_default()).disabled, restProps.disabled), _defineProperty(_classnames, (Input_module_default())["has-slot-before"], !!slotBefore), _defineProperty(_classnames, (Input_module_default())["has-slot-after"], !!slotAfter), _defineProperty(_classnames, (Input_module_default())["is-direction-column"], isRootDirectionColumn), _classnames))
  }), slotBefore ? (0,utils_react/* handleReactSlot */.u)(slotBefore) : null, /*#__PURE__*/react.createElement(TagInput, _extends({
    ref: ref,
    type: "text",
    className: classnames_default()((Input_module_default()).input, inputClassName),
    tabIndex: restProps.disabled ? -1 : 0
  }, restProps, {
    onKeyDown: isPreventKeyDownForNumberTypeStrict ? function (e) {
      if (restProps !== null && restProps !== void 0 && restProps.onKeyDown) {
        restProps.onKeyDown(e);
      }

      preventKeyDownForNumberTypeStrict(e);
    } : restProps === null || restProps === void 0 ? void 0 : restProps.onKeyDown
  })), slotAfter ? (0,utils_react/* handleReactSlot */.u)(slotAfter) : null);
});
Input.defaultProps = {
  variant: InputVariant["default"]
};
Input.variant = InputVariant;
Input.size = InputSize;
Input.propTypes = {
  rounded: (prop_types_default()).bool,
  className: (prop_types_default()).string,
  type: (prop_types_default()).string,
  variant: prop_types_default().oneOf(Object.values(InputVariant)),
  size: prop_types_default().oneOf(Object.values(InputSize)),
  slotAfter: (prop_types_default()).any,
  tagInput: (prop_types_default()).any
};
/* harmony default export */ var Input_Input = (Input);

/***/ }),

/***/ 69517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CY": function() { return /* binding */ minLoadingTimeInMillisecondsDefault; },
/* harmony export */   "Fu": function() { return /* binding */ LOADING_TYPES; },
/* harmony export */   "JF": function() { return /* binding */ DATA_ACQUISITION_STATUS; },
/* harmony export */   "dk": function() { return /* binding */ minLoadingTimeInMilliseconds; }
/* harmony export */ });
var DATA_ACQUISITION_STATUS = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH"
};
var minLoadingTimeInMillisecondsDefault = 10000;
var minLoadingTimeInMilliseconds = {
  CONTACT_EMAIL: 10000,
  INIT: 10000,
  BOOK: 10000,
  BOOK_INFO: 10000,
  BOOK_CONTENT: 10000,
  FOLDER_LIST: 10000,
  BOOKS_LIST: 10000,
  CURRENT_FOLDER: 10000,
  SUBSCRIPTION_CONTENT: 10000,
  THOUGHT_CONTENT: 10000,
  NEWS_CONTENT: 10000,
  SEARCH_FILTER_CONTENT: 10000,
  HISTORY: 10000,
  SC_PREVIEW: 10000
};
var LOADING_TYPES = {
  INIT: "INIT",
  BOOK: "BOOK",
  BOOK_INFO: "BOOK_INFO",
  BOOK_CONTENT: "BOOK_CONTENT",
  BOOK_DATA: "BOOK_DATA",
  FOLDER_LIST: "FOLDER_LIST",
  BOOKS_LIST: "BOOKS_LIST",
  BOOKS_IN_TRANSLATIONS: "BOOKS_IN_TRANSLATIONS",
  CURRENT_FOLDER: "CURRENT_FOLDER",
  SUBSCRIPTION_CONTENT: "SUBSCRIPTION_CONTENT",
  THOUGHT_CONTENT: "THOUGHT_CONTENT",
  NEWS_CONTENT: "NEWS_CONTENT",
  CONTACT_EMAIL: "CONTACT_EMAIL",
  SEARCH_FILTER_CONTENT: "SEARCH_FILTER_CONTENT",
  FEATURED_SEARCH_SECTIONS: "FEATURED_SEARCH_SECTIONS",
  HISTORY: "HISTORY",
  SC_PREVIEW: "SC_PREVIEW"
};

/***/ }),

/***/ 63975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Loader_Loader; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(34412);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(56253);
// EXTERNAL MODULE: ../shared/store/settings/selectors.js
var selectors = __webpack_require__(4787);
// EXTERNAL MODULE: ../shared/utils/settings/constants.js + 1 modules
var constants = __webpack_require__(20467);
// EXTERNAL MODULE: ../shared/utils/url/url.js
var url = __webpack_require__(59916);
// EXTERNAL MODULE: ../shared/hooks/useCookiesWithOptions.js + 9 modules
var useCookiesWithOptions = __webpack_require__(65482);
// EXTERNAL MODULE: ../shared/utils/theme/theme.js + 1 modules
var theme = __webpack_require__(93752);
;// CONCATENATED MODULE: ../shared/components/Loader/PreloadIcon.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }









var PreloadIcon = /*#__PURE__*/react.memo(function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 200 : _ref$size;

  var _useCookiesWithOption = (0,useCookiesWithOptions/* default */.Z)([theme/* COOKIE_KEY_THEME */.kh]),
      _useCookiesWithOption2 = _slicedToArray(_useCookiesWithOption, 1),
      cookie = _useCookiesWithOption2[0];

  var themeMode = (0,es/* useSelector */.v9)((0,selectors/* selectorSetting */.K)(constants/* SETTING.themeMode.id */.Fy.themeMode.id));
  var fileName = (0,theme/* getTheme */.gh)(cookie.theme || themeMode).gifLoader;
  var path = (0,url/* getUrlImages */.d$)() + "/" + fileName;
  var style;

  if (size) {
    style = {
      width: size,
      height: size * 1.1
    };
  }

  return /*#__PURE__*/react.createElement("img", {
    src: path,
    alt: "Loading...",
    style: style
  });
});
PreloadIcon.propTypes = {
  size: (prop_types_default()).number
};
/* harmony default export */ var Loader_PreloadIcon = (PreloadIcon);
// EXTERNAL MODULE: ../shared/store/system/actions.js
var actions = __webpack_require__(93893);
// EXTERNAL MODULE: ../shared/components/Loader/Loader.constants.js
var Loader_constants = __webpack_require__(69517);
// EXTERNAL MODULE: ../shared/components/Loader/Loader.module.scss
var Loader_module = __webpack_require__(74954);
var Loader_module_default = /*#__PURE__*/__webpack_require__.n(Loader_module);
;// CONCATENATED MODULE: ../shared/components/Loader/Loader.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var Loader = function Loader(_ref) {
  var align = _ref.align,
      className = _ref.className,
      sizeSmall = _ref.sizeSmall,
      size = _ref.size,
      type = _ref.type,
      isPositionAbsolute = _ref.isPositionAbsolute;
  var dispatch = (0,es/* useDispatch */.I0)();
  var textMode = (0,es/* useSelector */.v9)((0,selectors/* selectorSetting */.K)(constants/* SETTING.textMode.id */.Fy.textMode.id));
  (0,react.useEffect)(function () {
    var startTime = Date.now();
    return function () {
      // Darryl and some users face the problem, "Poor connection" screen is shown,
      // after previously leaved tab is opened.
      // So no need to show popup if tab is not visible.
      if (document.visibilityState === "visible") {
        var delta = Date.now() - startTime;
        var minTime = type ? Loader_constants/* minLoadingTimeInMilliseconds */.dk[type] : Loader_constants/* minLoadingTimeInMillisecondsDefault */.CY;

        if (minTime && !textMode) {
          if (delta > minTime) {
            dispatch(actions/* _sharedActionsSystem.updateDataAcquisitionStatus */.g.updateDataAcquisitionStatus(Loader_constants/* DATA_ACQUISITION_STATUS.LOW */.JF.LOW));
          }
        }
      }
    };
  }, [type]);
  var sizeFinal;

  if (size !== undefined) {
    sizeFinal = size;
  } else if (sizeSmall) {
    sizeFinal = 50;
  } else {
    if (lib/* isMobile */.tq) {
      sizeFinal = 63;
    } else {
      sizeFinal = 100;
    }
  }

  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((Loader_module_default())["loader-wrap"], className, (Loader_module_default())[align], _defineProperty({}, (Loader_module_default())["position-absolute"], isPositionAbsolute))
  }, /*#__PURE__*/react.createElement(Loader_PreloadIcon, {
    size: sizeFinal
  }));
};

Loader.types = Loader_constants/* LOADING_TYPES */.Fu;
Loader.propTypes = {
  type: (prop_types_default()).string,
  sizeSmall: (prop_types_default()).bool,
  size: (prop_types_default()).number,
  isPositionAbsolute: (prop_types_default()).bool,
  align: prop_types_default().oneOf(["flex-center", "hor-center"]),
  className: (prop_types_default()).string
};
/* harmony default export */ var Loader_Loader = (Loader);

/***/ }),

/***/ 48011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48081);
/* harmony import */ var _IconView_IconView__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20844);
/* harmony import */ var _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59916);
/* harmony import */ var _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59034);
/* harmony import */ var _Logotype_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15445);
/* harmony import */ var _Logotype_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Logotype_module_scss__WEBPACK_IMPORTED_MODULE_7__);









var Logotype = function Logotype(_ref) {
  var className = _ref.className,
      writingsTextClassName = _ref.writingsTextClassName,
      text = _ref.text,
      isShowLogoWritingsLabel = _ref.isShowLogoWritingsLabel,
      isShowRegistered = _ref.isShowRegistered,
      isShowLogoLinks = _ref.isShowLogoLinks,
      scrollToTop = _ref.scrollToTop,
      onClick = _ref.onClick;

  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_3__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  var handleClickHome = function handleClickHome(event) {
    if (onClick) {
      onClick(event);
    }

    if (scrollToTop) {
      __webpack_require__.g.window.document.documentElement.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Logotype_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["logo-container"]), className)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_5__/* .URLS.home */ .ns.home,
    className: (_Logotype_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["logo-top-container"]),
    tabIndex: 0,
    "aria-label": text !== null && text !== void 0 ? text : t("logo"),
    onClick: handleClickHome
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (_Logotype_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["logo-content"])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconView_IconView__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    icon: _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_6__/* ["default"].logo */ .Z.logo,
    className: (_Logotype_module_scss__WEBPACK_IMPORTED_MODULE_7___default().logo),
    alt: "Ellen G. White Writings"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (_Logotype_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["logo-content-text"])
  }, isShowLogoWritingsLabel && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Logotype_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["logo-content-app-name"]), writingsTextClassName)
  }, text !== null && text !== void 0 ? text : "writings"), isShowRegistered && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (_Logotype_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["logo-content-copyright"])
  }, "\xAE")))), isShowLogoLinks && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (_Logotype_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["logo-container-links"])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_5__/* .EXTERNAL_URLS.whiteEstate */ .wk.whiteEstate,
    className: (_Logotype_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["logo-link"]),
    target: "_blank",
    rel: "noopener noreferrer"
  }, "whiteestate.org"), " ", "|", " ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_5__/* .EXTERNAL_URLS.ellenWhite */ .wk.ellenWhite,
    className: (_Logotype_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["logo-link"]),
    target: "_blank",
    rel: "noopener noreferrer"
  }, "ellenwhite.org")));
};

Logotype.defaultProps = {
  isShowRegistered: true
};
Logotype.propTypes = {
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  writingsTextClassName: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  Link: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().any),
  text: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  isShowLogoWritingsLabel: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  isShowLogoLinks: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  isShowRegistered: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  scrollToTop: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  onClick: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (Logotype);

/***/ }),

/***/ 40654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useLongPress; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _excluded = ["children", "onLongPress", "onClick", "onContextMenu", "timeout", "tag"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var useLongPress = function useLongPress(_ref) {
  var onLongPress = _ref.onLongPress,
      onClick = _ref.onClick,
      onContextMenu = _ref.onContextMenu,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 1000 : _ref$timeout;
  var refIsInvokedForLastInteraction = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  var refTimerId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(undefined);
  var refProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    timeout: timeout,
    onLongPress: onLongPress,
    onClick: onClick,
    onContextMenu: onContextMenu
  });
  refProps.current = {
    timeout: timeout,
    onLongPress: onLongPress,
    onClick: onClick,
    onContextMenu: onContextMenu
  };
  var clearTimeoutLongPress = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (refTimerId.current !== undefined) {
      clearTimeout(refTimerId.current);
      refTimerId.current = undefined;
    }
  }, []);
  var handleStart = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    // if (!global.window?.[WINDOW_KEY_IS_LAST_POINTER_MOUSE] && e.type.indexOf("mouse") === 0) {
    //   return;
    // }
    refIsInvokedForLastInteraction.current = false;
    e.persist();
    clearTimeoutLongPress();
    refTimerId.current = setTimeout(function () {
      if (!refIsInvokedForLastInteraction.current) {
        if (typeof refProps.current.onLongPress === "function") {
          refProps.current.onLongPress(e);
          refIsInvokedForLastInteraction.current = true;
        }
      }

      clearTimeoutLongPress();
    }, refProps.current.timeout);
  }, [clearTimeoutLongPress]);
  var handleEnd = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    if (refIsInvokedForLastInteraction.current) {
      e.preventDefault();
    }

    clearTimeoutLongPress();
  }, [clearTimeoutLongPress]);
  var handleCtxMenu = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    // prevent context menu, if long press was called for the current touch.
    if (!refIsInvokedForLastInteraction.current) {
      if (refProps.current.onContextMenu) {
        refProps.current.onContextMenu(e);
        refIsInvokedForLastInteraction.current = true;
        clearTimeoutLongPress();
      }
    }

    e.preventDefault();
  }, [clearTimeoutLongPress]);
  var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    // prevent click, if either ctx menu or long press was called for the current touch.
    if (!refIsInvokedForLastInteraction.current) {
      if (refProps.current.onClick) {
        refProps.current.onClick(e);
      }
    }

    clearTimeoutLongPress();
  }, [clearTimeoutLongPress]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return clearTimeoutLongPress;
  }, [clearTimeoutLongPress]);
  return {
    onTouchStart: handleStart,
    onMouseDown: handleStart,
    onMouseMove: clearTimeoutLongPress,
    onTouchMove: clearTimeoutLongPress,
    onTouchCancel: clearTimeoutLongPress,
    onMouseLeave: clearTimeoutLongPress,
    onTouchEnd: handleEnd,
    onMouseUp: handleEnd,
    onClick: handleClick,
    onContextMenu: handleCtxMenu
  };
};
var LongPressWrapper = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref2, ref) {
  var children = _ref2.children,
      onLongPress = _ref2.onLongPress,
      onClick = _ref2.onClick,
      onContextMenu = _ref2.onContextMenu,
      timeout = _ref2.timeout,
      _ref2$tag = _ref2.tag,
      Tag = _ref2$tag === void 0 ? "div" : _ref2$tag,
      restProps = _objectWithoutProperties(_ref2, _excluded);

  var longPressListeners = useLongPress({
    onLongPress: onLongPress,
    onClick: onClick,
    onContextMenu: onContextMenu,
    timeout: timeout
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, _extends({}, restProps, longPressListeners, {
    ref: ref
  }), children);
});
LongPressWrapper.propTypes = {
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node),
  onLongPress: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onClick: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onContextMenu: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  timeout: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number),
  tag: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (LongPressWrapper);

/***/ }),

/***/ 8217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48081);
/* harmony import */ var _Typography_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21766);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18170);
/* harmony import */ var _Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66636);
/* harmony import */ var _utils_reader_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16484);
/* harmony import */ var _utils_reader_reader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18664);
/* harmony import */ var _PlayerBehaviourDialog_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49946);
/* harmony import */ var _PlayerBehaviourDialog_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_PlayerBehaviourDialog_module_scss__WEBPACK_IMPORTED_MODULE_8__);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }











var PlayerBehaviourDialog = function PlayerBehaviourDialog(_ref) {
  var subtitle = _ref.subtitle,
      canPlayFromCurrentPara = _ref.canPlayFromCurrentPara,
      canPlayFirstAvailable = _ref.canPlayFirstAvailable,
      canPlayFromHistory = _ref.canPlayFromHistory,
      canContinue = _ref.canContinue,
      canDoNotAskAgain = _ref.canDoNotAskAgain,
      isDoNotAskChecked = _ref.isDoNotAskChecked,
      onClickBehaviour = _ref.onClickBehaviour;

  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_2__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isDoNotAskChecked),
      _useState2 = _slicedToArray(_useState, 2),
      doNotAskAgain = _useState2[0],
      setDoNotAskAgain = _useState2[1];

  var handleChooseBehaviour = function handleChooseBehaviour(type) {
    onClickBehaviour(type, doNotAskAgain);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_PlayerBehaviourDialog_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["dialog-player-behaviour"])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    variant: "h3"
  }, t("playerBehaviour")), subtitle && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    variant: "body2"
  }, subtitle), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_PlayerBehaviourDialog_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["dialog-player-behaviour__buttons"])
  }, canPlayFromCurrentPara && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    onClick: function onClick() {
      handleChooseBehaviour(_utils_reader_constants__WEBPACK_IMPORTED_MODULE_6__/* .READER_PLAYER_BEHAVIOURS.CURRENT_PARA */ .bn.CURRENT_PARA);
    },
    className: "dialog-btn"
  }, t((0,_utils_reader_reader__WEBPACK_IMPORTED_MODULE_7__/* .getPlayerBehaviorLabel */ .A5)(_utils_reader_constants__WEBPACK_IMPORTED_MODULE_6__/* .READER_PLAYER_BEHAVIOURS.CURRENT_PARA */ .bn.CURRENT_PARA))), canPlayFirstAvailable && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    onClick: function onClick() {
      handleChooseBehaviour(_utils_reader_constants__WEBPACK_IMPORTED_MODULE_6__/* .READER_PLAYER_BEHAVIOURS.FIRST_AVAILABLE */ .bn.FIRST_AVAILABLE);
    },
    className: (_PlayerBehaviourDialog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btn)
  }, t((0,_utils_reader_reader__WEBPACK_IMPORTED_MODULE_7__/* .getPlayerBehaviorLabel */ .A5)(_utils_reader_constants__WEBPACK_IMPORTED_MODULE_6__/* .READER_PLAYER_BEHAVIOURS.FIRST_AVAILABLE */ .bn.FIRST_AVAILABLE))), canPlayFromHistory && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    onClick: function onClick() {
      handleChooseBehaviour(_utils_reader_constants__WEBPACK_IMPORTED_MODULE_6__/* .READER_PLAYER_BEHAVIOURS.HISTORY */ .bn.HISTORY);
    },
    className: (_PlayerBehaviourDialog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btn)
  }, t((0,_utils_reader_reader__WEBPACK_IMPORTED_MODULE_7__/* .getPlayerBehaviorLabel */ .A5)(_utils_reader_constants__WEBPACK_IMPORTED_MODULE_6__/* .READER_PLAYER_BEHAVIOURS.HISTORY */ .bn.HISTORY))), canContinue && (canPlayFromHistory || canPlayFirstAvailable || canPlayFromCurrentPara) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, t("OR")), canContinue && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    onClick: function onClick() {
      handleChooseBehaviour(_utils_reader_constants__WEBPACK_IMPORTED_MODULE_6__/* .READER_PLAYER_BEHAVIOURS.CONTINUE */ .bn.CONTINUE);
    },
    className: (_PlayerBehaviourDialog_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btn)
  }, t("continuePlaying"))), canDoNotAskAgain && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    className: (_PlayerBehaviourDialog_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["dialog-player-behaviour__checkbox"]),
    title: t("doNotAskAgain"),
    checked: doNotAskAgain,
    onChange: function onChange() {
      setDoNotAskAgain(!doNotAskAgain);
    }
  })));
};

PlayerBehaviourDialog.propTypes = {
  subtitle: prop_types__WEBPACK_IMPORTED_MODULE_1__.string,
  canPlayFromCurrentPara: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  canPlayFirstAvailable: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  canPlayFromHistory: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  canContinue: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  canDoNotAskAgain: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  isDoNotAskChecked: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  onClickBehaviour: prop_types__WEBPACK_IMPORTED_MODULE_1__.func
};
/* harmony default export */ __webpack_exports__["Z"] = (PlayerBehaviourDialog);

/***/ }),

/***/ 4701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95524);
/* harmony import */ var _Scroll_Scroll__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95793);
/* harmony import */ var _Portal_Portal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64976);
/* harmony import */ var _hooks_useFocus__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47630);
/* harmony import */ var _hooks_useLockBodyScroll__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77706);
/* harmony import */ var _utils_assembly__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76732);
/* harmony import */ var _popup_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29467);
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62330);
/* harmony import */ var _Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(265);
/* harmony import */ var _utils_optimization__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18747);
/* harmony import */ var _utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78889);
/* harmony import */ var _shared_utils_number_number__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(50150);
/* harmony import */ var _shared_hooks_useRegulateGlobalClassNameIsAnyPopupLikeWindowOpened__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(59730);
/* harmony import */ var _shared_what_input_source__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(53769);
/* harmony import */ var _shared_what_input_source__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_shared_what_input_source__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _shared_what_input_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(74672);
/* harmony import */ var _popup_module_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(50919);
/* harmony import */ var _popup_module_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_popup_module_scss__WEBPACK_IMPORTED_MODULE_18__);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




















var POINTER_SIZE = 14; // e.g. Book Landing Site, Available Languages Popup on desktop zoom 150%+.

var DELTA_MIN_TO_ALLOW_APPLY_SIDE_FROM_PROPS = 100;
var Popup = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var _classnames2;

  var isShown = _ref.isShown,
      _ref$isUseLockBodyScr = _ref.isUseLockBodyScroll,
      isUseLockBodyScroll = _ref$isUseLockBodyScr === void 0 ? _utils_assembly__WEBPACK_IMPORTED_MODULE_8__/* ._experimental_isNextApp */ .rd : _ref$isUseLockBodyScr,
      _ref$isRegulateMaxSiz = _ref.isRegulateMaxSize,
      isRegulateMaxSize = _ref$isRegulateMaxSiz === void 0 ? true : _ref$isRegulateMaxSiz,
      _ref$isCorrectPositio = _ref.isCorrectPosition,
      isCorrectPosition = _ref$isCorrectPositio === void 0 ? true : _ref$isCorrectPositio,
      isShowPointer = _ref.isShowPointer,
      _ref$preventCoverHead = _ref.preventCoverHeader,
      preventCoverHeader = _ref$preventCoverHead === void 0 ? true : _ref$preventCoverHead,
      hasConstantSizes = _ref.hasConstantSizes,
      isContentDynamic = _ref.isContentDynamic,
      usePositionAbsolute = _ref.usePositionAbsolute,
      refElementScrollIedIntoViewBeforeBecameShown = _ref.refElementScrollIedIntoViewBeforeBecameShown,
      _ref$focusOnBecameVis = _ref.focusOnBecameVisible,
      focusOnBecameVisible = _ref$focusOnBecameVis === void 0 ? true : _ref$focusOnBecameVis,
      _ref$hasBackdrop = _ref.hasBackdrop,
      hasBackdrop = _ref$hasBackdrop === void 0 ? true : _ref$hasBackdrop,
      hasBackdropTransparent = _ref.hasBackdropTransparent,
      hideOnScroll = _ref.hideOnScroll,
      _ref$hideOnResize = _ref.hideOnResize,
      hideOnResize = _ref$hideOnResize === void 0 ? true : _ref$hideOnResize,
      hideOnMouseLeave = _ref.hideOnMouseLeave,
      _ref$allowMoveMouseOn = _ref.allowMoveMouseOnTooltip,
      allowMoveMouseOnTooltip = _ref$allowMoveMouseOn === void 0 ? true : _ref$allowMoveMouseOn,
      hideOnBlur = _ref.hideOnBlur,
      id = _ref.id,
      className = _ref.className,
      renderViewClassName = _ref.renderViewClassName,
      rootProps = _ref.rootProps,
      contentProps = _ref.contentProps,
      backdropProps = _ref.backdropProps,
      anchorEl = _ref.anchorEl,
      anchorRect = _ref.anchorRect,
      boundaryRect = _ref.boundaryRect,
      maxHeight = _ref.maxHeight,
      maxWidth = _ref.maxWidth,
      _ref$beautyGapHorizon = _ref.beautyGapHorizontal,
      beautyGapHorizontal = _ref$beautyGapHorizon === void 0 ? 16 : _ref$beautyGapHorizon,
      _ref$beautyGapVertica = _ref.beautyGapVertical,
      beautyGapVertical = _ref$beautyGapVertica === void 0 ? 16 : _ref$beautyGapVertica,
      xDesired = _ref.xDesired,
      yDesired = _ref.yDesired,
      leftSideFromProps = _ref.leftSide,
      onTopFromProps = _ref.onTop,
      positionPattern = _ref.positionPattern,
      onHide = _ref.onHide,
      children = _ref.children;
  (0,_hooks_useLockBodyScroll__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(!!(isShown && isUseLockBodyScroll));
  (0,_shared_hooks_useRegulateGlobalClassNameIsAnyPopupLikeWindowOpened__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(!!isShown);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      elContent = _useState2[0],
      setElContent = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isShownAtTop = _useState4[0],
      setIsShownAtTop = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isShownAtLeft = _useState6[0],
      setIsShownAtLeft = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      styleRoot = _useState8[0],
      setStyleRoot = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      styleScrollWrap = _useState10[0],
      setStyleScrollWrap = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      _useState12 = _slicedToArray(_useState11, 2),
      styleScrollView = _useState12[0],
      setStyleScrollView = _useState12[1];

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      _useState14 = _slicedToArray(_useState13, 2),
      triggerComputePosition = _useState14[0],
      setTriggerComputePosition = _useState14[1];

  var _useState15 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      _useState16 = _slicedToArray(_useState15, 2),
      triggerCorrectPosition = _useState16[0],
      setTriggerCorrectPosition = _useState16[1];

  var _useState17 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      _useState18 = _slicedToArray(_useState17, 2),
      triggerReDefineConstantSizes = _useState18[0],
      setTriggerReDefineConstantSizes = _useState18[1];

  var _useState19 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      _useState20 = _slicedToArray(_useState19, 2),
      sizeAfterInitiatedAndCorrected = _useState20[0],
      setSizeAfterInitiatedAndCorrected = _useState20[1];

  var _useState21 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState22 = _slicedToArray(_useState21, 2),
      isInitPositionAndSizesCorrected = _useState22[0],
      setIsInitPositionAndSizesCorrected = _useState22[1];

  var refIsScrolledToPropsElementAfterBecameShown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  var refIsInitPositionAndSizesCorrected = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(isInitPositionAndSizesCorrected);
  refIsInitPositionAndSizesCorrected.current = isInitPositionAndSizesCorrected;
  var classNameRootProps;
  var styleRootProps;
  var propsRestRoot;

  if (rootProps) {
    for (var key in rootProps) {
      if (key === "className") {
        classNameRootProps = rootProps[key];
      } else if (key === "style") {
        styleRootProps = rootProps[key];
      } else {
        if (!propsRestRoot) {
          propsRestRoot = {};
        }

        propsRestRoot[key] = rootProps[key];
      }
    }
  }

  var classNameContentProps;
  var styleContentProps;
  var scrollContentProps = {};
  var propsRestContent;

  if (contentProps) {
    for (var _key2 in contentProps) {
      if (_key2 === "className") {
        classNameContentProps = contentProps[_key2];
      } else if (_key2 === "style") {
        styleContentProps = contentProps[_key2];
      } else if (_key2 === "renderView" || _key2 === "ref") {
        scrollContentProps[_key2] = contentProps[_key2];
      } else {
        if (!propsRestContent) {
          propsRestContent = {};
        }

        propsRestContent[_key2] = contentProps[_key2];
      }
    }
  }

  var classNameBackdrop;
  var styleBackdrop;
  var restPropsBackdrop;

  if (backdropProps) {
    for (var _key4 in backdropProps) {
      if (_key4 === "className") {
        classNameBackdrop = backdropProps[_key4];
      } else if (_key4 === "style") {
        styleBackdrop = backdropProps[_key4];
      } else {
        if (!restPropsBackdrop) {
          restPropsBackdrop = {};
        }

        restPropsBackdrop[_key4] = backdropProps[_key4];
      }
    }
  }

  var getBoundaryRect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var rect;

    if (boundaryRect) {
      rect = boundaryRect;
    } else if (false) {} else {
      var top;

      if (preventCoverHeader) {
        var elHeader = document.querySelector("header");

        if (elHeader) {
          top = elHeader.offsetHeight;
        }
      }

      if (top === undefined) {
        top = beautyGapVertical;
      }

      var left = beautyGapHorizontal;
      var right = window.innerWidth - beautyGapHorizontal;
      var bottom = window.innerHeight - beautyGapVertical;
      rect = {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: right - left,
        height: bottom - top
      };
    }

    return rect;
  }, [preventCoverHeader, boundaryRect, beautyGapVertical, beautyGapHorizontal]);
  var getAnchorRect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var rect;

    if (anchorRect) {
      var _ref2, _anchorRect$x, _ref3, _anchorRect$y, _ref4, _anchorRect$left, _ref5, _anchorRect$right, _ref6, _anchorRect$top, _ref7, _anchorRect$bottom, _anchorRect$width, _anchorRect$height;

      rect = {
        x: (_ref2 = (_anchorRect$x = anchorRect.x) !== null && _anchorRect$x !== void 0 ? _anchorRect$x : anchorRect.left) !== null && _ref2 !== void 0 ? _ref2 : anchorRect.right,
        y: (_ref3 = (_anchorRect$y = anchorRect.y) !== null && _anchorRect$y !== void 0 ? _anchorRect$y : anchorRect.top) !== null && _ref3 !== void 0 ? _ref3 : anchorRect.bottom,
        left: (_ref4 = (_anchorRect$left = anchorRect.left) !== null && _anchorRect$left !== void 0 ? _anchorRect$left : anchorRect.x) !== null && _ref4 !== void 0 ? _ref4 : anchorRect.right,
        right: (_ref5 = (_anchorRect$right = anchorRect.right) !== null && _anchorRect$right !== void 0 ? _anchorRect$right : anchorRect.x) !== null && _ref5 !== void 0 ? _ref5 : anchorRect.left,
        top: (_ref6 = (_anchorRect$top = anchorRect.top) !== null && _anchorRect$top !== void 0 ? _anchorRect$top : anchorRect.y) !== null && _ref6 !== void 0 ? _ref6 : anchorRect.bottom,
        bottom: (_ref7 = (_anchorRect$bottom = anchorRect.bottom) !== null && _anchorRect$bottom !== void 0 ? _anchorRect$bottom : anchorRect.y) !== null && _ref7 !== void 0 ? _ref7 : anchorRect.top,
        width: (_anchorRect$width = anchorRect.width) !== null && _anchorRect$width !== void 0 ? _anchorRect$width : 0,
        height: (_anchorRect$height = anchorRect.height) !== null && _anchorRect$height !== void 0 ? _anchorRect$height : 0
      };
    } else {
      rect = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_10__/* .getBoundaryRectConsideringStackingContext */ .ut)(anchorEl);
    }

    if (isShowPointer && rect) {
      rect = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_10__/* .parseDOMRectToObject */ .qn)(rect);
      rect.x -= POINTER_SIZE / 2;
      rect.y -= POINTER_SIZE / 2;
      rect.width += POINTER_SIZE;
      rect.height += POINTER_SIZE;
      rect.top -= POINTER_SIZE / 2;
      rect.left -= POINTER_SIZE / 2;
      rect.bottom += POINTER_SIZE / 2;
      rect.right += POINTER_SIZE / 2;
    }

    return rect;
  }, [anchorRect, anchorEl, isShowPointer]);
  var hide = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    onHide(e);

    if (e) {
      e.stopPropagation();
    }
  }, [onHide]);

  var handleKeyDownContent = function handleKeyDownContent(e) {
    if (isShown) {
      (0,_utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_12__/* .handleKeyDownExitFloatWindow */ .IB)(e, hide);
    }
  };

  var handleClickRoot = function handleClickRoot(e) {
    if (e.target.classList.contains(_popup_constants__WEBPACK_IMPORTED_MODULE_9__/* .DATA_ATTR_HIDE_POPUP_ON_CLICK */ .S) || e.target.closest("[" + _popup_constants__WEBPACK_IMPORTED_MODULE_9__/* .DATA_ATTR_HIDE_POPUP_ON_CLICK */ .S + "]")) {
      hide(e);
    }
  };

  var handleBlurRoot = function handleBlurRoot(e) {
    if (hideOnBlur && isShown) {
      var root = e.currentTarget;

      if (!root) {
        return;
      } // Not investigated:
      // – without a {setTimeout}, document.activeElement equals to "body" element always.


      setTimeout(function () {
        var _document$getElementB;

        if (root !== document.activeElement && !root.contains(document.activeElement) && _shared_what_input_source__WEBPACK_IMPORTED_MODULE_14___default().ask() === _shared_what_input_constants__WEBPACK_IMPORTED_MODULE_15__.INPUT.keyboard // Prevent closing, if some float-window (e.g. modal or another popup)
        // was opened from this popup.
        && !((_document$getElementB = document.getElementById(_Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_16__/* .EL_ID_PORTAL_MAIN_AFTER */ .t)) !== null && _document$getElementB !== void 0 && _document$getElementB.contains(document.activeElement))) {
          hide(e);
        }
      });
    }
  };

  var initiatePositionAndMaxSizes = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var anchorRect = getAnchorRect();

    if (anchorRect) {
      var _styleContentProps, _styleContentProps2, _styleContentProps3, _styleContentProps5;

      var _boundaryRect = getBoundaryRect();

      var deltaTop = Math.min(anchorRect.top - _boundaryRect.top, anchorRect.top);
      var deltaLeft = Math.min(anchorRect.right - _boundaryRect.left, anchorRect.right);
      var deltaRight = Math.min(_boundaryRect.right - anchorRect.left, window.innerWidth - anchorRect.left);
      var deltaBottom = Math.min(_boundaryRect.bottom - anchorRect.bottom, window.innerHeight - anchorRect.bottom); // ===== Position regarding Anchor and Boundary Element/Rect ============

      var atTop = onTopFromProps !== null && onTopFromProps !== void 0 ? onTopFromProps : deltaTop > deltaBottom;
      var atLeft = leftSideFromProps !== null && leftSideFromProps !== void 0 ? leftSideFromProps : deltaLeft > deltaRight;

      if (positionPattern === _popup_constants__WEBPACK_IMPORTED_MODULE_9__/* .PopupPositionPattern.AT_RIGHT_ANCHOR_SIDE */ .a.AT_RIGHT_ANCHOR_SIDE) {
        atLeft = false;
      }

      if (onTopFromProps && deltaTop < DELTA_MIN_TO_ALLOW_APPLY_SIDE_FROM_PROPS && deltaBottom > deltaTop) {
        atTop = false;
      }

      if (leftSideFromProps && deltaLeft < DELTA_MIN_TO_ALLOW_APPLY_SIDE_FROM_PROPS && deltaRight > deltaLeft) {
        atLeft = false;
      } // ========================================================
      // ===================== Sizes ============================


      var maxWidthForCurrentPosition = atLeft ? deltaLeft : deltaRight;
      var maxHeightForCurrentPosition = atTop ? deltaTop : deltaBottom;
      var maxWidthFinal = Math.min.apply(Math, _toConsumableArray([isContentDynamic ? maxWidthForCurrentPosition : undefined, _boundaryRect.width, maxWidth, (_styleContentProps = styleContentProps) === null || _styleContentProps === void 0 ? void 0 : _styleContentProps.maxWidth, styleRoot === null || styleRoot === void 0 ? void 0 : styleRoot.maxWidth].filter(function (n) {
        return typeof n === "number" && n !== 0 && !isNaN(n) && n !== Infinity;
      })));
      var maxHeightFinal = Math.min.apply(Math, _toConsumableArray([maxHeightForCurrentPosition, _boundaryRect.height, typeof maxHeight === "function" ? maxHeight() : maxHeight, (_styleContentProps2 = styleContentProps) === null || _styleContentProps2 === void 0 ? void 0 : _styleContentProps2.maxHeight, styleRoot === null || styleRoot === void 0 ? void 0 : styleRoot.maxHeight].filter(function (n) {
        return typeof n === "number" && n !== 0 && !isNaN(n) && n !== Infinity;
      })));
      var styleSizes = isRegulateMaxSize ? {
        maxWidth: maxWidthFinal,
        maxHeight: maxHeightFinal
      } : undefined; // Prevent min size from props exceed max size X.

      if ((_styleContentProps3 = styleContentProps) !== null && _styleContentProps3 !== void 0 && _styleContentProps3.minWidth) {
        var _styleContentProps4;

        styleSizes.minWidth = Math.min((_styleContentProps4 = styleContentProps) === null || _styleContentProps4 === void 0 ? void 0 : _styleContentProps4.minWidth, maxWidthFinal);
      } // Prevent min size from props exceed max size Y.


      if ((_styleContentProps5 = styleContentProps) !== null && _styleContentProps5 !== void 0 && _styleContentProps5.minHeight) {
        var _styleContentProps6;

        styleSizes.minHeight = Math.min((_styleContentProps6 = styleContentProps) === null || _styleContentProps6 === void 0 ? void 0 : _styleContentProps6.minHeight, maxHeightFinal);
      }

      setStyleScrollView(styleSizes); // ========================================================
      // ===================== Position ============================

      if (usePositionAbsolute) {
        var _styleRoot = {
          position: "absolute",
          zIndex: 100
        };
        var strStyleTransform = "";

        if (atTop) {
          _styleRoot.top = 0 + "px";
          strStyleTransform += "translateY(-100%)";
        } else {
          _styleRoot.bottom = 0 + "px";
          strStyleTransform += "translateY(100%)";
        }

        if (atLeft) {
          _styleRoot.right = 0 + "px";
        } else {
          _styleRoot.left = 0 + "px";
        }

        _styleRoot.transform = strStyleTransform;
        setStyleScrollWrap(_objectSpread(_objectSpread({}, styleContentProps), styleSizes));
        setStyleRoot(_objectSpread(_objectSpread({}, _styleRoot), styleRootProps));
      } else {
        var styleScrollWrapPosition = {
          position: "fixed",
          width: "unset",
          height: "unset"
        };

        if (positionPattern === _popup_constants__WEBPACK_IMPORTED_MODULE_9__/* .PopupPositionPattern.AT_RIGHT_ANCHOR_SIDE */ .a.AT_RIGHT_ANCHOR_SIDE) {
          if (atLeft) {
            styleScrollWrapPosition.right = anchorRect.right + "px";
          } else {
            styleScrollWrapPosition.left = anchorRect.right + "px";
          }

          if (atTop) {
            styleScrollWrapPosition.bottom = Math.max(0, window.innerHeight - anchorRect.bottom) + "px";
          } else {
            styleScrollWrapPosition.top = Math.max(_boundaryRect.top, anchorRect.top) + "px";
          }
        } else {
          if (yDesired) {
            styleScrollWrapPosition.top = yDesired + "px";
          } else {
            if (atTop) {
              styleScrollWrapPosition.bottom = Math.max(0, window.innerHeight - anchorRect.top) + "px";
            } else {
              styleScrollWrapPosition.top = Math.max(_boundaryRect.top, anchorRect.bottom) + "px";
            }
          }

          if (xDesired) {
            styleScrollWrapPosition.left = xDesired + "px";
          } else {
            if (atLeft) {
              styleScrollWrapPosition.right = Math.max(0, window.innerWidth - anchorRect.right) + "px";
            } else {
              styleScrollWrapPosition.left = anchorRect.left + "px";
            }
          }
        }

        setStyleScrollWrap(_objectSpread(_objectSpread(_objectSpread({}, styleScrollWrapPosition), styleContentProps), styleSizes));
        setStyleRoot(styleRootProps);
      } // ========================================================


      setIsShownAtTop(atTop);
      setIsShownAtLeft(atLeft);
      setTriggerCorrectPosition(Math.random());
    }
  }, [xDesired, leftSideFromProps, onTopFromProps, usePositionAbsolute, isRegulateMaxSize, styleContentProps, maxWidth, maxHeight, isContentDynamic, getAnchorRect, getBoundaryRect, positionPattern, styleRootProps, styleRoot === null || styleRoot === void 0 ? void 0 : styleRoot.maxWidth, styleRoot === null || styleRoot === void 0 ? void 0 : styleRoot.maxHeight]);

  var cleanUpPositionAndSizes = function cleanUpPositionAndSizes() {
    setStyleRoot(null);
    setStyleScrollWrap(null);
    setStyleScrollView(null);
    setSizeAfterInitiatedAndCorrected(null);
    setIsInitPositionAndSizesCorrected(false);
    refIsScrolledToPropsElementAfterBecameShown.current = false;
  }; // STEP 1:
  // - scroll to {refElementScrollIedIntoViewBeforeBecameShown}
  // - initiates position and max sizes.


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isShown) {
      var onScrollToPropsElementDone = function onScrollToPropsElementDone() {
        if (usePositionAbsolute) {
          // Necessarily make anchor element visible in the view,
          // because popup's position is "absolute" – means popup is always near the button.
          var _boundaryRect2 = getBoundaryRect();

          var _anchorRect = getAnchorRect();

          var isScrollPerformed = false;

          if (_anchorRect.top > _boundaryRect2.bottom) {
            isScrollPerformed = true;
            anchorEl.scrollIntoView(false);
          } else if (_anchorRect.bottom < _boundaryRect2.top) {
            isScrollPerformed = true;
            anchorEl.scrollIntoView();
          } // ================================================================================


          if (isScrollPerformed) {
            setTimeout(initiatePositionAndMaxSizes, _utils_dom__WEBPACK_IMPORTED_MODULE_10__/* .isBrowserSupportsSmoothScroll */ .d1 ? 500 : 0);
          } else {
            initiatePositionAndMaxSizes();
          }
        } else {
          initiatePositionAndMaxSizes();
        }
      };

      if (refElementScrollIedIntoViewBeforeBecameShown !== null && refElementScrollIedIntoViewBeforeBecameShown !== void 0 && refElementScrollIedIntoViewBeforeBecameShown.current && !refIsScrolledToPropsElementAfterBecameShown.current) {
        refElementScrollIedIntoViewBeforeBecameShown.current.scrollIntoView(false);
        refIsScrolledToPropsElementAfterBecameShown.current = true;
        setTimeout(onScrollToPropsElementDone, _utils_dom__WEBPACK_IMPORTED_MODULE_10__/* .isBrowserSupportsSmoothScroll */ .d1 ? 500 : 0);
      } else {
        onScrollToPropsElementDone();
      }
    }
  }, [getAnchorRect, isShown, triggerComputePosition]); // STEP 2 - Corrects position and max sizes after first rendered in DOM.

  var isStyleScrollWrapSet = !!styleScrollWrap;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isShown && isStyleScrollWrapSet) {
      if (isCorrectPosition) {
        if (elContent) {
          var rect = elContent.getBoundingClientRect();

          var _boundaryRect3 = getBoundaryRect();

          var _anchorRect2 = getAnchorRect();

          if (!_anchorRect2) {
            return;
          } // Ignore delta less than 2px.
          // Delta is near 2px on Samsung Galaxy M52 v11.0 for 3-dots in Reader,
          // and the correction in such case breaks the popup size if it uses "Css grid".


          var isLeftOverBoundary = _boundaryRect3.left - rect.left > 2;
          var isRightOverBoundary = rect.right - _boundaryRect3.right > 2;

          if (isLeftOverBoundary || isRightOverBoundary) {
            if (usePositionAbsolute) {
              var _maxWidth = isLeftOverBoundary ? _boundaryRect3.right - _anchorRect2.left : _anchorRect2.right - _boundaryRect3.left;

              setStyleScrollWrap(function (v) {
                return _objectSpread(_objectSpread({}, v), {}, {
                  maxWidth: _maxWidth
                });
              });
              setStyleRoot(function (v) {
                return _objectSpread(_objectSpread({}, v), {}, {
                  left: isLeftOverBoundary ? 0 : "unset",
                  right: isLeftOverBoundary ? "unset" : 0,
                  maxWidth: _maxWidth
                });
              });
              setIsShownAtLeft(true);
            } else {
              var _maxWidth2 = _boundaryRect3.width;
              setStyleScrollWrap(function (v) {
                return _objectSpread(_objectSpread({}, v), {}, {
                  left: isLeftOverBoundary ? _boundaryRect3.left : "unset",
                  right: isLeftOverBoundary ? "unset" : window.innerWidth - _boundaryRect3.right,
                  maxWidth: _maxWidth2
                });
              });
              setStyleRoot(function (v) {
                return _objectSpread(_objectSpread({}, v), {}, {
                  maxWidth: _maxWidth2
                });
              });
              setIsShownAtLeft(true);
            }
          }

          setSizeAfterInitiatedAndCorrected(null);
          setTriggerReDefineConstantSizes(Math.random());
          setIsInitPositionAndSizesCorrected(true);
        }
      } else {
        setIsInitPositionAndSizesCorrected(true);
      }
    }
  }, [beautyGapHorizontal, usePositionAbsolute, isCorrectPosition, isShown, isStyleScrollWrapSet, elContent, triggerCorrectPosition, getBoundaryRect, getAnchorRect]); // STEP 3 - Stores sizes, if {hasConstantSizes}.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (hasConstantSizes && isInitPositionAndSizesCorrected && elContent) {
      setSizeAfterInitiatedAndCorrected({
        width: elContent.offsetWidth,
        height: elContent.offsetHeight
      });
    }
  }, [hasConstantSizes, isInitPositionAndSizesCorrected, triggerReDefineConstantSizes]); // Cleans up state after became hidden.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return function () {
      if (isShown) {
        cleanUpPositionAndSizes();
      }
    };
  }, [isShown]); // Smart listening for a popup content and anchor element mouse leave.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var listener, timerId;
    var appropriate = hideOnMouseLeave && isShown && elContent && isInitPositionAndSizesCorrected;

    if (appropriate) {
      var _anchorRect3 = getAnchorRect();

      listener = function listener(e) {
        var _getEventCoordinates = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_10__/* .getEventCoordinates */ .DC)(e),
            x = _getEventCoordinates.x,
            y = _getEventCoordinates.y;

        var contentRect = elContent.getBoundingClientRect();
        var contentRectExtended = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_10__/* .parseDOMRectToObject */ .qn)(contentRect);

        if (isShownAtTop) {
          contentRectExtended.bottom += _anchorRect3.height;
        } else {
          contentRectExtended.top -= _anchorRect3.height;
          contentRectExtended.y -= _anchorRect3.height;
        }

        contentRectExtended.height += _anchorRect3.height;
        var outOfPopupRectExtended = !(0,_shared_utils_number_number__WEBPACK_IMPORTED_MODULE_17__/* .isNumberBetweenEquals */ .S5)(x, contentRectExtended.left, contentRectExtended.right) || !(0,_shared_utils_number_number__WEBPACK_IMPORTED_MODULE_17__/* .isNumberBetweenEquals */ .S5)(y, contentRectExtended.top, contentRectExtended.bottom);
        var outOfAnchorRect = !(0,_shared_utils_number_number__WEBPACK_IMPORTED_MODULE_17__/* .isNumberBetweenEquals */ .S5)(x, _anchorRect3.left, _anchorRect3.right) || !(0,_shared_utils_number_number__WEBPACK_IMPORTED_MODULE_17__/* .isNumberBetweenEquals */ .S5)(y, _anchorRect3.top, _anchorRect3.bottom);

        if (outOfPopupRectExtended) {
          hide(e);
        } else {
          clearTimeout(timerId);

          if (outOfAnchorRect) {
            if (allowMoveMouseOnTooltip) {
              var outOfPopupRect = !(0,_shared_utils_number_number__WEBPACK_IMPORTED_MODULE_17__/* .isNumberBetweenEquals */ .S5)(x, contentRect.left, contentRect.right) || !(0,_shared_utils_number_number__WEBPACK_IMPORTED_MODULE_17__/* .isNumberBetweenEquals */ .S5)(y, contentRect.top, contentRect.bottom);

              if (outOfPopupRect) {
                timerId = setTimeout(hide, 400);
              }
            } else {
              hide(e);
            }
          }
        }
      };

      document.addEventListener("mousemove", listener);
    }

    return function () {
      if (appropriate) {
        document.removeEventListener("mousemove", listener);
        clearTimeout(timerId);
      }
    };
  }, [isShown, isInitPositionAndSizesCorrected, allowMoveMouseOnTooltip, hideOnMouseLeave, elContent, isShownAtTop, getAnchorRect]); // Updates position on window resize.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var listener;

    if (isShown) {
      var widthPrevRecalc = window.innerWidth;
      var heightPrevRecalc = window.innerHeight;
      var triggerRecalcPosition = (0,_utils_optimization__WEBPACK_IMPORTED_MODULE_11__/* .debounce */ .Ds)(function () {
        if (widthPrevRecalc !== window.innerWidth || heightPrevRecalc !== window.innerHeight) {
          setTriggerComputePosition(Math.random());
          widthPrevRecalc = window.innerWidth;
          heightPrevRecalc = window.innerHeight;
        }
      }, 125);

      listener = function listener() {
        triggerRecalcPosition();
      };

      window.addEventListener("resize", listener);
    }

    return function () {
      if (isShown) {
        window.removeEventListener("resize", listener);
      }
    };
  }, [isShown]);
  var isRenderContent = !!(isShown && isStyleScrollWrapSet);
  (0,_hooks_useFocus__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(focusOnBecameVisible && isRenderContent && elContent, {
    current: elContent
  }, {
    isScrollFocusedElementIntoView: !(refElementScrollIedIntoViewBeforeBecameShown !== null && refElementScrollIedIntoViewBeforeBecameShown !== void 0 && refElementScrollIedIntoViewBeforeBecameShown.current)
  }); // Fast-fix. Close fixed positioned popups of Main React Application,
  // if scrolled the layer of content + footer.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var mainScroller;

    if (!_utils_assembly__WEBPACK_IMPORTED_MODULE_8__/* ._experimental_isNextApp */ .rd) {
      var _mainScroller, _mainScroller$childre, _mainScroller$childre2;

      mainScroller = document.querySelector(".main-application");
      (_mainScroller = mainScroller) === null || _mainScroller === void 0 ? void 0 : (_mainScroller$childre = _mainScroller.children) === null || _mainScroller$childre === void 0 ? void 0 : (_mainScroller$childre2 = _mainScroller$childre[0]) === null || _mainScroller$childre2 === void 0 ? void 0 : _mainScroller$childre2.addEventListener("scroll", hide);
    }

    return function () {
      var _mainScroller2, _mainScroller2$childr, _mainScroller2$childr2;

      (_mainScroller2 = mainScroller) === null || _mainScroller2 === void 0 ? void 0 : (_mainScroller2$childr = _mainScroller2.children) === null || _mainScroller2$childr === void 0 ? void 0 : (_mainScroller2$childr2 = _mainScroller2$childr[0]) === null || _mainScroller2$childr2 === void 0 ? void 0 : _mainScroller2$childr2.removeEventListener("scroll", hide);
    };
  }, [hide]);

  if (!isRenderContent) {
    return null;
  }

  var styleConstantSizes = sizeAfterInitiatedAndCorrected ? sizeAfterInitiatedAndCorrected : undefined;
  var pointerClass;

  if (isShowPointer) {
    pointerClass = isShownAtTop ? isShownAtLeft ? (_popup_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["right-bottom"]) : (_popup_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["left-bottom"]) : isShownAtLeft ? (_popup_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["right-top"]) : (_popup_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["left-top"]);
  }

  var jsxContent = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({
    ref: ref,
    id: id,
    onBlur: handleBlurRoot,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_popup_module_scss__WEBPACK_IMPORTED_MODULE_18___default().root), className, classNameRootProps, _defineProperty({}, (_popup_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["ready-to-show"]), isInitPositionAndSizesCorrected))
  }, propsRestRoot, {
    style: styleRoot
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({
    tabIndex: 1,
    ref: setElContent,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_popup_module_scss__WEBPACK_IMPORTED_MODULE_18___default().content), classNameContentProps, (_classnames2 = {}, _defineProperty(_classnames2, (_popup_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["is-shown-at-top"]), isShownAtTop), _defineProperty(_classnames2, (_popup_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["is-shown-at-left"]), isShownAtLeft), _classnames2)),
    style: _objectSpread(_objectSpread({}, styleScrollWrap), styleConstantSizes),
    onKeyDown: handleKeyDownContent,
    onClick: handleClickRoot
  }, propsRestContent), pointerClass && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_popup_module_scss__WEBPACK_IMPORTED_MODULE_18___default().pointer), pointerClass)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Scroll_Scroll__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _extends({
    renderViewClassName: renderViewClassName,
    renderViewStyle: styleScrollView,
    autoHide: false // always show scrollbar, to understand if there is more content in popup
    ,
    universal: true,
    hasStaticPosition: true,
    noHidePopups: true,
    className: (_popup_module_scss__WEBPACK_IMPORTED_MODULE_18___default().scroll)
  }, scrollContentProps), typeof children === "function" ? children({
    hide: hide
  }) : children)), hasBackdrop && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _extends({
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_popup_module_scss__WEBPACK_IMPORTED_MODULE_18___default().backdrop), classNameBackdrop),
    onClick: hide,
    style: hasBackdropTransparent ? _objectSpread({
      backgroundColor: "transparent"
    }, styleBackdrop) : styleBackdrop
  }, restPropsBackdrop)));

  if (usePositionAbsolute) {
    if (!styleRoot) {
      return null;
    }

    return jsxContent;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Portal_Portal__WEBPACK_IMPORTED_MODULE_5__["default"], {
    id: _Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_16__/* .EL_ID_PORTAL_MAIN_AFTER */ .t
  }, jsxContent);
});
Popup.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_1__.string,
  isShown: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  hideOnMouseLeave: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  hideOnScroll: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  contentProps: prop_types__WEBPACK_IMPORTED_MODULE_1__.object,
  backdropProps: prop_types__WEBPACK_IMPORTED_MODULE_1__.object,
  anchorEl: prop_types__WEBPACK_IMPORTED_MODULE_1__.object,
  boundaryRect: prop_types__WEBPACK_IMPORTED_MODULE_1__.object,
  onHide: prop_types__WEBPACK_IMPORTED_MODULE_1__.func.isRequired,
  hasBackdrop: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  hasBackdropTransparent: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1__.any,
  positionPattern: prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf(Object.values(_popup_constants__WEBPACK_IMPORTED_MODULE_9__/* .PopupPositionPattern */ .a))
};
/* harmony default export */ __webpack_exports__["default"] = (Popup);

/***/ }),

/***/ 29467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ DATA_ATTR_HIDE_POPUP_ON_CLICK; },
/* harmony export */   "a": function() { return /* binding */ PopupPositionPattern; }
/* harmony export */ });
var PopupPositionPattern = {
  AT_RIGHT_ANCHOR_SIDE: "right"
};
var DATA_ATTR_HIDE_POPUP_ON_CLICK = "data-hide-popup";

/***/ }),

/***/ 64976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31542);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);



var Portal = function Portal(_ref) {
  var id = _ref.id,
      children = _ref.children,
      _ref$rootClass = _ref.rootClass,
      rootClass = _ref$rootClass === void 0 ? "" : _ref$rootClass;
  var elRoot = "window" in __webpack_require__.g ? document.querySelector("#" + id) : null;

  if (rootClass && elRoot && !elRoot.classList.contains(rootClass)) {
    elRoot.classList.add(rootClass);
  }

  return elRoot ? /*#__PURE__*/(0,react_dom__WEBPACK_IMPORTED_MODULE_0__.createPortal)(children, elRoot) : null;
};

Portal.propTypes = {
  id: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string.isRequired),
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node),
  rootClass: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Portal);

/***/ }),

/***/ 265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ EL_ID_PORTAL_MAIN_AFTER; }
/* harmony export */ });
var EL_ID_PORTAL_MAIN_AFTER = "portal-main-after";

/***/ }),

/***/ 45902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ TRACK_SIZES; }
/* harmony export */ });
var TRACK_SIZES = {
  sm: "sm",
  md: "md"
};

/***/ }),

/***/ 17490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_number_number__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50150);
/* harmony import */ var _Progress_constans__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45902);
/* harmony import */ var _Progress_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37936);
/* harmony import */ var _Progress_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Progress_module_scss__WEBPACK_IMPORTED_MODULE_5__);
var _excluded = ["value", "min", "max", "className", "thumbClassName", "progressClassName", "trackClassName", "disabled", "thumbProps", "showThumb", "size"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var Progress = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var _classnames;

  var value = _ref.value,
      min = _ref.min,
      max = _ref.max,
      className = _ref.className,
      thumbClassName = _ref.thumbClassName,
      progressClassName = _ref.progressClassName,
      trackClassName = _ref.trackClassName,
      disabled = _ref.disabled,
      thumbProps = _ref.thumbProps,
      showThumb = _ref.showThumb,
      size = _ref.size,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var thumbRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var currentProgressInPercents;
  var valueClutched = (0,_utils_number_number__WEBPACK_IMPORTED_MODULE_4__/* .clutch */ .Cz)(value, min, max);

  if (valueClutched === min) {
    currentProgressInPercents = 0;
  } else if (valueClutched === max) {
    currentProgressInPercents = 100;
  } else {
    currentProgressInPercents = (valueClutched - min) * 100 / (max - min);
  }

  var currentProgressWithPercentSymbol = "".concat(currentProgressInPercents, "%");
  var rootClassName = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Progress_module_scss__WEBPACK_IMPORTED_MODULE_5___default().root), className, (_classnames = {}, _defineProperty(_classnames, (_Progress_module_scss__WEBPACK_IMPORTED_MODULE_5___default().disabled), disabled), _defineProperty(_classnames, "disabled", disabled), _classnames));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({}, restProps, {
    className: rootClassName,
    ref: ref || sliderRef
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Progress_module_scss__WEBPACK_IMPORTED_MODULE_5___default().track), trackClassName, (_Progress_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[size])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Progress_module_scss__WEBPACK_IMPORTED_MODULE_5___default().progress), progressClassName),
    style: {
      width: currentProgressWithPercentSymbol
    }
  }), showThumb && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({
    ref: thumbRef,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Progress_module_scss__WEBPACK_IMPORTED_MODULE_5___default().thumb), thumbClassName),
    style: {
      left: currentProgressWithPercentSymbol
    },
    tabIndex: "0",
    role: "slider",
    "aria-orientation": "horizontal",
    "aria-valuemax": max,
    "aria-valuemin": min,
    "aria-valuenow": value
  }, thumbProps))));
});
Progress.defaultProps = {
  min: 0,
  max: 100,
  size: _Progress_constans__WEBPACK_IMPORTED_MODULE_3__/* .TRACK_SIZES.sm */ .e.sm
};
Progress.propTypes = {
  showThumb: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  disabled: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  value: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number),
  min: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number),
  max: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  thumbClassName: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  progressClassName: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  thumbProps: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOf(Object.values(_Progress_constans__WEBPACK_IMPORTED_MODULE_3__/* .TRACK_SIZES */ .e))
};
/* harmony default export */ __webpack_exports__["Z"] = (Progress);

/***/ }),

/***/ 68898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RadioButton_RadioButton; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../shared/contexts/TranslateContext.js
var TranslateContext = __webpack_require__(48081);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../shared/components/Typography/Typography.js
var Typography = __webpack_require__(21766);
// EXTERNAL MODULE: ../shared/components/IconView/IconView.js
var IconView = __webpack_require__(20844);
// EXTERNAL MODULE: ../shared/utils/string/string.js
var string = __webpack_require__(56332);
// EXTERNAL MODULE: ../shared/utils/keyboard-navigation/keyboard-navigation.js
var keyboard_navigation = __webpack_require__(78889);
// EXTERNAL MODULE: ../shared/components/Button/Ripple.js
var Ripple = __webpack_require__(22168);
;// CONCATENATED MODULE: ../shared/components/RadioButton/RadioButton.constants.js
var radioButtonLabelClassName = "js-e2e-radioButton-label";
// EXTERNAL MODULE: ../shared/components/RadioButton/RadioButton.module.scss
var RadioButton_module = __webpack_require__(9821);
var RadioButton_module_default = /*#__PURE__*/__webpack_require__.n(RadioButton_module);
;// CONCATENATED MODULE: ../shared/components/RadioButton/RadioButton.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }












var RadioButton = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _classNames;

  var className = _ref.className,
      value = _ref.value,
      onSelect = _ref.onSelect,
      isTranslateLabel = _ref.isTranslateLabel,
      groupName = _ref.groupName,
      isInline = _ref.isInline,
      disabled = _ref.disabled,
      selected = _ref.selected,
      style = _ref.style,
      icon = _ref.icon,
      label = _ref.label,
      hideRadio = _ref.hideRadio,
      searchValue = _ref.searchValue,
      onKeyDown = _ref.onKeyDown;

  var _useSharedTranslation = (0,TranslateContext/* useSharedTranslation */.G)(),
      t = _useSharedTranslation.t;

  var _useState = (0,react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var labelTranslated = isTranslateLabel ? t(label) : label;
  var labelFinal = (0,react.useMemo)(function () {
    return searchValue ? labelTranslated.replace(new RegExp((0,string/* escapeRegExp */.hr)(searchValue, "gi")), function (strMatch) {
      return "<mark>" + strMatch + "</mark>";
    }) : labelTranslated;
  }, [searchValue, labelTranslated]);

  var handleKeyDown = function handleKeyDown(event, id) {
    if (onSelect) {
      (0,keyboard_navigation/* handleKeyDownSelectItem */.nq)(event, function (e) {
        return onSelect(id, e);
      });
    }
  };

  return /*#__PURE__*/react.createElement("label", {
    ref: ref,
    className: classnames_default()(className, "radio-item", (RadioButton_module_default())["radio-item"], selected ? (RadioButton_module_default()).active : (RadioButton_module_default()).inactive, (_classNames = {}, _defineProperty(_classNames, (RadioButton_module_default()).disabled, disabled), _defineProperty(_classNames, (RadioButton_module_default())["is-inline"], isInline), _defineProperty(_classNames, (RadioButton_module_default()).focused, isFocused), _classNames)),
    onKeyDown: onKeyDown
  }, /*#__PURE__*/react.createElement("input", {
    type: "radio",
    name: groupName,
    className: (RadioButton_module_default()).input // NOTE:
    // Don't use attribute "checked" to indicate whether the checkbox is checked or not.
    // In HTML attribute "checked" is an analogue of "defaultValue".
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#attr-checked
    ,
    "aria-checked": selected,
    onChange: function onChange() {},
    onFocus: function onFocus() {
      return setIsFocused(true);
    },
    onBlur: function onBlur() {
      return setIsFocused(false);
    },
    onClick: function onClick(e) {
      return onSelect && onSelect(value, e);
    },
    onKeyDown: function onKeyDown(event) {
      return handleKeyDown(event, value);
    }
  }), !hideRadio && (icon ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    icon: icon
  }), "\xA0") : /*#__PURE__*/react.createElement("span", {
    className: (RadioButton_module_default())["wrap-check"]
  })), label && /*#__PURE__*/react.createElement(Typography/* default */.Z, {
    tag: "span",
    variant: "body3",
    color: "inherit",
    className: classnames_default()(radioButtonLabelClassName, (RadioButton_module_default()).label),
    style: style,
    dangerouslySetInnerHTML: {
      __html: labelFinal
    }
  }), /*#__PURE__*/react.createElement(Ripple/* default */.Z, null));
});
RadioButton.propTypes = {
  style: (prop_types_default()).object,
  icon: (prop_types_default()).any,
  label: (prop_types_default()).string,
  isTranslateLabel: (prop_types_default()).bool,
  isInline: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  selected: (prop_types_default()).bool,
  value: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number, (prop_types_default()).object]),
  onSelect: (prop_types_default()).func,
  groupName: (prop_types_default()).string
};
/* harmony default export */ var RadioButton_RadioButton = (RadioButton);

/***/ }),

/***/ 85769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _RadioButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68898);
/* harmony import */ var _Typography_Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21766);
/* harmony import */ var _utils_select__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48018);
/* harmony import */ var _RadioGroup_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65408);
/* harmony import */ var _RadioGroup_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_RadioGroup_module_scss__WEBPACK_IMPORTED_MODULE_6__);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }









var RadioGroup = function RadioGroup(_ref) {
  var options = _ref.options,
      value = _ref.value,
      onChange = _ref.onChange,
      className = _ref.className,
      isTranslateLabels = _ref.isTranslateLabels,
      label = _ref.label,
      _ref$groupName = _ref.groupName,
      groupName = _ref$groupName === void 0 ? "radio-group" : _ref$groupName,
      keysDisabled = _ref.disabled,
      colClassName = _ref.colClassName,
      isInline = _ref.isInline,
      hideRadio = _ref.hideRadio,
      searchValue = _ref.searchValue,
      onItemKeyDown = _ref.onItemKeyDown;
  var valueCurrentParsed = (0,_utils_select__WEBPACK_IMPORTED_MODULE_5__/* .getOptionKey */ ._)(value);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(valueCurrentParsed),
      _useState2 = _slicedToArray(_useState, 2),
      currentId = _useState2[0],
      setCurrentId = _useState2[1];

  var handleChange = function handleChange(value, e) {
    onChange && onChange(value, e);
    setCurrentId(value);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    role: "radiogroup",
    "aria-labelledby": groupName,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("RadioGroup", (_RadioGroup_module_scss__WEBPACK_IMPORTED_MODULE_6___default().RadioGroup), (_RadioGroup_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[colClassName], className)
  }, label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    key: "group-name",
    tag: "div",
    variant: _Typography_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"].variant.body3 */ .Z.variant.body3,
    fontFamily: _Typography_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"].fontFamily.roboto */ .Z.fontFamily.roboto,
    color: _Typography_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"].color.formLabelColor */ .Z.color.formLabelColor,
    className: (_RadioGroup_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["group-name"])
  }, label), options !== null && options !== void 0 && options.length ? options.map(function (item, index) {
    var label = item.label,
        icon = item.icon,
        style = item.style,
        isTranslateLabel = item.isTranslateLabel,
        disabled = item.disabled;
    var key = (0,_utils_select__WEBPACK_IMPORTED_MODULE_5__/* .getOptionKey */ ._)(item);
    var isDisabled = disabled !== null && disabled !== void 0 ? disabled : keysDisabled === null || keysDisabled === void 0 ? void 0 : keysDisabled.includes(key);
    var isSelected = key === currentId;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_RadioButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      key: key !== null && key !== void 0 ? key : index,
      style: style,
      icon: icon,
      onSelect: handleChange,
      onKeyDown: onItemKeyDown,
      isTranslateLabel: isTranslateLabel !== null && isTranslateLabel !== void 0 ? isTranslateLabel : isTranslateLabels,
      selected: isSelected,
      isInline: isInline,
      disabled: isDisabled,
      label: label,
      value: key,
      groupName: groupName,
      hideRadio: hideRadio,
      searchValue: searchValue
    });
  }) : "");
};

RadioGroup.propTypes = {
  isInline: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  hideRadio: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  isTranslateLabels: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  options: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array),
  disabled: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array),
  value: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)]),
  onChange: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  colClassName: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  groupName: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (RadioGroup);

/***/ }),

/***/ 95793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shared_components_Scroll_react_custom_scrollbars_lib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3062);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56253);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75573);
/* harmony import */ var _utils_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97993);
/* harmony import */ var _Scroll_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97004);
/* harmony import */ var _Scroll_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Scroll_module_scss__WEBPACK_IMPORTED_MODULE_6__);
var _excluded = ["fixBrokenScrollingToTheEdgeWithSelection", "isRenderViewFocusable", "noHidePopups", "children", "onVerticalThumbMouseDown", "onVerticalTrackMouseDown", "onScroll", "onScrollFrame", "onScrollStart", "onUpdate", "onScrollChangeDirection", "onScrollStop", "onScrollStopInstant", "stopDelay", "className", "renderViewClassName", "renderViewStyle", "fixScrollbarCoversContent", "hasStaticPosition", "renderView", "hideScrollBar"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }










var renderEmptyElement = function renderEmptyElement() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null);
};

var renderTrackVerticalDefault = function renderTrackVerticalDefault(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({}, props, {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_Scroll_module_scss__WEBPACK_IMPORTED_MODULE_6___default().scrollMainTrack), "scrollMainTrack")
  }));
};

var renderThumbVerticalDefault = function renderThumbVerticalDefault(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({}, props, {
    className: (_Scroll_module_scss__WEBPACK_IMPORTED_MODULE_6___default().scrollStyle)
  }));
};

var renderThumbHorizontalDefault = function renderThumbHorizontalDefault(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({}, props, {
    className: (_Scroll_module_scss__WEBPACK_IMPORTED_MODULE_6___default().scrollStyle)
  }));
};

var renderViewDefault = function renderViewDefault(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", props);
};
/**
 * @description Scroll component with custom scrollbars and handling scroll stop with possible delay
 */


var Scroll = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (_ref, ref) {
  var fixBrokenScrollingToTheEdgeWithSelection = _ref.fixBrokenScrollingToTheEdgeWithSelection,
      isRenderViewFocusable = _ref.isRenderViewFocusable,
      noHidePopups = _ref.noHidePopups,
      children = _ref.children,
      onVerticalThumbMouseDown = _ref.onVerticalThumbMouseDown,
      onVerticalTrackMouseDown = _ref.onVerticalTrackMouseDown,
      onScroll = _ref.onScroll,
      _onScrollFrame = _ref.onScrollFrame,
      onScrollStart = _ref.onScrollStart,
      onUpdate = _ref.onUpdate,
      onScrollChangeDirection = _ref.onScrollChangeDirection,
      onScrollStop = _ref.onScrollStop,
      onScrollStopInstant = _ref.onScrollStopInstant,
      stopDelay = _ref.stopDelay,
      className = _ref.className,
      renderViewClassName = _ref.renderViewClassName,
      renderViewStyle = _ref.renderViewStyle,
      fixScrollbarCoversContent = _ref.fixScrollbarCoversContent,
      hasStaticPosition = _ref.hasStaticPosition,
      renderView = _ref.renderView,
      hideScrollBar = _ref.hideScrollBar,
      props = _objectWithoutProperties(_ref, _excluded);

  var refRoot = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null); // keep start scroll position

  var scrollTopRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(); // keep timeout for make delayed scroll

  var timerIdScrollStop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(); // keep time for last event of stop scroll for make debounce logic

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      scrollStop = _useState2[0],
      setScrollStop = _useState2[1];

  var onScrollStartHandler = function onScrollStartHandler(e) {
    if (refRoot.current) {
      scrollTopRef.current = refRoot.current.view.scrollTop;
    }

    if (onScrollStart) {
      onScrollStart(e);
    }

    if (scrollStop && stopDelay !== 0) {
      setScrollStop(Date.now());
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (scrollStop) {
      //use ref object allows reset event scroll stop when user scroll again
      clearTimeout(timerIdScrollStop.current);
      timerIdScrollStop.current = setTimeout(function () {
        if (scrollStop && onScrollStop) {
          var _refRoot$current, _refRoot$current$view;

          var offset = 0;

          if (scrollTopRef.current && ((_refRoot$current = refRoot.current) === null || _refRoot$current === void 0 ? void 0 : (_refRoot$current$view = _refRoot$current.view) === null || _refRoot$current$view === void 0 ? void 0 : _refRoot$current$view.scrollTop) !== undefined) {
            var _refRoot$current2, _refRoot$current2$vie;

            offset = scrollTopRef.current - ((_refRoot$current2 = refRoot.current) === null || _refRoot$current2 === void 0 ? void 0 : (_refRoot$current2$vie = _refRoot$current2.view) === null || _refRoot$current2$vie === void 0 ? void 0 : _refRoot$current2$vie.scrollTop) || 0;
          }

          onScrollStop(offset);
        }

        setScrollStop();
      }, stopDelay);
    }

    return function () {
      clearTimeout(timerIdScrollStop.current);
    };
  }, [scrollStop, stopDelay]);

  var handleScrollFrame = function handleScrollFrame(event) {
    var previousScrollStepTop = scrollTopRef.current;

    if (timerIdScrollStop.current !== undefined) {
      clearTimeout(timerIdScrollStop.current);
      timerIdScrollStop.current = undefined;
    }

    if (onScrollChangeDirection) {
      var _refRoot$current3;

      var scrollTop = event.scrollTop;
      var delta = scrollTop - previousScrollStepTop;

      if (delta === 0) {
        return;
      }

      var deltaMin = 0;

      if ((_refRoot$current3 = refRoot.current) !== null && _refRoot$current3 !== void 0 && _refRoot$current3.view) {
        deltaMin = refRoot.current.view.clientHeight / 6;
      }

      if (scrollTop < deltaMin) {
        deltaMin = scrollTop / 2;
      }

      if (delta > 0 && delta > deltaMin) {
        onScrollChangeDirection(_constants__WEBPACK_IMPORTED_MODULE_5__/* .SCROLL_DIRECTIONS.DOWN */ .u1.DOWN);
      } else if (delta < 0 && delta < -deltaMin) {
        onScrollChangeDirection(_constants__WEBPACK_IMPORTED_MODULE_5__/* .SCROLL_DIRECTIONS.UP */ .u1.UP);
      }
    }
  };

  var handleScrollStop = function handleScrollStop() {
    if (onScrollStopInstant) {
      onScrollStopInstant();
    }

    if (stopDelay > 0) {
      setScrollStop(Date.now());
    } else if (onScrollStop) {
      var _refRoot$current4, _refRoot$current4$vie;

      var offset = 0;

      if (scrollTopRef.current && ((_refRoot$current4 = refRoot.current) === null || _refRoot$current4 === void 0 ? void 0 : (_refRoot$current4$vie = _refRoot$current4.view) === null || _refRoot$current4$vie === void 0 ? void 0 : _refRoot$current4$vie.scrollTop) !== undefined) {
        var _refRoot$current5, _refRoot$current5$vie;

        offset = scrollTopRef.current - ((_refRoot$current5 = refRoot.current) === null || _refRoot$current5 === void 0 ? void 0 : (_refRoot$current5$vie = _refRoot$current5.view) === null || _refRoot$current5$vie === void 0 ? void 0 : _refRoot$current5$vie.scrollTop) || 0;
      }

      onScrollStop(offset);
    }
  };

  var renderViewFinal = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (propsRenderView) {
    var _classNames;

    var propsRenderViewFinal = _objectSpread({}, propsRenderView);

    propsRenderViewFinal.className = classnames__WEBPACK_IMPORTED_MODULE_3___default()("scrollbars-render-view", [(_Scroll_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["scrollbars-render-view"])], renderViewClassName, propsRenderViewFinal.className, (_classNames = {}, _defineProperty(_classNames, (_Scroll_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["has-static-position"]), hasStaticPosition), _defineProperty(_classNames, (_Scroll_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["gap-for-scrollbar"]), fixScrollbarCoversContent), _classNames));

    if (renderViewStyle) {
      propsRenderViewFinal.style = _objectSpread(_objectSpread({}, propsRenderView.style), renderViewStyle);
    }

    if (isRenderViewFocusable) {
      propsRenderViewFinal.tabIndex = 0;
    }

    return renderView ? renderView(propsRenderViewFinal) : renderViewDefault(propsRenderViewFinal);
  }, [renderView, renderViewStyle, renderViewClassName, hasStaticPosition, fixScrollbarCoversContent, isRenderViewFocusable]);
  var handleRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (el) {
    (0,_utils_react__WEBPACK_IMPORTED_MODULE_7__/* .handleReactRef */ .q)(ref, el);
    refRoot.current = el;
  }, [ref]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Scroll_react_custom_scrollbars_lib__WEBPACK_IMPORTED_MODULE_2__/* .Scrollbars */ .$B, _extends({
    ref: handleRef,
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_Scroll_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["scrollbars-wrapper"]), "scrollbars-wrapper", className),
    hideTracksWhenNotNeeded: true,
    autoHide: true,
    onUpdate: onUpdate,
    onScrollStart: onScrollStartHandler,
    onScrollFrame: function onScrollFrame(event) {
      handleScrollFrame(event);

      if (_onScrollFrame) {
        _onScrollFrame(event);
      }
    },
    onVerticalThumbMouseDown: onVerticalThumbMouseDown,
    onVerticalTrackMouseDown: onVerticalTrackMouseDown,
    onScrollStop: handleScrollStop,
    onScroll: onScroll,
    renderView: renderViewFinal,
    renderTrackVertical: hideScrollBar ? renderEmptyElement : renderTrackVerticalDefault,
    renderThumbVertical: hideScrollBar ? renderEmptyElement : renderThumbVerticalDefault,
    renderThumbHorizontal: hideScrollBar ? renderEmptyElement : renderThumbHorizontalDefault
  }, props), children);
});
Scroll.defaultProps = {
  stopDelay: 0
};
Scroll.propTypes = {
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  renderViewClassName: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  noHidePopups: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  hideScrollBar: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  fixScrollbarCoversContent: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  renderViewStyle: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
  hasStaticPosition: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node),
  onVerticalThumbMouseDown: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onVerticalTrackMouseDown: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onScroll: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onScrollFrame: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onScrollChangeDirection: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onScrollStart: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onUpdate: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onScrollStop: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onScrollStopInstant: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  renderView: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  stopDelay: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)
};
/* harmony default export */ __webpack_exports__["Z"] = (Scroll);

/***/ }),

/***/ 71770:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.renderViewDefault = renderViewDefault;
exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
exports.renderThumbVerticalDefault = renderThumbVerticalDefault;

var _react = __webpack_require__(27378);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/* eslint-disable react/prop-types */


function renderViewDefault(props) {
  return _react2["default"].createElement('div', props);
}

function renderTrackHorizontalDefault(_ref) {
  var style = _ref.style,
      props = _objectWithoutProperties(_ref, ['style']);

  var finalStyle = _extends({}, style, {
    right: 2,
    bottom: 2,
    left: 2,
    borderRadius: 3
  });

  return _react2["default"].createElement('div', _extends({
    style: finalStyle
  }, props));
}

function renderTrackVerticalDefault(_ref2) {
  var style = _ref2.style,
      props = _objectWithoutProperties(_ref2, ['style']);

  var finalStyle = _extends({}, style, {
    right: 2,
    bottom: 2,
    top: 2,
    borderRadius: 3
  });

  return _react2["default"].createElement('div', _extends({
    style: finalStyle
  }, props));
}

function renderThumbHorizontalDefault(_ref3) {
  var style = _ref3.style,
      props = _objectWithoutProperties(_ref3, ['style']);

  var finalStyle = _extends({}, style, {
    cursor: 'pointer',
    borderRadius: 'inherit',
    backgroundColor: 'rgba(0,0,0,.2)'
  });

  return _react2["default"].createElement('div', _extends({
    style: finalStyle
  }, props));
}

function renderThumbVerticalDefault(_ref4) {
  var style = _ref4.style,
      props = _objectWithoutProperties(_ref4, ['style']);

  var finalStyle = _extends({}, style, {
    cursor: 'pointer',
    borderRadius: 'inherit',
    backgroundColor: 'rgba(0,0,0,.2)'
  });

  return _react2["default"].createElement('div', _extends({
    style: finalStyle
  }, props));
}

/***/ }),

/***/ 30772:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _raf2 = __webpack_require__(5026);

var _raf3 = _interopRequireDefault(_raf2);

var _domCss = __webpack_require__(18575);

var _domCss2 = _interopRequireDefault(_domCss);

var _react = __webpack_require__(27378);

var _propTypes = __webpack_require__(23615);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isString = __webpack_require__(59753);

var _isString2 = _interopRequireDefault(_isString);

var _returnFalse = __webpack_require__(47996);

var _returnFalse2 = _interopRequireDefault(_returnFalse);

var _getInnerWidth = __webpack_require__(3458);

var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);

var _getInnerHeight = __webpack_require__(11945);

var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);

var _styles = __webpack_require__(39048);

var _defaultRenderElements = __webpack_require__(71770);

var _require = __webpack_require__(34289),
    useDeviceDetect = _require.useDeviceDetect;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Scrollbars = function (_Component) {
  _inherits(Scrollbars, _Component);

  var _useDeviceDetect = useDeviceDetect(),
      isIOS = _useDeviceDetect.isIOS,
      osVersion = _useDeviceDetect.osVersion;

  function Scrollbars(props) {
    var _ref;

    _classCallCheck(this, Scrollbars);

    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));

    _this.getScrollLeft = _this.getScrollLeft.bind(_this);
    _this.getScrollTop = _this.getScrollTop.bind(_this);
    _this.getScrollWidth = _this.getScrollWidth.bind(_this);
    _this.getScrollHeight = _this.getScrollHeight.bind(_this);
    _this.getClientWidth = _this.getClientWidth.bind(_this);
    _this.getClientHeight = _this.getClientHeight.bind(_this);
    _this.getValues = _this.getValues.bind(_this);
    _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
    _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
    _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
    _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);
    _this.scrollLeft = _this.scrollLeft.bind(_this);
    _this.scrollTop = _this.scrollTop.bind(_this);
    _this.scrollToLeft = _this.scrollToLeft.bind(_this);
    _this.scrollToTop = _this.scrollToTop.bind(_this);
    _this.scrollToRight = _this.scrollToRight.bind(_this);
    _this.scrollToBottom = _this.scrollToBottom.bind(_this);
    _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
    _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
    _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
    _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
    _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
    _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.handleDrag = _this.handleDrag.bind(_this);
    _this.handleDragEnd = _this.handleDragEnd.bind(_this);
    _this.state = {
      didMountUniversal: false
    };
    return _this;
  }

  _createClass(Scrollbars, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addListeners();
      this.update();
      this.componentDidMountUniversal();
    }
  }, {
    key: 'componentDidMountUniversal',
    value: function componentDidMountUniversal() {
      // eslint-disable-line react/sort-comp
      var universal = this.props.universal;
      if (!universal) return;
      this.setState({
        didMountUniversal: true
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeListeners();
      (0, _raf2.cancel)(this.requestFrame);
      clearTimeout(this.hideTracksTimeout);
      clearInterval(this.detectScrollingInterval);
    }
  }, {
    key: 'getScrollLeft',
    value: function getScrollLeft() {
      if (!this.view) return 0;
      return this.view.scrollLeft;
    }
  }, {
    key: 'getScrollTop',
    value: function getScrollTop() {
      if (!this.view) return 0;
      return this.view.scrollTop;
    }
  }, {
    key: 'getScrollWidth',
    value: function getScrollWidth() {
      if (!this.view) return 0;
      return this.view.scrollWidth;
    }
  }, {
    key: 'getScrollHeight',
    value: function getScrollHeight() {
      if (!this.view) return 0;
      return this.view.scrollHeight;
    }
  }, {
    key: 'getClientWidth',
    value: function getClientWidth() {
      if (!this.view) return 0;
      return this.view.clientWidth;
    }
  }, {
    key: 'getClientHeight',
    value: function getClientHeight() {
      if (!this.view) return 0;
      return this.view.clientHeight;
    }
  }, {
    key: 'getValues',
    value: function getValues() {
      var _ref2 = this.view || {},
          _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
          _ref2$scrollWidth = _ref2.scrollWidth,
          scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
          _ref2$scrollHeight = _ref2.scrollHeight,
          scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
          _ref2$clientWidth = _ref2.clientWidth,
          clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
          _ref2$clientHeight = _ref2.clientHeight,
          clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;

      return {
        left: scrollLeft / (scrollWidth - clientWidth) || 0,
        top: scrollTop / (scrollHeight - clientHeight) || 0,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth,
        scrollHeight: scrollHeight,
        clientWidth: clientWidth,
        clientHeight: clientHeight
      };
    }
  }, {
    key: 'getThumbHorizontalWidth',
    value: function getThumbHorizontalWidth() {
      var _props = this.props,
          thumbSize = _props.thumbSize,
          thumbMinSize = _props.thumbMinSize;
      var _view = this.view,
          scrollWidth = _view.scrollWidth,
          clientWidth = _view.clientWidth;
      var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
      var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
      if (trackWidth <= width) return 0;
      if (thumbSize) return thumbSize;
      return Math.max(width, thumbMinSize);
    }
  }, {
    key: 'getThumbVerticalHeight',
    value: function getThumbVerticalHeight() {
      var _props2 = this.props,
          thumbSize = _props2.thumbSize,
          thumbMinSize = _props2.thumbMinSize;
      var _view2 = this.view,
          scrollHeight = _view2.scrollHeight,
          clientHeight = _view2.clientHeight;
      var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
      var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
      if (trackHeight <= height) return 0;
      if (thumbSize) return thumbSize;
      return Math.max(height, thumbMinSize);
    }
  }, {
    key: 'getScrollLeftForOffset',
    value: function getScrollLeftForOffset(offset) {
      var _view3 = this.view,
          scrollWidth = _view3.scrollWidth,
          clientWidth = _view3.clientWidth;
      var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
      var thumbWidth = this.getThumbHorizontalWidth();
      return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
    }
  }, {
    key: 'getScrollTopForOffset',
    value: function getScrollTopForOffset(offset) {
      var _view4 = this.view,
          scrollHeight = _view4.scrollHeight,
          clientHeight = _view4.clientHeight;
      var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
      var thumbHeight = this.getThumbVerticalHeight();
      return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
    }
  }, {
    key: 'scrollLeft',
    value: function scrollLeft() {
      var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!this.view) return;
      this.view.scrollLeft = left;
    }
  }, {
    key: 'scrollTop',
    value: function scrollTop() {
      var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!this.view) return;
      this.view.scrollTop = top;
    }
  }, {
    key: 'scrollToLeft',
    value: function scrollToLeft() {
      if (!this.view) return;
      this.view.scrollLeft = 0;
    }
  }, {
    key: 'scrollToTop',
    value: function scrollToTop() {
      if (!this.view) return;
      this.view.scrollTop = 0;
    }
  }, {
    key: 'scrollToRight',
    value: function scrollToRight() {
      if (!this.view) return;
      this.view.scrollLeft = this.view.scrollWidth;
    }
  }, {
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      if (!this.view) return;
      this.view.scrollTop = this.view.scrollHeight;
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      /* istanbul ignore if */
      if (typeof document === 'undefined' || !this.view) return;
      var view = this.view,
          trackHorizontal = this.trackHorizontal,
          trackVertical = this.trackVertical,
          thumbHorizontal = this.thumbHorizontal,
          thumbVertical = this.thumbVertical;
      view.addEventListener('scroll', this.handleScroll);
      trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
      trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
      trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
      trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
      trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
      trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
      thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
      thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
      window.addEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners() {
      /* istanbul ignore if */
      if (typeof document === 'undefined' || !this.view) return;
      var view = this.view,
          trackHorizontal = this.trackHorizontal,
          trackVertical = this.trackVertical,
          thumbHorizontal = this.thumbHorizontal,
          thumbVertical = this.thumbVertical;
      view.removeEventListener('scroll', this.handleScroll);
      trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
      trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
      trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
      trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
      trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
      trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
      thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
      thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
      window.removeEventListener('resize', this.handleWindowResize); // Possibly setup by `handleDragStart`

      this.teardownDragging();
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll(event) {
      var _this2 = this;

      var _props3 = this.props,
          onScroll = _props3.onScroll,
          onScrollFrame = _props3.onScrollFrame;
      if (onScroll) onScroll(event);
      this.update(function (values) {
        var scrollLeft = values.scrollLeft,
            scrollTop = values.scrollTop;
        _this2.viewScrollLeft = scrollLeft;
        _this2.viewScrollTop = scrollTop;
        if (onScrollFrame) onScrollFrame(values);
      });
      this.detectScrolling();
    }
  }, {
    key: 'handleScrollStart',
    value: function handleScrollStart() {
      var onScrollStart = this.props.onScrollStart;
      if (onScrollStart) onScrollStart();
      this.handleScrollStartAutoHide();
    }
  }, {
    key: 'handleScrollStartAutoHide',
    value: function handleScrollStartAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.showTracks();
    }
  }, {
    key: 'handleScrollStop',
    value: function handleScrollStop() {
      var onScrollStop = this.props.onScrollStop;
      if (onScrollStop) onScrollStop();
      this.handleScrollStopAutoHide();
    }
  }, {
    key: 'handleScrollStopAutoHide',
    value: function handleScrollStopAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.hideTracks();
    }
  }, {
    key: 'handleWindowResize',
    value: function handleWindowResize() {
      this.forceUpdate();
    }
  }, {
    key: 'handleHorizontalTrackMouseDown',
    value: function handleHorizontalTrackMouseDown(event) {
      event.preventDefault();
      var target = event.target,
          clientX = event.clientX;

      var _target$getBoundingCl = target.getBoundingClientRect(),
          targetLeft = _target$getBoundingCl.left;

      var thumbWidth = this.getThumbHorizontalWidth();
      var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
      this.view.scrollLeft = this.getScrollLeftForOffset(offset);
    }
  }, {
    key: 'handleVerticalTrackMouseDown',
    value: function handleVerticalTrackMouseDown(event) {
      /** ============= NEW CODE: BEGIN =================== **/
      var onVerticalTrackMouseDown = this.props.onVerticalTrackMouseDown;

      if (onVerticalTrackMouseDown) {
        onVerticalTrackMouseDown();
      }
      /** ============= NEW CODE: END =================== **/


      event.preventDefault();
      var target = event.target,
          clientY = event.clientY;

      var _target$getBoundingCl2 = target.getBoundingClientRect(),
          targetTop = _target$getBoundingCl2.top;

      var thumbHeight = this.getThumbVerticalHeight();
      var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
      this.view.scrollTop = this.getScrollTopForOffset(offset);
    }
  }, {
    key: 'handleHorizontalThumbMouseDown',
    value: function handleHorizontalThumbMouseDown(event) {
      event.preventDefault();
      this.handleDragStart(event);
      var target = event.target,
          clientX = event.clientX;
      var offsetWidth = target.offsetWidth;

      var _target$getBoundingCl3 = target.getBoundingClientRect(),
          left = _target$getBoundingCl3.left;

      this.prevPageX = offsetWidth - (clientX - left);
    }
  }, {
    key: 'handleVerticalThumbMouseDown',
    value: function handleVerticalThumbMouseDown(event) {
      /** ============= NEW CODE: BEGIN =================== **/
      var onVerticalThumbMouseDown = this.props.onVerticalThumbMouseDown;

      if (onVerticalThumbMouseDown) {
        onVerticalThumbMouseDown();
      }
      /** ============= NEW CODE: END =================== **/


      event.preventDefault();
      this.handleDragStart(event);
      var target = event.target,
          clientY = event.clientY;
      var offsetHeight = target.offsetHeight;

      var _target$getBoundingCl4 = target.getBoundingClientRect(),
          top = _target$getBoundingCl4.top;

      this.prevPageY = offsetHeight - (clientY - top);
    }
  }, {
    key: 'setupDragging',
    value: function setupDragging() {
      (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
      document.addEventListener('mousemove', this.handleDrag);
      document.addEventListener('mouseup', this.handleDragEnd);
      document.onselectstart = _returnFalse2["default"];
    }
  }, {
    key: 'teardownDragging',
    value: function teardownDragging() {
      (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
      document.removeEventListener('mousemove', this.handleDrag);
      document.removeEventListener('mouseup', this.handleDragEnd);
      document.onselectstart = undefined;
    }
  }, {
    key: 'handleDragStart',
    value: function handleDragStart(event) {
      this.dragging = true;
      event.stopImmediatePropagation();
      this.setupDragging();
    }
  }, {
    key: 'handleDrag',
    value: function handleDrag(event) {
      if (this.prevPageX) {
        var clientX = event.clientX;

        var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
            trackLeft = _trackHorizontal$getB.left;

        var thumbWidth = this.getThumbHorizontalWidth();
        var clickPosition = thumbWidth - this.prevPageX;
        var offset = -trackLeft + clientX - clickPosition;
        this.view.scrollLeft = this.getScrollLeftForOffset(offset);
      }

      if (this.prevPageY) {
        var clientY = event.clientY;

        var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
            trackTop = _trackVertical$getBou.top;

        var thumbHeight = this.getThumbVerticalHeight();

        var _clickPosition = thumbHeight - this.prevPageY;

        var _offset = -trackTop + clientY - _clickPosition;

        this.view.scrollTop = this.getScrollTopForOffset(_offset);
      }

      return false;
    }
  }, {
    key: 'handleDragEnd',
    value: function handleDragEnd() {
      this.dragging = false;
      this.prevPageX = this.prevPageY = 0;
      this.teardownDragging();
      this.handleDragEndAutoHide();
    }
  }, {
    key: 'handleDragEndAutoHide',
    value: function handleDragEndAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.hideTracks();
    }
  }, {
    key: 'handleTrackMouseEnter',
    value: function handleTrackMouseEnter() {
      this.trackMouseOver = true;
      this.handleTrackMouseEnterAutoHide();
    }
  }, {
    key: 'handleTrackMouseEnterAutoHide',
    value: function handleTrackMouseEnterAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.showTracks();
    }
  }, {
    key: 'handleTrackMouseLeave',
    value: function handleTrackMouseLeave() {
      this.trackMouseOver = false;
      this.handleTrackMouseLeaveAutoHide();
    }
  }, {
    key: 'handleTrackMouseLeaveAutoHide',
    value: function handleTrackMouseLeaveAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.hideTracks();
    }
  }, {
    key: 'showTracks',
    value: function showTracks() {
      clearTimeout(this.hideTracksTimeout);
      (0, _domCss2["default"])(this.trackHorizontal, {
        opacity: 1
      });
      (0, _domCss2["default"])(this.trackVertical, {
        opacity: 1
      });
    }
  }, {
    key: 'hideTracks',
    value: function hideTracks() {
      var _this3 = this;

      if (this.dragging) return;
      if (this.scrolling) return;
      if (this.trackMouseOver) return;
      var autoHideTimeout = this.props.autoHideTimeout;
      clearTimeout(this.hideTracksTimeout);
      this.hideTracksTimeout = setTimeout(function () {
        (0, _domCss2["default"])(_this3.trackHorizontal, {
          opacity: 0
        });
        (0, _domCss2["default"])(_this3.trackVertical, {
          opacity: 0
        });
      }, autoHideTimeout);
    }
  }, {
    key: 'detectScrolling',
    value: function detectScrolling() {
      var _this4 = this;

      if (this.scrolling) return;
      this.scrolling = true;
      this.handleScrollStart();
      this.detectScrollingInterval = setInterval(function () {
        if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
          clearInterval(_this4.detectScrollingInterval);
          _this4.scrolling = false;

          _this4.handleScrollStop();
        }

        _this4.lastViewScrollLeft = _this4.viewScrollLeft;
        _this4.lastViewScrollTop = _this4.viewScrollTop;
      }, 100);
    }
  }, {
    key: 'raf',
    value: function raf(callback) {
      var _this5 = this;

      if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
      this.requestFrame = (0, _raf3["default"])(function () {
        _this5.requestFrame = undefined;
        callback();
      });
    }
  }, {
    key: 'update',
    value: function update(callback) {
      var _this6 = this;

      this.raf(function () {
        return _this6._update(callback);
      });
    }
  }, {
    key: '_update',
    value: function _update(callback) {
      var _props4 = this.props,
          onUpdate = _props4.onUpdate,
          hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;
      var values = this.getValues();
      var scrollLeft = values.scrollLeft,
          clientWidth = values.clientWidth,
          scrollWidth = values.scrollWidth;
      var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
      var thumbHorizontalWidth = this.getThumbHorizontalWidth();
      var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
      var thumbHorizontalStyle = {
        width: thumbHorizontalWidth,
        transform: 'translateX(' + thumbHorizontalX + 'px)'
      };
      var scrollTop = values.scrollTop,
          clientHeight = values.clientHeight,
          scrollHeight = values.scrollHeight;
      var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
      var thumbVerticalHeight = this.getThumbVerticalHeight();
      var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
      var thumbVerticalStyle = {
        height: thumbVerticalHeight,
        transform: 'translateY(' + thumbVerticalY + 'px)'
      };

      if (hideTracksWhenNotNeeded) {
        var trackHorizontalStyle = {
          visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
        };
        var trackVerticalStyle = {
          visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
        };
        (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
        (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
      }

      (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
      (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
      if (onUpdate) onUpdate(values);
      if (typeof callback !== 'function') return;
      callback(values);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _props5 = this.props,
          onScroll = _props5.onScroll,
          onScrollFrame = _props5.onScrollFrame,
          onScrollStart = _props5.onScrollStart,
          onScrollStop = _props5.onScrollStop,
          onUpdate = _props5.onUpdate,
          renderView = _props5.renderView,
          renderTrackHorizontal = _props5.renderTrackHorizontal,
          renderTrackVertical = _props5.renderTrackVertical,
          renderThumbHorizontal = _props5.renderThumbHorizontal,
          renderThumbVertical = _props5.renderThumbVertical,
          tagName = _props5.tagName,
          hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
          autoHide = _props5.autoHide,
          autoHideTimeout = _props5.autoHideTimeout,
          autoHideDuration = _props5.autoHideDuration,
          thumbSize = _props5.thumbSize,
          thumbMinSize = _props5.thumbMinSize,
          universal = _props5.universal,
          autoHeight = _props5.autoHeight,
          autoHeightMin = _props5.autoHeightMin,
          autoHeightMax = _props5.autoHeightMax,
          style = _props5.style,
          children = _props5.children,
          props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onVerticalThumbMouseDown', 'onVerticalTrackMouseDown', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
      /* eslint-enable no-unused-vars */


      var didMountUniversal = this.state.didMountUniversal;

      var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
        minHeight: autoHeightMin,
        maxHeight: autoHeightMax
      }), style);
      /** ============= NEW CODE: BEGIN =================== **/


      var viewStyleDefault = {};
      var viewStyleAutoHeight = {
        minHeight: (0, _isString2["default"])(autoHeightMin) ? autoHeightMin : autoHeightMin + 'px',
        maxHeight: (0, _isString2["default"])(autoHeightMax) ? autoHeightMax : autoHeightMax + 'px'
      };

      var viewStyle = _extends({}, _styles.viewStyleDefault, viewStyleDefault, autoHeight && _extends({}, _styles.viewStyleAutoHeight, viewStyleAutoHeight), autoHeight && universal && !didMountUniversal && {
        minHeight: autoHeightMin,
        maxHeight: autoHeightMax
      }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);

      var trackAutoHeightStyle = {
        transition: 'opacity ' + autoHideDuration + 'ms',
        opacity: 0
      };

      var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, universal && !didMountUniversal && {
        display: 'none'
      });

      var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, universal && !didMountUniversal && {
        display: 'none'
      });

      return (0, _react.createElement)(tagName, _extends({}, props, {
        style: containerStyle,
        ref: function ref(_ref3) {
          _this7.container = _ref3;
        }
      }), [(0, _react.cloneElement)(renderView({
        style: viewStyle
      }), {
        key: 'view',
        ref: function ref(_ref4) {
          _this7.view = _ref4;
        }
      }, children), (0, _react.cloneElement)(renderTrackHorizontal({
        style: trackHorizontalStyle
      }), {
        key: 'trackHorizontal',
        ref: function ref(_ref5) {
          _this7.trackHorizontal = _ref5;
        }
      }, (0, _react.cloneElement)(renderThumbHorizontal({
        style: _styles.thumbHorizontalStyleDefault
      }), {
        ref: function ref(_ref6) {
          _this7.thumbHorizontal = _ref6;
        }
      })), (0, _react.cloneElement)(renderTrackVertical({
        style: trackVerticalStyle
      }), {
        key: 'trackVertical',
        ref: function ref(_ref7) {
          _this7.trackVertical = _ref7;
        }
      }, (0, _react.cloneElement)(renderThumbVertical({
        style: _styles.thumbVerticalStyleDefault
      }), {
        ref: function ref(_ref8) {
          _this7.thumbVertical = _ref8;
        }
      }))]);
    }
  }]);

  return Scrollbars;
}(_react.Component);

exports["default"] = Scrollbars;
Scrollbars.propTypes = {
  onScroll: _propTypes2["default"].func,
  onScrollFrame: _propTypes2["default"].func,
  onScrollStart: _propTypes2["default"].func,
  onScrollStop: _propTypes2["default"].func,
  onVerticalThumbMouseDown: _propTypes2["default"].func,
  onVerticalTrackMouseDown: _propTypes2["default"].func,
  onUpdate: _propTypes2["default"].func,
  renderView: _propTypes2["default"].func,
  renderTrackHorizontal: _propTypes2["default"].func,
  renderTrackVertical: _propTypes2["default"].func,
  renderThumbHorizontal: _propTypes2["default"].func,
  renderThumbVertical: _propTypes2["default"].func,
  tagName: _propTypes2["default"].string,
  thumbSize: _propTypes2["default"].number,
  thumbMinSize: _propTypes2["default"].number,
  hideTracksWhenNotNeeded: _propTypes2["default"].bool,
  autoHide: _propTypes2["default"].bool,
  autoHideTimeout: _propTypes2["default"].number,
  autoHideDuration: _propTypes2["default"].number,
  autoHeight: _propTypes2["default"].bool,
  autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
  autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
  universal: _propTypes2["default"].bool,
  style: _propTypes2["default"].object,
  children: _propTypes2["default"].node
};
Scrollbars.defaultProps = {
  renderView: _defaultRenderElements.renderViewDefault,
  renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
  renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
  renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
  renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
  tagName: 'div',
  thumbMinSize: 30,
  hideTracksWhenNotNeeded: false,
  autoHide: false,
  autoHideTimeout: 1000,
  autoHideDuration: 200,
  autoHeight: false,
  autoHeightMin: 0,
  autoHeightMax: 200,
  universal: false
};

/***/ }),

/***/ 39048:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var containerStyleDefault = exports.containerStyleDefault = {
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  height: '100%'
}; // Overrides containerStyleDefault properties

var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
  height: 'auto'
};
var viewStyleDefault = exports.viewStyleDefault = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  overflow: 'scroll',
  WebkitOverflowScrolling: 'touch'
}; // Overrides viewStyleDefault properties

var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
  position: 'relative',
  top: undefined,
  left: undefined,
  right: undefined,
  bottom: undefined
};
var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
  overflow: 'hidden',
  marginRight: 0,
  marginBottom: 0
};
var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
  position: 'absolute',
  height: 6
};
var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
  position: 'absolute',
  width: 6
};
var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
  position: 'relative',
  display: 'block',
  height: '100%'
};
var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
  position: 'relative',
  display: 'block',
  width: '100%'
};
var disableSelectStyle = exports.disableSelectStyle = {
  userSelect: 'none'
};
var disableSelectStyleReset = exports.disableSelectStyleReset = {
  userSelect: ''
};

/***/ }),

/***/ 3062:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.$B = undefined;

var _Scrollbars = __webpack_require__(30772);

var _Scrollbars2 = _interopRequireDefault(_Scrollbars);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

__webpack_unused_export__ = _Scrollbars2["default"];
exports.$B = _Scrollbars2["default"];

/***/ }),

/***/ 11945:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getInnerHeight;

function getInnerHeight(el) {
  var clientHeight = el.clientHeight;

  var _getComputedStyle = getComputedStyle(el),
      paddingTop = _getComputedStyle.paddingTop,
      paddingBottom = _getComputedStyle.paddingBottom;

  return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

/***/ }),

/***/ 3458:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getInnerWidth;

function getInnerWidth(el) {
  var clientWidth = el.clientWidth;

  var _getComputedStyle = getComputedStyle(el),
      paddingLeft = _getComputedStyle.paddingLeft,
      paddingRight = _getComputedStyle.paddingRight;

  return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

/***/ }),

/***/ 59753:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isString;

function isString(maybe) {
  return typeof maybe === 'string';
}

/***/ }),

/***/ 47996:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = returnFalse;

function returnFalse() {
  return false;
}

/***/ }),

/***/ 70889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Badge_Badge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(806);
/* harmony import */ var _Typography_Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21766);
/* harmony import */ var _shared_components_Button_Ripple__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22168);
/* harmony import */ var _utils_url_url__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59916);
/* harmony import */ var _utils_search_search__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15347);
/* harmony import */ var _utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78889);
/* harmony import */ var _SearchAccordionItem_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8492);
/* harmony import */ var _SearchAccordionItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_SearchAccordionItem_module_scss__WEBPACK_IMPORTED_MODULE_9__);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var badgeCountSeparator = " ";

var SearchAccordionItem = function SearchAccordionItem(_ref) {
  var _classNames;

  var className = _ref.className,
      title = _ref.title,
      url = _ref.url,
      count = _ref.count,
      countMax = _ref.countMax,
      variant = _ref.variant,
      onClick = _ref.onClick,
      active = _ref.active,
      titleProps = _ref.titleProps,
      id = _ref.id,
      onContextMenu = _ref.onContextMenu,
      section = _ref.section,
      item = _ref.item,
      tabIndex = _ref.tabIndex;
  var Tag = url ? "a" : "div";
  var props = {};

  if (url) {
    props.href = url;

    if ((0,_utils_url_url__WEBPACK_IMPORTED_MODULE_6__/* .isUrlHasHttpPart */ .Vd)(url)) {
      props.target = "_blank";
      props.rel = "noopener noreferrer";
    }
  }

  var badgeCount = (0,_utils_search_search__WEBPACK_IMPORTED_MODULE_7__/* .getResultsCount */ .Gv)(count, countMax, badgeCountSeparator);
  var isDisabled = count !== undefined && badgeCount === "0";

  if (isDisabled) {
    props.disabled = isDisabled;
  }

  var handleKeyDownHead = function handleKeyDownHead(e) {
    return (0,_utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_8__/* .handleKeyDownSelectItem */ .nq)(e, onClick);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, _extends({}, props, {
    tabIndex: tabIndex,
    id: id,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_SearchAccordionItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().root), className, (_SearchAccordionItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default())[variant], (_classNames = {}, _defineProperty(_classNames, (_SearchAccordionItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().active), active), _defineProperty(_classNames, (_SearchAccordionItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().disabled), isDisabled), _classNames)),
    onKeyDown: handleKeyDownHead,
    onClick: onClick,
    onContextMenu: onContextMenu ? function (e) {
      return onContextMenu(e, item, section);
    } : null
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _extends({
    className: (_SearchAccordionItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["item-text"]),
    variant: variant === "tertiary" ? _Typography_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"].variant.h5 */ .Z.variant.h5 : _Typography_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"].variant.body4 */ .Z.variant.body4,
    color: variant === "tertiary" ? _Typography_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"].color.searchSectionPrimary */ .Z.color.searchSectionPrimary : undefined,
    hoverable: variant === "tertiary",
    clamp: 2,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }, titleProps)), count !== undefined && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Badge_Badge__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    number: badgeCount,
    className: (_SearchAccordionItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["badge-wrap"]),
    classNameText: (_SearchAccordionItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["badge-text"])
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Button_Ripple__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, null));
};

SearchAccordionItem.propTypes = {
  id: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  variant: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  active: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  titleProps: prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape(_Typography_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes),
  title: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  url: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  count: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().number), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)]),
  countMax: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number),
  onClick: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onContextMenu: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  section: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number),
  item: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object)
};
SearchAccordionItem.defaultProps = {
  variant: "primary"
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchAccordionItem);

/***/ }),

/***/ 50439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48081);
/* harmony import */ var _shared_utils_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62330);
/* harmony import */ var _IconButton_IconButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75448);
/* harmony import */ var _Input_Input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38081);
/* harmony import */ var _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59034);
/* harmony import */ var _SearchField_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2809);
/* harmony import */ var _SearchField_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_SearchField_module_scss__WEBPACK_IMPORTED_MODULE_7__);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }









var SearchField = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, refInput) {
  var className = _ref.className,
      inputClassName = _ref.inputClassName,
      isIconClearVisible = _ref.isIconClearVisible,
      isIconSearchVisible = _ref.isIconSearchVisible,
      isIconSearchEnabled = _ref.isIconSearchEnabled,
      placeholder = _ref.placeholder,
      value = _ref.value,
      onSearch = _ref.onSearch,
      onClear = _ref.onClear,
      onInputFocus = _ref.onInputFocus,
      onInputClick = _ref.onInputClick,
      onInputBlur = _ref.onInputBlur,
      onInputKeyDown = _ref.onInputKeyDown,
      onChange = _ref.onChange,
      isWithDebounce = _ref.isWithDebounce,
      size = _ref.size,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
      required = _ref.required,
      slotBefore = _ref.slotBefore,
      slotAfter = _ref.slotAfter;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value || ""),
      _useState2 = _slicedToArray(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_2__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  var refIsLastMouseDownWithFocusedInput = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setSearch(value || "");
  }, [value]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var timeout;

    if (isWithDebounce) {
      timeout = setTimeout(function () {
        onChange(search);
      }, 500);
    } else {
      onChange(search);
    }

    return function () {
      clearTimeout(timeout);
    };
  }, [search, isWithDebounce]);

  var handleSearch = function handleSearch(event) {
    event.preventDefault();

    if (search.length && onSearch) {
      onSearch(search);
    }
  };

  var handleClear = function handleClear(event) {
    setSearch("");

    if (onClear) {
      onClear(event);
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Input_Input__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    tagRoot: "form",
    rootProps: {
      onSubmit: handleSearch,
      role: "search"
    },
    ref: refInput,
    className: className,
    inputClassName: inputClassName,
    variant: _Input_Input__WEBPACK_IMPORTED_MODULE_5__/* ["default"].variant.search */ .Z.variant.search,
    size: size,
    value: search,
    "data-focus": autoFocus ? "true" : "false",
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : t("search"),
    autoCapitalize: "false",
    autoCorrect: "false",
    onKeyDown: onInputKeyDown,
    onChange: function onChange(event) {
      setSearch(event.target.value.replace(/“/g, "\""));
    },
    onFocus: function onFocus(e) {
      if (onInputFocus) {
        onInputFocus();
      }
    },
    onClick: onInputClick,
    onMouseDown: function onMouseDown(e) {
      refIsLastMouseDownWithFocusedInput.current = (0,_shared_utils_dom__WEBPACK_IMPORTED_MODULE_3__/* .isElementFocused */ .Qw)(e.target);
    },
    onMouseUp: function onMouseUp(e) {
      if (!refIsLastMouseDownWithFocusedInput.current) {
        setTimeout(function () {
          e.target.select();
        }, 0);
      }
    },
    onBlur: onInputBlur,
    slotBefore: slotBefore && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: (_SearchField_module_scss__WEBPACK_IMPORTED_MODULE_7___default().actions)
    }, slotBefore),
    slotAfter: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: (_SearchField_module_scss__WEBPACK_IMPORTED_MODULE_7___default().actions)
    }, !!search && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      icon: _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_6__/* ["default"].close */ .Z.close,
      className: (_SearchField_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["btn-clear"]),
      title: t("clear"),
      onClick: handleClear
    }), isIconSearchVisible && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      tabIndex: -1,
      icon: _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_6__/* ["default"].search */ .Z.search,
      className: (_SearchField_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["btn-search"]),
      title: t("search"),
      onClick: function onClick(event) {
        if (isIconSearchEnabled) {
          handleSearch(event);
        }
      }
    }), slotAfter)
  });
});
SearchField.defaultProps = {
  isIconClearVisible: true,
  isIconSearchVisible: true,
  isIconSearchEnabled: true,
  onChange: function onChange() {}
};
SearchField.propTypes = {
  isWithDebounce: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  isIconClearVisible: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  isIconSearchVisible: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  isIconSearchEnabled: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  placeholder: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  value: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  onSearch: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onClear: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onInputFocus: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onInputClick: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onInputBlur: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onChange: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchField);

/***/ }),

/***/ 26930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Select_SelectBodyTypeRadioButton; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../shared/components/RadioButton/RadioGroup.js
var RadioGroup = __webpack_require__(85769);
// EXTERNAL MODULE: ../shared/utils/keyboard-navigation/keyboard-navigation.js
var keyboard_navigation = __webpack_require__(78889);
// EXTERNAL MODULE: ../shared/components/Select/SelectBody.module.scss
var SelectBody_module = __webpack_require__(21968);
var SelectBody_module_default = /*#__PURE__*/__webpack_require__.n(SelectBody_module);
;// CONCATENATED MODULE: ../shared/components/Select/SelectBody.js




var SelectBody = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var options = _ref.options,
      labels = _ref.labels,
      className = _ref.className,
      renderGroup = _ref.renderGroup,
      slotsAfterOptions = _ref.slotsAfterOptions;
  var refInternal = (0,react.useRef)(null);
  var refRoot = ref !== null && ref !== void 0 ? ref : refInternal;

  if (!options) {
    return null;
  }

  var renderOptions = function renderOptions() {
    if (Array.isArray(options)) {
      var elements = [];

      var renderOptionsGroup = function renderOptionsGroup(options, indexGroup, array) {
        if (!options) {
          return;
        }

        if (options.length || slotsAfterOptions !== null && slotsAfterOptions !== void 0 && slotsAfterOptions[indexGroup]) {
          var label = labels === null || labels === void 0 ? void 0 : labels[indexGroup];
          elements.push(renderGroup({
            label: label,
            indexGroup: indexGroup,
            options: options
          }));

          if (slotsAfterOptions !== null && slotsAfterOptions !== void 0 && slotsAfterOptions[indexGroup]) {
            elements.push(slotsAfterOptions[indexGroup]);
          }

          if (elements.length && array && array[indexGroup + 1]) {
            elements.push( /*#__PURE__*/react.createElement("hr", {
              key: "divider" + indexGroup,
              className: (SelectBody_module_default())["options-group-divider"]
            }));
          }
        }
      };

      if (options.length) {
        if (options.some(function (o) {
          return Array.isArray(o);
        })) {
          options.forEach(renderOptionsGroup);
        } else {
          renderOptionsGroup(options, 0);
        }
      }

      return elements;
    }

    return options;
  };

  var handleItemKeyDown = function handleItemKeyDown(e) {
    return (0,keyboard_navigation/* handleKeyDownNavigation */.OB)(refRoot.current, e, true);
  };

  return /*#__PURE__*/react.createElement("div", {
    ref: refRoot,
    className: className,
    onKeyDown: handleItemKeyDown
  }, renderOptions());
});
SelectBody.propTypes = {
  className: (prop_types_default()).string,
  options: (prop_types_default()).array,
  labels: (prop_types_default()).array,
  renderGroup: (prop_types_default()).func,
  slotsAfterOptions: (prop_types_default()).array
};
/* harmony default export */ var Select_SelectBody = (SelectBody);
// EXTERNAL MODULE: ../shared/utils/select.js
var utils_select = __webpack_require__(48018);
;// CONCATENATED MODULE: ../shared/components/Select/SelectBodyTypeRadioButton.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






var SelectBodyTypeRadioButton = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var isTranslateLabels = _ref.isTranslateLabels,
      options = _ref.options,
      keysDisabled = _ref.keysDisabled,
      value = _ref.value,
      labels = _ref.labels,
      onSelect = _ref.onSelect,
      className = _ref.className,
      _ref$withRadio = _ref.withRadio,
      withRadio = _ref$withRadio === void 0 ? false : _ref$withRadio,
      searchValue = _ref.searchValue,
      slotsAfterOptions = _ref.slotsAfterOptions;
  var isValueArray = Array.isArray(value);
  var valueNormalized = (0,react.useMemo)(function () {
    return isValueArray ? value : [value];
  }, [isValueArray, value]);
  var optionsNormalized = (0,react.useMemo)(function () {
    if (!options) {
      return [];
    }

    return !options.length || Array.isArray(options[0]) ? options : [options];
  }, [options]);

  var _useState = (0,react.useState)(valueNormalized),
      _useState2 = _slicedToArray(_useState, 2),
      valueNormalizedLocal = _useState2[0],
      setValueNormalizedLocal = _useState2[1]; // Updates {valueNormalizedLocal} on props {value} change.


  (0,react.useEffect)(function () {
    setValueNormalizedLocal(valueNormalized);
  }, [valueNormalized]);

  if (!(options !== null && options !== void 0 && options.length)) {
    return null;
  }

  var handleSelect = function handleSelect(optionIndex, optionsGroupIndex, e) {
    var valueNormalizedNew = valueNormalized.map(function (value, index) {
      if (index === optionsGroupIndex) {
        return optionsNormalized[optionsGroupIndex][optionIndex];
      }

      return optionsNormalized[index].find(function (option) {
        return (0,utils_select/* getOptionKey */._)(option) === (0,utils_select/* getOptionKey */._)(value);
      });
    });
    setValueNormalizedLocal(valueNormalizedNew); // if {value} was an array then return as an array of options.
    // if {value} was an object then return as an option.

    onSelect(isValueArray ? valueNormalizedNew : valueNormalizedNew[optionsGroupIndex], optionIndex, optionsGroupIndex, e);
  };

  var renderGroup = function renderGroup(_ref2) {
    var label = _ref2.label,
        options = _ref2.options,
        indexGroup = _ref2.indexGroup;
    var selectedId = (0,utils_select/* getOptionKey */._)(valueNormalizedLocal[indexGroup]);
    return /*#__PURE__*/react.createElement(RadioGroup/* default */.Z, {
      key: "radio-group-" + indexGroup,
      isTranslateLabels: isTranslateLabels,
      label: label,
      disabled: keysDisabled,
      groupnName: label,
      value: selectedId,
      options: options,
      onChange: function onChange(v, e) {
        handleSelect(options.findIndex(function (o) {
          return (0,utils_select/* getOptionKey */._)(o) === v;
        }), indexGroup, e);
      },
      hideRadio: !withRadio,
      searchValue: searchValue
    });
  };

  return /*#__PURE__*/react.createElement(Select_SelectBody, {
    ref: ref,
    className: className,
    labels: labels,
    options: options,
    slotsAfterOptions: slotsAfterOptions,
    renderGroup: renderGroup
  });
});
SelectBodyTypeRadioButton.propTypes = {
  className: (prop_types_default()).string,
  withRadio: (prop_types_default()).bool,
  isTranslateLabels: (prop_types_default()).bool,
  value: prop_types_default().oneOfType([(prop_types_default()).array, (prop_types_default()).object, (prop_types_default()).string, (prop_types_default()).number]),
  labels: (prop_types_default()).array,
  keysDisabled: (prop_types_default()).array,
  searchValue: (prop_types_default()).string,
  options: (prop_types_default()).array,
  onSelect: (prop_types_default()).func
};
/* harmony default export */ var Select_SelectBodyTypeRadioButton = (SelectBodyTypeRadioButton);

/***/ }),

/***/ 80800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _SelectBodyTypeRadioButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26930);
/* harmony import */ var _DropDown_DropDownVariantButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12346);
/* harmony import */ var _utils_select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48018);
var _excluded = ["showArrow", "withRadio", "options", "label", "value", "placeholder", "onChange", "buttonProps", "labels", "parentNode", "boundaryRect", "isTranslateLabels"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var SelectVariantButton = function SelectVariantButton(_ref) {
  var _ref2, _options$find;

  var _ref$showArrow = _ref.showArrow,
      showArrow = _ref$showArrow === void 0 ? true : _ref$showArrow,
      withRadio = _ref.withRadio,
      options = _ref.options,
      label = _ref.label,
      value = _ref.value,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      buttonProps = _ref.buttonProps,
      labels = _ref.labels,
      parentNode = _ref.parentNode,
      boundaryRect = _ref.boundaryRect,
      isTranslateLabels = _ref.isTranslateLabels,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var handleChange = function handleChange(item, indexOption, indexGroup) {
    onChange((0,_utils_select__WEBPACK_IMPORTED_MODULE_4__/* .getOptionKey */ ._)(Array.isArray(item) ? item[indexGroup] : item), indexGroup);
  };

  var key = (0,_utils_select__WEBPACK_IMPORTED_MODULE_4__/* .getOptionKey */ ._)(value);
  var labelOptionActive = (_ref2 = label !== null && label !== void 0 ? label : (_options$find = options.find(function (o) {
    return (0,_utils_select__WEBPACK_IMPORTED_MODULE_4__/* .getOptionKey */ ._)(o) === key;
  })) === null || _options$find === void 0 ? void 0 : _options$find.label) !== null && _ref2 !== void 0 ? _ref2 : placeholder;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_DropDown_DropDownVariantButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _extends({
    showArrow: showArrow,
    buttonProps: buttonProps,
    label: labelOptionActive,
    parentNode: parentNode,
    boundaryRect: boundaryRect
  }, restProps), function (_ref3) {
    var hide = _ref3.hide;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SelectBodyTypeRadioButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      withRadio: withRadio,
      isTranslateLabels: isTranslateLabels,
      labels: labels,
      options: options,
      value: value,
      onSelect: function onSelect(item, indexOption, indexGroup, e) {
        handleChange(item, indexOption, indexGroup);
        hide(e);
      }
    });
  });
};

SelectVariantButton.propTypes = {
  options: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().array),
  value: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().any),
  onChange: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onClick: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  containerStyle: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectVariantButton);

/***/ }),

/***/ 67367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _DropDown_DropDown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68551);
/* harmony import */ var _SelectBodyTypeRadioButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26930);
/* harmony import */ var _Typography_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21766);
/* harmony import */ var _Input_Input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38081);
/* harmony import */ var _ArrowIcon_ArrowIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93588);
/* harmony import */ var _utils_select__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48018);
/* harmony import */ var _utils_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97993);
/* harmony import */ var _SelectVariantInput_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85829);
/* harmony import */ var _SelectVariantInput_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_SelectVariantInput_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78889);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }













var SelectVariantInput = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var _options$find;

  var isParseValueToPrimitiveOnChange = _ref.isParseValueToPrimitiveOnChange,
      _ref$withArrow = _ref.withArrow,
      withArrow = _ref$withArrow === void 0 ? false : _ref$withArrow,
      options = _ref.options,
      value = _ref.value,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      parentNode = _ref.parentNode,
      label = _ref.label,
      onHide = _ref.onHide,
      searchValue = _ref.searchValue,
      _ref$isWidthBasedOnIn = _ref.isWidthBasedOnInput,
      isWidthBasedOnInput = _ref$isWidthBasedOnIn === void 0 ? true : _ref$isWidthBasedOnIn,
      _ref$isJustifyEnd = _ref.isJustifyEnd,
      isJustifyEnd = _ref$isJustifyEnd === void 0 ? false : _ref$isJustifyEnd,
      popupProps = _ref.popupProps,
      inputProps = _ref.inputProps;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      instanceRoot = _useState2[0],
      setInstanceRoot = _useState2[1];

  var refRadioGroup = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var handleChange = function handleChange(value, index) {
    if (instanceRoot) {
      instanceRoot.hide();
    }

    if (value) {
      onChange(isParseValueToPrimitiveOnChange ? (0,_utils_select__WEBPACK_IMPORTED_MODULE_9__/* .getOptionKey */ ._)(value) : value, index);
    }
  };

  var handleInputKeyDown = function handleInputKeyDown(e) {
    (0,_utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_8__/* .handleKeyDownNavigation */ .OB)(refRadioGroup.current, e, false, false);
  };

  var key = (0,_utils_select__WEBPACK_IMPORTED_MODULE_9__/* .getOptionKey */ ._)(value);
  var labelOptionActive = (options === null || options === void 0 ? void 0 : (_options$find = options.find(function (o) {
    return (0,_utils_select__WEBPACK_IMPORTED_MODULE_9__/* .getOptionKey */ ._)(o) === key;
  })) === null || _options$find === void 0 ? void 0 : _options$find.label) || (value === null || value === void 0 ? void 0 : value.label);
  var handleRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (el) {
    (0,_utils_react__WEBPACK_IMPORTED_MODULE_10__/* .handleReactRef */ .q)(ref, el);
    setInstanceRoot(el);
  }, [ref]);
  var isInputReadOnly = !inputProps || !("readOnly" in inputProps) || inputProps.readOnly;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_DropDown_DropDown__WEBPACK_IMPORTED_MODULE_3__["default"], {
    ref: handleRef,
    noPortal: true,
    isMinWidthBasedOnButton: true,
    isMaxWidthBasedOnButton: isWidthBasedOnInput,
    toggleOnClickButton: isInputReadOnly,
    focusOnBecameVisible: isInputReadOnly,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_SelectVariantInput_module_scss__WEBPACK_IMPORTED_MODULE_11___default().root), isJustifyEnd ? (_SelectVariantInput_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["justify-end"]) : ""),
    disabled: disabled,
    boundaryRect: parentNode === null || parentNode === void 0 ? void 0 : parentNode.getBoundingClientRect(),
    popupProps: _objectSpread({
      contentProps: {
        className: (_SelectVariantInput_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["popup-content"])
      },
      hideOnScroll: false,
      usePositionAbsolute: true
    }, popupProps),
    onHide: onHide,
    button: function button(_ref2) {
      var show = _ref2.show,
          onClick = _ref2.onClick;
      var slotAfterInput = withArrow ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ArrowIcon_ArrowIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        direction: show ? _ArrowIcon_ArrowIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"].direction.DOWN */ .Z.direction.DOWN : _ArrowIcon_ArrowIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"].direction.RIGHT */ .Z.direction.RIGHT
      }) : undefined;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        variant: _Typography_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"].variant.body2 */ .Z.variant.body2,
        color: disabled ? _Typography_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"].color.iconDisabled */ .Z.color.iconDisabled : undefined
      }, label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Input_Input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, _extends({
        disabled: disabled,
        active: show,
        value: labelOptionActive,
        onChange: function onChange() {} // temporary, to prevent React error in console.
        ,
        className: (_SelectVariantInput_module_scss__WEBPACK_IMPORTED_MODULE_11___default().input),
        onClick: onClick,
        onKeyDown: handleInputKeyDown,
        slotAfter: slotAfterInput
      }, inputProps, {
        readOnly: isInputReadOnly
      })));
    },
    body: function body(_ref3) {
      var hide = _ref3.hide;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SelectBodyTypeRadioButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        ref: refRadioGroup,
        value: value,
        searchValue: searchValue,
        options: options,
        onSelect: function onSelect(item, indexOption, indexGroup, e) {
          handleChange(item, indexOption, indexGroup);
          hide(e);
        }
      });
    }
  });
});
SelectVariantInput.propTypes = {
  options: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array),
  value: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().object), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)]),
  onChange: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  parentNode: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().any),
  label: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  disabled: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  withArrow: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  isWidthBasedOnInput: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectVariantInput);

/***/ }),

/***/ 4234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95524);
/* harmony import */ var _Portal_Portal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64976);
/* harmony import */ var _Scroll_Scroll__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95793);
/* harmony import */ var _hooks_useFocus__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47630);
/* harmony import */ var _utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78889);
/* harmony import */ var _shared_hooks_useRegulateGlobalClassNameIsAnyPopupLikeWindowOpened__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59730);
/* harmony import */ var _shared_hooks_useLockBodyScroll__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77706);
/* harmony import */ var _Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(265);
/* harmony import */ var _SidePanel_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39513);
/* harmony import */ var _SidePanel_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_SidePanel_module_scss__WEBPACK_IMPORTED_MODULE_10__);
var _excluded = ["isUseLockBodyScroll", "isHiddenByCSS", "focusOnBecameOpen", "isOpen", "preventCoverHeader", "onClose", "className", "children", "side", "contentProps", "backdropProps"],
    _excluded2 = ["className", "tag"],
    _excluded3 = ["className"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }













var SidePanel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (_ref, ref) {
  var _classnames;

  var isUseLockBodyScroll = _ref.isUseLockBodyScroll,
      _ref$isHiddenByCSS = _ref.isHiddenByCSS,
      isHiddenByCSS = _ref$isHiddenByCSS === void 0 ? false : _ref$isHiddenByCSS,
      _ref$focusOnBecameOpe = _ref.focusOnBecameOpen,
      focusOnBecameOpen = _ref$focusOnBecameOpe === void 0 ? true : _ref$focusOnBecameOpe,
      isOpen = _ref.isOpen,
      _ref$preventCoverHead = _ref.preventCoverHeader,
      preventCoverHeader = _ref$preventCoverHead === void 0 ? true : _ref$preventCoverHead,
      onClose = _ref.onClose,
      className = _ref.className,
      children = _ref.children,
      side = _ref.side,
      contentProps = _ref.contentProps,
      backdropProps = _ref.backdropProps,
      rootProps = _objectWithoutProperties(_ref, _excluded);

  var contentClassName = contentProps.className,
      _contentProps$tag = contentProps.tag,
      Tag = _contentProps$tag === void 0 ? _Scroll_Scroll__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z : _contentProps$tag,
      contentRestProps = _objectWithoutProperties(contentProps, _excluded2);

  var backdropClassName = backdropProps.className,
      backdropRestProps = _objectWithoutProperties(backdropProps, _excluded3);

  var refElRoot = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var refFinal = ref !== null && ref !== void 0 ? ref : refElRoot;
  (0,_shared_hooks_useLockBodyScroll__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(!!(isUseLockBodyScroll && isOpen));
  (0,_hooks_useFocus__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(focusOnBecameOpen && isOpen, refFinal);
  (0,_shared_hooks_useRegulateGlobalClassNameIsAnyPopupLikeWindowOpened__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(!!isOpen);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      headerHeight = _useState2[0],
      setHeaderHeight = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _document$querySelect;

    setHeaderHeight((_document$querySelect = document.querySelector("header")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetHeight);
  }, []);

  if (!isOpen && !isHiddenByCSS) {
    return null;
  }

  var propsContentOptional;

  if (Tag === _Scroll_Scroll__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z) {
    propsContentOptional = {
      hasStaticPosition: true,
      style: _objectSpread({
        width: undefined
      }, contentProps === null || contentProps === void 0 ? void 0 : contentProps.style)
    };
  }

  var handleKeyDownRoot = function handleKeyDownRoot(e) {
    if (isOpen && onClose) {
      (0,_utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_7__/* .handleKeyDownExitFloatWindow */ .IB)(e, onClose);
    }
  };

  var jsxPanel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({
    ref: refFinal,
    tabIndex: 1,
    onKeyDown: handleKeyDownRoot,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_SidePanel_module_scss__WEBPACK_IMPORTED_MODULE_10___default().root), className, (_SidePanel_module_scss__WEBPACK_IMPORTED_MODULE_10___default())[side], (_classnames = {}, _defineProperty(_classnames, (_SidePanel_module_scss__WEBPACK_IMPORTED_MODULE_10___default().open), isOpen), _defineProperty(_classnames, (_SidePanel_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["prevent-cover-header"]), preventCoverHeader), _classnames))
  }, rootProps, {
    style: _objectSpread(_objectSpread({}, rootProps.style), {}, {
      "--height-header": headerHeight + "px"
    })
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, _extends({
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_SidePanel_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content), contentClassName)
  }, contentRestProps, propsContentOptional), children), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _extends({
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_SidePanel_module_scss__WEBPACK_IMPORTED_MODULE_10___default().backdrop), backdropClassName),
    onClick: onClose
  }, backdropRestProps)));

  if (isHiddenByCSS) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "hidden",
      id: isHiddenByCSS
    }, jsxPanel);
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Portal_Portal__WEBPACK_IMPORTED_MODULE_4__["default"], {
    id: _Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_11__/* .EL_ID_PORTAL_MAIN_AFTER */ .t
  }, jsxPanel);
});
SidePanel.defaultProps = {
  side: "left",
  contentProps: {},
  backdropProps: {}
};
SidePanel.propTypes = {
  isOpen: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  positionFixed: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  preventCoverHeader: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1__.node,
  className: prop_types__WEBPACK_IMPORTED_MODULE_1__.string,
  side: prop_types__WEBPACK_IMPORTED_MODULE_1__.string,
  contentProps: prop_types__WEBPACK_IMPORTED_MODULE_1__.object,
  backdropProps: prop_types__WEBPACK_IMPORTED_MODULE_1__.object
};
/* harmony default export */ __webpack_exports__["Z"] = (SidePanel);

/***/ }),

/***/ 26309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _IconView_IconView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20844);
/* harmony import */ var _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59034);
/* harmony import */ var _hooks_useRefData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40462);
/* harmony import */ var _utils_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97993);
/* harmony import */ var _SwipeArrows_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34625);
/* harmony import */ var _SwipeArrows_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_SwipeArrows_module_scss__WEBPACK_IMPORTED_MODULE_6__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








var SwipeArrows = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      isCanShowArrowLeft = _ref.isCanShowArrowLeft,
      isCanShowArrowRight = _ref.isCanShowArrowRight,
      onClickArrowLeft = _ref.onClickArrowLeft,
      onClickArrowRight = _ref.onClickArrowRight,
      isUseLogicOfLeavingHoveredShown = _ref.isUseLogicOfLeavingHoveredShown;
  var refIdTimeoutHideArrowsAfterScrolled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(undefined);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isShowArrowsAfterScrolled = _useState2[0],
      setIsShowArrowsAfterScrolled = _useState2[1];

  var refData = (0,_hooks_useRefData__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    isShowArrowsAfterScrolled: isShowArrowsAfterScrolled
  });

  var _autoHideArrowsAfterScrolled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    refIdTimeoutHideArrowsAfterScrolled.current = setTimeout(function () {
      setIsShowArrowsAfterScrolled(false);
      refIdTimeoutHideArrowsAfterScrolled.current = undefined;
    }, 2500);
  }, []);

  var _cancelHideArrowsAfterScrolled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (refIdTimeoutHideArrowsAfterScrolled.current !== undefined) {
      clearTimeout(refIdTimeoutHideArrowsAfterScrolled.current);
      refIdTimeoutHideArrowsAfterScrolled.current = undefined;
    }
  }, []);

  var showArrowsWithAutoHide = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    _cancelHideArrowsAfterScrolled();

    if (!refData.current.isShowArrowsAfterScrolled) {
      setIsShowArrowsAfterScrolled(true);
    }

    _autoHideArrowsAfterScrolled();
  }, [_cancelHideArrowsAfterScrolled, _autoHideArrowsAfterScrolled]);
  var interfaceRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      showArrowsWithAutoHide: showArrowsWithAutoHide
    };
  }, [showArrowsWithAutoHide]);
  (0,_utils_react__WEBPACK_IMPORTED_MODULE_5__/* .handleReactRef */ .q)(ref, interfaceRef);

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isHoveredArrowLeft = _useState4[0],
      setIsHoveredArrowLeft = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isHoveredArrowRight = _useState6[0],
      setIsHoveredArrowRight = _useState6[1];

  var handleMouseEnterArrow = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (isArrowRight) {
    if (!isUseLogicOfLeavingHoveredShown) {
      return;
    }

    if (isArrowRight) {
      setIsHoveredArrowRight(true);
    } else {
      setIsHoveredArrowLeft(true);
    }
  }, [isUseLogicOfLeavingHoveredShown]);
  var handleMouseLeaveArrow = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (isArrowRight) {
    if (!isUseLogicOfLeavingHoveredShown) {
      return;
    }

    if (isArrowRight) {
      setIsHoveredArrowRight(false);
    } else {
      setIsHoveredArrowLeft(false);
    }
  }, [isUseLogicOfLeavingHoveredShown]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_SwipeArrows_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["swipe-arrows"]), className)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_SwipeArrows_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inner)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_SwipeArrows_module_scss__WEBPACK_IMPORTED_MODULE_6___default().arrow), (_SwipeArrows_module_scss__WEBPACK_IMPORTED_MODULE_6___default().prev), _defineProperty({}, (_SwipeArrows_module_scss__WEBPACK_IMPORTED_MODULE_6___default().shown), isShowArrowsAfterScrolled && isCanShowArrowLeft || isHoveredArrowLeft)),
    onClick: onClickArrowLeft,
    onMouseEnter: function onMouseEnter() {
      return handleMouseEnterArrow(false);
    },
    onMouseLeave: function onMouseLeave() {
      return handleMouseLeaveArrow(false);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconView_IconView__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    icon: _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_3__/* ["default"]["chevron-left"] */ .Z["chevron-left"]
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_SwipeArrows_module_scss__WEBPACK_IMPORTED_MODULE_6___default().arrow), (_SwipeArrows_module_scss__WEBPACK_IMPORTED_MODULE_6___default().next), _defineProperty({}, (_SwipeArrows_module_scss__WEBPACK_IMPORTED_MODULE_6___default().shown), isShowArrowsAfterScrolled && isCanShowArrowRight || isHoveredArrowRight)),
    onClick: onClickArrowRight,
    onMouseEnter: function onMouseEnter() {
      return handleMouseEnterArrow(true);
    },
    onMouseLeave: function onMouseLeave() {
      return handleMouseLeaveArrow(true);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconView_IconView__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    icon: _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_3__/* ["default"]["chevron-left"] */ .Z["chevron-left"]
  }))));
});
/* harmony default export */ __webpack_exports__["Z"] = (SwipeArrows);

/***/ }),

/***/ 60914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_swipeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57321);
/* harmony import */ var react_swipeable__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_swipeable__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97993);
var _excluded = ["children", "className", "style", "onClick", "onMouseMove", "onTouchStart", "onTouchEnd", "onTouchCancel", "onTouchMove", "onScroll", "dataAttrs", "tag"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Swipeable = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, _ref) {
  var children = props.children,
      className = props.className,
      style = props.style,
      onClick = props.onClick,
      onMouseMove = props.onMouseMove,
      onTouchStart = props.onTouchStart,
      onTouchEnd = props.onTouchEnd,
      onTouchCancel = props.onTouchCancel,
      onTouchMove = props.onTouchMove,
      onScroll = props.onScroll,
      dataAttrs = props.dataAttrs,
      _props$tag = props.tag,
      Tag = _props$tag === void 0 ? "div" : _props$tag,
      hookProps = _objectWithoutProperties(props, _excluded);

  var handlers = (0,react_swipeable__WEBPACK_IMPORTED_MODULE_2__.useSwipeable)(_objectSpread({}, hookProps));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, _extends({
    ref: function ref(el) {
      (0,_utils_react__WEBPACK_IMPORTED_MODULE_3__/* .handleReactRef */ .q)(_ref, el);
      handlers.ref(el);
    },
    className: className,
    style: style,
    onClick: onClick,
    onScroll: onScroll,
    onMouseMove: onMouseMove,
    onTouchStart: onTouchStart,
    onTouchEnd: onTouchEnd,
    onTouchCancel: onTouchCancel,
    onTouchMove: onTouchMove
  }, dataAttrs), children);
});
Swipeable.propTypes = {
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Swipeable);

/***/ }),

/***/ 94034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vn": function() { return /* binding */ TAB_VARIANT; },
/* harmony export */   "qJ": function() { return /* binding */ TAB_SIZE; },
/* harmony export */   "yv": function() { return /* binding */ TAB_COLOR; }
/* harmony export */ });
var TAB_VARIANT = {
  underlined: "underlined",
  tabLike: "tab-like"
};
var TAB_SIZE = {
  sm: "sm"
};
var TAB_COLOR = {
  primary: "primary",
  dark: "dark",
  searchSectionPrimary: "search-section-primary"
};

/***/ }),

/***/ 52296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48081);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _shared_components_Button_Ripple__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22168);
/* harmony import */ var _shared_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58114);
/* harmony import */ var _shared_components_LongPressWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40654);
/* harmony import */ var _shared_what_input_useWhatInput__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83951);
/* harmony import */ var _Tab_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94034);
/* harmony import */ var _Tab_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92289);
/* harmony import */ var _Tab_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Tab_module_scss__WEBPACK_IMPORTED_MODULE_9__);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var DelayDoubleClick = 300;

var Tab = function Tab(_ref) {
  var _classNames;

  var className = _ref.className,
      classNameActive = _ref.classNameActive,
      number = _ref.number,
      isLocked = _ref.isLocked,
      isSelected = _ref.isSelected,
      isActive = _ref.isActive,
      variant = _ref.variant,
      size = _ref.size,
      color = _ref.color,
      onSelect = _ref.onSelect,
      onLock = _ref.onLock,
      children = _ref.children;

  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_2__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  var _useTooltipContext = (0,_shared_components__WEBPACK_IMPORTED_MODULE_5__/* .useTooltipContext */ .nr)(),
      showTooltip = _useTooltipContext.showTooltip;

  var isLastPointerMouse = (0,_shared_what_input_useWhatInput__WEBPACK_IMPORTED_MODULE_7__/* .useWhatInputIsLastPointerMouse */ .a)();
  var refTimestampLastClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
  var refIdTimerDoubleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(undefined);

  var checkDoubleClick = function checkDoubleClick() {
    if (refTimestampLastClick.current === 0) {
      refTimestampLastClick.current = Date.now();
    }

    var currentClickTime = Date.now();
    var lastClickTime = refTimestampLastClick.current;
    refTimestampLastClick.current = currentClickTime;
    var timeOffset = currentClickTime - lastClickTime;
    return timeOffset > 0 && timeOffset <= DelayDoubleClick;
  };

  var handleClick = function handleClick(e) {
    if (onLock) {
      if (!refIdTimerDoubleClick.current) {
        refIdTimerDoubleClick.current = setTimeout(function () {
          onSelect(e);
          refIdTimerDoubleClick.current = undefined;
        }, DelayDoubleClick);
      }

      if (checkDoubleClick()) {
        clearTimeout(refIdTimerDoubleClick.current);
        refIdTimerDoubleClick.current = undefined;
        onLock(e);
      }
    } else {
      onSelect(e);
    }
  };

  var showLockTooltip = function showLockTooltip(e) {
    var hint = isLocked ? "unlockColumnHint" : "lockColumnHint";
    showTooltip(t(hint), e);
  };

  var longPressListeners = (0,_shared_components_LongPressWrapper__WEBPACK_IMPORTED_MODULE_6__/* .useLongPress */ .T)({
    onLongPress: showLockTooltip,
    onClick: handleClick,
    onContextMenu: showLockTooltip
  });
  var ariaLabel = typeof children === "string" ? children : "";
  var isActiveFinal = isSelected || isActive;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", _extends({
    tabIndex: -1,
    role: "tab",
    "aria-label": ariaLabel ? t("tabLabel", {
      label: ariaLabel
    }) : undefined,
    "aria-selected": isSelected ? "true" : "false",
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_Tab_module_scss__WEBPACK_IMPORTED_MODULE_9___default().tab), "tab-default", className, (_Tab_module_scss__WEBPACK_IMPORTED_MODULE_9___default())[size], (_Tab_module_scss__WEBPACK_IMPORTED_MODULE_9___default())[variant], (_Tab_module_scss__WEBPACK_IMPORTED_MODULE_9___default())[color], (_classNames = {}, _defineProperty(_classNames, classNameActive, isActiveFinal), _defineProperty(_classNames, (_Tab_module_scss__WEBPACK_IMPORTED_MODULE_9___default().active), isActiveFinal), _defineProperty(_classNames, (_Tab_module_scss__WEBPACK_IMPORTED_MODULE_9___default().locked), isLocked), _classNames)),
    onClick: handleClick
  }, longPressListeners, {
    onMouseEnter: isLastPointerMouse && onLock ? showLockTooltip : undefined
  }), children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Button_Ripple__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, null));
};

Tab.variant = _Tab_constants__WEBPACK_IMPORTED_MODULE_8__/* .TAB_VARIANT */ .Vn;
Tab.size = _Tab_constants__WEBPACK_IMPORTED_MODULE_8__/* .TAB_SIZE */ .qJ;
Tab.color = _Tab_constants__WEBPACK_IMPORTED_MODULE_8__/* .TAB_COLOR */ .yv;
Tab.defaultProps = {
  variant: _Tab_constants__WEBPACK_IMPORTED_MODULE_8__/* .TAB_VARIANT.underlined */ .Vn.underlined,
  color: _Tab_constants__WEBPACK_IMPORTED_MODULE_8__/* .TAB_COLOR.primary */ .yv.primary
};
Tab.propTypes = {
  variant: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOf(Object.values(_Tab_constants__WEBPACK_IMPORTED_MODULE_8__/* .TAB_VARIANT */ .Vn)),
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOf(Object.values(_Tab_constants__WEBPACK_IMPORTED_MODULE_8__/* .TAB_SIZE */ .qJ)),
  color: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOf(Object.values(_Tab_constants__WEBPACK_IMPORTED_MODULE_8__/* .TAB_COLOR */ .yv))
};
/* harmony default export */ __webpack_exports__["Z"] = (Tab);

/***/ }),

/***/ 78329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Tabs_TabBar; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../shared/contexts/TranslateContext.js
var TranslateContext = __webpack_require__(48081);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../shared/components/Tabs/Tab/Tab.js
var Tab = __webpack_require__(52296);
// EXTERNAL MODULE: ../shared/components/Divider/DividerVertical.module.scss
var DividerVertical_module = __webpack_require__(20122);
var DividerVertical_module_default = /*#__PURE__*/__webpack_require__.n(DividerVertical_module);
;// CONCATENATED MODULE: ../shared/components/Divider/DividerVertical.js





var DividerVertical = function DividerVertical(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((DividerVertical_module_default()).root, className)
  });
};

DividerVertical.propTypes = {
  className: (prop_types_default()).string
};
/* harmony default export */ var Divider_DividerVertical = (DividerVertical);
// EXTERNAL MODULE: ../shared/utils/select.js
var utils_select = __webpack_require__(48018);
// EXTERNAL MODULE: ../shared/components/Tabs/Tab/Tab.constants.js
var Tab_constants = __webpack_require__(94034);
// EXTERNAL MODULE: ../shared/utils/keyboard-navigation/keyboard-navigation.js
var keyboard_navigation = __webpack_require__(78889);
// EXTERNAL MODULE: ../shared/components/Tabs/TabBar.module.scss
var TabBar_module = __webpack_require__(2561);
var TabBar_module_default = /*#__PURE__*/__webpack_require__.n(TabBar_module);
;// CONCATENATED MODULE: ../shared/components/Tabs/TabBar.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var TabBar = function TabBar(_ref) {
  var _classNames;

  var className = _ref.className,
      activeTabClassName = _ref.activeTabClassName,
      tabClassName = _ref.tabClassName,
      withDividers = _ref.withDividers,
      alignLeft = _ref.alignLeft,
      style = _ref.style,
      current = _ref.current,
      tabVariant = _ref.tabVariant,
      tabSize = _ref.tabSize,
      tabColor = _ref.tabColor,
      options = _ref.options,
      onSelectTab = _ref.onSelectTab,
      onLockTab = _ref.onLockTab;

  var _useSharedTranslation = (0,TranslateContext/* useSharedTranslation */.G)(),
      t = _useSharedTranslation.t;

  var refRoot = (0,react.useRef)();

  var handleKeyDown = function handleKeyDown(e) {
    return (0,keyboard_navigation/* handleKeyDownNavigation */.OB)(refRoot.current, e);
  };

  return /*#__PURE__*/react.createElement("div", {
    ref: refRoot,
    tabIndex: 0,
    role: "tablist",
    className: classnames_default()(className, (TabBar_module_default()).root, "tab-wrap", (_classNames = {}, _defineProperty(_classNames, (TabBar_module_default())["align-left"], alignLeft), _defineProperty(_classNames, (TabBar_module_default())["tab-size-sm"], tabSize === Tab_constants/* TAB_SIZE.sm */.qJ.sm), _classNames)),
    style: style,
    onKeyDown: handleKeyDown
  }, options.map(function (item, index) {
    var key = (0,utils_select/* getOptionKey */._)(item);
    var isLocked = item.isLocked,
        isActive = item.isActive;
    var isSelected = key === current;
    var jsxTab = /*#__PURE__*/react.createElement(Tab/* default */.Z, {
      className: tabClassName,
      classNameActive: activeTabClassName,
      number: index + 1,
      isActive: isActive,
      isLocked: isLocked,
      isSelected: isSelected,
      variant: tabVariant,
      size: tabSize,
      color: tabColor,
      onSelect: onSelectTab ? function () {
        return onSelectTab(key);
      } : undefined,
      onLock: onLockTab ? function () {
        return onLockTab(key);
      } : undefined
    }, t(item.label));
    return /*#__PURE__*/react.createElement(react.Fragment, {
      key: index
    }, withDividers && index !== 0 && /*#__PURE__*/react.createElement(Divider_DividerVertical, {
      className: (TabBar_module_default()).divider
    }), jsxTab);
  }));
};

TabBar.tabVariant = Tab_constants/* TAB_VARIANT */.Vn;
TabBar.tabSize = Tab_constants/* TAB_SIZE */.qJ;
TabBar.tabColor = Tab_constants/* TAB_COLOR */.yv;
TabBar.defaultProps = {
  tabVariant: Tab_constants/* TAB_VARIANT.underlined */.Vn.underlined
};
TabBar.propTypes = {
  className: (prop_types_default()).string,
  current: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  tabVariant: prop_types_default().oneOf(Object.values(Tab_constants/* TAB_VARIANT */.Vn)),
  tabSize: prop_types_default().oneOf(Object.values(Tab_constants/* TAB_SIZE */.qJ)),
  tabColor: prop_types_default().oneOf(Object.values(Tab_constants/* TAB_COLOR */.yv)),
  style: (prop_types_default()).object,
  options: (prop_types_default()).array,
  onSelectTab: (prop_types_default()).func,
  onLockTab: (prop_types_default()).func
};
/* harmony default export */ var Tabs_TabBar = (TabBar);

/***/ }),

/***/ 70439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _TextField_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53234);
/* harmony import */ var _TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3__);
var _excluded = ["rootClass", "className", "backColor", "textColor", "label", "error", "value", "autoFocus", "disabled", "helperText", "multiline", "rows"];

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var TextField = function TextField(_ref) {
  var _classNames;

  var rootClass = _ref.rootClass,
      className = _ref.className,
      backColor = _ref.backColor,
      textColor = _ref.textColor,
      label = _ref.label,
      error = _ref.error,
      value = _ref.value,
      autoFocus = _ref.autoFocus,
      disabled = _ref.disabled,
      helperText = _ref.helperText,
      multiline = _ref.multiline,
      rows = _ref.rows,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(autoFocus),
      _useState2 = _slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hover = _useState4[0],
      setHover = _useState4[1];

  var isShowPlaceholder = !!label && !focus;

  var renderField = function renderField() {
    if (multiline) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("textarea", _extends({
        "data-focus": autoFocus,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["field-input"]), className),
        style: textColor ? {
          color: textColor
        } : null,
        rows: rows,
        value: value,
        disabled: disabled
      }, rest));
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", _extends({
      "data-focus": autoFocus,
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["field-input"]), className),
      style: textColor ? {
        color: textColor
      } : null,
      value: value,
      disabled: disabled
    }, rest));
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    onFocus: function onFocus() {
      return setFocus(true);
    },
    onBlur: function onBlur() {
      return setFocus(false);
    },
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["field-root"]), (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[rootClass], (_classNames = {}, _defineProperty(_classNames, (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default().disabled), disabled), _defineProperty(_classNames, (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default().focus), focus), _defineProperty(_classNames, (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default().active), value.length), _defineProperty(_classNames, (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default().error), error && !(hover || focus)), _defineProperty(_classNames, (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default().hover), hover && !disabled), _defineProperty(_classNames, (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default().multiline), multiline), _defineProperty(_classNames, (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["with-label"]), !!label), _classNames)),
    style: backColor ? {
      backgroundColor: backColor
    } : null
  }, !!label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
    className: (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["field-label"]),
    "data-label": isShowPlaceholder
  }, label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["field-container"])
  }, renderField(), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("fieldset", {
    className: (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["field-fieldset"])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("legend", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, label)))), !!helperText && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: (_TextField_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["field-helper"])
  }, helperText));
};

TextField.propTypes = {
  type: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  id: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  name: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  label: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  value: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  rootClass: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  backColor: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  textColor: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  helperText: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  disabled: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  autoFocus: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  error: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  multiline: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  rows: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)
};
/* harmony default export */ __webpack_exports__["Z"] = (TextField);

/***/ }),

/***/ 88770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48081);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34412);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75573);
/* harmony import */ var _store_system_selectors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91809);
/* harmony import */ var _store_system_actions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93893);
/* harmony import */ var _utils_copy__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73981);
/* harmony import */ var _utils_multilang_i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54354);
/* harmony import */ var _Toaster_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19892);
/* harmony import */ var _Toaster_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Toaster_module_scss__WEBPACK_IMPORTED_MODULE_9__);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }












var Toaster = function Toaster() {
  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_1__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
  var messages = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_system_selectors__WEBPACK_IMPORTED_MODULE_5__/* .selectorSystemMessages */ .fU);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      stack = _useState2[0],
      setStack = _useState2[1];

  var pushToStack = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (toast) {
    setStack([toast]);
  }, []);
  var removeFromStackById = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (uniqueId) {
    setStack(function (stackOld) {
      return stackOld.filter(function (toast) {
        return toast.uniqueId !== uniqueId;
      });
    });
  }, []); // queue picking logic

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _messages = _slicedToArray(messages, 1),
        firstMessage = _messages[0];

    if (firstMessage !== null && firstMessage !== void 0 && firstMessage.message) {
      var msgFinal = "";

      if (Array.isArray(firstMessage.message)) {
        firstMessage.message.forEach(function (m) {
          msgFinal += (0,_utils_multilang_i18n__WEBPACK_IMPORTED_MODULE_8__/* .tWithPrefixHandler */ .Rs)(t, m);
        });
      } else {
        msgFinal += (0,_utils_multilang_i18n__WEBPACK_IMPORTED_MODULE_8__/* .tWithPrefixHandler */ .Rs)(t, firstMessage.message);
      }

      pushToStack({
        type: firstMessage.type || _constants__WEBPACK_IMPORTED_MODULE_4__/* .TOAST_TYPE.notify */ ["do"].notify,
        message: msgFinal,
        timestampClose: Date.now() + 1000 + (msgFinal ? msgFinal.length * 75 : 0),
        uniqueId: Math.random()
      });
      dispatch(_store_system_actions__WEBPACK_IMPORTED_MODULE_6__/* ._sharedActionsSystem.toastSuccess */ .g.toastSuccess(firstMessage));
    }
  }, [t, pushToStack, messages]); // auto-close logic

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var timeout;
    var toastNextToBeClosed = stack.sort(function (a, b) {
      return b.timestampClose > a.timestampClose ? 1 : -1;
    })[0];

    if (toastNextToBeClosed) {
      timeout = setTimeout(function () {
        setStack(function (stackOld) {
          return stackOld.filter(function (toast) {
            return toast !== toastNextToBeClosed;
          });
        });
      }, toastNextToBeClosed.timestampClose - Date.now());
    }

    return function () {
      clearTimeout(timeout);
    };
  }, [stack]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, stack.map(function (t) {
    var message = t.message,
        type = t.type,
        uniqueId = t.uniqueId;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      key: uniqueId,
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_Toaster_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["toast-view"]), (_Toaster_module_scss__WEBPACK_IMPORTED_MODULE_9___default())[type]),
      dangerouslySetInnerHTML: {
        __html: message
      },
      onClick: function onClick() {
        (0,_utils_copy__WEBPACK_IMPORTED_MODULE_7__/* .copy */ .JG)(message);
        removeFromStackById(uniqueId);
      }
    });
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Toaster);

/***/ }),

/***/ 23853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nr": function() { return /* binding */ useTooltipContext; },
/* harmony export */   "pn": function() { return /* binding */ TooltipProvider; }
/* harmony export */ });
/* unused harmony export TooltipContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TooltipWrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94249);



var TooltipContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
var TooltipProvider = function TooltipProvider(_ref) {
  var children = _ref.children;
  var rootRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var showTooltip = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (rootRef !== null && rootRef !== void 0 && rootRef.current) {
      var _rootRef$current;

      (_rootRef$current = rootRef.current).show.apply(_rootRef$current, arguments);
    }
  }, []);
  var hideTooltip = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (rootRef !== null && rootRef !== void 0 && rootRef.current) {
      rootRef.current.hide();
    }
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TooltipContext.Provider, {
    value: {
      showTooltip: showTooltip,
      hideTooltip: hideTooltip
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TooltipWrap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    ref: rootRef
  }), children);
};
TooltipProvider.propTypes = {
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node)
};
/**
 * @returns {{
 *   showTooltip, hideTooltip,
 * }}
 */

var useTooltipContext = function useTooltipContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(TooltipContext);
};

/***/ }),

/***/ 94249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Tooltip_TooltipWrap; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../shared/components/Typography/Typography.js
var Typography = __webpack_require__(21766);
// EXTERNAL MODULE: ../shared/utils/url/url.js
var url_url = __webpack_require__(59916);
;// CONCATENATED MODULE: ../shared/components/Tooltip/TooltipMessage.js





var TooltipMessage = function TooltipMessage(_ref) {
  var style = _ref.style,
      message = _ref.message,
      onClick = _ref.onClick;

  if ((0,url_url/* containsUrl */.fC)(message)) {
    var parts = message.split(/(https?:\/\/[^\s]+)/g);

    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf("http") > -1) {
        var url = parts[i];
        parts[i] = /*#__PURE__*/react.createElement("a", {
          key: i,
          target: "_blank",
          rel: "noopener noreferrer",
          href: url,
          dangerouslySetInnerHTML: {
            __html: url
          }
        });
      }
    }

    return /*#__PURE__*/react.createElement(Typography/* default */.Z, {
      style: style,
      variant: Typography/* default.variant.body4 */.Z.variant.body4,
      onClick: onClick
    }, parts);
  }

  return /*#__PURE__*/react.createElement(Typography/* default */.Z, {
    style: style,
    variant: Typography/* default.variant.body4 */.Z.variant.body4,
    dangerouslySetInnerHTML: {
      __html: message
    },
    onClick: onClick
  });
};

TooltipMessage.propTypes = {
  message: (prop_types_default()).string,
  className: (prop_types_default()).string
};
/* harmony default export */ var Tooltip_TooltipMessage = (TooltipMessage);
// EXTERNAL MODULE: ../shared/components/Popup/Popup.js
var Popup = __webpack_require__(4701);
// EXTERNAL MODULE: ../shared/components/Tooltip/Tooltip.module.scss
var Tooltip_module = __webpack_require__(4746);
var Tooltip_module_default = /*#__PURE__*/__webpack_require__.n(Tooltip_module);
;// CONCATENATED MODULE: ../shared/components/Tooltip/TooltipWrap.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var INITIAL_STATE = {
  message: null,
  isShown: false,
  target: null,
  targetRect: null,
  parentRect: null,
  allowMoveMouseOnTooltip: false
};
var SHOW_DELAY = 150;

var _resetListener;

var TooltipWrap = /*#__PURE__*/function (_React$Component) {
  _inherits(TooltipWrap, _React$Component);

  var _super = _createSuper(TooltipWrap);

  function TooltipWrap(props) {
    var _this;

    _classCallCheck(this, TooltipWrap);

    _this = _super.call(this, props);
    _this.state = INITIAL_STATE;
    _this.timerRef = undefined;
    _this.rootElementRef = /*#__PURE__*/react.createRef();
    _this.hide = _this.hide.bind(_assertThisInitialized(_this));
    _this.getResetAllListener = _this.getResetAllListener.bind(_assertThisInitialized(_this));
    _this.show = _this.show.bind(_assertThisInitialized(_this));
    return _this;
  } // Pattern of this context saving.


  _createClass(TooltipWrap, [{
    key: "getResetAllListener",
    value: function getResetAllListener() {
      var _this2 = this;

      if (_resetListener === undefined) {
        _resetListener = function _resetListener() {
          _this2.hide();
        };
      }

      return _resetListener;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("popstate", this.getResetAllListener());
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var resetAllListener = this.getResetAllListener();
      resetAllListener();
      window.removeEventListener("popstate", resetAllListener);
    }
  }, {
    key: "show",
    value: function show(message, e, parent, options) {
      var _targetRectCustom,
          _this3 = this;

      var delayTimeout, targetRectCustom, allowMoveMouseOnTooltip;

      if (options) {
        delayTimeout = options.delayTimeout;
        targetRectCustom = options.targetRectCustom;
        allowMoveMouseOnTooltip = options.allowMoveMouseOnTooltip;
      }

      if (delayTimeout === undefined) {
        delayTimeout = SHOW_DELAY;
      }

      this.hide();
      e.persist && e.persist();
      var timerId;
      var target = e.target;
      var targetRect = (_targetRectCustom = targetRectCustom) !== null && _targetRectCustom !== void 0 ? _targetRectCustom : target ? target.getBoundingClientRect() : {};
      var parentRect = parent ? parent.getBoundingClientRect() : undefined;

      var listener = function listener() {
        if (timerId) {
          clearTimeout(timerId);
        } else {
          _this3.hide();
        }
      };

      var listenerOptions = {
        once: true,
        capture: true
      };
      target.addEventListener("mouseleave", listener, listenerOptions);

      var show = function show() {
        _this3.setState({
          isShown: true,
          message: message,
          allowMoveMouseOnTooltip: allowMoveMouseOnTooltip,
          onHide: function onHide() {
            target.removeEventListener("mouseleave", listener, listenerOptions);
          },
          target: target,
          targetRect: targetRect,
          parentRect: parentRect
        });

        target.removeEventListener("mouseleave", listener, listenerOptions);
      };

      if (delayTimeout) {
        timerId = setTimeout(function () {
          timerId = undefined;
          show();
        }, delayTimeout);
        this.timerRef = timerId;
      } else {
        show();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      clearTimeout(this.timerRef);

      if (this.state.onHide) {
        this.state.onHide();
      }

      this.setState(INITIAL_STATE);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          message = _this$state.message,
          isShown = _this$state.isShown,
          target = _this$state.target,
          targetRect = _this$state.targetRect,
          parentRect = _this$state.parentRect,
          allowMoveMouseOnTooltip = _this$state.allowMoveMouseOnTooltip;
      return /*#__PURE__*/react.createElement(Popup["default"], {
        ref: this.rootElementRef,
        className: "tooltip",
        contentProps: {
          className: (Tooltip_module_default()).root
        },
        isShowPointer: true,
        hideOnMouseLeave: true,
        allowMoveMouseOnTooltip: allowMoveMouseOnTooltip,
        isUseLockBodyScroll: false,
        focusOnBecameVisible: false,
        hasBackdrop: false,
        preventCoverHeader: false,
        isShown: isShown,
        anchorEl: target,
        anchorRect: targetRect,
        boundaryRect: parentRect,
        maxHeight: 256,
        onHide: this.hide
      }, /*#__PURE__*/react.createElement(Tooltip_TooltipMessage, {
        message: message
      }));
    }
  }]);

  return TooltipWrap;
}(react.Component);

/* harmony default export */ var Tooltip_TooltipWrap = (TooltipWrap);

/***/ }),

/***/ 69701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JA": function() { return /* binding */ TypographyLetterSpacing; },
/* harmony export */   "XY": function() { return /* binding */ TypographyFontFamily; },
/* harmony export */   "YA": function() { return /* binding */ TypographyAlignToClassNameMap; },
/* harmony export */   "_5": function() { return /* binding */ TypographyAlign; },
/* harmony export */   "_Y": function() { return /* binding */ TypographyVariantToTagMap; },
/* harmony export */   "ae": function() { return /* binding */ TypographyLetterSpacingToClassNameMap; },
/* harmony export */   "aq": function() { return /* binding */ TypographyColor; },
/* harmony export */   "bu": function() { return /* binding */ TypographyVariant; },
/* harmony export */   "e3": function() { return /* binding */ MapTypographyFontFamilyToCN; },
/* harmony export */   "tn": function() { return /* binding */ TypographyColorToCNMap; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75573);
var _MapTypographyFontFam, _TypographyColorToCNM, _TypographyAlignToCla, _TypographyLetterSpac, _TypographyVariantToT;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var TypographyFontFamily = _constants__WEBPACK_IMPORTED_MODULE_0__/* .FontFamily */ .bt;
var MapTypographyFontFamilyToCN = (_MapTypographyFontFam = {}, _defineProperty(_MapTypographyFontFam, TypographyFontFamily.bebas, "bebas"), _defineProperty(_MapTypographyFontFam, TypographyFontFamily.roboto, "roboto"), _MapTypographyFontFam);
var TypographyColor = {
  inherit: "inherit",
  primary: "primary",
  primaryLight: "primary-light",
  gray: "gray",
  iconHover: "icon-hover",
  white: "white",
  formLabelColor: "form-label-color",
  textInactive: "text-inactive",
  textLink: "text-link",
  default: "default",
  iconDisabled: "icon-disabled",
  waterMark: "water-mark",
  searchSectionPrimary: "search-section-primary"
};
var TypographyColorToCNMap = (_TypographyColorToCNM = {}, _defineProperty(_TypographyColorToCNM, TypographyColor.inherit, "inherit"), _defineProperty(_TypographyColorToCNM, TypographyColor.primary, "primary"), _defineProperty(_TypographyColorToCNM, TypographyColor.primaryLight, "primary-light"), _defineProperty(_TypographyColorToCNM, TypographyColor.gray, "gray"), _defineProperty(_TypographyColorToCNM, TypographyColor.white, "white"), _defineProperty(_TypographyColorToCNM, TypographyColor.formLabelColor, "form-label-color"), _defineProperty(_TypographyColorToCNM, TypographyColor.textInactive, "text-inactive"), _defineProperty(_TypographyColorToCNM, TypographyColor.textLink, "text-link"), _defineProperty(_TypographyColorToCNM, TypographyColor.default, "default"), _defineProperty(_TypographyColorToCNM, TypographyColor.iconDisabled, "icon-disabled"), _defineProperty(_TypographyColorToCNM, TypographyColor.iconHover, "icon-hover"), _defineProperty(_TypographyColorToCNM, TypographyColor.waterMark, "water-mark"), _defineProperty(_TypographyColorToCNM, TypographyColor.searchSectionPrimary, "search-section-primary"), _TypographyColorToCNM);
var TypographyAlign = {
  left: "left",
  center: "center",
  right: "right"
};
var TypographyAlignToClassNameMap = (_TypographyAlignToCla = {}, _defineProperty(_TypographyAlignToCla, TypographyAlign.left, "l"), _defineProperty(_TypographyAlignToCla, TypographyAlign.center, "c"), _defineProperty(_TypographyAlignToCla, TypographyAlign.right, "r"), _TypographyAlignToCla);
var TypographyLetterSpacing = {
  big: "big",
  sm: "sm"
};
var TypographyLetterSpacingToClassNameMap = (_TypographyLetterSpac = {}, _defineProperty(_TypographyLetterSpac, TypographyLetterSpacing.big, "ls-big"), _defineProperty(_TypographyLetterSpac, TypographyLetterSpacing.sm, "ls-sm"), _TypographyLetterSpac);
var TypographyVariant = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "subtitle1",
  body1: "body1",
  body2: "body2",
  body3: "body3",
  body4: "body4",
  body5: "body5"
};
var TypographyVariantToTagMap = (_TypographyVariantToT = {}, _defineProperty(_TypographyVariantToT, TypographyVariant.h1, "h1"), _defineProperty(_TypographyVariantToT, TypographyVariant.h2, "h2"), _defineProperty(_TypographyVariantToT, TypographyVariant.h3, "h3"), _defineProperty(_TypographyVariantToT, TypographyVariant.h4, "h4"), _defineProperty(_TypographyVariantToT, TypographyVariant.h5, "h5"), _defineProperty(_TypographyVariantToT, TypographyVariant.h6, "h6"), _defineProperty(_TypographyVariantToT, TypographyVariant.subtitle1, "h3"), _defineProperty(_TypographyVariantToT, TypographyVariant.body1, "p"), _defineProperty(_TypographyVariantToT, TypographyVariant.body2, "p"), _defineProperty(_TypographyVariantToT, TypographyVariant.body3, "p"), _defineProperty(_TypographyVariantToT, TypographyVariant.body4, "span"), _defineProperty(_TypographyVariantToT, TypographyVariant.body5, "span"), _TypographyVariantToT);

/***/ }),

/***/ 21766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69701);
/* harmony import */ var _Typography_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17150);
/* harmony import */ var _Typography_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_4__);
var _excluded = ["tag", "variant", "style", "className", "align", "fontFamily", "color", "clamp", "threeDots", "hoverable", "letterSpacing"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var Typography = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var _classnames;

  var tag = _ref.tag,
      variant = _ref.variant,
      style = _ref.style,
      className = _ref.className,
      align = _ref.align,
      fontFamily = _ref.fontFamily,
      color = _ref.color,
      clamp = _ref.clamp,
      threeDots = _ref.threeDots,
      hoverable = _ref.hoverable,
      letterSpacing = _ref.letterSpacing,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var fontFamilyFinal = fontFamily !== null && fontFamily !== void 0 ? fontFamily : variant !== null && variant !== void 0 && variant.includes("h") || variant !== null && variant !== void 0 && variant.includes("subtitle") ? _Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .MapTypographyFontFamilyToCN.bebas */ .e3.bebas : variant ? _Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .MapTypographyFontFamilyToCN.roboto */ .e3.roboto : "";
  var TagFinal = tag !== null && tag !== void 0 ? tag : variant ? _Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .TypographyVariantToTagMap */ ._Y[variant] : "span";
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TagFinal, _extends({
    style: _objectSpread({
      "--clamp": clamp ? clamp : undefined
    }, style),
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, (_Typography_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), (_Typography_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[fontFamilyFinal], (_Typography_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[variant], color ? (_Typography_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[_Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .TypographyColorToCNMap */ .tn[color]] : undefined, align ? (_Typography_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[_Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .TypographyAlignToClassNameMap */ .YA[align]] : undefined, letterSpacing ? (_Typography_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[_Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .TypographyLetterSpacingToClassNameMap */ .ae[letterSpacing]] : undefined, (_classnames = {}, _defineProperty(_classnames, (_Typography_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["three-dots"]), threeDots), _defineProperty(_classnames, (_Typography_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["line-clamp"]), clamp), _defineProperty(_classnames, (_Typography_module_scss__WEBPACK_IMPORTED_MODULE_4___default().hoverable), hoverable), _classnames))
  }, restProps, {
    ref: ref
  }));
});
Typography.propTypes = {
  tag: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  style: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object),
  threeDots: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  hoverable: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  clamp: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),
  align: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(Object.values(_Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .TypographyAlign */ ._5)),
  fontFamily: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(Object.values(_Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .TypographyFontFamily */ .XY)),
  variant: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(Object.values(_Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .TypographyVariant */ .bu)),
  letterSpacing: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(Object.values(_Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .TypographyLetterSpacing */ .JA)),
  color: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(Object.values(_Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .TypographyColor */ .aq))
};
Typography.align = _Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .TypographyAlign */ ._5;
Typography.fontFamily = _Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .TypographyFontFamily */ .XY;
Typography.variant = _Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .TypographyVariant */ .bu;
Typography.letterSpacing = _Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .TypographyLetterSpacing */ .JA;
Typography.color = _Typography_constants__WEBPACK_IMPORTED_MODULE_3__/* .TypographyColor */ .aq;
/* harmony default export */ __webpack_exports__["Z"] = (Typography);

/***/ }),

/***/ 90499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48081);
/* harmony import */ var _Typography_Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21766);
/* harmony import */ var _Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66636);
/* harmony import */ var _SearchField_SearchField__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50439);
/* harmony import */ var _Input_Input__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38081);
/* harmony import */ var _utils_url_url__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59916);
/* harmony import */ var _utils_select__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48018);
/* harmony import */ var _utils_string_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56332);
/* harmony import */ var _utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78889);
/* harmony import */ var _shared_what_input_useWhatInput__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83951);
/* harmony import */ var _ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87877);
/* harmony import */ var _ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
















var ViewLanguages = function ViewLanguages(_ref) {
  var title = _ref.title,
      isHideCheckbox = _ref.isHideCheckbox,
      isDisabled = _ref.isDisabled,
      renderSlotRightSide = _ref.renderSlotRightSide,
      onClickItem = _ref.onClickItem,
      _onContextMenu = _ref.onContextMenu,
      disableLastItem = _ref.disableLastItem,
      items = _ref.items,
      itemsHighlighted = _ref.itemsHighlighted,
      itemsDisabled = _ref.itemsDisabled,
      itemsChecked = _ref.itemsChecked,
      itemsDefault = _ref.itemsDefault;

  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_3__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var refListItems = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var isLastPointerMouse = (0,_shared_what_input_useWhatInput__WEBPACK_IMPORTED_MODULE_11__/* .useWhatInputIsLastPointerMouse */ .a)();
  var searchValueLowerCase = searchValue.toLowerCase();

  var isItemPassesFilter = function isItemPassesFilter(item) {
    var _item$id, _item$label, _getOptionKey;

    if (!searchValue) {
      return true;
    }

    return ((_item$id = item.id) === null || _item$id === void 0 ? void 0 : _item$id.toLowerCase().includes(searchValueLowerCase)) || ((_item$label = item.label) === null || _item$label === void 0 ? void 0 : _item$label.toLowerCase().includes(searchValueLowerCase)) || ((_getOptionKey = (0,_utils_select__WEBPACK_IMPORTED_MODULE_12__/* .getOptionKey */ ._)(item)) === null || _getOptionKey === void 0 ? void 0 : _getOptionKey.toLowerCase().includes(searchValueLowerCase));
  };

  var isAtLeastOneItemChecked = !!itemsChecked.length;
  var isAtLeastOneItemShown = false;

  var renderItem = function renderItem(item) {
    var _classNames;

    var itemId = (0,_utils_select__WEBPACK_IMPORTED_MODULE_12__/* .getOptionKey */ ._)(item);
    var imageUrl = (0,_utils_url_url__WEBPACK_IMPORTED_MODULE_8__/* .makeLangImage */ .aW)(itemId, true);
    var isChecked = itemsChecked.includes(itemId);
    var isDefault = itemsDefault === null || itemsDefault === void 0 ? void 0 : itemsDefault.includes(itemId);
    var isDisabled = itemsDisabled === null || itemsDisabled === void 0 ? void 0 : itemsDisabled.includes(itemId);
    var isHighlighted = itemsHighlighted === null || itemsHighlighted === void 0 ? void 0 : itemsHighlighted.includes(itemId);
    var isPassesFilter = isItemPassesFilter(item);

    if (isPassesFilter) {
      isAtLeastOneItemShown = true;
    }

    var handleChange = function handleChange(e) {
      onClickItem(e, item, {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isDefault: isDefault,
        isHighlighted: isHighlighted
      });
    };

    var handleKeyDown = function handleKeyDown(e) {
      return (0,_utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_10__/* .handleKeyDownSelectItem */ .nq)(e, handleChange);
    };

    var disableLastChecked = disableLastItem && isChecked && itemsChecked.length === 1;
    var isDisabledFinal = isDisabled || disableLastChecked;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
      key: itemId,
      tabIndex: isDisabledFinal ? undefined : 0 // to be able to perform tab navigation
      ,
      "data-focus": isAtLeastOneItemChecked ? undefined : true,
      "aria-checked": isChecked,
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["lang-sel_item"]), (_classNames = {}, _defineProperty(_classNames, (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["is-default"]), isDefault), _defineProperty(_classNames, (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["is-checked"]), isChecked), _defineProperty(_classNames, (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["is-highlighted"]), isHighlighted), _defineProperty(_classNames, (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["is-disabled"]), isDisabledFinal), _defineProperty(_classNames, (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default().hidden), !isPassesFilter), _classNames)),
      onClick: handleChange,
      onKeyDown: handleKeyDown,
      onContextMenu: function onContextMenu(e) {
        if (_onContextMenu) {
          _onContextMenu(e, item, {
            isDisabled: isDisabled,
            isChecked: isChecked,
            isDefault: isDefault,
            isHighlighted: isHighlighted
          });
        }
      }
    }, !isHideCheckbox && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      isFocusable: false,
      className: (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default().checkbox),
      disabled: isDisabled,
      checked: isChecked,
      partCheck: isDefault,
      onChange: function onChange(value, e) {
        e.stopPropagation();
        handleChange(value);
      }
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
      alt: item.code,
      role: "presentation",
      loading: "lazy",
      className: (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["lang-sel-img"]),
      src: imageUrl,
      onError: function onError(e) {
        if (e.target.src.indexOf("flags") > -1) {
          e.target.src = _utils_url_url__WEBPACK_IMPORTED_MODULE_8__/* .flagPlaceholder */ .HN;
        }
      }
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      className: (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default().label),
      hoverable: true,
      variant: _Typography_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"].variant.body4 */ .Z.variant.body4,
      color: _Typography_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"].color.inherit */ .Z.color.inherit
    }, t(item.label), renderSlotRightSide && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["lang-sel-count"])
    }, renderSlotRightSide(item))));
  };

  var handleKeyDownListItems = function handleKeyDownListItems(e) {
    (0,_utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_10__/* .handleKeyDownNavigation */ .OB)(refListItems.current, e, true);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default().root), _defineProperty({}, (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["is-disabled"]), isDisabled))
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default().head), _defineProperty({}, (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["with-title"]), !!title))
  }, title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default().title)
  }, title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SearchField_SearchField__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    isWithDebounce: true,
    autoFocus: isLastPointerMouse,
    className: (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["wrap-search"]),
    inputClassName: (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default().input),
    value: searchValue,
    size: _Input_Input__WEBPACK_IMPORTED_MODULE_7__/* ["default"].size.small */ .Z.size.small,
    isIconSearchEnabled: false,
    isIconClearVisible: !!searchValue,
    isIconSearchVisible: !searchValue,
    onChange: setSearchValue,
    onInputKeyDown: handleKeyDownListItems,
    onClear: function onClear() {
      return setSearchValue("");
    },
    onInputClick: function onInputClick(event) {
      return event.stopPropagation();
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: refListItems,
    className: (_ViewLanguages_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["wrap-items"]),
    onKeyDown: handleKeyDownListItems
  }, items.map(renderItem), searchValue && !isAtLeastOneItemShown ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    key: "placeholder",
    align: "center",
    variant: "body3",
    color: "text-inactive"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: {
      textTransform: "capitalize"
    }
  }, t("resultsZeroCount")), "\xA0", (0,_utils_string_string__WEBPACK_IMPORTED_MODULE_9__/* .addQuotes */ .XK)(searchValue)) : null));
};

ViewLanguages.propTypes = {
  isDisabled: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  isHideCheckbox: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  title: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  items: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().array.isRequired),
  itemsChecked: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().array.isRequired),
  itemsDisabled: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().array),
  itemsDefault: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().array),
  itemsHighlighted: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().array),
  onClickItem: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func.isRequired),
  onContextMenu: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  renderSlotRightSide: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  disableLastItem: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool)
};
/* harmony default export */ __webpack_exports__["Z"] = (ViewLanguages);

/***/ }),

/***/ 58114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e0": function() { return /* reexport */ ArrowIcon/* default */.Z; },
  "YM": function() { return /* reexport */ Backdrop/* default */.Z; },
  "zx": function() { return /* reexport */ Button/* default */.Z; },
  "hU": function() { return /* reexport */ IconButton/* default */.Z; },
  "mO": function() { return /* reexport */ IconView/* default */.Z; },
  "II": function() { return /* reexport */ Input/* default */.Z; },
  "mm": function() { return /* reexport */ LinkLearnHowToUseApps/* LinkLearnHowToUseApps */.m; },
  "aN": function() { return /* reexport */ Loader["default"]; },
  "ZT": function() { return /* reexport */ Typography/* default */.Z; },
  "nr": function() { return /* reexport */ TooltipContext/* useTooltipContext */.nr; }
});

// UNUSED EXPORTS: Accordion, AdventistContainer, Badge, BadgeOffline, Breadcrumbs, Checkbox, Divider, DropDown, EGWSlider, FeaturedSectionContent, FilterAlphabet, FloatWindow, Logotype, PlayerBehaviourDialog, Popup, Portal, Progress, RadioButton, Scroll, SearchAccordionItem, SearchField, SelectVariantInput, SidePanel, SwipeArrows, Swipeable, Tab, TabBar, TextField, Toaster, TooltipContext, TooltipProvider, TooltipWrap, ViewLanguages, modal

// EXTERNAL MODULE: ../shared/components/Button/Button.js
var Button = __webpack_require__(18170);
// EXTERNAL MODULE: ../shared/components/Button/LinkLearnHowToUseApps.js
var LinkLearnHowToUseApps = __webpack_require__(7360);
// EXTERNAL MODULE: ../shared/components/Button/ThemeButton.js
var ThemeButton = __webpack_require__(33499);
// EXTERNAL MODULE: ../shared/components/Button/Ripple.js
var Ripple = __webpack_require__(22168);
;// CONCATENATED MODULE: ../shared/components/Button/index.js




// EXTERNAL MODULE: ../shared/components/Accordion/Accordion.js
var Accordion = __webpack_require__(76149);
// EXTERNAL MODULE: ../shared/components/AdventistContainer/AdventistContainer.js
var AdventistContainer = __webpack_require__(95804);
// EXTERNAL MODULE: ../shared/components/ArrowIcon/ArrowIcon.js + 1 modules
var ArrowIcon = __webpack_require__(93588);
// EXTERNAL MODULE: ../shared/components/Backdrop/Backdrop.js
var Backdrop = __webpack_require__(95524);
// EXTERNAL MODULE: ../shared/components/Badge/Badge.js
var Badge = __webpack_require__(806);
// EXTERNAL MODULE: ../shared/components/BadgeOffline/BadgeOffline.js
var BadgeOffline = __webpack_require__(70184);
// EXTERNAL MODULE: ../shared/components/Breadcrumbs/BreadCrumbs.js + 6 modules
var BreadCrumbs = __webpack_require__(365);
// EXTERNAL MODULE: ../shared/components/Checkbox/Checkbox.js
var Checkbox = __webpack_require__(66636);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../shared/components/Divider/Divider.module.scss
var Divider_module = __webpack_require__(88478);
var Divider_module_default = /*#__PURE__*/__webpack_require__.n(Divider_module);
;// CONCATENATED MODULE: ../shared/components/Divider/Divider.js



var Divider = function Divider(_ref) {
  var className = _ref.className,
      style = _ref.style;
  return /*#__PURE__*/react.createElement("hr", {
    style: style,
    className: (Divider_module_default()).root + (className ? " " + className : "")
  });
};

Divider.propTypes = {};
/* harmony default export */ var Divider_Divider = ((/* unused pure expression or super */ null && (Divider)));
// EXTERNAL MODULE: ../shared/components/DropDown/DropDown.js + 1 modules
var DropDown = __webpack_require__(68551);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../shared/components/Progress/Progress.js
var Progress = __webpack_require__(17490);
// EXTERNAL MODULE: ../shared/utils/number/number.js
var number = __webpack_require__(50150);
// EXTERNAL MODULE: ../shared/utils/react.js
var utils_react = __webpack_require__(97993);
// EXTERNAL MODULE: ../shared/utils/dom.js
var dom = __webpack_require__(62330);
// EXTERNAL MODULE: ../shared/components/EGWSlider/EGWSlider.module.scss
var EGWSlider_module = __webpack_require__(11289);
var EGWSlider_module_default = /*#__PURE__*/__webpack_require__.n(EGWSlider_module);
;// CONCATENATED MODULE: ../shared/components/EGWSlider/EGWSlider.js
var _excluded = ["value", "step", "isDraggableOnlyThumb", "min", "max", "onChangeCommitted", "thumbClassName", "disabled", "onChange", "className"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }










var preventEvent = function preventEvent(e) {
  e.preventDefault();
};

var EGWSlider = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var value = _ref.value,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      isDraggableOnlyThumb = _ref.isDraggableOnlyThumb,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 0 : _ref$max,
      onChangeCommitted = _ref.onChangeCommitted,
      thumbClassName = _ref.thumbClassName,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var refRoot = (0,react.useRef)(null);
  var refThumb = (0,react.useRef)(null);

  var getSliderBoundingClientRect = function getSliderBoundingClientRect() {
    var sliderRefCurrent = refRoot.current;

    if (sliderRefCurrent) {
      return sliderRefCurrent.getBoundingClientRect();
    }

    return undefined;
  };
  /**
   * @description Calculates slider progress for now based on coordinates from the given event.
   * @type {function(e: MouseEvent | TouchEvent ): (number)}
   */


  var getProgressWithEvent = function getProgressWithEvent(e) {
    var sliderBoundingClientRect = getSliderBoundingClientRect();

    if (sliderBoundingClientRect) {
      var _getEventCoordinates2 = (0,dom/* getEventCoordinates */.DC)(e),
          x = _getEventCoordinates2.x;

      var sliderRelativeCoordinate = x - sliderBoundingClientRect.left;

      if (sliderRelativeCoordinate <= 0) {
        return min;
      }

      var sliderWidth = sliderBoundingClientRect.width;

      if (sliderRelativeCoordinate >= sliderWidth) {
        return max;
      }

      var progressInPercents = Math.ceil(sliderRelativeCoordinate * 100 / sliderWidth);
      var newValue = (max - min) * progressInPercents / 100 + min;
      var extraPoints = newValue % step;
      return (0,number/* clutch */.Cz)(newValue - extraPoints, min, max);
    }

    return value;
  };

  var addSliderMoveListeners = function addSliderMoveListeners() {
    document.addEventListener("mousemove", onThumbMove);
    document.addEventListener("touchmove", onThumbMove, {
      passive: false,
      cancelable: true
    });
    document.addEventListener("mouseup", onMouseReleased);
    document.addEventListener("touchend", onMouseReleased);
  };

  var removeSliderMoveListeners = function removeSliderMoveListeners() {
    document.removeEventListener("mousemove", onThumbMove);
    document.removeEventListener("touchmove", onThumbMove);
    document.removeEventListener("mouseup", onMouseReleased);
    document.removeEventListener("touchend", onMouseReleased);
  };

  var onThumbCapture = isDraggableOnlyThumb ? function (_ref2) {
    var nativeEvent = _ref2.nativeEvent;

    if (onChangeCommitted) {
      onChangeCommitted(nativeEvent, getProgressWithEvent(nativeEvent));
    }

    addSliderMoveListeners();
  } : function () {};
  var onSliderCapture = isDraggableOnlyThumb ? function () {} : function (_ref3) {
    var nativeEvent = _ref3.nativeEvent;
    // prev solution works wrong commiting updates on click and hold
    onChange(nativeEvent, getProgressWithEvent(nativeEvent));
    addSliderMoveListeners();
  };

  var onMouseReleased = function onMouseReleased(e) {
    removeSliderMoveListeners();

    if (onChangeCommitted) {
      onChangeCommitted(e, getProgressWithEvent(e));
    }
  };

  var onThumbMove = function onThumbMove(e) {
    onChange(e, getProgressWithEvent(e));
  };

  var onThumbKeyDown = function onThumbKeyDown(e) {
    var leftArrow = (0,dom/* isEventKey */.WV)(e, dom/* KeyCode.leftArrow */.VD.leftArrow);
    var rightArrow = (0,dom/* isEventKey */.WV)(e, dom/* KeyCode.rightArrow */.VD.rightArrow);
    var upArrow = (0,dom/* isEventKey */.WV)(e, dom/* KeyCode.upArrow */.VD.upArrow);
    var downArrow = (0,dom/* isEventKey */.WV)(e, dom/* KeyCode.downArrow */.VD.downArrow);

    if (leftArrow || downArrow) {
      var newValue = (0,number/* clutch */.Cz)(value - step, min, max);
      onChange(e, newValue);

      if (onChangeCommitted) {
        onChangeCommitted(e, newValue);
      }

      e.preventDefault();
    }

    if (rightArrow || upArrow) {
      var _newValue = (0,number/* clutch */.Cz)(value + step, min, max);

      onChange(e, _newValue);

      if (onChangeCommitted) {
        onChangeCommitted(e, _newValue);
      }

      e.preventDefault();
    }
  };

  (0,react.useEffect)(function () {
    var sliderRefCurrent = refRoot.current;

    if (sliderRefCurrent) {
      sliderRefCurrent.addEventListener("mousedown", preventEvent, {
        passive: false,
        cancelable: true
      });
      sliderRefCurrent.addEventListener("touchstart", preventEvent, {
        passive: false,
        cancelable: true
      });
      sliderRefCurrent.addEventListener("touchmove", preventEvent, {
        passive: false,
        cancelable: true
      });
    }

    var thumbRefCurrent = refThumb.current;

    if (thumbRefCurrent) {
      thumbRefCurrent.addEventListener("mousedown", preventEvent, {
        passive: false,
        cancelable: true
      });
      thumbRefCurrent.addEventListener("touchstart", preventEvent, {
        passive: false,
        cancelable: true
      });
      thumbRefCurrent.addEventListener("touchmove", preventEvent, {
        passive: false,
        cancelable: true
      });
    }

    return function () {
      if (sliderRefCurrent) {
        sliderRefCurrent.removeEventListener("mousedown", preventEvent);
        sliderRefCurrent.removeEventListener("touchstart", preventEvent);
        sliderRefCurrent.removeEventListener("touchmove", preventEvent);
      }

      if (thumbRefCurrent) {
        thumbRefCurrent.removeEventListener("mousedown", preventEvent);
        thumbRefCurrent.removeEventListener("touchstart", preventEvent);
        thumbRefCurrent.removeEventListener("touchmove", preventEvent);
      }
    };
  }, []);
  var handleRef = (0,react.useCallback)(function (instance) {
    (0,utils_react/* handleReactRef */.q)(ref, instance);
    refRoot.current = instance;
  }, [ref]);
  return /*#__PURE__*/react.createElement(Progress/* default */.Z, _extends({
    showThumb: true,
    ref: handleRef,
    className: classnames_default()(className, (EGWSlider_module_default()).root, _defineProperty({}, (EGWSlider_module_default())["draggable-only-thumb"], isDraggableOnlyThumb)),
    value: value,
    min: min,
    max: max,
    disabled: disabled,
    onMouseDown: onSliderCapture,
    onTouchStart: onSliderCapture,
    trackClassName: (EGWSlider_module_default()).track,
    thumbClassName: classnames_default()((EGWSlider_module_default()).thumb, thumbClassName),
    thumbProps: {
      ref: refThumb,
      onMouseDown: onThumbCapture,
      onTouchStart: onThumbCapture,
      onKeyDown: onThumbKeyDown
    }
  }, restProps));
});
EGWSlider.defaultProps = {
  isDraggableOnlyThumb: false,
  thumbClassName: ""
};
EGWSlider.propTypes = {
  value: (prop_types_default()).number,
  step: (prop_types_default()).number,
  min: (prop_types_default()).number,
  max: (prop_types_default()).number,
  className: (prop_types_default()).string,
  thumbClassName: (prop_types_default()).string,
  isDraggableOnlyThumb: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  onChangeCommitted: (prop_types_default()).func,
  onChange: (prop_types_default()).func.isRequired
};
// EXTERNAL MODULE: ../shared/components/FeaturedSectionContent/FeaturedSectionContent.js
var FeaturedSectionContent = __webpack_require__(9237);
// EXTERNAL MODULE: ../shared/components/DropDown/DropDownVariantIconButton.js
var DropDownVariantIconButton = __webpack_require__(26976);
// EXTERNAL MODULE: ../shared/hooks/viewMode.js
var viewMode = __webpack_require__(6569);
// EXTERNAL MODULE: ../shared/assets/EgwWebFont.js
var EgwWebFont = __webpack_require__(59034);
// EXTERNAL MODULE: ../shared/utils/keyboard-navigation/keyboard-navigation.js
var keyboard_navigation = __webpack_require__(78889);
;// CONCATENATED MODULE: ../shared/components/FilterAlphabet/FilterAlphabet.constants.js
var filterAlphabetThreeDotsButtonClassName = "_js-test_alphabet-three-dots";
var filterAlphabetThreeDotsPopupClassName = "_js-test_test_alphabet-three-dots-popup";
// EXTERNAL MODULE: ../shared/components/FilterAlphabet/FilterAlphabet.module.scss
var FilterAlphabet_module = __webpack_require__(23886);
var FilterAlphabet_module_default = /*#__PURE__*/__webpack_require__.n(FilterAlphabet_module);
;// CONCATENATED MODULE: ../shared/components/FilterAlphabet/FilterAlphabet.js
function FilterAlphabet_extends() { FilterAlphabet_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return FilterAlphabet_extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { FilterAlphabet_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function FilterAlphabet_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }












var FilterAlphabet = function FilterAlphabet(_ref) {
  var isHorizontal = _ref.isHorizontal,
      onFilter = _ref.onFilter,
      filter = _ref.filter,
      chars = _ref.chars,
      className = _ref.className;
  var remToPx = (0,viewMode/* useRemToPx */.y)();

  var _useState = (0,react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      elRoot = _useState2[0],
      setElRoot = _useState2[1];

  var refHiddenContent = (0,react.useRef)();
  var sizeAvailable = elRoot ? isHorizontal ? elRoot.offsetWidth : elRoot.offsetHeight : undefined;
  var list = chars.map(function (item, index) {
    return /*#__PURE__*/react.createElement(Button/* default */.Z, {
      key: index,
      tabIndex: index === 0 ? 0 : -1,
      variant: Button/* default.variant.clear */.Z.variant.clear,
      color: Button/* default.color.icon */.Z.color.icon,
      size: Button/* default.size.big */.Z.size.big,
      active: filter === item,
      onClick: function onClick() {
        onFilter(item === filter ? null : item);
      }
    }, item);
  });
  var charHeight = isHorizontal ? remToPx(1.28) : remToPx(1.52);
  var threeDotsBtnHeight = remToPx(1.2);

  var _list$reduce = list.reduce(function (acc, item) {
    acc.listHeight += charHeight;

    if (acc.listHeight > sizeAvailable) {
      acc.hiddenList.push(item);
    } else {
      acc.availableList.push(item);
    }

    return acc;
  }, {
    availableList: [],
    hiddenList: [],
    listHeight: threeDotsBtnHeight
  }),
      availableList = _list$reduce.availableList,
      hiddenList = _list$reduce.hiddenList;

  var handleKeyDownRoot = function handleKeyDownRoot(e) {
    return (0,keyboard_navigation/* handleKeyDownNavigation */.OB)(elRoot, e, true);
  };

  var handleHiddenContentKeyDown = function handleHiddenContentKeyDown(e) {
    var _refHiddenContent$cur;

    (0,keyboard_navigation/* handleKeyDownNavigation */.OB)((_refHiddenContent$cur = refHiddenContent.current) === null || _refHiddenContent$cur === void 0 ? void 0 : _refHiddenContent$cur.view, e, true);
  };

  return /*#__PURE__*/react.createElement("div", {
    ref: setElRoot,
    className: classnames_default()((FilterAlphabet_module_default()).root, className, isHorizontal ? (FilterAlphabet_module_default()).horizontal : (FilterAlphabet_module_default()).vertical),
    onKeyDown: handleKeyDownRoot
  }, /*#__PURE__*/react.createElement("div", {
    className: (FilterAlphabet_module_default()).inner
  }, availableList, !!hiddenList.length && /*#__PURE__*/react.createElement(DropDownVariantIconButton/* default */.Z, {
    className: filterAlphabetThreeDotsButtonClassName,
    icon: EgwWebFont/* default.dots-vertical */.Z["dots-vertical"],
    popupProps: {
      className: filterAlphabetThreeDotsPopupClassName,
      contentProps: {
        ref: refHiddenContent,
        renderView: function renderView(props) {
          return /*#__PURE__*/react.createElement("div", FilterAlphabet_extends({}, props, {
            className: classnames_default()(props.className, (FilterAlphabet_module_default())["popup-inner"]),
            style: _objectSpread(_objectSpread({}, props.style), {}, {
              maxWidth: sizeAvailable - threeDotsBtnHeight
            }),
            onKeyDown: handleHiddenContentKeyDown
          }));
        }
      }
    }
  }, hiddenList)));
};

FilterAlphabet.propTypes = {
  isHorizontal: (prop_types_default()).bool,
  chars: (prop_types_default()).array,
  filter: (prop_types_default()).string,
  onFilter: (prop_types_default()).func,
  className: (prop_types_default()).string
};
/* harmony default export */ var FilterAlphabet_FilterAlphabet = ((/* unused pure expression or super */ null && (FilterAlphabet)));
// EXTERNAL MODULE: ../shared/components/FloatWindow/FloatWindow.js
var FloatWindow = __webpack_require__(56123);
// EXTERNAL MODULE: ../shared/components/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(75448);
// EXTERNAL MODULE: ../shared/components/IconView/IconView.js
var IconView = __webpack_require__(20844);
// EXTERNAL MODULE: ../shared/components/Input/Input.js + 1 modules
var Input = __webpack_require__(38081);
// EXTERNAL MODULE: ../shared/components/Loader/Loader.js + 1 modules
var Loader = __webpack_require__(63975);
// EXTERNAL MODULE: ../shared/components/Logotype/Logotype.js
var Logotype = __webpack_require__(48011);
// EXTERNAL MODULE: ../shared/components/modal/Modal.js + 1 modules
var Modal = __webpack_require__(58411);
// EXTERNAL MODULE: ../shared/components/PlayerBehaviourDialog/PlayerBehaviourDialog.js
var PlayerBehaviourDialog = __webpack_require__(8217);
// EXTERNAL MODULE: ../shared/components/Popup/Popup.js
var Popup = __webpack_require__(4701);
// EXTERNAL MODULE: ../shared/components/Portal/Portal.js
var Portal = __webpack_require__(64976);
// EXTERNAL MODULE: ../shared/components/RadioButton/RadioButton.js + 1 modules
var RadioButton = __webpack_require__(68898);
// EXTERNAL MODULE: ../shared/components/Scroll/Scroll.js
var Scroll = __webpack_require__(95793);
// EXTERNAL MODULE: ../shared/components/SearchAccordionItem/SearchAccordionItem.js
var SearchAccordionItem = __webpack_require__(70889);
// EXTERNAL MODULE: ../shared/components/Select/SelectVariantInput.js
var SelectVariantInput = __webpack_require__(67367);
// EXTERNAL MODULE: ../shared/components/SearchField/SearchField.js
var SearchField = __webpack_require__(50439);
// EXTERNAL MODULE: ../shared/components/SidePanel/SidePanel.js
var SidePanel = __webpack_require__(4234);
// EXTERNAL MODULE: ../shared/components/Swipeable/Swipeable.js
var Swipeable = __webpack_require__(60914);
// EXTERNAL MODULE: ../shared/components/SwipeArrows/SwipeArrows.js
var SwipeArrows = __webpack_require__(26309);
// EXTERNAL MODULE: ../shared/components/Tabs/TabBar.js + 1 modules
var TabBar = __webpack_require__(78329);
// EXTERNAL MODULE: ../shared/components/Tabs/Tab/Tab.js
var Tab = __webpack_require__(52296);
// EXTERNAL MODULE: ../shared/components/TextField/TextField.js
var TextField = __webpack_require__(70439);
// EXTERNAL MODULE: ../shared/components/Toaster/Toaster.js
var Toaster = __webpack_require__(88770);
// EXTERNAL MODULE: ../shared/components/Tooltip/TooltipWrap.js + 1 modules
var TooltipWrap = __webpack_require__(94249);
// EXTERNAL MODULE: ../shared/components/Tooltip/TooltipContext.js
var TooltipContext = __webpack_require__(23853);
// EXTERNAL MODULE: ../shared/components/Typography/Typography.js
var Typography = __webpack_require__(21766);
// EXTERNAL MODULE: ../shared/components/ViewLanguages/ViewLanguages.js
var ViewLanguages = __webpack_require__(90499);
;// CONCATENATED MODULE: ../shared/components/index.js











































/***/ }),

/***/ 91817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ modalMessageClassName; }
/* harmony export */ });
var modalMessageClassName = "js-e2e-modal-content";

/***/ }),

/***/ 58411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ modal_Modal; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../shared/contexts/TranslateContext.js
var TranslateContext = __webpack_require__(48081);
// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(34412);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../shared/components/Backdrop/Backdrop.js
var Backdrop = __webpack_require__(95524);
// EXTERNAL MODULE: ../shared/components/Button/CloseButton/CloseButton.js
var CloseButton = __webpack_require__(72064);
// EXTERNAL MODULE: ../shared/components/Typography/Typography.js
var Typography = __webpack_require__(21766);
// EXTERNAL MODULE: ../shared/components/modal/ModalActions.js
var ModalActions = __webpack_require__(35727);
// EXTERNAL MODULE: ../shared/components/modal/modal.module.scss
var modal_module = __webpack_require__(11302);
var modal_module_default = /*#__PURE__*/__webpack_require__.n(modal_module);
;// CONCATENATED MODULE: ../shared/components/modal/ModalHead.js
var _excluded = ["className"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var classNameRoot = (modal_module_default())["modal-head"];

var ModalHead = function ModalHead(_ref) {
  var className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/react.createElement("div", _extends({
    className: className ? classNameRoot + " " + className : classNameRoot
  }, restProps));
};

/* harmony default export */ var modal_ModalHead = (ModalHead);
// EXTERNAL MODULE: ../shared/contexts/modal.js
var modal = __webpack_require__(26933);
// EXTERNAL MODULE: ../shared/hooks/useLockBodyScroll.js
var useLockBodyScroll = __webpack_require__(77706);
// EXTERNAL MODULE: ../shared/hooks/useFocus.js
var useFocus = __webpack_require__(47630);
// EXTERNAL MODULE: ../shared/hooks/viewMode.js
var viewMode = __webpack_require__(6569);
// EXTERNAL MODULE: ../shared/store/settings/selectors.js
var selectors = __webpack_require__(4787);
// EXTERNAL MODULE: ../shared/utils/settings/constants.js + 1 modules
var constants = __webpack_require__(20467);
// EXTERNAL MODULE: ../shared/utils/keyboard-navigation/keyboard-navigation.js
var keyboard_navigation = __webpack_require__(78889);
// EXTERNAL MODULE: ../shared/components/modal/Modal.constants.js
var Modal_constants = __webpack_require__(91817);
;// CONCATENATED MODULE: ../shared/components/modal/Modal.js
function Modal_extends() { Modal_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Modal_extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




















var Modal = function Modal(_ref) {
  var props = _ref.props,
      onClose = _ref.onClose;
  var dialogId = props.dialogId,
      component = props.component,
      title = props.title,
      message = props.message,
      positiveBtn = props.positiveBtn,
      negativeBtn = props.negativeBtn,
      noCancelable = props.noCancelable,
      className = props.className,
      onConfirm = props.onConfirm,
      onCancel = props.onCancel,
      isYesNo = props.isYesNo,
      confirm = props.confirm,
      translateMessage = props.translateMessage,
      fixBrokenLayoutAfterOpenFullscreenYoutubeVideoOnIpad = props.fixBrokenLayoutAfterOpenFullscreenYoutubeVideoOnIpad;

  var _useSharedTranslation = (0,TranslateContext/* useSharedTranslation */.G)(),
      t = _useSharedTranslation.t;

  var refRoot = (0,react.useRef)(null);
  var remToPx = (0,viewMode/* useRemToPx */.y)();
  var zoom = (0,es/* useSelector */.v9)((0,selectors/* selectorSetting */.K)(constants/* SETTING.zoom.id */.Fy.zoom.id));
  (0,useLockBodyScroll/* default */.Z)(true);
  (0,useFocus/* default */.Z)(true, refRoot);

  var handleKeyDownRoot = function handleKeyDownRoot(e) {
    (0,keyboard_navigation/* handleKeyDownExitFloatWindow */.IB)(e, function () {
      return onClose(dialogId);
    });

    if ((0,keyboard_navigation/* isTryingExitElementByButtonTab */.zf)(refRoot.current, e)) {
      e.preventDefault();
    }
  };

  var styleContent = {},
      propsMessage = {};

  if (confirm) {
    if (zoom < 300) {
      styleContent.width = remToPx(25.5);
    }
  }

  var messageFinal = message ? translateMessage ? typeof message === "function" ? message({
    t: t
  }) : t(message) : message : "";

  if (typeof messageFinal === "string") {
    propsMessage.dangerouslySetInnerHTML = {
      __html: messageFinal
    };
  } else {
    propsMessage.children = messageFinal;
  }

  return /*#__PURE__*/react.createElement("div", {
    ref: refRoot,
    className: (modal_module_default()).modal,
    onClick: function onClick(e) {
      // prevent close float windows (popup, modal, side panel) below
      e.nativeEvent.stopImmediatePropagation();
    },
    onKeyDown: handleKeyDownRoot
  }, /*#__PURE__*/react.createElement("div", {
    className: (modal_module_default())["modal-root"]
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((modal_module_default())["modal-content"], className, _defineProperty({}, (modal_module_default())["no-animation"], fixBrokenLayoutAfterOpenFullscreenYoutubeVideoOnIpad)),
    style: styleContent
  }, /*#__PURE__*/react.createElement("div", {
    className: (modal_module_default())["modal-close-btn"]
  }, /*#__PURE__*/react.createElement(CloseButton/* default */.Z, {
    onClick: function onClick() {
      return onClose(dialogId);
    }
  })), title && /*#__PURE__*/react.createElement(modal_ModalHead, null, /*#__PURE__*/react.createElement(Typography/* default */.Z, {
    className: (modal_module_default()).title,
    variant: "h3"
  }, t(title))), component !== null && component !== void 0 ? component : /*#__PURE__*/react.createElement("div", {
    className: className
  }, /*#__PURE__*/react.createElement(Typography/* default */.Z, Modal_extends({
    variant: "body2",
    className: Modal_constants/* modalMessageClassName */.B
  }, propsMessage))), (onConfirm || onCancel) && /*#__PURE__*/react.createElement(ModalActions/* default */.Z, {
    isYesNo: isYesNo,
    positiveText: positiveBtn,
    negativeText: negativeBtn,
    onClickPositive: function onClickPositive() {
      var confirmReturnValue = onConfirm && onConfirm();

      if (confirmReturnValue || confirmReturnValue === undefined) {
        onClose(dialogId);
      }
    },
    onClickNegative: function onClickNegative() {
      if (onCancel) {
        if (onCancel()) {
          onClose(dialogId);
        }
      } else {
        onClose(dialogId);
      }
    }
  }), /*#__PURE__*/react.createElement("div", {
    className: (modal_module_default()).skirt
  }))), /*#__PURE__*/react.createElement(Backdrop/* default */.Z, {
    className: (modal_module_default()).backdrop,
    onClick: noCancelable ? undefined : function () {
      return onClose(dialogId);
    },
    clickable: !noCancelable
  }));
};

/* harmony default export */ var modal_Modal = (Modal);

/***/ }),

/***/ 35727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48081);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18170);
/* harmony import */ var _ModalActions_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14616);
/* harmony import */ var _ModalActions_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ModalActions_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var ModalActions = function ModalActions(_ref) {
  var className = _ref.className,
      isYesNo = _ref.isYesNo,
      disabled = _ref.disabled,
      positiveText = _ref.positiveText,
      negativeText = _ref.negativeText,
      onClickNegative = _ref.onClickNegative,
      onClickPositive = _ref.onClickPositive;

  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_1__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_ModalActions_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["modal-actions"]), "dialog-btn-wrap", className)
  }, onClickNegative && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    type: "button",
    color: _Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"].color.secondary */ .Z.color.secondary,
    minWidth: _Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"].minWidth.md */ .Z.minWidth.md,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_ModalActions_module_scss__WEBPACK_IMPORTED_MODULE_4___default().btn), "dialog-btn"),
    onClick: onClickNegative
  }, t(negativeText || (isYesNo ? "no" : "cancel"))), onClickPositive && onClickNegative && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_ModalActions_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["row-space"])
  }), onClickPositive && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    "data-focus-first": true,
    type: "button",
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_ModalActions_module_scss__WEBPACK_IMPORTED_MODULE_4___default().btn), "dialog-btn"),
    minWidth: _Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"].minWidth.md */ .Z.minWidth.md,
    onClick: onClickPositive,
    disabled: disabled
  }, t(positiveText || (isYesNo ? "yes" : "ok"))));
};

/* harmony default export */ __webpack_exports__["Z"] = (ModalActions);

/***/ }),

/***/ 75573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JM": function() { return /* binding */ READER_TOP_PANEL_PORTAL_ID; },
/* harmony export */   "Tt": function() { return /* binding */ OptionKeyOptionNotFoundBySearch; },
/* harmony export */   "Yt": function() { return /* binding */ TIMEOUT_HOUR; },
/* harmony export */   "ZX": function() { return /* binding */ CFStatus; },
/* harmony export */   "_Q": function() { return /* binding */ MENU_STATE_COLLAPSE; },
/* harmony export */   "bt": function() { return /* binding */ FontFamily; },
/* harmony export */   "do": function() { return /* binding */ TOAST_TYPE; },
/* harmony export */   "pY": function() { return /* binding */ TIMEOUT_DAY; },
/* harmony export */   "to": function() { return /* binding */ TOGGLE_IN_LIBRARY_BEHAVIOURS; },
/* harmony export */   "u1": function() { return /* binding */ SCROLL_DIRECTIONS; },
/* harmony export */   "uB": function() { return /* binding */ ComponentsId; },
/* harmony export */   "xF": function() { return /* binding */ TreeMenuMode; }
/* harmony export */ });
/* unused harmony exports TIMEOUT_MAX, AppState, MenuEvents */
// https://stackoverflow.com/questions/3468607/why-does-settimeout-break-for-large-millisecond-delay-values
var TIMEOUT_MAX = 2147483647; // 2^32 (24.85 days)

var TIMEOUT_HOUR = 3600000;
var TIMEOUT_DAY = 86400000;
var AppState = {
  none: "none",
  loading: "loading",
  loaded: "loaded",
  serverDown: "serverDown"
};
var READER_TOP_PANEL_PORTAL_ID = "reader-top-panel-portal";
var OptionKeyOptionNotFoundBySearch = "notFoundBySearch";
var MenuEvents = {
  openInWindow: {
    key: "openInWindow",
    label: "openInWindow"
  },
  openInActiveSplit: {
    key: "openInActiveSplit",
    label: "openInActiveSplit"
  },
  openInTab: {
    key: "openInTab",
    label: "openInTab"
  },
  openInNewSplit: {
    key: "openInSplit",
    label: "openInNewSplit"
  },
  about: {
    key: "about",
    label: "about"
  }
};
var TOGGLE_IN_LIBRARY_BEHAVIOURS = {
  ASK: 1,
  DO_NOT_ASK: 2
};
var TreeMenuMode = {
  CATEGORIES: "categories",
  FOLDERS: "folders",
  TITLES: "titles"
};
var MENU_STATE_COLLAPSE = "0";
var TOAST_TYPE = {
  error: "toast-error",
  notify: "toast-notify",
  warning: "toast-warning",
  success: "toast-success"
};
var SCROLL_DIRECTIONS = {
  UNTOUCHED: "UNTOUCHED",
  UP: "up",
  DOWN: "down",
  LEFT: "left",
  RIGHT: "right"
};
var ComponentsId = {
  CF_TYPO_ID: "CF_TYPO_ID",
  CF_SEND_ID: "CF_SEND_ID"
};
var CFStatus = {
  PENDING: "PENDING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS"
};
var FontFamily = {
  bebas: "bebas",
  roboto: "roboto"
};

/***/ }),

/***/ 71423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ SearchExamples; },
/* harmony export */   "Ny": function() { return /* binding */ SearchPanelTabs; }
/* harmony export */ });
/* unused harmony export SEARH_PANEL_TAB_ITEMS */
var SearchExamples = {
  goToBibleRef: {
    title: "goToBibleRef",
    keys: ["revelation612", "rev612"]
  },
  goToBookPage: {
    title: "goToBookPage",
    keys: ["education", "education57", "ed57"]
  },
  wordsWithinBookEd: {
    title: "wordsWithinBookEd",
    keys: ["edGreatestWant", "educationGreatestWant"]
  },
  phraseInBook: {
    title: "phraseInBook",
    keys: ["edPhrase", "educationPhrase"]
  },
  search_topic: {
    title: "search_topic",
    keys: ["greatestWantQuotes"]
  },
  wildCardSearch: {
    title: "wildCardSearch",
    keys: ["just"]
  },
  proximityMatch: {
    title: "proximityMatch",
    keys: ["faithSight"]
  },
  minimumMatching: {
    title: "minimumMatching",
    keys: ["loveJoy"]
  },
  orderedSearch: {
    title: "orderedSearch",
    keys: ["godStr"]
  },
  answers: {
    title: "ansToQuest",
    keys: ["ansToQuestExample"]
  }
};
var SearchPanelTabs = {
  RESULTS: "RESULTS",
  RELATED: "RELATED",
  FEATURED: "FEATURED",
  STUDY: "STUDY"
};
var SEARH_PANEL_TAB_ITEMS = [{
  id: SearchPanelTabs.RESULTS,
  label: "results"
}, {
  id: SearchPanelTabs.RELATED,
  label: "related"
}, {
  id: SearchPanelTabs.FEATURED,
  label: "featured"
}, {
  id: SearchPanelTabs.STUDY,
  label: "study"
}];

/***/ }),

/***/ 2542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JW": function() { return /* binding */ PLAYBACK_MAX; },
/* harmony export */   "gu": function() { return /* binding */ PLAYBACK_DEFAULT; },
/* harmony export */   "lO": function() { return /* binding */ PLAYBACK_MIN; }
/* harmony export */ });
/* unused harmony export SKIP_VALUE_DEFAULT */
var PLAYBACK_MIN = 0.1;
var PLAYBACK_MAX = 4;
var PLAYBACK_DEFAULT = 1;
var SKIP_VALUE_DEFAULT = 10;

/***/ }),

/***/ 81852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E0": function() { return /* binding */ useGetCurrentPlayingPara; },
/* harmony export */   "bL": function() { return /* binding */ useAudioContextWithCurrentTime; },
/* harmony export */   "j2": function() { return /* binding */ useGetCurrPrevNextChapters; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _AudioContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77926);
/* harmony import */ var _utils_player__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87794);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



 // Expands AudioContext hook to get dynamic current time position of the playing audio.
// Note: Each {time} update invokes a render.

var useAudioContextWithCurrentTime = function useAudioContextWithCurrentTime(audioContext, _ref) {
  var delayUpdateTime = _ref.delayUpdateTime;
  var timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(-1);
  var isPlaying = audioContext.isPlaying,
      getPlayerCurrentTime = audioContext.getPlayerCurrentTime,
      chapterId = audioContext.chapterId,
      subscribeToPlayerEvents = audioContext.subscribeToPlayerEvents,
      unsubscribeFromPlayerEvents = audioContext.unsubscribeFromPlayerEvents;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getPlayerCurrentTime()),
      _useState2 = _slicedToArray(_useState, 2),
      time = _useState2[0],
      setTime = _useState2[1]; // @UX - is needed to much faster time sync.


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var listener = function listener(_ref2) {
      var event = _ref2.event,
          position = _ref2.position;

      if (event === _AudioContext__WEBPACK_IMPORTED_MODULE_1__/* .PLAYER_EVENTS.CAN_PLAY_THROUGH */ .mL.CAN_PLAY_THROUGH) {
        setTime(getPlayerCurrentTime());
      }

      if (event === _AudioContext__WEBPACK_IMPORTED_MODULE_1__/* .PLAYER_EVENTS.PLAY_CHAPTER */ .mL.PLAY_CHAPTER) {
        setTime(position);
      }
    };

    subscribeToPlayerEvents(listener);
    return function () {
      unsubscribeFromPlayerEvents(listener);
    };
  }, []); // Update {time} every {delayUpdateTime} if {enabled} and {isPlaying}.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var updateCurrentTime = function updateCurrentTime(setNewTimeout) {
      setTime(getPlayerCurrentTime());

      if (setNewTimeout) {
        timeoutRef.current = setTimeout(function () {
          return updateCurrentTime(setNewTimeout);
        }, delayUpdateTime);
      }
    };

    updateCurrentTime(isPlaying);
    return function () {
      clearTimeout(timeoutRef.current);
    };
  }, [delayUpdateTime, isPlaying, chapterId]);

  var withInstantlyTimeUpdate = function withInstantlyTimeUpdate(method) {
    return function () {
      method.apply(void 0, arguments);
      setTime(getPlayerCurrentTime());
    };
  };

  return _objectSpread(_objectSpread({}, audioContext), {}, {
    timePosition: time,
    seekPlayer: withInstantlyTimeUpdate(audioContext.seekPlayer),
    skipPlayer: withInstantlyTimeUpdate(audioContext.skipPlayer),
    setPlayerCurrentTime: withInstantlyTimeUpdate(audioContext.setPlayerCurrentTime)
  });
};
var DELAY_CODE_EXECUTIONS = 500;
/**
 * Returns immediately found current para and waits its remain time with {setTimeout}
 * to find a next para then.
 * @return {{
 *   id: string,
 *   start: number,
 *   end: number,
 * } | undefined}
 */

var useGetCurrentPlayingPara = function useGetCurrentPlayingPara() {
  var timerIdRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var _useAudioContext = (0,_AudioContext__WEBPACK_IMPORTED_MODULE_1__/* .useAudioContext */ .YC)(),
      isPlaying = _useAudioContext.isPlaying,
      getPlayerCurrentTime = _useAudioContext.getPlayerCurrentTime,
      playbackRate = _useAudioContext.playbackRate,
      subscribeToPlayerEvents = _useAudioContext.subscribeToPlayerEvents,
      unsubscribeFromPlayerEvents = _useAudioContext.unsubscribeFromPlayerEvents,
      audioChapterId = _useAudioContext.audioChapterId,
      waveformsDictionary = _useAudioContext.waveformsDictionary;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      triggerRedefineValue = _useState4[0],
      setTriggerRedefineValue = _useState4[1]; // Find current paragraph and set timeout to search paragraph anew after its remain seconds.


  var currentPara = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    clearTimeout(timerIdRef.current);
    var playerPosition = getPlayerCurrentTime();
    var currentPara = (0,_utils_player__WEBPACK_IMPORTED_MODULE_2__/* .findWaveformsDictionaryParaByPosition */ .h$)(waveformsDictionary, audioChapterId, playerPosition);

    if (currentPara && isPlaying) {
      var secondsRemain = ((currentPara.end - playerPosition) / playbackRate).toFixed(2);
      timerIdRef.current = setTimeout(function () {
        setTriggerRedefineValue(currentPara.id + secondsRemain + Math.random());
      }, secondsRemain * 1000 + DELAY_CODE_EXECUTIONS);
    }

    return currentPara;
  }, [triggerRedefineValue, waveformsDictionary, isPlaying, audioChapterId, playbackRate]); // Clean up timer on unmount.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return function () {
      clearTimeout(timerIdRef.current);
    };
  }, []); // Additional cases to search paragraph anew.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var listener = function listener(_ref3) {
      var event = _ref3.event;

      if (event === _AudioContext__WEBPACK_IMPORTED_MODULE_1__/* .PLAYER_EVENTS.PLAY_CHAPTER */ .mL.PLAY_CHAPTER || event === _AudioContext__WEBPACK_IMPORTED_MODULE_1__/* .PLAYER_EVENTS.CAN_PLAY_THROUGH */ .mL.CAN_PLAY_THROUGH || event === _AudioContext__WEBPACK_IMPORTED_MODULE_1__/* .PLAYER_EVENTS.SKIP */ .mL.SKIP || event === _AudioContext__WEBPACK_IMPORTED_MODULE_1__/* .PLAYER_EVENTS.SEEK */ .mL.SEEK) {
        setTriggerRedefineValue(Math.random());
      }
    };

    subscribeToPlayerEvents(listener);
    return function () {
      unsubscribeFromPlayerEvents(listener);
    };
  }, []);
  return currentPara;
};
/**
 * @typedef {Object} CurrPrevNextChapters
 * @property {{
 *     chapter: {} | null,
 *     audioChapter: {} | null,
 *     positions: {} | null,
 *   } | null} chapterCurr
 * @property {SeekChapter | null} chapterSeekNext
 * @property {SeekChapter | null} chapterSeekPrev
 */

var useGetCurrPrevNextChapters = function useGetCurrPrevNextChapters(isPlaying, playbackRate, getPlayerCurrentTime, audioChapterId, toc, waveformsDictionary, subscribeToPlayerEvents, unsubscribeFromPlayerEvents, downloadOrPullFromSWWaveformsData) {
  var timerIdRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      triggerRedefineValue = _useState6[0],
      setTriggerRedefineValue = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState8 = _slicedToArray(_useState7, 2),
      chaptersIdsWaveformFetched = _useState8[0],
      setChaptersIdsWaveformFetched = _useState8[1];
  /**
   * Finds the current playing chapter.
   * Sets the timeout to define value anew.
   * @type {CurrPrevNextChapters}
   */


  var currPrevNextChaptersData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var _chapterSeekNext$audi, _chapterCurr$audioCha, _chapterSeekNext;

    clearTimeout(timerIdRef.current);
    var chapterCurr = null,
        chapterSeekNext = null,
        chapterSeekPrev = null;
    var playerPosition = getPlayerCurrentTime();
    var indexChapterPlaying = toc.findIndex(function (chapter) {
      var res = (0,_utils_player__WEBPACK_IMPORTED_MODULE_2__/* .isChapterInPlayer */ .c6)(toc, chapter.id, waveformsDictionary, audioChapterId, playerPosition);

      if (res.isInPlayer) {
        chapterCurr = {
          chapter: chapter,
          positions: res.audioPositions,
          audioChapter: res.audioChapter
        };
        return true;
      }

      return false;
    });

    if (indexChapterPlaying !== -1) {
      chapterSeekPrev = (0,_utils_player__WEBPACK_IMPORTED_MODULE_2__/* .getSeekChapter */ .Yr)(toc, indexChapterPlaying, waveformsDictionary, false);
      chapterSeekNext = (0,_utils_player__WEBPACK_IMPORTED_MODULE_2__/* .getSeekChapter */ .Yr)(toc, indexChapterPlaying, waveformsDictionary, true);
    }

    if (chapterCurr && chapterSeekNext && ((_chapterSeekNext$audi = chapterSeekNext.audioChapter) === null || _chapterSeekNext$audi === void 0 ? void 0 : _chapterSeekNext$audi.id) === ((_chapterCurr$audioCha = chapterCurr.audioChapter) === null || _chapterCurr$audioCha === void 0 ? void 0 : _chapterCurr$audioCha.id) && (_chapterSeekNext = chapterSeekNext) !== null && _chapterSeekNext !== void 0 && _chapterSeekNext.positions && isPlaying) {
      var secondsRemainByPosition = chapterSeekNext.positions.start - getPlayerCurrentTime();
      var secondsRemainFinal = (secondsRemainByPosition / playbackRate).toFixed(2);
      timerIdRef.current = setTimeout(function () {
        setTriggerRedefineValue(chapterCurr.chapter.id + secondsRemainFinal + Math.random());
      }, secondsRemainFinal * 1000 + DELAY_CODE_EXECUTIONS);
    }

    return {
      chapterCurr: chapterCurr,
      chapterSeekNext: chapterSeekNext,
      chapterSeekPrev: chapterSeekPrev
    };
  }, [triggerRedefineValue, waveformsDictionary, isPlaying, audioChapterId, playbackRate, toc, waveformsDictionary]); // Fetches missing waveforms for potentially next and prev seek chapters.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var chapterSeekNext = currPrevNextChaptersData.chapterSeekNext,
        chapterSeekPrev = currPrevNextChaptersData.chapterSeekPrev;
    var chaptersWaveformDownloadNeeded = [chapterSeekNext, chapterSeekPrev].filter(function (d) {
      if (d) {
        var isMissingWaveform = d.isMissingWaveform,
            audioChapter = d.audioChapter;
        return isMissingWaveform && audioChapter && !chaptersIdsWaveformFetched.includes(audioChapter.id);
      }

      return false;
    });

    if (chaptersWaveformDownloadNeeded.length) {
      var chaptersIds = chaptersWaveformDownloadNeeded.map(function (_ref4) {
        var audioChapter = _ref4.audioChapter;
        downloadOrPullFromSWWaveformsData(audioChapter);
        return audioChapter.id;
      });
      setChaptersIdsWaveformFetched(function (v) {
        return [].concat(_toConsumableArray(v), _toConsumableArray(chaptersIds));
      });
    }
  }, [currPrevNextChaptersData]); // Clean up timer on unmount.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return function () {
      clearTimeout(timerIdRef.current);
    };
  }, []); // Additional cases to define chapters anew.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var listener = function listener(_ref5) {
      var event = _ref5.event;

      if (event === _AudioContext__WEBPACK_IMPORTED_MODULE_1__/* .PLAYER_EVENTS.PLAY_CHAPTER */ .mL.PLAY_CHAPTER || event === _AudioContext__WEBPACK_IMPORTED_MODULE_1__/* .PLAYER_EVENTS.CAN_PLAY_THROUGH */ .mL.CAN_PLAY_THROUGH) {
        setTriggerRedefineValue(Math.random());
      }
    };

    subscribeToPlayerEvents(listener);
    return function () {
      unsubscribeFromPlayerEvents(listener);
    };
  }, []);
  return currPrevNextChaptersData;
};

/***/ }),

/***/ 77926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YC": function() { return /* binding */ useAudioContext; },
/* harmony export */   "mL": function() { return /* binding */ PLAYER_EVENTS; },
/* harmony export */   "nY": function() { return /* binding */ AudioProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34412);
/* harmony import */ var _utils_url_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59916);
/* harmony import */ var _hooks_useObserverPattern__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77423);
/* harmony import */ var _api_analitics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82287);
/* harmony import */ var _utils_number_number__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(50150);
/* harmony import */ var _store_player_selectors__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(46996);
/* harmony import */ var _store_player_actions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16360);
/* harmony import */ var _store_system_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93893);
/* harmony import */ var _store_library_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82900);
/* harmony import */ var _utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34855);
/* harmony import */ var _store_system_selectors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91809);
/* harmony import */ var _store_sw_actions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38857);
/* harmony import */ var _store_settings_actions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(58538);
/* harmony import */ var _AudioContext_hooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81852);
/* harmony import */ var _utils_player__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(87794);
/* harmony import */ var _hooks_pwa_sw__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69867);
/* harmony import */ var _AudioContext_constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(2542);
/* harmony import */ var _utils_settings_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(20467);
/* harmony import */ var _shared_utils_assembly__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(76732);
/* harmony import */ var _shared_utils_device_detect__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(83684);
/* harmony import */ var _shared_store_sw_selectorWaveformsDownloadedIds__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(27447);
/* harmony import */ var _shared_store_sw_selectorAudiosDownloadedIds__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(8073);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

























var PLAYER_EVENTS = {
  END: 2,
  CAN_PLAY_THROUGH: 3,
  PAUSE: 4,
  PLAY: 5,
  SKIP: 6,
  SEEK: 7,
  PLAY_CHAPTER: 8
};
var playerID = Date.now().toString();
var AudioContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var scope = "AudioContext";
var srcSilence = "/audio/silence.mp3";
var playerStateInitial = {
  chapterId: "",
  volume: 1,
  duration: 0,
  isPlaying: false,
  isMute: false,
  playbackRate: _AudioContext_constants__WEBPACK_IMPORTED_MODULE_20__/* .PLAYBACK_DEFAULT */ .gu,
  fromML: false
}; // Prevent apply IOS fixes in dev mode, because IOS version less than 14 freeze website
// for approximately 20 seconds when trying to play an audio.

var isApplyIOSFixes = !(0,_shared_utils_assembly__WEBPACK_IMPORTED_MODULE_16__/* .isDevelopment */ .yG)();
var AudioProvider = function AudioProvider(_ref) {
  var _waveformsDictionary$, _waveformsDictionary$2, _currPrevNextChapters, _currPrevNextChapters2;

  var analytics = _ref.analytics,
      children = _ref.children;
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
  var audioRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(playerStateInitial),
      _useState2 = _slicedToArray(_useState, 2),
      playerState = _useState2[0],
      _setPlayerState = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      swPulledBase64 = _useState4[0],
      setSwPulledBase64 = _useState4[1];

  var chapterId = playerState.chapterId,
      isPlaying = playerState.isPlaying,
      volume = playerState.volume,
      isMute = playerState.isMute,
      playbackRate = playerState.playbackRate,
      duration = playerState.duration,
      fromML = playerState.fromML;
  var waveformsDictionary = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_player_selectors__WEBPACK_IMPORTED_MODULE_21__/* .selectorPlayerWaveformsDictionary */ .cc);
  var onLine = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_system_selectors__WEBPACK_IMPORTED_MODULE_10__/* .selectorSystemOnLine */ .JU);
  var audiosDownloadedIds = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_shared_store_sw_selectorAudiosDownloadedIds__WEBPACK_IMPORTED_MODULE_19__/* .selectorAudiosDownloadedIds */ .P);
  var waveformsDownloadedIds = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_shared_store_sw_selectorWaveformsDownloadedIds__WEBPACK_IMPORTED_MODULE_18__/* .selectorWaveformsDownloadedIds */ .Z);
  var brokenAudios = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_player_selectors__WEBPACK_IMPORTED_MODULE_21__/* .selectorPlayerBrokenAudios */ .Qf);

  var _useObserverPattern = (0,_hooks_useObserverPattern__WEBPACK_IMPORTED_MODULE_4__/* .useObserverPattern */ .U)(),
      addObserverListener = _useObserverPattern.addObserverListener,
      removeObserverListener = _useObserverPattern.removeObserverListener,
      notifyObserverListeners = _useObserverPattern.notifyObserverListeners;

  var _useBookWithSWFallbac = (0,_hooks_pwa_sw__WEBPACK_IMPORTED_MODULE_14__/* .useBookWithSWFallback */ .OK)(chapterId),
      book = _useBookWithSWFallbac.book,
      toc = _useBookWithSWFallbac.toc;

  var audioChapters = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return (0,_utils_player__WEBPACK_IMPORTED_MODULE_22__/* .filterTOCToAudioChapters */ .dm)(toc);
  }, [toc]);
  var audioChapter = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return (0,_utils_player__WEBPACK_IMPORTED_MODULE_22__/* .getAudioChapterByChapterId */ .jW)(toc, chapterId);
  }, [toc, chapterId]);
  var audioChapterId = audioChapter === null || audioChapter === void 0 ? void 0 : audioChapter.id;
  var isUseCachedAudioFile = audiosDownloadedIds.includes(audioChapterId);

  var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    if (audioChapter) {
      var srcFinal = isUseCachedAudioFile ? swPulledBase64.key === audioChapterId ? swPulledBase64.value : undefined : (0,_utils_url_url__WEBPACK_IMPORTED_MODULE_3__/* .makeResourceUrl */ .c7)(audioChapter.mp3);
      return [srcFinal, (0,_utils_player__WEBPACK_IMPORTED_MODULE_22__/* .getFileDuration */ .eM)(audioChapter.mp3), audioChapter.title];
    }

    return [];
  }, [audioChapterId, isUseCachedAudioFile, audioChapter, swPulledBase64]),
      _useMemo2 = _slicedToArray(_useMemo, 3),
      src = _useMemo2[0],
      fileDuration = _useMemo2[1],
      _useMemo2$ = _useMemo2[2],
      trackTitle = _useMemo2$ === void 0 ? "" : _useMemo2$;

  var cover = book ? (0,_utils_url_url__WEBPACK_IMPORTED_MODULE_3__/* .getBookCover */ .Ow)(book, true) : undefined;
  var isBroken = brokenAudios.includes(audioChapterId);
  var waveform = ((_waveformsDictionary$ = waveformsDictionary[audioChapterId]) === null || _waveformsDictionary$ === void 0 ? void 0 : _waveformsDictionary$.waveform) || null;
  var paragraphsAudioPositions = ((_waveformsDictionary$2 = waveformsDictionary[audioChapterId]) === null || _waveformsDictionary$2 === void 0 ? void 0 : _waveformsDictionary$2.paragraphsAudioPositions) || null;

  var dispatchPlayerEvent = function dispatchPlayerEvent(event) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var prevented = false;
    notifyObserverListeners(_objectSpread(_objectSpread({}, data), {}, {
      event: event,
      preventEvent: function preventEvent() {
        prevented = true;
      }
    }));
    return prevented;
  };

  var getAudioElement = function getAudioElement() {
    return audioRef.current;
  };

  var getCurrentTime = function getCurrentTime() {
    var player = getAudioElement();

    if (player) {
      return player.currentTime;
    }

    return 0;
  }; // Fetch paragraphs audio positions (and chapter audio wave form as there is the single API).
  // Waveforms data is needed to draw audio wave, detect para position in the track or vice-versa.
  // It is needed in the Reader and Big Audio Player only, so its call is optional.


  var downloadOrPullFromSWWaveformsData = function downloadOrPullFromSWWaveformsData(audioTrack) {
    if (audioTrack) {
      if (waveformsDownloadedIds.includes(audioTrack.id)) {
        dispatch(_store_sw_actions__WEBPACK_IMPORTED_MODULE_11__/* ._sharedActionsSW.pullProgressWaveform */ .m.pullProgressWaveform(audioTrack.id));
      } else {
        if (onLine) {
          dispatch(_store_player_actions__WEBPACK_IMPORTED_MODULE_6__/* ._sharedActionsPlayer.fetchWaveformsDictionary */ .m.fetchWaveformsDictionary((0,_utils_url_url__WEBPACK_IMPORTED_MODULE_3__/* .makeWaveformsJsonUrl */ .Je)(audioTrack.mp3), audioTrack.id));
        }
      }
    }
  };

  var currPrevNextChapters = (0,_AudioContext_hooks__WEBPACK_IMPORTED_MODULE_13__/* .useGetCurrPrevNextChapters */ .j2)(isPlaying, playbackRate, getCurrentTime, audioChapterId, toc, waveformsDictionary, addObserverListener, removeObserverListener, downloadOrPullFromSWWaveformsData);
  var canSeekBack = !!((_currPrevNextChapters = currPrevNextChapters.chapterSeekPrev) !== null && _currPrevNextChapters !== void 0 && _currPrevNextChapters.audioChapter);
  var canSeekForward = !!((_currPrevNextChapters2 = currPrevNextChapters.chapterSeekNext) !== null && _currPrevNextChapters2 !== void 0 && _currPrevNextChapters2.audioChapter);

  var saveHistoryListenCurrentPosition = function saveHistoryListenCurrentPosition(delay) {
    var chapter = chapterId;

    if (chapter) {
      dispatch(_store_library_actions__WEBPACK_IMPORTED_MODULE_8__/* ._sharedActionsLibrary.saveListen */ .C.saveListen(chapter, getCurrentTime(), fromML, delay));
    }
  };

  var setCurrentTime = function setCurrentTime(position) {
    if (position === undefined) {
      return;
    }

    var player = getAudioElement();

    if (player) {
      player.currentTime = position || 0;
    }
  };

  var _setPlayerVolume = function _setPlayerVolume(volume) {
    var player = getAudioElement();

    if (!player) {
      return;
    }

    var volumeFinal = parseFloat(volume) || 1;

    if (typeof volumeFinal === "number" && volumeFinal !== player.volume) {
      player.volume = volumeFinal;
    }
  };

  var _setPlayerPlayback = function _setPlayerPlayback(playbackRate) {
    var player = getAudioElement();

    if (player) {
      player.playbackRate = playbackRate;
    }
  };

  var setStateWithPreservingOldValues = function setStateWithPreservingOldValues(newState) {
    _setPlayerState(function (oldState) {
      return _objectSpread(_objectSpread({}, oldState), newState);
    });
  };

  var updatePlaybackRate = function updatePlaybackRate(value) {
    setStateWithPreservingOldValues({
      playbackRate: value
    });
  };

  var _play = function _play() {
    var onError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var player = getAudioElement();

    if (player) {
      player.play().then(function () {
        dispatch(_store_settings_actions__WEBPACK_IMPORTED_MODULE_12__/* ._sharedActionsSettings.updateSettings */ .a.updateSettings(_utils_settings_constants__WEBPACK_IMPORTED_MODULE_15__/* .SETTING.playerState.id */ .Fy.playerState.id, playerID));
        setStateWithPreservingOldValues({
          isPlaying: true
        });
        saveHistoryListenCurrentPosition(1000);
      }).catch(onError);
    }
  };

  var pause = function pause() {
    saveHistoryListenCurrentPosition(1000);
    var player = getAudioElement();

    if (player) {
      player.pause();
      setStateWithPreservingOldValues({
        isPlaying: false
      });
    }
  }; // Fixes:
  // – "canplaythrough" is fired with empty source (src) when changing from source A to source B.


  var fireFunctionAfterValidSrcAttached = function fireFunctionAfterValidSrcAttached(cb) {
    var player = getAudioElement();

    if (player) {
      player.addEventListener("canplaythrough", function () {
        if (player.src) {
          if (cb) {
            cb();
          }
        } else {
          fireFunctionAfterValidSrcAttached(cb);
        }
      }, {
        once: true
      });
    }
  };

  var setActiveChapter = function setActiveChapter(id, startTime, options) {
    setStateWithPreservingOldValues({
      chapterId: id,
      fromML: options === null || options === void 0 ? void 0 : options.fromML
    });
    pause();
    setCurrentTime(startTime);

    var handleAttachedChapterSRC = function handleAttachedChapterSRC() {
      _setPlayerPlayback(playbackRate);

      setCurrentTime(startTime);

      if (options !== null && options !== void 0 && options.onChapterSRCAttached) {
        options.onChapterSRCAttached();
      }
    };

    if (id === chapterId) {
      handleAttachedChapterSRC();
    } else {
      fireFunctionAfterValidSrcAttached(handleAttachedChapterSRC);
    }
  };

  var _playChapter = function _playChapter(id, startTime, options) {
    dispatchPlayerEvent(PLAYER_EVENTS.PLAY_CHAPTER, {
      position: startTime
    });
    setActiveChapter(id, startTime, {
      fromML: options === null || options === void 0 ? void 0 : options.fromML,
      onChapterSRCAttached: function onChapterSRCAttached() {
        _play(options === null || options === void 0 ? void 0 : options.onError);
      }
    });
  };

  var toggleChapterPlaying = function toggleChapterPlaying(id, startTime, options) {
    if (id === undefined || id === chapterId) {
      if (isPlaying) {
        pause();
      } else {
        _play(options === null || options === void 0 ? void 0 : options.onError);
      }
    } else {
      _playChapter(id, startTime, options);
    }
  };

  var playChapterAndShowPlayer = function playChapterAndShowPlayer(id, startTime, options) {
    _playChapter(id, startTime, options);

    dispatch(_store_player_actions__WEBPACK_IMPORTED_MODULE_6__/* ._sharedActionsPlayer.setIsSmallPlayerVisible */ .m.setIsSmallPlayerVisible(true));
  };

  var stop = function stop() {
    setStateWithPreservingOldValues({
      chapterId: ""
    });
    dispatch(_store_player_actions__WEBPACK_IMPORTED_MODULE_6__/* ._sharedActionsPlayer.setIsSmallPlayerVisible */ .m.setIsSmallPlayerVisible(false));
    var player = getAudioElement();

    if (player) {
      if (!player.paused) {
        pause();
      }
    }
  };

  var skip = function skip(skipValue) {
    var player = getAudioElement();

    if (player) {
      setCurrentTime((0,_utils_number_number__WEBPACK_IMPORTED_MODULE_23__/* .clutch */ .Cz)(getCurrentTime() + skipValue, 0, duration));
      dispatchPlayerEvent(PLAYER_EVENTS.SKIP);
      saveHistoryListenCurrentPosition(1000);
    }
  };

  var seek = function seek(forvard) {
    var seekChapterData = forvard ? currPrevNextChapters.chapterSeekNext : currPrevNextChapters.chapterSeekPrev;

    if (seekChapterData && seekChapterData.chapter && seekChapterData.audioChapter) {
      if (seekChapterData.audioChapter.id === audioChapterId) {
        var _seekChapterData$posi, _seekChapterData$posi2;

        setCurrentTime((_seekChapterData$posi = (_seekChapterData$posi2 = seekChapterData.positions) === null || _seekChapterData$posi2 === void 0 ? void 0 : _seekChapterData$posi2.start) !== null && _seekChapterData$posi !== void 0 ? _seekChapterData$posi : 0);
        dispatchPlayerEvent(PLAYER_EVENTS.SKIP);
      } else {
        var _seekChapterData$posi3, _seekChapterData$posi4;

        var chapterIdNew = seekChapterData.chapter.id;
        playChapterAndShowPlayer(chapterIdNew, (_seekChapterData$posi3 = (_seekChapterData$posi4 = seekChapterData.positions) === null || _seekChapterData$posi4 === void 0 ? void 0 : _seekChapterData$posi4.start) !== null && _seekChapterData$posi3 !== void 0 ? _seekChapterData$posi3 : 0);
        dispatchPlayerEvent(PLAYER_EVENTS.SEEK, {
          chapterIdNew: chapterIdNew
        });
      }

      saveHistoryListenCurrentPosition(1000);
      return;
    }

    pause();
  };

  var _handlePlayedToEnd = function _handlePlayedToEnd() {
    var prevented = dispatchPlayerEvent(PLAYER_EVENTS.END);

    if (!prevented) {
      seek(true);
    }
  };

  var _handleLoadedMetaData = function _handleLoadedMetaData(event) {
    setStateWithPreservingOldValues({
      duration: event.target.duration
    });
  };

  var _handlePlay = function _handlePlay() {
    dispatchPlayerEvent(PLAYER_EVENTS.PLAY);

    if (brokenAudios.includes(chapterId)) {
      // Remove from the broken audios array.
      var audioIndex = brokenAudios.findIndex(function (item) {
        return item === chapterId;
      });

      if (audioIndex !== -1) {
        brokenAudios.splice(audioIndex, 1);
        dispatch(_store_player_actions__WEBPACK_IMPORTED_MODULE_6__/* ._sharedActionsPlayer.setBrokenAudios */ .m.setBrokenAudios(_toConsumableArray(brokenAudios)));
      }
    }
  };

  var _handlePause = function _handlePause() {
    dispatchPlayerEvent(PLAYER_EVENTS.PAUSE);
  };

  var errorHandler = function errorHandler() {
    setStateWithPreservingOldValues({
      chapterId: chapterId,
      volume: 1
    });
    pause();

    if (!brokenAudios.includes(chapterId)) {
      // Add to the broken audios array.
      dispatch(_store_player_actions__WEBPACK_IMPORTED_MODULE_6__/* ._sharedActionsPlayer.setBrokenAudios */ .m.setBrokenAudios([].concat(_toConsumableArray(brokenAudios), [chapterId])));
    }

    if (onLine) {
      dispatch(_store_system_actions__WEBPACK_IMPORTED_MODULE_7__/* ._sharedActionsSystem.toast */ .g.toast("@audioNotAvailable"));
    }
  };

  var refFunctions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    downloadOrPullFromSWWaveformsData: downloadOrPullFromSWWaveformsData,
    fireFunctionAfterValidSrcAttached: fireFunctionAfterValidSrcAttached,
    _play: _play,
    pause: pause,
    _setPlayerVolume: _setPlayerVolume,
    _setPlayerPlayback: _setPlayerPlayback,
    getCurrentTime: getCurrentTime,
    skip: skip,
    seek: seek
  }); // analytics

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (analytics && chapterId) {
      (0,_api_analitics__WEBPACK_IMPORTED_MODULE_5__/* .logOtherEvent */ .iW)(_api_analitics__WEBPACK_IMPORTED_MODULE_5__/* .OtherLogEvents.LISTEN_CHAPTER */ .b$.LISTEN_CHAPTER, {
        id: chapterId
      });
    }
  }, [analytics, chapterId]); // Fixes the IOS can't play the audio before the interaction with the page.
  // Reproduce: use Iphone, go to Book List with shown bookshelf under the items, refresh the page,
  // click on the play icon, see thrown error in the console and audio hadn't started playing.
  // https://stackoverflow.com/a/64750678

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if ((0,_shared_utils_device_detect__WEBPACK_IMPORTED_MODULE_17__/* .getIsIOSDevice */ .Y$)() && isApplyIOSFixes) {
      var player = getAudioElement();

      if (player) {
        player.src = srcSilence;
        player.play().catch(function () {});
        player.pause();
        player.currentTime = 0;
        document.addEventListener("touchstart", function () {
          if (player.src.includes(srcSilence)) {
            player.play().then(function () {
              player.pause();
            }).catch(function () {});
          }
        }, {
          once: true
        });
      }
    }
  }, []); // Fix audio is not loading and "canplaythrough" event is not fired when src is set on the IOS.
  // e.g. just start playing in Reader – it requires 2nd click on play btn.
  // e.g. start playing in Reader, change chapter – it requires 2nd click on play btn.
  // https://stackoverflow.com/a/49794011

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (src && (0,_shared_utils_device_detect__WEBPACK_IMPORTED_MODULE_17__/* .getIsIOSDevice */ .Y$)() && isApplyIOSFixes) {
      getAudioElement().load();
    }
  }, [src]); // ==================================================
  // Sets the first possible audio chapter if no chapter was found.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (chapterId && !audioChapter && audioChapters !== null && audioChapters !== void 0 && audioChapters.length) {
      setStateWithPreservingOldValues({
        chapterId: audioChapters[0].id
      });
    }
  }, [chapterId, audioChapter, audioChapters]); // Fetches chapter paragraphs positions in the audio (and waveform),
  // to be able to navigate (seek) between subchapters.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (audioChapter) {
      downloadOrPullFromSWWaveformsData(audioChapter);
    }
  }, [audioChapter]); // Pauses the playing if started playing in another app tab.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var handler = function handler(e) {
      if (e.key === _utils_settings_constants__WEBPACK_IMPORTED_MODULE_15__/* .SETTING.playerState.id */ .Fy.playerState.id) {
        if (isPlaying && e.newValue !== playerID) {
          refFunctions.current.pause();
        }
      }
    };

    window.addEventListener("storage", handler);
    return function () {
      window.removeEventListener("storage", handler);
    };
  }, []); // Attaches {mediaSession} controls events.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if ("mediaSession" in navigator && cover) {
      if (window.MediaMetadata) {
        navigator.mediaSession.metadata = new window.MediaMetadata({
          pageTitle: book === null || book === void 0 ? void 0 : book.title,
          album: trackTitle,
          artwork: [{
            src: cover,
            type: "image/png"
          }]
        });
      }

      navigator.mediaSession.setActionHandler("play", function () {
        refFunctions.current._play();
      });
      navigator.mediaSession.setActionHandler("pause", function () {
        refFunctions.current.pause();
      });
      navigator.mediaSession.setActionHandler("seekbackward", function () {
        refFunctions.current.skip(-10);
      });
      navigator.mediaSession.setActionHandler("seekforward", function () {
        refFunctions.current.skip(10);
      });
      navigator.mediaSession.setActionHandler("previoustrack", function () {
        refFunctions.current.seek(false);
      });
      navigator.mediaSession.setActionHandler("nexttrack", function () {
        refFunctions.current.seek(true);
      });
    }
  }, [cover, book === null || book === void 0 ? void 0 : book.title, trackTitle]); // Updates HTMLElement volume when it is updated in the state.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    _setPlayerVolume(volume);
  }, [volume]); // Updates HTMLElement playbackRate when it is updated in the state.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    _setPlayerPlayback(playbackRate);
  }, [playbackRate]); // Pulls audio file base64.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!onLine && !isUseCachedAudioFile && audioChapterId) {
      dispatch(_store_system_actions__WEBPACK_IMPORTED_MODULE_7__/* ._sharedActionsSystem.toast */ .g.toast(["@sw:noInternetConnection", ". ", "@sw:featureNotAvailable", "."]));
    }

    if (isUseCachedAudioFile) {
      dispatch(_store_sw_actions__WEBPACK_IMPORTED_MODULE_11__/* ._sharedActionsSW.pullAudio */ .m.pullAudio(audioChapterId));
      dispatch(_store_sw_actions__WEBPACK_IMPORTED_MODULE_11__/* ._sharedActionsSW.pullProgressWaveform */ .m.pullProgressWaveform(audioChapterId));
    }
  }, [onLine, isUseCachedAudioFile, audioChapterId]); // Updates pulled audio base64.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var listener = function listener(e) {
      setSwPulledBase64(e.detail);

      if (isPlaying) {
        refFunctions.current.fireFunctionAfterValidSrcAttached(function () {
          refFunctions.current._play();
        });
      }
    };

    window.addEventListener(_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_9__/* .CUSTOM_EVENT_TYPE_NEW_PULLED_AUDIO_FILE_SRC */ .x, listener);
    return function () {
      window.removeEventListener(_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_9__/* .CUSTOM_EVENT_TYPE_NEW_PULLED_AUDIO_FILE_SRC */ .x, listener);
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(AudioContext.Provider, {
    value: {
      saveHistoryListenCurrentPosition: saveHistoryListenCurrentPosition,
      setActiveChapter: setActiveChapter,
      playChapterAndShowPlayer: playChapterAndShowPlayer,
      toggleChapterPlaying: toggleChapterPlaying,
      pausePlayer: pause,
      stopPlayer: stop,
      getPlayerCurrentTime: getCurrentTime,
      setPlayerCurrentTime: setCurrentTime,
      updatePlayerState: setStateWithPreservingOldValues,
      updatePlaybackRate: updatePlaybackRate,
      seekPlayer: seek,
      skipPlayer: skip,
      downloadOrPullFromSWWaveformsData: downloadOrPullFromSWWaveformsData,
      subscribeToPlayerEvents: addObserverListener,
      unsubscribeFromPlayerEvents: removeObserverListener,
      chapterId: chapterId,
      volume: volume,
      duration: duration,
      isPlaying: isPlaying,
      isMute: isMute,
      playbackRate: playbackRate,
      fileDuration: fileDuration,
      trackTitle: trackTitle,
      canSeekBack: canSeekBack,
      canSeekForward: canSeekForward,
      isBroken: isBroken,
      // solves a problem of a wrong {chapterId} in the case of a duplicate chapter
      // e.g. {chapterId="127.5"}, but {audioChapterId="127.7"}
      audioChapterId: audioChapterId,
      audioChapter: audioChapter,
      audioChapters: audioChapters,
      waveform: waveform,
      waveformsDictionary: waveformsDictionary,
      paragraphsAudioPositions: paragraphsAudioPositions,
      currPrevNextChapters: currPrevNextChapters,
      toc: toc,
      book: book
    }
  }, children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("audio", {
    ref: audioRef,
    muted: isMute,
    title: trackTitle,
    src: src,
    onPlay: _handlePlay,
    onPause: _handlePause,
    onLoadedMetadata: _handleLoadedMetaData,
    onCanPlayThrough: function onCanPlayThrough() {
      dispatchPlayerEvent(PLAYER_EVENTS.CAN_PLAY_THROUGH);
    },
    onEnded: _handlePlayedToEnd,
    onError: errorHandler
  }));
};
AudioProvider.displayName = scope;
AudioProvider.propTypes = {
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node),
  analytics: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool) // defines whether send listen analytics or not

};
/**
 * @returns {{
    playChapterAndShowPlayer: (
      id: string,
      startTime?: number,
      options?: {
        fromML?: boolean,
        onError?: function,
      }
    ) => void,
    setActiveChapter: function,
    playChapterAndShowPlayerIfNotTheSameBook: function,
    toggleChapterPlaying: function,
    seekPlayer: function,
    skipPlayer: function,
    stopPlayer: function,

    getPlayer: function,
    getPlayerCurrentTime: function,
    setPlayerCurrentTime: function,
    updatePlayerState: function,
    updatePlaybackRate: function,
    downloadOrPullFromSWWaveformsData: function,
    savePlayPosition: function,

    subscribeToPlayerEvents: function,
    unsubscribeFromPlayerEvents: function,

    chapterId: string,
    volume: number,
    duration: number,
    isPlaying: boolean,
    stopTimeout: number,
    isMute: boolean,
    playbackRate: number,

    fileDuration: number|undefined,
    trackTitle: string,
    canSeekBack: boolean,
    canSeekForward: boolean,
    isBroken: boolean,

    audioChapterId: string|undefined,
    audioChapter: {}|null,
    waveform: {}|null,
    waveformsDictionary: {},
    paragraphsAudioPositions: []|null,
    audioChapters: {}[],
    currPrevNextChapters: CurrPrevNextChapters,
    toc: {}[],
    book: {},
 * }}
 */

var useAudioContext = function useAudioContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AudioContext);
};

/***/ }),

/***/ 48081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useSharedTranslation; },
/* harmony export */   "u": function() { return /* binding */ SharedTranslationProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var SharedTranslationContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var SharedTranslationProvider = function SharedTranslationProvider(_ref) {
  var useTranslation = _ref.useTranslation,
      children = _ref.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(SharedTranslationContext.Provider, {
    value: {
      _useTranslation: useTranslation
    }
  }, children);
};
SharedTranslationProvider.propTypes = {
  i18nInstance: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object)
};

var useSharedTranslationContext = function useSharedTranslationContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SharedTranslationContext);
};
/**
 * @returns {{
    playChapterAndShowPlayer: (
      id: string,
      startTime?: number,
      options?: {
        fromML?: boolean,
        onError?: function,
      }
    ) => void,
    setActiveChapter: function,
    playChapterAndShowPlayerIfNotTheSameBook: function,
    toggleChapterPlaying: function,
    seekPlayer: function,
    skipPlayer: function,
    stopPlayer: function,

    getPlayer: function,
    getPlayerCurrentTime: function,
    setPlayerCurrentTime: function,
    updatePlayerState: function,
    updatePlaybackRate: function,
    downloadOrPullFromSWWaveformsData: function,
    savePlayPosition: function,

    subscribeToPlayerEvents: function,
    unsubscribeFromPlayerEvents: function,

    chapterId: string,
    volume: number,
    duration: number,
    isPlaying: boolean,
    stopTimeout: number,
    isMute: boolean,
    playbackRate: number,

    fileDuration: number|undefined,
    trackTitle: string,
    canSeekBack: boolean,
    canSeekForward: boolean,
    isBroken: boolean,

    audioChapterId: string|undefined,
    audioChapter: {}|null,
    waveform: {}|null,
    waveformsDictionary: {},
    paragraphsAudioPositions: []|null,
    audioChapters: {}[],
    currPrevNextChapters: CurrPrevNextChapters,
    toc: {}[],
    book: {},
 * }}
 */


var useSharedTranslation = function useSharedTranslation() {
  var _useSharedTranslation = useSharedTranslationContext(),
      _useTranslation = _useSharedTranslation._useTranslation;

  return _useTranslation();
};

/***/ }),

/***/ 26933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useModalContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _components_modal_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58411);
/* harmony import */ var _components_Portal_Portal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64976);
/* harmony import */ var _components_Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(265);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var ModalContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});

var ModalProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalProvider, _React$Component);

  var _super = _createSuper(ModalProvider);

  function ModalProvider() {
    var _this;

    _classCallCheck(this, ModalProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      stack: null
    });

    _defineProperty(_assertThisInitialized(_this), "setStack", function (valueNew) {
      _this.setState(function (s) {
        return _objectSpread(_objectSpread({}, s), {}, {
          stack: typeof valueNew === "function" ? valueNew(s.stack) : valueNew
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clearStack", function () {
      _this.setStack(null);
    });

    _defineProperty(_assertThisInitialized(_this), "pushToStack", function (item) {
      _this.setStack(function (valueOld) {
        return valueOld ? [].concat(_toConsumableArray(valueOld), [item]) : [item];
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showModal", function (modalContent, options) {
      _this.pushToStack(_objectSpread(_objectSpread({}, options), {}, {
        component: modalContent,
        dialogId: (options === null || options === void 0 ? void 0 : options.dialogId) || Math.random()
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "showDialog", function (title, message, onConfirm, options) {
      _this.pushToStack(_objectSpread(_objectSpread({}, options), {}, {
        title: title,
        message: message,
        onConfirm: onConfirm,
        dialogId: (options === null || options === void 0 ? void 0 : options.dialogId) || Math.random()
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "showConfirm", function (title, message, onConfirm, options) {
      _this.pushToStack(_objectSpread(_objectSpread({}, options), {}, {
        confirm: true,
        title: title,
        message: message,
        onConfirm: onConfirm,
        dialogId: (options === null || options === void 0 ? void 0 : options.dialogId) || Math.random()
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function (dialogId) {
      _this.setStack(function (stackOld) {
        if (stackOld) {
          var itemToClose = dialogId && typeof dialogId === 'number' ? stackOld.find(function (m) {
            return m.dialogId === dialogId;
          }) : stackOld[stackOld.length - 1];

          if (itemToClose !== null && itemToClose !== void 0 && itemToClose.onClose) {
            itemToClose.onClose();
          }

          return stackOld.filter(function (i) {
            return i !== itemToClose;
          });
        }

        return null;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkDialogId", function (dialogId) {
      return _this.state.stack ? _this.state.stack.some(function (i) {
        return i.dialogId === dialogId;
      }) : false;
    });

    return _this;
  }

  _createClass(ModalProvider, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalContext.Provider, {
        value: {
          checkDialogId: this.checkDialogId,
          showModal: this.showModal,
          showDialog: this.showDialog,
          hideDialog: this.onClose,
          showConfirm: this.showConfirm,
          onClose: this.onClose,
          // back-compatibility for Lite App
          clearStack: this.clearStack
        }
      }, this.props.children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Portal_Portal__WEBPACK_IMPORTED_MODULE_2__["default"], {
        id: _components_Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_3__/* .EL_ID_PORTAL_MAIN_AFTER */ .t
      }, this.state.stack ? this.state.stack.map(function (props, index) {
        var _props$dialogId;

        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_modal_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          key: (_props$dialogId = props.dialogId) !== null && _props$dialogId !== void 0 ? _props$dialogId : index,
          props: props,
          onClose: _this2.onClose
        });
      }) : null));
    }
  }]);

  return ModalProvider;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
/**
 *
 * @returns {{
 *   checkDialogId: function,
 * showModal: function,
 * showDialog: function,
 * hideDialog: function,
 * showConfirm: function,
 * onClose: function,
 * clearStack: function,
 * }}
 */


var useModalContext = function useModalContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ModalContext);
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalProvider);

/***/ }),

/***/ 40947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ STORAGE_KEY_IS_PWA_INSTALLED; }
/* harmony export */ });
var STORAGE_KEY_IS_PWA_INSTALLED = "is-pwa-installed";

/***/ }),

/***/ 79427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useIsStandAlone; },
/* harmony export */   "N": function() { return /* binding */ useIsStandAloneInstalled; }
/* harmony export */ });
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67766);
/* harmony import */ var _pwa_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40947);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _useMediaQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38295);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





var useIsStandAlone = function useIsStandAlone() {
  var _global$window, _global$window$naviga;

  var isStandAloneByMediaQuery = (0,_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_QUERIES.standAlone */ .q.standAlone);
  var isStandAloneIOS = ((_global$window = __webpack_require__.g.window) === null || _global$window === void 0 ? void 0 : (_global$window$naviga = _global$window.navigator) === null || _global$window$naviga === void 0 ? void 0 : _global$window$naviga.standalone) === true;
  var isStandAlone = isStandAloneIOS || isStandAloneByMediaQuery;
  return isStandAlone;
};
var useIsStandAloneInstalled = function useIsStandAloneInstalled() {
  var isStandAlone = useIsStandAlone();

  var _useLocalStorage = (0,_storage__WEBPACK_IMPORTED_MODULE_0__/* .useLocalStorage */ ._)(_pwa_constants__WEBPACK_IMPORTED_MODULE_3__/* .STORAGE_KEY_IS_PWA_INSTALLED */ .z, false, true),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      isPWAInstalled = _useLocalStorage2[0],
      setIsPWAInstalled = _useLocalStorage2[1];

  var handleInstallSuccess = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    setIsPWAInstalled(true);
  }, [setIsPWAInstalled]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (isStandAlone) {
      handleInstallSuccess();
    }
  }, [isStandAlone, handleInstallSuccess]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    window.addEventListener("onappinstalled", handleInstallSuccess);
    return function () {
      window.removeEventListener("onappinstalled", handleInstallSuccess);
    };
  }, [handleInstallSuccess]);
  return isPWAInstalled;
};

/***/ }),

/***/ 69867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Db": function() { return /* binding */ useAutoDownloadWebsite; },
  "OK": function() { return /* binding */ useBookWithSWFallback; },
  "Go": function() { return /* binding */ useClearSWDataWhenVersionsDiffers; },
  "OH": function() { return /* binding */ useHandleSWMessages; },
  "MN": function() { return /* binding */ useRegisterServiceWorker; },
  "px": function() { return /* binding */ useStashInstallPWAPrompt; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(34412);
// EXTERNAL MODULE: ../shared/utils/console.js
var console = __webpack_require__(65795);
// EXTERNAL MODULE: ../shared/utils/sw/sw.constants.js
var sw_constants = __webpack_require__(34855);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
// EXTERNAL MODULE: ../shared/store/toc/selectors.js
var selectors = __webpack_require__(8962);
// EXTERNAL MODULE: ../shared/store/sw/selectorIsWebsiteDownloaded.js
var selectorIsWebsiteDownloaded = __webpack_require__(27611);
// EXTERNAL MODULE: ../shared/store/sw/actions.js
var actions = __webpack_require__(38857);
// EXTERNAL MODULE: ../shared/store/system/actions.js
var system_actions = __webpack_require__(93893);
// EXTERNAL MODULE: ../shared/utils/storage/storage.js
var storage = __webpack_require__(12202);
// EXTERNAL MODULE: ../shared/utils/dom.js
var dom = __webpack_require__(62330);
// EXTERNAL MODULE: ../shared/utils/storage/storage.constants.js
var storage_constants = __webpack_require__(79384);
// EXTERNAL MODULE: ../shared/utils/sw/sw.js + 1 modules
var sw = __webpack_require__(3359);
// EXTERNAL MODULE: ../shared/utils/assembly.js
var assembly = __webpack_require__(76732);
// EXTERNAL MODULE: ../shared/hooks/pwa/pwa.js
var pwa = __webpack_require__(79427);
// EXTERNAL MODULE: ../shared/store/mainTree/hooks-selectors.js
var hooks_selectors = __webpack_require__(13812);
// EXTERNAL MODULE: ../main/package.json
var main_package = __webpack_require__(59798);
// EXTERNAL MODULE: ../node_modules/unzip-js/src/index.js
var src = __webpack_require__(47989);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ../shared/api/content/books/constants.js
var constants = __webpack_require__(67504);
// EXTERNAL MODULE: ../shared/utils/content/content.constants.js
var content_constants = __webpack_require__(5626);
// EXTERNAL MODULE: ../shared/api/content/books/utils.js
var utils = __webpack_require__(26343);
;// CONCATENATED MODULE: ../shared/utils/zip.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }







var scope = "ZIP";
var parseZipBlob = function parseZipBlob(blob) {
  return new Promise(function (resolve, reject) {
    src_default()(blob, function (err, zipFile) {
      if (err) {
        (0,console/* consoleLogError */.aw)(scope, "unzip error", {
          err: err,
          zipFile: zipFile
        });
        reject(err);
        return;
      }

      zipFile.readEntries(function (err, entries) {
        if (err) {
          (0,console/* consoleLogError */.aw)(scope, "read entries error", {
            err: err,
            entries: entries
          });
          reject(err);
          return;
        }

        var promisesEntriesParsing = [];
        entries.forEach(function (entry) {
          promisesEntriesParsing.push(new Promise(function (resolve, reject) {
            zipFile.readEntryData(entry, false, function (err, readStream) {
              if (err) {
                (0,console/* consoleLogError */.aw)(scope, "read entry data error", {
                  err: err,
                  readStream: readStream
                });
                reject(err);
                return;
              }

              var strEntryData = "";
              readStream.on("data", function (chunk) {
                strEntryData += chunk.toString();
              });
              readStream.on("error", function (err) {
                (0,console/* consoleLogError */.aw)(scope, "read stream error", {
                  err: err,
                  readStream: readStream
                });
                reject([entry.name, err]);
              });
              readStream.on("end", function () {
                resolve([entry.name, strEntryData]);
              });
            });
          }));
        });
        Promise.all(promisesEntriesParsing).then(resolve);
      });
    });
  });
};
var parseZipBookDownload = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
    var entries, chaptersParas, book, toc, _iterator, _step, _step$value2, filename, contents, match;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return parseZipBlob(data);

        case 2:
          entries = _context.sent;
          chaptersParas = {};
          _iterator = _createForOfIteratorHelper(entries);

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              _step$value2 = _slicedToArray(_step.value, 2), filename = _step$value2[0], contents = _step$value2[1];

              if (filename === constants/* FILES_DOWNLOAD_BOOK.BOOK */.ux.BOOK) {
                book = JSON.parse(contents);
              } else if (filename === constants/* FILES_DOWNLOAD_BOOK.TOC */.ux.TOC) {
                toc = JSON.parse(contents);
              } else {
                if (filename) {
                  match = filename.match(content_constants/* paraWithoutPrefixRegExp */.ww);

                  if (match && match[2]) {
                    // match[2] - para number
                    chaptersParas[match[2]] = JSON.parse(contents);
                  }
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return _context.abrupt("return", {
            book: (0,utils/* convertBook */.RC)(book),
            toc: (0,content/* makeChapterTree */.o)(toc).chapters,
            chaptersParas: chaptersParas
          });

        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function parseZipBookDownload(_x) {
    return _ref.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ../shared/store/sw/selectorIsSWRegistered.js
var selectorIsSWRegistered = __webpack_require__(93662);
// EXTERNAL MODULE: ../shared/store/sw/selectorIsSWInit.js
var selectorIsSWInit = __webpack_require__(49037);
// EXTERNAL MODULE: ../shared/store/sw/selectorIsSWInitStatusRetrieved.js
var selectorIsSWInitStatusRetrieved = __webpack_require__(93242);
// EXTERNAL MODULE: ../shared/store/sw/constants.js
var store_sw_constants = __webpack_require__(59079);
;// CONCATENATED MODULE: ../shared/store/sw/selectorIsErrorWebsiteDownload.js

var selectorIsErrorWebsiteDownload = function selectorIsErrorWebsiteDownload(state) {
  return state[store_sw_constants/* KEY_REDUCER_SW */.U].isErrorWebsiteDownload;
};
// EXTERNAL MODULE: ../shared/store/sw/selectorWebsiteUrlsForOfflineUse.js
var selectorWebsiteUrlsForOfflineUse = __webpack_require__(53201);
// EXTERNAL MODULE: ../shared/store/sw/selectorIsDownloadingWebsite.js
var selectorIsDownloadingWebsite = __webpack_require__(4061);
// EXTERNAL MODULE: ../shared/store/sw/selectorDownloadedBooksIds.js
var selectorDownloadedBooksIds = __webpack_require__(4586);
;// CONCATENATED MODULE: ../shared/hooks/pwa/sw.js
function sw_typeof(obj) { "@babel/helpers - typeof"; return sw_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, sw_typeof(obj); }

function sw_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ sw_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == sw_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function sw_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function sw_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { sw_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { sw_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


























var IS_CONSOLE_LOGS = (0,assembly/* isProduction */.yv)() || false;
var sw_scope = "SW shared";
var useRegisterServiceWorker = function useRegisterServiceWorker(scriptURL) {
  var dispatch = (0,es/* useDispatch */.I0)();
  (0,react.useEffect)(function () {
    (0,sw/* registerServiceWorker */.$J)(scriptURL + "?v=" + main_package.version, function (registration) {
      dispatch(actions/* _sharedActionsSW.updateIsSWRegistered */.m.updateIsSWRegistered(true));

      if (IS_CONSOLE_LOGS) {
        (0,console/* consoleLogSuccess */.UA)(sw_scope, "Registration successful! Scope: ", registration.scope);
      }
    }, function (err) {
      (0,console/* consoleLogError */.aw)(sw_scope, "Registration failed. Error: ", err);
    }, function () {
      dispatch(actions/* _sharedActionsSW.updateIsSWInit */.m.updateIsSWInit(true));
    });
  }, [scriptURL]);
};

var createSWMessageListener = function createSWMessageListener(dispatch) {
  return /*#__PURE__*/function () {
    var _ref = sw_asyncToGenerator( /*#__PURE__*/sw_regeneratorRuntime().mark(function _callee(event) {
      var value, cacheName, namedCachesNames;
      return sw_regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (IS_CONSOLE_LOGS) {
              (0,console/* consoleLogInfo */.jn)(sw_scope, "Message event: ", event.data);
            }

            _context.t0 = event.data.type;
            _context.next = _context.t0 === sw_constants/* SW_EVENTS_TYPES_FROM.UPDATE_NAMED_CACHE_KEYS_AVAILABLE */.vK.UPDATE_NAMED_CACHE_KEYS_AVAILABLE ? 5 : _context.t0 === sw_constants/* SW_EVENTS_TYPES_FROM.GET_FROM_NAMED_CACHE_SUCCESS */.vK.GET_FROM_NAMED_CACHE_SUCCESS ? 7 : _context.t0 === sw_constants/* SW_EVENTS_TYPES_FROM.START_DOWNLOAD_URLS */.vK.START_DOWNLOAD_URLS ? 15 : _context.t0 === sw_constants/* SW_EVENTS_TYPES_FROM.CANCEL_DOWNLOAD_URLS */.vK.CANCEL_DOWNLOAD_URLS ? 15 : _context.t0 === sw_constants/* SW_EVENTS_TYPES_FROM.ERROR_DOWNLOAD_URLS */.vK.ERROR_DOWNLOAD_URLS ? 15 : _context.t0 === sw_constants/* SW_EVENTS_TYPES_FROM.END_DOWNLOAD_URLS */.vK.END_DOWNLOAD_URLS ? 15 : _context.t0 === sw_constants/* SW_EVENTS_TYPES_FROM.DOWNLOAD_URLS_PROGRESS */.vK.DOWNLOAD_URLS_PROGRESS ? 20 : _context.t0 === sw_constants/* SW_EVENTS_TYPES_FROM.GET_INIT_DATA_SUCCESS */.vK.GET_INIT_DATA_SUCCESS ? 22 : 27;
            break;

          case 5:
            dispatch(actions/* _sharedActionsSW.updateKeysAvailable */.m.updateKeysAvailable(event.data.data.cacheName, event.data.data.keys));
            return _context.abrupt("break", 27);

          case 7:
            value = event.data.data.value;
            cacheName = event.data.data.cacheName;

            if (!(cacheName === sw_constants/* NAMED_CACHE_NAME.BOOK_DATA */.jy.BOOK_DATA)) {
              _context.next = 13;
              break;
            }

            _context.next = 12;
            return parseZipBookDownload(value);

          case 12:
            value = _context.sent;

          case 13:
            dispatch(actions/* _sharedActionsSW.pullSuccess */.m.pullSuccess(event.data.data.cacheName, event.data.data.key, value));
            return _context.abrupt("break", 27);

          case 15:
            if (event.data.type !== sw_constants/* SW_EVENTS_TYPES_FROM.ERROR_DOWNLOAD_URLS */.vK.ERROR_DOWNLOAD_URLS) {
              dispatch(actions/* _sharedActionsSW.updateIsWebsiteUrlsDownloading */.m.updateIsWebsiteUrlsDownloading(event.data.type === sw_constants/* SW_EVENTS_TYPES_FROM.START_DOWNLOAD_URLS */.vK.START_DOWNLOAD_URLS));
            }

            if (event.data.type === sw_constants/* SW_EVENTS_TYPES_FROM.END_DOWNLOAD_URLS */.vK.END_DOWNLOAD_URLS || event.data.type === sw_constants/* SW_EVENTS_TYPES_FROM.CANCEL_DOWNLOAD_URLS */.vK.CANCEL_DOWNLOAD_URLS) {
              dispatch(actions/* _sharedActionsSW.updateWebsiteUrlsStatuses */.m.updateWebsiteUrlsStatuses(event.data.data));
            }

            if (event.data.type === sw_constants/* SW_EVENTS_TYPES_FROM.ERROR_DOWNLOAD_URLS */.vK.ERROR_DOWNLOAD_URLS) {
              dispatch(actions/* _sharedActionsSW.updateIsErrorWebsiteDownload */.m.updateIsErrorWebsiteDownload(true));
            }

            if (event.data.type === sw_constants/* SW_EVENTS_TYPES_FROM.CANCEL_DOWNLOAD_URLS */.vK.CANCEL_DOWNLOAD_URLS) {
              dispatch(system_actions/* _sharedActionsSystem.toast */.g.toast("@sw:downloadCancelled"));
            }

            return _context.abrupt("break", 27);

          case 20:
            dispatch(actions/* _sharedActionsSW.updateWebsiteUrlsProgress */.m.updateWebsiteUrlsProgress(event.data.data));
            return _context.abrupt("break", 27);

          case 22:
            namedCachesNames = Object.keys(event.data.data.namedCaches);
            namedCachesNames.forEach(function (cacheKey) {
              dispatch(actions/* _sharedActionsSW.updateKeysAvailable */.m.updateKeysAvailable(cacheKey, event.data.data.namedCaches[cacheKey]));
            });
            dispatch(actions/* _sharedActionsSW.updateWebsiteUrlsStatuses */.m.updateWebsiteUrlsStatuses(event.data.data.urlsStatuses));
            dispatch(actions/* _sharedActionsSW.updateIsSWInitDataRetrieved */.m.updateIsSWInitDataRetrieved(true));
            return _context.abrupt("break", 27);

          case 27:
            _context.next = 32;
            break;

          case 29:
            _context.prev = 29;
            _context.t1 = _context["catch"](0);
            (0,console/* consoleLogError */.aw)(sw_scope, "Error parsing event data: ", _context.t1);

          case 32:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 29]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var useHandleSWMessages = function useHandleSWMessages() {
  var dispatch = (0,es/* useDispatch */.I0)();
  (0,react.useEffect)(function () {
    var _global$window, _global$window$naviga, _global$window$naviga2;

    var listener = createSWMessageListener(dispatch);
    (_global$window = __webpack_require__.g.window) === null || _global$window === void 0 ? void 0 : (_global$window$naviga = _global$window.navigator) === null || _global$window$naviga === void 0 ? void 0 : (_global$window$naviga2 = _global$window$naviga.serviceWorker) === null || _global$window$naviga2 === void 0 ? void 0 : _global$window$naviga2.addEventListener("message", listener);
    return function () {
      var _global$window2, _global$window2$navig, _global$window2$navig2;

      (_global$window2 = __webpack_require__.g.window) === null || _global$window2 === void 0 ? void 0 : (_global$window2$navig = _global$window2.navigator) === null || _global$window2$navig === void 0 ? void 0 : (_global$window2$navig2 = _global$window2$navig.serviceWorker) === null || _global$window2$navig2 === void 0 ? void 0 : _global$window2$navig2.removeEventListener("message", listener);
    };
  }, []);
};
var tocEmpty = [];
var useBookWithSWFallback = function useBookWithSWFallback(id) {
  var dispatch = (0,es/* useDispatch */.I0)();
  var strBookId = id ? (0,content/* getBookIdNumber */.o8)((0,content/* getBookIdWithPrefix */.NR)(id)).toString() : "";
  var bookRedux = (0,hooks_selectors/* useSelectorBook */.j)(strBookId);
  var tocItems = (0,es/* useSelector */.v9)(selectors/* selectorTocItems */.L);
  var downloadedBooksIds = (0,es/* useSelector */.v9)(selectorDownloadedBooksIds/* selectorDownloadedBooksIds */.F);
  var toc = bookRedux && tocItems[bookRedux.book_id] || tocEmpty; // Pulls a book from SW.

  (0,react.useEffect)(function () {
    if (!bookRedux && strBookId && downloadedBooksIds.includes(strBookId)) {
      dispatch(actions/* _sharedActionsSW.pullBookData */.m.pullBookData(strBookId));
    }
  }, [bookRedux, strBookId, downloadedBooksIds]);
  return {
    book: bookRedux,
    toc: toc
  };
};
var useStashInstallPWAPrompt = function useStashInstallPWAPrompt() {
  // Stash install PWA prompt to a global variable.
  (0,react.useEffect)(function () {
    var listener = function listener(e) {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault(); // Stash the event so it can be triggered later.

      __webpack_require__.g.window[sw_constants/* WINDOW_KEY_INSTALL_EVENT */.RY] = e;
      (0,dom/* dispatchCustomEvent */.hb)(sw_constants/* CUSTOM_EVENT_TYPE_STASH_INSTALL_PROMPT */.XQ);
    };

    window.addEventListener("beforeinstallprompt", listener);
    return function () {
      window.removeEventListener("beforeinstallprompt", listener);
    };
  }, []);
};
var useAutoDownloadWebsite = function useAutoDownloadWebsite() {
  var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var dispatch = (0,es/* useDispatch */.I0)();
  var isSWInit = (0,es/* useSelector */.v9)(selectorIsSWInit/* selectorIsSWInit */.u);
  var isSWRegistered = (0,es/* useSelector */.v9)(selectorIsSWRegistered/* selectorIsSWRegistered */.Z);
  var isSWInitStatusRetrieved = (0,es/* useSelector */.v9)(selectorIsSWInitStatusRetrieved/* selectorIsSWInitStatusRetrieved */._);
  var urlsForOfflineUse = (0,es/* useSelector */.v9)(selectorWebsiteUrlsForOfflineUse/* selectorWebsiteUrlsForOfflineUse */.q);
  var isWebsiteDownloaded = (0,es/* useSelector */.v9)(selectorIsWebsiteDownloaded/* selectorIsWebsiteDownloaded */.W);
  var isErrorWebsiteDownload = (0,es/* useSelector */.v9)(selectorIsErrorWebsiteDownload);
  var isUrlsDownloading = (0,es/* useSelector */.v9)(selectorIsDownloadingWebsite/* selectorIsDownloadingWebsite */.H);
  var isStandAlone = (0,pwa/* useIsStandAlone */.J)(); // Asks SW to return status data.

  (0,react.useEffect)(function () {
    if (!enabled) {
      return;
    }

    if (isSWInit && isSWRegistered && urlsForOfflineUse.length) {
      dispatch(actions/* _sharedActionsSW.getInitStatus */.m.getInitStatus());
    }
  }, [enabled, isSWInit, isSWRegistered, urlsForOfflineUse]); // Downloads website.

  (0,react.useEffect)(function () {
    if (!enabled) {
      return;
    }

    var isUserCanceledDownloadAtLeastOnce = (0,storage/* getLocalStorageItem */.le)(sw_constants/* STORAGE_KEY_IS_USER_CANCELED_AUTO_DOWNLOADING */.Dr);

    if (isStandAlone && isSWInitStatusRetrieved && !isErrorWebsiteDownload && !isWebsiteDownloaded && !isUrlsDownloading && !isUserCanceledDownloadAtLeastOnce) {
      dispatch(actions/* _sharedActionsSW.downloadWebsite */.m.downloadWebsite());
    }
  }, [isStandAlone, isUrlsDownloading, isErrorWebsiteDownload, isWebsiteDownloaded, isSWInitStatusRetrieved, urlsForOfflineUse, enabled]);
};
var useClearSWDataWhenVersionsDiffers = function useClearSWDataWhenVersionsDiffers() {
  // Removes cache urls if the app version became different.
  (0,react.useEffect)(function () {
    var listener = function listener() {
      (0,sw/* postSWMessageClearWebsiteData */.iK)();
    };

    window.addEventListener(storage_constants/* CUSTOM_EVENT_APP_VERSION_DIFFERS */.t0, listener);
    return function () {
      window.removeEventListener(storage_constants/* CUSTOM_EVENT_APP_VERSION_DIFFERS */.t0, listener);
    };
  }, []); // Removes cache urls if the app version became different.
  // Removes named cache(s) contents if the content version became different.

  (0,react.useEffect)(function () {
    var listener = function listener() {
      (0,sw/* postSWMessageClearNamedCaches */.ZM)();
    };

    window.addEventListener(storage_constants/* CUSTOM_EVENT_CONTENT_VERSION_DIFFERS */.w_, listener);
    return function () {
      window.removeEventListener(storage_constants/* CUSTOM_EVENT_CONTENT_VERSION_DIFFERS */.w_, listener);
    };
  }, []);
};

/***/ }),

/***/ 67766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useLocalStorage; }
/* harmony export */ });
/* unused harmony exports useStorage, useSessionStorage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12202);
/* harmony import */ var _utils_assembly__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76732);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var useStorage = function useStorage(storage, key, initialValue, stringify) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
    return (0,_utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .getStorageItem */ .qn)(storage, key, initialValue, stringify);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      storedValue = _useState2[0],
      setStoredValue = _useState2[1];

  var setValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (value) {
    var stringify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var valueToStore;

    try {
      setStoredValue(function (valueOld) {
        valueToStore = value instanceof Function ? value(valueOld) : value;
        (0,_utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .setStorageItem */ .Nh)(storage, key, valueToStore, stringify);
        return valueToStore;
      });
    } catch (error) {
      if ((0,_utils_assembly__WEBPACK_IMPORTED_MODULE_2__/* .isDevelopment */ .yG)()) {
        console.log("%c[Store] Error storing " + key, "background: red; color: white; font-size: 18px;", {
          key: key,
          value: value,
          valueToStore: valueToStore,
          error: error
        });
      }
    }
  }, [key, storage]);
  return [storedValue, setValue];
};
var useLocalStorage = function useLocalStorage(key, initialValue, stringify) {
  return useStorage(_utils_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .localStorageSafe */ .NE, key, initialValue, stringify);
};
var useSessionStorage = function useSessionStorage(key, initialValue, stringify) {
  return useStorage(sessionStorageSafe, key, initialValue, stringify);
};

/***/ }),

/***/ 65482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useCookiesWithOptions; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/cookie/index.js
var cookie = __webpack_require__(34882);
;// CONCATENATED MODULE: ../node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return cookie/* parse */.Q(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

;// CONCATENATED MODULE: ../node_modules/universal-cookie/es6/Cookies.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie/* parse */.Q(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ var es6_Cookies = (Cookies);

;// CONCATENATED MODULE: ../node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = (es6_Cookies);

;// CONCATENATED MODULE: ../node_modules/react-cookie/es6/Cookies.js

/* harmony default export */ var react_cookie_es6_Cookies = (es6);

;// CONCATENATED MODULE: ../node_modules/react-cookie/es6/CookiesContext.js


var CookiesContext = react.createContext(new react_cookie_es6_Cookies());
var Provider = CookiesContext.Provider, CookiesContext_Consumer = CookiesContext.Consumer;
/* harmony default export */ var es6_CookiesContext = (CookiesContext);

;// CONCATENATED MODULE: ../node_modules/react-cookie/es6/CookiesProvider.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var CookiesProvider = /** @class */ (function (_super) {
    __extends(CookiesProvider, _super);
    function CookiesProvider(props) {
        var _this = _super.call(this, props) || this;
        if (props.cookies) {
            _this.cookies = props.cookies;
        }
        else {
            _this.cookies = new es6();
        }
        return _this;
    }
    CookiesProvider.prototype.render = function () {
        return react.createElement(Provider, { value: this.cookies }, this.props.children);
    };
    return CookiesProvider;
}(react.Component));
/* harmony default export */ var es6_CookiesProvider = ((/* unused pure expression or super */ null && (CookiesProvider)));

;// CONCATENATED MODULE: ../node_modules/react-cookie/es6/withCookies.js
var withCookies_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var withCookies_assign = (undefined && undefined.__assign) || function () {
    withCookies_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return withCookies_assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


// Only way to make function modules work with both TypeScript and Rollup
var hoistStatics = __webpack_require__(55839);
function withCookies(WrappedComponent) {
    // @ts-ignore
    var name = WrappedComponent.displayName || WrappedComponent.name;
    var CookieWrapper = /** @class */ (function (_super) {
        withCookies_extends(CookieWrapper, _super);
        function CookieWrapper() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.onChange = function () {
                // Make sure to update children with new values
                _this.forceUpdate();
            };
            return _this;
        }
        CookieWrapper.prototype.listen = function () {
            this.props.cookies.addChangeListener(this.onChange);
        };
        CookieWrapper.prototype.unlisten = function (cookies) {
            (cookies || this.props.cookies).removeChangeListener(this.onChange);
        };
        CookieWrapper.prototype.componentDidMount = function () {
            this.listen();
        };
        CookieWrapper.prototype.componentDidUpdate = function (prevProps) {
            if (prevProps.cookies !== this.props.cookies) {
                this.unlisten(prevProps.cookies);
                this.listen();
            }
        };
        CookieWrapper.prototype.componentWillUnmount = function () {
            this.unlisten();
        };
        CookieWrapper.prototype.render = function () {
            var _a = this.props, forwardedRef = _a.forwardedRef, cookies = _a.cookies, restProps = __rest(_a, ["forwardedRef", "cookies"]);
            var allCookies = cookies.getAll();
            return (React.createElement(WrappedComponent, withCookies_assign({}, restProps, { ref: forwardedRef, cookies: cookies, allCookies: allCookies })));
        };
        CookieWrapper.displayName = "withCookies(" + name + ")";
        CookieWrapper.WrappedComponent = WrappedComponent;
        return CookieWrapper;
    }(React.Component));
    var ForwardedComponent = React.forwardRef(function (props, ref) {
        return (React.createElement(Consumer, null, function (cookies) { return (React.createElement(CookieWrapper, withCookies_assign({ cookies: cookies }, props, { forwardedRef: ref }))); }));
    });
    ForwardedComponent.displayName = CookieWrapper.displayName;
    ForwardedComponent.WrappedComponent = CookieWrapper.WrappedComponent;
    return hoistStatics(ForwardedComponent, WrappedComponent);
}

;// CONCATENATED MODULE: ../node_modules/react-cookie/es6/useCookies.js


function useCookies(dependencies) {
    var cookies = (0,react.useContext)(es6_CookiesContext);
    if (!cookies) {
        throw new Error('Missing <CookiesProvider>');
    }
    var initialCookies = cookies.getAll();
    var _a = (0,react.useState)(initialCookies), allCookies = _a[0], setCookies = _a[1];
    var previousCookiesRef = (0,react.useRef)(allCookies);
    (0,react.useEffect)(function () {
        function onChange() {
            var newCookies = cookies.getAll();
            if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
                setCookies(newCookies);
            }
            previousCookiesRef.current = newCookies;
        }
        cookies.addChangeListener(onChange);
        return function () {
            cookies.removeChangeListener(onChange);
        };
    }, [cookies]);
    var setCookie = (0,react.useMemo)(function () { return cookies.set.bind(cookies); }, [cookies]);
    var removeCookie = (0,react.useMemo)(function () { return cookies.remove.bind(cookies); }, [cookies]);
    return [allCookies, setCookie, removeCookie];
}
function shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) {
        return true;
    }
    for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
        var dependency = dependencies_1[_i];
        if (newCookies[dependency] !== oldCookies[dependency]) {
            return true;
        }
    }
    return false;
}

;// CONCATENATED MODULE: ../node_modules/react-cookie/es6/index.js





// EXTERNAL MODULE: ../shared/utils/storage/storage.constants.js
var storage_constants = __webpack_require__(79384);
;// CONCATENATED MODULE: ../shared/hooks/useCookiesWithOptions.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var useCookiesWithOptions = function useCookiesWithOptions(dependencies) {
  var instance = useCookies(dependencies);
  var setFn = instance[1];
  var setFnWithOptions = (0,react.useCallback)(function (name, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    return setFn(name, value, options ? _objectSpread(_objectSpread({}, storage_constants/* cookieConfig */.SC), options) : storage_constants/* cookieConfig */.SC);
  }, [setFn]);
  return [instance[0], setFnWithOptions];
};

/* harmony default export */ var hooks_useCookiesWithOptions = (useCookiesWithOptions);

/***/ }),

/***/ 34289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useDeviceDetect": function() { return /* binding */ useDeviceDetect; }
/* harmony export */ });
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56253);

var useDeviceDetect = function useDeviceDetect() {
  return {
    isIOS: react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isIOS */ .gn,
    isRealMobile: react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isMobile */ .tq,
    isRealTablet: react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isTablet */ .Em,
    isRealMobileOnly: react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isMobileOnly */ .UA,
    isRealMobileOrTablet: react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isMobile */ .tq || react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isTablet */ .Em,
    osVersion: react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .osVersion */ .MM
  };
};

/***/ }),

/***/ 47630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78889);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }



/**
 * @param {*} isFocus - defines whether focusing is enabled or not.
 * @param elementRef - focusable element or element with focusable children.
 * @param {?{
 *   isScrollFocusedElementIntoView?: boolean,
 *   isFocusOnFirstIteration?: boolean,
 *   onAfterFocus?: () => void,
 * }} options
 */

var useFocus = function useFocus(isFocus, elementRef, options) {
  var isScrollFocusedElementIntoView = true;
  var isFocusOnFirstIteration = true;
  var onAfterFocus = undefined;

  if (options) {
    isScrollFocusedElementIntoView = options.isScrollFocusedElementIntoView;
    isFocusOnFirstIteration = options.isFocusOnFirstIteration;
    onAfterFocus = options.onAfterFocus;
  }

  var refIsFirstIteration = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true); // Focuses itself or a suitable element inside after opened.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var elFocusedPrev;

    if (refIsFirstIteration.current) {
      refIsFirstIteration.current = false;

      if (!isFocusOnFirstIteration) {
        return undefined;
      }
    }

    if (isFocus && elementRef.current) {
      elFocusedPrev = document.activeElement;

      var focusableElements = _toConsumableArray(elementRef.current.querySelectorAll(_utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_1__/* .selectorFocusableElements */ .yX));

      var elFocusFirst = focusableElements.find(function (el) {
        return el.hasAttribute("data-focus-first");
      });

      if (elFocusFirst) {
        (0,_utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_1__/* .focusElement */ .C5)([elFocusFirst], !isScrollFocusedElementIntoView);
      } else if (focusableElements.length) {
        (0,_utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_1__/* .focusElement */ .C5)(focusableElements, !isScrollFocusedElementIntoView);
      } else {
        (0,_utils_keyboard_navigation_keyboard_navigation__WEBPACK_IMPORTED_MODULE_1__/* .focusElement */ .C5)([elementRef.current], !isScrollFocusedElementIntoView);
      }

      if (onAfterFocus) {
        onAfterFocus();
      }
    }

    return function () {
      if (isFocus && elFocusedPrev) {
        elFocusedPrev.focus();
      }
    };
  }, [isFocus]);
};

/* harmony default export */ __webpack_exports__["Z"] = (useFocus);

/***/ }),

/***/ 77706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _shared_utils_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62330);


var CSS_VAR_APP_PADDING_RIGHT = "--app__padding-right";

var setAppPaddingRight = function setAppPaddingRight(size) {
  document.body.style.setProperty(CSS_VAR_APP_PADDING_RIGHT, size);
};

var useLockBodyScroll = function useLockBodyScroll(lock) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var overflowValueInitial, paddingRightValueInitial;
    var isScrollbarTakesContentPlace, scrollBarWidth;
    var isExited = false;

    if (lock) {
      // {setTimeout} is needed, because:
      // Open popup 1 -> locked for popup 1.
      // Open popup 2 without closing popup 1 -> locked for popup 2, unlocked for popup 1.
      setTimeout(function () {
        var elBody = document.body;

        if (isExited || elBody.offsetHeight >= elBody.scrollHeight) {
          return;
        }

        var styleBodyInitial = window.getComputedStyle(elBody);
        overflowValueInitial = styleBodyInitial.overflow;
        paddingRightValueInitial = styleBodyInitial.getPropertyValue(CSS_VAR_APP_PADDING_RIGHT);
        var scrollBarInfo = (0,_shared_utils_dom__WEBPACK_IMPORTED_MODULE_1__/* .getBrowserScrollbarInfo */ .Ke)();
        isScrollbarTakesContentPlace = scrollBarInfo.isTakesContentPlace;
        scrollBarWidth = scrollBarInfo.width;
        document.body.style.overflow = "hidden";

        if (isScrollbarTakesContentPlace) {
          setAppPaddingRight(scrollBarWidth + "px");
        }
      });
    }

    return function () {
      if (lock) {
        isExited = true;
        document.body.style.overflow = overflowValueInitial;

        if (isScrollbarTakesContentPlace) {
          setAppPaddingRight(paddingRightValueInitial);
        }
      }
    };
  }, [lock]);
};

/* harmony default export */ __webpack_exports__["Z"] = (useLockBodyScroll);

/***/ }),

/***/ 60370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _api_cPanel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42304);
/* harmony import */ var _contexts_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26933);


var DIALOG_ID = "login";

var useLogin = function useLogin() {
  var _useModalContext = (0,_contexts_modal__WEBPACK_IMPORTED_MODULE_1__/* .useModalContext */ .v)(),
      showConfirm = _useModalContext.showConfirm,
      hideDialog = _useModalContext.hideDialog,
      checkDialogId = _useModalContext.checkDialogId;

  var openLoginWindow = function openLoginWindow(onAuthWindowClose) {
    var authWindow = (0,_api_cPanel__WEBPACK_IMPORTED_MODULE_0__/* .makeOAuthRequest */ .d)();

    var checkIfWindowAuthClosed = function checkIfWindowAuthClosed() {
      if (authWindow !== null && authWindow !== void 0 && authWindow.closed) {
        clearInterval(timer);

        if (onAuthWindowClose) {
          onAuthWindowClose();
        }

        if (checkDialogId(DIALOG_ID)) {
          hideDialog();
        }
      }
    };

    var timer = setInterval(checkIfWindowAuthClosed, 500);
  };

  var showLoginConfirm = function showLoginConfirm(_onCancel, onConfirm) {
    var handleConfirm = function handleConfirm() {
      openLoginWindow();

      if (onConfirm) {
        onConfirm();
      }
    };

    showConfirm("pleaseSignIn", "enterToUse", handleConfirm, {
      dialogId: DIALOG_ID,
      translateMessage: true,
      positiveBtn: "signIn",
      onCancel: function onCancel() {
        if (_onCancel) {
          _onCancel.apply(void 0, arguments);
        }

        return true; // to auto-close the modal
      }
    });
  };

  return {
    openLoginWindow: openLoginWindow,
    showLoginConfirm: showLoginConfirm
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useLogin);

/***/ }),

/***/ 38295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ MEDIA_QUERIES; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


var sassVariables = {
  tablet: 768,
  desktop: 1024
};
var MEDIA_QUERIES = {
  tabletOnly: "(min-width: " + (sassVariables.tablet - 1) + "px and (max-width:" + (sassVariables.desktop - 1) + "px)",
  untilTablet: "(max-width: ".concat(sassVariables.tablet - 1, "px)"),
  untilDesktopAndDesktop: "(max-width: ".concat(sassVariables.desktop, "px)"),
  canHover: "(hover: hover) and (pointer: fine)",
  standAlone: "(display-mode: standalone), (display-mode: minimal-ui)"
};

var isApiSupported = function isApiSupported(api) {
  return  true ? api in window : 0;
};

var isClient = true;

var useMediaQuery = function useMediaQuery(mediaQuery) {
  var canMatchMedia = true;

  if (!isClient || !isApiSupported("matchMedia")) {
    // eslint-disable-next-line no-console
    canMatchMedia = false;
  }

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(canMatchMedia ? !!window.matchMedia(mediaQuery).matches : null),
      _useState2 = _slicedToArray(_useState, 2),
      isVerified = _useState2[0],
      setIsVerified = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var mediaQueryList = window.matchMedia(mediaQuery);

    var documentChangeHandler = function documentChangeHandler() {
      return setIsVerified(!!mediaQueryList.matches);
    };

    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener("change", documentChangeHandler);
    } else if (mediaQueryList.addListener) {
      mediaQueryList.addListener(documentChangeHandler);
    }

    documentChangeHandler();
    return function () {
      if (mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener("change", documentChangeHandler);
      } else if (mediaQueryList.removeListener) {
        mediaQueryList.removeListener(documentChangeHandler);
      }
    };
  }, [mediaQuery]);
  return isVerified;
};

/* harmony default export */ __webpack_exports__["Z"] = (useMediaQuery);

/***/ }),

/***/ 77423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useObserverPattern; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }


/**
 * @returns {{
 * notifyObserverListeners: (function(...[*]): any[]),
 * removeObserverListener: (function(*=): void),
 * addObserverListener: (function(*): void)
 * }}
 */

var useObserverPattern = function useObserverPattern() {
  var refListeners = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]);

  var addListener = function addListener(listener) {
    refListeners.current = [].concat(_toConsumableArray(refListeners.current), [listener]);
  };

  var removeListener = function removeListener(listener) {
    refListeners.current = refListeners.current.filter(function (oldListener) {
      return oldListener !== listener;
    });
  };

  var notifyListeners = function notifyListeners() {
    var results = [];

    var _iterator = _createForOfIteratorHelper(refListeners.current),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var listener = _step.value;

        if (typeof listener === "function") {
          results.push(listener.apply(void 0, arguments));
        } else {
          results.push(undefined);
          removeListener(listener);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return results;
  };

  return {
    addObserverListener: addListener,
    removeObserverListener: removeListener,
    notifyObserverListeners: notifyListeners
  };
};

/***/ }),

/***/ 12651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34412);
/* harmony import */ var _store_system_selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91809);
/* harmony import */ var _store_system_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93893);




var useOnlineOnlyHandler = function useOnlineOnlyHandler() {
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
  var onLine = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(_store_system_selectors__WEBPACK_IMPORTED_MODULE_1__/* .selectorSystemOnLine */ .JU);
  return function (cb, cbOffline) {
    return function () {
      if (onLine) {
        cb.apply(void 0, arguments);
      } else {
        if (cbOffline) {
          cbOffline.apply(void 0, arguments);
        }

        dispatch(_store_system_actions__WEBPACK_IMPORTED_MODULE_2__/* ._sharedActionsSystem.toast */ .g.toast(["@sw:noInternetConnection", ". ", "@sw:featureNotAvailable", "."]));
      }
    };
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useOnlineOnlyHandler);

/***/ }),

/***/ 98754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ usePopup; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


var usePopup = function usePopup() {
  var closeOnPathnameChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var openPopup = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    var _e$detail;

    setAnchorEl(((_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.target) || e.currentTarget || e.target);
  }, []);
  var closePopup = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    setAnchorEl(null);
  }, []);
  var isShown = !!anchorEl;
  var pathname = "window" in __webpack_require__.g && window.location.pathname; // Close popup on route change.

  var refIsFirstCall = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!closeOnPathnameChange) {
      return;
    }

    if (refIsFirstCall.current) {
      refIsFirstCall.current = false;
      return;
    }

    closePopup();
  }, [pathname, closePopup, closeOnPathnameChange]);
  return {
    anchorEl: anchorEl,
    isShown: isShown,
    openPopup: openPopup,
    closePopup: closePopup
  };
};

/***/ }),

/***/ 40462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);

/**
 * @param {T & {[string]: any}} data
 * @returns {{current: T & {[string]: any}}}
 */

var useRefData = function useRefData(data) {
  var refData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(data);

  for (var key in data) {
    refData.current[key] = data[key];
  }

  return refData;
};

/* harmony default export */ __webpack_exports__["Z"] = (useRefData);

/***/ }),

/***/ 59730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);

var CLASS_NAME = "is-any-popup-like-window-opened"; // Note: Use search through the project to find the usage cases.

var useRegulateGlobalClassNameIsAnyPopupLikeWindowOpened = function useRegulateGlobalClassNameIsAnyPopupLikeWindowOpened(isWindowOpened) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var isExited = false,
        isWasOpenedBefore,
        root;

    if (isWindowOpened) {
      // {setTimeout} is needed, because:
      // Open popup 1 -> locked for popup 1.
      // Open popup 2 without closing popup 1 -> locked for popup 2, unlocked for popup 1.
      setTimeout(function () {
        if (!isExited) {
          root = document.documentElement;

          if (root) {
            isWasOpenedBefore = root.classList.contains(CLASS_NAME);

            if (!isWasOpenedBefore) {
              root.classList.add(CLASS_NAME);
            }
          }
        }
      });
    }

    return function () {
      if (isWindowOpened) {
        isExited = true;

        if (!isWasOpenedBefore && root) {
          root.classList.remove(CLASS_NAME);
        }
      }
    };
  }, [isWindowOpened]);
};

/* harmony default export */ __webpack_exports__["Z"] = (useRegulateGlobalClassNameIsAnyPopupLikeWindowOpened);

/***/ }),

/***/ 6569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useRemToPx; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34412);
/* harmony import */ var _shared_store_settings_selectors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4787);
/* harmony import */ var _shared_utils_settings_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20467);
/* harmony import */ var _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93752);





var useRemToPx = function useRemToPx() {
  var zoom = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((0,_shared_store_settings_selectors__WEBPACK_IMPORTED_MODULE_4__/* .selectorSetting */ .K)(_shared_utils_settings_constants__WEBPACK_IMPORTED_MODULE_2__/* .SETTING.zoom.id */ .Fy.zoom.id));
  var remToPx = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (remValue) {
    return remValue * _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_3__/* .DefaultFontSize */ .OS * zoom / 100;
  }, [zoom]);
  return remToPx;
};

/***/ }),

/***/ 67775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ _sharedActionsFeaturedSearch; },
/* harmony export */   "c": function() { return /* binding */ _sharedActionsConstantsFeaturedSearch; }
/* harmony export */ });
var prefix = "featured/";
var _sharedActionsConstantsFeaturedSearch = {
  FETCH_BY_QUERY: prefix + "FETCH",
  FETCH_SUCCESS: prefix + "FETCH_SUCCESS",
  SET_SECTION: prefix + "SET_SECTION",
  FETCH_FOR_PARAGRAPH: prefix + "FETCH_FOR_PARAGRAPH"
};
var _sharedActionsFeaturedSearch = {
  fetchByQuery: function fetchByQuery(query, langs) {
    return {
      type: _sharedActionsConstantsFeaturedSearch.FETCH_BY_QUERY,
      data: {
        query: query,
        langs: langs
      }
    };
  },
  fetchByParaId: function fetchByParaId(paraId, onSuccess) {
    return {
      type: _sharedActionsConstantsFeaturedSearch.FETCH_FOR_PARAGRAPH,
      data: {
        paraId: paraId,
        onSuccess: onSuccess
      }
    };
  },
  fetchSuccess: function fetchSuccess(data, params) {
    return {
      type: _sharedActionsConstantsFeaturedSearch.FETCH_SUCCESS,
      data: {
        data: data,
        params: params
      }
    };
  },
  setSection: function setSection(sectionNew) {
    return {
      type: _sharedActionsConstantsFeaturedSearch.SET_SECTION,
      data: sectionNew
    };
  }
};

/***/ }),

/***/ 85533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ KEY_REDUCER_FEATURED_SEARCH; },
/* harmony export */   "v": function() { return /* binding */ LOADER_ID_FEATURED_SEARCH_SECTIONS; }
/* harmony export */ });
var KEY_REDUCER_FEATURED_SEARCH = "featuredSearch";
var LOADER_ID_FEATURED_SEARCH_SECTIONS = "fs/section";

/***/ }),

/***/ 27736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FB": function() { return /* reexport */ selectorDownloadedBooksIds/* selectorDownloadedBooksIds */.F; },
  "uV": function() { return /* reexport */ selectorIsSWInit/* selectorIsSWInit */.u; },
  "_H": function() { return /* reexport */ selectorIsSWInitStatusRetrieved/* selectorIsSWInitStatusRetrieved */._; },
  "ZB": function() { return /* reexport */ selectorIsSWRegistered/* selectorIsSWRegistered */.Z; },
  "L8": function() { return /* reexport */ selectorStatusesWebsiteUrlsForOfflineUse; },
  "qJ": function() { return /* reexport */ selectorWebsiteUrlsForOfflineUse/* selectorWebsiteUrlsForOfflineUse */.q; }
});

// UNUSED EXPORTS: KEY_REDUCER_STUDY_CENTER, _sharedReducerSW, _sharedStateSW, selectorAudiosDownloadedIds, selectorDownloadAudiosProgresses, selectorDownloadBooksProgresses, selectorDownloadProgresses, selectorIsDownloadingWebsite, selectorIsErrorWebsiteDownload, selectorIsWebsiteDownloaded, selectorNamedCacheKeysAvailable, selectorOfflineHistoryListenIds, selectorOfflineHistoryReadIds, selectorProgressWebsiteDownload, selectorSCActiveColorId, selectorSCActiveSelectedText, selectorSCCheckedEntries, selectorSCCheckedTopics, selectorSCColors, selectorSCCurrentEntryId, selectorSCCurrentTopicId, selectorSCEntries, selectorSCLastActions, selectorSCLastReaderLocation, selectorSCLastTopic, selectorSCPreviewParagraphs, selectorSCStaticShare, selectorSCTopics, selectorSCTopicsItemsCounts, selectorWaveformsDownloadedIds

// EXTERNAL MODULE: ../shared/store/sw/selectorIsWebsiteDownloaded.js
var selectorIsWebsiteDownloaded = __webpack_require__(27611);
// EXTERNAL MODULE: ../shared/store/sw/selectorDownloadAudiosProgresses.js
var selectorDownloadAudiosProgresses = __webpack_require__(65268);
// EXTERNAL MODULE: ../shared/store/sw/selectorAudiosDownloadedIds.js
var selectorAudiosDownloadedIds = __webpack_require__(8073);
// EXTERNAL MODULE: ../shared/store/sw/selectorDownloadBooksProgresses.js
var selectorDownloadBooksProgresses = __webpack_require__(55445);
// EXTERNAL MODULE: ../shared/store/sw/selectorDownloadedBooksIds.js
var selectorDownloadedBooksIds = __webpack_require__(4586);
// EXTERNAL MODULE: ../shared/store/sw/selectorIsSWInit.js
var selectorIsSWInit = __webpack_require__(49037);
// EXTERNAL MODULE: ../shared/store/sw/selectorIsSWInitStatusRetrieved.js
var selectorIsSWInitStatusRetrieved = __webpack_require__(93242);
// EXTERNAL MODULE: ../shared/store/sw/selectorIsSWRegistered.js
var selectorIsSWRegistered = __webpack_require__(93662);
// EXTERNAL MODULE: ../shared/store/sw/selectorOfflineHistoryListenIds.js
var selectorOfflineHistoryListenIds = __webpack_require__(39248);
// EXTERNAL MODULE: ../shared/store/sw/selectorOfflineHistoryReadIds.js
var selectorOfflineHistoryReadIds = __webpack_require__(83156);
// EXTERNAL MODULE: ../shared/store/sw/constants.js
var constants = __webpack_require__(59079);
;// CONCATENATED MODULE: ../shared/store/sw/selectorStatusesWebsiteUrlsForOfflineUse.js

var selectorStatusesWebsiteUrlsForOfflineUse = function selectorStatusesWebsiteUrlsForOfflineUse(state) {
  return state[constants/* KEY_REDUCER_SW */.U].websiteUrlsStatuses;
};
// EXTERNAL MODULE: ../shared/store/sw/selectorWaveformsDownloadedIds.js
var selectorWaveformsDownloadedIds = __webpack_require__(27447);
// EXTERNAL MODULE: ../shared/store/sw/selectorWebsiteUrlsForOfflineUse.js
var selectorWebsiteUrlsForOfflineUse = __webpack_require__(53201);
// EXTERNAL MODULE: ../shared/store/sw/reducer.js
var reducer = __webpack_require__(69884);
;// CONCATENATED MODULE: ../shared/store/sw/index.js



















;// CONCATENATED MODULE: ../shared/store/index.js



/***/ }),

/***/ 82900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ _sharedActionsLibrary; },
/* harmony export */   "G": function() { return /* binding */ _sharedActionsConstantsLibrary; }
/* harmony export */ });
var _sharedActionsConstantsLibrary = {
  ACTION_SAVE_LISTEN: "ACTION_SAVE_LISTEN",
  ACTION_SAVE_READ: "ACTION_SAVE_READ",
  ACTION_SAVE_ALL: "ACTION_SAVE_ALL",
  UPDATE_ALL_HISTORY: "UPDATE_ALL_HISTORY",
  FETCH_ALL_BOOKS_DATA: "FETCH_ALL_BOOKS_DATA",
  TOGGLE_BOOK_IN_ML_BY_ID: "TOGGLE_BOOK_IN_ML_BY_ID",
  SET_LIBRARY_LANGUAGES: "SET_LIBRARY_LANGUAGES"
};
var _sharedActionsLibrary = {
  saveListen: function saveListen(chapterId, position, saveML, delay, localItemDateISO, skipSaveOnServer) {
    return {
      type: _sharedActionsConstantsLibrary.ACTION_SAVE_LISTEN,
      data: {
        chapterId: chapterId,
        position: position,
        saveML: saveML,
        delay: delay,
        localItemDateISO: localItemDateISO,
        skipSaveOnServer: skipSaveOnServer
      }
    };
  },
  saveRead: function saveRead(chapterId, paraId, saveML, delay, localItemDateISO, skipSaveOnServer) {
    return {
      type: _sharedActionsConstantsLibrary.ACTION_SAVE_READ,
      data: {
        chapterId: chapterId,
        paraId: paraId,
        justSync: !paraId,
        saveML: saveML,
        delay: delay,
        localItemDateISO: localItemDateISO,
        skipSaveOnServer: skipSaveOnServer
      }
    };
  },
  saveAll: function saveAll(chapterId, paraId, position, saveML, delay, localItemDateISO, skipSaveOnServer) {
    return {
      type: _sharedActionsConstantsLibrary.ACTION_SAVE_ALL,
      data: {
        chapterId: chapterId,
        paraId: paraId,
        justSync: !paraId,
        position: position,
        saveML: saveML,
        delay: delay,
        localItemDateISO: localItemDateISO,
        skipSaveOnServer: skipSaveOnServer
      }
    };
  },
  updateAllHistory: function updateAllHistory(userId, payload) {
    return {
      type: _sharedActionsConstantsLibrary.UPDATE_ALL_HISTORY,
      data: {
        userId: userId,
        payload: payload
      }
    };
  },
  fetchAllBooksData: function fetchAllBooksData(start, onSuccess, onFinally) {
    return {
      type: _sharedActionsConstantsLibrary.FETCH_ALL_BOOKS_DATA,
      data: {
        start: start,
        onSuccess: onSuccess,
        onFinally: onFinally
      }
    };
  },
  toggleBookInMLById: function toggleBookInMLById(bookId) {
    return {
      type: _sharedActionsConstantsLibrary.TOGGLE_BOOK_IN_ML_BY_ID,
      data: bookId
    };
  },
  setLibraryLanguages: function setLibraryLanguages(data) {
    return {
      type: _sharedActionsConstantsLibrary.SET_LIBRARY_LANGUAGES,
      data: data
    };
  }
};

/***/ }),

/***/ 70929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ KEY_REDUCER_LIBRARY; },
/* harmony export */   "r": function() { return /* binding */ LOADER_ID_FETCH_ALL_HISTORY; }
/* harmony export */ });
var KEY_REDUCER_LIBRARY = "library";
var LOADER_ID_FETCH_ALL_HISTORY = "fetch/allHistory";

/***/ }),

/***/ 35589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fr": function() { return /* binding */ selectorHistoryAllHistoryUserId; },
/* harmony export */   "uV": function() { return /* binding */ selectorHistoryAllHistory; }
/* harmony export */ });
/* unused harmony export selectorHistoryLastTimeOpenML */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70929);


var selectorHistory = function selectorHistory(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_LIBRARY */ .O];
};

var selectorHistoryAllHistoryUserId = function selectorHistoryAllHistoryUserId(state) {
  return selectorHistory(state).allHistoryUserId;
};
var selectorHistoryAllHistory = function selectorHistoryAllHistory(state) {
  return selectorHistory(state).allHistory;
};
var selectorHistoryLastTimeOpenML = function selectorHistoryLastTimeOpenML(state) {
  return selectorHistory(state).lastTimeOpenML;
};

/***/ }),

/***/ 53882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ _sharedActionsMainTree; },
/* harmony export */   "t": function() { return /* binding */ _sharedActionsConstantsMainTree; }
/* harmony export */ });
var prefix = "mainTree";
var _sharedActionsConstantsMainTree = {
  FETCH_FOLDERS_TO_ROOT_SUCCESS: prefix + "FETCH_FOLDERS_TO_ROOT_SUCCESS",
  FETCH_MAIN_TREE_SUCCESS: prefix + "FETCH_MAIN_TREE_SUCCESS",
  FETCH_BIBLES_SUCCESS: prefix + "FETCH_BIBLES_SUCCESS",
  FETCH_SG_BOOKS_SUCCESS: prefix + "FETCH_SG_BOOKS_SUCCESS",
  FETCH_DICTIONARIES_SUCCESS: prefix + "FETCH_DICTIONARIES_SUCCESS",
  FETCH_LANGUAGE_FOLDERS: prefix + "FETCH_LANGUAGE_FOLDERS",
  SET_BOOKS: prefix + "SET_BOOKS",
  PUSH_BOOKS: prefix + "PUSH_BOOKS",
  FETCH_BOOK: prefix + "FETCH_BOOK",
  ADD_ID_BOOK_FETCH_FAILED: prefix + "ADD_ID_BOOK_FETCH_FAILED",
  FETCH_BOOKS_BY_IDS: prefix + "FETCH_BOOKS_BY_IDS"
};
var _sharedActionsMainTree = {
  fetchFoldersToRootSuccess: function fetchFoldersToRootSuccess(data) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return {
      type: _sharedActionsConstantsMainTree.FETCH_FOLDERS_TO_ROOT_SUCCESS,
      data: {
        mainTree: data,
        options: options
      }
    };
  },
  fetchMainTreeSuccess: function fetchMainTreeSuccess(data) {
    return {
      type: _sharedActionsConstantsMainTree.FETCH_MAIN_TREE_SUCCESS,
      data: data
    };
  },
  fetchBiblesSuccess: function fetchBiblesSuccess(data) {
    return {
      type: _sharedActionsConstantsMainTree.FETCH_BIBLES_SUCCESS,
      data: data
    };
  },
  fetchSGBooksSuccess: function fetchSGBooksSuccess(data) {
    return {
      type: _sharedActionsConstantsMainTree.FETCH_SG_BOOKS_SUCCESS,
      data: data
    };
  },
  fetchDictionariesSuccess: function fetchDictionariesSuccess(data) {
    return {
      type: _sharedActionsConstantsMainTree.FETCH_DICTIONARIES_SUCCESS,
      data: data
    };
  },
  fetchLanguageFolders: function fetchLanguageFolders(lang) {
    return {
      type: _sharedActionsConstantsMainTree.FETCH_LANGUAGE_FOLDERS,
      data: lang
    };
  },
  setBooks: function setBooks(data) {
    return {
      type: _sharedActionsConstantsMainTree.SET_BOOKS,
      data: data
    };
  },
  addBooks: function addBooks(books) {
    return {
      type: _sharedActionsConstantsMainTree.PUSH_BOOKS,
      data: books
    };
  },
  fetchBook: function fetchBook(nBookId) {
    return {
      type: _sharedActionsConstantsMainTree.FETCH_BOOK,
      data: nBookId
    };
  },
  fetchBooksByIds: function fetchBooksByIds(booksIds, loaderId) {
    return {
      type: _sharedActionsConstantsMainTree.FETCH_BOOKS_BY_IDS,
      data: {
        booksIds: booksIds,
        loaderId: loaderId
      }
    };
  },
  addIdBrokenBook: function addIdBrokenBook(id) {
    return {
      type: _sharedActionsConstantsMainTree.ADD_ID_BOOK_FETCH_FAILED,
      data: id
    };
  }
};

/***/ }),

/***/ 41330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ KEY_REDUCER_MAIN_TREE; }
/* harmony export */ });
var KEY_REDUCER_MAIN_TREE = "mainTree";

/***/ }),

/***/ 13812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useSelectorBook; }
/* harmony export */ });
/* unused harmony export useSelectFolder */
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34412);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47725);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var _utils_content_content__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69051);




var useSelectFolder = function useSelectFolder(idFolder) {
  var folderTree = useSelector(selectorMainTree);
  return useMemo(function () {
    if (idFolder) {
      return findNode(idFolder, folderTree);
    }

    return null;
  }, [idFolder, folderTree]);
};
/**
 * hook for get book by id (book or chapter/paragraph)
 */

var useSelectorBook = function useSelectorBook(id) {
  var bookId = (0,_utils_content_content__WEBPACK_IMPORTED_MODULE_3__/* .getBookIdWithPrefix */ .NR)(id);
  var books = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(_selectors__WEBPACK_IMPORTED_MODULE_1__/* .selectorMainTreeBooks */ .yS);
  var mainTree = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(_selectors__WEBPACK_IMPORTED_MODULE_1__/* .selectorMainTree */ .h6);
  var bookFromBooks = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    return books && bookId ? books.find(function (book) {
      return book.id === bookId;
    }) : undefined;
  }, [books, bookId]);
  return (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    if (bookFromBooks) {
      var bookOut = bookFromBooks; // TODO impl get from bookToc reducer for each book

      var book = (0,_utils_content_content__WEBPACK_IMPORTED_MODULE_3__/* .findNode */ .DY)(bookId, mainTree);

      if (book.children) {
        bookOut.children = book.children;
        bookOut.chapters = book.chapters;
      }

      return bookOut;
    }

    return undefined;
  }, [bookId, mainTree, bookFromBooks]);
};

/***/ }),

/***/ 47725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ selectorMainTreeDictionaries; },
/* harmony export */   "Km": function() { return /* binding */ selectorMainTreeBookLangMap; },
/* harmony export */   "Kw": function() { return /* binding */ selectorMainTreeSgBooksMap; },
/* harmony export */   "Q5": function() { return /* binding */ selectorMainTreeBibleVersions; },
/* harmony export */   "Qu": function() { return /* binding */ selectorMainTreeLangMap; },
/* harmony export */   "Zn": function() { return /* binding */ selectorMainTreeIdsBooksFetchFailed; },
/* harmony export */   "h6": function() { return /* binding */ selectorMainTree; },
/* harmony export */   "yS": function() { return /* binding */ selectorMainTreeBooks; }
/* harmony export */ });
/* unused harmony export selectorMainTreeBooksPeriodicals */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80406);
/* harmony import */ var _utils_content_content_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5626);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41330);




var _selectorReducer = function _selectorReducer(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_2__/* .KEY_REDUCER_MAIN_TREE */ .$];
};

var selectorMainTreeBibleVersions = function selectorMainTreeBibleVersions(state) {
  return _selectorReducer(state).bibles;
};
var selectorMainTree = function selectorMainTree(state) {
  return _selectorReducer(state).mainTree;
};
var selectorMainTreeBooks = function selectorMainTreeBooks(state) {
  return _selectorReducer(state).books;
};
var selectorMainTreeIdsBooksFetchFailed = function selectorMainTreeIdsBooksFetchFailed(state) {
  return _selectorReducer(state).idsBooksFetchFailed;
};
var selectorMainTreeSgBooksMap = function selectorMainTreeSgBooksMap(state) {
  return _selectorReducer(state).sgBooksMap;
};
var selectorMainTreeLangMap = function selectorMainTreeLangMap(state) {
  return _selectorReducer(state).langMap;
};
var selectorMainTreeDictionaries = function selectorMainTreeDictionaries(state) {
  return _selectorReducer(state).dictionaries;
};
var selectorMainTreeBookLangMap = function selectorMainTreeBookLangMap(state) {
  return _selectorReducer(state).bookLangMap;
};
var selectorMainTreeBooksPeriodicals = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(selectorMainTreeBooks, function (books) {
  return books.filter(function (b) {
    return b.type === _utils_content_content_constants__WEBPACK_IMPORTED_MODULE_1__/* .BOOK_TYPE.periodical */ ._i.periodical;
  });
});

/***/ }),

/***/ 79622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ makeLoaderIdBook; },
/* harmony export */   "s": function() { return /* binding */ makeLoaderIdBookTOC; }
/* harmony export */ });
/* harmony import */ var _shared_utils_content_content__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69051);

var makeLoaderIdBook = function makeLoaderIdBook(bookId) {
  return "loader/content/book-" + (0,_shared_utils_content_content__WEBPACK_IMPORTED_MODULE_0__/* .getBookIdNumber */ .o8)(bookId);
};
var makeLoaderIdBookTOC = function makeLoaderIdBookTOC(bookId) {
  return "loader/content/book-toc-" + (0,_shared_utils_content_content__WEBPACK_IMPORTED_MODULE_0__/* .getBookIdNumber */ .o8)(bookId);
};

/***/ }),

/***/ 9206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ _sharedActionsConstantsParagraphs; },
/* harmony export */   "e": function() { return /* binding */ _sharedActionsParagraphs; }
/* harmony export */ });
var _sharedActionsConstantsParagraphs = {
  CLEAR_BOOK_PARAS: "paras/FETCH_PARAGRAPHS_CLEAR",
  FETCH_PARAGRAPHS_SUCCESS: "paras/FETCH_PARAGRAPHS_SUCCESS",
  FETCH_CHAPTER_PARAS_SUCCESS: "paras/FETCH_CHAPTER_PARAS_SUCCESS",
  FETCH_CHAPTERS_PARAS_SUCCESS: "paras/FETCH_CHAPTERS_PARAS_SUCCESS"
};
var _sharedActionsParagraphs = {
  fetchParaSuccess: function fetchParaSuccess(numberIdBook, parasObj) {
    return {
      type: _sharedActionsConstantsParagraphs.FETCH_PARAGRAPHS_SUCCESS,
      data: {
        nBookId: numberIdBook,
        parasObj: parasObj
      }
    };
  },
  fetchChapterParasSuccess: function fetchChapterParasSuccess(chapterId, paras, highlight) {
    return {
      type: _sharedActionsConstantsParagraphs.FETCH_CHAPTER_PARAS_SUCCESS,
      data: {
        chapterId: chapterId,
        paras: paras,
        highlight: highlight
      }
    };
  },
  // Same as {fetchChapterParasSuccess}, but for multiple chapters at once.
  fetchChaptersParasSuccess: function fetchChaptersParasSuccess(numberIdBook, mapChapterNumberToParas) {
    return {
      type: _sharedActionsConstantsParagraphs.FETCH_CHAPTERS_PARAS_SUCCESS,
      data: {
        bookIdOrigin: numberIdBook,
        mapChapterNumberToParas: mapChapterNumberToParas
      }
    };
  },
  clearBookParas: function clearBookParas(nBookId) {
    return {
      type: _sharedActionsConstantsParagraphs.CLEAR_BOOK_PARAS,
      data: nBookId
    };
  }
};

/***/ }),

/***/ 3195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ti": function() { return /* binding */ makeLoaderIdChapterParasLoading; },
/* harmony export */   "fv": function() { return /* binding */ KEY_REDUCER_PARAGRAPHS; }
/* harmony export */ });
/* unused harmony export LOADER_ID_CHAPTER_PARAS_LOADING */
var LOADER_ID_CHAPTER_PARAS_LOADING = "paras/chapterParas";
var makeLoaderIdChapterParasLoading = function makeLoaderIdChapterParasLoading(chapterId) {
  return LOADER_ID_CHAPTER_PARAS_LOADING + chapterId;
};
var KEY_REDUCER_PARAGRAPHS = "paragraphReducer";

/***/ }),

/***/ 83934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$m": function() { return /* binding */ selectorChaptersParas; }
/* harmony export */ });
/* unused harmony exports selectorParagraphs, selectorBooksCacheInfo */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3195);

var selectorParagraphs = function selectorParagraphs(state) {
  return state[KEY_REDUCER_PARAGRAPHS].paragraphs;
};
var selectorBooksCacheInfo = function selectorBooksCacheInfo(state) {
  return state[KEY_REDUCER_PARAGRAPHS].booksCacheInfo;
};
var selectorChaptersParas = function selectorChaptersParas(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_PARAGRAPHS */ .fv].chaptersParas;
};

/***/ }),

/***/ 16360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ _sharedActionsConstantsPlayer; },
/* harmony export */   "m": function() { return /* binding */ _sharedActionsPlayer; }
/* harmony export */ });
var _sharedActionsConstantsPlayer = {
  PUT_AUDIO_WAVE: "player/PUT_AUDIO_WAVE",
  SET_BROKEN_AUDIOS: "player/SET_BROKEN_AUDIOS",
  FETCH_WAVE_FORMS_DICTIONARY: "player/FETCH_WAVE_FORMS_DICTIONARY",
  SET_IS_SMALL_PLAYER_VISIBLE: "player/SET_IS_SMALL_PLAYER_VISIBLE"
};
var _sharedActionsPlayer = {
  putAudioWaveformsData: function putAudioWaveformsData(data) {
    return {
      type: _sharedActionsConstantsPlayer.PUT_AUDIO_WAVE,
      data: data
    };
  },
  setBrokenAudios: function setBrokenAudios(id) {
    return {
      type: _sharedActionsConstantsPlayer.SET_BROKEN_AUDIOS,
      data: id
    };
  },
  fetchWaveformsDictionary: function fetchWaveformsDictionary(url, chapterId) {
    return {
      type: _sharedActionsConstantsPlayer.FETCH_WAVE_FORMS_DICTIONARY,
      data: {
        url: url,
        chapterId: chapterId
      }
    };
  },
  setIsSmallPlayerVisible: function setIsSmallPlayerVisible(flag) {
    return {
      type: _sharedActionsConstantsPlayer.SET_IS_SMALL_PLAYER_VISIBLE,
      data: flag
    };
  }
};

/***/ }),

/***/ 94238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ KEY_REDUCER_PLAYER; }
/* harmony export */ });
var KEY_REDUCER_PLAYER = "audioPlayer";

/***/ }),

/***/ 46996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qf": function() { return /* binding */ selectorPlayerBrokenAudios; },
/* harmony export */   "cc": function() { return /* binding */ selectorPlayerWaveformsDictionary; }
/* harmony export */ });
/* unused harmony export selectorIsSmallPlayerVisible */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94238);

var selectorPlayerWaveformsDictionary = function selectorPlayerWaveformsDictionary(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_PLAYER */ .e].waveformsDictionary;
};
var selectorPlayerBrokenAudios = function selectorPlayerBrokenAudios(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_PLAYER */ .e].brokenAudios;
};
var selectorIsSmallPlayerVisible = function selectorIsSmallPlayerVisible(state) {
  return state[KEY_REDUCER_PLAYER].isSmallPlayerVisible;
};

/***/ }),

/***/ 22343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getBookWaveformLoaderId; }
/* harmony export */ });
var getBookWaveformLoaderId = function getBookWaveformLoaderId(chapterId) {
  return "FBW_" + chapterId;
};

/***/ }),

/***/ 37314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ _sharedActionsSearch; },
/* harmony export */   "k": function() { return /* binding */ _sharedActionsConstantsSearch; }
/* harmony export */ });
var prefix = "search/";
var _sharedActionsConstantsSearch = {
  FETCH_SUGGESTION: prefix + "FETCH_SUGGESTION",
  FETCH_SHORTCUT_SUCCESS: prefix + "FETCH_SHORTCUT_SUCCESS",
  FETCH_DETECT_SUCCESS: prefix + "FETCH_DETECT_SUCCESS",
  FETCH_SUGGESTION_SUCCESS: "FETCH_SUGGESTION_SUCCESS",
  FETCH_LANGS_FOR_WORD_SUCCESS: prefix + "FETCH_LANGS_FOR_WORD_SUCCESS"
};
var _sharedActionsSearch = {
  fetchSuggestion: function fetchSuggestion(query, currentLang) {
    return {
      type: _sharedActionsConstantsSearch.FETCH_SUGGESTION,
      data: {
        query: query,
        currentLang: currentLang
      }
    };
  },
  fetchShortcutSuccess: function fetchShortcutSuccess(data) {
    return {
      type: _sharedActionsConstantsSearch.FETCH_SHORTCUT_SUCCESS,
      data: data
    };
  },
  fetchDetectSuccess: function fetchDetectSuccess(detect) {
    return {
      type: _sharedActionsConstantsSearch.FETCH_DETECT_SUCCESS,
      data: {
        detect: detect
      }
    };
  },
  fetchLangsForWordSuccess: function fetchLangsForWordSuccess(langs, query, correction) {
    return {
      type: _sharedActionsConstantsSearch.FETCH_LANGS_FOR_WORD_SUCCESS,
      data: {
        langs: langs,
        query: query,
        correction: correction
      }
    };
  },
  fetchSuggestionSuccess: function fetchSuggestionSuccess(allData) {
    return {
      type: _sharedActionsConstantsSearch.FETCH_SUGGESTION_SUCCESS,
      data: allData
    };
  }
};

/***/ }),

/***/ 76713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "El": function() { return /* binding */ LOADER_ID_LOAD_SEARCH; },
/* harmony export */   "RR": function() { return /* binding */ LOADER_ID_DICTIONARY_LOAD; },
/* harmony export */   "gK": function() { return /* binding */ KEY_REDUCER_SEARCH; },
/* harmony export */   "y6": function() { return /* binding */ LOADER_ID_SUGGESTIONS; }
/* harmony export */ });
/* unused harmony exports LOADER_ID_LOAD_SEARCH_LOCAL, LOADER_ID_FETCH_SEARCH_LOCAL, LOADER_ID_FETCH_SEARCH */
var LOADER_ID_LOAD_SEARCH_LOCAL = "search-local/load";
var LOADER_ID_FETCH_SEARCH_LOCAL = "search-local/fetch";
var LOADER_ID_LOAD_SEARCH = "search/load";
var LOADER_ID_FETCH_SEARCH = "search/fetch";
var LOADER_ID_DICTIONARY_LOAD = "dictionary/load";
var LOADER_ID_SUGGESTIONS = "search-popup/suggestions";
var KEY_REDUCER_SEARCH = "search";

/***/ }),

/***/ 24803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kg": function() { return /* binding */ selectorSearchQuery; },
/* harmony export */   "RH": function() { return /* binding */ selectorSearchResultsDictionary; },
/* harmony export */   "c6": function() { return /* binding */ selectorSearchHistory; },
/* harmony export */   "dx": function() { return /* binding */ selectorSearchResults; },
/* harmony export */   "e0": function() { return /* binding */ selectorSearchShortcuts; },
/* harmony export */   "im": function() { return /* binding */ selectorSearchParams; },
/* harmony export */   "zS": function() { return /* binding */ selectorSearchFilter; }
/* harmony export */ });
/* unused harmony exports selectorSearchParamsDictionary, selectorSearchQueryLangs, selectorLocalSearchParams, selectorLocalSearchResults, selectorSearchShortcutContent, selectorSearchLang, selectorSearchBookListSuppressed, selectorQueryBooksSearch, selectorSearchRightPanelPosition, selectorSearchClearMarkBookId */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76713);

var selectorSearchResultsDictionary = function selectorSearchResultsDictionary(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SEARCH */ .gK].searchDictionary;
};
var selectorSearchParamsDictionary = function selectorSearchParamsDictionary(state) {
  return state[KEY_REDUCER_SEARCH].searchParamsDictionary;
};
var selectorSearchResults = function selectorSearchResults(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SEARCH */ .gK].search;
};
var selectorSearchParams = function selectorSearchParams(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SEARCH */ .gK].searchParams;
};
var selectorSearchQueryLangs = function selectorSearchQueryLangs(state) {
  return state[KEY_REDUCER_SEARCH].searchQueryLangs;
};
var selectorLocalSearchParams = function selectorLocalSearchParams(state) {
  return state[KEY_REDUCER_SEARCH].localSearchParams;
};
var selectorLocalSearchResults = function selectorLocalSearchResults(state) {
  return state[KEY_REDUCER_SEARCH].localSearch;
};
var selectorSearchQuery = function selectorSearchQuery(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SEARCH */ .gK].searchQuery;
};
var selectorSearchShortcuts = function selectorSearchShortcuts(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SEARCH */ .gK].shortcuts;
};
var selectorSearchShortcutContent = function selectorSearchShortcutContent(state) {
  return state[KEY_REDUCER_SEARCH].shortcutContent;
};
var selectorSearchLang = function selectorSearchLang(state) {
  return state[KEY_REDUCER_SEARCH].searchLang;
};
var selectorSearchFilter = function selectorSearchFilter(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SEARCH */ .gK].searchFilter;
};
var selectorSearchHistory = function selectorSearchHistory(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SEARCH */ .gK].searchHistory;
}; // These electors are for Main app only so far

var selectorSearchBookListSuppressed = function selectorSearchBookListSuppressed(state) {
  return state[KEY_REDUCER_SEARCH].searchBookListSuppressed;
};
var selectorQueryBooksSearch = function selectorQueryBooksSearch(state) {
  return state[KEY_REDUCER_SEARCH].searchNeedle;
};
var selectorSearchRightPanelPosition = function selectorSearchRightPanelPosition(state) {
  return state[KEY_REDUCER_SEARCH].rightPanelPosition;
};
var selectorSearchClearMarkBookId = function selectorSearchClearMarkBookId(state) {
  return state[KEY_REDUCER_SEARCH].searchClearMarkBookId;
};

/***/ }),

/***/ 58538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ _sharedActionsSettings; },
/* harmony export */   "u": function() { return /* binding */ _sharedActionsConstantsSettings; }
/* harmony export */ });
/* harmony import */ var _shared_utils_settings_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20467);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }


var prefix = "settings/";
var _sharedActionsConstantsSettings = {
  UPDATE_SETTINGS: prefix + "UPDATE_SETTINGS",
  UPDATE_SETTING_SUCCESS: prefix + "UPDATE_SETTING_SUCCESS",
  FETCH_GEO_IP_DATA: prefix + "FETCH_GEO_IP_DATA",
  FETCH_GEO_IP_DATA_SUCCESS: prefix + "FETCH_GEO_IP_DATA_SUCCESS"
};
var _sharedActionsSettings = {
  updateSettings: function updateSettings(dataOrKey, value, saveOnServer) {
    var data = _typeof(dataOrKey) === "object" ? dataOrKey : _defineProperty({}, dataOrKey, value);
    return {
      type: _sharedActionsConstantsSettings.UPDATE_SETTINGS,
      data: data,
      saveOnServer: saveOnServer
    };
  },
  updateSettingSuccess: function updateSettingSuccess(data) {
    return {
      type: _sharedActionsConstantsSettings.UPDATE_SETTING_SUCCESS,
      data: data
    };
  },
  fetchGeoIpData: function fetchGeoIpData() {
    return {
      type: _sharedActionsConstantsSettings.FETCH_GEO_IP_DATA
    };
  },
  fetchGeoIpDataSuccess: function fetchGeoIpDataSuccess(data) {
    return {
      type: _sharedActionsConstantsSettings.FETCH_GEO_IP_DATA_SUCCESS,
      data: data
    };
  }
};

/***/ }),

/***/ 94889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ KEY_REDUCER_SETTINGS; }
/* harmony export */ });
var KEY_REDUCER_SETTINGS = "settings";

/***/ }),

/***/ 4787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ selectorSetting; }
/* harmony export */ });
/* unused harmony export selectorSettings */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94889);

var selectorSettings = function selectorSettings(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SETTINGS */ .P];
};
var selectorSetting = function selectorSetting(settingId) {
  return function (state) {
    return selectorSettings(state)[settingId];
  };
};

/***/ }),

/***/ 88882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ _sharedActionsConstantsShare; },
/* harmony export */   "_": function() { return /* binding */ _sharedActionsShare; }
/* harmony export */ });
var prefix = "share/";
var _sharedActionsConstantsShare = {
  SET_SHARE_DATA: prefix + "SET_SHARE_DATA"
};
var _sharedActionsShare = {
  setShareData: function setShareData(shareData) {
    return {
      type: _sharedActionsConstantsShare.SET_SHARE_DATA,
      data: shareData
    };
  }
};

/***/ }),

/***/ 59825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ KEY_REDUCER_SHARE; }
/* harmony export */ });
var KEY_REDUCER_SHARE = "share";

/***/ }),

/***/ 37623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ _sharedActionsConstantsShop; },
/* harmony export */   "h": function() { return /* binding */ _sharedActionsShop; }
/* harmony export */ });
var _sharedActionsConstantsShop = {
  FETCH_ALL_SHOP_BOOKS_SUCCESS: "FETCH_ALL_SHOP_BOOKS_SUCCESS",
  FETCH_SHOP_BOOKS_SUCCESS: "FETCH_SHOP_BOOKS_SUCCESS",
  SET_IS_PACKAGE_FETCHED: "SET_IS_PACKAGE_FETCHED",
  FETCH_SHOP_BOOKS_PENDING: "FETCH_SHOP_BOOKS_PENDING",
  FETCH_SHOP_BOOKS: "FETCH_SHOP_BOOKS",
  FETCH_PACKAGES_SUCCESS: "FETCH_PACKAGES_SUCCESS",
  FETCH_PACKAGES_PENDING: "FETCH_PACKAGES_PENDING",
  FETCH_PACKAGES: "FETCH_PACKAGES",
  RESET_SHOP: "RESET_SHOP",
  RESTORE_SHOP: "RESTORE_SHOP"
};
var _sharedActionsShop = {
  fetchShopBooksSuccess: function fetchShopBooksSuccess(books, bookIds) {
    return {
      type: _sharedActionsConstantsShop.FETCH_SHOP_BOOKS_SUCCESS,
      data: {
        books: books,
        bookIds: bookIds
      }
    };
  },
  fetchAllShopBooksSuccess: function fetchAllShopBooksSuccess(data) {
    return {
      type: _sharedActionsConstantsShop.FETCH_ALL_SHOP_BOOKS_SUCCESS,
      data: data
    };
  },
  fetchShopBooksPending: function fetchShopBooksPending(data) {
    return {
      type: _sharedActionsConstantsShop.FETCH_SHOP_BOOKS_PENDING,
      data: data
    };
  },
  setIsPackageFetched: function setIsPackageFetched(data) {
    return {
      type: _sharedActionsConstantsShop.SET_IS_PACKAGE_FETCHED,
      data: data
    };
  },
  fetchShopBooks: function fetchShopBooks(data) {
    return {
      type: _sharedActionsConstantsShop.FETCH_SHOP_BOOKS,
      data: data
    };
  },
  fetchPackagesPending: function fetchPackagesPending(data) {
    return {
      type: _sharedActionsConstantsShop.FETCH_PACKAGES_PENDING,
      data: data
    };
  },
  fetchPackagesSuccess: function fetchPackagesSuccess(data) {
    return {
      type: _sharedActionsConstantsShop.FETCH_PACKAGES_SUCCESS,
      data: data
    };
  },
  fetchPackages: function fetchPackages() {
    return {
      type: _sharedActionsConstantsShop.FETCH_PACKAGES
    };
  },
  resetShop: function resetShop() {
    return {
      type: _sharedActionsConstantsShop.RESET_SHOP
    };
  },
  restoreShop: function restoreShop(shopItems) {
    return {
      type: _sharedActionsConstantsShop.RESTORE_SHOP,
      data: shopItems
    };
  }
};

/***/ }),

/***/ 34144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ KEY_REDUCER_SHOP; },
/* harmony export */   "y": function() { return /* binding */ LOADER_ID_SHOP; }
/* harmony export */ });
var KEY_REDUCER_SHOP = "shop";
var LOADER_ID_SHOP = "shop/loader";

/***/ }),

/***/ 47108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ selectorShopIds; },
/* harmony export */   "J6": function() { return /* binding */ selectorShopPackages; },
/* harmony export */   "SS": function() { return /* binding */ selectorLoadingPackages; },
/* harmony export */   "af": function() { return /* binding */ selectorShopBooks; },
/* harmony export */   "ff": function() { return /* binding */ selectorPendingIds; },
/* harmony export */   "kW": function() { return /* binding */ selectorPackageIds; },
/* harmony export */   "rG": function() { return /* binding */ selectorShopIsPackagesFetched; }
/* harmony export */ });
/* unused harmony export selectorShopBooksAll */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34144);

var selectorShopBooks = function selectorShopBooks(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SHOP */ ._].shopBooks;
};
var selectorShopBooksAll = function selectorShopBooksAll(state) {
  return state[KEY_REDUCER_SHOP].allShopBooks;
};
var selectorShopIds = function selectorShopIds(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SHOP */ ._].shopIds;
};
var selectorPendingIds = function selectorPendingIds(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SHOP */ ._].pendingIds;
};
var selectorPackageIds = function selectorPackageIds(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SHOP */ ._].packageIds;
};
var selectorLoadingPackages = function selectorLoadingPackages(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SHOP */ ._].loadingPackages;
};
var selectorShopPackages = function selectorShopPackages(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SHOP */ ._].shopPackages;
};
var selectorShopIsPackagesFetched = function selectorShopIsPackagesFetched(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SHOP */ ._].isPackagesFetched;
};

/***/ }),

/***/ 97580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _sharedActionsConstantsSupport; },
/* harmony export */   "_": function() { return /* binding */ _sharedActionsSupport; }
/* harmony export */ });
var _sharedActionsConstantsSupport = {
  FETCH_CF: "support/FETCH_CF",
  SEND_CF: "support/SEND_CF",
  FETCH_CF_SUCCESS: "support/FETCH_CF_SUCCESS",
  SEND_CF_STATUS: "support/SEND_CF_STATUS"
};
var _sharedActionsSupport = {
  actionFetchCF: function actionFetchCF() {
    return {
      type: _sharedActionsConstantsSupport.FETCH_CF
    };
  },
  actionSendCF: function actionSendCF(data) {
    return {
      type: _sharedActionsConstantsSupport.SEND_CF,
      data: data
    };
  },
  actionFetchCFSuccess: function actionFetchCFSuccess(data) {
    return {
      type: _sharedActionsConstantsSupport.FETCH_CF_SUCCESS,
      data: data
    };
  },
  actionSendCFStatus: function actionSendCFStatus(data) {
    return {
      type: _sharedActionsConstantsSupport.SEND_CF_STATUS,
      data: data
    };
  }
};

/***/ }),

/***/ 38857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ _sharedActionsConstantsSW; },
/* harmony export */   "m": function() { return /* binding */ _sharedActionsSW; }
/* harmony export */ });
/* harmony import */ var _utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34855);

var _sharedActionsConstantsSW = {
  // SW logic
  UPDATE_IS_SW_REGISTERED: "sw/UPDATE_IS_SW_REGISTERED",
  UPDATE_IS_SW_INIT: "sw/UPDATE_IS_SW_INIT",
  UPDATE_IS_SW_INIT_DATA_RETRIEVED: "sw/UPDATE_IS_SW_INIT_DATA_RETRIEVED",
  GET_INIT_STATUS: "sw/GET_INIT_STATUS",
  // ==============================
  // Website logic
  DOWNLOAD_WEBSITE: "sw/DOWNLOAD_WEBSITE",
  CANCEL_DOWNLOAD_WEBSITE: "sw/DOWNLOAD_WEBSITE_URLS_FOR_OFFLINE_USE",
  UPDATE_WEBSITE_URLS: "sw/UPDATE_WEBSITE_URLS",
  UPDATE_WEBSITE_URLS_STATUSES: "sw/UPDATE_WEBSITE_URLS_STATUSES",
  UPDATE_IS_WEBSITE_DOWNLOADING: "sw/UPDATE_IS_WEBSITE_DOWNLOADING",
  UPDATE_IS_ERROR_WEBSITE_DOWNLOAD: "sw/UPDATE_IS_ERROR_WEBSITE_DOWNLOAD",
  UPDATE_DOWNLOAD_WEBSITE_URLS_PROGRESS: "sw/UPDATE_DOWNLOAD_WEBSITE_URLS_PROGRESS",
  // ==============================
  // Downloaded data (for offline use) logic
  DOWNLOAD_DATA: "sw/DOWNLOAD_DATA",
  CANCEL_DOWNLOAD_DATA: "sw/CANCEL_DOWNLOAD_DATA",
  UPDATE_DOWNLOAD_PROGRESS: "sw/UPDATE_DOWNLOAD_PROGRESS",
  UPDATE_KEYS_AVAILABLE: "sw/UPDATE_KEYS_AVAILABLE",
  PULL: "sw/PULL",
  PULL_SUCCESS: "sw/PULL_SUCCESS" // ==============================

};
var _sharedActionsSW = {
  // SW logic
  updateIsSWRegistered: function updateIsSWRegistered(flag) {
    return {
      type: _sharedActionsConstantsSW.UPDATE_IS_SW_REGISTERED,
      data: flag
    };
  },
  updateIsSWInit: function updateIsSWInit(flag) {
    return {
      type: _sharedActionsConstantsSW.UPDATE_IS_SW_INIT,
      data: flag
    };
  },
  updateIsSWInitDataRetrieved: function updateIsSWInitDataRetrieved(flag) {
    return {
      type: _sharedActionsConstantsSW.UPDATE_IS_SW_INIT_DATA_RETRIEVED,
      data: flag
    };
  },
  getInitStatus: function getInitStatus() {
    return {
      type: _sharedActionsConstantsSW.GET_INIT_STATUS
    };
  },
  // ==============================
  // Website logic
  downloadWebsite: function downloadWebsite() {
    return {
      type: _sharedActionsConstantsSW.DOWNLOAD_WEBSITE
    };
  },
  cancelDownloadWebsite: function cancelDownloadWebsite() {
    return {
      type: _sharedActionsConstantsSW.CANCEL_DOWNLOAD_WEBSITE
    };
  },
  updateWebsiteUrls: function updateWebsiteUrls(urls) {
    return {
      type: _sharedActionsConstantsSW.UPDATE_WEBSITE_URLS,
      data: urls
    };
  },
  updateIsWebsiteUrlsDownloading: function updateIsWebsiteUrlsDownloading(flag) {
    return {
      type: _sharedActionsConstantsSW.UPDATE_IS_WEBSITE_DOWNLOADING,
      data: flag
    };
  },
  updateIsErrorWebsiteDownload: function updateIsErrorWebsiteDownload(flag) {
    return {
      type: _sharedActionsConstantsSW.UPDATE_IS_ERROR_WEBSITE_DOWNLOAD,
      data: flag
    };
  },
  updateWebsiteUrlsStatuses: function updateWebsiteUrlsStatuses(data) {
    return {
      type: _sharedActionsConstantsSW.UPDATE_WEBSITE_URLS_STATUSES,
      data: data
    };
  },
  updateWebsiteUrlsProgress: function updateWebsiteUrlsProgress(progress) {
    return {
      type: _sharedActionsConstantsSW.UPDATE_DOWNLOAD_WEBSITE_URLS_PROGRESS,
      data: progress
    };
  },
  // ==============================
  // Downloaded data (for offline use) logic
  downloadDataForOffline: function downloadDataForOffline(cacheName, data, onSuccess) {
    return {
      type: _sharedActionsConstantsSW.DOWNLOAD_DATA,
      data: {
        cacheName: cacheName,
        data: data,
        onSuccess: onSuccess
      }
    };
  },
  cancelDownloadData: function cancelDownloadData(cacheName, item) {
    return {
      type: _sharedActionsConstantsSW.CANCEL_DOWNLOAD_DATA,
      data: {
        cacheName: cacheName,
        item: item
      }
    };
  },
  updateKeysAvailable: function updateKeysAvailable(cacheName, keys) {
    return {
      type: _sharedActionsConstantsSW.UPDATE_KEYS_AVAILABLE,
      data: {
        cacheName: cacheName,
        keys: keys
      }
    };
  },
  pull: function pull(cacheName, key) {
    return {
      type: _sharedActionsConstantsSW.PULL,
      data: {
        cacheName: cacheName,
        key: key
      }
    };
  },
  pullSuccess: function pullSuccess(cacheName, key, value) {
    return {
      type: _sharedActionsConstantsSW.PULL_SUCCESS,
      data: {
        cacheName: cacheName,
        key: key,
        value: value
      }
    };
  },
  updateDownloadProgress: function updateDownloadProgress(type, id, progress) {
    return {
      type: _sharedActionsConstantsSW.UPDATE_DOWNLOAD_PROGRESS,
      data: {
        type: type,
        id: id,
        progress: progress
      }
    };
  },
  // =========================

  /* ===== Derivatives methods, for easier code reading ===== */
  downloadDataBookData: function downloadDataBookData(books, onSuccess) {
    return _sharedActionsSW.downloadDataForOffline(_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.BOOK_DATA */ .jy.BOOK_DATA, books, onSuccess);
  },
  cancelDownloadDataBookData: function cancelDownloadDataBookData(book) {
    return _sharedActionsSW.cancelDownloadData(_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.BOOK_DATA */ .jy.BOOK_DATA, book);
  },
  updateDownloadProgressBookData: function updateDownloadProgressBookData(bookId, progress) {
    return _sharedActionsSW.updateDownloadProgress(_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.BOOK_DATA */ .jy.BOOK_DATA, bookId, progress);
  },
  pullBookData: function pullBookData(bookId) {
    return _sharedActionsSW.pull(_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.BOOK_DATA */ .jy.BOOK_DATA, bookId);
  },
  downloadDataAudio: function downloadDataAudio(audioChapters) {
    return _sharedActionsSW.downloadDataForOffline(_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.AUDIO_FILE */ .jy.AUDIO_FILE, audioChapters);
  },
  cancelDownloadDataAudio: function cancelDownloadDataAudio(audioChapter) {
    return _sharedActionsSW.cancelDownloadData(_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.AUDIO_FILE */ .jy.AUDIO_FILE, audioChapter);
  },
  pullAudio: function pullAudio(chapterId) {
    return _sharedActionsSW.pull(_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.AUDIO_FILE */ .jy.AUDIO_FILE, chapterId);
  },
  updateDownloadProgressAudio: function updateDownloadProgressAudio(chapterId, progress) {
    return _sharedActionsSW.updateDownloadProgress(_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.AUDIO_FILE */ .jy.AUDIO_FILE, chapterId, progress);
  },
  // Waveforms are downloaded with audios for now as it is easier.
  // downloadDataForOfflineWaveform: (toc, onSuccess) => {
  //   return _sharedActionsSW.downloadDataForOffline(NAMED_CACHE_NAME.WAVEFORM, toc, onSuccess);
  // },
  pullProgressWaveform: function pullProgressWaveform(chapterId) {
    return _sharedActionsSW.pull(_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.WAVEFORM */ .jy.WAVEFORM, chapterId);
  },
  updateDownloadProgressWaveform: function updateDownloadProgressWaveform(id, progress) {
    return _sharedActionsSW.updateDownloadProgress(_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.WAVEFORM */ .jy.WAVEFORM, id, progress);
  } // ==============================

};

/***/ }),

/***/ 59079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ KEY_REDUCER_SW; },
/* harmony export */   "m": function() { return /* binding */ PROGRESS_VALUE_REMOVE; }
/* harmony export */ });
var KEY_REDUCER_SW = "sw";
var PROGRESS_VALUE_REMOVE = -1;

/***/ }),

/***/ 69884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ _sharedStateSW; },
/* harmony export */   "d": function() { return /* binding */ _sharedReducerSW; }
/* harmony export */ });
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38857);
/* harmony import */ var _utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34855);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59079);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var _sharedStateSW = {
  isSWRegistered: false,
  isSWInit: false,
  isSWInitStatusRetrieved: false,
  // Urls
  websiteUrls: [],
  isWebsiteUrlsDownloading: false,
  isErrorWebsiteDownload: false,
  websiteUrlsProgress: 0,
  websiteUrlsStatuses: [],
  // ===================
  // Downloaded
  namedCacheKeysAvailable: _utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_1__/* .NAMED_CACHE_NAMES.reduce */ .QQ.reduce(function (acc, key) {
    acc[key] = [];
    return acc;
  }, {}),
  // ====================
  downloadProgresses: _utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_1__/* .NAMED_CACHE_NAMES.reduce */ .QQ.reduce(function (acc, key) {
    acc[key] = {};
    return acc;
  }, {})
};
var _sharedReducerSW = function _sharedReducerSW() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _sharedStateSW;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      data = _ref.data;

  switch (type) {
    case _actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsSW.UPDATE_IS_SW_REGISTERED */ .d.UPDATE_IS_SW_REGISTERED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isSWRegistered: data
        });
      }

    case _actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsSW.UPDATE_IS_SW_INIT */ .d.UPDATE_IS_SW_INIT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isSWInit: data
        });
      }

    case _actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsSW.UPDATE_IS_SW_INIT_DATA_RETRIEVED */ .d.UPDATE_IS_SW_INIT_DATA_RETRIEVED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isSWInitStatusRetrieved: data
        });
      }

    case _actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsSW.UPDATE_WEBSITE_URLS */ .d.UPDATE_WEBSITE_URLS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          websiteUrls: data
        });
      }

    case _actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsSW.UPDATE_WEBSITE_URLS_STATUSES */ .d.UPDATE_WEBSITE_URLS_STATUSES:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          websiteUrlsStatuses: _objectSpread(_objectSpread({}, state.websiteUrlsStatuses), data)
        });
      }

    case _actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsSW.UPDATE_IS_WEBSITE_DOWNLOADING */ .d.UPDATE_IS_WEBSITE_DOWNLOADING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isWebsiteUrlsDownloading: data
        });
      }

    case _actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsSW.UPDATE_IS_ERROR_WEBSITE_DOWNLOAD */ .d.UPDATE_IS_ERROR_WEBSITE_DOWNLOAD:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isErrorWebsiteDownload: data
        });
      }

    case _actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsSW.UPDATE_DOWNLOAD_WEBSITE_URLS_PROGRESS */ .d.UPDATE_DOWNLOAD_WEBSITE_URLS_PROGRESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          websiteUrlsProgress: data
        });
      }

    case _actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsSW.UPDATE_KEYS_AVAILABLE */ .d.UPDATE_KEYS_AVAILABLE:
      {
        var cacheName = data.cacheName,
            keys = data.keys;

        var downloadProgressesNew = _objectSpread({}, state.downloadProgresses[cacheName]); // If item is downloaded delete progress automatically


        Object.keys(downloadProgressesNew).forEach(function (k) {
          if (keys.includes(k)) {
            delete downloadProgressesNew[k];
          }
        }); // ===================================================

        return _objectSpread(_objectSpread({}, state), {}, {
          namedCacheKeysAvailable: _objectSpread(_objectSpread({}, state.namedCacheKeysAvailable), {}, _defineProperty({}, cacheName, keys)),
          downloadProgresses: _objectSpread(_objectSpread({}, state.downloadProgresses), {}, _defineProperty({}, cacheName, downloadProgressesNew))
        });
      }

    case _actions__WEBPACK_IMPORTED_MODULE_0__/* ._sharedActionsConstantsSW.UPDATE_DOWNLOAD_PROGRESS */ .d.UPDATE_DOWNLOAD_PROGRESS:
      {
        var _downloadProgressesNew = _objectSpread({}, state.downloadProgresses[data.type]);

        if (data.progress === _constants__WEBPACK_IMPORTED_MODULE_2__/* .PROGRESS_VALUE_REMOVE */ .m) {
          delete _downloadProgressesNew[data.id];
        } else {
          _downloadProgressesNew[data.id] = data.progress;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          downloadProgresses: _objectSpread(_objectSpread({}, state.downloadProgresses), {}, _defineProperty({}, data.type, _downloadProgressesNew))
        });
      }

    default:
      return state;
  }
};

/***/ }),

/***/ 8073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ selectorAudiosDownloadedIds; }
/* harmony export */ });
/* harmony import */ var _shared_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34855);
/* harmony import */ var _shared_store_sw_selectorNamedCacheKeysAvailable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(625);


var selectorAudiosDownloadedIds = function selectorAudiosDownloadedIds(state) {
  return (0,_shared_store_sw_selectorNamedCacheKeysAvailable__WEBPACK_IMPORTED_MODULE_1__/* .selectorNamedCacheKeysAvailable */ .Z)(state)[_shared_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.AUDIO_FILE */ .jy.AUDIO_FILE];
};

/***/ }),

/***/ 65268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ selectorDownloadAudiosProgresses; }
/* harmony export */ });
/* harmony import */ var _shared_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34855);
/* harmony import */ var _shared_store_sw_selectorDownloadProgresses__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42097);


var selectorDownloadAudiosProgresses = function selectorDownloadAudiosProgresses(state) {
  return (0,_shared_store_sw_selectorDownloadProgresses__WEBPACK_IMPORTED_MODULE_1__/* .selectorDownloadProgresses */ .m)(state)[_shared_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.AUDIO_FILE */ .jy.AUDIO_FILE];
};

/***/ }),

/***/ 55445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ selectorDownloadBooksProgresses; }
/* harmony export */ });
/* harmony import */ var _shared_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34855);
/* harmony import */ var _shared_store_sw_selectorDownloadProgresses__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42097);


var selectorDownloadBooksProgresses = function selectorDownloadBooksProgresses(state) {
  return (0,_shared_store_sw_selectorDownloadProgresses__WEBPACK_IMPORTED_MODULE_1__/* .selectorDownloadProgresses */ .m)(state)[_shared_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.BOOK_DATA */ .jy.BOOK_DATA];
};

/***/ }),

/***/ 42097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ selectorDownloadProgresses; }
/* harmony export */ });
/* harmony import */ var _shared_store_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59079);

var selectorDownloadProgresses = function selectorDownloadProgresses(state) {
  return state[_shared_store_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SW */ .U].downloadProgresses;
};

/***/ }),

/***/ 4586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ selectorDownloadedBooksIds; }
/* harmony export */ });
/* harmony import */ var _shared_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34855);
/* harmony import */ var _shared_store_sw_selectorNamedCacheKeysAvailable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(625);


var selectorDownloadedBooksIds = function selectorDownloadedBooksIds(state) {
  return (0,_shared_store_sw_selectorNamedCacheKeysAvailable__WEBPACK_IMPORTED_MODULE_1__/* .selectorNamedCacheKeysAvailable */ .Z)(state)[_shared_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.BOOK_DATA */ .jy.BOOK_DATA];
};

/***/ }),

/***/ 4061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ selectorIsDownloadingWebsite; }
/* harmony export */ });
/* harmony import */ var _shared_store_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59079);

var selectorIsDownloadingWebsite = function selectorIsDownloadingWebsite(state) {
  return state[_shared_store_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SW */ .U].isWebsiteUrlsDownloading;
};

/***/ }),

/***/ 49037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ selectorIsSWInit; }
/* harmony export */ });
/* harmony import */ var _shared_store_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59079);

var selectorIsSWInit = function selectorIsSWInit(state) {
  return state[_shared_store_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SW */ .U].isSWInit;
};

/***/ }),

/***/ 93242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ selectorIsSWInitStatusRetrieved; }
/* harmony export */ });
/* harmony import */ var _shared_store_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59079);

var selectorIsSWInitStatusRetrieved = function selectorIsSWInitStatusRetrieved(state) {
  return state[_shared_store_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SW */ .U].isSWInitStatusRetrieved;
};

/***/ }),

/***/ 93662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ selectorIsSWRegistered; }
/* harmony export */ });
/* harmony import */ var _shared_store_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59079);

var selectorIsSWRegistered = function selectorIsSWRegistered(state) {
  return state[_shared_store_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SW */ .U].isSWRegistered;
};

/***/ }),

/***/ 27611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ selectorIsWebsiteDownloaded; }
/* harmony export */ });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80406);
/* harmony import */ var _utils_assembly__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76732);
/* harmony import */ var _shared_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27736);



var selectorIsWebsiteDownloaded = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(_shared_store__WEBPACK_IMPORTED_MODULE_2__/* .selectorWebsiteUrlsForOfflineUse */ .qJ, _shared_store__WEBPACK_IMPORTED_MODULE_2__/* .selectorStatusesWebsiteUrlsForOfflineUse */ .L8, function (urlsForOfflineUse, urlsStatuses) {
  return urlsForOfflineUse.every(function (u) {
    if (!urlsStatuses[u] && (0,_utils_assembly__WEBPACK_IMPORTED_MODULE_1__/* .isDevelopment */ .yG)() && u !== null && u !== void 0 && u.includes("static/development/")) {
      return true;
    }

    return urlsStatuses[u];
  });
});

/***/ }),

/***/ 625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ selectorNamedCacheKeysAvailable; }
/* harmony export */ });
/* harmony import */ var _shared_store_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59079);

var selectorNamedCacheKeysAvailable = function selectorNamedCacheKeysAvailable(state) {
  return state[_shared_store_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SW */ .U].namedCacheKeysAvailable;
};

/***/ }),

/***/ 39248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ selectorOfflineHistoryListenIds; }
/* harmony export */ });
/* harmony import */ var _shared_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34855);
/* harmony import */ var _shared_store_sw_selectorNamedCacheKeysAvailable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(625);


var selectorOfflineHistoryListenIds = function selectorOfflineHistoryListenIds(state) {
  return (0,_shared_store_sw_selectorNamedCacheKeysAvailable__WEBPACK_IMPORTED_MODULE_1__/* .selectorNamedCacheKeysAvailable */ .Z)(state)[_shared_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.OFFLINE_HISTORY_LISTEN */ .jy.OFFLINE_HISTORY_LISTEN];
};

/***/ }),

/***/ 83156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ selectorOfflineHistoryReadIds; }
/* harmony export */ });
/* harmony import */ var _shared_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34855);
/* harmony import */ var _shared_store_sw_selectorNamedCacheKeysAvailable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(625);


var selectorOfflineHistoryReadIds = function selectorOfflineHistoryReadIds(state) {
  return (0,_shared_store_sw_selectorNamedCacheKeysAvailable__WEBPACK_IMPORTED_MODULE_1__/* .selectorNamedCacheKeysAvailable */ .Z)(state)[_shared_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.OFFLINE_HISTORY_READ */ .jy.OFFLINE_HISTORY_READ];
};

/***/ }),

/***/ 27447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ selectorWaveformsDownloadedIds; }
/* harmony export */ });
/* harmony import */ var _shared_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34855);
/* harmony import */ var _shared_store_sw_selectorNamedCacheKeysAvailable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(625);


var selectorWaveformsDownloadedIds = function selectorWaveformsDownloadedIds(state) {
  return (0,_shared_store_sw_selectorNamedCacheKeysAvailable__WEBPACK_IMPORTED_MODULE_1__/* .selectorNamedCacheKeysAvailable */ .Z)(state)[_shared_utils_sw_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .NAMED_CACHE_NAME.WAVEFORM */ .jy.WAVEFORM];
};

/***/ }),

/***/ 53201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ selectorWebsiteUrlsForOfflineUse; }
/* harmony export */ });
/* harmony import */ var _shared_store_sw_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59079);

var selectorWebsiteUrlsForOfflineUse = function selectorWebsiteUrlsForOfflineUse(state) {
  return state[_shared_store_sw_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_SW */ .U].websiteUrls;
};

/***/ }),

/***/ 93893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ _sharedActionsSystem; },
/* harmony export */   "v": function() { return /* binding */ _sharedActionsConstantsSystem; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75573);

var prefix = "sys/";
var _sharedActionsConstantsSystem = {
  LOADING: prefix + "loading",
  TOAST: prefix + "toast",
  TOAST_SUCCESS: prefix + "toast-success",
  SET_IS_ONLINE: prefix + "set-is-online",
  SET_IS_LOGIN: prefix + "set-is-login",
  SET_USER_INFO: prefix + "set-user-info",
  SET_TOP_PANEL_VISIBILITY: prefix + "set-topPanel-visibility",
  UPDATE_DATA_ACQUISITION_STATUS: prefix + "update-data-acquisition-status",
  SET_AVATAR_LAST_UPDATE_TIMESTAMP: prefix + "set-avatar-last-update-timestamp",
  UPLOAD_USER_AVATAR: prefix + "upload-user-avatar",
  DELETE_USER_AVATAR: prefix + "delete-user-avatar"
};
var _sharedActionsSystem = {
  updateDataAcquisitionStatus: function updateDataAcquisitionStatus(data) {
    return {
      type: _sharedActionsConstantsSystem.UPDATE_DATA_ACQUISITION_STATUS,
      data: data
    };
  },
  loading: function loading(loadingId) {
    var forceRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var forceAdd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return {
      type: _sharedActionsConstantsSystem.LOADING,
      data: {
        loadingId: loadingId,
        forceRemove: forceRemove,
        forceAdd: forceAdd
      }
    };
  },
  toast: function toast(message) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_0__/* .TOAST_TYPE.notify */ ["do"].notify;
    return {
      type: _sharedActionsConstantsSystem.TOAST,
      data: {
        message: message,
        type: type
      }
    };
  },
  toastSuccess: function toastSuccess(message) {
    return {
      type: _sharedActionsConstantsSystem.TOAST_SUCCESS,
      data: message
    };
  },
  setIsOnline: function setIsOnline(flag) {
    return {
      type: _sharedActionsConstantsSystem.SET_IS_ONLINE,
      data: flag
    };
  },
  setIsLogin: function setIsLogin(flag, isFetchInitLoad) {
    return {
      type: _sharedActionsConstantsSystem.SET_IS_LOGIN,
      data: flag,
      isFetchInitLoad: isFetchInitLoad // is not in the {data} to not re-write each case.

    };
  },
  setUserInfo: function setUserInfo(userInfo) {
    return {
      type: _sharedActionsConstantsSystem.SET_USER_INFO,
      data: userInfo
    };
  },
  setAvatarLastUpdateTimestamp: function setAvatarLastUpdateTimestamp(timestamp) {
    return {
      type: _sharedActionsConstantsSystem.SET_AVATAR_LAST_UPDATE_TIMESTAMP,
      data: timestamp
    };
  },
  uploadUserAvatar: function uploadUserAvatar(avatar) {
    return {
      type: _sharedActionsConstantsSystem.UPLOAD_USER_AVATAR,
      data: avatar
    };
  },
  deleteUserAvatar: function deleteUserAvatar() {
    return {
      type: _sharedActionsConstantsSystem.DELETE_USER_AVATAR
    };
  },
  setTopPanelVisibility: function setTopPanelVisibility(flag) {
    return {
      type: _sharedActionsConstantsSystem.SET_TOP_PANEL_VISIBILITY,
      data: flag
    };
  }
};

/***/ }),

/***/ 59465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ KEY_REDUCER_SYSTEM; }
/* harmony export */ });
var KEY_REDUCER_SYSTEM = "system";

/***/ }),

/***/ 91809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "If": function() { return /* binding */ selectorUserInfo; },
/* harmony export */   "JU": function() { return /* binding */ selectorSystemOnLine; },
/* harmony export */   "Sg": function() { return /* binding */ selectorSystemLoaders; },
/* harmony export */   "Uw": function() { return /* binding */ selectorLoaderById; },
/* harmony export */   "ci": function() { return /* binding */ selectorSystemDataAcquisitionStatus; },
/* harmony export */   "eq": function() { return /* binding */ selectorSystemIsTopPanelVisible; },
/* harmony export */   "fU": function() { return /* binding */ selectorSystemMessages; },
/* harmony export */   "wN": function() { return /* binding */ selectorSystemIsLogin; }
/* harmony export */ });
/* unused harmony export selectorAvatarLastUpdateTimestamp */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80406);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59465);


var selectorSystemLoaders = function selectorSystemLoaders(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_1__/* .KEY_REDUCER_SYSTEM */ .G].loaders;
};
var selectorSystemMessages = function selectorSystemMessages(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_1__/* .KEY_REDUCER_SYSTEM */ .G].messages;
};
var selectorSystemOnLine = function selectorSystemOnLine(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_1__/* .KEY_REDUCER_SYSTEM */ .G].onLine;
};
var selectorSystemIsLogin = function selectorSystemIsLogin(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_1__/* .KEY_REDUCER_SYSTEM */ .G].isLogin;
};
var selectorUserInfo = function selectorUserInfo(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_1__/* .KEY_REDUCER_SYSTEM */ .G].userInfo;
};
var selectorAvatarLastUpdateTimestamp = function selectorAvatarLastUpdateTimestamp(state) {
  return state[KEY_REDUCER_SYSTEM].avatarLastUpdateTimestamp;
};
var selectorSystemDataAcquisitionStatus = function selectorSystemDataAcquisitionStatus(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_1__/* .KEY_REDUCER_SYSTEM */ .G].dataAcquisitionStatus;
};
var selectorSystemIsTopPanelVisible = function selectorSystemIsTopPanelVisible(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_1__/* .KEY_REDUCER_SYSTEM */ .G].isTopPanelVisible;
};
var selectorLoaderById = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(selectorSystemLoaders, function (_, loadingId) {
  return loadingId;
}, function (loaders, loadingId) {
  return loaders.some(function (id) {
    return id === loadingId;
  });
});

/***/ }),

/***/ 85939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ _sharedActionsConstantsToc; },
/* harmony export */   "v": function() { return /* binding */ _sharedActionsToc; }
/* harmony export */ });
var _sharedActionsConstantsToc = {
  SET_ITEM: "toc/SET_ITEM",
  FETCH: "toc/FETCH"
};
var _sharedActionsToc = {
  setItem: function setItem(bookIdOrigin, toc) {
    return {
      type: _sharedActionsConstantsToc.SET_ITEM,
      data: {
        bookIdOrigin: bookIdOrigin,
        toc: toc
      }
    };
  },
  fetch: function fetch(nBookId) {
    return {
      type: _sharedActionsConstantsToc.FETCH,
      data: nBookId
    };
  }
};

/***/ }),

/***/ 53087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ KEY_REDUCER_TOC; }
/* harmony export */ });
var KEY_REDUCER_TOC = "toc";

/***/ }),

/***/ 8962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ selectorTocItems; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53087);

var selectorTocItems = function selectorTocItems(state) {
  return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .KEY_REDUCER_TOC */ .q].items;
};

/***/ }),

/***/ 12537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Go": function() { return /* binding */ APIUrls; },
/* harmony export */   "ap": function() { return /* binding */ searchStrToReqParams; }
/* harmony export */ });
/* unused harmony exports getParamsNames, filterRequestParamsByParams, reqParamsToString, parseAcceptLanguageHeader, decodeSearchStr, parseProtocol, parseHost, initMiddleware, getCorsConfig, getWindowEnv, isIphoneByUserAgent */
/* provided dependency */ var process = __webpack_require__(27061);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var APIUrls = {
  robots: "/robots.txt",
  getToken: "/api/getToken",
  status: "/api/status",
  authCallback: "/api/authCallback",
  fbCallback: "/api/callbackFB",
  getInstagramLastPostId: "/api/getInstagramLastPostId",
  proxyFaqSearch: "/api/faq-search",
  proxySearchAnswers: "/api/search-answers"
};
var getParamsNames = function getParamsNames(params) {
  return Object.values(params).map(function (_ref) {
    var name = _ref.name;
    return name;
  });
};
var filterRequestParamsByParams = function filterRequestParamsByParams(reqParams, params) {
  var out = {};
  var paramsNames = getParamsNames(params);
  Object.keys(reqParams).forEach(function (key) {
    if (paramsNames.includes(key)) {
      out[key] = reqParams[key];
    }
  });
  return out;
};
var reqParamsToString = function reqParamsToString(params, encode) {
  var withFirstPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var firstPrefix = withFirstPrefix ? "?" : "";
  var i = 0;
  return Object.entries(params).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        name = _ref3[0],
        value = _ref3[1];

    if (value !== "" && value !== undefined) {
      var prefix = i === 0 ? firstPrefix : "&"; // "encodeURI" is needed to encode cyrillic letters for the Search API (e.g. "?query=бог").

      acc += prefix + name + "=" + (encode ? encodeURIComponent(value) : value);
      i++;
    }

    return acc;
  }, "");
};
var parseAcceptLanguageHeader = function parseAcceptLanguageHeader(str) {
  if (!str) {
    return undefined;
  }

  var _str$match = str.match(/((([a-zA-Z]+(-[a-zA-Z0-9]+){0,2})|\*)(;q=[0-1](\.[0-9]+)?)?)*/g),
      _str$match2 = _slicedToArray(_str$match, 1),
      langStr = _str$match2[0];

  var _langStr$split = langStr.split("-"),
      _langStr$split2 = _slicedToArray(_langStr$split, 1),
      langShort = _langStr$split2[0];

  return langShort;
};
var searchStrToReqParams = function searchStrToReqParams(str) {
  var decode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!str) {
    return {};
  }

  return str.replace("?", "").split("&").reduce(function (acc, pair) {
    var _pair$split = pair.split("="),
        _pair$split2 = _slicedToArray(_pair$split, 2),
        name = _pair$split2[0],
        value = _pair$split2[1];

    if (name !== undefined && value !== undefined) {
      // Prevents "?=undefined".
      acc[name] = decode ? decodeURIComponent(value) : value;
    }

    return acc;
  }, {});
};
var decodeSearchStr = function decodeSearchStr(str) {
  return decodeURIComponent(decodeURI(str.replace(/\+/g, " ")));
};
var parseProtocol = function parseProtocol(req, host) {
  if (req && req.headers["x-forwarded-proto"] && typeof req.headers["x-forwarded-proto"] === "string") {
    return "".concat(req.headers["x-forwarded-proto"], ":");
  }

  return /^localhost(:\d+)?$/.test(host) ? "http:" : "https:";
};
var parseHost = function parseHost(req) {
  if (req) {
    if (req.headers.host) {
      return req.headers.host;
    }

    if (req.headers["x-forwarded-host"] && typeof req.headers["x-forwarded-host"] === "string") {
      return req.headers["x-forwarded-host"];
    }
  }

  return null;
};
var initMiddleware = function initMiddleware(middleware) {
  return function (req, res) {
    return new Promise(function (resolve, reject) {
      middleware(req, res, function (result) {
        if (result instanceof Error) {
          return reject(result);
        }

        return resolve(result);
      });
    });
  };
}; // TODO add params from env

var getCorsConfig = function getCorsConfig() {
  return {
    methods: ["GET"],
    origin: "*"
  };
};
/**
 *
 * @returns generated content for inject process.env parameters to window.env
 */

var getWindowEnv = function getWindowEnv() {
  return "window.env = {\n      REACT_APP_RESOURCE_URL: \"".concat(process.env.REACT_APP_RESOURCE_URL, "\",\n      REACT_APP_SERVER_URL: \"").concat(process.env.REACT_APP_SERVER_URL, "\",\n      REACT_APP_CLIENT_ID_AUTHORIZED: \"").concat(process.env.REACT_APP_CLIENT_ID_AUTHORIZED, "\",\n      REACT_APP_CPANEL: \"").concat(process.env.REACT_APP_CPANEL, "\",\n      REACT_APP_TEXT_APP_HOST: \"").concat(process.env.REACT_APP_TEXT_APP_HOST, "\",\n      REACT_APP_NEXT_APP_HOST: \"").concat(process.env.REACT_APP_NEXT_APP_HOST, "\",\n      REACT_APP_BASE_HOST: \"").concat(process.env.REACT_APP_BASE_HOST, "\",\n      REACT_APP_SEARCH_LOGS_URL: \"").concat(process.env.REACT_APP_SEARCH_LOGS_URL, "\",\n      REACT_APP_SEARCH_LOGS_TOKEN: \"").concat(process.env.REACT_APP_SEARCH_LOGS_TOKEN, "\",\n      REACT_APP_ENVIRONMENT: \"").concat(process.env.REACT_APP_ENVIRONMENT, "\",\n      REACT_APP_MAIN_APP_HOST: \"").concat(process.env.REACT_APP_MAIN_APP_HOST, "\",\n      REACT_APP_IS_LANDING: \"").concat(process.env.REACT_APP_IS_LANDING, "\",\n      REACT_APP_SERVER_TOKEN: \"").concat(process.env.REACT_APP_SERVER_TOKEN, "\",\n      REACT_APP_FB_APP_ID: \"").concat(process.env.REACT_APP_FB_APP_ID, "\",\n    }");
};
var isIphoneByUserAgent = function isIphoneByUserAgent(strUserAgent) {
  if (typeof strUserAgent === "string") {
    return strUserAgent.includes("iPhone");
  }

  return false;
};

/***/ }),

/***/ 21707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G2": function() { return /* binding */ arrayToObjMap; },
/* harmony export */   "L1": function() { return /* binding */ sortByField; },
/* harmony export */   "Sr": function() { return /* binding */ SortDirection; },
/* harmony export */   "aW": function() { return /* binding */ filterByArray; },
/* harmony export */   "dl": function() { return /* binding */ joinObjArrays; },
/* harmony export */   "h$": function() { return /* binding */ bufferToBase64; },
/* harmony export */   "jq": function() { return /* binding */ isArraysContentsEquals; },
/* harmony export */   "lI": function() { return /* binding */ sortByArray; },
/* harmony export */   "rO": function() { return /* binding */ toggleInArray; },
/* harmony export */   "yf": function() { return /* binding */ arraymove; }
/* harmony export */ });
/* unused harmony exports moveArrayElementToIndex, removeFromArrayWithArray, joinArrays, isArr1IncludesEachArr2Item */
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

var SortDirection = {
  ASC: "ASC",
  DESC: "DESC"
};
var sortByField = function sortByField(items, getField) {
  var sortDirection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SortDirection.ASC;

  var sortedList = _toConsumableArray(items);

  if (!getField || !sortDirection) {
    return sortedList;
  }

  var isGetFieldFunction = typeof getField === "function";
  return sortedList.sort(function (leftItem, rightItem) {
    var left = isGetFieldFunction ? getField(leftItem) : leftItem[getField];
    var right = isGetFieldFunction ? getField(rightItem) : rightItem[getField];

    if (sortDirection === SortDirection.ASC) {
      return left < right ? -1 : 1;
    }

    return left > right ? -1 : 1;
  });
};
var arraymove = function arraymove(arr, fromIndex, toIndex) {
  if (fromIndex === -1 || toIndex === fromIndex) {
    return;
  }

  var element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
};
var moveArrayElementToIndex = function moveArrayElementToIndex(items, element, index) {
  var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var indexCurrent;

  if (key) {
    indexCurrent = items.findIndex(function (i) {
      return i[key] === element;
    });
  } else {
    indexCurrent = items.indexOf(element);
  }

  if (indexCurrent !== -1 && indexCurrent !== index) {
    arraymove(items, indexCurrent, index);
  }

  return items;
};
/**
 * Sort base array based on sort list
 * @param {array} baseList
 * @param {array} sortList
 * @param {string} key
 * @returns sorted array
 */

var sortByArray = function sortByArray(baseList, sortList) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

  var outList = _toConsumableArray(baseList);

  var indexList = {};
  sortList.forEach(function (item, index) {
    return indexList[item] = index + 1;
  });
  outList.sort(function (a, b) {
    var valA = key ? a[key] : a;
    var valB = key ? b[key] : b;
    var orderA = indexList[valA] || outList.length;
    var orderB = indexList[valB] || outList.length;
    return orderA - orderB;
  });
  return outList;
};
var filterByArray = function filterByArray(arr, arrKeysFilters, key) {
  if (arrKeysFilters.length === 0) {
    return arr;
  }

  return arr.filter(function (i) {
    return arrKeysFilters.includes(i[key]);
  });
};
var toggleInArray = function toggleInArray(arr, value, forcePush) {
  var forceRemove = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var index = arr.indexOf(value);

  if (index === -1) {
    if (!forceRemove) {
      arr.push(value);
    }
  } else if (!forcePush) {
    arr.splice(index, 1);
  }

  return index;
};
var removeFromArrayWithArray = function removeFromArrayWithArray(array, removeIds) {
  var removeId, removeIdIndex;

  for (var i = 0; i < removeIds.length; i++) {
    removeId = removeIds[i];
    removeIdIndex = array.findIndex(function (element) {
      return element === removeId;
    });

    if (removeIdIndex !== -1) {
      array.splice(removeIdIndex, 1);
    }
  }
}; // Converts an ArrayBuffer to base64, by converting to string
// and then using window.btoa' to base64.

var bufferToBase64 = function bufferToBase64(buffer) {
  if (!__webpack_require__.g.window) {
    return "";
  }

  var bytes = new Uint8Array(buffer);
  var len = buffer.byteLength;
  var binary = "";

  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return window.btoa(binary);
};
var arrayToObjMap = function arrayToObjMap(aArray, key, value) {
  var obj = {};
  aArray.forEach(function (item) {
    obj[item[key]] = item[value];
  });
  return obj;
};
var joinObjArrays = function joinObjArrays(arrays) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "id";
  var obj = {};
  arrays.forEach(function (array) {
    array.forEach(function (item) {
      if (!obj[item[key]]) {
        obj[item[key]] = item;
      }
    });
  });
  var finalList = [];
  Object.keys(obj).forEach(function (objKey) {
    finalList.push(obj[objKey]);
  });
  return finalList;
};
var joinArrays = function joinArrays(arrays) {
  var arrayFull = [];
  arrays.forEach(function (arr) {
    arrayFull.push.apply(arrayFull, _toConsumableArray(arr));
  });
  return _toConsumableArray(new Set(arrayFull));
};
var isArr1IncludesEachArr2Item = function isArr1IncludesEachArr2Item(arr1, arr2) {
  return arr1 && arr2 && arr1.length && arr2.length && arr2.every(function (element) {
    return arr1.includes(element);
  });
};
var isArraysContentsEquals = function isArraysContentsEquals(arr1, arr2, compareOrder) {
  return arr1 && arr2 && arr1.length === arr2.length && arr2.every(function (element, index) {
    return compareOrder === true ? element === arr1[index] : arr1.includes(element);
  });
};

/***/ }),

/***/ 76732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AK": function() { return /* binding */ getEvnVariable; },
/* harmony export */   "rd": function() { return /* binding */ _experimental_isNextApp; },
/* harmony export */   "yG": function() { return /* binding */ isDevelopment; },
/* harmony export */   "yv": function() { return /* binding */ isProduction; }
/* harmony export */ });
/* unused harmony exports EL_CLASSNAME_NEXTAPP, getSentryDSN, getEnvironment, isStaging, isTest */
/* provided dependency */ var process = __webpack_require__(27061);
var EL_CLASSNAME_NEXTAPP = "nextapp";
var _experimental_isNextApp = "window" in __webpack_require__.g && document.documentElement.classList.contains(EL_CLASSNAME_NEXTAPP);
var getEvnVariable = function getEvnVariable(key, envValue, defaultValue) {
  var value = envValue;

  if ( true && window.env && window.env[key]) {
    value = window.env[key];
  }

  return value || defaultValue;
};
var getSentryDSN = function getSentryDSN() {
  return getEvnVariable("REACT_APP_SENTRY_DSN", process.env.REACT_APP_SENTRY_DSN, "https://afbc217bb2af4dfab407f6afe216e267@o4504169105850368.ingest.sentry.io/4504169109585920");
};
var getEnvironment = function getEnvironment() {
  return getEvnVariable("REACT_APP_ENVIRONMENT", process.env.REACT_APP_ENVIRONMENT, "development");
};
var isStaging = function isStaging() {
  return getEnvironment() === "staging";
};
var isProduction = function isProduction() {
  return getEnvironment() === "production";
};
var isTest = function isTest() {
  return getEnvironment() === "test";
};
var isDevelopment = function isDevelopment() {
  return  false || false;
};

/***/ }),

/***/ 45973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ makeBreadcrumbLandingBook; },
/* harmony export */   "A3": function() { return /* binding */ makeBreadcrumbsObject; },
/* harmony export */   "KC": function() { return /* binding */ makeBreadcrumbChapter; },
/* harmony export */   "gH": function() { return /* binding */ makeBreadcrumbsReader; },
/* harmony export */   "ri": function() { return /* binding */ makeBreadcrumbsChapter; }
/* harmony export */ });
/* unused harmony exports clearUnnecessaryPropertiesForBreadcrumbs, makeBreadcrumbLandingLang, makeBreadcrumbsBookPage, makeBreadcrumbsAllCollection, makeBreadcrumbsHomePage */
/* harmony import */ var _content_content__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69051);
/* harmony import */ var _menu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35567);
/* harmony import */ var _reader_reader_chapters_navigator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80256);
/* harmony import */ var _search_search__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15347);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23658);
/* harmony import */ var _multilang_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76439);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var clearUnnecessaryPropertiesForBreadcrumbs = function clearUnnecessaryPropertiesForBreadcrumbs(breadcrumbs) {
  return breadcrumbs.map(function (_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === void 0 ? null : _ref$className,
        id = _ref.id,
        label = _ref.label,
        children = _ref.children,
        url = _ref.url,
        title = _ref.title,
        _ref$book_id = _ref.book_id,
        book_id = _ref$book_id === void 0 ? null : _ref$book_id,
        _ref$folder_id = _ref.folder_id,
        folder_id = _ref$folder_id === void 0 ? null : _ref$folder_id,
        _ref$lang = _ref.lang,
        lang = _ref$lang === void 0 ? null : _ref$lang;
    var elem = {
      id: id,
      label: label || title || "",
      url: url ? url.replace("/text", "") : null,
      book_id: book_id,
      folder_id: folder_id,
      lang: lang,
      className: className
    };

    if (children) {
      elem.children = children.map(function (child) {
        return _objectSpread(_objectSpread({}, child), {}, {
          children: []
        });
      });
    }

    return elem;
  });
};
var makeBreadcrumbChapter = function makeBreadcrumbChapter(chapter, children) {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbType.chapter */ .k.chapter,
    id: chapter.id,
    label: chapter.title,
    children: children && children.length ? children.map(makeBreadcrumbChapter) : null
  };
};

var makeBreadcrumbBook = function makeBreadcrumbBook(book, children) {
  var bookChildren = null;
  var tocTree = children && children.length ? (0,_content_content__WEBPACK_IMPORTED_MODULE_0__/* .parseTocInternal */ .Y6)(children, 0) : null;

  if (tocTree && tocTree.length) {
    bookChildren = tocTree[0].children;
  }

  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbType.book */ .k.book,
    id: book.id,
    label: book.title,
    children: bookChildren && bookChildren.length ? bookChildren.map(makeBreadcrumbChapter) : null
  };
};

var makeBreadcrumbFolder = function makeBreadcrumbFolder(folder, children) {
  var out = {
    type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbType.folder */ .k.folder,
    id: folder.id,
    label: folder.label || folder.title || "",
    folder_id: folder.folder_id || "",
    lang: folder.lang || "",
    className: folder.className || ""
  };

  if (children && children.length) {
    var isChildrenBooks = !!children[0].book_id;
    out.children = isChildrenBooks ? children.map(makeBreadcrumbBook) : children.map(makeBreadcrumbFolder);
  }

  return out;
};

var makeBreadcrumbLanguage = function makeBreadcrumbLanguage(language, children) {
  var childrenBreadcrumbs = null;

  if (children && children.length) {
    var isChildrenLanguages = !!children[0].code;
    childrenBreadcrumbs = isChildrenLanguages ? children.map(makeBreadcrumbLanguage) : children.map(makeBreadcrumbFolder);
  }

  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbType.folder */ .k.folder,
    id: language.id,
    label: language.label,
    children: childrenBreadcrumbs
  };
};

var makeBreadcrumbLandingLang = function makeBreadcrumbLandingLang(book, langs) {
  var bookLang = langs.find(function (lang) {
    return lang.code === book.lang;
  });
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbType.chapter */ .k.chapter,
    id: book.first_para,
    label: bookLang ? "".concat(bookLang.label, " - ").concat(book.title) : book.title
  };
};
var makeBreadcrumbLandingBook = function makeBreadcrumbLandingBook(book) {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbType.externalUrl */ .k.externalUrl,
    id: book.id,
    label: book.title,
    url: book.urlLanding
  };
};

var makeBreadcrumbMenuItem = function makeBreadcrumbMenuItem(menuItem, children) {
  return _objectSpread(_objectSpread({}, menuItem), {}, {
    children: children ? children.map(makeBreadcrumbLanguage) : null
  });
};

var getBreadcrumbsForFolderTreeTrace = function getBreadcrumbsForFolderTreeTrace(folderTreeTrace) {
  return folderTreeTrace.map(function (f) {
    return makeBreadcrumbFolder(f, f.children);
  });
};

var getBreadcrumbsForLanguages = function getBreadcrumbsForLanguages(isLanding, langs, languageActive) {
  if (langs && langs.length) {
    var languageSuitable = langs.find(function (lang) {
      return lang.id === languageActive;
    }) || langs[0];
    return makeBreadcrumbLanguage(languageSuitable, isLanding ? null : languageSuitable.children);
  }

  return null;
}; // Is exported temporary, check the usage place.


var makeBreadcrumbsChapter = function makeBreadcrumbsChapter(toc, _chapterId) {
  var traceTOC = [];

  if (toc && toc.length && _chapterId) {
    var chapterIdFinal;
    var chapterCurrentFixed = (0,_reader_reader_chapters_navigator__WEBPACK_IMPORTED_MODULE_5__/* .diveToChapterWithContent */ .vm)(_chapterId, toc);

    if (chapterCurrentFixed.index === -1) {
      chapterIdFinal = _chapterId;
    } else {
      chapterIdFinal = chapterCurrentFixed.chapter.id;
    }

    var tocTree = toc ? (0,_content_content__WEBPACK_IMPORTED_MODULE_0__/* .parseTocInternal */ .Y6)(toc, 0) : undefined;
    var tocTreeFinal = tocTree && tocTree[0] && tocTree[0].children ? tocTree[0].children : toc;
    (0,_content_content__WEBPACK_IMPORTED_MODULE_0__/* .findNode */ .DY)(chapterIdFinal, tocTreeFinal, "id", traceTOC);
    traceTOC = traceTOC.map(function (c) {
      return makeBreadcrumbChapter(c, c.children);
    }).reverse();
  }

  return traceTOC;
};
/**
 * @param crumbs - crumbs itself
 * @param collection - influences the breadcrumbs color (e.g. brown for bible, blue for egw)
 */

var makeBreadcrumbsObject = function makeBreadcrumbsObject(crumbs, collection) {
  return {
    // probably, rename properties to better names.
    title: crumbs && crumbs.length ? crumbs[crumbs.length - 1].label : "–",
    breadcrumbs: crumbs,
    folderType: collection || ""
  };
};
var makeBreadcrumbsBookPage = function makeBreadcrumbsBookPage(isLanding, langs, folderTreeTrace, book, mainMenuItem) {
  var languageActiveFinal = book && book.lang || folderTreeTrace && folderTreeTrace.length && folderTreeTrace[0].lang || DEFAULT_LANGUAGE;
  var breadcrumbs = [_objectSpread(_objectSpread({}, mainMenuItem), {}, {
    id: "/?lang=".concat(languageActiveFinal),
    // children: isLanding ? null : mainMenuItem.children.filter((i) => {
    //   return !i.locations
    //     || !i.locations.length
    //     || i.locations.includes(MENU_ITEM_LOCATION.BREADCRUMBS);
    // }),
    children: isLanding ? null : langs.map(makeBreadcrumbLanguage)
  }) // {
  //   ...MenuItems.allCollection,
  //   children: isLanding ? null : langs,
  // }
  ];

  if (languageActiveFinal) {
    var breadcrumbLanguage = getBreadcrumbsForLanguages(isLanding, langs, languageActiveFinal);

    if (breadcrumbLanguage) {
      breadcrumbs.push(breadcrumbLanguage);
    }
  }

  if (!isLanding && folderTreeTrace) {
    breadcrumbs.push.apply(breadcrumbs, _toConsumableArray(getBreadcrumbsForFolderTreeTrace(folderTreeTrace)));
  }

  if (book) {
    breadcrumbs.push(makeBreadcrumbBook(book));
  }

  return makeBreadcrumbsObject(breadcrumbs);
};
var makeBreadcrumbsAllCollection = function makeBreadcrumbsAllCollection(isLanding, langs, folderTreeTrace, lang, mainMenuItem, menuItemAllCollection) {
  var languageActiveFinal = folderTreeTrace && folderTreeTrace.length && folderTreeTrace[0].lang || lang;
  var breadcrumbs = [_objectSpread(_objectSpread({}, mainMenuItem), {}, {
    id: "/?lang=".concat(languageActiveFinal),
    children: isLanding ? null : mainMenuItem.children.filter(function (i) {
      return !i.locations || !i.locations.length || i.locations.includes(MENU_ITEM_LOCATION.BREADCRUMBS);
    })
  }), makeBreadcrumbMenuItem(menuItemAllCollection, isLanding ? null : langs)];

  if (languageActiveFinal) {
    var breadcrumbLanguage = getBreadcrumbsForLanguages(isLanding, langs, languageActiveFinal);

    if (breadcrumbLanguage) {
      breadcrumbs.push(breadcrumbLanguage);
    }
  }

  if (folderTreeTrace) {
    breadcrumbs.push.apply(breadcrumbs, _toConsumableArray(getBreadcrumbsForFolderTreeTrace(folderTreeTrace)));
  }

  return makeBreadcrumbsObject(breadcrumbs, getFolderType(folderTreeTrace, "add_class"));
};
var makeBreadcrumbsReader = function makeBreadcrumbsReader(isLanding, langs, folderTreeTrace, book, toc, chapterId, mainMenuItem, bookTitles, childrenCustomSuitableLang) {
  var bookLang = book && book.lang;
  var breadcrumbs = [_objectSpread(_objectSpread({}, mainMenuItem), {}, {
    id: "/?lang=".concat(bookLang),
    children: isLanding ? bookTitles.map(function (book) {
      return makeBreadcrumbLandingLang(book, langs);
    }) : langs.map(makeBreadcrumbLanguage)
  })];

  if (bookLang) {
    var breadcrumbLanguage = getBreadcrumbsForLanguages(isLanding, langs, bookLang);

    if (breadcrumbLanguage) {
      if (isLanding) {
        breadcrumbLanguage.type = _constants__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbType.nonClickable */ .k.nonClickable;

        if (childrenCustomSuitableLang) {
          breadcrumbLanguage.children = childrenCustomSuitableLang;
        }
      }

      breadcrumbs.push(breadcrumbLanguage);
    }
  }

  if (!isLanding && folderTreeTrace) {
    breadcrumbs.push.apply(breadcrumbs, _toConsumableArray(getBreadcrumbsForFolderTreeTrace(folderTreeTrace)));
  }

  if (book) {
    var breadcrumbBook = makeBreadcrumbBook(book, toc);
    breadcrumbs.push(isLanding ? _objectSpread(_objectSpread({}, breadcrumbBook), {}, {
      type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbType.nonClickable */ .k.nonClickable
    }) : breadcrumbBook);
  }

  if (toc && toc.length && chapterId) {
    breadcrumbs.push.apply(breadcrumbs, _toConsumableArray(makeBreadcrumbsChapter(toc, chapterId)));
  }

  return makeBreadcrumbsObject(breadcrumbs, book ? book.folder_color_group : "");
};
var makeBreadcrumbsHomePage = function makeBreadcrumbsHomePage(langs, folderTreeTrace) {
  var breadcrumbs = [];
  var languageActiveFinal = folderTreeTrace && folderTreeTrace.length && folderTreeTrace[0].lang || DEFAULT_LANGUAGE;

  if (languageActiveFinal) {
    var breadcrumbLanguage = getBreadcrumbsForLanguages(false, langs, languageActiveFinal);

    if (breadcrumbLanguage) {
      breadcrumbs.push(breadcrumbLanguage);
    }
  }

  return makeBreadcrumbsObject(breadcrumbs);
};

/***/ }),

/***/ 23658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ BreadcrumbType; }
/* harmony export */ });
var BreadcrumbType = {
  nonClickable: "nonClickable",
  lang: "lang",
  folder: "folder",
  book: "book",
  chapter: "chapter",
  externalUrl: "externalUrl"
};

/***/ }),

/***/ 65795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B9": function() { return /* binding */ consoleLogGroup; },
/* harmony export */   "UA": function() { return /* binding */ consoleLogSuccess; },
/* harmony export */   "aw": function() { return /* binding */ consoleLogError; },
/* harmony export */   "b9": function() { return /* binding */ consoleLogWarning; },
/* harmony export */   "jn": function() { return /* binding */ consoleLogInfo; }
/* harmony export */ });
/* unused harmony export consoleLogBasic */
/* harmony import */ var _theme_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93752);
var _mapBgColor;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var Type = {
  basic: "0",
  success: "1",
  error: "2",
  info: "3",
  warning: "4"
};
var mapBgColor = (_mapBgColor = {}, _defineProperty(_mapBgColor, Type.basic, "#ffffff"), _defineProperty(_mapBgColor, Type.success, "#008000"), _defineProperty(_mapBgColor, Type.error, "#B22222"), _defineProperty(_mapBgColor, Type.info, "#00AAAA"), _defineProperty(_mapBgColor, Type.warning, "#FFD700"), _mapBgColor);

var consoleLog = function consoleLog(type, scope, text) {
  var _console;

  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  // eslint-disable-next-line no-console
  (_console = console).log.apply(_console, ["%c".concat(scope ? "[".concat(scope, "]") : "", " ").concat(text), "background: ".concat(mapBgColor[type], ";\n    color: ").concat((0,_theme_theme__WEBPACK_IMPORTED_MODULE_0__/* .checkColorDark */ .XY)(mapBgColor[type]) ? "white" : "black", ";\n    ").concat(type === Type.basic ? "font-weight: bold;" : "", "\n    ")].concat(args));
};

var makeConsoleLogFn = function makeConsoleLogFn(type) {
  return function (scope, text) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    consoleLog.apply(void 0, [type, scope, text].concat(args));
  };
};

var consoleLogSuccess = makeConsoleLogFn(Type.success);
var consoleLogError = makeConsoleLogFn(Type.error); // export const consoleLogErrorWithTrace = (...args) => {
//   consoleLogError(...args);
//
//   console.groupCollapsed("Trace");
//   console.trace();
//   console.groupEnd();
// };

var consoleLogWarning = makeConsoleLogFn(Type.warning);
var consoleLogInfo = makeConsoleLogFn(Type.info);
var consoleLogBasic = makeConsoleLogFn(Type.basic);
var consoleLogGroup = function consoleLogGroup(groupName, data) {
  console.groupCollapsed(groupName);
  console.log(data);
  console.groupEnd();
};

/***/ }),

/***/ 5626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ft": function() { return /* binding */ folderIdRegex; },
/* harmony export */   "J8": function() { return /* binding */ CONTENT_CLASSES; },
/* harmony export */   "QO": function() { return /* binding */ bookIdRegex; },
/* harmony export */   "S": function() { return /* binding */ FOLDER_TYPE; },
/* harmony export */   "Vz": function() { return /* binding */ TREE_LABEL_HIDE_IN_TREE; },
/* harmony export */   "ZF": function() { return /* binding */ langRegex; },
/* harmony export */   "_i": function() { return /* binding */ BOOK_TYPE; },
/* harmony export */   "b2": function() { return /* binding */ bookIdRegexStrict; },
/* harmony export */   "eW": function() { return /* binding */ DEFAULT_BIBLE; },
/* harmony export */   "k$": function() { return /* binding */ BOOK_PERMISSION; },
/* harmony export */   "nM": function() { return /* binding */ POSTFIX_BOOK_CODE_SG; },
/* harmony export */   "tA": function() { return /* binding */ NKJV_BIBLE; },
/* harmony export */   "ww": function() { return /* binding */ paraWithoutPrefixRegExp; },
/* harmony export */   "yj": function() { return /* binding */ BOOK_TYPES; }
/* harmony export */ });
/* unused harmony exports LANGUAGE_DIRECTION, BOOK_SUB_TYPE, CLASSNAME_READER_DEV_ID_ITEM */
var POSTFIX_BOOK_CODE_SG = "-SG";
var bookIdRegex = /b[0-9]*/;
var folderIdRegex = /^[0-9]+$/;
var langRegex = /^[a-z]+$/;
var bookIdRegexStrict = new RegExp("^".concat(bookIdRegex.source, "$"));
var paraWithoutPrefixRegExp = /(\d+)\.(\d+)/;
var NKJV_BIBLE = "b14334";
var DEFAULT_BIBLE = {
  en: "1965"
};
var BOOK_TYPE = {
  book: "book",
  bible: "bible",
  apl: "apl",
  manuscript: "manuscript",
  periodical: "periodical",
  dictionary: "dictionary"
};
var LANGUAGE_DIRECTION = {
  rightToLeft: "rtl"
};
var BOOK_TYPES = Object.values(BOOK_TYPE);
var BOOK_SUB_TYPE = {
  commentary: "commentary",
  noPageBreaks: "no pagebreaks",
  empty: ""
};
var FOLDER_TYPE = {
  bible: "bible",
  apl: "apl",
  egwwritings: "egwwritings",
  reference: "reference"
};
var BOOK_PERMISSION = {
  purchased: "purchased",
  authenticated: "authenticated",
  public: "public"
};
var TREE_LABEL_HIDE_IN_TREE = "none";
var CLASSNAME_READER_DEV_ID_ITEM = "dev-id-item";
var CONTENT_CLASSES = {
  EGW_WRITINGS: FOLDER_TYPE.egwwritings,
  EGW_LINK: "egwlink",
  EGW_LINK_BOOK: "egwlink_book",
  EGW_LINK_BIBLE: "egwlink_bible",
  EGW_LINK_EXTERNAL: "egwlink_external",
  BOOKS: "books",
  BOOK: BOOK_TYPE.book,
  READER_HEADER_TEXT: "readerHeaderText",
  PAGE_NUMBER: "readerPageNumber",
  REF_CODE: "refCode",
  DICTIONARY: BOOK_TYPE.dictionary,
  REFERENCE: FOLDER_TYPE.reference,
  PAGE_BREAK: "page-break",
  PARAGRAPH: "para",
  PICTURE: "para-picture",
  CHAPTER: "chapter",
  LANGUAGE: "language",
  FOLDER: "folder",
  ICON_TRANSLATE: "reader-translate-icon",
  ICON_BIBLE: "egw-bible-icon",
  CATEGORIES_ROOT: "categories-root",
  CATEGORIES_CATEGORY: "categories-category",
  CATEGORIES_BOOK: "categories-book",
  CATEGORIES_LANGUAGE_FOLDER: "categories-language-folder",
  CATEGORIES_BOOK_TRANSLATION: "categories-book-translation",
  TITLES_ROOT: "titles-root",
  TITLES_CATEGORY: "titles-category",
  TITLES_BOOK: "titles-book",
  TITLES_LANGUAGE_FOLDER: "titles-language-folder",
  TITLES_BOOK_TRANSLATION: "titles-book-translation",
  TREE_ITEM: "tree-item",
  FOOT_NOTE: "footnote",
  CHAPTER_END_NOTE: "chapterendnote",
  BOOK_END_NOTE: "bookendnote",
  SC_MARK: "sc-mark",
  SC_NOTE: "sc-note",
  SC_BOOKMARK: "sc-bookmark",
  SC_HIGHLIGHT: "hh"
};

/***/ }),

/***/ 69051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$9": function() { return /* binding */ isBookRealTypeBibleCommentaries; },
/* harmony export */   "$s": function() { return /* binding */ isBookRealTypeBible; },
/* harmony export */   "DY": function() { return /* binding */ findNode; },
/* harmony export */   "Eq": function() { return /* binding */ normalizeSubsContent; },
/* harmony export */   "H7": function() { return /* binding */ cutOutHeaders; },
/* harmony export */   "H8": function() { return /* binding */ removeBR; },
/* harmony export */   "HS": function() { return /* binding */ getFirstTitleChar; },
/* harmony export */   "NR": function() { return /* binding */ getBookIdWithPrefix; },
/* harmony export */   "Y6": function() { return /* binding */ parseTocInternal; },
/* harmony export */   "av": function() { return /* binding */ removeTags; },
/* harmony export */   "bp": function() { return /* binding */ makeParaDataFinal; },
/* harmony export */   "dr": function() { return /* binding */ isBookPermissionAuthOK; },
/* harmony export */   "fr": function() { return /* binding */ isSameBook; },
/* harmony export */   "hQ": function() { return /* binding */ isBookPermissionPurchaseOK; },
/* harmony export */   "o": function() { return /* binding */ makeChapterTree; },
/* harmony export */   "o8": function() { return /* binding */ getBookIdNumber; },
/* harmony export */   "wh": function() { return /* binding */ isTreeItemExpandable; }
/* harmony export */ });
/* unused harmony exports getParagraph, getChapterNumber, renderYearAndName, convertChapters, normalizeBibleRefCode4, isShowParaLevelByBookRealType, isBookForSale, isBookPermissionsOK */
/* harmony import */ var _content_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5626);
/* harmony import */ var _shared_utils_reader_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16484);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }



/**
 * @param {string | number | {}} idOrBook
 * @return {string} e.g. "b127"
 */

var getBookIdWithPrefix = function getBookIdWithPrefix(idOrBook) {
  var id = idOrBook;

  if (id !== null && _typeof(id) === 'object') {
    id = idOrBook.id || idOrBook.book_id;
  }

  if (!id) {
    return undefined;
  }

  if (_content_constants__WEBPACK_IMPORTED_MODULE_0__/* .bookIdRegexStrict.test */ .b2.test(id)) {
    return id;
  }

  var value = Number.isInteger(id) ? id.toString() : id;

  var _value$split = value.split("."),
      _value$split2 = _slicedToArray(_value$split, 1),
      book = _value$split2[0];

  return "b" + book.replace(/[a-z]/, "");
};
var getParagraph = function getParagraph(paraId, paragraphs) {
  if (paraId) {
    var bookParas = paragraphs[getBookIdNumber(paraId)];

    if (bookParas) {
      var paragraph = bookParas.find(function (item) {
        return item.id === paraId;
      });

      if (paragraph) {
        return paragraph;
      }
    }
  }

  return undefined;
};
var getBookIdNumber = function getBookIdNumber(value) {
  if (!value) {
    return undefined;
  }

  if (typeof value === "string") {
    var outValue = value.split(".")[0].replace(/[a-z]/, "");
    return parseInt(outValue);
  }

  return value;
};
var getChapterNumber = function getChapterNumber(value) {
  if (!value) {
    return undefined;
  }

  if (typeof value === "string") {
    var outValue = value.split(".")[1];
    return parseInt(outValue);
  }

  return value;
};
/**
 * method checkes ids for one book. canc check paraId and bookId
 * @param {*} paraId  123.45 or b123
 * @param {*} paraId1 123.45 or b123
 */

var isSameBook = function isSameBook(paraId, paraId1) {
  if (!paraId || !paraId1) {
    return false;
  }

  return getBookIdWithPrefix(paraId) === getBookIdWithPrefix(paraId1);
};
var renderYearAndName = function renderYearAndName(_ref) {
  var pubYear = _ref.pub_year,
      pubName = _ref.pub_name;
  var year = Number(pubYear) !== 0 ? pubYear : "";
  return (year ? "".concat(year, " ").concat(pubName) : pubName) || "";
};
var removeBR = function removeBR(text) {
  var newValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";

  if (!text) {
    return "";
  }

  return text.replace(/<br\s*[/]?>/gi, newValue);
};

var makeChapter = function makeChapter(chapter) {
  return _objectSpread(_objectSpread({}, chapter), {}, {
    label: chapter.title || chapter.refcode_short || chapter.para_id,
    className: _content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.CHAPTER */ .J8.CHAPTER,
    id: chapter.para_id
  });
};

var parseTocInternal = function parseTocInternal(initialData, initialLevel) {
  var tracklistIndex = 0;

  var toc = function toc(data, level) {
    if (!data.length) {
      return [];
    }

    var result = [];
    var accumulator = [];
    var lastChunk = null;

    for (var i = 0; i < data.length; i++) {
      var chap = makeChapter(data[i]);

      if (chap.level === level) {
        if (lastChunk != null) {
          var _resultItem = lastChunk;

          if (lastChunk.mp3) {
            _resultItem.cursor = tracklistIndex;
            tracklistIndex++;
          }

          _resultItem.children = toc(accumulator, level + 1);
          result.push(_resultItem);
          accumulator.length = 0;
        }

        lastChunk = chap;
      } else {
        accumulator.push(chap);
      }
    }

    var resultItem = lastChunk;

    if (lastChunk.mp3) {
      resultItem.cursor = tracklistIndex;
      tracklistIndex++;
    }

    resultItem.children = toc(accumulator, level + 1);
    result.push(resultItem);
    return result;
  };

  return toc(initialData, initialLevel);
};
var convertChapters = function convertChapters(content) {
  var cursor = 0;
  return content.map(function (item) {
    var newItem = _objectSpread(_objectSpread({}, item), {}, {
      className: _content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.CHAPTER */ .J8.CHAPTER,
      id: item.para_id
    });

    if (item.mp3) {
      newItem.cursor = cursor;
      cursor++;
    }

    return newItem;
  });
};
var makeChapterTree = function makeChapterTree(content) {
  var children = parseTocInternal(content, 0);
  var bookChildren = children;

  if (children[0].children.length > 1) {
    bookChildren = children[0].children;
  }

  var chapters = convertChapters(content);
  return {
    children: bookChildren,
    chapters: chapters
  };
};
var cutOutHeaders = function cutOutHeaders(dateContent) {
  dateContent.forEach(function (item) {
    item.content = item.content.filter(function (tag) {
      return !tag.includes("</h1>");
    });
  });
  return dateContent;
};
var normalizeSubsContent = function normalizeSubsContent(content) {
  return content.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      className: "subscription",
      // label: item?.book_title // text app crash build
      label: item ? item.book_title : undefined
    });
  });
}; // [3360] e.g. replace "3,4,5" to "3-5" for "b2778"

var normalizeBibleRefCode4 = function normalizeBibleRefCode4(bookType, refcode4) {
  if (bookType === "scriptindex" && typeof refcode4 === "string") {
    return refcode4.replace(/([\d]+),.*,\s([\d]+)/g, function (fullMatch, from, to) {
      return from + " - " + to;
    });
  }

  return "";
};
var isBookRealTypeBible = function isBookRealTypeBible() {
  var realType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return realType.indexOf("bible") === 0;
};
var isBookRealTypeBibleCommentaries = function isBookRealTypeBibleCommentaries(realType) {
  return realType === _shared_utils_reader_constants__WEBPACK_IMPORTED_MODULE_1__/* .BOOK_REAL_TYPE.bibleCommentaries */ .aE.bibleCommentaries;
}; // Special requirement from D - show paragraphs level in Tree, BC, TOC for any bible.

var isShowParaLevelByBookRealType = function isShowParaLevelByBookRealType(realType) {
  return realType ? isBookRealTypeBible(realType) : false;
};
var makeParaDataFinal = function makeParaDataFinal(bookType, bookRealType, para, indexPara) {
  var isRealTypeBible = isBookRealTypeBible(bookRealType);
  var labelTree;
  /* === Bible has para level, thus "Tree" and "BC" labels should be parsed differently. === */

  var label = para.refcode_4 || para.refcode_short || [para.refcode_1, para.refcode_2, para.refcode_3, para.refcode_4].filter(Boolean).join(" ") || indexPara;

  if (isRealTypeBible) {
    var refCode4Normalized = normalizeBibleRefCode4(bookType, para.refcode_4); // "BC" label

    if (para.refcode_2 && para.refcode_3 && refCode4Normalized) {
      if (refCode4Normalized === "0") {
        label = para.refcode_2 + " " + para.refcode_3;
      } else {
        label = para.refcode_2 + " " + para.refcode_3 + ":" + refCode4Normalized;
      }
    } else {
      label = para.refcode_long || para.refcode_1;
    } // ======================================
    // [3360][3365] e.g. remove unnecessary "h4" for "b2778"


    if (bookType === "scriptindex" && para.element_type === "h4") {
      labelTree = _content_constants__WEBPACK_IMPORTED_MODULE_0__/* .TREE_LABEL_HIDE_IN_TREE */ .Vz;
    } else {
      // "Tree" label
      if (para.refcode_3 && refCode4Normalized) {
        if (refCode4Normalized === "0") {
          labelTree = para.refcode_3;
        } else {
          labelTree = para.refcode_3 + ":" + refCode4Normalized;
        }
      } else {
        labelTree = para.refcode_short || para.refcode_1;
      } // ======================================

    }
  }
  /* ======================================================================================= */


  return {
    labelTreeFinal: labelTree,
    labelFinal: label
  };
};
var removeTags = function removeTags() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var newValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var re = /(<([^>]+)>)/g;

  if (re.test(text)) {
    return text.replace(/(<([^>]+)>)/g, newValue);
  }

  return text;
};
/**
 * Method for search object by id in json tree.
 *
 * @param {*} value  - id or other value for search
 * @param {*} currentNode - json tree
 * @param {string} field - property name to search
 * @param {Array} nodeList - holder of all parent for found value
 * @returns (Object|Boolean);
 */

var findNode = function findNode(value, currentNode) {
  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "id";
  var nodeList = arguments.length > 3 ? arguments[3] : undefined;
  var callValueAsFunction = arguments.length > 4 ? arguments[4] : undefined;
  var i, currentChild, result, children;

  if (callValueAsFunction ? value(currentNode) : value == currentNode[field]) {
    return currentNode;
  }

  if (currentNode.length) {
    children = currentNode;
  } else {
    children = currentNode.children;
  }

  if (children) {
    for (i = 0; i < children.length; i += 1) {
      currentChild = children[i];
      result = findNode(value, currentChild, field, nodeList, callValueAsFunction);

      if (result !== false) {
        if (nodeList) {
          nodeList.push(currentChild);
        }

        return result;
      }
    }
  }

  return false;
};
var isTreeItemExpandable = function isTreeItemExpandable(item, isShowParaLevel) {
  var itemClassNameOrType = item.className || item.type;

  if (itemClassNameOrType === _content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.CHAPTER */ .J8.CHAPTER) {
    if (isShowParaLevel) {
      return true;
    }

    var itemChildren = item.children || []; // If the first child is a chapter, then the others too.
    // If the children are chapters, then the parent should be expandable.

    return itemChildren[0] && itemChildren[0].className === _content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.CHAPTER */ .J8.CHAPTER;
  }

  return itemClassNameOrType !== _content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.CATEGORIES_BOOK_TRANSLATION */ .J8.CATEGORIES_BOOK_TRANSLATION && itemClassNameOrType !== _content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.TITLES_BOOK_TRANSLATION */ .J8.TITLES_BOOK_TRANSLATION && itemClassNameOrType !== _content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.PARAGRAPH */ .J8.PARAGRAPH;
};
var isBookForSale = function isBookForSale(book) {
  if (!book) {
    return undefined;
  }

  return book.permission_required === _content_constants__WEBPACK_IMPORTED_MODULE_0__/* .BOOK_PERMISSION.authenticated */ .k$.authenticated;
};
var isBookPermissionPurchaseOK = function isBookPermissionPurchaseOK(shopBook) {
  if (shopBook) {
    return shopBook.is_purchased;
  }

  return true;
};
var isBookPermissionAuthOK = function isBookPermissionAuthOK(book, isLogin) {
  if (!book) {
    return undefined;
  }

  if (isBookForSale(book)) {
    return isLogin;
  }

  return true;
};
var isBookPermissionsOK = function isBookPermissionsOK(shopBook, book, isLogin) {
  return isBookPermissionPurchaseOK(shopBook) && isBookPermissionAuthOK(book, isLogin);
};
var FirstCharRegEx = /^(the\s|a\s|an\s|from\s|"|\()(.*)/; // TODO make fix for get only book char for first char
// 'The $150,000 Fund' - first char should be "o", bcz of "1(one)".

var getFirstTitleChar = function getFirstTitleChar(value) {
  var title = value.toLowerCase();
  var match = title.match(FirstCharRegEx);

  if (match && match[2]) {
    title = match[2];
  }

  return title.trim().substr(0, 1);
};

/***/ }),

/***/ 73981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JG": function() { return /* binding */ copy; },
/* harmony export */   "zp": function() { return /* binding */ copyText; }
/* harmony export */ });
/* unused harmony export COPY_FORMATS */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
};
var defaultMessage = "Copy to clipboard: #{key}, Enter";

var format = function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
};

var COPY_FORMATS = {
  TEXT_PLAIN: "text/plain",
  TEXT_HTML: "text/html"
};

var deselectCurrent = function deselectCurrent() {
  var selection = document.getSelection();

  if (!selection.rangeCount) {
    return function () {};
  }

  var active = document.activeElement;
  var ranges = [];

  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) {
    // .toUpperCase handles XHTML
    case "INPUT":
    case "TEXTAREA":
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === "Caret" && selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function (range) {
        selection.addRange(range);
      });
    }

    active && active.focus();
  };
};

var copyText = function copyText(text, options) {
  return new Promise(function (resolve) {
    copy(text, _objectSpread(_objectSpread({}, options), {}, {
      format: options && options.format || COPY_FORMATS.TEXT_PLAIN,
      onSuccess: function onSuccess() {
        return resolve(true);
      },
      onError: function onError() {
        return resolve(false);
      }
    }));
  });
};

var copyUsingCopyEvent = function copyUsingCopyEvent(e, options, text) {
  try {
    e.stopPropagation();

    if (options.format) {
      e.preventDefault();

      if (typeof e.clipboardData === "undefined") {
        // IE 11
        console.warn("unable to use e.clipboardData");
        window.clipboardData.clearData();

        var _format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];

        window.clipboardData.setData(_format, text);
      } else {
        // all other browsers
        e.clipboardData.clearData();

        if (options.format === COPY_FORMATS.TEXT_HTML) {
          if (options.textPlain) {
            e.clipboardData.setData(COPY_FORMATS.TEXT_PLAIN, options.textPlain);
          }

          e.clipboardData.setData(options.format, text);
        } else {
          e.clipboardData.setData(options.format, text);
        }
      }
    }

    if (options.onCopy) {
      e.preventDefault();
      options.onCopy(e.clipboardData);
    }

    return true;
  } catch (err) {
    console.log("Failed to copy using copyEvent': ", {
      err: err,
      event: e,
      options: options,
      text: text
    });
    return false;
  }
}; // NOTE: Copying using a {document.execCommand} works on user interaction events,
// like a screen touch, but doesn't work on a "copy" event.


var copyUsingDocExec = function copyUsingDocExec(options, text) {
  var reselectPrevious, range, selection, mark;

  try {
    reselectPrevious = deselectCurrent();
    range = document.createRange();
    selection = document.getSelection();
    mark = document.createElement("span");
    mark.textContent = text; // reset user styles for span element

    mark.style.all = "unset"; // prevents scrolling to the end of the page

    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)"; // used to preserve spaces and line breaks

    mark.style.whiteSpace = "pre"; // do not inherit user-select (it may be `none`)

    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function (e) {
      return copyUsingCopyEvent(e, options, text);
    });
    document.body.appendChild(mark);
    range.selectNodeContents(mark);
    selection.addRange(range);
    return document.execCommand("copy");
  } catch (e) {
    console.log("Failed to copy using 'window.clipboardData': ", {
      hasDocExec: "execCommand" in document
    });
    return false;
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }

    reselectPrevious();
  }
};

var copyUsingClipboardData = function copyUsingClipboardData(options, text) {
  try {
    window.clipboardData.setData(options.format || "text", text);
    options.onCopy && options.onCopy(window.clipboardData);
    return true;
  } catch (err) {
    console.log("Failed to copy using 'window.clipboardData': ", {
      err: err,
      hasClipboardData: "clipboardData" in window
    });
    return false;
  }
}; // Note: Is supported IOS greater than 13.


var copyUsingNavigatorClipboard = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(text) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;

          if (!("navigator" in window && "clipboard" in window.navigator)) {
            _context.next = 4;
            break;
          }

          _context.next = 4;
          return window.navigator.clipboard.writeText(text);

        case 4:
          return _context.abrupt("return", true);

        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          console.error("Failed to copy using 'window.navigator.clipboard.writeText': ", {
            err: _context.t0,
            text: text,
            hasNavigatorClipboard: "navigator" in window && "clipboard" in window.navigator
          });
          return _context.abrupt("return", false);

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function copyUsingNavigatorClipboard(_x) {
    return _ref.apply(this, arguments);
  };
}();

var copy = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(text, options) {
    var success, message;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          success = false;

          if (!options) {
            options = {};
          }

          if (options.copyEvent) {
            success = copyUsingCopyEvent(options.copyEvent, options, text);
          }

          if (!success) {
            success = copyUsingDocExec(options, text);
          }

          if (!success) {
            success = copyUsingClipboardData(options, text);
          }

          if (success) {
            _context2.next = 9;
            break;
          }

          _context2.next = 8;
          return copyUsingNavigatorClipboard(text);

        case 8:
          success = _context2.sent;

        case 9:
          if (!success) {
            message = format("message" in options ? options.message : defaultMessage);
            window.prompt(message, text);
          }

          if (success) {
            if (options.onSuccess) {
              options.onSuccess();
            }
          } else {
            if (options.onError) {
              options.onError();
            }
          }

          return _context2.abrupt("return", success);

        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function copy(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 96112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IS": function() { return /* binding */ formatServerDateToJSDate; },
/* harmony export */   "KA": function() { return /* binding */ isSameDateMonthYear; },
/* harmony export */   "Ut": function() { return /* binding */ isBeforeDateISO; },
/* harmony export */   "xH": function() { return /* binding */ formatToServerDate; }
/* harmony export */ });
/* unused harmony exports CLIENT_DATE_FORMAT, fromNow, formatDateToDateLabel */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27693);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



var relativeTime = __webpack_require__(87815);

dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend(relativeTime, {
  thresholds: [{
    l: "s",
    r: 1
  }, {
    l: "m",
    r: 1
  }, {
    l: "mm",
    r: 59,
    d: "minute"
  }, {
    l: "h",
    r: 1
  }, {
    l: "hh",
    r: 23,
    d: "hour"
  }, {
    l: "d",
    r: 1
  }, {
    l: "dd",
    r: 29,
    d: "day"
  }, {
    l: "M",
    r: 1
  }, {
    l: "MM",
    r: 11,
    d: "month"
  }, {
    l: "y",
    r: 1
  }, {
    l: "yy",
    d: "year"
  }],
  rounding: Math.floor
});
var SERVER_DATE_SEPARATOR = "-";
var CLIENT_DATE_FORMAT = "DD.MM.YYYY";
var fromNow = function fromNow(date) {
  if (!date) {
    return "";
  }

  var dateObject = dayjs(date);
  var timeDifferenceFromNow = dayjs().diff(dateObject, "second");

  if (timeDifferenceFromNow < 44) {
    return "a few seconds ago";
  } else if (timeDifferenceFromNow < 90) {
    return "44 seconds ago";
  }

  return dateObject.fromNow();
};
var formatDateToDateLabel = function formatDateToDateLabel(date) {
  return date ? dayjs(date).format(CLIENT_DATE_FORMAT) : '';
};

var parseServerDate = function parseServerDate(date) {
  if (!date) {
    return null;
  }

  var _date$split = date.split(SERVER_DATE_SEPARATOR),
      _date$split2 = _slicedToArray(_date$split, 3),
      year = _date$split2[0],
      month = _date$split2[1],
      day = _date$split2[2];

  return {
    year: year,
    month: month,
    date: day
  };
};

var formatServerDateToJSDate = function formatServerDateToJSDate(date) {
  var dateObject = dayjs__WEBPACK_IMPORTED_MODULE_0___default()();

  if (date) {
    var serverDateParsed = parseServerDate(date);

    if (serverDateParsed) {
      var year = serverDateParsed.year,
          month = serverDateParsed.month,
          _date = serverDateParsed.date;

      if (_date) {
        dateObject = dateObject.date(_date);
      }

      if (month) {
        dateObject = dateObject.month(parseInt(month) - 1);
      }

      if (year) {
        dateObject = dateObject.year(year);
      }
    }
  }

  return dateObject.toDate();
};
var formatToServerDate = function formatToServerDate(date) {
  return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format("YYYY-MM-DD");
};
var isBeforeDateISO = function isBeforeDateISO(dateOld, dateNew) {
  if (!dateOld) {
    return true;
  }

  if (!dateNew) {
    return false;
  }

  try {
    var dateOldISO = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateOld);
    var dateNewISO = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateNew);
    return dateOldISO.isSame(dateNewISO) || dateNewISO.isAfter(dateOldISO);
  } catch (e) {
    return true;
  }
};
var isSameDateMonthYear = function isSameDateMonthYear(date1, date2) {
  return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date1).isSame(date2, "date") && dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date1).isSame(date2, "month") && dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date1).isSame(date2, "year");
};

/***/ }),

/***/ 83684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G2": function() { return /* binding */ isIOSVersionUntil11; },
/* harmony export */   "Y$": function() { return /* binding */ getIsIOSDevice; }
/* harmony export */ });
/* unused harmony export isIOSWithDesktopVersionRequested */
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56253);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


var isIOSWithDesktopVersionRequested = function isIOSWithDesktopVersionRequested() {
  var _global$window, _global$window$naviga, _global$window$naviga2, _global$window2, _global$window2$navig, _global$window2$navig2, _global$window3, _global$window3$navig;

  return ( // Ipad is detected as a computer, if "desktop browser mode" is enabled in the Safari.
  react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isMacOs */ .Q5 || ((_global$window = __webpack_require__.g.window) === null || _global$window === void 0 ? void 0 : (_global$window$naviga = _global$window.navigator) === null || _global$window$naviga === void 0 ? void 0 : (_global$window$naviga2 = _global$window$naviga.vendor) === null || _global$window$naviga2 === void 0 ? void 0 : _global$window$naviga2.includes("Apple Computer")) || ((_global$window2 = __webpack_require__.g.window) === null || _global$window2 === void 0 ? void 0 : (_global$window2$navig = _global$window2.navigator) === null || _global$window2$navig === void 0 ? void 0 : (_global$window2$navig2 = _global$window2$navig.vendor) === null || _global$window2$navig2 === void 0 ? void 0 : _global$window2$navig2.includes("Mac OS"))) && ((_global$window3 = __webpack_require__.g.window) === null || _global$window3 === void 0 ? void 0 : (_global$window3$navig = _global$window3.navigator) === null || _global$window3$navig === void 0 ? void 0 : _global$window3$navig.maxTouchPoints) > 0;
};

var getOsVersionMajor = function getOsVersionMajor() {
  var _osVersion$split = react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .osVersion.split */ .MM.split("."),
      _osVersion$split2 = _slicedToArray(_osVersion$split, 1),
      major = _osVersion$split2[0];

  return Number(major);
};

var isIOSVersionUntil11 = function isIOSVersionUntil11() {
  if (!react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isIOS */ .gn) {
    return false;
  }

  if (isIOSWithDesktopVersionRequested()) {
    return false;
  }

  return getOsVersionMajor() < 11;
};
var getIsIOSDevice = function getIsIOSDevice() {
  if (react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isIOS */ .gn) {
    return true;
  }

  return isIOSWithDesktopVersionRequested();
};

/***/ }),

/***/ 62330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$g": function() { return /* binding */ isBrowserSupportsFloatValueForScrollTop; },
/* harmony export */   "AZ": function() { return /* binding */ getEventPath; },
/* harmony export */   "DC": function() { return /* binding */ getEventCoordinates; },
/* harmony export */   "E7": function() { return /* binding */ isHotKey; },
/* harmony export */   "Ke": function() { return /* binding */ getBrowserScrollbarInfo; },
/* harmony export */   "O5": function() { return /* binding */ _deprecated_calculateMaxSizes; },
/* harmony export */   "Om": function() { return /* binding */ makeFnGetFirstVisible; },
/* harmony export */   "Qw": function() { return /* binding */ isElementFocused; },
/* harmony export */   "Sb": function() { return /* binding */ calculateTextDimension; },
/* harmony export */   "Sv": function() { return /* binding */ downloadFile; },
/* harmony export */   "VD": function() { return /* binding */ KeyCode; },
/* harmony export */   "WV": function() { return /* binding */ isEventKey; },
/* harmony export */   "_F": function() { return /* binding */ _deprecated_calculateFitPosition; },
/* harmony export */   "d1": function() { return /* binding */ isBrowserSupportsSmoothScroll; },
/* harmony export */   "hb": function() { return /* binding */ dispatchCustomEvent; },
/* harmony export */   "hy": function() { return /* binding */ isFocusTextInput; },
/* harmony export */   "oM": function() { return /* binding */ getIsMatchesCssMediaHover; },
/* harmony export */   "oU": function() { return /* binding */ isEventDoubleClick; },
/* harmony export */   "p$": function() { return /* binding */ getFirstVisible; },
/* harmony export */   "p2": function() { return /* binding */ scrollIntoViewIfVisibleLessThan; },
/* harmony export */   "qm": function() { return /* binding */ Hotkey; },
/* harmony export */   "qn": function() { return /* binding */ parseDOMRectToObject; },
/* harmony export */   "ul": function() { return /* binding */ inRect; },
/* harmony export */   "ut": function() { return /* binding */ getBoundaryRectConsideringStackingContext; }
/* harmony export */ });
/* unused harmony exports isEventKeys, contains, scrollViewIfEdge, findClosestScrollView, findClosestWithNonZeroPosition, findClosestIndividualStackingContextContainer, getTouches, isFullScreenElementCrossBrowser, getFnRequestFullScreenCrossBrowser, requestFullScreenCrossBrowser, exitFullScreenCrossBrowser, replaceElement, replaceAllElBySelector, removeElement, removeAllElBySelector */
/* harmony import */ var _number_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50150);

var KeyCode = {
  leftArrow: 37,
  rightArrow: 39,
  upArrow: 38,
  downArrow: 40,
  space: 32,
  enter: 13,
  esc: 27,
  tab: 9,
  f3: 114,
  f: 70,
  l: 76,
  p: 80,
  s: 83,
  c: 67,
  t: 84,
  d: 68,
  e: 69,
  v: 86,
  zero: 48,
  keyZ: 90,
  plus: "Equal",
  numPlus: 107,
  minus: "Minus",
  numMinus: 109,
  period: 190,
  comma: 188,
  f11: 122,
  f1: 112
};
var Hotkey = {
  focusSearch: {
    label: "Search",
    keyCode: {
      ctrl: true,
      shift: true,
      keys: [KeyCode.f]
    }
  },
  toggleTree: {
    label: "Toogle Tree",
    keyCode: {
      ctrl: true,
      alt: true,
      keys: [KeyCode.t]
    }
  },
  help: {
    label: "Help",
    keyCode: {
      keys: [KeyCode.f1]
    }
  },
  readerLinkPrev: {
    label: "Previous Reader Link",
    keyCode: {
      ctrl: true,
      keys: [KeyCode.leftArrow]
    }
  },
  readerLinkNext: {
    label: "Next Reader Link",
    keyCode: {
      ctrl: true,
      keys: [KeyCode.rightArrow]
    }
  },
  openItem: {
    label: "Open element",
    keyCode: {
      ctrl: false,
      alt: false,
      shift: false,
      keys: [KeyCode.enter]
    }
  },
  expandItem: {
    label: "Expand element",
    keyCode: {
      ctrl: false,
      alt: false,
      shift: true,
      keys: [KeyCode.enter]
    }
  },
  checkItem: {
    label: "Check element",
    keyCode: {
      ctrl: false,
      alt: false,
      shift: false,
      keys: [KeyCode.space]
    }
  },
  itemContextMenu: {
    label: "Element context Menu",
    keyCode: {
      ctrl: true,
      alt: false,
      shift: false,
      keys: [KeyCode.enter]
    }
  },
  selectButtonOrLink: {
    label: "Select Button Or Link",
    keyCode: {
      ctrl: false,
      alt: false,
      shift: false,
      keys: [KeyCode.enter, KeyCode.space]
    }
  },
  itemPrevX: {
    label: "Previous element",
    keyCode: {
      ctrl: false,
      alt: false,
      shift: false,
      keys: [KeyCode.leftArrow]
    }
  },
  itemNextX: {
    label: "Next element",
    keyCode: {
      ctrl: false,
      alt: false,
      shift: false,
      keys: [KeyCode.rightArrow]
    }
  },
  itemPrevY: {
    label: "Previous element",
    keyCode: {
      ctrl: false,
      alt: false,
      shift: false,
      keys: [KeyCode.upArrow]
    }
  },
  itemNextY: {
    label: "Next element",
    keyCode: {
      ctrl: false,
      alt: false,
      shift: false,
      keys: [KeyCode.downArrow]
    }
  },
  exitFloatWindow: {
    label: "Exit popup",
    keyCode: {
      ctrl: false,
      alt: false,
      shift: false,
      keys: [KeyCode.esc]
    }
  }
};
var textInputs = ["INPUT", "TEXTAREA"];
var isFocusTextInput = function isFocusTextInput() {
  if (document.activeElement) {
    return document.activeElement.contentEditable === "true" || textInputs.includes(document.activeElement.tagName);
  }

  return false;
};
var isElementFocused = function isElementFocused(element) {
  if (document.activeElement) {
    return document.activeElement === element;
  }

  return false;
};
var isEventKey = function isEventKey() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var code = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof code === "string") {
    return e.code === code;
  }

  return e.which === code || e.keyCode === code;
};
var isEventKeys = function isEventKeys() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var codes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return strict ? codes.every(function (code) {
    return isEventKey(e, code);
  }) : codes.some(function (code) {
    return isEventKey(e, code);
  });
};
var isHotKey = function isHotKey(event, hotkey) {
  if (!event || !hotkey) {
    return false;
  }

  var hotkeyFinal = "keyCode" in hotkey ? hotkey.keyCode : hotkey;
  var isShift = !hotkeyFinal.shift || event.shiftKey;
  var isAlt = !hotkeyFinal.alt || event.altKey;
  var isCtrl = !hotkeyFinal.ctrl || event.ctrlKey || event.metaKey;
  return isShift && isAlt && isCtrl && isEventKeys(event, hotkeyFinal.keys);
};
var getEventPath = function getEventPath(e) {
  return e.path || e.composedPath && e.composedPath() || null;
};
var makeFnGetFirstVisible = function makeFnGetFirstVisible(scrollableView, isReverse, isHorizontal, checkFn, checkFnReverse) {
  if (!scrollableView) {
    return undefined;
  }

  var children = scrollableView.children;

  if (!children) {
    return undefined;
  }

  var keyOffsetElem = isHorizontal ? "offsetLeft" : "offsetTop"; // client[Side] value for parent, to exclude border size value.

  var keySize = isHorizontal ? "clientWidth" : "clientHeight"; // offset[Side] value for item, to include border size value.

  var keySizeElem = isHorizontal ? "offsetWidth" : "offsetHeight";
  var keyPaddingStart = isHorizontal ? "paddingLeft" : "paddingTop";
  var keyPaddingEnd = isHorizontal ? "paddingRight" : "paddingBottom";
  var computedStyle = window.getComputedStyle(scrollableView);
  var wrapStart = Math.round(isHorizontal ? scrollableView.scrollLeft : scrollableView.scrollTop) + parseFloat(computedStyle[keyPaddingStart]);
  var wrapEnd = wrapStart + scrollableView[keySize] + parseFloat(computedStyle[keyPaddingEnd]);
  var elem, elemStart;

  if (isReverse) {
    for (var i = children.length - 1; i >= 0; i--) {
      elem = children[i];
      elemStart = elem[keyOffsetElem];

      if (checkFnReverse(elemStart, wrapStart, elemStart + elem[keySizeElem], wrapEnd, elem)) {
        return elem;
      }
    }
  } else {
    for (var _i2 = 0; _i2 < children.length; _i2++) {
      elem = children[_i2];
      elemStart = elem[keyOffsetElem];

      if (checkFn(elemStart, wrapStart, elemStart + elem[keySizeElem], wrapEnd, elem)) {
        return elem;
      }
    }
  }

  return undefined;
};
var getFirstVisible = function getFirstVisible(parent, isReverse, isHorizontal) {
  return makeFnGetFirstVisible(parent, isReverse, isHorizontal, function (elemStart, wrapStart, elemEnd) {
    return (0,_number_number__WEBPACK_IMPORTED_MODULE_0__/* .isNumberBetweenEquals */ .S5)(wrapStart, elemStart, elemEnd);
  }, function (elemStart, wrapStart, elemEnd, wrapEnd) {
    return (0,_number_number__WEBPACK_IMPORTED_MODULE_0__/* .isNumberBetweenEquals */ .S5)(wrapEnd, elemStart, elemEnd);
  });
};
var OFFSET_AUTO_SCROLL_VIEW = 50;
var contains = function contains(rect, x, y) {
  var width = rect.width,
      height = rect.height,
      left = rect.left,
      top = rect.top;
  var newRect = {
    width: width,
    height: height,
    x: rect.x || left,
    y: rect.y || top
  };
  return newRect.x <= x && x <= newRect.x + newRect.width && newRect.y <= y && y <= newRect.y + newRect.height;
};
var scrollViewIfEdge = function scrollViewIfEdge(clientX, clientY) {
  var scrollbarsViews = document.getElementsByClassName("scrollbars-render-view");
  var scrollbarsView, rect;

  for (var i = scrollbarsViews.length - 1; i >= 0; i--) {
    scrollbarsView = scrollbarsViews[i];
    rect = scrollbarsView.getBoundingClientRect();

    if (contains(rect, clientX, clientY)) {
      break;
    }
  }

  if (scrollbarsView) {
    var scrollViewY = rect.y;

    if (clientY - scrollViewY < OFFSET_AUTO_SCROLL_VIEW) {
      scrollbarsView.scroll(0, scrollbarsView.scrollTop - 1);
    } else if (clientY > rect.y + rect.height - OFFSET_AUTO_SCROLL_VIEW) {
      scrollbarsView.scroll(0, scrollbarsView.scrollTop + 1);
    }
  }
};
var findClosestScrollView = function findClosestScrollView(el) {
  if (!el) {
    return null;
  }

  var node = null;

  do {
    node = (node || el).parentNode;
  } while (node && node instanceof Element && ( // there is a case {scrollHeight} is greater by 1-2px than {offsetHeight}
  // e.g. search "god", open Related tab in S+,
  // find accordion "EGW Book Category by Topic",
  // check properties of ".accordion_body"
  // FIXME: Not in priority till is used in the single place, need to investigate.
  node.scrollHeight - node.offsetHeight <= 2 || getComputedStyle(node).overflow === "hidden"));

  return node === document ? window : node;
};
var findClosestWithNonZeroPosition = function findClosestWithNonZeroPosition(el) {
  if (!el) {
    return null;
  }

  var computedStyle = null;
  var node = null;

  do {
    node = (node || el).parentNode;

    if (node && node instanceof Element) {
      computedStyle = getComputedStyle(node);
    } else {
      computedStyle = null;
    }
  } while (computedStyle && !(computedStyle.position !== "static" && (parseInt(computedStyle.top) || parseInt(computedStyle.left) || parseInt(computedStyle.bottom) || parseInt(computedStyle.right))));

  return computedStyle ? node : null;
}; // Stacking Context: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context#the_stacking_context
// Method can be expanded with the rest CSS-properties, that create a Stacking Context.

var findClosestIndividualStackingContextContainer = function findClosestIndividualStackingContextContainer(el) {
  if (!el) {
    return null;
  }

  var node = null;

  do {
    node = (node || el).parentNode;
  } while (node && node instanceof Element && getComputedStyle(node).transform !== "none");

  return node && node instanceof Element ? node : null;
}; // If some parent of {el} has own Stacking Context and either the parent itself has a non-zero
// position or its child that is a parent to {el},
// then constantly VIEWPORT-related coordinates of {anchorEl.getBoundingClientRect()},
// should be re-calculated, to become regarding the parent with a non-zero offset parent.

var getBoundaryRectConsideringStackingContext = function getBoundaryRectConsideringStackingContext(el) {
  if (!el) {
    return null;
  }

  var rectEl = el.getBoundingClientRect();

  try {
    var elISC = findClosestIndividualStackingContextContainer(el);

    if (elISC) {
      var elWithNonZeroPosition = findClosestWithNonZeroPosition(el);

      if (elWithNonZeroPosition && elISC.contains(elWithNonZeroPosition)) {
        var computedStyleElStickyClosest = window.getComputedStyle(elWithNonZeroPosition);
        var top = parseInt(computedStyleElStickyClosest.top);
        var left = parseInt(computedStyleElStickyClosest.left);

        if (top || left) {
          rectEl = {
            top: rectEl.top - top,
            bottom: rectEl.bottom - top,
            left: rectEl.left - left,
            right: rectEl.right - left,
            width: rectEl.width,
            height: rectEl.height
          };
        }
      }
    }
  } catch (e) {
    console.log("%cgetBoundaryRectRegardingClosestStackingContext CRASHED, pls check!!!!", "background: black; color: red; font-size: 16px;");
    console.log(e);
    console.groupCollapsed("Trace");
    console.trace();
    console.groupEnd();
  }

  return rectEl;
};
var downloadFile = function downloadFile(uri, name) {
  var fileName = name ? name : uri.substr(uri.lastIndexOf("/") + 1);
  var link = document.createElement("a");
  link.download = fileName;
  link.href = uri;
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
var dispatchCustomEvent = function dispatchCustomEvent(type, detail) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
  element.dispatchEvent(new CustomEvent(type, detail ? {
    detail: detail
  } : null));
};
var getIsMatchesCssMediaHover = function getIsMatchesCssMediaHover() {
  return __webpack_require__.g.window && __webpack_require__.g.window.matchMedia && __webpack_require__.g.window.matchMedia("(hover: hover) and (pointer: fine)").matches;
};
/**
 * dont use very offen, long time calculation
 * @param {*} text
 * @param {*} classes
 */

var calculateTextDimension = function calculateTextDimension(text) {
  var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var dimensions = {
    width: 0,
    height: 0
  };

  if (!("window" in __webpack_require__.g)) {
    return dimensions;
  }

  classes.push("textDimensionCalculation");
  var div = document.createElement("div");
  div.setAttribute("class", classes.join(" "));
  div.innerHTML = text;
  div.style.position = "absolute";
  div.style.visibility = "hidden";
  div.style.height = "auto";
  div.style.width = "auto";
  document.body.appendChild(div);
  dimensions.width = div.clientWidth;
  dimensions.height = div.clientHeight;
  removeElement(div);
  return dimensions;
};
var inRect = function inRect(parentRect, rect, options) {
  var fully,
      half,
      paddingVertical = 0;

  if (options) {
    fully = options.fully;
    half = options.half;
    paddingVertical = options.paddingVertical;
  }

  if (fully) {
    return parentRect.left <= rect.left && parentRect.right >= rect.right && parentRect.top <= rect.top && parentRect.bottom >= rect.bottom;
  }

  if (half) {
    return parentRect.left < rect.left + rect.width / 2 && parentRect.right > rect.right - rect.width / 2 && parentRect.top < rect.top + rect.height / 2 && parentRect.bottom > rect.bottom - rect.height / 2;
  }

  return parentRect.left < rect.left && parentRect.right > rect.left && parentRect.top < rect.bottom - paddingVertical && parentRect.bottom > rect.top + paddingVertical;
};
/**
 * Calculates the optimal position styles relate to the rect, that should not be covered
 * ("avoidRectangleRect") and boundaries that should not be crossed
 * ("boundaryRect").
 *
 * @param {Object} boundaryRect - The boundaries that should not be crossed.
 * @param {Object} avoidRectangleRect - The rect, that should not be covered.
 * @param {number} blockWidth - window width.
 * @param {number} blockHeight - window height.
 *
 * @returns {{top: number, left: number}}
 */

var _deprecated_calculateFitPosition = function _deprecated_calculateFitPosition(boundaryRect, avoidRectangleRect, blockWidth, blockHeight) {
  var top, left;
  var topDelta = avoidRectangleRect.top - boundaryRect.top;
  var bottomDelta = boundaryRect.bottom - avoidRectangleRect.bottom;
  var leftDelta = avoidRectangleRect.right - boundaryRect.left;
  var rightDelta = boundaryRect.right - avoidRectangleRect.left;

  if (topDelta > bottomDelta) {
    top = avoidRectangleRect.top - blockHeight;
    top = (0,_number_number__WEBPACK_IMPORTED_MODULE_0__/* .clutch */ .Cz)(top, 0, window.innerHeight);
  } else {
    top = avoidRectangleRect.bottom;
    top = (0,_number_number__WEBPACK_IMPORTED_MODULE_0__/* .clutch */ .Cz)(top, 0, window.innerHeight - blockHeight);
  }

  if (leftDelta > rightDelta) {
    left = avoidRectangleRect.right - blockWidth;
    left = (0,_number_number__WEBPACK_IMPORTED_MODULE_0__/* .clutch */ .Cz)(left, 0, window.innerWidth);
  } else {
    left = avoidRectangleRect.left;
    left = (0,_number_number__WEBPACK_IMPORTED_MODULE_0__/* .clutch */ .Cz)(avoidRectangleRect.left, 0, window.innerWidth - blockWidth);
  }

  return {
    top: top,
    left: left
  };
};
/**
 * Calculates the optimal sizes styles relate to the rect, that should not be
 * covered ("avoidRectangleRect") and boundaries that should not be crossed
 * ("boundaryRect").
 *
 * @param {Object} boundaryRect - The boundaries that should not be crossed.
 * @param {Object} avoidRectangleRect - The rect, that should not be covered.
 *
 * @returns {{maxWidth: number, maxHeight: number}}
 */

var _deprecated_calculateMaxSizes = function _deprecated_calculateMaxSizes(boundaryRect, avoidRectangleRect) {
  var maxWidth, maxHeight;
  var topDelta = avoidRectangleRect.top - boundaryRect.top;
  var leftDelta = avoidRectangleRect.left - boundaryRect.left;
  var rightDelta = boundaryRect.right - avoidRectangleRect.right;
  var bottomDelta = boundaryRect.bottom - avoidRectangleRect.bottom;

  if (topDelta && bottomDelta) {
    if (topDelta > bottomDelta) {
      maxHeight = topDelta;
    } else {
      maxHeight = bottomDelta;
    }
  }

  if (leftDelta && rightDelta) {
    if (leftDelta > rightDelta) {
      maxWidth = leftDelta;
    } else {
      maxWidth = rightDelta;
    }
  }

  return {
    maxWidth: maxWidth,
    maxHeight: maxHeight
  };
};
/**
 * @description Returns touches array of event
 * @param {TouchEvent} e
 * @returns {Object}
 */

var getTouches = function getTouches(e) {
  if (e.originalEvent) {
    if (e.originalEvent.touches && e.originalEvent.touches.length) {
      return e.originalEvent.touches;
    } else if (e.originalEvent.changedTouches && e.originalEvent.changedTouches.length) {
      return e.originalEvent.changedTouches;
    }
  }

  return e.changedTouches || e.touches;
};
var getEventCoordinates = function getEventCoordinates(e) {
  var x = e.x === undefined ? e.clientX : e.x;
  var y = e.y === undefined ? e.clientY : e.y;

  if (x === undefined) {
    var touches = getTouches(e);

    if (touches && touches.length) {
      var lastTouch = touches[touches.length - 1];

      if (lastTouch) {
        x = lastTouch.clientX;
        y = lastTouch.clientY;
      }
    }
  }

  return {
    x: x,
    y: y
  };
}; // Value is initiated inside function {initiateValueIsBrowserSupportsFloatValueForScrollTop}.

var isBrowserSupportsFloatValueForScrollTop;

(function initiateValueIsBrowserSupportsFloatValueForScrollTop() {
  if (!("window" in __webpack_require__.g)) {
    return undefined;
  }

  var elScrollableHeight = 50;
  var elScrollable = document.createElement("div");
  elScrollable.style.width = "50px";
  elScrollable.style.height = elScrollableHeight + "px";
  elScrollable.style.overflow = "scroll";
  var elContent = document.createElement("div");
  elContent.style.width = "50px";
  elContent.style.height = elScrollableHeight + 5 + "px";
  document.documentElement.appendChild(elScrollable);
  elScrollable.appendChild(elContent);
  elScrollable.scrollTop = 0.5;
  isBrowserSupportsFloatValueForScrollTop = elScrollable.scrollTop === 0.5;
  document.documentElement.removeChild(elScrollable);
  elScrollable.remove();
  elContent.remove();
})();

var parseDOMRectToObject = function parseDOMRectToObject(rect) {
  if (!rect) {
    return rect;
  }

  var top = rect.top,
      right = rect.right,
      bottom = rect.bottom,
      left = rect.left,
      width = rect.width,
      height = rect.height,
      x = rect.x,
      y = rect.y;
  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: x,
    y: y
  };
};
var getBrowserScrollbarInfo = function getBrowserScrollbarInfo() {
  var isScrollbarTakesContentPlace, scrollBarWidth;
  var width = 50;
  var elScrollable = document.createElement("div");
  elScrollable.style.height = "50px";
  elScrollable.style.width = width + "px";
  var elContent = document.createElement("div");
  elScrollable.appendChild(elContent);
  document.body.appendChild(elScrollable);
  elScrollable.style.overflow = "scroll";
  var widthScrollbarVisible = parseFloat(window.getComputedStyle(elContent).width);
  elScrollable.style.overflow = "hidden";
  var widthScrollbarHidden = parseFloat(window.getComputedStyle(elContent).width);
  var percentScrollbarHiddenVisible = widthScrollbarVisible * 100 / widthScrollbarHidden;

  if (percentScrollbarHiddenVisible > 0) {
    isScrollbarTakesContentPlace = true;
    scrollBarWidth = width - width * (percentScrollbarHiddenVisible / 100);
  }

  document.body.removeChild(elScrollable);
  elScrollable.remove();
  elContent.remove();
  return {
    width: scrollBarWidth,
    isTakesContentPlace: isScrollbarTakesContentPlace
  };
};
var isBrowserSupportsSmoothScroll = "window" in __webpack_require__.g && "CSS" in window && "supports" in window.CSS ? window.CSS.supports('scroll-behavior', 'smooth') : null;
var isFullScreenElementCrossBrowser = function isFullScreenElementCrossBrowser(element) {
  if (element && element !== document.documentElement) {
    return !!(document.fullscreenElement === element || document.mozFullScreenElement === element || document.webkitFullscreenElement === element || document.msFullscreenElement === element);
  }

  return !!(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen || document.fullScreenMode);
};
var getFnRequestFullScreenCrossBrowser = function getFnRequestFullScreenCrossBrowser() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.documentElement;
  return element.requestFullscreen || element.mozRequestFullScreen || element.webkitRequestFullscreen || element.msRequestFullscreen;
};
var requestFullScreenCrossBrowser = function requestFullScreenCrossBrowser() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.documentElement;
  var fn = getFnRequestFullScreenCrossBrowser(element);

  if (fn) {
    fn.call(element);
  }

  return null;
};
var exitFullScreenCrossBrowser = function exitFullScreenCrossBrowser() {
  if (document.exitFullscreen) {
    return document.exitFullscreen();
  }

  if (document.mozCancelFullScreen) {
    return document.mozCancelFullScreen();
  }

  if (document.webkitExitFullscreen) {
    return document.webkitExitFullscreen();
  }

  if (document.msExitFullscreen) {
    return document.msExitFullscreen();
  }

  return null;
};
var isEventDoubleClick = function isEventDoubleClick(event) {
  return event.detail === 2;
};
var scrollIntoViewIfVisibleLessThan = function scrollIntoViewIfVisibleLessThan(element, coefficientVisibleLessThan) {
  if (element) {
    var scrollView = findClosestScrollView(element);

    if (scrollView && scrollView !== window) {
      var scrollViewHeight = scrollView.offsetHeight;
      var scrollViewTop = scrollView.scrollTop;
      var scrollViewBottom = scrollViewTop + scrollViewHeight;
      var elHeight = element.offsetHeight;
      var elTop = element.offsetTop;
      var elBottom = elTop + elHeight;
      var deltaTop = scrollViewTop - elTop;
      var deltaBottom = elBottom - scrollViewBottom;
      var coefficientVisible = (scrollViewHeight + Math.min(0, deltaTop) + Math.min(0, deltaBottom)) / scrollViewHeight;

      if ((deltaBottom > 0 || deltaTop > 0) && coefficientVisible < coefficientVisibleLessThan) {
        var topNew;

        if (deltaBottom > 0) {
          topNew = Math.min(scrollViewTop + deltaBottom, elTop);
        } else {
          topNew = Math.max(scrollViewTop - deltaTop, elBottom - scrollViewHeight);
        }

        scrollView.scroll({
          top: topNew,
          behavior: "smooth"
        });
      }
    }
  }
};
var replaceElement = function replaceElement(el, newEl) {
  return el.parentNode.replaceChild(newEl, el);
};
var replaceAllElBySelector = function replaceAllElBySelector(parent, selector, newEl) {
  parent.querySelectorAll(selector).forEach(function (el) {
    return replaceElement(el, newEl);
  });
};
var removeElement = function removeElement(el) {
  return el.parentNode.removeChild(el);
};
var removeAllElBySelector = function removeAllElBySelector(parent, selector) {
  parent.querySelectorAll(selector).forEach(removeElement);
};

/***/ }),

/***/ 21875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GB": function() { return /* binding */ DONATE_TIMEOUT_ALREADY_DONATED; },
/* harmony export */   "Mr": function() { return /* binding */ getDonateTimestampNextShowWithClosedCount; },
/* harmony export */   "cI": function() { return /* binding */ COOKIE_KEY_DONATE_CLOSED_COUNT; },
/* harmony export */   "fV": function() { return /* binding */ COOKIE_KEY_DONATE_NEXT_SHOW; },
/* harmony export */   "nW": function() { return /* binding */ COOKIE_KEY_DONATE_DAY_USING; },
/* harmony export */   "uL": function() { return /* binding */ DONATE_DEF_CONFIG; }
/* harmony export */ });
var COOKIE_KEY_DONATE_NEXT_SHOW = "donateNotifyNS";
var COOKIE_KEY_DONATE_CLOSED_COUNT = "donateNotifyCC";
var COOKIE_KEY_DONATE_DAY_USING = "donateNotifyDU";
var DONATE_TIMEOUT_ALREADY_DONATED = 28987200000; // 335.5 days (11 months).

var DONATE_DEF_CONFIG = {
  firstTimeDelay: 900000,
  // 15 min,
  secondTimeDelay: 2419200000,
  // 28 days.
  showAfterDayUsing: false
};

var getDonateDelayWithClosedCount = function getDonateDelayWithClosedCount(closedCount, config) {
  var _config$secondTimeDel;

  if (closedCount === 0) {
    var _config$firstTimeDela;

    return (_config$firstTimeDela = config.firstTimeDelay) !== null && _config$firstTimeDela !== void 0 ? _config$firstTimeDela : 900000;
  }

  return (_config$secondTimeDel = config.secondTimeDelay) !== null && _config$secondTimeDel !== void 0 ? _config$secondTimeDel : 2419200000; // 28 days.
};

var getDonateTimestampNextShowWithClosedCount = function getDonateTimestampNextShowWithClosedCount(closedCount) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DONATE_DEF_CONFIG;
  return Date.now() + getDonateDelayWithClosedCount(closedCount, config);
};

/***/ }),

/***/ 10620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OV": function() { return /* binding */ YOUTUBE_CHANNEL_URL; }
/* harmony export */ });
/* unused harmony exports YOUTUBE_URL_ORIGIN, YOUTUBE_CHANNEL_ID, YOUTUBE_ROUTE, YOUTUBE_URL_PARAM */
var YOUTUBE_URL_ORIGIN = "https://www.youtube.com";
var YOUTUBE_CHANNEL_ID = "UCJlRjlukZiCk3YFuOP4sz9w";
var YOUTUBE_ROUTE = {
  channel: "channel",
  watch: "watch",
  playlist: "playlist",
  embed: "embed"
};
var YOUTUBE_URL_PARAM = {
  playlist: "list",
  video: "v"
};
var YOUTUBE_CHANNEL_URL = YOUTUBE_URL_ORIGIN + "/" + YOUTUBE_ROUTE.channel + "/" + YOUTUBE_CHANNEL_ID;

/***/ }),

/***/ 78889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C5": function() { return /* binding */ focusElement; },
/* harmony export */   "IB": function() { return /* binding */ handleKeyDownExitFloatWindow; },
/* harmony export */   "OB": function() { return /* binding */ handleKeyDownNavigation; },
/* harmony export */   "nq": function() { return /* binding */ handleKeyDownSelectItem; },
/* harmony export */   "yX": function() { return /* binding */ selectorFocusableElements; },
/* harmony export */   "zf": function() { return /* binding */ isTryingExitElementByButtonTab; }
/* harmony export */ });
/* unused harmony exports handleKeyDownOpenItem, handleKeyDownExpandItem, handleKeyDownCheckItem, handleKeyDownContextMenuItem, handleItemKeyDown, lastElementIsFocusable, filterVisibleElements, firstElementIsFocusable, commonPopupKeyDownEvent */
/* harmony import */ var _dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62330);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }



var part = ":not([disabled]):not([data-focus='false'])";
var selectorFocusableElements = "input" + part + "," + "[data-submit]" + part + "," + "button" + part + "," + "a" + part + "," + "select" + part + "," + "textarea" + part + "," + "[tabindex]" + part;
var handleKeyDownNavigation = function handleKeyDownNavigation(container, e, stopPropagation) {
  var prevNextX = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (!container || !e) {
    return;
  }

  var isKeyCodeItemPrev = (0,_dom__WEBPACK_IMPORTED_MODULE_0__/* .isHotKey */ .E7)(e, _dom__WEBPACK_IMPORTED_MODULE_0__/* .Hotkey.itemPrevY */ .qm.itemPrevY);

  if (prevNextX && !isKeyCodeItemPrev) {
    isKeyCodeItemPrev = (0,_dom__WEBPACK_IMPORTED_MODULE_0__/* .isHotKey */ .E7)(e, _dom__WEBPACK_IMPORTED_MODULE_0__/* .Hotkey.itemPrevX */ .qm.itemPrevX);
  }

  var isKeyCodeItemNext = (0,_dom__WEBPACK_IMPORTED_MODULE_0__/* .isHotKey */ .E7)(e, _dom__WEBPACK_IMPORTED_MODULE_0__/* .Hotkey.itemNextY */ .qm.itemNextY);

  if (prevNextX && !isKeyCodeItemNext) {
    isKeyCodeItemNext = (0,_dom__WEBPACK_IMPORTED_MODULE_0__/* .isHotKey */ .E7)(e, _dom__WEBPACK_IMPORTED_MODULE_0__/* .Hotkey.itemNextX */ .qm.itemNextX);
  }

  if (isKeyCodeItemPrev || isKeyCodeItemNext) {
    var focusableElements = container.querySelectorAll(selectorFocusableElements);
    var indexItemCurrent = -1;
    var documentActiveElement = document.activeElement;

    for (var i = 0; i < focusableElements.length; i++) {
      if (focusableElements[i] === documentActiveElement) {
        indexItemCurrent = i;
        break;
      }
    }

    var indexItemNew;

    if (indexItemCurrent === -1) {
      indexItemNew = isKeyCodeItemNext ? 0 : focusableElements.length - 1;
    } else if (isKeyCodeItemPrev) {
      if (indexItemCurrent < 1) {
        indexItemNew = focusableElements.length - 1;
      } else {
        indexItemNew = indexItemCurrent - 1;
      }
    } else {
      if (indexItemCurrent > focusableElements.length - 2) {
        indexItemNew = 0;
      } else {
        indexItemNew = indexItemCurrent + 1;
      }
    }

    if (indexItemNew !== undefined && focusableElements[indexItemNew]) {
      focusableElements[indexItemNew].focus();
      e.preventDefault();

      if (stopPropagation) {
        e.stopPropagation();
      }
    }
  }
};

var handleKeyDown = function handleKeyDown(e, hotkey, cb) {
  if (e && hotkey && cb && (0,_dom__WEBPACK_IMPORTED_MODULE_0__/* .isHotKey */ .E7)(e, hotkey)) {
    cb(e);
    e.preventDefault();
    return true;
  }

  return false;
};

var handleKeyDownSelectItem = function handleKeyDownSelectItem(e, cb) {
  return handleKeyDown(e, _dom__WEBPACK_IMPORTED_MODULE_0__/* .Hotkey.selectButtonOrLink */ .qm.selectButtonOrLink, cb);
};
var handleKeyDownOpenItem = function handleKeyDownOpenItem(e, cb) {
  return handleKeyDown(e, Hotkey.openItem, cb);
};
var handleKeyDownExpandItem = function handleKeyDownExpandItem(e, cb) {
  return handleKeyDown(e, Hotkey.expandItem, cb);
};
var handleKeyDownCheckItem = function handleKeyDownCheckItem(e, cb) {
  return handleKeyDown(e, Hotkey.checkItem, cb);
};
var handleKeyDownContextMenuItem = function handleKeyDownContextMenuItem(e, cb) {
  return handleKeyDown(e, Hotkey.itemContextMenu, cb);
};
var handleKeyDownExitFloatWindow = function handleKeyDownExitFloatWindow(e, cb) {
  return handleKeyDown(e, _dom__WEBPACK_IMPORTED_MODULE_0__/* .Hotkey.exitFloatWindow */ .qm.exitFloatWindow, cb);
};
var isTryingExitElementByButtonTab = function isTryingExitElementByButtonTab(element, e) {
  if (!element || !e) {
    return false;
  }

  return (0,_dom__WEBPACK_IMPORTED_MODULE_0__/* .isEventKey */ .WV)(e, _dom__WEBPACK_IMPORTED_MODULE_0__/* .KeyCode.tab */ .VD.tab) && (!e.shiftKey && lastElementIsFocusable(element) || e.shiftKey && firstElementIsFocusable(element));
};
var handleItemKeyDown = function handleItemKeyDown(e, onCheck, onExpand, onOpen, onContextMenu) {
  if (!e) {
    return false;
  }

  return handleKeyDownCheckItem(e, onCheck) || handleKeyDownExpandItem(e, onExpand) || handleKeyDownContextMenuItem(e, onContextMenu) || handleKeyDownOpenItem(e, onOpen);
};
var lastElementIsFocusable = function lastElementIsFocusable() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var activeElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.activeElement;

  if (!target) {
    return false;
  }

  var elements = target.querySelectorAll(selectorFocusableElements);
  var filteredElements = elements && Array.from(elements).filter(filterVisibleElements);

  if (activeElement && filteredElements && filteredElements.length) {
    return activeElement === filteredElements[filteredElements.length - 1];
  }

  return false;
};
var filterVisibleElements = function filterVisibleElements(element) {
  return element.offsetParent !== null && !element.closest(".hideView");
};
var firstElementIsFocusable = function firstElementIsFocusable() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var activeElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.activeElement;

  if (!target) {
    return false;
  }

  var elements = target.querySelectorAll(selectorFocusableElements);
  var filteredElements = elements && Array.from(elements).filter(filterVisibleElements);

  if (activeElement && filteredElements && filteredElements.length) {
    return activeElement === filteredElements[0];
  }

  return false;
};
/**
 *
 * @param {Event} e
 * @param {Element} element
 * @param {function} escCb
 */

var commonPopupKeyDownEvent = function commonPopupKeyDownEvent() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var escCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (element && e) {
    if (escCb && isEventKey(e, KeyCode.esc)) {
      // looking for a nested popup
      var nestedPopup = !!(element && element.querySelector(".showView:not(.scrollToWrapper)"));

      if (!nestedPopup) {
        escCb();
      }
    } else if (isTryingExitElementByButtonTab(element, e)) {
      e.preventDefault();
    }
  }
};
/**
 * @param {NodeList} focusableElements
 * @param {boolean} preventScroll
 */

var focusElement = function focusElement() {
  var focusableElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var preventScroll = arguments.length > 1 ? arguments[1] : undefined;

  if (focusableElements && focusableElements.length) {
    var isElementWasFocused = false;

    var onSuitableElementEncountered = function onSuitableElementEncountered(el) {
      el.focus({
        preventScroll: preventScroll
      });

      if (!preventScroll && "scrollIntoView" in el) {
        el.scrollIntoView(true);
      }
    };

    var _iterator = _createForOfIteratorHelper(focusableElements),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _el$dataset;

        var el = _step.value;

        if (el.getAttribute("aria-checked") === "true" || (el.type === "radio" || el.type === "checkbox") && el.checked || ((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.focus) === "true") {
          onSuitableElementEncountered(el);
          isElementWasFocused = true;
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (!isElementWasFocused) {
      onSuitableElementEncountered(focusableElements[0]);
    }
  }
};

/***/ }),

/***/ 76221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ langListShort; }
/* harmony export */ });
var langListShort = [{
  url: "zh",
  label: "Chinese"
}, {
  url: "en",
  label: "English"
}, {
  url: "fr",
  label: "French"
}, {
  url: "de",
  label: "German"
}, {
  url: "it",
  label: "Italian"
}, {
  url: "pt",
  label: "Portuguese"
}, {
  url: "ro",
  label: "Romanian"
}, {
  url: "ru",
  label: "Russian"
}, {
  url: "es",
  label: "Spanish"
}];

/***/ }),

/***/ 35567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ MENU_ITEM_LOCATION; }
/* harmony export */ });
var MENU_ITEM_LOCATION = {
  MENU: "menu",
  BREADCRUMBS: "breadcrumbs",
  HOME: "home"
};

/***/ }),

/***/ 76439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CZ": function() { return /* binding */ UL_LANGUAGES; },
/* harmony export */   "E3": function() { return /* binding */ I18N_NAMESPACE; },
/* harmony export */   "k$": function() { return /* binding */ DEFAULT_LANGUAGE; },
/* harmony export */   "og": function() { return /* binding */ I18N_NAMESPACES_LANDING; },
/* harmony export */   "po": function() { return /* binding */ COOKIE_KEY_I_18_NEXT; },
/* harmony export */   "vh": function() { return /* binding */ LANG_CODE_EN; }
/* harmony export */ });
/* unused harmony export I18N_NAMESPACES */
/* harmony import */ var _array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21707);
/* harmony import */ var _assets_uiLanguages_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72044);
/* harmony import */ var _config_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10808);



var LANG_CODE_EN = _config_json__WEBPACK_IMPORTED_MODULE_2__.LANG_CODE_EN;
var DEFAULT_LANGUAGE = LANG_CODE_EN;
var UL_LANGUAGES = (0,_array__WEBPACK_IMPORTED_MODULE_0__/* .sortByField */ .L1)(_assets_uiLanguages_json__WEBPACK_IMPORTED_MODULE_1__, "key");
(0,_array__WEBPACK_IMPORTED_MODULE_0__/* .arraymove */ .yf)(UL_LANGUAGES, UL_LANGUAGES.findIndex(function (l) {
  return l.id === DEFAULT_LANGUAGE;
}), 0);
var COOKIE_KEY_I_18_NEXT = "i18next";
var I18N_NAMESPACE = {
  common: "common",
  translate: "translate",
  sw: "sw",
  books: "books",
  authors: "authors",
  featuredSearch: "featuredSearch"
};
var I18N_NAMESPACES = Object.values(I18N_NAMESPACE);
var I18N_NAMESPACES_LANDING = [I18N_NAMESPACE.common, I18N_NAMESPACE.sw];

/***/ }),

/***/ 54354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rs": function() { return /* binding */ tWithPrefixHandler; },
/* harmony export */   "hz": function() { return /* binding */ i18nLoadPath; },
/* harmony export */   "iH": function() { return /* binding */ translateObjectsArray; }
/* harmony export */ });
/* unused harmony export translateObjKey */
/* harmony import */ var _url_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59916);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }



var packageJson = __webpack_require__(59798);

var translateObjKey = function translateObjKey(obj, t) {
  var keyOrKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "label";
  var translateOptions = arguments.length > 3 ? arguments[3] : undefined;

  if (_typeof(obj) !== "object" || Array.isArray(obj)) {
    return obj;
  }

  var optionNew = _objectSpread({}, obj);

  if (Array.isArray(keyOrKeys)) {
    var _iterator = _createForOfIteratorHelper(keyOrKeys),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        optionNew[key] = t(optionNew[key], translateOptions);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else {
    optionNew[keyOrKeys] = t(optionNew[keyOrKeys], translateOptions);
  }

  return optionNew;
};
var translateObjectsArray = function translateObjectsArray(options, t, config) {
  var keyOrKeys, translateOptions;

  if (config) {
    keyOrKeys = config.keyOrKeys;
    translateOptions = config.translateOptions;
  }

  if (Array.isArray(options)) {
    return options.map(function (o) {
      return translateObjKey(o, t, keyOrKeys, translateOptions);
    });
  }

  return options;
};
var tWithPrefixHandler = function tWithPrefixHandler(t, key, options) {
  var translateIfNoSpecialSymbol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (key && key.indexOf("@") === 0) {
    return t(key.slice(1), options);
  }

  return translateIfNoSpecialSymbol ? t(key, options) : key;
};
var i18nLoadPath = function i18nLoadPath(lng, ns) {
  return (0,_url_url__WEBPACK_IMPORTED_MODULE_0__/* .makePublicUrl */ .xo)("/locales/" + lng + "/" + ns + ".json") + "?v=" + packageJson.version;
};

/***/ }),

/***/ 50150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cz": function() { return /* binding */ clutch; },
/* harmony export */   "Dx": function() { return /* binding */ getNumber; },
/* harmony export */   "Md": function() { return /* binding */ toFixedWithoutRounding; },
/* harmony export */   "PX": function() { return /* binding */ calcPercentage; },
/* harmony export */   "S5": function() { return /* binding */ isNumberBetweenEquals; },
/* harmony export */   "gA": function() { return /* binding */ int3DigitFormat; },
/* harmony export */   "pU": function() { return /* binding */ isDeltaEquals; }
/* harmony export */ });
/* unused harmony exports isNumberCalculable, calcProportion, roundNumberToDecimalWithStep */
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var isNumberBetweenEquals = function isNumberBetweenEquals(number, min, max) {
  return number >= min && number <= max;
};
var getNumber = function getNumber(value) {
  var defaultNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var number = parseInt(value);
  return isNaN(number) ? defaultNumber : number;
};
/**
 * @description Returns "value" if is in boundaries of "min" and "max"
 * Returns "max" if "value" more than "max"
 * Returns "min" if "value" less than "min"
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */

var clutch = function clutch(value, min, max) {
  if (min > max) {
    max = min;
    min = max;
  }

  if (isNaN(value)) {
    return max;
  }

  if (value > max) {
    return max;
  } else if (value < min) {
    return min;
  }

  return value;
};
/**
 * @description Returns whether a given number is acceptable for calculations,
 * so if it's a regular digit number.
 * @param {number} value
 * @returns {boolean}
 */

var isNumberCalculable = function isNumberCalculable(value) {
  return !isNaN(value) && typeof value === "number";
};
/**
 * @description Calculates direct or inverse proportion.
 * @param {number} value
 * @param {number} base
 * @param {number} baseNew
 * @returns {number}
 */

var calcProportion = function calcProportion(value, base, baseNew) {
  return value * baseNew / base;
};
var calcPercentage = function calcPercentage(partialValue, totalValue) {
  return 100 * partialValue / totalValue;
};
var isDeltaEquals = function isDeltaEquals(num1, num2, delta) {
  return Math.abs(num1 - num2) <= delta;
};
var int3DigitFormat = function int3DigitFormat(n) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ",";
  var list = (Number.isInteger(n) ? n : n | 0).toString().split("");
  var l = list.length;

  for (var i = l - 3; i > 0; i -= 3) {
    list.splice(i, 0, separator);
  }

  return list.join("");
};
var toFixedWithoutRounding = function toFixedWithoutRounding(num, fixed) {
  if (typeof num !== "number" || isNaN(num)) {
    return 0;
  }

  var regExp = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
  return num.toString().match(regExp)[0];
};
var roundNumberToDecimalWithStep = function roundNumberToDecimalWithStep(num, decimalStep) {
  if (typeof num === "number") {
    var _num$toString$split3 = num.toString().split("."),
        _num$toString$split4 = _slicedToArray(_num$toString$split3, 2),
        int = _num$toString$split4[0],
        fraction = _num$toString$split4[1];

    if (fraction && fraction[0]) {
      return parseFloat(int + "." + (fraction[0] - fraction[0] % decimalStep));
    }
  }

  return num;
};

/***/ }),

/***/ 18747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ds": function() { return /* binding */ debounce; },
/* harmony export */   "P2": function() { return /* binding */ throttle; },
/* harmony export */   "qo": function() { return /* binding */ trottleCheck; }
/* harmony export */ });
/* unused harmony exports applyCacheToFn, applyRuntimeCacheToFn */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _this = undefined;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// Adds a cache layer over the {fn} that returns previously stored result of the {fn} call
// if the result exists.
var _generateKeyDefault = function _generateKeyDefault() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.toString();
};

var applyCacheToFn = function applyCacheToFn(cacheManager, fn) {
  var fnGenerateKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _generateKeyDefault;
  var staleTimeInMilliseconds = arguments.length > 3 ? arguments[3] : undefined;

  var _cacheResult = function _cacheResult(key, result, timestamp) {
    cacheManager.set(key, {
      result: result,
      timestamp: timestamp
    });
  };

  return {
    get: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var key,
            timestamp,
            cacheData,
            result,
            _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              key = fnGenerateKey.apply(void 0, _args);
              timestamp = Date.now();

              if (!cacheManager.has(key)) {
                _context.next = 7;
                break;
              }

              cacheData = cacheManager.get(key);

              if (!cacheData) {
                _context.next = 7;
                break;
              }

              if (!(!staleTimeInMilliseconds || timestamp - cacheData.timestamp < staleTimeInMilliseconds)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", cacheData.result);

            case 7:
              _context.next = 9;
              return fn.apply(void 0, _args);

            case 9:
              result = _context.sent;

              _cacheResult(key, result, timestamp);

              return _context.abrupt("return", result);

            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));

      function get() {
        return _get.apply(this, arguments);
      }

      return get;
    }(),
    cache: function cache(args, result) {
      _cacheResult(fnGenerateKey.apply(void 0, _toConsumableArray(args)), result, Date.now());
    }
  };
};
var applyRuntimeCacheToFn = function applyRuntimeCacheToFn(fn, fnGenerateKey, staleTimeInMilliseconds) {
  return applyCacheToFn(new Map(), fn, fnGenerateKey, staleTimeInMilliseconds);
};
var debounce = function debounce(func, timeout) {
  var timer;
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(_this, args);
    }, timeout);
  };
};
var throttle = function throttle(func, timeout) {
  var isCallAllowed = true;
  return function () {
    if (isCallAllowed) {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      func.apply(_this, args);
      isCallAllowed = false;
      setTimeout(function () {
        isCallAllowed = true;
      }, timeout);
    }
  };
};
var trottleCheck = function trottleCheck(trottle) {
  var lastAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  return trottle === 0 || trottle > 0 && Date.now() - lastAction > trottle;
};

/***/ }),

/***/ 87794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mp": function() { return /* binding */ findWaveformsDictionaryParaById; },
/* harmony export */   "Yr": function() { return /* binding */ getSeekChapter; },
/* harmony export */   "_g": function() { return /* binding */ getFirstAvailableAudioChapter; },
/* harmony export */   "c6": function() { return /* binding */ isChapterInPlayer; },
/* harmony export */   "dm": function() { return /* binding */ filterTOCToAudioChapters; },
/* harmony export */   "eM": function() { return /* binding */ getFileDuration; },
/* harmony export */   "h$": function() { return /* binding */ findWaveformsDictionaryParaByPosition; },
/* harmony export */   "hR": function() { return /* binding */ getFileSize; },
/* harmony export */   "jW": function() { return /* binding */ getAudioChapterByChapterId; },
/* harmony export */   "yL": function() { return /* binding */ checkIsChildPlaying; }
/* harmony export */ });
/* unused harmony export _testGetDuplicateChapters */
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var checkIsChildPlaying = function checkIsChildPlaying(item, id) {
  if (item.id === id) {
    return true;
  }

  var children = item.children;

  if (children && children.length) {
    var result = false;

    for (var i = 0; i < children.length; i++) {
      result = checkIsChildPlaying(children[i], id);

      if (result) {
        break;
      }
    }

    return result;
  }

  return false;
};
var getFileDuration = function getFileDuration(mp3Url) {
  if (!mp3Url) {
    return 0;
  }

  var fileDuration = 0;
  var durationReg = /duration=(.*)&/;

  var _mp3Url$match = mp3Url.match(durationReg),
      _mp3Url$match2 = _slicedToArray(_mp3Url$match, 2),
      value = _mp3Url$match2[1];

  if (value) {
    fileDuration = parseInt(value, 10);
  }

  return fileDuration;
};
var getFileSize = function getFileSize(mp3Url) {
  if (!mp3Url) {
    return 0;
  }

  var size = 0;
  var regExp = /size=(.*)$/;

  var _mp3Url$match3 = mp3Url.match(regExp),
      _mp3Url$match4 = _slicedToArray(_mp3Url$match3, 2),
      value = _mp3Url$match4[1];

  if (value) {
    size = parseInt(value, 10);
  }

  return size;
};
var findWaveformsDictionaryParaById = function findWaveformsDictionaryParaById(waveformsDictionary, targetId, paraId) {
  if (!targetId || !waveformsDictionary[targetId]) {
    return null;
  }

  return waveformsDictionary[targetId].paragraphsAudioPositions.find(function (item) {
    return item.id === paraId;
  });
};
var findWaveformsDictionaryParaByPosition = function findWaveformsDictionaryParaByPosition(waveformsDictionary, targetId, position) {
  if (!waveformsDictionary[targetId]) {
    return null;
  }

  return waveformsDictionary[targetId].paragraphsAudioPositions.find(function (item) {
    return item.start <= position && item.end > position;
  });
};

var getParentAudioChapter = function getParentAudioChapter(chapters, chapter) {
  if (!chapter || chapter.level === 1) {
    return null;
  }

  var parentLevel = chapter.level - 1;
  var index = chapters.findIndex(function (item) {
    return item === chapter;
  });
  var possibleParentChapter;

  for (var i = index - 1; i >= 0; i--) {
    possibleParentChapter = chapters[i];

    if (possibleParentChapter.level === parentLevel) {
      if (possibleParentChapter.mp3) {
        return possibleParentChapter;
      }

      return getParentAudioChapter();
    }
  }

  return null;
};

var isChapterDuplicate = function isChapterDuplicate(chapter1, chapter2) {
  if (!chapter1 || !chapter2) {
    return false;
  }

  return chapter1.dup && chapter1.dup === chapter2.id || chapter2.dup && chapter2.dup === chapter1.id;
};

var getDuplicateChapters = function getDuplicateChapters(toc, chapter) {
  var out = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (toc && chapter) {
    toc.filter(function (c) {
      return isChapterDuplicate(c, chapter);
    }).forEach(function (dc) {
      var isInOut = out.includes(dc);

      if (!isInOut) {
        out.push(dc);
        getDuplicateChapters(toc, dc, out);
      }
    });
  }

  return out;
};

var _testGetDuplicateChapters = (/* unused pure expression or super */ null && (getDuplicateChapters));
var getAudioChapterByChapterId = function getAudioChapterByChapterId(toc, chapterId) {
  if (!chapterId || !toc || !toc.length) {
    return null;
  } // Case 1 - Basic.


  var currentChapter = toc.find(function (chapter) {
    return chapter.id === chapterId;
  });

  if (currentChapter && currentChapter.mp3) {
    return currentChapter;
  } // ===================================
  // Case 2 - Duplicates.
  // e.g. 1965.2 is a dup of 1965.1 that is a dup of 1965.3


  var duplicateChapters = getDuplicateChapters(toc, currentChapter);
  var duplicateChapterWithMP3 = duplicateChapters.find(function (c) {
    return !!c.mp3;
  }); // ============================================

  return duplicateChapterWithMP3 || getParentAudioChapter(toc, currentChapter);
};
var getFirstAvailableAudioChapter = function getFirstAvailableAudioChapter(toc) {
  if (!toc) {
    return null;
  }

  return toc.find(function (item) {
    return item.mp3;
  });
};
/**
 *
 * @typedef {Object} SeekChapter
 * @property {{} | null} audioChapter
 * @property {{} | null} chapter
 * @property {{} | null} positions
 * @property {boolean} isMissingWaveform
 */

var isChapterInPlayer = function isChapterInPlayer(toc, idChapter, waveformsDictionary, idAudioChapterPlayer, playerPosition) {
  var indexChapter = toc.findIndex(function (c) {
    return c.id === idChapter;
  });
  var chapter = toc[indexChapter];
  var id = chapter.id;
  var audioChapter = getAudioChapterByChapterId(toc, id);
  var audioPositions = null;
  var isInPlayer = false;

  if (audioChapter && audioChapter.id === idAudioChapterPlayer) {
    var isOKPrev = true,
        isOKNext = true;
    var chapterPrev = toc[indexChapter - 1];

    if (chapterPrev) {
      var audioChapterPrev = getAudioChapterByChapterId(toc, chapterPrev.id);

      if (audioChapterPrev && audioChapterPrev.mp3 === audioChapter.mp3) {
        var audioPositionsPrev = findWaveformsDictionaryParaById(waveformsDictionary, audioChapterPrev.id, chapterPrev.id);

        if (audioPositionsPrev) {
          isOKPrev = playerPosition >= audioPositionsPrev.end;
        }
      }
    }

    var chapterNext = toc[indexChapter + 1];

    if (chapterNext) {
      var audioChapterNext = getAudioChapterByChapterId(toc, chapterNext.id);

      if (audioChapterNext && audioChapterNext.mp3 === audioChapter.mp3) {
        var audioPositionsNext = findWaveformsDictionaryParaById(waveformsDictionary, audioChapterNext.id, chapterNext.id);

        if (audioPositionsNext) {
          isOKNext = playerPosition < audioPositionsNext.start;
        }
      }
    }

    isInPlayer = isOKPrev && isOKNext;
  }

  return {
    isInPlayer: isInPlayer,
    audioChapter: audioChapter,
    audioPositions: audioPositions
  };
};
/**
 * @returns {SeekChapter | null}
 */

var getSeekChapter = function getSeekChapter(toc, indexChapterPlaying, waveformsDictionary, isForward) {
  var index = indexChapterPlaying + (isForward ? 1 : -1);
  var chapter = toc[index];

  while (chapter) {
    var audioChapter = getAudioChapterByChapterId(toc, chapter.id);

    if (audioChapter) {
      var positions = findWaveformsDictionaryParaById(waveformsDictionary, audioChapter.id, chapter.id);
      return {
        audioChapter: audioChapter,
        chapter: chapter,
        positions: positions,
        isMissingWaveform: !waveformsDictionary[audioChapter.id]
      };
    }

    index += isForward ? 1 : -1;
    chapter = toc[index];
  }

  return null;
};
var filterTOCToAudioChapters = function filterTOCToAudioChapters(toc) {
  if (!toc) {
    return null;
  }

  return toc.filter(function (chapter) {
    return chapter.mp3;
  });
};

/***/ }),

/***/ 97993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ handleReactRef; },
/* harmony export */   "u": function() { return /* binding */ handleReactSlot; }
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var handleReactSlot = function handleReactSlot(slot) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (_typeof(slot)) {
    case "function":
      for (var _len = arguments.length, restArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        restArgs[_key - 2] = arguments[_key];
      }

      return slot.apply(void 0, [props].concat(restArgs));

    default:
      return slot;
  }
};
var handleReactRef = function handleReactRef(ref, instance) {
  if (ref) {
    if (typeof ref === "function") {
      ref(instance);
    } else if ("current" in ref) {
      ref.current = instance;
    }
  }
};

/***/ }),

/***/ 16484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IJ": function() { return /* binding */ READER_VIEW_CLASS_NAME_PARA_WRAP; },
/* harmony export */   "Kd": function() { return /* binding */ DEF_READER_TEXT_ALIGN; },
/* harmony export */   "Lt": function() { return /* binding */ READER_VIEW_CLASS_NAME_PARA_CONTENT_ONLY; },
/* harmony export */   "P6": function() { return /* binding */ IdReaderDefaultFont; },
/* harmony export */   "V1": function() { return /* binding */ ClassNameReaderPanelScrollbar; },
/* harmony export */   "XE": function() { return /* binding */ CUSTOM_EVENT_TYPE_READER_PLAY; },
/* harmony export */   "aE": function() { return /* binding */ BOOK_REAL_TYPE; },
/* harmony export */   "ao": function() { return /* binding */ READER_OPEN_LINK_BEHAVIOUR; },
/* harmony export */   "bn": function() { return /* binding */ READER_PLAYER_BEHAVIOURS; },
/* harmony export */   "qg": function() { return /* binding */ DATA_ATTR_PANEL_INDEX; },
/* harmony export */   "rJ": function() { return /* binding */ CUSTOM_EVENT_TYPE_READER_ACTION; },
/* harmony export */   "t4": function() { return /* binding */ BooksIdsJTL; },
/* harmony export */   "uu": function() { return /* binding */ DATA_ATTR_LINK_ID; },
/* harmony export */   "vl": function() { return /* binding */ DATA_ATTR_PARA_ID; }
/* harmony export */ });
/* unused harmony exports IdReaderDefaultFontEasyApp, MAP_READER_OPEN_LINK_BEHAVIOUR_LABEL, CLASS_NAME_EL_ARROW, ClassNameReaderPanel, DATA_ATTR_PANEL_ID, BOOKS_IDS_BIBLE_VERSION_DICTIONARIES, BIBLE_TYPE_CONCORDANCES, fontOptions, textAlignOptions */
/* harmony import */ var _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59034);
var _MAP_READER_OPEN_LINK;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var IdFontRobotoCon = "roboto_con";
var IdFontVolkhovRegular = "volkhov_regular";
var IdReaderDefaultFont = IdFontRobotoCon;
var IdReaderDefaultFontEasyApp = (/* unused pure expression or super */ null && (IdFontVolkhovRegular));
var DEF_READER_TEXT_ALIGN = "justify";
var READER_PLAYER_BEHAVIOURS = {
  ASK: 1,
  HISTORY: 2,
  CURRENT_PARA: 3,
  CONTINUE: 4,
  FIRST_AVAILABLE: 5
};
var READER_OPEN_LINK_BEHAVIOUR = {
  openInActiveSplit: "openInActiveSplit",
  openInNewSplit: "openInSplit",
  openInCurrentWindow: "openInWindow",
  openInNewTab: "openInTab"
};
var MAP_READER_OPEN_LINK_BEHAVIOUR_LABEL = (_MAP_READER_OPEN_LINK = {}, _defineProperty(_MAP_READER_OPEN_LINK, READER_OPEN_LINK_BEHAVIOUR.openInActiveSplit, "openInActiveSplit"), _defineProperty(_MAP_READER_OPEN_LINK, READER_OPEN_LINK_BEHAVIOUR.openInNewSplit, "openInNewSplit"), _defineProperty(_MAP_READER_OPEN_LINK, READER_OPEN_LINK_BEHAVIOUR.openInCurrentWindow, "openInWindow"), _defineProperty(_MAP_READER_OPEN_LINK, READER_OPEN_LINK_BEHAVIOUR.openInNewTab, "openInTab"), _MAP_READER_OPEN_LINK);
var CLASS_NAME_EL_ARROW = "reader-arrow";
var DATA_ATTR_PARA_ID = "data-id";
var ClassNameReaderPanelScrollbar = "rpc";
var ClassNameReaderPanel = "rp";
var CUSTOM_EVENT_TYPE_READER_ACTION = "readerAction";
var DATA_ATTR_PANEL_INDEX = "data-panel-index";
var DATA_ATTR_PANEL_ID = "data-panel-id";
var DATA_ATTR_LINK_ID = "data-link"; // JTL books must open with additional books in reader

var BooksIdsJTL = ["b14345", "b14347", "b14372", "b14373", "b14374", "b14375", "b14376", "b14377", "b14378", "b14379", "b14380", "b14381"];
var BOOKS_IDS_BIBLE_VERSION_DICTIONARIES = (/* unused pure expression or super */ null && (["b14175", // KJVSD King James Bible With Strongs Dictionary
"b14125" // KJRV King James Reference Versio
]));
var BIBLE_TYPE_CONCORDANCES = "bible-concordances";
var BOOK_REAL_TYPE = {
  bibleVersions: "bible-versions",
  bibleConcordances: "bible-concordances",
  bibleDictionaries: "bible-dictionaries",
  bibleCommentaries: "bible-commentaries",
  bibleSdasi: "bible-sdasi"
};
var CUSTOM_EVENT_TYPE_READER_PLAY = "handlePlayAudioInReader";
var fontOptions = [{
  label: "Roboto Condensed",
  id: IdFontRobotoCon,
  value: "Roboto Condensed",
  style: {
    fontFamily: "Roboto Condensed"
  }
}, {
  label: "Roboto",
  id: "roboto",
  value: "Roboto",
  style: {
    fontFamily: "Roboto"
  }
}, {
  label: "Roboto Slab",
  id: "roboto_slab",
  value: "Roboto Slab",
  style: {
    fontFamily: "Roboto Slab"
  }
}, {
  label: "Merriweather",
  id: "merriweather",
  value: "Merriweather",
  style: {
    fontFamily: "Merriweather",
    fontStyle: "italic"
  }
}, {
  label: "Noto Sans",
  id: "noto_sans",
  value: "Noto Sans",
  style: {
    fontFamily: "Noto Sans"
  }
}, {
  label: "Noto Sans Condensed",
  id: "noto_sans_cond",
  value: "Noto Sans Condensed",
  style: {
    fontFamily: "Noto Sans Condensed"
  }
}, {
  label: "Noto Serif",
  id: "noto_serif",
  value: "Noto Serif",
  style: {
    fontFamily: "Noto Serif"
  }
}, {
  label: "Volkhov Regular",
  id: IdFontVolkhovRegular,
  value: "Volkhov Regular",
  style: {
    fontFamily: "Volkhov"
  }
}, {
  label: "Volkhov Italic",
  id: "volkhov_italic",
  value: "Volkhov Italic",
  style: {
    fontFamily: "Volkhov",
    fontStyle: "italic"
  }
}, {
  label: "Volkhov Bold",
  id: "volkhov_bold",
  value: "Volkhov Bold",
  style: {
    fontFamily: "Volkhov",
    fontWeight: "bold"
  }
}];
var textAlignOptions = [{
  id: "left",
  icon: _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["text-left"] */ .Z["text-left"]
}, {
  id: "center",
  icon: _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["text-center"] */ .Z["text-center"]
}, {
  id: "right",
  icon: _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["text-right"] */ .Z["text-right"]
}, {
  id: "justify",
  icon: _assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["text-justify"] */ .Z["text-justify"]
}];
var READER_VIEW_CLASS_NAME_PARA_WRAP = "js-para";
var READER_VIEW_CLASS_NAME_PARA_CONTENT_ONLY = "js-para-content";

/***/ }),

/***/ 80256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FN": function() { return /* binding */ makeBookInfoChapterObject; },
/* harmony export */   "Mg": function() { return /* binding */ getChapterByParaId; },
/* harmony export */   "P$": function() { return /* binding */ getTocChaptersPrevNextCurr; },
/* harmony export */   "vm": function() { return /* binding */ diveToChapterWithContent; },
/* harmony export */   "z$": function() { return /* binding */ makeBookInfoTocObject; }
/* harmony export */ });
var ignoreParas = [// See: EGWW-4249
"14748.2", "14749.2", "14750.2117", "14752.2", "14753.2"];

var getRealFirstChapter = function getRealFirstChapter(toc) {
  var firstChapterIndex = 0;

  if (toc[firstChapterIndex].para_id.split(".")[1] === "0" && toc[firstChapterIndex + 1]) {
    firstChapterIndex++;
  }

  if (ignoreParas.indexOf(toc[firstChapterIndex].para_id) > -1 && toc[firstChapterIndex + 1]) {
    firstChapterIndex++;
  }

  if (toc[firstChapterIndex].level === 0 && toc[firstChapterIndex + 1]) {
    firstChapterIndex++;
  }

  return firstChapterIndex;
};

var makeBookInfoChapterObject = function makeBookInfoChapterObject(book, toc) {
  var firstChapterIndex = getRealFirstChapter(toc);
  return {
    book: book,
    isBookInfo: true,
    para_id: book.book_id + ".0",
    id_prev: null,
    id_next: toc[firstChapterIndex].para_id,
    content: "",
    translations: []
  };
};
var makeBookInfoTocObject = function makeBookInfoTocObject(chapterId, toc) {
  var firstChapterIndex = getRealFirstChapter(toc);
  var id = String(chapterId).split(".")[0] + ".0";
  return {
    para_id: id,
    level: toc[firstChapterIndex].level,
    isBookInfo: true,
    title: "About book",
    refcode_short: "",
    dup: "",
    mp3: null,
    puborder: toc[firstChapterIndex].puborder - 1,
    className: "chapter",
    id: id,
    cursor: 0
  };
}; // Specific navigation: Skips chapters without paragraphs.

var diveToChapterWithContent = function diveToChapterWithContent(chapterId, toc) {
  var chapter = null;
  var index = -1;

  if (toc && chapterId) {
    index = toc.findIndex(function (item) {
      return chapterId === item.id;
    });

    if (toc[index] && ignoreParas.indexOf(toc[index].para_id) > -1 && toc[index + 1]) {
      index += 1;
    }

    if (index !== -1) {
      if (chapterId.split(".")[1] === "0") {
        return {
          chapter: makeBookInfoTocObject(chapterId, toc),
          index: 0
        };
      }

      var chapterObj = goInDirectionWithSkipChaptersTitles(toc, index, true);

      if (chapterObj.chapter) {
        chapter = chapterObj.chapter;
        index = chapterObj.index;
      }
    }

    if (index === -1) {
      // The reinsurance code for cases, when user manually opens a link
      // with an id like "xxx.1"
      // (Note, ".1" it means to open a first chapter, not a chapter with index "1")
      if (chapterId.split(".")[1] === "1") {
        if (toc[1] || toc[0]) {
          index = toc[1] ? 1 : 0;
          chapter = toc[index];
        }
      }

      if (chapterId.split(".")[1] === "0") {
        index = 0;
        chapter = makeBookInfoTocObject(chapterId, toc);
      }
    }
  }

  return {
    chapter: chapter,
    index: index
  };
}; // Specific navigation: Skips chapters without paragraphs.

var getTocChaptersPrevNextCurr = function getTocChaptersPrevNextCurr(chapterId, toc) {
  var currChapterObj,
      currChapter = null,
      prevChapter = null,
      nextChapter = null;

  if (toc) {
    currChapterObj = diveToChapterWithContent(chapterId, toc);

    if (currChapterObj && currChapterObj.index !== -1) {
      currChapter = currChapterObj.chapter;
      var currChapterHighestParent = goInDirectionWithSkipChaptersTitles(toc, currChapterObj.index, false);

      if (toc[currChapterHighestParent.index - 1] && toc[currChapterHighestParent.index - 1].level !== 0) {
        prevChapter = toc[currChapterHighestParent.index - 1];
      } // Always skip the title chapter - it's an exception.


      if (prevChapter && prevChapter.level === 0) {
        prevChapter = null;
      } // ==============================================


      var nextChapterObject = goInDirectionWithSkipChaptersTitles(toc, currChapterObj.index + 1, true);

      if (nextChapterObject.chapter) {
        nextChapter = nextChapterObject.chapter;
      }
    }

    if (currChapterObj && currChapterObj.index !== 0) {
      currChapter = currChapterObj.chapter;

      var _nextChapterObject = goInDirectionWithSkipChaptersTitles(toc, currChapterObj.index + 1, true);

      if (_nextChapterObject.chapter) {
        nextChapter = _nextChapterObject.chapter;
      }
    }
  }

  return {
    currChapter: currChapter,
    prevChapter: prevChapter,
    nextChapter: nextChapter
  };
}; // Specific navigation: Skips chapters without paragraphs.

var goInDirectionWithSkipChaptersTitles = function goInDirectionWithSkipChaptersTitles(toc, index, isForward) {
  var indexNew = index;
  var chapterNew = toc[indexNew];

  while (isForward ? toc[indexNew + 1] && (toc[indexNew + 1].puborder - chapterNew.puborder === 1 || toc[indexNew + 1].dup === chapterNew.id || ignoreParas.indexOf(chapterNew.id) > -1) : toc[indexNew - 1] && (chapterNew.puborder - toc[indexNew - 1].puborder === 1 || toc[indexNew - 1].id === chapterNew.dup || ignoreParas.indexOf(chapterNew.id) > -1)) {
    if (isForward) {
      indexNew = indexNew + 1;
    } else {
      indexNew = indexNew - 1;
    }

    chapterNew = toc[indexNew];
  }

  return {
    chapter: chapterNew || null,
    index: chapterNew ? indexNew : -1
  };
}; // e.g. of the case
// requested a random para id of the chapter, fetch chapter content to get actual {chapterId}
// Actual {chapterId} is needed to detect possible chapter that could be skipped.
// "Title" chapter and "Parent of a Branch" chapters should be skipped, because they
// have little amount of paragraphs.


var getChapterByParaId = function getChapterByParaId(toc, paraId, fnFetchChapterContent) {
  var chapterObj = diveToChapterWithContent(paraId, toc);

  if (chapterObj.index === -1) {
    var chapterContentOrPromise = fnFetchChapterContent(paraId);

    var handleChapterContent = function handleChapterContent(chapterContent) {
      if (chapterContent && chapterContent[0]) {
        var chapterCurrentFixed = diveToChapterWithContent(chapterContent[0].para_id, toc);

        if (chapterCurrentFixed.index !== -1) {
          return chapterCurrentFixed;
        }
      }

      return chapterObj;
    };

    if (chapterContentOrPromise instanceof Promise) {
      return chapterContentOrPromise.then(handleChapterContent);
    }

    return handleChapterContent(chapterContentOrPromise);
  }

  return chapterObj;
};

/***/ }),

/***/ 41674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ highlightContainingMarkNoteElements; },
/* harmony export */   "o": function() { return /* binding */ getClosestNoteElement; }
/* harmony export */ });
/* harmony import */ var _content_content_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5626);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }


var getClosestNoteElement = function getClosestNoteElement(element) {
  if (!element) {
    return null;
  }

  var nonTextNode = element.nodeType === Node.TEXT_NODE ? element.parentElement : element;
  var classList = nonTextNode.classList;
  var FOOT_NOTE = _content_content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.FOOT_NOTE */ .J8.FOOT_NOTE,
      CHAPTER_END_NOTE = _content_content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.CHAPTER_END_NOTE */ .J8.CHAPTER_END_NOTE,
      BOOK_END_NOTE = _content_content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.BOOK_END_NOTE */ .J8.BOOK_END_NOTE;
  return classList.contains(FOOT_NOTE) || classList.contains(CHAPTER_END_NOTE) || classList.contains(BOOK_END_NOTE) ? nonTextNode : nonTextNode.closest(".".concat(FOOT_NOTE, ",.").concat(CHAPTER_END_NOTE, ",.").concat(BOOK_END_NOTE));
};
var highlightContainingMarkNoteElements = function highlightContainingMarkNoteElements(elContainer) {
  if (elContainer) {
    var FOOT_NOTE = _content_content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.FOOT_NOTE */ .J8.FOOT_NOTE,
        CHAPTER_END_NOTE = _content_content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.CHAPTER_END_NOTE */ .J8.CHAPTER_END_NOTE,
        BOOK_END_NOTE = _content_content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.BOOK_END_NOTE */ .J8.BOOK_END_NOTE;
    var elements = elContainer.querySelectorAll("a.".concat(FOOT_NOTE, ",a.").concat(CHAPTER_END_NOTE, ",a.").concat(BOOK_END_NOTE));

    var _iterator = _createForOfIteratorHelper(elements),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var element = _step.value;

        if (element.querySelector("mark")) {
          var elementMarkWrapped = document.createElement("mark");
          elementMarkWrapped.appendChild(element.cloneNode(true));

          if (element.parentNode) {
            element.parentNode.replaceChild(elementMarkWrapped, element);
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
};

/***/ }),

/***/ 18664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A5": function() { return /* binding */ getPlayerBehaviorLabel; },
/* harmony export */   "E1": function() { return /* binding */ isParaHeader; },
/* harmony export */   "E6": function() { return /* binding */ getReaderFirstVisibleId; },
/* harmony export */   "IW": function() { return /* binding */ dispatchWindowEventPlayAudioInReader; },
/* harmony export */   "QT": function() { return /* binding */ findFirstVisibleLinkInActiveParaOrJustFirstVisible; },
/* harmony export */   "V": function() { return /* binding */ findNearLink; },
/* harmony export */   "hY": function() { return /* binding */ createReaderActiveLink; },
/* harmony export */   "mT": function() { return /* binding */ getReaderAudioChapter; },
/* harmony export */   "rO": function() { return /* binding */ findContentLinkById; },
/* harmony export */   "uE": function() { return /* binding */ findTargetId; }
/* harmony export */ });
/* unused harmony exports getLinksInPanel, findLinkBasedOnLinksArea, makeActiveLinkSelector, dispatchCustomEventReaderAction, getReaderFontConfigById, makeLinkClassName */
/* harmony import */ var _shared_utils_number_number__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50150);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16484);
/* harmony import */ var _dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62330);
/* harmony import */ var _content_content_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5626);
/* harmony import */ var _player__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87794);





var findTargetId = function findTargetId(para, toc, bookFirstPara) {
  if (!para || !toc) {
    return undefined;
  }

  var targetId;
  var index = (toc || []).findIndex(function (item) {
    return item.puborder > para.puborder;
  });

  if (index > 0) {
    index--;
    var chapter = toc[index];

    if (chapter) {
      targetId = chapter.level === 0 ? bookFirstPara || toc[0].id : chapter.id;
    }
  } else if (para.puborder >= (toc[toc.length - 1] || {}).puborder) {
    targetId = toc[toc.length - 1].id;
  } else if (index === -1 && toc.length === 1) {
    targetId = toc[0].id;
  }

  return targetId;
};
var isParaHeader = function isParaHeader(para) {
  return !!(para && para.element_type && para.element_type[0] === "h");
};
/**
 * @typedef {Object} LinkInPanel
 * @property elem: {},
 * @property id: string,
 * @property activePara: boolean,
 * @property isBible: boolean,
 * @property className: string,
 * @property title: string,
 * @property visible: boolean,
 * @property index: number,
 * @property paraId: string,
 */

/**
 * @returns {{links: LinkInPanel[], panel: Element}}
 */

var getLinksInPanel = function getLinksInPanel(indexPanel, paraIdPanel) {
  var panel = document.querySelector("[".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .DATA_ATTR_PANEL_INDEX */ .qg, "='").concat(indexPanel, "'] .").concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .ClassNameReaderPanelScrollbar */ .V1)) || document.querySelector( // for lite app
  "[".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .DATA_ATTR_PANEL_INDEX */ .qg, "='").concat(indexPanel, "']"));
  var panelRect;
  var links = [];

  if (panel) {
    var egwlinks = panel.getElementsByClassName(_content_content_constants__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_CLASSES.EGW_LINK */ .J8.EGW_LINK);
    panelRect = panel.getBoundingClientRect();
    var elem,
        elementId,
        elemRect,
        parentPara,
        prevParaId,
        paraId,
        activePara,
        index = 0;
    var computedStyleFirstLink = egwlinks[0] ? window.getComputedStyle(egwlinks[0]) : null;
    var paddingVisibilityVertical;

    if (computedStyleFirstLink) {
      var floatFontSize = parseFloat(computedStyleFirstLink.fontSize);
      var floatLineHeight = parseFloat(computedStyleFirstLink.lineHeight);
      var heightTextLine = floatFontSize * (floatLineHeight / floatFontSize);
      paddingVisibilityVertical = heightTextLine / 2;
    }

    for (var i = 0; i < egwlinks.length; i++) {
      elem = egwlinks[i];
      activePara = false;
      parentPara = elem.closest(".para");

      if (parentPara) {
        paraId = parentPara.getAttribute(_constants__WEBPACK_IMPORTED_MODULE_0__/* .DATA_ATTR_PARA_ID */ .vl);

        if (paraIdPanel && paraId === paraIdPanel) {
          activePara = true;
        }
      }

      elementId = elem.getAttribute(_constants__WEBPACK_IMPORTED_MODULE_0__/* .DATA_ATTR_LINK_ID */ .uu);

      if (prevParaId === paraId) {
        index++;
      } else {
        index = 0;
      }

      prevParaId = paraId;

      if (elem.classList.contains(_content_content_constants__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_CLASSES.EGW_LINK_EXTERNAL */ .J8.EGW_LINK_EXTERNAL)) {
        continue;
      }

      elemRect = elem.getBoundingClientRect();
      var isBible = elem.classList.contains(_content_content_constants__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_CLASSES.EGW_LINK_BIBLE */ .J8.EGW_LINK_BIBLE);
      links.push({
        elem: elem,
        id: elementId,
        activePara: activePara,
        isBible: isBible,
        className: isBible ? _content_content_constants__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_CLASSES.EGW_LINK_BIBLE */ .J8.EGW_LINK_BIBLE : _content_content_constants__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_CLASSES.EGW_LINK_BOOK */ .J8.EGW_LINK_BOOK,
        title: elem.innerText,
        visible: (0,_dom__WEBPACK_IMPORTED_MODULE_1__/* .inRect */ .ul)(panelRect, elemRect, {
          paddingVertical: paddingVisibilityVertical
        }),
        index: index,
        paraId: paraId
      });
    }
  }

  return {
    panel: panel,
    panelRect: panelRect,
    links: links
  };
};
/**
 * @returns {LinkInPanel | null}
 */

var findNearLink = function findNearLink(next, activeLink, activeId, activeIndex, isOpenFirstIfNoLinkActive) {
  var _getLinksInPanel = getLinksInPanel(activeIndex, activeId),
      links = _getLinksInPanel.links;

  var index = -1; // Based on active link

  if (activeLink) {
    index = links.findIndex(function (item) {
      return activeLink.paraIdFrom === item.paraId && (activeLink.idOriginal || activeLink.id) === item.id && activeLink.indexInPara === item.index;
    });
  } // First visible


  if (index === -1 && isOpenFirstIfNoLinkActive) {
    index = links.findIndex(function (item) {
      return item.visible;
    });
  } // First available link


  if (index === -1 && isOpenFirstIfNoLinkActive && links.length) {
    index = next ? 0 : links.length - 1;
  }

  if (index !== -1) {
    if (!activeLink) {
      return links[index];
    } else if (next && index + 1 < links.length) {
      return links[index + 1];
    } else if (!next && index - 1 >= 0) {
      return links[index - 1];
    }
  }

  return null;
};
var findLinkBasedOnLinksArea = function findLinkBasedOnLinksArea(idToSearchLinksIn, indexToSearchLinksIn) {
  var _getLinksInPanel2 = getLinksInPanel(indexToSearchLinksIn, idToSearchLinksIn),
      panelRect = _getLinksInPanel2.panelRect,
      links = _getLinksInPanel2.links;

  var arrowElement = document.querySelector(".".concat(CLASS_NAME_EL_ARROW, "[").concat(DATA_ATTR_PANEL_INDEX, "=\"").concat(indexToSearchLinksIn, "\"]"));

  if (arrowElement && panelRect) {
    var arrowRect = arrowElement.getBoundingClientRect();
    var areaWidth = panelRect.width;
    var areaHeight = 48;
    var areaX = arrowRect.x;
    var areaY = arrowRect.y - areaHeight / 2;
    var linkSuitable = links.find(function (link) {
      var rect = link.elem.getBoundingClientRect();
      var rectX = rect.x;
      var rectY = rect.y;
      return rectX >= areaX && rectY >= areaY && rectX + rect.width <= areaX + areaWidth && rectY + rect.height <= areaY + areaHeight;
    });

    if (linkSuitable) {
      return linkSuitable;
    }
  }

  return null;
};
var findContentLinkById = function findContentLinkById(idToSearchLinksIn, indexToSearchLinksIn, linkId) {
  if (linkId) {
    var _getLinksInPanel4 = getLinksInPanel(indexToSearchLinksIn, idToSearchLinksIn),
        links = _getLinksInPanel4.links;

    var linkSuitable = links.find(function (item) {
      return item.id === linkId && item.paraId === idToSearchLinksIn;
    }) || links.find(function (item) {
      return item.id === linkId;
    });

    if (linkSuitable) {
      return linkSuitable;
    }
  }

  return null;
};
var findFirstVisibleLinkInActiveParaOrJustFirstVisible = function findFirstVisibleLinkInActiveParaOrJustFirstVisible(idToSearchLinksIn, indexToSearchLinksIn) {
  var _getLinksInPanel5 = getLinksInPanel(indexToSearchLinksIn, idToSearchLinksIn),
      links = _getLinksInPanel5.links;

  return links.find(function (item) {
    return item.activePara && item.visible;
  }) || links.find(function (item) {
    return item.visible;
  }) || null;
};
var createReaderActiveLink = function createReaderActiveLink(linkClassName, idOriginal, indexInPara, paraIdFrom, paraIdsContentPreviewBibleLink) {
  return {
    linkClassName: linkClassName,
    paraIdFrom: paraIdFrom,
    indexInPara: indexInPara,
    idOriginal: idOriginal,
    paraIdsContentPreviewBibleLink: paraIdsContentPreviewBibleLink
  };
};
var allowedContentClass = [_content_content_constants__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_CLASSES.EGW_LINK */ .J8.EGW_LINK, _content_content_constants__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_CLASSES.EGW_LINK_BIBLE */ .J8.EGW_LINK_BIBLE, _content_content_constants__WEBPACK_IMPORTED_MODULE_2__/* .CONTENT_CLASSES.EGW_LINK_BOOK */ .J8.EGW_LINK_BOOK];
var makeActiveLinkSelector = function makeActiveLinkSelector(item) {
  var linkClassName = item.linkClassName,
      id = item.id,
      paraIdFrom = item.paraIdFrom,
      indexInPara = item.indexInPara,
      idOriginal = item.idOriginal;
  var selectors = [];

  if (paraIdFrom) {
    selectors.push(".".concat(CONTENT_CLASSES.PARAGRAPH, "[data-id='").concat(paraIdFrom, "']:not(.tree-link)"));
  }

  if (allowedContentClass.includes(linkClassName)) {
    if (indexInPara !== undefined) {
      selectors.push(".".concat(linkClassName));
    } else {
      selectors.push(".".concat(linkClassName, "[data-link='").concat(idOriginal || id, "']"));
    }

    return selectors.join(" ");
  }

  return undefined;
};
var dispatchCustomEventReaderAction = function dispatchCustomEventReaderAction(action, value) {
  dispatchCustomEvent(CUSTOM_EVENT_TYPE_READER_ACTION, {
    action: action,
    value: value
  });
};
var getReaderAudioChapter = function getReaderAudioChapter(toc, chapterId) {
  if (!toc || !toc[0]) {
    return null;
  }

  var audioChapter = (0,_player__WEBPACK_IMPORTED_MODULE_3__/* .getAudioChapterByChapterId */ .jW)(toc, chapterId);

  if (!audioChapter && chapterId === toc[0].id) {
    return (0,_player__WEBPACK_IMPORTED_MODULE_3__/* .getFirstAvailableAudioChapter */ ._g)(toc);
  }

  return audioChapter;
};
var getPlayerBehaviorLabel = function getPlayerBehaviorLabel(settingValue) {
  if (settingValue === _constants__WEBPACK_IMPORTED_MODULE_0__/* .READER_PLAYER_BEHAVIOURS.ASK */ .bn.ASK) {
    return "ask";
  }

  if (settingValue === _constants__WEBPACK_IMPORTED_MODULE_0__/* .READER_PLAYER_BEHAVIOURS.HISTORY */ .bn.HISTORY) {
    return "fromHistory";
  }

  if (settingValue === _constants__WEBPACK_IMPORTED_MODULE_0__/* .READER_PLAYER_BEHAVIOURS.CURRENT_PARA */ .bn.CURRENT_PARA) {
    return "currentParagraph";
  }

  if (settingValue === _constants__WEBPACK_IMPORTED_MODULE_0__/* .READER_PLAYER_BEHAVIOURS.CONTINUE */ .bn.CONTINUE) {
    return "continuePlaying";
  }

  if (settingValue === _constants__WEBPACK_IMPORTED_MODULE_0__/* .READER_PLAYER_BEHAVIOURS.FIRST_AVAILABLE */ .bn.FIRST_AVAILABLE) {
    return "firstAvailable";
  }

  return "";
};
var dispatchWindowEventPlayAudioInReader = function dispatchWindowEventPlayAudioInReader() {
  window.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOM_EVENT_TYPE_READER_PLAY */ .XE));
};
var getReaderFontConfigById = function getReaderFontConfigById(fontId) {
  var font = fontId || IdReaderDefaultFont;
  var fontValue = fontOptions.find(function (item) {
    return item.id === font;
  });

  if (!fontValue) {
    fontValue = fontOptions[0];
  }

  return fontValue;
};
var getReaderFirstVisibleId = function getReaderFirstVisibleId(parent) {
  var checkElementEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var offsetTop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var firstVisibleDataId;
  (0,_dom__WEBPACK_IMPORTED_MODULE_1__/* .makeFnGetFirstVisible */ .Om)(parent, false, false, function (elemStart, wrapStart, elemEnd, wrapEnd, elem) {
    var wrapStartFinal = wrapStart + offsetTop;

    if (elemStart === elemEnd) {
      // h4 bible paras are height 0 - their content is cut off on our side, it's a requirement.
      // But elements are presented in the reader to scroll to the right place.
      return false;
    }

    if (elemStart >= wrapStartFinal || checkElementEnd && elemEnd > wrapStartFinal || (0,_shared_utils_number_number__WEBPACK_IMPORTED_MODULE_4__/* .isNumberBetweenEquals */ .S5)(wrapStartFinal, elemStart, elemEnd) && (0,_shared_utils_number_number__WEBPACK_IMPORTED_MODULE_4__/* .isNumberBetweenEquals */ .S5)(wrapEnd, elemStart, elemEnd)) {
      firstVisibleDataId = elem.getAttribute(_constants__WEBPACK_IMPORTED_MODULE_0__/* .DATA_ATTR_PARA_ID */ .vl);

      if (firstVisibleDataId) {
        return true;
      }
    }

    return false;
  });
  return firstVisibleDataId;
};
var makeLinkClassName = function makeLinkClassName(elLink) {
  if (elLink.classList) {
    if (elLink.classList.contains(CONTENT_CLASSES.EGW_LINK_BIBLE)) {
      return CONTENT_CLASSES.EGW_LINK_BIBLE;
    } else if (elLink.classList.contains(CONTENT_CLASSES.EGW_LINK_BOOK)) {
      return CONTENT_CLASSES.EGW_LINK_BOOK;
    } else if (elLink.classList.contains(CONTENT_CLASSES.EGW_LINK_EXTERNAL)) {
      return CONTENT_CLASSES.EGW_LINK_EXTERNAL;
    }
  }

  return "";
};

/***/ }),

/***/ 55082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gn": function() { return /* binding */ filterOptionsAdvSearchByTitleAndBookCode; },
/* harmony export */   "Uo": function() { return /* binding */ filterOptionsAdvSearchByTitle; },
/* harmony export */   "n4": function() { return /* binding */ getBiblePubnr; },
/* harmony export */   "rK": function() { return /* binding */ cutAreaFromExtras; }
/* harmony export */ });
/* unused harmony export filterOptionsAdvSearchWithBookCode */
/* harmony import */ var _array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21707);
/* harmony import */ var _shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5626);
/* harmony import */ var _shared_utils_content_content__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69051);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }




var filterOptionsAdvSearchByTitle = function filterOptionsAdvSearchByTitle(options, value) {
  return options.filter(function (item) {
    return item.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
  });
};
var filterOptionsAdvSearchWithBookCode = function filterOptionsAdvSearchWithBookCode(options, value) {
  return options.filter(function (item) {
    return item.code.toLowerCase().indexOf(value.toLowerCase()) !== -1;
  });
};
var filterOptionsAdvSearchByTitleAndBookCode = function filterOptionsAdvSearchByTitleAndBookCode(options, value) {
  var finalFilteredOptions = [].concat(_toConsumableArray(filterOptionsAdvSearchWithBookCode(options, value)), _toConsumableArray(filterOptionsAdvSearchByTitle(options, value)));
  var index = finalFilteredOptions.findIndex(function (item) {
    var _item$code;

    return (item === null || item === void 0 ? void 0 : (_item$code = item.code) === null || _item$code === void 0 ? void 0 : _item$code.toLowerCase()) === value.toLowerCase();
  });

  if (index !== -1 && index !== 0) {
    (0,_array__WEBPACK_IMPORTED_MODULE_0__/* .arraymove */ .yf)(finalFilteredOptions, index, 0);
  }

  return finalFilteredOptions;
};
var getBiblePubnr = function getBiblePubnr(baseBible) {
  if (!baseBible) {
    return parseInt(_shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_BIBLE.en */ .eW.en);
  }

  return (0,_shared_utils_content_content__WEBPACK_IMPORTED_MODULE_2__/* .getBookIdNumber */ .o8)(baseBible);
};
var cutAreaFromExtras = function cutAreaFromExtras(oldExtras) {
  var extras = _objectSpread({}, oldExtras);

  if ("collection" in extras) {
    delete extras["collection"];
  }

  if ("collections" in extras) {
    delete extras["collections"];
  }

  return extras;
};

/***/ }),

/***/ 27962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YO": function() { return /* binding */ APL_AUTHOR_FOLDERS; },
/* harmony export */   "_q": function() { return /* binding */ extrasArrayFields; }
/* harmony export */ });
/* unused harmony export APL_AUTHOR_FOLDER */
var extrasArrayFields = ["collections"];
var APL_AUTHOR_FOLDER = {
  pioneerAuthors: 16,
  recentAuthors: 19
};
var APL_AUTHOR_FOLDERS = Object.values(APL_AUTHOR_FOLDER);

/***/ }),

/***/ 80226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bo": function() { return /* binding */ advSearchTypes; },
/* harmony export */   "Bx": function() { return /* binding */ facetsKeysPhrase; },
/* harmony export */   "Db": function() { return /* binding */ facetsKeysSuggestion; },
/* harmony export */   "Fw": function() { return /* binding */ Periods; },
/* harmony export */   "J0": function() { return /* binding */ QueryTypeDefault; },
/* harmony export */   "KM": function() { return /* binding */ Order; },
/* harmony export */   "OL": function() { return /* binding */ DateRangeLifetime; },
/* harmony export */   "OS": function() { return /* binding */ QUERY_TYPE; },
/* harmony export */   "Pp": function() { return /* binding */ dateRangeSearchAll; },
/* harmony export */   "Q7": function() { return /* binding */ snippetOptions; },
/* harmony export */   "QL": function() { return /* binding */ SEARCH_TOTAL_MAX; },
/* harmony export */   "Sc": function() { return /* binding */ SearchType; },
/* harmony export */   "T$": function() { return /* binding */ facetsKeysBook; },
/* harmony export */   "TR": function() { return /* binding */ PeriodWithCustom; },
/* harmony export */   "UD": function() { return /* binding */ mapSearchTypeToNamesExtras; },
/* harmony export */   "VS": function() { return /* binding */ orderOptions; },
/* harmony export */   "X": function() { return /* binding */ isRestricted; },
/* harmony export */   "Xb": function() { return /* binding */ DictionarySearchTypeDefault; },
/* harmony export */   "ai": function() { return /* binding */ SearchTypes; },
/* harmony export */   "am": function() { return /* binding */ facetsKeysAI; },
/* harmony export */   "bz": function() { return /* binding */ SearchTypeDefault; },
/* harmony export */   "fU": function() { return /* binding */ SEARCH_SNIPPET_DEFAULT; },
/* harmony export */   "gb": function() { return /* binding */ dateRangeInitial; },
/* harmony export */   "h$": function() { return /* binding */ monthNamesInitial; },
/* harmony export */   "hN": function() { return /* binding */ yearCompilations; },
/* harmony export */   "iP": function() { return /* binding */ ViewTabResultsRightPanelDefault; },
/* harmony export */   "iQ": function() { return /* binding */ DictionarySearchTypeOptions; },
/* harmony export */   "ib": function() { return /* binding */ SearchListType; },
/* harmony export */   "kG": function() { return /* binding */ dictionaryNWANDFilterKey; },
/* harmony export */   "kV": function() { return /* binding */ dictionaryDefaultFilter; },
/* harmony export */   "ku": function() { return /* binding */ AdvSearchType; },
/* harmony export */   "ly": function() { return /* binding */ periodOptions; },
/* harmony export */   "mt": function() { return /* binding */ facetsKeysOmsk; },
/* harmony export */   "nR": function() { return /* binding */ limitOptions; },
/* harmony export */   "p2": function() { return /* binding */ PeriodDefault; },
/* harmony export */   "pH": function() { return /* binding */ Period; },
/* harmony export */   "pP": function() { return /* binding */ Snippet; },
/* harmony export */   "sX": function() { return /* binding */ FOLDERS_IDS_APL; },
/* harmony export */   "td": function() { return /* binding */ searchGroups; },
/* harmony export */   "tf": function() { return /* binding */ searchParamsAI; },
/* harmony export */   "u7": function() { return /* binding */ OrderDefault; },
/* harmony export */   "uB": function() { return /* binding */ dictionaryAllFilterKey; },
/* harmony export */   "uG": function() { return /* binding */ queryTypeOptions; },
/* harmony export */   "wM": function() { return /* binding */ orderOptionsExcludedLanding; }
/* harmony export */ });
/* unused harmony exports queryPhraseRegExp, DictionarySearchType, LOCAL_SEARCH_SNIPPET_DEFAULT, LocalOrderDefault, Collection, CollectionAllKey, Collections, CollectionDefault, CollectionName, collectionOptions, SearchItemType, ViewTabResultsRightPanel, escapeHtml */
var _mapSearchTypeToNames;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var queryPhraseRegExp = /^".*"$/;
var DateRangeLifetime = {
  start: 1845,
  end: 1917
};
var yearCompilations = 1918;
var Order = {
  wrel: "wrel",
  seq: "seq",
  rel: "rel",
  date: "date",
  minusDate: "-date"
};
var Snippet = {
  REF: "ref",
  SHORT: "short",
  LONG: "long",
  FULL: "full"
};
var QUERY_TYPE = {
  EXACT: "exact",
  PREFER_EXACT: "prefer_exact",
  STEMMED: "stemmed",
  EXCLUDE_EXACT: "exclude_exact"
};
var queryTypeOptions = [{
  key: QUERY_TYPE.PREFER_EXACT,
  label: "queryTypePreferExact"
}, {
  key: QUERY_TYPE.EXACT,
  label: "queryTypeExact"
}, {
  key: QUERY_TYPE.EXCLUDE_EXACT,
  label: "queryTypeStemmed"
} // { key: QUERY_TYPE.STEMMED, label: "queryTypeStemmed" },
// { key: QUERY_TYPE.EXCLUDE_EXACT, label: "excludeExact" },
];
var orderOptions = [{
  key: Order.wrel,
  label: "weightedrelevancy"
}, {
  key: Order.seq,
  label: "booksequence"
}, {
  key: Order.rel,
  label: "relevancy"
}, {
  key: Order.date,
  label: "earliestfirst"
}, {
  key: Order.minusDate,
  label: "latestfirst"
}];
var orderOptionsExcludedLanding = [Order.rel, Order.date, Order.minusDate];
var limitOptions = [{
  key: 10,
  label: "10"
}, {
  key: 25,
  label: "25"
}, {
  key: 50,
  label: "50"
}];
var snippetOptions = [{
  key: Snippet.REF,
  label: "reference"
}, {
  key: Snippet.SHORT,
  label: "short"
}, {
  key: Snippet.LONG,
  label: "long"
}, {
  key: Snippet.FULL,
  label: "paragraph"
}];
var searchGroups = {
  egwwritings: "egw",
  bible: "bible",
  apl: "apl",
  reference: "reference"
};
var Period = {
  both: "both",
  all: "all",
  lifetime: "lifetime",
  compilations: "compilations",
  myBible: "mybible",
  bible: "bible",
  // Seems very unnecessary.
  apl: "apl",
  dictionary: "dictionary"
}; // "custom" option is absent in the Textapp. There is no Tree menu which this period related to.

var PeriodWithCustom = _objectSpread(_objectSpread({}, Period), {}, {
  custom: "custom"
});
var Periods = Object.values(Period);
var DictionarySearchType = {
  TEXT: "false",
  HEADINGS: "true",
  HEADINGS_EXACT: "exact"
};
var DictionarySearchTypeOptions = [{
  id: DictionarySearchType.HEADINGS_EXACT,
  label: "searchExactHeadings"
}, {
  id: DictionarySearchType.HEADINGS,
  label: "searchHeadings"
}, {
  id: DictionarySearchType.TEXT,
  label: "searchText"
}];
var PeriodDefault = Period.both;
var SEARCH_SNIPPET_DEFAULT = Snippet.SHORT;
var LOCAL_SEARCH_SNIPPET_DEFAULT = Snippet.LONG;
var OrderDefault = Order.wrel;
var LocalOrderDefault = Order.rel;
var DictionarySearchTypeDefault = DictionarySearchType.HEADINGS_EXACT;
var QueryTypeDefault = QUERY_TYPE.PREFER_EXACT;
var Collection = {
  ALL: "all",
  EGW: "egwwritings",
  BIBLE: "bible",
  REFERENCE: "reference",
  APL: "apl"
};
var CollectionAllKey = Collection.ALL;
var Collections = Object.values(Collection);
var CollectionDefault = Collection.EGW;
var CollectionName = {
  EGW: "egwCollection",
  ALL: "allCollection",
  COMPILATIONS: "compilations",
  LIFETIME: "lifetime",
  APL: "adventistpioneerlibrary",
  MY_BIBLE: "myBible",
  DICTIONARY: "dictionary"
};
var collectionOptions = [{
  key: Collection.ALL,
  label: CollectionName.ALL
}, {
  key: Collection.EGW,
  label: CollectionName.EGW
}, {
  key: Collection.BIBLE,
  label: "bible"
}, {
  key: Collection.APL,
  label: CollectionName.APL
}, {
  key: Collection.REFERENCE,
  label: "reference"
}];
var periodOptions = [{
  key: Period.both,
  label: CollectionName.EGW
}, {
  key: Period.all,
  label: CollectionName.ALL
}, {
  key: Period.lifetime,
  label: CollectionName.LIFETIME
}, {
  key: Period.compilations,
  label: CollectionName.COMPILATIONS
}, {
  key: Period.apl,
  label: CollectionName.APL
}, {
  key: Period.myBible,
  label: CollectionName.MY_BIBLE
}, {
  key: Period.dictionary,
  label: CollectionName.DICTIONARY
}];
var SEARCH_TOTAL_MAX = 99999;
var FOLDERS_IDS_APL = [15];
var SearchItemType = {
  SHORTCUT: "shortcut",
  SUGGESTION: "suggestion",
  TRANSLATIONS: "translations",
  CORRECTION: "correction",
  SYNONYM: "synonym",
  RECENT: "recent",
  WORD: "word",
  AUTOCOMPLETE: "autocomplete",
  RECENT_MORE: "recent-more"
};
var dateRangeSearchAll = Period.both;
var dateRangeInitial = [{
  id: Period.lifetime,
  label: "lifetime"
}, {
  id: Period.compilations,
  label: "compilations"
}, {
  id: Period.both,
  label: "search_all"
}];
var monthNamesInitial = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
var AdvSearchType = {
  book: "book",
  periodicals: "periodicals",
  ltms: "ltms",
  topical: "topical",
  scripture: "scripture",
  apl: "apl",
  reference: "reference",
  bible: "bible",
  commentary: "commentary",
  dictionary: "dictionary"
};
var advSearchTypes = Object.values(AdvSearchType);
var SearchType = _objectSpread(_objectSpread({}, AdvSearchType), {}, {
  basic: "basic",
  bookCode: "pubnr",
  related: "related"
});
var SearchTypeDefault = SearchType.basic;
var SearchTypes = Object.values(SearchType);
var ViewTabResultsRightPanel = {
  answers: "answers",
  faq: "faq",
  related: "related",
  featured: "featured",
  text: "text",
  translations: "translations"
};
var ViewTabResultsRightPanelDefault = ViewTabResultsRightPanel.text;
var extrasCommon = ["type", "queryType", "order", "snippet", "period"];
var mapSearchTypeToNamesExtras = (_mapSearchTypeToNames = {}, _defineProperty(_mapSearchTypeToNames, SearchType.basic, [].concat(extrasCommon, ["pubnr", "bookCode", "dictionarySearchType"])), _defineProperty(_mapSearchTypeToNames, SearchType.related, [].concat(extrasCommon, ["section"])), _defineProperty(_mapSearchTypeToNames, SearchType.bookCode, extrasCommon), _defineProperty(_mapSearchTypeToNames, SearchType.dictionary, [].concat(extrasCommon, ["dictionarySearchType"])), _defineProperty(_mapSearchTypeToNames, SearchType.book, [].concat(extrasCommon, ["lang", "pubnr", "bookCode", "bookpage", "paragraph", "daterange", "collections"])), _defineProperty(_mapSearchTypeToNames, SearchType.periodicals, [].concat(extrasCommon, ["daterange", "start_year", "end_year", "pubnr", "bookCode", "paragraph", "year", "month", "day"])), _defineProperty(_mapSearchTypeToNames, SearchType.ltms, [].concat(extrasCommon, ["subtype", "number", "year", "place", "addressee", "start_year", "end_year"])), _defineProperty(_mapSearchTypeToNames, SearchType.topical, [].concat(extrasCommon, ["headings_only"])), _defineProperty(_mapSearchTypeToNames, SearchType.scripture, [].concat(extrasCommon, ["book", "chapter"])), _defineProperty(_mapSearchTypeToNames, SearchType.apl, [].concat(extrasCommon, ["subtype", "pubnr", "bookCode", "bookpage", "paragraph", "start_year", "end_year", "date", "folder" // author
])), _defineProperty(_mapSearchTypeToNames, SearchType.reference, [].concat(extrasCommon, ["collection", "pubnr", "bookCode", "bookpage", "paragraph"])), _defineProperty(_mapSearchTypeToNames, SearchType.bible, [].concat(extrasCommon, ["lang", "pubnr", "bookCode", "book", "chapter", "verse"])), _defineProperty(_mapSearchTypeToNames, SearchType.commentary, [].concat(extrasCommon, ["pubnr", "bookCode", "book", "chapter", "verse"])), _mapSearchTypeToNames);
var dictionaryAllFilterKey = "all";
var dictionaryNWANDFilterKey = 1843; // "Noah Webster’s 1828 Dictionary (NWAD)"

var dictionaryDefaultFilter = {
  key: dictionaryAllFilterKey,
  label: "All Dictionaries"
};
var isRestricted = function isRestricted(value, max) {
  return value > (max || SEARCH_TOTAL_MAX);
};
var SearchListType = {
  OMSK: "omsk_search",
  BOOK: "book_search",
  PHRASE: "phrase_search",
  SUGGESTION: "suggestion_search",
  DEFAULT: "default",
  ANSWER: "answer",
  FAQ: "faq",
  AI: "ai"
};
var facetsKeysOmsk = ["egw_search:003", "egw_dictionary:002"];
var facetsKeysBook = ["egw_search:002"];
var facetsKeysPhrase = ["egw_phrase:000"];
var facetsKeysSuggestion = ["egw_search:009"];
var facetsKeysAI = ["egw_ai"];
var searchParamsAI = {
  extras: {
    section: facetsKeysAI[0]
  }
};
var escapeHtml = function escapeHtml(html) {
  return html.replace(/</g, "&lt;").replace(/>/g, "&gt;");
};

/***/ }),

/***/ 15347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gb": function() { return /* binding */ setShortcutDataParamsToSearchParams; },
/* harmony export */   "Gv": function() { return /* binding */ getResultsCount; },
/* harmony export */   "IA": function() { return /* binding */ fixSearchPreferExact; },
/* harmony export */   "J0": function() { return /* binding */ isOrderOptionDisabledByPeriod; },
/* harmony export */   "Kc": function() { return /* binding */ _makeLangSort; },
/* harmony export */   "Kq": function() { return /* binding */ validateSearchQuery; },
/* harmony export */   "ML": function() { return /* binding */ isQueryOnlyText; },
/* harmony export */   "VJ": function() { return /* binding */ updateSearchPeriod; },
/* harmony export */   "XJ": function() { return /* binding */ getSearchTypeByPeriod; },
/* harmony export */   "Xm": function() { return /* binding */ handleSearchShortcut; },
/* harmony export */   "fg": function() { return /* binding */ isSettingPeriodValid; },
/* harmony export */   "kg": function() { return /* binding */ getSearchListType; },
/* harmony export */   "kn": function() { return /* binding */ getExtrasByUrl; },
/* harmony export */   "mg": function() { return /* binding */ getDateRangeFilterBook; }
/* harmony export */ });
/* unused harmony exports isCollectionValid, getTopics, getExtrasBySearchType, isBunchLoaded, getSearchShortcut, getFolderType, isQueryPhrase, isQueryQuestion */
/* harmony import */ var _number_number__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50150);
/* harmony import */ var _url_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59916);
/* harmony import */ var _search_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80226);
/* harmony import */ var _user_agent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74741);
/* harmony import */ var _array__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21707);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }







var isYearRangeLifetime = function isYearRangeLifetime(startYear, endYear) {
  return (0,_number_number__WEBPACK_IMPORTED_MODULE_4__/* .isNumberBetweenEquals */ .S5)(startYear, _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .DateRangeLifetime.start */ .OL.start, _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .DateRangeLifetime.end */ .OL.end) || (0,_number_number__WEBPACK_IMPORTED_MODULE_4__/* .isNumberBetweenEquals */ .S5)(endYear, _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .DateRangeLifetime.start */ .OL.start, _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .DateRangeLifetime.end */ .OL.end);
};

var isYearRangeCompilations = function isYearRangeCompilations(startYear) {
  var endYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startYear;
  return startYear >= _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .yearCompilations */ .hN || endYear >= _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .yearCompilations */ .hN;
};

var getDateRangeFilterBook = function getDateRangeFilterBook(books, dateRange) {
  if (dateRange !== _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .dateRangeSearchAll */ .Pp) {
    var checkFn;

    if (dateRange === _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .Period.lifetime */ .pH.lifetime) {
      checkFn = isYearRangeLifetime;
    } else if (dateRange === _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .Period.compilations */ .pH.compilations) {
      checkFn = isYearRangeCompilations;
    }

    if (checkFn) {
      return books.filter(function (book) {
        if (book.startYear || book.endYear) {
          return checkFn(book.startYear, book.endYear);
        }

        return checkFn(book.year);
      });
    }
  }

  return books;
};
var isSettingPeriodValid = function isSettingPeriodValid(v) {
  return _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .Periods.includes */ .Fw.includes(v);
};
var isCollectionValid = function isCollectionValid(collection) {
  return Collections.includes(collection) || CollectionAllKey === collection;
};
var getTopics = function getTopics(topics) {
  return Object.keys(topics).map(function (key) {
    return {
      topic: key,
      count: topics[key]
    };
  });
};
var getSearchTypeByPeriod = function getSearchTypeByPeriod(period, defaultType) {
  if (period === _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .Period.dictionary */ .pH.dictionary) {
    return _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .SearchType.dictionary */ .Sc.dictionary;
  }

  return defaultType || _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .SearchType.basic */ .Sc.basic;
};
var getExtrasBySearchType = function getExtrasBySearchType(type, paramsOrFnGetParam) {
  var fields = type && _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .SearchTypes.includes */ .ai.includes(type) ? _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .mapSearchTypeToNamesExtras */ .UD[type] : _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .mapSearchTypeToNamesExtras */ .UD[_search_constants__WEBPACK_IMPORTED_MODULE_1__/* .SearchType.basic */ .Sc.basic];
  var result = {};

  var _iterator = _createForOfIteratorHelper(fields),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var name = _step.value;
      var value = typeof paramsOrFnGetParam === "function" ? paramsOrFnGetParam(name) : paramsOrFnGetParam[name];

      if (value !== undefined) {
        result[name] = value;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
};
var getExtrasByUrl = function getExtrasByUrl(paramsUrl) {
  return getExtrasBySearchType((0,_url_url__WEBPACK_IMPORTED_MODULE_0__/* .getQueryByName */ .An)("type", paramsUrl), function (name) {
    return (0,_url_url__WEBPACK_IMPORTED_MODULE_0__/* .getQueryByName */ .An)(name, paramsUrl);
  });
};
var isBunchLoaded = function isBunchLoaded(items, total, offset, limit) {
  var indexItemStart = items.findIndex(function (item) {
    return item.index === offset;
  });

  if (indexItemStart === -1) {
    return false;
  }

  var indexItemLast = Math.min(indexItemStart + limit, total - 1);
  var itemLast = items[items.length - 1];

  if (itemLast && itemLast.index < indexItemLast) {
    return false;
  }

  var chunk = items.slice(indexItemStart, indexItemLast + 1);
  return chunk.length - 1 === limit && chunk.every(function (item, i) {
    return item.index === offset + i;
  });
};
var fixSearchPreferExact = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(fetchFn, offset, limit) {
    var check1, total, results, response1, req2Offset, req2Limit, response2, response2ResultsIndexUpdated, check2;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetchFn(_search_constants__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_TYPE.EXACT */ .OS.EXACT, 0, 1);

        case 2:
          check1 = _context.sent;
          total = check1.total;
          results = [];

          if (!(total > offset)) {
            _context.next = 10;
            break;
          }

          _context.next = 8;
          return fetchFn(_search_constants__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_TYPE.EXACT */ .OS.EXACT, offset, limit);

        case 8:
          response1 = _context.sent;
          results.push.apply(results, _toConsumableArray(response1.results));

        case 10:
          req2Offset = offset + results.length - total;
          req2Limit = limit - results.length;

          if (!(req2Limit > 0 && req2Offset < _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_TOTAL_MAX */ .QL && req2Offset > -1)) {
            _context.next = 21;
            break;
          }

          _context.next = 15;
          return fetchFn(_search_constants__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_TYPE.EXCLUDE_EXACT */ .OS.EXCLUDE_EXACT, req2Offset, req2Limit);

        case 15:
          response2 = _context.sent;
          response2ResultsIndexUpdated = response2.results.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              index: item.index + total
            });
          });
          total += response2.total;
          results.push.apply(results, _toConsumableArray(response2ResultsIndexUpdated));
          _context.next = 25;
          break;

        case 21:
          _context.next = 23;
          return fetchFn(_search_constants__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_TYPE.EXCLUDE_EXACT */ .OS.EXCLUDE_EXACT, 0, 1);

        case 23:
          check2 = _context.sent;
          total += check2.total;

        case 25:
          return _context.abrupt("return", {
            total: total,
            results: results
          });

        case 26:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function fixSearchPreferExact(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var getSearchShortcut = function getSearchShortcut(shortcuts, currentSearchLang, newLang, defLang, isLogin, libraryLanguages, query) {
  var shortCutData;
  var languageUpdated;

  if (shortcuts && shortcuts.length > 0) {
    var langShortcut;

    if (newLang) {
      langShortcut = shortcuts.find(function (item) {
        return newLang === item.lang && item.hits;
      }) || shortcuts.find(function (item) {
        return newLang === item.lang;
      });

      if (langShortcut) {
        languageUpdated = langShortcut.lang;
      }
    }

    if (!langShortcut) {
      langShortcut = shortcuts.find(function (item) {
        return defLang === item.lang;
      });

      if (langShortcut) {
        languageUpdated = defLang;
      } else {
        langShortcut = shortcuts.find(function (item) {
          return item.lang === currentSearchLang;
        });
      }
    } // get any lang from ML of default lang


    if (!langShortcut && isLogin && libraryLanguages.length) {
      langShortcut = shortcuts.find(function (item) {
        return libraryLanguages.includes(item.lang);
      });
    } // get any shortcut with empty cutQuery for open a book by possible bookcode


    if (!langShortcut) {
      langShortcut = shortcuts.find(function (item) {
        return !item.cutQuery;
      });
    }

    if (langShortcut && query && query.includes("JTL") && langShortcut.book_code !== query) {
      // EGWW-4260
      langShortcut = shortcuts.find(function (item) {
        return item.book_code === query;
      });
    }

    shortCutData = langShortcut;
  }

  return {
    shortCutData: shortCutData,
    languageUpdated: languageUpdated
  };
};
var setShortcutDataParamsToSearchParams = function setShortcutDataParamsToSearchParams(searchParams, shortcutData, baseBible) {
  var isSetLanguage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var isPeriodCustomForSearchInPara = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  searchParams.query = shortcutData.cutQuery;
  searchParams.queryFull = shortcutData.query;

  if (isSetLanguage) {
    searchParams.langs = [shortcutData.lang];
  }

  if (shortcutData.paraId) {
    searchParams.chapters = [shortcutData.paraId];
  } else {
    searchParams.books = [shortcutData.bookId];
  }

  if (!searchParams.extras) {
    searchParams.extras = {};
  }

  if (shortcutData.bookId === baseBible) {
    searchParams.extras.period = _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .Period.myBible */ .pH.myBible;
  } else {
    // For next app "all" so far.
    searchParams.extras.period = isPeriodCustomForSearchInPara ? _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .PeriodWithCustom.custom */ .TR.custom : _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .Period.all */ .pH.all;
  }

  return searchParams;
};
var getFolderType = function getFolderType(list) {
  var fieldCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "className";
  var realType = "";
  list.forEach(function (item) {
    var itemType = item[fieldCheck];

    if (itemType && Collections.includes(itemType)) {
      realType = itemType;
    }
  });
  return realType;
};
var isQueryPhrase = function isQueryPhrase(query) {
  return queryPhraseRegExp.test(query.trim());
};
var isQueryQuestion = function isQueryQuestion(query) {
  return query.trim().indexOf("?") === query.trim().length - 1;
}; // Ignore a query that starts with book code "HOW"

var isQueryOnlyText = function isQueryOnlyText(query) {
  return query && (query.toLowerCase().indexOf("how") === 0 && query.length !== 3 || query.includes("*") || isQueryQuestion(query));
};
var handleSearchShortcut = function handleSearchShortcut(shortcut, _ref2) {
  var onShortcutBook = _ref2.onShortcutBook,
      onSearchInBookOrChapter = _ref2.onSearchInBookOrChapter,
      onShortcutPara = _ref2.onShortcutPara,
      onTextSearch = _ref2.onTextSearch;

  if (shortcut && shortcut.bookId && !(shortcut.shortCutType === "search" && shortcut.hits === 0 && shortcut.paraId)) {
    var shortCutType = shortcut.shortCutType,
        paraId = shortcut.paraId,
        hits = shortcut.hits;

    if (shortCutType === "search") {
      if (hits === 0) {
        // Opens a book
        onShortcutBook();
      } else {
        // Opens search results page for search word in book e.g. try "aa hope"
        onSearchInBookOrChapter();
      }
    } else if (paraId) {
      // Opens a para of a book
      onShortcutPara();
    }
  } else {
    // Simple text search
    if (onTextSearch) {
      onTextSearch();
    }
  }
};
var isOrderOptionDisabledByPeriod = function isOrderOptionDisabledByPeriod(itemId, period) {
  if (itemId === _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .Order.wrel */ .KM.wrel && (period === _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .PeriodWithCustom.myBible */ .TR.myBible || period === _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .PeriodWithCustom.apl */ .TR.apl)) {
    return true;
  }

  return itemId === _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .Order.rel */ .KM.rel && (period === _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .PeriodWithCustom.compilations */ .TR.compilations || period === _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .PeriodWithCustom.lifetime */ .TR.lifetime || period === _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .PeriodWithCustom.apl */ .TR.apl);
};
var updateSearchPeriod = function updateSearchPeriod(period) {
  var params = {
    period: period
  };

  if (period === _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .PeriodWithCustom.lifetime */ .TR.lifetime || period === _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .PeriodWithCustom.compilations */ .TR.compilations) {
    params.order = _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .Order.wrel */ .KM.wrel;
  }

  if (period === _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .PeriodWithCustom.myBible */ .TR.myBible || period === _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .PeriodWithCustom.apl */ .TR.apl) {
    params.order = _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .Order.seq */ .KM.seq;
  }

  return params;
};
function _makeLangSort(mainTreeLangs, libraryLanguages, languageUI, langList, langScoreMap) {
  // Firstly, sort by: {score | lang books count}
  var mapLangCodeToBookCount = {};
  mainTreeLangs.forEach(function (item) {
    mapLangCodeToBookCount[item.code] = item.book_count;
  });

  var sortedList = _toConsumableArray(langList);

  sortedList.sort(function (a, b) {
    if (langScoreMap && langScoreMap[a] && langScoreMap[b]) {
      if (langScoreMap[a] > langScoreMap[b]) {
        return -1;
      }

      if (langScoreMap[a] < langScoreMap[b]) {
        return 1;
      }
    }

    if (mapLangCodeToBookCount[a] && mapLangCodeToBookCount[b]) {
      if (mapLangCodeToBookCount[a] > mapLangCodeToBookCount[b]) {
        return -1;
      }

      if (mapLangCodeToBookCount[a] < mapLangCodeToBookCount[b]) {
        return 1;
      }
    }

    return 0;
  }); // =================
  // Then, sort by (order with priority):
  // {ML default lang}, {languageUI}, {ML rest langs}

  var libLangsFinal = libraryLanguages && libraryLanguages.length ? _toConsumableArray(libraryLanguages) : [(0,_user_agent__WEBPACK_IMPORTED_MODULE_2__/* .getLanguageDefault */ .hW)()];
  var libLangsSorted = libLangsFinal; // Sort non default languages of ML, base on score and UI language

  var libNonDefaultLangs = libLangsFinal.slice(1);

  if (libNonDefaultLangs.length > 1) {
    libNonDefaultLangs.sort(function (a, b) {
      if (langScoreMap) {
        if (langScoreMap[a] > langScoreMap[b]) {
          return -1;
        }

        if (langScoreMap[a] < langScoreMap[b]) {
          return 1;
        }
      }

      if (a === languageUI) {
        return -1;
      }

      if (b === languageUI) {
        return 1;
      }

      return 0;
    });
    libLangsSorted = [libLangsFinal[0]].concat(_toConsumableArray(libNonDefaultLangs));
  } // ===============================================================


  sortedList = (0,_array__WEBPACK_IMPORTED_MODULE_3__/* .sortByArray */ .lI)(sortedList, libLangsSorted); // =============================

  return sortedList;
}
var getResultsCount = function getResultsCount(count) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_TOTAL_MAX */ .QL;
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ",";

  if (max && (0,_search_constants__WEBPACK_IMPORTED_MODULE_1__/* .isRestricted */ .X)(count, max)) {
    return "".concat((0,_number_number__WEBPACK_IMPORTED_MODULE_4__/* .int3DigitFormat */ .gA)(max, separator), "+");
  }

  return (0,_number_number__WEBPACK_IMPORTED_MODULE_4__/* .int3DigitFormat */ .gA)(count, separator);
};
var QueryRegex = /[0-9A-Z_a-z]*/;
var validateSearchQuery = function validateSearchQuery(query) {
  if (!query) {
    return false;
  }

  return QueryRegex.test(query);
};
var getSearchListType = function getSearchListType(section) {
  if (section) {
    if (_search_constants__WEBPACK_IMPORTED_MODULE_1__/* .facetsKeysOmsk.includes */ .mt.includes(section)) {
      return _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .SearchListType.OMSK */ .ib.OMSK;
    } else if (_search_constants__WEBPACK_IMPORTED_MODULE_1__/* .facetsKeysPhrase.includes */ .Bx.includes(section)) {
      return _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .SearchListType.PHRASE */ .ib.PHRASE;
    } else if (_search_constants__WEBPACK_IMPORTED_MODULE_1__/* .facetsKeysBook.includes */ .T$.includes(section)) {
      return _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .SearchListType.BOOK */ .ib.BOOK;
    } else if (_search_constants__WEBPACK_IMPORTED_MODULE_1__/* .facetsKeysSuggestion.includes */ .Db.includes(section)) {
      return _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .SearchListType.SUGGESTION */ .ib.SUGGESTION;
    } else if (_search_constants__WEBPACK_IMPORTED_MODULE_1__/* .facetsKeysAI.includes */ .am.includes(section)) {
      return _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .SearchListType.AI */ .ib.AI;
    }
  }

  return _search_constants__WEBPACK_IMPORTED_MODULE_1__/* .SearchListType.DEFAULT */ .ib.DEFAULT;
};

/***/ }),

/***/ 48018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ makeOption; },
/* harmony export */   "_": function() { return /* binding */ getOptionKey; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// "id" is a back-compatibility.
// Bad:  { id:  "en", label: "English" }
// Good: { key: "en", label: "English" }
var getOptionKey = function getOptionKey(option) {
  var _option$key;

  return _typeof(option) === "object" && option !== null ? (_option$key = option.key) !== null && _option$key !== void 0 ? _option$key : option.id : option;
};
var makeOption = function makeOption(key, label, additionalProps) {
  return _objectSpread({
    key: key,
    label: label
  }, additionalProps);
};

/***/ }),

/***/ 20467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fy": function() { return /* binding */ SETTING; },
  "MU": function() { return /* binding */ SETTING_LOCATION; },
  "fO": function() { return /* binding */ SETTING_TYPE; }
});

// EXTERNAL MODULE: ../shared/utils/theme/theme.js + 1 modules
var theme = __webpack_require__(93752);
// EXTERNAL MODULE: ../shared/utils/user-agent.js
var user_agent = __webpack_require__(74741);
// EXTERNAL MODULE: ../shared/utils/multilang/constants.js
var constants = __webpack_require__(76439);
// EXTERNAL MODULE: ../shared/utils/viewmode.js
var viewmode = __webpack_require__(24064);
// EXTERNAL MODULE: ../shared/utils/reader/constants.js
var reader_constants = __webpack_require__(16484);
// EXTERNAL MODULE: ../shared/content/search.js
var search = __webpack_require__(71423);
// EXTERNAL MODULE: ../shared/utils/content/content.constants.js
var content_constants = __webpack_require__(5626);
// EXTERNAL MODULE: ../shared/utils/search/search.constants.js
var search_constants = __webpack_require__(80226);
// EXTERNAL MODULE: ../shared/constants.js
var shared_constants = __webpack_require__(75573);
;// CONCATENATED MODULE: ../shared/utils/workspace/constants.js
var _SAVE_WORKSPACE_BEHAV;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CUSTOM_EVENT_WS_SHOW_ON_LOGOUT = "showPopupSaveWSonLogOut";
var SAVE_WORKSPACE_BEHAVIOURS = {
  ASK: 1,
  SAVE: 2,
  CREATE_NEW: 3,
  DO_NOT_SAVE: 4
};
var SAVE_WORKSPACE_BEHAVIOURS_LABELS = (_SAVE_WORKSPACE_BEHAV = {}, _defineProperty(_SAVE_WORKSPACE_BEHAV, SAVE_WORKSPACE_BEHAVIOURS.ASK, "ask"), _defineProperty(_SAVE_WORKSPACE_BEHAV, SAVE_WORKSPACE_BEHAVIOURS.SAVE, "saveToCurrent"), _defineProperty(_SAVE_WORKSPACE_BEHAV, SAVE_WORKSPACE_BEHAVIOURS.CREATE_NEW, "createNew"), _defineProperty(_SAVE_WORKSPACE_BEHAV, SAVE_WORKSPACE_BEHAVIOURS.DO_NOT_SAVE, "doNotSave"), _SAVE_WORKSPACE_BEHAV);
;// CONCATENATED MODULE: ../shared/utils/settings/constants.js










var SETTING_LOCATION = {
  MAIN_APP: "MAIN_APP",
  NEXT_APP: "NEXT_APP"
};
var SETTING_TYPE = {
  string: "string",
  bool: "bool",
  number: "number",
  array: "array",
  object: "object"
}; // TODO:
//  Possible REFACTOR ways:
//  #1 way: add validation and default values as object to this constant,
//    so everything about settings will be in the single place
//    (but there for each app would be redundant data of other apps config)
//  #2 way: – {locations} should be removed, instead each app determined what settings it supports
//          – {default} values should be moved to {SHARED_DEFAULT_SETTINGS} object,
//            and each application should implement its {DEFAULT_SETTINGS} object,
//            that is inherited from the shared object.

var SETTING = {
  isDevMode: {
    // for show some features on demo servers after enable
    id: "isDevMode",
    default: false,
    type: SETTING_TYPE.bool,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  themeMode: {
    id: "themeMode",
    server: true,
    type: SETTING_TYPE.string,
    default: theme/* DefaultThemeId */.fy,
    saveOnLogout: true,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  textMode: {
    id: "textMode",
    type: SETTING_TYPE.bool,
    default: false,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  languageUI: {
    id: "languageUI",
    server: true,
    type: SETTING_TYPE.string,
    default: (0,user_agent/* getSystemLang */.aQ)(constants/* DEFAULT_LANGUAGE */.k$),
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  isGrid: {
    id: "isGrid",
    type: SETTING_TYPE.bool,
    default: true,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  isShowAZ: {
    id: "isShowAZ",
    type: SETTING_TYPE.bool,
    default: true,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  isShowRightPanel: {
    id: "isShowRightPanel",
    type: SETTING_TYPE.bool,
    default: false,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  zoom: {
    id: "zoom",
    server: true,
    type: SETTING_TYPE.number,
    default: 100,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  treeFontSize: {
    id: "treeFontSize",
    server: true,
    type: SETTING_TYPE.number,
    default: viewmode/* TreeFontSizeDefault */.gh,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  searchFontSize: {
    id: "searchFontSize",
    server: true,
    type: SETTING_TYPE.number,
    default: viewmode/* SearchFontSizeDefault */.XF,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  showSCEntriesInReader: {
    id: "showSCEntriesInReader",
    type: SETTING_TYPE.bool,
    default: true,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  lastActiveColor: {
    id: "lastActiveColor",
    server: true,
    type: SETTING_TYPE.string,
    default: undefined,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  editorTempEntry: {
    id: "editorTempEntry",
    server: true,
    type: SETTING_TYPE.object,
    default: {},
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  showTranslations: {
    id: "showTranslations",
    server: true,
    type: SETTING_TYPE.bool,
    default: true,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  showRefCodes: {
    id: "showRefCodes",
    server: true,
    type: SETTING_TYPE.bool,
    default: true,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  showHeaders: {
    id: "showHeaders",
    server: true,
    type: SETTING_TYPE.bool,
    default: false,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  showPageNumbers: {
    id: "showPageNumbers",
    server: true,
    type: SETTING_TYPE.bool,
    default: false,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  showPageBreaks: {
    id: "showPageBreaks",
    server: true,
    type: SETTING_TYPE.bool,
    default: false,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  syncReader: {
    id: "syncReader",
    type: SETTING_TYPE.bool,
    default: false,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  syncReaderAndSearch: {
    id: "syncReaderAndSearch",
    type: SETTING_TYPE.bool,
    default: true,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  syncPlayerAndReader: {
    id: "syncPlayerAndReader",
    type: SETTING_TYPE.bool,
    default: false,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  readerFontFamily: {
    id: "readerFontFamily",
    server: true,
    type: SETTING_TYPE.string,
    default: reader_constants/* IdReaderDefaultFont */.P6,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  readerFontSize: {
    id: "readerFontSize",
    server: true,
    type: SETTING_TYPE.number,
    default: theme/* ReaderFontSizes.default */.Rb["default"],
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  textAlign: {
    id: "textAlign",
    server: true,
    type: SETTING_TYPE.string,
    default: reader_constants/* DEF_READER_TEXT_ALIGN */.Kd,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  readerMinWidth: {
    id: "readerMinWidth",
    type: SETTING_TYPE.number,
    default: 300,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  layout: {
    id: "layout",
    type: SETTING_TYPE.string,
    default: "",
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  isShowFooter: {
    id: "isShowFooter",
    type: SETTING_TYPE.bool,
    default: true,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  isShowFooterContent: {
    id: "isShowFooterContent",
    type: SETTING_TYPE.bool,
    default: false,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  scrollToFooter: {
    id: "scrollToFooter",
    type: SETTING_TYPE.bool,
    default: false,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  viewMode: {
    id: "viewMode",
    type: SETTING_TYPE.string,
    default: viewmode/* VIEW_MODE.DESKTOP */.WF.DESKTOP,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  rightTab: {
    id: "rightTab",
    type: SETTING_TYPE.string,
    default: search/* SearchPanelTabs.RESULTS */.Ny.RESULTS,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  showRightPanel: {
    id: "showRightPanel",
    type: SETTING_TYPE.bool,
    default: false,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  isRightPanelPinned: {
    id: "isRightPanelPinned",
    type: SETTING_TYPE.bool,
    default: false,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  showLeftPanel: {
    id: "showLeftPanel",
    type: SETTING_TYPE.bool,
    default: false,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  isLeftPanelPinned: {
    id: "isLeftPanelPinned",
    type: SETTING_TYPE.bool,
    default: false,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  openLastBook: {
    id: "openLastBook",
    server: true,
    type: SETTING_TYPE.bool,
    default: false,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  libraryLanguages: {
    id: "libraryLanguages",
    type: SETTING_TYPE.array,
    default: [],
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  filterLibraryLanguages: {
    id: "filterLibraryLanguages",
    type: SETTING_TYPE.array,
    default: [],
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  sortByRecent: {
    id: "sortByRecent",
    server: true,
    type: SETTING_TYPE.bool,
    default: true,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  playerState: {
    id: "playerState",
    type: SETTING_TYPE.number,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  baseBible: {
    id: "baseBible",
    type: SETTING_TYPE.string,
    server: true,
    default: "b" + content_constants/* DEFAULT_BIBLE.en */.eW.en,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  jtlBaseBible: {
    id: "jtlBaseBible",
    type: SETTING_TYPE.string,
    server: true,
    default: "b1965",
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  timeZoneAuto: {
    id: "timeZoneAuto",
    server: true,
    type: SETTING_TYPE.bool,
    default: true,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  timeZone: {
    id: "timeZone",
    server: true,
    type: SETTING_TYPE.string,
    default: "America/New_York",
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  collectionFilter: {
    id: "collectionFilter",
    server: true,
    type: SETTING_TYPE.string,
    default: search_constants/* PeriodDefault */.p2,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  dictionaryFilter: {
    id: "dictionaryFilter",
    server: true,
    type: SETTING_TYPE.string,
    default: search_constants/* dictionaryNWANDFilterKey */.kG,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  deliveryTime: {
    id: "deliveryTime",
    type: SETTING_TYPE.string,
    default: "00:00:00",
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  searchLangDefault: {
    id: "searchLangDefault",
    server: true,
    type: SETTING_TYPE.string,
    default: (0,user_agent/* getSystemLang */.aQ)(constants/* DEFAULT_LANGUAGE */.k$),
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  searchSnippet: {
    id: "searchSnippet",
    server: true,
    type: SETTING_TYPE.string,
    default: search_constants/* Snippet.LONG */.pP.LONG,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  searchSort: {
    id: "searchSort",
    server: true,
    type: SETTING_TYPE.string,
    default: search_constants/* Order.wrel */.KM.wrel,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  searchQueryType: {
    id: "searchQueryType",
    server: true,
    type: SETTING_TYPE.string,
    default: search_constants/* QUERY_TYPE.PREFER_EXACT */.OS.PREFER_EXACT,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  viewTabResultsRightPanel: {
    id: "viewTabResultsRightPanel",
    server: false,
    type: SETTING_TYPE.string,
    default: search_constants/* ViewTabResultsRightPanelDefault */.iP,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  showBookshelf: {
    id: "showBookshelf",
    type: SETTING_TYPE.bool,
    default: true,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  lockedTabs: {
    id: "lockedTabs",
    type: SETTING_TYPE.array,
    default: [],
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  menuState: {
    id: "menuState",
    type: SETTING_TYPE.string,
    default: shared_constants/* MENU_STATE_COLLAPSE */._Q,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  hlListType: {
    id: "hlListType",
    type: SETTING_TYPE.string,
    default: "g_c",
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  scPanel: {
    id: "scPanel",
    type: SETTING_TYPE.string,
    default: "n",
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  libraryFirstOpen: {
    id: "libraryFirstOpen",
    type: SETTING_TYPE.bool,
    default: true,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  isWSConfirmFirstOpened: {
    id: "isWSConfirmFirstOpened",
    type: SETTING_TYPE.bool,
    default: true,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  paraChangePlayerBehaviour: {
    id: "paraChangePlayerBehaviour",
    server: true,
    type: SETTING_TYPE.number,
    default: reader_constants/* READER_PLAYER_BEHAVIOURS.ASK */.bn.ASK,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  bookChangePlayerBehaviour: {
    id: "bookChangePlayerBehaviour",
    server: true,
    type: SETTING_TYPE.number,
    default: reader_constants/* READER_PLAYER_BEHAVIOURS.ASK */.bn.ASK,
    locations: [SETTING_LOCATION.MAIN_APP, SETTING_LOCATION.NEXT_APP]
  },
  saveWSOnReaderCloseBehaviour: {
    id: "saveWSOnReaderCloseBehaviour",
    server: true,
    type: SETTING_TYPE.number,
    default: SAVE_WORKSPACE_BEHAVIOURS.ASK,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  toggleInLibraryBehaviour: {
    id: "toggleInLibraryBehaviour",
    server: true,
    type: SETTING_TYPE.number,
    default: shared_constants/* TOGGLE_IN_LIBRARY_BEHAVIOURS.ASK */.to.ASK,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  copyChecks: {
    id: "copyChecks",
    type: SETTING_TYPE.object,
    default: {
      refs: true,
      headers: false,
      pageBreaks: false,
      scElements: false,
      searchHighlights: false,
      embedUrlLink: false,
      footnote: false
    },
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  printChecks: {
    id: "printChecks",
    type: SETTING_TYPE.object,
    default: {
      refs: true,
      headers: false,
      pageBreaks: false,
      format: true,
      radio: "para"
    },
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  workspaces: {
    id: "workspaces",
    server: true,
    type: SETTING_TYPE.array,
    default: [],
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  activeWorkspace: {
    id: "activeWorkspace",
    server: true,
    type: SETTING_TYPE.string,
    default: "",
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  lastEditWorkspace: {
    id: "lastEditWorkspace",
    server: true,
    type: SETTING_TYPE.string,
    default: "",
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  treeMenuMode: {
    id: "treeMenuMode",
    type: SETTING_TYPE.string,
    default: shared_constants/* TreeMenuMode.FOLDERS */.xF.FOLDERS,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  showReadingHistory: {
    id: "showReadingHistory",
    type: SETTING_TYPE.bool,
    default: true,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  showListenHistory: {
    id: "showListenHistory",
    type: SETTING_TYPE.bool,
    default: true,
    locations: [SETTING_LOCATION.MAIN_APP]
  },
  geoIpData: {
    id: "geoIpData",
    saveOnLogout: true,
    locations: []
  },
  openLink: {
    id: "openLink",
    server: true,
    locations: [SETTING_LOCATION.MAIN_APP],
    default: reader_constants/* READER_OPEN_LINK_BEHAVIOUR.openInActiveSplit */.ao.openInActiveSplit,
    type: SETTING_TYPE.string
  }
};

/***/ }),

/***/ 19819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jp": function() { return /* binding */ storeSetting; },
/* harmony export */   "b9": function() { return /* binding */ _getStoredSettings; },
/* harmony export */   "t4": function() { return /* binding */ _validateSettings; },
/* harmony export */   "ty": function() { return /* binding */ _validateSetting; },
/* harmony export */   "xB": function() { return /* binding */ _getDefaultSettings; }
/* harmony export */ });
/* unused harmony export _getStoredSetting */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20467);
/* harmony import */ var _storage_storage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12202);
/* harmony import */ var _console__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65795);
/* harmony import */ var _validators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38175);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




 // use only to product an individual method for an app e.g. {validateSettingsMainApp}

var _validateSettings = function _validateSettings(settings, settingsValidators, settingsDefault, holderFixedSettings) {
  for (var id in settings) {
    _validateSetting(id, settings[id], settingsValidators, settingsDefault, holderFixedSettings);
  }
}; // use only to product an individual method for an app e.g. {validateSettingMainApp}

var _validateSetting = function _validateSetting(id, value, settingsValidators, settingsDefault, holderFixedSettings) {
  var settingObj = _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING */ .Fy[id];

  if (settingObj) {
    if (!(0,_validators__WEBPACK_IMPORTED_MODULE_3__/* .validateSettingType */ .VK)(settingObj.type, value) || settingsValidators[id] && !settingsValidators[id](value)) {
      var _ref;

      var valueDefault = (_ref = settingsDefault && settingsDefault[settingObj.id]) !== null && _ref !== void 0 ? _ref : settingObj.default; // Consider a setting valid, if its value equals the default value.

      var isValidFinal = value === valueDefault;

      if (!isValidFinal) {
        console.log("%cSetting is not valid", "background: yellow; color: black;", {
          settingObj: settingObj,
          settingValue: value,
          settingsValidators: settingsValidators,
          settingsDefault: settingsDefault,
          holderFixedSettings: holderFixedSettings
        });

        if (holderFixedSettings) {
          holderFixedSettings[id] = valueDefault;
        }
      }

      return isValidFinal;
    }

    return true;
  }

  return undefined;
}; // use only to product an individual method for an app e.g. {getStoredSettingMainApp}

var _getStoredSetting = function _getStoredSetting(id, valueDefault) {
  var setting = _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING */ .Fy[id];

  if (!setting) {
    return undefined;
  }

  var settingDefault = valueDefault !== null && valueDefault !== void 0 ? valueDefault : setting.default;
  var outValue;
  var storage = setting.session ? _storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .sessionStorageSafe */ .kh : _storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .localStorageSafe */ .NE;

  if (setting.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING_TYPE.number */ .fO.number) {
    var intValue = storage.getItem(setting.id);

    if (intValue !== undefined && intValue !== null) {
      outValue = parseInt(intValue, 10);
    } else if (settingDefault) {
      outValue = settingDefault;
    }
  } else if (setting.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING_TYPE.bool */ .fO.bool) {
    var value = storage.getItem(setting.id);
    outValue = settingDefault;

    if (value !== undefined && value !== null) {
      outValue = value === "1";
    }
  } else if (setting.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING_TYPE.string */ .fO.string || setting.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING_TYPE.array */ .fO.array || setting.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING_TYPE.object */ .fO.object) {
    outValue = setting.session ? (0,_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .getSessionStorageItem */ .St)(setting.id, settingDefault, setting.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING_TYPE.array */ .fO.array || setting.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING_TYPE.object */ .fO.object) : (0,_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .getLocalStorageItem */ .le)(setting.id, settingDefault, setting.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING_TYPE.array */ .fO.array || setting.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING_TYPE.object */ .fO.object);
  }

  return outValue;
}; // use only to product an individual method for an app e.g. {getStoredSettingsMainApp}

var _getStoredSettings = function _getStoredSettings(location, settingsDefault) {
  var settingsObj = {};
  Object.keys(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING */ .Fy).forEach(function (id) {
    if (_constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING */ .Fy[id].locations.includes(location)) {
      settingsObj[id] = _getStoredSetting(id, settingsDefault && settingsDefault[id]);
    }
  });
  return settingsObj;
}; // use only to product an individual method for an app e.g. {getDefaultSettingsMainApp}

var _getDefaultSettings = function _getDefaultSettings(location, settingsDefault) {
  return Object.entries(_constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING */ .Fy).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        id = _ref3[0],
        config = _ref3[1];

    if (config.locations.includes(location)) {
      var _ref4;

      acc[id] = (_ref4 = settingsDefault && settingsDefault[id]) !== null && _ref4 !== void 0 ? _ref4 : config.default;
    }

    return acc;
  }, {});
};
var storeSetting = function storeSetting(id, value) {
  var setting = _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING */ .Fy[id];

  if (setting) {
    var valueToStore = value;

    if (setting.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING_TYPE.bool */ .fO.bool) {
      valueToStore = value ? "1" : "0";
    }

    if (setting.session) {
      (0,_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .setSessionStorageItem */ .D9)(setting.id, valueToStore, setting.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING_TYPE.array */ .fO.array || setting.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING_TYPE.object */ .fO.object);
    } else {
      (0,_storage_storage__WEBPACK_IMPORTED_MODULE_1__/* .setLocalStorageItem */ .D$)(setting.id, valueToStore, setting.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING_TYPE.array */ .fO.array || setting.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SETTING_TYPE.object */ .fO.object);
    }

    return setting;
  }

  (0,_console__WEBPACK_IMPORTED_MODULE_2__/* .consoleLogWarning */ .b9)("Settings", "Setting not defined: ", id, setting);
  return undefined;
};

/***/ }),

/***/ 38175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VK": function() { return /* binding */ validateSettingType; },
/* harmony export */   "ik": function() { return /* binding */ SETTINGS_VALIDATORS; }
/* harmony export */ });
/* unused harmony exports validateSettingCollectionFilter, validateSettingIsExists */
/* harmony import */ var _search_search__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15347);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20467);
var _SETTINGS_VALIDATORS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var validateSettingCollectionFilter = _search_search__WEBPACK_IMPORTED_MODULE_0__/* .isSettingPeriodValid */ .fg;
var validateSettingIsExists = function validateSettingIsExists(v) {
  return !!v;
};
var validateSettingType = function validateSettingType(type, value) {
  return !(type === _constants__WEBPACK_IMPORTED_MODULE_1__/* .SETTING_TYPE.string */ .fO.string && typeof value !== "string" || type === _constants__WEBPACK_IMPORTED_MODULE_1__/* .SETTING_TYPE.number */ .fO.number && typeof value !== "number" || type === _constants__WEBPACK_IMPORTED_MODULE_1__/* .SETTING_TYPE.bool */ .fO.bool && typeof value !== "boolean" || type === _constants__WEBPACK_IMPORTED_MODULE_1__/* .SETTING_TYPE.array */ .fO.array && !Array.isArray(value));
};
var SETTINGS_VALIDATORS = (_SETTINGS_VALIDATORS = {}, _defineProperty(_SETTINGS_VALIDATORS, _constants__WEBPACK_IMPORTED_MODULE_1__/* .SETTING.collectionFilter.id */ .Fy.collectionFilter.id, validateSettingCollectionFilter), _defineProperty(_SETTINGS_VALIDATORS, _constants__WEBPACK_IMPORTED_MODULE_1__/* .SETTING.libraryLanguages.id */ .Fy.libraryLanguages.id, validateSettingIsExists), _SETTINGS_VALIDATORS);

/***/ }),

/***/ 79384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cn": function() { return /* binding */ CUSTOM_EVENT_CONTENT_LOGOUT; },
/* harmony export */   "LA": function() { return /* binding */ STORAGE_KEY_TOKEN; },
/* harmony export */   "SC": function() { return /* binding */ cookieConfig; },
/* harmony export */   "Sj": function() { return /* binding */ STORAGE_KEY_REFRESH_COUNT; },
/* harmony export */   "e8": function() { return /* binding */ _deprecated_STORAGE_KEY_REFRESH_TOKEN; },
/* harmony export */   "lC": function() { return /* binding */ CUSTOM_EVENT_STORAGE_QUOTA_EXCEEDED; },
/* harmony export */   "ns": function() { return /* binding */ STORAGE_KEY_CONTENT_CACHE_LAST_CHECK; },
/* harmony export */   "t0": function() { return /* binding */ CUSTOM_EVENT_APP_VERSION_DIFFERS; },
/* harmony export */   "vj": function() { return /* binding */ STORAGE_KEY_CONTENT_VERSION; },
/* harmony export */   "w_": function() { return /* binding */ CUSTOM_EVENT_CONTENT_VERSION_DIFFERS; }
/* harmony export */ });
var cookieConfig = {
  maxAge: 60 * 60 * 24 * 365,
  path: "/"
};
var STORAGE_KEY_TOKEN = "token"; // can be removed in a year after the next release, regarding this comment date.

var _deprecated_STORAGE_KEY_REFRESH_TOKEN = "refresh_token";
var STORAGE_KEY_REFRESH_COUNT = "refreshCount";
var STORAGE_KEY_CONTENT_CACHE_LAST_CHECK = "content_cache_last_check";
var STORAGE_KEY_CONTENT_VERSION = "content_version";
var CUSTOM_EVENT_APP_VERSION_DIFFERS = "appVersionDiffers";
var CUSTOM_EVENT_CONTENT_VERSION_DIFFERS = "contentVersionDiffers";
var CUSTOM_EVENT_CONTENT_LOGOUT = "logout";
var CUSTOM_EVENT_STORAGE_QUOTA_EXCEEDED = "storageQuotaExceeded";

/***/ }),

/***/ 12202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D$": function() { return /* binding */ setLocalStorageItem; },
/* harmony export */   "D9": function() { return /* binding */ setSessionStorageItem; },
/* harmony export */   "NE": function() { return /* binding */ localStorageSafe; },
/* harmony export */   "Nh": function() { return /* binding */ setStorageItem; },
/* harmony export */   "St": function() { return /* binding */ getSessionStorageItem; },
/* harmony export */   "d8": function() { return /* binding */ setCookie; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; },
/* harmony export */   "kT": function() { return /* binding */ deleteCookie; },
/* harmony export */   "kh": function() { return /* binding */ sessionStorageSafe; },
/* harmony export */   "le": function() { return /* binding */ getLocalStorageItem; },
/* harmony export */   "qn": function() { return /* binding */ getStorageItem; }
/* harmony export */ });
/* unused harmony exports _emulateStorage, _getSessionStorageSafe, _getLocalStorageSafe, estimate, clearStorage */
/* harmony import */ var _storage_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79384);
/* harmony import */ var _dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62330);
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

 // import { consoleLogError, consoleLogInfo } from "../console";


function getCookie(name, cookie, defaultValue) {
  if (!cookie) {
    return defaultValue;
  }

  var value = "; ".concat(cookie);
  var parts = value.split("; ".concat(name, "="));

  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }

  return defaultValue;
}
function setCookie(name, value) {
  var maxAge = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _storage_constants__WEBPACK_IMPORTED_MODULE_0__/* .cookieConfig.maxAge */ .SC.maxAge;
  var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _storage_constants__WEBPACK_IMPORTED_MODULE_0__/* .cookieConfig.path */ .SC.path;
  document.cookie = "".concat(name, "=").concat(value, ";path=").concat(path, ";max-age=").concat(maxAge);
}
function deleteCookie(name) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _storage_constants__WEBPACK_IMPORTED_MODULE_0__/* .cookieConfig.path */ .SC.path;

  if (true) {
    document.cookie = name + "=; Path=" + path + "; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
}
var _emulatedItems = [];
var _emulateStorage = {
  setItem: function setItem(name, value) {
    _emulatedItems[name] = value;
  },
  getItem: function getItem(name) {
    return _emulatedItems[name] || null;
  },
  removeItem: function removeItem(name) {
    delete _emulatedItems[name];
  },
  clear: function clear() {
    _emulatedItems.length = 0;
  }
}; // Fixes the crash of some Darryl's friend with an Ipad IOS 10.

var _getSessionStorageSafe = function _getSessionStorageSafe() {
  try {
    if (!navigator.cookieEnabled) {
      return _emulateStorage;
    }

    if ((typeof sessionStorage === "undefined" ? "undefined" : _typeof(sessionStorage)) === "object") {
      sessionStorage.setItem("sessionStorage", 1);
      sessionStorage.removeItem("sessionStorage");
    }

    return sessionStorage;
  } catch (error) {
    return _emulateStorage;
  }
}; // Fixes the crash of some Darryl's friend with an Ipad IOS 10.

var _getLocalStorageSafe = function _getLocalStorageSafe() {
  try {
    if (!navigator.cookieEnabled) {
      return _emulateStorage;
    }

    if ((typeof localStorage === "undefined" ? "undefined" : _typeof(localStorage)) === "object") {
      localStorage.setItem("localStorage", 1);
      localStorage.removeItem("localStorage");
    }

    return localStorage;
  } catch (error) {
    return _emulateStorage;
  }
};
var localStorageSafe = _getLocalStorageSafe();
var sessionStorageSafe = _getSessionStorageSafe();
var estimate;
{
  var formatByteSize = function formatByteSize(bytes) {
    if (bytes < 1024) return bytes + " bytes";else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + " KiB";else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + " MiB";else return (bytes / 1073741824).toFixed(3) + " GiB";
  };

  var _getJSONSizeInBytes = function _getJSONSizeInBytes(obj) {
    var bytes = 0;

    function sizeOf(obj) {
      if (obj !== null && obj !== undefined) {
        switch (_typeof(obj)) {
          case 'number':
            bytes += 8;
            break;

          case 'string':
            bytes += obj.length * 2;
            break;

          case 'boolean':
            bytes += 4;
            break;

          case 'object':
            var objClass = Object.prototype.toString.call(obj).slice(8, -1);

            if (objClass === 'Object' || objClass === 'Array') {
              for (var key in obj) {
                if (!obj.hasOwnProperty(key)) continue;
                sizeOf(obj[key]);
              }
            } else bytes += obj.toString().length * 2;

            break;
        }
      }

      return bytes;
    }

    ;
    return sizeOf(obj);
  };

  var _getStorageSizeUsed = function _getStorageSizeUsed(storage) {
    var total = 0,
        size,
        key;

    for (key in storage) {
      if (storage.hasOwnProperty(key)) {
        // Each length is multiplied by 2 because
        // the char in javascript stores as UTF-16 (occupies 2 bytes)
        size = (storage[key].length + key.length) * 2;
        total += size;
      }
    }

    return total;
  };

  var _getStorageSizeAvailable = function _getStorageSizeAvailable(storage) {
    if (storage) {
      var i = 0;

      try {
        // Test up to 10 MB
        for (i = 250; i <= 100000; i += 250) {
          storage.setItem('test', new Array(i * 1024 + 1).join('a'));
        }
      } catch (e) {
        storage.removeItem('test');
        return (i - 250) * 1024;
      }
    }

    return null;
  };

  var _estimateStorageUsage = function _estimateStorageUsage(storageName, storage) {
    return {
      bytesUsed: formatByteSize(_getStorageSizeUsed(storage)),
      bytesAvailable: formatByteSize(_getStorageSizeAvailable(storage))
    };
  };

  var _estimateSWStorageUsage = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var estimation;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!('storage' in navigator && 'estimate' in navigator.storage)) {
              _context.next = 6;
              break;
            }

            _context.next = 4;
            return navigator.storage.estimate();

          case 4:
            estimation = _context.sent;
            return _context.abrupt("return", {
              bytesUsage: estimation.usage,
              bytesQuota: estimation.quota
            });

          case 6:
            _context.next = 10;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);

          case 10:
            return _context.abrupt("return", null);

          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function _estimateSWStorageUsage() {
      return _ref.apply(this, arguments);
    };
  }();

  var _estimateMemoryCacheSize = function _estimateMemoryCacheSize() {
    try {
      var MemoryCache = window.MemoryCacheHolder;
      return {
        bytesSize: _getJSONSizeInBytes(MemoryCache),
        length: Object.keys(MemoryCache).length
      };
    } catch (e) {// no-op
    }
  };

  var _estimateReduxSize = function _estimateReduxSize() {
    try {
      return {
        bytesSize: formatByteSize(_getJSONSizeInBytes(store.getState()))
      };
    } catch (e) {// no-op
    }
  };

  var _estimateLogSizes = function _estimateLogSizes() {
    var lengthSearch, lengthNetwork, lengthOther;

    try {
      var value = localStorage.getItem("logSearch");

      if (value) {
        lengthSearch = JSON.parse(value).length;
      }
    } catch (e) {// no-op
    }

    try {
      var _value = localStorage.getItem("logNetwork");

      if (_value) {
        lengthNetwork = JSON.parse(_value).length;
      }
    } catch (e) {// no-op
    }

    try {
      var _value2 = localStorage.getItem("logOther");

      if (_value2) {
        lengthOther = JSON.parse(_value2).length;
      }
    } catch (e) {// no-op
    }

    return {
      lengthSearch: lengthSearch,
      lengthNetwork: lengthNetwork,
      lengthOther: lengthOther
    };
  };

  var _estimateJSUse = function _estimateJSUse() {
    try {
      var out = {};

      for (var memoryKey in performance.memory) {
        out[memoryKey] = performance.memory[memoryKey];
      }

      return out;
    } catch (e) {
      // no-op
      return null;
    }
  };

  estimate = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = _estimateStorageUsage("localStorage", localStorage);
            _context2.t1 = _estimateStorageUsage("sessionStorage", sessionStorage);
            _context2.t2 = _estimateMemoryCacheSize();
            _context2.t3 = _estimateReduxSize();
            _context2.t4 = _estimateLogSizes();
            _context2.t5 = _estimateJSUse();
            _context2.next = 8;
            return _estimateSWStorageUsage();

          case 8:
            _context2.t6 = _context2.sent;
            return _context2.abrupt("return", {
              localStorage: _context2.t0,
              sessionStorage: _context2.t1,
              memoryCache: _context2.t2,
              redux: _context2.t3,
              logSizes: _context2.t4,
              jsUse: _context2.t5,
              serviceWorker: _context2.t6
            });

          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));

    return function estimate() {
      return _ref2.apply(this, arguments);
    };
  }();
}
var clearStorage = function clearStorage(storage, keysToIgnore) {
  Object.keys(storage).forEach(function (key) {
    var removeKey = !keysToIgnore || !keysToIgnore.includes(key);

    if (removeKey) {
      storage.removeItem(key);
    }
  });
};
var getStorageItem = function getStorageItem(storage, key, defValue) {
  var stringify = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var stored = storage.getItem(key);

  if (stored === undefined || stored === null) {
    return defValue;
  }

  if (!stringify) {
    return stored;
  }

  try {
    var parsed = JSON.parse(stored);
    return parsed ? JSON.parse(stored) : defValue;
  } catch (e) {
    return defValue;
  }
};
var setStorageItem = function setStorageItem(storage, key, value, stringify) {
  try {
    if (value) {
      storage.setItem(key, stringify ? JSON.stringify(value) : value);
    } else {
      storage.removeItem(key);
    }
  } catch (error) {
    if (error && error.code === error.QUOTA_EXCEEDED_ERR) {
      // consoleLogInfo("Storage Quota exceeded", "Caught error, dispatched window custom event!", {
      //   storage, key, value, stringify,
      // });
      (0,_dom__WEBPACK_IMPORTED_MODULE_1__/* .dispatchCustomEvent */ .hb)(_storage_constants__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOM_EVENT_STORAGE_QUOTA_EXCEEDED */ .lC, {
        storage: storage,
        cb: function cb() {
          setStorageItem(storage, key, value, stringify);
        }
      });
      return;
    } //
    // consoleLogError("Storage", "Set item - Unhandled ERROR: ", {
    //   error,
    //   storage, key, value, stringify,
    // });

  }
};
var getLocalStorageItem = function getLocalStorageItem(key, defValue, stringify) {
  return getStorageItem(localStorageSafe, key, defValue, stringify);
};
var setLocalStorageItem = function setLocalStorageItem(key, value, stringify) {
  return setStorageItem(localStorageSafe, key, value, stringify);
};
var getSessionStorageItem = function getSessionStorageItem(key, defValue, stringify) {
  return getStorageItem(sessionStorageSafe, key, defValue, stringify);
};
var setSessionStorageItem = function setSessionStorageItem(key, value, stringify) {
  return setStorageItem(sessionStorageSafe, key, value, stringify);
};

/***/ }),

/***/ 56332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XK": function() { return /* binding */ addQuotes; },
/* harmony export */   "hr": function() { return /* binding */ escapeRegExp; },
/* harmony export */   "s2": function() { return /* binding */ threeDotsIfLongerThan; }
/* harmony export */ });
/* unused harmony exports getWordsCount, getWordsFromString, getShorterString, addParentheses, formatTextExcerpt, clearSignsInString, capitalize */
/* harmony import */ var _console__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65795);

var getWordsCount = function getWordsCount(str) {
  if (!str) {
    return 0;
  }

  var match = str.match(/(\w+)/g);
  return match ? match.length : 0;
};
var getWordsFromString = function getWordsFromString(str) {
  if (!str) {
    return null;
  }

  return str.match(/\b(\w+)\b/g);
};
var getShorterString = function getShorterString(str1, str2) {
  if (str1 && str2) {
    return str1.length > str2.length ? str2 : str1;
  }

  return str1 || str2;
};
var addQuotes = function addQuotes(str) {
  return "\"" + str + "\"";
};
var addParentheses = function addParentheses(str) {
  return "(" + str + ")";
};
var escapeRegExp = function escapeRegExp(str) {
  return str.toString().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};
var threeDotsIfLongerThan = function threeDotsIfLongerThan(lengthMax, str) {
  if (typeof str === "string") {
    if (str.length > lengthMax) {
      return str.slice(0, lengthMax - 1) + "…";
    }

    return str;
  }

  return "";
};

var isLetterSeparatorSign = function isLetterSeparatorSign(letter) {
  if (typeof letter === "string") {
    return letter.match(/[,;\-–“"']/);
  }

  consoleLogError("isLetterSeparatorSign", "Invalid argument: ", {
    letter: letter
  });
  return "";
};

var isLetterInvalidAsSentenceBegin = function isLetterInvalidAsSentenceBegin(letter) {
  if (typeof letter === "string") {
    // consider any digit letter as no valid, because it's impossible
    // to determine whether this number is full.
    return letter.match(/[0-9]/) || letter !== letter.toUpperCase();
  }

  consoleLogError("isLetterInvalidAsSentenceBegin", "Invalid argument: ", {
    letter: letter
  });
  return "";
};

var isLetterInvalidAsSentenceEnd = function isLetterInvalidAsSentenceEnd(letter) {
  if (typeof letter === "string") {
    // consider any digit letter as no valid, because it's impossible
    // to determine whether this number is full.
    return letter.match(/[0-9]/) || !letter.match(/[.!?]/);
  }

  consoleLogError("isLetterInvalidAsSentenceEnd", "Invalid argument: ", {
    letter: letter
  });
  return "";
}; // Check a test file for better understanding.


var formatTextExcerpt = function formatTextExcerpt(str) {
  if (typeof str === "string") {
    var out = str.trim();

    if (out) {
      if (isLetterInvalidAsSentenceBegin(out[0])) {
        var indexLetterSpace = out.indexOf(" ");

        if (indexLetterSpace !== -1 && indexLetterSpace !== out.length - 1) {
          out = out.slice(indexLetterSpace + 1);
        }
      }

      if (out.length > 1 && isLetterSeparatorSign(out[0])) {
        out = out.slice(1);
      }

      if (isLetterInvalidAsSentenceEnd(out[out.length - 1])) {
        var lastIndexLetterSpace = out.lastIndexOf(" ");

        if (lastIndexLetterSpace !== -1 && lastIndexLetterSpace > 1) {
          out = out.slice(0, lastIndexLetterSpace);
        }
      }

      if (out.length > 1 && isLetterSeparatorSign(out[out.length - 1])) {
        out = out.slice(0, out.length - 1);
      }

      out = out.trim();

      if (isLetterInvalidAsSentenceBegin(out[0])) {
        out = "…" + out;
      }

      if (isLetterInvalidAsSentenceEnd(out[out.length - 1])) {
        out = out + "…";
      }
    }

    return out;
  }

  consoleLogError("formatTextExcerpt", "Invalid string argument: ", {
    str: str
  });
  return "";
};
var clearSignsInString = function clearSignsInString(str) {
  if (typeof str === "string") {
    return str.replace(/["\-–,;.!?*]/g, "");
  }

  consoleLogError("clearSignsInString", "Invalid string argument: ", {
    str: str
  });
  return "";
};
var capitalize = function capitalize(str, eachWord) {
  if (!str || typeof str !== "string") {
    return "";
  }

  if (eachWord) {
    return str.split(" ").map(capitalize).join(" ");
  }

  return str[0].toUpperCase() + str.slice(1);
};

/***/ }),

/***/ 37332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YF": function() { return /* binding */ SystemFolderIds; },
/* harmony export */   "Ys": function() { return /* binding */ STORAGE_KEY_LAST_SC_ACTIONS; }
/* harmony export */ });
/* unused harmony exports RootTopicId, RootTopicFolder, SubscriptionTopicId, SubscriptionTopicFolder, UnderlineColor, UserRoles */
var RootTopicId = "null";
var RootTopicFolder = {
  title: "studyCenter",
  titleEditor: "editorCenter",
  type: "folder",
  id: RootTopicId
};
var SubscriptionTopicId = "6d6f3cc9-4466-4542-8787-3a6d43c0a4bc";
var SubscriptionTopicFolder = {
  title: "favoriteSubscription",
  label: "favoriteSubscription",
  type: "folder",
  id: SubscriptionTopicId
};
var SystemFolderIds = [RootTopicFolder.id, SubscriptionTopicFolder.id];
var STORAGE_KEY_LAST_SC_ACTIONS = "lastScActions";
var UnderlineColor = "00000000-0000-0000-0000-000000000000";
var UserRoles = {
  studyCenterEditor: "StudyCenterEditor",
  StudyCenterEditorAdmin: "StudyCenterEditorAdmin"
};

/***/ }),

/***/ 8816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T1": function() { return /* binding */ cropHtmlContent; },
/* harmony export */   "qS": function() { return /* binding */ validateDate; },
/* harmony export */   "z": function() { return /* binding */ makeSubsReadUrl; }
/* harmony export */ });
/* unused harmony exports parseDate, getDate, createMoreIcon, countLetters, splitText, convertToString */
/* harmony import */ var _url_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59916);
/* harmony import */ var _shared_utils_viewmode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24064);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



var validateDate = function validateDate(date) {
  return date.getFullYear() + "-" + parseDate(date.getMonth() + 1) + "-" + parseDate(date.getDate());
};
var parseDate = function parseDate(num) {
  var norm = Math.floor(Math.abs(num));
  return (norm < 10 ? "0" : "") + norm;
};
var getDate = function getDate(date) {
  return date ? new Date(date) : new Date();
};
var makeSubsReadUrl = function makeSubsReadUrl(date, bookId) {
  var url = "".concat(_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.subscription */ .ns.subscription).concat(_url_url__WEBPACK_IMPORTED_MODULE_0__/* .URLS.read */ .ns.read, "/").concat(date, "/");

  if (bookId) {
    url += bookId;
  }

  return url;
};
var createMoreIcon = function createMoreIcon(content, text) {
  var re = /<\/[^>]+>$/g;
  var lastTag = content.match(re);

  if (!lastTag) {
    return "";
  }

  var moreIcon = "<span class=\"subs-arrow-container\">\n  <span class=\"subs-more-text\">".concat(text, "</span>\n  <i class=\"subs-more-icon icon-right\" ></i>  \n  </span>").concat(lastTag[0]);
  return content.replace(re, moreIcon);
};
var countLetters = function countLetters(text) {
  return text.replace(/(<([^>]+)>)/g, "").length;
};
var splitText = function splitText(text, maxLetters) {
  var cloned = text;
  var index = -1;

  while (cloned.length > maxLetters) {
    cloned = cloned.slice(0, index);
    index--;
  }

  return cloned;
};
var convertToString = function convertToString(elements) {
  var updatedContent = "";
  elements.forEach(function (el, index) {
    var lastIndex = elements.length - 1 === index;

    if (lastIndex) {
      updatedContent += "<".concat(el.tag, ">").concat(el.text += "... ", "</").concat(el.tag, ">");
    } else {
      updatedContent += el.html;
      updatedContent += "\n";
    }
  });
  return createMoreIcon(updatedContent, "More");
};
var cropHtmlContent = function cropHtmlContent(width, content) {
  var isMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var re = /<\w[^>]*>(.*?)<\/([^>]+)>$/;
  var ratio = isMobile ? (0,_shared_utils_viewmode__WEBPACK_IMPORTED_MODULE_1__/* .remToPx */ .cv)(0.65) : (0,_shared_utils_viewmode__WEBPACK_IMPORTED_MODULE_1__/* .remToPx */ .cv)(0.5); // ratio = one letter ~width

  var maxAmountOfLine = isMobile ? 4 : 6;
  var maxLettersInRow = Math.round(width / ratio);
  var elements = [];

  for (var i = 0, rowCount = 0; i < content.length; i++) {
    var found = content[i].match(re);

    if (rowCount < maxAmountOfLine) {
      if (found) {
        var _found2 = _slicedToArray(found, 3),
            html = _found2[0],
            text = _found2[1],
            tag = _found2[2];

        var amount = countLetters(text);

        if (amount <= maxLettersInRow) {
          rowCount++;
          elements.push({
            tag: tag,
            text: text,
            html: html
          });
        } else {
          var row = Math.ceil(amount / maxLettersInRow);
          var nextRowCount = row + rowCount;

          if (nextRowCount > maxAmountOfLine) {
            var restLines = maxAmountOfLine - rowCount;
            var maxLetters = maxLettersInRow * restLines;
            rowCount += restLines;
            elements.push({
              tag: tag,
              text: splitText(text, maxLetters),
              html: html
            });
          } else {
            rowCount += row;
            elements.push({
              tag: tag,
              text: text,
              html: html
            });
          }
        }
      }
    }
  }

  return convertToString(elements);
};

/***/ }),

/***/ 34855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dr": function() { return /* binding */ STORAGE_KEY_IS_USER_CANCELED_AUTO_DOWNLOADING; },
/* harmony export */   "QQ": function() { return /* binding */ NAMED_CACHE_NAMES; },
/* harmony export */   "RY": function() { return /* binding */ WINDOW_KEY_INSTALL_EVENT; },
/* harmony export */   "XQ": function() { return /* binding */ CUSTOM_EVENT_TYPE_STASH_INSTALL_PROMPT; },
/* harmony export */   "_P": function() { return /* binding */ SW_EVENTS_TYPES_TO; },
/* harmony export */   "jQ": function() { return /* binding */ ID_PROCESS_CACHE_URLS; },
/* harmony export */   "jy": function() { return /* binding */ NAMED_CACHE_NAME; },
/* harmony export */   "vK": function() { return /* binding */ SW_EVENTS_TYPES_FROM; },
/* harmony export */   "x": function() { return /* binding */ CUSTOM_EVENT_TYPE_NEW_PULLED_AUDIO_FILE_SRC; }
/* harmony export */ });
// FIXME: It's a crutch, because base64 strings are too large (e.g. 16 megabytes)!
//  Need to access the audio file directly, by using a custom endpoint,
//  that is intercepted in SW e.g. "/sw/named-cache/audioFile/[chapter_id]"
//  But it's not working with mp3 file for some reason. Need to investigate!
var CUSTOM_EVENT_TYPE_NEW_PULLED_AUDIO_FILE_SRC = "sw/pulled_audio_src_success"; // ================================================================================
// Is used to prompt user to install an app.

var WINDOW_KEY_INSTALL_EVENT = "installEvent";
var CUSTOM_EVENT_TYPE_STASH_INSTALL_PROMPT = "stashInstallEvent";
var STORAGE_KEY_IS_USER_CANCELED_AUTO_DOWNLOADING = "isUserCanceledPWADownload"; // If needed, create a unique constant for the process of "download website".

var ID_PROCESS_CACHE_URLS = "cache_urls";
var SW_EVENTS_TYPES_FROM = {
  UPDATE_NAMED_CACHE_KEYS_AVAILABLE: "updateNamedCacheKeysAvailable",
  GET_FROM_NAMED_CACHE_SUCCESS: "getFromNamedCacheSuccess",
  START_DOWNLOAD_URLS: "startDownloadUrls",
  CANCEL_DOWNLOAD_URLS: "cancelDownloadUrls",
  ERROR_DOWNLOAD_URLS: "errorDownloadUrls",
  END_DOWNLOAD_URLS: "endDownloadUrls",
  DOWNLOAD_URLS_PROGRESS: "downloadUrlsProgress",
  GET_INIT_DATA_SUCCESS: "getInitDataSuccess"
};
var SW_EVENTS_TYPES_TO = {
  CANCEL_PROCESS: "cancelProcess",
  CACHE_URLS: "cacheUrls",
  REMOVE_URLS: "removeUrls",
  GET_INIT_DATA: "getInitData",
  ADD_TO_CACHE: "addToNamedCache",
  REMOVE_FROM_CACHE: "removeFromNamedCache",
  GET_FROM_CACHE: "getFromNamedCache",
  CLEAR_NAMED_CACHES: "clearNamedCaches",
  CLEAR_WEBSITE_DATA: "clearWebsiteData"
};
var NAMED_CACHE_NAME = {
  BOOK_DATA: "bookData",
  WAVEFORM: "waveform",
  AUDIO_FILE: "audioFile",
  OFFLINE_HISTORY_READ: "offlineReadHistory",
  OFFLINE_HISTORY_LISTEN: "offlineListenHistory"
};
var NAMED_CACHE_NAMES = Object.values(NAMED_CACHE_NAME);

/***/ }),

/***/ 3359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sl": function() { return /* binding */ makeUrlsStaticForUsingAppOffline; },
  "Hm": function() { return /* binding */ postSWMessageCacheAudioFile; },
  "lW": function() { return /* binding */ postSWMessageCacheBook; },
  "vw": function() { return /* binding */ postSWMessageCacheOfflineHistoryListen; },
  "GW": function() { return /* binding */ postSWMessageCacheOfflineHistoryRead; },
  "cx": function() { return /* binding */ postSWMessageCacheUrls; },
  "ez": function() { return /* binding */ postSWMessageCacheWaveform; },
  "s5": function() { return /* binding */ postSWMessageCancelProcess; },
  "ZM": function() { return /* binding */ postSWMessageClearNamedCaches; },
  "iK": function() { return /* binding */ postSWMessageClearWebsiteData; },
  "aB": function() { return /* binding */ postSWMessageGetAudioFile; },
  "jD": function() { return /* binding */ postSWMessageGetBook; },
  "z3": function() { return /* binding */ postSWMessageGetInitData; },
  "Hw": function() { return /* binding */ postSWMessageGetOfflineHistoryListen; },
  "j4": function() { return /* binding */ postSWMessageGetOfflineHistoryRead; },
  "g": function() { return /* binding */ postSWMessageGetWaveform; },
  "fP": function() { return /* binding */ postSWMessageRemoveAudio; },
  "eJ": function() { return /* binding */ postSWMessageRemoveBook; },
  "bV": function() { return /* binding */ postSWMessageRemoveWaveform; },
  "$J": function() { return /* binding */ registerServiceWorker; },
  "Dm": function() { return /* binding */ unregisterServiceWorker; }
});

// UNUSED EXPORTS: postSWMessageAddToCache, postSWMessageGetFromCache, postSWMessageRemoveFromCache, postSWMessageRemoveOfflineHistoryListen, postSWMessageRemoveOfflineHistoryRead, postSWMessageRemoveUrls

// EXTERNAL MODULE: ../shared/utils/multilang/i18n.js
var i18n = __webpack_require__(54354);
// EXTERNAL MODULE: ../shared/utils/sw/sw.constants.js
var sw_constants = __webpack_require__(34855);
;// CONCATENATED MODULE: ../shared/styles/egwWeFontConfig.json
var egwWeFontConfig_namespaceObject = JSON.parse('{"v":"cf7f087e72a9e40c7d1fcbbc487d9f7e"}');
// EXTERNAL MODULE: ../shared/utils/url/url.js
var url = __webpack_require__(59916);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
;// CONCATENATED MODULE: ../shared/utils/sw/sw.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }






var registerServiceWorker = function registerServiceWorker(scriptURL, onSuccessRegistration, onError, onFinally) {
  if ("window" in __webpack_require__.g && "serviceWorker" in navigator) {
    navigator.serviceWorker.register(scriptURL).then(onSuccessRegistration, onError).finally(onFinally);
  }
};
var unregisterServiceWorker = function unregisterServiceWorker() {
  if ("window" in __webpack_require__.g && "serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      var _iterator = _createForOfIteratorHelper(registrations),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var registration = _step.value;
          registration.unregister();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
  }
};
var makeUrlsStaticForUsingAppOffline = function makeUrlsStaticForUsingAppOffline(localeLang, themes, namespaces, langMap) {
  var flagImages = Object.keys(langMap).map(function (code) {
    return (0,url/* makePublicUrl */.xo)((0,url/* makeLangImage */.aW)(code, true));
  });
  return ["/images/books/placeholders/base.png", "/images/books/placeholders/base-big.png", "/images/books/placeholders/apl.png", "/images/books/placeholders/apl-big.png", "/images/books/placeholders/bible.png", "/images/books/placeholders/bible-big.png", "/images/books/placeholders/reference.png", "/images/books/placeholders/reference-big.png", url/* flagPlaceholder */.HN].concat(_toConsumableArray(flagImages), ["/fonts/egw-web-font.ttf?" + egwWeFontConfig_namespaceObject.v, "/fonts/egw-web-font.css", // FIXME: Add full list of fonts used in REACT app Reader.
  //  May be, use constant {fontOptions} and {window.getComputedStyle} to detect file of the font.
  "/fonts/stylesheet.css", "/fonts/BebasNeueBold.ttf", "/fonts/BebasNeueRegular.ttf"], _toConsumableArray(themes.map(function (theme) {
    return "/styles/" + theme.id + ".css";
  })), _toConsumableArray(themes.map(function (theme) {
    return "/images/" + theme.gifLoader;
  })), _toConsumableArray(namespaces.map(function (ns) {
    return (0,i18n/* i18nLoadPath */.hz)(localeLang, ns);
  })));
};

var postSWMessage = function postSWMessage(type, data) {
  if (!__webpack_require__.g.window || !navigator.serviceWorker) {
    return;
  }

  navigator.serviceWorker.ready.then(function (registration) {
    if (registration.active) {
      registration.active.postMessage({
        type: type,
        data: data
      });
    }
  });
};

var postSWMessageCancelProcess = function postSWMessageCancelProcess(processId) {
  postSWMessage(sw_constants/* SW_EVENTS_TYPES_TO.CANCEL_PROCESS */._P.CANCEL_PROCESS, processId);
};
var postSWMessageCacheUrls = function postSWMessageCacheUrls(urls) {
  postSWMessage(sw_constants/* SW_EVENTS_TYPES_TO.CACHE_URLS */._P.CACHE_URLS, {
    processId: sw_constants/* ID_PROCESS_CACHE_URLS */.jQ,
    urls: urls
  });
};
var postSWMessageRemoveUrls = function postSWMessageRemoveUrls(urls) {
  postSWMessage(SW_EVENTS_TYPES_TO.REMOVE_URLS, urls);
};
var postSWMessageGetInitData = function postSWMessageGetInitData(urlsForOfflineUse) {
  postSWMessage(sw_constants/* SW_EVENTS_TYPES_TO.GET_INIT_DATA */._P.GET_INIT_DATA, urlsForOfflineUse);
};
var postSWMessageAddToCache = function postSWMessageAddToCache(cacheName, key, value) {
  postSWMessage(sw_constants/* SW_EVENTS_TYPES_TO.ADD_TO_CACHE */._P.ADD_TO_CACHE, {
    cacheName: cacheName,
    key: key,
    value: value
  });
};
var postSWMessageRemoveFromCache = function postSWMessageRemoveFromCache(cacheName, key) {
  postSWMessage(sw_constants/* SW_EVENTS_TYPES_TO.REMOVE_FROM_CACHE */._P.REMOVE_FROM_CACHE, {
    cacheName: cacheName,
    key: key
  });
};
var postSWMessageGetFromCache = function postSWMessageGetFromCache(cacheName, key) {
  postSWMessage(sw_constants/* SW_EVENTS_TYPES_TO.GET_FROM_CACHE */._P.GET_FROM_CACHE, {
    cacheName: cacheName,
    key: key
  });
};
var postSWMessageClearNamedCaches = function postSWMessageClearNamedCaches() {
  postSWMessage(sw_constants/* SW_EVENTS_TYPES_TO.CLEAR_NAMED_CACHES */._P.CLEAR_NAMED_CACHES);
};
var postSWMessageClearWebsiteData = function postSWMessageClearWebsiteData() {
  postSWMessage(sw_constants/* SW_EVENTS_TYPES_TO.CLEAR_WEBSITE_DATA */._P.CLEAR_WEBSITE_DATA);
}; // Derivatives methods, for easier code reading.

/* === Book === */

var postSWMessageCacheBook = function postSWMessageCacheBook(nBookId, bookData) {
  postSWMessageAddToCache(sw_constants/* NAMED_CACHE_NAME.BOOK_DATA */.jy.BOOK_DATA, nBookId, bookData);
};
var postSWMessageRemoveBook = function postSWMessageRemoveBook(bookIdNumber) {
  postSWMessageRemoveFromCache(sw_constants/* NAMED_CACHE_NAME.BOOK_DATA */.jy.BOOK_DATA, bookIdNumber);
};
var postSWMessageGetBook = function postSWMessageGetBook(bookIdNumber) {
  postSWMessageGetFromCache(sw_constants/* NAMED_CACHE_NAME.BOOK_DATA */.jy.BOOK_DATA, bookIdNumber);
};
/* === Audio file === */

var postSWMessageCacheAudioFile = function postSWMessageCacheAudioFile(chapterId, base64) {
  postSWMessageAddToCache(sw_constants/* NAMED_CACHE_NAME.AUDIO_FILE */.jy.AUDIO_FILE, chapterId, base64);
};
var postSWMessageRemoveAudio = function postSWMessageRemoveAudio(chapterId) {
  postSWMessageRemoveFromCache(sw_constants/* NAMED_CACHE_NAME.AUDIO_FILE */.jy.AUDIO_FILE, chapterId);
};
var postSWMessageGetAudioFile = function postSWMessageGetAudioFile(chapterId) {
  postSWMessageGetFromCache(sw_constants/* NAMED_CACHE_NAME.AUDIO_FILE */.jy.AUDIO_FILE, chapterId);
};
/* === Waveform ===== */

var postSWMessageCacheWaveform = function postSWMessageCacheWaveform(chapterId, data) {
  postSWMessageAddToCache(sw_constants/* NAMED_CACHE_NAME.WAVEFORM */.jy.WAVEFORM, chapterId, data);
};
var postSWMessageRemoveWaveform = function postSWMessageRemoveWaveform(chapterId) {
  postSWMessageRemoveFromCache(sw_constants/* NAMED_CACHE_NAME.WAVEFORM */.jy.WAVEFORM, chapterId);
};
var postSWMessageGetWaveform = function postSWMessageGetWaveform(chapterId) {
  postSWMessageGetFromCache(sw_constants/* NAMED_CACHE_NAME.WAVEFORM */.jy.WAVEFORM, chapterId);
};
/* === Offline history ===== */

var postSWMessageCacheOfflineHistoryRead = function postSWMessageCacheOfflineHistoryRead(chapterId, paraId, saveML, timestamp) {
  postSWMessageAddToCache(sw_constants/* NAMED_CACHE_NAME.OFFLINE_HISTORY_READ */.jy.OFFLINE_HISTORY_READ, (0,content/* getBookIdNumber */.o8)(chapterId), {
    chapterId: chapterId,
    paraId: paraId,
    saveML: saveML,
    timestamp: timestamp
  });
};
var postSWMessageCacheOfflineHistoryListen = function postSWMessageCacheOfflineHistoryListen(chapterId, position, saveML, timestamp) {
  postSWMessageAddToCache(sw_constants/* NAMED_CACHE_NAME.OFFLINE_HISTORY_LISTEN */.jy.OFFLINE_HISTORY_LISTEN, (0,content/* getBookIdNumber */.o8)(chapterId), {
    chapterId: chapterId,
    position: position,
    saveML: saveML,
    timestamp: timestamp
  });
};
var postSWMessageRemoveOfflineHistoryRead = function postSWMessageRemoveOfflineHistoryRead(bookId) {
  postSWMessageRemoveFromCache(NAMED_CACHE_NAME.OFFLINE_HISTORY_READ, bookId);
};
var postSWMessageRemoveOfflineHistoryListen = function postSWMessageRemoveOfflineHistoryListen(bookId) {
  postSWMessageRemoveFromCache(NAMED_CACHE_NAME.OFFLINE_HISTORY_LISTEN, bookId);
};
var postSWMessageGetOfflineHistoryRead = function postSWMessageGetOfflineHistoryRead(bookId) {
  postSWMessageGetFromCache(sw_constants/* NAMED_CACHE_NAME.OFFLINE_HISTORY_READ */.jy.OFFLINE_HISTORY_READ, bookId);
};
var postSWMessageGetOfflineHistoryListen = function postSWMessageGetOfflineHistoryListen(bookId) {
  postSWMessageGetFromCache(sw_constants/* NAMED_CACHE_NAME.OFFLINE_HISTORY_LISTEN */.jy.OFFLINE_HISTORY_LISTEN, bookId);
}; // ================================

/***/ }),

/***/ 52707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZL": function() { return /* binding */ clearLocalStorage; },
  "Xp": function() { return /* binding */ clearSessionStorage; },
  "Bt": function() { return /* binding */ deleteAllCookies; },
  "YW": function() { return /* binding */ getSessionToken; },
  "vp": function() { return /* binding */ getStableToken; },
  "lz": function() { return /* binding */ getTokens; },
  "d0": function() { return /* binding */ setTokens; }
});

// UNUSED EXPORTS: deleteCookie, getCookie, localStorageIgnoredKeys, localStorageIgnoredSubstrings

// EXTERNAL MODULE: ../node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(67921);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ../node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(13596);
// EXTERNAL MODULE: ../shared/utils/storage/storage.js
var storage = __webpack_require__(12202);
// EXTERNAL MODULE: ../shared/utils/storage/storage.constants.js
var storage_constants = __webpack_require__(79384);
// EXTERNAL MODULE: ../shared/utils/donate.js
var donate = __webpack_require__(21875);
// EXTERNAL MODULE: ../shared/utils/theme/theme.js + 1 modules
var theme = __webpack_require__(93752);
// EXTERNAL MODULE: ../shared/hooks/pwa/pwa.constants.js
var pwa_constants = __webpack_require__(40947);
// EXTERNAL MODULE: ../shared/utils/console.js
var console = __webpack_require__(65795);
// EXTERNAL MODULE: ../shared/utils/url/url.js
var url = __webpack_require__(59916);
// EXTERNAL MODULE: ../shared/utils/settings/constants.js + 1 modules
var constants = __webpack_require__(20467);
// EXTERNAL MODULE: ../shared/utils/studyCenter/constants.js
var studyCenter_constants = __webpack_require__(37332);
;// CONCATENATED MODULE: ../shared/utils/tutorials/constants.js
var TUTORIALS_LOCAL_STORAGE_KEY_PREFIX = "isHelpBtnWasShown";
;// CONCATENATED MODULE: ../shared/utils/systemUtils/systemUtils.js












var persistentKeysLS = [storage_constants/* STORAGE_KEY_CONTENT_CACHE_LAST_CHECK */.ns, storage_constants/* STORAGE_KEY_CONTENT_VERSION */.vj, pwa_constants/* STORAGE_KEY_IS_PWA_INSTALLED */.z];
var localStorageIgnoredSubstrings = [studyCenter_constants/* STORAGE_KEY_LAST_SC_ACTIONS */.Ys, TUTORIALS_LOCAL_STORAGE_KEY_PREFIX];
var localStorageIgnoredKeys = Object.values(constants/* SETTING */.Fy).filter(function (setting) {
  return setting.saveOnLogout;
}).map(function (setting) {
  return setting.id;
}); // Use this method to clear LS.
// By default, it preserves keys that don't need to be removed.

var clearLocalStorage = function clearLocalStorage(clearAllKeys) {
  Object.keys(storage/* localStorageSafe */.NE).forEach(function (key) {
    var removeKey = !persistentKeysLS.includes(key) && (clearAllKeys || !localStorageIgnoredSubstrings.some(function (substring) {
      return key.includes(substring);
    }) && !localStorageIgnoredKeys.includes(key));

    if (removeKey) {
      storage/* localStorageSafe.removeItem */.NE.removeItem(key);
    }
  });
};
var persistentKeysSS = [storage_constants/* STORAGE_KEY_REFRESH_COUNT */.Sj]; // Use this method to clear SS.
// By default, it preserves keys that don't need to be removed.

var clearSessionStorage = function clearSessionStorage(clearAllKeys) {
  Object.keys(storage/* sessionStorageSafe */.kh).forEach(function (key) {
    var removeKey = !persistentKeysSS.includes(key) && clearAllKeys;

    if (removeKey) {
      storage/* sessionStorageSafe.removeItem */.kh.removeItem(key);
    }
  });
};
var getCookie = function getCookie(name) {
  return js_cookie_default().get(name);
};
var deleteCookie = function deleteCookie(name) {
  return js_cookie_default().remove(name);
};
var ignoredCookies = [donate/* COOKIE_KEY_DONATE_NEXT_SHOW */.fV, donate/* COOKIE_KEY_DONATE_CLOSED_COUNT */.cI, theme/* COOKIE_KEY_THEME */.kh, storage_constants/* STORAGE_KEY_TOKEN */.LA, storage_constants/* _deprecated_STORAGE_KEY_REFRESH_TOKEN */.e8];
var deleteAllCookies = function deleteAllCookies() {
  Object.keys(js_cookie_default().get()).forEach(function (name) {
    if (!ignoredCookies.includes(name)) {
      deleteCookie(name);
    }
  });
};
var getTokens = function getTokens() {
  var accessToken, refreshToken, expiresTimestamp;
  var tokenCookie = getCookie(storage_constants/* STORAGE_KEY_TOKEN */.LA, document.cookie);

  if (tokenCookie) {
    try {
      var jsonTokenCookie = JSON.parse(tokenCookie);
      accessToken = jsonTokenCookie.accessToken;
      refreshToken = jsonTokenCookie.refreshToken;
      expiresTimestamp = jsonTokenCookie.expiresTimestamp;
    } catch (e) {
      (0,console/* consoleLogInfo */.jn)("getTokens", "Error parse token cookie: ", {
        tokenCookie: tokenCookie
      });
    }
  }

  if (!refreshToken) {
    var tokenLS = (0,storage/* getLocalStorageItem */.le)(storage_constants/* STORAGE_KEY_TOKEN */.LA, null, true);

    if (tokenLS) {
      accessToken = tokenLS.accessToken;
      refreshToken = tokenLS.refreshToken;
      expiresTimestamp = tokenLS.expiresTimestamp;
    }
  } // Back compatibility for production users, that are already authorized,
  // but the refresh token is saved the old way.


  if (!refreshToken) {
    refreshToken = getCookie(storage_constants/* _deprecated_STORAGE_KEY_REFRESH_TOKEN */.e8, document.cookie);
  } // ========================
  // Stable no-expire token.


  var serverToken = (0,url/* getServerToken */.fh)(); // ================================================

  return {
    accessToken: accessToken,
    expiresTimestamp: expiresTimestamp,
    refreshToken: refreshToken,
    serverToken: serverToken
  };
};
var setTokens = function setTokens(accessToken, refreshToken, expiresIn) {
  if (refreshToken) {
    var token = {
      refreshToken: refreshToken,
      accessToken: accessToken,
      expiresTimestamp: Date.now() + expiresIn * 1000
    };
    (0,storage/* setCookie */.d8)(storage_constants/* STORAGE_KEY_TOKEN */.LA, JSON.stringify(token)); // Save to the LS, for users, that has disallowed the cookies.

    (0,storage/* setLocalStorageItem */.D$)(storage_constants/* STORAGE_KEY_TOKEN */.LA, token, true);
  } else {
    deleteCookie(storage_constants/* STORAGE_KEY_TOKEN */.LA);
    deleteCookie(storage_constants/* _deprecated_STORAGE_KEY_REFRESH_TOKEN */.e8); // Save to the LS, for users, that has disallowed the cookies.

    (0,storage/* setLocalStorageItem */.D$)(storage_constants/* STORAGE_KEY_TOKEN */.LA, undefined);
  }
};
/**
 * return token for current session
 * @returns uuid
 */

var getSessionToken = function getSessionToken() {
  var token = storage/* sessionStorageSafe.getItem */.kh.getItem("session_token");

  if (!token) {
    token = (0,v4/* default */.Z)();
    storage/* sessionStorageSafe.setItem */.kh.setItem("session_token", token);
  }

  return token;
};
/**
 * return token for current browser
 * @returns uuid
 */

var getStableToken = function getStableToken() {
  var token = storage/* localStorageSafe.getItem */.NE.getItem("stable_token");

  if (!token) {
    token = (0,v4/* default */.Z)();
    (0,storage/* setLocalStorageItem */.D$)("stable_token", token);
  }

  return token;
};

/***/ }),

/***/ 93752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vj": function() { return /* binding */ COOKIE_KEY_FULLSCREEN; },
  "Es": function() { return /* binding */ COOKIE_KEY_READER_FONT_SIZE; },
  "wV": function() { return /* binding */ COOKIE_KEY_SEARCH_FONT_SIZE; },
  "kh": function() { return /* binding */ COOKIE_KEY_THEME; },
  "OS": function() { return /* binding */ DefaultFontSize; },
  "fy": function() { return /* binding */ DefaultThemeId; },
  "vr": function() { return /* binding */ MapIdThemeDarkToIdThemeLight; },
  "el": function() { return /* binding */ MapIdThemeLightToIdThemeDark; },
  "Rb": function() { return /* binding */ ReaderFontSizes; },
  "Q2": function() { return /* binding */ Theme; },
  "Op": function() { return /* binding */ ThemeLocations; },
  "b3": function() { return /* binding */ Themes; },
  "VK": function() { return /* binding */ activateTheme; },
  "XY": function() { return /* binding */ checkColorDark; },
  "xI": function() { return /* binding */ getIsAccessibilityTheme; },
  "gh": function() { return /* binding */ getTheme; },
  "$o": function() { return /* binding */ isDarkTheme; }
});

// UNUSED EXPORTS: COOKIE_KEY_VIEWMODE, TextappDefaultThemeId, checkColorLight, dispatchCustomEventNewThemeApplied, fillContrastColor, getContrastColor, getContrastTextColor, getElementCSSVariable, getRootCSSVariable, hexToRgb, isThemeValid

// EXTERNAL MODULE: ../shared/utils/dom.js
var dom = __webpack_require__(62330);
;// CONCATENATED MODULE: ../shared/utils/theme/constants.js
var CUSTOM_EVENT_NEW_THEME_APPLIED = "new-theme-applied";
;// CONCATENATED MODULE: ../shared/utils/theme/theme.js
var _MapIdThemeLightToIdT;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var packageJson = __webpack_require__(59798);

var DefaultFontSize = 18;
var COOKIE_KEY_THEME = "theme";
var COOKIE_KEY_VIEWMODE = "viewmode";
var COOKIE_KEY_FULLSCREEN = "fullScreen";
var COOKIE_KEY_READER_FONT_SIZE = "rfs";
var COOKIE_KEY_SEARCH_FONT_SIZE = "sfs";
var ThemeLocations = {
  MAIN_APP: "MAIN_APP",
  NEXT_APP: "NEXT_APP",
  LANDING_APP: "LANDING_APP"
};
var Theme = {
  dy: {
    id: "dy",
    label: "dayMode",
    gifLoader: "loader-dy.gif",
    location: [ThemeLocations.MAIN_APP, ThemeLocations.NEXT_APP]
  },
  dw: {
    id: "dw",
    label: "dawnMode",
    gifLoader: "loader-dw.gif",
    location: [ThemeLocations.MAIN_APP, ThemeLocations.NEXT_APP]
  },
  dk: {
    id: "dk",
    label: "duskMode",
    dark: true,
    gifLoader: "loader-dk.gif",
    location: [ThemeLocations.MAIN_APP, ThemeLocations.NEXT_APP]
  },
  dm: {
    id: "dm",
    label: "darkMode",
    dark: true,
    gifLoader: "loader-dm.gif",
    location: [ThemeLocations.MAIN_APP, ThemeLocations.NEXT_APP]
  },
  dg: {
    id: "dg",
    label: "darkGreen",
    dark: false,
    gifLoader: "loader-dy.gif",
    location: [ThemeLocations.LANDING_APP]
  },
  dgd: {
    id: "dgd",
    label: "darkGreenDarken",
    dark: true,
    gifLoader: "loader-dm.gif",
    location: [ThemeLocations.LANDING_APP]
  },
  ls: {
    id: "ls",
    label: "landingSDA",
    dark: false,
    gifLoader: "loader-dy.gif",
    location: [ThemeLocations.LANDING_APP]
  },
  adm: {
    id: "adm",
    label: "accessabilityDarkMode",
    dark: true,
    accessibility: true,
    gifLoader: "loader-adm.gif",
    location: [ThemeLocations.MAIN_APP, ThemeLocations.NEXT_APP]
  },
  ady: {
    id: "ady",
    label: "accessabilityDayMode",
    accessibility: true,
    gifLoader: "loader-dy.gif",
    location: [ThemeLocations.MAIN_APP, ThemeLocations.NEXT_APP]
  }
};
var MapIdThemeLightToIdThemeDark = (_MapIdThemeLightToIdT = {}, _defineProperty(_MapIdThemeLightToIdT, Theme.dy.id, Theme.dk.id), _defineProperty(_MapIdThemeLightToIdT, Theme.dw.id, Theme.dm.id), _defineProperty(_MapIdThemeLightToIdT, Theme.ady.id, Theme.adm.id), _defineProperty(_MapIdThemeLightToIdT, Theme.dg.id, Theme.dgd.id), _MapIdThemeLightToIdT);
var MapIdThemeDarkToIdThemeLight = {};

for (var key in MapIdThemeLightToIdThemeDark) {
  MapIdThemeDarkToIdThemeLight[MapIdThemeLightToIdThemeDark[key]] = key;
}

var Themes = Object.values(Theme);
var DefaultThemeId = Theme.dy.id;
var TextappDefaultThemeId = Theme.dw.id;
var hexToRgb = function hexToRgb(hex) {
  if (hex.slice(0, 1) === "#") {
    hex = hex.slice(1);
  }

  if (hex.length === 3) {
    hex = hex.split("").map(function (hex) {
      return hex + hex;
    }).join("");
  }

  var red = parseInt(hex.substr(0, 2), 16);
  var green = parseInt(hex.substr(2, 2), 16);
  var blue = parseInt(hex.substr(4, 2), 16);
  return [red, green, blue];
};
var getIsAccessibilityTheme = function getIsAccessibilityTheme(theme) {
  return Theme[theme] ? !!Theme[theme].accessibility : undefined;
};
var isDarkTheme = function isDarkTheme(theme) {
  return Theme[theme] && Theme[theme].dark;
};
var checkColorDark = function checkColorDark(hex) {
  var _hexToRgb = hexToRgb(hex),
      _hexToRgb2 = _slicedToArray(_hexToRgb, 3),
      red = _hexToRgb2[0],
      green = _hexToRgb2[1],
      blue = _hexToRgb2[2];

  return 1 - (0.299 * red + 0.587 * green + 0.114 * blue) / 255 > 0.5;
};
var isThemeValid = function isThemeValid(idTheme, location) {
  return Theme[idTheme] && Theme[idTheme].location.includes(location);
};
var ReaderFontSizes = {
  min: 8,
  max: 72,
  factor: 2,
  default: 20,
  blindDefault: 36
};
var getTheme = function getTheme(idTheme) {
  var theme = Theme[idTheme];

  if (theme) {
    return theme;
  }

  return Theme[DefaultThemeId];
};
var checkTimeout = 145;

var onLoadCSSLinkElement = function onLoadCSSLinkElement(link, callback) {
  var attempt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var cssLoaded = false;

  try {
    if (link.sheet && link.sheet.cssRules.length > 0) {
      cssLoaded = true;
    } else if (link.styleSheet && link.styleSheet.cssText.length > 0) {
      cssLoaded = true;
    } else if (link.innerHTML && link.innerHTML.length > 0) {
      cssLoaded = true;
    }
  } catch (ex) {// case for el being removed or some cross-browser issue.
  }

  if (cssLoaded) {
    callback();
  } else {
    if (attempt * checkTimeout / 1000 < 25) {
      // prevent unexpected cases when no load more than 25s
      setTimeout(function () {
        onLoadCSSLinkElement(link, callback, ++attempt);
      }, checkTimeout);
    }
  }
};

var classNameThemeLink = "theme-link"; // creates new <link> with theme css url, removes old one after the new is loaded.

var activateTheme = function activateTheme(themeMode) {
  // consoleLogInfo("Theme", "Activate: ", themeMode);
  var themeIdNew = getTheme(themeMode).id;
  var elementsThemeLink = document.querySelectorAll("." + classNameThemeLink);
  var themeLinkEl = document.createElement("link");
  themeLinkEl.rel = "stylesheet";
  themeLinkEl.className = classNameThemeLink;
  themeLinkEl.href = window.location.origin + "/styles/" + themeIdNew + ".css?v=" + packageJson.version;
  document.head.appendChild(themeLinkEl);
  onLoadCSSLinkElement(themeLinkEl, function () {
    elementsThemeLink.forEach(function (el) {
      if (el) {
        el.remove();
      }
    });
    dispatchCustomEventNewThemeApplied();
  });
};
var dispatchCustomEventNewThemeApplied = function dispatchCustomEventNewThemeApplied() {
  (0,dom/* dispatchCustomEvent */.hb)(CUSTOM_EVENT_NEW_THEME_APPLIED);
};
var getRootCSSVariable = function getRootCSSVariable(name) {
  return getComputedStyle(document.documentElement).getPropertyValue("--" + name);
};
var getElementCSSVariable = function getElementCSSVariable(element, name) {
  return element.style.getPropertyValue("--" + name);
};
var getContrastColor = function getContrastColor(color) {
  return checkColorDark(color) ? getRootCSSVariable("hl-light") : getRootCSSVariable("hl-dark");
};
var checkColorLight = function checkColorLight(hex) {
  var _hexToRgb3 = hexToRgb(hex),
      _hexToRgb4 = _slicedToArray(_hexToRgb3, 3),
      red = _hexToRgb4[0],
      green = _hexToRgb4[1],
      blue = _hexToRgb4[2];

  return red > 240 && green > 240 && blue > 240;
};
var fillContrastColor = function fillContrastColor(color) {
  var backgroundColor = getRootCSSVariable("tree-row-odd");
  var lightAndDark = color === "#000000" || checkColorLight(color);

  if (lightAndDark) {
    return getContrastColor(backgroundColor);
  }

  return color;
};
/**
 * Return contrast text color for hightlight
 * @param {String} hexcolor
 * @returns css variable for color
 */

var getContrastTextColor = function getContrastTextColor(hexcolor) {
  return checkColorDark(hexcolor) ? "var(--hl-light)" : "var(--hl-dark)";
};

/***/ }),

/***/ 82344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": function() { return /* binding */ msToTimeLabel; }
/* harmony export */ });
/* unused harmony exports addZero, convertToTime, formatServerTimeToTimeLabel, parseServerTime, createServerTime */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27693);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


var addZero = function addZero(number) {
  if (number < 10) {
    return "0" + number.toString();
  }

  return number;
};
var msToTimeLabel = function msToTimeLabel(ms, separator) {
  var seconds = ms / 1000;
  var minutes = ms / 1000 / 60;
  var s = seconds === 60 ? 0 : Math.floor(seconds > 60 ? seconds % 60 : seconds);
  var m = minutes === 60 ? 0 : Math.floor(minutes > 60 ? minutes % 60 : minutes);
  var h = Math.floor(ms / 1000 / 60 / 60);
  var out = separator ? addZero(s) : addZero(s) + "s";
  out = (separator ? addZero(m) + separator : addZero(m) + "m ") + out;

  if (h) {
    out = (separator ? addZero(h) + separator : addZero(h) + "h ") + out;
  }

  return out;
};
var convertToTime = function convertToTime(position) {
  return msToTimeLabel(position * 1000, ":");
};
var SERVER_TIME_SEPARATOR = ":";
var SERVER_TIME_FORMAT = "HH" + SERVER_TIME_SEPARATOR + "mm" + SERVER_TIME_SEPARATOR + "ss";
var CLIENT_HOUR_SEPARATOR = ":";
var CLIENT_MINUTE_SEPARATOR = " ";
var CLIENT_TIME_FORMAT = "h" + CLIENT_HOUR_SEPARATOR + "mm" + CLIENT_MINUTE_SEPARATOR + "A";
var formatServerTimeToTimeLabel = function formatServerTimeToTimeLabel(time) {
  if (time) {
    var _time$split3 = time.split(SERVER_TIME_SEPARATOR),
        _time$split4 = _slicedToArray(_time$split3, 3),
        hourIn24Format = _time$split4[0],
        minute = _time$split4[1],
        second = _time$split4[2];

    return dayjs().hour(hourIn24Format).minute(minute).second(second).format(CLIENT_TIME_FORMAT);
  }

  return dayjs(new Date()).format(CLIENT_TIME_FORMAT);
};
var parseServerTime = function parseServerTime(time) {
  var _formatServerTimeToTi = formatServerTimeToTimeLabel(time).split(CLIENT_HOUR_SEPARATOR),
      _formatServerTimeToTi2 = _slicedToArray(_formatServerTimeToTi, 2),
      hour12Format = _formatServerTimeToTi2[0],
      minuteAndPeriod = _formatServerTimeToTi2[1];

  var _minuteAndPeriod$spli = minuteAndPeriod.split(CLIENT_MINUTE_SEPARATOR),
      _minuteAndPeriod$spli2 = _slicedToArray(_minuteAndPeriod$spli, 2),
      minute = _minuteAndPeriod$spli2[0],
      period = _minuteAndPeriod$spli2[1];

  return [hour12Format, minute, period];
};
var createServerTime = function createServerTime() {
  var hourIn24Format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var minute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var second = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return dayjs(new Date(0, 0, 0)).hour(hourIn24Format).minute(minute).second(second).format(SERVER_TIME_FORMAT);
};

/***/ }),

/***/ 59916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$F": function() { return /* binding */ getSearchLogsToken; },
/* harmony export */   "An": function() { return /* binding */ getQueryByName; },
/* harmony export */   "Dt": function() { return /* binding */ getSubsAddUrl; },
/* harmony export */   "HN": function() { return /* binding */ flagPlaceholder; },
/* harmony export */   "IW": function() { return /* binding */ makeUrlImgAuthor; },
/* harmony export */   "Je": function() { return /* binding */ makeWaveformsJsonUrl; },
/* harmony export */   "Ow": function() { return /* binding */ getBookCover; },
/* harmony export */   "T8": function() { return /* binding */ getUrlImagesBooks; },
/* harmony export */   "U6": function() { return /* binding */ makeUrlImgBookASI; },
/* harmony export */   "UO": function() { return /* binding */ getBaseHost; },
/* harmony export */   "VP": function() { return /* binding */ getUrlImgStore; },
/* harmony export */   "Vd": function() { return /* binding */ isUrlHasHttpPart; },
/* harmony export */   "aQ": function() { return /* binding */ wrongCoverUrls; },
/* harmony export */   "aW": function() { return /* binding */ makeLangImage; },
/* harmony export */   "bV": function() { return /* binding */ placeHolderImage; },
/* harmony export */   "c7": function() { return /* binding */ makeResourceUrl; },
/* harmony export */   "cP": function() { return /* binding */ makeUrlImgBookSplash; },
/* harmony export */   "d$": function() { return /* binding */ getUrlImages; },
/* harmony export */   "fC": function() { return /* binding */ containsUrl; },
/* harmony export */   "fh": function() { return /* binding */ getServerToken; },
/* harmony export */   "gU": function() { return /* binding */ getCPanelUrl; },
/* harmony export */   "hV": function() { return /* binding */ getSearchLogsUrl; },
/* harmony export */   "i2": function() { return /* binding */ getClientId; },
/* harmony export */   "iQ": function() { return /* binding */ getSubsEditUrl; },
/* harmony export */   "j5": function() { return /* binding */ makeUrlImgAuthorSignature; },
/* harmony export */   "jE": function() { return /* binding */ getAPIUrl; },
/* harmony export */   "jL": function() { return /* binding */ makeUrlImgBookPaper; },
/* harmony export */   "nb": function() { return /* binding */ getTextAppHost; },
/* harmony export */   "ns": function() { return /* binding */ URLS; },
/* harmony export */   "oq": function() { return /* binding */ getMainAppHost; },
/* harmony export */   "q6": function() { return /* binding */ makeUrlImgASILogo; },
/* harmony export */   "sY": function() { return /* binding */ parseUrlHash; },
/* harmony export */   "t6": function() { return /* binding */ makeUrlImgBookReflection; },
/* harmony export */   "uO": function() { return /* binding */ makeUrlImgBookCover; },
/* harmony export */   "wk": function() { return /* binding */ EXTERNAL_URLS; },
/* harmony export */   "xo": function() { return /* binding */ makePublicUrl; }
/* harmony export */ });
/* unused harmony exports URL_ORIGIN_TEXT_APP, getNextAppHost, getControlPanelProfile, getBackupsUrl, placeHolderImageBig, folderPlaceholder, avatarPlaceholder, getPlaceholderImage, makeUrlImgBookCoverWithPlaceholder, getUrlImagesSignatures, getUrlImagesAuthors, getUrlImagesASIBooks, makePathBookImages, getUrlImgScreenshot, AMP_ROUTE, URLS_AMP, withURlProtocol */
/* harmony import */ var _assembly__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76732);
/* provided dependency */ var process = __webpack_require__(27061);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

//DEFINE WHERE IS APP HOSTED

var URL_ORIGIN_TEXT_APP = process.env.REACT_APP_BASE_TEXT || ""; //DEFINE WHAT API APPLICATION USES

var getAPIUrl = function getAPIUrl() {
  return (0,_assembly__WEBPACK_IMPORTED_MODULE_0__/* .getEvnVariable */ .AK)("REACT_APP_SERVER_URL", process.env.REACT_APP_SERVER_URL, "https://a.staging.egwwritings.org");
};
var getCPanelUrl = function getCPanelUrl() {
  return (0,_assembly__WEBPACK_IMPORTED_MODULE_0__/* .getEvnVariable */ .AK)("REACT_APP_CPANEL", process.env.REACT_APP_CPANEL);
};
var getBaseHost = function getBaseHost() {
  var envValue = (0,_assembly__WEBPACK_IMPORTED_MODULE_0__/* .getEvnVariable */ .AK)("REACT_APP_BASE_HOST", process.env.REACT_APP_BASE_HOST);

  if ("window" in __webpack_require__.g) {
    var actualLocationOrigin = window.location.origin; // Because Landing Websites have common env-variable {BASE_HOST}
    // (bvc it's single instance for all landings apps, that has common ENV file).
    // Thus base host should be picked from the location, to prevent CORS issues.

    if (!isLocalhost(actualLocationOrigin) && actualLocationOrigin !== envValue) {
      return actualLocationOrigin;
    }
  }

  return envValue;
};
var getServerToken = function getServerToken() {
  return (0,_assembly__WEBPACK_IMPORTED_MODULE_0__/* .getEvnVariable */ .AK)("REACT_APP_SERVER_TOKEN", process.env.REACT_APP_SERVER_TOKEN);
};
var getTextAppHost = function getTextAppHost() {
  return (0,_assembly__WEBPACK_IMPORTED_MODULE_0__/* .getEvnVariable */ .AK)("REACT_APP_TEXT_APP_HOST", process.env.REACT_APP_TEXT_APP_HOST);
};
var getNextAppHost = function getNextAppHost() {
  return getEvnVariable("REACT_APP_NEXT_APP_HOST", process.env.REACT_APP_NEXT_APP_HOST);
};
var getSearchLogsUrl = function getSearchLogsUrl() {
  return (0,_assembly__WEBPACK_IMPORTED_MODULE_0__/* .getEvnVariable */ .AK)("REACT_APP_SEARCH_LOGS_URL", process.env.REACT_APP_SEARCH_LOGS_URL);
};
var getSearchLogsToken = function getSearchLogsToken() {
  return (0,_assembly__WEBPACK_IMPORTED_MODULE_0__/* .getEvnVariable */ .AK)("REACT_APP_SEARCH_LOGS_TOKEN", process.env.REACT_APP_SEARCH_LOGS_TOKEN);
}; //FIXME workaround before CD/CI update

var nextDomain = "next.";
var textDomain = "text.";
var getMainAppHost = function getMainAppHost() {
  var realMainApp = (0,_assembly__WEBPACK_IMPORTED_MODULE_0__/* .getEvnVariable */ .AK)("REACT_APP_MAIN_APP_HOST", process.env.REACT_APP_MAIN_APP_HOST);
  var link = realMainApp || getBaseHost() || "";

  if (link.indexOf(nextDomain) !== -1) {
    link = link.split(nextDomain).join("");
  }

  if (link.indexOf(textDomain) !== -1) {
    link = link.split(textDomain).join("");
  }

  return link;
};
var getClientId = function getClientId() {
  return (0,_assembly__WEBPACK_IMPORTED_MODULE_0__/* .getEvnVariable */ .AK)("REACT_APP_CLIENT_ID_AUTHORIZED", process.env.REACT_APP_CLIENT_ID_AUTHORIZED);
};
var makeResourceUrl = function makeResourceUrl(url) {
  var resUrl = (0,_assembly__WEBPACK_IMPORTED_MODULE_0__/* .getEvnVariable */ .AK)("REACT_APP_RESOURCE_URL", process.env.REACT_APP_RESOURCE_URL, "https://media2.egwwritings.org");
  return resUrl + url;
};
var getControlPanelProfile = function getControlPanelProfile() {
  return getCPanelUrl() + "/accounts/profile";
};
var getSubsAddUrl = function getSubsAddUrl() {
  return getCPanelUrl() + "/subscriptions/add";
};
var getSubsEditUrl = function getSubsEditUrl() {
  return getCPanelUrl() + "/subscriptions";
};
var getBackupsUrl = function getBackupsUrl() {
  return getCPanelUrl() + "/studycenter/backups";
};
var EXTERNAL_URLS = {
  donate: "https://partner.egwwritings.org/",
  about: "https://whiteestate.org/about/egwbio/",
  oldVersion: "https://legacy.egwwritings.org/",
  oldMobile: "https://m.egwwritings.org",
  oldTextApp: "https://text.egwwritings.org",
  playPitcairn: "https://honor.ellenwhite.org/",
  subscription: getCPanelUrl() + "/accounts/login/?next=/accounts/subscription/",
  faq: "https://ellenwhite.org/faq",
  ellenWhite: "https://ellenwhite.org",
  whiteEstate: "https://whiteestate.org",
  adventistDigitalLibrary: "https://adventistdigitallibrary.org",
  adventistEncyclopedia: "https://encyclopedia.adventist.org/",
  adventistHeritage: "https://www.adventistheritage.org/",
  iosAPP: "https://apps.apple.com/us/app/egw-writings-2/id994076136",
  macOsPKGApp: "https://media4.egwwritings.org/macos/7.8/egw-writings.pkg",
  macOsStoreApp: "https://apps.apple.com/us/app/egw-writings/id1458108029",
  androidApp: "https://play.google.com/store/apps/details?id=com.whiteestate.egwwritings",
  windowsApp: "https://apps.microsoft.com/store/detail/egw-writings/9WZDNCRDBTJ0"
};
/**
 * add process.env.PUBLIC_URL to url.
 * @param {*} url
 */

var makePublicUrl = function makePublicUrl(url) {
  return (process.env.PUBLIC_URL || "") + url;
};
var placeHolderImage = makePublicUrl("/images/book-placeholder.png");
var placeHolderImageBig = makePublicUrl("/images/book-placeholder-big.png");
var folderPlaceholder = makePublicUrl("/images/folder.svg");
var flagPlaceholder = makePublicUrl("/images/no-flag.svg");
var avatarPlaceholder = makePublicUrl("/images/avatar.svg");
var categories = ["base", "bible", "apl", "reference"];
var getPlaceholderImage = function getPlaceholderImage(isBig) {
  var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "base";
  var validCategory = categories.includes(category) ? category : "base";
  var fileName = validCategory + "" + (isBig ? "-big" : "") + ".png";
  return makePublicUrl("/images/placeholder/" + fileName);
};
var makeUrlImgBookCoverWithPlaceholder = function makeUrlImgBookCoverWithPlaceholder(bookId, big, category) {
  if (bookId) {
    var coverLink = big ? "large" : "small"; // const def =
    //   "&default=" +
    //   encodeURIComponent(
    //     makeImgFeedsUrl(getPlaceholderImage(big, category)),
    //     // (big ? "/covers/book-placeholder-big.png" : "/covers/book-placeholder.png")
    //   );
    // return `${getAPIUrl()}/covers/${bookId}?type=${coverLink}${def}`;

    return "".concat(getAPIUrl(), "/covers/").concat(bookId, "?type=").concat(coverLink);
  } else if (category) {
    return getBaseHost() + "/" + getPlaceholderImage(big, category);
  }

  return big ? placeHolderImageBig : placeHolderImage;
};
var getUrlImages = function getUrlImages() {
  return makePublicUrl("/images");
};
var getUrlImagesSignatures = function getUrlImagesSignatures() {
  return getUrlImages() + "/signatures";
};
var getUrlImagesAuthors = function getUrlImagesAuthors() {
  return getUrlImages() + "/authors";
};
var getUrlImagesBooks = function getUrlImagesBooks() {
  return getUrlImages() + "/books";
};
var getUrlImagesASIBooks = function getUrlImagesASIBooks() {
  return getUrlImages() + "/asi";
};
var makeUrlImgAuthorSignature = function makeUrlImgAuthorSignature(author, isDarkTheme) {
  if (author) {
    var fileName = author.replace(/\s/g, "_") + (isDarkTheme ? "-dark" : "-light");
    return getUrlImagesSignatures() + "/" + fileName + ".png";
  }

  return undefined;
};
var makeUrlImgAuthor = function makeUrlImgAuthor(author) {
  return getUrlImagesAuthors() + "/" + author + ".png";
};
var makePathBookImages = function makePathBookImages(book, imagesSubFolder) {
  var pathToBookImages = getUrlImagesBooks() + "/" + book.lang + "/" + book.book_id + "/";

  if (imagesSubFolder) {
    return pathToBookImages + imagesSubFolder + "/";
  }

  return pathToBookImages;
};
var makeUrlImgBookPaper = function makeUrlImgBookPaper(book, imagesSubFolder) {
  return makePathBookImages(book, imagesSubFolder) + "paper.png";
};
var makeUrlImgBookCover = function makeUrlImgBookCover(book, imagesSubFolder) {
  return makePathBookImages(book, imagesSubFolder) + "cover.png";
};
var makeUrlImgBookReflection = function makeUrlImgBookReflection(book, imagesSubFolder) {
  return makePathBookImages(book, imagesSubFolder) + "reflection.png";
};
var makeUrlImgBookSplash = function makeUrlImgBookSplash(splashName) {
  return getUrlImagesBooks() + "/splashes/" + splashName + ".png";
};
var makeUrlImgBookASI = function makeUrlImgBookASI(book) {
  return getUrlImagesASIBooks() + "/" + book.book_id + ".png";
};
var makeUrlImgASILogo = function makeUrlImgASILogo() {
  return getUrlImagesASIBooks() + "/asi-logo.png";
};
/**
 * @param {"ios" | "android"} store
 * @returns {string}
 */

var getUrlImgStore = function getUrlImgStore(store) {
  return getUrlImages() + "/stores/" + store + ".png";
};
/**
 * @param {"androidTablet" | "SamsungS9" | "imac" | "iPad" | "iPhoneX"} name
 * @returns {string}
 */

var getUrlImgScreenshot = function getUrlImgScreenshot(name) {
  return getUrlImages() + "/screenshots/" + name + ".png";
};
var wrongCoverUrls = new Set();
var getBookCover = function getBookCover(book, isBig, withDefault) {
  var coverUrl;

  if (book) {
    var cover = isBig ? book.coverLarge : book.coverSmall;

    if (cover) {
      coverUrl = makeResourceUrl(cover);
    } else if (book.book_id) {
      coverUrl = makeUrlImgBookCoverWithPlaceholder(book.book_id, isBig, book.folder_color_group || book.realType);
    }
  }

  if (wrongCoverUrls.has(coverUrl)) {
    return withDefault ? isBig ? placeHolderImageBig : placeHolderImage : undefined;
  }

  return coverUrl;
};
var makeWaveformsJsonUrl = function makeWaveformsJsonUrl(mp3URL) {
  return makeResourceUrl(mp3URL.split("#")[0].replace(".mp3", ".json"));
}; //TODO make kebab-case for urls

var routeBibliography = "/bibliography";
var URLS = {
  home: "/",
  theme: "/getTheme",
  read: "/read",
  myLibrary: "/myLibrary",
  allCollection: "/allCollection",
  adventistBeliefs: "/allCollection/en/1340",
  categories: "/categories",
  titles: "/titles",
  login: "/login",
  logout: "/logout",
  studyCenter: "/studyCenter",
  editorCenter: "/editorCenter",
  thoughts: "/thoughts",
  subscription: "/subscription",
  subscriptionAdd: "/subscriptionAdd",
  subscriptionEdit: "/subscriptionEdit",
  audioBooks: "/audio",
  history: "/history",
  about: "/about",
  settings: "/settings",
  settingsLang: "/settings/lang",
  advSearch: "/advsearch",
  globalSearchResults: "/relatedsearch",
  historySearch: "/search-history",
  featuredSearch: "/featured-search",
  information: "/information",
  languages: "/languages",
  donate: "/donate",
  contactus: "/contactus",
  lessons: "/lessons",
  helpingGuides: "/helping-guides",
  moreAboutUs: "/about",
  book: "/book",
  pdf: "/pdf",
  epub: "/epub",
  aboutEW: "/aboutEW",
  textSearchResults: "/search",
  relatedSearchResults: "/related-search-results",
  answers: "/answers",
  faqSearch: "/faq-search",
  faqSearchReader: "/faq-search-reader",
  searchFilters: "/search-filters",
  // Textapp only.
  privacyPolicy: "/privacyPolicy",
  copirightNotice: "/legal-copyright-notice",
  userAgreement: "/userAgreement",
  offline: "/offline",
  dictionary: "/dictionary",
  themeMode: "/themeMode",
  faq: "/faq",
  patchNotes: "/patchNotes",
  staticShare: "/static-share",
  loading: "/loading",
  system: "/system",
  bibliography: routeBibliography,
  bibliographyEgw: routeBibliography + "/egw",
  bibliographyBible: routeBibliography + "/bible",
  workspaces: "/workspaces",
  helpTranslate: "/help-translate",
  oidcSignin: "/api/oidc/auth/cb",
  oidcSilentSignin: "/api/oidc/silent",
  oidcSignout: "/api/oidc/logout",
  legacyEbooks: "/ebooks",
  pwaStartURL: "/app"
};
var AMP_ROUTE = "/amp";
var URLS_AMP = {
  read: AMP_ROUTE + URLS.read
};
var getQueryByName = function getQueryByName(name, url, noDecode) {
  if (!url) {
    return undefined;
  }

  name = name.replace(/[[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);

  if (!results) {
    return undefined;
  }

  if (!results[2]) {
    return "";
  }

  var result = results[2].replace(/\+/g, " ");

  if (noDecode) {
    return result;
  }

  return decodeURIComponent(result);
};
var parseUrlHash = function parseUrlHash(url) {
  var indexHashStart = url.indexOf("#");
  var urlHash = indexHashStart === -1 ? url : url.slice(indexHashStart + 1);
  var arrParams = urlHash.split("&");
  var params = {};
  arrParams.map(function (p) {
    var _p$split = p.split("="),
        _p$split2 = _slicedToArray(_p$split, 2),
        name = _p$split2[0],
        value = _p$split2[1];

    params[name] = value;
  });
  return params;
};
var containsUrl = function containsUrl(str) {
  return str && str.indexOf("http") > -1;
};
var withURlProtocol = function withURlProtocol(url) {
  return containsUrl(url) ? url : "https://".concat(url);
};
var isUrlHasHttpPart = function isUrlHasHttpPart(url) {
  return !!url && url.slice(0, 4) === "http";
};

var isLocalhost = function isLocalhost(url) {
  return !!url && url.startsWith("http://localhost");
};

var makeLangImage = function makeLangImage(code) {
  var small = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var folder = small ? "flags" : "flags_big";
  return "/images/".concat(folder, "/").concat(code, ".png");
};

/***/ }),

/***/ 74741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mc": function() { return /* binding */ isOnLine; },
/* harmony export */   "_f": function() { return /* binding */ getCurrentLang; },
/* harmony export */   "aQ": function() { return /* binding */ getSystemLang; },
/* harmony export */   "hW": function() { return /* binding */ getLanguageDefault; }
/* harmony export */ });
/* harmony import */ var _multilang_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76439);

var getSystemLang = function getSystemLang(fallbackLang) {
  if (true) {
    var windowNavigator = window.navigator;
    var lang = windowNavigator.languages && windowNavigator.languages[0] || // Firefox
    windowNavigator.language || // All browsers
    fallbackLang; // Fallback language

    if (lang.indexOf("-") !== -1) {
      return lang.split("-")[0];
    }

    return lang;
  }

  return fallbackLang;
};
var isOnLine = function isOnLine() {
  if ("window" in __webpack_require__.g && __webpack_require__.g.window.navigator) {
    return __webpack_require__.g.window.navigator.onLine;
  }

  return undefined;
};
var getLanguageDefault = function getLanguageDefault() {
  var languages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _multilang_constants__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_LANGUAGE */ .k$;
  return languages.length ? languages[0] : getSystemLang(fallback);
};
var getCurrentLang = function getCurrentLang(i18n, language) {
  return language || i18n.language && i18n.language.split("-")[0] || _multilang_constants__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_LANGUAGE */ .k$;
};

/***/ }),

/***/ 24064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WF": function() { return /* binding */ VIEW_MODE; },
/* harmony export */   "XF": function() { return /* binding */ SearchFontSizeDefault; },
/* harmony export */   "cv": function() { return /* binding */ remToPx; },
/* harmony export */   "gh": function() { return /* binding */ TreeFontSizeDefault; },
/* harmony export */   "x8": function() { return /* binding */ emToPx; }
/* harmony export */ });
/* unused harmony export VIEW_MODE_CLASSNAME_PREFIX */
/* harmony import */ var _theme_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93752);

var VIEW_MODE_CLASSNAME_PREFIX = "mode-";
/**
 * @enum {string}
 */

var VIEW_MODE = {
  DESKTOP: VIEW_MODE_CLASSNAME_PREFIX + "desktop",
  DESKTOP2K: VIEW_MODE_CLASSNAME_PREFIX + "2k",
  DESKTOP4K: VIEW_MODE_CLASSNAME_PREFIX + "4k",
  MOBILE: VIEW_MODE_CLASSNAME_PREFIX + "mobile",
  TABLET: VIEW_MODE_CLASSNAME_PREFIX + "tablet",
  FULLSCREEN: VIEW_MODE_CLASSNAME_PREFIX + "fullscreen",
  TEXT_ONLY: VIEW_MODE_CLASSNAME_PREFIX + "text",
  BLIND: VIEW_MODE_CLASSNAME_PREFIX + "blind",
  DARK: VIEW_MODE_CLASSNAME_PREFIX + "dark",
  ZOOM: VIEW_MODE_CLASSNAME_PREFIX + "zoom"
};
var SearchFontSizeDefault = 16;
var TreeFontSizeDefault = 14;
var remToPx = function remToPx(remValue) {
  var fontSize = "window" in __webpack_require__.g ? window.getComputedStyle(document.body).fontSize : _theme_theme__WEBPACK_IMPORTED_MODULE_0__/* .DefaultFontSize */ .OS;
  return remValue * parseFloat(fontSize);
};
var emToPx = function emToPx(el, emValue) {
  var size;

  if (el) {
    var fontSize = "window" in __webpack_require__.g ? window.getComputedStyle(el).fontSize : _theme_theme__WEBPACK_IMPORTED_MODULE_0__/* .DefaultFontSize */ .OS;
    size = emValue * parseFloat(fontSize);
  }

  return size;
};

/***/ }),

/***/ 74672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "INPUT": function() { return /* binding */ INPUT; }
/* harmony export */ });
var INPUT = {
  keyboard: "keyboard"
};

/***/ }),

/***/ 53769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _this = void 0;

var _require = __webpack_require__(74672),
    INPUT = _require.INPUT;

module.exports = function () {
  var isKeyDownInputFormInput = undefined; // form input types

  var FORK_CHANGE_formInputs = ["button", "input", "select", "textarea"]; // checks conditions before updating new input

  var FORK_CHANGE_setInput = function FORK_CHANGE_setInput(event) {
    var eventKey = event.which;
    var value = inputMap[event.type];

    if (value === "pointer") {
      value = pointerType(event);
    }

    var ignoreMatch = !specificMap.length && ignoreMap.indexOf(eventKey) === -1;
    var specificMatch = specificMap.length && specificMap.indexOf(eventKey) !== -1;
    var shouldUpdate = value === INPUT.keyboard && eventKey && (ignoreMatch || specificMatch) || value === "mouse" || value === "touch"; // prevent touch detection from being overridden by event execution order

    if (validateTouch(value)) {
      shouldUpdate = false;
    }

    if (shouldUpdate && currentInput !== value) {
      currentInput = value;
      persistInput("input", currentInput);
      doUpdate("input");
    }

    if (shouldUpdate && currentIntent !== value) {
      // preserve intent for keyboard interaction with form fields
      var activeElem = document.activeElement;
      var notFormInput = activeElem && activeElem.nodeName && (FORK_CHANGE_formInputs.indexOf(activeElem.nodeName.toLowerCase()) === -1 || activeElem.type === "radio" || activeElem.type === "checkbox" || activeElem.nodeName.toLowerCase() === "button" && !checkClosest(activeElem, "form"));

      if (event.type === "keydown") {
        isKeyDownInputFormInput = !notFormInput;
      }

      if (isKeyDownInputFormInput && event.type === "keyup") {
        return;
      }

      if (notFormInput) {
        currentIntent = value;
        persistInput("intent", currentIntent);
        doUpdate("intent");
      }
    }
  };
  /*
   * bail out if there is no document or window
   * (i.e. in a node/non-DOM environment)
   *
   * Return a stubbed API instead
   */


  if (typeof document === "undefined" || false) {
    return {
      // always return "initial" because no interaction will ever be detected
      ask: function ask() {
        return "initial";
      },
      // always return null
      element: function element() {
        return null;
      },
      // no-op
      ignoreKeys: function ignoreKeys() {},
      // no-op
      specificKeys: function specificKeys() {},
      // no-op
      registerOnChange: function registerOnChange() {},
      // no-op
      unRegisterOnChange: function unRegisterOnChange() {}
    };
  }
  /*
   * variables
   */
  // cache document.documentElement


  var docElem = document.documentElement; // currently focused dom element

  var currentElement = null; // last used input type

  var currentInput = "initial"; // last used input intent

  var currentIntent = currentInput; // UNIX timestamp of current event

  var currentTimestamp = Date.now(); // check for a `data-whatpersist` attribute on either the `html` or `body` elements, defaults to `true`

  var shouldPersist = false; // empty array for holding callback functions

  var functionList = []; // list of modifier keys commonly used with the mouse and
  // can be safely ignored to prevent false keyboard detection

  var ignoreMap = [16, // shift
  17, // control
  18, // alt
  91, // Windows key / left Apple cmd
  93 // Windows menu / right Apple cmd
  ];
  var specificMap = []; // mapping of events to input types

  var inputMap = {
    keydown: INPUT.keyboard,
    keyup: INPUT.keyboard,
    mousedown: "mouse",
    mousemove: "mouse",
    MSPointerDown: "pointer",
    MSPointerMove: "pointer",
    pointerdown: "pointer",
    pointermove: "pointer",
    touchstart: "touch",
    touchend: "touch"
  }; // boolean: true if the page is being scrolled

  var isScrolling = false; // store current mouse position

  var mousePos = {
    x: null,
    y: null
  }; // map of IE 10 pointer events

  var pointerMap = {
    2: "touch",
    3: "touch",
    // treat pen like touch
    4: "mouse"
  }; // check support for passive event listeners

  var supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, "passive", {
      get: function get() {
        supportsPassive = true;
        return false;
      }
    });
    window.addEventListener("test", null, opts);
  } catch (e) {// fail silently
  }
  /*
   * set up
   */


  var setUp = function setUp() {
    // add correct mouse wheel event mapping to `inputMap`
    inputMap[detectWheel()] = "mouse";
    addListeners();
  };
  /*
   * events
   */


  var addListeners = function addListeners() {
    // `pointermove`, `MSPointerMove`, `mousemove` and mouse wheel event binding
    // can only demonstrate potential, but not actual, interaction
    // and are treated separately
    var options = supportsPassive ? {
      passive: true,
      capture: true
    } : true;
    document.addEventListener("DOMContentLoaded", setPersist, true); // pointer events (mouse, pen, touch)

    if (window.PointerEvent) {
      window.addEventListener("pointerdown", FORK_CHANGE_setInput, true);
      window.addEventListener("pointermove", setIntent, true);
    } else if (window.MSPointerEvent) {
      window.addEventListener("MSPointerDown", FORK_CHANGE_setInput, true);
      window.addEventListener("MSPointerMove", setIntent, true);
    } else {
      // mouse events
      window.addEventListener("mousedown", FORK_CHANGE_setInput, true);
      window.addEventListener("mousemove", setIntent, true); // touch events

      if ("ontouchstart" in window) {
        window.addEventListener("touchstart", FORK_CHANGE_setInput, options);
        window.addEventListener("touchend", FORK_CHANGE_setInput, true);
      }
    } // mouse wheel


    window.addEventListener(detectWheel(), setIntent, options); // keyboard events

    window.addEventListener("keydown", FORK_CHANGE_setInput, true);
    window.addEventListener("keyup", FORK_CHANGE_setInput, true); // focus events

    window.addEventListener("focusin", setElement, true);
    window.addEventListener("focusout", clearElement, true);
  }; // checks if input persistence should happen and
  // get saved state from session storage if true (defaults to `false`)


  var setPersist = function setPersist() {
    shouldPersist = !(docElem.getAttribute("data-whatpersist") === "false" || document.body.getAttribute("data-whatpersist") === "false");

    if (shouldPersist) {
      // check for session variables and use if available
      try {
        if (window.sessionStorage.getItem("what-input")) {
          currentInput = window.sessionStorage.getItem("what-input");
        }

        if (window.sessionStorage.getItem("what-intent")) {
          currentIntent = window.sessionStorage.getItem("what-intent");
        }
      } catch (e) {// fail silently
      }
    } // always run these so at least `initial` state is set


    doUpdate("input");
    doUpdate("intent");
  }; // updates the doc and `inputTypes` array with new input


  var doUpdate = function doUpdate(which) {
    docElem.setAttribute("data-what" + which, which === "input" ? currentInput : currentIntent);
    fireFunctions(which);
  }; // updates input intent for `mousemove` and `pointermove`


  var setIntent = function setIntent(event) {
    var value = inputMap[event.type];

    if (value === "pointer") {
      value = pointerType(event);
    } // test to see if `mousemove` happened relative to the screen to detect scrolling versus mousemove


    detectScrolling(event); // only execute if scrolling isn't happening

    if ((!isScrolling && !validateTouch(value) || isScrolling && event.type === "wheel" || event.type === "mousewheel" || event.type === "DOMMouseScroll") && currentIntent !== value) {
      currentIntent = value;
      persistInput("intent", currentIntent);
      doUpdate("intent");
    }
  };

  var setElement = function setElement(event) {
    if (!event.target.nodeName) {
      // If nodeName is undefined, clear the element
      // This can happen if click inside an <svg> element.
      clearElement();
      return;
    }

    currentElement = event.target.nodeName.toLowerCase();
    docElem.setAttribute("data-whatelement", currentElement);

    if (event.target.classList && event.target.classList.length) {
      docElem.setAttribute("data-whatclasses", event.target.classList.toString().replace(" ", ","));
    }
  };

  var clearElement = function clearElement() {
    currentElement = null;
    docElem.removeAttribute("data-whatelement");
    docElem.removeAttribute("data-whatclasses");
  };

  var persistInput = function persistInput(which, value) {
    if (shouldPersist) {
      try {
        window.sessionStorage.setItem("what-" + which, value);
      } catch (e) {// fail silently
      }
    }
  };
  /*
   * utilities
   */


  var pointerType = function pointerType(event) {
    if (typeof event.pointerType === "number") {
      return pointerMap[event.pointerType];
    } else {
      // treat pen like touch
      return event.pointerType === "pen" ? "touch" : event.pointerType;
    }
  }; // prevent touch detection from being overridden by event execution order


  var validateTouch = function validateTouch(value) {
    var timestamp = Date.now();
    var touchIsValid = value === "mouse" && currentInput === "touch" && timestamp - currentTimestamp < 200;
    currentTimestamp = timestamp;
    return touchIsValid;
  }; // detect version of mouse wheel event to use
  // via https://developer.mozilla.org/en-US/docs/Web/API/Element/wheel_event


  var detectWheel = function detectWheel() {
    var wheelType = null; // Modern browsers support "wheel"

    if ("onwheel" in document.createElement("div")) {
      wheelType = "wheel";
    } else {
      // Webkit and IE support at least "mousewheel"
      // or assume that remaining browsers are older Firefox
      wheelType = document.onmousewheel !== undefined ? "mousewheel" : "DOMMouseScroll";
    }

    return wheelType;
  }; // runs callback functions


  var fireFunctions = function fireFunctions(type) {
    for (var i = 0, len = functionList.length; i < len; i++) {
      if (functionList[i].type === type) {
        functionList[i].fn.call(_this, type === "input" ? currentInput : currentIntent);
      }
    }
  }; // finds matching element in an object


  var objPos = function objPos(match) {
    for (var i = 0, len = functionList.length; i < len; i++) {
      if (functionList[i].fn === match) {
        return i;
      }
    }

    return undefined;
  };

  var detectScrolling = function detectScrolling(event) {
    if (mousePos.x !== event.screenX || mousePos.y !== event.screenY) {
      isScrolling = false;
      mousePos.x = event.screenX;
      mousePos.y = event.screenY;
    } else {
      isScrolling = true;
    }
  }; // manual version of `closest()`


  var checkClosest = function checkClosest(elem, tag) {
    var ElementPrototype = window.Element.prototype;

    if (!ElementPrototype.matches) {
      ElementPrototype.matches = ElementPrototype.msMatchesSelector || ElementPrototype.webkitMatchesSelector;
    }

    if (!ElementPrototype.closest) {
      do {
        if (elem.matches(tag)) {
          return elem;
        }

        elem = elem.parentElement || elem.parentNode;
      } while (elem !== null && elem.nodeType === 1);

      return null;
    } else {
      return elem.closest(tag);
    }
  };
  /*
   * init
   */
  // don't start script unless browser cuts the mustard
  // (also passes if polyfills are used)


  if ("addEventListener" in window && Array.prototype.indexOf) {
    setUp();
  }
  /*
   * api
   */


  return {
    // returns string: the current input type
    // opt: 'intent'|'input'
    // 'input' (default): returns the same value as the `data-whatinput` attribute
    // 'intent': includes `data-whatintent` value if it's different than `data-whatinput`
    ask: function ask(opt) {
      return opt === "intent" ? currentIntent : currentInput;
    },
    // returns string: the currently focused element or null
    element: function element() {
      return currentElement;
    },
    // overwrites ignored keys with provided array
    ignoreKeys: function ignoreKeys(arr) {
      ignoreMap = arr;
    },
    // overwrites specific char keys to update on
    specificKeys: function specificKeys(arr) {
      specificMap = arr;
    },
    // attach functions to input and intent "events"
    // funct: function to fire on change
    // eventType: 'input'|'intent'
    registerOnChange: function registerOnChange(fn, eventType) {
      functionList.push({
        fn: fn,
        type: eventType || "input"
      });
    },
    unRegisterOnChange: function unRegisterOnChange(fn) {
      var position = objPos(fn);

      if (position || position === 0) {
        functionList.splice(position, 1);
      }
    },
    clearStorage: function clearStorage() {
      window.sessionStorage.clear();
    }
  };
}();

/***/ }),

/***/ 83951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useWhatInputIsLastPointerMouse; },
/* harmony export */   "s": function() { return /* binding */ useWhatInputValueIsLastPointerMouse; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _what_input_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95504);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


 // TODO: May be create a SystemContext and place it there.

var useWhatInputIsLastPointerMouse = function useWhatInputIsLastPointerMouse() {
  var _global$window;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((_global$window = __webpack_require__.g.window) === null || _global$window === void 0 ? void 0 : _global$window[_what_input_utils__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW_KEY_IS_LAST_POINTER_MOUSE */ .cc]),
      _useState2 = _slicedToArray(_useState, 2),
      isLastInputMouse = _useState2[0],
      setIsLastInputMouse = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var listener = function listener(e) {
      setIsLastInputMouse(e.detail);
    };

    window.addEventListener(_what_input_utils__WEBPACK_IMPORTED_MODULE_1__/* .EVENT_CUSTOM_IS_LAST_POINTER_MOUSE */ .ru, listener);
    return function () {
      window.removeEventListener(_what_input_utils__WEBPACK_IMPORTED_MODULE_1__/* .EVENT_CUSTOM_IS_LAST_POINTER_MOUSE */ .ru, listener);
    };
  }, []);
  return isLastInputMouse;
}; // Lite hook to return a value only.
// For using inside {IconButton}. If troubles, may be need to implement {MainProvider}
// and store there this and {isMobile, isTablet, ...} too.

var useWhatInputValueIsLastPointerMouse = function useWhatInputValueIsLastPointerMouse() {
  return "window" in __webpack_require__.g ? window[_what_input_utils__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW_KEY_IS_LAST_POINTER_MOUSE */ .cc] : undefined;
};

/***/ }),

/***/ 95504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cc": function() { return /* binding */ WINDOW_KEY_IS_LAST_POINTER_MOUSE; },
/* harmony export */   "ru": function() { return /* binding */ EVENT_CUSTOM_IS_LAST_POINTER_MOUSE; },
/* harmony export */   "w": function() { return /* binding */ dispatchCustomEventLastInputWasMouseChange; }
/* harmony export */ });
/* harmony import */ var _shared_utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62330);

var EVENT_CUSTOM_IS_LAST_POINTER_MOUSE = "isLastInputWasMouse";
var WINDOW_KEY_IS_LAST_POINTER_MOUSE = "isLastInputWasMouse";
var dispatchCustomEventLastInputWasMouseChange = function dispatchCustomEventLastInputWasMouseChange(isLastInputWasMouse) {
  (0,_shared_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* .dispatchCustomEvent */ .hb)(EVENT_CUSTOM_IS_LAST_POINTER_MOUSE, isLastInputWasMouse);
};

/***/ }),

/***/ 86606:
/***/ (function(module) {

"use strict";

var assign = Object.assign.bind(Object);
function g() {
    return assign;
}
Object.defineProperties(g(), {
    implementation: {
        get: g
    },
    shim: {
        value: g
    },
    getPolyfill: {
        value: g
    }
});
module.exports = g();

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 8936:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(5772);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(30816)["Buffer"];
/* provided dependency */ var process = __webpack_require__(27061);
(function(){"use strict";var e={742:function(e,t,i){var a=i(491);var r=i(562);var n=i(450);var s=i(324);var l=i(320);for(var f in l){t[f]=l[f]}t.NONE=0;t.DEFLATE=1;t.INFLATE=2;t.GZIP=3;t.GUNZIP=4;t.DEFLATERAW=5;t.INFLATERAW=6;t.UNZIP=7;var o=31;var h=139;function Zlib(e){if(typeof e!=="number"||e<t.DEFLATE||e>t.UNZIP){throw new TypeError("Bad argument")}this.dictionary=null;this.err=0;this.flush=0;this.init_done=false;this.level=0;this.memLevel=0;this.mode=e;this.strategy=0;this.windowBits=0;this.write_in_progress=false;this.pending_close=false;this.gzip_id_bytes_read=0}Zlib.prototype.close=function(){if(this.write_in_progress){this.pending_close=true;return}this.pending_close=false;a(this.init_done,"close before init");a(this.mode<=t.UNZIP);if(this.mode===t.DEFLATE||this.mode===t.GZIP||this.mode===t.DEFLATERAW){n.deflateEnd(this.strm)}else if(this.mode===t.INFLATE||this.mode===t.GUNZIP||this.mode===t.INFLATERAW||this.mode===t.UNZIP){s.inflateEnd(this.strm)}this.mode=t.NONE;this.dictionary=null};Zlib.prototype.write=function(e,t,i,a,r,n,s){return this._write(true,e,t,i,a,r,n,s)};Zlib.prototype.writeSync=function(e,t,i,a,r,n,s){return this._write(false,e,t,i,a,r,n,s)};Zlib.prototype._write=function(e,i,r,n,s,l,f,o){a.equal(arguments.length,8);a(this.init_done,"write before init");a(this.mode!==t.NONE,"already finalized");a.equal(false,this.write_in_progress,"write already in progress");a.equal(false,this.pending_close,"close is pending");this.write_in_progress=true;a.equal(false,i===undefined,"must provide flush value");this.write_in_progress=true;if(i!==t.Z_NO_FLUSH&&i!==t.Z_PARTIAL_FLUSH&&i!==t.Z_SYNC_FLUSH&&i!==t.Z_FULL_FLUSH&&i!==t.Z_FINISH&&i!==t.Z_BLOCK){throw new Error("Invalid flush value")}if(r==null){r=Buffer.alloc(0);s=0;n=0}this.strm.avail_in=s;this.strm.input=r;this.strm.next_in=n;this.strm.avail_out=o;this.strm.output=l;this.strm.next_out=f;this.flush=i;if(!e){this._process();if(this._checkError()){return this._afterSync()}return}var h=this;process.nextTick((function(){h._process();h._after()}));return this};Zlib.prototype._afterSync=function(){var e=this.strm.avail_out;var t=this.strm.avail_in;this.write_in_progress=false;return[t,e]};Zlib.prototype._process=function(){var e=null;switch(this.mode){case t.DEFLATE:case t.GZIP:case t.DEFLATERAW:this.err=n.deflate(this.strm,this.flush);break;case t.UNZIP:if(this.strm.avail_in>0){e=this.strm.next_in}switch(this.gzip_id_bytes_read){case 0:if(e===null){break}if(this.strm.input[e]===o){this.gzip_id_bytes_read=1;e++;if(this.strm.avail_in===1){break}}else{this.mode=t.INFLATE;break}case 1:if(e===null){break}if(this.strm.input[e]===h){this.gzip_id_bytes_read=2;this.mode=t.GUNZIP}else{this.mode=t.INFLATE}break;default:throw new Error("invalid number of gzip magic number bytes read")}case t.INFLATE:case t.GUNZIP:case t.INFLATERAW:this.err=s.inflate(this.strm,this.flush);if(this.err===t.Z_NEED_DICT&&this.dictionary){this.err=s.inflateSetDictionary(this.strm,this.dictionary);if(this.err===t.Z_OK){this.err=s.inflate(this.strm,this.flush)}else if(this.err===t.Z_DATA_ERROR){this.err=t.Z_NEED_DICT}}while(this.strm.avail_in>0&&this.mode===t.GUNZIP&&this.err===t.Z_STREAM_END&&this.strm.next_in[0]!==0){this.reset();this.err=s.inflate(this.strm,this.flush)}break;default:throw new Error("Unknown mode "+this.mode)}};Zlib.prototype._checkError=function(){switch(this.err){case t.Z_OK:case t.Z_BUF_ERROR:if(this.strm.avail_out!==0&&this.flush===t.Z_FINISH){this._error("unexpected end of file");return false}break;case t.Z_STREAM_END:break;case t.Z_NEED_DICT:if(this.dictionary==null){this._error("Missing dictionary")}else{this._error("Bad dictionary")}return false;default:this._error("Zlib error");return false}return true};Zlib.prototype._after=function(){if(!this._checkError()){return}var e=this.strm.avail_out;var t=this.strm.avail_in;this.write_in_progress=false;this.callback(t,e);if(this.pending_close){this.close()}};Zlib.prototype._error=function(e){if(this.strm.msg){e=this.strm.msg}this.onerror(e,this.err);this.write_in_progress=false;if(this.pending_close){this.close()}};Zlib.prototype.init=function(e,i,r,n,s){a(arguments.length===4||arguments.length===5,"init(windowBits, level, memLevel, strategy, [dictionary])");a(e>=8&&e<=15,"invalid windowBits");a(i>=-1&&i<=9,"invalid compression level");a(r>=1&&r<=9,"invalid memlevel");a(n===t.Z_FILTERED||n===t.Z_HUFFMAN_ONLY||n===t.Z_RLE||n===t.Z_FIXED||n===t.Z_DEFAULT_STRATEGY,"invalid strategy");this._init(i,e,r,n,s);this._setDictionary()};Zlib.prototype.params=function(){throw new Error("deflateParams Not supported")};Zlib.prototype.reset=function(){this._reset();this._setDictionary()};Zlib.prototype._init=function(e,i,a,l,f){this.level=e;this.windowBits=i;this.memLevel=a;this.strategy=l;this.flush=t.Z_NO_FLUSH;this.err=t.Z_OK;if(this.mode===t.GZIP||this.mode===t.GUNZIP){this.windowBits+=16}if(this.mode===t.UNZIP){this.windowBits+=32}if(this.mode===t.DEFLATERAW||this.mode===t.INFLATERAW){this.windowBits=-1*this.windowBits}this.strm=new r;switch(this.mode){case t.DEFLATE:case t.GZIP:case t.DEFLATERAW:this.err=n.deflateInit2(this.strm,this.level,t.Z_DEFLATED,this.windowBits,this.memLevel,this.strategy);break;case t.INFLATE:case t.GUNZIP:case t.INFLATERAW:case t.UNZIP:this.err=s.inflateInit2(this.strm,this.windowBits);break;default:throw new Error("Unknown mode "+this.mode)}if(this.err!==t.Z_OK){this._error("Init error")}this.dictionary=f;this.write_in_progress=false;this.init_done=true};Zlib.prototype._setDictionary=function(){if(this.dictionary==null){return}this.err=t.Z_OK;switch(this.mode){case t.DEFLATE:case t.DEFLATERAW:this.err=n.deflateSetDictionary(this.strm,this.dictionary);break;default:break}if(this.err!==t.Z_OK){this._error("Failed to set dictionary")}};Zlib.prototype._reset=function(){this.err=t.Z_OK;switch(this.mode){case t.DEFLATE:case t.DEFLATERAW:case t.GZIP:this.err=n.deflateReset(this.strm);break;case t.INFLATE:case t.INFLATERAW:case t.GUNZIP:this.err=s.inflateReset(this.strm);break;default:break}if(this.err!==t.Z_OK){this._error("Failed to reset stream")}};t.Zlib=Zlib},23:function(e,t,i){var a=i(300).Buffer;var r=i(781).Transform;var n=i(742);var s=i(837);var l=i(491).ok;var f=i(300).kMaxLength;var o="Cannot create final Buffer. It would be larger "+"than 0x"+f.toString(16)+" bytes";n.Z_MIN_WINDOWBITS=8;n.Z_MAX_WINDOWBITS=15;n.Z_DEFAULT_WINDOWBITS=15;n.Z_MIN_CHUNK=64;n.Z_MAX_CHUNK=Infinity;n.Z_DEFAULT_CHUNK=16*1024;n.Z_MIN_MEMLEVEL=1;n.Z_MAX_MEMLEVEL=9;n.Z_DEFAULT_MEMLEVEL=8;n.Z_MIN_LEVEL=-1;n.Z_MAX_LEVEL=9;n.Z_DEFAULT_LEVEL=n.Z_DEFAULT_COMPRESSION;var h=Object.keys(n);for(var _=0;_<h.length;_++){var d=h[_];if(d.match(/^Z/)){Object.defineProperty(t,d,{enumerable:true,value:n[d],writable:false})}}var u={Z_OK:n.Z_OK,Z_STREAM_END:n.Z_STREAM_END,Z_NEED_DICT:n.Z_NEED_DICT,Z_ERRNO:n.Z_ERRNO,Z_STREAM_ERROR:n.Z_STREAM_ERROR,Z_DATA_ERROR:n.Z_DATA_ERROR,Z_MEM_ERROR:n.Z_MEM_ERROR,Z_BUF_ERROR:n.Z_BUF_ERROR,Z_VERSION_ERROR:n.Z_VERSION_ERROR};var c=Object.keys(u);for(var v=0;v<c.length;v++){var b=c[v];u[u[b]]=b}Object.defineProperty(t,"codes",{enumerable:true,value:Object.freeze(u),writable:false});t.Deflate=Deflate;t.Inflate=Inflate;t.Gzip=Gzip;t.Gunzip=Gunzip;t.DeflateRaw=DeflateRaw;t.InflateRaw=InflateRaw;t.Unzip=Unzip;t.createDeflate=function(e){return new Deflate(e)};t.createInflate=function(e){return new Inflate(e)};t.createDeflateRaw=function(e){return new DeflateRaw(e)};t.createInflateRaw=function(e){return new InflateRaw(e)};t.createGzip=function(e){return new Gzip(e)};t.createGunzip=function(e){return new Gunzip(e)};t.createUnzip=function(e){return new Unzip(e)};t.deflate=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Deflate(t),e,i)};t.deflateSync=function(e,t){return zlibBufferSync(new Deflate(t),e)};t.gzip=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Gzip(t),e,i)};t.gzipSync=function(e,t){return zlibBufferSync(new Gzip(t),e)};t.deflateRaw=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new DeflateRaw(t),e,i)};t.deflateRawSync=function(e,t){return zlibBufferSync(new DeflateRaw(t),e)};t.unzip=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Unzip(t),e,i)};t.unzipSync=function(e,t){return zlibBufferSync(new Unzip(t),e)};t.inflate=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Inflate(t),e,i)};t.inflateSync=function(e,t){return zlibBufferSync(new Inflate(t),e)};t.gunzip=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Gunzip(t),e,i)};t.gunzipSync=function(e,t){return zlibBufferSync(new Gunzip(t),e)};t.inflateRaw=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new InflateRaw(t),e,i)};t.inflateRawSync=function(e,t){return zlibBufferSync(new InflateRaw(t),e)};function zlibBuffer(e,t,i){var r=[];var n=0;e.on("error",onError);e.on("end",onEnd);e.end(t);flow();function flow(){var t;while(null!==(t=e.read())){r.push(t);n+=t.length}e.once("readable",flow)}function onError(t){e.removeListener("end",onEnd);e.removeListener("readable",flow);i(t)}function onEnd(){var t;var s=null;if(n>=f){s=new RangeError(o)}else{t=a.concat(r,n)}r=[];e.close();i(s,t)}}function zlibBufferSync(e,t){if(typeof t==="string")t=a.from(t);if(!a.isBuffer(t))throw new TypeError("Not a string or buffer");var i=e._finishFlushFlag;return e._processChunk(t,i)}function Deflate(e){if(!(this instanceof Deflate))return new Deflate(e);Zlib.call(this,e,n.DEFLATE)}function Inflate(e){if(!(this instanceof Inflate))return new Inflate(e);Zlib.call(this,e,n.INFLATE)}function Gzip(e){if(!(this instanceof Gzip))return new Gzip(e);Zlib.call(this,e,n.GZIP)}function Gunzip(e){if(!(this instanceof Gunzip))return new Gunzip(e);Zlib.call(this,e,n.GUNZIP)}function DeflateRaw(e){if(!(this instanceof DeflateRaw))return new DeflateRaw(e);Zlib.call(this,e,n.DEFLATERAW)}function InflateRaw(e){if(!(this instanceof InflateRaw))return new InflateRaw(e);Zlib.call(this,e,n.INFLATERAW)}function Unzip(e){if(!(this instanceof Unzip))return new Unzip(e);Zlib.call(this,e,n.UNZIP)}function isValidFlushFlag(e){return e===n.Z_NO_FLUSH||e===n.Z_PARTIAL_FLUSH||e===n.Z_SYNC_FLUSH||e===n.Z_FULL_FLUSH||e===n.Z_FINISH||e===n.Z_BLOCK}function Zlib(e,i){var s=this;this._opts=e=e||{};this._chunkSize=e.chunkSize||t.Z_DEFAULT_CHUNK;r.call(this,e);if(e.flush&&!isValidFlushFlag(e.flush)){throw new Error("Invalid flush flag: "+e.flush)}if(e.finishFlush&&!isValidFlushFlag(e.finishFlush)){throw new Error("Invalid flush flag: "+e.finishFlush)}this._flushFlag=e.flush||n.Z_NO_FLUSH;this._finishFlushFlag=typeof e.finishFlush!=="undefined"?e.finishFlush:n.Z_FINISH;if(e.chunkSize){if(e.chunkSize<t.Z_MIN_CHUNK||e.chunkSize>t.Z_MAX_CHUNK){throw new Error("Invalid chunk size: "+e.chunkSize)}}if(e.windowBits){if(e.windowBits<t.Z_MIN_WINDOWBITS||e.windowBits>t.Z_MAX_WINDOWBITS){throw new Error("Invalid windowBits: "+e.windowBits)}}if(e.level){if(e.level<t.Z_MIN_LEVEL||e.level>t.Z_MAX_LEVEL){throw new Error("Invalid compression level: "+e.level)}}if(e.memLevel){if(e.memLevel<t.Z_MIN_MEMLEVEL||e.memLevel>t.Z_MAX_MEMLEVEL){throw new Error("Invalid memLevel: "+e.memLevel)}}if(e.strategy){if(e.strategy!=t.Z_FILTERED&&e.strategy!=t.Z_HUFFMAN_ONLY&&e.strategy!=t.Z_RLE&&e.strategy!=t.Z_FIXED&&e.strategy!=t.Z_DEFAULT_STRATEGY){throw new Error("Invalid strategy: "+e.strategy)}}if(e.dictionary){if(!a.isBuffer(e.dictionary)){throw new Error("Invalid dictionary: it should be a Buffer instance")}}this._handle=new n.Zlib(i);var l=this;this._hadError=false;this._handle.onerror=function(e,i){_close(l);l._hadError=true;var a=new Error(e);a.errno=i;a.code=t.codes[i];l.emit("error",a)};var f=t.Z_DEFAULT_COMPRESSION;if(typeof e.level==="number")f=e.level;var o=t.Z_DEFAULT_STRATEGY;if(typeof e.strategy==="number")o=e.strategy;this._handle.init(e.windowBits||t.Z_DEFAULT_WINDOWBITS,f,e.memLevel||t.Z_DEFAULT_MEMLEVEL,o,e.dictionary);this._buffer=a.allocUnsafe(this._chunkSize);this._offset=0;this._level=f;this._strategy=o;this.once("end",this.close);Object.defineProperty(this,"_closed",{get:function(){return!s._handle},configurable:true,enumerable:true})}s.inherits(Zlib,r);Zlib.prototype.params=function(e,i,a){if(e<t.Z_MIN_LEVEL||e>t.Z_MAX_LEVEL){throw new RangeError("Invalid compression level: "+e)}if(i!=t.Z_FILTERED&&i!=t.Z_HUFFMAN_ONLY&&i!=t.Z_RLE&&i!=t.Z_FIXED&&i!=t.Z_DEFAULT_STRATEGY){throw new TypeError("Invalid strategy: "+i)}if(this._level!==e||this._strategy!==i){var r=this;this.flush(n.Z_SYNC_FLUSH,(function(){l(r._handle,"zlib binding closed");r._handle.params(e,i);if(!r._hadError){r._level=e;r._strategy=i;if(a)a()}}))}else{process.nextTick(a)}};Zlib.prototype.reset=function(){l(this._handle,"zlib binding closed");return this._handle.reset()};Zlib.prototype._flush=function(e){this._transform(a.alloc(0),"",e)};Zlib.prototype.flush=function(e,t){var i=this;var r=this._writableState;if(typeof e==="function"||e===undefined&&!t){t=e;e=n.Z_FULL_FLUSH}if(r.ended){if(t)process.nextTick(t)}else if(r.ending){if(t)this.once("end",t)}else if(r.needDrain){if(t){this.once("drain",(function(){return i.flush(e,t)}))}}else{this._flushFlag=e;this.write(a.alloc(0),"",t)}};Zlib.prototype.close=function(e){_close(this,e);process.nextTick(emitCloseNT,this)};function _close(e,t){if(t)process.nextTick(t);if(!e._handle)return;e._handle.close();e._handle=null}function emitCloseNT(e){e.emit("close")}Zlib.prototype._transform=function(e,t,i){var r;var s=this._writableState;var l=s.ending||s.ended;var f=l&&(!e||s.length===e.length);if(e!==null&&!a.isBuffer(e))return i(new Error("invalid input"));if(!this._handle)return i(new Error("zlib binding closed"));if(f)r=this._finishFlushFlag;else{r=this._flushFlag;if(e.length>=s.length){this._flushFlag=this._opts.flush||n.Z_NO_FLUSH}}this._processChunk(e,r,i)};Zlib.prototype._processChunk=function(e,t,i){var r=e&&e.length;var n=this._chunkSize-this._offset;var s=0;var h=this;var _=typeof i==="function";if(!_){var d=[];var u=0;var c;this.on("error",(function(e){c=e}));l(this._handle,"zlib binding closed");do{var v=this._handle.writeSync(t,e,s,r,this._buffer,this._offset,n)}while(!this._hadError&&callback(v[0],v[1]));if(this._hadError){throw c}if(u>=f){_close(this);throw new RangeError(o)}var b=a.concat(d,u);_close(this);return b}l(this._handle,"zlib binding closed");var w=this._handle.write(t,e,s,r,this._buffer,this._offset,n);w.buffer=e;w.callback=callback;function callback(f,o){if(this){this.buffer=null;this.callback=null}if(h._hadError)return;var c=n-o;l(c>=0,"have should not go down");if(c>0){var v=h._buffer.slice(h._offset,h._offset+c);h._offset+=c;if(_){h.push(v)}else{d.push(v);u+=v.length}}if(o===0||h._offset>=h._chunkSize){n=h._chunkSize;h._offset=0;h._buffer=a.allocUnsafe(h._chunkSize)}if(o===0){s+=r-f;r=f;if(!_)return true;var b=h._handle.write(t,e,s,r,h._buffer,h._offset,h._chunkSize);b.callback=callback;b.buffer=e;return}if(!_)return false;i()}};s.inherits(Deflate,Zlib);s.inherits(Inflate,Zlib);s.inherits(Gzip,Zlib);s.inherits(Gunzip,Zlib);s.inherits(DeflateRaw,Zlib);s.inherits(InflateRaw,Zlib);s.inherits(Unzip,Zlib)},380:function(e,t){var i=typeof Uint8Array!=="undefined"&&typeof Uint16Array!=="undefined"&&typeof Int32Array!=="undefined";function _has(e,t){return Object.prototype.hasOwnProperty.call(e,t)}t.assign=function(e){var t=Array.prototype.slice.call(arguments,1);while(t.length){var i=t.shift();if(!i){continue}if(typeof i!=="object"){throw new TypeError(i+"must be non-object")}for(var a in i){if(_has(i,a)){e[a]=i[a]}}}return e};t.shrinkBuf=function(e,t){if(e.length===t){return e}if(e.subarray){return e.subarray(0,t)}e.length=t;return e};var a={arraySet:function(e,t,i,a,r){if(t.subarray&&e.subarray){e.set(t.subarray(i,i+a),r);return}for(var n=0;n<a;n++){e[r+n]=t[i+n]}},flattenChunks:function(e){var t,i,a,r,n,s;a=0;for(t=0,i=e.length;t<i;t++){a+=e[t].length}s=new Uint8Array(a);r=0;for(t=0,i=e.length;t<i;t++){n=e[t];s.set(n,r);r+=n.length}return s}};var r={arraySet:function(e,t,i,a,r){for(var n=0;n<a;n++){e[r+n]=t[i+n]}},flattenChunks:function(e){return[].concat.apply([],e)}};t.setTyped=function(e){if(e){t.Buf8=Uint8Array;t.Buf16=Uint16Array;t.Buf32=Int32Array;t.assign(t,a)}else{t.Buf8=Array;t.Buf16=Array;t.Buf32=Array;t.assign(t,r)}};t.setTyped(i)},496:function(e){function adler32(e,t,i,a){var r=e&65535|0,n=e>>>16&65535|0,s=0;while(i!==0){s=i>2e3?2e3:i;i-=s;do{r=r+t[a++]|0;n=n+r|0}while(--s);r%=65521;n%=65521}return r|n<<16|0}e.exports=adler32},320:function(e){e.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},307:function(e){function makeTable(){var e,t=[];for(var i=0;i<256;i++){e=i;for(var a=0;a<8;a++){e=e&1?3988292384^e>>>1:e>>>1}t[i]=e}return t}var t=makeTable();function crc32(e,i,a,r){var n=t,s=r+a;e^=-1;for(var l=r;l<s;l++){e=e>>>8^n[(e^i[l])&255]}return e^-1}e.exports=crc32},450:function(e,t,i){var a=i(380);var r=i(842);var n=i(496);var s=i(307);var l=i(31);var f=0;var o=1;var h=3;var _=4;var d=5;var u=0;var c=1;var v=-2;var b=-3;var w=-5;var p=-1;var g=1;var m=2;var k=3;var y=4;var E=0;var z=2;var Z=8;var x=9;var I=15;var R=8;var S=29;var L=256;var A=L+1+S;var T=30;var F=19;var N=2*A+1;var D=15;var B=3;var U=258;var O=U+B+1;var M=32;var C=42;var G=69;var H=73;var P=91;var K=103;var W=113;var V=666;var q=1;var X=2;var Y=3;var j=4;var J=3;function err(e,t){e.msg=l[t];return t}function rank(e){return(e<<1)-(e>4?9:0)}function zero(e){var t=e.length;while(--t>=0){e[t]=0}}function flush_pending(e){var t=e.state;var i=t.pending;if(i>e.avail_out){i=e.avail_out}if(i===0){return}a.arraySet(e.output,t.pending_buf,t.pending_out,i,e.next_out);e.next_out+=i;t.pending_out+=i;e.total_out+=i;e.avail_out-=i;t.pending-=i;if(t.pending===0){t.pending_out=0}}function flush_block_only(e,t){r._tr_flush_block(e,e.block_start>=0?e.block_start:-1,e.strstart-e.block_start,t);e.block_start=e.strstart;flush_pending(e.strm)}function put_byte(e,t){e.pending_buf[e.pending++]=t}function putShortMSB(e,t){e.pending_buf[e.pending++]=t>>>8&255;e.pending_buf[e.pending++]=t&255}function read_buf(e,t,i,r){var l=e.avail_in;if(l>r){l=r}if(l===0){return 0}e.avail_in-=l;a.arraySet(t,e.input,e.next_in,l,i);if(e.state.wrap===1){e.adler=n(e.adler,t,l,i)}else if(e.state.wrap===2){e.adler=s(e.adler,t,l,i)}e.next_in+=l;e.total_in+=l;return l}function longest_match(e,t){var i=e.max_chain_length;var a=e.strstart;var r;var n;var s=e.prev_length;var l=e.nice_match;var f=e.strstart>e.w_size-O?e.strstart-(e.w_size-O):0;var o=e.window;var h=e.w_mask;var _=e.prev;var d=e.strstart+U;var u=o[a+s-1];var c=o[a+s];if(e.prev_length>=e.good_match){i>>=2}if(l>e.lookahead){l=e.lookahead}do{r=t;if(o[r+s]!==c||o[r+s-1]!==u||o[r]!==o[a]||o[++r]!==o[a+1]){continue}a+=2;r++;do{}while(o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&a<d);n=U-(d-a);a=d-U;if(n>s){e.match_start=t;s=n;if(n>=l){break}u=o[a+s-1];c=o[a+s]}}while((t=_[t&h])>f&&--i!==0);if(s<=e.lookahead){return s}return e.lookahead}function fill_window(e){var t=e.w_size;var i,r,n,s,l;do{s=e.window_size-e.lookahead-e.strstart;if(e.strstart>=t+(t-O)){a.arraySet(e.window,e.window,t,t,0);e.match_start-=t;e.strstart-=t;e.block_start-=t;r=e.hash_size;i=r;do{n=e.head[--i];e.head[i]=n>=t?n-t:0}while(--r);r=t;i=r;do{n=e.prev[--i];e.prev[i]=n>=t?n-t:0}while(--r);s+=t}if(e.strm.avail_in===0){break}r=read_buf(e.strm,e.window,e.strstart+e.lookahead,s);e.lookahead+=r;if(e.lookahead+e.insert>=B){l=e.strstart-e.insert;e.ins_h=e.window[l];e.ins_h=(e.ins_h<<e.hash_shift^e.window[l+1])&e.hash_mask;while(e.insert){e.ins_h=(e.ins_h<<e.hash_shift^e.window[l+B-1])&e.hash_mask;e.prev[l&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=l;l++;e.insert--;if(e.lookahead+e.insert<B){break}}}}while(e.lookahead<O&&e.strm.avail_in!==0)}function deflate_stored(e,t){var i=65535;if(i>e.pending_buf_size-5){i=e.pending_buf_size-5}for(;;){if(e.lookahead<=1){fill_window(e);if(e.lookahead===0&&t===f){return q}if(e.lookahead===0){break}}e.strstart+=e.lookahead;e.lookahead=0;var a=e.block_start+i;if(e.strstart===0||e.strstart>=a){e.lookahead=e.strstart-a;e.strstart=a;flush_block_only(e,false);if(e.strm.avail_out===0){return q}}if(e.strstart-e.block_start>=e.w_size-O){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=0;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.strstart>e.block_start){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return q}function deflate_fast(e,t){var i;var a;for(;;){if(e.lookahead<O){fill_window(e);if(e.lookahead<O&&t===f){return q}if(e.lookahead===0){break}}i=0;if(e.lookahead>=B){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}if(i!==0&&e.strstart-i<=e.w_size-O){e.match_length=longest_match(e,i)}if(e.match_length>=B){a=r._tr_tally(e,e.strstart-e.match_start,e.match_length-B);e.lookahead-=e.match_length;if(e.match_length<=e.max_lazy_match&&e.lookahead>=B){e.match_length--;do{e.strstart++;e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}while(--e.match_length!==0);e.strstart++}else{e.strstart+=e.match_length;e.match_length=0;e.ins_h=e.window[e.strstart];e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask}}else{a=r._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++}if(a){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=e.strstart<B-1?e.strstart:B-1;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function deflate_slow(e,t){var i;var a;var n;for(;;){if(e.lookahead<O){fill_window(e);if(e.lookahead<O&&t===f){return q}if(e.lookahead===0){break}}i=0;if(e.lookahead>=B){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}e.prev_length=e.match_length;e.prev_match=e.match_start;e.match_length=B-1;if(i!==0&&e.prev_length<e.max_lazy_match&&e.strstart-i<=e.w_size-O){e.match_length=longest_match(e,i);if(e.match_length<=5&&(e.strategy===g||e.match_length===B&&e.strstart-e.match_start>4096)){e.match_length=B-1}}if(e.prev_length>=B&&e.match_length<=e.prev_length){n=e.strstart+e.lookahead-B;a=r._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-B);e.lookahead-=e.prev_length-1;e.prev_length-=2;do{if(++e.strstart<=n){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}}while(--e.prev_length!==0);e.match_available=0;e.match_length=B-1;e.strstart++;if(a){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}else if(e.match_available){a=r._tr_tally(e,0,e.window[e.strstart-1]);if(a){flush_block_only(e,false)}e.strstart++;e.lookahead--;if(e.strm.avail_out===0){return q}}else{e.match_available=1;e.strstart++;e.lookahead--}}if(e.match_available){a=r._tr_tally(e,0,e.window[e.strstart-1]);e.match_available=0}e.insert=e.strstart<B-1?e.strstart:B-1;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function deflate_rle(e,t){var i;var a;var n,s;var l=e.window;for(;;){if(e.lookahead<=U){fill_window(e);if(e.lookahead<=U&&t===f){return q}if(e.lookahead===0){break}}e.match_length=0;if(e.lookahead>=B&&e.strstart>0){n=e.strstart-1;a=l[n];if(a===l[++n]&&a===l[++n]&&a===l[++n]){s=e.strstart+U;do{}while(a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&n<s);e.match_length=U-(s-n);if(e.match_length>e.lookahead){e.match_length=e.lookahead}}}if(e.match_length>=B){i=r._tr_tally(e,1,e.match_length-B);e.lookahead-=e.match_length;e.strstart+=e.match_length;e.match_length=0}else{i=r._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++}if(i){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=0;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function deflate_huff(e,t){var i;for(;;){if(e.lookahead===0){fill_window(e);if(e.lookahead===0){if(t===f){return q}break}}e.match_length=0;i=r._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++;if(i){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=0;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function Config(e,t,i,a,r){this.good_length=e;this.max_lazy=t;this.nice_length=i;this.max_chain=a;this.func=r}var Q;Q=[new Config(0,0,0,0,deflate_stored),new Config(4,4,8,4,deflate_fast),new Config(4,5,16,8,deflate_fast),new Config(4,6,32,32,deflate_fast),new Config(4,4,16,16,deflate_slow),new Config(8,16,32,32,deflate_slow),new Config(8,16,128,128,deflate_slow),new Config(8,32,128,256,deflate_slow),new Config(32,128,258,1024,deflate_slow),new Config(32,258,258,4096,deflate_slow)];function lm_init(e){e.window_size=2*e.w_size;zero(e.head);e.max_lazy_match=Q[e.level].max_lazy;e.good_match=Q[e.level].good_length;e.nice_match=Q[e.level].nice_length;e.max_chain_length=Q[e.level].max_chain;e.strstart=0;e.block_start=0;e.lookahead=0;e.insert=0;e.match_length=e.prev_length=B-1;e.match_available=0;e.ins_h=0}function DeflateState(){this.strm=null;this.status=0;this.pending_buf=null;this.pending_buf_size=0;this.pending_out=0;this.pending=0;this.wrap=0;this.gzhead=null;this.gzindex=0;this.method=Z;this.last_flush=-1;this.w_size=0;this.w_bits=0;this.w_mask=0;this.window=null;this.window_size=0;this.prev=null;this.head=null;this.ins_h=0;this.hash_size=0;this.hash_bits=0;this.hash_mask=0;this.hash_shift=0;this.block_start=0;this.match_length=0;this.prev_match=0;this.match_available=0;this.strstart=0;this.match_start=0;this.lookahead=0;this.prev_length=0;this.max_chain_length=0;this.max_lazy_match=0;this.level=0;this.strategy=0;this.good_match=0;this.nice_match=0;this.dyn_ltree=new a.Buf16(N*2);this.dyn_dtree=new a.Buf16((2*T+1)*2);this.bl_tree=new a.Buf16((2*F+1)*2);zero(this.dyn_ltree);zero(this.dyn_dtree);zero(this.bl_tree);this.l_desc=null;this.d_desc=null;this.bl_desc=null;this.bl_count=new a.Buf16(D+1);this.heap=new a.Buf16(2*A+1);zero(this.heap);this.heap_len=0;this.heap_max=0;this.depth=new a.Buf16(2*A+1);zero(this.depth);this.l_buf=0;this.lit_bufsize=0;this.last_lit=0;this.d_buf=0;this.opt_len=0;this.static_len=0;this.matches=0;this.insert=0;this.bi_buf=0;this.bi_valid=0}function deflateResetKeep(e){var t;if(!e||!e.state){return err(e,v)}e.total_in=e.total_out=0;e.data_type=z;t=e.state;t.pending=0;t.pending_out=0;if(t.wrap<0){t.wrap=-t.wrap}t.status=t.wrap?C:W;e.adler=t.wrap===2?0:1;t.last_flush=f;r._tr_init(t);return u}function deflateReset(e){var t=deflateResetKeep(e);if(t===u){lm_init(e.state)}return t}function deflateSetHeader(e,t){if(!e||!e.state){return v}if(e.state.wrap!==2){return v}e.state.gzhead=t;return u}function deflateInit2(e,t,i,r,n,s){if(!e){return v}var l=1;if(t===p){t=6}if(r<0){l=0;r=-r}else if(r>15){l=2;r-=16}if(n<1||n>x||i!==Z||r<8||r>15||t<0||t>9||s<0||s>y){return err(e,v)}if(r===8){r=9}var f=new DeflateState;e.state=f;f.strm=e;f.wrap=l;f.gzhead=null;f.w_bits=r;f.w_size=1<<f.w_bits;f.w_mask=f.w_size-1;f.hash_bits=n+7;f.hash_size=1<<f.hash_bits;f.hash_mask=f.hash_size-1;f.hash_shift=~~((f.hash_bits+B-1)/B);f.window=new a.Buf8(f.w_size*2);f.head=new a.Buf16(f.hash_size);f.prev=new a.Buf16(f.w_size);f.lit_bufsize=1<<n+6;f.pending_buf_size=f.lit_bufsize*4;f.pending_buf=new a.Buf8(f.pending_buf_size);f.d_buf=1*f.lit_bufsize;f.l_buf=(1+2)*f.lit_bufsize;f.level=t;f.strategy=s;f.method=i;return deflateReset(e)}function deflateInit(e,t){return deflateInit2(e,t,Z,I,R,E)}function deflate(e,t){var i,a;var n,l;if(!e||!e.state||t>d||t<0){return e?err(e,v):v}a=e.state;if(!e.output||!e.input&&e.avail_in!==0||a.status===V&&t!==_){return err(e,e.avail_out===0?w:v)}a.strm=e;i=a.last_flush;a.last_flush=t;if(a.status===C){if(a.wrap===2){e.adler=0;put_byte(a,31);put_byte(a,139);put_byte(a,8);if(!a.gzhead){put_byte(a,0);put_byte(a,0);put_byte(a,0);put_byte(a,0);put_byte(a,0);put_byte(a,a.level===9?2:a.strategy>=m||a.level<2?4:0);put_byte(a,J);a.status=W}else{put_byte(a,(a.gzhead.text?1:0)+(a.gzhead.hcrc?2:0)+(!a.gzhead.extra?0:4)+(!a.gzhead.name?0:8)+(!a.gzhead.comment?0:16));put_byte(a,a.gzhead.time&255);put_byte(a,a.gzhead.time>>8&255);put_byte(a,a.gzhead.time>>16&255);put_byte(a,a.gzhead.time>>24&255);put_byte(a,a.level===9?2:a.strategy>=m||a.level<2?4:0);put_byte(a,a.gzhead.os&255);if(a.gzhead.extra&&a.gzhead.extra.length){put_byte(a,a.gzhead.extra.length&255);put_byte(a,a.gzhead.extra.length>>8&255)}if(a.gzhead.hcrc){e.adler=s(e.adler,a.pending_buf,a.pending,0)}a.gzindex=0;a.status=G}}else{var b=Z+(a.w_bits-8<<4)<<8;var p=-1;if(a.strategy>=m||a.level<2){p=0}else if(a.level<6){p=1}else if(a.level===6){p=2}else{p=3}b|=p<<6;if(a.strstart!==0){b|=M}b+=31-b%31;a.status=W;putShortMSB(a,b);if(a.strstart!==0){putShortMSB(a,e.adler>>>16);putShortMSB(a,e.adler&65535)}e.adler=1}}if(a.status===G){if(a.gzhead.extra){n=a.pending;while(a.gzindex<(a.gzhead.extra.length&65535)){if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}flush_pending(e);n=a.pending;if(a.pending===a.pending_buf_size){break}}put_byte(a,a.gzhead.extra[a.gzindex]&255);a.gzindex++}if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}if(a.gzindex===a.gzhead.extra.length){a.gzindex=0;a.status=H}}else{a.status=H}}if(a.status===H){if(a.gzhead.name){n=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}flush_pending(e);n=a.pending;if(a.pending===a.pending_buf_size){l=1;break}}if(a.gzindex<a.gzhead.name.length){l=a.gzhead.name.charCodeAt(a.gzindex++)&255}else{l=0}put_byte(a,l)}while(l!==0);if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}if(l===0){a.gzindex=0;a.status=P}}else{a.status=P}}if(a.status===P){if(a.gzhead.comment){n=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}flush_pending(e);n=a.pending;if(a.pending===a.pending_buf_size){l=1;break}}if(a.gzindex<a.gzhead.comment.length){l=a.gzhead.comment.charCodeAt(a.gzindex++)&255}else{l=0}put_byte(a,l)}while(l!==0);if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}if(l===0){a.status=K}}else{a.status=K}}if(a.status===K){if(a.gzhead.hcrc){if(a.pending+2>a.pending_buf_size){flush_pending(e)}if(a.pending+2<=a.pending_buf_size){put_byte(a,e.adler&255);put_byte(a,e.adler>>8&255);e.adler=0;a.status=W}}else{a.status=W}}if(a.pending!==0){flush_pending(e);if(e.avail_out===0){a.last_flush=-1;return u}}else if(e.avail_in===0&&rank(t)<=rank(i)&&t!==_){return err(e,w)}if(a.status===V&&e.avail_in!==0){return err(e,w)}if(e.avail_in!==0||a.lookahead!==0||t!==f&&a.status!==V){var g=a.strategy===m?deflate_huff(a,t):a.strategy===k?deflate_rle(a,t):Q[a.level].func(a,t);if(g===Y||g===j){a.status=V}if(g===q||g===Y){if(e.avail_out===0){a.last_flush=-1}return u}if(g===X){if(t===o){r._tr_align(a)}else if(t!==d){r._tr_stored_block(a,0,0,false);if(t===h){zero(a.head);if(a.lookahead===0){a.strstart=0;a.block_start=0;a.insert=0}}}flush_pending(e);if(e.avail_out===0){a.last_flush=-1;return u}}}if(t!==_){return u}if(a.wrap<=0){return c}if(a.wrap===2){put_byte(a,e.adler&255);put_byte(a,e.adler>>8&255);put_byte(a,e.adler>>16&255);put_byte(a,e.adler>>24&255);put_byte(a,e.total_in&255);put_byte(a,e.total_in>>8&255);put_byte(a,e.total_in>>16&255);put_byte(a,e.total_in>>24&255)}else{putShortMSB(a,e.adler>>>16);putShortMSB(a,e.adler&65535)}flush_pending(e);if(a.wrap>0){a.wrap=-a.wrap}return a.pending!==0?u:c}function deflateEnd(e){var t;if(!e||!e.state){return v}t=e.state.status;if(t!==C&&t!==G&&t!==H&&t!==P&&t!==K&&t!==W&&t!==V){return err(e,v)}e.state=null;return t===W?err(e,b):u}function deflateSetDictionary(e,t){var i=t.length;var r;var s,l;var f;var o;var h;var _;var d;if(!e||!e.state){return v}r=e.state;f=r.wrap;if(f===2||f===1&&r.status!==C||r.lookahead){return v}if(f===1){e.adler=n(e.adler,t,i,0)}r.wrap=0;if(i>=r.w_size){if(f===0){zero(r.head);r.strstart=0;r.block_start=0;r.insert=0}d=new a.Buf8(r.w_size);a.arraySet(d,t,i-r.w_size,r.w_size,0);t=d;i=r.w_size}o=e.avail_in;h=e.next_in;_=e.input;e.avail_in=i;e.next_in=0;e.input=t;fill_window(r);while(r.lookahead>=B){s=r.strstart;l=r.lookahead-(B-1);do{r.ins_h=(r.ins_h<<r.hash_shift^r.window[s+B-1])&r.hash_mask;r.prev[s&r.w_mask]=r.head[r.ins_h];r.head[r.ins_h]=s;s++}while(--l);r.strstart=s;r.lookahead=B-1;fill_window(r)}r.strstart+=r.lookahead;r.block_start=r.strstart;r.insert=r.lookahead;r.lookahead=0;r.match_length=r.prev_length=B-1;r.match_available=0;e.next_in=h;e.input=_;e.avail_in=o;r.wrap=f;return u}t.deflateInit=deflateInit;t.deflateInit2=deflateInit2;t.deflateReset=deflateReset;t.deflateResetKeep=deflateResetKeep;t.deflateSetHeader=deflateSetHeader;t.deflate=deflate;t.deflateEnd=deflateEnd;t.deflateSetDictionary=deflateSetDictionary;t.deflateInfo="pako deflate (from Nodeca project)"},333:function(e){var t=30;var i=12;e.exports=function inflate_fast(e,a){var r;var n;var s;var l;var f;var o;var h;var _;var d;var u;var c;var v;var b;var w;var p;var g;var m;var k;var y;var E;var z;var Z;var x;var I,R;r=e.state;n=e.next_in;I=e.input;s=n+(e.avail_in-5);l=e.next_out;R=e.output;f=l-(a-e.avail_out);o=l+(e.avail_out-257);h=r.dmax;_=r.wsize;d=r.whave;u=r.wnext;c=r.window;v=r.hold;b=r.bits;w=r.lencode;p=r.distcode;g=(1<<r.lenbits)-1;m=(1<<r.distbits)-1;e:do{if(b<15){v+=I[n++]<<b;b+=8;v+=I[n++]<<b;b+=8}k=w[v&g];t:for(;;){y=k>>>24;v>>>=y;b-=y;y=k>>>16&255;if(y===0){R[l++]=k&65535}else if(y&16){E=k&65535;y&=15;if(y){if(b<y){v+=I[n++]<<b;b+=8}E+=v&(1<<y)-1;v>>>=y;b-=y}if(b<15){v+=I[n++]<<b;b+=8;v+=I[n++]<<b;b+=8}k=p[v&m];i:for(;;){y=k>>>24;v>>>=y;b-=y;y=k>>>16&255;if(y&16){z=k&65535;y&=15;if(b<y){v+=I[n++]<<b;b+=8;if(b<y){v+=I[n++]<<b;b+=8}}z+=v&(1<<y)-1;if(z>h){e.msg="invalid distance too far back";r.mode=t;break e}v>>>=y;b-=y;y=l-f;if(z>y){y=z-y;if(y>d){if(r.sane){e.msg="invalid distance too far back";r.mode=t;break e}}Z=0;x=c;if(u===0){Z+=_-y;if(y<E){E-=y;do{R[l++]=c[Z++]}while(--y);Z=l-z;x=R}}else if(u<y){Z+=_+u-y;y-=u;if(y<E){E-=y;do{R[l++]=c[Z++]}while(--y);Z=0;if(u<E){y=u;E-=y;do{R[l++]=c[Z++]}while(--y);Z=l-z;x=R}}}else{Z+=u-y;if(y<E){E-=y;do{R[l++]=c[Z++]}while(--y);Z=l-z;x=R}}while(E>2){R[l++]=x[Z++];R[l++]=x[Z++];R[l++]=x[Z++];E-=3}if(E){R[l++]=x[Z++];if(E>1){R[l++]=x[Z++]}}}else{Z=l-z;do{R[l++]=R[Z++];R[l++]=R[Z++];R[l++]=R[Z++];E-=3}while(E>2);if(E){R[l++]=R[Z++];if(E>1){R[l++]=R[Z++]}}}}else if((y&64)===0){k=p[(k&65535)+(v&(1<<y)-1)];continue i}else{e.msg="invalid distance code";r.mode=t;break e}break}}else if((y&64)===0){k=w[(k&65535)+(v&(1<<y)-1)];continue t}else if(y&32){r.mode=i;break e}else{e.msg="invalid literal/length code";r.mode=t;break e}break}}while(n<s&&l<o);E=b>>3;n-=E;b-=E<<3;v&=(1<<b)-1;e.next_in=n;e.next_out=l;e.avail_in=n<s?5+(s-n):5-(n-s);e.avail_out=l<o?257+(o-l):257-(l-o);r.hold=v;r.bits=b;return}},324:function(e,t,i){var a=i(380);var r=i(496);var n=i(307);var s=i(333);var l=i(19);var f=0;var o=1;var h=2;var _=4;var d=5;var u=6;var c=0;var v=1;var b=2;var w=-2;var p=-3;var g=-4;var m=-5;var k=8;var y=1;var E=2;var z=3;var Z=4;var x=5;var I=6;var R=7;var S=8;var L=9;var A=10;var T=11;var F=12;var N=13;var D=14;var B=15;var U=16;var O=17;var M=18;var C=19;var G=20;var H=21;var P=22;var K=23;var W=24;var V=25;var q=26;var X=27;var Y=28;var j=29;var J=30;var Q=31;var $=32;var ee=852;var te=592;var ie=15;var ae=ie;function zswap32(e){return(e>>>24&255)+(e>>>8&65280)+((e&65280)<<8)+((e&255)<<24)}function InflateState(){this.mode=0;this.last=false;this.wrap=0;this.havedict=false;this.flags=0;this.dmax=0;this.check=0;this.total=0;this.head=null;this.wbits=0;this.wsize=0;this.whave=0;this.wnext=0;this.window=null;this.hold=0;this.bits=0;this.length=0;this.offset=0;this.extra=0;this.lencode=null;this.distcode=null;this.lenbits=0;this.distbits=0;this.ncode=0;this.nlen=0;this.ndist=0;this.have=0;this.next=null;this.lens=new a.Buf16(320);this.work=new a.Buf16(288);this.lendyn=null;this.distdyn=null;this.sane=0;this.back=0;this.was=0}function inflateResetKeep(e){var t;if(!e||!e.state){return w}t=e.state;e.total_in=e.total_out=t.total=0;e.msg="";if(t.wrap){e.adler=t.wrap&1}t.mode=y;t.last=0;t.havedict=0;t.dmax=32768;t.head=null;t.hold=0;t.bits=0;t.lencode=t.lendyn=new a.Buf32(ee);t.distcode=t.distdyn=new a.Buf32(te);t.sane=1;t.back=-1;return c}function inflateReset(e){var t;if(!e||!e.state){return w}t=e.state;t.wsize=0;t.whave=0;t.wnext=0;return inflateResetKeep(e)}function inflateReset2(e,t){var i;var a;if(!e||!e.state){return w}a=e.state;if(t<0){i=0;t=-t}else{i=(t>>4)+1;if(t<48){t&=15}}if(t&&(t<8||t>15)){return w}if(a.window!==null&&a.wbits!==t){a.window=null}a.wrap=i;a.wbits=t;return inflateReset(e)}function inflateInit2(e,t){var i;var a;if(!e){return w}a=new InflateState;e.state=a;a.window=null;i=inflateReset2(e,t);if(i!==c){e.state=null}return i}function inflateInit(e){return inflateInit2(e,ae)}var re=true;var ne,se;function fixedtables(e){if(re){var t;ne=new a.Buf32(512);se=new a.Buf32(32);t=0;while(t<144){e.lens[t++]=8}while(t<256){e.lens[t++]=9}while(t<280){e.lens[t++]=7}while(t<288){e.lens[t++]=8}l(o,e.lens,0,288,ne,0,e.work,{bits:9});t=0;while(t<32){e.lens[t++]=5}l(h,e.lens,0,32,se,0,e.work,{bits:5});re=false}e.lencode=ne;e.lenbits=9;e.distcode=se;e.distbits=5}function updatewindow(e,t,i,r){var n;var s=e.state;if(s.window===null){s.wsize=1<<s.wbits;s.wnext=0;s.whave=0;s.window=new a.Buf8(s.wsize)}if(r>=s.wsize){a.arraySet(s.window,t,i-s.wsize,s.wsize,0);s.wnext=0;s.whave=s.wsize}else{n=s.wsize-s.wnext;if(n>r){n=r}a.arraySet(s.window,t,i-r,n,s.wnext);r-=n;if(r){a.arraySet(s.window,t,i-r,r,0);s.wnext=r;s.whave=s.wsize}else{s.wnext+=n;if(s.wnext===s.wsize){s.wnext=0}if(s.whave<s.wsize){s.whave+=n}}}return 0}function inflate(e,t){var i;var ee,te;var ie;var ae;var re,ne;var se;var le;var fe,oe;var he;var _e;var de;var ue=0;var ce,ve,be;var we,pe,ge;var me;var ke;var ye=new a.Buf8(4);var Ee;var ze;var Ze=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&e.avail_in!==0){return w}i=e.state;if(i.mode===F){i.mode=N}ae=e.next_out;te=e.output;ne=e.avail_out;ie=e.next_in;ee=e.input;re=e.avail_in;se=i.hold;le=i.bits;fe=re;oe=ne;ke=c;e:for(;;){switch(i.mode){case y:if(i.wrap===0){i.mode=N;break}while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(i.wrap&2&&se===35615){i.check=0;ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0);se=0;le=0;i.mode=E;break}i.flags=0;if(i.head){i.head.done=false}if(!(i.wrap&1)||(((se&255)<<8)+(se>>8))%31){e.msg="incorrect header check";i.mode=J;break}if((se&15)!==k){e.msg="unknown compression method";i.mode=J;break}se>>>=4;le-=4;me=(se&15)+8;if(i.wbits===0){i.wbits=me}else if(me>i.wbits){e.msg="invalid window size";i.mode=J;break}i.dmax=1<<me;e.adler=i.check=1;i.mode=se&512?A:F;se=0;le=0;break;case E:while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.flags=se;if((i.flags&255)!==k){e.msg="unknown compression method";i.mode=J;break}if(i.flags&57344){e.msg="unknown header flags set";i.mode=J;break}if(i.head){i.head.text=se>>8&1}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0)}se=0;le=0;i.mode=z;case z:while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(i.head){i.head.time=se}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;ye[2]=se>>>16&255;ye[3]=se>>>24&255;i.check=n(i.check,ye,4,0)}se=0;le=0;i.mode=Z;case Z:while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(i.head){i.head.xflags=se&255;i.head.os=se>>8}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0)}se=0;le=0;i.mode=x;case x:if(i.flags&1024){while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.length=se;if(i.head){i.head.extra_len=se}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0)}se=0;le=0}else if(i.head){i.head.extra=null}i.mode=I;case I:if(i.flags&1024){he=i.length;if(he>re){he=re}if(he){if(i.head){me=i.head.extra_len-i.length;if(!i.head.extra){i.head.extra=new Array(i.head.extra_len)}a.arraySet(i.head.extra,ee,ie,he,me)}if(i.flags&512){i.check=n(i.check,ee,he,ie)}re-=he;ie+=he;i.length-=he}if(i.length){break e}}i.length=0;i.mode=R;case R:if(i.flags&2048){if(re===0){break e}he=0;do{me=ee[ie+he++];if(i.head&&me&&i.length<65536){i.head.name+=String.fromCharCode(me)}}while(me&&he<re);if(i.flags&512){i.check=n(i.check,ee,he,ie)}re-=he;ie+=he;if(me){break e}}else if(i.head){i.head.name=null}i.length=0;i.mode=S;case S:if(i.flags&4096){if(re===0){break e}he=0;do{me=ee[ie+he++];if(i.head&&me&&i.length<65536){i.head.comment+=String.fromCharCode(me)}}while(me&&he<re);if(i.flags&512){i.check=n(i.check,ee,he,ie)}re-=he;ie+=he;if(me){break e}}else if(i.head){i.head.comment=null}i.mode=L;case L:if(i.flags&512){while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(se!==(i.check&65535)){e.msg="header crc mismatch";i.mode=J;break}se=0;le=0}if(i.head){i.head.hcrc=i.flags>>9&1;i.head.done=true}e.adler=i.check=0;i.mode=F;break;case A:while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}e.adler=i.check=zswap32(se);se=0;le=0;i.mode=T;case T:if(i.havedict===0){e.next_out=ae;e.avail_out=ne;e.next_in=ie;e.avail_in=re;i.hold=se;i.bits=le;return b}e.adler=i.check=1;i.mode=F;case F:if(t===d||t===u){break e}case N:if(i.last){se>>>=le&7;le-=le&7;i.mode=X;break}while(le<3){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.last=se&1;se>>>=1;le-=1;switch(se&3){case 0:i.mode=D;break;case 1:fixedtables(i);i.mode=G;if(t===u){se>>>=2;le-=2;break e}break;case 2:i.mode=O;break;case 3:e.msg="invalid block type";i.mode=J}se>>>=2;le-=2;break;case D:se>>>=le&7;le-=le&7;while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if((se&65535)!==(se>>>16^65535)){e.msg="invalid stored block lengths";i.mode=J;break}i.length=se&65535;se=0;le=0;i.mode=B;if(t===u){break e}case B:i.mode=U;case U:he=i.length;if(he){if(he>re){he=re}if(he>ne){he=ne}if(he===0){break e}a.arraySet(te,ee,ie,he,ae);re-=he;ie+=he;ne-=he;ae+=he;i.length-=he;break}i.mode=F;break;case O:while(le<14){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.nlen=(se&31)+257;se>>>=5;le-=5;i.ndist=(se&31)+1;se>>>=5;le-=5;i.ncode=(se&15)+4;se>>>=4;le-=4;if(i.nlen>286||i.ndist>30){e.msg="too many length or distance symbols";i.mode=J;break}i.have=0;i.mode=M;case M:while(i.have<i.ncode){while(le<3){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.lens[Ze[i.have++]]=se&7;se>>>=3;le-=3}while(i.have<19){i.lens[Ze[i.have++]]=0}i.lencode=i.lendyn;i.lenbits=7;Ee={bits:i.lenbits};ke=l(f,i.lens,0,19,i.lencode,0,i.work,Ee);i.lenbits=Ee.bits;if(ke){e.msg="invalid code lengths set";i.mode=J;break}i.have=0;i.mode=C;case C:while(i.have<i.nlen+i.ndist){for(;;){ue=i.lencode[se&(1<<i.lenbits)-1];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(be<16){se>>>=ce;le-=ce;i.lens[i.have++]=be}else{if(be===16){ze=ce+2;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=ce;le-=ce;if(i.have===0){e.msg="invalid bit length repeat";i.mode=J;break}me=i.lens[i.have-1];he=3+(se&3);se>>>=2;le-=2}else if(be===17){ze=ce+3;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=ce;le-=ce;me=0;he=3+(se&7);se>>>=3;le-=3}else{ze=ce+7;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=ce;le-=ce;me=0;he=11+(se&127);se>>>=7;le-=7}if(i.have+he>i.nlen+i.ndist){e.msg="invalid bit length repeat";i.mode=J;break}while(he--){i.lens[i.have++]=me}}}if(i.mode===J){break}if(i.lens[256]===0){e.msg="invalid code -- missing end-of-block";i.mode=J;break}i.lenbits=9;Ee={bits:i.lenbits};ke=l(o,i.lens,0,i.nlen,i.lencode,0,i.work,Ee);i.lenbits=Ee.bits;if(ke){e.msg="invalid literal/lengths set";i.mode=J;break}i.distbits=6;i.distcode=i.distdyn;Ee={bits:i.distbits};ke=l(h,i.lens,i.nlen,i.ndist,i.distcode,0,i.work,Ee);i.distbits=Ee.bits;if(ke){e.msg="invalid distances set";i.mode=J;break}i.mode=G;if(t===u){break e}case G:i.mode=H;case H:if(re>=6&&ne>=258){e.next_out=ae;e.avail_out=ne;e.next_in=ie;e.avail_in=re;i.hold=se;i.bits=le;s(e,oe);ae=e.next_out;te=e.output;ne=e.avail_out;ie=e.next_in;ee=e.input;re=e.avail_in;se=i.hold;le=i.bits;if(i.mode===F){i.back=-1}break}i.back=0;for(;;){ue=i.lencode[se&(1<<i.lenbits)-1];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(ve&&(ve&240)===0){we=ce;pe=ve;ge=be;for(;;){ue=i.lencode[ge+((se&(1<<we+pe)-1)>>we)];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(we+ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=we;le-=we;i.back+=we}se>>>=ce;le-=ce;i.back+=ce;i.length=be;if(ve===0){i.mode=q;break}if(ve&32){i.back=-1;i.mode=F;break}if(ve&64){e.msg="invalid literal/length code";i.mode=J;break}i.extra=ve&15;i.mode=P;case P:if(i.extra){ze=i.extra;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.length+=se&(1<<i.extra)-1;se>>>=i.extra;le-=i.extra;i.back+=i.extra}i.was=i.length;i.mode=K;case K:for(;;){ue=i.distcode[se&(1<<i.distbits)-1];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if((ve&240)===0){we=ce;pe=ve;ge=be;for(;;){ue=i.distcode[ge+((se&(1<<we+pe)-1)>>we)];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(we+ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=we;le-=we;i.back+=we}se>>>=ce;le-=ce;i.back+=ce;if(ve&64){e.msg="invalid distance code";i.mode=J;break}i.offset=be;i.extra=ve&15;i.mode=W;case W:if(i.extra){ze=i.extra;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.offset+=se&(1<<i.extra)-1;se>>>=i.extra;le-=i.extra;i.back+=i.extra}if(i.offset>i.dmax){e.msg="invalid distance too far back";i.mode=J;break}i.mode=V;case V:if(ne===0){break e}he=oe-ne;if(i.offset>he){he=i.offset-he;if(he>i.whave){if(i.sane){e.msg="invalid distance too far back";i.mode=J;break}}if(he>i.wnext){he-=i.wnext;_e=i.wsize-he}else{_e=i.wnext-he}if(he>i.length){he=i.length}de=i.window}else{de=te;_e=ae-i.offset;he=i.length}if(he>ne){he=ne}ne-=he;i.length-=he;do{te[ae++]=de[_e++]}while(--he);if(i.length===0){i.mode=H}break;case q:if(ne===0){break e}te[ae++]=i.length;ne--;i.mode=H;break;case X:if(i.wrap){while(le<32){if(re===0){break e}re--;se|=ee[ie++]<<le;le+=8}oe-=ne;e.total_out+=oe;i.total+=oe;if(oe){e.adler=i.check=i.flags?n(i.check,te,oe,ae-oe):r(i.check,te,oe,ae-oe)}oe=ne;if((i.flags?se:zswap32(se))!==i.check){e.msg="incorrect data check";i.mode=J;break}se=0;le=0}i.mode=Y;case Y:if(i.wrap&&i.flags){while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(se!==(i.total&4294967295)){e.msg="incorrect length check";i.mode=J;break}se=0;le=0}i.mode=j;case j:ke=v;break e;case J:ke=p;break e;case Q:return g;case $:default:return w}}e.next_out=ae;e.avail_out=ne;e.next_in=ie;e.avail_in=re;i.hold=se;i.bits=le;if(i.wsize||oe!==e.avail_out&&i.mode<J&&(i.mode<X||t!==_)){if(updatewindow(e,e.output,e.next_out,oe-e.avail_out)){i.mode=Q;return g}}fe-=e.avail_in;oe-=e.avail_out;e.total_in+=fe;e.total_out+=oe;i.total+=oe;if(i.wrap&&oe){e.adler=i.check=i.flags?n(i.check,te,oe,e.next_out-oe):r(i.check,te,oe,e.next_out-oe)}e.data_type=i.bits+(i.last?64:0)+(i.mode===F?128:0)+(i.mode===G||i.mode===B?256:0);if((fe===0&&oe===0||t===_)&&ke===c){ke=m}return ke}function inflateEnd(e){if(!e||!e.state){return w}var t=e.state;if(t.window){t.window=null}e.state=null;return c}function inflateGetHeader(e,t){var i;if(!e||!e.state){return w}i=e.state;if((i.wrap&2)===0){return w}i.head=t;t.done=false;return c}function inflateSetDictionary(e,t){var i=t.length;var a;var n;var s;if(!e||!e.state){return w}a=e.state;if(a.wrap!==0&&a.mode!==T){return w}if(a.mode===T){n=1;n=r(n,t,i,0);if(n!==a.check){return p}}s=updatewindow(e,t,i,i);if(s){a.mode=Q;return g}a.havedict=1;return c}t.inflateReset=inflateReset;t.inflateReset2=inflateReset2;t.inflateResetKeep=inflateResetKeep;t.inflateInit=inflateInit;t.inflateInit2=inflateInit2;t.inflate=inflate;t.inflateEnd=inflateEnd;t.inflateGetHeader=inflateGetHeader;t.inflateSetDictionary=inflateSetDictionary;t.inflateInfo="pako inflate (from Nodeca project)"},19:function(e,t,i){var a=i(380);var r=15;var n=852;var s=592;var l=0;var f=1;var o=2;var h=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0];var _=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78];var d=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0];var u=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];e.exports=function inflate_table(e,t,i,c,v,b,w,p){var g=p.bits;var m=0;var k=0;var y=0,E=0;var z=0;var Z=0;var x=0;var I=0;var R=0;var S=0;var L;var A;var T;var F;var N;var D=null;var B=0;var U;var O=new a.Buf16(r+1);var M=new a.Buf16(r+1);var C=null;var G=0;var H,P,K;for(m=0;m<=r;m++){O[m]=0}for(k=0;k<c;k++){O[t[i+k]]++}z=g;for(E=r;E>=1;E--){if(O[E]!==0){break}}if(z>E){z=E}if(E===0){v[b++]=1<<24|64<<16|0;v[b++]=1<<24|64<<16|0;p.bits=1;return 0}for(y=1;y<E;y++){if(O[y]!==0){break}}if(z<y){z=y}I=1;for(m=1;m<=r;m++){I<<=1;I-=O[m];if(I<0){return-1}}if(I>0&&(e===l||E!==1)){return-1}M[1]=0;for(m=1;m<r;m++){M[m+1]=M[m]+O[m]}for(k=0;k<c;k++){if(t[i+k]!==0){w[M[t[i+k]]++]=k}}if(e===l){D=C=w;U=19}else if(e===f){D=h;B-=257;C=_;G-=257;U=256}else{D=d;C=u;U=-1}S=0;k=0;m=y;N=b;Z=z;x=0;T=-1;R=1<<z;F=R-1;if(e===f&&R>n||e===o&&R>s){return 1}for(;;){H=m-x;if(w[k]<U){P=0;K=w[k]}else if(w[k]>U){P=C[G+w[k]];K=D[B+w[k]]}else{P=32+64;K=0}L=1<<m-x;A=1<<Z;y=A;do{A-=L;v[N+(S>>x)+A]=H<<24|P<<16|K|0}while(A!==0);L=1<<m-1;while(S&L){L>>=1}if(L!==0){S&=L-1;S+=L}else{S=0}k++;if(--O[m]===0){if(m===E){break}m=t[i+w[k]]}if(m>z&&(S&F)!==T){if(x===0){x=z}N+=y;Z=m-x;I=1<<Z;while(Z+x<E){I-=O[Z+x];if(I<=0){break}Z++;I<<=1}R+=1<<Z;if(e===f&&R>n||e===o&&R>s){return 1}T=S&F;v[T]=z<<24|Z<<16|N-b|0}}if(S!==0){v[N+S]=m-x<<24|64<<16|0}p.bits=z;return 0}},31:function(e){e.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},842:function(e,t,i){var a=i(380);var r=4;var n=0;var s=1;var l=2;function zero(e){var t=e.length;while(--t>=0){e[t]=0}}var f=0;var o=1;var h=2;var _=3;var d=258;var u=29;var c=256;var v=c+1+u;var b=30;var w=19;var p=2*v+1;var g=15;var m=16;var k=7;var y=256;var E=16;var z=17;var Z=18;var x=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];var I=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];var R=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];var S=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];var L=512;var A=new Array((v+2)*2);zero(A);var T=new Array(b*2);zero(T);var F=new Array(L);zero(F);var N=new Array(d-_+1);zero(N);var D=new Array(u);zero(D);var B=new Array(b);zero(B);function StaticTreeDesc(e,t,i,a,r){this.static_tree=e;this.extra_bits=t;this.extra_base=i;this.elems=a;this.max_length=r;this.has_stree=e&&e.length}var U;var O;var M;function TreeDesc(e,t){this.dyn_tree=e;this.max_code=0;this.stat_desc=t}function d_code(e){return e<256?F[e]:F[256+(e>>>7)]}function put_short(e,t){e.pending_buf[e.pending++]=t&255;e.pending_buf[e.pending++]=t>>>8&255}function send_bits(e,t,i){if(e.bi_valid>m-i){e.bi_buf|=t<<e.bi_valid&65535;put_short(e,e.bi_buf);e.bi_buf=t>>m-e.bi_valid;e.bi_valid+=i-m}else{e.bi_buf|=t<<e.bi_valid&65535;e.bi_valid+=i}}function send_code(e,t,i){send_bits(e,i[t*2],i[t*2+1])}function bi_reverse(e,t){var i=0;do{i|=e&1;e>>>=1;i<<=1}while(--t>0);return i>>>1}function bi_flush(e){if(e.bi_valid===16){put_short(e,e.bi_buf);e.bi_buf=0;e.bi_valid=0}else if(e.bi_valid>=8){e.pending_buf[e.pending++]=e.bi_buf&255;e.bi_buf>>=8;e.bi_valid-=8}}function gen_bitlen(e,t){var i=t.dyn_tree;var a=t.max_code;var r=t.stat_desc.static_tree;var n=t.stat_desc.has_stree;var s=t.stat_desc.extra_bits;var l=t.stat_desc.extra_base;var f=t.stat_desc.max_length;var o;var h,_;var d;var u;var c;var v=0;for(d=0;d<=g;d++){e.bl_count[d]=0}i[e.heap[e.heap_max]*2+1]=0;for(o=e.heap_max+1;o<p;o++){h=e.heap[o];d=i[i[h*2+1]*2+1]+1;if(d>f){d=f;v++}i[h*2+1]=d;if(h>a){continue}e.bl_count[d]++;u=0;if(h>=l){u=s[h-l]}c=i[h*2];e.opt_len+=c*(d+u);if(n){e.static_len+=c*(r[h*2+1]+u)}}if(v===0){return}do{d=f-1;while(e.bl_count[d]===0){d--}e.bl_count[d]--;e.bl_count[d+1]+=2;e.bl_count[f]--;v-=2}while(v>0);for(d=f;d!==0;d--){h=e.bl_count[d];while(h!==0){_=e.heap[--o];if(_>a){continue}if(i[_*2+1]!==d){e.opt_len+=(d-i[_*2+1])*i[_*2];i[_*2+1]=d}h--}}}function gen_codes(e,t,i){var a=new Array(g+1);var r=0;var n;var s;for(n=1;n<=g;n++){a[n]=r=r+i[n-1]<<1}for(s=0;s<=t;s++){var l=e[s*2+1];if(l===0){continue}e[s*2]=bi_reverse(a[l]++,l)}}function tr_static_init(){var e;var t;var i;var a;var r;var n=new Array(g+1);i=0;for(a=0;a<u-1;a++){D[a]=i;for(e=0;e<1<<x[a];e++){N[i++]=a}}N[i-1]=a;r=0;for(a=0;a<16;a++){B[a]=r;for(e=0;e<1<<I[a];e++){F[r++]=a}}r>>=7;for(;a<b;a++){B[a]=r<<7;for(e=0;e<1<<I[a]-7;e++){F[256+r++]=a}}for(t=0;t<=g;t++){n[t]=0}e=0;while(e<=143){A[e*2+1]=8;e++;n[8]++}while(e<=255){A[e*2+1]=9;e++;n[9]++}while(e<=279){A[e*2+1]=7;e++;n[7]++}while(e<=287){A[e*2+1]=8;e++;n[8]++}gen_codes(A,v+1,n);for(e=0;e<b;e++){T[e*2+1]=5;T[e*2]=bi_reverse(e,5)}U=new StaticTreeDesc(A,x,c+1,v,g);O=new StaticTreeDesc(T,I,0,b,g);M=new StaticTreeDesc(new Array(0),R,0,w,k)}function init_block(e){var t;for(t=0;t<v;t++){e.dyn_ltree[t*2]=0}for(t=0;t<b;t++){e.dyn_dtree[t*2]=0}for(t=0;t<w;t++){e.bl_tree[t*2]=0}e.dyn_ltree[y*2]=1;e.opt_len=e.static_len=0;e.last_lit=e.matches=0}function bi_windup(e){if(e.bi_valid>8){put_short(e,e.bi_buf)}else if(e.bi_valid>0){e.pending_buf[e.pending++]=e.bi_buf}e.bi_buf=0;e.bi_valid=0}function copy_block(e,t,i,r){bi_windup(e);if(r){put_short(e,i);put_short(e,~i)}a.arraySet(e.pending_buf,e.window,t,i,e.pending);e.pending+=i}function smaller(e,t,i,a){var r=t*2;var n=i*2;return e[r]<e[n]||e[r]===e[n]&&a[t]<=a[i]}function pqdownheap(e,t,i){var a=e.heap[i];var r=i<<1;while(r<=e.heap_len){if(r<e.heap_len&&smaller(t,e.heap[r+1],e.heap[r],e.depth)){r++}if(smaller(t,a,e.heap[r],e.depth)){break}e.heap[i]=e.heap[r];i=r;r<<=1}e.heap[i]=a}function compress_block(e,t,i){var a;var r;var n=0;var s;var l;if(e.last_lit!==0){do{a=e.pending_buf[e.d_buf+n*2]<<8|e.pending_buf[e.d_buf+n*2+1];r=e.pending_buf[e.l_buf+n];n++;if(a===0){send_code(e,r,t)}else{s=N[r];send_code(e,s+c+1,t);l=x[s];if(l!==0){r-=D[s];send_bits(e,r,l)}a--;s=d_code(a);send_code(e,s,i);l=I[s];if(l!==0){a-=B[s];send_bits(e,a,l)}}}while(n<e.last_lit)}send_code(e,y,t)}function build_tree(e,t){var i=t.dyn_tree;var a=t.stat_desc.static_tree;var r=t.stat_desc.has_stree;var n=t.stat_desc.elems;var s,l;var f=-1;var o;e.heap_len=0;e.heap_max=p;for(s=0;s<n;s++){if(i[s*2]!==0){e.heap[++e.heap_len]=f=s;e.depth[s]=0}else{i[s*2+1]=0}}while(e.heap_len<2){o=e.heap[++e.heap_len]=f<2?++f:0;i[o*2]=1;e.depth[o]=0;e.opt_len--;if(r){e.static_len-=a[o*2+1]}}t.max_code=f;for(s=e.heap_len>>1;s>=1;s--){pqdownheap(e,i,s)}o=n;do{s=e.heap[1];e.heap[1]=e.heap[e.heap_len--];pqdownheap(e,i,1);l=e.heap[1];e.heap[--e.heap_max]=s;e.heap[--e.heap_max]=l;i[o*2]=i[s*2]+i[l*2];e.depth[o]=(e.depth[s]>=e.depth[l]?e.depth[s]:e.depth[l])+1;i[s*2+1]=i[l*2+1]=o;e.heap[1]=o++;pqdownheap(e,i,1)}while(e.heap_len>=2);e.heap[--e.heap_max]=e.heap[1];gen_bitlen(e,t);gen_codes(i,f,e.bl_count)}function scan_tree(e,t,i){var a;var r=-1;var n;var s=t[0*2+1];var l=0;var f=7;var o=4;if(s===0){f=138;o=3}t[(i+1)*2+1]=65535;for(a=0;a<=i;a++){n=s;s=t[(a+1)*2+1];if(++l<f&&n===s){continue}else if(l<o){e.bl_tree[n*2]+=l}else if(n!==0){if(n!==r){e.bl_tree[n*2]++}e.bl_tree[E*2]++}else if(l<=10){e.bl_tree[z*2]++}else{e.bl_tree[Z*2]++}l=0;r=n;if(s===0){f=138;o=3}else if(n===s){f=6;o=3}else{f=7;o=4}}}function send_tree(e,t,i){var a;var r=-1;var n;var s=t[0*2+1];var l=0;var f=7;var o=4;if(s===0){f=138;o=3}for(a=0;a<=i;a++){n=s;s=t[(a+1)*2+1];if(++l<f&&n===s){continue}else if(l<o){do{send_code(e,n,e.bl_tree)}while(--l!==0)}else if(n!==0){if(n!==r){send_code(e,n,e.bl_tree);l--}send_code(e,E,e.bl_tree);send_bits(e,l-3,2)}else if(l<=10){send_code(e,z,e.bl_tree);send_bits(e,l-3,3)}else{send_code(e,Z,e.bl_tree);send_bits(e,l-11,7)}l=0;r=n;if(s===0){f=138;o=3}else if(n===s){f=6;o=3}else{f=7;o=4}}}function build_bl_tree(e){var t;scan_tree(e,e.dyn_ltree,e.l_desc.max_code);scan_tree(e,e.dyn_dtree,e.d_desc.max_code);build_tree(e,e.bl_desc);for(t=w-1;t>=3;t--){if(e.bl_tree[S[t]*2+1]!==0){break}}e.opt_len+=3*(t+1)+5+5+4;return t}function send_all_trees(e,t,i,a){var r;send_bits(e,t-257,5);send_bits(e,i-1,5);send_bits(e,a-4,4);for(r=0;r<a;r++){send_bits(e,e.bl_tree[S[r]*2+1],3)}send_tree(e,e.dyn_ltree,t-1);send_tree(e,e.dyn_dtree,i-1)}function detect_data_type(e){var t=4093624447;var i;for(i=0;i<=31;i++,t>>>=1){if(t&1&&e.dyn_ltree[i*2]!==0){return n}}if(e.dyn_ltree[9*2]!==0||e.dyn_ltree[10*2]!==0||e.dyn_ltree[13*2]!==0){return s}for(i=32;i<c;i++){if(e.dyn_ltree[i*2]!==0){return s}}return n}var C=false;function _tr_init(e){if(!C){tr_static_init();C=true}e.l_desc=new TreeDesc(e.dyn_ltree,U);e.d_desc=new TreeDesc(e.dyn_dtree,O);e.bl_desc=new TreeDesc(e.bl_tree,M);e.bi_buf=0;e.bi_valid=0;init_block(e)}function _tr_stored_block(e,t,i,a){send_bits(e,(f<<1)+(a?1:0),3);copy_block(e,t,i,true)}function _tr_align(e){send_bits(e,o<<1,3);send_code(e,y,A);bi_flush(e)}function _tr_flush_block(e,t,i,a){var n,s;var f=0;if(e.level>0){if(e.strm.data_type===l){e.strm.data_type=detect_data_type(e)}build_tree(e,e.l_desc);build_tree(e,e.d_desc);f=build_bl_tree(e);n=e.opt_len+3+7>>>3;s=e.static_len+3+7>>>3;if(s<=n){n=s}}else{n=s=i+5}if(i+4<=n&&t!==-1){_tr_stored_block(e,t,i,a)}else if(e.strategy===r||s===n){send_bits(e,(o<<1)+(a?1:0),3);compress_block(e,A,T)}else{send_bits(e,(h<<1)+(a?1:0),3);send_all_trees(e,e.l_desc.max_code+1,e.d_desc.max_code+1,f+1);compress_block(e,e.dyn_ltree,e.dyn_dtree)}init_block(e);if(a){bi_windup(e)}}function _tr_tally(e,t,i){e.pending_buf[e.d_buf+e.last_lit*2]=t>>>8&255;e.pending_buf[e.d_buf+e.last_lit*2+1]=t&255;e.pending_buf[e.l_buf+e.last_lit]=i&255;e.last_lit++;if(t===0){e.dyn_ltree[i*2]++}else{e.matches++;t--;e.dyn_ltree[(N[i]+c+1)*2]++;e.dyn_dtree[d_code(t)*2]++}return e.last_lit===e.lit_bufsize-1}t._tr_init=_tr_init;t._tr_stored_block=_tr_stored_block;t._tr_flush_block=_tr_flush_block;t._tr_tally=_tr_tally;t._tr_align=_tr_align},562:function(e){function ZStream(){this.input=null;this.next_in=0;this.avail_in=0;this.total_in=0;this.output=null;this.next_out=0;this.avail_out=0;this.total_out=0;this.msg="";this.state=null;this.data_type=2;this.adler=0}e.exports=ZStream},491:function(e){e.exports=__webpack_require__(39619)},300:function(e){e.exports=__webpack_require__(30816)},781:function(e){e.exports=__webpack_require__(4957)},837:function(e){e.exports=__webpack_require__(71323)}};var t={};function __nccwpck_require__(i){var a=t[i];if(a!==undefined){return a.exports}var r=t[i]={exports:{}};var n=true;try{e[i](r,r.exports,__nccwpck_require__);n=false}finally{if(n)delete t[i]}return r.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var i=__nccwpck_require__(23);module.exports=i})();

/***/ }),

/***/ 88734:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 33906:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"Accordion_root___ycJw","toggling-disabled":"Accordion_toggling-disabled__UaK2m","head":"Accordion_head__xOAno","body":"Accordion_body__bqueB"};

/***/ }),

/***/ 39244:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","adventistContainer":"AdventistContainer_adventistContainer__clHnh","adventistIconContainer":"AdventistContainer_adventistIconContainer__W3k9Q","footerADVIcon":"AdventistContainer_footerADVIcon__3_Efs"};

/***/ }),

/***/ 7862:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"arrow-icon":"arrow-icon_arrow-icon__OMC5G","up":"arrow-icon_up__ro_2F","down":"arrow-icon_down__aAP7m","right":"arrow-icon_right__opY6c","left":"arrow-icon_left__kSDkA"};

/***/ }),

/***/ 95778:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"backdrop_backdrop___uG7z","not-clickable":"backdrop_not-clickable__PO_XW"};

/***/ }),

/***/ 53131:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge-wrap":"Badge_badge-wrap__cDTMB","badge-text":"Badge_badge-text__jx0NS"};

/***/ }),

/***/ 88484:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge-offline":"BadgeOffline_badge-offline__SiOiC"};

/***/ }),

/***/ 96468:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"BreadCrumbs_root__rWoq1"};

/***/ }),

/***/ 48804:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","btn":"Button_btn___dWY2","active":"Button_active__60o1W","roboto":"Button_roboto__Mz_Cz","with-custom-ctx-menu":"Button_with-custom-ctx-menu___rbok","clear":"Button_clear__zN_xv","gray-dark":"Button_gray-dark__Ip9z6","icon":"Button_icon__rDvw_","light":"Button_light___F02T","primary":"Button_primary__qr8Lf","secondary":"Button_secondary__6Teto","quaternary":"Button_quaternary___Nhkn","search-section-primary":"Button_search-section-primary__RFEMn","header-item":"Button_header-item__kE_rU","egw":"Button_egw__TeD1H","references":"Button_references__GKKxp","apl":"Button_apl__RKOXW","bible":"Button_bible__rC80n","link":"Button_link__F87gN","disabled":"Button_disabled__DNsNd","default":"Button_default__NjLb_","tertiary":"Button_tertiary__PLecZ","outline":"Button_outline__I41a_","small":"Button_small__IDzxY","medium":"Button_medium__SidzD","big":"Button_big__EtZiV","min-width_md":"Button_min-width_md__PC8ok","min-width_lg":"Button_min-width_lg__RRzhx","padding-less":"Button_padding-less__9bmHE","mode-blind":"Button_mode-blind__pBfxC"};

/***/ }),

/***/ 31089:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon":"ButtonMore_icon__zRsW0","is-less":"ButtonMore_is-less__wpCsk"};

/***/ }),

/***/ 28903:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root-icon-btn":"close-button_root-icon-btn__23k0E","btn-close":"close-button_btn-close__6Y2BI","btn-close__text":"close-button_btn-close__text__EoX3x"};

/***/ }),

/***/ 63758:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Ripple_root__FI8op","dark":"Ripple_dark__nrylw","ripple":"Ripple_ripple__YTqMP","pressed":"Ripple_pressed__Axou4","released":"Ripple_released__BGniJ"};

/***/ }),

/***/ 59954:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"ThemeButton_btn__g0rms","icon":"ThemeButton_icon__MoeqE","is-dark-theme":"ThemeButton_is-dark-theme__1sLlO"};

/***/ }),

/***/ 64235:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","checkbox-item":"Checkbox_checkbox-item__Qa25q","is-inline":"Checkbox_is-inline__74raj","wrap-checkmark":"Checkbox_wrap-checkmark__8i9fs","label":"Checkbox_label__dZ4SU","part-checked":"Checkbox_part-checked__iHge8","checked":"Checkbox_checked__6tIaR","checkmark":"Checkbox_checkmark__azrVk","bounceScale":"Checkbox_bounceScale__ba_QT","disabled":"Checkbox_disabled__k55Li","input":"Checkbox_input__GiYNu","is-last-input-mouse":"Checkbox_is-last-input-mouse__sFvfB","focused":"Checkbox_focused__KbYoY"};

/***/ }),

/***/ 88478:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__ySxqX"};

/***/ }),

/***/ 20122:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"DividerVertical_root__gqpV7"};

/***/ }),

/***/ 15644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"base-drop-down":"dropDown_base-drop-down__x2KNf"};

/***/ }),

/***/ 11289:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"EGWSlider_root__KNkEN","disabled":"EGWSlider_disabled__gRYuh","draggable-only-thumb":"EGWSlider_draggable-only-thumb__gwOXB","track":"EGWSlider_track__7Nk1w"};

/***/ }),

/***/ 71984:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","featured-section__item":"FeaturedSectionContent_featured-section__item__Vo_r3","featured-section__image":"FeaturedSectionContent_featured-section__image__sNeDt","featured-section__title":"FeaturedSectionContent_featured-section__title__eiXsj","featured-section__title-text":"FeaturedSectionContent_featured-section__title-text__wW9mw","featured-section__links":"FeaturedSectionContent_featured-section__links__UlXvv","hidden":"FeaturedSectionContent_hidden__cjLt_","featured-section__link":"FeaturedSectionContent_featured-section__link__r8XcO","featured-section__link-text":"FeaturedSectionContent_featured-section__link-text__M1ZAP","btn-more":"FeaturedSectionContent_btn-more__Cnc8X","mode-tablet":"FeaturedSectionContent_mode-tablet__Sf75_","mode-mobile":"FeaturedSectionContent_mode-mobile__GXyYA"};

/***/ }),

/***/ 23886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterAlphabet_root__s5Ij2","horizontal":"FilterAlphabet_horizontal__NoVYP","vertical":"FilterAlphabet_vertical__oDfgS","inner":"FilterAlphabet_inner__D9IIr","popup-inner":"FilterAlphabet_popup-inner___Z7HR"};

/***/ }),

/***/ 21571:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","float-window":"FloatWindow_float-window__EhmRD","dragging":"FloatWindow_dragging__41kvR"};

/***/ }),

/***/ 64501:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"IconButton_root__OPepv","header-item":"IconButton_header-item___cyCX","active":"IconButton_active__mOLug","disabled":"IconButton_disabled__vgGfM","text-only":"IconButton_text-only__wlPGd","bordered":"IconButton_bordered__5tJKP","mode-blind":"IconButton_mode-blind__dHjdh","is-last-input-mouse":"IconButton_is-last-input-mouse__3lhKR"};

/***/ }),

/***/ 49616:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","input":"Input_input__j_2jC","root":"Input_root__EzBTK","has-placeholder-color-active":"Input_has-placeholder-color-active__R3fjM","disabled":"Input_disabled__mBfAC","rounded":"Input_rounded__7VMEg","read-only":"Input_read-only__WNKPP","sm":"Input_sm__TyGKz","is-direction-column":"Input_is-direction-column__2ZKiQ","has-slot-before":"Input_has-slot-before__DydiS","has-slot-after":"Input_has-slot-after__K30pg","default":"Input_default__AZlBe","active":"Input_active__PM7vc","search":"Input_search__HRO8O","oneWord":"Input_oneWord__3qlIl","mode-blind":"Input_mode-blind__BMig9"};

/***/ }),

/***/ 74954:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loader-wrap":"Loader_loader-wrap__eyw71","position-absolute":"Loader_position-absolute__Yu7FJ","flex-center":"Loader_flex-center__RfJXI","hor-center":"Loader_hor-center__isD_p"};

/***/ }),

/***/ 15445:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","logo-container":"Logotype_logo-container__mmyat","logo-content":"Logotype_logo-content__p7OGN","logo":"Logotype_logo__wMYWo","logo-content-text":"Logotype_logo-content-text__sUaHH","logo-content-copyright":"Logotype_logo-content-copyright__Hhmoc","logo-top-container":"Logotype_logo-top-container__WiX9g","logo-container-links":"Logotype_logo-container-links__Tr_sU","logo-link":"Logotype_logo-link__9nk_a","logo-content-app-name":"Logotype_logo-content-app-name__P71cb","mobile-search-form-visible":"Logotype_mobile-search-form-visible__9vMBG","is-last-input-mouse":"Logotype_is-last-input-mouse__MCmRN"};

/***/ }),

/***/ 49946:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialog-player-behaviour":"PlayerBehaviourDialog_dialog-player-behaviour__N_LdN","dialog-player-behaviour__buttons":"PlayerBehaviourDialog_dialog-player-behaviour__buttons__aRPq4","dialog-player-behaviour__checkbox":"PlayerBehaviourDialog_dialog-player-behaviour__checkbox__BSHXV"};

/***/ }),

/***/ 50919:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"popup_root__7UYwp","ready-to-show":"popup_ready-to-show__O2NxH","content":"popup_content__rG6wW","pointer":"popup_pointer__hhQnY","left-top":"popup_left-top__BTBlf","right-top":"popup_right-top__TN9H_","left-bottom":"popup_left-bottom__pXxm4","right-bottom":"popup_right-bottom__35yCD","backdrop":"popup_backdrop__W17BX","animationFadeIn":"popup_animationFadeIn__UpNOM","mode-blind":"popup_mode-blind__f8C25","arrow-loading":"popup_arrow-loading__oqKPX","animationSlideInLeft":"popup_animationSlideInLeft__jjlsZ","animationSlideInRight":"popup_animationSlideInRight__5kC4l","animationFade":"popup_animationFade__IKAtn"};

/***/ }),

/***/ 37936:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"Progress_md__cKUjm","lg":"1024","root":"Progress_root__TsFiN","disabled":"Progress_disabled__TS3vY","track":"Progress_track__5FPzD","sm":"Progress_sm__P0Joo","progress":"Progress_progress__UfVjN","thumb":"Progress_thumb__TvVyV"};

/***/ }),

/***/ 9821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","radio-item":"RadioButton_radio-item__KV2pn","is-inline":"RadioButton_is-inline___f2w3","wrap-check":"RadioButton_wrap-check__R84B2","label":"RadioButton_label__70WxL","active":"RadioButton_active__FGVqu","bounceIn":"RadioButton_bounceIn__egDtA","bounceScale":"RadioButton_bounceScale__u7h74","inactive":"RadioButton_inactive__YhViD","disabled":"RadioButton_disabled__5IvnP","input":"RadioButton_input__f21Fc","icon":"RadioButton_icon__My843","is-last-input-mouse":"RadioButton_is-last-input-mouse__FINtP","mode-blind":"RadioButton_mode-blind__Kw6zR","focused":"RadioButton_focused__Xs3hR"};

/***/ }),

/***/ 65408:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"group-name":"RadioGroup_group-name__Q1oEz","form-group-col2":"RadioGroup_form-group-col2___04XM","CheckboxGroup":"RadioGroup_CheckboxGroup__GpeZe","RadioGroup":"RadioGroup_RadioGroup__M7p9_","form-group-col3":"RadioGroup_form-group-col3__TEc6R"};

/***/ }),

/***/ 97004:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","scrollbars-wrapper":"Scroll_scrollbars-wrapper__BIqaL","scrollbars-render-view":"Scroll_scrollbars-render-view__A8E7_","mode-mobile":"Scroll_mode-mobile__VYgiq","has-static-position":"Scroll_has-static-position__9KFrz","gap-for-scrollbar":"Scroll_gap-for-scrollbar__K3FGE","scrollStyle":"Scroll_scrollStyle__mceWw","scrollMainTrack":"Scroll_scrollMainTrack__Alr5D","is-last-input-mouse":"Scroll_is-last-input-mouse__f5PAP"};

/***/ }),

/***/ 8492:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"SearchAccordionItem_root__eJT1e","disabled":"SearchAccordionItem_disabled__tYZCH","primary":"SearchAccordionItem_primary__BqCia","active":"SearchAccordionItem_active__9wKB_","tertiary":"SearchAccordionItem_tertiary__A_mDz","badge-wrap":"SearchAccordionItem_badge-wrap__otMtQ","mode-blind":"SearchAccordionItem_mode-blind__NwrCK","badge-text":"SearchAccordionItem_badge-text__HXbbB","is-last-input-mouse":"SearchAccordionItem_is-last-input-mouse__bHPXy","item-text":"SearchAccordionItem_item-text__ZK020"};

/***/ }),

/***/ 2809:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","actions":"SearchField_actions__4aUDu"};

/***/ }),

/***/ 21968:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"options-group-divider":"SelectBody_options-group-divider__yZXCY"};

/***/ }),

/***/ 35005:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectVariantIcon_root__d_PxX"};

/***/ }),

/***/ 85829:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectVariantInput_root__alhmT","justify-end":"SelectVariantInput_justify-end__y27XH","input":"SelectVariantInput_input__vfV9R","popup-content":"SelectVariantInput_popup-content__9Ysco"};

/***/ }),

/***/ 39513:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"SidePanel_root__6p_Y4","left":"SidePanel_left__WfZrT","content":"SidePanel_content__lTExd","right":"SidePanel_right__HNFwH","backdrop":"SidePanel_backdrop__sw1TG","animationFadeIn":"SidePanel_animationFadeIn___c1kn","prevent-cover-header":"SidePanel_prevent-cover-header__VTuM2","arrow-loading":"SidePanel_arrow-loading__zNn4D","animationSlideInLeft":"SidePanel_animationSlideInLeft__0DCgH","animationSlideInRight":"SidePanel_animationSlideInRight__9nkcH","animationFade":"SidePanel_animationFade__feMeP"};

/***/ }),

/***/ 34625:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","swipe-arrows":"SwipeArrows_swipe-arrows__IPmuM","inner":"SwipeArrows_inner__1vfgs","arrow":"SwipeArrows_arrow__AluRY","next":"SwipeArrows_next__B0TTK","shown":"SwipeArrows_shown__rOVQQ","prev":"SwipeArrows_prev__SH7so","is-last-input-mouse":"SwipeArrows_is-last-input-mouse__F8mHU"};

/***/ }),

/***/ 92289:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","tab":"Tab_tab__sgdbf","tab-like":"Tab_tab-like__7YAg4","active":"Tab_active__yszym","locked":"Tab_locked__LnPzQ","underlined":"Tab_underlined__WQAYz","primary":"Tab_primary__21Fw6","dark":"Tab_dark__ak6vH","search-section-primary":"Tab_search-section-primary__yqDke","sm":"Tab_sm__2LjJg","mode-blind":"Tab_mode-blind__EJ95_","inactive":"Tab_inactive__Vpjbw"};

/***/ }),

/***/ 2561:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"TabBar_root__SoFxN","align-left":"TabBar_align-left__a7ey6","tab-size-sm":"TabBar_tab-size-sm__HckB1","divider":"TabBar_divider__xrUfx"};

/***/ }),

/***/ 53234:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"field-root":"TextField_field-root__4KlIU","multiline":"TextField_multiline__LH5Tc","field-container":"TextField_field-container__qhKrs","with-label":"TextField_with-label__ScUa4","active":"TextField_active__8nGN3","field-fieldset":"TextField_field-fieldset__rUuYj","focus":"TextField_focus__K41Og","field-label":"TextField_field-label__R4Bvn","error":"TextField_error__mcN0V","hover":"TextField_hover___Q2s4","disabled":"TextField_disabled__giRUE","field-input":"TextField_field-input__7kbJB","field-helper":"TextField_field-helper__GjBWT","note-textarea":"TextField_note-textarea__TT8tR"};

/***/ }),

/***/ 19892:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","toast-view":"Toaster_toast-view__hghIp","mode-blind":"Toaster_mode-blind__BFNhs"};

/***/ }),

/***/ 4746:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__AzmzU"};

/***/ }),

/***/ 17150:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","h1":"Typography_h1__LfvC_","h2":"Typography_h2__hmiNN","h3":"Typography_h3__rgyxH","h4":"Typography_h4__Er3ff","h5":"Typography_h5__GZeqt","h6":"Typography_h6__0hypO","subtitle1":"Typography_subtitle1__nicC4","primary":"Typography_primary__5Wa_5","primary-light":"Typography_primary-light__Pjx8x","search-section-primary":"Typography_search-section-primary__o_4h1","text-link":"Typography_text-link__J9HRA","gray":"Typography_gray__9SKxq","white":"Typography_white__O7Zh1","form-label-color":"Typography_form-label-color__vcTy_","default":"Typography_default__BliHv","text-inactive":"Typography_text-inactive__hZWaJ","inherit":"Typography_inherit__mjVVc","icon-disabled":"Typography_icon-disabled__GZa5y","icon-hover":"Typography_icon-hover__g9HV2","water-mark":"Typography_water-mark__Jj3WC","is-last-input-mouse":"Typography_is-last-input-mouse__gl1K7","typography":"Typography_typography__Uxiab","hoverable":"Typography_hoverable__CnqME","three-dots":"Typography_three-dots__7f7Cy","line-clamp":"Typography_line-clamp__TWdY3","l":"Typography_l__g43Zl","c":"Typography_c__AjXAT","r":"Typography_r__DRrzp","bebas":"Typography_bebas__tp8Aj","roboto":"Typography_roboto__prAHo","body1":"Typography_body1__G_YYa","body2":"Typography_body2__3DMYL","body3":"Typography_body3__TVyjT","body4":"Typography_body4__f3ppq","body5":"Typography_body5__sq7Sg","ls-big":"Typography_ls-big__26sf7","ls-sm":"Typography_ls-sm__xnbvm"};

/***/ }),

/***/ 87877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","lang-sel_item":"ViewLanguages_lang-sel_item__2dRr2","is-disabled":"ViewLanguages_is-disabled__xMpCx","is-highlighted":"ViewLanguages_is-highlighted__f0bsT","root":"ViewLanguages_root__wZyBx","title":"ViewLanguages_title__ilXDq","lang-sel_scroll":"ViewLanguages_lang-sel_scroll__2nhYa","head":"ViewLanguages_head__V06bD","with-title":"ViewLanguages_with-title__QoPSO","input":"ViewLanguages_input__eQmwC","checkbox":"ViewLanguages_checkbox__DOSVR","is-checked":"ViewLanguages_is-checked__6e2wb","is-default":"ViewLanguages_is-default__ZaFIN","hidden":"ViewLanguages_hidden__medy4","lang-sel-img":"ViewLanguages_lang-sel-img__oNaKr","label":"ViewLanguages_label__3XDTM","lang-sel-count":"ViewLanguages_lang-sel-count__Cg1OJ","mode-blind":"ViewLanguages_mode-blind__6Ddb4","wrap-search":"ViewLanguages_wrap-search__kLPlr"};

/***/ }),

/***/ 14616:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","modal-actions":"ModalActions_modal-actions__yNT7g","row-space":"ModalActions_row-space__KWVHp","btn":"ModalActions_btn__NylM7"};

/***/ }),

/***/ 11302:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","modal":"modal_modal__PNjwN","modal-root":"modal_modal-root__jxDhD","modal-content":"modal_modal-content__zGZMz","animationFade":"modal_animationFade__tgz6g","no-animation":"modal_no-animation__5ipwG","modal-close-btn":"modal_modal-close-btn__NIl10","skirt":"modal_skirt__VVgGw","modal-head":"modal_modal-head__n0taX","title":"modal_title__ZqTPc","backdrop":"modal_backdrop__9UrFS","animationFadeIn":"modal_animationFadeIn__cNdb4","modal-row-space":"modal_modal-row-space__CdJvZ","mode-blind":"modal_mode-blind__Ek1Vt","arrow-loading":"modal_arrow-loading__QEe8J","animationSlideInLeft":"modal_animationSlideInLeft__Ehqk_","animationSlideInRight":"modal_animationSlideInRight__whVCL"};

/***/ }),

/***/ 29431:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","text-mode-page":"TextModePage_text-mode-page__dd4nd","logo":"TextModePage_logo__fodId","header-page":"TextModePage_header-page__Y2uhs","container":"TextModePage_container__UZzId","logo-container":"TextModePage_logo-container__oHzS6","content-container":"TextModePage_content-container__7DwDf","title":"TextModePage_title__ZN54V","text-mode-button":"TextModePage_text-mode-button__VHre8","btn-group":"TextModePage_btn-group__W9hW5"};

/***/ }),

/***/ 4957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(27061);
(function(){var e={782:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},646:function(e){"use strict";const t={};function createErrorType(e,r,n){if(!n){n=Error}function getMessage(e,t,n){if(typeof r==="string"){return r}else{return r(e,t,n)}}class NodeError extends n{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=n.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let n;if(typeof t==="string"&&startsWith(t,"not ")){n="must not be";t=t.replace(/^not /,"")}else{n="must be"}let i;if(endsWith(e," argument")){i=`The ${e} ${n} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";i=`The "${e}" ${r} ${n} ${oneOf(t,"type")}`}i+=`. Received type ${typeof r}`;return i}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},403:function(e,t,r){"use strict";var n=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var i=r(709);var a=r(337);r(782)(Duplex,i);{var o=n(a.prototype);for(var s=0;s<o.length;s++){var f=o[s];if(!Duplex.prototype[f])Duplex.prototype[f]=a.prototype[f]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);i.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},889:function(e,t,r){"use strict";e.exports=PassThrough;var n=r(170);r(782)(PassThrough,n);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);n.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},709:function(e,t,r){"use strict";e.exports=Readable;var n;Readable.ReadableState=ReadableState;var i=r(361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var o=r(678);var s=r(300).Buffer;var f=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof f}var l=r(837);var u;if(l&&l.debuglog){u=l.debuglog("stream")}else{u=function debug(){}}var d=r(379);var c=r(25);var h=r(776),p=h.getHighWaterMark;var b=r(646).q,g=b.ERR_INVALID_ARG_TYPE,y=b.ERR_STREAM_PUSH_AFTER_EOF,_=b.ERR_METHOD_NOT_IMPLEMENTED,v=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var m;var S;r(782)(Readable,o);var R=c.errorOrDestroy;var E=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=p(this,e,"readableHighWaterMark",i);this.buffer=new d;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(704).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){n=n||r(403);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof n;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}o.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=c.destroy;Readable.prototype._undestroy=c.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var n;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=s.from(e,t);t=""}n=true}}else{n=true}return readableAddChunk(this,e,t,false,n)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,n,i){u("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var o;if(!i)o=chunkInvalid(a,t);if(o){R(e,o)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==s.prototype){t=_uint8ArrayToBuffer(t)}if(n){if(a.endEmitted)R(e,new v);else addChunk(e,a,t,true)}else if(a.ended){R(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!n){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,n){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(n)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new g("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(704).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var n=this._readableState.buffer.head;var i="";while(n!==null){i+=t.write(n.data);n=n.next}this._readableState.buffer.clear();if(i!=="")this._readableState.buffer.push(i);this._readableState.length=i.length;return this};var T=1073741824;function computeNewHighWaterMark(e){if(e>=T){e=T}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){u("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){u("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var n=t.needReadable;u("need readable",n);if(t.length===0||t.length-e<t.highWaterMark){n=true;u("length less than watermark",n)}if(t.ended||t.reading){n=false;u("reading or ended",n)}else if(n){u("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var i;if(e>0)i=fromList(e,t);else i=null;if(i===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(i!==null)this.emit("data",i);return i};function onEofChunk(e,t){u("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;u("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){u("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;u("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;u("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){R(this,new _("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var n=this._readableState;switch(n.pipesCount){case 0:n.pipes=e;break;case 1:n.pipes=[n.pipes,e];break;default:n.pipes.push(e);break}n.pipesCount+=1;u("pipe count=%d opts=%j",n.pipesCount,t);var i=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var o=i?onend:unpipe;if(n.endEmitted)process.nextTick(o);else r.once("end",o);e.on("unpipe",onunpipe);function onunpipe(e,t){u("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){u("onend");e.end()}var s=pipeOnDrain(r);e.on("drain",s);var f=false;function cleanup(){u("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",s);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);f=true;if(n.awaitDrain&&(!e._writableState||e._writableState.needDrain))s()}r.on("data",ondata);function ondata(t){u("ondata");var i=e.write(t);u("dest.write",i);if(i===false){if((n.pipesCount===1&&n.pipes===e||n.pipesCount>1&&indexOf(n.pipes,e)!==-1)&&!f){u("false write response, pause",n.awaitDrain);n.awaitDrain++}r.pause()}}function onerror(t){u("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)R(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){u("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){u("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!n.flowing){u("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;u("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var n=t.pipes;var i=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<i;a++){n[a].emit("unpipe",this,{hasUnpiped:false})}return this}var o=indexOf(t.pipes,e);if(o===-1)return this;t.pipes.splice(o,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=o.prototype.on.call(this,e,t);var n=this._readableState;if(e==="data"){n.readableListening=this.listenerCount("readable")>0;if(n.flowing!==false)this.resume()}else if(e==="readable"){if(!n.endEmitted&&!n.readableListening){n.readableListening=n.needReadable=true;n.flowing=false;n.emittedReadable=false;u("on readable",n.length,n.reading);if(n.length){emitReadable(this)}else if(!n.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=o.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=o.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){u("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){u("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){u("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){u("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){u("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;u("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var n=false;e.on("end",(function(){u("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(i){u("wrapped data");if(r.decoder)i=r.decoder.write(i);if(r.objectMode&&(i===null||i===undefined))return;else if(!r.objectMode&&(!i||!i.length))return;var a=t.push(i);if(!a){n=true;e.pause()}}));for(var i in e){if(this[i]===undefined&&typeof e[i]==="function"){this[i]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(i)}}for(var a=0;a<E.length;a++){e.on(E[a],this.emit.bind(this,E[a]))}this._read=function(t){u("wrapped _read",t);if(n){n=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(m===undefined){m=r(871)}return m(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;u("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){u("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(S===undefined){S=r(727)}return S(Readable,e,t)}}function indexOf(e,t){for(var r=0,n=e.length;r<n;r++){if(e[r]===t)return r}return-1}},170:function(e,t,r){"use strict";e.exports=Transform;var n=r(646).q,i=n.ERR_METHOD_NOT_IMPLEMENTED,a=n.ERR_MULTIPLE_CALLBACK,o=n.ERR_TRANSFORM_ALREADY_TRANSFORMING,s=n.ERR_TRANSFORM_WITH_LENGTH_0;var f=r(403);r(782)(Transform,f);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var n=r.writecb;if(n===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);n(e);var i=this._readableState;i.reading=false;if(i.needReadable||i.length<i.highWaterMark){this._read(i.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);f.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return f.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new i("_transform()"))};Transform.prototype._write=function(e,t,r){var n=this._transformState;n.writecb=r;n.writechunk=e;n.writeencoding=t;if(!n.transforming){var i=this._readableState;if(n.needTransform||i.needReadable||i.length<i.highWaterMark)this._read(i.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){f.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new s;if(e._transformState.transforming)throw new o;return e.push(null)}},337:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var n;Writable.WritableState=WritableState;var i={deprecate:r(769)};var a=r(678);var o=r(300).Buffer;var s=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof s}var f=r(25);var l=r(776),u=l.getHighWaterMark;var d=r(646).q,c=d.ERR_INVALID_ARG_TYPE,h=d.ERR_METHOD_NOT_IMPLEMENTED,p=d.ERR_MULTIPLE_CALLBACK,b=d.ERR_STREAM_CANNOT_PIPE,g=d.ERR_STREAM_DESTROYED,y=d.ERR_STREAM_NULL_VALUES,_=d.ERR_STREAM_WRITE_AFTER_END,v=d.ERR_UNKNOWN_ENCODING;var w=f.errorOrDestroy;r(782)(Writable,a);function nop(){}function WritableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=u(this,e,"writableHighWaterMark",i);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:i.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var m;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){m=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(m.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{m=function realHasInstance(e){return e instanceof this}}function Writable(e){n=n||r(403);var t=this instanceof n;if(!t&&!m.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new b)};function writeAfterEnd(e,t){var r=new _;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,n){var i;if(r===null){i=new y}else if(typeof r!=="string"&&!t.objectMode){i=new c("chunk",["string","Buffer"],r)}if(i){w(e,i);process.nextTick(n,i);return false}return true}Writable.prototype.write=function(e,t,r){var n=this._writableState;var i=false;var a=!n.objectMode&&_isUint8Array(e);if(a&&!o.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=n.defaultEncoding;if(typeof r!=="function")r=nop;if(n.ending)writeAfterEnd(this,r);else if(a||validChunk(this,n,e,r)){n.pendingcb++;i=writeOrBuffer(this,n,a,e,t,r)}return i};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new v(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=o.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,n,i,a){if(!r){var o=decodeChunk(t,n,i);if(n!==o){r=true;i="buffer";n=o}}var s=t.objectMode?1:n.length;t.length+=s;var f=t.length<t.highWaterMark;if(!f)t.needDrain=true;if(t.writing||t.corked){var l=t.lastBufferedRequest;t.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null};if(l){l.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,s,n,i,a)}return f}function doWrite(e,t,r,n,i,a,o){t.writelen=n;t.writecb=o;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new g("write"));else if(r)e._writev(i,t.onwrite);else e._write(i,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,n,i){--t.pendingcb;if(r){process.nextTick(i,n);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,n)}else{i(n);e._writableState.errorEmitted=true;w(e,n);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var n=r.sync;var i=r.writecb;if(typeof i!=="function")throw new p;onwriteStateUpdate(r);if(t)onwriteError(e,r,n,t,i);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(n){process.nextTick(afterWrite,e,r,a,i)}else{afterWrite(e,r,a,i)}}}function afterWrite(e,t,r,n){if(!r)onwriteDrain(e,t);t.pendingcb--;n();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var n=t.bufferedRequestCount;var i=new Array(n);var a=t.corkedRequestsFree;a.entry=r;var o=0;var s=true;while(r){i[o]=r;if(!r.isBuf)s=false;r=r.next;o+=1}i.allBuffers=s;doWrite(e,t,true,t.length,i,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var f=r.chunk;var l=r.encoding;var u=r.callback;var d=t.objectMode?1:f.length;doWrite(e,t,false,d,f,l,u);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new h("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var n=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(n.corked){n.corked=1;this.uncork()}if(!n.ending)endWritable(this,n,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var n=e._readableState;if(!n||n.autoDestroy&&n.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var n=e.entry;e.entry=null;while(n){var i=n.callback;t.pendingcb--;i(r);n=n.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=f.destroy;Writable.prototype._undestroy=f.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},871:function(e,t,r){"use strict";var n;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(698);var a=Symbol("lastResolve");var o=Symbol("lastReject");var s=Symbol("error");var f=Symbol("ended");var l=Symbol("lastPromise");var u=Symbol("handlePromise");var d=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[d].read();if(r!==null){e[l]=null;e[a]=null;e[o]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,n){e.then((function(){if(t[f]){r(createIterResult(undefined,true));return}t[u](r,n)}),n)}}var c=Object.getPrototypeOf((function(){}));var h=Object.setPrototypeOf((n={get stream(){return this[d]},next:function next(){var e=this;var t=this[s];if(t!==null){return Promise.reject(t)}if(this[f]){return Promise.resolve(createIterResult(undefined,true))}if(this[d].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[s]){r(e[s])}else{t(createIterResult(undefined,true))}}))}))}var r=this[l];var n;if(r){n=new Promise(wrapForNext(r,this))}else{var i=this[d].read();if(i!==null){return Promise.resolve(createIterResult(i,false))}n=new Promise(this[u])}this[l]=n;return n}},_defineProperty(n,Symbol.asyncIterator,(function(){return this})),_defineProperty(n,"return",(function _return(){var e=this;return new Promise((function(t,r){e[d].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),n),c);var p=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(h,(t={},_defineProperty(t,d,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,f,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,u,{value:function value(e,t){var n=r[d].read();if(n){r[l]=null;r[a]=null;r[o]=null;e(createIterResult(n,false))}else{r[a]=e;r[o]=t}},writable:true}),t));r[l]=null;i(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[o];if(t!==null){r[l]=null;r[a]=null;r[o]=null;t(e)}r[s]=e;return}var n=r[a];if(n!==null){r[l]=null;r[a]=null;r[o]=null;n(createIterResult(undefined,true))}r[f]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=p},379:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var n=r(300),i=n.Buffer;var a=r(837),o=a.inspect;var s=o&&o.custom||"inspect";function copyBuffer(e,t,r){i.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return i.alloc(0);var t=i.allocUnsafe(e>>>0);var r=this.head;var n=0;while(r){copyBuffer(r.data,t,n);n+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var n=t.data;e-=n.length;while(t=t.next){var i=t.data;var a=e>i.length?i.length:e;if(a===i.length)n+=i;else n+=i.slice(0,e);e-=a;if(e===0){if(a===i.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=i.slice(a)}break}++r}this.length-=r;return n}},{key:"_getBuffer",value:function _getBuffer(e){var t=i.allocUnsafe(e);var r=this.head;var n=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var o=e>a.length?a.length:e;a.copy(t,t.length-e,0,o);e-=o;if(e===0){if(o===a.length){++n;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(o)}break}++n}this.length-=n;return t}},{key:s,value:function value(e,t){return o(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},25:function(e){"use strict";function destroy(e,t){var r=this;var n=this._readableState&&this._readableState.destroyed;var i=this._writableState&&this._writableState.destroyed;if(n||i){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var n=e._writableState;if(r&&r.autoDestroy||n&&n.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},698:function(e,t,r){"use strict";var n=r(646).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,n=new Array(r),i=0;i<r;i++){n[i]=arguments[i]}e.apply(this,n)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var i=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var o=function onlegacyfinish(){if(!e.writable)f()};var s=e._writableState&&e._writableState.finished;var f=function onfinish(){a=false;s=true;if(!i)r.call(e)};var l=e._readableState&&e._readableState.endEmitted;var u=function onend(){i=false;l=true;if(!a)r.call(e)};var d=function onerror(t){r.call(e,t)};var c=function onclose(){var t;if(i&&!l){if(!e._readableState||!e._readableState.ended)t=new n;return r.call(e,t)}if(a&&!s){if(!e._writableState||!e._writableState.ended)t=new n;return r.call(e,t)}};var h=function onrequest(){e.req.on("finish",f)};if(isRequest(e)){e.on("complete",f);e.on("abort",c);if(e.req)h();else e.on("request",h)}else if(a&&!e._writableState){e.on("end",o);e.on("close",o)}e.on("end",u);e.on("finish",f);if(t.error!==false)e.on("error",d);e.on("close",c);return function(){e.removeListener("complete",f);e.removeListener("abort",c);e.removeListener("request",h);if(e.req)e.req.removeListener("finish",f);e.removeListener("end",o);e.removeListener("close",o);e.removeListener("finish",f);e.removeListener("end",u);e.removeListener("error",d);e.removeListener("close",c)}}e.exports=eos},727:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,n,i,a,o){try{var s=e[a](o);var f=s.value}catch(e){r(e);return}if(s.done){t(f)}else{Promise.resolve(f).then(n,i)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(n,i){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,n,i,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,n,i,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(646).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var i;if(t&&typeof t.next==="function"){i=t}else if(t&&t[Symbol.asyncIterator])i=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])i=t[Symbol.iterator]();else throw new n("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var o=false;a._read=function(){if(!o){o=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield i.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{o=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},442:function(e,t,r){"use strict";var n;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var i=r(646).q,a=i.ERR_MISSING_ARGS,o=i.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,i,a){a=once(a);var s=false;e.on("close",(function(){s=true}));if(n===undefined)n=r(698);n(e,{readable:t,writable:i},(function(e){if(e)return a(e);s=true;a()}));var f=false;return function(t){if(s)return;if(f)return;f=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new o("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var n=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var i;var o=t.map((function(e,r){var a=r<t.length-1;var s=r>0;return destroyer(e,a,s,(function(e){if(!i)i=e;if(e)o.forEach(call);if(a)return;o.forEach(call);n(i)}))}));return t.reduce(pipe)}e.exports=pipeline},776:function(e,t,r){"use strict";var n=r(646).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,i){var a=highWaterMarkFrom(t,i,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var o=i?r:"highWaterMark";throw new n(o,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},678:function(e,t,r){e.exports=r(781)},55:function(e,t,r){var n=r(300);var i=n.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow){e.exports=n}else{copyProps(n,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return i(e,t,r)}SafeBuffer.prototype=Object.create(i.prototype);copyProps(i,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return i(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var n=i(e);if(t!==undefined){if(typeof r==="string"){n.fill(t,r)}else{n.fill(t)}}else{n.fill(0)}return n};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n.SlowBuffer(e)}},173:function(e,t,r){e.exports=Stream;var n=r(361).EventEmitter;var i=r(782);i(Stream,n);Stream.Readable=r(709);Stream.Writable=r(337);Stream.Duplex=r(403);Stream.Transform=r(170);Stream.PassThrough=r(889);Stream.finished=r(698);Stream.pipeline=r(442);Stream.Stream=Stream;function Stream(){n.call(this)}Stream.prototype.pipe=function(e,t){var r=this;function ondata(t){if(e.writable){if(false===e.write(t)&&r.pause){r.pause()}}}r.on("data",ondata);function ondrain(){if(r.readable&&r.resume){r.resume()}}e.on("drain",ondrain);if(!e._isStdio&&(!t||t.end!==false)){r.on("end",onend);r.on("close",onclose)}var i=false;function onend(){if(i)return;i=true;e.end()}function onclose(){if(i)return;i=true;if(typeof e.destroy==="function")e.destroy()}function onerror(e){cleanup();if(n.listenerCount(this,"error")===0){throw e}}r.on("error",onerror);e.on("error",onerror);function cleanup(){r.removeListener("data",ondata);e.removeListener("drain",ondrain);r.removeListener("end",onend);r.removeListener("close",onclose);r.removeListener("error",onerror);e.removeListener("error",onerror);r.removeListener("end",cleanup);r.removeListener("close",cleanup);e.removeListener("close",cleanup)}r.on("end",cleanup);r.on("close",cleanup);e.on("close",cleanup);e.emit("pipe",r);return e}},704:function(e,t,r){"use strict";var n=r(55).Buffer;var i=n.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(n.isEncoding===i||!i(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=n.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var n=t.length-1;if(n<r)return 0;var i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-1;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-2;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0){if(i===2)i=0;else e.lastNeed=i-3}return i}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var n=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,n);return e.toString("utf8",t,n)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},769:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},300:function(e){"use strict";e.exports=__webpack_require__(30816)},361:function(e){"use strict";e.exports=__webpack_require__(50343)},781:function(e){"use strict";e.exports=(__webpack_require__(50343).EventEmitter)},837:function(e){"use strict";e.exports=__webpack_require__(71323)}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var a=true;try{e[r](i,i.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(173);module.exports=r})();

/***/ }),

/***/ 65218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90568)


/***/ }),

/***/ 88038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(31508)


/***/ }),

/***/ 86677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(77417)


/***/ }),

/***/ 86524:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(96553);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 60836:
/***/ (function(module) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),

/***/ 83822:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(67392);
var callBind = __webpack_require__(34573);

var implementation = __webpack_require__(60836);
var getPolyfill = __webpack_require__(11800);
var shim = __webpack_require__(27894);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),

/***/ 11800:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(60836);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),

/***/ 27894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(11800);
var define = __webpack_require__(67392);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),

/***/ 89538:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(71030); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),

/***/ 44733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(71030);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(89538);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),

/***/ 71030:
/***/ (function(module) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),

/***/ 16948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(27061);
// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map


/***/ }),

/***/ 82780:
/***/ (function(module) {

var div = null
var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]

module.exports = function prefixStyle (prop) {
  // re-use a dummy div
  if (!div) {
    div = document.createElement('div')
  }

  var style = div.style

  // prop exists without prefix
  if (prop in style) {
    return prop
  }

  // borderRadius -> BorderRadius
  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)

  // find the vendor-prefixed prop
  for (var i = prefixes.length; i >= 0; i--) {
    var name = prefixes[i] + titleCase
    // e.g. WebkitBorderRadius or webkitBorderRadius
    if (name in style) {
      return name
    }
  }

  return false
}


/***/ }),

/***/ 27061:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 58772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(90331);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 23615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(58772)();
}


/***/ }),

/***/ 90331:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 5026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var now = __webpack_require__(16948)
  , root = typeof window === 'undefined' ? __webpack_require__.g : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}


/***/ }),

/***/ 56253:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(27378);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(4651);

var ClientUAInstance = new UAParser();
var browser = ClientUAInstance.getBrowser();
var cpu = ClientUAInstance.getCPU();
var device = ClientUAInstance.getDevice();
var engine = ClientUAInstance.getEngine();
var os = ClientUAInstance.getOS();
var ua = ClientUAInstance.getUA();
var setUa = function setUa(userAgentString) {
  return ClientUAInstance.setUA(userAgentString);
};
var parseUserAgent = function parseUserAgent(userAgent) {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }

  var UserAgentInstance = new UAParser(userAgent);
  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: function setUserAgent(userAgentString) {
      return UserAgentInstance.setUA(userAgentString);
    }
  };
};

var UAHelper = /*#__PURE__*/Object.freeze({
  ClientUAInstance: ClientUAInstance,
  browser: browser,
  cpu: cpu,
  device: device,
  engine: engine,
  os: os,
  ua: ua,
  setUa: setUa,
  parseUserAgent: parseUserAgent
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Embedded: 'embedded',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Opera: 'Opera',
  Yandex: 'Yandex',
  Safari: 'Safari',
  InternetExplorer: 'Internet Explorer',
  Edge: 'Edge',
  Chromium: 'Chromium',
  Ie: 'IE',
  MobileSafari: 'Mobile Safari',
  EdgeChromium: 'Edge Chromium',
  MIUI: 'MIUI Browser',
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: 'Android',
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var InitialDeviceTypes = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkDeviceType = function checkDeviceType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    case DeviceTypes.Embedded:
      return {
        isEmbedded: true
      };

    default:
      return InitialDeviceTypes;
  }
};
var setUserAgent = function setUserAgent(userAgent) {
  return setUa(userAgent);
};
var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
  return {
    isEmbedded: isEmbedded,
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

function deviceDetect(userAgent) {
  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      engine = _ref.engine,
      os = _ref.os,
      ua = _ref.ua;

  var type = checkDeviceType(device.type);
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable,
      isEmbedded = type.isEmbedded;

  if (isBrowser) {
    return browserPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return smartTvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearablePayload(isWearable, engine, os, ua);
  }

  if (isEmbedded) {
    return embeddedPayload(isEmbedded, device, engine, os, ua);
  }
}

var isMobileType = function isMobileType(_ref) {
  var type = _ref.type;
  return type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType(_ref2) {
  var type = _ref2.type;
  return type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
  var type = _ref3.type;
  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
};
var isSmartTVType = function isSmartTVType(_ref4) {
  var type = _ref4.type;
  return type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType(_ref5) {
  var type = _ref5.type;
  return type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType(_ref6) {
  var type = _ref6.type;
  return type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType(_ref7) {
  var type = _ref7.type;
  return type === DeviceTypes.Console;
};
var isEmbeddedType = function isEmbeddedType(_ref8) {
  var type = _ref8.type;
  return type === DeviceTypes.Embedded;
};
var getMobileVendor = function getMobileVendor(_ref9) {
  var vendor = _ref9.vendor;
  return setDefaults(vendor);
};
var getMobileModel = function getMobileModel(_ref10) {
  var model = _ref10.model;
  return setDefaults(model);
};
var getDeviceType = function getDeviceType(_ref11) {
  var type = _ref11.type;
  return setDefaults(type, 'browser');
}; // os types

var isAndroidType = function isAndroidType(_ref12) {
  var name = _ref12.name;
  return name === OsTypes.Android;
};
var isWindowsType = function isWindowsType(_ref13) {
  var name = _ref13.name;
  return name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType(_ref14) {
  var name = _ref14.name;
  return name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType(_ref15) {
  var name = _ref15.name;
  return name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType(_ref16) {
  var name = _ref16.name;
  return name === OsTypes.IOS;
};
var getOsVersion = function getOsVersion(_ref17) {
  var version = _ref17.version;
  return setDefaults(version);
};
var getOsName = function getOsName(_ref18) {
  var name = _ref18.name;
  return setDefaults(name);
}; // browser types

var isChromeType = function isChromeType(_ref19) {
  var name = _ref19.name;
  return name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType(_ref20) {
  var name = _ref20.name;
  return name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType(_ref21) {
  var name = _ref21.name;
  return name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType(_ref22) {
  var name = _ref22.name;
  return name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType(_ref23) {
  var name = _ref23.name;
  return name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType(_ref24) {
  var name = _ref24.name;
  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType(_ref25) {
  var name = _ref25.name;
  return name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType(_ref26) {
  var name = _ref26.name;
  return name === BrowserTypes.Opera;
};
var isIEType = function isIEType(_ref27) {
  var name = _ref27.name;
  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType(_ref28) {
  var name = _ref28.name;
  return name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
  var name = _ref29.name;
  return name === BrowserTypes.SamsungBrowser;
};
var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
  var version = _ref30.version;
  return setDefaults(version);
};
var getBrowserVersion = function getBrowserVersion(_ref31) {
  var major = _ref31.major;
  return setDefaults(major);
};
var getBrowserName = function getBrowserName(_ref32) {
  var name = _ref32.name;
  return setDefaults(name);
}; // engine types

var getEngineName = function getEngineName(_ref33) {
  var name = _ref33.name;
  return setDefaults(name);
};
var getEngineVersion = function getEngineVersion(_ref34) {
  var version = _ref34.version;
  return setDefaults(version);
};
var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var isEdgeChromiumType = function isEdgeChromiumType(ua) {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};
var getUseragent = function getUseragent(userAg) {
  return setDefaults(userAg);
};

function buildSelectorsObject(options) {
  var _ref = options ? options : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      os = _ref.os,
      engine = _ref.engine,
      ua = _ref.ua;

  return {
    isSmartTV: isSmartTVType(device),
    isConsole: isConsoleType(device),
    isWearable: isWearableType(device),
    isEmbedded: isEmbeddedType(device),
    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
    isChromium: isChromiumType(browser),
    isMobile: isMobileAndTabletType(device) || getIPad13(),
    isMobileOnly: isMobileType(device),
    isTablet: isTabletType(device) || getIPad13(),
    isBrowser: isBrowserType(device),
    isDesktop: isBrowserType(device),
    isAndroid: isAndroidType(os),
    isWinPhone: isWinPhoneType(os),
    isIOS: isIOSType(os) || getIPad13(),
    isChrome: isChromeType(browser),
    isFirefox: isFirefoxType(browser),
    isSafari: isSafariType(browser),
    isOpera: isOperaType(browser),
    isIE: isIEType(browser),
    osVersion: getOsVersion(os),
    osName: getOsName(os),
    fullBrowserVersion: getBrowserFullVersion(browser),
    browserVersion: getBrowserVersion(browser),
    browserName: getBrowserName(browser),
    mobileVendor: getMobileVendor(device),
    mobileModel: getMobileModel(device),
    engineName: getEngineName(engine),
    engineVersion: getEngineVersion(engine),
    getUA: getUseragent(ua),
    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
    isYandex: isYandexType(browser),
    deviceType: getDeviceType(device),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(ua),
    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
    isWindows: isWindowsType(os),
    isMacOs: isMacOsType(os),
    isMIUI: isMIUIType(browser),
    isSamsungBrowser: isSamsungBrowserType(browser)
  };
}

var isSmartTV = isSmartTVType(device);
var isConsole = isConsoleType(device);
var isWearable = isWearableType(device);
var isEmbedded = isEmbeddedType(device);
var isMobileSafari = isMobileSafariType(browser) || getIPad13();
var isChromium = isChromiumType(browser);
var isMobile = isMobileAndTabletType(device) || getIPad13();
var isMobileOnly = isMobileType(device);
var isTablet = isTabletType(device) || getIPad13();
var isBrowser = isBrowserType(device);
var isDesktop = isBrowserType(device);
var isAndroid = isAndroidType(os);
var isWinPhone = isWinPhoneType(os);
var isIOS = isIOSType(os) || getIPad13();
var isChrome = isChromeType(browser);
var isFirefox = isFirefoxType(browser);
var isSafari = isSafariType(browser);
var isOpera = isOperaType(browser);
var isIE = isIEType(browser);
var osVersion = getOsVersion(os);
var osName = getOsName(os);
var fullBrowserVersion = getBrowserFullVersion(browser);
var browserVersion = getBrowserVersion(browser);
var browserName = getBrowserName(browser);
var mobileVendor = getMobileVendor(device);
var mobileModel = getMobileModel(device);
var engineName = getEngineName(engine);
var engineVersion = getEngineVersion(engine);
var getUA = getUseragent(ua);
var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
var isYandex = isYandexType(browser);
var deviceType = getDeviceType(device);
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType(ua);
var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
var isWindows = isWindowsType(os);
var isMacOs = isMacOsType(os);
var isMIUI = isMIUIType(browser);
var isSamsungBrowser = isSamsungBrowserType(browser);
var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') {
    console.error('No valid user agent string was provided');
    return;
  }

  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
      device = _UAHelper$parseUserAg.device,
      browser = _UAHelper$parseUserAg.browser,
      os = _UAHelper$parseUserAg.os,
      engine = _UAHelper$parseUserAg.engine,
      ua = _UAHelper$parseUserAg.ua;

  return buildSelectorsObject({
    device: device,
    browser: browser,
    os: os,
    engine: engine,
    ua: ua
  });
};

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      _this.isEventListenerAdded = false;
      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
      _this.state = {
        isLandscape: false,
        isPortrait: false
      };
      return _this;
    }

    _createClass(_class, [{
      key: "handleOrientationChange",
      value: function handleOrientationChange() {
        if (!this.isEventListenerAdded) {
          this.isEventListenerAdded = true;
        }

        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: orientation === 0,
          isLandscape: orientation === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function onOrientationChange() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function onPageLoad() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
          if (!this.isEventListenerAdded) {
            this.handleOrientationChange();
            window.addEventListener("load", this.onPageLoad, false);
          } else {
            window.removeEventListener("load", this.onPageLoad, false);
          }

          window.addEventListener("resize", this.onOrientationChange, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.onOrientationChange, false);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]);

    return _class;
  }(React__default.Component);
}

function useMobileOrientation() {
  var _useState = React.useState(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleOrientationChange = React.useCallback(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    var next = {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
    state.orientation !== next.orientation && setState(next);
  }, [state.orientation]);
  React.useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
      handleOrientationChange();
      window.addEventListener("load", handleOrientationChange, false);
      window.addEventListener("resize", handleOrientationChange, false);
    }

    return function () {
      window.removeEventListener("resize", handleOrientationChange, false);
      window.removeEventListener("load", handleOrientationChange, false);
    };
  }, [handleOrientationChange]);
  return state;
}

function useDeviceData(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  return parseUserAgent(hookUserAgent);
}

function useDeviceSelectors(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  var deviceData = useDeviceData(hookUserAgent);
  var selectors = buildSelectorsObject(deviceData);
  return [selectors, deviceData];
}

__webpack_unused_export__ = AndroidView;
__webpack_unused_export__ = BrowserTypes;
__webpack_unused_export__ = BrowserView;
__webpack_unused_export__ = ConsoleView;
__webpack_unused_export__ = CustomView;
__webpack_unused_export__ = IEView;
__webpack_unused_export__ = IOSView;
__webpack_unused_export__ = MobileOnlyView;
__webpack_unused_export__ = MobileView;
__webpack_unused_export__ = OsTypes;
__webpack_unused_export__ = SmartTVView;
__webpack_unused_export__ = TabletView;
__webpack_unused_export__ = WearableView;
__webpack_unused_export__ = WinPhoneView;
exports.KC = browserName;
exports.x_ = browserVersion;
__webpack_unused_export__ = deviceDetect;
exports.vO = deviceType;
__webpack_unused_export__ = engineName;
__webpack_unused_export__ = engineVersion;
__webpack_unused_export__ = fullBrowserVersion;
__webpack_unused_export__ = getSelectorsByUserAgent;
__webpack_unused_export__ = getUA;
exports.Dt = isAndroid;
__webpack_unused_export__ = isBrowser;
exports.i7 = isChrome;
__webpack_unused_export__ = isChromium;
__webpack_unused_export__ = isConsole;
exports.nI = isDesktop;
exports.un = isEdge;
__webpack_unused_export__ = isEdgeChromium;
__webpack_unused_export__ = isElectron;
__webpack_unused_export__ = isEmbedded;
exports.vU = isFirefox;
__webpack_unused_export__ = isIE;
exports.gn = isIOS;
__webpack_unused_export__ = isIOS13;
__webpack_unused_export__ = isIPad13;
__webpack_unused_export__ = isIPhone13;
__webpack_unused_export__ = isIPod13;
__webpack_unused_export__ = isLegacyEdge;
__webpack_unused_export__ = isMIUI;
exports.Q5 = isMacOs;
exports.tq = isMobile;
exports.UA = isMobileOnly;
__webpack_unused_export__ = isMobileSafari;
exports.f0 = isOpera;
exports.G6 = isSafari;
__webpack_unused_export__ = isSamsungBrowser;
__webpack_unused_export__ = isSmartTV;
exports.Em = isTablet;
__webpack_unused_export__ = isWearable;
__webpack_unused_export__ = isWinPhone;
__webpack_unused_export__ = isWindows;
__webpack_unused_export__ = isYandex;
__webpack_unused_export__ = mobileModel;
__webpack_unused_export__ = mobileVendor;
exports.BF = osName;
exports.MM = osVersion;
__webpack_unused_export__ = parseUserAgent;
__webpack_unused_export__ = setUserAgent;
__webpack_unused_export__ = useDeviceData;
__webpack_unused_export__ = useDeviceSelectors;
__webpack_unused_export__ = useMobileOrientation;
__webpack_unused_export__ = withOrientationChange;


/***/ }),

/***/ 58702:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 19185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(58702);
} else {}


/***/ }),

/***/ 34412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* reexport */ components_Provider; },
  "I0": function() { return /* reexport */ useDispatch; },
  "v9": function() { return /* reexport */ useSelector; }
});

// UNUSED EXPORTS: ReactReduxContext, batch, connect, createDispatchHook, createSelectorHook, createStoreHook, shallowEqual, useStore

// EXTERNAL MODULE: ../node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(70644);
// EXTERNAL MODULE: ../node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(60626);
// EXTERNAL MODULE: ../node_modules/react-dom/index.js
var react_dom = __webpack_require__(31542);
;// CONCATENATED MODULE: ../node_modules/react-redux/es/utils/reactBatchedUpdates.js

;// CONCATENATED MODULE: ../node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

let batch = defaultNoopBatch; // Allow injecting another batching function later

const setBatch = newBatch => batch = newBatch; // Supply a getter just to skip dealing with ESM bindings

const getBatch = () => batch;
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
;// CONCATENATED MODULE: ../node_modules/react-redux/es/components/Context.js

const Context_ReactReduxContext = /*#__PURE__*/(0,react.createContext)(null);

if (false) {}

/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (Context_ReactReduxContext)));
;// CONCATENATED MODULE: ../node_modules/react-redux/es/hooks/useReduxContext.js



/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */
function useReduxContext_useReduxContext() {
  const contextValue = (0,react.useContext)(Context_ReactReduxContext);

  if (false) {}

  return contextValue;
}
;// CONCATENATED MODULE: ../node_modules/react-redux/es/utils/useSyncExternalStore.js
const useSyncExternalStore_notInitialized = () => {
  throw new Error('uSES not initialized!');
};
;// CONCATENATED MODULE: ../node_modules/react-redux/es/hooks/useSelector.js




let useSyncExternalStoreWithSelector = useSyncExternalStore_notInitialized;
const initializeUseSelector = fn => {
  useSyncExternalStoreWithSelector = fn;
};

const refEquality = (a, b) => a === b;
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context = Context_ReactReduxContext) {
  const useReduxContext = context === Context_ReactReduxContext ? useReduxContext_useReduxContext : () => (0,react.useContext)(context);
  return function useSelector(selector, equalityFn = refEquality) {
    if (false) {}

    const {
      store,
      subscription,
      getServerState
    } = useReduxContext();
    const selectedState = useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, selector, equalityFn);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

const useSelector = /*#__PURE__*/createSelectorHook();
// EXTERNAL MODULE: ../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(55839);
// EXTERNAL MODULE: ../node_modules/react-is/index.js
var react_is = __webpack_require__(19185);
;// CONCATENATED MODULE: ../node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  const batch = getBatch();
  let first = null;
  let last = null;
  return {
    clear() {
      first = null;
      last = null;
    },

    notify() {
      batch(() => {
        let listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },

    get() {
      let listeners = [];
      let listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },

    subscribe(callback) {
      let isSubscribed = true;
      let listener = last = {
        callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }

  };
}

const nullListeners = {
  notify() {},

  get: () => []
};
function Subscription_createSubscription(store, parentSub) {
  let unsubscribe;
  let listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  const subscription = {
    addNestedSub,
    notifyNestedSubs,
    handleChangeWrapper,
    isSubscribed,
    trySubscribe,
    tryUnsubscribe,
    getListeners: () => listeners
  };
  return subscription;
}
;// CONCATENATED MODULE: ../node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed
// Matches logic in React's `shared/ExecutionEnvironment` file

const canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = canUseDOM ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ../node_modules/react-redux/es/components/connect.js


const _excluded = (/* unused pure expression or super */ null && (["reactReduxForwardedRef"]));

/* eslint-disable valid-jsdoc, @typescript-eslint/no-unused-vars */













let useSyncExternalStore = (/* unused pure expression or super */ null && (notInitialized));
const initializeConnect = fn => {
  useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these

const EMPTY_ARRAY = (/* unused pure expression or super */ null && ([null, 0]));
const NO_SUBSCRIPTION_ARRAY = (/* unused pure expression or super */ null && ([null, null])); // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message

const stringifyComponent = Comp => {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(() => effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage


function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, // actualChildProps: unknown,
childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.


function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, // forceComponentUpdateDispatch: React.Dispatch<any>,
additionalSubscribeListener) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return () => {}; // Capture values for checking if and when this component unmounts

  let didUnsubscribe = false;
  let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  const checkForUpdates = () => {
    if (didUnsubscribe || !isMounted.current) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    } // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it


    const latestStoreState = store.getState();
    let newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
      // Trigger the React `useSyncExternalStore` subscriber

      additionalSubscribeListener();
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  const unsubscribeWrapper = () => {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer


const initStateUpdates = () => EMPTY_ARRAY;

function strictEqual(a, b) {
  return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */


let hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */

function connect(mapStateToProps, mapDispatchToProps, mergeProps, {
  // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
  // @ts-ignore
  pure,
  areStatesEqual = strictEqual,
  areOwnPropsEqual = shallowEqual,
  areStatePropsEqual = shallowEqual,
  areMergedPropsEqual = shallowEqual,
  // use React's forwardRef to expose a ref of the wrapped component
  forwardRef = false,
  // the context consumer to use
  context = ReactReduxContext
} = {}) {
  if (false) {}

  const Context = context;
  const initMapStateToProps = mapStateToPropsFactory(mapStateToProps);
  const initMapDispatchToProps = mapDispatchToPropsFactory(mapDispatchToProps);
  const initMergeProps = mergePropsFactory(mergeProps);
  const shouldHandleStateChanges = Boolean(mapStateToProps);

  const wrapWithConnect = WrappedComponent => {
    if (false) {}

    const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    const displayName = `Connect(${wrappedComponentName})`;
    const selectorFactoryOptions = {
      shouldHandleStateChanges,
      displayName,
      wrappedComponentName,
      WrappedComponent,
      // @ts-ignore
      initMapStateToProps,
      // @ts-ignore
      initMapDispatchToProps,
      initMergeProps,
      areStatesEqual,
      areStatePropsEqual,
      areOwnPropsEqual,
      areMergedPropsEqual
    };

    function ConnectFunction(props) {
      const [propsContext, reactReduxForwardedRef, wrapperProps] = useMemo(() => {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        const {
          reactReduxForwardedRef
        } = props,
              wrapperProps = _objectWithoutPropertiesLoose(props, _excluded);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]);
      const ContextToUse = useMemo(() => {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && // @ts-ignore
        isContextConsumer( /*#__PURE__*/React.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      const contextValue = useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      const store = didStoreComeFromProps ? props.store : contextValue.store;
      const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
      const childPropsSelector = useMemo(() => {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return defaultSelectorFactory(store.dispatch, selectorFactoryOptions);
      }, [store]);
      const [subscription, notifyNestedSubs] = useMemo(() => {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        const subscription = createSubscription(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]); // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.

      const overriddenContextValue = useMemo(() => {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return _extends({}, contextValue, {
          subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // Set up refs to coordinate values between the subscription effect and the render logic

      const lastChildProps = useRef();
      const lastWrapperProps = useRef(wrapperProps);
      const childPropsFromStoreUpdate = useRef();
      const renderIsScheduled = useRef(false);
      const isProcessingDispatch = useRef(false);
      const isMounted = useRef(false);
      const latestSubscriptionCallbackError = useRef();
      useIsomorphicLayoutEffect(() => {
        isMounted.current = true;
        return () => {
          isMounted.current = false;
        };
      }, []);
      const actualChildPropsSelector = useMemo(() => {
        const selector = () => {
          // Tricky logic here:
          // - This render may have been triggered by a Redux store update that produced new child props
          // - However, we may have gotten new wrapper props after that
          // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
          // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
          // So, we'll use the child props from store update only if the wrapper props are the same as last time.
          if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
            return childPropsFromStoreUpdate.current;
          } // TODO We're reading the store directly in render() here. Bad idea?
          // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
          // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
          // to determine what the child props should be.


          return childPropsSelector(store.getState(), wrapperProps);
        };

        return selector;
      }, [store, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      const subscribeForReact = useMemo(() => {
        const subscribe = reactListener => {
          if (!subscription) {
            return () => {};
          }

          return subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
          childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
        };

        return subscribe;
      }, [subscription]);
      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs]);
      let actualChildProps;

      try {
        actualChildProps = useSyncExternalStore( // TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
        subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
        // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
        actualChildPropsSelector, getServerState ? () => childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
      } catch (err) {
        if (latestSubscriptionCallbackError.current) {
          ;
          err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
        }

        throw err;
      }

      useIsomorphicLayoutEffect(() => {
        latestSubscriptionCallbackError.current = undefined;
        childPropsFromStoreUpdate.current = undefined;
        lastChildProps.current = actualChildProps;
      }); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      const renderedWrappedComponent = useMemo(() => {
        return (
          /*#__PURE__*/
          // @ts-ignore
          React.createElement(WrappedComponent, _extends({}, actualChildProps, {
            ref: reactReduxForwardedRef
          }))
        );
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      const renderedChild = useMemo(() => {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/React.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    }

    const _Connect = React.memo(ConnectFunction);

    // Add a hacky cast to get the right output type
    const Connect = _Connect;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      const _forwarded = React.forwardRef(function forwardConnectRef(props, ref) {
        // @ts-ignore
        return /*#__PURE__*/React.createElement(Connect, _extends({}, props, {
          reactReduxForwardedRef: ref
        }));
      });

      const forwarded = _forwarded;
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistStatics(forwarded, WrappedComponent);
    }

    return hoistStatics(Connect, WrappedComponent);
  };

  return wrapWithConnect;
}

/* harmony default export */ var components_connect = ((/* unused pure expression or super */ null && (connect)));
;// CONCATENATED MODULE: ../node_modules/react-redux/es/components/Provider.js





function Provider({
  store,
  context,
  children,
  serverState
}) {
  const contextValue = (0,react.useMemo)(() => {
    const subscription = Subscription_createSubscription(store);
    return {
      store,
      subscription,
      getServerState: serverState ? () => serverState : undefined
    };
  }, [store, serverState]);
  const previousState = (0,react.useMemo)(() => store.getState(), [store]);
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(() => {
    const {
      subscription
    } = contextValue;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return () => {
      subscription.tryUnsubscribe();
      subscription.onStateChange = undefined;
    };
  }, [contextValue, previousState]);
  const Context = context || Context_ReactReduxContext; // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype

  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

/* harmony default export */ var components_Provider = (Provider);
;// CONCATENATED MODULE: ../node_modules/react-redux/es/hooks/useStore.js



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context = Context_ReactReduxContext) {
  const useReduxContext = // @ts-ignore
  context === Context_ReactReduxContext ? useReduxContext_useReduxContext : () => (0,react.useContext)(context);
  return function useStore() {
    const {
      store
    } = useReduxContext(); // @ts-ignore

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

const useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ../node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context = Context_ReactReduxContext) {
  const useStore = // @ts-ignore
  context === Context_ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    const store = useStore(); // @ts-ignore

    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

const useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ../node_modules/react-redux/es/exports.js









;// CONCATENATED MODULE: ../node_modules/react-redux/es/index.js
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.






initializeUseSelector(with_selector.useSyncExternalStoreWithSelector);
initializeConnect(shim.useSyncExternalStore); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);



/***/ }),

/***/ 57321:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(27378)) :
  0;
}(this, (function (exports, React) {
  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () {
              return e[k];
            }
          });
        }
      });
    }
    n['default'] = e;
    return n;
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var LEFT = "Left";
  var RIGHT = "Right";
  var UP = "Up";
  var DOWN = "Down";

  var defaultProps = {
    delta: 10,
    preventDefaultTouchmoveEvent: false,
    rotationAngle: 0,
    trackMouse: false,
    trackTouch: true
  };
  var initialState = {
    first: true,
    initial: [0, 0],
    start: 0,
    swiping: false,
    xy: [0, 0]
  };
  var mouseMove = "mousemove";
  var mouseUp = "mouseup";
  var touchEnd = "touchend";
  var touchMove = "touchmove";
  var touchStart = "touchstart";

  function getDirection(absX, absY, deltaX, deltaY) {
    if (absX > absY) {
      if (deltaX > 0) {
        return RIGHT;
      }

      return LEFT;
    } else if (deltaY > 0) {
      return DOWN;
    }

    return UP;
  }

  function rotateXYByAngle(pos, angle) {
    if (angle === 0) return pos;
    var angleInRadians = Math.PI / 180 * angle;
    var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
    var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
    return [x, y];
  }

  function getHandlers(set, handlerProps) {
    var onStart = function onStart(event) {
      if (event && "touches" in event && event.touches.length > 1) return;
      set(function (state, props) {
        if (props.trackMouse) {
          document.addEventListener(mouseMove, onMove);
          document.addEventListener(mouseUp, onUp);
        }

        var _ref = "touches" in event ? event.touches[0] : event,
            clientX = _ref.clientX,
            clientY = _ref.clientY;

        var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
        return _extends({}, state, initialState, {
          initial: [].concat(xy),
          xy: xy,
          start: event.timeStamp || 0
        });
      });
    };

    var onMove = function onMove(event) {
      set(function (state, props) {
        if ("touches" in event && event.touches.length > 1) {
          return state;
        }

        var _ref2 = "touches" in event ? event.touches[0] : event,
            clientX = _ref2.clientX,
            clientY = _ref2.clientY;

        var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
            x = _rotateXYByAngle[0],
            y = _rotateXYByAngle[1];

        var deltaX = x - state.xy[0];
        var deltaY = y - state.xy[1];
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);
        var time = (event.timeStamp || 0) - state.start;
        var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
        var vxvy = [deltaX / (time || 1), deltaY / (time || 1)];
        var dir = getDirection(absX, absY, deltaX, deltaY);
        var delta = typeof props.delta === "number" ? props.delta : props.delta[dir.toLowerCase()] || defaultProps.delta;
        if (absX < delta && absY < delta && !state.swiping) return state;
        var eventData = {
          absX: absX,
          absY: absY,
          deltaX: deltaX,
          deltaY: deltaY,
          dir: dir,
          event: event,
          first: state.first,
          initial: state.initial,
          velocity: velocity,
          vxvy: vxvy
        };
        eventData.first && props.onSwipeStart && props.onSwipeStart(eventData);
        props.onSwiping && props.onSwiping(eventData);
        var cancelablePageSwipe = false;

        if (props.onSwiping || props.onSwiped || "onSwiped" + dir in props) {
          cancelablePageSwipe = true;
        }

        if (cancelablePageSwipe && props.preventDefaultTouchmoveEvent && props.trackTouch && event.cancelable) event.preventDefault();
        return _extends({}, state, {
          first: false,
          eventData: eventData,
          swiping: true
        });
      });
    };

    var onEnd = function onEnd(event) {
      set(function (state, props) {
        var eventData;

        if (state.swiping && state.eventData) {
          eventData = _extends({}, state.eventData, {
            event: event
          });
          props.onSwiped && props.onSwiped(eventData);
          var onSwipedDir = props["onSwiped" + eventData.dir];
          onSwipedDir && onSwipedDir(eventData);
        } else {
          props.onTap && props.onTap({
            event: event
          });
        }

        return _extends({}, state, initialState, {
          eventData: eventData
        });
      });
    };

    var cleanUpMouse = function cleanUpMouse() {
      document.removeEventListener(mouseMove, onMove);
      document.removeEventListener(mouseUp, onUp);
    };

    var onUp = function onUp(e) {
      cleanUpMouse();
      onEnd(e);
    };

    var attachTouch = function attachTouch(el, passive) {
      var cleanup = function cleanup() {};

      if (el && el.addEventListener) {
        var tls = [[touchStart, onStart], [touchMove, onMove], [touchEnd, onEnd]];
        tls.forEach(function (_ref3) {
          var e = _ref3[0],
              h = _ref3[1];
          return el.addEventListener(e, h, {
            passive: passive
          });
        });

        cleanup = function cleanup() {
          return tls.forEach(function (_ref4) {
            var e = _ref4[0],
                h = _ref4[1];
            return el.removeEventListener(e, h);
          });
        };
      }

      return cleanup;
    };

    var onRef = function onRef(el) {
      if (el === null) return;
      set(function (state, props) {
        if (state.el === el) return state;
        var addState = {};

        if (state.el && state.el !== el && state.cleanUpTouch) {
          state.cleanUpTouch();
          addState.cleanUpTouch = void 0;
        }

        if (props.trackTouch && el) {
          addState.cleanUpTouch = attachTouch(el, !props.preventDefaultTouchmoveEvent);
        }

        return _extends({}, state, {
          el: el
        }, addState);
      });
    };

    var output = {
      ref: onRef
    };

    if (handlerProps.trackMouse) {
      output.onMouseDown = onStart;
    }

    return [output, attachTouch];
  }

  function updateTransientState(state, props, attachTouch) {
    var addState = {};

    if (!props.trackTouch && state.cleanUpTouch) {
      state.cleanUpTouch();
      addState.cleanUpTouch = void 0;
    } else if (props.trackTouch && !state.cleanUpTouch) {
      if (state.el) {
        addState.cleanUpTouch = attachTouch(state.el, !props.preventDefaultTouchmoveEvent);
      }
    }

    return _extends({}, state, addState);
  }

  function useSwipeable(options) {
    var trackMouse = options.trackMouse;
    var transientState = React__namespace.useRef(_extends({}, initialState));
    var transientProps = React__namespace.useRef(_extends({}, defaultProps));
    transientProps.current = _extends({}, defaultProps, options, {
      delta: options.delta === void 0 ? defaultProps.delta : options.delta,
      rotationAngle: options.rotationAngle === void 0 ? defaultProps.rotationAngle : options.rotationAngle,
      trackTouch: options.trackTouch === void 0 ? defaultProps.trackTouch : options.trackTouch
    });

    var _React$useMemo = React__namespace.useMemo(function () {
      return getHandlers(function (stateSetter) {
        return transientState.current = stateSetter(transientState.current, transientProps.current);
      }, {
        trackMouse: trackMouse
      });
    }, [trackMouse]),
        handlers = _React$useMemo[0],
        attachTouch = _React$useMemo[1];

    transientState.current = updateTransientState(transientState.current, transientProps.current, attachTouch);
    return handlers;
  }

  exports.DOWN = DOWN;
  exports.LEFT = LEFT;
  exports.RIGHT = RIGHT;
  exports.UP = UP;
  exports.useSwipeable = useSwipeable;

})));
//# sourceMappingURL=react-swipeable.umd.js.map


/***/ }),

/***/ 93092:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { AbortError, codes } = __webpack_require__(58380)

const eos = __webpack_require__(85027)

const { ERR_INVALID_ARG_TYPE } = codes // This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029

const validateAbortSignal = (signal, name) => {
  if (typeof signal !== 'object' || !('aborted' in signal)) {
    throw new ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal)
  }
}

function isNodeStream(obj) {
  return !!(obj && typeof obj.pipe === 'function')
}

module.exports.addAbortSignal = function addAbortSignal(signal, stream) {
  validateAbortSignal(signal, 'signal')

  if (!isNodeStream(stream)) {
    throw new ERR_INVALID_ARG_TYPE('stream', 'stream.Stream', stream)
  }

  return module.exports.addAbortSignalNoValidate(signal, stream)
}

module.exports.addAbortSignalNoValidate = function (signal, stream) {
  if (typeof signal !== 'object' || !('aborted' in signal)) {
    return stream
  }

  const onAbort = () => {
    stream.destroy(
      new AbortError(undefined, {
        cause: signal.reason
      })
    )
  }

  if (signal.aborted) {
    onAbort()
  } else {
    signal.addEventListener('abort', onAbort)
    eos(stream, () => signal.removeEventListener('abort', onAbort))
  }

  return stream
}


/***/ }),

/***/ 57712:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { StringPrototypeSlice, SymbolIterator, TypedArrayPrototypeSet, Uint8Array } = __webpack_require__(57793)

const { Buffer } = __webpack_require__(30816)

const { inspect } = __webpack_require__(55616)

module.exports = class BufferList {
  constructor() {
    this.head = null
    this.tail = null
    this.length = 0
  }

  push(v) {
    const entry = {
      data: v,
      next: null
    }
    if (this.length > 0) this.tail.next = entry
    else this.head = entry
    this.tail = entry
    ++this.length
  }

  unshift(v) {
    const entry = {
      data: v,
      next: this.head
    }
    if (this.length === 0) this.tail = entry
    this.head = entry
    ++this.length
  }

  shift() {
    if (this.length === 0) return
    const ret = this.head.data
    if (this.length === 1) this.head = this.tail = null
    else this.head = this.head.next
    --this.length
    return ret
  }

  clear() {
    this.head = this.tail = null
    this.length = 0
  }

  join(s) {
    if (this.length === 0) return ''
    let p = this.head
    let ret = '' + p.data

    while ((p = p.next) !== null) ret += s + p.data

    return ret
  }

  concat(n) {
    if (this.length === 0) return Buffer.alloc(0)
    const ret = Buffer.allocUnsafe(n >>> 0)
    let p = this.head
    let i = 0

    while (p) {
      TypedArrayPrototypeSet(ret, p.data, i)
      i += p.data.length
      p = p.next
    }

    return ret
  } // Consumes a specified amount of bytes or characters from the buffered data.

  consume(n, hasStrings) {
    const data = this.head.data

    if (n < data.length) {
      // `slice` is the same for buffers and strings.
      const slice = data.slice(0, n)
      this.head.data = data.slice(n)
      return slice
    }

    if (n === data.length) {
      // First chunk is a perfect match.
      return this.shift()
    } // Result spans more than one buffer.

    return hasStrings ? this._getString(n) : this._getBuffer(n)
  }

  first() {
    return this.head.data
  }

  *[SymbolIterator]() {
    for (let p = this.head; p; p = p.next) {
      yield p.data
    }
  } // Consumes a specified amount of characters from the buffered data.

  _getString(n) {
    let ret = ''
    let p = this.head
    let c = 0

    do {
      const str = p.data

      if (n > str.length) {
        ret += str
        n -= str.length
      } else {
        if (n === str.length) {
          ret += str
          ++c
          if (p.next) this.head = p.next
          else this.head = this.tail = null
        } else {
          ret += StringPrototypeSlice(str, 0, n)
          this.head = p
          p.data = StringPrototypeSlice(str, n)
        }

        break
      }

      ++c
    } while ((p = p.next) !== null)

    this.length -= c
    return ret
  } // Consumes a specified amount of bytes from the buffered data.

  _getBuffer(n) {
    const ret = Buffer.allocUnsafe(n)
    const retLen = n
    let p = this.head
    let c = 0

    do {
      const buf = p.data

      if (n > buf.length) {
        TypedArrayPrototypeSet(ret, buf, retLen - n)
        n -= buf.length
      } else {
        if (n === buf.length) {
          TypedArrayPrototypeSet(ret, buf, retLen - n)
          ++c
          if (p.next) this.head = p.next
          else this.head = this.tail = null
        } else {
          TypedArrayPrototypeSet(ret, new Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n)
          this.head = p
          p.data = buf.slice(n)
        }

        break
      }

      ++c
    } while ((p = p.next) !== null)

    this.length -= c
    return ret
  } // Make sure the linked list only shows the minimal necessary information.

  [Symbol.for('nodejs.util.inspect.custom')](_, options) {
    return inspect(this, {
      ...options,
      // Only inspect one level.
      depth: 0,
      // It should not recurse.
      customInspect: false
    })
  }
}


/***/ }),

/***/ 66036:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { pipeline } = __webpack_require__(20410)

const Duplex = __webpack_require__(55426)

const { destroyer } = __webpack_require__(27640)

const { isNodeStream, isReadable, isWritable } = __webpack_require__(81391)

const {
  AbortError,
  codes: { ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS }
} = __webpack_require__(58380)

module.exports = function compose(...streams) {
  if (streams.length === 0) {
    throw new ERR_MISSING_ARGS('streams')
  }

  if (streams.length === 1) {
    return Duplex.from(streams[0])
  }

  const orgStreams = [...streams]

  if (typeof streams[0] === 'function') {
    streams[0] = Duplex.from(streams[0])
  }

  if (typeof streams[streams.length - 1] === 'function') {
    const idx = streams.length - 1
    streams[idx] = Duplex.from(streams[idx])
  }

  for (let n = 0; n < streams.length; ++n) {
    if (!isNodeStream(streams[n])) {
      // TODO(ronag): Add checks for non streams.
      continue
    }

    if (n < streams.length - 1 && !isReadable(streams[n])) {
      throw new ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable')
    }

    if (n > 0 && !isWritable(streams[n])) {
      throw new ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable')
    }
  }

  let ondrain
  let onfinish
  let onreadable
  let onclose
  let d

  function onfinished(err) {
    const cb = onclose
    onclose = null

    if (cb) {
      cb(err)
    } else if (err) {
      d.destroy(err)
    } else if (!readable && !writable) {
      d.destroy()
    }
  }

  const head = streams[0]
  const tail = pipeline(streams, onfinished)
  const writable = !!isWritable(head)
  const readable = !!isReadable(tail) // TODO(ronag): Avoid double buffering.
  // Implement Writable/Readable/Duplex traits.
  // See, https://github.com/nodejs/node/pull/33515.

  d = new Duplex({
    // TODO (ronag): highWaterMark?
    writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
    readableObjectMode: !!(tail !== null && tail !== undefined && tail.writableObjectMode),
    writable,
    readable
  })

  if (writable) {
    d._write = function (chunk, encoding, callback) {
      if (head.write(chunk, encoding)) {
        callback()
      } else {
        ondrain = callback
      }
    }

    d._final = function (callback) {
      head.end()
      onfinish = callback
    }

    head.on('drain', function () {
      if (ondrain) {
        const cb = ondrain
        ondrain = null
        cb()
      }
    })
    tail.on('finish', function () {
      if (onfinish) {
        const cb = onfinish
        onfinish = null
        cb()
      }
    })
  }

  if (readable) {
    tail.on('readable', function () {
      if (onreadable) {
        const cb = onreadable
        onreadable = null
        cb()
      }
    })
    tail.on('end', function () {
      d.push(null)
    })

    d._read = function () {
      while (true) {
        const buf = tail.read()

        if (buf === null) {
          onreadable = d._read
          return
        }

        if (!d.push(buf)) {
          return
        }
      }
    }
  }

  d._destroy = function (err, callback) {
    if (!err && onclose !== null) {
      err = new AbortError()
    }

    onreadable = null
    ondrain = null
    onfinish = null

    if (onclose === null) {
      callback(err)
    } else {
      onclose = callback
      destroyer(tail, err)
    }
  }

  return d
}


/***/ }),

/***/ 27640:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* replacement start */

const process = __webpack_require__(27061)
/* replacement end */

const {
  aggregateTwoErrors,
  codes: { ERR_MULTIPLE_CALLBACK },
  AbortError
} = __webpack_require__(58380)

const { Symbol } = __webpack_require__(57793)

const { kDestroyed, isDestroyed, isFinished, isServerRequest } = __webpack_require__(81391)

const kDestroy = Symbol('kDestroy')
const kConstruct = Symbol('kConstruct')

function checkError(err, w, r) {
  if (err) {
    // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
    err.stack // eslint-disable-line no-unused-expressions

    if (w && !w.errored) {
      w.errored = err
    }

    if (r && !r.errored) {
      r.errored = err
    }
  }
} // Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.

function destroy(err, cb) {
  const r = this._readableState
  const w = this._writableState // With duplex streams we use the writable side for state.

  const s = w || r

  if ((w && w.destroyed) || (r && r.destroyed)) {
    if (typeof cb === 'function') {
      cb()
    }

    return this
  } // We set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  checkError(err, w, r)

  if (w) {
    w.destroyed = true
  }

  if (r) {
    r.destroyed = true
  } // If still constructing then defer calling _destroy.

  if (!s.constructed) {
    this.once(kDestroy, function (er) {
      _destroy(this, aggregateTwoErrors(er, err), cb)
    })
  } else {
    _destroy(this, err, cb)
  }

  return this
}

function _destroy(self, err, cb) {
  let called = false

  function onDestroy(err) {
    if (called) {
      return
    }

    called = true
    const r = self._readableState
    const w = self._writableState
    checkError(err, w, r)

    if (w) {
      w.closed = true
    }

    if (r) {
      r.closed = true
    }

    if (typeof cb === 'function') {
      cb(err)
    }

    if (err) {
      process.nextTick(emitErrorCloseNT, self, err)
    } else {
      process.nextTick(emitCloseNT, self)
    }
  }

  try {
    self._destroy(err || null, onDestroy)
  } catch (err) {
    onDestroy(err)
  }
}

function emitErrorCloseNT(self, err) {
  emitErrorNT(self, err)
  emitCloseNT(self)
}

function emitCloseNT(self) {
  const r = self._readableState
  const w = self._writableState

  if (w) {
    w.closeEmitted = true
  }

  if (r) {
    r.closeEmitted = true
  }

  if ((w && w.emitClose) || (r && r.emitClose)) {
    self.emit('close')
  }
}

function emitErrorNT(self, err) {
  const r = self._readableState
  const w = self._writableState

  if ((w && w.errorEmitted) || (r && r.errorEmitted)) {
    return
  }

  if (w) {
    w.errorEmitted = true
  }

  if (r) {
    r.errorEmitted = true
  }

  self.emit('error', err)
}

function undestroy() {
  const r = this._readableState
  const w = this._writableState

  if (r) {
    r.constructed = true
    r.closed = false
    r.closeEmitted = false
    r.destroyed = false
    r.errored = null
    r.errorEmitted = false
    r.reading = false
    r.ended = r.readable === false
    r.endEmitted = r.readable === false
  }

  if (w) {
    w.constructed = true
    w.destroyed = false
    w.closed = false
    w.closeEmitted = false
    w.errored = null
    w.errorEmitted = false
    w.finalCalled = false
    w.prefinished = false
    w.ended = w.writable === false
    w.ending = w.writable === false
    w.finished = w.writable === false
  }
}

function errorOrDestroy(stream, err, sync) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.
  const r = stream._readableState
  const w = stream._writableState

  if ((w && w.destroyed) || (r && r.destroyed)) {
    return this
  }

  if ((r && r.autoDestroy) || (w && w.autoDestroy)) stream.destroy(err)
  else if (err) {
    // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
    err.stack // eslint-disable-line no-unused-expressions

    if (w && !w.errored) {
      w.errored = err
    }

    if (r && !r.errored) {
      r.errored = err
    }

    if (sync) {
      process.nextTick(emitErrorNT, stream, err)
    } else {
      emitErrorNT(stream, err)
    }
  }
}

function construct(stream, cb) {
  if (typeof stream._construct !== 'function') {
    return
  }

  const r = stream._readableState
  const w = stream._writableState

  if (r) {
    r.constructed = false
  }

  if (w) {
    w.constructed = false
  }

  stream.once(kConstruct, cb)

  if (stream.listenerCount(kConstruct) > 1) {
    // Duplex
    return
  }

  process.nextTick(constructNT, stream)
}

function constructNT(stream) {
  let called = false

  function onConstruct(err) {
    if (called) {
      errorOrDestroy(stream, err !== null && err !== undefined ? err : new ERR_MULTIPLE_CALLBACK())
      return
    }

    called = true
    const r = stream._readableState
    const w = stream._writableState
    const s = w || r

    if (r) {
      r.constructed = true
    }

    if (w) {
      w.constructed = true
    }

    if (s.destroyed) {
      stream.emit(kDestroy, err)
    } else if (err) {
      errorOrDestroy(stream, err, true)
    } else {
      process.nextTick(emitConstructNT, stream)
    }
  }

  try {
    stream._construct(onConstruct)
  } catch (err) {
    onConstruct(err)
  }
}

function emitConstructNT(stream) {
  stream.emit(kConstruct)
}

function isRequest(stream) {
  return stream && stream.setHeader && typeof stream.abort === 'function'
}

function emitCloseLegacy(stream) {
  stream.emit('close')
}

function emitErrorCloseLegacy(stream, err) {
  stream.emit('error', err)
  process.nextTick(emitCloseLegacy, stream)
} // Normalize destroy for legacy.

function destroyer(stream, err) {
  if (!stream || isDestroyed(stream)) {
    return
  }

  if (!err && !isFinished(stream)) {
    err = new AbortError()
  } // TODO: Remove isRequest branches.

  if (isServerRequest(stream)) {
    stream.socket = null
    stream.destroy(err)
  } else if (isRequest(stream)) {
    stream.abort()
  } else if (isRequest(stream.req)) {
    stream.req.abort()
  } else if (typeof stream.destroy === 'function') {
    stream.destroy(err)
  } else if (typeof stream.close === 'function') {
    // TODO: Don't lose err?
    stream.close()
  } else if (err) {
    process.nextTick(emitErrorCloseLegacy, stream, err)
  } else {
    process.nextTick(emitCloseLegacy, stream)
  }

  if (!stream.destroyed) {
    stream[kDestroyed] = true
  }
}

module.exports = {
  construct,
  destroyer,
  destroy,
  undestroy,
  errorOrDestroy
}


/***/ }),

/***/ 55426:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.


const {
  ObjectDefineProperties,
  ObjectGetOwnPropertyDescriptor,
  ObjectKeys,
  ObjectSetPrototypeOf
} = __webpack_require__(57793)

module.exports = Duplex

const Readable = __webpack_require__(61716)

const Writable = __webpack_require__(69337)

ObjectSetPrototypeOf(Duplex.prototype, Readable.prototype)
ObjectSetPrototypeOf(Duplex, Readable)
{
  const keys = ObjectKeys(Writable.prototype) // Allow the keys array to be GC'ed.

  for (let i = 0; i < keys.length; i++) {
    const method = keys[i]
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method]
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options)
  Readable.call(this, options)
  Writable.call(this, options)

  if (options) {
    this.allowHalfOpen = options.allowHalfOpen !== false

    if (options.readable === false) {
      this._readableState.readable = false
      this._readableState.ended = true
      this._readableState.endEmitted = true
    }

    if (options.writable === false) {
      this._writableState.writable = false
      this._writableState.ending = true
      this._writableState.ended = true
      this._writableState.finished = true
    }
  } else {
    this.allowHalfOpen = true
  }
}

ObjectDefineProperties(Duplex.prototype, {
  writable: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writable')
  },
  writableHighWaterMark: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableHighWaterMark')
  },
  writableObjectMode: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableObjectMode')
  },
  writableBuffer: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableBuffer')
  },
  writableLength: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableLength')
  },
  writableFinished: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableFinished')
  },
  writableCorked: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableCorked')
  },
  writableEnded: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableEnded')
  },
  writableNeedDrain: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableNeedDrain')
  },
  destroyed: {
    __proto__: null,

    get() {
      if (this._readableState === undefined || this._writableState === undefined) {
        return false
      }

      return this._readableState.destroyed && this._writableState.destroyed
    },

    set(value) {
      // Backward compatibility, the user is explicitly
      // managing destroyed.
      if (this._readableState && this._writableState) {
        this._readableState.destroyed = value
        this._writableState.destroyed = value
      }
    }
  }
})
let webStreamsAdapters // Lazy to avoid circular references

function lazyWebStreams() {
  if (webStreamsAdapters === undefined) webStreamsAdapters = {}
  return webStreamsAdapters
}

Duplex.fromWeb = function (pair, options) {
  return lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options)
}

Duplex.toWeb = function (duplex) {
  return lazyWebStreams().newReadableWritablePairFromDuplex(duplex)
}

let duplexify

Duplex.from = function (body) {
  if (!duplexify) {
    duplexify = __webpack_require__(9981)
  }

  return duplexify(body, 'body')
}


/***/ }),

/***/ 9981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* replacement start */
const process = __webpack_require__(27061)
/* replacement end */

;('use strict')

const bufferModule = __webpack_require__(30816)

const {
  isReadable,
  isWritable,
  isIterable,
  isNodeStream,
  isReadableNodeStream,
  isWritableNodeStream,
  isDuplexNodeStream
} = __webpack_require__(81391)

const eos = __webpack_require__(85027)

const {
  AbortError,
  codes: { ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE }
} = __webpack_require__(58380)

const { destroyer } = __webpack_require__(27640)

const Duplex = __webpack_require__(55426)

const Readable = __webpack_require__(61716)

const { createDeferredPromise } = __webpack_require__(55616)

const from = __webpack_require__(26963)

const Blob = globalThis.Blob || bufferModule.Blob
const isBlob =
  typeof Blob !== 'undefined'
    ? function isBlob(b) {
        return b instanceof Blob
      }
    : function isBlob(b) {
        return false
      }

const AbortController = globalThis.AbortController || (__webpack_require__(30473).AbortController)

const { FunctionPrototypeCall } = __webpack_require__(57793) // This is needed for pre node 17.

class Duplexify extends Duplex {
  constructor(options) {
    super(options) // https://github.com/nodejs/node/pull/34385

    if ((options === null || options === undefined ? undefined : options.readable) === false) {
      this._readableState.readable = false
      this._readableState.ended = true
      this._readableState.endEmitted = true
    }

    if ((options === null || options === undefined ? undefined : options.writable) === false) {
      this._writableState.writable = false
      this._writableState.ending = true
      this._writableState.ended = true
      this._writableState.finished = true
    }
  }
}

module.exports = function duplexify(body, name) {
  if (isDuplexNodeStream(body)) {
    return body
  }

  if (isReadableNodeStream(body)) {
    return _duplexify({
      readable: body
    })
  }

  if (isWritableNodeStream(body)) {
    return _duplexify({
      writable: body
    })
  }

  if (isNodeStream(body)) {
    return _duplexify({
      writable: false,
      readable: false
    })
  } // TODO: Webstreams
  // if (isReadableStream(body)) {
  //   return _duplexify({ readable: Readable.fromWeb(body) });
  // }
  // TODO: Webstreams
  // if (isWritableStream(body)) {
  //   return _duplexify({ writable: Writable.fromWeb(body) });
  // }

  if (typeof body === 'function') {
    const { value, write, final, destroy } = fromAsyncGen(body)

    if (isIterable(value)) {
      return from(Duplexify, value, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        write,
        final,
        destroy
      })
    }

    const then = value === null || value === undefined ? undefined : value.then

    if (typeof then === 'function') {
      let d
      const promise = FunctionPrototypeCall(
        then,
        value,
        (val) => {
          if (val != null) {
            throw new ERR_INVALID_RETURN_VALUE('nully', 'body', val)
          }
        },
        (err) => {
          destroyer(d, err)
        }
      )
      return (d = new Duplexify({
        // TODO (ronag): highWaterMark?
        objectMode: true,
        readable: false,
        write,

        final(cb) {
          final(async () => {
            try {
              await promise
              process.nextTick(cb, null)
            } catch (err) {
              process.nextTick(cb, err)
            }
          })
        },

        destroy
      }))
    }

    throw new ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value)
  }

  if (isBlob(body)) {
    return duplexify(body.arrayBuffer())
  }

  if (isIterable(body)) {
    return from(Duplexify, body, {
      // TODO (ronag): highWaterMark?
      objectMode: true,
      writable: false
    })
  } // TODO: Webstreams.
  // if (
  //   isReadableStream(body?.readable) &&
  //   isWritableStream(body?.writable)
  // ) {
  //   return Duplexify.fromWeb(body);
  // }

  if (
    typeof (body === null || body === undefined ? undefined : body.writable) === 'object' ||
    typeof (body === null || body === undefined ? undefined : body.readable) === 'object'
  ) {
    const readable =
      body !== null && body !== undefined && body.readable
        ? isReadableNodeStream(body === null || body === undefined ? undefined : body.readable)
          ? body === null || body === undefined
            ? undefined
            : body.readable
          : duplexify(body.readable)
        : undefined
    const writable =
      body !== null && body !== undefined && body.writable
        ? isWritableNodeStream(body === null || body === undefined ? undefined : body.writable)
          ? body === null || body === undefined
            ? undefined
            : body.writable
          : duplexify(body.writable)
        : undefined
    return _duplexify({
      readable,
      writable
    })
  }

  const then = body === null || body === undefined ? undefined : body.then

  if (typeof then === 'function') {
    let d
    FunctionPrototypeCall(
      then,
      body,
      (val) => {
        if (val != null) {
          d.push(val)
        }

        d.push(null)
      },
      (err) => {
        destroyer(d, err)
      }
    )
    return (d = new Duplexify({
      objectMode: true,
      writable: false,

      read() {}
    }))
  }

  throw new ERR_INVALID_ARG_TYPE(
    name,
    [
      'Blob',
      'ReadableStream',
      'WritableStream',
      'Stream',
      'Iterable',
      'AsyncIterable',
      'Function',
      '{ readable, writable } pair',
      'Promise'
    ],
    body
  )
}

function fromAsyncGen(fn) {
  let { promise, resolve } = createDeferredPromise()
  const ac = new AbortController()
  const signal = ac.signal
  const value = fn(
    (async function* () {
      while (true) {
        const _promise = promise
        promise = null
        const { chunk, done, cb } = await _promise
        process.nextTick(cb)
        if (done) return
        if (signal.aborted)
          throw new AbortError(undefined, {
            cause: signal.reason
          })
        ;({ promise, resolve } = createDeferredPromise())
        yield chunk
      }
    })(),
    {
      signal
    }
  )
  return {
    value,

    write(chunk, encoding, cb) {
      const _resolve = resolve
      resolve = null

      _resolve({
        chunk,
        done: false,
        cb
      })
    },

    final(cb) {
      const _resolve = resolve
      resolve = null

      _resolve({
        done: true,
        cb
      })
    },

    destroy(err, cb) {
      ac.abort()
      cb(err)
    }
  }
}

function _duplexify(pair) {
  const r = pair.readable && typeof pair.readable.read !== 'function' ? Readable.wrap(pair.readable) : pair.readable
  const w = pair.writable
  let readable = !!isReadable(r)
  let writable = !!isWritable(w)
  let ondrain
  let onfinish
  let onreadable
  let onclose
  let d

  function onfinished(err) {
    const cb = onclose
    onclose = null

    if (cb) {
      cb(err)
    } else if (err) {
      d.destroy(err)
    } else if (!readable && !writable) {
      d.destroy()
    }
  } // TODO(ronag): Avoid double buffering.
  // Implement Writable/Readable/Duplex traits.
  // See, https://github.com/nodejs/node/pull/33515.

  d = new Duplexify({
    // TODO (ronag): highWaterMark?
    readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
    writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
    readable,
    writable
  })

  if (writable) {
    eos(w, (err) => {
      writable = false

      if (err) {
        destroyer(r, err)
      }

      onfinished(err)
    })

    d._write = function (chunk, encoding, callback) {
      if (w.write(chunk, encoding)) {
        callback()
      } else {
        ondrain = callback
      }
    }

    d._final = function (callback) {
      w.end()
      onfinish = callback
    }

    w.on('drain', function () {
      if (ondrain) {
        const cb = ondrain
        ondrain = null
        cb()
      }
    })
    w.on('finish', function () {
      if (onfinish) {
        const cb = onfinish
        onfinish = null
        cb()
      }
    })
  }

  if (readable) {
    eos(r, (err) => {
      readable = false

      if (err) {
        destroyer(r, err)
      }

      onfinished(err)
    })
    r.on('readable', function () {
      if (onreadable) {
        const cb = onreadable
        onreadable = null
        cb()
      }
    })
    r.on('end', function () {
      d.push(null)
    })

    d._read = function () {
      while (true) {
        const buf = r.read()

        if (buf === null) {
          onreadable = d._read
          return
        }

        if (!d.push(buf)) {
          return
        }
      }
    }
  }

  d._destroy = function (err, callback) {
    if (!err && onclose !== null) {
      err = new AbortError()
    }

    onreadable = null
    ondrain = null
    onfinish = null

    if (onclose === null) {
      callback(err)
    } else {
      onclose = callback
      destroyer(w, err)
      destroyer(r, err)
    }
  }

  return d
}


/***/ }),

/***/ 85027:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* replacement start */
const process = __webpack_require__(27061)
/* replacement end */
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).

;('use strict')

const { AbortError, codes } = __webpack_require__(58380)

const { ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE } = codes

const { kEmptyObject, once } = __webpack_require__(55616)

const { validateAbortSignal, validateFunction, validateObject } = __webpack_require__(85132)

const { Promise } = __webpack_require__(57793)

const {
  isClosed,
  isReadable,
  isReadableNodeStream,
  isReadableFinished,
  isReadableErrored,
  isWritable,
  isWritableNodeStream,
  isWritableFinished,
  isWritableErrored,
  isNodeStream,
  willEmitClose: _willEmitClose
} = __webpack_require__(81391)

function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function'
}

const nop = () => {}

function eos(stream, options, callback) {
  var _options$readable, _options$writable

  if (arguments.length === 2) {
    callback = options
    options = kEmptyObject
  } else if (options == null) {
    options = kEmptyObject
  } else {
    validateObject(options, 'options')
  }

  validateFunction(callback, 'callback')
  validateAbortSignal(options.signal, 'options.signal')
  callback = once(callback)
  const readable =
    (_options$readable = options.readable) !== null && _options$readable !== undefined
      ? _options$readable
      : isReadableNodeStream(stream)
  const writable =
    (_options$writable = options.writable) !== null && _options$writable !== undefined
      ? _options$writable
      : isWritableNodeStream(stream)

  if (!isNodeStream(stream)) {
    // TODO: Webstreams.
    throw new ERR_INVALID_ARG_TYPE('stream', 'Stream', stream)
  }

  const wState = stream._writableState
  const rState = stream._readableState

  const onlegacyfinish = () => {
    if (!stream.writable) {
      onfinish()
    }
  } // TODO (ronag): Improve soft detection to include core modules and
  // common ecosystem modules that do properly emit 'close' but fail
  // this generic check.

  let willEmitClose =
    _willEmitClose(stream) && isReadableNodeStream(stream) === readable && isWritableNodeStream(stream) === writable
  let writableFinished = isWritableFinished(stream, false)

  const onfinish = () => {
    writableFinished = true // Stream should not be destroyed here. If it is that
    // means that user space is doing something differently and
    // we cannot trust willEmitClose.

    if (stream.destroyed) {
      willEmitClose = false
    }

    if (willEmitClose && (!stream.readable || readable)) {
      return
    }

    if (!readable || readableFinished) {
      callback.call(stream)
    }
  }

  let readableFinished = isReadableFinished(stream, false)

  const onend = () => {
    readableFinished = true // Stream should not be destroyed here. If it is that
    // means that user space is doing something differently and
    // we cannot trust willEmitClose.

    if (stream.destroyed) {
      willEmitClose = false
    }

    if (willEmitClose && (!stream.writable || writable)) {
      return
    }

    if (!writable || writableFinished) {
      callback.call(stream)
    }
  }

  const onerror = (err) => {
    callback.call(stream, err)
  }

  let closed = isClosed(stream)

  const onclose = () => {
    closed = true
    const errored = isWritableErrored(stream) || isReadableErrored(stream)

    if (errored && typeof errored !== 'boolean') {
      return callback.call(stream, errored)
    }

    if (readable && !readableFinished && isReadableNodeStream(stream, true)) {
      if (!isReadableFinished(stream, false)) return callback.call(stream, new ERR_STREAM_PREMATURE_CLOSE())
    }

    if (writable && !writableFinished) {
      if (!isWritableFinished(stream, false)) return callback.call(stream, new ERR_STREAM_PREMATURE_CLOSE())
    }

    callback.call(stream)
  }

  const onrequest = () => {
    stream.req.on('finish', onfinish)
  }

  if (isRequest(stream)) {
    stream.on('complete', onfinish)

    if (!willEmitClose) {
      stream.on('abort', onclose)
    }

    if (stream.req) {
      onrequest()
    } else {
      stream.on('request', onrequest)
    }
  } else if (writable && !wState) {
    // legacy streams
    stream.on('end', onlegacyfinish)
    stream.on('close', onlegacyfinish)
  } // Not all streams will emit 'close' after 'aborted'.

  if (!willEmitClose && typeof stream.aborted === 'boolean') {
    stream.on('aborted', onclose)
  }

  stream.on('end', onend)
  stream.on('finish', onfinish)

  if (options.error !== false) {
    stream.on('error', onerror)
  }

  stream.on('close', onclose)

  if (closed) {
    process.nextTick(onclose)
  } else if (
    (wState !== null && wState !== undefined && wState.errorEmitted) ||
    (rState !== null && rState !== undefined && rState.errorEmitted)
  ) {
    if (!willEmitClose) {
      process.nextTick(onclose)
    }
  } else if (
    !readable &&
    (!willEmitClose || isReadable(stream)) &&
    (writableFinished || isWritable(stream) === false)
  ) {
    process.nextTick(onclose)
  } else if (
    !writable &&
    (!willEmitClose || isWritable(stream)) &&
    (readableFinished || isReadable(stream) === false)
  ) {
    process.nextTick(onclose)
  } else if (rState && stream.req && stream.aborted) {
    process.nextTick(onclose)
  }

  const cleanup = () => {
    callback = nop
    stream.removeListener('aborted', onclose)
    stream.removeListener('complete', onfinish)
    stream.removeListener('abort', onclose)
    stream.removeListener('request', onrequest)
    if (stream.req) stream.req.removeListener('finish', onfinish)
    stream.removeListener('end', onlegacyfinish)
    stream.removeListener('close', onlegacyfinish)
    stream.removeListener('finish', onfinish)
    stream.removeListener('end', onend)
    stream.removeListener('error', onerror)
    stream.removeListener('close', onclose)
  }

  if (options.signal && !closed) {
    const abort = () => {
      // Keep it because cleanup removes it.
      const endCallback = callback
      cleanup()
      endCallback.call(
        stream,
        new AbortError(undefined, {
          cause: options.signal.reason
        })
      )
    }

    if (options.signal.aborted) {
      process.nextTick(abort)
    } else {
      const originalCallback = callback
      callback = once((...args) => {
        options.signal.removeEventListener('abort', abort)
        originalCallback.apply(stream, args)
      })
      options.signal.addEventListener('abort', abort)
    }
  }

  return cleanup
}

function finished(stream, opts) {
  return new Promise((resolve, reject) => {
    eos(stream, opts, (err) => {
      if (err) {
        reject(err)
      } else {
        resolve()
      }
    })
  })
}

module.exports = eos
module.exports.finished = finished


/***/ }),

/***/ 26963:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* replacement start */

const process = __webpack_require__(27061)
/* replacement end */

const { PromisePrototypeThen, SymbolAsyncIterator, SymbolIterator } = __webpack_require__(57793)

const { Buffer } = __webpack_require__(30816)

const { ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES } = (__webpack_require__(58380).codes)

function from(Readable, iterable, opts) {
  let iterator

  if (typeof iterable === 'string' || iterable instanceof Buffer) {
    return new Readable({
      objectMode: true,
      ...opts,

      read() {
        this.push(iterable)
        this.push(null)
      }
    })
  }

  let isAsync

  if (iterable && iterable[SymbolAsyncIterator]) {
    isAsync = true
    iterator = iterable[SymbolAsyncIterator]()
  } else if (iterable && iterable[SymbolIterator]) {
    isAsync = false
    iterator = iterable[SymbolIterator]()
  } else {
    throw new ERR_INVALID_ARG_TYPE('iterable', ['Iterable'], iterable)
  }

  const readable = new Readable({
    objectMode: true,
    highWaterMark: 1,
    // TODO(ronag): What options should be allowed?
    ...opts
  }) // Flag to protect against _read
  // being called before last iteration completion.

  let reading = false

  readable._read = function () {
    if (!reading) {
      reading = true
      next()
    }
  }

  readable._destroy = function (error, cb) {
    PromisePrototypeThen(
      close(error),
      () => process.nextTick(cb, error), // nextTick is here in case cb throws
      (e) => process.nextTick(cb, e || error)
    )
  }

  async function close(error) {
    const hadError = error !== undefined && error !== null
    const hasThrow = typeof iterator.throw === 'function'

    if (hadError && hasThrow) {
      const { value, done } = await iterator.throw(error)
      await value

      if (done) {
        return
      }
    }

    if (typeof iterator.return === 'function') {
      const { value } = await iterator.return()
      await value
    }
  }

  async function next() {
    for (;;) {
      try {
        const { value, done } = isAsync ? await iterator.next() : iterator.next()

        if (done) {
          readable.push(null)
        } else {
          const res = value && typeof value.then === 'function' ? await value : value

          if (res === null) {
            reading = false
            throw new ERR_STREAM_NULL_VALUES()
          } else if (readable.push(res)) {
            continue
          } else {
            reading = false
          }
        }
      } catch (err) {
        readable.destroy(err)
      }

      break
    }
  }

  return readable
}

module.exports = from


/***/ }),

/***/ 55782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { ArrayIsArray, ObjectSetPrototypeOf } = __webpack_require__(57793)

const { EventEmitter: EE } = __webpack_require__(50343)

function Stream(opts) {
  EE.call(this, opts)
}

ObjectSetPrototypeOf(Stream.prototype, EE.prototype)
ObjectSetPrototypeOf(Stream, EE)

Stream.prototype.pipe = function (dest, options) {
  const source = this

  function ondata(chunk) {
    if (dest.writable && dest.write(chunk) === false && source.pause) {
      source.pause()
    }
  }

  source.on('data', ondata)

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume()
    }
  }

  dest.on('drain', ondrain) // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.

  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend)
    source.on('close', onclose)
  }

  let didOnEnd = false

  function onend() {
    if (didOnEnd) return
    didOnEnd = true
    dest.end()
  }

  function onclose() {
    if (didOnEnd) return
    didOnEnd = true
    if (typeof dest.destroy === 'function') dest.destroy()
  } // Don't leave dangling pipes when there are errors.

  function onerror(er) {
    cleanup()

    if (EE.listenerCount(this, 'error') === 0) {
      this.emit('error', er)
    }
  }

  prependListener(source, 'error', onerror)
  prependListener(dest, 'error', onerror) // Remove all the event listeners that were added.

  function cleanup() {
    source.removeListener('data', ondata)
    dest.removeListener('drain', ondrain)
    source.removeListener('end', onend)
    source.removeListener('close', onclose)
    source.removeListener('error', onerror)
    dest.removeListener('error', onerror)
    source.removeListener('end', cleanup)
    source.removeListener('close', cleanup)
    dest.removeListener('close', cleanup)
  }

  source.on('end', cleanup)
  source.on('close', cleanup)
  dest.on('close', cleanup)
  dest.emit('pipe', source) // Allow for unix-like usage: A.pipe(B).pipe(C)

  return dest
}

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn) // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.

  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn)
  else if (ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn)
  else emitter._events[event] = [fn, emitter._events[event]]
}

module.exports = {
  Stream,
  prependListener
}


/***/ }),

/***/ 54393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const AbortController = globalThis.AbortController || (__webpack_require__(30473).AbortController)

const {
  codes: { ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS, ERR_OUT_OF_RANGE },
  AbortError
} = __webpack_require__(58380)

const { validateAbortSignal, validateInteger, validateObject } = __webpack_require__(85132)

const kWeakHandler = (__webpack_require__(57793).Symbol)('kWeak')

const { finished } = __webpack_require__(85027)

const {
  ArrayPrototypePush,
  MathFloor,
  Number,
  NumberIsNaN,
  Promise,
  PromiseReject,
  PromisePrototypeThen,
  Symbol
} = __webpack_require__(57793)

const kEmpty = Symbol('kEmpty')
const kEof = Symbol('kEof')

function map(fn, options) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn)
  }

  if (options != null) {
    validateObject(options, 'options')
  }

  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }

  let concurrency = 1

  if ((options === null || options === undefined ? undefined : options.concurrency) != null) {
    concurrency = MathFloor(options.concurrency)
  }

  validateInteger(concurrency, 'concurrency', 1)
  return async function* map() {
    var _options$signal, _options$signal2

    const ac = new AbortController()
    const stream = this
    const queue = []
    const signal = ac.signal
    const signalOpt = {
      signal
    }

    const abort = () => ac.abort()

    if (
      options !== null &&
      options !== undefined &&
      (_options$signal = options.signal) !== null &&
      _options$signal !== undefined &&
      _options$signal.aborted
    ) {
      abort()
    }

    options === null || options === undefined
      ? undefined
      : (_options$signal2 = options.signal) === null || _options$signal2 === undefined
      ? undefined
      : _options$signal2.addEventListener('abort', abort)
    let next
    let resume
    let done = false

    function onDone() {
      done = true
    }

    async function pump() {
      try {
        for await (let val of stream) {
          var _val

          if (done) {
            return
          }

          if (signal.aborted) {
            throw new AbortError()
          }

          try {
            val = fn(val, signalOpt)
          } catch (err) {
            val = PromiseReject(err)
          }

          if (val === kEmpty) {
            continue
          }

          if (typeof ((_val = val) === null || _val === undefined ? undefined : _val.catch) === 'function') {
            val.catch(onDone)
          }

          queue.push(val)

          if (next) {
            next()
            next = null
          }

          if (!done && queue.length && queue.length >= concurrency) {
            await new Promise((resolve) => {
              resume = resolve
            })
          }
        }

        queue.push(kEof)
      } catch (err) {
        const val = PromiseReject(err)
        PromisePrototypeThen(val, undefined, onDone)
        queue.push(val)
      } finally {
        var _options$signal3

        done = true

        if (next) {
          next()
          next = null
        }

        options === null || options === undefined
          ? undefined
          : (_options$signal3 = options.signal) === null || _options$signal3 === undefined
          ? undefined
          : _options$signal3.removeEventListener('abort', abort)
      }
    }

    pump()

    try {
      while (true) {
        while (queue.length > 0) {
          const val = await queue[0]

          if (val === kEof) {
            return
          }

          if (signal.aborted) {
            throw new AbortError()
          }

          if (val !== kEmpty) {
            yield val
          }

          queue.shift()

          if (resume) {
            resume()
            resume = null
          }
        }

        await new Promise((resolve) => {
          next = resolve
        })
      }
    } finally {
      ac.abort()
      done = true

      if (resume) {
        resume()
        resume = null
      }
    }
  }.call(this)
}

function asIndexedPairs(options = undefined) {
  if (options != null) {
    validateObject(options, 'options')
  }

  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }

  return async function* asIndexedPairs() {
    let index = 0

    for await (const val of this) {
      var _options$signal4

      if (
        options !== null &&
        options !== undefined &&
        (_options$signal4 = options.signal) !== null &&
        _options$signal4 !== undefined &&
        _options$signal4.aborted
      ) {
        throw new AbortError({
          cause: options.signal.reason
        })
      }

      yield [index++, val]
    }
  }.call(this)
}

async function some(fn, options = undefined) {
  for await (const unused of filter.call(this, fn, options)) {
    return true
  }

  return false
}

async function every(fn, options = undefined) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn)
  } // https://en.wikipedia.org/wiki/De_Morgan%27s_laws

  return !(await some.call(
    this,
    async (...args) => {
      return !(await fn(...args))
    },
    options
  ))
}

async function find(fn, options) {
  for await (const result of filter.call(this, fn, options)) {
    return result
  }

  return undefined
}

async function forEach(fn, options) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn)
  }

  async function forEachFn(value, options) {
    await fn(value, options)
    return kEmpty
  } // eslint-disable-next-line no-unused-vars

  for await (const unused of map.call(this, forEachFn, options));
}

function filter(fn, options) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn)
  }

  async function filterFn(value, options) {
    if (await fn(value, options)) {
      return value
    }

    return kEmpty
  }

  return map.call(this, filterFn, options)
} // Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate

class ReduceAwareErrMissingArgs extends ERR_MISSING_ARGS {
  constructor() {
    super('reduce')
    this.message = 'Reduce of an empty stream requires an initial value'
  }
}

async function reduce(reducer, initialValue, options) {
  var _options$signal5

  if (typeof reducer !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('reducer', ['Function', 'AsyncFunction'], reducer)
  }

  if (options != null) {
    validateObject(options, 'options')
  }

  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }

  let hasInitialValue = arguments.length > 1

  if (
    options !== null &&
    options !== undefined &&
    (_options$signal5 = options.signal) !== null &&
    _options$signal5 !== undefined &&
    _options$signal5.aborted
  ) {
    const err = new AbortError(undefined, {
      cause: options.signal.reason
    })
    this.once('error', () => {}) // The error is already propagated

    await finished(this.destroy(err))
    throw err
  }

  const ac = new AbortController()
  const signal = ac.signal

  if (options !== null && options !== undefined && options.signal) {
    const opts = {
      once: true,
      [kWeakHandler]: this
    }
    options.signal.addEventListener('abort', () => ac.abort(), opts)
  }

  let gotAnyItemFromStream = false

  try {
    for await (const value of this) {
      var _options$signal6

      gotAnyItemFromStream = true

      if (
        options !== null &&
        options !== undefined &&
        (_options$signal6 = options.signal) !== null &&
        _options$signal6 !== undefined &&
        _options$signal6.aborted
      ) {
        throw new AbortError()
      }

      if (!hasInitialValue) {
        initialValue = value
        hasInitialValue = true
      } else {
        initialValue = await reducer(initialValue, value, {
          signal
        })
      }
    }

    if (!gotAnyItemFromStream && !hasInitialValue) {
      throw new ReduceAwareErrMissingArgs()
    }
  } finally {
    ac.abort()
  }

  return initialValue
}

async function toArray(options) {
  if (options != null) {
    validateObject(options, 'options')
  }

  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }

  const result = []

  for await (const val of this) {
    var _options$signal7

    if (
      options !== null &&
      options !== undefined &&
      (_options$signal7 = options.signal) !== null &&
      _options$signal7 !== undefined &&
      _options$signal7.aborted
    ) {
      throw new AbortError(undefined, {
        cause: options.signal.reason
      })
    }

    ArrayPrototypePush(result, val)
  }

  return result
}

function flatMap(fn, options) {
  const values = map.call(this, fn, options)
  return async function* flatMap() {
    for await (const val of values) {
      yield* val
    }
  }.call(this)
}

function toIntegerOrInfinity(number) {
  // We coerce here to align with the spec
  // https://github.com/tc39/proposal-iterator-helpers/issues/169
  number = Number(number)

  if (NumberIsNaN(number)) {
    return 0
  }

  if (number < 0) {
    throw new ERR_OUT_OF_RANGE('number', '>= 0', number)
  }

  return number
}

function drop(number, options = undefined) {
  if (options != null) {
    validateObject(options, 'options')
  }

  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }

  number = toIntegerOrInfinity(number)
  return async function* drop() {
    var _options$signal8

    if (
      options !== null &&
      options !== undefined &&
      (_options$signal8 = options.signal) !== null &&
      _options$signal8 !== undefined &&
      _options$signal8.aborted
    ) {
      throw new AbortError()
    }

    for await (const val of this) {
      var _options$signal9

      if (
        options !== null &&
        options !== undefined &&
        (_options$signal9 = options.signal) !== null &&
        _options$signal9 !== undefined &&
        _options$signal9.aborted
      ) {
        throw new AbortError()
      }

      if (number-- <= 0) {
        yield val
      }
    }
  }.call(this)
}

function take(number, options = undefined) {
  if (options != null) {
    validateObject(options, 'options')
  }

  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }

  number = toIntegerOrInfinity(number)
  return async function* take() {
    var _options$signal10

    if (
      options !== null &&
      options !== undefined &&
      (_options$signal10 = options.signal) !== null &&
      _options$signal10 !== undefined &&
      _options$signal10.aborted
    ) {
      throw new AbortError()
    }

    for await (const val of this) {
      var _options$signal11

      if (
        options !== null &&
        options !== undefined &&
        (_options$signal11 = options.signal) !== null &&
        _options$signal11 !== undefined &&
        _options$signal11.aborted
      ) {
        throw new AbortError()
      }

      if (number-- > 0) {
        yield val
      } else {
        return
      }
    }
  }.call(this)
}

module.exports.streamReturningOperators = {
  asIndexedPairs,
  drop,
  filter,
  flatMap,
  map,
  take
}
module.exports.promiseReturningOperators = {
  every,
  forEach,
  reduce,
  toArray,
  some,
  find
}


/***/ }),

/***/ 67640:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.


const { ObjectSetPrototypeOf } = __webpack_require__(57793)

module.exports = PassThrough

const Transform = __webpack_require__(20050)

ObjectSetPrototypeOf(PassThrough.prototype, Transform.prototype)
ObjectSetPrototypeOf(PassThrough, Transform)

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options)
  Transform.call(this, options)
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk)
}


/***/ }),

/***/ 20410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* replacement start */
const process = __webpack_require__(27061)
/* replacement end */
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).

;('use strict')

const { ArrayIsArray, Promise, SymbolAsyncIterator } = __webpack_require__(57793)

const eos = __webpack_require__(85027)

const { once } = __webpack_require__(55616)

const destroyImpl = __webpack_require__(27640)

const Duplex = __webpack_require__(55426)

const {
  aggregateTwoErrors,
  codes: {
    ERR_INVALID_ARG_TYPE,
    ERR_INVALID_RETURN_VALUE,
    ERR_MISSING_ARGS,
    ERR_STREAM_DESTROYED,
    ERR_STREAM_PREMATURE_CLOSE
  },
  AbortError
} = __webpack_require__(58380)

const { validateFunction, validateAbortSignal } = __webpack_require__(85132)

const { isIterable, isReadable, isReadableNodeStream, isNodeStream } = __webpack_require__(81391)

const AbortController = globalThis.AbortController || (__webpack_require__(30473).AbortController)

let PassThrough
let Readable

function destroyer(stream, reading, writing) {
  let finished = false
  stream.on('close', () => {
    finished = true
  })
  const cleanup = eos(
    stream,
    {
      readable: reading,
      writable: writing
    },
    (err) => {
      finished = !err
    }
  )
  return {
    destroy: (err) => {
      if (finished) return
      finished = true
      destroyImpl.destroyer(stream, err || new ERR_STREAM_DESTROYED('pipe'))
    },
    cleanup
  }
}

function popCallback(streams) {
  // Streams should never be an empty array. It should always contain at least
  // a single stream. Therefore optimize for the average case instead of
  // checking for length === 0 as well.
  validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]')
  return streams.pop()
}

function makeAsyncIterable(val) {
  if (isIterable(val)) {
    return val
  } else if (isReadableNodeStream(val)) {
    // Legacy streams are not Iterable.
    return fromReadable(val)
  }

  throw new ERR_INVALID_ARG_TYPE('val', ['Readable', 'Iterable', 'AsyncIterable'], val)
}

async function* fromReadable(val) {
  if (!Readable) {
    Readable = __webpack_require__(61716)
  }

  yield* Readable.prototype[SymbolAsyncIterator].call(val)
}

async function pump(iterable, writable, finish, { end }) {
  let error
  let onresolve = null

  const resume = (err) => {
    if (err) {
      error = err
    }

    if (onresolve) {
      const callback = onresolve
      onresolve = null
      callback()
    }
  }

  const wait = () =>
    new Promise((resolve, reject) => {
      if (error) {
        reject(error)
      } else {
        onresolve = () => {
          if (error) {
            reject(error)
          } else {
            resolve()
          }
        }
      }
    })

  writable.on('drain', resume)
  const cleanup = eos(
    writable,
    {
      readable: false
    },
    resume
  )

  try {
    if (writable.writableNeedDrain) {
      await wait()
    }

    for await (const chunk of iterable) {
      if (!writable.write(chunk)) {
        await wait()
      }
    }

    if (end) {
      writable.end()
    }

    await wait()
    finish()
  } catch (err) {
    finish(error !== err ? aggregateTwoErrors(error, err) : err)
  } finally {
    cleanup()
    writable.off('drain', resume)
  }
}

function pipeline(...streams) {
  return pipelineImpl(streams, once(popCallback(streams)))
}

function pipelineImpl(streams, callback, opts) {
  if (streams.length === 1 && ArrayIsArray(streams[0])) {
    streams = streams[0]
  }

  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams')
  }

  const ac = new AbortController()
  const signal = ac.signal
  const outerSignal = opts === null || opts === undefined ? undefined : opts.signal // Need to cleanup event listeners if last stream is readable
  // https://github.com/nodejs/node/issues/35452

  const lastStreamCleanup = []
  validateAbortSignal(outerSignal, 'options.signal')

  function abort() {
    finishImpl(new AbortError())
  }

  outerSignal === null || outerSignal === undefined ? undefined : outerSignal.addEventListener('abort', abort)
  let error
  let value
  const destroys = []
  let finishCount = 0

  function finish(err) {
    finishImpl(err, --finishCount === 0)
  }

  function finishImpl(err, final) {
    if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) {
      error = err
    }

    if (!error && !final) {
      return
    }

    while (destroys.length) {
      destroys.shift()(error)
    }

    outerSignal === null || outerSignal === undefined ? undefined : outerSignal.removeEventListener('abort', abort)
    ac.abort()

    if (final) {
      if (!error) {
        lastStreamCleanup.forEach((fn) => fn())
      }

      process.nextTick(callback, error, value)
    }
  }

  let ret

  for (let i = 0; i < streams.length; i++) {
    const stream = streams[i]
    const reading = i < streams.length - 1
    const writing = i > 0
    const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false
    const isLastStream = i === streams.length - 1

    if (isNodeStream(stream)) {
      if (end) {
        const { destroy, cleanup } = destroyer(stream, reading, writing)
        destroys.push(destroy)

        if (isReadable(stream) && isLastStream) {
          lastStreamCleanup.push(cleanup)
        }
      } // Catch stream errors that occur after pipe/pump has completed.

      function onError(err) {
        if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
          finish(err)
        }
      }

      stream.on('error', onError)

      if (isReadable(stream) && isLastStream) {
        lastStreamCleanup.push(() => {
          stream.removeListener('error', onError)
        })
      }
    }

    if (i === 0) {
      if (typeof stream === 'function') {
        ret = stream({
          signal
        })

        if (!isIterable(ret)) {
          throw new ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret)
        }
      } else if (isIterable(stream) || isReadableNodeStream(stream)) {
        ret = stream
      } else {
        ret = Duplex.from(stream)
      }
    } else if (typeof stream === 'function') {
      ret = makeAsyncIterable(ret)
      ret = stream(ret, {
        signal
      })

      if (reading) {
        if (!isIterable(ret, true)) {
          throw new ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret)
        }
      } else {
        var _ret

        if (!PassThrough) {
          PassThrough = __webpack_require__(67640)
        } // If the last argument to pipeline is not a stream
        // we must create a proxy stream so that pipeline(...)
        // always returns a stream which can be further
        // composed through `.pipe(stream)`.

        const pt = new PassThrough({
          objectMode: true
        }) // Handle Promises/A+ spec, `then` could be a getter that throws on
        // second use.

        const then = (_ret = ret) === null || _ret === undefined ? undefined : _ret.then

        if (typeof then === 'function') {
          finishCount++
          then.call(
            ret,
            (val) => {
              value = val

              if (val != null) {
                pt.write(val)
              }

              if (end) {
                pt.end()
              }

              process.nextTick(finish)
            },
            (err) => {
              pt.destroy(err)
              process.nextTick(finish, err)
            }
          )
        } else if (isIterable(ret, true)) {
          finishCount++
          pump(ret, pt, finish, {
            end
          })
        } else {
          throw new ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret)
        }

        ret = pt
        const { destroy, cleanup } = destroyer(ret, false, true)
        destroys.push(destroy)

        if (isLastStream) {
          lastStreamCleanup.push(cleanup)
        }
      }
    } else if (isNodeStream(stream)) {
      if (isReadableNodeStream(ret)) {
        finishCount += 2
        const cleanup = pipe(ret, stream, finish, {
          end
        })

        if (isReadable(stream) && isLastStream) {
          lastStreamCleanup.push(cleanup)
        }
      } else if (isIterable(ret)) {
        finishCount++
        pump(ret, stream, finish, {
          end
        })
      } else {
        throw new ERR_INVALID_ARG_TYPE('val', ['Readable', 'Iterable', 'AsyncIterable'], ret)
      }

      ret = stream
    } else {
      ret = Duplex.from(stream)
    }
  }

  if (
    (signal !== null && signal !== undefined && signal.aborted) ||
    (outerSignal !== null && outerSignal !== undefined && outerSignal.aborted)
  ) {
    process.nextTick(abort)
  }

  return ret
}

function pipe(src, dst, finish, { end }) {
  let ended = false
  dst.on('close', () => {
    if (!ended) {
      // Finish if the destination closes before the source has completed.
      finish(new ERR_STREAM_PREMATURE_CLOSE())
    }
  })
  src.pipe(dst, {
    end
  })

  if (end) {
    // Compat. Before node v10.12.0 stdio used to throw an error so
    // pipe() did/does not end() stdio destinations.
    // Now they allow it but "secretly" don't close the underlying fd.
    src.once('end', () => {
      ended = true
      dst.end()
    })
  } else {
    finish()
  }

  eos(
    src,
    {
      readable: true,
      writable: false
    },
    (err) => {
      const rState = src._readableState

      if (
        err &&
        err.code === 'ERR_STREAM_PREMATURE_CLOSE' &&
        rState &&
        rState.ended &&
        !rState.errored &&
        !rState.errorEmitted
      ) {
        // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish)
      } else {
        finish(err)
      }
    }
  )
  return eos(
    dst,
    {
      readable: false,
      writable: true
    },
    finish
  )
}

module.exports = {
  pipelineImpl,
  pipeline
}


/***/ }),

/***/ 61716:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* replacement start */
const process = __webpack_require__(27061)
/* replacement end */
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

;('use strict')

const {
  ArrayPrototypeIndexOf,
  NumberIsInteger,
  NumberIsNaN,
  NumberParseInt,
  ObjectDefineProperties,
  ObjectKeys,
  ObjectSetPrototypeOf,
  Promise,
  SafeSet,
  SymbolAsyncIterator,
  Symbol
} = __webpack_require__(57793)

module.exports = Readable
Readable.ReadableState = ReadableState

const { EventEmitter: EE } = __webpack_require__(50343)

const { Stream, prependListener } = __webpack_require__(55782)

const { Buffer } = __webpack_require__(30816)

const { addAbortSignal } = __webpack_require__(93092)

const eos = __webpack_require__(85027)

let debug = (__webpack_require__(55616).debuglog)('stream', (fn) => {
  debug = fn
})

const BufferList = __webpack_require__(57712)

const destroyImpl = __webpack_require__(27640)

const { getHighWaterMark, getDefaultHighWaterMark } = __webpack_require__(25985)

const {
  aggregateTwoErrors,
  codes: {
    ERR_INVALID_ARG_TYPE,
    ERR_METHOD_NOT_IMPLEMENTED,
    ERR_OUT_OF_RANGE,
    ERR_STREAM_PUSH_AFTER_EOF,
    ERR_STREAM_UNSHIFT_AFTER_END_EVENT
  }
} = __webpack_require__(58380)

const { validateObject } = __webpack_require__(85132)

const kPaused = Symbol('kPaused')

const { StringDecoder } = __webpack_require__(34361)

const from = __webpack_require__(26963)

ObjectSetPrototypeOf(Readable.prototype, Stream.prototype)
ObjectSetPrototypeOf(Readable, Stream)

const nop = () => {}

const { errorOrDestroy } = destroyImpl

function ReadableState(options, stream, isDuplex) {
  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof __webpack_require__(55426) // Object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away.

  this.objectMode = !!(options && options.objectMode)
  if (isDuplex) this.objectMode = this.objectMode || !!(options && options.readableObjectMode) // The point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"

  this.highWaterMark = options
    ? getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex)
    : getDefaultHighWaterMark(false) // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift().

  this.buffer = new BufferList()
  this.length = 0
  this.pipes = []
  this.flowing = null
  this.ended = false
  this.endEmitted = false
  this.reading = false // Stream is still being constructed and cannot be
  // destroyed until construction finished or failed.
  // Async construction is opt in, therefore we start as
  // constructed.

  this.constructed = true // A flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.

  this.sync = true // Whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.

  this.needReadable = false
  this.emittedReadable = false
  this.readableListening = false
  this.resumeScheduled = false
  this[kPaused] = null // True if the error was already emitted and should not be thrown again.

  this.errorEmitted = false // Should close be emitted on destroy. Defaults to true.

  this.emitClose = !options || options.emitClose !== false // Should .destroy() be called after 'end' (and potentially 'finish').

  this.autoDestroy = !options || options.autoDestroy !== false // Has it been destroyed.

  this.destroyed = false // Indicates whether the stream has errored. When true no further
  // _read calls, 'data' or 'readable' events should occur. This is needed
  // since when autoDestroy is disabled we need a way to tell whether the
  // stream has failed.

  this.errored = null // Indicates whether the stream has finished destroying.

  this.closed = false // True if close has been emitted or would have been emitted
  // depending on emitClose.

  this.closeEmitted = false // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.

  this.defaultEncoding = (options && options.defaultEncoding) || 'utf8' // Ref the piped dest which we need a drain event on it
  // type: null | Writable | Set<Writable>.

  this.awaitDrainWriters = null
  this.multiAwaitDrain = false // If true, a maybeReadMore has been scheduled.

  this.readingMore = false
  this.dataEmitted = false
  this.decoder = null
  this.encoding = null

  if (options && options.encoding) {
    this.decoder = new StringDecoder(options.encoding)
    this.encoding = options.encoding
  }
}

function Readable(options) {
  if (!(this instanceof Readable)) return new Readable(options) // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5.

  const isDuplex = this instanceof __webpack_require__(55426)

  this._readableState = new ReadableState(options, this, isDuplex)

  if (options) {
    if (typeof options.read === 'function') this._read = options.read
    if (typeof options.destroy === 'function') this._destroy = options.destroy
    if (typeof options.construct === 'function') this._construct = options.construct
    if (options.signal && !isDuplex) addAbortSignal(options.signal, this)
  }

  Stream.call(this, options)
  destroyImpl.construct(this, () => {
    if (this._readableState.needReadable) {
      maybeReadMore(this, this._readableState)
    }
  })
}

Readable.prototype.destroy = destroyImpl.destroy
Readable.prototype._undestroy = destroyImpl.undestroy

Readable.prototype._destroy = function (err, cb) {
  cb(err)
}

Readable.prototype[EE.captureRejectionSymbol] = function (err) {
  this.destroy(err)
} // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.

Readable.prototype.push = function (chunk, encoding) {
  return readableAddChunk(this, chunk, encoding, false)
} // Unshift should *always* be something directly out of read().

Readable.prototype.unshift = function (chunk, encoding) {
  return readableAddChunk(this, chunk, encoding, true)
}

function readableAddChunk(stream, chunk, encoding, addToFront) {
  debug('readableAddChunk', chunk)
  const state = stream._readableState
  let err

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding

      if (state.encoding !== encoding) {
        if (addToFront && state.encoding) {
          // When unshifting, if state.encoding is set, we have to save
          // the string in the BufferList with the state encoding.
          chunk = Buffer.from(chunk, encoding).toString(state.encoding)
        } else {
          chunk = Buffer.from(chunk, encoding)
          encoding = ''
        }
      }
    } else if (chunk instanceof Buffer) {
      encoding = ''
    } else if (Stream._isUint8Array(chunk)) {
      chunk = Stream._uint8ArrayToBuffer(chunk)
      encoding = ''
    } else if (chunk != null) {
      err = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk)
    }
  }

  if (err) {
    errorOrDestroy(stream, err)
  } else if (chunk === null) {
    state.reading = false
    onEofChunk(stream, state)
  } else if (state.objectMode || (chunk && chunk.length > 0)) {
    if (addToFront) {
      if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT())
      else if (state.destroyed || state.errored) return false
      else addChunk(stream, state, chunk, true)
    } else if (state.ended) {
      errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF())
    } else if (state.destroyed || state.errored) {
      return false
    } else {
      state.reading = false

      if (state.decoder && !encoding) {
        chunk = state.decoder.write(chunk)
        if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false)
        else maybeReadMore(stream, state)
      } else {
        addChunk(stream, state, chunk, false)
      }
    }
  } else if (!addToFront) {
    state.reading = false
    maybeReadMore(stream, state)
  } // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.

  return !state.ended && (state.length < state.highWaterMark || state.length === 0)
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
    // Use the guard to avoid creating `Set()` repeatedly
    // when we have multiple pipes.
    if (state.multiAwaitDrain) {
      state.awaitDrainWriters.clear()
    } else {
      state.awaitDrainWriters = null
    }

    state.dataEmitted = true
    stream.emit('data', chunk)
  } else {
    // Update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length
    if (addToFront) state.buffer.unshift(chunk)
    else state.buffer.push(chunk)
    if (state.needReadable) emitReadable(stream)
  }

  maybeReadMore(stream, state)
}

Readable.prototype.isPaused = function () {
  const state = this._readableState
  return state[kPaused] === true || state.flowing === false
} // Backwards compatibility.

Readable.prototype.setEncoding = function (enc) {
  const decoder = new StringDecoder(enc)
  this._readableState.decoder = decoder // If setEncoding(null), decoder.encoding equals utf8.

  this._readableState.encoding = this._readableState.decoder.encoding
  const buffer = this._readableState.buffer // Iterate over current buffer to convert already stored Buffers:

  let content = ''

  for (const data of buffer) {
    content += decoder.write(data)
  }

  buffer.clear()
  if (content !== '') buffer.push(content)
  this._readableState.length = content.length
  return this
} // Don't raise the hwm > 1GB.

const MAX_HWM = 0x40000000

function computeNewHighWaterMark(n) {
  if (n > MAX_HWM) {
    throw new ERR_OUT_OF_RANGE('size', '<= 1GiB', n)
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts.
    n--
    n |= n >>> 1
    n |= n >>> 2
    n |= n >>> 4
    n |= n >>> 8
    n |= n >>> 16
    n++
  }

  return n
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.

function howMuchToRead(n, state) {
  if (n <= 0 || (state.length === 0 && state.ended)) return 0
  if (state.objectMode) return 1

  if (NumberIsNaN(n)) {
    // Only flow one buffer at a time.
    if (state.flowing && state.length) return state.buffer.first().length
    return state.length
  }

  if (n <= state.length) return n
  return state.ended ? state.length : 0
} // You can override either this method, or the async _read(n) below.

Readable.prototype.read = function (n) {
  debug('read', n) // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
  // in this scenario, so we are doing it manually.

  if (n === undefined) {
    n = NaN
  } else if (!NumberIsInteger(n)) {
    n = NumberParseInt(n, 10)
  }

  const state = this._readableState
  const nOrig = n // If we're asking for more than the current hwm, then raise the hwm.

  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n)
  if (n !== 0) state.emittedReadable = false // If we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.

  if (
    n === 0 &&
    state.needReadable &&
    ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)
  ) {
    debug('read: emitReadable', state.length, state.ended)
    if (state.length === 0 && state.ended) endReadable(this)
    else emitReadable(this)
    return null
  }

  n = howMuchToRead(n, state) // If we've ended, and we're now clear, then finish it up.

  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this)
    return null
  } // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.
  // if we need a readable event, then we need to do some reading.

  let doRead = state.needReadable
  debug('need readable', doRead) // If we currently have less than the highWaterMark, then also read some.

  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true
    debug('length less than watermark', doRead)
  } // However, if we've ended, then there's no point, if we're already
  // reading, then it's unnecessary, if we're constructing we have to wait,
  // and if we're destroyed or errored, then it's not allowed,

  if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
    doRead = false
    debug('reading, ended or constructing', doRead)
  } else if (doRead) {
    debug('do read')
    state.reading = true
    state.sync = true // If the length is currently zero, then we *need* a readable event.

    if (state.length === 0) state.needReadable = true // Call internal read method

    try {
      this._read(state.highWaterMark)
    } catch (err) {
      errorOrDestroy(this, err)
    }

    state.sync = false // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.

    if (!state.reading) n = howMuchToRead(nOrig, state)
  }

  let ret
  if (n > 0) ret = fromList(n, state)
  else ret = null

  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark
    n = 0
  } else {
    state.length -= n

    if (state.multiAwaitDrain) {
      state.awaitDrainWriters.clear()
    } else {
      state.awaitDrainWriters = null
    }
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true // If we tried to read() past the EOF, then emit end on the next tick.

    if (nOrig !== n && state.ended) endReadable(this)
  }

  if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
    state.dataEmitted = true
    this.emit('data', ret)
  }

  return ret
}

function onEofChunk(stream, state) {
  debug('onEofChunk')
  if (state.ended) return

  if (state.decoder) {
    const chunk = state.decoder.end()

    if (chunk && chunk.length) {
      state.buffer.push(chunk)
      state.length += state.objectMode ? 1 : chunk.length
    }
  }

  state.ended = true

  if (state.sync) {
    // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    emitReadable(stream)
  } else {
    // Emit 'readable' now to make sure it gets picked up.
    state.needReadable = false
    state.emittedReadable = true // We have to emit readable now that we are EOF. Modules
    // in the ecosystem (e.g. dicer) rely on this event being sync.

    emitReadable_(stream)
  }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.

function emitReadable(stream) {
  const state = stream._readableState
  debug('emitReadable', state.needReadable, state.emittedReadable)
  state.needReadable = false

  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing)
    state.emittedReadable = true
    process.nextTick(emitReadable_, stream)
  }
}

function emitReadable_(stream) {
  const state = stream._readableState
  debug('emitReadable_', state.destroyed, state.length, state.ended)

  if (!state.destroyed && !state.errored && (state.length || state.ended)) {
    stream.emit('readable')
    state.emittedReadable = false
  } // The stream needs another readable event if:
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.

  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark
  flow(stream)
} // At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.

function maybeReadMore(stream, state) {
  if (!state.readingMore && state.constructed) {
    state.readingMore = true
    process.nextTick(maybeReadMore_, stream, state)
  }
}

function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (
    !state.reading &&
    !state.ended &&
    (state.length < state.highWaterMark || (state.flowing && state.length === 0))
  ) {
    const len = state.length
    debug('maybeReadMore read 0')
    stream.read(0)
    if (len === state.length)
      // Didn't get any data, stop spinning.
      break
  }

  state.readingMore = false
} // Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.

Readable.prototype._read = function (n) {
  throw new ERR_METHOD_NOT_IMPLEMENTED('_read()')
}

Readable.prototype.pipe = function (dest, pipeOpts) {
  const src = this
  const state = this._readableState

  if (state.pipes.length === 1) {
    if (!state.multiAwaitDrain) {
      state.multiAwaitDrain = true
      state.awaitDrainWriters = new SafeSet(state.awaitDrainWriters ? [state.awaitDrainWriters] : [])
    }
  }

  state.pipes.push(dest)
  debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts)
  const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr
  const endFn = doEnd ? onend : unpipe
  if (state.endEmitted) process.nextTick(endFn)
  else src.once('end', endFn)
  dest.on('unpipe', onunpipe)

  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe')

    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true
        cleanup()
      }
    }
  }

  function onend() {
    debug('onend')
    dest.end()
  }

  let ondrain
  let cleanedUp = false

  function cleanup() {
    debug('cleanup') // Cleanup event handlers once the pipe is broken.

    dest.removeListener('close', onclose)
    dest.removeListener('finish', onfinish)

    if (ondrain) {
      dest.removeListener('drain', ondrain)
    }

    dest.removeListener('error', onerror)
    dest.removeListener('unpipe', onunpipe)
    src.removeListener('end', onend)
    src.removeListener('end', unpipe)
    src.removeListener('data', ondata)
    cleanedUp = true // If the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.

    if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain()
  }

  function pause() {
    // If the user unpiped during `dest.write()`, it is possible
    // to get stuck in a permanently paused state if that write
    // also returned false.
    // => Check whether `dest` is still a piping destination.
    if (!cleanedUp) {
      if (state.pipes.length === 1 && state.pipes[0] === dest) {
        debug('false write response, pause', 0)
        state.awaitDrainWriters = dest
        state.multiAwaitDrain = false
      } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
        debug('false write response, pause', state.awaitDrainWriters.size)
        state.awaitDrainWriters.add(dest)
      }

      src.pause()
    }

    if (!ondrain) {
      // When the dest drains, it reduces the awaitDrain counter
      // on the source.  This would be more elegant with a .once()
      // handler in flow(), but adding and removing repeatedly is
      // too slow.
      ondrain = pipeOnDrain(src, dest)
      dest.on('drain', ondrain)
    }
  }

  src.on('data', ondata)

  function ondata(chunk) {
    debug('ondata')
    const ret = dest.write(chunk)
    debug('dest.write', ret)

    if (ret === false) {
      pause()
    }
  } // If the dest has an error, then stop piping into it.
  // However, don't suppress the throwing behavior for this.

  function onerror(er) {
    debug('onerror', er)
    unpipe()
    dest.removeListener('error', onerror)

    if (dest.listenerCount('error') === 0) {
      const s = dest._writableState || dest._readableState

      if (s && !s.errorEmitted) {
        // User incorrectly emitted 'error' directly on the stream.
        errorOrDestroy(dest, er)
      } else {
        dest.emit('error', er)
      }
    }
  } // Make sure our error handler is attached before userland ones.

  prependListener(dest, 'error', onerror) // Both close and finish should trigger unpipe, but only once.

  function onclose() {
    dest.removeListener('finish', onfinish)
    unpipe()
  }

  dest.once('close', onclose)

  function onfinish() {
    debug('onfinish')
    dest.removeListener('close', onclose)
    unpipe()
  }

  dest.once('finish', onfinish)

  function unpipe() {
    debug('unpipe')
    src.unpipe(dest)
  } // Tell the dest that it's being piped to.

  dest.emit('pipe', src) // Start the flow if it hasn't been started already.

  if (dest.writableNeedDrain === true) {
    if (state.flowing) {
      pause()
    }
  } else if (!state.flowing) {
    debug('pipe resume')
    src.resume()
  }

  return dest
}

function pipeOnDrain(src, dest) {
  return function pipeOnDrainFunctionResult() {
    const state = src._readableState // `ondrain` will call directly,
    // `this` maybe not a reference to dest,
    // so we use the real dest here.

    if (state.awaitDrainWriters === dest) {
      debug('pipeOnDrain', 1)
      state.awaitDrainWriters = null
    } else if (state.multiAwaitDrain) {
      debug('pipeOnDrain', state.awaitDrainWriters.size)
      state.awaitDrainWriters.delete(dest)
    }

    if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) {
      src.resume()
    }
  }
}

Readable.prototype.unpipe = function (dest) {
  const state = this._readableState
  const unpipeInfo = {
    hasUnpiped: false
  } // If we're not piping anywhere, then do nothing.

  if (state.pipes.length === 0) return this

  if (!dest) {
    // remove all.
    const dests = state.pipes
    state.pipes = []
    this.pause()

    for (let i = 0; i < dests.length; i++)
      dests[i].emit('unpipe', this, {
        hasUnpiped: false
      })

    return this
  } // Try to find the right one.

  const index = ArrayPrototypeIndexOf(state.pipes, dest)
  if (index === -1) return this
  state.pipes.splice(index, 1)
  if (state.pipes.length === 0) this.pause()
  dest.emit('unpipe', this, unpipeInfo)
  return this
} // Set up data events if they are asked for
// Ensure readable listeners eventually get something.

Readable.prototype.on = function (ev, fn) {
  const res = Stream.prototype.on.call(this, ev, fn)
  const state = this._readableState

  if (ev === 'data') {
    // Update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0 // Try start flowing on next tick if stream isn't explicitly paused.

    if (state.flowing !== false) this.resume()
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true
      state.flowing = false
      state.emittedReadable = false
      debug('on readable', state.length, state.reading)

      if (state.length) {
        emitReadable(this)
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this)
      }
    }
  }

  return res
}

Readable.prototype.addListener = Readable.prototype.on

Readable.prototype.removeListener = function (ev, fn) {
  const res = Stream.prototype.removeListener.call(this, ev, fn)

  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this)
  }

  return res
}

Readable.prototype.off = Readable.prototype.removeListener

Readable.prototype.removeAllListeners = function (ev) {
  const res = Stream.prototype.removeAllListeners.apply(this, arguments)

  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this)
  }

  return res
}

function updateReadableListening(self) {
  const state = self._readableState
  state.readableListening = self.listenerCount('readable') > 0

  if (state.resumeScheduled && state[kPaused] === false) {
    // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true // Crude way to check if we should resume.
  } else if (self.listenerCount('data') > 0) {
    self.resume()
  } else if (!state.readableListening) {
    state.flowing = null
  }
}

function nReadingNextTick(self) {
  debug('readable nexttick read 0')
  self.read(0)
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.

Readable.prototype.resume = function () {
  const state = this._readableState

  if (!state.flowing) {
    debug('resume') // We flow only if there is no one listening
    // for readable, but we still have to call
    // resume().

    state.flowing = !state.readableListening
    resume(this, state)
  }

  state[kPaused] = false
  return this
}

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true
    process.nextTick(resume_, stream, state)
  }
}

function resume_(stream, state) {
  debug('resume', state.reading)

  if (!state.reading) {
    stream.read(0)
  }

  state.resumeScheduled = false
  stream.emit('resume')
  flow(stream)
  if (state.flowing && !state.reading) stream.read(0)
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing)

  if (this._readableState.flowing !== false) {
    debug('pause')
    this._readableState.flowing = false
    this.emit('pause')
  }

  this._readableState[kPaused] = true
  return this
}

function flow(stream) {
  const state = stream._readableState
  debug('flow', state.flowing)

  while (state.flowing && stream.read() !== null);
} // Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.

Readable.prototype.wrap = function (stream) {
  let paused = false // TODO (ronag): Should this.destroy(err) emit
  // 'error' on the wrapped stream? Would require
  // a static factory method, e.g. Readable.wrap(stream).

  stream.on('data', (chunk) => {
    if (!this.push(chunk) && stream.pause) {
      paused = true
      stream.pause()
    }
  })
  stream.on('end', () => {
    this.push(null)
  })
  stream.on('error', (err) => {
    errorOrDestroy(this, err)
  })
  stream.on('close', () => {
    this.destroy()
  })
  stream.on('destroy', () => {
    this.destroy()
  })

  this._read = () => {
    if (paused && stream.resume) {
      paused = false
      stream.resume()
    }
  } // Proxy all the other methods. Important when wrapping filters and duplexes.

  const streamKeys = ObjectKeys(stream)

  for (let j = 1; j < streamKeys.length; j++) {
    const i = streamKeys[j]

    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = stream[i].bind(stream)
    }
  }

  return this
}

Readable.prototype[SymbolAsyncIterator] = function () {
  return streamToAsyncIterator(this)
}

Readable.prototype.iterator = function (options) {
  if (options !== undefined) {
    validateObject(options, 'options')
  }

  return streamToAsyncIterator(this, options)
}

function streamToAsyncIterator(stream, options) {
  if (typeof stream.read !== 'function') {
    stream = Readable.wrap(stream, {
      objectMode: true
    })
  }

  const iter = createAsyncIterator(stream, options)
  iter.stream = stream
  return iter
}

async function* createAsyncIterator(stream, options) {
  let callback = nop

  function next(resolve) {
    if (this === stream) {
      callback()
      callback = nop
    } else {
      callback = resolve
    }
  }

  stream.on('readable', next)
  let error
  const cleanup = eos(
    stream,
    {
      writable: false
    },
    (err) => {
      error = err ? aggregateTwoErrors(error, err) : null
      callback()
      callback = nop
    }
  )

  try {
    while (true) {
      const chunk = stream.destroyed ? null : stream.read()

      if (chunk !== null) {
        yield chunk
      } else if (error) {
        throw error
      } else if (error === null) {
        return
      } else {
        await new Promise(next)
      }
    }
  } catch (err) {
    error = aggregateTwoErrors(error, err)
    throw error
  } finally {
    if (
      (error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) &&
      (error === undefined || stream._readableState.autoDestroy)
    ) {
      destroyImpl.destroyer(stream, null)
    } else {
      stream.off('readable', next)
      cleanup()
    }
  }
} // Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.

ObjectDefineProperties(Readable.prototype, {
  readable: {
    __proto__: null,

    get() {
      const r = this._readableState // r.readable === false means that this is part of a Duplex stream
      // where the readable side was disabled upon construction.
      // Compat. The user might manually disable readable side through
      // deprecated setter.

      return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted
    },

    set(val) {
      // Backwards compat.
      if (this._readableState) {
        this._readableState.readable = !!val
      }
    }
  },
  readableDidRead: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return this._readableState.dataEmitted
    }
  },
  readableAborted: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return !!(
        this._readableState.readable !== false &&
        (this._readableState.destroyed || this._readableState.errored) &&
        !this._readableState.endEmitted
      )
    }
  },
  readableHighWaterMark: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return this._readableState.highWaterMark
    }
  },
  readableBuffer: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return this._readableState && this._readableState.buffer
    }
  },
  readableFlowing: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return this._readableState.flowing
    },
    set: function (state) {
      if (this._readableState) {
        this._readableState.flowing = state
      }
    }
  },
  readableLength: {
    __proto__: null,
    enumerable: false,

    get() {
      return this._readableState.length
    }
  },
  readableObjectMode: {
    __proto__: null,
    enumerable: false,

    get() {
      return this._readableState ? this._readableState.objectMode : false
    }
  },
  readableEncoding: {
    __proto__: null,
    enumerable: false,

    get() {
      return this._readableState ? this._readableState.encoding : null
    }
  },
  errored: {
    __proto__: null,
    enumerable: false,

    get() {
      return this._readableState ? this._readableState.errored : null
    }
  },
  closed: {
    __proto__: null,

    get() {
      return this._readableState ? this._readableState.closed : false
    }
  },
  destroyed: {
    __proto__: null,
    enumerable: false,

    get() {
      return this._readableState ? this._readableState.destroyed : false
    },

    set(value) {
      // We ignore the value if the stream
      // has not been initialized yet.
      if (!this._readableState) {
        return
      } // Backward compatibility, the user is explicitly
      // managing destroyed.

      this._readableState.destroyed = value
    }
  },
  readableEnded: {
    __proto__: null,
    enumerable: false,

    get() {
      return this._readableState ? this._readableState.endEmitted : false
    }
  }
})
ObjectDefineProperties(ReadableState.prototype, {
  // Legacy getter for `pipesCount`.
  pipesCount: {
    __proto__: null,

    get() {
      return this.pipes.length
    }
  },
  // Legacy property for `paused`.
  paused: {
    __proto__: null,

    get() {
      return this[kPaused] !== false
    },

    set(value) {
      this[kPaused] = !!value
    }
  }
}) // Exposed for testing purposes only.

Readable._fromList = fromList // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.

function fromList(n, state) {
  // nothing buffered.
  if (state.length === 0) return null
  let ret
  if (state.objectMode) ret = state.buffer.shift()
  else if (!n || n >= state.length) {
    // Read it all, truncate the list.
    if (state.decoder) ret = state.buffer.join('')
    else if (state.buffer.length === 1) ret = state.buffer.first()
    else ret = state.buffer.concat(state.length)
    state.buffer.clear()
  } else {
    // read part of list.
    ret = state.buffer.consume(n, state.decoder)
  }
  return ret
}

function endReadable(stream) {
  const state = stream._readableState
  debug('endReadable', state.endEmitted)

  if (!state.endEmitted) {
    state.ended = true
    process.nextTick(endReadableNT, state, stream)
  }
}

function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length) // Check that we didn't get one last unshift.

  if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
    state.endEmitted = true
    stream.emit('end')

    if (stream.writable && stream.allowHalfOpen === false) {
      process.nextTick(endWritableNT, stream)
    } else if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well.
      const wState = stream._writableState
      const autoDestroy =
        !wState ||
        (wState.autoDestroy && // We don't expect the writable to ever 'finish'
          // if writable is explicitly set to false.
          (wState.finished || wState.writable === false))

      if (autoDestroy) {
        stream.destroy()
      }
    }
  }
}

function endWritableNT(stream) {
  const writable = stream.writable && !stream.writableEnded && !stream.destroyed

  if (writable) {
    stream.end()
  }
}

Readable.from = function (iterable, opts) {
  return from(Readable, iterable, opts)
}

let webStreamsAdapters // Lazy to avoid circular references

function lazyWebStreams() {
  if (webStreamsAdapters === undefined) webStreamsAdapters = {}
  return webStreamsAdapters
}

Readable.fromWeb = function (readableStream, options) {
  return lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options)
}

Readable.toWeb = function (streamReadable, options) {
  return lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options)
}

Readable.wrap = function (src, options) {
  var _ref, _src$readableObjectMo

  return new Readable({
    objectMode:
      (_ref =
        (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined
          ? _src$readableObjectMo
          : src.objectMode) !== null && _ref !== undefined
        ? _ref
        : true,
    ...options,

    destroy(err, callback) {
      destroyImpl.destroyer(src, err)
      callback(err)
    }
  }).wrap(src)
}


/***/ }),

/***/ 25985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { MathFloor, NumberIsInteger } = __webpack_require__(57793)

const { ERR_INVALID_ARG_VALUE } = (__webpack_require__(58380).codes)

function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null
}

function getDefaultHighWaterMark(objectMode) {
  return objectMode ? 16 : 16 * 1024
}

function getHighWaterMark(state, options, duplexKey, isDuplex) {
  const hwm = highWaterMarkFrom(options, isDuplex, duplexKey)

  if (hwm != null) {
    if (!NumberIsInteger(hwm) || hwm < 0) {
      const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark'
      throw new ERR_INVALID_ARG_VALUE(name, hwm)
    }

    return MathFloor(hwm)
  } // Default value

  return getDefaultHighWaterMark(state.objectMode)
}

module.exports = {
  getHighWaterMark,
  getDefaultHighWaterMark
}


/***/ }),

/***/ 20050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.


const { ObjectSetPrototypeOf, Symbol } = __webpack_require__(57793)

module.exports = Transform

const { ERR_METHOD_NOT_IMPLEMENTED } = (__webpack_require__(58380).codes)

const Duplex = __webpack_require__(55426)

const { getHighWaterMark } = __webpack_require__(25985)

ObjectSetPrototypeOf(Transform.prototype, Duplex.prototype)
ObjectSetPrototypeOf(Transform, Duplex)
const kCallback = Symbol('kCallback')

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options) // TODO (ronag): This should preferably always be
  // applied but would be semver-major. Or even better;
  // make Transform a Readable with the Writable interface.

  const readableHighWaterMark = options ? getHighWaterMark(this, options, 'readableHighWaterMark', true) : null

  if (readableHighWaterMark === 0) {
    // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = {
      ...options,
      highWaterMark: null,
      readableHighWaterMark,
      // TODO (ronag): 0 is not optimal since we have
      // a "bug" where we check needDrain before calling _write and not after.
      // Refs: https://github.com/nodejs/node/pull/32887
      // Refs: https://github.com/nodejs/node/pull/35941
      writableHighWaterMark: options.writableHighWaterMark || 0
    }
  }

  Duplex.call(this, options) // We have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.

  this._readableState.sync = false
  this[kCallback] = null

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform
    if (typeof options.flush === 'function') this._flush = options.flush
  } // When the writable side finishes, then flush out anything remaining.
  // Backwards compat. Some Transform streams incorrectly implement _final
  // instead of or in addition to _flush. By using 'prefinish' instead of
  // implementing _final we continue supporting this unfortunate use case.

  this.on('prefinish', prefinish)
}

function final(cb) {
  if (typeof this._flush === 'function' && !this.destroyed) {
    this._flush((er, data) => {
      if (er) {
        if (cb) {
          cb(er)
        } else {
          this.destroy(er)
        }

        return
      }

      if (data != null) {
        this.push(data)
      }

      this.push(null)

      if (cb) {
        cb()
      }
    })
  } else {
    this.push(null)

    if (cb) {
      cb()
    }
  }
}

function prefinish() {
  if (this._final !== final) {
    final.call(this)
  }
}

Transform.prototype._final = final

Transform.prototype._transform = function (chunk, encoding, callback) {
  throw new ERR_METHOD_NOT_IMPLEMENTED('_transform()')
}

Transform.prototype._write = function (chunk, encoding, callback) {
  const rState = this._readableState
  const wState = this._writableState
  const length = rState.length

  this._transform(chunk, encoding, (err, val) => {
    if (err) {
      callback(err)
      return
    }

    if (val != null) {
      this.push(val)
    }

    if (
      wState.ended || // Backwards compat.
      length === rState.length || // Backwards compat.
      rState.length < rState.highWaterMark
    ) {
      callback()
    } else {
      this[kCallback] = callback
    }
  })
}

Transform.prototype._read = function () {
  if (this[kCallback]) {
    const callback = this[kCallback]
    this[kCallback] = null
    callback()
  }
}


/***/ }),

/***/ 81391:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { Symbol, SymbolAsyncIterator, SymbolIterator } = __webpack_require__(57793)

const kDestroyed = Symbol('kDestroyed')
const kIsErrored = Symbol('kIsErrored')
const kIsReadable = Symbol('kIsReadable')
const kIsDisturbed = Symbol('kIsDisturbed')

function isReadableNodeStream(obj, strict = false) {
  var _obj$_readableState

  return !!(
    (
      obj &&
      typeof obj.pipe === 'function' &&
      typeof obj.on === 'function' &&
      (!strict || (typeof obj.pause === 'function' && typeof obj.resume === 'function')) &&
      (!obj._writableState ||
        ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined
          ? undefined
          : _obj$_readableState.readable) !== false) && // Duplex
      (!obj._writableState || obj._readableState)
    ) // Writable has .pipe.
  )
}

function isWritableNodeStream(obj) {
  var _obj$_writableState

  return !!(
    (
      obj &&
      typeof obj.write === 'function' &&
      typeof obj.on === 'function' &&
      (!obj._readableState ||
        ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined
          ? undefined
          : _obj$_writableState.writable) !== false)
    ) // Duplex
  )
}

function isDuplexNodeStream(obj) {
  return !!(
    obj &&
    typeof obj.pipe === 'function' &&
    obj._readableState &&
    typeof obj.on === 'function' &&
    typeof obj.write === 'function'
  )
}

function isNodeStream(obj) {
  return (
    obj &&
    (obj._readableState ||
      obj._writableState ||
      (typeof obj.write === 'function' && typeof obj.on === 'function') ||
      (typeof obj.pipe === 'function' && typeof obj.on === 'function'))
  )
}

function isIterable(obj, isAsync) {
  if (obj == null) return false
  if (isAsync === true) return typeof obj[SymbolAsyncIterator] === 'function'
  if (isAsync === false) return typeof obj[SymbolIterator] === 'function'
  return typeof obj[SymbolAsyncIterator] === 'function' || typeof obj[SymbolIterator] === 'function'
}

function isDestroyed(stream) {
  if (!isNodeStream(stream)) return null
  const wState = stream._writableState
  const rState = stream._readableState
  const state = wState || rState
  return !!(stream.destroyed || stream[kDestroyed] || (state !== null && state !== undefined && state.destroyed))
} // Have been end():d.

function isWritableEnded(stream) {
  if (!isWritableNodeStream(stream)) return null
  if (stream.writableEnded === true) return true
  const wState = stream._writableState
  if (wState !== null && wState !== undefined && wState.errored) return false
  if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null
  return wState.ended
} // Have emitted 'finish'.

function isWritableFinished(stream, strict) {
  if (!isWritableNodeStream(stream)) return null
  if (stream.writableFinished === true) return true
  const wState = stream._writableState
  if (wState !== null && wState !== undefined && wState.errored) return false
  if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null
  return !!(wState.finished || (strict === false && wState.ended === true && wState.length === 0))
} // Have been push(null):d.

function isReadableEnded(stream) {
  if (!isReadableNodeStream(stream)) return null
  if (stream.readableEnded === true) return true
  const rState = stream._readableState
  if (!rState || rState.errored) return false
  if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null
  return rState.ended
} // Have emitted 'end'.

function isReadableFinished(stream, strict) {
  if (!isReadableNodeStream(stream)) return null
  const rState = stream._readableState
  if (rState !== null && rState !== undefined && rState.errored) return false
  if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null
  return !!(rState.endEmitted || (strict === false && rState.ended === true && rState.length === 0))
}

function isReadable(stream) {
  if (stream && stream[kIsReadable] != null) return stream[kIsReadable]
  if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null
  if (isDestroyed(stream)) return false
  return isReadableNodeStream(stream) && stream.readable && !isReadableFinished(stream)
}

function isWritable(stream) {
  if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null
  if (isDestroyed(stream)) return false
  return isWritableNodeStream(stream) && stream.writable && !isWritableEnded(stream)
}

function isFinished(stream, opts) {
  if (!isNodeStream(stream)) {
    return null
  }

  if (isDestroyed(stream)) {
    return true
  }

  if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && isReadable(stream)) {
    return false
  }

  if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && isWritable(stream)) {
    return false
  }

  return true
}

function isWritableErrored(stream) {
  var _stream$_writableStat, _stream$_writableStat2

  if (!isNodeStream(stream)) {
    return null
  }

  if (stream.writableErrored) {
    return stream.writableErrored
  }

  return (_stream$_writableStat =
    (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined
      ? undefined
      : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined
    ? _stream$_writableStat
    : null
}

function isReadableErrored(stream) {
  var _stream$_readableStat, _stream$_readableStat2

  if (!isNodeStream(stream)) {
    return null
  }

  if (stream.readableErrored) {
    return stream.readableErrored
  }

  return (_stream$_readableStat =
    (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined
      ? undefined
      : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined
    ? _stream$_readableStat
    : null
}

function isClosed(stream) {
  if (!isNodeStream(stream)) {
    return null
  }

  if (typeof stream.closed === 'boolean') {
    return stream.closed
  }

  const wState = stream._writableState
  const rState = stream._readableState

  if (
    typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' ||
    typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean'
  ) {
    return (
      (wState === null || wState === undefined ? undefined : wState.closed) ||
      (rState === null || rState === undefined ? undefined : rState.closed)
    )
  }

  if (typeof stream._closed === 'boolean' && isOutgoingMessage(stream)) {
    return stream._closed
  }

  return null
}

function isOutgoingMessage(stream) {
  return (
    typeof stream._closed === 'boolean' &&
    typeof stream._defaultKeepAlive === 'boolean' &&
    typeof stream._removedConnection === 'boolean' &&
    typeof stream._removedContLen === 'boolean'
  )
}

function isServerResponse(stream) {
  return typeof stream._sent100 === 'boolean' && isOutgoingMessage(stream)
}

function isServerRequest(stream) {
  var _stream$req

  return (
    typeof stream._consuming === 'boolean' &&
    typeof stream._dumped === 'boolean' &&
    ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) ===
      undefined
  )
}

function willEmitClose(stream) {
  if (!isNodeStream(stream)) return null
  const wState = stream._writableState
  const rState = stream._readableState
  const state = wState || rState
  return (
    (!state && isServerResponse(stream)) || !!(state && state.autoDestroy && state.emitClose && state.closed === false)
  )
}

function isDisturbed(stream) {
  var _stream$kIsDisturbed

  return !!(
    stream &&
    ((_stream$kIsDisturbed = stream[kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined
      ? _stream$kIsDisturbed
      : stream.readableDidRead || stream.readableAborted)
  )
}

function isErrored(stream) {
  var _ref,
    _ref2,
    _ref3,
    _ref4,
    _ref5,
    _stream$kIsErrored,
    _stream$_readableStat3,
    _stream$_writableStat3,
    _stream$_readableStat4,
    _stream$_writableStat4

  return !!(
    stream &&
    ((_ref =
      (_ref2 =
        (_ref3 =
          (_ref4 =
            (_ref5 =
              (_stream$kIsErrored = stream[kIsErrored]) !== null && _stream$kIsErrored !== undefined
                ? _stream$kIsErrored
                : stream.readableErrored) !== null && _ref5 !== undefined
              ? _ref5
              : stream.writableErrored) !== null && _ref4 !== undefined
            ? _ref4
            : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined
            ? undefined
            : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined
          ? _ref3
          : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined
          ? undefined
          : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined
        ? _ref2
        : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined
        ? undefined
        : _stream$_readableStat4.errored) !== null && _ref !== undefined
      ? _ref
      : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined
      ? undefined
      : _stream$_writableStat4.errored)
  )
}

module.exports = {
  kDestroyed,
  isDisturbed,
  kIsDisturbed,
  isErrored,
  kIsErrored,
  isReadable,
  kIsReadable,
  isClosed,
  isDestroyed,
  isDuplexNodeStream,
  isFinished,
  isIterable,
  isReadableNodeStream,
  isReadableEnded,
  isReadableFinished,
  isReadableErrored,
  isNodeStream,
  isWritable,
  isWritableNodeStream,
  isWritableEnded,
  isWritableFinished,
  isWritableErrored,
  isServerRequest,
  isServerResponse,
  willEmitClose
}


/***/ }),

/***/ 69337:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* replacement start */
const process = __webpack_require__(27061)
/* replacement end */
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

;('use strict')

const {
  ArrayPrototypeSlice,
  Error,
  FunctionPrototypeSymbolHasInstance,
  ObjectDefineProperty,
  ObjectDefineProperties,
  ObjectSetPrototypeOf,
  StringPrototypeToLowerCase,
  Symbol,
  SymbolHasInstance
} = __webpack_require__(57793)

module.exports = Writable
Writable.WritableState = WritableState

const { EventEmitter: EE } = __webpack_require__(50343)

const Stream = (__webpack_require__(55782).Stream)

const { Buffer } = __webpack_require__(30816)

const destroyImpl = __webpack_require__(27640)

const { addAbortSignal } = __webpack_require__(93092)

const { getHighWaterMark, getDefaultHighWaterMark } = __webpack_require__(25985)

const {
  ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED,
  ERR_STREAM_ALREADY_FINISHED,
  ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING
} = (__webpack_require__(58380).codes)

const { errorOrDestroy } = destroyImpl
ObjectSetPrototypeOf(Writable.prototype, Stream.prototype)
ObjectSetPrototypeOf(Writable, Stream)

function nop() {}

const kOnFinished = Symbol('kOnFinished')

function WritableState(options, stream, isDuplex) {
  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof __webpack_require__(55426) // Object stream flag to indicate whether or not this stream
  // contains buffers or objects.

  this.objectMode = !!(options && options.objectMode)
  if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode) // The point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write().

  this.highWaterMark = options
    ? getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex)
    : getDefaultHighWaterMark(false) // if _final has been called.

  this.finalCalled = false // drain event flag.

  this.needDrain = false // At the start of calling end()

  this.ending = false // When end() has been called, and returned.

  this.ended = false // When 'finish' is emitted.

  this.finished = false // Has it been destroyed

  this.destroyed = false // Should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.

  const noDecode = !!(options && options.decodeStrings === false)
  this.decodeStrings = !noDecode // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.

  this.defaultEncoding = (options && options.defaultEncoding) || 'utf8' // Not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.

  this.length = 0 // A flag to see when we're in the middle of a write.

  this.writing = false // When true all writes will be buffered until .uncork() call.

  this.corked = 0 // A flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.

  this.sync = true // A flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.

  this.bufferProcessing = false // The callback that's passed to _write(chunk, cb).

  this.onwrite = onwrite.bind(undefined, stream) // The callback that the user supplies to write(chunk, encoding, cb).

  this.writecb = null // The amount that is being written when _write is called.

  this.writelen = 0 // Storage for data passed to the afterWrite() callback in case of
  // synchronous _write() completion.

  this.afterWriteTickInfo = null
  resetBuffer(this) // Number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted.

  this.pendingcb = 0 // Stream is still being constructed and cannot be
  // destroyed until construction finished or failed.
  // Async construction is opt in, therefore we start as
  // constructed.

  this.constructed = true // Emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams.

  this.prefinished = false // True if the error was already emitted and should not be thrown again.

  this.errorEmitted = false // Should close be emitted on destroy. Defaults to true.

  this.emitClose = !options || options.emitClose !== false // Should .destroy() be called after 'finish' (and potentially 'end').

  this.autoDestroy = !options || options.autoDestroy !== false // Indicates whether the stream has errored. When true all write() calls
  // should return false. This is needed since when autoDestroy
  // is disabled we need a way to tell whether the stream has failed.

  this.errored = null // Indicates whether the stream has finished destroying.

  this.closed = false // True if close has been emitted or would have been emitted
  // depending on emitClose.

  this.closeEmitted = false
  this[kOnFinished] = []
}

function resetBuffer(state) {
  state.buffered = []
  state.bufferedIndex = 0
  state.allBuffers = true
  state.allNoop = true
}

WritableState.prototype.getBuffer = function getBuffer() {
  return ArrayPrototypeSlice(this.buffered, this.bufferedIndex)
}

ObjectDefineProperty(WritableState.prototype, 'bufferedRequestCount', {
  __proto__: null,

  get() {
    return this.buffered.length - this.bufferedIndex
  }
})

function Writable(options) {
  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.
  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5.
  const isDuplex = this instanceof __webpack_require__(55426)

  if (!isDuplex && !FunctionPrototypeSymbolHasInstance(Writable, this)) return new Writable(options)
  this._writableState = new WritableState(options, this, isDuplex)

  if (options) {
    if (typeof options.write === 'function') this._write = options.write
    if (typeof options.writev === 'function') this._writev = options.writev
    if (typeof options.destroy === 'function') this._destroy = options.destroy
    if (typeof options.final === 'function') this._final = options.final
    if (typeof options.construct === 'function') this._construct = options.construct
    if (options.signal) addAbortSignal(options.signal, this)
  }

  Stream.call(this, options)
  destroyImpl.construct(this, () => {
    const state = this._writableState

    if (!state.writing) {
      clearBuffer(this, state)
    }

    finishMaybe(this, state)
  })
}

ObjectDefineProperty(Writable, SymbolHasInstance, {
  __proto__: null,
  value: function (object) {
    if (FunctionPrototypeSymbolHasInstance(this, object)) return true
    if (this !== Writable) return false
    return object && object._writableState instanceof WritableState
  }
}) // Otherwise people can pipe Writable streams, which is just wrong.

Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE())
}

function _write(stream, chunk, encoding, cb) {
  const state = stream._writableState

  if (typeof encoding === 'function') {
    cb = encoding
    encoding = state.defaultEncoding
  } else {
    if (!encoding) encoding = state.defaultEncoding
    else if (encoding !== 'buffer' && !Buffer.isEncoding(encoding)) throw new ERR_UNKNOWN_ENCODING(encoding)
    if (typeof cb !== 'function') cb = nop
  }

  if (chunk === null) {
    throw new ERR_STREAM_NULL_VALUES()
  } else if (!state.objectMode) {
    if (typeof chunk === 'string') {
      if (state.decodeStrings !== false) {
        chunk = Buffer.from(chunk, encoding)
        encoding = 'buffer'
      }
    } else if (chunk instanceof Buffer) {
      encoding = 'buffer'
    } else if (Stream._isUint8Array(chunk)) {
      chunk = Stream._uint8ArrayToBuffer(chunk)
      encoding = 'buffer'
    } else {
      throw new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk)
    }
  }

  let err

  if (state.ending) {
    err = new ERR_STREAM_WRITE_AFTER_END()
  } else if (state.destroyed) {
    err = new ERR_STREAM_DESTROYED('write')
  }

  if (err) {
    process.nextTick(cb, err)
    errorOrDestroy(stream, err, true)
    return err
  }

  state.pendingcb++
  return writeOrBuffer(stream, state, chunk, encoding, cb)
}

Writable.prototype.write = function (chunk, encoding, cb) {
  return _write(this, chunk, encoding, cb) === true
}

Writable.prototype.cork = function () {
  this._writableState.corked++
}

Writable.prototype.uncork = function () {
  const state = this._writableState

  if (state.corked) {
    state.corked--
    if (!state.writing) clearBuffer(this, state)
  }
}

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = StringPrototypeToLowerCase(encoding)
  if (!Buffer.isEncoding(encoding)) throw new ERR_UNKNOWN_ENCODING(encoding)
  this._writableState.defaultEncoding = encoding
  return this
} // If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.

function writeOrBuffer(stream, state, chunk, encoding, callback) {
  const len = state.objectMode ? 1 : chunk.length
  state.length += len // stream._write resets state.length

  const ret = state.length < state.highWaterMark // We must ensure that previous needDrain will not be reset to false.

  if (!ret) state.needDrain = true

  if (state.writing || state.corked || state.errored || !state.constructed) {
    state.buffered.push({
      chunk,
      encoding,
      callback
    })

    if (state.allBuffers && encoding !== 'buffer') {
      state.allBuffers = false
    }

    if (state.allNoop && callback !== nop) {
      state.allNoop = false
    }
  } else {
    state.writelen = len
    state.writecb = callback
    state.writing = true
    state.sync = true

    stream._write(chunk, encoding, state.onwrite)

    state.sync = false
  } // Return false if errored or destroyed in order to break
  // any synchronous while(stream.write(data)) loops.

  return ret && !state.errored && !state.destroyed
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len
  state.writecb = cb
  state.writing = true
  state.sync = true
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'))
  else if (writev) stream._writev(chunk, state.onwrite)
  else stream._write(chunk, encoding, state.onwrite)
  state.sync = false
}

function onwriteError(stream, state, er, cb) {
  --state.pendingcb
  cb(er) // Ensure callbacks are invoked even when autoDestroy is
  // not enabled. Passing `er` here doesn't make sense since
  // it's related to one specific write, not to the buffered
  // writes.

  errorBuffer(state) // This can emit error, but error must always follow cb.

  errorOrDestroy(stream, er)
}

function onwrite(stream, er) {
  const state = stream._writableState
  const sync = state.sync
  const cb = state.writecb

  if (typeof cb !== 'function') {
    errorOrDestroy(stream, new ERR_MULTIPLE_CALLBACK())
    return
  }

  state.writing = false
  state.writecb = null
  state.length -= state.writelen
  state.writelen = 0

  if (er) {
    // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
    er.stack // eslint-disable-line no-unused-expressions

    if (!state.errored) {
      state.errored = er
    } // In case of duplex streams we need to notify the readable side of the
    // error.

    if (stream._readableState && !stream._readableState.errored) {
      stream._readableState.errored = er
    }

    if (sync) {
      process.nextTick(onwriteError, stream, state, er, cb)
    } else {
      onwriteError(stream, state, er, cb)
    }
  } else {
    if (state.buffered.length > state.bufferedIndex) {
      clearBuffer(stream, state)
    }

    if (sync) {
      // It is a common case that the callback passed to .write() is always
      // the same. In that case, we do not schedule a new nextTick(), but
      // rather just increase a counter, to improve performance and avoid
      // memory allocations.
      if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) {
        state.afterWriteTickInfo.count++
      } else {
        state.afterWriteTickInfo = {
          count: 1,
          cb,
          stream,
          state
        }
        process.nextTick(afterWriteTick, state.afterWriteTickInfo)
      }
    } else {
      afterWrite(stream, state, 1, cb)
    }
  }
}

function afterWriteTick({ stream, state, count, cb }) {
  state.afterWriteTickInfo = null
  return afterWrite(stream, state, count, cb)
}

function afterWrite(stream, state, count, cb) {
  const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain

  if (needDrain) {
    state.needDrain = false
    stream.emit('drain')
  }

  while (count-- > 0) {
    state.pendingcb--
    cb()
  }

  if (state.destroyed) {
    errorBuffer(state)
  }

  finishMaybe(stream, state)
} // If there's something in the buffer waiting, then invoke callbacks.

function errorBuffer(state) {
  if (state.writing) {
    return
  }

  for (let n = state.bufferedIndex; n < state.buffered.length; ++n) {
    var _state$errored

    const { chunk, callback } = state.buffered[n]
    const len = state.objectMode ? 1 : chunk.length
    state.length -= len
    callback(
      (_state$errored = state.errored) !== null && _state$errored !== undefined
        ? _state$errored
        : new ERR_STREAM_DESTROYED('write')
    )
  }

  const onfinishCallbacks = state[kOnFinished].splice(0)

  for (let i = 0; i < onfinishCallbacks.length; i++) {
    var _state$errored2

    onfinishCallbacks[i](
      (_state$errored2 = state.errored) !== null && _state$errored2 !== undefined
        ? _state$errored2
        : new ERR_STREAM_DESTROYED('end')
    )
  }

  resetBuffer(state)
} // If there's something in the buffer waiting, then process it.

function clearBuffer(stream, state) {
  if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) {
    return
  }

  const { buffered, bufferedIndex, objectMode } = state
  const bufferedLength = buffered.length - bufferedIndex

  if (!bufferedLength) {
    return
  }

  let i = bufferedIndex
  state.bufferProcessing = true

  if (bufferedLength > 1 && stream._writev) {
    state.pendingcb -= bufferedLength - 1
    const callback = state.allNoop
      ? nop
      : (err) => {
          for (let n = i; n < buffered.length; ++n) {
            buffered[n].callback(err)
          }
        } // Make a copy of `buffered` if it's going to be used by `callback` above,
    // since `doWrite` will mutate the array.

    const chunks = state.allNoop && i === 0 ? buffered : ArrayPrototypeSlice(buffered, i)
    chunks.allBuffers = state.allBuffers
    doWrite(stream, state, true, state.length, chunks, '', callback)
    resetBuffer(state)
  } else {
    do {
      const { chunk, encoding, callback } = buffered[i]
      buffered[i++] = null
      const len = objectMode ? 1 : chunk.length
      doWrite(stream, state, false, len, chunk, encoding, callback)
    } while (i < buffered.length && !state.writing)

    if (i === buffered.length) {
      resetBuffer(state)
    } else if (i > 256) {
      buffered.splice(0, i)
      state.bufferedIndex = 0
    } else {
      state.bufferedIndex = i
    }
  }

  state.bufferProcessing = false
}

Writable.prototype._write = function (chunk, encoding, cb) {
  if (this._writev) {
    this._writev(
      [
        {
          chunk,
          encoding
        }
      ],
      cb
    )
  } else {
    throw new ERR_METHOD_NOT_IMPLEMENTED('_write()')
  }
}

Writable.prototype._writev = null

Writable.prototype.end = function (chunk, encoding, cb) {
  const state = this._writableState

  if (typeof chunk === 'function') {
    cb = chunk
    chunk = null
    encoding = null
  } else if (typeof encoding === 'function') {
    cb = encoding
    encoding = null
  }

  let err

  if (chunk !== null && chunk !== undefined) {
    const ret = _write(this, chunk, encoding)

    if (ret instanceof Error) {
      err = ret
    }
  } // .end() fully uncorks.

  if (state.corked) {
    state.corked = 1
    this.uncork()
  }

  if (err) {
    // Do nothing...
  } else if (!state.errored && !state.ending) {
    // This is forgiving in terms of unnecessary calls to end() and can hide
    // logic errors. However, usually such errors are harmless and causing a
    // hard error can be disproportionately destructive. It is not always
    // trivial for the user to determine whether end() needs to be called
    // or not.
    state.ending = true
    finishMaybe(this, state, true)
    state.ended = true
  } else if (state.finished) {
    err = new ERR_STREAM_ALREADY_FINISHED('end')
  } else if (state.destroyed) {
    err = new ERR_STREAM_DESTROYED('end')
  }

  if (typeof cb === 'function') {
    if (err || state.finished) {
      process.nextTick(cb, err)
    } else {
      state[kOnFinished].push(cb)
    }
  }

  return this
}

function needFinish(state) {
  return (
    state.ending &&
    !state.destroyed &&
    state.constructed &&
    state.length === 0 &&
    !state.errored &&
    state.buffered.length === 0 &&
    !state.finished &&
    !state.writing &&
    !state.errorEmitted &&
    !state.closeEmitted
  )
}

function callFinal(stream, state) {
  let called = false

  function onFinish(err) {
    if (called) {
      errorOrDestroy(stream, err !== null && err !== undefined ? err : ERR_MULTIPLE_CALLBACK())
      return
    }

    called = true
    state.pendingcb--

    if (err) {
      const onfinishCallbacks = state[kOnFinished].splice(0)

      for (let i = 0; i < onfinishCallbacks.length; i++) {
        onfinishCallbacks[i](err)
      }

      errorOrDestroy(stream, err, state.sync)
    } else if (needFinish(state)) {
      state.prefinished = true
      stream.emit('prefinish') // Backwards compat. Don't check state.sync here.
      // Some streams assume 'finish' will be emitted
      // asynchronously relative to _final callback.

      state.pendingcb++
      process.nextTick(finish, stream, state)
    }
  }

  state.sync = true
  state.pendingcb++

  try {
    stream._final(onFinish)
  } catch (err) {
    onFinish(err)
  }

  state.sync = false
}

function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.finalCalled = true
      callFinal(stream, state)
    } else {
      state.prefinished = true
      stream.emit('prefinish')
    }
  }
}

function finishMaybe(stream, state, sync) {
  if (needFinish(state)) {
    prefinish(stream, state)

    if (state.pendingcb === 0) {
      if (sync) {
        state.pendingcb++
        process.nextTick(
          (stream, state) => {
            if (needFinish(state)) {
              finish(stream, state)
            } else {
              state.pendingcb--
            }
          },
          stream,
          state
        )
      } else if (needFinish(state)) {
        state.pendingcb++
        finish(stream, state)
      }
    }
  }
}

function finish(stream, state) {
  state.pendingcb--
  state.finished = true
  const onfinishCallbacks = state[kOnFinished].splice(0)

  for (let i = 0; i < onfinishCallbacks.length; i++) {
    onfinishCallbacks[i]()
  }

  stream.emit('finish')

  if (state.autoDestroy) {
    // In case of duplex streams we need a way to detect
    // if the readable side is ready for autoDestroy as well.
    const rState = stream._readableState
    const autoDestroy =
      !rState ||
      (rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false))

    if (autoDestroy) {
      stream.destroy()
    }
  }
}

ObjectDefineProperties(Writable.prototype, {
  closed: {
    __proto__: null,

    get() {
      return this._writableState ? this._writableState.closed : false
    }
  },
  destroyed: {
    __proto__: null,

    get() {
      return this._writableState ? this._writableState.destroyed : false
    },

    set(value) {
      // Backward compatibility, the user is explicitly managing destroyed.
      if (this._writableState) {
        this._writableState.destroyed = value
      }
    }
  },
  writable: {
    __proto__: null,

    get() {
      const w = this._writableState // w.writable === false means that this is part of a Duplex stream
      // where the writable side was disabled upon construction.
      // Compat. The user might manually disable writable side through
      // deprecated setter.

      return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended
    },

    set(val) {
      // Backwards compatible.
      if (this._writableState) {
        this._writableState.writable = !!val
      }
    }
  },
  writableFinished: {
    __proto__: null,

    get() {
      return this._writableState ? this._writableState.finished : false
    }
  },
  writableObjectMode: {
    __proto__: null,

    get() {
      return this._writableState ? this._writableState.objectMode : false
    }
  },
  writableBuffer: {
    __proto__: null,

    get() {
      return this._writableState && this._writableState.getBuffer()
    }
  },
  writableEnded: {
    __proto__: null,

    get() {
      return this._writableState ? this._writableState.ending : false
    }
  },
  writableNeedDrain: {
    __proto__: null,

    get() {
      const wState = this._writableState
      if (!wState) return false
      return !wState.destroyed && !wState.ending && wState.needDrain
    }
  },
  writableHighWaterMark: {
    __proto__: null,

    get() {
      return this._writableState && this._writableState.highWaterMark
    }
  },
  writableCorked: {
    __proto__: null,

    get() {
      return this._writableState ? this._writableState.corked : 0
    }
  },
  writableLength: {
    __proto__: null,

    get() {
      return this._writableState && this._writableState.length
    }
  },
  errored: {
    __proto__: null,
    enumerable: false,

    get() {
      return this._writableState ? this._writableState.errored : null
    }
  },
  writableAborted: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return !!(
        this._writableState.writable !== false &&
        (this._writableState.destroyed || this._writableState.errored) &&
        !this._writableState.finished
      )
    }
  }
})
const destroy = destroyImpl.destroy

Writable.prototype.destroy = function (err, cb) {
  const state = this._writableState // Invoke pending callbacks.

  if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[kOnFinished].length)) {
    process.nextTick(errorBuffer, state)
  }

  destroy.call(this, err, cb)
  return this
}

Writable.prototype._undestroy = destroyImpl.undestroy

Writable.prototype._destroy = function (err, cb) {
  cb(err)
}

Writable.prototype[EE.captureRejectionSymbol] = function (err) {
  this.destroy(err)
}

let webStreamsAdapters // Lazy to avoid circular references

function lazyWebStreams() {
  if (webStreamsAdapters === undefined) webStreamsAdapters = {}
  return webStreamsAdapters
}

Writable.fromWeb = function (writableStream, options) {
  return lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options)
}

Writable.toWeb = function (streamWritable) {
  return lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable)
}


/***/ }),

/***/ 85132:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const {
  ArrayIsArray,
  ArrayPrototypeIncludes,
  ArrayPrototypeJoin,
  ArrayPrototypeMap,
  NumberIsInteger,
  NumberIsNaN,
  NumberMAX_SAFE_INTEGER,
  NumberMIN_SAFE_INTEGER,
  NumberParseInt,
  ObjectPrototypeHasOwnProperty,
  RegExpPrototypeExec,
  String,
  StringPrototypeToUpperCase,
  StringPrototypeTrim
} = __webpack_require__(57793)

const {
  hideStackFrames,
  codes: { ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL }
} = __webpack_require__(58380)

const { normalizeEncoding } = __webpack_require__(55616)

const { isAsyncFunction, isArrayBufferView } = (__webpack_require__(55616).types)

const signals = {}
/**
 * @param {*} value
 * @returns {boolean}
 */

function isInt32(value) {
  return value === (value | 0)
}
/**
 * @param {*} value
 * @returns {boolean}
 */

function isUint32(value) {
  return value === value >>> 0
}

const octalReg = /^[0-7]+$/
const modeDesc = 'must be a 32-bit unsigned integer or an octal string'
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 *
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */

function parseFileMode(value, name, def) {
  if (typeof value === 'undefined') {
    value = def
  }

  if (typeof value === 'string') {
    if (RegExpPrototypeExec(octalReg, value) === null) {
      throw new ERR_INVALID_ARG_VALUE(name, value, modeDesc)
    }

    value = NumberParseInt(value, 8)
  }

  validateUint32(value, name)
  return value
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */

/** @type {validateInteger} */

const validateInteger = hideStackFrames((value, name, min = NumberMIN_SAFE_INTEGER, max = NumberMAX_SAFE_INTEGER) => {
  if (typeof value !== 'number') throw new ERR_INVALID_ARG_TYPE(name, 'number', value)
  if (!NumberIsInteger(value)) throw new ERR_OUT_OF_RANGE(name, 'an integer', value)
  if (value < min || value > max) throw new ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value)
})
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */

/** @type {validateInt32} */

const validateInt32 = hideStackFrames((value, name, min = -2147483648, max = 2147483647) => {
  // The defaults for min and max correspond to the limits of 32-bit integers.
  if (typeof value !== 'number') {
    throw new ERR_INVALID_ARG_TYPE(name, 'number', value)
  }

  if (!NumberIsInteger(value)) {
    throw new ERR_OUT_OF_RANGE(name, 'an integer', value)
  }

  if (value < min || value > max) {
    throw new ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value)
  }
})
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */

/** @type {validateUint32} */

const validateUint32 = hideStackFrames((value, name, positive = false) => {
  if (typeof value !== 'number') {
    throw new ERR_INVALID_ARG_TYPE(name, 'number', value)
  }

  if (!NumberIsInteger(value)) {
    throw new ERR_OUT_OF_RANGE(name, 'an integer', value)
  }

  const min = positive ? 1 : 0 // 2 ** 32 === 4294967296

  const max = 4_294_967_295

  if (value < min || value > max) {
    throw new ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value)
  }
})
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */

/** @type {validateString} */

function validateString(value, name) {
  if (typeof value !== 'string') throw new ERR_INVALID_ARG_TYPE(name, 'string', value)
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */

/** @type {validateNumber} */

function validateNumber(value, name, min = undefined, max) {
  if (typeof value !== 'number') throw new ERR_INVALID_ARG_TYPE(name, 'number', value)

  if (
    (min != null && value < min) ||
    (max != null && value > max) ||
    ((min != null || max != null) && NumberIsNaN(value))
  ) {
    throw new ERR_OUT_OF_RANGE(
      name,
      `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`,
      value
    )
  }
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */

/** @type {validateOneOf} */

const validateOneOf = hideStackFrames((value, name, oneOf) => {
  if (!ArrayPrototypeIncludes(oneOf, value)) {
    const allowed = ArrayPrototypeJoin(
      ArrayPrototypeMap(oneOf, (v) => (typeof v === 'string' ? `'${v}'` : String(v))),
      ', '
    )
    const reason = 'must be one of: ' + allowed
    throw new ERR_INVALID_ARG_VALUE(name, value, reason)
  }
})
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */

/** @type {validateBoolean} */

function validateBoolean(value, name) {
  if (typeof value !== 'boolean') throw new ERR_INVALID_ARG_TYPE(name, 'boolean', value)
}

function getOwnPropertyValueOrDefault(options, key, defaultValue) {
  return options == null || !ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key]
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */

/** @type {validateObject} */

const validateObject = hideStackFrames((value, name, options = null) => {
  const allowArray = getOwnPropertyValueOrDefault(options, 'allowArray', false)
  const allowFunction = getOwnPropertyValueOrDefault(options, 'allowFunction', false)
  const nullable = getOwnPropertyValueOrDefault(options, 'nullable', false)

  if (
    (!nullable && value === null) ||
    (!allowArray && ArrayIsArray(value)) ||
    (typeof value !== 'object' && (!allowFunction || typeof value !== 'function'))
  ) {
    throw new ERR_INVALID_ARG_TYPE(name, 'Object', value)
  }
})
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */

/** @type {validateArray} */

const validateArray = hideStackFrames((value, name, minLength = 0) => {
  if (!ArrayIsArray(value)) {
    throw new ERR_INVALID_ARG_TYPE(name, 'Array', value)
  }

  if (value.length < minLength) {
    const reason = `must be longer than ${minLength}`
    throw new ERR_INVALID_ARG_VALUE(name, value, reason)
  }
}) // eslint-disable-next-line jsdoc/require-returns-check

/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */

function validateSignalName(signal, name = 'signal') {
  validateString(signal, name)

  if (signals[signal] === undefined) {
    if (signals[StringPrototypeToUpperCase(signal)] !== undefined) {
      throw new ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)')
    }

    throw new ERR_UNKNOWN_SIGNAL(signal)
  }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */

/** @type {validateBuffer} */

const validateBuffer = hideStackFrames((buffer, name = 'buffer') => {
  if (!isArrayBufferView(buffer)) {
    throw new ERR_INVALID_ARG_TYPE(name, ['Buffer', 'TypedArray', 'DataView'], buffer)
  }
})
/**
 * @param {string} data
 * @param {string} encoding
 */

function validateEncoding(data, encoding) {
  const normalizedEncoding = normalizeEncoding(encoding)
  const length = data.length

  if (normalizedEncoding === 'hex' && length % 2 !== 0) {
    throw new ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`)
  }
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */

function validatePort(port, name = 'Port', allowZero = true) {
  if (
    (typeof port !== 'number' && typeof port !== 'string') ||
    (typeof port === 'string' && StringPrototypeTrim(port).length === 0) ||
    +port !== +port >>> 0 ||
    port > 0xffff ||
    (port === 0 && !allowZero)
  ) {
    throw new ERR_SOCKET_BAD_PORT(name, port, allowZero)
  }

  return port | 0
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */

/** @type {validateAbortSignal} */

const validateAbortSignal = hideStackFrames((signal, name) => {
  if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) {
    throw new ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal)
  }
})
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */

/** @type {validateFunction} */

const validateFunction = hideStackFrames((value, name) => {
  if (typeof value !== 'function') throw new ERR_INVALID_ARG_TYPE(name, 'Function', value)
})
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */

/** @type {validatePlainFunction} */

const validatePlainFunction = hideStackFrames((value, name) => {
  if (typeof value !== 'function' || isAsyncFunction(value)) throw new ERR_INVALID_ARG_TYPE(name, 'Function', value)
})
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */

/** @type {validateUndefined} */

const validateUndefined = hideStackFrames((value, name) => {
  if (value !== undefined) throw new ERR_INVALID_ARG_TYPE(name, 'undefined', value)
})
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */

function validateUnion(value, name, union) {
  if (!ArrayPrototypeIncludes(union, value)) {
    throw new ERR_INVALID_ARG_TYPE(name, `('${ArrayPrototypeJoin(union, '|')}')`, value)
  }
}

module.exports = {
  isInt32,
  isUint32,
  parseFileMode,
  validateArray,
  validateBoolean,
  validateBuffer,
  validateEncoding,
  validateFunction,
  validateInt32,
  validateInteger,
  validateNumber,
  validateObject,
  validateOneOf,
  validatePlainFunction,
  validatePort,
  validateSignalName,
  validateString,
  validateUint32,
  validateUndefined,
  validateUnion,
  validateAbortSignal
}


/***/ }),

/***/ 18359:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const CustomStream = __webpack_require__(14018)

const promises = __webpack_require__(2504)

const originalDestroy = CustomStream.Readable.destroy
module.exports = CustomStream.Readable // Explicit export naming is needed for ESM

module.exports._uint8ArrayToBuffer = CustomStream._uint8ArrayToBuffer
module.exports._isUint8Array = CustomStream._isUint8Array
module.exports.isDisturbed = CustomStream.isDisturbed
module.exports.isErrored = CustomStream.isErrored
module.exports.isReadable = CustomStream.isReadable
module.exports.Readable = CustomStream.Readable
module.exports.Writable = CustomStream.Writable
module.exports.Duplex = CustomStream.Duplex
module.exports.Transform = CustomStream.Transform
module.exports.PassThrough = CustomStream.PassThrough
module.exports.addAbortSignal = CustomStream.addAbortSignal
module.exports.finished = CustomStream.finished
module.exports.destroy = CustomStream.destroy
module.exports.destroy = originalDestroy
module.exports.pipeline = CustomStream.pipeline
module.exports.compose = CustomStream.compose
Object.defineProperty(CustomStream, 'promises', {
  configurable: true,
  enumerable: true,

  get() {
    return promises
  }
})
module.exports.Stream = CustomStream.Stream // Allow default importing

module.exports["default"] = module.exports


/***/ }),

/***/ 58380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { format, inspect, AggregateError: CustomAggregateError } = __webpack_require__(55616)
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/master/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/

const AggregateError = globalThis.AggregateError || CustomAggregateError
const kIsNodeError = Symbol('kIsNodeError')
const kTypes = [
  'string',
  'function',
  'number',
  'object', // Accept 'Function' and 'Object' as alternative to the lower cased version.
  'Function',
  'Object',
  'boolean',
  'bigint',
  'symbol'
]
const classRegExp = /^([A-Z][a-z0-9]*)+$/
const nodeInternalPrefix = '__node_internal_'
const codes = {}

function assert(value, message) {
  if (!value) {
    throw new codes.ERR_INTERNAL_ASSERTION(message)
  }
} // Only use this for integers! Decimal numbers do not work with this function.

function addNumericalSeparator(val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0

  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }

  return `${val.slice(0, i)}${res}`
}

function getMessage(key, msg, args) {
  if (typeof msg === 'function') {
    assert(
      msg.length <= args.length, // Default options do not count.
      `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`
    )
    return msg(...args)
  }

  const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length
  assert(
    expectedLength === args.length,
    `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`
  )

  if (args.length === 0) {
    return msg
  }

  return format(msg, ...args)
}

function E(code, message, Base) {
  if (!Base) {
    Base = Error
  }

  class NodeError extends Base {
    constructor(...args) {
      super(getMessage(code, message, args))
    }

    toString() {
      return `${this.name} [${code}]: ${this.message}`
    }
  }

  Object.defineProperties(NodeError.prototype, {
    name: {
      value: Base.name,
      writable: true,
      enumerable: false,
      configurable: true
    },
    toString: {
      value() {
        return `${this.name} [${code}]: ${this.message}`
      },

      writable: true,
      enumerable: false,
      configurable: true
    }
  })
  NodeError.prototype.code = code
  NodeError.prototype[kIsNodeError] = true
  codes[code] = NodeError
}

function hideStackFrames(fn) {
  // We rename the functions that will be hidden to cut off the stacktrace
  // at the outermost one
  const hidden = nodeInternalPrefix + fn.name
  Object.defineProperty(fn, 'name', {
    value: hidden
  })
  return fn
}

function aggregateTwoErrors(innerError, outerError) {
  if (innerError && outerError && innerError !== outerError) {
    if (Array.isArray(outerError.errors)) {
      // If `outerError` is already an `AggregateError`.
      outerError.errors.push(innerError)
      return outerError
    }

    const err = new AggregateError([outerError, innerError], outerError.message)
    err.code = outerError.code
    return err
  }

  return innerError || outerError
}

class AbortError extends Error {
  constructor(message = 'The operation was aborted', options = undefined) {
    if (options !== undefined && typeof options !== 'object') {
      throw new codes.ERR_INVALID_ARG_TYPE('options', 'Object', options)
    }

    super(message, options)
    this.code = 'ABORT_ERR'
    this.name = 'AbortError'
  }
}

E('ERR_ASSERTION', '%s', Error)
E(
  'ERR_INVALID_ARG_TYPE',
  (name, expected, actual) => {
    assert(typeof name === 'string', "'name' must be a string")

    if (!Array.isArray(expected)) {
      expected = [expected]
    }

    let msg = 'The '

    if (name.endsWith(' argument')) {
      // For cases like 'first argument'
      msg += `${name} `
    } else {
      msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `
    }

    msg += 'must be '
    const types = []
    const instances = []
    const other = []

    for (const value of expected) {
      assert(typeof value === 'string', 'All expected entries have to be of type string')

      if (kTypes.includes(value)) {
        types.push(value.toLowerCase())
      } else if (classRegExp.test(value)) {
        instances.push(value)
      } else {
        assert(value !== 'object', 'The value "object" should be written as "Object"')
        other.push(value)
      }
    } // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.

    if (instances.length > 0) {
      const pos = types.indexOf('object')

      if (pos !== -1) {
        types.splice(types, pos, 1)
        instances.push('Object')
      }
    }

    if (types.length > 0) {
      switch (types.length) {
        case 1:
          msg += `of type ${types[0]}`
          break

        case 2:
          msg += `one of type ${types[0]} or ${types[1]}`
          break

        default: {
          const last = types.pop()
          msg += `one of type ${types.join(', ')}, or ${last}`
        }
      }

      if (instances.length > 0 || other.length > 0) {
        msg += ' or '
      }
    }

    if (instances.length > 0) {
      switch (instances.length) {
        case 1:
          msg += `an instance of ${instances[0]}`
          break

        case 2:
          msg += `an instance of ${instances[0]} or ${instances[1]}`
          break

        default: {
          const last = instances.pop()
          msg += `an instance of ${instances.join(', ')}, or ${last}`
        }
      }

      if (other.length > 0) {
        msg += ' or '
      }
    }

    switch (other.length) {
      case 0:
        break

      case 1:
        if (other[0].toLowerCase() !== other[0]) {
          msg += 'an '
        }

        msg += `${other[0]}`
        break

      case 2:
        msg += `one of ${other[0]} or ${other[1]}`
        break

      default: {
        const last = other.pop()
        msg += `one of ${other.join(', ')}, or ${last}`
      }
    }

    if (actual == null) {
      msg += `. Received ${actual}`
    } else if (typeof actual === 'function' && actual.name) {
      msg += `. Received function ${actual.name}`
    } else if (typeof actual === 'object') {
      var _actual$constructor

      if (
        (_actual$constructor = actual.constructor) !== null &&
        _actual$constructor !== undefined &&
        _actual$constructor.name
      ) {
        msg += `. Received an instance of ${actual.constructor.name}`
      } else {
        const inspected = inspect(actual, {
          depth: -1
        })
        msg += `. Received ${inspected}`
      }
    } else {
      let inspected = inspect(actual, {
        colors: false
      })

      if (inspected.length > 25) {
        inspected = `${inspected.slice(0, 25)}...`
      }

      msg += `. Received type ${typeof actual} (${inspected})`
    }

    return msg
  },
  TypeError
)
E(
  'ERR_INVALID_ARG_VALUE',
  (name, value, reason = 'is invalid') => {
    let inspected = inspect(value)

    if (inspected.length > 128) {
      inspected = inspected.slice(0, 128) + '...'
    }

    const type = name.includes('.') ? 'property' : 'argument'
    return `The ${type} '${name}' ${reason}. Received ${inspected}`
  },
  TypeError
)
E(
  'ERR_INVALID_RETURN_VALUE',
  (input, name, value) => {
    var _value$constructor

    const type =
      value !== null &&
      value !== undefined &&
      (_value$constructor = value.constructor) !== null &&
      _value$constructor !== undefined &&
      _value$constructor.name
        ? `instance of ${value.constructor.name}`
        : `type ${typeof value}`
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`
  },
  TypeError
)
E(
  'ERR_MISSING_ARGS',
  (...args) => {
    assert(args.length > 0, 'At least one arg needs to be specified')
    let msg
    const len = args.length
    args = (Array.isArray(args) ? args : [args]).map((a) => `"${a}"`).join(' or ')

    switch (len) {
      case 1:
        msg += `The ${args[0]} argument`
        break

      case 2:
        msg += `The ${args[0]} and ${args[1]} arguments`
        break

      default:
        {
          const last = args.pop()
          msg += `The ${args.join(', ')}, and ${last} arguments`
        }
        break
    }

    return `${msg} must be specified`
  },
  TypeError
)
E(
  'ERR_OUT_OF_RANGE',
  (str, range, input) => {
    assert(range, 'Missing "range" argument')
    let received

    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)

      if (input > 2n ** 32n || input < -(2n ** 32n)) {
        received = addNumericalSeparator(received)
      }

      received += 'n'
    } else {
      received = inspect(input)
    }

    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`
  },
  RangeError
)
E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error)
E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error)
E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error)
E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error)
E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error)
E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError)
E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error)
E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error)
E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error)
E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error)
E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError)
module.exports = {
  AbortError,
  aggregateTwoErrors: hideStackFrames(aggregateTwoErrors),
  hideStackFrames,
  codes
}


/***/ }),

/***/ 57793:
/***/ (function(module) {

"use strict";

/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/master/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/

module.exports = {
  ArrayIsArray(self) {
    return Array.isArray(self)
  },

  ArrayPrototypeIncludes(self, el) {
    return self.includes(el)
  },

  ArrayPrototypeIndexOf(self, el) {
    return self.indexOf(el)
  },

  ArrayPrototypeJoin(self, sep) {
    return self.join(sep)
  },

  ArrayPrototypeMap(self, fn) {
    return self.map(fn)
  },

  ArrayPrototypePop(self, el) {
    return self.pop(el)
  },

  ArrayPrototypePush(self, el) {
    return self.push(el)
  },

  ArrayPrototypeSlice(self, start, end) {
    return self.slice(start, end)
  },

  Error,

  FunctionPrototypeCall(fn, thisArgs, ...args) {
    return fn.call(thisArgs, ...args)
  },

  FunctionPrototypeSymbolHasInstance(self, instance) {
    return Function.prototype[Symbol.hasInstance].call(self, instance)
  },

  MathFloor: Math.floor,
  Number,
  NumberIsInteger: Number.isInteger,
  NumberIsNaN: Number.isNaN,
  NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
  NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
  NumberParseInt: Number.parseInt,

  ObjectDefineProperties(self, props) {
    return Object.defineProperties(self, props)
  },

  ObjectDefineProperty(self, name, prop) {
    return Object.defineProperty(self, name, prop)
  },

  ObjectGetOwnPropertyDescriptor(self, name) {
    return Object.getOwnPropertyDescriptor(self, name)
  },

  ObjectKeys(obj) {
    return Object.keys(obj)
  },

  ObjectSetPrototypeOf(target, proto) {
    return Object.setPrototypeOf(target, proto)
  },

  Promise,

  PromisePrototypeCatch(self, fn) {
    return self.catch(fn)
  },

  PromisePrototypeThen(self, thenFn, catchFn) {
    return self.then(thenFn, catchFn)
  },

  PromiseReject(err) {
    return Promise.reject(err)
  },

  ReflectApply: Reflect.apply,

  RegExpPrototypeTest(self, value) {
    return self.test(value)
  },

  SafeSet: Set,
  String,

  StringPrototypeSlice(self, start, end) {
    return self.slice(start, end)
  },

  StringPrototypeToLowerCase(self) {
    return self.toLowerCase()
  },

  StringPrototypeToUpperCase(self) {
    return self.toUpperCase()
  },

  StringPrototypeTrim(self) {
    return self.trim()
  },

  Symbol,
  SymbolAsyncIterator: Symbol.asyncIterator,
  SymbolHasInstance: Symbol.hasInstance,
  SymbolIterator: Symbol.iterator,

  TypedArrayPrototypeSet(self, buf, len) {
    return self.set(buf, len)
  },

  Uint8Array
}


/***/ }),

/***/ 55616:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const bufferModule = __webpack_require__(30816)

const AsyncFunction = Object.getPrototypeOf(async function () {}).constructor
const Blob = globalThis.Blob || bufferModule.Blob
/* eslint-disable indent */

const isBlob =
  typeof Blob !== 'undefined'
    ? function isBlob(b) {
        // eslint-disable-next-line indent
        return b instanceof Blob
      }
    : function isBlob(b) {
        return false
      }
/* eslint-enable indent */
// This is a simplified version of AggregateError

class AggregateError extends Error {
  constructor(errors) {
    if (!Array.isArray(errors)) {
      throw new TypeError(`Expected input to be an Array, got ${typeof errors}`)
    }

    let message = ''

    for (let i = 0; i < errors.length; i++) {
      message += `    ${errors[i].stack}\n`
    }

    super(message)
    this.name = 'AggregateError'
    this.errors = errors
  }
}

module.exports = {
  AggregateError,
  kEmptyObject: Object.freeze({}),

  once(callback) {
    let called = false
    return function (...args) {
      if (called) {
        return
      }

      called = true
      callback.apply(this, args)
    }
  },

  createDeferredPromise: function () {
    let resolve
    let reject // eslint-disable-next-line promise/param-names

    const promise = new Promise((res, rej) => {
      resolve = res
      reject = rej
    })
    return {
      promise,
      resolve,
      reject
    }
  },

  promisify(fn) {
    return new Promise((resolve, reject) => {
      fn((err, ...args) => {
        if (err) {
          return reject(err)
        }

        return resolve(...args)
      })
    })
  },

  debuglog() {
    return function () {}
  },

  format(format, ...args) {
    // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
    return format.replace(/%([sdifj])/g, function (...[_unused, type]) {
      const replacement = args.shift()

      if (type === 'f') {
        return replacement.toFixed(6)
      } else if (type === 'j') {
        return JSON.stringify(replacement)
      } else if (type === 's' && typeof replacement === 'object') {
        const ctor = replacement.constructor !== Object ? replacement.constructor.name : ''
        return `${ctor} {}`.trim()
      } else {
        return replacement.toString()
      }
    })
  },

  inspect(value) {
    // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
    switch (typeof value) {
      case 'string':
        if (value.includes("'")) {
          if (!value.includes('"')) {
            return `"${value}"`
          } else if (!value.includes('`') && !value.includes('${')) {
            return `\`${value}\``
          }
        }

        return `'${value}'`

      case 'number':
        if (isNaN(value)) {
          return 'NaN'
        } else if (Object.is(value, -0)) {
          return String(value)
        }

        return value

      case 'bigint':
        return `${String(value)}n`

      case 'boolean':
      case 'undefined':
        return String(value)

      case 'object':
        return '{}'
    }
  },

  types: {
    isAsyncFunction(fn) {
      return fn instanceof AsyncFunction
    },

    isArrayBufferView(arr) {
      return ArrayBuffer.isView(arr)
    }
  },
  isBlob
}
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom')


/***/ }),

/***/ 14018:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* replacement start */
const { Buffer } = __webpack_require__(30816)
/* replacement end */
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

;('use strict')

const { ObjectDefineProperty, ObjectKeys, ReflectApply } = __webpack_require__(57793)

const {
  promisify: { custom: customPromisify }
} = __webpack_require__(55616)

const { streamReturningOperators, promiseReturningOperators } = __webpack_require__(54393)

const {
  codes: { ERR_ILLEGAL_CONSTRUCTOR }
} = __webpack_require__(58380)

const compose = __webpack_require__(66036)

const { pipeline } = __webpack_require__(20410)

const { destroyer } = __webpack_require__(27640)

const eos = __webpack_require__(85027)

const internalBuffer = {}

const promises = __webpack_require__(2504)

const utils = __webpack_require__(81391)

const Stream = (module.exports = __webpack_require__(55782).Stream)

Stream.isDisturbed = utils.isDisturbed
Stream.isErrored = utils.isErrored
Stream.isReadable = utils.isReadable
Stream.Readable = __webpack_require__(61716)

for (const key of ObjectKeys(streamReturningOperators)) {
  const op = streamReturningOperators[key]

  function fn(...args) {
    if (new.target) {
      throw ERR_ILLEGAL_CONSTRUCTOR()
    }

    return Stream.Readable.from(ReflectApply(op, this, args))
  }

  ObjectDefineProperty(fn, 'name', {
    __proto__: null,
    value: op.name
  })
  ObjectDefineProperty(fn, 'length', {
    __proto__: null,
    value: op.length
  })
  ObjectDefineProperty(Stream.Readable.prototype, key, {
    __proto__: null,
    value: fn,
    enumerable: false,
    configurable: true,
    writable: true
  })
}

for (const key of ObjectKeys(promiseReturningOperators)) {
  const op = promiseReturningOperators[key]

  function fn(...args) {
    if (new.target) {
      throw ERR_ILLEGAL_CONSTRUCTOR()
    }

    return ReflectApply(op, this, args)
  }

  ObjectDefineProperty(fn, 'name', {
    __proto__: null,
    value: op.name
  })
  ObjectDefineProperty(fn, 'length', {
    __proto__: null,
    value: op.length
  })
  ObjectDefineProperty(Stream.Readable.prototype, key, {
    __proto__: null,
    value: fn,
    enumerable: false,
    configurable: true,
    writable: true
  })
}

Stream.Writable = __webpack_require__(69337)
Stream.Duplex = __webpack_require__(55426)
Stream.Transform = __webpack_require__(20050)
Stream.PassThrough = __webpack_require__(67640)
Stream.pipeline = pipeline

const { addAbortSignal } = __webpack_require__(93092)

Stream.addAbortSignal = addAbortSignal
Stream.finished = eos
Stream.destroy = destroyer
Stream.compose = compose
ObjectDefineProperty(Stream, 'promises', {
  __proto__: null,
  configurable: true,
  enumerable: true,

  get() {
    return promises
  }
})
ObjectDefineProperty(pipeline, customPromisify, {
  __proto__: null,
  enumerable: true,

  get() {
    return promises.pipeline
  }
})
ObjectDefineProperty(eos, customPromisify, {
  __proto__: null,
  enumerable: true,

  get() {
    return promises.finished
  }
}) // Backwards-compat with node 0.4.x

Stream.Stream = Stream

Stream._isUint8Array = function isUint8Array(value) {
  return value instanceof Uint8Array
}

Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength)
}


/***/ }),

/***/ 2504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { ArrayPrototypePop, Promise } = __webpack_require__(57793)

const { isIterable, isNodeStream } = __webpack_require__(81391)

const { pipelineImpl: pl } = __webpack_require__(20410)

const { finished } = __webpack_require__(85027)

function pipeline(...streams) {
  return new Promise((resolve, reject) => {
    let signal
    let end
    const lastArg = streams[streams.length - 1]

    if (lastArg && typeof lastArg === 'object' && !isNodeStream(lastArg) && !isIterable(lastArg)) {
      const options = ArrayPrototypePop(streams)
      signal = options.signal
      end = options.end
    }

    pl(
      streams,
      (err, value) => {
        if (err) {
          reject(err)
        } else {
          resolve(value)
        }
      },
      {
        signal,
        end
      }
    )
  })
}

module.exports = {
  finished,
  pipeline
}


/***/ }),

/***/ 86248:
/***/ (function(module) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per GeneratorResume behavior specified since ES2015:
        // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
        // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next method, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable != null) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    throw new TypeError(typeof iterable + " is not iterable");
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 59948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var functionsHaveConfigurableNames = (__webpack_require__(80222).functionsHaveConfigurableNames)();

var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};

if (functionsHaveConfigurableNames && Object.defineProperty) {
	Object.defineProperty(module.exports, "name", ({ value: 'get flags' }));
}


/***/ }),

/***/ 62473:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(67392);
var callBind = __webpack_require__(34573);

var implementation = __webpack_require__(59948);
var getPolyfill = __webpack_require__(52046);
var shim = __webpack_require__(93289);

var flagsBound = callBind(getPolyfill());

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),

/***/ 52046:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(59948);

var supportsDescriptors = (__webpack_require__(67392).supportsDescriptors);
var $gOPD = Object.getOwnPropertyDescriptor;

module.exports = function getPolyfill() {
	if (supportsDescriptors && (/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (
			descriptor
			&& typeof descriptor.get === 'function'
			&& typeof RegExp.prototype.dotAll === 'boolean'
			&& typeof RegExp.prototype.hasIndices === 'boolean'
		) {
			/* eslint getter-return: 0 */
			var calls = '';
			var o = {};
			Object.defineProperty(o, 'hasIndices', {
				get: function () {
					calls += 'd';
				}
			});
			Object.defineProperty(o, 'sticky', {
				get: function () {
					calls += 'y';
				}
			});
			if (calls === 'dy') {
				return descriptor.get;
			}
		}
	}
	return implementation;
};


/***/ }),

/***/ 93289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var supportsDescriptors = (__webpack_require__(67392).supportsDescriptors);
var getPolyfill = __webpack_require__(52046);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),

/***/ 80406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P1": function() { return /* binding */ createSelector; }
/* harmony export */ });
/* unused harmony exports defaultMemoize, createSelectorCreator, createStructuredSelector */
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),

/***/ 95337:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(68750);
var callBound = __webpack_require__(12737);
var inspect = __webpack_require__(86524);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ 46236:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var SLOT = __webpack_require__(22524);

var $SyntaxError = SyntaxError;
var $StopIteration = typeof StopIteration === 'object' ? StopIteration : null;

module.exports = function getStopIterationIterator(origIterator) {
	if (!$StopIteration) {
		throw new $SyntaxError('this environment lacks StopIteration');
	}

	SLOT.set(origIterator, '[[Done]]', false);

	var siIterator = {
		next: function next() {
			var iterator = SLOT.get(this, '[[Iterator]]');
			var done = SLOT.get(iterator, '[[Done]]');
			try {
				return {
					done: done,
					value: done ? void undefined : iterator.next()
				};
			} catch (e) {
				SLOT.set(iterator, '[[Done]]', true);
				if (e !== $StopIteration) {
					throw e;
				}
				return {
					done: true,
					value: void undefined
				};
			}
		}
	};

	SLOT.set(siIterator, '[[Iterator]]', origIterator);

	return siIterator;
};


/***/ }),

/***/ 34361:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(61562).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 61562:
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(30816)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 87602:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var space = __webpack_require__(92746)

/**
 * Export.
 */

module.exports = toCamelCase

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}


/***/ }),

/***/ 67519:
/***/ (function(module) {


/**
 * Export.
 */

module.exports = toNoCase

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/
var hasSeparator = /(_|-|\.|:)/
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}


/***/ }),

/***/ 92746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var clean = __webpack_require__(67519)

/**
 * Export.
 */

module.exports = toSpaceCase

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}


/***/ }),

/***/ 4651:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* UAParser.js v1.0.34
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */
(function(window,undefined){"use strict";var LIBVERSION="1.0.34",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=350;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HUAWEI="Huawei",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",OPERA="Opera",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",VIERA="Viera",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook",CHROMIUM_OS="Chromium OS",MAC_OS="Mac OS";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i]}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){if(!regex[j]){break}matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined:i}}return str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,/(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,/(ba?idubrowser)[\/ ]?([\w\.]+)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i],[VERSION,[NAME,"WeChat(Win) Desktop"]],[/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/yabrowser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI "+BROWSER]],[/fxios\/([-\w\.]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihu|(qi?ho?o?|360)browser/i],[[NAME,"360 "+BROWSER]],[/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 "+BROWSER],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i],[NAME,VERSION],[/(metasr)[\/ ]?([\w\.]+)/i,/(lbbrowser)/i,/\[(linkedin)app\]/i],[NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(chromium|instagram)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i,/panasonic;(viera)/i],[NAME,VERSION],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows (ce|mobile); ppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]([-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/\((ip(?:hone|od)[\w ]*);/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/\b(poco[\w ]+)(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[12]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/(pixel c)\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kobo)\s(ereader|touch)/i,/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w ]+) b/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mitv-\w{5}) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/Hbbtv.*(technisat) (.*);/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield) bui/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation [345portablevi]+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/((pebble))app/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[MODEL,[VENDOR,APPLE],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/(quest( 2| pro)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/(android[-\w\. ]{0,9});.+buil/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows) nt 6\.2; (arm)/i,/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,/(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,strMapper,windowsVersionMap]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,MAC_OS],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[VERSION,[NAME,"watchOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[NAME,CHROMIUM_OS],VERSION],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _navigator=typeof window!==UNDEF_TYPE&&window.navigator?window.navigator:undefined;var _ua=ua||(_navigator&&_navigator.userAgent?_navigator.userAgent:EMPTY);var _uach=_navigator&&_navigator.userAgentData?_navigator.userAgentData:undefined;var _rgxmap=extensions?extend(regexes,extensions):regexes;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined;_browser[VERSION]=undefined;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser[MAJOR]=majorize(_browser[VERSION]);if(_navigator&&_navigator.brave&&typeof _navigator.brave.isBrave==FUNC_TYPE){_browser[NAME]="Brave"}return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined;_device[MODEL]=undefined;_device[TYPE]=undefined;rgxMapper.call(_device,_ua,_rgxmap.device);if(!_device[TYPE]&&_uach&&_uach.mobile){_device[TYPE]=MOBILE}if(_device[MODEL]=="Macintosh"&&_navigator&&typeof _navigator.standalone!==UNDEF_TYPE&&_navigator.maxTouchPoints&&_navigator.maxTouchPoints>2){_device[MODEL]="iPad";_device[TYPE]=TABLET}return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined;_engine[VERSION]=undefined;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined;_os[VERSION]=undefined;rgxMapper.call(_os,_ua,_rgxmap.os);if(!_os[NAME]&&_uach&&_uach.platform!="Unknown"){_os[NAME]=_uach.platform.replace(/chrome os/i,CHROMIUM_OS).replace(/macos/i,MAC_OS)}return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);if(typeof exports!==UNDEF_TYPE){if("object"!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__.amdO){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!==UNDEF_TYPE){window.UAParser=UAParser}}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),

/***/ 47989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var BlobSlicer = __webpack_require__(8558)
var ZipFile = __webpack_require__(51450)
var Utils = __webpack_require__(77198)

module.exports = function unzip (source, callback) {
  if (typeof source === 'string') {
    var xhr = new XMLHttpRequest()
    xhr.addEventListener('readystatechange', function () {
      if (this.readyState === 4) {
        if (this.status === 200) createZipFile(this.response, callback)
        else callback(Utils.E('network error: {0} {1}', this.status, this.statusText))
      }
    })
    try {
      xhr.open('GET', source)
      xhr.responseType = 'blob'
      xhr.send()
    } catch (err) {
      callback(err)
    }
  } else {
    createZipFile(source, callback)
  }
}

function createZipFile (source, callback) {
  try {
    var reader = new BlobSlicer(source)
    Utils.readEOCDRecord(reader, function (err, eocdr) {
      callback(err, err ? null : new ZipFile(reader, eocdr))
    })
  } catch (err) {
    callback(err)
  }
}


/***/ }),

/***/ 77198:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.readEOCDRecord = readEOCDRecord
exports.readUInt64LE = readUInt64LE
exports.E = E
exports.cp437ToUnicode = cp437ToUnicode

function readEOCDRecord (reader, callback) {
  var fixedFieldsSize = 22
  var maxRecordSize = fixedFieldsSize + 0xffff

  reader.read(-maxRecordSize, function (err, buf) {
    if (err) return callback(err)

    if (buf.length < fixedFieldsSize) {
      return callback(
        E('expected at least 22 bytes for End Of Central Directory got {0}', buf.length)
      )
    }

    var eocdr = {}
    // end of central dir signature    4 bytes  (0x06054b50)
    var offset = buf.lastIndexOf('PK\x05\x06')
    if (offset === -1) return callback(E('End Of Central Directory not found'))
    var recordBuffer = buf.slice(offset)
    // number of this disk             2 bytes
    if (recordBuffer.readUInt16LE(4) !== 0) {
      return callback(E('spanned zip files are not supported'))
    }
    // number of the disk with the
    // start of the central directory  2 bytes
    // total number of entries in the
    // central directory on this disk  2 bytes
    // total number of entries in
    // the central directory           2 bytes
    eocdr.entryCount = recordBuffer.readUInt16LE(10)
    // size of the central directory   4 bytes
    eocdr.cdSize = recordBuffer.readUInt32LE(12)
    // offset of start of central
    // directory with respect to
    // the starting disk number        4 bytes
    eocdr.cdOffset = recordBuffer.readUInt32LE(16)
    // .ZIP file comment length        2 bytes
    var commentLength = recordBuffer.readUInt16LE(20)
    // .ZIP file comment       (variable size)
    eocdr.comment = recordBuffer.toString('utf-8', 22, 22 + commentLength)
    console.assert(
      eocdr.comment.length === commentLength,
      'expected ' + commentLength + ' bytes for zip file comment got ' + eocdr.comment.length
    )

    if (
      eocdr.entryCount === 0xffff ||
      eocdr.cdSize === 0xffffffff ||
      eocdr.cdOffset === 0xffffffff
    ) {
      readEOCD64Record(reader, offset, function (err, eocd64r) {
        if (eocd64r) eocd64r.comment = eocdr.comment
        callback(err, eocd64r)
      })
    } else callback(null, eocdr)
  })
}

function readEOCD64Record (reader, eocdOffset, callback) {
  var fixedFieldsSize = 56

  readEOCDLocator(reader, eocdOffset, function (err, eocd64Offset) {
    if (err) return callback(err)

    reader.read(eocd64Offset, eocd64Offset + fixedFieldsSize, function (err, buf) {
      if (err) return callback(err)

      if (buf.length < fixedFieldsSize) {
        return callback(
          E('expected at least 56 bytes for Zip64 End Of Central Directory got {0}', buf.length)
        )
      }

      var eocd64r = {}
      // zip64 end of central dir
      // signature                       4 bytes  (0x06064b50)
      if (buf.readUInt32LE(0) !== 0x06064b50) {
        return callback(E('Zip64 End Of Central Directory not found'))
      }
      // size of zip64 end of central
      // directory record                8 bytes
      // version made by                 2 bytes
      // version needed to extract       2 bytes
      // number of this disk             4 bytes
      // number of the disk with the
      // start of the central directory  4 bytes
      // total number of entries in the
      // central directory on this disk  8 bytes
      // total number of entries in the
      // central directory               8 bytes
      eocd64r.entryCount = readUInt64LE(buf, 32)
      // size of the central directory   8 bytes
      eocd64r.cdSize = readUInt64LE(buf, 40)
      // offset of start of central
      // directory with respect to
      // the starting disk number        8 bytes
      eocd64r.cdOffset = readUInt64LE(buf, 48)
      // zip64 extensible data sector    (variable size)

      callback(null, eocd64r)
    })
  })
}

function readEOCDLocator (reader, eocdOffset, callback) {
  var locatorRecordSize = 20

  reader.read(eocdOffset - locatorRecordSize, eocdOffset, function (err, buf) {
    if (err) return callback(err)

    if (buf.length < locatorRecordSize) {
      return callback(
        E(
          'expected at least 20 bytes for Zip64 End Of Central Directory Locator got {0}',
          buf.length
        )
      )
    }

    // zip64 end of central dir locator
    // signature                       4 bytes  (0x07064b50)
    if (buf.readUInt32LE(0) !== 0x07064b50) {
      return callback(E('Zip64 End Of Central Directory Locator not found'))
    }
    // number of the disk with the
    // start of the zip64 end of
    // central directory               4 bytes
    // relative offset of the zip64
    // end of central directory record 8 bytes
    var eocd64Offset = readUInt64LE(buf, 8)
    // total number of disks           4 bytes
    if (buf.readUInt32LE(16) !== 1) {
      return callback(E('spanned zip files are not supported'))
    }

    callback(null, eocd64Offset)
  })
}

function readUInt64LE (buffer, offset) {
  return buffer.readUInt32LE(offset) + (buffer.readUInt32LE(offset + 4) * 0x100000000)
}

function E (message) {
  var args = arguments
  return new Error(
    message.replace(/{(\d+)}/g, function (match, p) {
      var r = args[+p + 1]
      return r === undefined ? match : r
    })
  )
}

function cp437ToUnicode (buffer) {
  var table = [
    0x0000, 0x263A, 0x263B, 0x2665, 0x2666, 0x2663, 0x2660, 0x2022, 0x25D8, 0x25CB, 0x25D9,
    0x2642, 0x2640, 0x266A, 0x266B, 0x263C, 0x25BA, 0x25C4, 0x2195, 0x203C, 0x00B6, 0x00A7,
    0x25AC, 0x21A8, 0x2191, 0x2193, 0x2192, 0x2190, 0x221F, 0x2194, 0x25B2, 0x25BC, 0x0020,
    0x0021, 0x0022, 0x0023, 0x0024, 0x0025, 0x0026, 0x0027, 0x0028, 0x0029, 0x002A, 0x002B,
    0x002C, 0x002D, 0x002E, 0x002F, 0x0030, 0x0031, 0x0032, 0x0033, 0x0034, 0x0035, 0x0036,
    0x0037, 0x0038, 0x0039, 0x003A, 0x003B, 0x003C, 0x003D, 0x003E, 0x003F, 0x0040, 0x0041,
    0x0042, 0x0043, 0x0044, 0x0045, 0x0046, 0x0047, 0x0048, 0x0049, 0x004A, 0x004B, 0x004C,
    0x004D, 0x004E, 0x004F, 0x0050, 0x0051, 0x0052, 0x0053, 0x0054, 0x0055, 0x0056, 0x0057,
    0x0058, 0x0059, 0x005A, 0x005B, 0x005C, 0x005D, 0x005E, 0x005F, 0x0060, 0x0061, 0x0062,
    0x0063, 0x0064, 0x0065, 0x0066, 0x0067, 0x0068, 0x0069, 0x006A, 0x006B, 0x006C, 0x006D,
    0x006E, 0x006F, 0x0070, 0x0071, 0x0072, 0x0073, 0x0074, 0x0075, 0x0076, 0x0077, 0x0078,
    0x0079, 0x007A, 0x007B, 0x007C, 0x007D, 0x007E, 0x2302, 0x00C7, 0x00FC, 0x00E9, 0x00E2,
    0x00E4, 0x00E0, 0x00E5, 0x00E7, 0x00EA, 0x00EB, 0x00E8, 0x00EF, 0x00EE, 0x00EC, 0x00C4,
    0x00C5, 0x00C9, 0x00E6, 0x00C6, 0x00F4, 0x00F6, 0x00F2, 0x00FB, 0x00F9, 0x00FF, 0x00D6,
    0x00DC, 0x00A2, 0x00A3, 0x00A5, 0x20A7, 0x0192, 0x00E1, 0x00ED, 0x00F3, 0x00FA, 0x00F1,
    0x00D1, 0x00AA, 0x00BA, 0x00BF, 0x2310, 0x00AC, 0x00BD, 0x00BC, 0x00A1, 0x00AB, 0x00BB,
    0x2591, 0x2592, 0x2593, 0x2502, 0x2524, 0x2561, 0x2562, 0x2556, 0x2555, 0x2563, 0x2551,
    0x2557, 0x255D, 0x255C, 0x255B, 0x2510, 0x2514, 0x2534, 0x252C, 0x251C, 0x2500, 0x253C,
    0x255E, 0x255F, 0x255A, 0x2554, 0x2569, 0x2566, 0x2560, 0x2550, 0x256C, 0x2567, 0x2568,
    0x2564, 0x2565, 0x2559, 0x2558, 0x2552, 0x2553, 0x256B, 0x256A, 0x2518, 0x250C, 0x2588,
    0x2584, 0x258C, 0x2590, 0x2580, 0x03B1, 0x00DF, 0x0393, 0x03C0, 0x03A3, 0x03C3, 0x00B5,
    0x03C4, 0x03A6, 0x0398, 0x03A9, 0x03B4, 0x221E, 0x03C6, 0x03B5, 0x2229, 0x2261, 0x00B1,
    0x2265, 0x2264, 0x2320, 0x2321, 0x00F7, 0x2248, 0x00B0, 0x2219, 0x00B7, 0x221A, 0x207F,
    0x00B2, 0x25A0, 0x00A0
  ]

  var convertedBuffer = new Array(buffer.length)
  var len = convertedBuffer.length
  var i
  for (i = 0; i < len; i++) {
    convertedBuffer[i] = table[buffer[i]]
  }

  var MAX_CHUNK_SIZE = 32767
  var str = ''
  for (i = 0; i < len; i += MAX_CHUNK_SIZE) {
    str += String.fromCharCode.apply(null, convertedBuffer.slice(i, i + MAX_CHUNK_SIZE))
  }
  return str
}


/***/ }),

/***/ 51450:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(30816)["Buffer"];


var crc32 = __webpack_require__(47857)
var createInflateRaw = (__webpack_require__(43499).createInflateRaw)
var Transform = (__webpack_require__(18359).Transform)
var Utils = __webpack_require__(77198)
var E = Utils.E
var readUInt64LE = Utils.readUInt64LE
var cp437ToUnicode = Utils.cp437ToUnicode

module.exports = ZipFile

function ZipFile (reader, eocdr) {
  this.entries = []
  this.entryCount = eocdr.entryCount
  this.comment = eocdr.comment
  this._cdSize = eocdr.cdSize
  this._cdOffset = eocdr.cdOffset
  this._reader = reader
}

ZipFile.prototype.readEntries = function (callback) {
  var fixedFieldsSize = 46
  var self = this

  callback = (function (fn) {
    var called = false
    return function (err, entries) {
      if (called) return
      called = true
      fn(err, entries)
    }
  })(callback)

  var readStream = this._reader.createReadStream({
    start: this._cdOffset,
    end: (this._cdOffset + this._cdSize)
  })
  readStream.on('error', callback)
  readStream.on('end', function () {
    callback(
      self.entries.length === self.entryCount
        ? null
        : E('expected {0} entries got {1}', self.entryCount, self.entries.length),
      self.entries
    )
  })
  readStream.on('readable', onReadable)

  function destroyAndDrain (error) {
    readStream.destroy(error)
    readStream.read()
  }

  function onReadable () {
    while (this.readableLength > 0) {
      if (this.readableLength < fixedFieldsSize) {
        if (this.ended) {
          return destroyAndDrain(
            E('expected at least 46 bytes for Central File Header got {0}', this.readableLength)
          )
        }
        break
      }
      var fixedFieldsBuffer = this.read(fixedFieldsSize)
      var entry = new Entry()

      // central file header signature   4 bytes  (0x02014b50)
      if (fixedFieldsBuffer.readUInt32LE(0) !== 0x02014b50) {
        return destroyAndDrain(E('invalide Central File Header signature'))
      }
      // version made by                 2 bytes
      entry.versionMadeBy = fixedFieldsBuffer.readUInt16LE(4)
      // version needed to extract       2 bytes
      entry.versionNeededToExtract = fixedFieldsBuffer.readUInt16LE(6)
      // general purpose bit flag        2 bytes
      entry.generalPurposeBitFlag = fixedFieldsBuffer.readUInt16LE(8)
      // compression method              2 bytes
      entry.compressionMethod = fixedFieldsBuffer.readUInt16LE(10)
      // last mod file time              2 bytes
      entry.lastModTime = fixedFieldsBuffer.readUInt16LE(12)
      // last mod file date              2 bytes
      entry.lastModDate = fixedFieldsBuffer.readUInt16LE(14)
      // crc-32                          4 bytes
      entry.crc32 = fixedFieldsBuffer.readUInt32LE(16)
      // compressed size                 4 bytes
      entry.compressedSize = fixedFieldsBuffer.readUInt32LE(20)
      // uncompressed size               4 bytes
      entry.uncompressedSize = fixedFieldsBuffer.readUInt32LE(24)
      // file name length                2 bytes
      var nameLength = fixedFieldsBuffer.readUInt16LE(28)
      // extra field length              2 bytes
      var extraFieldsLength = fixedFieldsBuffer.readUInt16LE(30)
      // file comment length             2 bytes
      var commentLength = fixedFieldsBuffer.readUInt16LE(32)
      // disk number start               2 bytes
      // internal file attributes        2 bytes
      entry.internalAttributes = fixedFieldsBuffer.readUInt16LE(36)
      // external file attributes        4 bytes
      entry.externalAttributes = fixedFieldsBuffer.readUInt32LE(38)
      // relative offset of local header 4 bytes
      entry.localHeaderOffset = fixedFieldsBuffer.readUInt32LE(42)

      var variableFieldsSize = nameLength + extraFieldsLength + commentLength
      if (this.readableLength < variableFieldsSize) {
        if (this.ended) {
          return destroyAndDrain(
            E(
              'expected at least {0} bytes for variable fields in Central File Header got {1}',
              variableFieldsSize,
              this.readableLength
            )
          )
        }
        this.unshift(fixedFieldsBuffer)
        break
      }
      var variableFieldsBuffer = this.read(variableFieldsSize)

      // file name (variable size)
      entry.name = variableFieldsBuffer.slice(0, nameLength)
      // extra field (variable size)
      var extraFieldsBuffer = variableFieldsBuffer.slice(
        nameLength,
        nameLength + extraFieldsLength
      )
      for (var i = 0, len = extraFieldsBuffer.length - 3; i < len;) {
        var headerId = extraFieldsBuffer.readUInt16LE(i)
        var dataSize = extraFieldsBuffer.readUInt16LE(i += 2)
        var data = Buffer.from(extraFieldsBuffer.slice(i += 2, i += dataSize))
        entry.extraFields.push({ headerId: headerId, dataSize: dataSize, data: data })
      }
      // comment (variable size)
      entry.comment = variableFieldsBuffer.slice(nameLength + extraFieldsLength)

      // handle encoding
      var isUTF8 = (entry.generalPurposeBitFlag & 0x800) === 0x800
      if (isUTF8) {
        entry.name = entry.name.toString()
        entry.comment = entry.comment.toString()
      } else {
        entry.name = cp437ToUnicode(entry.name)
        entry.comment = cp437ToUnicode(entry.comment)
      }
      // Info-ZIP Unicode Path/Comment Extra Field
      ;['name', 'comment'].forEach(function (field) {
        var headerId
        var oldData
        if (field === 'name') {
          headerId = 0x7075
          oldData = variableFieldsBuffer.slice(0, nameLength)
        } else {
          headerId = 0x6375
          oldData = variableFieldsBuffer.slice(nameLength + extraFieldsLength)
        }
        var infoZipUEFs = entry.extraFields.filter(function (ef) {
          return ef.headerId === headerId
        })

        infoZipUEFs.forEach(function (infoZipUEF) {
          var data = infoZipUEF.data
          if (data.length > 6) {
            var versionRecognized = data.readUInt8(0) === 1
            var crcCheckPassed = crc32.unsigned(oldData) === data.readUInt32LE(1)
            var str = data.toString('utf8', 5)
            if (versionRecognized && crcCheckPassed && str.length > 0) entry[field] = str
          }
        })
      })

      // handle zip64 format
      if (
        entry.compressedSize === 0xffffffff ||
        entry.uncompressedSize === 0xffffffff ||
        entry.localHeaderOffset === 0xffffffff
      ) {
        var zip64EIEF = entry.extraFields.filter(function (ef) {
          return ef.headerId === 0x0001
        })[0]
        if (zip64EIEF) {
          var offset = 0
          var fields = ['uncompressedSize', 'compressedSize', 'localHeaderOffset']
          for (var j in fields) {
            var field = fields[j]
            if (entry[field] === 0xffffffff) {
              try {
                entry[field] = readUInt64LE(zip64EIEF.data, offset)
                offset += 8
              } catch (err) {
                return destroyAndDrain(
                  E('invalid Zip64 Extended Information Extra Field: {0} not found', field)
                )
              }
            }
          }
        } else {
          return destroyAndDrain(E('Zip64 Extended Information Extra Field not found'))
        }
      }

      self.entries.push(entry)
    }
    this.read(0)
  }
}

ZipFile.prototype.readEntryData = function (entry, checkCrc, callback) {
  if (entry.encrypted) {
    callback(E('encrypted files are not supported'))
    return
  }
  if (entry.compressionMethod !== 0 && entry.compressionMethod !== 8) {
    callback(E('compression method is not supported'))
    return
  }

  var fixedFieldsSize = 30
  var self = this
  this._reader.read(
    entry.localHeaderOffset,
    entry.localHeaderOffset + fixedFieldsSize,
    function (err, buf) {
      if (err) return callback(err)

      if (buf.length < fixedFieldsSize) {
        return callback(
          E('expected at least 30 bytes for Local File Header got {1}', buf.length)
        )
      }

      // local file header signature     4 bytes  (0x04034b50)
      if (buf.readUInt32LE(0) !== 0x04034b50) {
        return callback(E('invalid Local File Header signature'))
      }
      // version needed to extract       2 bytes
      // general purpose bit flag        2 bytes
      // compression method              2 bytes
      // last mod file time              2 bytes
      // last mod file date              2 bytes
      // crc-32                          4 bytes
      // compressed size                 4 bytes
      // uncompressed size               4 bytes
      // file name length                2 bytes
      var nameLength = buf.readUInt16LE(26)
      // extra field length              2 bytes
      var extraFieldLength = buf.readUInt16LE(28)

      var dataStart = entry.localHeaderOffset + fixedFieldsSize + nameLength + extraFieldLength
      var readStream = self._reader.createReadStream({
        start: dataStart,
        end: dataStart + entry.compressedSize
      })

      var outStream = readStream

      if (entry.compressionMethod === 8) {
        var inflate = createInflateRaw()
        outStream = outStream
          .on('error', function (err) { inflate.destroy(err) })
          .pipe(inflate)
      }

      if (checkCrc) {
        var partialCrc
        var crcTransform = new Transform({
          transform: function (chunk, encoding, callback) {
            partialCrc = crc32(chunk, partialCrc)
            callback(null, chunk)
          },
          flush: function (callback) {
            var finalCrc = partialCrc.readUInt32BE(0)
            callback(finalCrc === entry.crc32 ? null : E('corrupted file: crc check fails'))
          }
        })
        outStream = outStream
          .on('error', function (err) { crcTransform.destroy(err) })
          .pipe(crcTransform)
      }

      callback(null, outStream)
    }
  )
}

function Entry () {
  this.extraFields = []
}

Object.defineProperties(Entry.prototype, {
  encrypted: {
    get: function () { return (this.generalPurposeBitFlag & 0x0001) === 0x0001 }
  },
  lastModDateTime: {
    get: function () {
      return new Date(
        (this.lastModDate >> 9 & 0x7f) + 1980, // year
        (this.lastModDate >> 5 & 0xf) - 1, // month
        this.lastModDate & 0x1f, // day
        (this.lastModTime >> 11) & 0x1f, // hours
        (this.lastModTime >> 5) & 0x3f, // minutes
        (this.lastModTime & 0x1f) * 2 // seconds
      )
    }
  }
})


/***/ }),

/***/ 94047:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(27378);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 92693:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=__webpack_require__(27378),n=__webpack_require__(70644);function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
exports.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return[function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
u(function(){f.hasValue=!0;f.value=d},[d]);w(d);return d};


/***/ }),

/***/ 70644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(94047);
} else {}


/***/ }),

/***/ 60626:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(92693);
} else {}


/***/ }),

/***/ 56579:
/***/ (function(module) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ 7673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9



var isArgumentsObject = __webpack_require__(47740);
var isGeneratorFunction = __webpack_require__(18265);
var whichTypedArray = __webpack_require__(52505);
var isTypedArray = __webpack_require__(50387);

function uncurryThis(f) {
  return f.call.bind(f);
}

var BigIntSupported = typeof BigInt !== 'undefined';
var SymbolSupported = typeof Symbol !== 'undefined';

var ObjectToString = uncurryThis(Object.prototype.toString);

var numberValue = uncurryThis(Number.prototype.valueOf);
var stringValue = uncurryThis(String.prototype.valueOf);
var booleanValue = uncurryThis(Boolean.prototype.valueOf);

if (BigIntSupported) {
  var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
}

if (SymbolSupported) {
  var symbolValue = uncurryThis(Symbol.prototype.valueOf);
}

function checkBoxedPrimitive(value, prototypeValueOf) {
  if (typeof value !== 'object') {
    return false;
  }
  try {
    prototypeValueOf(value);
    return true;
  } catch(e) {
    return false;
  }
}

exports.isArgumentsObject = isArgumentsObject;
exports.isGeneratorFunction = isGeneratorFunction;
exports.isTypedArray = isTypedArray;

// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function isPromise(input) {
	return (
		(
			typeof Promise !== 'undefined' &&
			input instanceof Promise
		) ||
		(
			input !== null &&
			typeof input === 'object' &&
			typeof input.then === 'function' &&
			typeof input.catch === 'function'
		)
	);
}
exports.isPromise = isPromise;

function isArrayBufferView(value) {
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    return ArrayBuffer.isView(value);
  }

  return (
    isTypedArray(value) ||
    isDataView(value)
  );
}
exports.isArrayBufferView = isArrayBufferView;


function isUint8Array(value) {
  return whichTypedArray(value) === 'Uint8Array';
}
exports.isUint8Array = isUint8Array;

function isUint8ClampedArray(value) {
  return whichTypedArray(value) === 'Uint8ClampedArray';
}
exports.isUint8ClampedArray = isUint8ClampedArray;

function isUint16Array(value) {
  return whichTypedArray(value) === 'Uint16Array';
}
exports.isUint16Array = isUint16Array;

function isUint32Array(value) {
  return whichTypedArray(value) === 'Uint32Array';
}
exports.isUint32Array = isUint32Array;

function isInt8Array(value) {
  return whichTypedArray(value) === 'Int8Array';
}
exports.isInt8Array = isInt8Array;

function isInt16Array(value) {
  return whichTypedArray(value) === 'Int16Array';
}
exports.isInt16Array = isInt16Array;

function isInt32Array(value) {
  return whichTypedArray(value) === 'Int32Array';
}
exports.isInt32Array = isInt32Array;

function isFloat32Array(value) {
  return whichTypedArray(value) === 'Float32Array';
}
exports.isFloat32Array = isFloat32Array;

function isFloat64Array(value) {
  return whichTypedArray(value) === 'Float64Array';
}
exports.isFloat64Array = isFloat64Array;

function isBigInt64Array(value) {
  return whichTypedArray(value) === 'BigInt64Array';
}
exports.isBigInt64Array = isBigInt64Array;

function isBigUint64Array(value) {
  return whichTypedArray(value) === 'BigUint64Array';
}
exports.isBigUint64Array = isBigUint64Array;

function isMapToString(value) {
  return ObjectToString(value) === '[object Map]';
}
isMapToString.working = (
  typeof Map !== 'undefined' &&
  isMapToString(new Map())
);

function isMap(value) {
  if (typeof Map === 'undefined') {
    return false;
  }

  return isMapToString.working
    ? isMapToString(value)
    : value instanceof Map;
}
exports.isMap = isMap;

function isSetToString(value) {
  return ObjectToString(value) === '[object Set]';
}
isSetToString.working = (
  typeof Set !== 'undefined' &&
  isSetToString(new Set())
);
function isSet(value) {
  if (typeof Set === 'undefined') {
    return false;
  }

  return isSetToString.working
    ? isSetToString(value)
    : value instanceof Set;
}
exports.isSet = isSet;

function isWeakMapToString(value) {
  return ObjectToString(value) === '[object WeakMap]';
}
isWeakMapToString.working = (
  typeof WeakMap !== 'undefined' &&
  isWeakMapToString(new WeakMap())
);
function isWeakMap(value) {
  if (typeof WeakMap === 'undefined') {
    return false;
  }

  return isWeakMapToString.working
    ? isWeakMapToString(value)
    : value instanceof WeakMap;
}
exports.isWeakMap = isWeakMap;

function isWeakSetToString(value) {
  return ObjectToString(value) === '[object WeakSet]';
}
isWeakSetToString.working = (
  typeof WeakSet !== 'undefined' &&
  isWeakSetToString(new WeakSet())
);
function isWeakSet(value) {
  return isWeakSetToString(value);
}
exports.isWeakSet = isWeakSet;

function isArrayBufferToString(value) {
  return ObjectToString(value) === '[object ArrayBuffer]';
}
isArrayBufferToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  isArrayBufferToString(new ArrayBuffer())
);
function isArrayBuffer(value) {
  if (typeof ArrayBuffer === 'undefined') {
    return false;
  }

  return isArrayBufferToString.working
    ? isArrayBufferToString(value)
    : value instanceof ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;

function isDataViewToString(value) {
  return ObjectToString(value) === '[object DataView]';
}
isDataViewToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  typeof DataView !== 'undefined' &&
  isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1))
);
function isDataView(value) {
  if (typeof DataView === 'undefined') {
    return false;
  }

  return isDataViewToString.working
    ? isDataViewToString(value)
    : value instanceof DataView;
}
exports.isDataView = isDataView;

// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function isSharedArrayBufferToString(value) {
  return ObjectToString(value) === '[object SharedArrayBuffer]';
}
function isSharedArrayBuffer(value) {
  if (typeof SharedArrayBufferCopy === 'undefined') {
    return false;
  }

  if (typeof isSharedArrayBufferToString.working === 'undefined') {
    isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
  }

  return isSharedArrayBufferToString.working
    ? isSharedArrayBufferToString(value)
    : value instanceof SharedArrayBufferCopy;
}
exports.isSharedArrayBuffer = isSharedArrayBuffer;

function isAsyncFunction(value) {
  return ObjectToString(value) === '[object AsyncFunction]';
}
exports.isAsyncFunction = isAsyncFunction;

function isMapIterator(value) {
  return ObjectToString(value) === '[object Map Iterator]';
}
exports.isMapIterator = isMapIterator;

function isSetIterator(value) {
  return ObjectToString(value) === '[object Set Iterator]';
}
exports.isSetIterator = isSetIterator;

function isGeneratorObject(value) {
  return ObjectToString(value) === '[object Generator]';
}
exports.isGeneratorObject = isGeneratorObject;

function isWebAssemblyCompiledModule(value) {
  return ObjectToString(value) === '[object WebAssembly.Module]';
}
exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;

function isNumberObject(value) {
  return checkBoxedPrimitive(value, numberValue);
}
exports.isNumberObject = isNumberObject;

function isStringObject(value) {
  return checkBoxedPrimitive(value, stringValue);
}
exports.isStringObject = isStringObject;

function isBooleanObject(value) {
  return checkBoxedPrimitive(value, booleanValue);
}
exports.isBooleanObject = isBooleanObject;

function isBigIntObject(value) {
  return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
}
exports.isBigIntObject = isBigIntObject;

function isSymbolObject(value) {
  return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
}
exports.isSymbolObject = isSymbolObject;

function isBoxedPrimitive(value) {
  return (
    isNumberObject(value) ||
    isStringObject(value) ||
    isBooleanObject(value) ||
    isBigIntObject(value) ||
    isSymbolObject(value)
  );
}
exports.isBoxedPrimitive = isBoxedPrimitive;

function isAnyArrayBuffer(value) {
  return typeof Uint8Array !== 'undefined' && (
    isArrayBuffer(value) ||
    isSharedArrayBuffer(value)
  );
}
exports.isAnyArrayBuffer = isAnyArrayBuffer;

['isProxy', 'isExternal', 'isModuleNamespaceObject'].forEach(function(method) {
  Object.defineProperty(exports, method, {
    enumerable: false,
    value: function() {
      throw new Error(method + ' is not supported in userland');
    }
  });
});


/***/ }),

/***/ 71323:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(27061);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnvRegex = /^$/;

if (process.env.NODE_DEBUG) {
  var debugEnv = process.env.NODE_DEBUG;
  debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
    .replace(/\*/g, '.*')
    .replace(/,/g, '$|^')
    .toUpperCase();
  debugEnvRegex = new RegExp('^' + debugEnv + '$', 'i');
}
exports.debuglog = function(set) {
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (debugEnvRegex.test(set)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').slice(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.slice(1, -1);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
exports.types = __webpack_require__(7673);

function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
exports.types.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;
exports.types.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;
exports.types.isNativeError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(56579);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(70087);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb.bind(null, null, ret)) },
            function(rej) { process.nextTick(callbackifyOnRejected.bind(null, rej, cb)) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;


/***/ }),

/***/ 13596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ../node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ../node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ../node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ../node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ../node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ }),

/***/ 38574:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isString = __webpack_require__(38559);
var isNumber = __webpack_require__(37691);
var isBoolean = __webpack_require__(80240);
var isSymbol = __webpack_require__(83448);
var isBigInt = __webpack_require__(17810);

// eslint-disable-next-line consistent-return
module.exports = function whichBoxedPrimitive(value) {
	// eslint-disable-next-line eqeqeq
	if (value == null || (typeof value !== 'object' && typeof value !== 'function')) {
		return null;
	}
	if (isString(value)) {
		return 'String';
	}
	if (isNumber(value)) {
		return 'Number';
	}
	if (isBoolean(value)) {
		return 'Boolean';
	}
	if (isSymbol(value)) {
		return 'Symbol';
	}
	if (isBigInt(value)) {
		return 'BigInt';
	}
};


/***/ }),

/***/ 52505:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var forEach = __webpack_require__(55278);
var availableTypedArrays = __webpack_require__(40973);
var callBound = __webpack_require__(12737);
var gOPD = __webpack_require__(77502);

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__(10698)();

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound('String.prototype.slice');
var toStrTags = {};
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		if (typeof g[typedArray] === 'function') {
			var arr = new g[typedArray]();
			if (Symbol.toStringTag in arr) {
				var proto = getPrototypeOf(arr);
				var descriptor = gOPD(proto, Symbol.toStringTag);
				if (!descriptor) {
					var superProto = getPrototypeOf(proto);
					descriptor = gOPD(superProto, Symbol.toStringTag);
				}
				toStrTags[typedArray] = descriptor.get;
			}
		}
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var foundName = false;
	forEach(toStrTags, function (getter, typedArray) {
		if (!foundName) {
			try {
				var name = getter.call(value);
				if (name === typedArray) {
					foundName = name;
				}
			} catch (e) {}
		}
	});
	return foundName;
};

var isTypedArray = __webpack_require__(50387);

module.exports = function whichTypedArray(value) {
	if (!isTypedArray(value)) { return false; }
	if (!hasToStringTag || !(Symbol.toStringTag in value)) { return $slice($toString(value), 8, -1); }
	return tryTypedArrays(value);
};


/***/ }),

/***/ 96553:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 40973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var possibleNames = [
	'BigInt64Array',
	'BigUint64Array',
	'Float32Array',
	'Float64Array',
	'Int16Array',
	'Int32Array',
	'Int8Array',
	'Uint16Array',
	'Uint32Array',
	'Uint8Array',
	'Uint8ClampedArray'
];

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;

module.exports = function availableTypedArrays() {
	var out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g[possibleNames[i]] === 'function') {
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};


/***/ }),

/***/ 22395:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(27061);


/* eslint global-require: 0 */
// the code is structured this way so that bundlers can
// alias out `has-symbols` to `() => true` or `() => false` if your target
// environments' Symbol capabilities are known, and then use
// dead code elimination on the rest of this module.
//
// Similarly, `isarray` can be aliased to `Array.isArray` if
// available in all target environments.

var isArguments = __webpack_require__(47740);
var getStopIterationIterator = __webpack_require__(46236);

if (__webpack_require__(40679)() || __webpack_require__(8186)()) {
	var $iterator = Symbol.iterator;
	// Symbol is available natively or shammed
	// natively:
	//  - Chrome >= 38
	//  - Edge 12-14?, Edge >= 15 for sure
	//  - FF >= 36
	//  - Safari >= 9
	//  - node >= 0.12
	module.exports = function getIterator(iterable) {
		// alternatively, `iterable[$iterator]?.()`
		if (iterable != null && typeof iterable[$iterator] !== 'undefined') {
			return iterable[$iterator]();
		}
		if (isArguments(iterable)) {
			// arguments objects lack Symbol.iterator
			// - node 0.12
			return Array.prototype[$iterator].call(iterable);
		}
	};
} else {
	// Symbol is not available, native or shammed
	var isArray = __webpack_require__(55182);
	var isString = __webpack_require__(38559);
	var GetIntrinsic = __webpack_require__(68750);
	var $Map = GetIntrinsic('%Map%', true);
	var $Set = GetIntrinsic('%Set%', true);
	var callBound = __webpack_require__(12737);
	var $arrayPush = callBound('Array.prototype.push');
	var $charCodeAt = callBound('String.prototype.charCodeAt');
	var $stringSlice = callBound('String.prototype.slice');

	var advanceStringIndex = function advanceStringIndex(S, index) {
		var length = S.length;
		if ((index + 1) >= length) {
			return index + 1;
		}

		var first = $charCodeAt(S, index);
		if (first < 0xD800 || first > 0xDBFF) {
			return index + 1;
		}

		var second = $charCodeAt(S, index + 1);
		if (second < 0xDC00 || second > 0xDFFF) {
			return index + 1;
		}

		return index + 2;
	};

	var getArrayIterator = function getArrayIterator(arraylike) {
		var i = 0;
		return {
			next: function next() {
				var done = i >= arraylike.length;
				var value;
				if (!done) {
					value = arraylike[i];
					i += 1;
				}
				return {
					done: done,
					value: value
				};
			}
		};
	};

	var getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
		if (isArray(iterable) || isArguments(iterable)) {
			return getArrayIterator(iterable);
		}
		if (isString(iterable)) {
			var i = 0;
			return {
				next: function next() {
					var nextIndex = advanceStringIndex(iterable, i);
					var value = $stringSlice(iterable, i, nextIndex);
					i = nextIndex;
					return {
						done: nextIndex > iterable.length,
						value: value
					};
				}
			};
		}

		// es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
		if (noPrimordialCollections && typeof iterable['_es6-shim iterator_'] !== 'undefined') {
			return iterable['_es6-shim iterator_']();
		}
	};

	if (!$Map && !$Set) {
		// the only language iterables are Array, String, arguments
		// - Safari <= 6.0
		// - Chrome < 38
		// - node < 0.12
		// - FF < 13
		// - IE < 11
		// - Edge < 11

		module.exports = function getIterator(iterable) {
			if (iterable != null) {
				return getNonCollectionIterator(iterable, true);
			}
		};
	} else {
		// either Map or Set are available, but Symbol is not
		// - es6-shim on an ES5 browser
		// - Safari 6.2 (maybe 6.1?)
		// - FF v[13, 36)
		// - IE 11
		// - Edge 11
		// - Safari v[6, 9)

		var isMap = __webpack_require__(6966);
		var isSet = __webpack_require__(4255);

		// Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
		var $mapForEach = callBound('Map.prototype.forEach', true);
		var $setForEach = callBound('Set.prototype.forEach', true);
		if (typeof process === 'undefined' || !process.versions || !process.versions.node) { // "if is not node"

			// Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
			// returns a value, or throws a StopIteration object. These browsers
			// do not have any other mechanism for iteration.
			var $mapIterator = callBound('Map.prototype.iterator', true);
			var $setIterator = callBound('Set.prototype.iterator', true);
		}
		// Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
		// this returns a proper iterator object, so we should use it instead of forEach.
		// newer es6-shim versions use a string "_es6-shim iterator_" property.
		var $mapAtAtIterator = callBound('Map.prototype.@@iterator', true) || callBound('Map.prototype._es6-shim iterator_', true);
		var $setAtAtIterator = callBound('Set.prototype.@@iterator', true) || callBound('Set.prototype._es6-shim iterator_', true);

		var getCollectionIterator = function getCollectionIterator(iterable) {
			if (isMap(iterable)) {
				if ($mapIterator) {
					return getStopIterationIterator($mapIterator(iterable));
				}
				if ($mapAtAtIterator) {
					return $mapAtAtIterator(iterable);
				}
				if ($mapForEach) {
					var entries = [];
					$mapForEach(iterable, function (v, k) {
						$arrayPush(entries, [k, v]);
					});
					return getArrayIterator(entries);
				}
			}
			if (isSet(iterable)) {
				if ($setIterator) {
					return getStopIterationIterator($setIterator(iterable));
				}
				if ($setAtAtIterator) {
					return $setAtAtIterator(iterable);
				}
				if ($setForEach) {
					var values = [];
					$setForEach(iterable, function (v) {
						$arrayPush(values, v);
					});
					return getArrayIterator(values);
				}
			}
		};

		module.exports = function getIterator(iterable) {
			return getCollectionIterator(iterable) || getNonCollectionIterator(iterable);
		};
	}
}


/***/ }),

/***/ 13062:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isMap = __webpack_require__(6966);
var isSet = __webpack_require__(4255);
var isWeakMap = __webpack_require__(80349);
var isWeakSet = __webpack_require__(7812);

module.exports = function whichCollection(value) {
	if (value && typeof value === 'object') {
		if (isMap(value)) {
			return 'Map';
		}
		if (isSet(value)) {
			return 'Set';
		}
		if (isWeakMap(value)) {
			return 'WeakMap';
		}
		if (isWeakSet(value)) {
			return 'WeakSet';
		}
	}
	return false;
};


/***/ }),

/***/ 1793:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),

/***/ 66470:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ 22951:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 91976:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1607);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 64649:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1607);

function _defineProperty(obj, key, value) {
  key = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),

/***/ 25773:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 53764:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ 30808:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ 8136:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(66470);
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(64013);
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(53764);
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return (0,arrayWithHoles/* default */.Z)(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || (0,nonIterableRest/* default */.Z)();
}

/***/ }),

/***/ 1607:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toPropertyKey; }
});

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(33940);
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if ((0,esm_typeof/* default */.Z)(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if ((0,esm_typeof/* default */.Z)(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return (0,esm_typeof/* default */.Z)(key) === "symbol" ? key : String(key);
}

/***/ }),

/***/ 33940:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ 64013:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1793);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 4147:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"egw","version":"1.3.436","private":true,"dependencies":{"@sentry/browser":"file:../node_modules/@sentry/browser","@sentry/nextjs":"file:../node_modules/@sentry/nextjs","axios":"file:../node_modules/axios","classnames":"file:../node_modules/classnames","cors":"file:../node_modules/cors","dayjs":"file:../node_modules/dayjs","deep-equal":"file:../node_modules/deep-equal","enzyme":"file:../node_modules/enzyme","eslint":"file:../node_modules/eslint","html-entities":"file:../node_modules/html-entities","i18next":"file:../node_modules/i18next","i18next-browser-languagedetector":"file:../node_modules/i18next-browser-languagedetector","i18next-http-backend":"file:../node_modules/i18next-http-backend","jest-next-dynamic":"file:../node_modules/jest-next-dynamic","js-cookie":"file:../node_modules/js-cookie","md5":"file:../node_modules/md5","next":"file:../node_modules/next","next-i18next":"file:../node_modules/next-i18next","next-redux-wrapper":"file:../node_modules/next-redux-wrapper","oidc-client":"file:../node_modules/oidc-client","postcss":"file:../node_modules/postcss","prop-types":"file:../node_modules/prop-types","sass":"file:../node_modules/sass","rangy":"file:../node_modules/rangy","react":"file:../node_modules/react","react-cookie":"file:../node_modules/react-cookie","react-device-detect":"file:../node_modules/react-device-detect","react-dom":"file:../node_modules/react-dom","react-qr-code":"file:../node_modules/react-qr-code","react-redux":"file:../node_modules/react-redux","react-resize-detector":"file:../node_modules/react-resize-detector","react-router-dom":"file:../node_modules/react-router-dom","react-scripts":"file:../node_modules/react-scripts","react-swipeable":"file:../node_modules/react-swipeable","react-twitter-embed":"file:../node_modules/react-twitter-embed","redux":"file:../node_modules/redux","redux-devtools-extension":"file:../node_modules/redux-devtools-extension","redux-mock-store":"file:../node_modules/redux-mock-store","redux-saga":"file:../node_modules/redux-saga","reselect":"file:../node_modules/reselect","uuid":"file:../node_modules/uuid","buffer":"file:../node_modules/buffer","buffer-crc32":"file:../node_modules/buffer-crc32","unzip-js":"file:../node_modules/unzip-js","browserify-zlib":"file:../node_modules/browserify-zlib","stream-browserify":"file:../node_modules/stream-browserify","emitter":"file:../node_modules/emitter","process":"file:../node_modules/process","readable-stream":"file:../node_modules/readable-stream","urql":"file:../node_modules/urql","graphql":"file:../node_modules/graphql","react-speech-recognition":"file:../node_modules/react-speech-recognition","regenerator-runtime":"file:../node_modules/regenerator-runtime"},"scripts":{"sayHello":"echo \\"Hello!\\"","start":"next start -p 8080","dev":"next dev -p 8080","build":"next build","linter":"eslint src","linter:errors":"eslint src --quiet","landing":"REACT_APP_IS_LANDING=true npm run build && npm run start"},"browserslist":{"production":[">0.2%","not dead","not op_mini all","ie 11","safari > 5"],"development":["last 1 chrome version","last 1 firefox version","last 1 safari version","ie 11","safari > 5"]},"jest":{"collectCoverageFrom":["src/**/*.{js,jsx,ts,tsx}","!<rootDir>/node_modules/","!src/**/*{actions.js,constants.js}"],"moduleNameMapper":{"src(.*)$":"<rootDir>/src$1","\\\\.(css|less|scss|sass)$":"identity-obj-proxy","\\\\.(jpg|jpeg|png|gif|eot|otf|webp|svg|ttf|woff|woff2|mp4|webm|wav|mp3|m4a|aac|oga)$":"<rootDir>/src/mocks/fileMock.js","^@/components(.*)$":"<rootDir>/src/next/components$1","^@/styles(.*)$":"<rootDir>/src/next/styles$1","^@/hooks(.*)$":"<rootDir>/src/next/hooks$1","^@/views(.*)$":"<rootDir>/src/next/views$1","^@/store(.*)$":"<rootDir>/src/next/store$1","^@/contexts(.*)$":"<rootDir>/src/next/contexts$1"},"coverageThreshold":{"global":{"branches":90,"functions":90,"lines":90,"statements":90}},"coverageReporters":["html"],"snapshotSerializers":["enzyme-to-json/serializer"]},"devDependencies":{"@babel/cli":"file:../node_modules/@babel/cli","@babel/core":"file:../node_modules/@babel/core","@babel/eslint-parser":"file:../node_modules/@babel/eslint-parser","@babel/plugin-proposal-class-properties":"file:../node_modules/@babel/plugin-proposal-class-properties","@babel/plugin-proposal-object-rest-spread":"file:../node_modules/@babel/plugin-proposal-object-rest-spread","@babel/plugin-proposal-optional-chaining":"file:../node_modules/@babel/plugin-proposal-optional-chaining","@babel/plugin-transform-arrow-functions":"file:../node_modules/@babel/plugin-transform-arrow-functions","@babel/plugin-transform-runtime":"file:../node_modules/@babel/plugin-transform-runtime","@babel/preset-env":"file:../node_modules/@babel/preset-env","@babel/preset-react":"file:../node_modules/@babel/preset-react","@babel/register":"file:../node_modules/@babel/register","@cfaester/enzyme-adapter-react-18":"file:../node_modules/@cfaester/enzyme-adapter-react-18","enzyme-to-json":"file:../node_modules/enzyme-to-json","identity-obj-proxy":"file:../node_modules/identity-obj-proxy","jest-canvas-mock":"file:../node_modules/jest-canvas-mock","prettier":"file:../node_modules/prettier","sass-loader":"file:../node_modules/sass-loader"},"optionalDependencies":{"@next/bundle-analyzer":"file:../node_modules/@next/bundle-analyzer","@redux-devtools/core":"file:../node_modules/@redux-devtools/core"},"_moduleAliases":{}}');

/***/ }),

/***/ 59798:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"egw","version":"1.3.436","private":true,"dependencies":{"lit-element":"file:../node_modules/lit-element","lit-translate":"file:../node_modules/lit-translate","pell":"file:../node_modules/pell","lit":"file:../node_modules/lit","@sentry/browser":"file:../node_modules/@sentry/browser","axios":"file:../node_modules/axios","classnames":"file:../node_modules/classnames","cookie-parser":"file:../node_modules/cookie-parser","core-js":"file:../node_modules/core-js","dayjs":"file:../node_modules/dayjs","deep-equal":"file:../node_modules/deep-equal","dom-css":"file:../node_modules/dom-css","dotenv":"file:../node_modules/dotenv","enzyme":"file:../node_modules/enzyme","eslint":"file:../node_modules/eslint","esm":"file:../node_modules/esm","express":"file:../node_modules/express","express-prom-bundle":"file:../node_modules/express-prom-bundle","prom-client":"file:../node_modules/prom-client","html-entities":"file:../node_modules/html-entities","i18next":"file:../node_modules/i18next","i18next-browser-languagedetector":"file:../node_modules/i18next-browser-languagedetector","i18next-http-backend":"file:../node_modules/i18next-http-backend","jest-next-dynamic":"file:../node_modules/jest-next-dynamic","js-cookie":"file:../node_modules/js-cookie","md5":"file:../node_modules/md5","module-alias":"file:../node_modules/module-alias","morgan":"file:../node_modules/morgan","oidc-client":"file:../node_modules/oidc-client","pdfjs-dist":"file:../node_modules/pdfjs-dist","postcss":"file:../node_modules/postcss","print-js":"file:../node_modules/print-js","prop-types":"file:../node_modules/prop-types","sass":"file:../node_modules/sass","rangy":"file:../node_modules/rangy","react":"file:../node_modules/react","react-app-polyfill":"file:../node_modules/react-app-polyfill","react-app-rewire-alias":"file:../node_modules/react-app-rewire-alias","react-color":"file:../node_modules/react-color","react-cookie":"file:../node_modules/react-cookie","react-device-detect":"file:../node_modules/react-device-detect","react-dom":"file:../node_modules/react-dom","react-helmet":"file:../node_modules/react-helmet","react-i18next":"file:../node_modules/react-i18next","react-lifecycles-compat":"file:../node_modules/react-lifecycles-compat","react-reader":"file:../node_modules/react-reader","react-redux":"file:../node_modules/react-redux","react-resize-detector":"file:../node_modules/react-resize-detector","react-router-dom":"file:../node_modules/react-router-dom","react-scripts":"file:../node_modules/react-scripts","react-style-proptype":"file:../node_modules/react-style-proptype","react-swipeable":"file:../node_modules/react-swipeable","react-twitter-embed":"file:../node_modules/react-twitter-embed","rebound":"file:../node_modules/rebound","redux":"file:../node_modules/redux","redux-devtools-extension":"file:../node_modules/redux-devtools-extension","redux-mock-store":"file:../node_modules/redux-mock-store","redux-saga":"file:../node_modules/redux-saga","reselect":"file:../node_modules/reselect","url":"file:../node_modules/url","assert":"file:../node_modules/assert","util":"file:../node_modules/util","uuid":"file:../node_modules/uuid","web-vitals":"file:../node_modules/web-vitals","buffer":"file:../node_modules/buffer","buffer-crc32":"file:../node_modules/buffer-crc32","unzip-js":"file:../node_modules/unzip-js","browserify-zlib":"file:../node_modules/browserify-zlib","stream-browserify":"file:../node_modules/stream-browserify","emitter":"file:../node_modules/emitter","process":"file:../node_modules/process","readable-stream":"file:../node_modules/readable-stream"},"_moduleAliases":{"@/shared":"../shared","axios":"./node_modules/axios"},"scripts":{"sayHello":"echo \\"Hello!\\"","dev":"react-app-rewired start","build":"GENERATE_SOURCEMAP=false react-app-rewired build","eject":"react-app-rewired eject","test":"TZ=UTC react-scripts test","test:sel":"jest ./selenium/test/*.test.js --testTimeout=10000000 --setupFiles dotenv/config","test:debug":"react-scripts --inspect-brk test --runInBand --no-cache","coverage":"TZ=UTC react-scripts test --coverage --watchAll=false","linter":"eslint src","linter:errors":"eslint src --quiet","start":"PORT=8080 node -r dotenv/config src/server/server.js","dev:server":"REACT_APP_BASE_HOST=http://localhost:8080 PORT=8080 MODE=dev nodemon --inspect -r dotenv/config src/server/server.js ","dev:reactappServer":"PORT=8080 MODE=dev nodemon --inspect -r dotenv/config src/server/server.js"},"browserslist":{"production":[">0.2%","not dead","not op_mini all","ie 11","safari > 5"],"development":["last 1 chrome version","last 1 firefox version","last 1 safari version","ie 11","safari > 5"]},"jest":{"collectCoverageFrom":["src/**/*.{js,jsx,ts,tsx}","!<rootDir>/node_modules/","!src/**/*{actions.js,constants.js}"],"moduleNameMapper":{"src(.*)$":"<rootDir>/src$1","\\\\.(css|less|scss|sass)$":"identity-obj-proxy","\\\\.(jpg|jpeg|png|gif|eot|otf|webp|svg|ttf|woff|woff2|mp4|webm|wav|mp3|m4a|aac|oga)$":"<rootDir>/src/mocks/fileMock.js","^@/components(.*)$":["<rootDir>/src/components$1"],"^@/styles(.*)$":["<rootDir>/src/styles$1"],"^@/assets(.*)$":["<rootDir>/src/assets$1"],"^@/utils(.*)$":["<rootDir>/src/utils$1"],"^@/hooks(.*)$":["<rootDir>/src/hooks$1"],"^@/redux(.*)$":["<rootDir>/src/redux$1"],"^@/pages(.*)$":["<rootDir>/src/pages$1"],"^@/shared(.*)$":["<rootDir>/../shared$1"]},"coverageThreshold":{"global":{"branches":90,"functions":90,"lines":90,"statements":90}},"coverageReporters":["html"],"snapshotSerializers":["enzyme-to-json/serializer"]},"devDependencies":{"@babel/cli":"file:../node_modules/@babel/cli","@babel/core":"file:../node_modules/@babel/core","@babel/eslint-parser":"file:../node_modules/@babel/eslint-parser","@babel/plugin-proposal-class-properties":"file:../node_modules/@babel/plugin-proposal-class-properties","@babel/plugin-proposal-object-rest-spread":"file:../node_modules/@babel/plugin-proposal-object-rest-spread","@babel/plugin-proposal-optional-chaining":"file:../node_modules/@babel/plugin-proposal-optional-chaining","@babel/plugin-transform-arrow-functions":"file:../node_modules/@babel/plugin-transform-arrow-functions","@babel/plugin-transform-runtime":"file:../node_modules/@babel/plugin-transform-runtime","@babel/preset-env":"file:../node_modules/@babel/preset-env","@babel/preset-react":"file:../node_modules/@babel/preset-react","@babel/register":"file:../node_modules/@babel/register","@cfaester/enzyme-adapter-react-18":"file:../node_modules/@cfaester/enzyme-adapter-react-18","enzyme-to-json":"file:../node_modules/enzyme-to-json","fantasticon":"file:../node_modules/fantasticon","identity-obj-proxy":"file:../node_modules/identity-obj-proxy","jest-canvas-mock":"file:../node_modules/jest-canvas-mock","module-alias":"file:../node_modules/module-alias","nodemon":"file:../node_modules/nodemon","eslint-config-prettier":"file:../node_modules/eslint-config-prettier","prettier":"file:../node_modules/prettier","react-app-rewired":"file:../node_modules/react-app-rewired","react-dev-utils":"file:../node_modules/react-dev-utils","sass-loader":"file:../node_modules/sass-loader"},"optionalDependencies":{"chromedriver":"file:../node_modules/chromedriver","selenium-webdriver":"file:../node_modules/selenium-webdriver","@types/react-router":"file:../node_modules/@types/react-router","@types/react-router-dom":"file:../node_modules/@types/react-router-dom","@redux-devtools/core":"file:../node_modules/@redux-devtools/core"}}');

/***/ }),

/***/ 72044:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"id":"en","key":"English"},{"id":"uk","key":"Ukrainian"},{"id":"ru","key":"Russian"},{"id":"pt","key":"Portuguese"},{"id":"zh","key":"Chinese"},{"id":"es","key":"Spanish"},{"id":"it","key":"Italian"},{"id":"de","key":"German"},{"id":"ar","key":"Arabic"},{"id":"ro","key":"Romanian"},{"id":"ko","key":"Korean"},{"id":"fr","key":"French"},{"id":"sw","key":"Swahili"},{"id":"pl","key":"Polish"},{"id":"ta","key":"Tagalog"},{"id":"af","key":"Afrikaans"},{"id":"sq","key":"Albanian"},{"id":"am","key":"Amharic"},{"id":"hy","key":"Armenian"},{"id":"az","key":"Azerbaijani"},{"id":"bn","key":"Bengali"},{"id":"bs","key":"Bosnian"},{"id":"bg","key":"Bulgarian"},{"id":"my","key":"Burmese"},{"id":"cat","key":"Catalan"},{"id":"hr","key":"Croatian"},{"id":"ces","key":"Czech"},{"id":"nl","key":"Dutch"},{"id":"et","key":"Estonian"},{"id":"fa","key":"Farsi (Persian)"},{"id":"fi","key":"Finnish"},{"id":"ka","key":"Georgian"},{"id":"el","key":"Greek"},{"id":"gu","key":"Gujrati"},{"id":"hi","key":"Hindi"},{"id":"hu","key":"Hungarian"},{"id":"in","key":"Indonesian"},{"id":"kn","key":"Kannada"},{"id":"mr","key":"Marathi"},{"id":"ml","key":"Malayalam"},{"id":"or","key":"Odia"},{"id":"sr","key":"Serbian"}]');

/***/ }),

/***/ 10808:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"LANG_CODE_EN":"en"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(33164), __webpack_exec__(8936), __webpack_exec__(77417); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);